import { createI18n as TN, useI18n as ki } from "vue-i18n";
import { defineStore as oo, storeToRefs as Nn } from "pinia";
import { ref as $e, computed as Ae, reactive as Er, watch as At, onMounted as Li, onUnmounted as f1, onBeforeUnmount as tl, toValue as kc, readonly as Zy, getCurrentScope as m1, onScopeDispose as v1, unref as ne, isReactive as X0, defineComponent as at, createElementBlock as G, openBlock as V, createElementVNode as E, createTextVNode as mt, toDisplayString as Y, nextTick as Rl, getCurrentInstance as Du, toRef as eh, customRef as CI, isRef as yo, shallowRef as qy, watchEffect as ra, useAttrs as kI, createBlock as Tt, Teleport as IN, withDirectives as xr, createCommentVNode as _e, mergeProps as jf, withModifiers as zi, withKeys as jy, createVNode as it, Transition as $r, toHandlers as H2, withCtx as Qt, normalizeStyle as g1, normalizeClass as Et, vShow as th, renderSlot as er, normalizeProps as AN, guardReactiveProps as EN, inject as Xi, useCssVars as Hl, useSlots as PN, toRefs as SI, createSlots as zg, resolveComponent as Ur, pushScopeId as nl, popScopeId as il, Fragment as cn, renderList as Pn, mergeModels as W2, useModel as MN, onBeforeMount as Ru, markRaw as Gy, h as ym, provide as J0, triggerRef as Iv, vModelText as _b, vModelRadio as Gp, createStaticVNode as DN, setBlockTracking as Bg, toRaw as LN } from "vue";
import { useRoute as ON } from "vue-router";
const NN = {
  vacvComponents: {
    common: {
      buttons: {
        open: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Open" } },
        close: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Close" } },
        select: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Select" } },
        selected: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Selected" } },
        backToTop: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Back to top of page" } },
        submit: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Submit" } },
        add: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Add" } },
        added: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Added" } },
        showOptions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Show options" } },
        hideOptions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hide options" } }
      },
      generic: {
        loading: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Loading" } }
      },
      labels: {
        aeroplan: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aeroplan" } },
        details: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Details" } },
        selectAnOption: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Select an option" } }
      },
      messages: {
        "go-back": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Go back to results" } },
        "fallback-img": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Image coming soon" } }
      },
      bookingsummary: {
        labels: {
          "booking-summary": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Booking Summary" } },
          package: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Package" } },
          flight: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Flight" } },
          transfers: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Transfers" } },
          hotel: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hotel" } },
          "hotel-and-rooms": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hotel & room(s)" } },
          "round-trip-flight": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Round-trip flight" } },
          ancillary: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Extras" } },
          traveller: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "traveller" } },
          travellers: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "travellers" } },
          included: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Included" } },
          travelprotection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Travel protection - " } },
          privateTransfer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Private transfers - " } },
          "extras-included": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Including selected extras" } }
        },
        messages: {
          "see-details": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "See details" } },
          "hide-details": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hide details" } },
          total: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Total" } },
          deposit: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Deposit" } },
          "continue-booking": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Continue" } }
        },
        errors: {
          "no-hotel-room": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "We can't load your hotel & room details right now. You'll be able to see them at the next step." } },
          "no-flights": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "We can't load your flight details right now. You'll be able to see them after you select your room." } },
          ancillary: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "We can't load your extras right now. You'll be able to see them at the next step." } }
        },
        aeroplan: {
          "use-your-points-to-save": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Use your points to save" } }
        }
      },
      pricedetails: {
        peradult: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "per adult" } },
        total: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Total" } },
        taxesincl: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Taxes & fees incl." } },
        title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Price Details" } },
        popoverLink: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Show price details" } },
        adult: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3 }], s: "adult" }, { t: 2, i: [{ t: 3 }], s: "adults" }] } },
        child: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3 }], s: "child" }, { t: 2, i: [{ t: 3 }], s: "children" }] } },
        taxesFees: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "taxes & fees" } },
        estimatedTotal: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Estimated Total" } },
        perNight: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "per night" } }
      },
      phoneNumber: {
        guestPhoneNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "1-866-529-2079" } },
        B2CPhoneNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "1-877-752-5510" } },
        B2BPhoneNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "1-877-752-7710" } }
      }
    },
    wasPrice: {
      was: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Was " } },
      save: { t: 0, b: { t: 2, i: [{ t: 3, v: "Save " }, { t: 4, k: "percent" }, { t: 3, v: "%" }] } }
    },
    guestsInput: {
      label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Guests" } },
      placeholder: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Guests" } },
      insideDataGuests: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3 }], s: "no guests" }, { t: 2, i: [{ t: 4, k: "n" }, { t: 3, v: " Guest" }] }, { t: 2, i: [{ t: 4, k: "n" }, { t: 3, v: " Guests" }] }] } },
      insideDataRooms: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 4, k: "n" }, { t: 3, v: " Room" }] }, { t: 2, i: [{ t: 4, k: "n" }, { t: 3, v: " Rooms" }] }] } },
      adults: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Adults (Age 18+)" } },
      children: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Children (Age 2-17)" } },
      infants: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Infants (under age 2)" } },
      counter: {
        add: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Add" } },
        remove: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Remove" } }
      },
      rooms: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Rooms" } },
      childAge: { t: 0, b: { t: 2, i: [{ t: 3, v: "Child " }, { t: 4, k: "n" }, { t: 3, v: " age" }] } },
      buttonLabel: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "DONE" } },
      roomsAdvisory: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Max. 1 room for bookings with children/infants" } },
      advisory: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "<strong>For 7 guests or more</strong>, please visit the <a href='https://vacations.aircanada.com/en/group-form' target='_blank'>Group Travel page</a> or call for assistance at 1-866-529-2079." } },
      infantTurns2: { t: 0, b: { t: 2, i: [{ t: 3, v: "If your infant turns 2 during your trip, they will require a return seat. Please call us at " }, { t: 4, k: "num" }, { t: 3, v: " to complete your booking." }] } },
      oneInfantPerAdult: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Max. 1 infant per adult" } },
      errors: {
        GuestsSelection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Number of guests is invalid" } },
        RoomSelection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "When booking multiple rooms, adults must be separated equally between rooms" } },
        ChildAgeSelection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter the child's age at departure date" } },
        ChildUnderTwo: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "If you would like to include one or more children under the age of 2 years old, please call us at 1 866 529-2079 to complete your booking." } }
      }
    },
    dialogs: {
      cubaPopup: {
        title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Travelling to Cuba" } },
        question: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Does this booking include one or more passenger(s) who is a U.S. citizen, U.S. permanent resident, or who is otherwise subject to U.S. jurisdiction?" } },
        changeDestination: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Change Destination" } },
        yes: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Yes" } },
        no: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "No" } },
        continue: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Continue Booking" } },
        yesSelected: { t: 0, b: { t: 2, i: [{ t: 3 }], s: '<p>Travel to/from Cuba is restricted for U.S citizens, U.S permanent residents and other persons subject to U.S jurisdiction.</p><p>The Office of Foreign Assets Control (OFAC) requires that all such travelers fill out a declaration to acknowledge that they are holders of a specific travel license for Cuba, or that their travel to Cuba is related to one of the following general license categories:</p><ul><li>Family visits</li><li>Official business of the U.S. government, foreign governments, and certain intergovernmental organizations</li><li>Journalistic activity</li><li>Professional research/professional meetings and conferences</li><li>Educational activities/group people-to-people educational travel</li><li>Religious activities</li><li>Support for the Cuban people</li><li>Humanitarian projects</li><li>Activities of private foundations or research or educational institutes</li><li>Exportation, importation, or transmission of information or information materials</li><li>Certain authorized export transactions</li></li></ul><p>Before booking a trip to Cuba, U.S. travellers should consult the U.S. Department of the Treasury website for <a href="https://ofac.treasury.gov/faqs#cuba" target="_blank">more information on Cuba Sanctions</a>.</p><p>U.S. nationals (U.S. citizens or U.S. residents), even legally authorized travellers, are prohibited from engaging in direct financial transactions with certain Cuban hotels, shops, and tour agencies owned or controlled by the Cuba military or intelligence services as listed on the U.S State Department <a href="https://www.state.gov/cuba-sanctions/cuba-restricted-list/" target="_blank">Cuba Restricted List</a>. Consult the Cuba Restricted List for more information.</p><p>Recent changes in U.S. sanctions on Cuba also prohibit U.S. nationals from lodging, paying for lodging, or making reservations at certain properties in Cuba. Consult the <a href="https://www.state.gov/cuba-sanctions/cuba-prohibited-accommodations-list/cuba-prohibited-accommodations-list-initial-publication/" target="_blank">Prohibited Accommodation List</a> for more information.</p>' } }
      },
      confirmation: {
        "modal-label-accessibility": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Confirmation" } }
      }
    },
    tripAdvisor: {
      review: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "review" } },
      reviews: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "reviews" } },
      "access-rating": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Tripadvisor rating " } },
      "access-bubbles": { t: 0, b: { t: 2, i: [{ t: 3 }], s: " of 5 bubbles" } }
    },
    aeroplan: {
      aeroplan: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aeroplan" } },
      "signin-btn": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sign in" } },
      "cont-as-guest-btn": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Continue as Guest" } },
      "earn-or-book-and-save": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Earn on your vacation or book with points and save" } },
      "login-banner": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Book with points or earn for your next vacation." } },
      points: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "pts" } },
      "points-initial-text": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Select points" } },
      "points-zero": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "No points" } }
    },
    carousel: {
      "aria-modal": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "View image gallery" } },
      "aria-next": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Next" } },
      "aria-previous": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Previous" } },
      caption: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Image" } },
      slidenum: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "of" } },
      photo: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Photo of" } }
    },
    confirmation: {
      labels: {
        title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Booking confirmed!" } },
        bookingNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Your booking number is:" } },
        bookingSummaryTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Booking summary" } },
        travellersTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Travellers" } },
        accommodationTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hotel & Room(s)" } },
        print: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Print Confirmation" } },
        congrats: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Congratulations" } },
        getReadyTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Get ready for your vacation" } },
        aeroplanJoin: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Join Aeroplan" } },
        aeroplanJoinLink: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "https://www.aircanada.com/aeroplan/member/enrolment" } },
        aeroplanAddNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Add Aeroplan number(s)" } },
        aeroplanAddNumberLink: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "https://vacations.aircanada.com/en/travel-info/manage-your-booking" } },
        hotelTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hotel & room(s)" } },
        checkInTime: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Check-in:" } },
        checkOutTime: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Check-out:" } },
        flightTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Round-trip flight" } },
        ancillaryTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Extras" } },
        priceDetailsTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Price details" } },
        privateTransferDescription: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "It's not too late to add a round-trip private transfer between the airport and your resort." } },
        privateTransferButton: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Add to your booking" } },
        paymentTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Payment method(s)" } },
        uplift: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Flex Pay" } },
        CAREFLEX: {
          name: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "CareFlex" } },
          inclusions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Includes cancellation with refund or travel credit, booking changes and package transfer. Certain conditions apply." } }
        },
        CAREFREE: {
          name: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "CareFree" } },
          inclusions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Includes standard seat selection and our Price Drop Guarantee. Certain conditions apply." } }
        },
        CFCTA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "CFCTA Contribution" } },
        insuranceTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Travel insurance" } },
        insuranceLogoTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Allianz Global Assistance" } },
        insuranceDescription: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Protect your health and finances so that you can travel with confidence in Canada and around the world. Get valuable insurance coverage with 24/7 emergency assistance from the team at Allianz Global Assistance, who are there to support you throughout your journey." } },
        insuranceContact: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'or contact Allianz Global Assistance today at <span class="tel">1-833-358-0582</span>.' } },
        insuranceNote: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Travel insurance is underwritten by CUMIS General Insurance Company, a member of The Co-operators group of companies and administered by Allianz Global Assistance, which is a registered business name of AZGA Service Canada Inc." } },
        insuranceBtn: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Get an online quote" } },
        seatSelTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Advance seat selection" } },
        seatSelOption1: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Select your seat now and/or upgrade to a preferred seat at an extra cost." } },
        seatSelOption2: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Select your seat later via the <a href="https://vacations.aircanada.com/en/travel-info/manage-your-booking" target="_blank" class="link">Manage Your Booking</a> page.' } },
        seatSelOption3: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "If you added CareFree to your booking, select your seat via the link above or contact us at 1 866 529-2079 to upgrade to a preferred seat." } },
        seatSelBtn: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Select your seat" } },
        giftCard: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Air Canada Gift Card ending with" } },
        endingWith: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "••••" } }
      },
      messages: {
        thankYou: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Thank you for travelling with Air Canada Vacations." } },
        checkInbox: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Check your inbox soon for your booking details." } },
        "aeroplan-points-confirmation-0": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "You'll earn Aeroplan points on this package." } },
        "aeroplan-points-confirmation-1": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Check your account <strong>after your vacation</strong> to see your new balance." } },
        aeroplanEnroll: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `<h2 class="h3style">Not an Aeroplan Member?</h2>Canada's premier travel loyalty program helps members travel more and travel better by providing access to amazing perks.` } },
        aeroplanBenefits: { t: 0, b: { t: 2, i: [{ t: 3 }], s: '<ul class="spa-list special-list details-2col"><li>Earn points on all flight-inclusive packages</li><li>Reach Aeroplan Elite&trade; Status faster on vacation packages. Earn on ALL qualifying currencies.</li><li>Earn faster when you book with eligible credit cards</li><li>Free texting while you fly with <a href="https://www.aircanada.com/ca/en/aco/home/fly/onboard/in-flight-entertainment-and-connectivity.html#/wifi" target="_blank" class="link">onboard WiFi</a>. Sponsored by Bell</li><li>Redeem for as low as 5,000 points</li><li>Exclusive discounts on activities</li><li>Combine points with family members to get rewards sooner thanks to Aeroplan Family Sharing</li></ul>' } },
        aeroplanAlready: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "<strong>Did you forget to provide Aeroplan number(s) for yourself or other travellers on your booking?</strong><br>Don't miss the Aeroplan points that can be earned!" } },
        ancillaryTravelProtectionLink: { t: 0, b: { t: 2, i: [{ t: 3 }], s: '<a href="https://vacations.aircanada.com/en/travel-info/travel-protection" target="_blank" class="link">Learn more</a>' } }
      }
    },
    filters: {
      filteredBy: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Filtered by" } },
      clearFilters: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Clear all filters" } },
      rangeSlider: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Price Range Per Adult ($)" } },
      destinations: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Destinations" } },
      moreDestinations: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "More destinations" } },
      moreAmenities: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "More amenities" } },
      priceRange: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Price Range Per Adult" } },
      deals: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Deals" } },
      starRating: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Star Rating" } },
      amenities: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Amenities" } },
      vacationType: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Vacation type" } },
      error: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Select at least one filter to apply." } },
      showLess: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Show less" } },
      showMore: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Show more" } },
      applyButton: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Apply Filters" } },
      filter: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "filter" } },
      starslabel: {
        stars: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "stars " } },
        andup: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "& up" } }
      },
      starRatingOptions: {
        2: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "2 stars & up" } },
        3: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "3 stars & up" } },
        4: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "4 stars & up" } },
        5: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "5 stars" } }
      },
      filterBy: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Filter by:" } }
    },
    hotelRating: {
      stars: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "stars" } }
    },
    productDetails: {
      bestFor: {
        title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ideal for" } },
        learnMore: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Learn more" } },
        hideDetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hide Details" } }
      },
      labels: {
        accessibleAnchor: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Skip to " } },
        hotel: {
          important: {
            title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Important information" } }
          },
          facilities: {
            title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Facilities" } }
          },
          location: {
            title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Location" } }
          },
          offers: {
            title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Offers" } }
          },
          overview: {
            title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Overview" } }
          }
        }
      },
      overview: {
        title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Overview" } },
        checkin: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Check in:" } },
        checkout: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Check out:" } },
        numberRooms: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Number of rooms:" } },
        numberBars: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Number Of bars:" } },
        numberRestaurants: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Number of restaurants:" } },
        numberPoolsOutdoor: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Number of pools (outdoor):" } },
        inclusions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Inclusions" } },
        otherServices: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Other services at charge ($)" } }
      },
      map: {
        "zoom-in": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Zoom in" } },
        "zoom-out": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Zoom out" } },
        "enter-full-screen": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Full screen" } },
        "exit-full-screen": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Exit full screen" } }
      },
      important: {
        title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Important information" } }
      },
      facilities: {
        title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Facilities" } },
        showMore: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Show more" } },
        showLess: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Show less" } },
        disclaimer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "*Additional fees may apply and service may require a reservation." } },
        foodAndDrinks: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Food & drink" } },
        activities: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Activities" } },
        otherFacilitiesAndServices: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Other facilities & services" } },
        pools: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Pool facilities" } },
        landSports: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Land activities" } },
        waterSports: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Non-motorized water sports/motorized water sports" } },
        entertainment: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Entertainment" } },
        golf: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Golf" } },
        bars: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Bars" } },
        restaurants: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Restaurants" } },
        restaurantType: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Restaurant type" } },
        restaurantCuisine: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Cuisine" } },
        restaurantNote: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Note" } },
        additionalInformation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Additional information" } },
        health: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Health and wellness" } },
        disclaimerPetFriendly: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "**Restrictions and additional fees may apply for pets" } }
      },
      offers: {
        title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Offers" } },
        terms: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Terms and Conditions" } },
        showLess: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hide Details" } }
      },
      rooms: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Rooms" } }
    },
    travellersTitle: {
      labels: {
        secureBooking: { t: 0, b: { t: 2, i: [{ t: 3 }], s: '<i class="fa-sharp fa-solid fa-lock-keyhole"></i><span class="sr-only">Learn more about</span> Secure booking' } },
        title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Travellers" } },
        "title-note": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "(*) Mandatory fields" } }
      },
      messages: {
        secureTooltipTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Security & Privacy" } },
        secureTooltipContent: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Every transaction with Air Canada Vacations is secure. Any personal information you share with us will be handled according to our <a href="https://vacations.aircanada.com/en/security-privacy" target="_blank" class="link">Privacy Policy</a>.' } }
      }
    },
    traveller: {
      errors: {
        noTitleSelected: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please select your title." } },
        noFirstNameEntered: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter your first name." } },
        noLastNameEntered: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter your last name." } },
        noDOBEntered: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter your date of birth." } },
        invalidDOB: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter a valid date." } },
        invalidChildDOB: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "The age of your child or children does not correspond with the provided date of birth. Please try again by starting a new search." } },
        invalidInfantReturnDOB: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Your infant will be turning 2 during your trip." } },
        invalidInfantReturnDOBDetails: { t: 0, b: { t: 2, i: [{ t: 3, v: "Travellers aged 2 and up are required to occupy their own seat, as per Transport Canada regulations. You must purchase a return seat for your 2-year-old. <br /><strong>Please call us at " }, { t: 4, k: "num" }, { t: 3, v: " to complete your booking.</strong>" }] } },
        noEmailEntered: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter your email." } },
        noPhoneNumberEntered: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter your 10-digit phone number." } },
        noOtherTravellerDateOfBirth: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter a date of birth." } },
        noOtherTravellerTitleField: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please select a title." } },
        noOtherTravellerFirstName: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter a first name." } },
        noOtherTravellerLastName: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter a last name." } },
        nameWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Letters (A-Z, a-z), accented letters, hyphen or apostrophe only." } },
        ccNameWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Letters (A-Z, a-z), accented letters, hyphen or apostrophe only." } },
        phoneNumberWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Numbers (0-9) and special characters ('+', '-', '(' and ')') only." } },
        aeroplanNumberWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Numbers (0-9) only." } },
        employeeNamePrefilled: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "There is an issue with this name. Please call 1-877-752-5510 to complete the booking." } },
        firstNameTextLength: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Maximum of 20 characters accepted." } },
        lastNameTextLength: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Maximum of 20 characters accepted." } },
        aeroplanInvalidNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter a valid Aeroplan number." } },
        phoneNumberTextLength: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Maximum of 20 characters accepted." } },
        emailTextLength: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Maximum of 50 characters accepted." } },
        emailWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter a valid email." } }
      },
      labels: {
        adult: { t: 0, b: { t: 2, i: [{ t: 3, v: "Adult " }, { t: 4, k: "index" }] } },
        child: { t: 0, b: { t: 2, i: [{ t: 3, v: "Child " }, { t: 4, k: "index" }, { t: 3, v: " (" }, { t: 4, k: "age" }, { t: 3, v: " years old)" }] } },
        childHideAge: { t: 0, b: { t: 2, i: [{ t: 3, v: "Child " }, { t: 4, k: "index" }] } },
        infant: { t: 0, b: { t: 2, i: [{ t: 3, v: "Infant " }, { t: 4, k: "index" }, { t: 3, v: " (under 2 years old)" }] } },
        infantHideAge: { t: 0, b: { t: 2, i: [{ t: 3, v: "Infant " }, { t: 4, k: "index" }] } },
        dateOfBirth: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Date of birth" } },
        "dateOfBirth-filled": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Date of birth:" } },
        travellerTitleField: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Title" } },
        travellerTitleMr: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Mr." } },
        travellerTitleMrs: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Mrs." } },
        travellerTitleMs: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ms." } },
        travellerFirstName: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "First name" } },
        travellerMiddleName: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Middle name" } },
        travellerLastName: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Last name" } },
        travellerEmail: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Email" } },
        "travellerEmail-filled": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Email:" } },
        travellerPhoneNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Phone number" } },
        "travellerPhoneNumber-filled": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Phone number:" } },
        travellerAeroplanNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aeroplan number" } },
        "travellerAeroplanNumber-filled": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aeroplan number:" } }
      },
      messages: {
        mainTraveller: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "(Main traveller)" } },
        travellerName: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Enter information as written on passport." } },
        travellerEmailDisclaimer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "All travel correspondence and tickets will be sent to this email." } }
      },
      placeholders: {
        birthDay: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "DD" } },
        birthMonth: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "MM" } },
        birthYear: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "YYYY" } }
      }
    },
    pricedetails: {
      peradult: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "per adult" } },
      total: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Total" } },
      taxesincl: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Taxes & fees incl." } },
      title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Price Details" } },
      titleHotelsSpa: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Price details" } },
      popoverLink: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Show price details" } },
      adult: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3 }], s: "adult" }, { t: 2, i: [{ t: 3 }], s: "adults" }] } },
      child: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3 }], s: "child" }, { t: 2, i: [{ t: 3 }], s: "children" }] } },
      infant: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3 }], s: "infant" }, { t: 2, i: [{ t: 3 }], s: "infants" }] } },
      infantAge: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "0-2 years old" } },
      taxesFees: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "taxes & fees" } },
      estimatedTotal: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Estimated Total" } },
      paymentSubtotal: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Subtotal" } },
      "extras-included": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Including selected extras" } },
      "aeroplan-points-applied": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aeroplan pts applied" } },
      nonRefundableRate: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Non-refundable rate" } },
      paymentAEPoints: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aeroplan points" } },
      nights: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "night(s)" } },
      taxesAndFees: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Taxes and fees" } }
    },
    legal: {
      disclaimer: {
        price: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Prices on our website reflect applicable reductions and are valid if you purchase services in a same session. If you log off our website, prices may be different the next time you log on. Final prices will be displayed before confirming your payment." } },
        "was-price": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Struck-out price represents original market price before applicable discounts." } }
      }
    },
    plp: {
      labels: {
        recommended: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Recommended" } },
        "recommended-access": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "This hotel is " } }
      },
      messages: {
        notfound: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "It looks like we can't find exactly what you're looking for." } },
        "notfound-filters": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "There are no vacations that match the selected filters. Please try again with different options." } },
        "notfound-filters-hotels": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "There are no hotels that match the selected filters. Please try again with different options." } },
        "notfound-unavailable": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "It looks like your current destination is unavailable." } },
        packagesfound: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "packages found" } },
        "packagesfound-single": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "package found" } },
        suggest: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "We suggest:" } },
        "suggest-date": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Changing your travel dates." } },
        "suggest-nearby-airports": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Trying nearby airports." } },
        "suggest-different-airport": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Try different airports." } },
        "suggest-different-destination": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Selecting a different destination." } },
        "suggest-alternative-destination": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Selecting an alternative destination." } },
        "suggest-travellers": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Reducing the number of travellers." } },
        "specific-s214-error-tulum": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "We can't find available flights to Tulum for your selected dates." } },
        "suggest-cancun-good-news": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Good news! You can still get to our Tulum hotels by flying to Cancún." } },
        "suggest-cancun-update": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "We suggest updating your search and selecting Cancún as your destination." } },
        "something-went-wrong": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "It looks like something went wrong." } },
        "try-again-by": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Try again by:" } },
        "click-modify": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Searching again by clicking 'Modify' above" } },
        "refresh-page": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Refreshing this page" } },
        alertNoCabinSearchedAvailable: { t: 0, b: { t: 2, i: [{ t: 3, v: "There are no " }, { t: 4, k: "searchedCabin" }, { t: 3, v: " seats available for your selected dates. However, space in " }, { t: 4, k: "returnedCabin" }, { t: 3, v: " is available around those dates." }] } },
        alertAdditionalCabinsAvailable: { t: 0, b: { t: 2, i: [{ t: 3, v: "We found " }, { t: 4, k: "searchedCabin" }, { t: 3, v: " seats available on the flight for the dates selected. We also found available package(s) around those dates in " }, { t: 4, k: "returnedCabin" }, { t: 3, v: "." }] } },
        "children-more-than-one-room-error": { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'To make a booking with children, select one room or <a href="https://vacations.aircanada.com/en/contact-us" target="_blank" class="link">contact us</a>.' } },
        "more-than-6-pax-error": { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'For bookings with more than 6 travellers, please <a href="https://vacations.aircanada.com/en/contact-us" target="_blank" class="link">contact us</a>.' } },
        "update-your-search": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Update your search" } },
        "adults-repartition-error": { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Please distribute the number of adults equally between the number of rooms and try again. If you need help with your booking, please <a href="https://vacations.aircanada.com/en/contact-us" target="_blank" class="link">contact us</a>.' } },
        recommended: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Recommended" } },
        "recommended-access": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "This hotel is " } }
      },
      filters: {
        filter: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "filtrer" } }
      }
    },
    plpList: {
      flexibleDates: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Flexible dates" } },
      flexDates: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "More Dates and Prices" } },
      flexDatesDeparture: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Departure" } },
      flexNights: { t: 0, b: { t: 2, i: [{ t: 3, v: "(" }, { t: 4, k: "count" }, { t: 3, v: " nights)" }] } },
      roomShowDetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "See all details" } },
      roomOptionsInfo: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3, v: "Up to " }, { t: 4, k: "count" }, { t: 3, v: " other room option available at this hotel" }] }, { t: 2, i: [{ t: 3, v: "Up to " }, { t: 4, k: "count" }, { t: 3, v: " other room options available at this hotel" }] }] } },
      roomOptionsButton: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "See all room options" } },
      roomDetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Room details" } },
      stars: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "stars" } },
      aeroplanpointsTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Terms & Conditions" } },
      flightdetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Flight details" } }
    },
    psytriggers: {
      "rooms-left": { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3, v: "Only " }, { t: 4, k: "count" }, { t: 3, v: " room left!" }] }, { t: 2, i: [{ t: 3, v: "Only " }, { t: 4, k: "count" }, { t: 3, v: " rooms left!" }] }] } },
      "total-bookings-24": { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3, v: "Hotel booked " }, { t: 4, k: "count" }, { t: 3, v: " time in the last 24 hours" }] }, { t: 2, i: [{ t: 3, v: "Hotel booked " }, { t: 4, k: "count" }, { t: 3, v: " times in the last 24 hours" }] }] } },
      "total-bookings-48": { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3, v: "Hotel booked " }, { t: 4, k: "count" }, { t: 3, v: " time in the last 48 hours" }] }, { t: 2, i: [{ t: 3, v: "Hotel booked " }, { t: 4, k: "count" }, { t: 3, v: " times in the last 48 hours" }] }] } },
      "last-booking-minute": { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3, v: "Hotel booked " }, { t: 4, k: "count" }, { t: 3, v: " minute ago" }] }, { t: 2, i: [{ t: 3, v: "Hotel booked " }, { t: 4, k: "count" }, { t: 3, v: " minutes ago" }] }] } },
      "last-booking-hour": { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3, v: "Hotel booked " }, { t: 4, k: "count" }, { t: 3, v: " hour ago" }] }, { t: 2, i: [{ t: 3, v: "Hotel booked " }, { t: 4, k: "count" }, { t: 3, v: " hours ago" }] }] } },
      "room-last-booking-minute": { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3, v: "Room booked " }, { t: 4, k: "count" }, { t: 3, v: " minute ago" }] }, { t: 2, i: [{ t: 3, v: "Room booked " }, { t: 4, k: "count" }, { t: 3, v: " minutes ago" }] }] } },
      "room-last-booking-hour": { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3, v: "Room booked " }, { t: 4, k: "count" }, { t: 3, v: " hour ago" }] }, { t: 2, i: [{ t: 3, v: "Room booked " }, { t: 4, k: "count" }, { t: 3, v: " hours ago" }] }] } },
      "room-total-bookings-24": { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3, v: "Room booked " }, { t: 4, k: "count" }, { t: 3, v: " time in the last 24 hours" }] }, { t: 2, i: [{ t: 3, v: "Room booked " }, { t: 4, k: "count" }, { t: 3, v: " times in the last 24 hours" }] }] } },
      "room-total-bookings-48": { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3, v: "Room booked " }, { t: 4, k: "count" }, { t: 3, v: " time in the last 48 hours" }] }, { t: 2, i: [{ t: 3, v: "Room booked " }, { t: 4, k: "count" }, { t: 3, v: " times in the last 48 hours" }] }] } },
      "rooms-left-advisory": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "This number is based on Air Canada Vacation's current inventory which can fluctuate from day to day." } },
      "bookings-advisory": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "This number is based on ACV's current booking data, which is subject to be updated every 60 minutes." } }
    },
    progressbar: {
      labels: {
        navback: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Back" } },
        stepofsteps: { t: 0, b: { t: 2, i: [{ t: 3, v: "Step " }, { t: 4, k: "step" }, { t: 3, v: " of " }, { t: 4, k: "steps" }, { t: 3, v: " - " }] } },
        hotel: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hotel" } },
        room: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Room(s)" } },
        flight: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Flight" } },
        extras: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Extras" } },
        payment: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Payment" } }
      }
    },
    payment: {
      labels: {
        title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Travellers" } },
        "title-note": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "(*) Mandatory fields" } },
        secureBooking: { t: 0, b: { t: 2, i: [{ t: 3 }], s: '<i class="fa-sharp fa-solid fa-lock-keyhole"></i><span class="sr-only">Learn more about</span> Secure booking' } },
        paymentMethod: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Payment method" } },
        twoCreditCards: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "I want to use 2 credit cards" } },
        sameAddress: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Same as credit card 1" } },
        creditCard: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Credit card" } },
        creditCardAmount: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Amount ($)" } },
        creditCardName: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Name on card" } },
        creditCardExpiry: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Expiration date (MM-YY)" } },
        creditCardAddressTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Billing address" } },
        creditCardAddress: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Address" } },
        creditCardApartment: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Apartment" } },
        creditCardCity: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "City" } },
        creditCardCountry: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Country" } },
        creditCardProvince: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Province/State" } },
        creditCardPostCode: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Postal/ZIP code" } },
        creditCardConfirm: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Confirm payment" } },
        updateInformation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Edit Details" } },
        passengerProtection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Air Passenger Protection Regulations Notice" } },
        promocodeTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Promo code" } },
        promocodeApplyButton: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Apply" } },
        promocodeRemoveButton: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Remove" } },
        paymentOptions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Payment options" } },
        payInFull: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Pay total" } },
        payWithDeposit: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Book with a deposit" } },
        payWithUplift: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Pay Monthly with Flex Pay" } },
        depositModalTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Book with a deposit" } },
        note: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Note:" } },
        travellerInfoNormalizedNote: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "We've adjusted the traveller name(s) in your booking to meet our system requirements." } },
        upliftFrom: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "from $" } },
        payMonthlyOffer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "/month" } },
        upliftWarningModalTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Are you sure you want to update your booking?" } },
        upLiftWarningModalBtnOK: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Update my booking" } },
        upliftWarningModalBtnCancel: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Cancel" } },
        allianzTravelInsuranceTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Allianz Travel Insurance" } },
        allianzTravelInsuranceDescription: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Protect your wellbeing and finances and travel with peace of mind." } },
        allianzTravelInsuranceDescription2: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please make a selection to continue." } },
        allianzTravelInsuranceNotesTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Notes:" } },
        allianzDeclineTravelInsurance: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "I decline protection for my trip and understand I may be responsible for non-refundable expenses." } },
        allianzAddTravelInsurance: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Add" } },
        allianzAddedTravelInsurance: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Added" } },
        mostPopular: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Most Popular" } },
        allianzTermsAndConditions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Terms & <span>Conditions<i class="fa-solid fa-arrow-up-right-from-square"></i></span>' } },
        allianzProductSummary: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Product <span>Summary<i class="fa-solid fa-arrow-up-right-from-square"></i></span>' } },
        priceTitle: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3 }], s: "Total Price for 1 passenger (plus applicable taxes)" }, { t: 2, i: [{ t: 3, v: "Total Price for " }, { t: 4, k: "count" }, { t: 3, v: " passengers (plus applicable taxes)" }] }] } },
        allianzProductChangeBtn: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Change" } },
        travelInsurance: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Travel Insurance" } },
        insuranceForXTravellers: { t: 0, b: { t: 2, i: [{ t: 3, v: "for " }, { t: 4, k: "x" }, { t: 3, v: " travellers" }] } },
        insuranceXTravellers: { t: 0, b: { t: 2, i: [{ t: 4, k: "x" }, { t: 3, v: " traveller(s)" }] } },
        plusTaxes: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Plus applicable taxes" } },
        billedSeparately: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Billed separately" } },
        allianzOptedOutInsurance: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "You have opted out of travel insurance. Please note that you may be responsible for non-refundable expenses." } },
        insuranceDOBChangeAdvisoryAccept: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ok" } },
        allianzDescriptionNotesTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please Note:" } },
        allianzDescriptionNotesNoteOne: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Your travel insurance will be billed to this credit card as a separate charge by Allianz Global Assistance." } },
        allianzDescriptionNotesNoteTwo: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "When you purchase travel insurance, you consent to Air Canada Vacations disclosing some of the personal information you provided (such as credit card information) to Allianz Global Assistance." } }
      },
      placeholders: {
        select: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Select" } }
      },
      validation: {
        paymentMethod: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please select a payment method." } }
      },
      errors: {
        ccNameWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Letters (A-Z, a-z), accented letters, hyphen or apostrophe only." } },
        ccAmountZero: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Amount cannot be $0.00" } },
        ccAmountEqualToTotal: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "To proceed, please select one Credit Card" } },
        ccAmountTooHighDeposit: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Amount must be less than the deposit amount" } },
        expirationWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter a date in the MM-YY format." } },
        expirationPastDate: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter a valid credit card expiration date" } },
        giftCardPayInFull: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Your booking will be paid in full with your Air Canada Gift Card." } },
        maxCharsAccepted: { t: 0, b: { t: 2, i: [{ t: 3, v: "Maximum of " }, { t: 4, k: "max" }, { t: 3, v: " characters accepted." }] } },
        maxTwoPaymentMethods: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "You've already selected a maximum of 2 payment methods. To use your gift card, please deselect one of your payment methods." } },
        notSupportedIframe: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Your browser does not support iframes. Please use a compatible browser to view this content." } },
        pleaseEnterCCName: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter the cardholder's name" } },
        pleaseEnterCCExpiryDate: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter the expiration date" } },
        pleaseEnterCCAddress: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter an address" } },
        pleaseEnterCCCity: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter a city" } },
        pleaseEnterCCCountry: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please select a country" } },
        pleaseEnterCCProvince: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please select a province/state" } },
        pleaseEnterCCPostalCode: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter a postal/zip code" } },
        cityWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Alphabetic (A-Z, a-z), spaces (' ') and special characters only." } },
        postalCodeWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter a valid postal code." } },
        upliftFormNotCompleted: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please complete the Flex Pay form before confirming payment, or select a different payment plan." } },
        unableGetUpliftToken: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "We're unable to complete your Flex Pay application at this time. Please try again." } },
        offerNotAvailable: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Price not available at this time" } },
        promocodeError: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Invalid Promo Code" } },
        pleaseEnterYour: { t: 0, b: { t: 2, i: [{ t: 3, v: "Please enter your " }, { t: 4, k: "field" }, { t: 3, v: "." }] } },
        noCardNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter a card number" } },
        noCVV: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter the CVV" } },
        cvvWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter a valid CVV code" } },
        ccWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter a valid credit card number" } },
        ccTypeNotAccepted: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter a valid card number for an accepted card type" } },
        creditCardPaymentFailure: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "We are unable to complete your booking due to a payment error. Please contact your bank." } },
        paymentAlreadyBooked: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Your package has already been booked. If you do not receive your confirmation email within the next 60 minutes, please <a href="https://vacations.aircanada.com/en/contact-us" target="_blank" class="link">contact us</a>.' } },
        errorHotel: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "We are unable to confirm your booking with the hotel. Please choose a different room type or hotel." } },
        paymentUserInput: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Your payment cannot be completed. Please verify your credit card details and try again." } },
        paymentFlightClientError: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Your selected flight is no longer available. Please try again with different dates or cabin classes." } },
        paymentBookingError: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Your selected package is no longer available. Please try again with different dates or a different destination. If the error persists, please <a href="https://vacations.aircanada.com/en/contact-us" target="_blank" class="link">contact us</a>.' } },
        paymentIncorrectPaxInfo: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Passenger information is invalid. Please verify and try again. If the error persists, please <a href="https://vacations.aircanada.com/en/contact-us" target="_blank" class="link">contact us</a>.' } },
        paymentTechnicalError: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Sorry, an error has occurred while completing your booking. Please try again. If the error persists, please <a href="https://vacations.aircanada.com/en/contact-us" target="_blank" class="link">contact us</a>.' } },
        payment3DSError: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sorry, an error occurred while processing your payment. Please try again. If the problem persists, please contact your bank." } },
        maxNumberOfAttempts3DSTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please be advised" } },
        maxNumberOfAttempts3DSMessage: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "<p>The maximum number of attempts has been reached. You will be redirected to the homepage.</p>" } },
        maxNumberOfAttempts3DSCta: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "OK" } },
        repeatCC: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Cannot be the same as Credit Card 1" } },
        ccAmountTooHighFull: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Amount must be less than the total amount" } },
        ccAmountValueTypeError: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Numbers (0-9) only" } },
        allianzError: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please choose a travel insurance plan, or decline travel insurance to continue." } }
      },
      messages: {
        continue: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Continue" } },
        secureTooltipTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Security & Privacy" } },
        secureTooltipContent: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Every transaction with Air Canada Vacations is secure. Any personal information you share with us will be handled according to our <a href="https://vacations.aircanada.com/en/security-privacy" target="_blank" class="link">Privacy Policy</a>.' } },
        mainTraveller: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "(Main traveller)" } },
        termsConditions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'By confirming your payment, you agree to have read and understood the Air Canada Vacations <a href="https://vacations.aircanada.com/en/terms-conditions" target="_blank" class="link">Terms and Conditions</a> and <a href="https://vacations.aircanada.com/en/security-privacy" target="_blank" class="link">Privacy Policy</a>.' } },
        packageNotAvailable: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "The package you selected is no longer available." } },
        "try-again": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Try again by making a different selection." } },
        "passengerProtection-1": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "If you are denied boarding, your flight is cancelled or delayed for at least two hours, or your baggage is lost or damaged, you may be entitled to certain standards of treatment and compensation under the Air Passenger Protection Regulations. For more information about your passenger rights please contact your air carrier or visit the Canadian Transportation Agency's website." } },
        "passengerProtection-2": { t: 0, b: { t: 2, i: [{ t: 3 }], s: `General terms and conditions pertaining to flight delays, cancellations, denied boarding, seating of children and lost or damaged baggage can be found in <a href="https://www.aircanada.com/ca/en/aco/home/legal/conditions-carriage-tariffs.html#/" target="_blank" class="link">Air Canada's General Conditions of Carriage and Tariffs</a>.` } },
        "aeroplan-you-have-x-points": { t: 0, b: { t: 2, i: [{ t: 3, v: "You have <span>" }, { t: 4, k: "points" }, { t: 3, v: "</span> Aeroplan points" }] } },
        "aeroplan-you-can-redeem-x-to-save-y": { t: 0, b: { t: 2, i: [{ t: 3, v: "You can redeem a maximum of <span>" }, { t: 4, k: "points" }, { t: 3, v: "</span> points to save <span>" }, { t: 4, k: "dollars" }, { t: 3, v: "</span>" }] } },
        "waiting-message-title": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "We are completing your booking" } },
        "waiting-message-description": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "It may take a few minutes to process your request. Do not click the refresh, back or stop button." } },
        "bill96-disclaimer": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please note that all documents and transactional emails will be sent in French" } },
        "bill96-checkbox": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "I would like to receive a copy of all documents and emails in English." } },
        promocodeDiscount: { t: 0, b: { t: 2, i: [{ t: 4, k: "discount" }, { t: 3, v: " OFF" }] } },
        amountDueBy: { t: 0, b: { t: 2, i: [{ t: 3, v: "Remaining balance of <strong>" }, { t: 4, k: "amount" }, { t: 3, v: "</strong> due by <strong>" }, { t: 4, k: "date" }, { t: 3, v: "</strong>" }] } },
        giftCardCheckAmountLink: { t: 0, b: { t: 2, i: [{ t: 3 }], s: '<a href="https://www.aircanada.com/ca/en/aco/home/book/payment-methods/air-canada-gift-cards.html#/" target="_blank" class="link">Check your gift card, eVoucher or travel voucher balance.</a>' } },
        upliftWarningMessage: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Making a change to your booking may require you to restart your Flex Pay application." } },
        billedSeparately: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Your trip and your travel insurance will be billed separately:" } },
        payableToVACV: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "payable to Air Canada Vacations" } },
        payableToInsuranceCompany: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "plus applicable taxes, payable to Allianz Global Assistance" } },
        insuranceDOBChangeAdvisoryTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please note" } },
        insuranceDOBChangeAdvisoryDescription: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Your travel insurance price may have changed based on the new information you provided." } },
        travelInsuranceNoOptions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sorry, there are no travel insurance options available for your trip." } }
      }
    },
    provinces: {
      AB: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "AB - Alberta" } },
      BC: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "BC - British Columbia" } },
      MB: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "MB - Manitoba" } },
      NB: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NB - New Brunswick" } },
      NL: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NL - Newfoundland and Labrador" } },
      NT: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NT - Northwest Territories" } },
      NS: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NS - Nova Scotia" } },
      NU: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NU - Nunavut" } },
      ON: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "ON - Ontario" } },
      PE: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "PE - Prince Edward Island" } },
      QC: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "QC - Quebec" } },
      SK: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "SK - Saskatchewan" } },
      YT: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "YT - Yukon Territory" } }
    },
    states: {
      AL: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "AL - Alabama" } },
      AK: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "AK - Alaska" } },
      AZ: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "AZ - Arizona" } },
      AR: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "AR - Arkansas" } },
      CA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "CA - California" } },
      CO: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "CO - Colorado" } },
      CT: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "CT - Connecticut" } },
      DE: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "DE - Delaware" } },
      DC: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "DC - District Of Columbia" } },
      FL: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "FL - Florida" } },
      GA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "GA - Georgia" } },
      HI: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "HI - Hawaii" } },
      ID: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "ID - Idaho" } },
      IL: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "IL - Illinois" } },
      IN: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "IN - Indiana" } },
      IA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "IA - Iowa" } },
      KS: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "KS - Kansas" } },
      KY: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "KY - Kentucky" } },
      LA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "LA - Louisiana" } },
      ME: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "ME - Maine" } },
      MD: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "MD - Maryland" } },
      MA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "MA - Massachusetts" } },
      MI: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "MI - Michigan" } },
      MN: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "MN - Minnesota" } },
      MS: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "MS - Mississippi" } },
      MO: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "MO - Missouri" } },
      MT: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "MT - Montana" } },
      NE: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NE - Nebraska" } },
      NV: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NV - Nevada" } },
      NH: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NH - New Hampshire" } },
      NJ: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NJ - New Jersey" } },
      NM: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NM - New Mexico" } },
      NY: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NY - New York" } },
      NC: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NC - North Carolina" } },
      ND: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "ND - North Dakota" } },
      OH: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "OH - Ohio" } },
      OK: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "OK - Oklahoma" } },
      OR: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "OR - Oregon" } },
      PA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "PA - Pennsylvania" } },
      RI: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "RI - Rhode Island" } },
      SC: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "SC - South Carolina" } },
      SD: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "SD - South Dakota" } },
      TN: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "TN - Tennessee" } },
      TX: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "TX - Texas" } },
      UT: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "UT - Utah" } },
      VT: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "VT - Vermont" } },
      VA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "VA - Virginia" } },
      WA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "WA - Washington" } },
      WV: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "WV - West Virginia" } },
      WI: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "WI - Wisconsin" } },
      WY: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "WY - Wyoming" } }
    },
    countries: {
      CA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Canada" } },
      US: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "United States" } }
    },
    bookingsummary: {
      labels: {
        "booking-summary": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Booking Summary" } },
        package: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Package" } },
        flight: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Flight" } },
        transfers: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Transfers" } },
        hotel: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hotel" } },
        "hotel-and-rooms": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hotel & room(s)" } },
        "round-trip-flight": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Round-trip flight" } },
        ancillary: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Extras" } },
        traveller: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "traveller" } },
        travellers: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "travellers" } },
        included: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Included" } },
        travelprotection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Travel protection - " } },
        privateTransfer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Private transfers - " } },
        "extras-included": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Including selected extras" } }
      },
      messages: {
        "see-details": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "See details" } },
        "hide-details": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hide details" } },
        total: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Total" } },
        deposit: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Deposit" } },
        "continue-booking": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Continue" } }
      },
      errors: {
        "no-hotel-room": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "We can't load your hotel & room details right now. You'll be able to see them at the next step." } },
        "no-flights": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "We can't load your flight details right now. You'll be able to see them after you select your room." } },
        ancillary: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "We can't load your extras right now. You'll be able to see them at the next step." } }
      },
      aeroplan: {
        "use-your-points-to-save": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Use your points to save" } }
      }
    },
    pdp: {
      labels: {
        title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Product Details Page (PDP)" } },
        accessibleAnchor: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Skip to " } },
        inclusionsButton: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Inclusions" } },
        roomDetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Room details" } },
        roomDescription: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Room description" } },
        roomService: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Room service" } },
        roomFacilities: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Room facilities" } },
        roomDimensions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Room size" } },
        occupancy: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Occupancy" } },
        maximumOccupancy: { t: 0, b: { t: 2, i: [{ t: 3, v: "Max Occupancy " }, { t: 4, k: "count" }] } },
        hotel: {
          overview: {
            title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Overview" } },
            checkin: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Check in:" } },
            checkout: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Check out:" } },
            numberRooms: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Number of rooms:" } },
            numberBars: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Number Of bars:" } },
            numberRestaurants: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Number of restaurants:" } },
            numberPoolsOutdoor: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Number of pools (outdoor):" } },
            inclusions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Inclusions" } },
            otherServices: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Other services at charge ($)" } }
          },
          important: {
            title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Important information" } }
          },
          location: {
            title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Location" } }
          },
          inclusions: {
            title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Inclusions" } }
          },
          facilities: {
            title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Facilities" } },
            showMore: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Show more" } },
            showLess: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Show less" } },
            disclaimer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "*Additional fees may apply and service may require a reservation." } },
            foodAndDrinks: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Food & drink" } },
            activities: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Activities" } },
            otherFacilitiesAndServices: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Other facilities & services" } },
            pools: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Pool facilities" } },
            landSports: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Land activities" } },
            waterSports: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Non-motorized water sports/motorized water sports" } },
            entertainment: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Entertainment" } },
            golf: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Golf" } },
            bars: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Bars" } },
            restaurants: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Restaurants" } },
            restaurantType: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Restaurant type" } },
            restaurantCuisine: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Cuisine" } },
            restaurantNote: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Note" } },
            additionalInformation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Additional information" } },
            health: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Health and wellness" } },
            disclaimerPetFriendly: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "**Restrictions and additional fees may apply for pets" } }
          }
        }
      },
      messages: {
        noRoomsAvailable: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "It looks like there are no rooms currently available." } },
        "try-again": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Choose a different hotel or resort and try again." } },
        "multiple-airport-your-choice": { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'This hotel can be accessed through multiple airports. Look for the <i class="fa-solid fa-plane" aria-hidden="true"></i><span class="sr-only">airport alert</span> below to view your options. Prices may differ based on your choice.' } },
        "multiple-airport-destination": { t: 0, b: { t: 2, i: [{ t: 3, v: "Round-trip flight via " }, { t: 4, k: "name" }, { t: 3, v: " (" }, { t: 4, k: "iata" }, { t: 3, v: ")" }] } }
      },
      access: {
        "plane-icon": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Airport alert! " } }
      },
      rooms: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Rooms" } },
      map: {
        "zoom-in": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Zoom in" } },
        "zoom-out": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Zoom out" } },
        "enter-full-screen": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Full screen" } },
        "exit-full-screen": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Exit full screen" } }
      }
    },
    flight: {
      labels: {
        flightDetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "FLIGHT DETAILS" } },
        title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Flights" } },
        departure: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Departure" } },
        return: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Return" } },
        stops: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3 }], s: "Direct flight" }, { t: 2, i: [{ t: 3 }], s: "1 stop" }, { t: 2, i: [{ t: 4, k: "count" }, { t: 3, v: " stops" }] }] } },
        duration: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Duration" } },
        showDetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "See details" } },
        hideDetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hide details" } },
        layoverDuration: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Layover duration:" } },
        operatedBy: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Operated by" } },
        cabinClassEconomy: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Economy" } },
        cabinClassPremium: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Premium Economy" } },
        cabinClassBusiness: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Business Class" } },
        cabinClassMixedPremium: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Mixed cabin with Premium Economy" } },
        cabinClassMixedBusiness: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Mixed cabin with Business Class" } }
      },
      messages: {
        flightDetailsSubtitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "More flight options are available after room selection." } },
        flightDetailsError: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "We can't load your flight details right now. You'll be able to see them after you select your room." } },
        noFlightsAvailable: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "It looks like the package you selected is no longer available." } },
        "try-again": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please try again by making a different selection." } },
        flightNotAvailableCard: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sorry, this flight option is no longer available." } },
        waitingMessageTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "We are updating your package" } },
        waitingMessageDescription: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "It may take up to 60 seconds to process your request.<br>Do not click the refresh, back or stop button." } },
        waitingScreenMessageTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Preparing your room" } },
        waitingScreenMessageDescription: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Give us a minute while we get everything ready for your stay.<br>Please don't click the refresh, back or stop button." } },
        cabinClassMixedPremiumTooltip: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "This option has multiple cabin classes, with at least one flight in Premium Economy." } },
        cabinClassMixedBusinessTooltip: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "This option has multiple cabin classes, with at least one flight in Business Class." } },
        selectedFlightNotInFilterResults: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Your selected flight is not included the filtered results, but you can view its details in the Booking Summary. " } }
      },
      access: {
        cabinClassTooltipButton: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Know more" } }
      },
      filter: {
        label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Filter by stops:" } },
        "dropdown-default": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "All stops" } },
        "dropdown-direct": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Direct flights only" } },
        "dropdown-1stop-or-less": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "1 stop or less" } },
        "flights-found": { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 4, k: "count" }, { t: 3, v: " flight found" }] }, { t: 2, i: [{ t: 4, k: "count" }, { t: 3, v: " flights found" }] }] } }
      }
    },
    ancillary: {
      labels: {
        title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Extras" } },
        travelProtection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Travel Protection" } },
        terms: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Terms and Conditions" } },
        showDetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Show details" } },
        hideDetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hide details" } },
        recommended: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Recommended" } },
        traveller: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "/ traveller" } },
        adult: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "/ adult" } },
        from: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "From" } },
        perTraveller: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "per traveller" } },
        perAdult: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "per adult" } },
        price: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Price" } },
        careflex: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "CareFlex" } },
        carefree: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "CareFree" } },
        travelprotection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Travel Protection" } },
        travelprotectionNote: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Add flexibility and peace of mind to your vacation with one of our travel protection plans." } },
        privateTransfer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Private Transfer" } },
        privateTransferNote: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Book round-trip private transfers between the airport & your resort." } },
        mealPlan: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Meal Plan" } },
        mealPlanNote: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Upgrade the meal plan with your package and treat yourself to an enhanced culinary experience." } },
        activities: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Attractions and Excursions" } },
        activitiesNote: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Transform ordinary trips into extraordinary ones. Add unique and unmissable things to do in your destination." } },
        showOptions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Show options" } },
        hideOptions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hide options" } },
        showingMealPlanResults: { t: 0, b: { t: 2, i: [{ t: 3, v: "Showing 1-" }, { t: 4, k: "end" }, { t: 3, v: " of " }, { t: 4, k: "total" }, { t: 3, v: " Meal Plan(s)" }] } },
        showingOptionsResults: { t: 0, b: { t: 2, i: [{ t: 3, v: "Showing 1-" }, { t: 4, k: "end" }, { t: 3, v: " of " }, { t: 4, k: "total" }, { t: 3, v: " options" }] } },
        nothingToDisplay: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "It doesn't look like there are any Extras available for your trip." } },
        bookingSummary: {
          CAREFLEX: {
            name: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "CareFlex" } },
            inclusions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Includes cancellation with refund or travel credit, booking changes and package transfer. Certain conditions apply." } }
          },
          CAREFREE: {
            name: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "CareFree" } },
            inclusions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Includes standard seat selection and our Price Drop Guarantee. Certain conditions apply." } }
          }
        }
      },
      nudge: {
        title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Looking for some peace of mind?" } },
        prompting: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Add travel protection and enjoy stress-free travel." } },
        withProtection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Protect my booking" } },
        withoutProtection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "No, I don't want travel protection" } },
        taxesincl: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Taxes and fees incl." } },
        total: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Total" } }
      },
      access: {
        details: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Know more" } },
        "know-more-about": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Know more about" } },
        included: { t: 0, b: { t: 2, i: [{ t: 3 }], s: " Included with " } },
        "table-cell-empty": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Empty" } }
      },
      messages: {
        waitingScreenMessageTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Adding your flight" } },
        waitingScreenMessageDescription: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Give us a minute to process your request.<br>Please don't click the refresh, back or stop button." } }
      }
    },
    prices: {
      labels: {
        promoCode: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Promo code" } }
      },
      deposit: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Deposit" } },
      "deposit-payment-remaining-balance-message": { t: 0, b: { t: 2, i: [{ t: 3, v: "Remaining balance <br/>due by <b>" }, { t: 4, k: "date" }, { t: 3, v: "</b>" }] } },
      "deposit-payment-remaining-balance-mobile-message": { t: 0, b: { t: 2, i: [{ t: 3, v: "<b>" }, { t: 4, k: "remaining" }, { t: 3, v: "</b> due by <b>" }, { t: 4, k: "date" }, { t: 3, v: "</b>" }] } },
      hotelInclusions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Inclusions" } },
      "plane-icon": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Airport alert! " } },
      "multiple-airport-destination": { t: 0, b: { t: 2, i: [{ t: 3, v: "Round-trip flight via " }, { t: 4, k: "name" }, { t: 3, v: " (" }, { t: 4, k: "iata" }, { t: 3, v: ")" }] } }
    },
    giftCard: {
      labels: {
        giftCard: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Air Canada Gift Card, eCoupon or travel voucher" } },
        giftCardNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Gift card number (15 digits)*" } },
        giftCardPIN: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "PIN (4 digits)*" } }
      },
      errors: {
        giftCardAmountZero: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter an amount." } },
        giftCardInsufficientAmount: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Your gift card balance is insufficient. Please select an additional payment method." } },
        giftCardPIN: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter a PIN." } },
        giftCardNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter a gift card number." } },
        giftCardOnlyNumbers: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Only numbers are accepted." } },
        giftCardLessThanDepositWithoutInsurance: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Amount must be equal to or less than the deposit amount due without Insurance premium" } },
        giftCardSplitDeposit: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Amount must be equal to or less than the deposit amount" } },
        giftCardSplitTotal: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Amount must be equal to or less than the total amount due" } },
        giftCardSplitTotalWithoutInsurance: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Amount must be equal to or less than the total amount due without Insurance premium" } }
      },
      messages: {
        giftCardCheckAmountLink: { t: 0, b: { t: 2, i: [{ t: 3 }], s: '<a href="https://www.aircanada.com/ca/en/aco/home/book/payment-methods/air-canada-gift-cards.html#/" target="_blank" class="link">Check your gift card, eVoucher or travel voucher balance.</a>' } }
      }
    },
    showmoreresults: {
      labels: {
        moreresultsCTA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Show More" } },
        showingresultsmessage: { t: 0, b: { t: 2, i: [{ t: 3, v: "Showing 1-" }, { t: 4, k: "end" }, { t: 3, v: " of " }, { t: 4, k: "total" }, { t: 3, v: " result(s)" }] } },
        showingRoomsResultsMessage: { t: 0, b: { t: 2, i: [{ t: 3, v: "Showing 1-" }, { t: 4, k: "end" }, { t: 3, v: " of " }, { t: 4, k: "total" }, { t: 3, v: " room(s)" }] } }
      }
    },
    alternatedates: {
      messages: {
        "not-available": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "The departure date you requested is not available" } },
        "select-available-dates": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Select the next available dates from the options below." } },
        "found-one-date": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "We found the following available date:" } }
      },
      labels: {
        "prefix-available-date": { t: 0, b: { static: "", t: 2, i: [] } }
      },
      errors: {
        "mandatory-date": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please select a date." } }
      }
    }
  }
}, FN = {
  vacvComponents: {
    common: {
      buttons: {
        open: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ouvrir" } },
        close: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Fermer" } },
        select: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Choisir" } },
        selected: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Choisi" } },
        backToTop: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Revenir au haut de la page" } },
        submit: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Soumettre" } },
        add: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ajouter" } },
        added: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ajouté" } },
        showOptions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Afficher les options" } },
        hideOptions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Masquer les options" } }
      },
      generic: {
        loading: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Chargement en cours" } }
      },
      labels: {
        aeroplan: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aéroplan" } },
        details: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Détails" } },
        selectAnOption: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sélectionner une option" } }
      },
      messages: {
        "go-back": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Revenir aux résultats" } },
        "fallback-img": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Image à venir" } }
      },
      bookingsummary: {
        labels: {
          "booking-summary": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Résumé de la réservation" } },
          package: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Forfait" } },
          flight: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Vol" } },
          transfers: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Transferts" } },
          hotel: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hôtel" } },
          "hotel-and-rooms": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hôtel et chambre(s)" } },
          "round-trip-flight": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Vol aller-retour" } },
          ancillary: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ajouts" } },
          traveller: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "voyageur" } },
          travellers: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "voyageurs" } },
          included: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Inclus" } },
          travelprotection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Protection de voyage - " } },
          privateTransfer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Transfert(s) privé(s) - " } },
          "extras-included": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Comprend les ajouts sélectionnés" } }
        },
        messages: {
          "see-details": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voir plus" } },
          "hide-details": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voir moins" } },
          total: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Total" } },
          deposit: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Dépôt" } },
          "continue-booking": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Continuer" } }
        },
        errors: {
          "no-hotel-room": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nous ne pouvons charger les détails de votre hôtel et de votre chambre pour le moment. Vous pourrez les voir à l'étape suivante." } },
          "no-flights": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nous ne pouvons afficher les détails de votre vol pour le moment. Vous pourrez les consulter après avoir sélectionné votre chambre." } },
          ancillary: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nous ne pouvons charger les ajouts pour le moment. Vous pourrez les voir à l'étape suivante." } }
        },
        aeroplan: {
          "use-your-points-to-save": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Utilisez vos points pour économiser" } }
        }
      },
      pricedetails: {
        peradult: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "par adulte" } },
        total: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Total" } },
        taxesincl: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Taxes et frais inclus" } },
        title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Détails du prix" } },
        popoverLink: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Afficher détails du prix" } },
        adult: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3 }], s: "adulte" }, { t: 2, i: [{ t: 3 }], s: "adultes" }] } },
        child: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3 }], s: "enfant" }, { t: 2, i: [{ t: 3 }], s: "enfants" }] } },
        taxesFees: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "taxes et frais" } },
        estimatedTotal: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Total estimé" } },
        perNight: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "par nuit" } }
      },
      phoneNumber: {
        guestPhoneNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "1-866-529-2079" } },
        B2CPhoneNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "1-877-752-5510" } },
        B2BPhoneNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "1-877-752-7710" } }
      }
    },
    wasPrice: {
      was: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Était " } },
      save: { t: 0, b: { t: 2, i: [{ t: 3, v: "Économisez " }, { t: 4, k: "percent" }, { t: 3, v: " %" }] } }
    },
    guestsInput: {
      label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voyageurs" } },
      placeholder: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voyageurs" } },
      insideDataGuests: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 4, k: "n" }, { t: 3, v: " voyageur" }] }, { t: 2, i: [{ t: 4, k: "n" }, { t: 3, v: " voyageurs" }] }] } },
      insideDataRooms: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 4, k: "n" }, { t: 3, v: " chambre" }] }, { t: 2, i: [{ t: 4, k: "n" }, { t: 3, v: " chambres" }] }] } },
      adults: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Adultes (18+)" } },
      children: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Enfants (2 à 17 ans)" } },
      infants: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Bébés (2 ans ou moins)" } },
      counter: {
        add: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ajouter" } },
        remove: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Supprimer" } }
      },
      rooms: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Chambres" } },
      childAge: { t: 0, b: { t: 2, i: [{ t: 3, v: "Âge enfant " }, { t: 4, k: "n" }] } },
      buttonLabel: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "TERMINÉ" } },
      roomsAdvisory: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Max. 1 chambre pour les réservations avec des enfants/bébé" } },
      advisory: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "<strong>Pour 7 personnes ou plus</strong>, veuillez consulter la <a href='https://vacations.aircanada.com/fr/group-form' target='_blank'>page sur les Voyager en groupe</a> ou appelez au 1-866-529-2079 pour obtenir de l'aide." } },
      infantTurns2: { t: 0, b: { t: 2, i: [{ t: 3, v: "Si votre enfant en bas âge atteint l'âge de 2 ans pendant votre voyage, il aura besoin d'un siège de retour. Veuillez nous appeler au " }, { t: 4, k: "num" }, { t: 3, v: " pour compléter votre réservation." }] } },
      oneInfantPerAdult: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Max. d'un (1) bébé par adulte" } },
      errors: {
        GuestsSelection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Le nombre de voyageurs n'est pas valide" } },
        RoomSelection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Lors de la réservation de plusieurs chambres, les adultes doivent être répartis équitablement dans les chambres." } },
        ChildAgeSelection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez indiquer l'âge de l'enfant à la date de départ" } },
        ChildUnderTwo: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Si vous souhaitez inclure un ou plusieurs enfants de moins de 2 ans, veuillez nous appeler au 1 866 529-2079 pour compléter votre réservation." } }
      }
    },
    dialogs: {
      cubaPopup: {
        title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Vous voyagez à Cuba?" } },
        question: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Cette réservation compte-t-elle un ou plusieurs passagers qui sont des citoyens américains, des résidents permanents des États-Unis ou qui relèvent de la compétence américaine?" } },
        changeDestination: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Changer de destination" } },
        yes: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Oui" } },
        no: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Non" } },
        continue: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Poursuivre la réservation" } },
        yesSelected: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `<p>Tout voyage à destination ou en provenance de Cuba est interdit pour les citoyens et résidents permanents américains, ainsi que toute personne relevant de la compétence des États-Unis.</p><p>L'Office of Foreign Assets Control (OFAC) exige que tous les voyageurs susmentionnés remplissent une déclaration qui reconnait qu'ils sont titulaires d'un permis de voyage spécifique à Cuba, ou que leur voyage à Cuba correspond à l'une des catégories générales autorisée par un permis :</p><ul><li>Visites familiales</li><li>Activités officielles menées par le gouvernement américain, des gouvernements étrangers et certaines organisations intergouvernementales</li><li>Activités journalistiques</li><li>Recherche professionnelle/réunions et conférences professionnelles</li><li>Activités éducatives/voyages éducatifs de groupes interpersonnels</li><li>Activités religieuses</li><li>Soutien au peuple cubain</li><li>Projets humanitaires</li><li>Activités de fondations privées, ou d'instituts de recherche ou d'éducation</li><li>Exportation, importation ou transmission d'information ou de matériel d'information</li><li>Certaines transactions à l'exportation pouvant bénéficier d'une autorisation</li></ul><p>Avant de réserver un voyage à Cuba, les voyageurs américains devraient consulter le site Web du département du Trésor des États-Unis (en anglais seulement) <a href="https://ofac.treasury.gov/faqs#cuba" target="_blank">pour plus d'informations sur les sanctions relatives à Cuba</a>.</p><p>Il est interdit aux ressortissants américains (citoyens ou résidents américains), y compris les voyageurs autorisés, d'effectuer des transactions financières directes avec certains hôtels, commerces et agences de voyages cubains qui appartiennent aux services militaires ou de renseignements cubains, tels qu'ils figurent sur la Liste restrictive pour Cuba du département d'État américain. Veuillez consulter <a href="https://www.state.gov/cuba-sanctions/cuba-restricted-list/" target="_blank">la Liste restrictive pour Cuba</a> (en anglais seulement) pour en savoir plus.</p><p>De récentes modifications apportées aux sanctions américaines contre Cuba interdisent également aux ressortissants américains de se loger, de payer pour un logement ou d'effectuer une réservation auprès de certaines propriétés à Cuba. Veuillez consulter <a href="https://www.state.gov/cuba-sanctions/cuba-prohibited-accommodations-list/cuba-prohibited-accommodations-list-initial-publication/" target="_blank">la Liste d'hébergements interdits</a> (en anglais seulement) pour en savoir plus.</p>` } }
      },
      confirmation: {
        "modal-label-accessibility": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Confirmation" } }
      }
    },
    tripAdvisor: {
      review: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "avis" } },
      reviews: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "avis" } },
      "access-rating": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Note Tripadvisor " } },
      "access-bubbles": { t: 0, b: { t: 2, i: [{ t: 3 }], s: " sur 5 bulles" } }
    },
    aeroplan: {
      aeroplan: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aeroplan" } },
      "signin-btn": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ouvrir une session" } },
      "cont-as-guest-btn": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Continuer comme invité" } },
      "earn-or-book-and-save": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Accumulez avec vos vacances ou économisez en réservant avec vos points" } },
      "login-banner": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Réservez avec des points ou accumulez pour vos prochaines vacances." } },
      points: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "pts" } },
      "points-initial-text": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sélectionner points" } },
      "points-zero": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aucun point" } }
    },
    carousel: {
      "aria-modal": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voir galerie de photos" } },
      "aria-next": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Suivant" } },
      "aria-previous": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Précédent" } },
      caption: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Image" } },
      slidenum: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "de" } },
      photo: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Photo de" } }
    },
    confirmation: {
      labels: {
        title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Votre réservation est confirmée!" } },
        bookingNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Votre numéro de réservation:" } },
        bookingSummaryTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Résumé de la réservation" } },
        travellersTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voyageurs" } },
        accommodationTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hôtel et chambre(s)" } },
        print: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Imprimer la confirmation" } },
        congrats: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Félicitations" } },
        getReadyTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Préparez-vous pour vos vacances" } },
        aeroplanJoin: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Adhérez à Aéroplan" } },
        aeroplanJoinLink: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "https://www.aircanada.com/aeroplan/member/enrolment?lang=fr-CA" } },
        aeroplanAddNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ajoutez le(s) numéro(s) Aéroplan" } },
        aeroplanAddNumberLink: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "https://vacations.aircanada.com/fr/infos-de-voyage/gestion-reservation" } },
        hotelTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hôtel et chambre(s)" } },
        checkInTime: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Enregistrement:" } },
        checkOutTime: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Départ:" } },
        flightTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Vol aller-retour" } },
        ancillaryTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ajouts" } },
        priceDetailsTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Détails du prix" } },
        privateTransferDescription: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Il n'est pas trop tard pour ajouter un transfert privé aller-retour entre l'aéroport et votre complexe hôtelier." } },
        privateTransferButton: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ajouter à votre réservation" } },
        paymentTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Mode(s) de paiement" } },
        uplift: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Flex Pay" } },
        CAREFLEX: {
          name: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "TouteTranquillité" } },
          inclusions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Comprend l'annulation avec remboursement ou crédit de voyage, les modifications de réservation et le transfert de forfait. Certaines conditions s'appliquent." } }
        },
        CAREFREE: {
          name: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "TouteFlexibilité" } },
          inclusions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Comprend la sélection standard des sièges et notre garantie ProtègePrix. Certaines conditions s'appliquent." } }
        },
        CFCTA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Contribution FICAV" } },
        insuranceTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Protection de voyage" } },
        insuranceLogoTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Allianz Global Assistance" } },
        insuranceDescription: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Protégez votre santé et vos finances afin de pouvoir voyager en toute confiance au Canada et dans le monde entier. Bénéficiez d'une couverture d'assurance précieuse et d'une assistance d'urgence en tout temps de la part de l'équipe d'Allianz Global Assistance, qui est là pour vous aider tout au long de votre voyage." } },
        insuranceContact: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `ou appelez Allianz Global Assistance aujourd'hui au <span class="tel">1 833 358-0582</span>.` } },
        insuranceNote: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "L'assurance voyage est souscrite auprès de la Compagnie d'Assurance Générale CUMIS, l'une des sociétés du Groupe Co-operators, et est administrée par Allianz Global Assistance qui est une dénomination commerciale enregistrée d'AZGA Service Canada Inc." } },
        insuranceBtn: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Obtenez une soumission en ligne" } },
        seatSelTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Présélection des sièges" } },
        seatSelOption1: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sélectionnez votre siège maintenant ou passez à un siège Préférence moyennant un supplément." } },
        seatSelOption2: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Sélectionnez votre siège ultérieurement via la page <a href="https://vacations.aircanada.com/fr/infos-de-voyage/gestion-reservation" target="_blank" class="link">Gestion de votre réservation</a>.' } },
        seatSelOption3: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Si vous avez ajouté la protection TouteTranquillité à votre réservation, sélectionnez votre siège via le lien ci-dessus ou contactez-nous au 1 866 529-2079 pour passer à un siège Préférence." } },
        seatSelBtn: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sélectionnez votre siège" } },
        giftCard: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Carte-cadeau Air Canada se terminant par" } },
        endingWith: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "••••" } }
      },
      messages: {
        thankYou: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Merci de voyager avec Vacances Air Canada." } },
        checkInbox: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Vérifiez votre boîte de réception pour les détails de votre réservation." } },
        "aeroplan-points-confirmation-0": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Vous accumulerez des points Aéroplan pour ce forfait." } },
        "aeroplan-points-confirmation-1": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Consultez votre compte <strong>après vos vacances</strong> pour voir votre nouveau solde de points." } },
        aeroplanEnroll: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `<h2 class="h3style">Vous n'êtes pas membre d'Aéroplan?</h2>Le plus important programme de fidélité des voyageurs au Canada aide les membres à voyager plus et mieux en leur donnant accès à des avantages extraordinaires.` } },
        aeroplanBenefits: { t: 0, b: { t: 2, i: [{ t: 3 }], s: '<ul class="spa-list special-list details-2col"><li>Accumulez des points sur tous les forfaits qui incluent les vols</li><li>Atteignez le statut Aéroplan Élite<span class="sup-small">mc</span> plus rapidement grâce aux forfaits vacances. Accumulez TOUTES  les unités de qualification</li><li>Accumulez des points plus rapidement lorsque vous réservez avec des cartes de crédit admissibles</li><li>Envoyez des textos gratuitement pendant votre vol grâce au <a href="https://www.aircanada.com/ca/fr/aco/home/fly/onboard/in-flight-entertainment-and-connectivity.html#/wifi" target="_blank" class="link">Wi-Fi à bord</a>. Commandité par Bell</li><li>Échangez vos points pour aussi peu que 5 000 points</li><li>Rabais exclusifs sur les activités</li><li>Combinez vos points avec ceux des membres de votre famille pour obtenir des primes plus rapidement grâce au Partage familial Aéroplan</li></ul>' } },
        aeroplanAlready: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "<strong>Vous avez oublié d'indiquer le(s) numéro(s) Aéroplan pour vous ou pour d'autres voyageurs lors de votre réservation?</strong><br>Ne manquez pas les points Aéroplan qui peuvent être accumulés!" } },
        ancillaryTravelProtectionLink: { t: 0, b: { t: 2, i: [{ t: 3 }], s: '<a href="https://vacations.aircanada.com/fr/infos-de-voyage/protections-de-voyage" target="_blank" class="link">En savoir plus</a>' } }
      }
    },
    filters: {
      filteredBy: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Filtré par" } },
      clearFilters: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Effacer tous les filtres" } },
      rangeSlider: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Prix par adulte ($)" } },
      destinations: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Destinations" } },
      moreDestinations: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Plus de destinations" } },
      moreAmenities: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Plus de commodités" } },
      priceRange: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Prix par adulte" } },
      deals: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Offres" } },
      starRating: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Classement" } },
      amenities: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Commodités" } },
      vacationType: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Type de vacances" } },
      error: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez choisir au moins un filtre pour appliquer les filtres." } },
      showLess: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Afficher moins" } },
      showMore: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Afficher plus" } },
      applyButton: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Appliquer" } },
      filter: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "filtrer" } },
      starslabel: {
        stars: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "étoiles " } },
        andup: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "et plus" } }
      },
      starRatingOptions: {
        2: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "2 étoiles et plus" } },
        3: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "3 étoiles et plus" } },
        4: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "4 étoiles et plus" } },
        5: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "5 étoiles" } }
      },
      filterBy: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Filtrer par :" } }
    },
    hotelRating: {
      stars: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "étoiles" } }
    },
    productDetails: {
      bestFor: {
        title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Idéal pour" } },
        learnMore: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "En savoir plus" } },
        hideDetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voir moins" } }
      },
      labels: {
        accessibleAnchor: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aller à la section " } },
        hotel: {
          important: {
            title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Informations importantes" } }
          },
          facilities: {
            title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Installations" } }
          },
          location: {
            title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Emplacement" } }
          },
          offers: {
            title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Offres" } }
          },
          overview: {
            title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aperçu" } }
          }
        }
      },
      overview: {
        title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aperçu" } },
        checkin: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Enregistrement:" } },
        checkout: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Départ:" } },
        numberRooms: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nombre de chambres:" } },
        numberBars: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nombre de bars:" } },
        numberRestaurants: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nombre de restaurants:" } },
        numberPoolsOutdoor: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nombre de piscines (extérieures):" } },
        inclusions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Inclusions" } },
        otherServices: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Autres services payants ($)" } }
      },
      map: {
        "zoom-in": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Zoom avant" } },
        "zoom-out": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Zoom arrière" } },
        "enter-full-screen": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Plein écran" } },
        "exit-full-screen": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Quitter le plein écran" } }
      },
      important: {
        title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Informations importantes" } }
      },
      facilities: {
        title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Installations" } },
        showMore: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voir plus" } },
        showLess: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voir moins" } },
        disclaimer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "*Des frais supplémentaires peuvent s'appliquer et le service peut nécessiter une réservation." } },
        foodAndDrinks: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Restaurants et bars" } },
        activities: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Activités" } },
        otherFacilitiesAndServices: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Autres installations et de services" } },
        pools: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Installations de piscine" } },
        landSports: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Activités terrestres" } },
        waterSports: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sports nautiques non motorisés et motorisés" } },
        entertainment: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Divertissement" } },
        golf: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Golf" } },
        bars: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Bars" } },
        restaurants: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Restaurants" } },
        restaurantType: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Type de restaurant" } },
        restaurantCuisine: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Type de cuisine" } },
        restaurantNote: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Note" } },
        additionalInformation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Renseignements supplémentaires" } },
        health: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Spa et bien-être" } },
        disclaimerPetFriendly: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "**Des restrictions et des frais supplémentaires peuvent s'appliquer pour les animaux de compagnie." } }
      },
      offers: {
        title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Offres" } },
        terms: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Conditions générales" } },
        showLess: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voir moins" } }
      },
      rooms: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Chambres" } }
    },
    travellersTitle: {
      labels: {
        secureBooking: { t: 0, b: { t: 2, i: [{ t: 3 }], s: '<i class="fa-sharp fa-solid fa-lock-keyhole"></i><span class="sr-only">Savoir plus sur la</span> Réservation sécurisée' } },
        title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voyageurs" } },
        "title-note": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "(*) Champs obligatoires" } }
      },
      messages: {
        secureTooltipTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sécurité et confidentialité" } },
        secureTooltipContent: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Chaque transaction avec Vacances Air Canada est sécurisée. Toute information personnelle que vous partagez avec nous sera traitée conformément à notre <a href="https://vacations.aircanada.com/fr/securite-confidentialite" target="_blank" class="link">politique de confidentialité</a>.' } }
      }
    },
    traveller: {
      errors: {
        noTitleSelected: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez sélectionner votre titre de civilité." } },
        noFirstNameEntered: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir votre prénom." } },
        noLastNameEntered: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir votre nom de famille." } },
        noDOBEntered: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir votre date de naissance." } },
        invalidDOB: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir une date valide." } },
        invalidChildDOB: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "L'âge de votre enfant ou de vos enfants ne correspond pas à la date de naissance indiquée. Veuillez réessayer en lançant une nouvelle recherche." } },
        invalidInfantReturnDOB: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Votre bébé aura 2 ans pendant votre voyage." } },
        invalidInfantReturnDOBDetails: { t: 0, b: { t: 2, i: [{ t: 3, v: "Les voyageurs âgés de 2 ans et plus doivent occuper leur propre siège, conformément à la réglementation de Transports Canada. Vous devez acheter un siège aller-retour pour votre enfant de 2 ans. <br/><strong>Veuillez nous appeler au " }, { t: 4, k: "num" }, { t: 3, v: " pour compléter votre réservation.</strong>" }] } },
        noEmailEntered: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir votre adresse courriel." } },
        noPhoneNumberEntered: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir votre numéro de téléphone à 10 chiffres." } },
        noOtherTravellerDateOfBirth: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir la date de naissance." } },
        noOtherTravellerTitleField: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez sélectionner le titre de civilité." } },
        noOtherTravellerFirstName: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir le prénom." } },
        noOtherTravellerLastName: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir le nom de famille." } },
        nameWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Seuls les lettres (A-Z, a-z), les lettres accentuées, les traits d'union et les apostrophes sont acceptés." } },
        ccNameWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Seuls les lettres (A-Z, a-z), les lettres accentuées, les traits d'union et les apostrophes sont acceptés." } },
        phoneNumberWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Seuls les chiffres (0-9) et les caractères spéciaux (« + », « -», « (« et ») ») sont acceptés" } },
        aeroplanNumberWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Seuls les chiffres (0-9) sont acceptés." } },
        employeeNamePrefilled: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Il y a un problème avec ce nom. Veuillez appeler le 1 877 752-5510 pour compléter la réservation." } },
        firstNameTextLength: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Un maximum de 20 caractères est accepté." } },
        lastNameTextLength: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Un maximum de 20 caractères est accepté." } },
        aeroplanInvalidNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez entrer un numéro Aéroplan valide." } },
        phoneNumberTextLength: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Un maximum de 20 caractères est accepté." } },
        emailTextLength: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Un maximum de 50 caractères est accepté." } },
        emailWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir un courriel valide." } }
      },
      labels: {
        adult: { t: 0, b: { t: 2, i: [{ t: 4, k: "index" }, { t: 4, k: "pos" }, { t: 3, v: " adulte" }] } },
        child: { t: 0, b: { t: 2, i: [{ t: 4, k: "index" }, { t: 4, k: "pos" }, { t: 3, v: " enfant (" }, { t: 4, k: "age" }, { t: 3, v: " ans)" }] } },
        childHideAge: { t: 0, b: { t: 2, i: [{ t: 4, k: "index" }, { t: 4, k: "pos" }, { t: 3, v: " enfant" }] } },
        infant: { t: 0, b: { t: 2, i: [{ t: 4, k: "index" }, { t: 4, k: "pos" }, { t: 3, v: " bébé(s) (2 ans ou moins)" }] } },
        infantHideAge: { t: 0, b: { t: 2, i: [{ t: 4, k: "index" }, { t: 4, k: "pos" }, { t: 3, v: " bébé(s)" }] } },
        dateOfBirth: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Date de naissance" } },
        "dateOfBirth-filled": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Date de naissance :" } },
        travellerTitleField: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Titre de civilité" } },
        travellerTitleMr: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "M." } },
        travellerTitleMrs: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Mme" } },
        travellerTitleMs: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Mlle" } },
        travellerFirstName: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Prénom" } },
        travellerMiddleName: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "2e prénom" } },
        travellerLastName: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nom de famille" } },
        travellerEmail: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Adresse courriel" } },
        "travellerEmail-filled": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Adresse courriel :" } },
        travellerPhoneNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Numéro de téléphone" } },
        "travellerPhoneNumber-filled": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Numéro de téléphone :" } },
        travellerAeroplanNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Numéro Aéroplan" } },
        "travellerAeroplanNumber-filled": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Numéro Aéroplan :" } }
      },
      messages: {
        mainTraveller: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "(Voyageur principal)" } },
        travellerName: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Inscrivez les informations telles qu'elles figurent sur le passeport." } },
        travellerEmailDisclaimer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Toute la correspondance de voyage et les billets seront envoyés à cette adresse courriel." } }
      },
      placeholders: {
        birthDay: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "JJ" } },
        birthMonth: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "MM" } },
        birthYear: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "AAAA" } }
      }
    },
    pricedetails: {
      peradult: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "par adulte" } },
      total: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Total" } },
      taxesincl: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Taxes et frais inclus" } },
      title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Détails du prix" } },
      titleHotelsSpa: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Détails du prix" } },
      popoverLink: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Afficher détails du prix" } },
      adult: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3 }], s: "adulte" }, { t: 2, i: [{ t: 3 }], s: "adultes" }] } },
      child: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3 }], s: "enfant" }, { t: 2, i: [{ t: 3 }], s: "enfants" }] } },
      infant: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3 }], s: "bébé" }, { t: 2, i: [{ t: 3 }], s: "bébés" }] } },
      infantAge: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "0-2 ans" } },
      taxesFees: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "taxes et frais" } },
      estimatedTotal: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Total estimé" } },
      paymentSubtotal: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sous-total" } },
      "extras-included": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Comprend les ajouts sélectionnés" } },
      "aeroplan-points-applied": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "points Aéroplan appliqués" } },
      nonRefundableRate: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Tarif non remboursable" } },
      paymentAEPoints: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aeroplan Points" } },
      nights: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "nuit(s)" } },
      taxesAndFees: { t: 0, b: { t: 2, i: [{ t: 3 }], s: " Taxes et frais" } }
    },
    legal: {
      disclaimer: {
        price: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Les prix sur notre site Web reflètent les réductions applicables et sont valides lors de l'achat de services le temps d'une même session. Les prix pourraient être différents si vous ouvrez ultérieurement une nouvelle session. Le prix final sera affiché au moment de la confirmation du paiement." } },
        "was-price": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Le prix rayé représente le prix initial du marché avant les rabais applicables." } }
      }
    },
    plp: {
      labels: {
        recommended: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Recommandé" } },
        "recommended-access": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Cet hôtel est " } }
      },
      messages: {
        notfound: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Il semble que nous ne puissions pas trouver exactement ce que vous cherchez." } },
        "notfound-filters": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Il n'y a pas de vacances qui correspondent aux filtres sélectionnés. Essayez à nouveau avec d'autres options de filtre." } },
        "notfound-filters-hotels": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Il n'y a pas d'hôtels qui correspondent aux filtres sélectionnés. Essayez à nouveau avec d'autres options de filtre." } },
        "notfound-unavailable": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Il semble que votre destination actuelle ne soit pas disponible." } },
        packagesfound: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "forfaits trouvés" } },
        "packagesfound-single": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "forfait trouvé" } },
        suggest: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voici ce que nous vous suggérons :" } },
        "suggest-date": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Modifiez vos dates de voyage." } },
        "suggest-nearby-airports": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Vérifiez les aéroports à proximité." } },
        "suggest-different-airport": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Essayez d'autres aéroports." } },
        "suggest-different-destination": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sélectionnez une autre destination." } },
        "suggest-alternative-destination": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sélectionnez une autre destination." } },
        "suggest-travellers": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Réduisez le nombre de voyageurs." } },
        "specific-s214-error-tulum": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nous ne trouvons pas de vols disponibles pour Tulum pour les dates que vous avez sélectionnées." } },
        "suggest-cancun-good-news": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Bonne nouvelle! Vous pouvez toujours vous rendre à nos hôtels de Tulum en prenant un vol pour Cancún." } },
        "suggest-cancun-update": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nous vous suggérons de mettre à jour votre recherche et de sélectionner Cancún comme destination." } },
        "something-went-wrong": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Il semble y avoir eu un problème." } },
        "try-again-by": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Essayez de nouveau avec les options suivantes :" } },
        "click-modify": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Recommencez la recherche en cliquant sur « Modifier » ci-dessus." } },
        "refresh-page": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Rafraîchissez la page." } },
        alertNoCabinSearchedAvailable: { t: 0, b: { t: 2, i: [{ t: 3, v: "Il n'y a pas de sièges " }, { t: 4, k: "searchedCabin" }, { t: 3, v: " disponibles pour les dates que vous avez sélectionnées. Cependant, des places en " }, { t: 4, k: "returnedCabin" }, { t: 3, v: " sont disponibles autour de ces dates." }] } },
        alertAdditionalCabinsAvailable: { t: 0, b: { t: 2, i: [{ t: 3, v: "Nous avons trouvé des sièges disponibles en " }, { t: 4, k: "searchedCabin" }, { t: 3, v: " sur le vol pour les dates sélectionnées. Nous avons également trouvé des forfaits disponibles autour de ces dates en " }, { t: 4, k: "returnedCabin" }, { t: 3, v: "." }] } },
        "children-more-than-one-room-error": { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Pour effectuer une réservation avec des enfants, sélectionnez une chambre ou <a href="https://vacations.aircanada.com/fr/nous-joindre" target="_blank" class="link">contactez-nous</a>.' } },
        "more-than-6-pax-error": { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Pour les réservations de plus de 6 voyageurs, <a href="https://vacations.aircanada.com/fr/nous-joindre" target="_blank" class="link">contactez-nous</a>.' } },
        "update-your-search": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Mettre à jour votre recherche" } },
        "adults-repartition-error": { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Veuillez répartir le nombre d'adultes de manière égale entre le nombre de chambres et réessayer. Si vous avez besoin d'aide pour votre réservation, <a href="https://vacations.aircanada.com/fr/nous-joindre" target="_blank" class="link">contactez-nous</a>.` } },
        recommended: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Recommandé" } },
        "recommended-access": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Cet hôtel est " } }
      },
      filters: {
        filter: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "filter" } }
      }
    },
    plpList: {
      flexibleDates: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Dates flexibles" } },
      flexDates: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Plus de dates et de prix" } },
      flexDatesDeparture: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Départ" } },
      flexNights: { t: 0, b: { t: 2, i: [{ t: 3, v: "(" }, { t: 4, k: "count" }, { t: 3, v: " nuits)" }] } },
      roomShowDetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Afficher tous les détails" } },
      roomOptionsInfo: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3, v: "Jusqu'à " }, { t: 4, k: "count" }, { t: 3, v: " autre option de chambre disponible dans cet hôtel" }] }, { t: 2, i: [{ t: 3, v: "Jusqu'à " }, { t: 4, k: "count" }, { t: 3, v: " autres options de chambres disponibles dans cet hôtel" }] }] } },
      roomOptionsButton: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Afficher toutes les options de chambres" } },
      roomDetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Détails de la chambre" } },
      stars: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "étoiles" } },
      aeroplanpointsTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Conditions générales" } },
      flightdetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Détails du vol" } }
    },
    psytriggers: {
      "rooms-left": { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3, v: "Plus que " }, { t: 4, k: "count" }, { t: 3, v: " chambre!" }] }, { t: 2, i: [{ t: 3, v: "Plus que " }, { t: 4, k: "count" }, { t: 3, v: " chambres!" }] }] } },
      "total-bookings-24": { t: 0, b: { t: 2, i: [{ t: 3, v: "Hôtel réservé " }, { t: 4, k: "count" }, { t: 3, v: " fois dans les dernières 24 h" }] } },
      "total-bookings-48": { t: 0, b: { t: 2, i: [{ t: 3, v: "Hôtel réservé " }, { t: 4, k: "count" }, { t: 3, v: " fois dans les dernières 48 h" }] } },
      "last-booking-minute": { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3, v: "Hôtel réservé il y a " }, { t: 4, k: "count" }, { t: 3, v: " minute" }] }, { t: 2, i: [{ t: 3, v: "Hôtel réservé il y a " }, { t: 4, k: "count" }, { t: 3, v: " minutes" }] }] } },
      "last-booking-hour": { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3, v: "Hôtel réservé il y a " }, { t: 4, k: "count" }, { t: 3, v: " heure" }] }, { t: 2, i: [{ t: 3, v: "Hôtel réservé il y a " }, { t: 4, k: "count" }, { t: 3, v: " heures" }] }] } },
      "room-last-booking-minute": { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3, v: "Chambre réservée il y a " }, { t: 4, k: "count" }, { t: 3, v: " minute" }] }, { t: 2, i: [{ t: 3, v: "Chambre réservée il y a " }, { t: 4, k: "count" }, { t: 3, v: " minutes" }] }] } },
      "room-last-booking-hour": { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3, v: "Chambre réservée il y a " }, { t: 4, k: "count" }, { t: 3, v: " heure" }] }, { t: 2, i: [{ t: 3, v: "Chambre réservée il y a " }, { t: 4, k: "count" }, { t: 3, v: " heures" }] }] } },
      "room-total-bookings-24": { t: 0, b: { t: 2, i: [{ t: 3, v: "Chambre réservée " }, { t: 4, k: "count" }, { t: 3, v: " fois dans les dernières 24 h" }] } },
      "room-total-bookings-48": { t: 0, b: { t: 2, i: [{ t: 3, v: "Chambre réservée " }, { t: 4, k: "count" }, { t: 3, v: " fois dans les dernières 48 h" }] } },
      "rooms-left-advisory": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ce nombre s'appuie sur l'inventaire actuel de Vacances Air Canada qui peut varier quotidiennement." } },
      "bookings-advisory": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ce nombre s'appuie sur les données de réservation actuelles de Vacances Air Canada, qui sont susceptibles d'être mises à jour toutes les 60 minutes." } }
    },
    progressbar: {
      labels: {
        navback: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Retour" } },
        stepofsteps: { t: 0, b: { t: 2, i: [{ t: 3, v: "Étape " }, { t: 4, k: "step" }, { t: 3, v: " de " }, { t: 4, k: "steps" }, { t: 3, v: " - " }] } },
        hotel: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hôtel" } },
        room: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Chambre(s)" } },
        flight: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Vol" } },
        extras: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ajouts" } },
        payment: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Paiement" } }
      }
    },
    payment: {
      labels: {
        title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voyageurs" } },
        "title-note": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "(*) Champs obligatoires" } },
        secureBooking: { t: 0, b: { t: 2, i: [{ t: 3 }], s: '<i class="fa-sharp fa-solid fa-lock-keyhole"></i><span class="sr-only">Savoir plus sur la</span> Réservation sécurisée' } },
        paymentMethod: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Mode de paiement" } },
        twoCreditCards: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Je souhaite utiliser 2 cartes de crédit" } },
        sameAddress: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Utiliser l'adresse de la carte 1" } },
        creditCard: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Carte de crédit" } },
        creditCardAmount: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Montant ($)" } },
        creditCardName: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nom figurant sur la carte" } },
        creditCardExpiry: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Date d'expiration (MM-AA)" } },
        creditCardAddressTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Adresse de facturation" } },
        creditCardAddress: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Adresse" } },
        creditCardApartment: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Appartement" } },
        creditCardCity: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ville" } },
        creditCardCountry: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Pays" } },
        creditCardProvince: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Province/État" } },
        creditCardPostCode: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Code postal" } },
        creditCardConfirm: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Confirmer le paiement" } },
        updateInformation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Modifier les détails" } },
        passengerProtection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Avis concernant le Règlement sur la protection des passagers aériens" } },
        promocodeTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Code promo" } },
        promocodeApplyButton: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Appliquer" } },
        promocodeRemoveButton: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Retirer" } },
        paymentOptions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Options de paiement" } },
        payInFull: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Paiement total" } },
        payWithDeposit: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Réservez avec un dépot" } },
        depositModalTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Réservez avec un dépot" } },
        payWithUplift: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Payez mensuellement avec Flex Pay" } },
        note: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Remarque :" } },
        travellerInfoNormalizedNote: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nous avons adapté les noms des voyageurs dans votre réservation pour répondre aux exigences de notre système." } },
        upliftFrom: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "À partir de " } },
        payMonthlyOffer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "$/mois" } },
        upliftWarningModalTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voulez-vous vraiment mettre à jour votre réservation?" } },
        upLiftWarningModalBtnOK: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Mettre à jour ma réservation" } },
        upliftWarningModalBtnCancel: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Annuler" } },
        allianzTravelInsuranceTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Assurance voyage Allianz" } },
        allianzTravelInsuranceDescription: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Protégez votre bien-être et vos finances et voyagez en toute sérénité." } },
        allianzTravelInsuranceDescription2: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez faire une sélection pour continuer." } },
        allianzTravelInsuranceNotesTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Remarques:" } },
        allianzDeclineTravelInsurance: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Je refuse la protection pour mon voyage et je comprends que je peux être responsable des dépenses non remboursables." } },
        allianzAddTravelInsurance: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ajouter" } },
        allianzAddedTravelInsurance: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ajouté" } },
        mostPopular: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Le plus populaire" } },
        allianzTermsAndConditions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Conditions <span>générales<i class="fa-solid fa-arrow-up-right-from-square"></i></span>' } },
        allianzProductSummary: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Résumé du <span>produit<i class="fa-solid fa-arrow-up-right-from-square"></i></span>' } },
        priceTitle: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3 }], s: "Prix total pour 1 voyageur plus les taxes applicables" }, { t: 2, i: [{ t: 3, v: "Prix total pour " }, { t: 4, k: "count" }, { t: 3, v: " voyageurs plus les taxes applicables" }] }] } },
        allianzProductChangeBtn: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Change" } },
        travelInsurance: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Assurance voyage" } },
        insuranceForXTravellers: { t: 0, b: { t: 2, i: [{ t: 3, v: "pour " }, { t: 4, k: "x" }, { t: 3, v: " passagers" }] } },
        insuranceXTravellers: { t: 0, b: { t: 2, i: [{ t: 4, k: "x" }, { t: 3, v: " voyageur(s)" }] } },
        plusTaxes: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Plus les taxes applicables" } },
        billedSeparately: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Facture séparée" } },
        allianzOptedOutInsurance: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Vous avez choisi de ne pas souscrire à l'assurance voyage. Veuillez noter que vous pouvez être responsable des dépenses non remboursables." } },
        insuranceDOBChangeAdvisoryAccept: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "OK" } },
        allianzDescriptionNotesTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Remarques:" } },
        allianzDescriptionNotesNoteOne: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Votre assurance voyage sera facturée séparément sur cette carte de crédit par Allianz Global Assistance." } },
        allianzDescriptionNotesNoteTwo: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Lorsque vous souscrivez une assurance voyage, vous consentez à ce que Vacances Air Canada divulgue à Allianz Global Assistance certains des renseignements personnels que vous avez fournis (tels que les renseignements relatifs à votre carte de crédit)." } }
      },
      placeholders: {
        select: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sélectionner" } }
      },
      validation: {
        paymentMethod: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez sélectionner un mode de paiement." } }
      },
      errors: {
        ccNameWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Seuls les lettres (A-Z, a-z), les lettres accentuées, les traits d'union et les apostrophes sont acceptés." } },
        ccAmountZero: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Le montant ne peut être 0,00 $" } },
        ccAmountEqualToTotal: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Pour continuer, veuillez sélectionner une carte de crédit" } },
        ccAmountTooHighDeposit: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Le montant doit être inférieur au montant du dépôt" } },
        expirationWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir la date en suivant le format MM-AA." } },
        expirationPastDate: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir une date d'expiration de carte de crédit valide" } },
        giftCardPayInFull: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Votre réservation sera payée en totalité avec votre carte-cadeau Air Canada." } },
        maxCharsAccepted: { t: 0, b: { t: 2, i: [{ t: 3, v: "Un maximum de " }, { t: 4, k: "max" }, { t: 3, v: " caractères est accepté." }] } },
        maxTwoPaymentMethods: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Vous avez déjà sélectionné un maximum de 2 modes de paiement. Pour utiliser votre carte-cadeau, veuillez désélectionner l'un de vos modes de paiement." } },
        notSupportedIframe: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Votre navigateur ne prend pas en charge les iframes. Veuillez utiliser un navigateur compatible pour afficher ce contenu" } },
        pleaseEnterCCName: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir le nom du titulaire de la carte" } },
        pleaseEnterCCExpiryDate: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir la date d'expiration" } },
        pleaseEnterCCAddress: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir l'adresse" } },
        pleaseEnterCCCity: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir la ville" } },
        pleaseEnterCCCountry: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez sélectionner le pays" } },
        pleaseEnterCCProvince: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez sélectionner la province ou l'état" } },
        pleaseEnterCCPostalCode: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir le code postal" } },
        cityWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Seuls les lettres (A-Z, a-z), les espaces (« -») et les caractères spéciaux sont acceptés" } },
        postalCodeWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez entrer un code postal valide." } },
        upliftFormNotCompleted: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez compléter le formulaire Flex Pay avant de confirmer le paiement, ou sélectionnez un autre plan de paiement." } },
        unableGetUpliftToken: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nous ne sommes pas en mesure de soumettre votre demande Flex Pay pour le moment. Veuillez réessayer." } },
        offerNotAvailable: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Prix actuellement indisponible" } },
        promocodeError: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Code promo non valide" } },
        pleaseEnterYour: { t: 0, b: { t: 2, i: [{ t: 3, v: "Veuillez saisir votre " }, { t: 4, k: "field" }, { t: 3, v: "." }] } },
        noCardNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir le numéro de la carte" } },
        noCVV: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir le code de sécurité" } },
        cvvWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir un CVC valide" } },
        ccWrongFormat: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir un numéro de carte de crédit valide" } },
        ccTypeNotAccepted: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir un numéro de carte valide pour un type de carte accepté" } },
        creditCardPaymentFailure: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nous ne sommes pas en mesure d'effectuer votre réservation en raison d'une erreur de paiement. Veuillez contacter votre banque." } },
        paymentAlreadyBooked: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Votre forfait a déjà été réservé. Si vous ne recevez pas votre courriel de confirmation dans les 60 prochaines minutes, <a href="https://vacations.aircanada.com/fr/nous-joindre" target="_blank" class="link">veuillez nous contacter</a>.' } },
        errorHotel: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nous ne sommes pas en mesure de confirmer votre réservation auprès de l'hôtel. Veuillez choisir un autre type de chambre ou un autre hôtel." } },
        paymentUserInput: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Votre paiement ne peut être complété. Veuillez vérifier vos informations de carte de crédit et réessayer." } },
        paymentFlightClientError: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Le vol sélectionné n'est plus disponible. Veuillez réessayer avec d'autres dates ou classes de cabine." } },
        paymentBookingError: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Le forfait sélectionné n'est plus disponible. Veuillez réessayer avec d'autres dates ou une autre destination. Si l'erreur persiste, <a href="https://vacations.aircanada.com/fr/nous-joindre" target="_blank" class="link">veuillez nous contacter</a>.` } },
        paymentIncorrectPaxInfo: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Les informations sur les passagers ne sont pas valides. Veuillez vérifier et réessayer. Si l'erreur persiste, <a href="https://vacations.aircanada.com/fr/nous-joindre" target="_blank" class="link">veuillez nous contacter</a>.` } },
        paymentTechnicalError: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Désolé, une erreur s'est produite lors de votre réservation. Veuillez réessayer. Si l'erreur persiste, <a href="https://vacations.aircanada.com/fr/nous-joindre" target="_blank" class="link">veuillez nous contacter</a>.` } },
        payment3DSError: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Une erreur s'est produite lors du traitement de votre paiement. Veuillez réessayer. Si le problème persiste, veuillez contacter votre banque." } },
        maxNumberOfAttempts3DSTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Attention" } },
        maxNumberOfAttempts3DSMessage: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "<p>Le nombre maximum d'essais a été atteint. Vous allez être redirigé·e vers la page d'accueil.</p>" } },
        maxNumberOfAttempts3DSCta: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "OK" } },
        repeatCC: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ne peut être identique à la carte de crédit 1" } },
        ccAmountTooHighFull: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Le montant doit être inférieur au montant total" } },
        ccAmountValueTypeError: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Seuls les chiffres (0-9) sont acceptés" } },
        allianzError: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez sélectionner une formule d'assurance voyage ou refuser l'assurance voyage pour continuer*." } }
      },
      messages: {
        continue: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Continuer" } },
        secureTooltipTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sécurité et confidentialité" } },
        secureTooltipContent: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'Chaque transaction avec Vacances Air Canada est sécurisée. Toute information personnelle que vous partagez avec nous sera traitée conformément à notre <a href="https://vacations.aircanada.com/fr/securite-confidentialite" target="_blank" class="link">politique de confidentialité</a>.' } },
        mainTraveller: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "(Voyageur principal)" } },
        termsConditions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: 'En confirmant votre paiement, vous reconnaissez avoir lu et compris les <a href="https://vacations.aircanada.com/fr/conditions-generales" target="_blank" class="link">conditions générales</a> et la <a href="https://vacations.aircanada.com/fr/securite-confidentialite" target="_blank" class="link">politique de confidentialité</a> de Vacances Air Canada.' } },
        packageNotAvailable: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Votre choix est actuellement indisponible." } },
        "try-again": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez réessayer en effectuant une autre sélection." } },
        "passengerProtection-1": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Si l'embarquement vous est refusé, ou si votre vol est annulé ou retardé d'au moins deux heures ou si vos bagages sont perdus ou endommagés, vous pourriez avoir droit au titre du Règlement sur la protection des passagers aériens, à certains avantages au titre des normes de traitement applicables et à une indemnité. Pour de plus amples renseignements sur vos droits, veuillez communiquer avec votre transporteur aérien ou visiter le site Web de l'Office des transports du Canada." } },
        "passengerProtection-2": { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Les conditions générales de transport applicables aux retards et annulations de vols, les refus d'embarquement, à l'attribution des sièges pour les enfants et les bagages endommagés à la page des <a href="https://www.aircanada.com/ca/fr/aco/home/legal/conditions-carriage-tariffs.html#/" target="_blank" class="link">Conditions générales de transport et tarifs d'Air Canada</a>.` } },
        "aeroplan-you-have-x-points": { t: 0, b: { t: 2, i: [{ t: 3, v: "Vous avez <span>" }, { t: 4, k: "points" }, { t: 3, v: "</span> points Aéroplan" }] } },
        "aeroplan-you-can-redeem-x-to-save-y": { t: 0, b: { t: 2, i: [{ t: 3, v: "Vous pouvez échanger un maximum de <span>" }, { t: 4, k: "points" }, { t: 3, v: "</span> points pour économiser <span>" }, { t: 4, k: "dollars" }, { t: 3, v: "</span>" }] } },
        "waiting-message-title": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nous terminons votre réservation" } },
        "waiting-message-description": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Le traitement de votre demande peut prendre quelques minutes. Ne rafraîchissez pas la page et ne cliquez pas sur le bouton d'arrêt ou « Précédent »." } },
        "bill96-disclaimer": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez noter que tous les documents et courriels transactionnels seront envoyés en français." } },
        "bill96-checkbox": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Je souhaite recevoir une copie de tous les documents et courriels en anglais." } },
        promocodeDiscount: { t: 0, b: { t: 2, i: [{ t: 3, v: "Rabais de " }, { t: 4, k: "discount" }] } },
        amountDueBy: { t: 0, b: { t: 2, i: [{ t: 3, v: "Solde restant de <strong>" }, { t: 4, k: "amount" }, { t: 3, v: "</strong> à payer d'ici le <strong>" }, { t: 4, k: "date" }, { t: 3, v: "</strong>" }] } },
        giftCardCheckAmountLink: { t: 0, b: { t: 2, i: [{ t: 3 }], s: '<a href="https://www.aircanada.com/ca/fr/aco/home/book/payment-methods/air-canada-gift-cards.html#/" target="_blank" class="link">Vérifiez le solde de votre carte-cadeau, de votre bon électronique ou de votre bon de voyage.</a>' } },
        upliftWarningMessage: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Si vous modifiez votre réservation, il se peut que vous deviez recommencer votre application Flex Pay." } },
        billedSeparately: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Votre voyage et votre assurance voyage seront facturés séparément :" } },
        payableToVACV: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "à payer à Vacances Air Canada" } },
        payableToInsuranceCompany: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "plus les taxes applicables à payer à Allianz Global Assistance" } },
        insuranceDOBChangeAdvisoryTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "À noter" } },
        insuranceDOBChangeAdvisoryDescription: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Le prix de votre assurance voyage peut avoir changé en fonction des nouvelles informations que vous avez fournies." } },
        travelInsuranceNoOptions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Désolé, il n'y a pas d'options d'assurance voyage disponibles pour votre voyage." } }
      }
    },
    provinces: {
      AB: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "AB - Alberta" } },
      BC: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "BC - Colombie-Brittanique" } },
      MB: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "MB - Manitoba" } },
      NB: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NB - Nouveau-Brunswick" } },
      NL: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NL - Terre-Neuve et Labrador" } },
      NT: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NT - Northwest Territories" } },
      NS: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NS - Nouvelle-Écosse" } },
      NU: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NU - Nunavut" } },
      ON: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "ON - Ontario" } },
      PE: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "PE - Île-du-Prince-Édouard" } },
      QC: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "QC - Québec" } },
      SK: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "SK - Saskatchewan" } },
      YT: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "YT - Yukon" } }
    },
    states: {
      AL: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "AL - Alabama" } },
      AK: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "AK - Alaska" } },
      AZ: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "AZ - Arizona" } },
      AR: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "AR - Arkansas" } },
      CA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "CA - Californie" } },
      CO: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "CO - Colorado" } },
      CT: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "CT - Connecticut" } },
      DE: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "DE - Delaware" } },
      DC: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "DC - District de Columbia" } },
      FL: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "FL - Floride" } },
      GA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "GA - Géorgie" } },
      HI: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "HI - Hawaii" } },
      ID: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "ID - Idaho" } },
      IL: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "IL - Illinois" } },
      IN: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "IN - Indiana" } },
      IA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "IA - Iowa" } },
      KS: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "KS - Kansas" } },
      KY: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "KY - Kentucky" } },
      LA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "LA - Louisiane" } },
      ME: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "ME - Maine" } },
      MD: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "MD - Maryland" } },
      MA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "MA - Massachusetts" } },
      MI: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "MI - Michigan" } },
      MN: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "MN - Minnesota" } },
      MS: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "MS - Mississippi" } },
      MO: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "MO - Missouri" } },
      MT: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "MT - Montana" } },
      NE: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NE - Nebraska" } },
      NV: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NV - Nevada" } },
      NH: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NH - New Hampshire" } },
      NJ: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NJ - New Jersey" } },
      NM: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NM - Nouveau-Mexique" } },
      NY: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NY - New York" } },
      NC: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NC - Caroline du Nord" } },
      ND: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "ND - Dakota du Nors" } },
      OH: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "OH - Ohio" } },
      OK: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "OK - Oklahoma" } },
      OR: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "OR - Oregon" } },
      PA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "PA - Pennyslvanie" } },
      RI: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "RI - Rhode Island" } },
      SC: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "SC - Caroline du Sud" } },
      SD: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "SD - Dakota du Sud" } },
      TN: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "TN - Tennessee" } },
      TX: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "TX - Texas" } },
      UT: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "UT - Utah" } },
      VT: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "VT - Vermont" } },
      VA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "VA - Virginie" } },
      WA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "WA - Washington" } },
      WV: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "WV - Virginie-Occidentale" } },
      WI: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "WI - Wisconsin" } },
      WY: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "WY - Wyoming" } }
    },
    countries: {
      CA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Canada" } },
      US: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "États-Unis" } }
    },
    bookingsummary: {
      labels: {
        "booking-summary": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Résumé de la réservation" } },
        package: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Forfait" } },
        flight: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Vol" } },
        transfers: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Transferts" } },
        hotel: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hôtel" } },
        "hotel-and-rooms": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Hôtel et chambre(s)" } },
        "round-trip-flight": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Vol aller-retour" } },
        ancillary: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ajouts" } },
        traveller: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "voyageur" } },
        travellers: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "voyageurs" } },
        included: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Inclus" } },
        travelprotection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Protection de voyage - " } },
        privateTransfer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Transfert(s) privé(s) - " } },
        "extras-included": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Comprend les ajouts sélectionnés" } }
      },
      messages: {
        "see-details": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voir plus" } },
        "hide-details": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voir moins" } },
        total: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Total" } },
        deposit: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Dépôt" } },
        "continue-booking": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Continuer" } }
      },
      errors: {
        "no-hotel-room": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nous ne pouvons charger les détails de votre hôtel et de votre chambre pour le moment. Vous pourrez les voir à l'étape suivante." } },
        "no-flights": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nous ne pouvons afficher les détails de votre vol pour le moment. Vous pourrez les consulter après avoir sélectionné votre chambre." } },
        ancillary: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nous ne pouvons charger les ajouts pour le moment. Vous pourrez les voir à l'étape suivante." } }
      },
      aeroplan: {
        "use-your-points-to-save": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Utilisez vos points pour économiser" } }
      }
    },
    pdp: {
      labels: {
        title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Product Details Page (PDP)" } },
        accessibleAnchor: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aller à la section " } },
        inclusionsButton: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Inclusions" } },
        roomDetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Détails de la chambre" } },
        roomDescription: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Détails de la chambre" } },
        roomService: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Service aux chambres" } },
        roomFacilities: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Installations" } },
        roomDimensions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Dimensions de la chambre" } },
        occupancy: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Occupation" } },
        maximumOccupancy: { t: 0, b: { t: 2, i: [{ t: 3, v: "Occupation maximale " }, { t: 4, k: "count" }] } },
        hotel: {
          overview: {
            title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aperçu" } },
            checkin: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Enregistrement:" } },
            checkout: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Départ:" } },
            numberRooms: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nombre de chambres:" } },
            numberBars: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nombre de bars:" } },
            numberRestaurants: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nombre de restaurants:" } },
            numberPoolsOutdoor: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nombre de piscines (extérieures):" } },
            inclusions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Inclusions" } },
            otherServices: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Autres services payants ($)" } }
          },
          important: {
            title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Informations importantes" } }
          },
          location: {
            title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Emplacement" } }
          },
          inclusions: {
            title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Inclusions" } }
          },
          facilities: {
            title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Installations" } },
            showMore: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voir plus" } },
            showLess: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voir moins" } },
            disclaimer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "*Des frais supplémentaires peuvent s'appliquer et le service peut nécessiter une réservation." } },
            foodAndDrinks: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Restaurants et bars" } },
            activities: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Activités" } },
            otherFacilitiesAndServices: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Autres installations et de services" } },
            pools: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Installations de piscine" } },
            landSports: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Activités terrestres" } },
            waterSports: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sports nautiques non motorisés et motorisés" } },
            entertainment: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Divertissement" } },
            golf: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Golf" } },
            bars: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Bars" } },
            restaurants: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Restaurants" } },
            restaurantType: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Type de restaurant" } },
            restaurantCuisine: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Type de cuisine" } },
            restaurantNote: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Note" } },
            additionalInformation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Renseignements supplémentaires" } },
            health: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Spa et bien-être" } },
            disclaimerPetFriendly: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "**Des restrictions et des frais supplémentaires peuvent s'appliquer pour les animaux de compagnie." } }
          }
        }
      },
      messages: {
        noRoomsAvailable: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Il semble qu'il n'y ait pas de chambres disponibles actuellement." } },
        "try-again": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Choisissez un autre hôtel ou complexe hôtelier et réessayez." } },
        "multiple-airport-your-choice": { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Cet hôtel est accessible par plusieurs aéroports. Recherchez <i class="fa-solid fa-plane" aria-hidden="true"></i><span class="sr-only">l'alerte aéroport</span> ci-dessous pour consulter vos options. Les prix peuvent varier en fonction de votre choix.` } },
        "multiple-airport-destination": { t: 0, b: { t: 2, i: [{ t: 3, v: "Vol aller-retour via " }, { t: 4, k: "name" }, { t: 3, v: " (" }, { t: 4, k: "iata" }, { t: 3, v: ")" }] } }
      },
      access: {
        "plane-icon": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Alerte aéroport! " } }
      },
      rooms: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Chambres" } },
      map: {
        "zoom-in": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Zoom avant" } },
        "zoom-out": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Zoom arrière" } },
        "enter-full-screen": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Plein écran" } },
        "exit-full-screen": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Quitter le plein écran" } }
      }
    },
    flight: {
      labels: {
        flightDetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Détails du vol" } },
        title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Vols" } },
        departure: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Départ" } },
        return: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Retour" } },
        stops: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3 }], s: "Vol direct" }, { t: 2, i: [{ t: 3 }], s: "1 escale" }, { t: 2, i: [{ t: 4, k: "count" }, { t: 3, v: " escales" }] }] } },
        duration: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Durée" } },
        showDetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voir plus" } },
        hideDetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voir moins" } },
        layoverDuration: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Durée de l'escale:" } },
        operatedBy: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Opéré par" } },
        cabinClassEconomy: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Économique" } },
        cabinClassPremium: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Économique Privilège" } },
        cabinClassBusiness: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Classe Affaires" } },
        cabinClassMixedPremium: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Cabine mixte avec Économique Privilège" } },
        cabinClassMixedBusiness: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Cabine mixte avec Classe Affaires" } }
      },
      messages: {
        flightDetailsSubtitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "D'autres options de vol sont disponibles après la sélection de chambre." } },
        flightDetailsError: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nous ne pouvons afficher les détails de votre vol pour le moment. Vous pourrez les consulter après avoir sélectionné votre chambre." } },
        noFlightsAvailable: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Il semble que le forfait que vous avez sélectionné ne soit plus disponible." } },
        "try-again": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez réessayer en effectuant une autre sélection." } },
        flightNotAvailableCard: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Désolé, cette option de vol n'est plus disponible." } },
        waitingMessageTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nous mettons à jour votre forfait." } },
        waitingMessageDescription: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Le traitement de votre demande peut prendre jusqu'à 60 secondes.<br>Ne rafraîchissez pas la page et ne cliquez pas sur le bouton d'arrêt ou « Précédent »." } },
        waitingScreenMessageTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Préparation de votre chambre" } },
        waitingScreenMessageDescription: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Accordez-nous une minute pendant que nous préparons tout pour votre séjour.<br>Ne rafraîchissez pas la page et ne cliquez pas sur le bouton d'arrêt ou « Précédent »." } },
        cabinClassMixedPremiumTooltip: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Cette option comporte plusieurs classes de cabine, avec au moins un vol en Économique Privilège." } },
        cabinClassMixedBusinessTooltip: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Cette option comporte plusieurs classes de cabine, avec au moins un vol en Classe affaires." } },
        selectedFlightNotInFilterResults: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Le vol sélectionné ne figure pas dans les résultats filtrés, mais vous pouvez en consulter les détails dans le Résumé de la réservation." } }
      },
      access: {
        cabinClassTooltipButton: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Savoir plus" } }
      },
      filter: {
        label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Filtrer par nombre d'escales :" } },
        "dropdown-default": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Toutes les escales" } },
        "dropdown-direct": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Vols directs seulement" } },
        "dropdown-1stop-or-less": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "1 escale ou moins" } },
        "flights-found": { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 4, k: "count" }, { t: 3, v: " vol trouvé" }] }, { t: 2, i: [{ t: 4, k: "count" }, { t: 3, v: " vols trouvés" }] }] } }
      }
    },
    ancillary: {
      labels: {
        title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ajouts" } },
        travelProtection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Protection de voyage" } },
        terms: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Conditions générales" } },
        showDetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voir plus" } },
        hideDetails: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voir moins" } },
        recommended: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Recommandé" } },
        traveller: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "/ voyageur" } },
        adult: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "/ adulte" } },
        perTraveller: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "par voyageur" } },
        perAdult: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "par adulte" } },
        from: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "À partir de" } },
        price: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Prix" } },
        careflex: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "TouteFlexibilité" } },
        carefree: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "TouteTranquillité" } },
        travelprotection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Protection de voyage" } },
        travelprotectionNote: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ajoutez de la flexibilité et de la tranquillité d'esprit à vos vacances avec l'une de nos solutions de protection de voyage." } },
        privateTransfer: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Transfert privé" } },
        privateTransferNote: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Réservez des transferts privés aller-retour entre l'aéroport et votre hôtel ou complexe." } },
        mealPlan: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Formule de repas" } },
        mealPlanNote: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Surclassez la formule de repas de votre forfait et offrez-vous une expérience culinaire améliorée." } },
        activities: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Attractions et excursions" } },
        activitiesNote: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Transformez un voyage ordinaire en voyage extraordinaire. Ajoutez des incontournables à visiter dans votre destination." } },
        showOptions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Afficher options" } },
        hideOptions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Masquer options" } },
        showingMealPlanResults: { t: 0, b: { t: 2, i: [{ t: 3, v: "Affichage de 1 à " }, { t: 4, k: "end" }, { t: 3, v: " sur " }, { t: 4, k: "total" }, { t: 3, v: " formule(s) de repas" }] } },
        showingOptionsResults: { t: 0, b: { t: 2, i: [{ t: 3, v: "Affichage de 1 à " }, { t: 4, k: "end" }, { t: 3, v: " sur " }, { t: 4, k: "total" }, { t: 3, v: " options" }] } },
        nothingToDisplay: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Il ne semble pas y avoir d'ajouts disponibles pour votre voyage." } },
        bookingSummary: {
          CAREFLEX: {
            name: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "TouteTranquillité" } },
            inclusions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Comprend l'annulation avec remboursement ou crédit de voyage, les modifications de réservation et le transfert de forfait. Certaines conditions s'appliquent." } }
          },
          CAREFREE: {
            name: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "TouteFlexibilité" } },
            inclusions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Comprend la sélection standard des sièges et notre garantie ProtègePrix. Certaines conditions s'appliquent." } }
          }
        }
      },
      nudge: {
        title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Vous recherchez la tranquillité d'esprit?" } },
        prompting: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ajoutez une protection de voyage et profitez d'un voyage sans tracas." } },
        withProtection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ajouter à ma réservation" } },
        withoutProtection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Non, merci" } },
        taxesincl: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Taxes et frais inclus" } },
        total: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Total" } }
      },
      access: {
        details: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Savoir plus" } },
        "know-more-about": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Savoir plus sur" } },
        included: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Inclus avec " } },
        "table-cell-empty": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Vide" } }
      },
      messages: {
        waitingScreenMessageTitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ajout de votre vol" } },
        waitingScreenMessageDescription: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Accordez-nous une minute pendant que nous traitons votre demande.<br>Ne rafraîchissez pas la page et ne cliquez pas sur le bouton d'arrêt ou « Précédent »." } }
      }
    },
    prices: {
      labels: {
        promoCode: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Code promo" } }
      },
      deposit: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Dépôt" } },
      "deposit-payment-remaining-balance-message": { t: 0, b: { t: 2, i: [{ t: 3, v: "Solde restant <br/>à payer d'ici le <b>" }, { t: 4, k: "date" }, { t: 3, v: "</b>" }] } },
      "deposit-payment-remaining-balance-mobile-message": { t: 0, b: { t: 2, i: [{ t: 3, v: "<b>" }, { t: 4, k: "remaining" }, { t: 3, v: "</b> à payer d'ici le <b>" }, { t: 4, k: "date" }, { t: 3, v: "</b>" }] } },
      hotelInclusions: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Inclusions" } },
      "plane-icon": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Alerte aéroport! " } },
      "multiple-airport-destination": { t: 0, b: { t: 2, i: [{ t: 3, v: "Vol aller-retour via " }, { t: 4, k: "name" }, { t: 3, v: " (" }, { t: 4, k: "iata" }, { t: 3, v: ")" }] } }
    },
    giftCard: {
      labels: {
        giftCard: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Payer par Carte-cadeau, eCoupon ou bon d'échange Air Canada" } },
        giftCardNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Numéro de carte (15 chiffres)*" } },
        giftCardPIN: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "NIP (4 chiffres)*" } }
      },
      errors: {
        giftCardAmountZero: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez entrer un montant." } },
        giftCardInsufficientAmount: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Le solde de votre carte cadeau est insuffisant. Veuillez sélectionner un autre mode de paiement." } },
        giftCardPIN: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez entrer un NIP." } },
        giftCardNumber: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez entrer un numéro de carte-cadeau." } },
        giftCardOnlyNumbers: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Seuls les chiffres sont acceptés" } },
        giftCardLessThanDepositWithoutInsurance: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Le montant doit être égal ou inférieur au montant du dépôt dû, sans la prime d'assurance." } },
        giftCardSplitDeposit: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Le montant doit être égal ou inférieur au montant du dépôt" } },
        giftCardSplitTotal: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Le montant doit être égal ou inférieur au montant total dû." } },
        giftCardSplitTotalWithoutInsurance: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Le montant doit être égal ou inférieur au montant total dû, sans la prime d'assurance." } }
      },
      messages: {
        giftCardCheckAmountLink: { t: 0, b: { t: 2, i: [{ t: 3 }], s: '<a href="https://www.aircanada.com/ca/fr/aco/home/book/payment-methods/air-canada-gift-cards.html#/" target="_blank" class="link">Vérifiez le solde de votre carte-cadeau, de votre bon électronique ou de votre bon de voyage.</a>' } }
      }
    },
    showmoreresults: {
      labels: {
        moreresultsCTA: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Afficher plus" } },
        showingresultsmessage: { t: 0, b: { t: 2, i: [{ t: 3, v: "Affichage de 1 à " }, { t: 4, k: "end" }, { t: 3, v: " sur " }, { t: 4, k: "total" }, { t: 3, v: " résultat(s)" }] } },
        showingRoomsResultsMessage: { t: 0, b: { t: 2, i: [{ t: 3, v: "Affichage de 1 à " }, { t: 4, k: "end" }, { t: 3, v: " sur " }, { t: 4, k: "total" }, { t: 3, v: " chambre(s)" }] } }
      }
    },
    alternatedates: {
      messages: {
        "not-available": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "La date de départ demandée n'est pas disponible" } },
        "select-available-dates": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sélectionnez une date parmi les options ci-dessous." } },
        "found-one-date": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Voici la prochaine date disponible :" } }
      },
      labels: {
        "prefix-available-date": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Le " } }
      },
      errors: {
        "mandatory-date": { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez sélectionner une date." } }
      }
    }
  }
};
var RN = Object.defineProperty, zN = (e, t, n) => t in e ? RN(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Av = (e, t, n) => zN(e, typeof t != "symbol" ? t + "" : t, n);
function BN(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function i() {
      return this instanceof i ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(i) {
    var r = Object.getOwnPropertyDescriptor(e, i);
    Object.defineProperty(n, i, r.get ? r : {
      enumerable: !0,
      get: function() {
        return e[i];
      }
    });
  }), n;
}
var VN = Error, UN = EvalError, HN = RangeError, WN = ReferenceError, TI = SyntaxError, Yy = TypeError, ZN = URIError, qN = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var e = {}, t = Symbol("test"), n = Object(t);
  if (typeof t == "string" || Object.prototype.toString.call(t) !== "[object Symbol]" || Object.prototype.toString.call(n) !== "[object Symbol]")
    return !1;
  var i = 42;
  e[t] = i;
  for (t in e)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(e).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(e).length !== 0)
    return !1;
  var r = Object.getOwnPropertySymbols(e);
  if (r.length !== 1 || r[0] !== t || !Object.prototype.propertyIsEnumerable.call(e, t))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var c = Object.getOwnPropertyDescriptor(e, t);
    if (c.value !== i || c.enumerable !== !0)
      return !1;
  }
  return !0;
}, Z2 = typeof Symbol < "u" && Symbol, jN = qN, GN = function() {
  return typeof Z2 != "function" || typeof Symbol != "function" || typeof Z2("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : jN();
}, bb = {
  __proto__: null,
  foo: {}
}, YN = Object, KN = function() {
  return { __proto__: bb }.foo === bb.foo && !(bb instanceof YN);
}, XN = "Function.prototype.bind called on incompatible ", JN = Object.prototype.toString, QN = Math.max, eF = "[object Function]", q2 = function(e, t) {
  for (var n = [], i = 0; i < e.length; i += 1)
    n[i] = e[i];
  for (var r = 0; r < t.length; r += 1)
    n[r + e.length] = t[r];
  return n;
}, tF = function(e, t) {
  for (var n = [], i = t, r = 0; i < e.length; i += 1, r += 1)
    n[r] = e[i];
  return n;
}, nF = function(e, t) {
  for (var n = "", i = 0; i < e.length; i += 1)
    n += e[i], i + 1 < e.length && (n += t);
  return n;
}, iF = function(e) {
  var t = this;
  if (typeof t != "function" || JN.apply(t) !== eF)
    throw new TypeError(XN + t);
  for (var n = tF(arguments, 1), i, r = function() {
    if (this instanceof i) {
      var g = t.apply(
        this,
        q2(n, arguments)
      );
      return Object(g) === g ? g : this;
    }
    return t.apply(
      e,
      q2(n, arguments)
    );
  }, c = QN(0, t.length - n.length), d = [], a = 0; a < c; a++)
    d[a] = "$" + a;
  if (i = Function("binder", "return function (" + nF(d, ",") + "){ return binder.apply(this,arguments); }")(r), t.prototype) {
    var f = function() {
    };
    f.prototype = t.prototype, i.prototype = new f(), f.prototype = null;
  }
  return i;
}, rF = iF, y1 = Function.prototype.bind || rF, sF = Function.prototype.call, oF = Object.prototype.hasOwnProperty, aF = y1, lF = aF.call(sF, oF), di, cF = VN, uF = UN, dF = HN, pF = WN, mh = TI, nh = Yy, hF = ZN, II = Function, wb = function(e) {
  try {
    return II('"use strict"; return (' + e + ").constructor;")();
  } catch {
  }
}, Td = Object.getOwnPropertyDescriptor;
if (Td)
  try {
    Td({}, "");
  } catch {
    Td = null;
  }
var xb = function() {
  throw new nh();
}, fF = Td ? function() {
  try {
    return arguments.callee, xb;
  } catch {
    try {
      return Td(arguments, "callee").get;
    } catch {
      return xb;
    }
  }
}() : xb, bp = GN(), mF = KN(), us = Object.getPrototypeOf || (mF ? function(e) {
  return e.__proto__;
} : null), Rp = {}, vF = typeof Uint8Array > "u" || !us ? di : us(Uint8Array), Id = {
  __proto__: null,
  "%AggregateError%": typeof AggregateError > "u" ? di : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? di : ArrayBuffer,
  "%ArrayIteratorPrototype%": bp && us ? us([][Symbol.iterator]()) : di,
  "%AsyncFromSyncIteratorPrototype%": di,
  "%AsyncFunction%": Rp,
  "%AsyncGenerator%": Rp,
  "%AsyncGeneratorFunction%": Rp,
  "%AsyncIteratorPrototype%": Rp,
  "%Atomics%": typeof Atomics > "u" ? di : Atomics,
  "%BigInt%": typeof BigInt > "u" ? di : BigInt,
  "%BigInt64Array%": typeof BigInt64Array > "u" ? di : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array > "u" ? di : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? di : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": cF,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": uF,
  "%Float32Array%": typeof Float32Array > "u" ? di : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? di : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? di : FinalizationRegistry,
  "%Function%": II,
  "%GeneratorFunction%": Rp,
  "%Int8Array%": typeof Int8Array > "u" ? di : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? di : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? di : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": bp && us ? us(us([][Symbol.iterator]())) : di,
  "%JSON%": typeof JSON == "object" ? JSON : di,
  "%Map%": typeof Map > "u" ? di : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !bp || !us ? di : us((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? di : Promise,
  "%Proxy%": typeof Proxy > "u" ? di : Proxy,
  "%RangeError%": dF,
  "%ReferenceError%": pF,
  "%Reflect%": typeof Reflect > "u" ? di : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? di : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !bp || !us ? di : us((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? di : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": bp && us ? us(""[Symbol.iterator]()) : di,
  "%Symbol%": bp ? Symbol : di,
  "%SyntaxError%": mh,
  "%ThrowTypeError%": fF,
  "%TypedArray%": vF,
  "%TypeError%": nh,
  "%Uint8Array%": typeof Uint8Array > "u" ? di : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? di : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? di : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? di : Uint32Array,
  "%URIError%": hF,
  "%WeakMap%": typeof WeakMap > "u" ? di : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? di : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? di : WeakSet
};
if (us)
  try {
    null.error;
  } catch (e) {
    var gF = us(us(e));
    Id["%Error.prototype%"] = gF;
  }
var yF = function e(t) {
  var n;
  if (t === "%AsyncFunction%")
    n = wb("async function () {}");
  else if (t === "%GeneratorFunction%")
    n = wb("function* () {}");
  else if (t === "%AsyncGeneratorFunction%")
    n = wb("async function* () {}");
  else if (t === "%AsyncGenerator%") {
    var i = e("%AsyncGeneratorFunction%");
    i && (n = i.prototype);
  } else if (t === "%AsyncIteratorPrototype%") {
    var r = e("%AsyncGenerator%");
    r && us && (n = us(r.prototype));
  }
  return Id[t] = n, n;
}, j2 = {
  __proto__: null,
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, Fm = y1, Vg = lF, _F = Fm.call(Function.call, Array.prototype.concat), bF = Fm.call(Function.apply, Array.prototype.splice), G2 = Fm.call(Function.call, String.prototype.replace), Ug = Fm.call(Function.call, String.prototype.slice), wF = Fm.call(Function.call, RegExp.prototype.exec), xF = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, $F = /\\(\\)?/g, CF = function(e) {
  var t = Ug(e, 0, 1), n = Ug(e, -1);
  if (t === "%" && n !== "%")
    throw new mh("invalid intrinsic syntax, expected closing `%`");
  if (n === "%" && t !== "%")
    throw new mh("invalid intrinsic syntax, expected opening `%`");
  var i = [];
  return G2(e, xF, function(r, c, d, a) {
    i[i.length] = d ? G2(a, $F, "$1") : c || r;
  }), i;
}, kF = function(e, t) {
  var n = e, i;
  if (Vg(j2, n) && (i = j2[n], n = "%" + i[0] + "%"), Vg(Id, n)) {
    var r = Id[n];
    if (r === Rp && (r = yF(n)), typeof r > "u" && !t)
      throw new nh("intrinsic " + e + " exists, but is not available. Please file an issue!");
    return {
      alias: i,
      name: n,
      value: r
    };
  }
  throw new mh("intrinsic " + e + " does not exist!");
}, Rh = function(e, t) {
  if (typeof e != "string" || e.length === 0)
    throw new nh("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof t != "boolean")
    throw new nh('"allowMissing" argument must be a boolean');
  if (wF(/^%?[^%]*%?$/, e) === null)
    throw new mh("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var n = CF(e), i = n.length > 0 ? n[0] : "", r = kF("%" + i + "%", t), c = r.name, d = r.value, a = !1, f = r.alias;
  f && (i = f[0], bF(n, _F([0, 1], f)));
  for (var g = 1, x = !0; g < n.length; g += 1) {
    var $ = n[g], A = Ug($, 0, 1), I = Ug($, -1);
    if ((A === '"' || A === "'" || A === "`" || I === '"' || I === "'" || I === "`") && A !== I)
      throw new mh("property names with quotes must have matching quotes");
    if (($ === "constructor" || !x) && (a = !0), i += "." + $, c = "%" + i + "%", Vg(Id, c))
      d = Id[c];
    else if (d != null) {
      if (!($ in d)) {
        if (!t)
          throw new nh("base intrinsic for " + e + " exists, but the property is not available.");
        return;
      }
      if (Td && g + 1 >= n.length) {
        var O = Td(d, $);
        x = !!O, x && "get" in O && !("originalValue" in O.get) ? d = O.get : d = d[$];
      } else
        x = Vg(d, $), d = d[$];
      x && !a && (Id[c] = d);
    }
  }
  return d;
}, AI = { exports: {} }, $b, Y2;
function _1() {
  if (Y2) return $b;
  Y2 = 1;
  var e = Rh, t = e("%Object.defineProperty%", !0) || !1;
  if (t)
    try {
      t({}, "a", { value: 1 });
    } catch {
      t = !1;
    }
  return $b = t, $b;
}
var SF = Rh, lg = SF("%Object.getOwnPropertyDescriptor%", !0);
if (lg)
  try {
    lg([], "length");
  } catch {
    lg = null;
  }
var EI = lg, K2 = _1(), TF = TI, wp = Yy, X2 = EI, IF = function(e, t, n) {
  if (!e || typeof e != "object" && typeof e != "function")
    throw new wp("`obj` must be an object or a function`");
  if (typeof t != "string" && typeof t != "symbol")
    throw new wp("`property` must be a string or a symbol`");
  if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
    throw new wp("`nonEnumerable`, if provided, must be a boolean or null");
  if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
    throw new wp("`nonWritable`, if provided, must be a boolean or null");
  if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
    throw new wp("`nonConfigurable`, if provided, must be a boolean or null");
  if (arguments.length > 6 && typeof arguments[6] != "boolean")
    throw new wp("`loose`, if provided, must be a boolean");
  var i = arguments.length > 3 ? arguments[3] : null, r = arguments.length > 4 ? arguments[4] : null, c = arguments.length > 5 ? arguments[5] : null, d = arguments.length > 6 ? arguments[6] : !1, a = !!X2 && X2(e, t);
  if (K2)
    K2(e, t, {
      configurable: c === null && a ? a.configurable : !c,
      enumerable: i === null && a ? a.enumerable : !i,
      value: n,
      writable: r === null && a ? a.writable : !r
    });
  else if (d || !i && !r && !c)
    e[t] = n;
  else
    throw new TF("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
}, Q0 = _1(), PI = function() {
  return !!Q0;
};
PI.hasArrayLengthDefineBug = function() {
  if (!Q0)
    return null;
  try {
    return Q0([], "length", { value: 1 }).length !== 1;
  } catch {
    return !0;
  }
};
var AF = PI, EF = Rh, J2 = IF, PF = AF(), Q2 = EI, eC = Yy, MF = EF("%Math.floor%"), DF = function(e, t) {
  if (typeof e != "function")
    throw new eC("`fn` is not a function");
  if (typeof t != "number" || t < 0 || t > 4294967295 || MF(t) !== t)
    throw new eC("`length` must be a positive 32-bit integer");
  var n = arguments.length > 2 && !!arguments[2], i = !0, r = !0;
  if ("length" in e && Q2) {
    var c = Q2(e, "length");
    c && !c.configurable && (i = !1), c && !c.writable && (r = !1);
  }
  return (i || r || !n) && (PF ? J2(
    /** @type {Parameters<define>[0]} */
    e,
    "length",
    t,
    !0,
    !0
  ) : J2(
    /** @type {Parameters<define>[0]} */
    e,
    "length",
    t
  )), e;
};
(function(e) {
  var t = y1, n = Rh, i = DF, r = Yy, c = n("%Function.prototype.apply%"), d = n("%Function.prototype.call%"), a = n("%Reflect.apply%", !0) || t.call(d, c), f = _1(), g = n("%Math.max%");
  e.exports = function($) {
    if (typeof $ != "function")
      throw new r("a function is required");
    var A = a(t, d, arguments);
    return i(
      A,
      1 + g(0, $.length - (arguments.length - 1)),
      !0
    );
  };
  var x = function() {
    return a(t, c, arguments);
  };
  f ? f(e.exports, "apply", { value: x }) : e.exports.apply = x;
})(AI);
var LF = AI.exports, MI = Rh, DI = LF, OF = DI(MI("String.prototype.indexOf")), NF = function(e, t) {
  var n = MI(e, !!t);
  return typeof n == "function" && OF(e, ".prototype.") > -1 ? DI(n) : n;
};
const FF = {}, RF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: FF
}, Symbol.toStringTag, { value: "Module" })), zF = /* @__PURE__ */ BN(RF);
var LI = typeof Map == "function" && Map.prototype, Cb = Object.getOwnPropertyDescriptor && LI ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
LI && Cb && typeof Cb.get == "function" && Cb.get;
var OI = typeof Set == "function" && Set.prototype, kb = Object.getOwnPropertyDescriptor && OI ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
OI && kb && typeof kb.get == "function" && kb.get;
var tC = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, BF = typeof Symbol == "function" && typeof Symbol.iterator == "object", VF = zF, nC = VF.custom;
UF(nC);
function UF(e) {
  if (BF)
    return e && typeof e == "object" && e instanceof Symbol;
  if (typeof e == "symbol")
    return !0;
  if (!e || typeof e != "object" || !tC)
    return !1;
  try {
    return tC.call(e), !0;
  } catch {
  }
  return !1;
}
var NI = Rh, zh = NF;
NI("%WeakMap%", !0);
NI("%Map%", !0);
zh("WeakMap.prototype.get", !0);
zh("WeakMap.prototype.set", !0);
zh("WeakMap.prototype.has", !0);
zh("Map.prototype.get", !0);
zh("Map.prototype.set", !0);
zh("Map.prototype.has", !0);
(function() {
  for (var e = [], t = 0; t < 256; ++t)
    e.push("%" + ((t < 16 ? "0" : "") + t.toString(16)).toUpperCase());
  return e;
})();
function FI(e = 0, t = 0) {
  window.scrollTo({
    top: e,
    left: t,
    behavior: "instant"
  });
}
function HF() {
  return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
}
function Hg(e, t) {
  var n;
  let i = e.target;
  for (; i; ) {
    if ((n = i == null ? void 0 : i.classList) != null && n.contains && t.some((r) => i.classList.contains(r)))
      return !1;
    if (i.parentElement)
      i = i.parentElement;
    else
      break;
  }
  return !0;
}
function WF(e) {
  const t = e.getAttribute("id"), n = document.querySelector('[for="' + t + '"]');
  if (n)
    return n.innerHTML.trim();
}
function ZF(e) {
  return WF(e) || e.getAttribute("name");
}
function qF(e, t) {
  var n, i, r, c, d, a, f, g;
  const x = t != null && t.small ? (n = e.url) == null ? void 0 : n.replace("{SIZE}", t.small) : (i = e.url) == null ? void 0 : i.replace("/{SIZE}/", "/"), $ = t != null && t.medium ? (r = e.url) == null ? void 0 : r.replace("{SIZE}", t.medium) : (c = e.url) == null ? void 0 : c.replace("/{SIZE}/", "/"), A = t != null && t.large ? (d = e.url) == null ? void 0 : d.replace("{SIZE}", t.large) : (a = e.url) == null ? void 0 : a.replace("/{SIZE}/", "/"), I = t != null && t.xlarge ? (f = e.url) == null ? void 0 : f.replace("{SIZE}", t.xlarge) : (g = e.url) == null ? void 0 : g.replace("/{SIZE}/", "/");
  return {
    small: x,
    medium: $,
    large: A,
    xlarge: I
  };
}
function Wg(e, t, n) {
  return e ? e.includes("{VARIATION}") ? t && n != null && n[t] ? e.replace("{VARIATION}", t) : e.replace("/{VARIATION}", "") : e : "";
}
function jF(e, t, n) {
  if (n != null && n[t]) {
    const i = /\/focalarea\/(?:cinema|tabletLandscape)\//;
    return e.replace(i, `/focalarea/${t}/`);
  }
  return e;
}
const RI = (e, t) => {
  const n = (i) => {
    Hg(i, e) && t();
  };
  return window.addEventListener("mousedown", n), window.addEventListener("touchstart", n), n;
}, zI = (e) => {
  e && (window.removeEventListener("mousedown", e), window.removeEventListener("touchstart", e));
};
function BI(e, t, n) {
  var i;
  let r, c = [];
  return e.length && (c = GF(e)), c.length === 1 && (i = c[0]) != null && i.date && c[0].date.replace(/-/g, "") === t ? [] : c.some(
    (d) => {
      var a;
      return ((a = d.date) == null ? void 0 : a.replace(/-/g, "")) === t;
    }
  ) ? (c.length <= n ? r = c : r = YF(
    c,
    t,
    n
  ), r.map((d) => {
    var a;
    return {
      ...d,
      selected: t === ((a = d == null ? void 0 : d.date) == null ? void 0 : a.replace(/-/g, ""))
    };
  })) : [];
}
function GF(e) {
  return e.filter((t) => t.date && /^\d{4}-\d{2}-\d{2}$/.test(t.date) && t.price).sort(function(t, n) {
    if (t.date && n.date) {
      const i = parseInt(t.date.replace(/-/g, "")), r = parseInt(n.date.replace(/-/g, ""));
      return i > r ? 1 : -1;
    }
    return 0;
  });
}
function YF(e, t, n) {
  const i = e.findIndex(
    (r) => {
      var c;
      return ((c = r.date) == null ? void 0 : c.replace(/-/g, "")) === t;
    }
  );
  if (i === -1)
    return e.slice(0, n);
  {
    const r = Math.max(0, i - 1), c = Math.min(e.length - 1, r + n - 1);
    return e.slice(r, c + 1);
  }
}
function KF(e) {
  return "quote" in e ? e.quote : void 0;
}
function b1(e) {
  const t = KF(e);
  if (t)
    return "prePackage" in t ? t.prePackage : "hotel" in t ? t.hotel : void 0;
}
function XF(e) {
  var t;
  const n = b1(e);
  if (n && "selectedOptionIds" in n) {
    const i = "itineraryId" in n.selectedOptionIds ? n.selectedOptionIds.itineraryId : void 0;
    return { itinerary: i ? (t = e == null ? void 0 : e.itineraries) == null ? void 0 : t[i] : void 0, itineraryId: i };
  }
}
let Vd = class extends Error {
};
class JF extends Vd {
  constructor(t) {
    super(`Invalid DateTime: ${t.toMessage()}`);
  }
}
class QF extends Vd {
  constructor(t) {
    super(`Invalid Interval: ${t.toMessage()}`);
  }
}
class eR extends Vd {
  constructor(t) {
    super(`Invalid Duration: ${t.toMessage()}`);
  }
}
let Yp = class extends Vd {
}, VI = class extends Vd {
  constructor(t) {
    super(`Invalid unit ${t}`);
  }
}, Rs = class extends Vd {
}, pu = class extends Vd {
  constructor() {
    super("Zone is an abstract class");
  }
};
const en = "numeric", Ka = "short", zo = "long", Zg = {
  year: en,
  month: en,
  day: en
}, UI = {
  year: en,
  month: Ka,
  day: en
}, tR = {
  year: en,
  month: Ka,
  day: en,
  weekday: Ka
}, HI = {
  year: en,
  month: zo,
  day: en
}, WI = {
  year: en,
  month: zo,
  day: en,
  weekday: zo
}, ZI = {
  hour: en,
  minute: en
}, qI = {
  hour: en,
  minute: en,
  second: en
}, jI = {
  hour: en,
  minute: en,
  second: en,
  timeZoneName: Ka
}, GI = {
  hour: en,
  minute: en,
  second: en,
  timeZoneName: zo
}, YI = {
  hour: en,
  minute: en,
  hourCycle: "h23"
}, KI = {
  hour: en,
  minute: en,
  second: en,
  hourCycle: "h23"
}, XI = {
  hour: en,
  minute: en,
  second: en,
  hourCycle: "h23",
  timeZoneName: Ka
}, JI = {
  hour: en,
  minute: en,
  second: en,
  hourCycle: "h23",
  timeZoneName: zo
}, QI = {
  year: en,
  month: en,
  day: en,
  hour: en,
  minute: en
}, eA = {
  year: en,
  month: en,
  day: en,
  hour: en,
  minute: en,
  second: en
}, tA = {
  year: en,
  month: Ka,
  day: en,
  hour: en,
  minute: en
}, nA = {
  year: en,
  month: Ka,
  day: en,
  hour: en,
  minute: en,
  second: en
}, nR = {
  year: en,
  month: Ka,
  day: en,
  weekday: Ka,
  hour: en,
  minute: en
}, iA = {
  year: en,
  month: zo,
  day: en,
  hour: en,
  minute: en,
  timeZoneName: Ka
}, rA = {
  year: en,
  month: zo,
  day: en,
  hour: en,
  minute: en,
  second: en,
  timeZoneName: Ka
}, sA = {
  year: en,
  month: zo,
  day: en,
  weekday: zo,
  hour: en,
  minute: en,
  timeZoneName: zo
}, oA = {
  year: en,
  month: zo,
  day: en,
  weekday: zo,
  hour: en,
  minute: en,
  second: en,
  timeZoneName: zo
};
let Rm = class {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new pu();
  }
  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new pu();
  }
  /**
   * The IANA name of this zone.
   * Defaults to `name` if not overwritten by a subclass.
   * @abstract
   * @type {string}
   */
  get ianaName() {
    return this.name;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new pu();
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(t, n) {
    throw new pu();
  }
  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(t, n) {
    throw new pu();
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(t) {
    throw new pu();
  }
  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(t) {
    throw new pu();
  }
  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new pu();
  }
}, Sb = null, aA = class lA extends Rm {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    return Sb === null && (Sb = new lA()), Sb;
  }
  /** @override **/
  get type() {
    return "system";
  }
  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName(t, { format: n, locale: i }) {
    return gA(t, n, i);
  }
  /** @override **/
  formatOffset(t, n) {
    return tm(this.offset(t), n);
  }
  /** @override **/
  offset(t) {
    return -new Date(t).getTimezoneOffset();
  }
  /** @override **/
  equals(t) {
    return t.type === "system";
  }
  /** @override **/
  get isValid() {
    return !0;
  }
}, cg = {};
function iR(e) {
  return cg[e] || (cg[e] = new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: e,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    era: "short"
  })), cg[e];
}
const rR = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function sR(e, t) {
  const n = e.format(t).replace(/\u200E/g, ""), i = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(n), [, r, c, d, a, f, g, x] = i;
  return [d, r, c, a, f, g, x];
}
function oR(e, t) {
  const n = e.formatToParts(t), i = [];
  for (let r = 0; r < n.length; r++) {
    const { type: c, value: d } = n[r], a = rR[c];
    c === "era" ? i[a] = d : Rn(a) || (i[a] = parseInt(d, 10));
  }
  return i;
}
let Ev = {}, Bh = class ew extends Rm {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(t) {
    return Ev[t] || (Ev[t] = new ew(t)), Ev[t];
  }
  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    Ev = {}, cg = {};
  }
  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
   * @return {boolean}
   */
  static isValidSpecifier(t) {
    return this.isValidZone(t);
  }
  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(t) {
    if (!t)
      return !1;
    try {
      return new Intl.DateTimeFormat("en-US", { timeZone: t }).format(), !0;
    } catch {
      return !1;
    }
  }
  constructor(t) {
    super(), this.zoneName = t, this.valid = ew.isValidZone(t);
  }
  /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "iana";
  }
  /**
   * The name of this zone (i.e. the IANA zone name).
   * @override
   * @type {string}
   */
  get name() {
    return this.zoneName;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns false for all IANA zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return !1;
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(t, { format: n, locale: i }) {
    return gA(t, n, i, this.name);
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(t, n) {
    return tm(this.offset(t), n);
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @override
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(t) {
    const n = new Date(t);
    if (isNaN(n)) return NaN;
    const i = iR(this.name);
    let [r, c, d, a, f, g, x] = i.formatToParts ? oR(i, n) : sR(i, n);
    a === "BC" && (r = -Math.abs(r) + 1);
    const $ = Xy({
      year: r,
      month: c,
      day: d,
      hour: f === 24 ? 0 : f,
      minute: g,
      second: x,
      millisecond: 0
    });
    let A = +n;
    const I = A % 1e3;
    return A -= I >= 0 ? I : 1e3 + I, ($ - A) / (60 * 1e3);
  }
  /**
   * Return whether this Zone is equal to another zone
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(t) {
    return t.type === "iana" && t.name === this.name;
  }
  /**
   * Return whether this Zone is valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return this.valid;
  }
}, iC = {};
function aR(e, t = {}) {
  const n = JSON.stringify([e, t]);
  let i = iC[n];
  return i || (i = new Intl.ListFormat(e, t), iC[n] = i), i;
}
let tw = {};
function nw(e, t = {}) {
  const n = JSON.stringify([e, t]);
  let i = tw[n];
  return i || (i = new Intl.DateTimeFormat(e, t), tw[n] = i), i;
}
let iw = {};
function lR(e, t = {}) {
  const n = JSON.stringify([e, t]);
  let i = iw[n];
  return i || (i = new Intl.NumberFormat(e, t), iw[n] = i), i;
}
let rw = {};
function cR(e, t = {}) {
  const { base: n, ...i } = t, r = JSON.stringify([e, i]);
  let c = rw[r];
  return c || (c = new Intl.RelativeTimeFormat(e, t), rw[r] = c), c;
}
let ug = null;
function uR() {
  return ug || (ug = new Intl.DateTimeFormat().resolvedOptions().locale, ug);
}
let rC = {};
function dR(e) {
  let t = rC[e];
  if (!t) {
    const n = new Intl.Locale(e);
    t = "getWeekInfo" in n ? n.getWeekInfo() : n.weekInfo, rC[e] = t;
  }
  return t;
}
function pR(e) {
  const t = e.indexOf("-x-");
  t !== -1 && (e = e.substring(0, t));
  const n = e.indexOf("-u-");
  if (n === -1)
    return [e];
  {
    let i, r;
    try {
      i = nw(e).resolvedOptions(), r = e;
    } catch {
      const a = e.substring(0, n);
      i = nw(a).resolvedOptions(), r = a;
    }
    const { numberingSystem: c, calendar: d } = i;
    return [r, c, d];
  }
}
function hR(e, t, n) {
  return (n || t) && (e.includes("-u-") || (e += "-u"), n && (e += `-ca-${n}`), t && (e += `-nu-${t}`)), e;
}
function fR(e) {
  const t = [];
  for (let n = 1; n <= 12; n++) {
    const i = gn.utc(2009, n, 1);
    t.push(e(i));
  }
  return t;
}
function mR(e) {
  const t = [];
  for (let n = 1; n <= 7; n++) {
    const i = gn.utc(2016, 11, 13 + n);
    t.push(e(i));
  }
  return t;
}
function Pv(e, t, n, i) {
  const r = e.listingMode();
  return r === "error" ? null : r === "en" ? n(t) : i(t);
}
function vR(e) {
  return e.numberingSystem && e.numberingSystem !== "latn" ? !1 : e.numberingSystem === "latn" || !e.locale || e.locale.startsWith("en") || new Intl.DateTimeFormat(e.intl).resolvedOptions().numberingSystem === "latn";
}
class gR {
  constructor(t, n, i) {
    this.padTo = i.padTo || 0, this.floor = i.floor || !1;
    const { padTo: r, floor: c, ...d } = i;
    if (!n || Object.keys(d).length > 0) {
      const a = { useGrouping: !1, ...i };
      i.padTo > 0 && (a.minimumIntegerDigits = i.padTo), this.inf = lR(t, a);
    }
  }
  format(t) {
    if (this.inf) {
      const n = this.floor ? Math.floor(t) : t;
      return this.inf.format(n);
    } else {
      const n = this.floor ? Math.floor(t) : k1(t, 3);
      return zr(n, this.padTo);
    }
  }
}
class yR {
  constructor(t, n, i) {
    this.opts = i, this.originalZone = void 0;
    let r;
    if (this.opts.timeZone)
      this.dt = t;
    else if (t.zone.type === "fixed") {
      const d = -1 * (t.offset / 60), a = d >= 0 ? `Etc/GMT+${d}` : `Etc/GMT${d}`;
      t.offset !== 0 && Bh.create(a).valid ? (r = a, this.dt = t) : (r = "UTC", this.dt = t.offset === 0 ? t : t.setZone("UTC").plus({ minutes: t.offset }), this.originalZone = t.zone);
    } else t.zone.type === "system" ? this.dt = t : t.zone.type === "iana" ? (this.dt = t, r = t.zone.name) : (r = "UTC", this.dt = t.setZone("UTC").plus({ minutes: t.offset }), this.originalZone = t.zone);
    const c = { ...this.opts };
    c.timeZone = c.timeZone || r, this.dtf = nw(n, c);
  }
  format() {
    return this.originalZone ? this.formatToParts().map(({ value: t }) => t).join("") : this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    const t = this.dtf.formatToParts(this.dt.toJSDate());
    return this.originalZone ? t.map((n) => {
      if (n.type === "timeZoneName") {
        const i = this.originalZone.offsetName(this.dt.ts, {
          locale: this.dt.locale,
          format: this.opts.timeZoneName
        });
        return {
          ...n,
          value: i
        };
      } else
        return n;
    }) : t;
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}
class _R {
  constructor(t, n, i) {
    this.opts = { style: "long", ...i }, !n && mA() && (this.rtf = cR(t, i));
  }
  format(t, n) {
    return this.rtf ? this.rtf.format(t, n) : UR(n, t, this.opts.numeric, this.opts.style !== "long");
  }
  formatToParts(t, n) {
    return this.rtf ? this.rtf.formatToParts(t, n) : [];
  }
}
const bR = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [6, 7]
};
class Mi {
  static fromOpts(t) {
    return Mi.create(
      t.locale,
      t.numberingSystem,
      t.outputCalendar,
      t.weekSettings,
      t.defaultToEN
    );
  }
  static create(t, n, i, r, c = !1) {
    const d = t || br.defaultLocale, a = d || (c ? "en-US" : uR()), f = n || br.defaultNumberingSystem, g = i || br.defaultOutputCalendar, x = sw(r) || br.defaultWeekSettings;
    return new Mi(a, f, g, x, d);
  }
  static resetCache() {
    ug = null, tw = {}, iw = {}, rw = {};
  }
  static fromObject({ locale: t, numberingSystem: n, outputCalendar: i, weekSettings: r } = {}) {
    return Mi.create(t, n, i, r);
  }
  constructor(t, n, i, r, c) {
    const [d, a, f] = pR(t);
    this.locale = d, this.numberingSystem = n || a || null, this.outputCalendar = i || f || null, this.weekSettings = r, this.intl = hR(this.locale, this.numberingSystem, this.outputCalendar), this.weekdaysCache = { format: {}, standalone: {} }, this.monthsCache = { format: {}, standalone: {} }, this.meridiemCache = null, this.eraCache = {}, this.specifiedLocale = c, this.fastNumbersCached = null;
  }
  get fastNumbers() {
    return this.fastNumbersCached == null && (this.fastNumbersCached = vR(this)), this.fastNumbersCached;
  }
  listingMode() {
    const t = this.isEnglish(), n = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return t && n ? "en" : "intl";
  }
  clone(t) {
    return !t || Object.getOwnPropertyNames(t).length === 0 ? this : Mi.create(
      t.locale || this.specifiedLocale,
      t.numberingSystem || this.numberingSystem,
      t.outputCalendar || this.outputCalendar,
      sw(t.weekSettings) || this.weekSettings,
      t.defaultToEN || !1
    );
  }
  redefaultToEN(t = {}) {
    return this.clone({ ...t, defaultToEN: !0 });
  }
  redefaultToSystem(t = {}) {
    return this.clone({ ...t, defaultToEN: !1 });
  }
  months(t, n = !1) {
    return Pv(this, t, bA, () => {
      const i = n ? { month: t, day: "numeric" } : { month: t }, r = n ? "format" : "standalone";
      return this.monthsCache[r][t] || (this.monthsCache[r][t] = fR((c) => this.extract(c, i, "month"))), this.monthsCache[r][t];
    });
  }
  weekdays(t, n = !1) {
    return Pv(this, t, $A, () => {
      const i = n ? { weekday: t, year: "numeric", month: "long", day: "numeric" } : { weekday: t }, r = n ? "format" : "standalone";
      return this.weekdaysCache[r][t] || (this.weekdaysCache[r][t] = mR(
        (c) => this.extract(c, i, "weekday")
      )), this.weekdaysCache[r][t];
    });
  }
  meridiems() {
    return Pv(
      this,
      void 0,
      () => CA,
      () => {
        if (!this.meridiemCache) {
          const t = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [gn.utc(2016, 11, 13, 9), gn.utc(2016, 11, 13, 19)].map(
            (n) => this.extract(n, t, "dayperiod")
          );
        }
        return this.meridiemCache;
      }
    );
  }
  eras(t) {
    return Pv(this, t, kA, () => {
      const n = { era: t };
      return this.eraCache[t] || (this.eraCache[t] = [gn.utc(-40, 1, 1), gn.utc(2017, 1, 1)].map(
        (i) => this.extract(i, n, "era")
      )), this.eraCache[t];
    });
  }
  extract(t, n, i) {
    const r = this.dtFormatter(t, n), c = r.formatToParts(), d = c.find((a) => a.type.toLowerCase() === i);
    return d ? d.value : null;
  }
  numberFormatter(t = {}) {
    return new gR(this.intl, t.forceSimple || this.fastNumbers, t);
  }
  dtFormatter(t, n = {}) {
    return new yR(t, this.intl, n);
  }
  relFormatter(t = {}) {
    return new _R(this.intl, this.isEnglish(), t);
  }
  listFormatter(t = {}) {
    return aR(this.intl, t);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
  }
  getWeekSettings() {
    return this.weekSettings ? this.weekSettings : vA() ? dR(this.locale) : bR;
  }
  getStartOfWeek() {
    return this.getWeekSettings().firstDay;
  }
  getMinDaysInFirstWeek() {
    return this.getWeekSettings().minimalDays;
  }
  getWeekendDays() {
    return this.getWeekSettings().weekend;
  }
  equals(t) {
    return this.locale === t.locale && this.numberingSystem === t.numberingSystem && this.outputCalendar === t.outputCalendar;
  }
  toString() {
    return `Locale(${this.locale}, ${this.numberingSystem}, ${this.outputCalendar})`;
  }
}
let Tb = null, Ll = class Gf extends Rm {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    return Tb === null && (Tb = new Gf(0)), Tb;
  }
  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(t) {
    return t === 0 ? Gf.utcInstance : new Gf(t);
  }
  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(t) {
    if (t) {
      const n = t.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (n)
        return new Gf(Jy(n[1], n[2]));
    }
    return null;
  }
  constructor(t) {
    super(), this.fixed = t;
  }
  /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "fixed";
  }
  /**
   * The name of this zone.
   * All fixed zones' names always start with "UTC" (plus optional offset)
   * @override
   * @type {string}
   */
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${tm(this.fixed, "narrow")}`;
  }
  /**
   * The IANA name of this zone, i.e. `Etc/UTC` or `Etc/GMT+/-nn`
   *
   * @override
   * @type {string}
   */
  get ianaName() {
    return this.fixed === 0 ? "Etc/UTC" : `Etc/GMT${tm(-this.fixed, "narrow")}`;
  }
  /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */
  offsetName() {
    return this.name;
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(t, n) {
    return tm(this.fixed, n);
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns true for all fixed offset zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return !0;
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */
  offset() {
    return this.fixed;
  }
  /**
   * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(t) {
    return t.type === "fixed" && t.fixed === this.fixed;
  }
  /**
   * Return whether this Zone is valid:
   * All fixed offset zones are valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return !0;
  }
};
class wR extends Rm {
  constructor(t) {
    super(), this.zoneName = t;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName() {
    return null;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  equals() {
    return !1;
  }
  /** @override **/
  get isValid() {
    return !1;
  }
}
function wu(e, t) {
  if (Rn(e) || e === null)
    return t;
  if (e instanceof Rm)
    return e;
  if (TR(e)) {
    const n = e.toLowerCase();
    return n === "default" ? t : n === "local" || n === "system" ? aA.instance : n === "utc" || n === "gmt" ? Ll.utcInstance : Ll.parseSpecifier(n) || Bh.create(e);
  } else return Tu(e) ? Ll.instance(e) : typeof e == "object" && "offset" in e && typeof e.offset == "function" ? e : new wR(e);
}
const w1 = {
  arab: "[٠-٩]",
  arabext: "[۰-۹]",
  bali: "[᭐-᭙]",
  beng: "[০-৯]",
  deva: "[०-९]",
  fullwide: "[０-９]",
  gujr: "[૦-૯]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[០-៩]",
  knda: "[೦-೯]",
  laoo: "[໐-໙]",
  limb: "[᥆-᥏]",
  mlym: "[൦-൯]",
  mong: "[᠐-᠙]",
  mymr: "[၀-၉]",
  orya: "[୦-୯]",
  tamldec: "[௦-௯]",
  telu: "[౦-౯]",
  thai: "[๐-๙]",
  tibt: "[༠-༩]",
  latn: "\\d"
}, sC = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
}, xR = w1.hanidec.replace(/[\[|\]]/g, "").split("");
function $R(e) {
  let t = parseInt(e, 10);
  if (isNaN(t)) {
    t = "";
    for (let n = 0; n < e.length; n++) {
      const i = e.charCodeAt(n);
      if (e[n].search(w1.hanidec) !== -1)
        t += xR.indexOf(e[n]);
      else
        for (const r in sC) {
          const [c, d] = sC[r];
          i >= c && i <= d && (t += i - c);
        }
    }
    return parseInt(t, 10);
  } else
    return t;
}
let zp = {};
function CR() {
  zp = {};
}
function za({ numberingSystem: e }, t = "") {
  const n = e || "latn";
  return zp[n] || (zp[n] = {}), zp[n][t] || (zp[n][t] = new RegExp(`${w1[n]}${t}`)), zp[n][t];
}
let oC = () => Date.now(), aC = "system", lC = null, cC = null, uC = null, dC = 60, pC, hC = null, br = class {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return oC;
  }
  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(t) {
    oC = t;
  }
  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(t) {
    aC = t;
  }
  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return wu(aC, aA.instance);
  }
  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return lC;
  }
  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(t) {
    lC = t;
  }
  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return cC;
  }
  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(t) {
    cC = t;
  }
  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return uC;
  }
  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(t) {
    uC = t;
  }
  /**
   * @typedef {Object} WeekSettings
   * @property {number} firstDay
   * @property {number} minimalDays
   * @property {number[]} weekend
   */
  /**
   * @return {WeekSettings|null}
   */
  static get defaultWeekSettings() {
    return hC;
  }
  /**
   * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
   * how many days are required in the first week of a year.
   * Does not affect existing instances.
   *
   * @param {WeekSettings|null} weekSettings
   */
  static set defaultWeekSettings(t) {
    hC = sw(t);
  }
  /**
   * Get the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   */
  static get twoDigitCutoffYear() {
    return dC;
  }
  /**
   * Set the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // all 'yy' are interpreted as 20th century
   * @example Settings.twoDigitCutoffYear = 99 // all 'yy' are interpreted as 21st century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 2049; '50' -> 1950
   * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
   */
  static set twoDigitCutoffYear(t) {
    dC = t % 100;
  }
  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return pC;
  }
  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(t) {
    pC = t;
  }
  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    Mi.resetCache(), Bh.resetCache(), gn.resetCache(), CR();
  }
}, ja = class {
  constructor(t, n) {
    this.reason = t, this.explanation = n;
  }
  toMessage() {
    return this.explanation ? `${this.reason}: ${this.explanation}` : this.reason;
  }
};
const cA = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], uA = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function sa(e, t) {
  return new ja(
    "unit out of range",
    `you specified ${t} (of type ${typeof t}) as a ${e}, which is invalid`
  );
}
function x1(e, t, n) {
  const i = new Date(Date.UTC(e, t - 1, n));
  e < 100 && e >= 0 && i.setUTCFullYear(i.getUTCFullYear() - 1900);
  const r = i.getUTCDay();
  return r === 0 ? 7 : r;
}
function dA(e, t, n) {
  return n + (zm(e) ? uA : cA)[t - 1];
}
function pA(e, t) {
  const n = zm(e) ? uA : cA, i = n.findIndex((c) => c < t), r = t - n[i];
  return { month: i + 1, day: r };
}
function $1(e, t) {
  return (e - t + 7) % 7 + 1;
}
function qg(e, t = 4, n = 1) {
  const { year: i, month: r, day: c } = e, d = dA(i, r, c), a = $1(x1(i, r, c), n);
  let f = Math.floor((d - a + 14 - t) / 7), g;
  return f < 1 ? (g = i - 1, f = _m(g, t, n)) : f > _m(i, t, n) ? (g = i + 1, f = 1) : g = i, { weekYear: g, weekNumber: f, weekday: a, ...Qy(e) };
}
function fC(e, t = 4, n = 1) {
  const { weekYear: i, weekNumber: r, weekday: c } = e, d = $1(x1(i, 1, t), n), a = ih(i);
  let f = r * 7 + c - d - 7 + t, g;
  f < 1 ? (g = i - 1, f += ih(g)) : f > a ? (g = i + 1, f -= ih(i)) : g = i;
  const { month: x, day: $ } = pA(g, f);
  return { year: g, month: x, day: $, ...Qy(e) };
}
function Ib(e) {
  const { year: t, month: n, day: i } = e, r = dA(t, n, i);
  return { year: t, ordinal: r, ...Qy(e) };
}
function mC(e) {
  const { year: t, ordinal: n } = e, { month: i, day: r } = pA(t, n);
  return { year: t, month: i, day: r, ...Qy(e) };
}
function vC(e, t) {
  if (!Rn(e.localWeekday) || !Rn(e.localWeekNumber) || !Rn(e.localWeekYear)) {
    if (!Rn(e.weekday) || !Rn(e.weekNumber) || !Rn(e.weekYear))
      throw new Yp(
        "Cannot mix locale-based week fields with ISO-based week fields"
      );
    return Rn(e.localWeekday) || (e.weekday = e.localWeekday), Rn(e.localWeekNumber) || (e.weekNumber = e.localWeekNumber), Rn(e.localWeekYear) || (e.weekYear = e.localWeekYear), delete e.localWeekday, delete e.localWeekNumber, delete e.localWeekYear, {
      minDaysInFirstWeek: t.getMinDaysInFirstWeek(),
      startOfWeek: t.getStartOfWeek()
    };
  } else
    return { minDaysInFirstWeek: 4, startOfWeek: 1 };
}
function kR(e, t = 4, n = 1) {
  const i = Ky(e.weekYear), r = oa(
    e.weekNumber,
    1,
    _m(e.weekYear, t, n)
  ), c = oa(e.weekday, 1, 7);
  return i ? r ? c ? !1 : sa("weekday", e.weekday) : sa("week", e.weekNumber) : sa("weekYear", e.weekYear);
}
function SR(e) {
  const t = Ky(e.year), n = oa(e.ordinal, 1, ih(e.year));
  return t ? n ? !1 : sa("ordinal", e.ordinal) : sa("year", e.year);
}
function hA(e) {
  const t = Ky(e.year), n = oa(e.month, 1, 12), i = oa(e.day, 1, jg(e.year, e.month));
  return t ? n ? i ? !1 : sa("day", e.day) : sa("month", e.month) : sa("year", e.year);
}
function fA(e) {
  const { hour: t, minute: n, second: i, millisecond: r } = e, c = oa(t, 0, 23) || t === 24 && n === 0 && i === 0 && r === 0, d = oa(n, 0, 59), a = oa(i, 0, 59), f = oa(r, 0, 999);
  return c ? d ? a ? f ? !1 : sa("millisecond", r) : sa("second", i) : sa("minute", n) : sa("hour", t);
}
function Rn(e) {
  return typeof e > "u";
}
function Tu(e) {
  return typeof e == "number";
}
function Ky(e) {
  return typeof e == "number" && e % 1 === 0;
}
function TR(e) {
  return typeof e == "string";
}
function IR(e) {
  return Object.prototype.toString.call(e) === "[object Date]";
}
function mA() {
  try {
    return typeof Intl < "u" && !!Intl.RelativeTimeFormat;
  } catch {
    return !1;
  }
}
function vA() {
  try {
    return typeof Intl < "u" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
  } catch {
    return !1;
  }
}
function AR(e) {
  return Array.isArray(e) ? e : [e];
}
function gC(e, t, n) {
  if (e.length !== 0)
    return e.reduce((i, r) => {
      const c = [t(r), r];
      return i && n(i[0], c[0]) === i[0] ? i : c;
    }, null)[1];
}
function ER(e, t) {
  return t.reduce((n, i) => (n[i] = e[i], n), {});
}
function vh(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function sw(e) {
  if (e == null)
    return null;
  if (typeof e != "object")
    throw new Rs("Week settings must be an object");
  if (!oa(e.firstDay, 1, 7) || !oa(e.minimalDays, 1, 7) || !Array.isArray(e.weekend) || e.weekend.some((t) => !oa(t, 1, 7)))
    throw new Rs("Invalid week settings");
  return {
    firstDay: e.firstDay,
    minimalDays: e.minimalDays,
    weekend: Array.from(e.weekend)
  };
}
function oa(e, t, n) {
  return Ky(e) && e >= t && e <= n;
}
function PR(e, t) {
  return e - t * Math.floor(e / t);
}
function zr(e, t = 2) {
  const n = e < 0;
  let i;
  return n ? i = "-" + ("" + -e).padStart(t, "0") : i = ("" + e).padStart(t, "0"), i;
}
function yu(e) {
  if (!(Rn(e) || e === null || e === ""))
    return parseInt(e, 10);
}
function pd(e) {
  if (!(Rn(e) || e === null || e === ""))
    return parseFloat(e);
}
function C1(e) {
  if (!(Rn(e) || e === null || e === "")) {
    const t = parseFloat("0." + e) * 1e3;
    return Math.floor(t);
  }
}
function k1(e, t, n = !1) {
  const i = 10 ** t;
  return (n ? Math.trunc : Math.round)(e * i) / i;
}
function zm(e) {
  return e % 4 === 0 && (e % 100 !== 0 || e % 400 === 0);
}
function ih(e) {
  return zm(e) ? 366 : 365;
}
function jg(e, t) {
  const n = PR(t - 1, 12) + 1, i = e + (t - n) / 12;
  return n === 2 ? zm(i) ? 29 : 28 : [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][n - 1];
}
function Xy(e) {
  let t = Date.UTC(
    e.year,
    e.month - 1,
    e.day,
    e.hour,
    e.minute,
    e.second,
    e.millisecond
  );
  return e.year < 100 && e.year >= 0 && (t = new Date(t), t.setUTCFullYear(e.year, e.month - 1, e.day)), +t;
}
function yC(e, t, n) {
  return -$1(x1(e, 1, t), n) + t - 1;
}
function _m(e, t = 4, n = 1) {
  const i = yC(e, t, n), r = yC(e + 1, t, n);
  return (ih(e) - i + r) / 7;
}
function ow(e) {
  return e > 99 ? e : e > br.twoDigitCutoffYear ? 1900 + e : 2e3 + e;
}
function gA(e, t, n, i = null) {
  const r = new Date(e), c = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  i && (c.timeZone = i);
  const d = { timeZoneName: t, ...c }, a = new Intl.DateTimeFormat(n, d).formatToParts(r).find((f) => f.type.toLowerCase() === "timezonename");
  return a ? a.value : null;
}
function Jy(e, t) {
  let n = parseInt(e, 10);
  Number.isNaN(n) && (n = 0);
  const i = parseInt(t, 10) || 0, r = n < 0 || Object.is(n, -0) ? -i : i;
  return n * 60 + r;
}
function yA(e) {
  const t = Number(e);
  if (typeof e == "boolean" || e === "" || Number.isNaN(t))
    throw new Rs(`Invalid unit value ${e}`);
  return t;
}
function Gg(e, t) {
  const n = {};
  for (const i in e)
    if (vh(e, i)) {
      const r = e[i];
      if (r == null) continue;
      n[t(i)] = yA(r);
    }
  return n;
}
function tm(e, t) {
  const n = Math.trunc(Math.abs(e / 60)), i = Math.trunc(Math.abs(e % 60)), r = e >= 0 ? "+" : "-";
  switch (t) {
    case "short":
      return `${r}${zr(n, 2)}:${zr(i, 2)}`;
    case "narrow":
      return `${r}${n}${i > 0 ? `:${i}` : ""}`;
    case "techie":
      return `${r}${zr(n, 2)}${zr(i, 2)}`;
    default:
      throw new RangeError(`Value format ${t} is out of range for property format`);
  }
}
function Qy(e) {
  return ER(e, ["hour", "minute", "second", "millisecond"]);
}
const MR = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], _A = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
], DR = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function bA(e) {
  switch (e) {
    case "narrow":
      return [...DR];
    case "short":
      return [..._A];
    case "long":
      return [...MR];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
const wA = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
], xA = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], LR = ["M", "T", "W", "T", "F", "S", "S"];
function $A(e) {
  switch (e) {
    case "narrow":
      return [...LR];
    case "short":
      return [...xA];
    case "long":
      return [...wA];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
const CA = ["AM", "PM"], OR = ["Before Christ", "Anno Domini"], NR = ["BC", "AD"], FR = ["B", "A"];
function kA(e) {
  switch (e) {
    case "narrow":
      return [...FR];
    case "short":
      return [...NR];
    case "long":
      return [...OR];
    default:
      return null;
  }
}
function RR(e) {
  return CA[e.hour < 12 ? 0 : 1];
}
function zR(e, t) {
  return $A(t)[e.weekday - 1];
}
function BR(e, t) {
  return bA(t)[e.month - 1];
}
function VR(e, t) {
  return kA(t)[e.year < 0 ? 0 : 1];
}
function UR(e, t, n = "always", i = !1) {
  const r = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  }, c = ["hours", "minutes", "seconds"].indexOf(e) === -1;
  if (n === "auto" && c) {
    const $ = e === "days";
    switch (t) {
      case 1:
        return $ ? "tomorrow" : `next ${r[e][0]}`;
      case -1:
        return $ ? "yesterday" : `last ${r[e][0]}`;
      case 0:
        return $ ? "today" : `this ${r[e][0]}`;
    }
  }
  const d = Object.is(t, -0) || t < 0, a = Math.abs(t), f = a === 1, g = r[e], x = i ? f ? g[1] : g[2] || g[1] : f ? r[e][0] : e;
  return d ? `${a} ${x} ago` : `in ${a} ${x}`;
}
function _C(e, t) {
  let n = "";
  for (const i of e)
    i.literal ? n += i.val : n += t(i.val);
  return n;
}
const HR = {
  D: Zg,
  DD: UI,
  DDD: HI,
  DDDD: WI,
  t: ZI,
  tt: qI,
  ttt: jI,
  tttt: GI,
  T: YI,
  TT: KI,
  TTT: XI,
  TTTT: JI,
  f: QI,
  ff: tA,
  fff: iA,
  ffff: sA,
  F: eA,
  FF: nA,
  FFF: rA,
  FFFF: oA
};
let qa = class Yf {
  static create(t, n = {}) {
    return new Yf(t, n);
  }
  static parseFormat(t) {
    let n = null, i = "", r = !1;
    const c = [];
    for (let d = 0; d < t.length; d++) {
      const a = t.charAt(d);
      a === "'" ? (i.length > 0 && c.push({ literal: r || /^\s+$/.test(i), val: i }), n = null, i = "", r = !r) : r || a === n ? i += a : (i.length > 0 && c.push({ literal: /^\s+$/.test(i), val: i }), i = a, n = a);
    }
    return i.length > 0 && c.push({ literal: r || /^\s+$/.test(i), val: i }), c;
  }
  static macroTokenToFormatOpts(t) {
    return HR[t];
  }
  constructor(t, n) {
    this.opts = n, this.loc = t, this.systemLoc = null;
  }
  formatWithSystemDefault(t, n) {
    return this.systemLoc === null && (this.systemLoc = this.loc.redefaultToSystem()), this.systemLoc.dtFormatter(t, { ...this.opts, ...n }).format();
  }
  dtFormatter(t, n = {}) {
    return this.loc.dtFormatter(t, { ...this.opts, ...n });
  }
  formatDateTime(t, n) {
    return this.dtFormatter(t, n).format();
  }
  formatDateTimeParts(t, n) {
    return this.dtFormatter(t, n).formatToParts();
  }
  formatInterval(t, n) {
    return this.dtFormatter(t.start, n).dtf.formatRange(t.start.toJSDate(), t.end.toJSDate());
  }
  resolvedOptions(t, n) {
    return this.dtFormatter(t, n).resolvedOptions();
  }
  num(t, n = 0) {
    if (this.opts.forceSimple)
      return zr(t, n);
    const i = { ...this.opts };
    return n > 0 && (i.padTo = n), this.loc.numberFormatter(i).format(t);
  }
  formatDateTimeFromString(t, n) {
    const i = this.loc.listingMode() === "en", r = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", c = (I, O) => this.loc.extract(t, I, O), d = (I) => t.isOffsetFixed && t.offset === 0 && I.allowZ ? "Z" : t.isValid ? t.zone.formatOffset(t.ts, I.format) : "", a = () => i ? RR(t) : c({ hour: "numeric", hourCycle: "h12" }, "dayperiod"), f = (I, O) => i ? BR(t, I) : c(O ? { month: I } : { month: I, day: "numeric" }, "month"), g = (I, O) => i ? zR(t, I) : c(
      O ? { weekday: I } : { weekday: I, month: "long", day: "numeric" },
      "weekday"
    ), x = (I) => {
      const O = Yf.macroTokenToFormatOpts(I);
      return O ? this.formatWithSystemDefault(t, O) : I;
    }, $ = (I) => i ? VR(t, I) : c({ era: I }, "era"), A = (I) => {
      switch (I) {
        case "S":
          return this.num(t.millisecond);
        case "u":
        case "SSS":
          return this.num(t.millisecond, 3);
        case "s":
          return this.num(t.second);
        case "ss":
          return this.num(t.second, 2);
        case "uu":
          return this.num(Math.floor(t.millisecond / 10), 2);
        case "uuu":
          return this.num(Math.floor(t.millisecond / 100));
        case "m":
          return this.num(t.minute);
        case "mm":
          return this.num(t.minute, 2);
        case "h":
          return this.num(t.hour % 12 === 0 ? 12 : t.hour % 12);
        case "hh":
          return this.num(t.hour % 12 === 0 ? 12 : t.hour % 12, 2);
        case "H":
          return this.num(t.hour);
        case "HH":
          return this.num(t.hour, 2);
        case "Z":
          return d({ format: "narrow", allowZ: this.opts.allowZ });
        case "ZZ":
          return d({ format: "short", allowZ: this.opts.allowZ });
        case "ZZZ":
          return d({ format: "techie", allowZ: this.opts.allowZ });
        case "ZZZZ":
          return t.zone.offsetName(t.ts, { format: "short", locale: this.loc.locale });
        case "ZZZZZ":
          return t.zone.offsetName(t.ts, { format: "long", locale: this.loc.locale });
        case "z":
          return t.zoneName;
        case "a":
          return a();
        case "d":
          return r ? c({ day: "numeric" }, "day") : this.num(t.day);
        case "dd":
          return r ? c({ day: "2-digit" }, "day") : this.num(t.day, 2);
        case "c":
          return this.num(t.weekday);
        case "ccc":
          return g("short", !0);
        case "cccc":
          return g("long", !0);
        case "ccccc":
          return g("narrow", !0);
        case "E":
          return this.num(t.weekday);
        case "EEE":
          return g("short", !1);
        case "EEEE":
          return g("long", !1);
        case "EEEEE":
          return g("narrow", !1);
        case "L":
          return r ? c({ month: "numeric", day: "numeric" }, "month") : this.num(t.month);
        case "LL":
          return r ? c({ month: "2-digit", day: "numeric" }, "month") : this.num(t.month, 2);
        case "LLL":
          return f("short", !0);
        case "LLLL":
          return f("long", !0);
        case "LLLLL":
          return f("narrow", !0);
        case "M":
          return r ? c({ month: "numeric" }, "month") : this.num(t.month);
        case "MM":
          return r ? c({ month: "2-digit" }, "month") : this.num(t.month, 2);
        case "MMM":
          return f("short", !1);
        case "MMMM":
          return f("long", !1);
        case "MMMMM":
          return f("narrow", !1);
        case "y":
          return r ? c({ year: "numeric" }, "year") : this.num(t.year);
        case "yy":
          return r ? c({ year: "2-digit" }, "year") : this.num(t.year.toString().slice(-2), 2);
        case "yyyy":
          return r ? c({ year: "numeric" }, "year") : this.num(t.year, 4);
        case "yyyyyy":
          return r ? c({ year: "numeric" }, "year") : this.num(t.year, 6);
        case "G":
          return $("short");
        case "GG":
          return $("long");
        case "GGGGG":
          return $("narrow");
        case "kk":
          return this.num(t.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(t.weekYear, 4);
        case "W":
          return this.num(t.weekNumber);
        case "WW":
          return this.num(t.weekNumber, 2);
        case "n":
          return this.num(t.localWeekNumber);
        case "nn":
          return this.num(t.localWeekNumber, 2);
        case "ii":
          return this.num(t.localWeekYear.toString().slice(-2), 2);
        case "iiii":
          return this.num(t.localWeekYear, 4);
        case "o":
          return this.num(t.ordinal);
        case "ooo":
          return this.num(t.ordinal, 3);
        case "q":
          return this.num(t.quarter);
        case "qq":
          return this.num(t.quarter, 2);
        case "X":
          return this.num(Math.floor(t.ts / 1e3));
        case "x":
          return this.num(t.ts);
        default:
          return x(I);
      }
    };
    return _C(Yf.parseFormat(n), A);
  }
  formatDurationFromString(t, n) {
    const i = (f) => {
      switch (f[0]) {
        case "S":
          return "millisecond";
        case "s":
          return "second";
        case "m":
          return "minute";
        case "h":
          return "hour";
        case "d":
          return "day";
        case "w":
          return "week";
        case "M":
          return "month";
        case "y":
          return "year";
        default:
          return null;
      }
    }, r = (f) => (g) => {
      const x = i(g);
      return x ? this.num(f.get(x), g.length) : g;
    }, c = Yf.parseFormat(n), d = c.reduce(
      (f, { literal: g, val: x }) => g ? f : f.concat(x),
      []
    ), a = t.shiftTo(...d.map(i).filter((f) => f));
    return _C(c, r(a));
  }
};
const SA = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function Vh(...e) {
  const t = e.reduce((n, i) => n + i.source, "");
  return RegExp(`^${t}$`);
}
function Uh(...e) {
  return (t) => e.reduce(
    ([n, i, r], c) => {
      const [d, a, f] = c(t, r);
      return [{ ...n, ...d }, a || i, f];
    },
    [{}, null, 1]
  ).slice(0, 2);
}
function Hh(e, ...t) {
  if (e == null)
    return [null, null];
  for (const [n, i] of t) {
    const r = n.exec(e);
    if (r)
      return i(r);
  }
  return [null, null];
}
function TA(...e) {
  return (t, n) => {
    const i = {};
    let r;
    for (r = 0; r < e.length; r++)
      i[e[r]] = yu(t[n + r]);
    return [i, null, n + r];
  };
}
const IA = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/, WR = `(?:${IA.source}?(?:\\[(${SA.source})\\])?)?`, S1 = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/, AA = RegExp(`${S1.source}${WR}`), T1 = RegExp(`(?:T${AA.source})?`), ZR = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/, qR = /(\d{4})-?W(\d\d)(?:-?(\d))?/, jR = /(\d{4})-?(\d{3})/, GR = TA("weekYear", "weekNumber", "weekDay"), YR = TA("year", "ordinal"), KR = /(\d{4})-(\d\d)-(\d\d)/, EA = RegExp(
  `${S1.source} ?(?:${IA.source}|(${SA.source}))?`
), XR = RegExp(`(?: ${EA.source})?`);
function rh(e, t, n) {
  const i = e[t];
  return Rn(i) ? n : yu(i);
}
function JR(e, t) {
  return [{
    year: rh(e, t),
    month: rh(e, t + 1, 1),
    day: rh(e, t + 2, 1)
  }, null, t + 3];
}
function Wh(e, t) {
  return [{
    hours: rh(e, t, 0),
    minutes: rh(e, t + 1, 0),
    seconds: rh(e, t + 2, 0),
    milliseconds: C1(e[t + 3])
  }, null, t + 4];
}
function Bm(e, t) {
  const n = !e[t] && !e[t + 1], i = Jy(e[t + 1], e[t + 2]), r = n ? null : Ll.instance(i);
  return [{}, r, t + 3];
}
function Vm(e, t) {
  const n = e[t] ? Bh.create(e[t]) : null;
  return [{}, n, t + 1];
}
const QR = RegExp(`^T?${S1.source}$`), ez = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function tz(e) {
  const [t, n, i, r, c, d, a, f, g] = e, x = t[0] === "-", $ = f && f[0] === "-", A = (I, O = !1) => I !== void 0 && (O || I && x) ? -I : I;
  return [
    {
      years: A(pd(n)),
      months: A(pd(i)),
      weeks: A(pd(r)),
      days: A(pd(c)),
      hours: A(pd(d)),
      minutes: A(pd(a)),
      seconds: A(pd(f), f === "-0"),
      milliseconds: A(C1(g), $)
    }
  ];
}
const nz = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function I1(e, t, n, i, r, c, d) {
  const a = {
    year: t.length === 2 ? ow(yu(t)) : yu(t),
    month: _A.indexOf(n) + 1,
    day: yu(i),
    hour: yu(r),
    minute: yu(c)
  };
  return d && (a.second = yu(d)), e && (a.weekday = e.length > 3 ? wA.indexOf(e) + 1 : xA.indexOf(e) + 1), a;
}
const iz = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function rz(e) {
  const [
    ,
    t,
    n,
    i,
    r,
    c,
    d,
    a,
    f,
    g,
    x,
    $
  ] = e, A = I1(t, r, i, n, c, d, a);
  let I;
  return f ? I = nz[f] : g ? I = 0 : I = Jy(x, $), [A, new Ll(I)];
}
function sz(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
const oz = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, az = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, lz = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function bC(e) {
  const [, t, n, i, r, c, d, a] = e;
  return [I1(t, r, i, n, c, d, a), Ll.utcInstance];
}
function cz(e) {
  const [, t, n, i, r, c, d, a] = e;
  return [I1(t, a, n, i, r, c, d), Ll.utcInstance];
}
const uz = Vh(ZR, T1), dz = Vh(qR, T1), pz = Vh(jR, T1), hz = Vh(AA), PA = Uh(
  JR,
  Wh,
  Bm,
  Vm
), fz = Uh(
  GR,
  Wh,
  Bm,
  Vm
), mz = Uh(
  YR,
  Wh,
  Bm,
  Vm
), vz = Uh(
  Wh,
  Bm,
  Vm
);
function gz(e) {
  return Hh(
    e,
    [uz, PA],
    [dz, fz],
    [pz, mz],
    [hz, vz]
  );
}
function yz(e) {
  return Hh(sz(e), [iz, rz]);
}
function _z(e) {
  return Hh(
    e,
    [oz, bC],
    [az, bC],
    [lz, cz]
  );
}
function bz(e) {
  return Hh(e, [ez, tz]);
}
const wz = Uh(Wh);
function xz(e) {
  return Hh(e, [QR, wz]);
}
const $z = Vh(KR, XR), Cz = Vh(EA), kz = Uh(
  Wh,
  Bm,
  Vm
);
function Sz(e) {
  return Hh(
    e,
    [$z, PA],
    [Cz, kz]
  );
}
const wC = "Invalid Duration", MA = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1e3
  },
  hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1e3 },
  minutes: { seconds: 60, milliseconds: 60 * 1e3 },
  seconds: { milliseconds: 1e3 }
}, Tz = {
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1e3
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1e3
  },
  ...MA
}, ta = 146097 / 400, xp = 146097 / 4800, Iz = {
  years: {
    quarters: 4,
    months: 12,
    weeks: ta / 7,
    days: ta,
    hours: ta * 24,
    minutes: ta * 24 * 60,
    seconds: ta * 24 * 60 * 60,
    milliseconds: ta * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: ta / 28,
    days: ta / 4,
    hours: ta * 24 / 4,
    minutes: ta * 24 * 60 / 4,
    seconds: ta * 24 * 60 * 60 / 4,
    milliseconds: ta * 24 * 60 * 60 * 1e3 / 4
  },
  months: {
    weeks: xp / 7,
    days: xp,
    hours: xp * 24,
    minutes: xp * 24 * 60,
    seconds: xp * 24 * 60 * 60,
    milliseconds: xp * 24 * 60 * 60 * 1e3
  },
  ...MA
}, xd = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
], Az = xd.slice(0).reverse();
function hu(e, t, n = !1) {
  const i = {
    values: n ? t.values : { ...e.values, ...t.values || {} },
    loc: e.loc.clone(t.loc),
    conversionAccuracy: t.conversionAccuracy || e.conversionAccuracy,
    matrix: t.matrix || e.matrix
  };
  return new Bs(i);
}
function DA(e, t) {
  let n = t.milliseconds ?? 0;
  for (const i of Az.slice(1))
    t[i] && (n += t[i] * e[i].milliseconds);
  return n;
}
function xC(e, t) {
  const n = DA(e, t) < 0 ? -1 : 1;
  xd.reduceRight((i, r) => {
    if (Rn(t[r]))
      return i;
    if (i) {
      const c = t[i] * n, d = e[r][i], a = Math.floor(c / d);
      t[r] += a * n, t[i] -= a * d * n;
    }
    return r;
  }, null), xd.reduce((i, r) => {
    if (Rn(t[r]))
      return i;
    if (i) {
      const c = t[i] % 1;
      t[i] -= c, t[r] += c * e[i][r];
    }
    return r;
  }, null);
}
function Ez(e) {
  const t = {};
  for (const [n, i] of Object.entries(e))
    i !== 0 && (t[n] = i);
  return t;
}
let Bs = class ks {
  /**
   * @private
   */
  constructor(t) {
    const n = t.conversionAccuracy === "longterm" || !1;
    let i = n ? Iz : Tz;
    t.matrix && (i = t.matrix), this.values = t.values, this.loc = t.loc || Mi.create(), this.conversionAccuracy = n ? "longterm" : "casual", this.invalid = t.invalid || null, this.matrix = i, this.isLuxonDuration = !0;
  }
  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(t, n) {
    return ks.fromObject({ milliseconds: t }, n);
  }
  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */
  static fromObject(t, n = {}) {
    if (t == null || typeof t != "object")
      throw new Rs(
        `Duration.fromObject: argument expected to be an object, got ${t === null ? "null" : typeof t}`
      );
    return new ks({
      values: Gg(t, ks.normalizeUnit),
      loc: Mi.fromObject(n),
      conversionAccuracy: n.conversionAccuracy,
      matrix: n.matrix
    });
  }
  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(t) {
    if (Tu(t))
      return ks.fromMillis(t);
    if (ks.isDuration(t))
      return t;
    if (typeof t == "object")
      return ks.fromObject(t);
    throw new Rs(
      `Unknown duration argument ${t} of type ${typeof t}`
    );
  }
  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(t, n) {
    const [i] = bz(t);
    return i ? ks.fromObject(i, n) : ks.invalid("unparsable", `the input "${t}" can't be parsed as ISO 8601`);
  }
  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(t, n) {
    const [i] = xz(t);
    return i ? ks.fromObject(i, n) : ks.invalid("unparsable", `the input "${t}" can't be parsed as ISO 8601`);
  }
  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(t, n = null) {
    if (!t)
      throw new Rs("need to specify a reason the Duration is invalid");
    const i = t instanceof ja ? t : new ja(t, n);
    if (br.throwOnInvalid)
      throw new eR(i);
    return new ks({ invalid: i });
  }
  /**
   * @private
   */
  static normalizeUnit(t) {
    const n = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[t && t.toLowerCase()];
    if (!n) throw new VI(t);
    return n;
  }
  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(t) {
    return t && t.isLuxonDuration || !1;
  }
  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */
  toFormat(t, n = {}) {
    const i = {
      ...n,
      floor: n.round !== !1 && n.floor !== !1
    };
    return this.isValid ? qa.create(this.loc, i).formatDurationFromString(this, t) : wC;
  }
  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */
  toHuman(t = {}) {
    if (!this.isValid) return wC;
    const n = xd.map((i) => {
      const r = this.values[i];
      return Rn(r) ? null : this.loc.numberFormatter({ style: "unit", unitDisplay: "long", ...t, unit: i.slice(0, -1) }).format(r);
    }).filter((i) => i);
    return this.loc.listFormatter({ type: "conjunction", style: t.listStyle || "narrow", ...t }).format(n);
  }
  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    return this.isValid ? { ...this.values } : {};
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    if (!this.isValid) return null;
    let t = "P";
    return this.years !== 0 && (t += this.years + "Y"), (this.months !== 0 || this.quarters !== 0) && (t += this.months + this.quarters * 3 + "M"), this.weeks !== 0 && (t += this.weeks + "W"), this.days !== 0 && (t += this.days + "D"), (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) && (t += "T"), this.hours !== 0 && (t += this.hours + "H"), this.minutes !== 0 && (t += this.minutes + "M"), (this.seconds !== 0 || this.milliseconds !== 0) && (t += k1(this.seconds + this.milliseconds / 1e3, 3) + "S"), t === "P" && (t += "T0S"), t;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(t = {}) {
    if (!this.isValid) return null;
    const n = this.toMillis();
    return n < 0 || n >= 864e5 ? null : (t = {
      suppressMilliseconds: !1,
      suppressSeconds: !1,
      includePrefix: !1,
      format: "extended",
      ...t,
      includeOffset: !1
    }, gn.fromMillis(n, { zone: "UTC" }).toISOTime(t));
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }
  /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `Duration { values: ${JSON.stringify(this.values)} }` : `Duration { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? DA(this.matrix, this.values) : NaN;
  }
  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(t) {
    if (!this.isValid) return this;
    const n = ks.fromDurationLike(t), i = {};
    for (const r of xd)
      (vh(n.values, r) || vh(this.values, r)) && (i[r] = n.get(r) + this.get(r));
    return hu(this, { values: i }, !0);
  }
  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(t) {
    if (!this.isValid) return this;
    const n = ks.fromDurationLike(t);
    return this.plus(n.negate());
  }
  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(t) {
    if (!this.isValid) return this;
    const n = {};
    for (const i of Object.keys(this.values))
      n[i] = yA(t(this.values[i], i));
    return hu(this, { values: n }, !0);
  }
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(t) {
    return this[ks.normalizeUnit(t)];
  }
  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(t) {
    if (!this.isValid) return this;
    const n = { ...this.values, ...Gg(t, ks.normalizeUnit) };
    return hu(this, { values: n });
  }
  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale: t, numberingSystem: n, conversionAccuracy: i, matrix: r } = {}) {
    const c = { loc: this.loc.clone({ locale: t, numberingSystem: n }), matrix: r, conversionAccuracy: i };
    return hu(this, c);
  }
  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(t) {
    return this.isValid ? this.shiftTo(t).get(t) : NaN;
  }
  /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid) return this;
    const t = this.toObject();
    return xC(this.matrix, t), hu(this, { values: t }, !0);
  }
  /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */
  rescale() {
    if (!this.isValid) return this;
    const t = Ez(this.normalize().shiftToAll().toObject());
    return hu(this, { values: t }, !0);
  }
  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...t) {
    if (!this.isValid) return this;
    if (t.length === 0)
      return this;
    t = t.map((d) => ks.normalizeUnit(d));
    const n = {}, i = {}, r = this.toObject();
    let c;
    for (const d of xd)
      if (t.indexOf(d) >= 0) {
        c = d;
        let a = 0;
        for (const g in i)
          a += this.matrix[g][d] * i[g], i[g] = 0;
        Tu(r[d]) && (a += r[d]);
        const f = Math.trunc(a);
        n[d] = f, i[d] = (a * 1e3 - f * 1e3) / 1e3;
      } else Tu(r[d]) && (i[d] = r[d]);
    for (const d in i)
      i[d] !== 0 && (n[c] += d === c ? i[d] : i[d] / this.matrix[c][d]);
    return xC(this.matrix, n), hu(this, { values: n }, !0);
  }
  /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */
  shiftToAll() {
    return this.isValid ? this.shiftTo(
      "years",
      "months",
      "weeks",
      "days",
      "hours",
      "minutes",
      "seconds",
      "milliseconds"
    ) : this;
  }
  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid) return this;
    const t = {};
    for (const n of Object.keys(this.values))
      t[n] = this.values[n] === 0 ? 0 : -this.values[n];
    return hu(this, { values: t }, !0);
  }
  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(t) {
    if (!this.isValid || !t.isValid || !this.loc.equals(t.loc))
      return !1;
    function n(i, r) {
      return i === void 0 || i === 0 ? r === void 0 || r === 0 : i === r;
    }
    for (const i of xd)
      if (!n(this.values[i], t.values[i]))
        return !1;
    return !0;
  }
};
const $p = "Invalid Interval";
function Pz(e, t) {
  return !e || !e.isValid ? yr.invalid("missing or invalid start") : !t || !t.isValid ? yr.invalid("missing or invalid end") : t < e ? yr.invalid(
    "end before start",
    `The end of an interval must be after its start, but you had start=${e.toISO()} and end=${t.toISO()}`
  ) : null;
}
class yr {
  /**
   * @private
   */
  constructor(t) {
    this.s = t.start, this.e = t.end, this.invalid = t.invalid || null, this.isLuxonInterval = !0;
  }
  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(t, n = null) {
    if (!t)
      throw new Rs("need to specify a reason the Interval is invalid");
    const i = t instanceof ja ? t : new ja(t, n);
    if (br.throwOnInvalid)
      throw new QF(i);
    return new yr({ invalid: i });
  }
  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(t, n) {
    const i = Pf(t), r = Pf(n);
    return Pz(i, r) ?? new yr({
      start: i,
      end: r
    });
  }
  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(t, n) {
    const i = Bs.fromDurationLike(n), r = Pf(t);
    return yr.fromDateTimes(r, r.plus(i));
  }
  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(t, n) {
    const i = Bs.fromDurationLike(n), r = Pf(t);
    return yr.fromDateTimes(r.minus(i), r);
  }
  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(t, n) {
    const [i, r] = (t || "").split("/", 2);
    if (i && r) {
      let c, d;
      try {
        c = gn.fromISO(i, n), d = c.isValid;
      } catch {
        d = !1;
      }
      let a, f;
      try {
        a = gn.fromISO(r, n), f = a.isValid;
      } catch {
        f = !1;
      }
      if (d && f)
        return yr.fromDateTimes(c, a);
      if (d) {
        const g = Bs.fromISO(r, n);
        if (g.isValid)
          return yr.after(c, g);
      } else if (f) {
        const g = Bs.fromISO(i, n);
        if (g.isValid)
          return yr.before(a, g);
      }
    }
    return yr.invalid("unparsable", `the input "${t}" can't be parsed as ISO 8601`);
  }
  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(t) {
    return t && t.isLuxonInterval || !1;
  }
  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }
  /**
   * Returns the end of the Interval
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }
  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }
  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(t = "milliseconds") {
    return this.isValid ? this.toDuration(t).get(t) : NaN;
  }
  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */
  count(t = "milliseconds", n) {
    if (!this.isValid) return NaN;
    const i = this.start.startOf(t, n);
    let r;
    return n != null && n.useLocaleWeeks ? r = this.end.reconfigure({ locale: i.locale }) : r = this.end, r = r.startOf(t, n), Math.floor(r.diff(i, t).get(t)) + (r.valueOf() !== this.end.valueOf());
  }
  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(t) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, t) : !1;
  }
  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(t) {
    return this.isValid ? this.s > t : !1;
  }
  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(t) {
    return this.isValid ? this.e <= t : !1;
  }
  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(t) {
    return this.isValid ? this.s <= t && this.e > t : !1;
  }
  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start: t, end: n } = {}) {
    return this.isValid ? yr.fromDateTimes(t || this.s, n || this.e) : this;
  }
  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...t) {
    if (!this.isValid) return [];
    const n = t.map(Pf).filter((d) => this.contains(d)).sort((d, a) => d.toMillis() - a.toMillis()), i = [];
    let { s: r } = this, c = 0;
    for (; r < this.e; ) {
      const d = n[c] || this.e, a = +d > +this.e ? this.e : d;
      i.push(yr.fromDateTimes(r, a)), r = a, c += 1;
    }
    return i;
  }
  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(t) {
    const n = Bs.fromDurationLike(t);
    if (!this.isValid || !n.isValid || n.as("milliseconds") === 0)
      return [];
    let { s: i } = this, r = 1, c;
    const d = [];
    for (; i < this.e; ) {
      const a = this.start.plus(n.mapUnits((f) => f * r));
      c = +a > +this.e ? this.e : a, d.push(yr.fromDateTimes(i, c)), i = c, r += 1;
    }
    return d;
  }
  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(t) {
    return this.isValid ? this.splitBy(this.length() / t).slice(0, t) : [];
  }
  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(t) {
    return this.e > t.s && this.s < t.e;
  }
  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(t) {
    return this.isValid ? +this.e == +t.s : !1;
  }
  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(t) {
    return this.isValid ? +t.e == +this.s : !1;
  }
  /**
   * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(t) {
    return this.isValid ? this.s <= t.s && this.e >= t.e : !1;
  }
  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(t) {
    return !this.isValid || !t.isValid ? !1 : this.s.equals(t.s) && this.e.equals(t.e);
  }
  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(t) {
    if (!this.isValid) return this;
    const n = this.s > t.s ? this.s : t.s, i = this.e < t.e ? this.e : t.e;
    return n >= i ? null : yr.fromDateTimes(n, i);
  }
  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(t) {
    if (!this.isValid) return this;
    const n = this.s < t.s ? this.s : t.s, i = this.e > t.e ? this.e : t.e;
    return yr.fromDateTimes(n, i);
  }
  /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(t) {
    const [n, i] = t.sort((r, c) => r.s - c.s).reduce(
      ([r, c], d) => c ? c.overlaps(d) || c.abutsStart(d) ? [r, c.union(d)] : [r.concat([c]), d] : [r, d],
      [[], null]
    );
    return i && n.push(i), n;
  }
  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(t) {
    let n = null, i = 0;
    const r = [], c = t.map((f) => [
      { time: f.s, type: "s" },
      { time: f.e, type: "e" }
    ]), d = Array.prototype.concat(...c), a = d.sort((f, g) => f.time - g.time);
    for (const f of a)
      i += f.type === "s" ? 1 : -1, i === 1 ? n = f.time : (n && +n != +f.time && r.push(yr.fromDateTimes(n, f.time)), n = null);
    return yr.merge(r);
  }
  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...t) {
    return yr.xor([this].concat(t)).map((n) => this.intersection(n)).filter((n) => n && !n.isEmpty());
  }
  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    return this.isValid ? `[${this.s.toISO()} – ${this.e.toISO()})` : $p;
  }
  /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }` : `Interval { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */
  toLocaleString(t = Zg, n = {}) {
    return this.isValid ? qa.create(this.s.loc.clone(n), t).formatInterval(this) : $p;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(t) {
    return this.isValid ? `${this.s.toISO(t)}/${this.e.toISO(t)}` : $p;
  }
  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    return this.isValid ? `${this.s.toISODate()}/${this.e.toISODate()}` : $p;
  }
  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(t) {
    return this.isValid ? `${this.s.toISOTime(t)}/${this.e.toISOTime(t)}` : $p;
  }
  /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */
  toFormat(t, { separator: n = " – " } = {}) {
    return this.isValid ? `${this.s.toFormat(t)}${n}${this.e.toFormat(t)}` : $p;
  }
  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(t, n) {
    return this.isValid ? this.e.diff(this.s, t, n) : Bs.invalid(this.invalidReason);
  }
  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(t) {
    return yr.fromDateTimes(t(this.s), t(this.e));
  }
}
let Mv = class {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(t = br.defaultZone) {
    const n = gn.now().setZone(t).set({ month: 12 });
    return !t.isUniversal && n.offset !== n.set({ month: 6 }).offset;
  }
  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(t) {
    return Bh.isValidZone(t);
  }
  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(t) {
    return wu(t, br.defaultZone);
  }
  /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */
  static getStartOfWeek({ locale: t = null, locObj: n = null } = {}) {
    return (n || Mi.create(t)).getStartOfWeek();
  }
  /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */
  static getMinimumDaysInFirstWeek({ locale: t = null, locObj: n = null } = {}) {
    return (n || Mi.create(t)).getMinDaysInFirstWeek();
  }
  /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */
  static getWeekendWeekdays({ locale: t = null, locObj: n = null } = {}) {
    return (n || Mi.create(t)).getWeekendDays().slice();
  }
  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(t = "long", { locale: n = null, numberingSystem: i = null, locObj: r = null, outputCalendar: c = "gregory" } = {}) {
    return (r || Mi.create(n, i, c)).months(t);
  }
  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(t = "long", { locale: n = null, numberingSystem: i = null, locObj: r = null, outputCalendar: c = "gregory" } = {}) {
    return (r || Mi.create(n, i, c)).months(t, !0);
  }
  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(t = "long", { locale: n = null, numberingSystem: i = null, locObj: r = null } = {}) {
    return (r || Mi.create(n, i, null)).weekdays(t);
  }
  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(t = "long", { locale: n = null, numberingSystem: i = null, locObj: r = null } = {}) {
    return (r || Mi.create(n, i, null)).weekdays(t, !0);
  }
  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({ locale: t = null } = {}) {
    return Mi.create(t).meridiems();
  }
  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(t = "short", { locale: n = null } = {}) {
    return Mi.create(n, null, "gregory").eras(t);
  }
  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */
  static features() {
    return { relative: mA(), localeWeek: vA() };
  }
};
function $C(e, t) {
  const n = (r) => r.toUTC(0, { keepLocalTime: !0 }).startOf("day").valueOf(), i = n(t) - n(e);
  return Math.floor(Bs.fromMillis(i).as("days"));
}
function Mz(e, t, n) {
  const i = [
    ["years", (f, g) => g.year - f.year],
    ["quarters", (f, g) => g.quarter - f.quarter + (g.year - f.year) * 4],
    ["months", (f, g) => g.month - f.month + (g.year - f.year) * 12],
    [
      "weeks",
      (f, g) => {
        const x = $C(f, g);
        return (x - x % 7) / 7;
      }
    ],
    ["days", $C]
  ], r = {}, c = e;
  let d, a;
  for (const [f, g] of i)
    n.indexOf(f) >= 0 && (d = f, r[f] = g(e, t), a = c.plus(r), a > t ? (r[f]--, e = c.plus(r), e > t && (a = e, r[f]--, e = c.plus(r))) : e = a);
  return [e, r, a, d];
}
function Dz(e, t, n, i) {
  let [r, c, d, a] = Mz(e, t, n);
  const f = t - r, g = n.filter(
    ($) => ["hours", "minutes", "seconds", "milliseconds"].indexOf($) >= 0
  );
  g.length === 0 && (d < t && (d = r.plus({ [a]: 1 })), d !== r && (c[a] = (c[a] || 0) + f / (d - r)));
  const x = Bs.fromObject(c, i);
  return g.length > 0 ? Bs.fromMillis(f, i).shiftTo(...g).plus(x) : x;
}
const Lz = "missing Intl.DateTimeFormat.formatToParts support";
function Ii(e, t = (n) => n) {
  return { regex: e, deser: ([n]) => t($R(n)) };
}
const Oz = " ", LA = `[ ${Oz}]`, OA = new RegExp(LA, "g");
function Nz(e) {
  return e.replace(/\./g, "\\.?").replace(OA, LA);
}
function CC(e) {
  return e.replace(/\./g, "").replace(OA, " ").toLowerCase();
}
function Ba(e, t) {
  return e === null ? null : {
    regex: RegExp(e.map(Nz).join("|")),
    deser: ([n]) => e.findIndex((i) => CC(n) === CC(i)) + t
  };
}
function kC(e, t) {
  return { regex: e, deser: ([, n, i]) => Jy(n, i), groups: t };
}
function Dv(e) {
  return { regex: e, deser: ([t]) => t };
}
function Fz(e) {
  return e.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function Rz(e, t) {
  const n = za(t), i = za(t, "{2}"), r = za(t, "{3}"), c = za(t, "{4}"), d = za(t, "{6}"), a = za(t, "{1,2}"), f = za(t, "{1,3}"), g = za(t, "{1,6}"), x = za(t, "{1,9}"), $ = za(t, "{2,4}"), A = za(t, "{4,6}"), I = (B) => ({ regex: RegExp(Fz(B.val)), deser: ([H]) => H, literal: !0 }), O = ((B) => {
    if (e.literal)
      return I(B);
    switch (B.val) {
      case "G":
        return Ba(t.eras("short"), 0);
      case "GG":
        return Ba(t.eras("long"), 0);
      case "y":
        return Ii(g);
      case "yy":
        return Ii($, ow);
      case "yyyy":
        return Ii(c);
      case "yyyyy":
        return Ii(A);
      case "yyyyyy":
        return Ii(d);
      case "M":
        return Ii(a);
      case "MM":
        return Ii(i);
      case "MMM":
        return Ba(t.months("short", !0), 1);
      case "MMMM":
        return Ba(t.months("long", !0), 1);
      case "L":
        return Ii(a);
      case "LL":
        return Ii(i);
      case "LLL":
        return Ba(t.months("short", !1), 1);
      case "LLLL":
        return Ba(t.months("long", !1), 1);
      case "d":
        return Ii(a);
      case "dd":
        return Ii(i);
      case "o":
        return Ii(f);
      case "ooo":
        return Ii(r);
      case "HH":
        return Ii(i);
      case "H":
        return Ii(a);
      case "hh":
        return Ii(i);
      case "h":
        return Ii(a);
      case "mm":
        return Ii(i);
      case "m":
        return Ii(a);
      case "q":
        return Ii(a);
      case "qq":
        return Ii(i);
      case "s":
        return Ii(a);
      case "ss":
        return Ii(i);
      case "S":
        return Ii(f);
      case "SSS":
        return Ii(r);
      case "u":
        return Dv(x);
      case "uu":
        return Dv(a);
      case "uuu":
        return Ii(n);
      case "a":
        return Ba(t.meridiems(), 0);
      case "kkkk":
        return Ii(c);
      case "kk":
        return Ii($, ow);
      case "W":
        return Ii(a);
      case "WW":
        return Ii(i);
      case "E":
      case "c":
        return Ii(n);
      case "EEE":
        return Ba(t.weekdays("short", !1), 1);
      case "EEEE":
        return Ba(t.weekdays("long", !1), 1);
      case "ccc":
        return Ba(t.weekdays("short", !0), 1);
      case "cccc":
        return Ba(t.weekdays("long", !0), 1);
      case "Z":
      case "ZZ":
        return kC(new RegExp(`([+-]${a.source})(?::(${i.source}))?`), 2);
      case "ZZZ":
        return kC(new RegExp(`([+-]${a.source})(${i.source})?`), 2);
      case "z":
        return Dv(/[a-z_+-/]{1,256}?/i);
      case " ":
        return Dv(/[^\S\n\r]/);
      default:
        return I(B);
    }
  })(e) || {
    invalidReason: Lz
  };
  return O.token = e, O;
}
const zz = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh"
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function Bz(e, t, n) {
  const { type: i, value: r } = e;
  if (i === "literal") {
    const f = /^\s+$/.test(r);
    return {
      literal: !f,
      val: f ? " " : r
    };
  }
  const c = t[i];
  let d = i;
  i === "hour" && (t.hour12 != null ? d = t.hour12 ? "hour12" : "hour24" : t.hourCycle != null ? t.hourCycle === "h11" || t.hourCycle === "h12" ? d = "hour12" : d = "hour24" : d = n.hour12 ? "hour12" : "hour24");
  let a = zz[d];
  if (typeof a == "object" && (a = a[c]), a)
    return {
      literal: !1,
      val: a
    };
}
function Vz(e) {
  return [`^${e.map((t) => t.regex).reduce((t, n) => `${t}(${n.source})`, "")}$`, e];
}
function Uz(e, t, n) {
  const i = e.match(t);
  if (i) {
    const r = {};
    let c = 1;
    for (const d in n)
      if (vh(n, d)) {
        const a = n[d], f = a.groups ? a.groups + 1 : 1;
        !a.literal && a.token && (r[a.token.val[0]] = a.deser(i.slice(c, c + f))), c += f;
      }
    return [i, r];
  } else
    return [i, {}];
}
function Hz(e) {
  const t = (r) => {
    switch (r) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };
  let n = null, i;
  return Rn(e.z) || (n = Bh.create(e.z)), Rn(e.Z) || (n || (n = new Ll(e.Z)), i = e.Z), Rn(e.q) || (e.M = (e.q - 1) * 3 + 1), Rn(e.h) || (e.h < 12 && e.a === 1 ? e.h += 12 : e.h === 12 && e.a === 0 && (e.h = 0)), e.G === 0 && e.y && (e.y = -e.y), Rn(e.u) || (e.S = C1(e.u)), [Object.keys(e).reduce((r, c) => {
    const d = t(c);
    return d && (r[d] = e[c]), r;
  }, {}), n, i];
}
let Ab = null;
function Wz() {
  return Ab || (Ab = gn.fromMillis(1555555555555)), Ab;
}
function Zz(e, t) {
  if (e.literal)
    return e;
  const n = qa.macroTokenToFormatOpts(e.val), i = zA(n, t);
  return i == null || i.includes(void 0) ? e : i;
}
function NA(e, t) {
  return Array.prototype.concat(...e.map((n) => Zz(n, t)));
}
let FA = class {
  constructor(t, n) {
    if (this.locale = t, this.format = n, this.tokens = NA(qa.parseFormat(n), t), this.units = this.tokens.map((i) => Rz(i, t)), this.disqualifyingUnit = this.units.find((i) => i.invalidReason), !this.disqualifyingUnit) {
      const [i, r] = Vz(this.units);
      this.regex = RegExp(i, "i"), this.handlers = r;
    }
  }
  explainFromTokens(t) {
    if (this.isValid) {
      const [n, i] = Uz(t, this.regex, this.handlers), [r, c, d] = i ? Hz(i) : [null, null, void 0];
      if (vh(i, "a") && vh(i, "H"))
        throw new Yp(
          "Can't include meridiem when specifying 24-hour format"
        );
      return {
        input: t,
        tokens: this.tokens,
        regex: this.regex,
        rawMatches: n,
        matches: i,
        result: r,
        zone: c,
        specificOffset: d
      };
    } else
      return { input: t, tokens: this.tokens, invalidReason: this.invalidReason };
  }
  get isValid() {
    return !this.disqualifyingUnit;
  }
  get invalidReason() {
    return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
  }
};
function RA(e, t, n) {
  return new FA(e, n).explainFromTokens(t);
}
function qz(e, t, n) {
  const { result: i, zone: r, specificOffset: c, invalidReason: d } = RA(e, t, n);
  return [i, r, c, d];
}
function zA(e, t) {
  if (!e)
    return null;
  const n = qa.create(t, e).dtFormatter(Wz()), i = n.formatToParts(), r = n.resolvedOptions();
  return i.map((c) => Bz(c, e, r));
}
const Eb = "Invalid DateTime", jz = 864e13;
function Kf(e) {
  return new ja("unsupported zone", `the zone "${e.name}" is not supported`);
}
function Pb(e) {
  return e.weekData === null && (e.weekData = qg(e.c)), e.weekData;
}
function Mb(e) {
  return e.localWeekData === null && (e.localWeekData = qg(
    e.c,
    e.loc.getMinDaysInFirstWeek(),
    e.loc.getStartOfWeek()
  )), e.localWeekData;
}
function hd(e, t) {
  const n = {
    ts: e.ts,
    zone: e.zone,
    c: e.c,
    o: e.o,
    loc: e.loc,
    invalid: e.invalid
  };
  return new gn({ ...n, ...t, old: n });
}
function BA(e, t, n) {
  let i = e - t * 60 * 1e3;
  const r = n.offset(i);
  if (t === r)
    return [i, t];
  i -= (r - t) * 60 * 1e3;
  const c = n.offset(i);
  return r === c ? [i, r] : [e - Math.min(r, c) * 60 * 1e3, Math.max(r, c)];
}
function Lv(e, t) {
  e += t * 60 * 1e3;
  const n = new Date(e);
  return {
    year: n.getUTCFullYear(),
    month: n.getUTCMonth() + 1,
    day: n.getUTCDate(),
    hour: n.getUTCHours(),
    minute: n.getUTCMinutes(),
    second: n.getUTCSeconds(),
    millisecond: n.getUTCMilliseconds()
  };
}
function dg(e, t, n) {
  return BA(Xy(e), t, n);
}
function SC(e, t) {
  const n = e.o, i = e.c.year + Math.trunc(t.years), r = e.c.month + Math.trunc(t.months) + Math.trunc(t.quarters) * 3, c = {
    ...e.c,
    year: i,
    month: r,
    day: Math.min(e.c.day, jg(i, r)) + Math.trunc(t.days) + Math.trunc(t.weeks) * 7
  }, d = Bs.fromObject({
    years: t.years - Math.trunc(t.years),
    quarters: t.quarters - Math.trunc(t.quarters),
    months: t.months - Math.trunc(t.months),
    weeks: t.weeks - Math.trunc(t.weeks),
    days: t.days - Math.trunc(t.days),
    hours: t.hours,
    minutes: t.minutes,
    seconds: t.seconds,
    milliseconds: t.milliseconds
  }).as("milliseconds"), a = Xy(c);
  let [f, g] = BA(a, n, e.zone);
  return d !== 0 && (f += d, g = e.zone.offset(f)), { ts: f, o: g };
}
function Cp(e, t, n, i, r, c) {
  const { setZone: d, zone: a } = n;
  if (e && Object.keys(e).length !== 0 || t) {
    const f = t || a, g = gn.fromObject(e, {
      ...n,
      zone: f,
      specificOffset: c
    });
    return d ? g : g.setZone(a);
  } else
    return gn.invalid(
      new ja("unparsable", `the input "${r}" can't be parsed as ${i}`)
    );
}
function Ov(e, t, n = !0) {
  return e.isValid ? qa.create(Mi.create("en-US"), {
    allowZ: n,
    forceSimple: !0
  }).formatDateTimeFromString(e, t) : null;
}
function Db(e, t) {
  const n = e.c.year > 9999 || e.c.year < 0;
  let i = "";
  return n && e.c.year >= 0 && (i += "+"), i += zr(e.c.year, n ? 6 : 4), t ? (i += "-", i += zr(e.c.month), i += "-", i += zr(e.c.day)) : (i += zr(e.c.month), i += zr(e.c.day)), i;
}
function TC(e, t, n, i, r, c) {
  let d = zr(e.c.hour);
  return t ? (d += ":", d += zr(e.c.minute), (e.c.millisecond !== 0 || e.c.second !== 0 || !n) && (d += ":")) : d += zr(e.c.minute), (e.c.millisecond !== 0 || e.c.second !== 0 || !n) && (d += zr(e.c.second), (e.c.millisecond !== 0 || !i) && (d += ".", d += zr(e.c.millisecond, 3))), r && (e.isOffsetFixed && e.offset === 0 && !c ? d += "Z" : e.o < 0 ? (d += "-", d += zr(Math.trunc(-e.o / 60)), d += ":", d += zr(Math.trunc(-e.o % 60))) : (d += "+", d += zr(Math.trunc(e.o / 60)), d += ":", d += zr(Math.trunc(e.o % 60)))), c && (d += "[" + e.zone.ianaName + "]"), d;
}
const VA = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, Gz = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, Yz = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, UA = ["year", "month", "day", "hour", "minute", "second", "millisecond"], Kz = [
  "weekYear",
  "weekNumber",
  "weekday",
  "hour",
  "minute",
  "second",
  "millisecond"
], Xz = ["year", "ordinal", "hour", "minute", "second", "millisecond"];
function Jz(e) {
  const t = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[e.toLowerCase()];
  if (!t) throw new VI(e);
  return t;
}
function IC(e) {
  switch (e.toLowerCase()) {
    case "localweekday":
    case "localweekdays":
      return "localWeekday";
    case "localweeknumber":
    case "localweeknumbers":
      return "localWeekNumber";
    case "localweekyear":
    case "localweekyears":
      return "localWeekYear";
    default:
      return Jz(e);
  }
}
function Qz(e) {
  return hg[e] || (pg === void 0 && (pg = br.now()), hg[e] = e.offset(pg)), hg[e];
}
function AC(e, t) {
  const n = wu(t.zone, br.defaultZone);
  if (!n.isValid)
    return gn.invalid(Kf(n));
  const i = Mi.fromObject(t);
  let r, c;
  if (Rn(e.year))
    r = br.now();
  else {
    for (const f of UA)
      Rn(e[f]) && (e[f] = VA[f]);
    const d = hA(e) || fA(e);
    if (d)
      return gn.invalid(d);
    const a = Qz(n);
    [r, c] = dg(e, a, n);
  }
  return new gn({ ts: r, zone: n, loc: i, o: c });
}
function EC(e, t, n) {
  const i = Rn(n.round) ? !0 : n.round, r = (d, a) => (d = k1(d, i || n.calendary ? 0 : 2, !0), t.loc.clone(n).relFormatter(n).format(d, a)), c = (d) => n.calendary ? t.hasSame(e, d) ? 0 : t.startOf(d).diff(e.startOf(d), d).get(d) : t.diff(e, d).get(d);
  if (n.unit)
    return r(c(n.unit), n.unit);
  for (const d of n.units) {
    const a = c(d);
    if (Math.abs(a) >= 1)
      return r(a, d);
  }
  return r(e > t ? -0 : 0, n.units[n.units.length - 1]);
}
function PC(e) {
  let t = {}, n;
  return e.length > 0 && typeof e[e.length - 1] == "object" ? (t = e[e.length - 1], n = Array.from(e).slice(0, e.length - 1)) : n = Array.from(e), [t, n];
}
let pg, hg = {};
class gn {
  /**
   * @access private
   */
  constructor(t) {
    const n = t.zone || br.defaultZone;
    let i = t.invalid || (Number.isNaN(t.ts) ? new ja("invalid input") : null) || (n.isValid ? null : Kf(n));
    this.ts = Rn(t.ts) ? br.now() : t.ts;
    let r = null, c = null;
    if (!i)
      if (t.old && t.old.ts === this.ts && t.old.zone.equals(n))
        [r, c] = [t.old.c, t.old.o];
      else {
        const d = Tu(t.o) && !t.old ? t.o : n.offset(this.ts);
        r = Lv(this.ts, d), i = Number.isNaN(r.year) ? new ja("invalid input") : null, r = i ? null : r, c = i ? null : d;
      }
    this._zone = n, this.loc = t.loc || Mi.create(), this.invalid = i, this.weekData = null, this.localWeekData = null, this.c = r, this.o = c, this.isLuxonDateTime = !0;
  }
  // CONSTRUCT
  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new gn({});
  }
  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [t, n] = PC(arguments), [i, r, c, d, a, f, g] = n;
    return AC({ year: i, month: r, day: c, hour: d, minute: a, second: f, millisecond: g }, t);
  }
  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [t, n] = PC(arguments), [i, r, c, d, a, f, g] = n;
    return t.zone = Ll.utcInstance, AC({ year: i, month: r, day: c, hour: d, minute: a, second: f, millisecond: g }, t);
  }
  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(t, n = {}) {
    const i = IR(t) ? t.valueOf() : NaN;
    if (Number.isNaN(i))
      return gn.invalid("invalid input");
    const r = wu(n.zone, br.defaultZone);
    return r.isValid ? new gn({
      ts: i,
      zone: r,
      loc: Mi.fromObject(n)
    }) : gn.invalid(Kf(r));
  }
  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(t, n = {}) {
    if (Tu(t))
      return t < -864e13 || t > jz ? gn.invalid("Timestamp out of range") : new gn({
        ts: t,
        zone: wu(n.zone, br.defaultZone),
        loc: Mi.fromObject(n)
      });
    throw new Rs(
      `fromMillis requires a numerical input, but received a ${typeof t} with value ${t}`
    );
  }
  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(t, n = {}) {
    if (Tu(t))
      return new gn({
        ts: t * 1e3,
        zone: wu(n.zone, br.defaultZone),
        loc: Mi.fromObject(n)
      });
    throw new Rs("fromSeconds requires a numerical input");
  }
  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */
  static fromObject(t, n = {}) {
    t = t || {};
    const i = wu(n.zone, br.defaultZone);
    if (!i.isValid)
      return gn.invalid(Kf(i));
    const r = Mi.fromObject(n), c = Gg(t, IC), { minDaysInFirstWeek: d, startOfWeek: a } = vC(c, r), f = br.now(), g = Rn(n.specificOffset) ? i.offset(f) : n.specificOffset, x = !Rn(c.ordinal), $ = !Rn(c.year), A = !Rn(c.month) || !Rn(c.day), I = $ || A, O = c.weekYear || c.weekNumber;
    if ((I || x) && O)
      throw new Yp(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (A && x)
      throw new Yp("Can't mix ordinal dates with month/day");
    const B = O || c.weekday && !I;
    let H, N, K = Lv(f, g);
    B ? (H = Kz, N = Gz, K = qg(K, d, a)) : x ? (H = Xz, N = Yz, K = Ib(K)) : (H = UA, N = VA);
    let U = !1;
    for (const me of H) {
      const ve = c[me];
      Rn(ve) ? U ? c[me] = N[me] : c[me] = K[me] : U = !0;
    }
    const q = B ? kR(c, d, a) : x ? SR(c) : hA(c), ee = q || fA(c);
    if (ee)
      return gn.invalid(ee);
    const te = B ? fC(c, d, a) : x ? mC(c) : c, [ae, oe] = dg(te, g, i), de = new gn({
      ts: ae,
      zone: i,
      o: oe,
      loc: r
    });
    return c.weekday && I && t.weekday !== de.weekday ? gn.invalid(
      "mismatched weekday",
      `you can't specify both a weekday of ${c.weekday} and a date of ${de.toISO()}`
    ) : de.isValid ? de : gn.invalid(de.invalid);
  }
  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(t, n = {}) {
    const [i, r] = gz(t);
    return Cp(i, r, n, "ISO 8601", t);
  }
  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(t, n = {}) {
    const [i, r] = yz(t);
    return Cp(i, r, n, "RFC 2822", t);
  }
  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(t, n = {}) {
    const [i, r] = _z(t);
    return Cp(i, r, n, "HTTP", n);
  }
  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(t, n, i = {}) {
    if (Rn(t) || Rn(n))
      throw new Rs("fromFormat requires an input string and a format");
    const { locale: r = null, numberingSystem: c = null } = i, d = Mi.fromOpts({
      locale: r,
      numberingSystem: c,
      defaultToEN: !0
    }), [a, f, g, x] = qz(d, t, n);
    return x ? gn.invalid(x) : Cp(a, f, i, `format ${n}`, t, g);
  }
  /**
   * @deprecated use fromFormat instead
   */
  static fromString(t, n, i = {}) {
    return gn.fromFormat(t, n, i);
  }
  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(t, n = {}) {
    const [i, r] = Sz(t);
    return Cp(i, r, n, "SQL", t);
  }
  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(t, n = null) {
    if (!t)
      throw new Rs("need to specify a reason the DateTime is invalid");
    const i = t instanceof ja ? t : new ja(t, n);
    if (br.throwOnInvalid)
      throw new JF(i);
    return new gn({ invalid: i });
  }
  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(t) {
    return t && t.isLuxonDateTime || !1;
  }
  /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */
  static parseFormatForOpts(t, n = {}) {
    const i = zA(t, Mi.fromObject(n));
    return i ? i.map((r) => r ? r.val : null).join("") : null;
  }
  /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */
  static expandFormat(t, n = {}) {
    return NA(qa.parseFormat(t), Mi.fromObject(n)).map((i) => i.val).join("");
  }
  static resetCache() {
    pg = void 0, hg = {};
  }
  // INFO
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(t) {
    return this[t];
  }
  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }
  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? Pb(this).weekYear : NaN;
  }
  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? Pb(this).weekNumber : NaN;
  }
  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? Pb(this).weekday : NaN;
  }
  /**
   * Returns true if this date is on a weekend according to the locale, false otherwise
   * @returns {boolean}
   */
  get isWeekend() {
    return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
  }
  /**
   * Get the day of the week according to the locale.
   * 1 is the first day of the week and 7 is the last day of the week.
   * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
   * @returns {number}
   */
  get localWeekday() {
    return this.isValid ? Mb(this).weekday : NaN;
  }
  /**
   * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
   * because the week can start on different days of the week (see localWeekday) and because a different number of days
   * is required for a week to count as the first week of a year.
   * @returns {number}
   */
  get localWeekNumber() {
    return this.isValid ? Mb(this).weekNumber : NaN;
  }
  /**
   * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
   * differently, see localWeekNumber.
   * @returns {number}
   */
  get localWeekYear() {
    return this.isValid ? Mb(this).weekYear : NaN;
  }
  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? Ib(this.c).ordinal : NaN;
  }
  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? Mv.months("short", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? Mv.months("long", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? Mv.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? Mv.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "short",
      locale: this.locale
    }) : null;
  }
  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "long",
      locale: this.locale
    }) : null;
  }
  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    return this.isOffsetFixed ? !1 : this.offset > this.set({ month: 1, day: 1 }).offset || this.offset > this.set({ month: 5 }).offset;
  }
  /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */
  getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed)
      return [this];
    const t = 864e5, n = 6e4, i = Xy(this.c), r = this.zone.offset(i - t), c = this.zone.offset(i + t), d = this.zone.offset(i - r * n), a = this.zone.offset(i - c * n);
    if (d === a)
      return [this];
    const f = i - d * n, g = i - a * n, x = Lv(f, d), $ = Lv(g, a);
    return x.hour === $.hour && x.minute === $.minute && x.second === $.second && x.millisecond === $.millisecond ? [hd(this, { ts: f }), hd(this, { ts: g })] : [this];
  }
  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return zm(this.year);
  }
  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return jg(this.year, this.month);
  }
  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? ih(this.year) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? _m(this.weekYear) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's local week year
   * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
   * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
   * @type {number}
   */
  get weeksInLocalWeekYear() {
    return this.isValid ? _m(
      this.localWeekYear,
      this.loc.getMinDaysInFirstWeek(),
      this.loc.getStartOfWeek()
    ) : NaN;
  }
  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(t = {}) {
    const { locale: n, numberingSystem: i, calendar: r } = qa.create(
      this.loc.clone(t),
      t
    ).resolvedOptions(this);
    return { locale: n, numberingSystem: i, outputCalendar: r };
  }
  // TRANSFORM
  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(t = 0, n = {}) {
    return this.setZone(Ll.instance(t), n);
  }
  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(br.defaultZone);
  }
  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(t, { keepLocalTime: n = !1, keepCalendarTime: i = !1 } = {}) {
    if (t = wu(t, br.defaultZone), t.equals(this.zone))
      return this;
    if (t.isValid) {
      let r = this.ts;
      if (n || i) {
        const c = t.offset(this.ts), d = this.toObject();
        [r] = dg(d, c, t);
      }
      return hd(this, { ts: r, zone: t });
    } else
      return gn.invalid(Kf(t));
  }
  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale: t, numberingSystem: n, outputCalendar: i } = {}) {
    const r = this.loc.clone({ locale: t, numberingSystem: n, outputCalendar: i });
    return hd(this, { loc: r });
  }
  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(t) {
    return this.reconfigure({ locale: t });
  }
  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(t) {
    if (!this.isValid) return this;
    const n = Gg(t, IC), { minDaysInFirstWeek: i, startOfWeek: r } = vC(n, this.loc), c = !Rn(n.weekYear) || !Rn(n.weekNumber) || !Rn(n.weekday), d = !Rn(n.ordinal), a = !Rn(n.year), f = !Rn(n.month) || !Rn(n.day), g = a || f, x = n.weekYear || n.weekNumber;
    if ((g || d) && x)
      throw new Yp(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (f && d)
      throw new Yp("Can't mix ordinal dates with month/day");
    let $;
    c ? $ = fC(
      { ...qg(this.c, i, r), ...n },
      i,
      r
    ) : Rn(n.ordinal) ? ($ = { ...this.toObject(), ...n }, Rn(n.day) && ($.day = Math.min(jg($.year, $.month), $.day))) : $ = mC({ ...Ib(this.c), ...n });
    const [A, I] = dg($, this.o, this.zone);
    return hd(this, { ts: A, o: I });
  }
  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(t) {
    if (!this.isValid) return this;
    const n = Bs.fromDurationLike(t);
    return hd(this, SC(this, n));
  }
  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(t) {
    if (!this.isValid) return this;
    const n = Bs.fromDurationLike(t).negate();
    return hd(this, SC(this, n));
  }
  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(t, { useLocaleWeeks: n = !1 } = {}) {
    if (!this.isValid) return this;
    const i = {}, r = Bs.normalizeUnit(t);
    switch (r) {
      case "years":
        i.month = 1;
      case "quarters":
      case "months":
        i.day = 1;
      case "weeks":
      case "days":
        i.hour = 0;
      case "hours":
        i.minute = 0;
      case "minutes":
        i.second = 0;
      case "seconds":
        i.millisecond = 0;
        break;
    }
    if (r === "weeks")
      if (n) {
        const c = this.loc.getStartOfWeek(), { weekday: d } = this;
        d < c && (i.weekNumber = this.weekNumber - 1), i.weekday = c;
      } else
        i.weekday = 1;
    if (r === "quarters") {
      const c = Math.ceil(this.month / 3);
      i.month = (c - 1) * 3 + 1;
    }
    return this.set(i);
  }
  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(t, n) {
    return this.isValid ? this.plus({ [t]: 1 }).startOf(t, n).minus(1) : this;
  }
  // OUTPUT
  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(t, n = {}) {
    return this.isValid ? qa.create(this.loc.redefaultToEN(n)).formatDateTimeFromString(this, t) : Eb;
  }
  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(t = Zg, n = {}) {
    return this.isValid ? qa.create(this.loc.clone(n), t).formatDateTime(this) : Eb;
  }
  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(t = {}) {
    return this.isValid ? qa.create(this.loc.clone(t), t).formatDateTimeParts(this) : [];
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */
  toISO({
    format: t = "extended",
    suppressSeconds: n = !1,
    suppressMilliseconds: i = !1,
    includeOffset: r = !0,
    extendedZone: c = !1
  } = {}) {
    if (!this.isValid)
      return null;
    const d = t === "extended";
    let a = Db(this, d);
    return a += "T", a += TC(this, d, n, i, r, c), a;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */
  toISODate({ format: t = "extended" } = {}) {
    return this.isValid ? Db(this, t === "extended") : null;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return Ov(this, "kkkk-'W'WW-c");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds: t = !1,
    suppressSeconds: n = !1,
    includeOffset: i = !0,
    includePrefix: r = !1,
    extendedZone: c = !1,
    format: d = "extended"
  } = {}) {
    return this.isValid ? (r ? "T" : "") + TC(
      this,
      d === "extended",
      n,
      t,
      i,
      c
    ) : null;
  }
  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return Ov(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", !1);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return Ov(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */
  toSQLDate() {
    return this.isValid ? Db(this, !0) : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset: t = !0, includeZone: n = !1, includeOffsetSpace: i = !0 } = {}) {
    let r = "HH:mm:ss.SSS";
    return (n || t) && (i && (r += " "), n ? r += "z" : t && (r += "ZZ")), Ov(this, r, !0);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(t = {}) {
    return this.isValid ? `${this.toSQLDate()} ${this.toSQLTime(t)}` : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : Eb;
  }
  /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }` : `DateTime { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }
  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }
  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(t = {}) {
    if (!this.isValid) return {};
    const n = { ...this.c };
    return t.includeConfig && (n.outputCalendar = this.outputCalendar, n.numberingSystem = this.loc.numberingSystem, n.locale = this.loc.locale), n;
  }
  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  // COMPARE
  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(t, n = "milliseconds", i = {}) {
    if (!this.isValid || !t.isValid)
      return Bs.invalid("created by diffing an invalid DateTime");
    const r = { locale: this.locale, numberingSystem: this.numberingSystem, ...i }, c = AR(n).map(Bs.normalizeUnit), d = t.valueOf() > this.valueOf(), a = d ? this : t, f = d ? t : this, g = Dz(a, f, c, r);
    return d ? g.negate() : g;
  }
  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(t = "milliseconds", n = {}) {
    return this.diff(gn.now(), t, n);
  }
  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */
  until(t) {
    return this.isValid ? yr.fromDateTimes(this, t) : this;
  }
  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(t, n, i) {
    if (!this.isValid) return !1;
    const r = t.valueOf(), c = this.setZone(t.zone, { keepLocalTime: !0 });
    return c.startOf(n, i) <= r && r <= c.endOf(n, i);
  }
  /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(t) {
    return this.isValid && t.isValid && this.valueOf() === t.valueOf() && this.zone.equals(t.zone) && this.loc.equals(t.loc);
  }
  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(t = {}) {
    if (!this.isValid) return null;
    const n = t.base || gn.fromObject({}, { zone: this.zone }), i = t.padding ? this < n ? -t.padding : t.padding : 0;
    let r = ["years", "months", "days", "hours", "minutes", "seconds"], c = t.unit;
    return Array.isArray(t.unit) && (r = t.unit, c = void 0), EC(n, this.plus(i), {
      ...t,
      numeric: "always",
      units: r,
      unit: c
    });
  }
  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(t = {}) {
    return this.isValid ? EC(t.base || gn.fromObject({}, { zone: this.zone }), this, {
      ...t,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: !0
    }) : null;
  }
  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...t) {
    if (!t.every(gn.isDateTime))
      throw new Rs("min requires all arguments be DateTimes");
    return gC(t, (n) => n.valueOf(), Math.min);
  }
  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...t) {
    if (!t.every(gn.isDateTime))
      throw new Rs("max requires all arguments be DateTimes");
    return gC(t, (n) => n.valueOf(), Math.max);
  }
  // MISC
  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(t, n, i = {}) {
    const { locale: r = null, numberingSystem: c = null } = i, d = Mi.fromOpts({
      locale: r,
      numberingSystem: c,
      defaultToEN: !0
    });
    return RA(d, t, n);
  }
  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(t, n, i = {}) {
    return gn.fromFormatExplain(t, n, i);
  }
  /**
   * Build a parser for `fmt` using the given locale. This parser can be passed
   * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
   * can be used to optimize cases where many dates need to be parsed in a
   * specific format.
   *
   * @param {String} fmt - the format the string is expected to be in (see
   * description)
   * @param {Object} options - options used to set locale and numberingSystem
   * for parser
   * @returns {TokenParser} - opaque object to be used
   */
  static buildFormatParser(t, n = {}) {
    const { locale: i = null, numberingSystem: r = null } = n, c = Mi.fromOpts({
      locale: i,
      numberingSystem: r,
      defaultToEN: !0
    });
    return new FA(c, t);
  }
  /**
   * Create a DateTime from an input string and format parser.
   *
   * The format parser must have been created with the same locale as this call.
   *
   * @param {String} text - the string to parse
   * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
   * @param {Object} opts - options taken by fromFormat()
   * @returns {DateTime}
   */
  static fromFormatParser(t, n, i = {}) {
    if (Rn(t) || Rn(n))
      throw new Rs(
        "fromFormatParser requires an input string and a format parser"
      );
    const { locale: r = null, numberingSystem: c = null } = i, d = Mi.fromOpts({
      locale: r,
      numberingSystem: c,
      defaultToEN: !0
    });
    if (!d.equals(n.locale))
      throw new Rs(
        `fromFormatParser called with a locale of ${d}, but the format parser was created for ${n.locale}`
      );
    const { result: a, zone: f, specificOffset: g, invalidReason: x } = n.explainFromTokens(t);
    return x ? gn.invalid(x) : Cp(
      a,
      f,
      i,
      `format ${n.format}`,
      t,
      g
    );
  }
  // FORMAT PRESETS
  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return Zg;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return UI;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return tR;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return HI;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return WI;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return ZI;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return qI;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return jI;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return GI;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return YI;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return KI;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return XI;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return JI;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return QI;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return eA;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return tA;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return nA;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return nR;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return iA;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return rA;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return sA;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return oA;
  }
}
function Pf(e) {
  if (gn.isDateTime(e))
    return e;
  if (e && e.valueOf && Tu(e.valueOf()))
    return gn.fromJSDate(e);
  if (e && typeof e == "object")
    return gn.fromObject(e);
  throw new Rs(
    `Unknown datetime argument: ${e}, of type ${typeof e}`
  );
}
const eB = Object.prototype.toString;
function tB(e, t) {
  return eB.call(e) === `[object ${t}]`;
}
function nB(e) {
  return tB(e, "Object");
}
function iB(e) {
  return !!(e && e.then && typeof e.then == "function");
}
const nm = "8.38.0", Lc = globalThis;
function A1(e, t, n) {
  const i = Lc, r = i.__SENTRY__ = i.__SENTRY__ || {}, c = r[nm] = r[nm] || {};
  return c[e] || (c[e] = t());
}
const HA = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, rB = "Sentry Logger ", MC = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], DC = {};
function sB(e) {
  if (!("console" in Lc))
    return e();
  const t = Lc.console, n = {}, i = Object.keys(DC);
  i.forEach((r) => {
    const c = DC[r];
    n[r] = t[r], t[r] = c;
  });
  try {
    return e();
  } finally {
    i.forEach((r) => {
      t[r] = n[r];
    });
  }
}
function oB() {
  let e = !1;
  const t = {
    enable: () => {
      e = !0;
    },
    disable: () => {
      e = !1;
    },
    isEnabled: () => e
  };
  return HA ? MC.forEach((n) => {
    t[n] = (...i) => {
      e && sB(() => {
        Lc.console[n](`${rB}[${n}]:`, ...i);
      });
    };
  }) : MC.forEach((n) => {
    t[n] = () => {
    };
  }), t;
}
const fg = A1("logger", oB);
function aB(e, t, n) {
  try {
    Object.defineProperty(e, t, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: n,
      writable: !0,
      configurable: !0
    });
  } catch {
    HA && fg.log(`Failed to add non-enumerable property "${t}" to object`, e);
  }
}
const WA = 1e3;
function ZA() {
  return Date.now() / WA;
}
function lB() {
  const { performance: e } = Lc;
  if (!e || !e.now)
    return ZA;
  const t = Date.now() - e.now(), n = e.timeOrigin == null ? t : e.timeOrigin;
  return () => (n + e.now()) / WA;
}
const cB = lB();
(() => {
  const { performance: e } = Lc;
  if (!e || !e.now)
    return;
  const t = 3600 * 1e3, n = e.now(), i = Date.now(), r = e.timeOrigin ? Math.abs(e.timeOrigin + n - i) : t, c = r < t, d = e.timing && e.timing.navigationStart, a = typeof d == "number" ? Math.abs(d + n - i) : t, f = a < t;
  return c || f ? r <= a ? e.timeOrigin : d : i;
})();
function sh() {
  const e = Lc, t = e.crypto || e.msCrypto;
  let n = () => Math.random() * 16;
  try {
    if (t && t.randomUUID)
      return t.randomUUID().replace(/-/g, "");
    t && t.getRandomValues && (n = () => {
      const i = new Uint8Array(1);
      return t.getRandomValues(i), i[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (i) => (
      // eslint-disable-next-line no-bitwise
      (i ^ (n() & 15) >> i / 4).toString(16)
    )
  );
}
function LC() {
  return {
    traceId: sh(),
    spanId: sh().substring(16)
  };
}
function qA() {
  return E1(Lc), Lc;
}
function E1(e) {
  const t = e.__SENTRY__ = e.__SENTRY__ || {};
  return t.version = t.version || nm, t[nm] = t[nm] || {};
}
function uB(e, t = {}) {
  if (t.user && (!e.ipAddress && t.user.ip_address && (e.ipAddress = t.user.ip_address), !e.did && !t.did && (e.did = t.user.id || t.user.email || t.user.username)), e.timestamp = t.timestamp || cB(), t.abnormal_mechanism && (e.abnormal_mechanism = t.abnormal_mechanism), t.ignoreDuration && (e.ignoreDuration = t.ignoreDuration), t.sid && (e.sid = t.sid.length === 32 ? t.sid : sh()), t.init !== void 0 && (e.init = t.init), !e.did && t.did && (e.did = `${t.did}`), typeof t.started == "number" && (e.started = t.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof t.duration == "number")
    e.duration = t.duration;
  else {
    const n = e.timestamp - e.started;
    e.duration = n >= 0 ? n : 0;
  }
  t.release && (e.release = t.release), t.environment && (e.environment = t.environment), !e.ipAddress && t.ipAddress && (e.ipAddress = t.ipAddress), !e.userAgent && t.userAgent && (e.userAgent = t.userAgent), typeof t.errors == "number" && (e.errors = t.errors), t.status && (e.status = t.status);
}
const aw = "_sentrySpan";
function OC(e, t) {
  t ? aB(e, aw, t) : delete e[aw];
}
function NC(e) {
  return e[aw];
}
const dB = 100;
class P1 {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = LC();
  }
  /**
   * @inheritDoc
   */
  clone() {
    const t = new P1();
    return t._breadcrumbs = [...this._breadcrumbs], t._tags = { ...this._tags }, t._extra = { ...this._extra }, t._contexts = { ...this._contexts }, t._user = this._user, t._level = this._level, t._session = this._session, t._transactionName = this._transactionName, t._fingerprint = this._fingerprint, t._eventProcessors = [...this._eventProcessors], t._requestSession = this._requestSession, t._attachments = [...this._attachments], t._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, t._propagationContext = { ...this._propagationContext }, t._client = this._client, t._lastEventId = this._lastEventId, OC(t, NC(this)), t;
  }
  /**
   * @inheritDoc
   */
  setClient(t) {
    this._client = t;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(t) {
    this._lastEventId = t;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(t) {
    this._scopeListeners.push(t);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(t) {
    return this._eventProcessors.push(t), this;
  }
  /**
   * @inheritDoc
   */
  setUser(t) {
    return this._user = t || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && uB(this._session, { user: t }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(t) {
    return this._requestSession = t, this;
  }
  /**
   * @inheritDoc
   */
  setTags(t) {
    return this._tags = {
      ...this._tags,
      ...t
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(t, n) {
    return this._tags = { ...this._tags, [t]: n }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(t) {
    return this._extra = {
      ...this._extra,
      ...t
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(t, n) {
    return this._extra = { ...this._extra, [t]: n }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(t) {
    return this._fingerprint = t, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(t) {
    return this._level = t, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(t) {
    return this._transactionName = t, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(t, n) {
    return n === null ? delete this._contexts[t] : this._contexts[t] = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSession(t) {
    return t ? this._session = t : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(t) {
    if (!t)
      return this;
    const n = typeof t == "function" ? t(this) : t, [i, r] = n instanceof bm ? [n.getScopeData(), n.getRequestSession()] : nB(n) ? [t, t.requestSession] : [], { tags: c, extra: d, user: a, contexts: f, level: g, fingerprint: x = [], propagationContext: $ } = i || {};
    return this._tags = { ...this._tags, ...c }, this._extra = { ...this._extra, ...d }, this._contexts = { ...this._contexts, ...f }, a && Object.keys(a).length && (this._user = a), g && (this._level = g), x.length && (this._fingerprint = x), $ && (this._propagationContext = $), r && (this._requestSession = r), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, OC(this, void 0), this._attachments = [], this._propagationContext = LC(), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(t, n) {
    const i = typeof n == "number" ? n : dB;
    if (i <= 0)
      return this;
    const r = {
      timestamp: ZA(),
      ...t
    }, c = this._breadcrumbs;
    return c.push(r), this._breadcrumbs = c.length > i ? c.slice(-i) : c, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(t) {
    return this._attachments.push(t), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: NC(this)
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(t) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...t }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(t) {
    return this._propagationContext = t, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(t, n) {
    const i = n && n.event_id ? n.event_id : sh();
    if (!this._client)
      return fg.warn("No client configured on scope - will not capture exception!"), i;
    const r = new Error("Sentry syntheticException");
    return this._client.captureException(
      t,
      {
        originalException: t,
        syntheticException: r,
        ...n,
        event_id: i
      },
      this
    ), i;
  }
  /**
   * @inheritDoc
   */
  captureMessage(t, n, i) {
    const r = i && i.event_id ? i.event_id : sh();
    if (!this._client)
      return fg.warn("No client configured on scope - will not capture message!"), r;
    const c = new Error(t);
    return this._client.captureMessage(
      t,
      n,
      {
        originalException: t,
        syntheticException: c,
        ...i,
        event_id: r
      },
      this
    ), r;
  }
  /**
   * @inheritDoc
   */
  captureEvent(t, n) {
    const i = n && n.event_id ? n.event_id : sh();
    return this._client ? (this._client.captureEvent(t, { ...n, event_id: i }, this), i) : (fg.warn("No client configured on scope - will not capture event!"), i);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((t) => {
      t(this);
    }), this._notifyingListeners = !1);
  }
}
const bm = P1;
function pB() {
  return A1("defaultCurrentScope", () => new bm());
}
function hB() {
  return A1("defaultIsolationScope", () => new bm());
}
class fB {
  constructor(t, n) {
    let i;
    t ? i = t : i = new bm();
    let r;
    n ? r = n : r = new bm(), this._stack = [{ scope: i }], this._isolationScope = r;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(t) {
    const n = this._pushScope();
    let i;
    try {
      i = t(n);
    } catch (r) {
      throw this._popScope(), r;
    }
    return iB(i) ? i.then(
      (r) => (this._popScope(), r),
      (r) => {
        throw this._popScope(), r;
      }
    ) : (this._popScope(), i);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const t = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: t
    }), t;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function gh() {
  const e = qA(), t = E1(e);
  return t.stack = t.stack || new fB(pB(), hB());
}
function mB(e) {
  return gh().withScope(e);
}
function vB(e, t) {
  const n = gh();
  return n.withScope(() => (n.getStackTop().scope = e, t(e)));
}
function FC(e) {
  return gh().withScope(() => e(gh().getIsolationScope()));
}
function gB() {
  return {
    withIsolationScope: FC,
    withScope: mB,
    withSetScope: vB,
    withSetIsolationScope: (e, t) => FC(t),
    getCurrentScope: () => gh().getScope(),
    getIsolationScope: () => gh().getIsolationScope()
  };
}
function yB(e) {
  const t = E1(e);
  return t.acs ? t.acs : gB();
}
function _B() {
  const e = qA();
  return yB(e).getCurrentScope();
}
function bB(e, t) {
  return _B().captureException(e, void 0);
}
function wB(e, t) {
  const n = {
    event: "errorDL",
    errorType: e.name,
    errorDetails: e.message,
    errorURL: document.URL,
    errorPreviousURL: xB()
  };
  window.dataLayer.push(n);
}
function xB(e) {
  return document.referrer ? document.referrer : "";
}
let Yg = class extends Error {
  constructor(t) {
    super("MicroServiceError"), Av(this, "title"), Av(this, "status"), Av(this, "detail"), Av(this, "errorDetail");
    const { title: n, status: i, detail: r, errorDetail: c } = t;
    this.name = this.constructor.name, this.title = n, this.status = i, this.detail = r, this.errorDetail = c, this.message = `title:${n},status:${i},detail:${r},errorDetail:${c}`;
  }
};
function M1(e) {
  return e instanceof Error ? e : Error(`Unexpected non-Error value: ${JSON.stringify(e)}`);
}
function Kg(e) {
  if (e) {
    const { title: t, status: n, detail: i, errorDetail: r } = e;
    if (t || n || i || r)
      return new Yg(e);
  }
  return M1(e);
}
function Md(e, t = !1, n = []) {
  wB(e), t ? $B(e, n) && bB(e) : console.error(e);
}
function zc(e, t = !1) {
  return Md(M1(e), t);
}
function $B(e, t = []) {
  return !(e instanceof Yg && CB(e, t));
}
function CB(e, t = []) {
  return e.errorDetail ? t.indexOf(e.errorDetail) !== -1 : !1;
}
const kB = 24 * 60 * 60 * 1e3;
function SB(e, t = "dd/MM/yyyy") {
  try {
    return Math.round(
      gn.fromFormat(e, t).diff(
        gn.now(),
        "days"
      ).days
    );
  } catch (n) {
    return zc(n), "";
  }
}
function TB(e, t, n) {
  try {
    return gn.fromFormat(e, t).toFormat(n);
  } catch (i) {
    zc(i);
  }
  return "";
}
function Wa(e) {
  return jA(e, "yyyyMMdd", !1);
}
function Xg(e, t) {
  return jA(e, t, !0);
}
function jA(e, t, n) {
  e = e.replace(/[/-]/g, "");
  try {
    const i = gn.fromFormat(
      e,
      t,
      n ? { zone: "utc" } : {}
    );
    if (i.isValid)
      return i.toJSDate();
  } catch (i) {
    zc(i);
  }
}
function IB(e, t) {
  return gn.fromJSDate(e).plus({ days: t }).toJSDate();
}
function im(e) {
  return gn.fromJSDate(e).toFormat("yyyyMMdd");
}
function Jg(e, t) {
  const n = e && t ? Math.abs(e.getTime() - t.getTime()) : -1;
  return n > -1 ? Math.ceil(n / kB) : -1;
}
function GA(e) {
  e = e.replace(/[/-]/g, "");
  try {
    const t = gn.fromFormat(e, "ddMMyyyy");
    if (t.isValid)
      return t.toFormat("yyyyMMdd");
  } catch (t) {
    zc(t);
  }
}
const D1 = (e) => YA(e, "yyyyMMdd", "dd-MM-yyyy"), AB = (e) => YA(e, "yyyyMMdd", "MM/dd/yyyy"), YA = (e, t, n) => {
  if (e) {
    e = e.replace(/[/-]/g, "");
    try {
      const i = gn.fromFormat(e, t);
      if (i.isValid)
        return i.toFormat(n);
    } catch (i) {
      zc(i);
    }
  }
  return "";
}, Kp = (e, t) => {
  try {
    return gn.fromFormat(e + t, "yyyyMMddhhmm").toJSDate();
  } catch (n) {
    zc(n);
  }
  return "";
}, RC = (e, t) => {
  if (e == "fr")
    return t.toLowerCase();
  {
    const [n, i] = t.split("H");
    return gn.fromFormat(`${n}:${i}`, "H:m").toFormat("h:mm a");
  }
}, EB = (e, t) => gn.fromFormat(t, "yyyy-MM-dd").setLocale(e).toLocaleString({ weekday: "short", month: "short", day: "2-digit" });
function PB(e) {
  const t = D1(e);
  return KA(t);
}
function MB(e, t) {
  const n = Wa(e);
  if (n) {
    const i = IB(n, t ?? 0), r = D1(im(i));
    return KA(r);
  }
  return "";
}
function KA(e) {
  return e && e.replace(/-/g, "/");
}
function DB(e, t) {
  const n = gn.fromJSDate(e), i = gn.fromJSDate(t);
  return Math.floor(i.diff(n, ["years"]).years);
}
function LB(e, t) {
  var n, i, r, c, d;
  if (!e)
    return null;
  if ("itineraries" in e) {
    const a = (r = (i = (n = e.itineraries) == null ? void 0 : n[t]) == null ? void 0 : i.segments) == null ? void 0 : r.filter((x) => x.bound === "O"), f = ((c = a == null ? void 0 : a[0]) == null ? void 0 : c.departureDate) ?? "", g = gn.fromFormat(f, "yyyyMMdd");
    return g.isValid ? g.toJSDate() : null;
  } else if (e.quote && "hotel" in e.quote) {
    const a = ((d = e.quote) == null ? void 0 : d.hotel.information.checkIn) ?? "", f = gn.fromFormat(a, "yyyyMMdd");
    return f.isValid ? f.toJSDate() : null;
  }
  return null;
}
async function L1(e, t = {}) {
  const { timeout: n = t.timeout ?? 6e4, ...i } = t, r = new AbortController();
  return i.signal = r.signal, setTimeout(() => r.abort(), n), fetch(e, i);
}
function OB(e, t, n) {
  const i = {
    event: "paymentFormAbandonment",
    payFormPaymMethod: e,
    paymMeans1Fields: t,
    paymMeans2Fields: n
  };
  window.dataLayer.push(i);
}
const lw = [];
function XA(e) {
  const t = e.target;
  if (t != null && t.tagName && (t.tagName.toUpperCase() == "INPUT" || t.tagName.toUpperCase() == "SELECT")) {
    const n = ZF(t);
    NB(n);
  }
}
function JA() {
  OB(
    "Credit Card",
    lw.join(" > "),
    null
  );
}
function NB(e) {
  lw.includes(e) || lw.push(e);
}
function FB() {
  document.addEventListener("change", XA), window.addEventListener(
    "beforeunload",
    JA
  );
}
function RB() {
  document.removeEventListener("change", XA), window.removeEventListener(
    "beforeunload",
    JA
  );
}
function Wn(e, t, n) {
  return QA(e, t, !!n, "currency");
}
function O1(e, t) {
  return QA(e, t, !1, "decimal");
}
function QA(e, t, n, i) {
  try {
    const r = n ? 0 : 2;
    return t(Number(e), i, {
      minimumFractionDigits: r,
      maximumFractionDigits: r
    }).replace("CA", "");
  } catch {
    return "";
  }
}
const N1 = /* @__PURE__ */ new Map([
  ["mealPlans", "Meal Plan"],
  ["activities", "Activities"],
  ["privateTransfer", "Private Transfer"],
  ["travelProtections", "Travel Protection"]
]), Qg = {
  tablet: 768
}, eE = {
  en: {
    short: {
      year: "numeric",
      month: "short",
      day: "numeric"
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "short",
      hour: "numeric",
      minute: "numeric",
      hour12: !0
    },
    time: {
      hour: "numeric",
      minute: "numeric",
      hour12: !0
    },
    medium: {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long"
    }
  },
  fr: {
    short: {
      year: "numeric",
      month: "short",
      day: "numeric"
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "short",
      hour: "numeric",
      minute: "numeric",
      hour12: !0
    },
    time: {
      hour: "numeric",
      minute: "numeric",
      hour12: !1
    },
    medium: {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long"
    }
  }
};
var cw = /* @__PURE__ */ ((e) => (e.NOT_DEFINED = "not-defined", e.AUTH = "FWK.gZbHYSnFdC", e.CACHE_PARSE = "FWK.Q6fIgymToy", e.RESOURCE_NOT_FOUND = "FWK.tP6OWnrk3f", e.WEB_CLIENT = "FWK.Iq9P7cNBd3", e.CONCURRENCY = "FWK.Tr45gRE541", e.FORBIDDEN_GROUP = "FWK.QU4Yhpu6UX", e.USER_CHANGE = "FWK.aL6GGPIDIt", e.INIT_TASK_ERROR = "init-task-error", e.LOCAL_CACHE_ERROR = "local-cache-error", e.INCORRECT_SEARCH = "INCORRECT_SEARCH", e.INVALID_PROMO_CODE = "INVALID_PROMO_CODE", e.FLIGHT_ERROR = "FLIGHT_ERROR", e))(cw || {});
const zB = "ERROR_3DS", BB = /* @__PURE__ */ new Set(["TQO", "1375", "8743"]), Bp = {
  INCORRECT_SEARCH: "INCORRECT_SEARCH",
  INVALID_NUM_ROOM_CHILD: "INVALID_NUM_ROOM_CHILD",
  INVALID_OCCUPANCY: "INVALID_OCCUPANCY",
  GENERAL_SAX_ERROR: "GENERAL_SAX_ERROR",
  ADULTS_REPARTITION_ERROR: "ADULTS_REPARTITION_ERROR"
}, VB = [
  "AB",
  "BC",
  "MB",
  "NB",
  "NL",
  "NT",
  "NS",
  "NU",
  "ON",
  "PE",
  "QC",
  "SK",
  "YT"
], UB = [
  "AL",
  "AK",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "DC",
  "FL",
  "GA",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY"
], HB = ["CA", "US"], F1 = "4", R1 = "5", z1 = "34", B1 = "37", Za = "ccErrorText", $d = "cvvErrorMessage", Sc = "ccframe1", Ml = "ccframe2";
var yh = /* @__PURE__ */ ((e) => (e.en = "en", e.fr = "fr", e))(yh || {}), uw = /* @__PURE__ */ ((e) => (e.enCA = "en-CA", e.frCA = "fr-CA", e))(uw || {});
const tE = {
  currency: {
    style: "currency",
    currency: "CAD",
    notation: "standard",
    // "standard", "scientific", "engineering", "compact"
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  },
  decimal: {
    style: "decimal",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  },
  percent: {
    style: "percent",
    useGrouping: !1
  },
  short: {
    style: "decimal",
    notation: "compact",
    compactDisplay: "short",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }
}, dw = {
  personName: /^[a-zA-Z\u00C0-\u017F\s'-]+$/
}, Mf = 20, WB = 10, ZB = /^[A-Za-z]\d[A-Za-z]([- ]?\d[A-Za-z]\d)?$/, qB = /^\d{5}(?:[-\s]\d{4})?$/;
function zC(e) {
  return new RegExp("/" + e + "($|/)");
}
const jB = [yh.en, yh.fr], GB = {
  en: zC(yh.en),
  fr: zC(yh.fr)
}, YB = (e) => {
  for (const t of jB)
    if (GB[t].test(e))
      return t;
  return yh.en;
}, KB = () => {
  var e;
  return ((e = window == null ? void 0 : window.location) == null ? void 0 : e.pathname) ?? "/";
}, da = () => YB(KB());
function XB(e, t) {
  if (e && t) {
    const n = t - e;
    return Math.floor(n / t * 100);
  } else
    return 0;
}
function V1(e) {
  return (e == null ? void 0 : e.paxCount) && (e == null ? void 0 : e.paxCount) > 1;
}
const nE = function(e, t) {
  let n;
  return t === "CA" ? n = ZB : n = qB, n.test(String(e.value));
};
nE.skipEmpty = !1;
function BC(e, t, n) {
  const i = +e;
  return i >= t && i <= n;
}
function iE(e, t, n) {
  e || (e = "0");
  const i = n === "fr" ? "," : ".", r = n === "fr" ? "\\s" : ",";
  let c;
  const d = new RegExp(
    "[^\\d" + r + i + "]",
    "g"
  );
  return c = e.replace(d, ""), c = c.split(i).slice(0, 2).map((a, f) => f === 0 ? JB(n, a) : a.slice(0, 2)).join(i), c !== e && t.input(c), c;
}
const Iu = (e, t) => {
  let n = 0;
  return typeof t == "string" && (e === "fr" ? n = +t.replace(/\s/g, "").replace(",", ".").replace("$", "") : n = +t.replace(",", "").replace("$", "")), n;
};
function JB(e, t) {
  let n = 0;
  const i = e === "fr" ? /\s+/ : /,+/, r = e === "fr" ? " " : ",";
  return RegExp(i).exec(t) ? t.split(i).slice(0, 2).map((c, d) => {
    if (d === 0)
      return n = c.length >= 6 ? 6 : c.length, c.slice(0, n);
    if (d === 1)
      return c.slice(0, 6 - n);
  }).join(r).slice(0, 7) : t.slice(0, 6);
}
function rE([e, t], n, i) {
  return t === n && i && (t = i), `${e}-${t}`;
}
function e_(e, t) {
  var n;
  if (!((n = e == null ? void 0 : e.fixedValueFilters) != null && n.length))
    return [];
  const i = e.fixedValueFilters.find((r) => r.name === t);
  return (i == null ? void 0 : i.values.sort(function(r, c) {
    return r.value.toLowerCase() > c.value.toLowerCase() ? 1 : -1;
  }).map((r) => ({
    value: r.id,
    // in our data the destination numbers are .id
    label: r.value
    // and the names of the desitnations are .value
  }))) || [];
}
const pw = (e) => e_(e, "DESTINATION"), VC = (e) => e_(e, "DEALS"), UC = (e) => e_(e, "AMENITIES"), HC = (e) => e_(e, "VACATION_TYPE");
function t_(e, t) {
  const n = /* @__PURE__ */ new Map(), i = e == null ? void 0 : e.find(
    (r) => r.name === t
  );
  return i == null || i.values.forEach((r) => {
    const c = typeof r.value == "string" ? r.value : "";
    n.set(r.id, c);
  }), n;
}
const QB = (e) => t_(e, "DESTINATION"), eV = (e) => t_(e, "AMENITIES"), tV = (e) => t_(e, "VACATION_TYPE"), nV = (e) => t_(e, "DEALS"), iV = (e, t, n, i) => {
  if (!(e != null && e.length) || !i)
    return;
  let r = 0, c = 0, d = 0, a = 0;
  return e.map((f) => {
    let g;
    if (f.dob) {
      const I = gn.fromFormat(f.dob, "yyyyMMdd");
      I.isValid ? g = DB(I.toJSDate(), i) : g = 18;
    } else
      g = 18;
    const x = g >= 18, $ = g < 2;
    x ? (r++, a = r) : $ ? (d++, a = d) : (c++, a = c);
    const A = {
      ...f,
      adult: x,
      age: g,
      birthdayFormatted: D1(f.dob),
      orderIndex: a
    };
    return A.primaryTraveller && (A.phoneNumber = t, A.emailAddress = n), A;
  });
};
let ey = class {
  /*
   * Generates a random ID of a given size.
   * @param length The length of the ID to generate
   * @returns A random ID of the given size
   */
  static generateId(t) {
    const n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", i = new Uint8Array(t);
    return crypto.getRandomValues(i), Array.from(
      i,
      (r) => n[r % n.length]
    ).join("");
  }
};
const ty = async (e, t, n, i, r) => {
  try {
    const c = await L1(e);
    if (c.ok)
      return await c.json();
    {
      const d = new Error(
        `Error: ${t} invalid response ${n ? "retries:" + n : ""} HTTP ${c.status}: ${c.statusText}`
      );
      if (Md(d, i, r), typeof n == "number" && n > 0)
        return ty(e, t, n - 1);
      throw d;
    }
  } catch (c) {
    if (Md(
      Error(
        `Error: ${t} fetching ${n ? "retries:" + n : ""}`,
        { cause: c }
      ),
      i,
      r
    ), typeof n == "number" && n > 0)
      return ty(e, t, n - 1);
    throw c;
  }
};
async function rV(e, t = 2) {
  return ty(e, "Promo Badges", t);
}
function sE(e) {
  const t = e.privateTransfer ? [
    {
      type: "privateTransfer",
      ...e.privateTransfer
    }
  ] : [], n = Array.isArray(e.mealPlans) ? e.mealPlans : [], i = Array.isArray(e.activities) ? e.activities.map((f) => ({
    type: "activity",
    ...f
  })) : [], r = Array.isArray(e.travelProtections) ? e.travelProtections : [], c = (f, g) => [...f].sort((x, $) => {
    var A, I;
    const O = ((A = x.title) == null ? void 0 : A.toLowerCase()) ?? "", B = ((I = $.title) == null ? void 0 : I.toLowerCase()) ?? "";
    return O.localeCompare(B);
  }).map((x) => ({ type: g, ...x })), d = c(
    r,
    "travelProtection"
  ), a = c(n, "mealPlan");
  return [
    ...d,
    ...t,
    ...i,
    ...a
  ];
}
function sV(e, t) {
  const {
    travelProtectionIds: n = [],
    privateTransferId: i,
    // @ts-expect-error ts239 - HotelOnly API not properly typed yet
    mealPlanIds: r = [],
    activityIds: c = []
  } = e ?? {}, d = (A) => {
    const [I, O] = A.split("-");
    return `${I}-${O}`;
  }, a = n.length ? n.flatMap(
    (A) => Object.values((t == null ? void 0 : t.travelProtections) ?? {}).filter(
      (I) => {
        var O;
        return ((O = Object.values(I.subOptions)[0]) == null ? void 0 : O.id) === A;
      }
    )
  ) : [], f = i && t != null && t.privateTransfers ? Object.values(t.privateTransfers).find(
    (A) => {
      var I;
      return ((I = Object.values(A.subOptions)[0]) == null ? void 0 : I.id) === i;
    }
  ) : null, g = r.length ? r.flatMap(
    (A) => Object.values((t == null ? void 0 : t.mealPlans) ?? {}).filter(
      (I) => I.subOptions[d(A)]
    )
  ) : [], x = c.length ? c.flatMap(
    (A) => Object.values((t == null ? void 0 : t.activities) ?? {}).filter(
      (I) => I.subOptions[d(A)]
    )
  ) : [], $ = (A, I) => {
    for (const O of A) {
      const B = {};
      for (const H of I) {
        const N = d(H);
        O.subOptions[N] && (B[N] = O.subOptions[N]);
      }
      O.subOptions = B;
    }
  };
  return $(x, c), $(g, r), {
    travelProtections: a,
    activities: x,
    privateTransfer: f,
    mealPlans: g
  };
}
function oV(e = []) {
  return e == null ? void 0 : e.reduce((t, n) => n.paxCount ? n.paxCount + t : t, 0);
}
const U1 = (e, t) => {
  const n = t.split("-");
  return e.subOptions[`${n[0]}-${n[1]}`];
}, aV = (e, t) => {
  const n = t.split("-");
  return e.subOptions[`${n[0]}-${n[1]}`];
}, _h = (e) => "dates" in e, lV = function(e) {
  return P4(String(e.value));
}, cV = oo("hotelAndRoomStore", () => {
  const e = $e(), t = $e(), n = $e(), i = $e(), r = $e(), c = $e(), d = $e(), a = $e(!1);
  function f(g, x, $) {
    var A, I, O, B, H, N;
    return e.value = (A = $ == null ? void 0 : $.query) != null && A.numberOfRooms ? parseInt($.query.numberOfRooms.toString()) : null, t.value = (I = g == null ? void 0 : g.information) != null && I.checkIn ? new Date(
      parseInt(g.information.checkIn.substring(0, 4)),
      parseInt(g.information.checkIn.substring(4, 6)) - 1,
      parseInt(g.information.checkIn.substring(6))
    ) : null, n.value = (O = g == null ? void 0 : g.information) != null && O.checkOut ? new Date(
      parseInt(g.information.checkOut.substring(0, 4)),
      parseInt(g.information.checkOut.substring(4, 6)) - 1,
      parseInt(g.information.checkOut.substring(6))
    ) : null, i.value = g == null ? void 0 : g.roomId, r.value = i.value && (H = (B = x == null ? void 0 : x.rooms) == null ? void 0 : B[i.value]) != null && H.name ? x == null ? void 0 : x.rooms[i.value].name : null, c.value = (N = g == null ? void 0 : g.information) == null ? void 0 : N.mealPlanName, d.value = x != null && x.name ? x.name : null, t.value && n.value && r.value && e.value && d.value ? (a.value = !0, a) : (a.value = !1, a);
  }
  return {
    checkIn: t,
    checkOut: n,
    roomName: r,
    mealPlan: c,
    hotelName: d,
    numberOfRooms: e,
    isValid: a,
    setHotelAndRoom: f
  };
}), Ud = oo("ancillary", () => {
  const e = $e({
    activities: [],
    travelProtections: [],
    mealPlans: [],
    privateTransfer: null
  }), t = $e(0), n = (q, ee, te) => {
    if (q === "privateTransfer")
      e.value[q] = ee;
    else if (q === "travelProtections") {
      const ae = e.value[q];
      ae.some((oe) => oe.id === ee.id) || ae.push(ee);
    } else te && (q === "mealPlans" ? (g(ee), e.value[q].push({
      ...ee,
      selectedSubOptionId: te
    })) : (f(ee), e.value[q].push({
      ...ee,
      selectedSubOptionId: te
    })));
    B();
  }, i = (q, ee) => {
    O(), q.selectedActivityIds && q.selectedActivityIds.split(",").forEach((te) => {
      var ae;
      ee.activities && n(
        "activities",
        (ae = ee.activities) == null ? void 0 : ae[te.split("-")[0]],
        te
      );
    }), q.selectedTravelProtectionIds && q.selectedTravelProtectionIds.split(",").forEach((te) => {
      var ae;
      ee.travelProtections && n(
        "travelProtections",
        (ae = ee.travelProtections) == null ? void 0 : ae[te.split("-")[0]]
      );
    }), q.selectedMealPlanIds && q.selectedMealPlanIds.split(",").forEach((te) => {
      var ae;
      ee.mealPlans && n(
        "mealPlans",
        (ae = ee.mealPlans) == null ? void 0 : ae[te.split("-")[0]],
        te
      );
    }), q.selectedPrivateTransferId && ee.privateTransfers && n(
      "privateTransfer",
      ee.privateTransfers[q.selectedPrivateTransferId.split("-")[0]]
    );
  }, r = (q) => {
    const { activities: ee, travelProtections: te, mealPlans: ae, privateTransfer: oe } = e.value;
    return [
      ...ee,
      ...te,
      ...ae,
      ...oe ? [oe] : []
    ].find((de) => de.id === q);
  }, c = (q) => {
    var ee;
    const te = r(q);
    if (!(te != null && te.selectedSubOptionId))
      return;
    const ae = te.selectedSubOptionId, oe = ae.split("-"), de = `${oe[0]}-${oe[1]}`, me = te.subOptions[de];
    if (me)
      return _h(me) && ((ee = me.dates) == null ? void 0 : ee[ae]) !== void 0 ? me.dates[ae] : me;
  }, d = (q) => {
    const ee = r(q);
    if (!(ee != null && ee.selectedSubOptionId))
      return ee == null ? void 0 : ee.title;
    const te = ee.selectedSubOptionId.split("-"), ae = `${te[0]}-${te[1]}`, oe = ee.subOptions[ae];
    return oe ? oe.title : ee.title;
  }, a = (q, ee, te) => {
    var ae;
    if (q === "privateTransfer")
      ((ae = e.value[q]) == null ? void 0 : ae.id) === ee && (e.value[q] = null);
    else if (q === "mealPlans") {
      const oe = e.value[q];
      te ? e.value[q] = oe.filter(
        (de) => de.selectedSubOptionId !== te
      ) : e.value[q] = oe.filter(
        (de) => de.id !== ee
      );
    } else if (q === "travelProtections") {
      const oe = e.value[q];
      e.value[q] = oe.filter(
        (de) => de.id !== ee
      );
    } else if (q === "activities") {
      const oe = e.value[q];
      te ? e.value[q] = oe.filter(
        (de) => de.selectedSubOptionId !== te
      ) : e.value[q] = oe.filter(
        (de) => de.id !== ee
      );
    }
    B();
  }, f = (q) => {
    e.value.activities = e.value.activities.filter(
      (ee) => ee.id !== q.id
    );
  }, g = (q) => {
    e.value.mealPlans = e.value.mealPlans.filter(
      (ee) => ee.id !== q.id
    );
  }, x = (q, ee) => {
    const te = e.value[q];
    return Array.isArray(te) ? te.some((ae) => ae.id === ee) : (te == null ? void 0 : te.id) === ee;
  }, $ = (q, ee) => {
    const te = e.value[q];
    return Array.isArray(te) ? te.some(
      (ae) => ae.selectedSubOptionId === ee
    ) : !1;
  }, A = (q) => {
    var ee, te, ae, oe;
    const de = (ee = q == null ? void 0 : q.selectedTravelProtectionIds) != null && ee.length ? q.selectedTravelProtectionIds.split(",") : e.value.travelProtections.map((pe) => Object.values(pe.subOptions)[0].id).filter((pe) => pe !== void 0), me = (te = q == null ? void 0 : q.selectedMealPlanIds) != null && te.length ? q.selectedMealPlanIds.split(",") : e.value.mealPlans.map((pe) => Object.values(pe.subOptions)[0].id).filter((pe) => pe !== void 0), ve = (ae = q == null ? void 0 : q.selectedActivityIds) != null && ae.length ? q.selectedActivityIds.split(",") : e.value.activities.map((pe) => pe.selectedSubOptionId).filter((pe) => pe !== void 0);
    let re;
    (oe = q == null ? void 0 : q.selectedPrivateTransferId) != null && oe.length ? re = q.selectedPrivateTransferId : e.value.privateTransfer ? re = Object.values(
      e.value.privateTransfer.subOptions
    )[0].id : re = void 0;
    const le = {};
    return de && de.length > 0 && (le.travelProtectionIds = de), ve && ve.length > 0 && (le.activityIds = ve), re && (le.privateTransferId = re), me && me.length > 0 && (le.mealPlanIds = me), le;
  }, I = Ae(() => e.value.travelProtections.length > 0 || e.value.activities.length > 0 || e.value.privateTransfer !== null || e.value.mealPlans.length > 0), O = () => {
    e.value.travelProtections = [], e.value.activities = [], e.value.privateTransfer = null, e.value.mealPlans = [];
  }, B = () => {
    let q = 0;
    const ee = (oe) => Object.values(oe.subOptions)[0].price, te = (oe) => {
      const de = U1(oe, oe.selectedSubOptionId);
      return de ? de.dates ? de.dates[oe.selectedSubOptionId].price : de.price : Object.values(oe.subOptions)[0].price;
    }, ae = (oe) => {
      const de = aV(oe, oe.selectedSubOptionId);
      return de ? de.price : 0;
    };
    e.value.travelProtections.forEach((oe) => {
      q += ee(oe);
    }), e.value.activities.forEach((oe) => {
      q += te(oe);
    }), e.value.privateTransfer && (q += ee(e.value.privateTransfer)), e.value.mealPlans.forEach((oe) => {
      q += ae(oe);
    }), t.value = q;
  }, H = Ae(
    () => e.value.activities.map((q) => q.selectedSubOptionId).join(",")
  ), N = Ae(
    () => e.value.travelProtections.map((q) => Object.keys(q.subOptions)[0]).join(",")
  ), K = Ae(
    () => {
      var q;
      return Object.keys(((q = e.value.privateTransfer) == null ? void 0 : q.subOptions) ?? {})[0] ?? "";
    }
  ), U = Ae(
    () => e.value.mealPlans.map((q) => q.selectedSubOptionId).join(",")
  );
  return {
    ancillaries: e,
    hasSelectedAncillaries: I,
    totalPriceOfSelectedAncillariesPerTraveler: t,
    addAncillary: n,
    removeAncillary: a,
    setStore: i,
    isAncillarySelected: x,
    isAncillarySubOptionSelected: $,
    getSelectedAncillary: r,
    getSelectedSubOption: c,
    geSubOptionTitle: d,
    toPostData: A,
    reset: O,
    activityIdsString: H,
    travelProtectionIdsString: N,
    privateTransferIdString: K,
    mealPlanIdsString: U
  };
});
function Ss(e, t) {
  return e ?? t;
}
function uV(e) {
  return e.map((t, n) => ({
    id: n,
    first_name: Ss(t.firstName, ""),
    last_name: Ss(t.lastName, ""),
    date_of_birth: Ss(AB(t.dob), "")
  }));
}
function dV(e) {
  var t, n, i;
  const r = e == null ? void 0 : e.filter((c) => c.bound === "O");
  return [
    {
      airline_name: Ss((t = r[0]) == null ? void 0 : t.carrierName, ""),
      origin: Ss((n = r[0]) == null ? void 0 : n.origin, ""),
      destination: Ss(
        (i = r[r.length - 1]) == null ? void 0 : i.destination,
        ""
      ),
      trip_type: "roundtrip",
      itinerary: e.map((c) => ({
        departure_apc: Ss(c.origin, ""),
        departure_time: Ss(c.departureDate, ""),
        arrival_apc: Ss(c.destination, ""),
        arrival_time: Ss(c.arrivalDate, ""),
        fare_class: Ss(c.cabinClassName, ""),
        carrier_code: Ss(c.carrierCode, "")
      })),
      insurance: []
    }
  ];
}
function pV(e) {
  return [
    {
      reservation_type: "pre_paid",
      has_deposit: !1,
      hotel_name: Ss(e.hotelName, ""),
      number_of_rooms: Ss(e.numberOfRooms, 0),
      room_type: Ss(e.roomName, ""),
      check_in: Ss(e.checkIn, ""),
      check_out: Ss(e.checkOut, ""),
      insurance: []
    }
  ];
}
function hV(e, t) {
  return e.map((n, i) => ({
    id: i.toString(),
    name: n.title,
    price: fV(n, t)
  }));
}
function fV(e, t) {
  if (e.type === "activity") {
    const n = Ud().getSelectedAncillary(
      e.id
    );
    return n ? ((i) => {
      const r = U1(
        n,
        n.selectedSubOptionId
      );
      return r ? r.dates ? r.dates[i.selectedSubOptionId].price : r.price : Object.values(i.subOptions)[0].price;
    })(n) * 100 * t : 0;
  } else {
    const n = Object.values(e.subOptions)[0];
    return n.price ? n.price * 100 * t : 0;
  }
}
function oE(e, t, n, i, r) {
  function c() {
    (function(K, U, q, ee, te, ae, oe, de, me) {
      K.UpLiftPlatformObject = te, K[te] = K[te] || function() {
        (K[te].q = K[te].q || []).push(arguments);
      }, // @ts-expect-error:
      K[te].l = 1 * /* @__PURE__ */ new Date(), de = U.createElement(q), me = U.getElementsByTagName(q)[0], de.async = 1, de.src = ee + "?upcode=" + ae, me.parentNode.insertBefore(de, me), oe = K.location.host.match(/[\w-]+\.\w{2,3}(:\d+)?$/), oe && (oe = oe[0]), K[te]("create", ae, oe);
    })(
      window,
      document,
      "script",
      "https://tag.uplift.com/external/up.js",
      "up",
      i
      //getEnvVar("VITE_UPLIFT_LIB_UPC")
    );
  }
  function d() {
    return !!(window.Uplift && window.Uplift.Payments);
  }
  function a() {
    return !!(window.Uplift && window.Uplift.initialized);
  }
  function f(K, U, q) {
    const ee = da(), te = {
      apiKey: r,
      //getEnvVar("VITE_UPLIFT_LIB_API_KEY"),
      locale: ee === "en" ? "en-CA" : "fr-CA",
      currency: "CAD",
      checkout: K,
      channel: U ? "desktop" : "mobile",
      container: K ? "#up-pay-monthly-container" : void 0,
      onChange: K ? q : void 0
    };
    d() ? window.Uplift.Payments.init(te) : x();
  }
  function g(K, U, q, ee, te) {
    const ae = uV(K), oe = U ? dV(U) : [], de = q ? pV(q) : [], me = hV(
      ee,
      K.length
    ), ve = {
      travelers: ae,
      air_reservations: oe,
      hotel_reservations: de,
      add_ons: me,
      order_amount: te > 0 ? Math.round((te * 100 + Number.EPSILON) * 100) / 100 : 0
    };
    return d() ? window.Uplift.Payments.load(ve) : x(), ve;
  }
  function x() {
    e && Md(
      Error("Flex Pay library is not ready yet"),
      t,
      n
    );
  }
  function $() {
    d() ? window.Uplift.Payments.select() : x();
  }
  function A(K) {
    d() ? window.Uplift.Payments.load(K) : x();
  }
  function I(K) {
    d() ? (window.Uplift.Payments.deselect(K), window.Uplift.Analytics.selectPayment(K)) : x();
  }
  function O() {
    d() ? window.Uplift.Payments.getToken() : x();
  }
  function B(K) {
    d() ? window.Uplift.Analytics.selectPayment(K) : x();
  }
  function H(K, U) {
    d() ? window.Uplift.Analytics.orderSubmit(K, U) : x();
  }
  function N(K) {
    d() ? (window.Uplift.Analytics.orderResponse(K), window.Uplift.Payments.confirm(K.order_id)) : x();
  }
  return {
    loadUpliftLib: c,
    isUpliftReady: d,
    isUpliftInitialized: a,
    initPayMonthly: f,
    sendOrderInfo: g,
    upliftNotReadyError: x,
    selectUpliftPayment: $,
    loadOrderInfo: A,
    deselectUpliftPayment: I,
    getUpliftToken: O,
    upliftAnalyticsSelectPayment: B,
    upliftOrderSubmit: H,
    upliftOrderConfirmation: N
  };
}
const mV = async (e, t, n, i, r, c) => {
  n();
  const d = {
    billingAddress: gV(t),
    creditCards: [vV(t, e)]
    // Add the virtual card
  };
  if (c && c > 0) {
    const a = i();
    d.aeroplanPoints = [a];
  }
  r(d);
}, aE = (e) => ({
  address1: e.street_address,
  city: e.city,
  province: e.region,
  country: e.country,
  postalCode: e.postal_code,
  email: e.email,
  phone: e.phone
}), vV = (e, t) => ({
  correlation: ey.generateId(12),
  trace: ey.generateId(12),
  ...aE(e.contact),
  nameOnCard: e.name_on_card,
  creditCardTypeEnum: yV(e.card_type),
  // API should define as string in case of leading zeros
  cardSecurityCode: e.card_ccv,
  creditCardToken: e.card_number,
  expirationMonth: _V(e.expiration_month),
  expirationYear: bV(e.expiration_year),
  amount: t,
  currency: "cad"
}), gV = (e) => aE(e.contact), yV = (e) => {
  if (e === "MASTERCARD")
    return "masterCard";
  if (e === "VISA")
    return "visa";
}, _V = (e) => e.toString().padStart(2, "0"), bV = (e) => e.toString().slice(-2);
function wV(e, t) {
  const n = {
    subTotal: 0,
    total: e ? e.total : 0
  };
  return t && (n.total = e ? e.grandTotal : 0, xV(
    t.allowPromoCode,
    t.allowOpcTax,
    e,
    n
  ), $V(
    t.dollarValue,
    t.allowOpcTax,
    e,
    n
  ), CV(
    n,
    e,
    t.priceAncillaries,
    t.allowOpcTax,
    t.insurancePremium
  )), {
    total: n.total,
    subTotal: n.subTotal
  };
}
function xV(e, t, n, i, r) {
  var c;
  if ((c = n == null ? void 0 : n.promo) != null && c.value) {
    const d = H1(n);
    typeof d == "number" && (i.subTotal = d), typeof n.grandTotal == "number" && (i.total = n.grandTotal);
  }
}
function $V(e, t, n, i, r) {
  if (e && e > 0) {
    const c = H1(n);
    typeof c == "number" && (i.subTotal = c);
    let d = e > i.total ? 0 : i.total - e;
    d = Math.round(d * 100) / 100, i.total = d;
  }
}
function CV(e, t, n, i, r) {
  if (r) {
    if (e.subTotal === 0) {
      const c = H1(
        t
      );
      typeof c == "number" && (e.subTotal = c);
    }
    e.total += r;
  }
}
function H1(e, t, n) {
  let i = e == null ? void 0 : e.total;
  return typeof i == "number" && e != null && e.opcTax && (i += e.opcTax), i;
}
const W1 = (e, t) => e === "JWT_TOKEN_ERROR" || e === 401 || e === 403 && t === cw.FORBIDDEN_GROUP || e === 400 && t === cw.USER_CHANGE, lE = oo("message", () => {
  const e = $e(null), t = $e(null);
  function n(d) {
    e.value = d;
  }
  function i() {
    e.value = null;
  }
  function r(d) {
    t.value = d;
  }
  function c() {
    t.value = null;
  }
  return {
    alertMessage: e,
    statusMessage: t,
    setAlert: n,
    deleteAlert: i,
    setStatus: r,
    deleteStatus: c
  };
});
async function bh(e, t = null, n = "POST", i = 0, r = 3, c = 6e4) {
  try {
    const d = await window.sso.getUserToken(), a = TE(d, t), f = await L1(e.toString(), {
      ...a,
      method: n,
      timeout: c
    });
    if (f.ok) {
      const g = await f.json();
      if (("title" in g || "errorDetail" in g) && "status" in g && "detail" in g)
        throw Kg(g);
      return g;
    } else {
      if (f.status === 401 && i < r)
        return i++, await bh(e, t, n, i);
      {
        const g = await f.json(), { status: x, detail: $ } = g;
        if (W1(x, $)) {
          const { setStatus: A } = lE();
          A(g);
        }
        throw Kg(g);
      }
    }
  } catch (d) {
    throw M1(d);
  }
}
var kV = [
  "__key",
  "__init",
  "__shim",
  "__original",
  "__index",
  "__prevKey"
];
function cE() {
  return Math.random().toString(36).substring(2, 15);
}
function WC(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function n_(e, t, n = !0, i = ["__key"]) {
  if (e === t)
    return !0;
  if (typeof t == "object" && typeof e == "object") {
    if (e instanceof Map || e instanceof Set)
      return !1;
    if (e instanceof Date && t instanceof Date)
      return e.getTime() === t.getTime();
    if (e instanceof RegExp && t instanceof RegExp)
      return SV(e, t);
    if (e === null || t === null || Object.keys(e).length !== Object.keys(t).length)
      return !1;
    for (const r of i)
      if ((r in e || r in t) && e[r] !== t[r])
        return !1;
    for (const r in e)
      if (!(r in t) || e[r] !== t[r] && !n || n && !n_(e[r], t[r], n, i))
        return !1;
    return !0;
  }
  return !1;
}
function SV(e, t) {
  return e.source === t.source && e.flags.split("").sort().join("") === t.flags.split("").sort().join("");
}
function Lb(e) {
  const t = typeof e;
  if (t === "number")
    return !1;
  if (e === void 0)
    return !0;
  if (t === "string")
    return e === "";
  if (t === "object") {
    if (e === null)
      return !0;
    for (const n in e)
      return !1;
    return !(e instanceof RegExp || e instanceof Date);
  }
  return !1;
}
function hw(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function mg(e) {
  return hw(e) || Array.isArray(e);
}
function ZC(e) {
  if (hw(e) === !1 || e.__FKNode__ || e.__POJO__ === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const n = t.prototype;
  return !(hw(n) === !1 || n.hasOwnProperty("isPrototypeOf") === !1);
}
var uE = /* @__NO_SIDE_EFFECTS__ */ (e, t, n = !1, i = !1) => {
  if (t === null)
    return null;
  const r = {};
  if (typeof t == "string")
    return t;
  for (const c in e)
    if (WC(t, c) && (t[c] !== void 0 || !i)) {
      if (n && Array.isArray(e[c]) && Array.isArray(t[c])) {
        r[c] = e[c].concat(t[c]);
        continue;
      }
      if (t[c] === void 0)
        continue;
      ZC(e[c]) && ZC(t[c]) ? r[c] = /* @__PURE__ */ uE(
        e[c],
        t[c],
        n,
        i
      ) : r[c] = t[c];
    } else
      r[c] = e[c];
  for (const c in t)
    !WC(r, c) && t[c] !== void 0 && (r[c] = t[c]);
  return r;
};
function TV(e) {
  return e.replace(
    /-([a-z0-9])/gi,
    (t, n) => n.toUpperCase()
  );
}
function IV(e) {
  return e.replace(
    /([a-z0-9])([A-Z])/g,
    (t, n, i) => n + "-" + i.toLowerCase()
  ).replace(" ", "-").toLowerCase();
}
function ny(e, t = kV) {
  if (e === null || e instanceof RegExp || e instanceof Date || e instanceof Map || e instanceof Set || typeof File == "function" && e instanceof File)
    return e;
  let n;
  Array.isArray(e) ? n = e.map((i) => typeof i == "object" ? ny(i, t) : i) : n = Object.keys(e).reduce((i, r) => (i[r] = typeof e[r] == "object" ? ny(e[r], t) : e[r], i), {});
  for (const i of t)
    i in e && Object.defineProperty(n, i, {
      enumerable: !1,
      value: e[i]
    });
  return n;
}
function fw(e) {
  return typeof e == "object" ? ny(e) : e;
}
function qC(e) {
  return e !== void 0 && e !== "false" && e !== !1 ? !0 : void 0;
}
function wh(e) {
  return Object.isFrozen(e) ? e : Object.defineProperty(e, "__init", {
    enumerable: !1,
    value: !0
  });
}
function AV(e) {
  return e.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]/g, " ").trim().replace(/\s+/g, "-");
}
function dE() {
  const e = [];
  let t = 0;
  const n = (r) => e.push(r), i = (r) => {
    const c = e[t];
    return typeof c == "function" ? c(r, (d) => (t++, i(d))) : (t = 0, r);
  };
  return n.dispatch = i, n.unshift = (r) => e.unshift(r), n.remove = (r) => {
    const c = e.indexOf(r);
    c > -1 && e.splice(c, 1);
  }, n;
}
function EV() {
  const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
  let n;
  const i = (r, c) => {
    if (n) {
      n.set(c.name, [r, c]);
      return;
    }
    e.has(c.name) && e.get(c.name).forEach((d) => {
      (c.origin === r || d.modifiers.includes("deep")) && d.listener(c);
    }), c.bubble && r.bubble(c);
  };
  return i.flush = () => {
    e.clear(), t.clear(), n == null || n.clear();
  }, i.on = (r, c, d = "push") => {
    const [a, ...f] = r.split("."), g = c.receipt || cE(), x = {
      modifiers: f,
      event: a,
      listener: c,
      receipt: g
    };
    return e.has(a) ? e.get(a)[d](x) : e.set(a, [x]), t.has(g) ? t.get(g)[d](a) : t.set(g, [a]), g;
  }, i.off = (r) => {
    var c;
    t.has(r) && ((c = t.get(r)) == null || c.forEach((d) => {
      const a = e.get(d);
      Array.isArray(a) && e.set(
        d,
        a.filter((f) => f.receipt !== r)
      );
    }), t.delete(r));
  }, i.pause = (r) => {
    n || (n = /* @__PURE__ */ new Map()), r && r.walk((c) => c._e.pause());
  }, i.play = (r) => {
    if (!n)
      return;
    const c = n;
    n = void 0, c.forEach(([d, a]) => i(d, a)), r && r.walk((d) => d._e.play());
  }, i;
}
function PV(e, t, n, i, r = !0, c) {
  return t._e(e, {
    payload: i,
    name: n,
    bubble: r,
    origin: e,
    meta: c
  }), e;
}
function MV(e, t, n) {
  return Z1(e.parent) && e.parent._e(e.parent, n), e;
}
function DV(e, t, n, i, r) {
  return t._e.on(n, i, r);
}
function LV(e, t, n) {
  return t._e.off(n), e;
}
var pE = dE();
pE((e, t) => (e.message || (e.message = `E${e.code}`), t(e)));
var hE = dE();
hE((e, t) => {
  e.message || (e.message = `W${e.code}`);
  const n = t(e);
  return console && typeof console.warn == "function" && console.warn(n.message), n;
});
function fE(e, t = {}) {
  hE.dispatch({ code: e, data: t });
}
function wm(e, t = {}) {
  throw Error(pE.dispatch({ code: e, data: t }).message);
}
function mE(e, t) {
  return {
    blocking: !1,
    key: cE(),
    meta: {},
    type: "state",
    visible: !0,
    ...e
  };
}
function OV(e, ...t) {
  const n = `${e.name}-set`, i = (r) => /* @__PURE__ */ mE({
    key: AV(r),
    type: "error",
    value: r,
    meta: { source: n, autoClear: !0 }
  });
  return t.filter((r) => !!r).map((r) => {
    if (typeof r == "string" && (r = [r]), Array.isArray(r))
      return r.map((c) => i(c));
    {
      const c = {};
      for (const d in r)
        Array.isArray(r[d]) ? c[d] = r[d].map(
          (a) => i(a)
        ) : c[d] = [i(r[d])];
      return c;
    }
  });
}
var vE = /* @__PURE__ */ new Map(), Ob = /* @__PURE__ */ new Map(), NV = EV();
function FV(e) {
  if (Ob.has(e)) {
    const t = Ob.get(e);
    Ob.delete(e), vE.delete(t), NV(e, {
      payload: null,
      name: t,
      bubble: !1,
      origin: e
    });
  }
}
function RV(e) {
  return vE.get(e);
}
function jC(e, t, n) {
  let i = !0;
  return t in e.config._t ? i = !1 : e.emit(`config:${t}`, n, !1), t in e.props || (e.emit("prop", { prop: t, value: n }), e.emit(`prop:${t}`, n)), i;
}
function zV(e, t) {
  const n = (t || document).getElementById(e);
  if (n instanceof HTMLFormElement) {
    const i = new Event("submit", { cancelable: !0, bubbles: !0 });
    n.dispatchEvent(i);
    return;
  }
  fE(151, e);
}
function BV(e) {
  const t = (n) => {
    for (const i in n.store) {
      const r = n.store[i];
      r.type === "error" || r.type === "ui" && i === "incomplete" ? n.store.remove(i) : r.type === "state" && n.store.set({ ...r, value: !1 });
    }
  };
  t(e), e.walk(t);
}
function VV(e, t) {
  const n = typeof e == "string" ? RV(e) : e;
  if (n) {
    const i = (c) => {
      const d = fw(c.props.initial);
      return d !== void 0 ? d : c.type === "group" ? {} : c.type === "list" ? [] : void 0;
    };
    n._e.pause(n);
    const r = fw(t);
    return t && !Lb(t) && (n.props.initial = mg(r) ? wh(r) : r, n.props._init = n.props.initial), n.input(i(n), !1), n.walk((c) => {
      c.type === "list" && c.sync || c.input(i(c), !1);
    }), n.input(
      Lb(r) && r ? r : i(n),
      !1
    ), n.type !== "input" && t && !Lb(t) && mg(t) && n.walk((c) => {
      c.props.initial = mg(c.value) ? wh(c.value) : c.value, c.props._init = c.props.initial;
    }), n._e.play(n), BV(n), n.emit("reset", n), n;
  }
  fE(152, e);
}
var UV = {
  delimiter: ".",
  delay: 0,
  locale: "en",
  rootClasses: (e) => ({ [`formkit-${IV(e)}`]: !0 })
}, HV = Symbol("index"), mw = Symbol("removed"), vw = Symbol("moved"), gE = Symbol("inserted");
function WV(e) {
  return e.type === "list" && Array.isArray(e._value);
}
function Z1(e) {
  return e && typeof e == "object" && e.__FKNode__ === !0;
}
var vg = (e, t, n) => {
  wm(102, [e, n]);
};
gi(u4, vg, !1), gi(n4), gi(t4), gi(p4, vg, !1), gi(h4), gi(MV), gi($4), gi(JV), gi(!1), gi(e4), gi(XV), gi(QV), gi(C4), gi(YV), gi(c4, l4, !1), gi(jV), gi(s4), gi(PV), gi(m4), gi(DV), gi(LV), gi(!1, i4), gi(!1), gi(r4), gi(g4, vg, !1), gi(w4), gi(a4), gi(x4), gi(b4), gi(_4), gi(bE), gi(d4, !1, !1), gi(o4);
function gi(e, t, n = !0) {
  return {
    get: e ? (i, r) => n ? (...c) => e(i, r, ...c) : e(i, r) : !1,
    set: t !== void 0 ? t : vg.bind(null)
  };
}
var ZV = 0;
function qV(e) {
  return e.type === "group" ? wh(
    e.value && typeof e.value == "object" && !Array.isArray(e.value) ? e.value : {}
  ) : e.type === "list" ? wh(Array.isArray(e.value) ? e.value : []) : e.value;
}
function jV(e, t, n, i = !0) {
  return t._value = GV(e, e.hook.input.dispatch(n)), e.emit("input", t._value), e.isCreated && e.type === "input" && n_(t._value, t.value) && !e.props.mergeStrategy ? (e.emit("commitRaw", t.value), t.settled) : (t.isSettled && e.disturb(), i ? (t._tmo && clearTimeout(t._tmo), t._tmo = setTimeout(
    iy,
    e.props.delay,
    e,
    t
  )) : iy(e, t), t.settled);
}
function GV(e, t) {
  switch (e.type) {
    case "input":
      break;
    case "group":
      (!t || typeof t != "object") && wm(107, [e, t]);
      break;
    case "list":
      Array.isArray(t) || wm(108, [e, t]);
      break;
  }
  return t;
}
function iy(e, t, n = !0, i = !0) {
  t._value = t.value = e.hook.commit.dispatch(t._value), e.type !== "input" && i && e.hydrate(), e.emit("commitRaw", t.value), e.emit("commit", t.value), n && e.calm();
}
function yE(e, { name: t, value: n, from: i }) {
  if (!Object.isFrozen(e._value)) {
    if (WV(e)) {
      const r = n === mw ? [] : n === vw && typeof i == "number" ? e._value.splice(i, 1) : [n];
      e._value.splice(
        t,
        n === vw || i === gE ? 0 : 1,
        ...r
      );
      return;
    }
    n !== mw ? e._value[t] = n : delete e._value[t];
  }
}
function YV(e, t) {
  const n = t._value;
  return e.type === "list" && e.sync && KV(e, t), t.children.forEach((i) => {
    if (typeof n == "object")
      if (i.name in n) {
        const r = i.type !== "input" || n[i.name] && typeof n[i.name] == "object" ? wh(n[i.name]) : n[i.name];
        if (!i.isSettled || (!mg(r) || i.props.mergeStrategy) && n_(r, i._value))
          return;
        i.input(r, !1);
      } else
        (e.type !== "list" || typeof i.name == "number") && yE(t, { name: i.name, value: i.value }), n.__init || (i.type === "group" ? i.input({}, !1) : i.type === "list" ? i.input([], !1) : i.input(void 0, !1));
  }), e;
}
function KV(e, t) {
  const n = e._value;
  if (!Array.isArray(n))
    return;
  const i = [], r = new Set(t.children), c = /* @__PURE__ */ new Map();
  n.forEach((a, f) => {
    if (t.children[f] && t.children[f]._value === a)
      i.push(t.children[f]), r.delete(t.children[f]);
    else {
      i.push(null);
      const g = c.get(a) || [];
      g.push(f), c.set(a, g);
    }
  }), r.size && c.size && r.forEach((a) => {
    if (c.has(a._value)) {
      const f = c.get(a._value), g = f.shift();
      i[g] = a, r.delete(a), f.length || c.delete(a._value);
    }
  });
  const d = [];
  for (c.forEach((a) => {
    d.push(...a);
  }); r.size && d.length; ) {
    const a = r.values().next().value, f = d.shift();
    if (f === void 0)
      break;
    i[f] = a, r.delete(a);
  }
  d.forEach((a, f) => {
    i[a] = k4({ value: f });
  }), r.size && r.forEach((a) => {
    if (!("__FKP" in a)) {
      const f = a._c.parent;
      if (!f || S4(f))
        return;
      f.ledger.unmerge(a), a._c.parent = null, a.destroy();
    }
  }), t.children = i;
}
function XV(e, t) {
  var n;
  return t._d <= 0 && (t.isSettled = !1, e.emit("settled", !1, !1), t.settled = new Promise((i) => {
    t._resolve = i;
  }), e.parent && ((n = e.parent) == null || n.disturb())), t._d++, e;
}
function JV(e, t, n) {
  var i;
  if (n !== void 0 && e.type !== "input") {
    yE(t, n);
    const r = !!(e.config.mergeStrategy && e.config.mergeStrategy[n.name]);
    return iy(e, t, !0, r);
  }
  t._d > 0 && t._d--, t._d === 0 && (t.isSettled = !0, e.emit("settled", !0, !1), e.parent && ((i = e.parent) == null || i.calm({ name: e.name, value: t.value })), t._resolve && t._resolve(t.value));
}
function QV(e, t) {
  e.emit("destroying", e), e.store.filter(() => !1), e.parent && e.parent.remove(e), FV(e), e.emit("destroyed", e), t._e.flush(), t._value = t.value = void 0;
  for (const n in t.context)
    delete t.context[n];
  t.plugins.clear(), t.context = null;
}
function e4(e, t, n) {
  t.type = n.type;
  const i = ny(n);
  e.props.__propDefs = _E(
    e.props.__propDefs ?? [],
    (i == null ? void 0 : i.props) || []
  ), i.props = e.props.__propDefs, t.props.definition = i, t.value = t._value = qV({
    type: e.type,
    value: t.value
  }), n.forceTypeProp && (e.props.type && (e.props.originalType = e.props.type), t.props.type = n.forceTypeProp), n.family && (t.props.family = n.family), n.features && n.features.forEach((r) => r(e)), n.props && e.addProps(n.props), e.emit("defined", n);
}
function t4(e, t, n) {
  const i = Array.isArray(n) ? n : Object.keys(n), r = Array.isArray(n) ? {} : i.reduce((d, a) => ("default" in n[a] && (d[a] = n[a].default), d), {});
  if (e.props.attrs) {
    const d = { ...e.props.attrs };
    e.props._emit = !1;
    for (const f in d) {
      const g = TV(f);
      i.includes(g) && (e.props[g] = d[f], delete d[f]);
    }
    Array.isArray(n) || i.forEach((f) => {
      "default" in n[f] && e.props[f] === void 0 && (e.props[f] = r[f]);
    });
    const a = fw(t._value);
    e.props.initial = e.type !== "input" ? wh(a) : a, e.props._emit = !0, e.props.attrs = d;
  }
  const c = _E(e.props.__propDefs ?? [], n);
  return e.props.definition && (e.props.definition.props = c), e.props.__propDefs = c, e.emit("added-props", n), e;
}
function GC(e) {
  return Array.isArray(e) ? e.reduce((t, n) => (t[n] = {}, t), {}) : e;
}
function _E(e, t) {
  return Array.isArray(e) && Array.isArray(t) ? e.concat(t) : uE(GC(e), GC(t));
}
function n4(e, t, n, i) {
  if (e.type === "input" && wm(100, e), n.parent && n.parent !== e && n.parent.remove(n), !t.children.includes(n)) {
    if (i !== void 0 && e.type === "list") {
      const r = t.children[i];
      r && "__FKP" in r ? (n._c.uid = r.uid, t.children.splice(i, 1, n)) : t.children.splice(i, 0, n), Array.isArray(e.value) && e.value.length < t.children.length && e.disturb().calm({
        name: i,
        value: n.value,
        from: gE
      });
    } else
      t.children.push(n);
    n.isSettled || e.disturb();
  }
  if (n.parent !== e) {
    if (n.parent = e, n.parent !== e)
      return e.remove(n), n.parent.add(n), e;
  } else
    n.use(e.plugins);
  return iy(e, t, !1), e.ledger.merge(n), e.emit("child", n), e;
}
function i4(e, t, n, i) {
  return Z1(i) ? (e.parent && e.parent !== i && e.parent.remove(e), t.parent = i, e.resetConfig(), i.children.includes(e) ? e.use(i.plugins) : i.add(e), !0) : i === null ? (t.parent = null, !0) : !1;
}
function r4(e, t, n) {
  const i = t.children.indexOf(n);
  if (i !== -1) {
    n.isSettled && e.disturb(), t.children.splice(i, 1);
    let r = qC(n.props.preserve), c = n.parent;
    for (; r === void 0 && c; )
      r = qC(c.props.preserve), c = c.parent;
    r ? e.calm() : e.calm({
      name: e.type === "list" ? i : n.name,
      value: mw
    }), n.parent = null, n.config._rmn = n;
  }
  return e.ledger.unmerge(n), e.emit("childRemoved", n), e;
}
function s4(e, t, n) {
  t.children.forEach((i) => !("__FKP" in i) && n(i));
}
function o4(e, t, n, i = !1, r = !1) {
  t.children.some((c) => {
    if ("__FKP" in c)
      return !1;
    const d = n(c);
    return i && d === !1 ? !0 : r && d === !1 ? !1 : c.walk(n, i, r);
  });
}
function a4(e, t) {
  const n = e.parent || void 0;
  t.config = y4(e.config._t, n), e.walk((i) => i.resetConfig());
}
function bE(e, t, n, i = !0, r = !0) {
  return Array.isArray(n) || n instanceof Set ? (n.forEach((c) => bE(e, t, c)), e) : (t.plugins.has(n) || (r && typeof n.library == "function" && n.library(e), i && n(e) !== !1 && (t.plugins.add(n), e.children.forEach((c) => c.use(n)))), e);
}
function l4(e, t, n, i) {
  if (Z1(e.parent)) {
    const r = e.parent.children, c = i >= r.length ? r.length - 1 : i < 0 ? 0 : i, d = r.indexOf(e);
    return d === -1 ? !1 : (r.splice(d, 1), r.splice(c, 0, e), e.parent.children = r, e.parent.type === "list" && e.parent.disturb().calm({ name: c, value: vw, from: d }), !0);
  }
  return !1;
}
function c4(e) {
  if (e.parent) {
    const t = [...e.parent.children].indexOf(e);
    return t === -1 ? e.parent.children.length : t;
  }
  return -1;
}
function u4(e, t) {
  return t;
}
function d4(e, t) {
  var n;
  return ((n = e.parent) == null ? void 0 : n.type) === "list" ? e.index : t.name !== HV ? t.name : e.index;
}
function p4(e, t) {
  return t.parent ? t.parent.address.concat([e.name]) : [e.name];
}
function h4(e, t, n) {
  const i = typeof n == "string" ? n.split(e.config.delimiter) : n;
  if (!i.length)
    return;
  const r = i[0];
  let c = e.parent;
  for (c || (String(i[0]) === String(e.name) && i.shift(), c = e), r === "$parent" && i.shift(); c && i.length; ) {
    const d = i.shift();
    switch (d) {
      case "$root":
        c = e.root;
        break;
      case "$parent":
        c = c.parent;
        break;
      case "$self":
        c = e;
        break;
      default:
        c = c.children.find(
          (a) => !("__FKP" in a) && String(a.name) === String(d)
        ) || f4(c, d);
    }
  }
  return c || void 0;
}
function f4(e, t) {
  const n = String(t).match(/^(find)\((.*)\)$/);
  if (n) {
    const [, i, r] = n, c = r.split(",").map((d) => d.trim());
    switch (i) {
      case "find":
        return e.find(c[0], c[1]);
      default:
        return;
    }
  }
}
function m4(e, t, n, i) {
  return v4(e, n, i);
}
function v4(e, t, n = "name") {
  const i = typeof n == "string" ? (c) => c[n] == t : n, r = [e];
  for (; r.length; ) {
    const c = r.shift();
    if (!("__FKP" in c)) {
      if (i(c, t))
        return c;
      r.push(...c.children);
    }
  }
}
function g4(e) {
  let t = e;
  for (; t.parent; )
    t = t.parent;
  return t;
}
function y4(e = {}, t) {
  let n;
  return new Proxy(e, {
    get(...i) {
      const r = i[1];
      if (r === "_t")
        return e;
      const c = Reflect.get(...i);
      if (c !== void 0)
        return c;
      if (t) {
        const d = t.config[r];
        if (d !== void 0)
          return d;
      }
      if (e.rootConfig && typeof r == "string") {
        const d = e.rootConfig[r];
        if (d !== void 0)
          return d;
      }
      return r === "delay" && (n == null ? void 0 : n.type) === "input" ? 20 : UV[r];
    },
    set(...i) {
      const r = i[1], c = i[2];
      if (r === "_n")
        return n = c, e.rootConfig && e.rootConfig._add(n), !0;
      if (r === "_rmn")
        return e.rootConfig && e.rootConfig._rm(n), n = void 0, !0;
      if (!n_(e[r], c, !1)) {
        const d = Reflect.set(...i);
        return n && (n.emit(`config:${r}`, c, !1), jC(n, r, c), n.walk((a) => jC(a, r, c), !1, !0)), d;
      }
      return !0;
    }
  });
}
function _4(e, t, n, i = "ui") {
  const r = typeof n == "string" ? { key: n, value: n, type: i } : n, c = e.hook.text.dispatch(r);
  return e.emit("text", c, !1), c.value;
}
function b4(e) {
  const t = e.name;
  do {
    if (e.props.isForm === !0)
      break;
    e.parent || wm(106, t), e = e.parent;
  } while (e);
  e.props.id && zV(e.props.id, e.props.__root);
}
function w4(e, t, n) {
  return VV(e, n);
}
function x4(e, t, n, i) {
  const r = `${e.name}-set`, c = e.hook.setErrors.dispatch({ localErrors: n, childErrors: i });
  return OV(e, c.localErrors, c.childErrors).forEach(
    (d) => {
      e.store.apply(d, (a) => a.meta.source === r);
    }
  ), e;
}
function $4(e, t, n = !0, i) {
  return e.store.filter((r) => !(i === void 0 || r.meta.source === i), "error"), n && (i = i || `${e.name}-set`, e.walk((r) => {
    r.store.filter((c) => !(c.type === "error" && c.meta && c.meta.source === i));
  })), e;
}
function C4(e, t, n, i) {
  return t.traps.set(n, i), e;
}
function k4(e) {
  return {
    __FKP: !0,
    uid: Symbol(),
    name: (e == null ? void 0 : e.name) ?? `p_${ZV++}`,
    value: (e == null ? void 0 : e.value) ?? null,
    _value: (e == null ? void 0 : e.value) ?? null,
    type: (e == null ? void 0 : e.type) ?? "input",
    props: {},
    use: () => {
    },
    input(t) {
      return this._value = t, this.value = t, Promise.resolve();
    },
    isSettled: !0
  };
}
function S4(e) {
  return "__FKP" in e;
}
const YC = (e, t) => {
  const n = T4(e);
  t.node.walk((i) => {
    n.includes(i.name) && i.value && i.value !== "" && I4(i);
  });
};
function T4(e) {
  const t = /* @__PURE__ */ new Set([
    "address",
    "apartment",
    "city",
    "country",
    "state",
    "postcode",
    "cc-expiry",
    "cc-name"
  ]), n = e.creditCardIframeName;
  return Array.from(t).map(
    (i) => `${n}-${i}`
  );
}
const I4 = (e) => {
  e.store.set(
    mE({
      key: "submitted",
      value: !0,
      visible: !1
    })
  );
};
function A4(e) {
  var t, n, i;
  if ((t = e == null ? void 0 : e.quote) != null && t.prePackage && e != null && e.itineraries && e != null && e.hotels) {
    const r = (n = e.quote.prePackage.selectedOptionIds) == null ? void 0 : n.itineraryId;
    if (r) {
      const c = e.itineraries[r], d = (i = e.itineraries[r]) == null ? void 0 : i.segments;
      return !!c && !!d;
    }
  }
  return !1;
}
function E4(e) {
  var t, n, i, r;
  const c = (t = e == null ? void 0 : e.quote) == null ? void 0 : t.id, d = (i = (n = e == null ? void 0 : e.quote) == null ? void 0 : n.hotel) == null ? void 0 : i.hotelId, a = !!(d && (r = e == null ? void 0 : e.hotels) != null && r[d]);
  return !!(c && a);
}
function P4(e) {
  return e != null && e.trim() ? M4(e) % 10 == 0 : !1;
}
function M4(e) {
  let t = !1, n = 0;
  for (let i = e.length - 1; i >= 0; i--) {
    let r = Number(e[i]);
    t && (r *= 2, r > 9 && (r -= 9)), n += r, t = !t;
  }
  return n;
}
var gw = /* @__PURE__ */ ((e) => (e.priceasc = "priceasc", e.pricedesc = "pricedesc", e.nameasc = "nameasc", e.namedesc = "namedesc", e.starasc = "starasc", e.stardesc = "stardesc", e.recommended = "recommended", e.bestsavings = "bestsavings", e))(gw || {}), no = /* @__PURE__ */ ((e) => (e.full = "full", e.deposit = "deposit", e.uplift = "uplift", e))(no || {}), gg = /* @__PURE__ */ ((e) => (e.pax = "PAX", e.insurance = "INSURANCE", e.checkout = "CHECKOUT", e))(gg || {}), aa = /* @__PURE__ */ ((e) => (e.B2C_GUEST = "B2C Guest", e.AEROPLAN_B2C = "Aeroplan B2C Signed In", e.B2B = "B2B", e.AFFILIATE = "Affiliate", e.FRIENDS_AND_FAMILY = "Friends&Family", e.EMPLOYEE = "Employee", e))(aa || {});
window.dataLayer = window.dataLayer || [];
const D4 = "Vacation Package", L4 = "Flight&Hotel", O4 = "Hotel Only";
function N4(e) {
  return j1(e) + " Search Results";
}
function F4(e, t, n) {
  const i = R4(e, n), r = TB(
    i_(),
    "dd/mm/yyyy",
    "yyyy-mm"
  ), c = z4(e), d = B4();
  return [
    j1(e),
    i,
    t == null ? void 0 : t.name,
    r,
    `${c} Nights`,
    `${d} DBD`
  ].join(" | ");
}
function R4(e, t) {
  if (t) {
    const n = V4(t), i = q1(t);
    return `${n} | ${i}`;
  }
  return e.information.destination ?? "N/A";
}
function wE() {
  const e = new URLSearchParams(window.location.search), t = i_(), n = e.get("returnDateTime");
  if (typeof t == "string" && typeof n == "string") {
    const i = Xg(t, "ddMMyyyy"), r = Xg(n, "ddMMyyyy");
    if (i && r)
      return Jg(i, r);
  }
  return -1;
}
function xE() {
  const e = i_();
  return GA(e) ?? "";
}
function z4(e) {
  var t, n;
  const i = (t = e == null ? void 0 : e.information) == null ? void 0 : t.checkIn, r = (n = e == null ? void 0 : e.information) == null ? void 0 : n.checkOut;
  if (i && r) {
    const c = Xg(i, "yyyyMMdd"), d = Xg(r, "yyyyMMdd");
    if (c && d)
      return Jg(d, c);
  }
  return 0;
}
function B4() {
  const e = i_();
  return SB(e);
}
function V4(e = void 0) {
  return e ? U4(e) : W4();
}
function q1(e = void 0) {
  return e ? H4(e) : Z4();
}
function U4(e) {
  var t;
  return ((t = e == null ? void 0 : e.segments) == null ? void 0 : t.filter((n) => n.bound === "O")[0].origin) ?? "";
}
function H4(e) {
  var t;
  return (t = e == null ? void 0 : e.segments) == null ? void 0 : t.filter((n) => n.bound === "O").slice(-1)[0].destination;
}
function W4() {
  const e = new URLSearchParams(window.location.search), t = e.get("departureLocationPlaceId");
  return e.get("departureLocationSuggestionType") === "AIRPORTGROUP" && t ? t : "N/A";
}
function Z4() {
  const e = new URLSearchParams(window.location.search), t = e.get("arrivalLocationPlaceId");
  if (e.get("arrivalLocationSuggestionType") === "AIRPORTGROUP" && t)
    return t;
}
function i_() {
  const e = new URLSearchParams(window.location.search);
  return e.get("departingDateTime") ?? e.get("checkInDate") ?? "";
}
function j1(e) {
  return e && "dynamicPackage" in e ? e.dynamicPackage ? L4 : D4 : O4;
}
function $E(e, t, n, i, r) {
  var c, d, a;
  const f = new URLSearchParams(window.location.search), g = ((d = (c = i == null ? void 0 : i.segments) == null ? void 0 : c[0]) == null ? void 0 : d.origin) ?? "N/A", x = (i ? q1(i) : t.information.destination) ?? "N/A", $ = f.get("no_hotel") ? "Room" : "Hotel";
  return {
    item_name: (n == null ? void 0 : n.name) ?? "",
    item_id: F4(t, n, i),
    price: (a = t.pricing) == null ? void 0 : a.total,
    item_brand: kE(x),
    item_category: j1(t),
    item_category2: g,
    item_category3: x,
    item_category4: CE(r, $),
    item_category5: Q4(t),
    item_variant: q4(n, i),
    item_list_name: N4(t),
    item_list_id: "",
    index: e + 1,
    quantity: 1
  };
}
function q4(e, t) {
  return t ? Y4(t) : e.starCategory ? `${e.starCategory}*` : "";
}
function j4(e, t, n) {
  return {
    ...$E(0, e, n, t),
    item_list_id: "",
    quantity: 1
  };
}
const G4 = /* @__PURE__ */ new Map([
  ["Y", "Economy"],
  ["O", "Premium Economy"],
  ["J", "Business"]
]);
function Y4(e) {
  var t;
  return [
    ...new Set(
      (t = e == null ? void 0 : e.segments) == null ? void 0 : t.map((n) => G4.get(n.cabinClass ?? ""))
    )
  ].join(";");
}
function K4(e, t) {
  return e ? t ? 2 : 1 : 0;
}
function X4(e, t, n, i) {
  const r = [];
  if (n)
    r.push("Flex Pay");
  else {
    if (e)
      for (let c = 0; c < e; c++)
        r.push("Credit Card");
    t && r.push("Aeroplan Points"), i && r.push("Gift Card");
  }
  return r.join(", ");
}
const Zh = /* @__PURE__ */ new Map();
Zh.set("guest", aa.B2B);
Zh.set("aeroplan", aa.AEROPLAN_B2C);
Zh.set("affiliate", aa.AFFILIATE);
Zh.set("b2b", aa.B2B);
Zh.set("fandf", aa.FRIENDS_AND_FAMILY);
Zh.set("employee", aa.EMPLOYEE);
function CE(e, t) {
  if (!e)
    return "N/A";
  const { type: n, value: i = "", span: r = "" } = e, c = parseInt(i, 10), d = c > 1 ? "s" : "";
  switch (n) {
    case "ROOMS_LEFT":
      return `Only ${c} room${d} left`;
    case "LAST_BOOKING":
      return `${t} booked ${c} ${r.toLowerCase()}${d} ago`;
    case "TOTAL_BOOKINGS":
      return `${t} booked ${c} time${d} in the last ${parseInt(r)} hours`;
    default:
      return "N/A";
  }
}
function J4(e) {
  return e > 0 ? `+$${e}` : "$0";
}
function Q4(e, t = 5) {
  var n, i;
  const { total: r, wasPrice: c } = ((i = (n = e == null ? void 0 : e.pricing) == null ? void 0 : n.perPaxType) == null ? void 0 : i[0]) ?? {}, d = XB(
    r,
    c
  );
  return d >= Number(t) ? `Save ${d}%` : "N/A";
}
function kE(e) {
  var t;
  return e ? ((t = window == null ? void 0 : window.mappedBudgetProductLine) == null ? void 0 : t.get(e)) ?? "N/A" : "N/A";
}
var ps = /* @__PURE__ */ ((e) => (e.PackagesSpa = "Package Booking Flow", e.HotelsSpa = "Hotels Booking Flow", e.PromotionsSpa = "Promo Module", e.GqtSpaB2C = "Group Quoting Tool (B2C)", e.GqtSpaB2B = "Group Quoting Tool (B2B)", e.StaticPage = "N/A", e))(ps || {});
function e5(e, t) {
  const { quoteId: n } = t, i = `/hotel-only/quote/${n}`;
  return SE(e, i);
}
function t5(e, t) {
  const { quoteId: n } = t, i = `/packages-quote/v2/quotes/${n}`;
  return SE(e, i);
}
function SE(e, t) {
  const n = new URL(e.origin.replace(/\/+$/, "") + "/"), i = t.replace(/^\/+/, "");
  return new URL(i, n);
}
function TE(e, t = null) {
  const n = {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + e
    }
  };
  return {
    ...t ? { body: t } : null,
    ...n
  };
}
const zu = oo("aeroplan", () => {
  const e = $e(NaN), t = $e(NaN), n = $e(!1), i = $e(!1), r = $e(!1), c = $e(!1), d = $e(!1);
  function a(B) {
    e.value = B;
  }
  function f(B) {
    t.value = B;
  }
  function g(B) {
    n.value = B;
  }
  function x(B) {
    i.value = B;
  }
  function $(B) {
    r.value = B;
  }
  function A(B) {
    c.value = B;
  }
  function I(B) {
    d.value = B;
  }
  function O() {
    e.value = NaN, t.value = NaN, n.value = !1;
  }
  return {
    pointsToRedeem: e,
    dollarValue: t,
    hideCreditCardForm: n,
    controlPoints: i,
    dropDownCheckoutFormExecuted: r,
    dropDownBookingSummaryExecuted: c,
    showAeroPlanPointsDropDown: d,
    setPointsToRedeem: a,
    setDollarValue: f,
    setHideCreditCardForm: g,
    setControlPoints: x,
    setDropDownCheckoutFormExecuted: $,
    setDropDownBookingSummaryExecuted: A,
    setShowAeroPlanPointsDropDown: I,
    reset: O
  };
}), xo = oo("checkout", () => {
  const e = $e(!0), t = $e(!1), n = $e(!1), i = $e(!1), r = $e(0), c = $e(""), d = $e(""), a = $e(""), f = $e(null), g = $e(0), x = $e(!1), $ = $e(!1), A = $e(!0), I = no.full, O = $e(I), B = $e(0), H = $e(aa.B2C_GUEST), N = $e(!1), K = Ae(() => {
    if (t.value && !e.value) {
      if (n.value)
        return !1;
      if (x.value && f.value != null && f.value > 0 && r.value === f.value && B.value <= 0 || r.value === g.value)
        return !0;
    }
    return !1;
  }), U = $e(!1), q = $e(
    te(Sc, 1)
  ), ee = $e(
    te(Ml, 2)
  );
  function te(It, wn) {
    return {
      creditCardName: "",
      creditCardExpiry: "",
      creditCardAmount: "",
      creditCardIframeName: It,
      creditCardIframeNumber: wn,
      address: "",
      apartment: "",
      city: "",
      country: "CA",
      state: "",
      postcode: ""
    };
  }
  const ae = Er(
    Array.from({ length: 2 }, () => 0)
  );
  function oe(It) {
    It < 2 && ae[It]++;
  }
  function de() {
    ae.forEach((It, wn) => {
      ae[wn] = 0;
    });
  }
  const me = $e(!1), ve = $e(!1), re = $e(!1), le = Ae(() => c.value === "" ? i.value : !0), pe = (It) => {
    e.value = It;
  }, Ne = (It) => {
    t.value = It;
  }, We = (It) => {
    H.value = It;
  }, Ge = (It) => {
    n.value = It;
  }, et = (It) => {
    f.value = It;
  }, ft = () => {
    f.value = null;
  }, De = (It) => {
    x.value = It;
  }, Ke = (It) => {
    O.value = It;
  }, gt = (It) => {
    $.value = It;
  }, qe = (It) => {
    A.value = It;
  }, rt = (It, wn) => {
    r.value = It, c.value = O1(r.value, wn);
  }, Le = (It) => {
    B.value = It;
  }, Je = () => {
    r.value = 0, c.value = "", i.value = !1;
  }, je = (It) => {
    t.value && (e.value ? Je() : x.value && f.value !== null && f.value > 0 ? rt(f.value, It) : rt(g.value, It));
  };
  function ot(It) {
    if (e.value && t.value && c.value === "") {
      q.value.creditCardAmount = "";
      return;
    }
    if (e.value)
      if (x.value && f.value) {
        const wn = f.value - r.value;
        q.value.creditCardAmount = Wn(wn, It).replace(
          "$",
          ""
        );
      } else {
        let wn = parseFloat(
          (g.value - r.value).toFixed(2)
        );
        wn < 0 && (wn = 0), q.value.creditCardAmount = Wn(wn, It).replace(
          "$",
          ""
        );
      }
    t.value && (x.value && f.value !== null ? tt() : Xe());
  }
  function Xe() {
    e.value && r.value > g.value - B.value ? q.value.creditCardAmount = B.value ? B.value.toString() : "0" : r.value === g.value && !B.value && (e.value = !1);
  }
  function tt() {
    x.value && f.value != null && r.value > f.value - B.value ? e.value && (q.value.creditCardAmount = B.value ? B.value.toString() : "0") : r.value === f.value && !B.value && (e.value = !1);
  }
  function dt(It) {
    const wn = function(Oi) {
      const hr = Iu(
        da(),
        Oi.value
      );
      return It(hr);
    };
    return wn.skipEmpty = !1, wn;
  }
  const bt = dt(
    (It) => It < g.value
  ), qt = dt(
    (It) => It <= g.value
  ), Oe = dt(
    (It) => B.value > 0 && It <= g.value
  ), Bt = dt(
    (It) => B.value > 0 && !!f.value && f.value > 0 && It <= f.value - B.value
  ), Tn = dt((It) => f.value === null ? !0 : f.value === 0 || It <= f.value), hn = dt(
    (It) => It != f.value
  ), Ht = dt(
    (It) => It != g.value
  ), qn = dt((It) => It > 0), vi = dt((It) => x.value && f.value != null ? It <= f.value : !1);
  return {
    card1: q,
    card2: ee,
    showBill96Checkbox: me,
    bill96: ve,
    isTotalPriceZero: re,
    isPaymentMethodCreditCard: e,
    isPaymentMethodGiftCard: t,
    isPaymentMethodUplift: n,
    amountToPay: g,
    depositAmount: f,
    selectDeposit: x,
    giftCardAmount: r,
    displayedGiftCardAmount: c,
    giftCardNumber: d,
    giftCardPIN: a,
    validators: {
      isAmountGreaterThanZero: qn,
      isAmountLessThanTotal: bt,
      isAmountLessThanDeposit: Tn,
      isAmountLessThanOrEqualToTotal: qt,
      isAmountLessThanOrEqualToTotalWithoutInsurancePremium: Oe,
      isAmountLessThanOrEqualToDepositWithoutInsurancePremium: Bt,
      isAmountLessThanOrEqualToDeposit: vi,
      isAmountNotEqualToTotal: Ht,
      isAmountNotEqualToDeposit: hn,
      isGiftCardAmountSufficient: function(It) {
        return Iu(
          da(),
          It.value
        ) >= g.value;
      },
      isGiftCardDepositSufficient: function(It) {
        return x.value && f.value != null ? Iu(
          da(),
          It.value
        ) >= f.value : !1;
      }
    },
    giftCardAmountErrorVisible: le,
    checkoutHasBeenSubmitted: i,
    toggle2cc: $,
    sameBillingAddress: A,
    showGiftCardTwoCardError: N,
    showGiftCardPayInFullMessage: K,
    showPaymentMethodError: U,
    selectedPlan: O,
    insurancePremiumAmount: B,
    audience: H,
    creditCard3DSFailures: ae,
    setDepositAmount: et,
    setDepositAmountToNull: ft,
    setSelectDeposit: De,
    setGiftCardAmount: rt,
    clearGiftCardAmount: Je,
    autoCalculateGiftCardAmount: je,
    recalculateCreditCard1Amount: ot,
    setIsPaymentMethodCreditCard: pe,
    setIsPaymentMethodGiftCard: Ne,
    setIsPaymentMethodUplift: Ge,
    setSelectedPlan: Ke,
    setToggle2cc: gt,
    setSameBillingAddress: qe,
    setInsurancePremiumAmount: Le,
    setAudience: We,
    incrementCreditCard3DSFailures: oe,
    resetCreditCard3DSFailures: de
  };
}), n5 = /* @__PURE__ */ new Map(), KC = /* @__PURE__ */ new Map(), XC = $e(!1);
oo("promos", () => ({
  fetchPromoBadges: async (e, t = 2) => {
    var n;
    const i = await rV(
      e,
      t
    );
    if ((n = i == null ? void 0 : i.Promos) != null && n.length)
      for (const r of i.Promos) {
        n5.set(r.promo_id, r);
        for (const c of r.Hotel_List) {
          const d = KC.get(c.Hotel_Code) || [];
          d.push({
            promo_id: r.promo_id,
            ...c
          }), KC.set(c.Hotel_Code, d);
        }
      }
    XC.value = !0;
  },
  isLoaded: XC
}));
const Dd = oo("upliftStore", () => {
  const e = $e(!1), t = $e(!1), n = $e(!1), i = $e(), r = $e(), c = $e(!1), d = $e(!1), a = $e(!0), f = $e();
  function g() {
    e.value = !1, t.value = !1, n.value = !1, i.value = null;
  }
  function x(U) {
    e.value = U;
  }
  function $(U) {
    t.value = U;
  }
  function A(U) {
    n.value = U;
  }
  function I(U) {
    i.value = U;
  }
  function O(U) {
    r.value = U;
  }
  function B(U) {
    c.value = U;
  }
  function H(U) {
    d.value = U;
  }
  function N(U) {
    a.value = U;
  }
  function K(U) {
    f.value = U;
  }
  return {
    upliftOfferAvailable: e,
    upliftTokenAvailable: t,
    upliftTokenRetrieved: n,
    upliftToken: i,
    upLiftOrderObj: r,
    showFormIncompleteError: c,
    showUnableToGetUpliftTokenError: d,
    passengerIsOldEnough: a,
    upliftWasDisabledByNonEligibility: f,
    resetUplift: g,
    setUpliftOfferAvailable: x,
    setUpliftOrder: O,
    setUpliftTokenAvailable: $,
    setUpliftTokenRetrieved: A,
    setUpliftToken: I,
    setShowFormIncompleteError: B,
    setShowUnableToGetUpliftTokenError: H,
    setPassengerIsOldEnough: N,
    setUpliftWasDisabledByNonEligibility: K
  };
});
function i5(e) {
  return m1() ? (v1(e), !0) : !1;
}
function yw(e) {
  return typeof e == "function" ? e() : ne(e);
}
const r5 = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const JC = () => {
};
function s5(e, t) {
  function n(...i) {
    return new Promise((r, c) => {
      Promise.resolve(e(() => t.apply(this, i), { fn: t, thisArg: this, args: i })).then(r).catch(c);
    });
  }
  return n;
}
function o5(e, t = {}) {
  let n, i, r = JC;
  const c = (d) => {
    clearTimeout(d), r(), r = JC;
  };
  return (d) => {
    const a = yw(e), f = yw(t.maxWait);
    return n && c(n), a <= 0 || f !== void 0 && f <= 0 ? (i && (c(i), i = null), Promise.resolve(d())) : new Promise((g, x) => {
      r = t.rejectOnCancel ? x : g, f && !i && (i = setTimeout(() => {
        n && c(n), i = null, g(d());
      }, f)), n = setTimeout(() => {
        i && c(i), i = null, g(d());
      }, a);
    });
  };
}
function IE(e, t = 200, n = {}) {
  return s5(
    o5(t, n),
    e
  );
}
function a5(e, t, n = {}) {
  const {
    immediate: i = !0
  } = n, r = $e(!1);
  let c = null;
  function d() {
    c && (clearTimeout(c), c = null);
  }
  function a() {
    r.value = !1, d();
  }
  function f(...g) {
    d(), r.value = !0, c = setTimeout(() => {
      r.value = !1, c = null, e(...g);
    }, yw(t));
  }
  return i && (r.value = !0, r5 && f()), i5(a), {
    isPending: Zy(r),
    start: f,
    stop: a
  };
}
const AE = oo("UX", () => {
  const e = $e(), t = Er({
    PDPSectionInView: "rooms"
  });
  return {
    PDP: t,
    setPDPSectionDisplayed: (n, i) => {
      i ? (e.value = i, t.PDPSectionInView = n ?? "rooms", setTimeout(() => {
        e.value = !1;
      }, 1500)) : e.value || (t.PDPSectionInView = n);
    }
  };
});
function qh() {
  const { setPDPSectionDisplayed: e } = AE(), t = $e();
  return {
    onIntersectionObserver: ([{ isIntersecting: n }]) => {
      n && a5(() => {
        t.value && e(t.value.id);
      }, 500);
    },
    section: t
  };
}
const Wl = oo("insuranceStore", () => {
  const e = $e(null), t = $e(null), n = $e(!1), i = $e([]), r = $e({}), c = $e(!1), d = $e(""), a = $e(""), f = $e(!1), g = $e(!1);
  function x(ve) {
    e.value = ve, n.value = !1;
  }
  function $(ve) {
    t.value = ve;
  }
  function A(ve) {
    i.value = [], ve.forEach((re) => {
      i.value.push(re.dob);
    });
  }
  function I(ve) {
    c.value = ve;
  }
  function O(ve) {
    d.value = ve;
  }
  function B(ve) {
    a.value = ve;
  }
  function H() {
    g.value = !0;
  }
  function N() {
    e.value = null;
  }
  function K() {
    t.value = null;
  }
  function U(ve) {
    ve && e.value && N(), n.value = ve;
  }
  function q() {
    n.value = !1;
  }
  function ee() {
    r.value = {};
  }
  function te() {
    f.value = !0;
  }
  function ae() {
    N(), K(), i.value = [], A([]), q(), ee(), B(""), O(""), I(!1), f.value = !1, g.value = !1;
  }
  const oe = (ve) => {
    ve.forEach((re) => {
      re.inclusions.forEach((le) => {
        r.value[le.title] = le.description;
      });
    });
  }, de = Ae(
    () => {
      var ve;
      return ((ve = e.value) == null ? void 0 : ve.premium) ?? 0;
    }
  ), me = Ae(
    () => e.value !== null
  );
  return {
    // State
    selectedInsuranceProduct: e,
    declinedTravelInsurance: n,
    insuranceQuoteId: t,
    quotedDOB: i,
    travelInsuranceInclusionsMatrix: r,
    showModalInclusionDetails: c,
    modalTitle: d,
    modalContent: a,
    initialQuoteFailed: f,
    travelInsuranceFailedOnReQuote: g,
    // Actions
    selectTravelInsuranceProduct: x,
    removeInsurance: N,
    declineInsurance: U,
    uncheckDecline: q,
    resetInsuranceStore: ae,
    setInsuranceQuoteId: $,
    setQuotedDOB: A,
    populateTravelInsuranceInclusionsMatrix: oe,
    setShowModalInclusionDetails: I,
    setModalContent: B,
    setModalTitle: O,
    clearMatrix: ee,
    setInitialQuoteFailed: te,
    setFailedOnReQuote: H,
    // Getters
    insurancePremium: de,
    hasSelectedInsuranceProduct: me
  };
});
oo("paymentStepStore", () => {
  const e = $e(), t = $e([]), n = $e();
  function i(f) {
    e.value && (n.value = e.value);
    const g = t.value.find((x) => x.name == f);
    g && (e.value = g);
  }
  function r(f, g) {
    var x;
    t.value.find(($) => $.name == f) || (x = t.value) == null || x.push({ name: f, step: g });
  }
  function c(f) {
    return !!(f && e.value && e.value.name == f);
  }
  function d(f) {
    r(gg.pax, 1), r(gg.insurance, 2), r(gg.checkout, 3), i(f);
  }
  function a() {
    e.value = null, t.value = [];
  }
  return {
    // State
    currentStep: e,
    paymentSteps: t,
    previousStep: n,
    // Actions
    setCurrentStep: i,
    showPaymentStep: c,
    initStore: d,
    resetStore: a,
    //Getters
    getStepByName: (f) => {
      var g;
      return (g = t.value) == null ? void 0 : g.find((x) => x.name == f);
    }
  };
});
const l5 = oo("showHide", () => {
  const e = $e(!0);
  return { show: e, setShowHide: (t) => {
    e.value = t;
  } };
}), Bc = oo("filter", () => {
  const e = $e({
    rangeValueFilters: [
      { name: "PRICE", low: 0, high: 5e3, increment: 50 },
      { name: "RATING", low: 0, high: 5, increment: 1 }
    ],
    fixedValueFilters: [
      { name: "DESTINATION", values: [] },
      { name: "AMENITIES", values: [] },
      { name: "DEALS", values: [] },
      { name: "VACATION_TYPE", values: [] }
    ]
  }), t = $e([
    { name: "PRICE", selectedLow: 0, selectedHigh: 5e3 },
    { name: "RATING", selectedLow: 0, selectedHigh: 5 }
  ]), n = $e([
    { name: "DESTINATION", selectedIds: [] },
    { name: "AMENITIES", selectedIds: [] },
    { name: "DEALS", selectedIds: [] },
    { name: "VACATION_TYPE", selectedIds: [] }
  ]), i = $e(!1), r = $e(!1), c = $e(!1), d = $e(!1), a = $e(!1);
  function f(H, N) {
    return H.filter((K) => g(K, N));
  }
  function g(H, N) {
    return N.some((K) => K.id === H);
  }
  function x(H) {
    !i.value && H != null && H.length && (e.value.rangeValueFilters = H.map((N) => N.name === "RATING" ? { ...N, low: 0 } : { ...N }), t.value = t.value.map(
      (N) => {
        const K = H.find(
          (U) => U.name === N.name
        );
        return K ? K.name === "RATING" ? {
          ...N,
          selectedLow: N.selectedLow === 0 ? 0 : Math.max(
            2,
            Math.min(N.selectedLow, K.high)
          ),
          selectedHigh: Math.min(
            K.high,
            Math.max(N.selectedHigh, 2)
          )
        } : {
          ...N,
          selectedLow: Math.max(
            0,
            Math.min(N.selectedLow, K.high)
          ),
          selectedHigh: Math.min(
            K.high,
            Math.max(N.selectedHigh, 0)
          )
        } : N;
      }
    ), i.value = !0);
  }
  function $(H) {
    !r.value && H != null && H.length && (e.value.fixedValueFilters = [...H], n.value = n.value.map(
      (N) => {
        const K = H.find(
          (U) => U.name === N.name
        );
        if (K) {
          const U = f(N.selectedIds, K.values);
          return { ...N, selectedIds: U };
        }
        return N;
      }
    ), r.value = !0);
  }
  function A(H, N, K) {
    const U = t.value.find((de) => de.name === H), q = e.value.rangeValueFilters.find(
      (de) => de.name === H
    ), ee = (q == null ? void 0 : q.low) ?? 0, te = (q == null ? void 0 : q.high) ?? (H === "PRICE" ? 5e3 : 5);
    let ae = N ?? ee, oe = K ?? te;
    H === "RATING" && ae === 0 ? ae = 0 : ae = Math.max(ee, ae), oe = Math.min(te, oe), U ? (U.selectedLow = ae, U.selectedHigh = oe) : t.value.push({
      name: H,
      selectedLow: ae,
      selectedHigh: oe
    });
  }
  function I(H, N) {
    const K = n.value.find((ee) => ee.name === H), U = e.value.fixedValueFilters.find(
      (ee) => ee.name === H
    ), q = N && N.length > 0 ? f(N, (U == null ? void 0 : U.values) ?? []) : [];
    K ? K.selectedIds = q : n.value.push({ name: H, selectedIds: q });
  }
  function O() {
    t.value = [
      { name: "PRICE", selectedLow: 0, selectedHigh: 5e3 },
      { name: "RATING", selectedLow: 0, selectedHigh: 5 }
    ], n.value = [
      { name: "DESTINATION", selectedIds: [] },
      { name: "AMENITIES", selectedIds: [] },
      { name: "DEALS", selectedIds: [] },
      { name: "VACATION_TYPE", selectedIds: [] }
    ], c.value = !1, d.value = !1;
  }
  const B = Ae(() => {
    const H = {}, N = t.value.find(
      (ae) => ae.name === "PRICE"
    );
    N && (N.selectedLow > 0 || N.selectedHigh < 5e3) && (H.fprice = `${N.selectedLow}-${N.selectedHigh}`);
    const K = t.value.find(
      (ae) => ae.name === "RATING"
    );
    K && (K.selectedLow > 0 || K.selectedHigh < 5) && (H.frating = `${K.selectedLow}-${K.selectedHigh}`);
    const U = n.value.find(
      (ae) => ae.name === "DESTINATION"
    );
    U != null && U.selectedIds.length && (H.fdest = U.selectedIds.join(","));
    const q = n.value.find(
      (ae) => ae.name === "AMENITIES"
    );
    q != null && q.selectedIds.length && (H.famenities = q.selectedIds.join(","));
    const ee = n.value.find(
      (ae) => ae.name === "DEALS"
    );
    ee != null && ee.selectedIds.length && (H.fdeal = ee.selectedIds.join(","));
    const te = n.value.find(
      (ae) => ae.name === "VACATION_TYPE"
    );
    return te != null && te.selectedIds.length && (H.fVacationType = te.selectedIds.join(",")), H;
  });
  return {
    filters: e,
    selectedRangeFilters: t,
    selectedFixedFilters: n,
    rangeFiltersInitialized: i,
    fixedFiltersInitialized: r,
    moreAmenitiesShow: c,
    moreDestinationsShow: d,
    hasPreviouslyAppliedFilters: a,
    updateAvailableRangeFilters: x,
    updateAvailableFixedFilters: $,
    updateSelectedRangeFilters: A,
    updateSelectedFixedFilters: I,
    resetFilters: O,
    searchOptionsFilters: B
  };
});
oo("plp", () => {
  const e = Bc(), t = $e(ps.PackagesSpa), n = $e({
    offset: 0,
    lang: da() || "en",
    sort: t.value === ps.PackagesSpa ? gw.recommended : gw.priceasc,
    ...e.searchOptionsFilters
  });
  function i(c) {
    Object.assign(n.value, c);
  }
  function r(c) {
    t.value = c;
  }
  return At(
    () => e.searchOptionsFilters,
    (c) => {
      [
        "fprice",
        "frating",
        "fdest",
        "famenities",
        "fdeal",
        "fVacationType"
      ].forEach((d) => {
        delete n.value[d];
      }), Object.assign(n.value, c);
    },
    { deep: !0 }
  ), {
    searchOptions: n,
    updateSearchOptions: i,
    setSpaType: r
  };
});
oo("packageId", () => {
  const e = $e(), t = $e(!1);
  function n(i) {
    e.value = i, t.value = !0;
  }
  return { packId: e, selected: t, setPackageId: n };
});
oo("passengers", () => {
  const e = $e([]), t = $e({});
  function n(d) {
    e.value = d;
  }
  function i(d) {
    t.value = d;
  }
  function r(d) {
    const a = e.value.find(
      (f) => f.id === d.id
    );
    a && Object.assign(a, d);
  }
  function c(d) {
    return e.value.map((a, f) => {
      const g = d.passengers[f];
      return g ? {
        ...a,
        ...g,
        originalTitle: a.title,
        originalFirstName: a.firstName,
        originalMiddleName: a.middleName,
        originalLastName: a.lastName,
        originalPhoneNumber: a.phoneNumber,
        originalEmailAddress: a.emailAddress,
        originalBirthdayFormatted: a.birthdayFormatted,
        originalDob: a.dob,
        originalAeroplanNum: a.aeroplanNum
      } : a;
    });
  }
  return {
    storedPassengers: e,
    formData: t,
    setFormData: i,
    setStoredPassengers: n,
    updateStoredPassenger: r,
    mapPassengerUpdatesToStoredPassengers: c
  };
});
var G1 = /* @__PURE__ */ ((e) => (e.POST = "POST", e.GET = "GET", e.PUT = "PUT", e))(G1 || {});
function EE(e) {
  let t = 1;
  const n = $e(null), i = $e(!1), r = $e(null), c = $e(null), d = async (g, x) => {
    const $ = x > 1;
    await c5(
      {
        refreshToken: $,
        composableOptions: e
      },
      n,
      i,
      r,
      c,
      g,
      f
    );
  };
  At(c, (g) => {
    t = u5(
      g,
      a,
      t,
      d,
      e.retryCount,
      e.shouldSendSentry,
      e.sentryErrorCodeFilter
    );
  });
  const { APIOptions: a, body: f } = e;
  return X0(a) ? At(
    a,
    (g) => {
      d(g, t);
    },
    {
      immediate: !0
    }
  ) : d(a, t), {
    data: n,
    loading: i,
    error: r
  };
}
const c5 = async function(e, t, n, i, r, c = {}, d) {
  const { refreshToken: a, composableOptions: f } = e, { getRequestUrl: g, fetchAbortTimeout: x } = f;
  let { method: $ } = f;
  $ ?? ($ = "GET");
  const A = {
    method: $,
    timeout: x
  };
  i.value = null, r.value = null, n.value = !0;
  try {
    const I = await window.sso.getUserToken(a);
    try {
      const O = g(c), B = TE(I, d), H = {
        ...A,
        ...B
      };
      if ($ === "POST")
        H.body = JSON.stringify(c);
      else if ($ === "PUT") {
        const { quoteId: U, ...q } = c;
        H.body = JSON.stringify(q);
      }
      const N = await L1(O, H), K = await N.json();
      if (N.ok) {
        if (("title" in K || "errorDetail" in K) && "status" in K && "detail" in K)
          throw Kg(K);
        t.value = K;
      } else if (W1(K.status, K.detail))
        r.value = K;
      else
        throw Kg(K);
    } catch (O) {
      i.value = O instanceof Error ? O : Error(JSON.stringify(O));
    }
  } catch (I) {
    r.value = {
      status: "JWT_TOKEN_ERROR",
      title: JSON.stringify(I),
      detail: JSON.stringify(I)
    };
  } finally {
    n.value = !1;
  }
}, u5 = (e, t, n, i, r, c, d) => {
  if (e) {
    const { status: a, detail: f, errorDetail: g } = e;
    if (a === 401 && n < r)
      return n++, i(t, n), n;
    if (W1(a, f)) {
      const { setStatus: x } = lE();
      x(e);
    }
    Md(Error(f ?? g ?? "No detail|errorDetail have been received from microservice"), c, d);
  }
  return n;
};
function d5(e, t) {
  return EE({
    APIOptions: e,
    getRequestUrl: () => t5(new URL(t.host), e).toString(),
    method: G1.PUT,
    fetchAbortTimeout: t.fetchAbortTimeout,
    host: t.host,
    paginationSize: t.paginationSize,
    sentryErrorCodeFilter: t.sentryErrorCodeFilter,
    shouldSendSentry: t.shouldSendSentry,
    retryCount: t.retryCount
  });
}
function p5(e, t) {
  return EE({
    APIOptions: e,
    getRequestUrl: () => e5(new URL(t.host), e).toString(),
    method: G1.PUT,
    fetchAbortTimeout: t.fetchAbortTimeout,
    host: t.host,
    sentryErrorCodeFilter: t.sentryErrorCodeFilter,
    shouldSendSentry: t.shouldSendSentry,
    retryCount: t.retryCount
  });
}
const h5 = "/form-of-payment", Y1 = h5 + "/threeDS", f5 = Y1 + "/cardLookup", m5 = Y1 + "/authentication", v5 = Y1 + "/cavvLookup";
async function g5(e, t) {
  try {
    return await bh(
      new URL(t + f5),
      JSON.stringify(e),
      "POST"
    );
  } catch (n) {
    return zc(n, !0), !1;
  }
}
async function y5(e, t) {
  try {
    return await bh(
      new URL(t + m5),
      JSON.stringify(e),
      "POST"
    );
  } catch (n) {
    return zc(n), !1;
  }
}
async function _5(e, t) {
  try {
    return await bh(
      new URL(t + v5),
      JSON.stringify(e),
      "POST"
    );
  } catch (n) {
    return zc(n), !1;
  }
}
async function b5(e = "3ds") {
  return new Promise((t) => {
    const n = (i) => {
      var r, c;
      (c = (r = i.data) == null ? void 0 : r.origin) != null && c.includes(e) && (t({
        status: i.data.status,
        result: i.data.result
      }), window.removeEventListener("message", n));
    };
    window.addEventListener("message", n);
  });
}
function w5(e, t, n) {
  const i = $e(), r = $e(), c = $e(), d = $e(), a = $e(), f = xo(), { incrementCreditCard3DSFailures: g } = f;
  async function x(I, O) {
    var B, H, N, K;
    let U = !0;
    for (let q = 0; q < I.length; q++) {
      const ee = await $(
        I[q],
        q,
        O
      );
      if (ee) {
        if (((B = ee.threeDS) == null ? void 0 : B.authStatus) === "challenge") {
          if (i.value = (H = ee.threeDS) == null ? void 0 : H.challengeURL, r.value = (N = ee.threeDS) == null ? void 0 : N.challengeData, U = await A(q, O), !U) {
            g(q);
            break;
          }
        } else if (((K = ee.threeDS) == null ? void 0 : K.authStatus) === "reject") {
          U = !1;
          break;
        }
      }
    }
    return U;
  }
  async function $(I, O, B) {
    var H, N, K, U, q;
    I.id = ey.generateId(12);
    let ee = Nb(
      I,
      B
    );
    const te = await g5(
      ee,
      t
    );
    if (te && (H = e == null ? void 0 : e.payment) != null && H.creditCards && (e.payment.creditCards[O] = te, ((N = te.threeDS) == null ? void 0 : N.transStatus) !== "X")) {
      n && (c.value = (K = te.threeDS) == null ? void 0 : K.threeDSMethodURL, d.value = (U = te.threeDS) == null ? void 0 : U.threeDSServerTransId, a.value = (q = te.threeDS) == null ? void 0 : q.threeDSMethodData), ee = Nb(
        te,
        B
      );
      const ae = await y5(
        ee,
        t
      );
      if (c.value = void 0, d.value = void 0, a.value = void 0, ae)
        return e.payment.creditCards[O] = ae, ae;
    }
    return !1;
  }
  async function A(I, O) {
    var B, H;
    const N = await b5();
    if (N.status === "success" && (B = e == null ? void 0 : e.payment) != null && B.creditCards) {
      e.payment.creditCards[I].threeDS.cresData = N.result, i.value = void 0, r.value = void 0;
      const K = Nb(
        e.payment.creditCards[I],
        O
      ), U = await _5(
        K,
        t
      );
      if (U)
        return e.payment.creditCards[I] = U, !!((H = U.threeDS) != null && H.accepted);
    }
    return !0;
  }
  return {
    challengeUrl: i,
    challengeData: r,
    fingerprintUrl: c,
    threeDSServerTransId: d,
    threeDSMethodData: a,
    processCreditCardsVia3DS: x
  };
}
function Nb(e, t) {
  return {
    gatewayAirport: t,
    creditCard: e
  };
}
let Ad;
function x5() {
  const e = /* @__PURE__ */ new Map();
  return e.set(Sc, {
    hpciCVVValid: !1,
    hpciCardNumberTouched: !1,
    hpciCardNumberValid: !1,
    hpciCVVTouched: !1,
    hpciCCNumToken: "",
    hpciCVVToken: "",
    hpciResponded: !1,
    hpciLateResponse: !1
  }), e;
}
function $5(e) {
  const t = window.hpciCards.get(e.hpciMsgSrcFrameName);
  t && (t.hpciCardNumberTouched = !0, +e.hpciCCLengthValue > 1 && e.hpciCCBINValue && !e.hpciCCBINValue.startsWith(
    F1
  ) && !e.hpciCCBINValue.startsWith(
    R1
  ) && !e.hpciCCBINValue.startsWith(
    z1
  ) && !e.hpciCCBINValue.startsWith(B1) ? (window.sendHPCIChangeTextFrameMsg(
    e.hpciMsgSrcFrameName,
    Za,
    Ad.ccTypeNotAccepted
  ), window.sendHPCIChangeStyleFrameMsg(
    e.hpciMsgSrcFrameName,
    Za,
    "display",
    "block"
  )) : window.sendHPCIChangeStyleFrameMsg(
    e.hpciMsgSrcFrameName,
    Za,
    "display",
    "none"
  ));
}
function C5(e) {
  const t = window.hpciCards.get(e.hpciMsgSrcFrameName);
  return t ? (t.hpciCardNumberTouched = !0, t.hpciCardNumberValid = !1, +e.hpciCCLengthValue < 1 ? (window.sendHPCIChangeTextFrameMsg(
    e.hpciMsgSrcFrameName,
    Za,
    Ad.noCardNumber
  ), window.sendHPCIChangeStyleFrameMsg(
    e.hpciMsgSrcFrameName,
    Za,
    "display",
    "block"
  )) : +e.hpciCCLengthValue > 1 && e.hpciCCBINValue && !e.hpciCCBINValue.startsWith(
    F1
  ) && !e.hpciCCBINValue.startsWith(
    R1
  ) && !e.hpciCCBINValue.startsWith(
    z1
  ) && !e.hpciCCBINValue.startsWith(B1) ? (window.sendHPCIChangeTextFrameMsg(
    e.hpciMsgSrcFrameName,
    Za,
    Ad.ccTypeNotAccepted
  ), window.sendHPCIChangeStyleFrameMsg(
    e.hpciMsgSrcFrameName,
    Za,
    "display",
    "block"
  )) : I5(
    e.hpciCCBINValue,
    e.hpciCCLengthValue,
    e.hpciCCEnteredLengthValue,
    e.hpciCCValidValue
  ) ? t.hpciCardNumberValid = !0 : (window.sendHPCIChangeTextFrameMsg(
    e.hpciMsgSrcFrameName,
    Za,
    Ad.ccWrongFormat
  ), window.sendHPCIChangeStyleFrameMsg(
    e.hpciMsgSrcFrameName,
    Za,
    "display",
    "block"
  )), t.hpciCardNumberValid) : !1;
}
function k5(e) {
  const t = window.hpciCards.get(e.hpciMsgSrcFrameName);
  t && (t.hpciCVVTouched = !0, (+e.hpciCVVLengthValue >= 3 || e.hpciCVVValidValue == "Y") && window.sendHPCIChangeStyleFrameMsg(
    e.hpciMsgSrcFrameName,
    $d,
    "display",
    "none"
  ));
}
function S5(e) {
  const t = window.hpciCards.get(e.hpciMsgSrcFrameName);
  return t ? (t.hpciCVVTouched = !0, t.hpciCVVValid = !1, +e.hpciCVVLengthValue < 1 ? (window.sendHPCIChangeTextFrameMsg(
    e.hpciMsgSrcFrameName,
    $d,
    Ad.noCVV
  ), window.sendHPCIChangeStyleFrameMsg(
    e.hpciMsgSrcFrameName,
    $d,
    "display",
    "block"
  )) : +e.hpciCVVLengthValue >= 3 && +e.hpciCVVLengthValue <= 4 && e.hpciCVVValidValue == "Y" ? t.hpciCVVValid = !0 : (window.sendHPCIChangeTextFrameMsg(
    e.hpciMsgSrcFrameName,
    $d,
    Ad.cvvWrongFormat
  ), window.sendHPCIChangeStyleFrameMsg(
    e.hpciMsgSrcFrameName,
    $d,
    "display",
    "block"
  )), t.hpciCVVValid) : !1;
}
function T5(e) {
  Ad = {
    ccTypeNotAccepted: e("vacvComponents.payment.errors.ccTypeNotAccepted"),
    noCardNumber: e("vacvComponents.payment.errors.noCardNumber"),
    ccWrongFormat: e("vacvComponents.payment.errors.ccWrongFormat"),
    noCVV: e("vacvComponents.payment.errors.noCVV"),
    cvvWrongFormat: e("vacvComponents.payment.errors.cvvWrongFormat")
  }, window.hpciCards = x5(), window.customHPCICCTypingValidation = $5, window.customHPCICCValidation = C5, window.customHPCICVVTypingValidation = k5, window.customHPCICVVValidation = S5;
}
function I5(e, t, n, i) {
  return !!(e && (e.startsWith(z1) || e.startsWith(B1)) && +t == 15 && +n == 17 && i == "Y" || e && (e.startsWith(F1) || e.startsWith(R1)) && +t == 16 && +n == 19 && i == "Y");
}
function PE(e, t) {
  window.hpciCards.forEach((n, i) => {
    n && (n.hpciCardNumberTouched || (ME(i, e), n.hpciCardNumberValid = !1), n.hpciCVVTouched || (window.sendHPCIChangeTextFrameMsg(
      i,
      $d,
      t
    ), window.sendHPCIChangeStyleFrameMsg(
      i,
      $d,
      "display",
      "block"
    ), n.hpciCVVValid = !1));
  });
}
function ME(e, t) {
  window.sendHPCIChangeTextFrameMsg(
    e,
    Za,
    t
  ), window.sendHPCIChangeStyleFrameMsg(
    e,
    Za,
    "display",
    "block"
  );
}
function A5(e, t) {
  PE(e, t);
  let n = !0;
  return window.hpciCards.forEach((i) => {
    (!i.hpciCVVValid || !i.hpciCardNumberValid) && (n = !1);
  }), n;
}
function E5() {
  window.hpciCards.set(Ml, {
    hpciCVVValid: !1,
    hpciCardNumberTouched: !1,
    hpciCardNumberValid: !1,
    hpciCVVTouched: !1,
    hpciCCNumToken: "",
    hpciCVVToken: "",
    hpciResponded: !1,
    hpciLateResponse: !1
  });
}
function Fb() {
  window.hpciCards.delete(Ml);
}
function P5() {
  window.hpciCards.forEach((e) => {
    e.hpciCardNumberValid = !1, e.hpciCVVValid = !1, e.hpciCardNumberTouched = !1, e.hpciCVVTouched = !1, e.hpciCCNumToken = "", e.hpciCVVToken = "", e.hpciResponded = !1, e.hpciLateResponse = !1;
  });
}
function M5(e) {
  window.customHPCIErrorHandler = function() {
    window.hpciCards.forEach((t) => {
      t.hpciResponded = !0;
    }), e();
  };
}
function DE(e, t) {
  const n = e.lang == "en" ? "en_CA" : "fr_CA";
  function i(a, f) {
    const { pathname: g = "", search: x = "" } = (window == null ? void 0 : window.location) ?? {}, $ = `${g}${x}`;
    return `${e.hpciHost}/iSynSApp/showPxyPage!ccFrame.action?pgmode1=${e.hpciPageMode}&locationName=${e.siteLoc}&enable3DSec=skip3ds&selected3DSecPayName=&selected3DSecPayCurISO=&enableEarlyToken=Y&enableTokenDisplay=Y&reportCCType=Y&reportCCDigits=Y&reportCVVDigits=Y&strictMsgFmt=Y&ccFrameName=${a}&sid=${e.siteId}&fullParentHost=${e.parentHost}&fullParentQStr=${$}&ccTypeMapMode=def&formatCCDigits=Y&formatCCDigitsDelimiter=-&formatCCMaskMode=S2L2&formatCCMaskChar=*&reportInit=Y&lang=${n}&ccNumTokenIdx=${f}`;
  }
  function r(a) {
    const f = window.hpciCards.get(a);
    return f && !f.hpciResponded ? (f.hpciLateResponse = !0, !1) : !0;
  }
  function c(a, f) {
    const g = window.hpciCards.get(a);
    g && (g.hpciResponded = !1, g.hpciLateResponse = !1, setTimeout(() => {
      r(a) || f(a);
    }, e.fetchApiTimeout), window.hpciStatusReset(), window.hpciCCFrameName = a, window.sendHPCIMsg());
  }
  async function d(a, f, g) {
    window.customHPCIHandler = function(x) {
      var $, A;
      const I = window.hpciCards.get(x.hpciMsgSrcFrameName);
      if (I) {
        if (I.hpciLateResponse)
          return;
        if (I.hpciResponded = !0, I.hpciCCNumToken = x.hpciMappedCCValue, I.hpciCVVToken = x.hpciMappedCVVValue, window.hpciCards.size > 1 && x.hpciMsgSrcFrameName == Sc && c(Ml, g), window.hpciCards.size === 1 && x.hpciMsgSrcFrameName == Sc || // Pay with one credit card
        window.hpciCards.size > 1 && x.hpciMsgSrcFrameName == Ml) {
          if (window.hpciCards.size > 1 && (($ = window.hpciCards.get(Sc)) == null ? void 0 : $.hpciCCNumToken) === ((A = window.hpciCards.get(Ml)) == null ? void 0 : A.hpciCCNumToken)) {
            ME(
              Ml,
              t("vacvComponents.payment.errors.repeatCC")
            ), I.hpciCardNumberValid = !1, f();
            return;
          }
          a();
        }
      }
    };
  }
  return {
    retreiveIframeURL: i,
    submitHpciIFrame: c,
    checkIfHasHPCIResponse: r,
    initCustomHPCISubmitHandler: d
  };
}
function D5(e) {
  const t = xo(), {
    isPaymentMethodGiftCard: n,
    selectDeposit: i,
    depositAmount: r,
    amountToPay: c,
    giftCardAmount: d,
    giftCardNumber: a,
    giftCardPIN: f,
    toggle2cc: g,
    sameBillingAddress: x,
    card1: $,
    card2: A
  } = Nn(t);
  function I(N, K, U, q, ee) {
    const te = K.hpciCCNumToken, ae = parseInt(te), oe = K.hpciCVVToken, de = parseInt(oe);
    let me;
    g.value || n.value && d.value > 0 ? (me = Iu(
      e,
      N.creditCardAmount
    ), ee && (me = H(me, ee))) : i.value && r.value !== null ? (me = r.value, ee && (me = H(me, ee))) : (me = c.value, ee && (me = H(me, ee)));
    const ve = e == "en" ? uw.enCA : uw.frCA, re = {
      currency: "cad",
      creditCardToken: ae,
      cardSecurityCode: de,
      expirationMonth: N.creditCardExpiry.substring(0, 2),
      expirationYear: N.creditCardExpiry.substring(3, 5),
      nameOnCard: N.creditCardName,
      amount: me,
      language: ve
    };
    let le;
    N.creditCardIframeName === Sc ? le = N : x.value ? le = $.value : le = N;
    const pe = ry(
      le,
      U,
      q
    );
    return {
      ...re,
      ...pe
    };
  }
  function O(N, K, U) {
    const q = ry(
      $.value,
      N,
      K
    ), ee = [], te = window.hpciCards.get(Sc);
    te && ee.push(
      I(
        $.value,
        te,
        N,
        K,
        U
      )
    );
    const ae = window.hpciCards.get(Ml);
    g.value && ae && ee.push(
      I(
        A.value,
        ae,
        N,
        K
      )
    );
    const oe = B();
    return {
      billingAddress: q,
      creditCards: ee,
      giftCards: oe
    };
  }
  function B() {
    if (n.value)
      return [{
        number: a.value,
        securityCode: f.value,
        amount: d.value,
        currency: "cad"
      }];
  }
  function H(N, K) {
    const U = (N - K).toFixed(2);
    let q = parseFloat(U);
    return q < 0 && (q = 0), q;
  }
  return {
    generateMicroServicePaymentRequest: O,
    extractGiftCards: B
  };
}
function ry(e, t, n) {
  return {
    address1: e.address,
    address2: e.apartment,
    city: e.city,
    province: e.state,
    country: e.country,
    postalCode: e.postcode,
    phone: t,
    email: n
  };
}
const LE = () => {
  const e = $e(!1), t = $e(-1), n = $e(-1), { upliftTokenAvailable: i } = Nn(Dd()), r = zu(), c = $e(0), { pointsToRedeem: d, dollarValue: a } = Nn(r), f = xo(), { isPaymentMethodUplift: g } = Nn(f), x = $e(), {
    setDropDownBookingSummaryExecuted: $,
    setDropDownCheckoutFormExecuted: A,
    setShowAeroPlanPointsDropDown: I
  } = r, {
    dropDownBookingSummaryExecuted: O,
    dropDownCheckoutFormExecuted: B,
    showAeroPlanPointsDropDown: H
  } = Nn(r), N = (q) => {
    q.value += 1;
  }, K = () => {
    e.value = !0;
  }, U = (q, ee, te, ae) => {
    c.value = ae.value, q === "OK" ? (ee(te), e.value = !1) : (e.value = !1, I(!0), N(c), I(!1), $(!1), A(!1));
  };
  return At(
    () => H.value,
    (q) => {
      (q !== void 0 || q) && (N(c), I(!1), $(!1), A(!1));
    }
  ), {
    componentKey: c,
    aeOption: x,
    displayUpliftWarningModalAeroplan: e,
    executeCloseUpLiftWarningModalAeroplan: U,
    executeAeroplanPointsSelection: async (q, ee) => {
      if (x.value = q, A(!1), d.value != (q == null ? void 0 : q.value) && (t.value = d.value, n.value = a.value), t.value === -1 && (q == null ? void 0 : q.value) == 0 || t.value === 0 && (q == null ? void 0 : q.value) == -1 || t.value === -1 && (q == null ? void 0 : q.value) == -1 && g.value && i.value) {
        ee(q);
        return;
      }
      g.value && i.value ? q && !O.value && !B.value ? ($(!0), A(!0), K()) : I(!0) : ee(q);
    },
    onOpenUpliftWarningModal: K,
    forceRerender: N
  };
}, K1 = (e) => {
  const t = $e(), n = $e(), i = $e(!1), { reset: r } = zu();
  return At(
    e,
    async (c) => {
      var d, a;
      t.value = await window.sso.getAeroplanPoints();
      const f = (a = (d = kc(c)) == null ? void 0 : d[0]) == null ? void 0 : a.points;
      n.value = f ? parseInt(f) : void 0, i.value = !!(t.value && t.value > 0 && n.value && t.value >= n.value);
    },
    { immediate: !0 }
  ), At(i, (c) => {
    c || r();
  }), {
    userPoints: t,
    redemptionEligible: i
  };
};
function X1(e, t = 100) {
  const n = IE(e, t);
  Li(function() {
    window.addEventListener("resize", n);
  }), tl(function() {
    window.removeEventListener("resize", n);
  });
}
const L5 = () => {
  const e = $e(window.innerWidth);
  X1(() => {
    e.value = window.innerWidth;
  });
  const t = Ae(() => e.value >= 991), n = Ae(
    () => e.value >= 768 && e.value < 991
  ), i = Ae(() => n.value || t.value);
  return {
    deviceSize: e,
    isDesktop: t,
    isTablet: n,
    isTabletAndUp: i
  };
};
$e();
const OE = () => {
  const e = $e(window.innerWidth > 991), t = IE(() => {
    e.value = window.innerWidth > 991;
  }, 100), n = () => {
    window.addEventListener("resize", t);
  }, i = () => {
    window.removeEventListener("resize", t);
  };
  return Li(n), f1(i), e;
}, O5 = (e = "left-start", t = "top") => {
  const n = $e(), i = $e(e), r = () => {
    n.value = HF();
  };
  return X1(r), At(n, async (c) => {
    c && (c < Qg.tablet ? i.value = t : i.value = e);
  }), Li(() => {
    r();
  }), {
    placement: i
  };
};
$e(!1);
function N5(e, t) {
  const n = {
    event: F5(e),
    aeroplanElement: "Points Tier Selector - Booking Summary",
    aeroplanElementValue: t
  };
  window.dataLayer.push(n);
}
function F5(e) {
  switch (e) {
    case "FlightDetails":
      return "flightAeroplan";
    case "Ancillary":
      return "ancilAeroplan";
    case "ProductDetails":
      return "pdpAeroplan";
    default:
      return "undefined component name";
  }
}
const R5 = () => {
  NE("Join Aeroplan");
}, z5 = () => {
  NE("Aeroplan number(s)");
};
function NE(e) {
  const t = {
    event: "confirmationAeroplan",
    aeroplanElement: e
  };
  window.dataLayer.push(t);
}
const B5 = () => {
  J1("Sign In");
}, V5 = () => {
  J1("Continue As Guest");
}, U5 = () => {
  J1("Close the Overlay (X)");
};
function J1(e) {
  const t = {
    event: "signInCheckoutModal",
    modalOption: e
  };
  window.dataLayer.push(t);
}
var _w = /* @__PURE__ */ ((e) => (e.show = "Show Options", e.hide = "Hide Options", e))(_w || {});
function H5(e, t) {
  const n = {
    event: "ancillaryOptions",
    ancillaryGroup: N1.get(e) ?? "",
    ancillaryOption: t
  };
  window.dataLayer.push(n);
}
function FE(e, t) {
  const n = {
    event: "ancillaryProduct",
    ancillaryGroup: N1.get(e) ?? "",
    ancillaryProduct: t
  };
  window.dataLayer.push(n);
}
function W5(e, t) {
  const n = {
    event: "ancillarySubOptions",
    ancillaryGroup: N1.get(e) ?? "",
    ancillaryProduct: t
  };
  window.dataLayer.push(n);
}
function Z5(e) {
  const t = {
    event: "checkoutPromoCode",
    chkPromoCode: e
  };
  window.dataLayer.push(t);
}
function q5() {
  const e = {
    event: "checkoutEngDocs"
  };
  window.dataLayer.push(e);
}
const bw = (e, t) => {
  if ("itineraries" in e) {
    const n = Object.values(e.itineraries)[0].segments;
    if (n) {
      const i = [
        ...new Set(n.map((d) => d.cabinClassName))
      ], r = q1(
        Object.values(e.itineraries)[0]
      ), c = Object.values(e.hotels ?? {}).map((d) => d.name).join(", ");
      j5(
        t,
        i.toString().replace(",", ";"),
        kE(r),
        c
      );
    }
  }
};
function j5(e, t, n, i) {
  const r = {
    event: e,
    budgetProductLine: n,
    cabinClass: t
  };
  e === "confirmationPrivTransfer" && i && (r.confHotelName = i), window.dataLayer.push(r);
}
function G5(e, t, n, i, r, c) {
  window.dataLayer.push({ ecommerce: null });
  const d = {
    event: "add_payment_info",
    payment_plan: X5(i, r),
    //  'Payment plan selected by user: one of [Pay in Full] OR [Pay Monthly] OR [Book With a Deposit]>',
    payment_type: c,
    // 'payment_type': '<Payment option selected by user: one or more of [Gift Card/Coupon/Voucher] OR [FTC] OR [Credit Card] OR [Flex Pay] OR [Aeroplan Points]>',
    ecommerce: {
      items: [J5(e, t, n)]
    }
  };
  window.dataLayer.push(d);
}
function Y5(e) {
  window.dataLayer.push({ ecommerce: null });
  const t = {
    event: "checkoutPaymentToggle",
    chkPayToggleElement: e
  };
  window.dataLayer.push(t);
}
function K5(e) {
  const t = {
    event: "checkoutPaymentMethod",
    checkoutPayMethod: e
  };
  window.dataLayer.push(t);
}
function X5(e, t) {
  return e ? "Book With a Deposit" : t ? "Pay Monthly" : "Pay in Full";
}
function J5(e, t, n) {
  return j4(e, t, n);
}
function Rb(e, t, n) {
  const i = {
    event: "pdpRoomTileLinks",
    roomLinkName: e,
    roomMealPlan: t,
    roomHotelName: n
  };
  window.dataLayer.push(i);
}
function Q5(e, t, n) {
  const i = CE(t, "Room"), r = J4(n), c = {
    event: "pdpSelect",
    roomPosition: e,
    roomPsychTrigger: i,
    roomPriceDifference: r
  };
  window.dataLayer.push(c);
}
function RE(e, t) {
  const n = {
    event: "pdpMaps",
    mapsHotelName: e,
    mapsDestination: t
  };
  window.dataLayer.push(n);
}
function e6(e) {
  const t = {
    event: "pdpRoomNav",
    roomNavName: e
  };
  window.dataLayer.push(t);
}
function t6() {
  const e = {
    event: "pageElements",
    pageElementName: "Back to Top Button",
    mpePageURL: document.location.href
  };
  window.dataLayer.push(e);
}
function n6(e, t) {
  var n, i, r;
  if (t.deals.length && kp(t.deals, "Deals"), t.rating) {
    const c = t.rating.substring(
      0,
      t.rating.indexOf("-")
    );
    if (c) {
      const d = c + (c === "5" ? "" : " & up");
      kp(d, "Star Rating");
    }
  }
  if (t.destinations.length) {
    const c = [], d = pw(e);
    t.destinations.forEach((a) => {
      const f = d.find(
        (g) => g.value === a
      );
      f && c.push(f.label);
    }), kp(c, "Destinations");
  }
  (n = t.amenities) != null && n.length && kp(t.amenities, "Amenities"), (i = t.vacationType) != null && i.length && kp(t.vacationType, "Vacation Type"), (r = t.priceRange) != null && r.length && kp(
    rE(t.priceRange),
    "Price Range"
  );
}
function kp(e, t) {
  const n = {
    event: "plpFilters",
    filterName: t,
    filterValue: Array.isArray(e) ? e.join(",") : e
  };
  window.dataLayer.push(n);
}
function i6(e, t, n, i, r) {
  window.dataLayer.push({ ecommerce: null });
  const c = {
    event: "select_item",
    ecommerce: {
      items: [
        r6(e, t, n, i, r)
      ]
    }
  };
  window.dataLayer.push(c);
}
function r6(e, t, n, i, r) {
  var c;
  return {
    ...$E(e, t, n, i, r),
    product_badge: n.recommended ? "Our Recommendation" : "none",
    rate_type: ((c = t.information) == null ? void 0 : c.refundable) === !0 ? "Refundable" : "Non-refundable",
    hotel_type: "dynamicPackage" in t && t.dynamicPackage ? "External" : "Internal"
  };
}
function ia(e, t) {
  const n = {
    event: "plpTiles",
    tileElementName: e,
    tileElementValue: t
  };
  window.dataLayer.push(n);
}
const s6 = (e, t, n) => {
  const i = {
    event: e,
    aeroplanElement: n
  };
  i.aeroplanElementValue = t, window.dataLayer.push(i);
};
function zE(e) {
  const t = {
    event: "insurancePlanSelect",
    insurancePlanChosen: e
  };
  window.dataLayer.push(t);
}
const Au = TN({
  legacy: !1,
  locale: "en",
  globalInjection: !0,
  fallbackLocale: "en",
  messages: {
    en: NN,
    fr: FN
  }
});
Au.global.setNumberFormat("en", tE);
Au.global.setNumberFormat("fr", tE);
Au.global.setDateTimeFormat("en", eE.en);
Au.global.setDateTimeFormat("fr", eE.fr);
const o6 = { class: "was-price" }, a6 = { class: "was" }, l6 = { class: "sr-only" }, c6 = { class: "save" }, u6 = /* @__PURE__ */ at({
  __name: "VacvWasPrice",
  props: {
    percentage: {},
    wasPrice: {}
  },
  emits: ["toggle"],
  setup(e) {
    return (t, n) => (V(), G("div", o6, [
      E("button", {
        type: "button",
        class: "was-price-popover-link link",
        "aria-haspopup": "true",
        onClick: n[0] || (n[0] = (i) => t.$emit("toggle"))
      }, [
        E("del", a6, [
          E("span", l6, Y(t.$t("vacvComponents.wasPrice.was")), 1),
          mt(Y(ne(Wn)(t.wasPrice, t.$n, !1)), 1)
        ]),
        E("span", c6, " " + Y(t.$t("vacvComponents.wasPrice.save", { percent: t.percentage })), 1)
      ])
    ]));
  }
}), d6 = { class: "vacv-trip-advisor" }, p6 = { class: "vacv-trip-advisor__rating" }, h6 = ["src", "alt"], f6 = { class: "vacv-trip-advisor__reviews" }, BE = /* @__PURE__ */ at({
  __name: "VacvTripAdvisor",
  props: {
    rating: {}
  },
  setup(e) {
    const { t } = ki({ useScope: "global" }), n = e, i = Ae(() => n.rating.reviews === 1 ? t("vacvComponents.tripAdvisor.review") : t("vacvComponents.tripAdvisor.reviews"));
    return (r, c) => (V(), G("div", d6, [
      E("span", p6, [
        E("img", {
          src: r.rating.ratingImageUrl,
          alt: ne(t)("vacvComponents.tripAdvisor.access-rating") + r.rating.value + ne(t)("vacvComponents.tripAdvisor.access-bubbles")
        }, null, 8, h6)
      ]),
      E("span", f6, Y(r.$n(r.rating.reviews)) + " " + Y(i.value), 1)
    ]));
  }
});
function r_(e) {
  return m1() ? (v1(e), !0) : !1;
}
function m6(e, t) {
  if (typeof Symbol < "u") {
    const n = { ...e };
    return Object.defineProperty(n, Symbol.iterator, {
      enumerable: !1,
      value() {
        let i = 0;
        return {
          next: () => ({
            value: t[i++],
            done: i > t.length
          })
        };
      }
    }), n;
  } else
    return Object.assign([...t], e);
}
function Is(e) {
  return typeof e == "function" ? e() : ne(e);
}
const Q1 = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const v6 = Object.prototype.toString, g6 = (e) => v6.call(e) === "[object Object]", Bo = () => {
}, y6 = /* @__PURE__ */ _6();
function _6() {
  var e, t;
  return Q1 && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function VE(e, t) {
  function n(...i) {
    return new Promise((r, c) => {
      Promise.resolve(e(() => t.apply(this, i), { fn: t, thisArg: this, args: i })).then(r).catch(c);
    });
  }
  return n;
}
function b6(e, t = {}) {
  let n, i, r = Bo;
  const c = (a) => {
    clearTimeout(a), r(), r = Bo;
  };
  return (a) => {
    const f = Is(e), g = Is(t.maxWait);
    return n && c(n), f <= 0 || g !== void 0 && g <= 0 ? (i && (c(i), i = null), Promise.resolve(a())) : new Promise((x, $) => {
      r = t.rejectOnCancel ? $ : x, g && !i && (i = setTimeout(() => {
        n && c(n), i = null, x(a());
      }, g)), n = setTimeout(() => {
        i && c(i), i = null, x(a());
      }, f);
    });
  };
}
function w6(...e) {
  let t = 0, n, i = !0, r = Bo, c, d, a, f, g;
  !yo(e[0]) && typeof e[0] == "object" ? { delay: d, trailing: a = !0, leading: f = !0, rejectOnCancel: g = !1 } = e[0] : [d, a = !0, f = !0, g = !1] = e;
  const x = () => {
    n && (clearTimeout(n), n = void 0, r(), r = Bo);
  };
  return (A) => {
    const I = Is(d), O = Date.now() - t, B = () => c = A();
    return x(), I <= 0 ? (t = Date.now(), B()) : (O > I && (f || !i) ? (t = Date.now(), B()) : a && (c = new Promise((H, N) => {
      r = g ? N : H, n = setTimeout(() => {
        t = Date.now(), i = !0, H(B()), x();
      }, Math.max(0, I - O));
    })), !f && !n && (n = setTimeout(() => i = !0, I)), i = !1, c);
  };
}
function x6(e) {
  const t = /* @__PURE__ */ Object.create(null);
  return (n) => t[n] || (t[n] = e(n));
}
const $6 = /-(\w)/g, C6 = x6((e) => e.replace($6, (t, n) => n ? n.toUpperCase() : ""));
function k6(e, t) {
  var n;
  if (typeof e == "number")
    return e + t;
  const i = ((n = e.match(/^-?\d+\.?\d*/)) == null ? void 0 : n[0]) || "", r = e.slice(i.length), c = Number.parseFloat(i) + t;
  return Number.isNaN(c) ? e : c + r;
}
function S6(e) {
  return Du();
}
function T6(...e) {
  if (e.length !== 1)
    return eh(...e);
  const t = e[0];
  return typeof t == "function" ? Zy(CI(() => ({ get: t, set: Bo }))) : $e(t);
}
function I6(e, t = 200, n = {}) {
  return VE(
    b6(t, n),
    e
  );
}
function A6(e, t = 200, n = !1, i = !0, r = !1) {
  return VE(
    w6(t, n, i, r),
    e
  );
}
function UE(e, t = !0, n) {
  S6() ? Li(e, n) : t ? e() : Rl(e);
}
function HE(e, t, n = {}) {
  const {
    immediate: i = !0
  } = n, r = $e(!1);
  let c = null;
  function d() {
    c && (clearTimeout(c), c = null);
  }
  function a() {
    r.value = !1, d();
  }
  function f(...g) {
    d(), r.value = !0, c = setTimeout(() => {
      r.value = !1, c = null, e(...g);
    }, Is(t));
  }
  return i && (r.value = !0, Q1 && f()), r_(a), {
    isPending: Zy(r),
    start: f,
    stop: a
  };
}
function E6(e = {}) {
  const {
    inheritAttrs: t = !0
  } = e, n = qy(), i = /* @__PURE__ */ at({
    setup(c, { slots: d }) {
      return () => {
        n.value = d.default;
      };
    }
  }), r = /* @__PURE__ */ at({
    inheritAttrs: t,
    setup(c, { attrs: d, slots: a }) {
      return () => {
        var f;
        if (!n.value && process.env.NODE_ENV !== "production")
          throw new Error("[VueUse] Failed to find the definition of reusable template");
        const g = (f = n.value) == null ? void 0 : f.call(n, { ...P6(d), $slots: a });
        return t && (g == null ? void 0 : g.length) === 1 ? g[0] : g;
      };
    }
  });
  return m6(
    { define: i, reuse: r },
    [i, r]
  );
}
function P6(e) {
  const t = {};
  for (const n in e)
    t[C6(n)] = e[n];
  return t;
}
function Cd(e) {
  var t;
  const n = Is(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
const Hd = Q1 ? window : void 0;
function Ts(...e) {
  let t, n, i, r;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([n, i, r] = e, t = Hd) : [t, n, i, r] = e, !t)
    return Bo;
  Array.isArray(n) || (n = [n]), Array.isArray(i) || (i = [i]);
  const c = [], d = () => {
    c.forEach((x) => x()), c.length = 0;
  }, a = (x, $, A, I) => (x.addEventListener($, A, I), () => x.removeEventListener($, A, I)), f = At(
    () => [Cd(t), Is(r)],
    ([x, $]) => {
      if (d(), !x)
        return;
      const A = g6($) ? { ...$ } : $;
      c.push(
        ...n.flatMap((I) => i.map((O) => a(x, I, O, A)))
      );
    },
    { immediate: !0, flush: "post" }
  ), g = () => {
    f(), d();
  };
  return r_(g), g;
}
let QC = !1;
function WE(e, t, n = {}) {
  const { window: i = Hd, ignore: r = [], capture: c = !0, detectIframe: d = !1 } = n;
  if (!i)
    return Bo;
  y6 && !QC && (QC = !0, Array.from(i.document.body.children).forEach((A) => A.addEventListener("click", Bo)), i.document.documentElement.addEventListener("click", Bo));
  let a = !0;
  const f = (A) => r.some((I) => {
    if (typeof I == "string")
      return Array.from(i.document.querySelectorAll(I)).some((O) => O === A.target || A.composedPath().includes(O));
    {
      const O = Cd(I);
      return O && (A.target === O || A.composedPath().includes(O));
    }
  }), x = [
    Ts(i, "click", (A) => {
      const I = Cd(e);
      if (!(!I || I === A.target || A.composedPath().includes(I))) {
        if (A.detail === 0 && (a = !f(A)), !a) {
          a = !0;
          return;
        }
        t(A);
      }
    }, { passive: !0, capture: c }),
    Ts(i, "pointerdown", (A) => {
      const I = Cd(e);
      a = !f(A) && !!(I && !A.composedPath().includes(I));
    }, { passive: !0 }),
    d && Ts(i, "blur", (A) => {
      setTimeout(() => {
        var I;
        const O = Cd(e);
        ((I = i.document.activeElement) == null ? void 0 : I.tagName) === "IFRAME" && !(O != null && O.contains(i.document.activeElement)) && t(A);
      }, 0);
    })
  ].filter(Boolean);
  return () => x.forEach((A) => A());
}
function M6() {
  const e = $e(!1), t = Du();
  return t && Li(() => {
    e.value = !0;
  }, t), e;
}
function D6(e) {
  const t = M6();
  return Ae(() => (t.value, !!e()));
}
function Vp(e, t = {}) {
  const { window: n = Hd } = t, i = D6(() => n && "matchMedia" in n && typeof n.matchMedia == "function");
  let r;
  const c = $e(!1), d = (g) => {
    c.value = g.matches;
  }, a = () => {
    r && ("removeEventListener" in r ? r.removeEventListener("change", d) : r.removeListener(d));
  }, f = ra(() => {
    i.value && (a(), r = n.matchMedia(Is(e)), "addEventListener" in r ? r.addEventListener("change", d) : r.addListener(d), c.value = r.matches);
  });
  return r_(() => {
    f(), a(), r = void 0;
  }), c;
}
function L6(e, t = {}) {
  function n(x, $) {
    let A = Is(e[Is(x)]);
    return $ != null && (A = k6(A, $)), typeof A == "number" && (A = `${A}px`), A;
  }
  const { window: i = Hd, strategy: r = "min-width" } = t;
  function c(x) {
    return i ? i.matchMedia(x).matches : !1;
  }
  const d = (x) => Vp(() => `(min-width: ${n(x)})`, t), a = (x) => Vp(() => `(max-width: ${n(x)})`, t), f = Object.keys(e).reduce((x, $) => (Object.defineProperty(x, $, {
    get: () => r === "min-width" ? d($) : a($),
    enumerable: !0,
    configurable: !0
  }), x), {});
  function g() {
    const x = Object.keys(e).map(($) => [$, d($)]);
    return Ae(() => x.filter(([, $]) => $.value).map(([$]) => $));
  }
  return Object.assign(f, {
    greaterOrEqual: d,
    smallerOrEqual: a,
    greater(x) {
      return Vp(() => `(min-width: ${n(x, 0.1)})`, t);
    },
    smaller(x) {
      return Vp(() => `(max-width: ${n(x, -0.1)})`, t);
    },
    between(x, $) {
      return Vp(() => `(min-width: ${n(x)}) and (max-width: ${n($, -0.1)})`, t);
    },
    isGreater(x) {
      return c(`(min-width: ${n(x, 0.1)})`);
    },
    isGreaterOrEqual(x) {
      return c(`(min-width: ${n(x)})`);
    },
    isSmaller(x) {
      return c(`(max-width: ${n(x, -0.1)})`);
    },
    isSmallerOrEqual(x) {
      return c(`(max-width: ${n(x)})`);
    },
    isInBetween(x, $) {
      return c(`(min-width: ${n(x)}) and (max-width: ${n($, -0.1)})`);
    },
    current: g,
    active() {
      const x = g();
      return Ae(() => x.value.length === 0 ? "" : x.value.at(-1));
    }
  });
}
function O6(e, t) {
  const n = qy(g()), i = T6(e), r = Ae({
    get() {
      var x;
      let A = i.value.indexOf(n.value);
      return A < 0 && (A = (x = void 0) != null ? x : 0), A;
    },
    set(x) {
      c(x);
    }
  });
  function c(x) {
    const $ = i.value, A = $.length, I = (x % A + A) % A, O = $[I];
    return n.value = O, O;
  }
  function d(x = 1) {
    return c(r.value + x);
  }
  function a(x = 1) {
    return d(x);
  }
  function f(x = 1) {
    return d(-x);
  }
  function g() {
    var x, $;
    return ($ = Is((x = void 0) != null ? x : Is(e)[0])) != null ? $ : void 0;
  }
  return At(i, () => c(r.value)), {
    state: n,
    index: r,
    next: a,
    prev: f,
    go: c
  };
}
const ek = 1;
function N6(e, t = {}) {
  const {
    throttle: n = 0,
    idle: i = 200,
    onStop: r = Bo,
    onScroll: c = Bo,
    offset: d = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    },
    eventListenerOptions: a = {
      capture: !1,
      passive: !0
    },
    behavior: f = "auto",
    window: g = Hd,
    onError: x = (ae) => {
      console.error(ae);
    }
  } = t, $ = $e(0), A = $e(0), I = Ae({
    get() {
      return $.value;
    },
    set(ae) {
      B(ae, void 0);
    }
  }), O = Ae({
    get() {
      return A.value;
    },
    set(ae) {
      B(void 0, ae);
    }
  });
  function B(ae, oe) {
    var de, me, ve, re;
    if (!g)
      return;
    const le = Is(e);
    if (!le)
      return;
    (ve = le instanceof Document ? g.document.body : le) == null || ve.scrollTo({
      top: (de = Is(oe)) != null ? de : O.value,
      left: (me = Is(ae)) != null ? me : I.value,
      behavior: Is(f)
    });
    const pe = ((re = le == null ? void 0 : le.document) == null ? void 0 : re.documentElement) || (le == null ? void 0 : le.documentElement) || le;
    I != null && ($.value = pe.scrollLeft), O != null && (A.value = pe.scrollTop);
  }
  const H = $e(!1), N = Er({
    left: !0,
    right: !1,
    top: !0,
    bottom: !1
  }), K = Er({
    left: !1,
    right: !1,
    top: !1,
    bottom: !1
  }), U = (ae) => {
    H.value && (H.value = !1, K.left = !1, K.right = !1, K.top = !1, K.bottom = !1, r(ae));
  }, q = I6(U, n + i), ee = (ae) => {
    var oe;
    if (!g)
      return;
    const de = ((oe = ae == null ? void 0 : ae.document) == null ? void 0 : oe.documentElement) || (ae == null ? void 0 : ae.documentElement) || Cd(ae), { display: me, flexDirection: ve } = getComputedStyle(de), re = de.scrollLeft;
    K.left = re < $.value, K.right = re > $.value;
    const le = Math.abs(re) <= (d.left || 0), pe = Math.abs(re) + de.clientWidth >= de.scrollWidth - (d.right || 0) - ek;
    me === "flex" && ve === "row-reverse" ? (N.left = pe, N.right = le) : (N.left = le, N.right = pe), $.value = re;
    let Ne = de.scrollTop;
    ae === g.document && !Ne && (Ne = g.document.body.scrollTop), K.top = Ne < A.value, K.bottom = Ne > A.value;
    const We = Math.abs(Ne) <= (d.top || 0), Ge = Math.abs(Ne) + de.clientHeight >= de.scrollHeight - (d.bottom || 0) - ek;
    me === "flex" && ve === "column-reverse" ? (N.top = Ge, N.bottom = We) : (N.top = We, N.bottom = Ge), A.value = Ne;
  }, te = (ae) => {
    var oe;
    if (!g)
      return;
    const de = (oe = ae.target.documentElement) != null ? oe : ae.target;
    ee(de), H.value = !0, q(ae), c(ae);
  };
  return Ts(
    e,
    "scroll",
    n ? A6(te, n, !0, !1) : te,
    a
  ), UE(() => {
    try {
      const ae = Is(e);
      if (!ae)
        return;
      ee(ae);
    } catch (ae) {
      x(ae);
    }
  }), Ts(
    e,
    "scrollend",
    U,
    a
  ), {
    x: I,
    y: O,
    isScrolling: H,
    arrivedState: N,
    directions: K,
    measure() {
      const ae = Is(e);
      g && ae && ee(ae);
    }
  };
}
function F6(e, t = {}) {
  const {
    threshold: n = 50,
    onSwipe: i,
    onSwipeEnd: r,
    onSwipeStart: c,
    passive: d = !0,
    window: a = Hd
  } = t, f = Er({ x: 0, y: 0 }), g = Er({ x: 0, y: 0 }), x = Ae(() => f.x - g.x), $ = Ae(() => f.y - g.y), { max: A, abs: I } = Math, O = Ae(() => A(I(x.value), I($.value)) >= n), B = $e(!1), H = Ae(() => O.value ? I(x.value) > I($.value) ? x.value > 0 ? "left" : "right" : $.value > 0 ? "up" : "down" : "none"), N = (de) => [de.touches[0].clientX, de.touches[0].clientY], K = (de, me) => {
    f.x = de, f.y = me;
  }, U = (de, me) => {
    g.x = de, g.y = me;
  };
  let q;
  const ee = R6(a == null ? void 0 : a.document);
  d ? q = ee ? { passive: !0 } : { capture: !1 } : q = ee ? { passive: !1, capture: !0 } : { capture: !0 };
  const te = (de) => {
    B.value && (r == null || r(de, H.value)), B.value = !1;
  }, ae = [
    Ts(e, "touchstart", (de) => {
      if (de.touches.length !== 1)
        return;
      q.capture && !q.passive && de.preventDefault();
      const [me, ve] = N(de);
      K(me, ve), U(me, ve), c == null || c(de);
    }, q),
    Ts(e, "touchmove", (de) => {
      if (de.touches.length !== 1)
        return;
      const [me, ve] = N(de);
      U(me, ve), !B.value && O.value && (B.value = !0), B.value && (i == null || i(de));
    }, q),
    Ts(e, ["touchend", "touchcancel"], te, q)
  ];
  return {
    isPassiveEventSupported: ee,
    isSwiping: B,
    direction: H,
    coordsStart: f,
    coordsEnd: g,
    lengthX: x,
    lengthY: $,
    stop: () => ae.forEach((de) => de())
  };
}
function R6(e) {
  if (!e)
    return !1;
  let t = !1;
  const n = {
    get passive() {
      return t = !0, !1;
    }
  };
  return e.addEventListener("x", Bo, n), e.removeEventListener("x", Bo), t;
}
function ex(e = {}) {
  const {
    window: t = Hd,
    initialWidth: n = Number.POSITIVE_INFINITY,
    initialHeight: i = Number.POSITIVE_INFINITY,
    listenOrientation: r = !0,
    includeScrollbar: c = !0
  } = e, d = $e(n), a = $e(i), f = () => {
    t && (c ? (d.value = t.innerWidth, a.value = t.innerHeight) : (d.value = t.document.documentElement.clientWidth, a.value = t.document.documentElement.clientHeight));
  };
  if (f(), UE(f), Ts("resize", f, { passive: !0 }), r) {
    const g = Vp("(orientation: portrait)");
    At(g, () => f());
  }
  return { width: d, height: a };
}
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var ZE = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], sy = /* @__PURE__ */ ZE.join(","), qE = typeof Element > "u", Ld = qE ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, oy = !qE && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e == null ? void 0 : e.ownerDocument;
}, ay = function e(t, n) {
  var i;
  n === void 0 && (n = !0);
  var r = t == null || (i = t.getAttribute) === null || i === void 0 ? void 0 : i.call(t, "inert"), c = r === "" || r === "true", d = c || n && t && e(t.parentNode);
  return d;
}, z6 = function(t) {
  var n, i = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return i === "" || i === "true";
}, jE = function(t, n, i) {
  if (ay(t))
    return [];
  var r = Array.prototype.slice.apply(t.querySelectorAll(sy));
  return n && Ld.call(t, sy) && r.unshift(t), r = r.filter(i), r;
}, GE = function e(t, n, i) {
  for (var r = [], c = Array.from(t); c.length; ) {
    var d = c.shift();
    if (!ay(d, !1))
      if (d.tagName === "SLOT") {
        var a = d.assignedElements(), f = a.length ? a : d.children, g = e(f, !0, i);
        i.flatten ? r.push.apply(r, g) : r.push({
          scopeParent: d,
          candidates: g
        });
      } else {
        var x = Ld.call(d, sy);
        x && i.filter(d) && (n || !t.includes(d)) && r.push(d);
        var $ = d.shadowRoot || // check for an undisclosed shadow
        typeof i.getShadowRoot == "function" && i.getShadowRoot(d), A = !ay($, !1) && (!i.shadowRootFilter || i.shadowRootFilter(d));
        if ($ && A) {
          var I = e($ === !0 ? d.children : $.children, !0, i);
          i.flatten ? r.push.apply(r, I) : r.push({
            scopeParent: d,
            candidates: I
          });
        } else
          c.unshift.apply(c, d.children);
      }
  }
  return r;
}, YE = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, _d = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || z6(t)) && !YE(t) ? 0 : t.tabIndex;
}, B6 = function(t, n) {
  var i = _d(t);
  return i < 0 && n && !YE(t) ? 0 : i;
}, V6 = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, KE = function(t) {
  return t.tagName === "INPUT";
}, U6 = function(t) {
  return KE(t) && t.type === "hidden";
}, H6 = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(i) {
    return i.tagName === "SUMMARY";
  });
  return n;
}, W6 = function(t, n) {
  for (var i = 0; i < t.length; i++)
    if (t[i].checked && t[i].form === n)
      return t[i];
}, Z6 = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || oy(t), i = function(a) {
    return n.querySelectorAll('input[type="radio"][name="' + a + '"]');
  }, r;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    r = i(window.CSS.escape(t.name));
  else
    try {
      r = i(t.name);
    } catch (d) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", d.message), !1;
    }
  var c = W6(r, t.form);
  return !c || c === t;
}, q6 = function(t) {
  return KE(t) && t.type === "radio";
}, j6 = function(t) {
  return q6(t) && !Z6(t);
}, G6 = function(t) {
  var n, i = t && oy(t), r = (n = i) === null || n === void 0 ? void 0 : n.host, c = !1;
  if (i && i !== t) {
    var d, a, f;
    for (c = !!((d = r) !== null && d !== void 0 && (a = d.ownerDocument) !== null && a !== void 0 && a.contains(r) || t != null && (f = t.ownerDocument) !== null && f !== void 0 && f.contains(t)); !c && r; ) {
      var g, x, $;
      i = oy(r), r = (g = i) === null || g === void 0 ? void 0 : g.host, c = !!((x = r) !== null && x !== void 0 && ($ = x.ownerDocument) !== null && $ !== void 0 && $.contains(r));
    }
  }
  return c;
}, tk = function(t) {
  var n = t.getBoundingClientRect(), i = n.width, r = n.height;
  return i === 0 && r === 0;
}, Y6 = function(t, n) {
  var i = n.displayCheck, r = n.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var c = Ld.call(t, "details>summary:first-of-type"), d = c ? t.parentElement : t;
  if (Ld.call(d, "details:not([open]) *"))
    return !0;
  if (!i || i === "full" || i === "legacy-full") {
    if (typeof r == "function") {
      for (var a = t; t; ) {
        var f = t.parentElement, g = oy(t);
        if (f && !f.shadowRoot && r(f) === !0)
          return tk(t);
        t.assignedSlot ? t = t.assignedSlot : !f && g !== t.ownerDocument ? t = g.host : t = f;
      }
      t = a;
    }
    if (G6(t))
      return !t.getClientRects().length;
    if (i !== "legacy-full")
      return !0;
  } else if (i === "non-zero-area")
    return tk(t);
  return !1;
}, K6 = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var i = 0; i < n.children.length; i++) {
          var r = n.children.item(i);
          if (r.tagName === "LEGEND")
            return Ld.call(n, "fieldset[disabled] *") ? !0 : !r.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, ly = function(t, n) {
  return !(n.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  ay(n) || U6(n) || Y6(n, t) || // For a details element with a summary, the summary element gets the focus
  H6(n) || K6(n));
}, ww = function(t, n) {
  return !(j6(n) || _d(n) < 0 || !ly(t, n));
}, X6 = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, J6 = function e(t) {
  var n = [], i = [];
  return t.forEach(function(r, c) {
    var d = !!r.scopeParent, a = d ? r.scopeParent : r, f = B6(a, d), g = d ? e(r.candidates) : a;
    f === 0 ? d ? n.push.apply(n, g) : n.push(a) : i.push({
      documentOrder: c,
      tabIndex: f,
      item: r,
      isScope: d,
      content: g
    });
  }), i.sort(V6).reduce(function(r, c) {
    return c.isScope ? r.push.apply(r, c.content) : r.push(c.content), r;
  }, []).concat(n);
}, Q6 = function(t, n) {
  n = n || {};
  var i;
  return n.getShadowRoot ? i = GE([t], n.includeContainer, {
    filter: ww.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: X6
  }) : i = jE(t, n.includeContainer, ww.bind(null, n)), J6(i);
}, eU = function(t, n) {
  n = n || {};
  var i;
  return n.getShadowRoot ? i = GE([t], n.includeContainer, {
    filter: ly.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : i = jE(t, n.includeContainer, ly.bind(null, n)), i;
}, Sp = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return Ld.call(t, sy) === !1 ? !1 : ww(n, t);
}, tU = /* @__PURE__ */ ZE.concat("iframe").join(","), zb = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return Ld.call(t, tU) === !1 ? !1 : ly(n, t);
};
/*!
* focus-trap 7.6.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function xw(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, i = Array(t); n < t; n++) i[n] = e[n];
  return i;
}
function nU(e) {
  if (Array.isArray(e)) return xw(e);
}
function iU(e, t, n) {
  return (t = lU(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function rU(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function sU() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function nk(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function ik(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? nk(Object(n), !0).forEach(function(i) {
      iU(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : nk(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function oU(e) {
  return nU(e) || rU(e) || cU(e) || sU();
}
function aU(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(e, t);
    if (typeof i != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function lU(e) {
  var t = aU(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function cU(e, t) {
  if (e) {
    if (typeof e == "string") return xw(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? xw(e, t) : void 0;
  }
}
var rk = {
  activateTrap: function(t, n) {
    if (t.length > 0) {
      var i = t[t.length - 1];
      i !== n && i._setPausedState(!0);
    }
    var r = t.indexOf(n);
    r === -1 || t.splice(r, 1), t.push(n);
  },
  deactivateTrap: function(t, n) {
    var i = t.indexOf(n);
    i !== -1 && t.splice(i, 1), t.length > 0 && !t[t.length - 1]._isManuallyPaused() && t[t.length - 1]._setPausedState(!1);
  }
}, uU = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, dU = function(t) {
  return (t == null ? void 0 : t.key) === "Escape" || (t == null ? void 0 : t.key) === "Esc" || (t == null ? void 0 : t.keyCode) === 27;
}, rm = function(t) {
  return (t == null ? void 0 : t.key) === "Tab" || (t == null ? void 0 : t.keyCode) === 9;
}, pU = function(t) {
  return rm(t) && !t.shiftKey;
}, hU = function(t) {
  return rm(t) && t.shiftKey;
}, sk = function(t) {
  return setTimeout(t, 0);
}, Df = function(t) {
  for (var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++)
    i[r - 1] = arguments[r];
  return typeof t == "function" ? t.apply(void 0, i) : t;
}, Nv = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, fU = [], mU = function(t, n) {
  var i = (n == null ? void 0 : n.document) || document, r = (n == null ? void 0 : n.trapStack) || fU, c = ik({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isKeyForward: pU,
    isKeyBackward: hU
  }, n), d = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    manuallyPaused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, a, f = function(le, pe, Ne) {
    return le && le[pe] !== void 0 ? le[pe] : c[Ne || pe];
  }, g = function(le, pe) {
    var Ne = typeof (pe == null ? void 0 : pe.composedPath) == "function" ? pe.composedPath() : void 0;
    return d.containerGroups.findIndex(function(We) {
      var Ge = We.container, et = We.tabbableNodes;
      return Ge.contains(le) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      (Ne == null ? void 0 : Ne.includes(Ge)) || et.find(function(ft) {
        return ft === le;
      });
    });
  }, x = function(le) {
    var pe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Ne = pe.hasFallback, We = Ne === void 0 ? !1 : Ne, Ge = pe.params, et = Ge === void 0 ? [] : Ge, ft = c[le];
    if (typeof ft == "function" && (ft = ft.apply(void 0, oU(et))), ft === !0 && (ft = void 0), !ft) {
      if (ft === void 0 || ft === !1)
        return ft;
      throw new Error("`".concat(le, "` was specified but was not a node, or did not return a node"));
    }
    var De = ft;
    if (typeof ft == "string") {
      try {
        De = i.querySelector(ft);
      } catch (Ke) {
        throw new Error("`".concat(le, '` appears to be an invalid selector; error="').concat(Ke.message, '"'));
      }
      if (!De && !We)
        throw new Error("`".concat(le, "` as selector refers to no known node"));
    }
    return De;
  }, $ = function() {
    var le = x("initialFocus", {
      hasFallback: !0
    });
    if (le === !1)
      return !1;
    if (le === void 0 || le && !zb(le, c.tabbableOptions))
      if (g(i.activeElement) >= 0)
        le = i.activeElement;
      else {
        var pe = d.tabbableGroups[0], Ne = pe && pe.firstTabbableNode;
        le = Ne || x("fallbackFocus");
      }
    else le === null && (le = x("fallbackFocus"));
    if (!le)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return le;
  }, A = function() {
    if (d.containerGroups = d.containers.map(function(le) {
      var pe = Q6(le, c.tabbableOptions), Ne = eU(le, c.tabbableOptions), We = pe.length > 0 ? pe[0] : void 0, Ge = pe.length > 0 ? pe[pe.length - 1] : void 0, et = Ne.find(function(Ke) {
        return Sp(Ke);
      }), ft = Ne.slice().reverse().find(function(Ke) {
        return Sp(Ke);
      }), De = !!pe.find(function(Ke) {
        return _d(Ke) > 0;
      });
      return {
        container: le,
        tabbableNodes: pe,
        focusableNodes: Ne,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: De,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: We,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: Ge,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: et,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: ft,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(gt) {
          var qe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, rt = pe.indexOf(gt);
          return rt < 0 ? qe ? Ne.slice(Ne.indexOf(gt) + 1).find(function(Le) {
            return Sp(Le);
          }) : Ne.slice(0, Ne.indexOf(gt)).reverse().find(function(Le) {
            return Sp(Le);
          }) : pe[rt + (qe ? 1 : -1)];
        }
      };
    }), d.tabbableGroups = d.containerGroups.filter(function(le) {
      return le.tabbableNodes.length > 0;
    }), d.tabbableGroups.length <= 0 && !x("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (d.containerGroups.find(function(le) {
      return le.posTabIndexesFound;
    }) && d.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, I = function(le) {
    var pe = le.activeElement;
    if (pe)
      return pe.shadowRoot && pe.shadowRoot.activeElement !== null ? I(pe.shadowRoot) : pe;
  }, O = function(le) {
    if (le !== !1 && le !== I(document)) {
      if (!le || !le.focus) {
        O($());
        return;
      }
      le.focus({
        preventScroll: !!c.preventScroll
      }), d.mostRecentlyFocusedNode = le, uU(le) && le.select();
    }
  }, B = function(le) {
    var pe = x("setReturnFocus", {
      params: [le]
    });
    return pe || (pe === !1 ? !1 : le);
  }, H = function(le) {
    var pe = le.target, Ne = le.event, We = le.isBackward, Ge = We === void 0 ? !1 : We;
    pe = pe || Nv(Ne), A();
    var et = null;
    if (d.tabbableGroups.length > 0) {
      var ft = g(pe, Ne), De = ft >= 0 ? d.containerGroups[ft] : void 0;
      if (ft < 0)
        Ge ? et = d.tabbableGroups[d.tabbableGroups.length - 1].lastTabbableNode : et = d.tabbableGroups[0].firstTabbableNode;
      else if (Ge) {
        var Ke = d.tabbableGroups.findIndex(function(je) {
          var ot = je.firstTabbableNode;
          return pe === ot;
        });
        if (Ke < 0 && (De.container === pe || zb(pe, c.tabbableOptions) && !Sp(pe, c.tabbableOptions) && !De.nextTabbableNode(pe, !1)) && (Ke = ft), Ke >= 0) {
          var gt = Ke === 0 ? d.tabbableGroups.length - 1 : Ke - 1, qe = d.tabbableGroups[gt];
          et = _d(pe) >= 0 ? qe.lastTabbableNode : qe.lastDomTabbableNode;
        } else rm(Ne) || (et = De.nextTabbableNode(pe, !1));
      } else {
        var rt = d.tabbableGroups.findIndex(function(je) {
          var ot = je.lastTabbableNode;
          return pe === ot;
        });
        if (rt < 0 && (De.container === pe || zb(pe, c.tabbableOptions) && !Sp(pe, c.tabbableOptions) && !De.nextTabbableNode(pe)) && (rt = ft), rt >= 0) {
          var Le = rt === d.tabbableGroups.length - 1 ? 0 : rt + 1, Je = d.tabbableGroups[Le];
          et = _d(pe) >= 0 ? Je.firstTabbableNode : Je.firstDomTabbableNode;
        } else rm(Ne) || (et = De.nextTabbableNode(pe));
      }
    } else
      et = x("fallbackFocus");
    return et;
  }, N = function(le) {
    var pe = Nv(le);
    if (!(g(pe, le) >= 0)) {
      if (Df(c.clickOutsideDeactivates, le)) {
        a.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: c.returnFocusOnDeactivate
        });
        return;
      }
      Df(c.allowOutsideClick, le) || le.preventDefault();
    }
  }, K = function(le) {
    var pe = Nv(le), Ne = g(pe, le) >= 0;
    if (Ne || pe instanceof Document)
      Ne && (d.mostRecentlyFocusedNode = pe);
    else {
      le.stopImmediatePropagation();
      var We, Ge = !0;
      if (d.mostRecentlyFocusedNode)
        if (_d(d.mostRecentlyFocusedNode) > 0) {
          var et = g(d.mostRecentlyFocusedNode), ft = d.containerGroups[et].tabbableNodes;
          if (ft.length > 0) {
            var De = ft.findIndex(function(Ke) {
              return Ke === d.mostRecentlyFocusedNode;
            });
            De >= 0 && (c.isKeyForward(d.recentNavEvent) ? De + 1 < ft.length && (We = ft[De + 1], Ge = !1) : De - 1 >= 0 && (We = ft[De - 1], Ge = !1));
          }
        } else
          d.containerGroups.some(function(Ke) {
            return Ke.tabbableNodes.some(function(gt) {
              return _d(gt) > 0;
            });
          }) || (Ge = !1);
      else
        Ge = !1;
      Ge && (We = H({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: d.mostRecentlyFocusedNode,
        isBackward: c.isKeyBackward(d.recentNavEvent)
      })), O(We || d.mostRecentlyFocusedNode || $());
    }
    d.recentNavEvent = void 0;
  }, U = function(le) {
    var pe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    d.recentNavEvent = le;
    var Ne = H({
      event: le,
      isBackward: pe
    });
    Ne && (rm(le) && le.preventDefault(), O(Ne));
  }, q = function(le) {
    (c.isKeyForward(le) || c.isKeyBackward(le)) && U(le, c.isKeyBackward(le));
  }, ee = function(le) {
    dU(le) && Df(c.escapeDeactivates, le) !== !1 && (le.preventDefault(), a.deactivate());
  }, te = function(le) {
    var pe = Nv(le);
    g(pe, le) >= 0 || Df(c.clickOutsideDeactivates, le) || Df(c.allowOutsideClick, le) || (le.preventDefault(), le.stopImmediatePropagation());
  }, ae = function() {
    if (d.active)
      return rk.activateTrap(r, a), d.delayInitialFocusTimer = c.delayInitialFocus ? sk(function() {
        O($());
      }) : O($()), i.addEventListener("focusin", K, !0), i.addEventListener("mousedown", N, {
        capture: !0,
        passive: !1
      }), i.addEventListener("touchstart", N, {
        capture: !0,
        passive: !1
      }), i.addEventListener("click", te, {
        capture: !0,
        passive: !1
      }), i.addEventListener("keydown", q, {
        capture: !0,
        passive: !1
      }), i.addEventListener("keydown", ee), a;
  }, oe = function() {
    if (d.active)
      return i.removeEventListener("focusin", K, !0), i.removeEventListener("mousedown", N, !0), i.removeEventListener("touchstart", N, !0), i.removeEventListener("click", te, !0), i.removeEventListener("keydown", q, !0), i.removeEventListener("keydown", ee), a;
  }, de = function(le) {
    var pe = le.some(function(Ne) {
      var We = Array.from(Ne.removedNodes);
      return We.some(function(Ge) {
        return Ge === d.mostRecentlyFocusedNode;
      });
    });
    pe && O($());
  }, me = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(de) : void 0, ve = function() {
    me && (me.disconnect(), d.active && !d.paused && d.containers.map(function(le) {
      me.observe(le, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return a = {
    get active() {
      return d.active;
    },
    get paused() {
      return d.paused;
    },
    activate: function(le) {
      if (d.active)
        return this;
      var pe = f(le, "onActivate"), Ne = f(le, "onPostActivate"), We = f(le, "checkCanFocusTrap");
      We || A(), d.active = !0, d.paused = !1, d.nodeFocusedBeforeActivation = i.activeElement, pe == null || pe();
      var Ge = function() {
        We && A(), ae(), ve(), Ne == null || Ne();
      };
      return We ? (We(d.containers.concat()).then(Ge, Ge), this) : (Ge(), this);
    },
    deactivate: function(le) {
      if (!d.active)
        return this;
      var pe = ik({
        onDeactivate: c.onDeactivate,
        onPostDeactivate: c.onPostDeactivate,
        checkCanReturnFocus: c.checkCanReturnFocus
      }, le);
      clearTimeout(d.delayInitialFocusTimer), d.delayInitialFocusTimer = void 0, oe(), d.active = !1, d.paused = !1, ve(), rk.deactivateTrap(r, a);
      var Ne = f(pe, "onDeactivate"), We = f(pe, "onPostDeactivate"), Ge = f(pe, "checkCanReturnFocus"), et = f(pe, "returnFocus", "returnFocusOnDeactivate");
      Ne == null || Ne();
      var ft = function() {
        sk(function() {
          et && O(B(d.nodeFocusedBeforeActivation)), We == null || We();
        });
      };
      return et && Ge ? (Ge(B(d.nodeFocusedBeforeActivation)).then(ft, ft), this) : (ft(), this);
    },
    pause: function(le) {
      return d.active ? (d.manuallyPaused = !0, this._setPausedState(!0, le)) : this;
    },
    unpause: function(le) {
      return d.active ? (d.manuallyPaused = !1, r[r.length - 1] !== this ? this : this._setPausedState(!1, le)) : this;
    },
    updateContainerElements: function(le) {
      var pe = [].concat(le).filter(Boolean);
      return d.containers = pe.map(function(Ne) {
        return typeof Ne == "string" ? i.querySelector(Ne) : Ne;
      }), d.active && A(), ve(), this;
    }
  }, Object.defineProperties(a, {
    _isManuallyPaused: {
      value: function() {
        return d.manuallyPaused;
      }
    },
    _setPausedState: {
      value: function(le, pe) {
        if (d.paused === le)
          return this;
        if (d.paused = le, le) {
          var Ne = f(pe, "onPause"), We = f(pe, "onPostPause");
          Ne == null || Ne(), oe(), ve(), We == null || We();
        } else {
          var Ge = f(pe, "onUnpause"), et = f(pe, "onPostUnpause");
          Ge == null || Ge(), A(), ae(), ve(), et == null || et();
        }
        return this;
      }
    }
  }), a.updateContainerElements(t), a;
};
function vU(e, t = {}) {
  let n;
  const { immediate: i, ...r } = t, c = $e(!1), d = $e(!1), a = ($) => n && n.activate($), f = ($) => n && n.deactivate($), g = () => {
    n && (n.pause(), d.value = !0);
  }, x = () => {
    n && (n.unpause(), d.value = !1);
  };
  return At(
    () => Cd(e),
    ($) => {
      $ && (n = mU($, {
        ...r,
        onActivate() {
          c.value = !0, t.onActivate && t.onActivate();
        },
        onDeactivate() {
          c.value = !1, t.onDeactivate && t.onDeactivate();
        }
      }), i && a());
    },
    { flush: "post" }
  ), r_(() => f()), {
    hasFocus: c,
    isPaused: d,
    activate: a,
    deactivate: f,
    pause: g,
    unpause: x
  };
}
const gU = (e) => (...t) => {
  e && (e == null || e(...t), e = null);
}, xm = () => {
};
function Fv(e, t, n) {
  return e > n ? n : e < t ? t : e;
}
function Bb(e, t) {
  var n;
  const i = ((n = Xf(e, t)) == null ? void 0 : n[0]) || t;
  e.push(i);
}
function Xf(e, t) {
  const n = e.indexOf(t);
  if (n !== -1)
    return e.splice(n, 1);
}
const yU = {
  /**
   * @description Set `null | false` to disable teleport.
   * @default `'body'`
   * @example
   * ```js
   * teleportTo: '#modals'
   * ```
   */
  teleportTo: {
    type: [String, null, Boolean, Object],
    default: "body"
  },
  /**
   * @description An uniq name for the open/close a modal via vfm.open/vfm.close APIs.
   * @default `undefined`
   * @example Symbol: `Symbol('MyModal')`
   * @example String: `'AUniqString'`
   * @example Number: `300`
   */
  modalId: {
    type: [String, Number, Symbol],
    default: void 0
  },
  /**
   * @description Display the modal or not.
   * @default `undefined`
   * @example
   * ```js
   * const showModal = ref(false)
   * v-model="showModal"
   * ```
   */
  modelValue: {
    type: Boolean,
    default: void 0
  },
  /**
   * @description Render the modal via `if` or `show`.
   * @default `'if'`
   * @example
   * ```js
   * displayDirective: 'if'
   * ```
   * @example
   * ```js
   * displayDirective: 'show'
   * ```
   */
  displayDirective: {
    type: String,
    default: "if",
    validator: (e) => ["if", "show", "visible"].includes(e)
  },
  /**
   * @description Hide the overlay or not.
   * @default `undefined`
   * @example
   * ```js
   * hideOverlay="true"
   * ```
   */
  hideOverlay: {
    type: Boolean,
    default: void 0
  },
  /**
   * @description Customize the overlay behavior.
   */
  overlayBehavior: {
    type: String,
    default: "auto",
    validator: (e) => ["auto", "persist"].includes(e)
  },
  /**
   * @description Customize the overlay transition.
   * @default `undefined`
   */
  overlayTransition: {
    type: [String, Object],
    default: void 0
  },
  /**
   * @description Customize the content transition.
   * @default `undefined`
   */
  contentTransition: {
    type: [String, Object],
    default: void 0
  },
  /**
   * @description Bind class to vfm__overlay.
   * @default `undefined`
   */
  overlayClass: {
    type: void 0,
    default: void 0
  },
  /**
   * @description Bind class to vfm__content.
   * @default `undefined`
   */
  contentClass: {
    type: void 0,
    default: void 0
  },
  /**
   * @description Bind style to vfm__overlay.
   * @default `undefined`
   */
  overlayStyle: {
    type: [String, Object, Array],
    default: void 0
  },
  /**
   * @description Bind style to vfm__content.
   * @default `undefined`
   */
  contentStyle: {
    type: [String, Object, Array],
    default: void 0
  },
  /**
   * @description Is it allow to close the modal by clicking the overlay.
   * @default `true`
   */
  clickToClose: {
    type: Boolean,
    default: !0
  },
  /**
   * @description Is it allow to close the modal by keypress `esc`.
   * @default `true`
   */
  escToClose: {
    type: Boolean,
    default: !0
  },
  /**
   * @description Is it allow to click outside of the vfm__content when the modal is opened
   * @default `'non-interactive'`
   */
  background: {
    type: String,
    default: "non-interactive",
    validator: (e) => ["interactive", "non-interactive"].includes(e)
  },
  /**
   * @description
   * * Use `{ disabled: true }` to disable the focusTrap.
   * * Checkout the createOptions type here https://github.com/focus-trap/focus-trap for more.
   * @default `{ allowOutsideClick: true }`
   */
  focusTrap: {
    type: [Boolean, Object],
    default: () => ({
      allowOutsideClick: !0
    })
  },
  /**
   * @description Lock body scroll or not when the modal is opened.
   * @default `true`
   */
  lockScroll: {
    type: Boolean,
    default: !0
  },
  /**
   * @description Creates a padding-right when scroll is locked to prevent the page from jumping
   * @default `true`
   */
  reserveScrollBarGap: {
    type: Boolean,
    default: !0
  },
  /**
   * @description Define how to increase the zIndex when there are nested modals
   * @default `({ index }) => 1000 + 2 * index`
   */
  zIndexFn: {
    type: Function,
    default: ({ index: e }) => 1e3 + 2 * e
  },
  /**
   * @description The direction of swiping to close the modal
   * @default `none`
   * @example
   * Set swipeToClose="none" to disable swiping to close
   * ```js
   * swipeToClose="none"
   * ```
   */
  swipeToClose: {
    type: String,
    default: "none",
    validator: (e) => ["none", "up", "right", "down", "left"].includes(e)
  },
  /**
   * @description Threshold for swipe to close
   * @default `0`
   */
  threshold: {
    type: Number,
    default: 0
  },
  /**
   * @description If set `:showSwipeBanner="true"`, only allow clicking `swipe-banner` slot to swipe to close
   * @default `undefined`
   * @example
   * ```js
   * swipeToClose="right"
   * :showSwipeBanner="true"
   * ```
   * ```html
   * <VueFinalModal
   *   ...
   *   swipeToClose="right"
   *   :showSwipeBanner="true"
   * >
   *   <template #swipe-banner>
   *     <div style="position: absolute; height: 100%; top: 0; left: 0; width: 10px;" />
   *   </template>
   *   ...modal content
   * </VueFinalModal>
   * ```
   */
  showSwipeBanner: {
    type: Boolean,
    default: void 0
  },
  /**
   * @description When set `:preventNavigationGestures="true"`, there will be two invisible bars for prevent navigation gestures including swiping back/forward on mobile webkit. For example: Safari mobile.
   * @default `undefined`
   * @example
   * Set preventNavigationGestures="true" to prevent Safari navigation gestures including swiping back/forward.
   * ```js
   * :preventNavigationGestures="true"
   * ```
   */
  preventNavigationGestures: {
    type: Boolean,
    default: void 0
  }
};
function ok(e = !1) {
  const t = $e(e), n = $e(t.value ? 0 : void 0);
  return [t, n, {
    beforeEnter() {
      n.value = 1;
    },
    afterEnter() {
      n.value = 0;
    },
    beforeLeave() {
      n.value = 3;
    },
    afterLeave() {
      n.value = 2;
    }
  }];
}
function _U(e, t) {
  const { modelValueLocal: n, onEntering: i, onEnter: r, onLeaving: c, onLeave: d } = t, a = $e(n.value), [f, g, x] = ok(a.value), [$, A, I] = ok(a.value), O = Ae(() => typeof e.contentTransition == "string" ? { name: e.contentTransition, appear: !0 } : { appear: !0, ...e.contentTransition }), B = Ae(() => typeof e.overlayTransition == "string" ? { name: e.overlayTransition, appear: !0 } : { appear: !0, ...e.overlayTransition }), H = Ae(
    () => (e.hideOverlay || A.value === 2) && g.value === 2
    /* Leave */
  );
  At(
    H,
    (U) => {
      U && (a.value = !1);
    }
  ), At(g, (U) => {
    if (U === 1) {
      if (!a.value)
        return;
      i == null || i();
    } else if (U === 0) {
      if (!a.value)
        return;
      r == null || r();
    } else
      U === 3 ? c == null || c() : U === 2 && (d == null || d());
  });
  async function N() {
    a.value = !0, await Rl(), f.value = !0, $.value = !0;
  }
  function K() {
    f.value = !1, $.value = !1;
  }
  return {
    visible: a,
    contentVisible: f,
    contentListeners: x,
    contentTransition: O,
    overlayVisible: $,
    overlayListeners: I,
    overlayTransition: B,
    enterTransition: N,
    leaveTransition: K
  };
}
function bU(e, t, n) {
  const { vfmRootEl: i, vfmContentEl: r, visible: c, modelValueLocal: d } = n, a = $e();
  function f() {
    c.value && e.escToClose && (d.value = !1);
  }
  function g($) {
    a.value = $ == null ? void 0 : $.target;
  }
  function x() {
    var $;
    a.value === i.value && (e.clickToClose ? d.value = !1 : (($ = r.value) == null || $.focus(), t("clickOutside")));
  }
  return {
    onEsc: f,
    onMouseupRoot: x,
    onMousedown: g
  };
}
function wU(e, t, n) {
  let i = !1;
  const { open: r, close: c } = n, d = $e(!1), a = {
    get value() {
      return d.value;
    },
    set value(g) {
      f(g);
    }
  };
  function f(g) {
    (g ? r() : c()) ? (d.value = g, g !== e.modelValue && t("update:modelValue", g)) : (i = !0, t("update:modelValue", !g), Rl(() => {
      i = !1;
    }));
  }
  return At(() => e.modelValue, (g) => {
    i || (a.value = !!g);
  }), {
    modelValueLocal: a
  };
}
function xU(e, t) {
  if (e.focusTrap === !1)
    return {
      focus() {
      },
      blur() {
      }
    };
  const { focusEl: n } = t, { hasFocus: i, activate: r, deactivate: c } = vU(n, e.focusTrap);
  function d() {
    requestAnimationFrame(() => {
      r();
    });
  }
  function a() {
    i.value && c();
  }
  return { focus: d, blur: a };
}
let tx = !1;
if (typeof window < "u") {
  const e = {
    get passive() {
      tx = !0;
    }
  };
  window.addEventListener("testPassive", null, e), window.removeEventListener("testPassive", null, e);
}
const XE = typeof window < "u" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
let $u = [], cy = !1, yg = 0, JE = -1, sm, om;
const $U = (e) => {
  if (!e || e.nodeType !== Node.ELEMENT_NODE)
    return !1;
  const t = window.getComputedStyle(e);
  return ["auto", "scroll"].includes(t.overflowY) && e.scrollHeight > e.clientHeight;
}, CU = (e, t) => !(e.scrollTop === 0 && t < 0 || e.scrollTop + e.clientHeight + t >= e.scrollHeight && t > 0), kU = (e) => {
  const t = [];
  for (; e; ) {
    if (t.push(e), e.classList.contains("vfm"))
      return t;
    e = e.parentElement;
  }
  return t;
}, SU = (e, t) => {
  let n = !1;
  return kU(e).forEach((i) => {
    $U(i) && CU(i, t) && (n = !0);
  }), n;
}, QE = (e) => $u.some(() => SU(e, -yg)), nx = (e) => {
  const t = e || window.event;
  return QE(t.target) || t.touches.length > 1 ? !0 : (t.preventDefault && t.preventDefault(), !1);
}, TU = (e) => {
  if (om === void 0) {
    const t = !!e && e.reserveScrollBarGap === !0, n = window.innerWidth - document.documentElement.clientWidth;
    if (t && n > 0) {
      const i = parseInt(getComputedStyle(document.body).getPropertyValue("padding-right"), 10);
      om = document.body.style.paddingRight, document.body.style.paddingRight = `${i + n}px`;
    }
  }
  sm === void 0 && (sm = document.body.style.overflow, document.body.style.overflow = "hidden");
}, IU = () => {
  om !== void 0 && (document.body.style.paddingRight = om, om = void 0), sm !== void 0 && (document.body.style.overflow = sm, sm = void 0);
}, AU = (e) => e ? e.scrollHeight - e.scrollTop <= e.clientHeight : !1, EU = (e, t) => (yg = e.targetTouches[0].clientY - JE, QE(e.target) ? !1 : t && t.scrollTop === 0 && yg > 0 || AU(t) && yg < 0 ? nx(e) : (e.stopPropagation(), !0)), PU = (e, t) => {
  if (!e) {
    console.error(
      "disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices."
    );
    return;
  }
  if ($u.some((i) => i.targetElement === e))
    return;
  const n = {
    targetElement: e,
    options: t || {}
  };
  $u = [...$u, n], XE ? (e.ontouchstart = (i) => {
    i.targetTouches.length === 1 && (JE = i.targetTouches[0].clientY);
  }, e.ontouchmove = (i) => {
    i.targetTouches.length === 1 && EU(i, e);
  }, cy || (document.addEventListener("touchmove", nx, tx ? { passive: !1 } : void 0), cy = !0)) : TU(t);
}, MU = (e) => {
  if (!e) {
    console.error(
      "enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices."
    );
    return;
  }
  $u = $u.filter((t) => t.targetElement !== e), XE ? (e.ontouchstart = null, e.ontouchmove = null, cy && $u.length === 0 && (document.removeEventListener("touchmove", nx, tx ? { passive: !1 } : void 0), cy = !1)) : $u.length || IU();
};
function DU(e, t) {
  const { lockScrollEl: n, modelValueLocal: i } = t;
  let r;
  At(n, (a) => {
    a && (r = a);
  }, { immediate: !0 }), At(() => e.lockScroll, (a) => {
    a ? d() : c();
  }), tl(() => {
    c();
  });
  function c() {
    r && MU(r);
  }
  function d() {
    i.value && e.lockScroll && r && PU(r, {
      reserveScrollBarGap: e.reserveScrollBarGap,
      allowTouchMove: (a) => {
        for (; a && a !== document.body; ) {
          if (a.getAttribute("vfm-scroll-lock-ignore") !== null)
            return !0;
          a = a.parentElement;
        }
        return !1;
      }
    });
  }
  return {
    enableBodyScroll: c,
    disableBodyScroll: d
  };
}
function LU(e) {
  const t = $e();
  function n(r) {
    var c;
    t.value = (c = e.zIndexFn) == null ? void 0 : c.call(e, { index: r <= -1 ? 0 : r });
  }
  function i() {
    t.value = void 0;
  }
  return {
    zIndex: t,
    refreshZIndex: n,
    resetZIndex: i
  };
}
const Vb = {
  beforeMount(e, { value: t }, { transition: n }) {
    e._vov = e.style.visibility === "hidden" ? "" : e.style.visibility, n && t ? n.beforeEnter(e) : Lf(e, t);
  },
  mounted(e, { value: t }, { transition: n }) {
    n && t && n.enter(e);
  },
  updated(e, { value: t, oldValue: n }, { transition: i }) {
    !t != !n && (i ? t ? (i.beforeEnter(e), Lf(e, !0), i.enter(e)) : i.leave(e, () => {
      Lf(e, !1);
    }) : Lf(e, t));
  },
  beforeUnmount(e, { value: t }) {
    Lf(e, t);
  }
};
function Lf(e, t) {
  e.style.visibility = t ? e._vov : "hidden";
}
const ak = (e) => {
  if (e instanceof MouseEvent) {
    const { clientX: t, clientY: n } = e;
    return { x: t, y: n };
  } else {
    const { clientX: t, clientY: n } = e.targetTouches[0];
    return { x: t, y: n };
  }
};
function OU(e) {
  if (!e)
    return !1;
  let t = !1;
  const n = {
    get passive() {
      return t = !0, !1;
    }
  };
  return e.addEventListener("x", xm, n), e.removeEventListener("x", xm), t;
}
function NU(e, {
  threshold: t = 0,
  onSwipeStart: n,
  onSwipe: i,
  onSwipeEnd: r,
  passive: c = !0
}) {
  const d = Er({ x: 0, y: 0 }), a = Er({ x: 0, y: 0 }), f = Ae(() => d.x - a.x), g = Ae(() => d.y - a.y), { max: x, abs: $ } = Math, A = Ae(
    () => x($(f.value), $(g.value)) >= t
  ), I = $e(!1), O = Ae(() => A.value ? $(f.value) > $(g.value) ? f.value > 0 ? "left" : "right" : g.value > 0 ? "up" : "down" : "none"), B = (ae, oe) => {
    d.x = ae, d.y = oe;
  }, H = (ae, oe) => {
    a.x = ae, a.y = oe;
  };
  let N, K;
  function U(ae) {
    N.capture && !N.passive && ae.preventDefault();
    const { x: oe, y: de } = ak(ae);
    B(oe, de), H(oe, de), n == null || n(ae), K = [
      Ts(e, "mousemove", q, N),
      Ts(e, "touchmove", q, N),
      Ts(e, "mouseup", ee, N),
      Ts(e, "touchend", ee, N),
      Ts(e, "touchcancel", ee, N)
    ];
  }
  function q(ae) {
    const { x: oe, y: de } = ak(ae);
    H(oe, de), !I.value && A.value && (I.value = !0), I.value && (i == null || i(ae));
  }
  function ee(ae) {
    I.value && (r == null || r(ae, O.value)), I.value = !1, K.forEach((oe) => oe());
  }
  let te = [];
  return Li(() => {
    const ae = OU(window == null ? void 0 : window.document);
    c ? N = ae ? { passive: !0 } : { capture: !1 } : N = ae ? { passive: !1, capture: !0 } : { capture: !0 }, te = [
      Ts(e, "mousedown", U, N),
      Ts(e, "touchstart", U, N)
    ];
  }), {
    isSwiping: I,
    direction: O,
    coordsStart: d,
    coordsEnd: a,
    lengthX: f,
    lengthY: g,
    stop: () => {
      te.forEach((ae) => ae()), K.forEach((ae) => ae());
    }
  };
}
function FU(e, t) {
  const { vfmContentEl: n, modelValueLocal: i } = t, r = 0.1, c = 300, d = $e(), a = Ae(() => {
    if (!(e.swipeToClose === void 0 || e.swipeToClose === "none"))
      return e.showSwipeBanner ? d.value : n.value;
  }), f = $e(0), g = $e(!0);
  let x = xm, $ = !0, A, I = !1;
  const { lengthX: O, lengthY: B, direction: H, isSwiping: N } = NU(a, {
    threshold: e.threshold,
    onSwipeStart(ee) {
      x = Ts(document, "selectionchange", () => {
        var te;
        g.value = (te = window.getSelection()) == null ? void 0 : te.isCollapsed;
      }), A = (/* @__PURE__ */ new Date()).getTime(), I = q(ee == null ? void 0 : ee.target);
    },
    onSwipe() {
      var ee, te, ae, oe;
      if (I && g.value && H.value === e.swipeToClose) {
        if (H.value === "up") {
          const de = Fv(Math.abs(B.value || 0), 0, ((ee = a.value) == null ? void 0 : ee.offsetHeight) || 0) - (e.threshold || 0);
          f.value = de;
        } else if (H.value === "down") {
          const de = Fv(Math.abs(B.value || 0), 0, ((te = a.value) == null ? void 0 : te.offsetHeight) || 0) - (e.threshold || 0);
          f.value = -de;
        } else if (H.value === "right") {
          const de = Fv(Math.abs(O.value || 0), 0, ((ae = a.value) == null ? void 0 : ae.offsetWidth) || 0) - (e.threshold || 0);
          f.value = -de;
        } else if (H.value === "left") {
          const de = Fv(Math.abs(O.value || 0), 0, ((oe = a.value) == null ? void 0 : oe.offsetWidth) || 0) - (e.threshold || 0);
          f.value = de;
        }
      }
    },
    onSwipeEnd(ee, te) {
      if (x(), !g.value) {
        g.value = !0;
        return;
      }
      const ae = (/* @__PURE__ */ new Date()).getTime(), oe = te === e.swipeToClose, de = (() => {
        var ve, re;
        if (te === "up" || te === "down")
          return Math.abs((B == null ? void 0 : B.value) || 0) > r * (((ve = a.value) == null ? void 0 : ve.offsetHeight) || 0);
        if (te === "left" || te === "right")
          return Math.abs((O == null ? void 0 : O.value) || 0) > r * (((re = a.value) == null ? void 0 : re.offsetWidth) || 0);
      })(), me = ae - A <= c;
      if ($ && I && oe && (de || me)) {
        i.value = !1;
        return;
      }
      f.value = 0;
    }
  }), K = Ae(() => {
    if (e.swipeToClose === "none")
      return;
    const ee = (() => {
      switch (e.swipeToClose) {
        case "up":
        case "down":
          return "translateY";
        case "left":
        case "right":
          return "translateX";
      }
    })();
    return {
      class: { "vfm-bounce-back": !N.value },
      style: { transform: `${ee}(${-f.value}px)` }
    };
  });
  At(
    () => g.value,
    (ee) => {
      ee || (f.value = 0);
    }
  ), At(
    () => i.value,
    (ee) => {
      ee && (f.value = 0);
    }
  ), At(
    () => f.value,
    (ee, te) => {
      switch (e.swipeToClose) {
        case "down":
        case "right":
          $ = ee < te;
          break;
        case "up":
        case "left":
          $ = ee > te;
          break;
      }
    }
  );
  function U(ee) {
    e.preventNavigationGestures && ee.preventDefault();
  }
  function q(ee) {
    const te = ee == null ? void 0 : ee.tagName;
    if (!te || ["INPUT", "TEXTAREA"].includes(te))
      return !1;
    const ae = (() => {
      switch (e.swipeToClose) {
        case "up":
          return (ee == null ? void 0 : ee.scrollTop) + (ee == null ? void 0 : ee.clientHeight) === (ee == null ? void 0 : ee.scrollHeight);
        case "left":
          return (ee == null ? void 0 : ee.scrollLeft) + (ee == null ? void 0 : ee.clientWidth) === (ee == null ? void 0 : ee.scrollWidth);
        case "down":
          return (ee == null ? void 0 : ee.scrollTop) === 0;
        case "right":
          return (ee == null ? void 0 : ee.scrollLeft) === 0;
        default:
          return !1;
      }
    })();
    return ee === a.value ? ae : ae && q(ee == null ? void 0 : ee.parentElement);
  }
  return {
    vfmContentEl: n,
    swipeBannerEl: d,
    bindSwipe: K,
    onTouchStartSwipeBanner: U
  };
}
const RU = Symbol("vfm");
let zU;
const BU = {
  install: xm,
  modals: [],
  openedModals: [],
  openedModalOverlays: [],
  dynamicModals: [],
  modalsContainers: $e([]),
  get: () => {
  },
  toggle: () => {
  },
  open: () => {
  },
  close: () => {
  },
  closeAll: () => Promise.allSettled([])
}, VU = () => Du() && Xi(RU, BU) || zU;
function lk(e) {
  var t;
  return (t = e == null ? void 0 : e.exposed) == null ? void 0 : t.modalExposed;
}
const UU = at({ inheritAttrs: !1 }), HU = /* @__PURE__ */ at({
  ...UU,
  __name: "VueFinalModal",
  props: yU,
  emits: ["update:modelValue", "beforeOpen", "opened", "beforeClose", "closed", "clickOutside"],
  setup(e, { expose: t, emit: n }) {
    const i = e, r = n, c = kI(), d = Du(), { modals: a, openedModals: f, openedModalOverlays: g } = WU(), x = $e(), $ = $e(), { focus: A, blur: I } = xU(i, { focusEl: x }), { zIndex: O, refreshZIndex: B, resetZIndex: H } = LU(i), { modelValueLocal: N } = wU(i, r, { open: Ke, close: gt }), { enableBodyScroll: K, disableBodyScroll: U } = DU(i, {
      lockScrollEl: x,
      modelValueLocal: N
    });
    let q = xm;
    const {
      visible: ee,
      contentVisible: te,
      contentListeners: ae,
      contentTransition: oe,
      overlayVisible: de,
      overlayListeners: me,
      overlayTransition: ve,
      enterTransition: re,
      leaveTransition: le
    } = _U(i, {
      modelValueLocal: N,
      onEntering() {
        Rl(() => {
          U(), A();
        });
      },
      onEnter() {
        r("opened"), q("opened");
      },
      onLeave() {
        Xf(f, d), H(), K(), r("closed"), q("closed");
      }
    }), { onEsc: pe, onMouseupRoot: Ne, onMousedown: We } = bU(i, r, { vfmRootEl: x, vfmContentEl: $, visible: ee, modelValueLocal: N }), {
      swipeBannerEl: Ge,
      bindSwipe: et,
      onTouchStartSwipeBanner: ft
    } = FU(i, { vfmContentEl: $, modelValueLocal: N }), De = Ae(() => d ? f.indexOf(d) : -1);
    At([() => i.zIndexFn, De], () => {
      ee.value && B(De.value);
    }), Li(() => {
      Bb(a, d);
    }), i.modelValue && (N.value = !0);
    function Ke() {
      let Xe = !1;
      return r("beforeOpen", { stop: () => Xe = !0 }), Xe ? !1 : (Bb(f, d), Bb(g, d), rt(), re(), !0);
    }
    function gt() {
      let Xe = !1;
      return r("beforeClose", { stop: () => Xe = !0 }), Xe ? !1 : (Xf(g, d), rt(), I(), le(), !0);
    }
    function qe() {
      N.value = !1;
    }
    tl(() => {
      K(), Xf(a, d), Xf(f, d), I(), rt();
    });
    async function rt() {
      await Rl();
      const Xe = g.filter((tt) => {
        var dt;
        const bt = lk(tt);
        return (bt == null ? void 0 : bt.value.overlayBehavior.value) === "auto" && !((dt = bt == null ? void 0 : bt.value.hideOverlay) != null && dt.value);
      });
      Xe.forEach((tt, dt) => {
        const bt = lk(tt);
        bt != null && bt.value && (bt.value.overlayVisible.value = dt === Xe.length - 1);
      });
    }
    const Le = eh(() => i.modalId), Je = eh(() => i.hideOverlay), je = eh(() => i.overlayBehavior), ot = Ae(() => ({
      modalId: Le,
      hideOverlay: Je,
      overlayBehavior: je,
      overlayVisible: de,
      toggle(Xe) {
        return new Promise((tt) => {
          q = gU((bt) => tt(bt));
          const dt = typeof Xe == "boolean" ? Xe : !N.value;
          N.value = dt;
        });
      }
    }));
    return t({
      modalExposed: ot
    }), (Xe, tt) => (V(), Tt(IN, {
      to: Xe.teleportTo ? Xe.teleportTo : void 0,
      disabled: !Xe.teleportTo
    }, [
      Xe.displayDirective !== "if" || ne(ee) ? xr((V(), G("div", jf({ key: 0 }, ne(c), {
        ref_key: "vfmRootEl",
        ref: x,
        class: ["vfm vfm--fixed vfm--inset", { "vfm--prevent-none": Xe.background === "interactive" }],
        style: { zIndex: ne(O) },
        role: "dialog",
        "aria-modal": "true",
        onKeydown: tt[7] || (tt[7] = jy(() => ne(pe)(), ["esc"])),
        onMouseup: tt[8] || (tt[8] = zi(() => ne(Ne)(), ["self"])),
        onMousedown: tt[9] || (tt[9] = zi((dt) => ne(We)(dt), ["self"]))
      }), [
        Je.value ? _e("", !0) : (V(), Tt($r, jf({ key: 0 }, ne(ve), H2(ne(me))), {
          default: Qt(() => [
            Xe.displayDirective !== "if" || ne(de) ? xr((V(), G("div", {
              key: 0,
              class: Et(["vfm__overlay vfm--overlay vfm--absolute vfm--inset vfm--prevent-none", Xe.overlayClass]),
              style: g1(Xe.overlayStyle),
              "aria-hidden": "true"
            }, null, 6)), [
              [th, Xe.displayDirective !== "show" || ne(de)],
              [ne(Vb), Xe.displayDirective !== "visible" || ne(de)]
            ]) : _e("", !0)
          ]),
          _: 1
        }, 16)),
        it($r, jf(ne(oe), H2(ne(ae))), {
          default: Qt(() => [
            Xe.displayDirective !== "if" || ne(te) ? xr((V(), G("div", jf({
              key: 0,
              ref_key: "vfmContentEl",
              ref: $,
              class: ["vfm__content vfm--outline-none", [Xe.contentClass, { "vfm--prevent-auto": Xe.background === "interactive" }]],
              style: Xe.contentStyle,
              tabindex: "0"
            }, ne(et), {
              onMousedown: tt[6] || (tt[6] = () => ne(We)())
            }), [
              er(Xe.$slots, "default", AN(EN({ close: qe }))),
              Xe.showSwipeBanner ? (V(), G("div", {
                key: 0,
                ref_key: "swipeBannerEl",
                ref: Ge,
                class: "vfm-swipe-banner-container",
                onTouchstart: tt[2] || (tt[2] = (dt) => ne(ft)(dt))
              }, [
                er(Xe.$slots, "swipe-banner", {}, () => [
                  E("div", {
                    class: "vfm-swipe-banner-back",
                    onTouchstart: tt[0] || (tt[0] = (dt) => Xe.swipeToClose === "left" && dt.preventDefault())
                  }, null, 32),
                  E("div", {
                    class: "vfm-swipe-banner-forward",
                    onTouchstart: tt[1] || (tt[1] = (dt) => Xe.swipeToClose === "right" && dt.preventDefault())
                  }, null, 32)
                ])
              ], 544)) : !Xe.showSwipeBanner && Xe.preventNavigationGestures ? (V(), G("div", {
                key: 1,
                class: "vfm-swipe-banner-container",
                onTouchstart: tt[5] || (tt[5] = (dt) => ne(ft)(dt))
              }, [
                E("div", {
                  class: "vfm-swipe-banner-back",
                  onTouchstart: tt[3] || (tt[3] = (dt) => Xe.swipeToClose === "left" && dt.preventDefault())
                }, null, 32),
                E("div", {
                  class: "vfm-swipe-banner-forward",
                  onTouchstart: tt[4] || (tt[4] = (dt) => Xe.swipeToClose === "right" && dt.preventDefault())
                }, null, 32)
              ], 32)) : _e("", !0)
            ], 16)), [
              [th, Xe.displayDirective !== "show" || ne(te)],
              [ne(Vb), Xe.displayDirective !== "visible" || ne(te)]
            ]) : _e("", !0)
          ]),
          _: 3
        }, 16)
      ], 16)), [
        [th, Xe.displayDirective !== "show" || ne(ee)],
        [ne(Vb), Xe.displayDirective !== "visible" || ne(ee)]
      ]) : _e("", !0)
    ], 8, ["to", "disabled"]));
  }
});
function WU() {
  const e = VU();
  if (!e)
    throw new Error(
      `[Vue Final Modal]: getActiveVfm was called with no active Vfm. Did you forget to install vfm?
	const vfm = createVfm()
	app.use(vfm)
This will fail in production.`
    );
  return e;
}
const ZU = {
  key: 0,
  class: "vacv-modal-header"
}, qU = ["aria-label"], jU = { class: "vacv-modal-content-inner" }, GU = { class: "modal__title" }, YU = { class: "modal__content" }, KU = /* @__PURE__ */ E("div", { class: "modal__action" }, null, -1), rl = /* @__PURE__ */ at({
  __name: "VacvCustomModal",
  props: {
    clickToClose: { type: Boolean },
    hideClose: { type: Boolean },
    size: {}
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = t, i = () => {
      n("close", "click");
    }, r = (c) => {
      (c.key === "Escape" || c.key === "esc") && n("close", "escape");
    };
    return Li(() => {
      document.addEventListener("keydown", r);
    }), tl(() => {
      document.removeEventListener("keydown", r);
    }), (c, d) => (V(), Tt(ne(HU), {
      "initial-focus": !0,
      "esc-to-close": !0,
      classes: "vacv-modal-container",
      "content-class": "vacv-modal-content-outer",
      "before-close": "clickClose",
      "click-to-close": c.clickToClose,
      "data-hide-close": c.hideClose,
      "data-size": c.size && c.size === "small" ? "small" : "medium"
    }, {
      default: Qt(() => [
        c.hideClose ? _e("", !0) : (V(), G("div", ZU, [
          E("button", {
            class: "modal__close btn-close",
            onClick: zi(i, ["prevent"]),
            "aria-label": c.$t("vacvComponents.common.buttons.close")
          }, null, 8, qU)
        ])),
        E("div", jU, [
          E("span", GU, [
            er(c.$slots, "title")
          ]),
          E("div", YU, [
            er(c.$slots, "default")
          ]),
          KU
        ])
      ]),
      _: 3
    }, 8, ["click-to-close", "data-hide-close", "data-size"]));
  }
}), XU = { class: "vacv-promo-badge" }, JU = { class: "vacv-promo-badge__title" }, QU = ["innerHTML"], e8 = /* @__PURE__ */ at({
  __name: "VacvPromoBadge",
  props: {
    badge: {},
    modalTitle: {},
    modalText: {},
    origin: {}
  },
  setup(e) {
    const t = e, n = $e(!1), i = () => {
      var d;
      (d = window.dataLayer) == null || d.push({
        event: t.origin,
        aeroplanElement: "Aeroplan Badge",
        aeroplanElementValue: t.badge
      });
    }, r = () => {
      n.value = !0, i();
    }, c = () => {
      n.value = !1;
    };
    return (d, a) => (V(), G("div", XU, [
      E("button", {
        onClick: r,
        class: "vacv-promo-badge__button",
        "aria-haspopup": "true"
      }, Y(d.badge), 1),
      it(rl, {
        onClose: c,
        modelValue: n.value,
        "onUpdate:modelValue": a[0] || (a[0] = (f) => n.value = f),
        class: "vacv-modal modal-fullscreen vacv-modal-centered vacv-promo-badge__modal"
      }, {
        default: Qt(() => [
          E("div", JU, Y(d.modalTitle), 1),
          E("div", {
            class: "vacv-promo-badge__content vacv-editor",
            innerHTML: d.modalText
          }, null, 8, QU)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]));
  }
}), Zn = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [i, r] of t)
    n[i] = r;
  return n;
}, eP = /* @__PURE__ */ Zn(e8, [["__scopeId", "data-v-acb3cd2b"]]);
function $w(e, t, n) {
  var i, r, c, d, a;
  t == null && (t = 100);
  function f() {
    var x = Date.now() - d;
    x < t && x >= 0 ? i = setTimeout(f, t - x) : (i = null, n || (a = e.apply(c, r), c = r = null));
  }
  var g = function() {
    c = this, r = arguments, d = Date.now();
    var x = n && !i;
    return i || (i = setTimeout(f, t)), x && (a = e.apply(c, r), c = r = null), a;
  };
  return g.clear = function() {
    i && (clearTimeout(i), i = null);
  }, g.flush = function() {
    i && (a = e.apply(c, r), c = r = null, clearTimeout(i), i = null);
  }, g;
}
$w.debounce = $w;
var Ub = $w;
function t8(e, t, n) {
  yo(e) ? At(e, (i, r) => {
    r == null || r.removeEventListener(t, n), i == null || i.addEventListener(t, n);
  }) : Li(() => {
    e.addEventListener(t, n);
  }), tl(() => {
    var i;
    (i = ne(e)) === null || i === void 0 || i.removeEventListener(t, n);
  });
}
function n8(e, t) {
  const n = "pointerdown";
  return typeof window > "u" || !window ? void 0 : t8(window, n, (r) => {
    const c = ne(e);
    c && (c === r.target || r.composedPath().includes(c) || t(r));
  });
}
function i8(e, t, n) {
  let i = null;
  const r = $e(!1);
  Li(() => {
    (e.content !== void 0 || n.value) && (r.value = !0), i = new MutationObserver(c), i.observe(t.value, {
      childList: !0,
      subtree: !0
    });
  }), tl(() => i.disconnect()), At(n, (d) => {
    d ? r.value = !0 : r.value = !1;
  });
  const c = () => {
    e.content ? r.value = !0 : r.value = !1;
  };
  return {
    hasContent: r
  };
}
function xh(e, t) {
  var n = e.getBoundingClientRect(), i = 1, r = 1;
  return {
    width: n.width / i,
    height: n.height / r,
    top: n.top / r,
    right: n.right / i,
    bottom: n.bottom / r,
    left: n.left / i,
    x: n.left / i,
    y: n.top / r
  };
}
function sl(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function ix(e) {
  var t = sl(e), n = t.pageXOffset, i = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: i
  };
}
function $m(e) {
  var t = sl(e).Element;
  return e instanceof t || e instanceof Element;
}
function pa(e) {
  var t = sl(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function tP(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = sl(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function r8(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function s8(e) {
  return e === sl(e) || !pa(e) ? ix(e) : r8(e);
}
function zl(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function Bu(e) {
  return (($m(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function rx(e) {
  return xh(Bu(e)).left + ix(e).scrollLeft;
}
function Oc(e) {
  return sl(e).getComputedStyle(e);
}
function sx(e) {
  var t = Oc(e), n = t.overflow, i = t.overflowX, r = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + r + i);
}
function o8(e) {
  var t = e.getBoundingClientRect(), n = t.width / e.offsetWidth || 1, i = t.height / e.offsetHeight || 1;
  return n !== 1 || i !== 1;
}
function a8(e, t, n) {
  n === void 0 && (n = !1);
  var i = pa(t);
  pa(t) && o8(t);
  var r = Bu(t), c = xh(e), d = {
    scrollLeft: 0,
    scrollTop: 0
  }, a = {
    x: 0,
    y: 0
  };
  return (i || !i && !n) && ((zl(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  sx(r)) && (d = s8(t)), pa(t) ? (a = xh(t), a.x += t.clientLeft, a.y += t.clientTop) : r && (a.x = rx(r))), {
    x: c.left + d.scrollLeft - a.x,
    y: c.top + d.scrollTop - a.y,
    width: c.width,
    height: c.height
  };
}
function ox(e) {
  var t = xh(e), n = e.offsetWidth, i = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - i) <= 1 && (i = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: i
  };
}
function s_(e) {
  return zl(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (tP(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Bu(e)
  );
}
function nP(e) {
  return ["html", "body", "#document"].indexOf(zl(e)) >= 0 ? e.ownerDocument.body : pa(e) && sx(e) ? e : nP(s_(e));
}
function am(e, t) {
  var n;
  t === void 0 && (t = []);
  var i = nP(e), r = i === ((n = e.ownerDocument) == null ? void 0 : n.body), c = sl(i), d = r ? [c].concat(c.visualViewport || [], sx(i) ? i : []) : i, a = t.concat(d);
  return r ? a : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    a.concat(am(s_(d)))
  );
}
function l8(e) {
  return ["table", "td", "th"].indexOf(zl(e)) >= 0;
}
function ck(e) {
  return !pa(e) || // https://github.com/popperjs/popper-core/issues/837
  Oc(e).position === "fixed" ? null : e.offsetParent;
}
function c8(e) {
  var t = navigator.userAgent.toLowerCase().indexOf("firefox") !== -1, n = navigator.userAgent.indexOf("Trident") !== -1;
  if (n && pa(e)) {
    var i = Oc(e);
    if (i.position === "fixed")
      return null;
  }
  for (var r = s_(e); pa(r) && ["html", "body"].indexOf(zl(r)) < 0; ) {
    var c = Oc(r);
    if (c.transform !== "none" || c.perspective !== "none" || c.contain === "paint" || ["transform", "perspective"].indexOf(c.willChange) !== -1 || t && c.willChange === "filter" || t && c.filter && c.filter !== "none")
      return r;
    r = r.parentNode;
  }
  return null;
}
function Um(e) {
  for (var t = sl(e), n = ck(e); n && l8(n) && Oc(n).position === "static"; )
    n = ck(n);
  return n && (zl(n) === "html" || zl(n) === "body" && Oc(n).position === "static") ? t : n || c8(e) || t;
}
var ha = "top", Xa = "bottom", Ja = "right", fa = "left", ax = "auto", Hm = [ha, Xa, Ja, fa], $h = "start", Cm = "end", u8 = "clippingParents", iP = "viewport", Of = "popper", d8 = "reference", uk = /* @__PURE__ */ Hm.reduce(function(e, t) {
  return e.concat([t + "-" + $h, t + "-" + Cm]);
}, []), rP = /* @__PURE__ */ [].concat(Hm, [ax]).reduce(function(e, t) {
  return e.concat([t, t + "-" + $h, t + "-" + Cm]);
}, []), p8 = "beforeRead", h8 = "read", f8 = "afterRead", m8 = "beforeMain", v8 = "main", g8 = "afterMain", y8 = "beforeWrite", _8 = "write", b8 = "afterWrite", w8 = [p8, h8, f8, m8, v8, g8, y8, _8, b8];
function x8(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), i = [];
  e.forEach(function(c) {
    t.set(c.name, c);
  });
  function r(c) {
    n.add(c.name);
    var d = [].concat(c.requires || [], c.requiresIfExists || []);
    d.forEach(function(a) {
      if (!n.has(a)) {
        var f = t.get(a);
        f && r(f);
      }
    }), i.push(c);
  }
  return e.forEach(function(c) {
    n.has(c.name) || r(c);
  }), i;
}
function $8(e) {
  var t = x8(e);
  return w8.reduce(function(n, i) {
    return n.concat(t.filter(function(r) {
      return r.phase === i;
    }));
  }, []);
}
function C8(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function Ol(e) {
  return e.split("-")[0];
}
function k8(e) {
  var t = e.reduce(function(n, i) {
    var r = n[i.name];
    return n[i.name] = r ? Object.assign({}, r, i, {
      options: Object.assign({}, r.options, i.options),
      data: Object.assign({}, r.data, i.data)
    }) : i, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
function S8(e) {
  var t = sl(e), n = Bu(e), i = t.visualViewport, r = n.clientWidth, c = n.clientHeight, d = 0, a = 0;
  return i && (r = i.width, c = i.height, /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || (d = i.offsetLeft, a = i.offsetTop)), {
    width: r,
    height: c,
    x: d + rx(e),
    y: a
  };
}
var Eu = Math.max, km = Math.min, Rv = Math.round;
function T8(e) {
  var t, n = Bu(e), i = ix(e), r = (t = e.ownerDocument) == null ? void 0 : t.body, c = Eu(n.scrollWidth, n.clientWidth, r ? r.scrollWidth : 0, r ? r.clientWidth : 0), d = Eu(n.scrollHeight, n.clientHeight, r ? r.scrollHeight : 0, r ? r.clientHeight : 0), a = -i.scrollLeft + rx(e), f = -i.scrollTop;
  return Oc(r || n).direction === "rtl" && (a += Eu(n.clientWidth, r ? r.clientWidth : 0) - c), {
    width: c,
    height: d,
    x: a,
    y: f
  };
}
function sP(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && tP(n)) {
    var i = t;
    do {
      if (i && e.isSameNode(i))
        return !0;
      i = i.parentNode || i.host;
    } while (i);
  }
  return !1;
}
function Cw(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function I8(e) {
  var t = xh(e);
  return t.top = t.top + e.clientTop, t.left = t.left + e.clientLeft, t.bottom = t.top + e.clientHeight, t.right = t.left + e.clientWidth, t.width = e.clientWidth, t.height = e.clientHeight, t.x = t.left, t.y = t.top, t;
}
function dk(e, t) {
  return t === iP ? Cw(S8(e)) : pa(t) ? I8(t) : Cw(T8(Bu(e)));
}
function A8(e) {
  var t = am(s_(e)), n = ["absolute", "fixed"].indexOf(Oc(e).position) >= 0, i = n && pa(e) ? Um(e) : e;
  return $m(i) ? t.filter(function(r) {
    return $m(r) && sP(r, i) && zl(r) !== "body";
  }) : [];
}
function E8(e, t, n) {
  var i = t === "clippingParents" ? A8(e) : [].concat(t), r = [].concat(i, [n]), c = r[0], d = r.reduce(function(a, f) {
    var g = dk(e, f);
    return a.top = Eu(g.top, a.top), a.right = km(g.right, a.right), a.bottom = km(g.bottom, a.bottom), a.left = Eu(g.left, a.left), a;
  }, dk(e, c));
  return d.width = d.right - d.left, d.height = d.bottom - d.top, d.x = d.left, d.y = d.top, d;
}
function Ch(e) {
  return e.split("-")[1];
}
function lx(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function oP(e) {
  var t = e.reference, n = e.element, i = e.placement, r = i ? Ol(i) : null, c = i ? Ch(i) : null, d = t.x + t.width / 2 - n.width / 2, a = t.y + t.height / 2 - n.height / 2, f;
  switch (r) {
    case ha:
      f = {
        x: d,
        y: t.y - n.height
      };
      break;
    case Xa:
      f = {
        x: d,
        y: t.y + t.height
      };
      break;
    case Ja:
      f = {
        x: t.x + t.width,
        y: a
      };
      break;
    case fa:
      f = {
        x: t.x - n.width,
        y: a
      };
      break;
    default:
      f = {
        x: t.x,
        y: t.y
      };
  }
  var g = r ? lx(r) : null;
  if (g != null) {
    var x = g === "y" ? "height" : "width";
    switch (c) {
      case $h:
        f[g] = f[g] - (t[x] / 2 - n[x] / 2);
        break;
      case Cm:
        f[g] = f[g] + (t[x] / 2 - n[x] / 2);
        break;
    }
  }
  return f;
}
function aP() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function lP(e) {
  return Object.assign({}, aP(), e);
}
function cP(e, t) {
  return t.reduce(function(n, i) {
    return n[i] = e, n;
  }, {});
}
function cx(e, t) {
  t === void 0 && (t = {});
  var n = t, i = n.placement, r = i === void 0 ? e.placement : i, c = n.boundary, d = c === void 0 ? u8 : c, a = n.rootBoundary, f = a === void 0 ? iP : a, g = n.elementContext, x = g === void 0 ? Of : g, $ = n.altBoundary, A = $ === void 0 ? !1 : $, I = n.padding, O = I === void 0 ? 0 : I, B = lP(typeof O != "number" ? O : cP(O, Hm)), H = x === Of ? d8 : Of, N = e.rects.popper, K = e.elements[A ? H : x], U = E8($m(K) ? K : K.contextElement || Bu(e.elements.popper), d, f), q = xh(e.elements.reference), ee = oP({
    reference: q,
    element: N,
    placement: r
  }), te = Cw(Object.assign({}, N, ee)), ae = x === Of ? te : q, oe = {
    top: U.top - ae.top + B.top,
    bottom: ae.bottom - U.bottom + B.bottom,
    left: U.left - ae.left + B.left,
    right: ae.right - U.right + B.right
  }, de = e.modifiersData.offset;
  if (x === Of && de) {
    var me = de[r];
    Object.keys(oe).forEach(function(ve) {
      var re = [Ja, Xa].indexOf(ve) >= 0 ? 1 : -1, le = [ha, Xa].indexOf(ve) >= 0 ? "y" : "x";
      oe[ve] += me[le] * re;
    });
  }
  return oe;
}
var pk = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function hk() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(i) {
    return !(i && typeof i.getBoundingClientRect == "function");
  });
}
function P8(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, i = n === void 0 ? [] : n, r = t.defaultOptions, c = r === void 0 ? pk : r;
  return function(a, f, g) {
    g === void 0 && (g = c);
    var x = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, pk, c),
      modifiersData: {},
      elements: {
        reference: a,
        popper: f
      },
      attributes: {},
      styles: {}
    }, $ = [], A = !1, I = {
      state: x,
      setOptions: function(N) {
        var K = typeof N == "function" ? N(x.options) : N;
        B(), x.options = Object.assign({}, c, x.options, K), x.scrollParents = {
          reference: $m(a) ? am(a) : a.contextElement ? am(a.contextElement) : [],
          popper: am(f)
        };
        var U = $8(k8([].concat(i, x.options.modifiers)));
        return x.orderedModifiers = U.filter(function(q) {
          return q.enabled;
        }), O(), I.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!A) {
          var N = x.elements, K = N.reference, U = N.popper;
          if (hk(K, U)) {
            x.rects = {
              reference: a8(K, Um(U), x.options.strategy === "fixed"),
              popper: ox(U)
            }, x.reset = !1, x.placement = x.options.placement, x.orderedModifiers.forEach(function(me) {
              return x.modifiersData[me.name] = Object.assign({}, me.data);
            });
            for (var q = 0; q < x.orderedModifiers.length; q++) {
              if (x.reset === !0) {
                x.reset = !1, q = -1;
                continue;
              }
              var ee = x.orderedModifiers[q], te = ee.fn, ae = ee.options, oe = ae === void 0 ? {} : ae, de = ee.name;
              typeof te == "function" && (x = te({
                state: x,
                options: oe,
                name: de,
                instance: I
              }) || x);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: C8(function() {
        return new Promise(function(H) {
          I.forceUpdate(), H(x);
        });
      }),
      destroy: function() {
        B(), A = !0;
      }
    };
    if (!hk(a, f))
      return I;
    I.setOptions(g).then(function(H) {
      !A && g.onFirstUpdate && g.onFirstUpdate(H);
    });
    function O() {
      x.orderedModifiers.forEach(function(H) {
        var N = H.name, K = H.options, U = K === void 0 ? {} : K, q = H.effect;
        if (typeof q == "function") {
          var ee = q({
            state: x,
            name: N,
            instance: I,
            options: U
          }), te = function() {
          };
          $.push(ee || te);
        }
      });
    }
    function B() {
      $.forEach(function(H) {
        return H();
      }), $ = [];
    }
    return I;
  };
}
var zv = {
  passive: !0
};
function M8(e) {
  var t = e.state, n = e.instance, i = e.options, r = i.scroll, c = r === void 0 ? !0 : r, d = i.resize, a = d === void 0 ? !0 : d, f = sl(t.elements.popper), g = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return c && g.forEach(function(x) {
    x.addEventListener("scroll", n.update, zv);
  }), a && f.addEventListener("resize", n.update, zv), function() {
    c && g.forEach(function(x) {
      x.removeEventListener("scroll", n.update, zv);
    }), a && f.removeEventListener("resize", n.update, zv);
  };
}
var D8 = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: M8,
  data: {}
};
function L8(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = oP({
    reference: t.rects.reference,
    element: t.rects.popper,
    placement: t.placement
  });
}
var O8 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: L8,
  data: {}
}, N8 = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function F8(e) {
  var t = e.x, n = e.y, i = window, r = i.devicePixelRatio || 1;
  return {
    x: Rv(Rv(t * r) / r) || 0,
    y: Rv(Rv(n * r) / r) || 0
  };
}
function fk(e) {
  var t, n = e.popper, i = e.popperRect, r = e.placement, c = e.variation, d = e.offsets, a = e.position, f = e.gpuAcceleration, g = e.adaptive, x = e.roundOffsets, $ = x === !0 ? F8(d) : typeof x == "function" ? x(d) : d, A = $.x, I = A === void 0 ? 0 : A, O = $.y, B = O === void 0 ? 0 : O, H = d.hasOwnProperty("x"), N = d.hasOwnProperty("y"), K = fa, U = ha, q = window;
  if (g) {
    var ee = Um(n), te = "clientHeight", ae = "clientWidth";
    ee === sl(n) && (ee = Bu(n), Oc(ee).position !== "static" && a === "absolute" && (te = "scrollHeight", ae = "scrollWidth")), ee = ee, (r === ha || (r === fa || r === Ja) && c === Cm) && (U = Xa, B -= ee[te] - i.height, B *= f ? 1 : -1), (r === fa || (r === ha || r === Xa) && c === Cm) && (K = Ja, I -= ee[ae] - i.width, I *= f ? 1 : -1);
  }
  var oe = Object.assign({
    position: a
  }, g && N8);
  if (f) {
    var de;
    return Object.assign({}, oe, (de = {}, de[U] = N ? "0" : "", de[K] = H ? "0" : "", de.transform = (q.devicePixelRatio || 1) <= 1 ? "translate(" + I + "px, " + B + "px)" : "translate3d(" + I + "px, " + B + "px, 0)", de));
  }
  return Object.assign({}, oe, (t = {}, t[U] = N ? B + "px" : "", t[K] = H ? I + "px" : "", t.transform = "", t));
}
function R8(e) {
  var t = e.state, n = e.options, i = n.gpuAcceleration, r = i === void 0 ? !0 : i, c = n.adaptive, d = c === void 0 ? !0 : c, a = n.roundOffsets, f = a === void 0 ? !0 : a, g = {
    placement: Ol(t.placement),
    variation: Ch(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: r
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, fk(Object.assign({}, g, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: d,
    roundOffsets: f
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, fk(Object.assign({}, g, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: f
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
var z8 = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: R8,
  data: {}
};
function B8(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var i = t.styles[n] || {}, r = t.attributes[n] || {}, c = t.elements[n];
    !pa(c) || !zl(c) || (Object.assign(c.style, i), Object.keys(r).forEach(function(d) {
      var a = r[d];
      a === !1 ? c.removeAttribute(d) : c.setAttribute(d, a === !0 ? "" : a);
    }));
  });
}
function V8(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(i) {
      var r = t.elements[i], c = t.attributes[i] || {}, d = Object.keys(t.styles.hasOwnProperty(i) ? t.styles[i] : n[i]), a = d.reduce(function(f, g) {
        return f[g] = "", f;
      }, {});
      !pa(r) || !zl(r) || (Object.assign(r.style, a), Object.keys(c).forEach(function(f) {
        r.removeAttribute(f);
      }));
    });
  };
}
var U8 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: B8,
  effect: V8,
  requires: ["computeStyles"]
}, H8 = [D8, O8, z8, U8], W8 = /* @__PURE__ */ P8({
  defaultModifiers: H8
});
function Z8(e) {
  return e === "x" ? "y" : "x";
}
function _g(e, t, n) {
  return Eu(e, km(t, n));
}
function q8(e) {
  var t = e.state, n = e.options, i = e.name, r = n.mainAxis, c = r === void 0 ? !0 : r, d = n.altAxis, a = d === void 0 ? !1 : d, f = n.boundary, g = n.rootBoundary, x = n.altBoundary, $ = n.padding, A = n.tether, I = A === void 0 ? !0 : A, O = n.tetherOffset, B = O === void 0 ? 0 : O, H = cx(t, {
    boundary: f,
    rootBoundary: g,
    padding: $,
    altBoundary: x
  }), N = Ol(t.placement), K = Ch(t.placement), U = !K, q = lx(N), ee = Z8(q), te = t.modifiersData.popperOffsets, ae = t.rects.reference, oe = t.rects.popper, de = typeof B == "function" ? B(Object.assign({}, t.rects, {
    placement: t.placement
  })) : B, me = {
    x: 0,
    y: 0
  };
  if (te) {
    if (c || a) {
      var ve = q === "y" ? ha : fa, re = q === "y" ? Xa : Ja, le = q === "y" ? "height" : "width", pe = te[q], Ne = te[q] + H[ve], We = te[q] - H[re], Ge = I ? -oe[le] / 2 : 0, et = K === $h ? ae[le] : oe[le], ft = K === $h ? -oe[le] : -ae[le], De = t.elements.arrow, Ke = I && De ? ox(De) : {
        width: 0,
        height: 0
      }, gt = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : aP(), qe = gt[ve], rt = gt[re], Le = _g(0, ae[le], Ke[le]), Je = U ? ae[le] / 2 - Ge - Le - qe - de : et - Le - qe - de, je = U ? -ae[le] / 2 + Ge + Le + rt + de : ft + Le + rt + de, ot = t.elements.arrow && Um(t.elements.arrow), Xe = ot ? q === "y" ? ot.clientTop || 0 : ot.clientLeft || 0 : 0, tt = t.modifiersData.offset ? t.modifiersData.offset[t.placement][q] : 0, dt = te[q] + Je - tt - Xe, bt = te[q] + je - tt;
      if (c) {
        var qt = _g(I ? km(Ne, dt) : Ne, pe, I ? Eu(We, bt) : We);
        te[q] = qt, me[q] = qt - pe;
      }
      if (a) {
        var Oe = q === "x" ? ha : fa, Bt = q === "x" ? Xa : Ja, Tn = te[ee], hn = Tn + H[Oe], Ht = Tn - H[Bt], qn = _g(I ? km(hn, dt) : hn, Tn, I ? Eu(Ht, bt) : Ht);
        te[ee] = qn, me[ee] = qn - Tn;
      }
    }
    t.modifiersData[i] = me;
  }
}
var j8 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: q8,
  requiresIfExists: ["offset"]
}, G8 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function bg(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return G8[t];
  });
}
var Y8 = {
  start: "end",
  end: "start"
};
function mk(e) {
  return e.replace(/start|end/g, function(t) {
    return Y8[t];
  });
}
function K8(e, t) {
  t === void 0 && (t = {});
  var n = t, i = n.placement, r = n.boundary, c = n.rootBoundary, d = n.padding, a = n.flipVariations, f = n.allowedAutoPlacements, g = f === void 0 ? rP : f, x = Ch(i), $ = x ? a ? uk : uk.filter(function(O) {
    return Ch(O) === x;
  }) : Hm, A = $.filter(function(O) {
    return g.indexOf(O) >= 0;
  });
  A.length === 0 && (A = $);
  var I = A.reduce(function(O, B) {
    return O[B] = cx(e, {
      placement: B,
      boundary: r,
      rootBoundary: c,
      padding: d
    })[Ol(B)], O;
  }, {});
  return Object.keys(I).sort(function(O, B) {
    return I[O] - I[B];
  });
}
function X8(e) {
  if (Ol(e) === ax)
    return [];
  var t = bg(e);
  return [mk(e), t, mk(t)];
}
function J8(e) {
  var t = e.state, n = e.options, i = e.name;
  if (!t.modifiersData[i]._skip) {
    for (var r = n.mainAxis, c = r === void 0 ? !0 : r, d = n.altAxis, a = d === void 0 ? !0 : d, f = n.fallbackPlacements, g = n.padding, x = n.boundary, $ = n.rootBoundary, A = n.altBoundary, I = n.flipVariations, O = I === void 0 ? !0 : I, B = n.allowedAutoPlacements, H = t.options.placement, N = Ol(H), K = N === H, U = f || (K || !O ? [bg(H)] : X8(H)), q = [H].concat(U).reduce(function(rt, Le) {
      return rt.concat(Ol(Le) === ax ? K8(t, {
        placement: Le,
        boundary: x,
        rootBoundary: $,
        padding: g,
        flipVariations: O,
        allowedAutoPlacements: B
      }) : Le);
    }, []), ee = t.rects.reference, te = t.rects.popper, ae = /* @__PURE__ */ new Map(), oe = !0, de = q[0], me = 0; me < q.length; me++) {
      var ve = q[me], re = Ol(ve), le = Ch(ve) === $h, pe = [ha, Xa].indexOf(re) >= 0, Ne = pe ? "width" : "height", We = cx(t, {
        placement: ve,
        boundary: x,
        rootBoundary: $,
        altBoundary: A,
        padding: g
      }), Ge = pe ? le ? Ja : fa : le ? Xa : ha;
      ee[Ne] > te[Ne] && (Ge = bg(Ge));
      var et = bg(Ge), ft = [];
      if (c && ft.push(We[re] <= 0), a && ft.push(We[Ge] <= 0, We[et] <= 0), ft.every(function(rt) {
        return rt;
      })) {
        de = ve, oe = !1;
        break;
      }
      ae.set(ve, ft);
    }
    if (oe)
      for (var De = O ? 3 : 1, Ke = function(Le) {
        var Je = q.find(function(je) {
          var ot = ae.get(je);
          if (ot)
            return ot.slice(0, Le).every(function(Xe) {
              return Xe;
            });
        });
        if (Je)
          return de = Je, "break";
      }, gt = De; gt > 0; gt--) {
        var qe = Ke(gt);
        if (qe === "break") break;
      }
    t.placement !== de && (t.modifiersData[i]._skip = !0, t.placement = de, t.reset = !0);
  }
}
var Q8 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: J8,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function eH(e, t, n) {
  var i = Ol(e), r = [fa, ha].indexOf(i) >= 0 ? -1 : 1, c = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, d = c[0], a = c[1];
  return d = d || 0, a = (a || 0) * r, [fa, Ja].indexOf(i) >= 0 ? {
    x: a,
    y: d
  } : {
    x: d,
    y: a
  };
}
function tH(e) {
  var t = e.state, n = e.options, i = e.name, r = n.offset, c = r === void 0 ? [0, 0] : r, d = rP.reduce(function(x, $) {
    return x[$] = eH($, t.rects, c), x;
  }, {}), a = d[t.placement], f = a.x, g = a.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += f, t.modifiersData.popperOffsets.y += g), t.modifiersData[i] = d;
}
var nH = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: tH
}, iH = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, lP(typeof t != "number" ? t : cP(t, Hm));
};
function rH(e) {
  var t, n = e.state, i = e.name, r = e.options, c = n.elements.arrow, d = n.modifiersData.popperOffsets, a = Ol(n.placement), f = lx(a), g = [fa, Ja].indexOf(a) >= 0, x = g ? "height" : "width";
  if (!(!c || !d)) {
    var $ = iH(r.padding, n), A = ox(c), I = f === "y" ? ha : fa, O = f === "y" ? Xa : Ja, B = n.rects.reference[x] + n.rects.reference[f] - d[f] - n.rects.popper[x], H = d[f] - n.rects.reference[f], N = Um(c), K = N ? f === "y" ? N.clientHeight || 0 : N.clientWidth || 0 : 0, U = B / 2 - H / 2, q = $[I], ee = K - A[x] - $[O], te = K / 2 - A[x] / 2 + U, ae = _g(q, te, ee), oe = f;
    n.modifiersData[i] = (t = {}, t[oe] = ae, t.centerOffset = ae - te, t);
  }
}
function sH(e) {
  var t = e.state, n = e.options, i = n.element, r = i === void 0 ? "[data-popper-arrow]" : i;
  r != null && (typeof r == "string" && (r = t.elements.popper.querySelector(r), !r) || sP(t.elements.popper, r) && (t.elements.arrow = r));
}
var oH = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: rH,
  effect: sH,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
const Hb = (e) => parseInt(e, 10);
function aH({
  arrowPadding: e,
  emit: t,
  locked: n,
  offsetDistance: i,
  offsetSkid: r,
  placement: c,
  popperNode: d,
  triggerNode: a
}) {
  const f = Er({
    isOpen: !1,
    popperInstance: null
  }), g = (B) => {
    var H;
    (H = f.popperInstance) === null || H === void 0 || H.setOptions((N) => ({
      ...N,
      modifiers: [...N.modifiers, {
        name: "eventListeners",
        enabled: B
      }]
    }));
  }, x = () => g(!0), $ = () => g(!1), A = () => {
    f.isOpen && (f.isOpen = !1, t("close:popper"));
  }, I = () => {
    f.isOpen || (f.isOpen = !0, t("open:popper"));
  };
  At([() => f.isOpen, c], async ([B]) => {
    B ? (await O(), x()) : $();
  });
  const O = async () => {
    await Rl(), f.popperInstance = W8(a.value, d.value, {
      placement: c.value,
      modifiers: [j8, Q8, {
        name: "flip",
        enabled: !n.value
      }, oH, {
        name: "arrow",
        options: {
          padding: Hb(e.value)
        }
      }, nH, {
        name: "offset",
        options: {
          offset: [Hb(r.value), Hb(i.value)]
        }
      }]
    }), f.popperInstance.update();
  };
  return tl(() => {
    var B;
    (B = f.popperInstance) === null || B === void 0 || B.destroy();
  }), {
    ...SI(f),
    open: I,
    close: A
  };
}
const lH = {
  id: "arrow",
  "data-popper-arrow": ""
};
function cH(e, t) {
  return V(), G("div", lH);
}
function uP(e, t) {
  t === void 0 && (t = {});
  var n = t.insertAt;
  if (!(!e || typeof document > "u")) {
    var i = document.head || document.getElementsByTagName("head")[0], r = document.createElement("style");
    r.type = "text/css", n === "top" && i.firstChild ? i.insertBefore(r, i.firstChild) : i.appendChild(r), r.styleSheet ? r.styleSheet.cssText = e : r.appendChild(document.createTextNode(e));
  }
}
var uH = `
#arrow[data-v-20b7fd4a],
  #arrow[data-v-20b7fd4a]::before {
    transition: background 250ms ease-in-out;
    position: absolute;
    width: calc(10px - var(--popper-theme-border-width, 0px));
    height: calc(10px - var(--popper-theme-border-width, 0px));
    box-sizing: border-box;
    background: var(--popper-theme-background-color);
}
#arrow[data-v-20b7fd4a] {
    visibility: hidden;
}
#arrow[data-v-20b7fd4a]::before {
    visibility: visible;
    content: "";
    transform: rotate(45deg);
}

  /* Top arrow */
.popper[data-popper-placement^="top"] > #arrow[data-v-20b7fd4a] {
    bottom: -5px;
}
.popper[data-popper-placement^="top"] > #arrow[data-v-20b7fd4a]::before {
    border-right: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
    border-bottom: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
}

  /* Bottom arrow */
.popper[data-popper-placement^="bottom"] > #arrow[data-v-20b7fd4a] {
    top: -5px;
}
.popper[data-popper-placement^="bottom"] > #arrow[data-v-20b7fd4a]::before {
    border-left: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
    border-top: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
}

  /* Left arrow */
.popper[data-popper-placement^="left"] > #arrow[data-v-20b7fd4a] {
    right: -5px;
}
.popper[data-popper-placement^="left"] > #arrow[data-v-20b7fd4a]::before {
    border-right: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
    border-top: var(--popper-theme-border-width)
      var(--popper-theme-border-style) var(--popper-theme-border-color);
}

  /* Right arrow */
.popper[data-popper-placement^="right"] > #arrow[data-v-20b7fd4a] {
    left: -5px;
}
`;
uP(uH);
const ux = {};
ux.render = cH;
ux.__scopeId = "data-v-20b7fd4a";
var dH = ux;
const pH = ["onKeyup"];
var dP = {
  props: {
    /**
     * Preferred placement (the "auto" placements will choose the side with most space.)
     */
    placement: {
      type: String,
      default: "bottom",
      validator: function(e) {
        return ["auto", "auto-start", "auto-end", "top", "top-start", "top-end", "bottom", "bottom-start", "bottom-end", "right", "right-start", "right-end", "left", "left-start", "left-end"].includes(e);
      }
    },
    /**
     * Disables automatically closing the popover when the user clicks away from it
     */
    disableClickAway: {
      type: Boolean,
      default: !1
    },
    /**
     * Offset in pixels along the trigger element
     */
    offsetSkid: {
      type: String,
      default: "0"
    },
    /**
     * Offset in pixels away from the trigger element
     */
    offsetDistance: {
      type: String,
      default: "12"
    },
    /**
     * Trigger the popper on hover
     */
    hover: {
      type: Boolean,
      default: !1
    },
    /**
     * Manually open/close the Popper, other events are ignored if this prop is set
     */
    show: {
      type: Boolean,
      default: null
    },
    /**
     * Disables the Popper. If it was already open, it will be closed.
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * Open the Popper after a delay (ms).
     */
    openDelay: {
      type: [Number, String],
      default: 0
    },
    /**
     * Close the Popper after a delay (ms).
     */
    closeDelay: {
      type: [Number, String],
      default: 0
    },
    /**
     * The z-index of the Popper.
     */
    zIndex: {
      type: [Number, String],
      default: 9999
    },
    /**
     * Display an arrow on the popper
     */
    arrow: {
      type: Boolean,
      default: !1
    },
    /**
     * Stop arrow from reaching the edge of the popper
     */
    arrowPadding: {
      type: String,
      default: "0"
    },
    /**
     * If the Popper should be interactive, it will close when clicked/hovered if false
     */
    interactive: {
      type: Boolean,
      default: !0
    },
    /**
     * Lock the Popper into place, it will not flip dynamically when it runs out of space if true
     */
    locked: {
      type: Boolean,
      default: !1
    },
    /**
     * If the content is just a simple string, it can be passed in as a prop
     */
    content: {
      type: String,
      default: null
    }
  },
  emits: ["open:popper", "close:popper"],
  setup(e, {
    emit: t
  }) {
    const n = e;
    Hl((et) => ({
      c81fc0a4: e.zIndex
    }));
    const i = PN(), r = $e(null), c = $e(null), d = $e(null), a = $e(!1);
    Li(() => {
      const et = i.default();
      if (et && et.length > 1)
        return console.error(`[Popper]: The <Popper> component expects only one child element at its root. You passed ${et.length} child nodes.`);
    });
    const {
      arrowPadding: f,
      closeDelay: g,
      content: x,
      disableClickAway: $,
      disabled: A,
      interactive: I,
      locked: O,
      offsetDistance: B,
      offsetSkid: H,
      openDelay: N,
      placement: K,
      show: U
    } = SI(n), {
      isOpen: q,
      open: ee,
      close: te
    } = aH({
      arrowPadding: f,
      emit: t,
      locked: O,
      offsetDistance: B,
      offsetSkid: H,
      placement: K,
      popperNode: c,
      triggerNode: d
    }), {
      hasContent: ae
    } = i8(i, c, x), oe = Ae(() => U.value !== null), de = Ae(() => A.value || !ae.value), me = Ae(() => q.value && !de.value), ve = Ae(() => !$.value && !oe.value), re = Ae(() => I.value ? `border: ${B.value}px solid transparent; margin: -${B.value}px;` : null), le = Ub.debounce(ee, N.value), pe = Ub.debounce(te, g.value), Ne = async () => {
      de.value || oe.value || (pe.clear(), le());
    }, We = async () => {
      oe.value || (le.clear(), pe());
    }, Ge = () => {
      q.value ? We() : Ne();
    };
    return At([ae, A], ([et, ft]) => {
      q.value && (!et || ft) && te();
    }), At(q, (et) => {
      et ? a.value = !0 : Ub.debounce(() => {
        a.value = !1;
      }, 200);
    }), ra(() => {
      oe.value && (U.value ? le() : pe());
    }), ra(() => {
      ve.value && n8(r, We);
    }), (et, ft) => (V(), G("div", {
      class: "inline-block",
      style: g1(ne(re)),
      onMouseleave: ft[2] || (ft[2] = (De) => e.hover && We()),
      ref: (De, Ke) => {
        Ke.popperContainerNode = De, r.value = De;
      }
    }, [E("div", {
      ref: (De, Ke) => {
        Ke.triggerNode = De, d.value = De;
      },
      onMouseover: ft[0] || (ft[0] = (De) => e.hover && Ne()),
      onClick: Ge,
      onFocus: Ne,
      onKeyup: jy(We, ["esc"])
    }, [er(et.$slots, "default")], 40, pH), it($r, {
      name: "fade"
    }, {
      default: Qt(() => [xr(E("div", {
        onClick: ft[1] || (ft[1] = (De) => !ne(I) && We()),
        class: "popper",
        ref: (De, Ke) => {
          Ke.popperNode = De, c.value = De;
        }
      }, [er(et.$slots, "content", {
        close: ne(te),
        isOpen: a.value
      }, () => [mt(Y(ne(x)), 1)]), e.arrow ? (V(), Tt(dH, {
        key: 0
      })) : _e("", !0)], 512), [[th, ne(me)]])]),
      _: 3
    })], 36));
  }
}, hH = `
.inline-block[data-v-5784ed69] {
    display: inline-block;
}
.popper[data-v-5784ed69] {
    transition: background 250ms ease-in-out;
    background: var(--popper-theme-background-color);
    padding: var(--popper-theme-padding);
    color: var(--popper-theme-text-color);
    border-radius: var(--popper-theme-border-radius);
    border-width: var(--popper-theme-border-width);
    border-style: var(--popper-theme-border-style);
    border-color: var(--popper-theme-border-color);
    box-shadow: var(--popper-theme-box-shadow);
    z-index: var(--c81fc0a4);
}
.popper[data-v-5784ed69]:hover,
  .popper:hover > #arrow[data-v-5784ed69]::before {
    background: var(--popper-theme-background-color-hover);
}
.inline-block[data-v-5784ed69] {
    display: inline-block;
}
.fade-enter-active[data-v-5784ed69],
  .fade-leave-active[data-v-5784ed69] {
    transition: opacity 0.2s ease;
}
.fade-enter-from[data-v-5784ed69],
  .fade-leave-to[data-v-5784ed69] {
    opacity: 0;
}
`;
uP(hH);
dP.__scopeId = "data-v-5784ed69";
var uy = /* @__PURE__ */ (() => {
  const e = dP;
  return e.install = (t) => {
    t.component("Popper", e);
  }, e;
})();
const fH = { class: "payment-title-wrapper" }, mH = { class: "securebooking-wrapper" }, vH = { class: "securebooking vacv-tooltip" }, gH = ["innerHTML"], yH = ["aria-label"], _H = {
  class: "tooltip-title",
  id: "tooltip-security-title"
}, bH = ["id", "innerHTML"], wH = {
  key: 0,
  class: "note"
}, OTe = /* @__PURE__ */ at({
  __name: "VacvTravellersTitle",
  props: {
    stepNumber: {}
  },
  setup(e) {
    const t = $e(!1), n = ey.generateId(12), i = $e();
    At(t, () => {
      t.value ? i.value = RI(
        ["popper", "btn-tooltip"],
        r
      ) : zI(i.value);
    });
    const r = () => (t.value = !t.value, t.value);
    return (c, d) => (V(), G("div", fH, [
      E("div", mH, [
        E("div", vH, [
          it(ne(uy), {
            arrow: "",
            show: t.value,
            placement: "bottom-start",
            role: "dialog",
            "aria-label": "tooltip-security-title",
            "aria-describedby": `tooltip-security-content-${ne(n)}`
          }, zg({
            default: Qt(() => [
              E("button", {
                class: "btn-tooltip linklook",
                onClick: r,
                innerHTML: c.$t("vacvComponents.travellersTitle.labels.secureBooking")
              }, null, 8, gH)
            ]),
            _: 2
          }, [
            t.value ? {
              name: "content",
              fn: Qt(() => [
                E("button", {
                  onClick: r,
                  class: "btn-close",
                  "aria-label": c.$t("vacvComponents.common.buttons.close")
                }, null, 8, yH),
                E("div", _H, Y(c.$t("vacvComponents.travellersTitle.messages.secureTooltipTitle")), 1),
                E("div", {
                  class: "tooltip-content",
                  id: `tooltip-security-content-${ne(n)}`,
                  innerHTML: c.$t(
                    "vacvComponents.travellersTitle.messages.secureTooltipContent"
                  )
                }, null, 8, bH)
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["show", "aria-describedby"])
        ]),
        E("h1", null, Y(c.$t("vacvComponents.travellersTitle.labels.title")), 1)
      ]),
      c.stepNumber !== 2 ? (V(), G("div", wH, Y(c.$t("vacvComponents.travellersTitle.labels.title-note")), 1)) : _e("", !0)
    ]));
  }
}), xH = ["id", "role", "aria-live", "aria-labelledby"], jh = /* @__PURE__ */ at({
  __name: "AccordionWrapper",
  props: {
    id: {},
    className: {},
    role: {},
    ariaLive: {},
    ariaLabelledby: {}
  },
  setup(e) {
    Hl((i) => ({
      bad741c4: t.value
    }));
    const t = $e("0px"), n = $e();
    return At(n, async (i) => {
      i != null && i.scrollHeight && (t.value = i.scrollHeight + "px");
    }), (i, r) => (V(), G("div", {
      id: i.id,
      class: Et("accordion-wrapper" + (i.className ? " " + i.className : "")),
      role: i.role,
      "aria-live": i.ariaLive,
      "aria-labelledby": i.ariaLabelledby,
      ref_key: "scrollHeightRef",
      ref: n
    }, [
      er(i.$slots, "default")
    ], 10, xH));
  }
}), $H = /* @__PURE__ */ at({
  __name: "VacvDataInput",
  props: {
    value: {},
    initialValue: {},
    icon: {},
    label: {},
    tabId: {},
    placeholder: {},
    validations: {},
    validationMessages: {},
    readonly: { type: Boolean },
    isValid: { type: Boolean }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, i = $e(!0), r = $e(n.initialValue ?? n.value), c = t, d = () => {
      c("click");
    }, a = Ae(() => {
      const f = [];
      return n.validations && f.push(
        ...n.validations.map((g) => [g])
      ), n.isValid !== null && f.push(["booleanCheck", i.value]), f.length > 0 ? f : void 0;
    });
    return At(
      () => n.isValid,
      (f) => {
        i.value = f !== void 0 ? f : !0;
      },
      { immediate: !0 }
    ), At(
      () => n.value,
      (f) => {
        f && (r.value = f);
      }
    ), (f, g) => {
      const x = Ur("FormKit");
      return V(), Tt(x, {
        "outer-class": "vacv-data-input",
        type: "text",
        name: f.label,
        id: f.tabId + "-" + f.label,
        "data-testid": f.label || "data-input",
        placeholder: f.placeholder,
        readonly: f.readonly,
        "prefix-icon": f.icon,
        validation: a.value,
        "validation-messages": f.validationMessages,
        "validation-visibility": "live",
        "wrapper-class": "fausers",
        modelValue: r.value,
        "onUpdate:modelValue": g[0] || (g[0] = ($) => r.value = $),
        onClick: d
      }, null, 8, ["name", "id", "data-testid", "placeholder", "readonly", "prefix-icon", "validation", "validation-messages", "modelValue"]);
    };
  }
}), CH = ["aria-labelledby"], kH = /* @__PURE__ */ at({
  __name: "VacvOverlay",
  props: {
    position: {},
    label: {}
  },
  setup(e) {
    return (t, n) => (V(), G("div", {
      class: Et(["vacv-overlay", t.position]),
      id: "vacv-overlay",
      "test-id": "vacv-overlay",
      "aria-labelledby": t.label
    }, [
      er(t.$slots, "default", {}, void 0, !0)
    ], 10, CH));
  }
}), SH = /* @__PURE__ */ Zn(kH, [["__scopeId", "data-v-bb7f27b7"]]), pP = (e) => (nl("data-v-cac30eba"), e = e(), il(), e), TH = { class: "vacv-counter-selector" }, IH = { class: "vacv-counter-selector-wrapper" }, AH = { class: "vacv-counter-selector-wrapper-label" }, EH = { class: "vacv-counter-selector-wrapper-button" }, PH = ["disabled"], MH = /* @__PURE__ */ pP(() => /* @__PURE__ */ E("i", {
  class: "fa-solid fa-minus",
  "aria-hidden": "true"
}, null, -1)), DH = { class: "sr-only" }, LH = { class: "vacv-counter-selector-wrapper-button-counter" }, OH = ["disabled"], NH = /* @__PURE__ */ pP(() => /* @__PURE__ */ E("i", {
  class: "fa-solid fa-plus",
  "aria-hidden": "true"
}, null, -1)), FH = { class: "sr-only" }, RH = {
  key: 0,
  class: "vacv-counter-selector-advisory"
}, zH = /* @__PURE__ */ at({
  __name: "VacvCounterSelector",
  props: {
    label: {},
    max: {},
    min: { default: 0 },
    value: {},
    advisory: { type: Boolean },
    disable: { type: Boolean }
  },
  emits: ["change"],
  setup(e, { expose: t, emit: n }) {
    const { t: i } = ki({ useScope: "global" }), r = e, c = n, d = $e(r.value || r.min), a = $e(!1), f = Ae(() => d.value <= r.min);
    At(
      () => r.value,
      (A) => {
        d.value = A ?? r.min ?? 0;
      }
    ), At(d, (A, I) => {
      A !== I && c("change", A);
    });
    const g = () => {
      d.value++, r.max && d.value === r.max && (d.value = r.max, a.value = !0);
    }, x = () => {
      a.value = !1, d.value--;
    };
    return t({
      increment: g,
      decrement: x,
      reset: () => {
        d.value = 0;
      }
    }), (A, I) => (V(), G("div", TH, [
      E("div", IH, [
        E("div", AH, Y(A.label), 1),
        E("div", EH, [
          E("button", {
            type: "button",
            class: "btn-increment minus",
            disabled: f.value,
            onClick: x
          }, [
            MH,
            E("span", DH, Y(ne(i)("vacvComponents.guestsInput.counter.remove")), 1)
          ], 8, PH),
          E("span", LH, Y(d.value), 1),
          E("button", {
            type: "button",
            class: "btn-increment plus",
            disabled: A.disable ? A.disable : a.value,
            onClick: g
          }, [
            NH,
            E("span", FH, Y(ne(i)("vacvComponents.guestsInput.counter.add")), 1)
          ], 8, OH)
        ])
      ]),
      A.advisory ? (V(), G("div", RH, [
        E("div", null, Y(ne(i)("vacvComponents.guestsInput.roomsAdvisory")), 1)
      ])) : _e("", !0)
    ]));
  }
}), Bv = /* @__PURE__ */ Zn(zH, [["__scopeId", "data-v-cac30eba"]]), BH = ["type", "disabled"], VH = /* @__PURE__ */ at({
  __name: "VacvButton",
  props: {
    label: {},
    secondary: { type: Boolean },
    position: { default: "left" },
    type: { default: "button" },
    disabled: { type: Boolean }
  },
  emits: ["click", "blur"],
  setup(e, { emit: t }) {
    const n = t, i = () => {
      n("click");
    }, r = () => {
      n("blur");
    };
    return (c, d) => (V(), G("div", {
      class: Et(["btn-wrapper", c.position])
    }, [
      E("button", {
        type: c.type,
        class: Et({
          "vacv-btn-primary": !c.secondary,
          "vacv-btn-secondary": c.secondary
        }),
        disabled: c.disabled,
        onClick: i,
        onBlur: r
      }, Y(c.label), 43, BH)
    ], 2));
  }
}), hP = /* @__PURE__ */ Zn(VH, [["__scopeId", "data-v-284f4d2a"]]), UH = ["id", "aria-expanded", "aria-controls", "aria-label", "data-test"], HH = ["data-inside-form"], WH = {
  key: 0,
  class: "icon-wrapper"
}, ZH = /* @__PURE__ */ E("i", {
  class: "fa-solid fa-chevron-up",
  "aria-hidden": "true"
}, null, -1), qH = /* @__PURE__ */ E("i", {
  class: "fa-solid fa-chevron-down",
  "aria-hidden": "true"
}, null, -1), jH = [
  ZH,
  qH
], GH = { key: 1 }, YH = ["data-test"], KH = {
  key: 3,
  class: "fa-solid fa-chevron-down",
  "aria-hidden": "true"
}, XH = ["data-test"], JH = /* @__PURE__ */ E("i", {
  class: "fa-solid fa-chevron-down",
  "aria-hidden": "true"
}, null, -1), QH = /* @__PURE__ */ at({
  __name: "VacvDropDownButton",
  props: {
    options: {},
    initialValue: {},
    selectedOption: {},
    label: {},
    dropDownVisible: { type: Boolean },
    dropDownId: {},
    outlined: { type: Boolean },
    useInsideForm: { type: Boolean }
  },
  emits: ["show-options"],
  setup(e) {
    const t = e, n = Ae(() => t.selectedOption ? t.selectedOption : t.options.length ? t.options.find(
      (r) => r.value === t.initialValue
    ) ?? t.options[0] : void 0);
    return (i, r) => {
      var c, d;
      return V(), G("button", {
        type: "button",
        role: "combobox",
        id: "dropdown-button-" + i.dropDownId,
        class: Et(["vacv-btn", { "vacv-btn-outline": i.outlined }]),
        "aria-haspopup": "true",
        "aria-expanded": i.dropDownVisible,
        "aria-controls": "dropdown-menu-" + i.dropDownId,
        "aria-label": i.$t("vacvComponents.common.buttons.open"),
        onClick: r[0] || (r[0] = (a) => i.$emit("show-options")),
        "data-test": i.dropDownId + "-test-button"
      }, [
        E("span", {
          class: "mobile-only dropdown-btn-text",
          "data-inside-form": i.useInsideForm,
          "aria-hidden": "true"
        }, [
          i.useInsideForm ? (V(), G("span", GH, Y((c = n.value) == null ? void 0 : c.label), 1)) : (V(), G("span", WH, jH)),
          i.useInsideForm ? (V(), G("i", KH)) : (V(), G("span", {
            key: 2,
            class: "vacv-label-sm",
            "data-test": i.dropDownId + "-test-button-label"
          }, Y(i.label), 9, YH))
        ], 8, HH),
        E("span", {
          class: "desktop-only dropdown-btn-text",
          "aria-hidden": "true",
          "data-test": i.dropDownId + "-test-button-text"
        }, [
          E("span", null, Y((d = n.value) == null ? void 0 : d.label), 1),
          JH
        ], 8, XH)
      ], 10, UH);
    };
  }
}), eW = ["id", "aria-labelledby", "aria-activedescendant", "data-test"], tW = ["id", "aria-selected", "onClick", "data-test", "drop-down-id"], nW = ["aria-label"], iW = /* @__PURE__ */ E("i", {
  class: "fa-solid fa-check",
  "aria-hidden": "true"
}, null, -1), rW = /* @__PURE__ */ at({
  __name: "VacvDropDownOptions",
  props: {
    options: {},
    initialValue: {},
    dropDownId: {}
  },
  emits: ["change-option"],
  setup(e, { expose: t, emit: n }) {
    const i = e, r = $e(i.initialValue), c = $e(), d = n, a = (f) => {
      r.value = f, d("change-option", f.value);
    };
    return At(
      () => i.initialValue,
      (f) => {
        f != null && (r.value = i.initialValue);
      }
    ), t({
      items: c
    }), (f, g) => {
      var x;
      return V(), G("ul", {
        role: "listbox",
        class: "vacv-dropdown-menu nolist",
        id: "dropdown-menu-" + i.dropDownId,
        "aria-labelledby": "dropdown-button-" + i.dropDownId,
        "aria-activedescendant": "option-" + ((x = r.value) == null ? void 0 : x.value),
        "data-test": i.dropDownId + "-test-menu"
      }, [
        (V(!0), G(cn, null, Pn(f.options, ($) => {
          var A, I;
          return V(), G("li", {
            role: "option",
            id: i.dropDownId + "-option-" + $.value,
            class: Et(((A = r.value) == null ? void 0 : A.value) == $.value ? "selected" : ""),
            "aria-selected": ((I = r.value) == null ? void 0 : I.value) == $.value,
            onClick: (O) => a($),
            "data-test": i.dropDownId + "-test-item",
            "drop-down-id": i.dropDownId,
            key: $.value,
            ref_for: !0,
            ref_key: "items",
            ref: c
          }, [
            E("button", {
              type: "button",
              "aria-label": $.sr ? $.sr : $.label,
              class: "dropdown-option"
            }, [
              iW,
              E("span", null, Y($.label), 1)
            ], 8, nW)
          ], 10, tW);
        }), 128))
      ], 8, eW);
    };
  }
}), sW = ["data-test", "data-testid", "id"], oW = {
  key: 0,
  class: "desktop-only vacv-label-sm"
}, dx = /* @__PURE__ */ at({
  __name: "VacvDropDown",
  props: {
    options: {},
    label: {},
    initialValue: {},
    dropDownId: {},
    selectedValue: {},
    openLeft: { type: Boolean },
    outlined: { type: Boolean },
    directionRow: { type: Boolean },
    useInsideForm: { type: Boolean },
    isStarRating: { type: Boolean }
  },
  emits: ["value-change"],
  setup(e, { expose: t, emit: n }) {
    const i = e, r = (K) => {
      const U = i.options.find((q) => q.value === K);
      return U !== void 0 ? U : i.options[0];
    }, c = $e(), d = $e(!1), a = $e(), f = $e(-1), g = $e(
      r(i.initialValue)
    ), x = $e(
      r(i.initialValue)
    ), $ = () => {
      d.value = !1;
    }, A = () => {
      d.value = !d.value, f.value = -1;
    };
    At(
      () => i.selectedValue,
      (K) => {
        K != null && (g.value ? g.value.value != K && I(K) : I(K));
      }
    );
    const I = (K) => {
      var ee;
      const U = i.options.find(({ value: te }) => te === K), q = g.value;
      g.value = U, $(), ((ee = x.value) == null ? void 0 : ee.value) !== (U == null ? void 0 : U.value) && (x.value = U, H("value-change", q, U));
    };
    WE(c, () => $());
    const O = (K) => {
      const q = a.value.children[1];
      if (f.value === -1) {
        const ee = K === "down" ? 0 : q.childElementCount - 1;
        B(ee);
      } else {
        let ee = null;
        const te = K === "down" ? f.value + 1 : f.value + q.childElementCount - 1;
        f.value = te % q.childElementCount, ee = q.children[f.value], ee.children[0].focus();
      }
    }, B = (K) => {
      const q = a.value.children[1];
      K < 0 && (K = 0), K >= q.children.length && (K = q.children.length - 1), f.value = K, q.children[f.value].children[0].focus();
    }, H = n, N = (K) => {
      K.key === "ArrowUp" ? (O("up"), K.preventDefault()) : K.key === "ArrowDown" && (O("down"), K.preventDefault());
    };
    return t({
      selectedOption: g,
      changeOption: I,
      goToItem: O,
      handleKeydown: N
    }), (K, U) => {
      var q;
      return V(), G("div", {
        class: Et(["vacv-dropdown", [{ isrow: i.directionRow }]]),
        ref_key: "dropdown",
        ref: c,
        onKeydown: N,
        "data-test": i.dropDownId + "-test",
        "data-testid": i.dropDownId + "-test",
        id: i.dropDownId
      }, [
        i.label ? (V(), G("div", oW, Y(i.label), 1)) : _e("", !0),
        E("div", {
          class: Et(["vacv-components-dropdown-wrapper", [
            {
              open: d.value,
              left: K.openLeft,
              "star-rating": i.isStarRating
            }
          ]]),
          ref_key: "dropDownContent",
          ref: a
        }, [
          it(QH, {
            "initial-value": i.initialValue,
            options: i.options,
            "selected-option": g.value,
            onShowOptions: A,
            label: i.label,
            class: Et(K.$attrs.class),
            "drop-down-visible": d.value,
            "drop-down-id": i.dropDownId,
            outlined: K.outlined,
            useInsideForm: K.useInsideForm,
            "data-selected": "option-" + ((q = g.value) == null ? void 0 : q.value)
          }, null, 8, ["initial-value", "options", "selected-option", "label", "class", "drop-down-visible", "drop-down-id", "outlined", "useInsideForm", "data-selected"]),
          it(rW, {
            options: K.options,
            onChangeOption: I,
            "initial-value": g.value,
            "drop-down-id": i.dropDownId
          }, null, 8, ["options", "initial-value", "drop-down-id"])
        ], 2)
      ], 42, sW);
    };
  }
}), aW = {
  key: 0,
  class: "modal-mask"
}, lW = { class: "modal-content" }, cW = ["aria-label"], uW = /* @__PURE__ */ at({
  __name: "VacvMobileOverlay",
  props: {
    onDisplay: { type: Boolean }
  },
  emits: ["close", "before-enter", "after-enter", "after-leave"],
  setup(e, { emit: t }) {
    const n = t, i = () => {
      n("before-enter"), window.dispatchEvent(new CustomEvent("vacvMobileOverlay-open"));
    }, r = () => {
      n("after-enter");
    }, c = () => {
      n("after-leave"), window.dispatchEvent(new CustomEvent("vacvMobileOverlay-close"));
    }, d = () => {
      n("close");
    };
    return (a, f) => (V(), Tt($r, {
      name: "modal",
      "on-before-enter": i,
      "on-after-enter": r,
      "on-after-leave": c
    }, {
      default: Qt(() => [
        a.onDisplay ? (V(), G("div", aW, [
          E("div", lW, [
            E("button", {
              type: "button",
              class: "btn-close",
              onClick: d,
              "aria-label": a.$t("vacvComponents.common.buttons.close")
            }, null, 8, cW),
            er(a.$slots, "default")
          ])
        ])) : _e("", !0)
      ]),
      _: 3
    }));
  }
}), dW = 767;
function fP(e) {
  return e && window.sso.isEmployeeUser(e) ? "vacvComponents.common.phoneNumber.B2CPhoneNumber" : e && window.sso.isB2BUser(e) ? "vacvComponents.common.phoneNumber.B2BPhoneNumber" : "vacvComponents.common.phoneNumber.guestPhoneNumber";
}
const pW = { class: "guests-wrapper" }, hW = {
  key: 0,
  class: "vacv-form-row child-age"
}, fW = {
  key: 0,
  class: "child-age-label errorMsg vacv-form-error"
}, mW = {
  key: 2,
  class: "one-infant-warning"
}, vW = {
  key: 3,
  class: "infant-turns-two-warning"
}, gW = { class: "guests-footer" }, yW = {
  key: 0,
  class: "errorMsg vacv-form-error",
  role: "alert",
  "aria-atomic": "true"
}, _W = ["innerHTML"], bW = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192h42.7c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0H21.3C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7h42.7C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3H405.3zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352H378.7C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7H154.7c-14.7 0-26.7-11.9-26.7-26.7z"/></svg><span class='sr-only'>Guests</span>`, NTe = /* @__PURE__ */ at({
  __name: "VacvGuestsInputField",
  props: /* @__PURE__ */ W2({
    tabId: {},
    modelValue: {},
    showInfantSelector: { type: Boolean }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ W2(["openOverlay", "analyticsErrorMessage", "submit"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = e, { t: i } = ki({ useScope: "global" }), r = t, c = MN(e, "modelValue"), d = $e(!1), a = $e(null), f = Ae(() => {
      const je = n.modelValue.totalAdults + n.modelValue.totalChildren + n.modelValue.totalInfants, ot = n.modelValue.totalRooms;
      return `${i("vacvComponents.guestsInput.insideDataGuests", je)} - ${i("vacvComponents.guestsInput.insideDataRooms", ot)}`;
    }), x = L6({
      mobile: 0,
      desktop: dW
    }).active(), $ = Ae(() => x.value === "mobile"), [A, I] = E6();
    WE(a, () => {
      K(!1);
    });
    function O(je) {
      c.value.totalAdults = je, c.value.totalRooms > je && (c.value.totalRooms = je), c.value.totalInfants > 0 && c.value.totalInfants > je && (c.value.totalInfants = je), oe();
    }
    function B(je) {
      if (c.value.totalChildren = je, c.value.childAges.length > je)
        c.value.childAges.length = je;
      else
        for (let ot = 0; ot < je; ot++)
          c.value.childAges[ot] || (c.value.childAges[ot] = {
            child: ot,
            age: "0",
            value: 0
          });
      oe(), de();
    }
    function H(je) {
      c.value.totalRooms = je;
    }
    function N(je) {
      c.value.totalInfants = je;
    }
    const K = (je) => {
      d.value = je, r("openOverlay", d.value);
    }, U = Ae(() => q()), q = () => !!(c.value.totalAdults % c.value.totalRooms);
    function ee() {
      return !(c.value.totalChildren > 0 && c.value.childAges.some((ot) => ot.value === 0));
    }
    const te = Ae(() => !ee()), ae = Ae(() => !te.value);
    function oe() {
      c.value.isDataValid = ee();
    }
    const de = () => c.value.totalChildren > 0 && c.value.childAges.some((ot) => ot.value === 0) ? (r("analyticsErrorMessage", "Enter Child Age at Departure Date"), !0) : q() ? (r("analyticsErrorMessage", "Distribute Adults Equally Between Rooms"), !0) : !1, me = () => {
      oe(), !de() && (d.value = !1, r("submit", c.value));
    }, ve = (je, ot) => {
      c.value.childAges[ot] = {
        child: ot,
        age: je.label,
        value: je.value
      }, de(), r("submit", c.value);
    }, re = (je) => {
      const ot = [
        {
          label: i("vacvComponents.guestsInput.childAge", je + 1),
          value: 0
        }
      ];
      for (let Xe = 2; Xe <= 17; Xe++)
        ot.push({ label: Xe.toString(), value: Xe });
      return ot;
    }, le = Ae(
      () => c.value.totalAdults === 1
    ), pe = Ae(
      () => c.value.totalAdults + c.value.totalChildren + c.value.totalInfants >= 6
    ), Ne = Ae(
      () => c.value.totalChildren + c.value.totalInfants > 0
    ), We = Ae(
      () => c.value.totalRooms >= c.value.totalAdults
    ), Ge = Ae(
      () => c.value.totalRooms >= c.value.totalAdults
    ), et = Ae(() => le.value || Ne.value || We.value || Ge.value), ft = Ae(() => !pe.value), De = Ae(() => !pe.value && c.value.totalRooms === 1), Ke = Ae(() => !pe.value && c.value.totalRooms === 1 && c.value.totalInfants < c.value.totalAdults), gt = Ae(() => c.value.totalChildren + c.value.totalInfants > 0 && c.value.totalRooms === 1), qe = Ae(() => c.value.totalInfants >= 2 && c.value.totalInfants === c.value.totalAdults), rt = Ae(() => i(fP(Je))), Le = Ae(() => c.value.totalInfants > 0);
    let Je = null;
    return Ru(async () => {
      Je = await window.sso.getUserToken();
    }), (je, ot) => (V(), G("div", {
      class: "vacv-guests-input-field",
      ref_key: "target",
      ref: a,
      "data-testid": "vacv-guests-input-field"
    }, [
      it($H, {
        icon: bW,
        value: f.value,
        initialValue: f.value,
        tabId: je.tabId,
        readonly: "",
        label: je.$t("vacvComponents.guestsInput.placeholder"),
        "label-class": "sr-only",
        placeholder: je.$t("vacvComponents.guestsInput.placeholder"),
        validations: ["required"],
        "validation-messages": {
          required: je.$t("vacvComponents.guestsInput.errors.GuestsSelection"),
          booleanCheck: je.$t("vacvComponents.guestsInput.errors.GuestsSelection")
        },
        isValid: ae.value,
        "data-testid": "vacv-data-input",
        onFocus: ot[0] || (ot[0] = (Xe) => K(!0)),
        onKeydown: ot[1] || (ot[1] = jy(zi(() => {
        }, ["prevent"]), ["enter"]))
      }, null, 8, ["value", "initialValue", "tabId", "label", "placeholder", "validation-messages", "isValid"]),
      it(ne(A), null, {
        default: Qt(() => [
          E("div", pW, [
            it(Bv, {
              class: "guest adult",
              label: je.$t("vacvComponents.guestsInput.adults"),
              max: 6,
              min: 1,
              disable: !ft.value,
              value: c.value.totalAdults,
              "data-testid": "vacv-counter-selector-adults",
              onChange: O
            }, null, 8, ["label", "disable", "value"]),
            it(Bv, {
              class: "guest child",
              label: je.$t("vacvComponents.guestsInput.children"),
              max: 4,
              disable: !De.value,
              value: c.value.totalChildren,
              "data-testid": "vacv-counter-selector-children",
              onChange: B
            }, null, 8, ["label", "disable", "value"]),
            c.value.totalChildren > 0 ? (V(), G("div", hW, [
              te.value ? (V(), G("span", fW, Y(je.$t("vacvComponents.guestsInput.errors.ChildAgeSelection")), 1)) : _e("", !0),
              (V(!0), G(cn, null, Pn(c.value.totalChildren, (Xe, tt) => (V(), G("div", {
                class: "vacv-form-item child",
                key: Xe + tt
              }, [
                it(dx, {
                  initialValue: c.value.childAges[tt].value,
                  dropDownId: `child-age-${tt}`,
                  outlined: "",
                  openLeft: "",
                  options: re(tt),
                  "data-testid": "vacv-dropdown-children-age",
                  onValueChange: (dt, bt) => ve(bt, tt)
                }, null, 8, ["initialValue", "dropDownId", "options", "onValueChange"])
              ]))), 128))
            ])) : _e("", !0),
            je.showInfantSelector ? (V(), Tt(Bv, {
              key: 1,
              class: "guest infant",
              label: je.$t("vacvComponents.guestsInput.infants"),
              max: 4,
              disable: !Ke.value,
              value: c.value.totalInfants,
              "data-testid": "vacv-counter-selector-infants",
              onChange: N
            }, null, 8, ["label", "disable", "value"])) : _e("", !0),
            qe.value ? (V(), G("div", mW, Y(je.$t("vacvComponents.guestsInput.oneInfantPerAdult")), 1)) : _e("", !0),
            Le.value ? (V(), G("div", vW, Y(je.$t("vacvComponents.guestsInput.infantTurns2", {
              num: rt.value
            })), 1)) : _e("", !0),
            it(Bv, {
              class: "guest room",
              label: je.$t("vacvComponents.guestsInput.rooms"),
              max: 6,
              min: 1,
              value: c.value.totalRooms,
              disable: et.value,
              advisory: gt.value,
              "data-testid": "vacv-counter-selector-rooms",
              onChange: H
            }, null, 8, ["label", "value", "disable", "advisory"])
          ]),
          E("div", gW, [
            U.value ? (V(), G("span", yW, Y(je.$t("vacvComponents.guestsInput.errors.RoomSelection")), 1)) : _e("", !0),
            E("div", {
              class: "text",
              innerHTML: je.$t("vacvComponents.guestsInput.advisory")
            }, null, 8, _W)
          ]),
          it(hP, {
            label: je.$t("vacvComponents.guestsInput.buttonLabel"),
            position: "right",
            type: "button",
            secondary: "",
            disabled: !ae.value,
            "data-testid": "vacv-button-submit",
            onClick: me
          }, null, 8, ["label", "disabled"])
        ]),
        _: 1
      }),
      !$.value && d.value ? (V(), Tt(SH, {
        key: 0,
        class: "guest-overlay",
        position: "right",
        label: "Guests"
      }, {
        default: Qt(() => [
          it(ne(I))
        ]),
        _: 1
      })) : _e("", !0),
      $.value ? (V(), Tt(uW, {
        key: 1,
        onDisplay: $.value && d.value,
        onClose: ot[2] || (ot[2] = (Xe) => d.value = !1)
      }, {
        default: Qt(() => [
          it(ne(I))
        ]),
        _: 1
      }, 8, ["onDisplay"])) : _e("", !0)
    ], 512));
  }
}), wW = ["aria-label"], xW = ["innerHTML"], FTe = /* @__PURE__ */ at({
  __name: "AlertMessage",
  props: {
    message: {},
    status: {}
  },
  setup(e) {
    const t = l5(), { show: n } = Nn(t), { setShowHide: i } = t;
    return Li(() => {
      i(!0);
    }), (r, c) => ne(n) ? (V(), G("div", {
      key: 0,
      class: Et(["spa-alertbox", r.status]),
      role: "alert",
      "aria-live": "polite"
    }, [
      E("button", {
        onClick: c[0] || (c[0] = (d) => ne(i)(!1)),
        class: "btn-close",
        "aria-label": r.$t("vacvComponents.common.buttons.close")
      }, null, 8, wW),
      E("div", {
        class: "text",
        innerHTML: r.message
      }, null, 8, xW)
    ], 2)) : _e("", !0);
  }
}), $W = { class: "ae-login-container" }, CW = { class: "ae-logo-wrapper" }, kW = { class: "logo" }, SW = ["src", "alt"], TW = { class: "text" }, IW = { class: "ae-login-btn" }, RTe = /* @__PURE__ */ at({
  __name: "AeroplanLoginBanner",
  props: {
    SENTRY_ERROR_CODE_FILTER: {},
    SHOULD_SEND_SENTRY: { type: Boolean },
    lang: {}
  },
  setup(e) {
    const t = e, { t: n } = ki({ useScope: "global" }), i = Xi("cdnBaseUrl"), r = Xi("aeSignInBannerURL"), d = Xi("aeLoginUrl") + "?redirect-url=" + encodeURIComponent(window.location.href), a = (g) => {
      g.preventDefault(), window.sso ? window.sso.loginAeroplan() : window.location.assign(d), s6(
        "plpAeroplan",
        "Sign In Button - Aeroplan Banner",
        "Aeroplan Banner"
      );
    }, f = $e("");
    return Li(async () => {
      if (r)
        try {
          const g = await ty(
            r + (t.lang === "fr" ? "?lang=fr" : ""),
            "AE Signin Banner",
            0,
            t.SHOULD_SEND_SENTRY,
            t.SENTRY_ERROR_CODE_FILTER
          );
          f.value = g.titleText ? g.titleText : n("vacvComponents.aeroplan.login-banner");
        } catch {
          f.value = n("vacvComponents.aeroplan.login-banner");
        }
      else
        f.value = n("vacvComponents.aeroplan.login-banner");
    }), (g, x) => (V(), G("div", $W, [
      E("div", CW, [
        E("div", kW, [
          E("img", {
            src: `${ne(i)}/img/aeroplan-logo.svg`,
            width: "120",
            alt: g.$t("vacvComponents.aeroplan.aeroplan")
          }, null, 8, SW)
        ]),
        E("div", TW, Y(f.value), 1)
      ]),
      E("div", IW, [
        E("button", {
          onClick: x[0] || (x[0] = ($) => a($)),
          class: "vacv-btn-secondary"
        }, Y(g.$t("vacvComponents.aeroplan.signin-btn")), 1)
      ])
    ]));
  }
}), AW = { class: "cc-form-street vacv-form-row vacv-input" }, EW = {
  key: 0,
  class: "vacv-form-item medium"
}, PW = {
  key: 1,
  class: "vacv-form-item narrow"
}, MW = {
  key: 0,
  class: "cc-form-city vacv-form-row vacv-input"
}, DW = { class: "vacv-form-item medium" }, LW = {
  key: 0,
  class: "vacv-form-item narrow"
}, OW = { class: "cc-form-province vacv-form-row vacv-input" }, NW = { class: "vacv-form-item medium" }, FW = {
  key: 0,
  class: "vacv-form-item narrow"
}, mP = /* @__PURE__ */ at({
  __name: "BillingAddress",
  props: {
    creditCardName: {},
    lang: {}
  },
  setup(e) {
    const t = xo(), { card1: n, card2: i, showBill96Checkbox: r, isPaymentMethodUplift: c } = Nn(t), d = e, a = d.creditCardName === "ccframe2" ? i : n, { t: f } = ki({ useScope: "global" }), g = [
      {
        label: f("vacvComponents.payment.placeholders.select"),
        value: ""
      },
      ...VB.map((O) => ({
        label: f(`vacvComponents.provinces.${O}`),
        value: O
      }))
    ], x = [
      {
        label: f("vacvComponents.payment.placeholders.select"),
        value: ""
      },
      ...UB.map((O) => ({
        label: f(`vacvComponents.states.${O}`),
        value: O
      }))
    ], $ = Ae(
      () => HB.map((O) => ({
        label: f(`vacvComponents.countries.${O}`),
        value: O
      }))
    );
    function A() {
      d.creditCardName === "ccframe1" && (r.value = d.lang === "en" && a.value.state === "QC");
    }
    const I = Ae(() => a.value.country === "US" ? x : g);
    return (O, B) => {
      const H = Ur("FormKit");
      return V(), G(cn, null, [
        E("div", AW, [
          ne(c) ? _e("", !0) : (V(), G("div", EW, [
            it(H, {
              type: "text",
              name: O.creditCardName + "-address",
              id: O.creditCardName + "-address",
              label: `${O.$t("vacvComponents.payment.labels.creditCardAddress")}*`,
              validation: "required",
              "validation-messages": {
                required: O.$t("vacvComponents.payment.errors.pleaseEnterCCAddress")
              },
              modelValue: ne(a).address,
              "onUpdate:modelValue": B[0] || (B[0] = (N) => ne(a).address = N)
            }, null, 8, ["name", "id", "label", "validation-messages", "modelValue"])
          ])),
          ne(c) ? _e("", !0) : (V(), G("div", PW, [
            it(H, {
              type: "text",
              name: O.creditCardName + "-apartment",
              id: O.creditCardName + "-apartment",
              label: O.$t("vacvComponents.payment.labels.creditCardApartment"),
              modelValue: ne(a).apartment,
              "onUpdate:modelValue": B[1] || (B[1] = (N) => ne(a).apartment = N)
            }, null, 8, ["name", "id", "label", "modelValue"])
          ]))
        ]),
        ne(c) ? _e("", !0) : (V(), G("div", MW, [
          E("div", DW, [
            it(H, {
              type: "text",
              name: O.creditCardName + "-city",
              id: O.creditCardName + "-city",
              label: `${O.$t("vacvComponents.payment.labels.creditCardCity")}*`,
              validation: "required|length:0,35|matches:/^[^\\d]+$/",
              "validation-messages": {
                required: O.$t("vacvComponents.payment.errors.pleaseEnterCCCity"),
                length: O.$t("vacvComponents.payment.errors.maxCharsAccepted", {
                  max: 35
                }),
                matches: O.$t("vacvComponents.payment.errors.cityWrongFormat")
              },
              modelValue: ne(a).city,
              "onUpdate:modelValue": B[2] || (B[2] = (N) => ne(a).city = N)
            }, null, 8, ["name", "id", "label", "validation-messages", "modelValue"])
          ]),
          ne(c) ? _e("", !0) : (V(), G("div", LW, [
            it(H, {
              delay: 0,
              type: "select",
              name: O.creditCardName + "-country",
              id: O.creditCardName + "-country",
              label: `${O.$t("vacvComponents.payment.labels.creditCardCountry")}*`,
              options: $.value,
              validation: "required",
              "validation-messages": {
                required: O.$t("vacvComponents.payment.errors.pleaseEnterCCCountry")
              },
              modelValue: ne(a).country,
              "onUpdate:modelValue": B[3] || (B[3] = (N) => ne(a).country = N)
            }, null, 8, ["name", "id", "label", "options", "validation-messages", "modelValue"])
          ]))
        ])),
        E("div", OW, [
          E("div", NW, [
            it(H, {
              delay: 0,
              type: "select",
              name: O.creditCardName + "-state",
              id: O.creditCardName + "-state",
              label: `${O.$t("vacvComponents.payment.labels.creditCardProvince")}*`,
              options: I.value,
              onChange: A,
              validation: "required",
              "validation-messages": {
                required: O.$t("vacvComponents.payment.errors.pleaseEnterCCProvince")
              },
              modelValue: ne(a).state,
              "onUpdate:modelValue": B[4] || (B[4] = (N) => ne(a).state = N)
            }, null, 8, ["name", "id", "label", "options", "validation-messages", "modelValue"])
          ]),
          ne(c) ? _e("", !0) : (V(), G("div", FW, [
            it(H, {
              type: "text",
              name: O.creditCardName + "-postcode",
              id: O.creditCardName + "-postcode",
              label: `${O.$t("vacvComponents.payment.labels.creditCardPostCode")}*`,
              validation: "required|isPostalCodeValidRule:" + ne(a).country,
              "validation-rules": { isPostalCodeValidRule: ne(nE) },
              "validation-messages": {
                required: O.$t("vacvComponents.payment.errors.pleaseEnterCCPostalCode"),
                isPostalCodeValidRule: O.$t(
                  "vacvComponents.payment.errors.postalCodeWrongFormat"
                )
              },
              modelValue: ne(a).postcode,
              "onUpdate:modelValue": B[5] || (B[5] = (N) => ne(a).postcode = N)
            }, null, 8, ["name", "id", "label", "validation", "validation-rules", "validation-messages", "modelValue"])
          ]))
        ])
      ], 64);
    };
  }
}), Lu = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M470.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 338.7 425.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>', RW = { class: "onecard-wrapper" }, zW = {
  key: 0,
  class: "h2style"
}, BW = {
  key: 1,
  class: "cc-amount vacv-form-row vacv-input"
}, VW = { class: "not-vacv-form-item" }, UW = {
  key: 2,
  class: "cc-card-section"
}, HW = { class: "cc-form-name vacv-form-row vacv-input" }, WW = { class: "vacv-form-item wide" }, ZW = ["id", "src", "name"], qW = { class: "cc-form-expiration vacv-form-row vacv-input" }, jW = { class: "vacv-form-item medium" }, GW = { class: "cc-address-section" }, YW = {
  key: 0,
  class: "sameaddress-checkbox vacv-checkbox"
}, vk = /* @__PURE__ */ at({
  __name: "CreditCard",
  props: {
    creditCardName: {},
    hpciConfig: {},
    lang: {},
    insurancePremium: {}
  },
  setup(e, { expose: t }) {
    const n = e, { t: i, n: r } = ki({ useScope: "global" }), c = xo(), { validators: d } = c, {
      isPaymentMethodCreditCard: a,
      isPaymentMethodGiftCard: f,
      amountToPay: g,
      depositAmount: x,
      selectDeposit: $,
      toggle2cc: A,
      sameBillingAddress: I,
      showGiftCardTwoCardError: O,
      card1: B,
      card2: H
    } = Nn(c), N = n.creditCardName === Sc ? B : H, { retreiveIframeURL: K } = DE(n.hpciConfig, i), U = Ae(() => A.value || f.value), q = Ae(() => !!(n.creditCardName === Ml || f.value)), ee = Ae(() => {
      const Ke = ["required", "isAmountGreaterThanZero"];
      return $.value && x.value != null && x.value > 0 ? (Ke.push("isAmountLessThanDeposit"), Ke.push("isAmountNotEqualToDeposit")) : (Ke.push("isAmountNotEqualToTotal"), Ke.push("isAmountLessThanTotal")), Ke.join("|");
    });
    function te(Ke, gt) {
      iE(Ke, gt, n.lang), oe(Ke);
    }
    function ae(Ke) {
      const gt = Ke.target, qe = gt.value;
      if (qe.length > 0) {
        let rt = Iu(n.lang, qe);
        n.insurancePremium && rt < n.insurancePremium && (rt = n.insurancePremium);
        const Le = Wn(rt, r).replace("$", "");
        B.value.creditCardAmount = Le, gt.value = Le;
      } else
        B.value.creditCardAmount = "0";
    }
    const oe = (Ke) => {
      const gt = Iu(
        n.lang,
        Ke
      ), qe = O1(0, r);
      let rt = 0;
      const Le = n.insurancePremium ?? 0;
      $.value && x.value ? Le ? (rt = x.value - gt, rt < 0 && (rt = 0), H.value.creditCardAmount = Wn(rt, r).replace("$", "")) : gt === x.value ? H.value.creditCardAmount = "0" : BC(gt.toString(), 0, x.value) ? (rt = Math.abs(x.value - gt), H.value.creditCardAmount = Wn(rt, r).replace("$", "")) : H.value.creditCardAmount = qe : BC(gt.toString(), 0, g.value) ? (rt = Math.abs(g.value - gt), H.value.creditCardAmount = Wn(rt, r).replace("$", "")) : H.value.creditCardAmount = qe, O.value = !1;
    }, de = (Ke, gt) => {
      const qe = Ke.replace(/[^\d-]/g, "").replace(/-+/g, "-").replace(/^([2-9]|1-)$/, "0$1").replace(/^(\d{2})(\d)$/, "$1-$2");
      qe !== Ke && gt.input(qe);
    }, { hideCreditCardForm: me } = Nn(zu()), ve = Ae(() => !me.value && a.value), re = Ae(() => n.creditCardName === Ml ? !I.value : !0), {
      isAmountGreaterThanZero: le,
      isAmountLessThanTotal: pe,
      isAmountLessThanDeposit: Ne,
      isAmountNotEqualToTotal: We,
      isAmountNotEqualToDeposit: Ge
    } = d, et = $e(), ft = () => {
      const Ke = et.value;
      Ke && (Ke.src = De());
    };
    function De() {
      return K(
        N.value.creditCardIframeName,
        N.value.creditCardIframeNumber
      );
    }
    return t({
      resetIFrame: ft
    }), (Ke, gt) => {
      const qe = Ur("FormKit");
      return V(), G("div", RW, [
        ne(A) ? (V(), G("h3", zW, Y(Ke.$t("vacvComponents.payment.labels.creditCard")) + " " + Y(ne(N).creditCardIframeNumber), 1)) : _e("", !0),
        U.value ? (V(), G("div", BW, [
          E("div", VW, [
            q.value ? (V(), Tt(qe, {
              key: 0,
              type: "text",
              name: Ke.creditCardName + "-cc-amount-card",
              id: Ke.creditCardName + "-cc-amount-card",
              label: Ke.$t("vacvComponents.payment.labels.creditCardAmount") + "*",
              "wrapper-class": "vacv-form-item narrow",
              disabled: "true",
              modelValue: ne(N).creditCardAmount,
              "onUpdate:modelValue": gt[0] || (gt[0] = (rt) => ne(N).creditCardAmount = rt)
            }, null, 8, ["name", "id", "label", "modelValue"])) : (V(), Tt(qe, {
              key: 1,
              type: "text",
              name: Ke.creditCardName + "-cc-amount-card",
              id: Ke.creditCardName + "-cc-amount-card",
              label: Ke.$t("vacvComponents.payment.labels.creditCardAmount") + "*",
              "wrapper-class": "vacv-form-item narrow",
              validation: ee.value,
              "validation-rules": {
                isAmountGreaterThanZero: ne(le),
                isAmountLessThanTotal: ne(pe),
                isAmountLessThanDeposit: ne(Ne),
                isAmountNotEqualToTotal: ne(We),
                isAmountNotEqualToDeposit: ne(Ge)
              },
              "validation-messages": {
                matches: Ke.$t("vacvComponents.payment.errors.ccAmountValueTypeError"),
                isAmountGreaterThanZero: Ke.$t(
                  "vacvComponents.payment.errors.ccAmountZero"
                ),
                isAmountLessThanTotal: Ke.$t(
                  "vacvComponents.payment.errors.ccAmountTooHighFull"
                ),
                isAmountLessThanDeposit: Ke.$t(
                  "vacvComponents.payment.errors.ccAmountTooHighDeposit"
                ),
                isAmountNotEqualToTotal: Ke.$t(
                  "vacvComponents.payment.errors.ccAmountEqualToTotal"
                ),
                isAmountNotEqualToDeposit: Ke.$t(
                  "vacvComponents.payment.errors.ccAmountEqualToTotal"
                )
              },
              modelValue: ne(N).creditCardAmount,
              "onUpdate:modelValue": gt[1] || (gt[1] = (rt) => ne(N).creditCardAmount = rt),
              onInput: te,
              onBlur: ae,
              autocomplete: "off"
            }, null, 8, ["name", "id", "label", "validation", "validation-rules", "validation-messages", "modelValue"]))
          ])
        ])) : _e("", !0),
        ve.value ? (V(), G("div", UW, [
          E("div", HW, [
            E("div", WW, [
              it(qe, {
                type: "text",
                name: Ke.creditCardName + "-cc-name",
                id: Ke.creditCardName + "-cc-name",
                label: Ke.$t("vacvComponents.payment.labels.creditCardName") + "*",
                validation: `required|length:0,60|matches:${ne(dw).personName}`,
                "validation-messages": {
                  required: Ke.$t("vacvComponents.payment.errors.pleaseEnterCCName"),
                  length: Ke.$t("vacvComponents.payment.errors.maxCharsAccepted", {
                    max: 60
                  }),
                  matches: Ke.$t("vacvComponents.payment.errors.ccNameWrongFormat")
                },
                modelValue: ne(N).creditCardName,
                "onUpdate:modelValue": gt[2] || (gt[2] = (rt) => ne(N).creditCardName = rt)
              }, null, 8, ["name", "id", "label", "validation", "validation-messages", "modelValue"])
            ])
          ]),
          E("iframe", {
            ref_key: "hpciIframe",
            ref: et,
            title: "Credit Card Payment",
            id: ne(N).creditCardIframeName,
            src: De(),
            name: ne(N).creditCardIframeName,
            onload: "receiveHPCIMsg()",
            style: { border: "0px", width: "100%" }
          }, Y(Ke.$t("vacvComponents.payment.errors.notSupportedIframe")), 9, ZW),
          E("div", qW, [
            E("div", jW, [
              it(qe, {
                type: "text",
                name: Ke.creditCardName + "-cc-expiry",
                id: Ke.creditCardName + "-cc-expiry",
                placeholder: "MM-YY",
                maxlength: "5",
                onInput: de,
                label: Ke.$t("vacvComponents.payment.labels.creditCardExpiry") + "*",
                validation: [
                  ["required"],
                  ["date_format", "MM-YY"],
                  ["monthBetween", ...ne(Dne)()]
                ],
                "validation-messages": {
                  required: Ke.$t(
                    "vacvComponents.payment.errors.pleaseEnterCCExpiryDate"
                  ),
                  date_format: Ke.$t(
                    "vacvComponents.payment.errors.expirationWrongFormat"
                  ),
                  monthBetween: Ke.$t(
                    "vacvComponents.payment.errors.expirationPastDate"
                  )
                },
                modelValue: ne(N).creditCardExpiry,
                "onUpdate:modelValue": gt[3] || (gt[3] = (rt) => ne(N).creditCardExpiry = rt)
              }, null, 8, ["name", "id", "label", "validation", "validation-messages", "modelValue"])
            ])
          ])
        ])) : _e("", !0),
        E("div", GW, [
          E("h3", null, Y(Ke.$t("vacvComponents.payment.labels.creditCardAddressTitle")), 1),
          Ke.creditCardName === "ccframe2" ? (V(), G("div", YW, [
            it(qe, {
              name: "sameAddress",
              type: "checkbox",
              "aria-checked": ne(I) ? "true" : "false",
              label: Ke.$t("vacvComponents.payment.labels.sameAddress"),
              "decorator-icon": ne(Lu),
              modelValue: ne(I),
              "onUpdate:modelValue": gt[4] || (gt[4] = (rt) => yo(I) ? I.value = rt : null)
            }, null, 8, ["aria-checked", "label", "decorator-icon", "modelValue"])
          ])) : _e("", !0),
          re.value ? (V(), Tt(mP, {
            key: 1,
            creditCardName: ne(N).creditCardIframeName,
            lang: Ke.lang
          }, null, 8, ["creditCardName", "lang"])) : _e("", !0)
        ])
      ]);
    };
  }
}), px = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M470.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 338.7 425.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>', KW = ["innerHTML"], XW = { class: "giftcard-section" }, JW = { class: "vacv-form-row vacv-input" }, QW = {
  class: "vacv-form-item medium",
  id: "gift-form-number"
}, eZ = {
  class: "vacv-form-item narrow",
  id: "gift-form-pin"
}, tZ = /* @__PURE__ */ at({
  __name: "GiftCardForm",
  props: {
    lang: {}
  },
  emits: ["amountBlur"],
  setup(e, { emit: t }) {
    const n = e, i = xo(), { validators: r } = i, {
      isPaymentMethodCreditCard: c,
      displayedGiftCardAmount: d,
      selectDeposit: a,
      depositAmount: f,
      giftCardAmount: g,
      giftCardNumber: x,
      giftCardPIN: $,
      checkoutHasBeenSubmitted: A,
      giftCardAmountErrorVisible: I,
      insurancePremiumAmount: O,
      amountToPay: B
    } = Nn(i), H = t, {
      isAmountGreaterThanZero: N,
      isAmountLessThanOrEqualToDeposit: K,
      isAmountLessThanOrEqualToTotal: U,
      isAmountLessThanOrEqualToTotalWithoutInsurancePremium: q,
      isAmountLessThanOrEqualToDepositWithoutInsurancePremium: ee,
      isGiftCardAmountSufficient: te,
      isGiftCardDepositSufficient: ae
    } = r, { t: oe, n: de } = ki({ useScope: "global" }), me = (Ge) => {
      const et = Ge.target;
      let ft = Iu(n.lang, et.value);
      O.value > 0 && (c.value = !0, f.value && ft >= f.value - O.value ? (ft = f.value - O.value, g.value = ft) : ft > B.value - O.value && (ft = B.value - O.value)), d.value = O1(ft, de), A.value = !1, H("amountBlur");
    }, ve = (Ge, et) => {
      const ft = iE(Ge, et, n.lang), De = Iu(n.lang, ft);
      g.value = De;
    }, re = {
      isAmountGreaterThanZero: N,
      isAmountLessThanOrEqualToDeposit: K,
      isAmountLessThanOrEqualToTotal: U,
      isAmountLessThanOrEqualToTotalWithoutInsurancePremium: q,
      isAmountLessThanOrEqualToDepositWithoutInsurancePremium: ee,
      isGiftCardAmountSufficient: te,
      isGiftCardDepositSufficient: ae
    }, le = {
      matches: oe("vacvComponents.payment.errors.ccAmountValueTypeError"),
      isAmountGreaterThanZero: oe(
        "vacvComponents.giftCard.errors.giftCardAmountZero"
      ),
      isAmountLessThanOrEqualToDeposit: oe(
        "vacvComponents.giftCard.errors.giftCardSplitDeposit"
      ),
      isAmountLessThanOrEqualToTotal: oe(
        "vacvComponents.giftCard.errors.giftCardSplitTotal"
      ),
      isAmountLessThanOrEqualToTotalWithoutInsurancePremium: oe(
        "vacvComponents.giftCard.errors.giftCardSplitTotalWithoutInsurance"
      ),
      isAmountLessThanOrEqualToDepositWithoutInsurancePremium: oe(
        "vacvComponents.giftCard.errors.giftCardLessThanDepositWithoutInsurance"
      ),
      isGiftCardAmountSufficient: oe(
        "vacvComponents.giftCard.errors.giftCardInsufficientAmount"
      ),
      isGiftCardDepositSufficient: oe(
        "vacvComponents.giftCard.errors.giftCardInsufficientAmount"
      )
    }, pe = {
      required: oe("vacvComponents.giftCard.errors.giftCardNumber"),
      matches: oe("vacvComponents.giftCard.errors.giftCardOnlyNumbers"),
      isValid: oe("vacvComponents.payment.errors.ccAmountTooHighFull")
    }, Ne = {
      required: oe("vacvComponents.giftCard.errors.giftCardPIN"),
      matches: oe("vacvComponents.giftCard.errors.giftCardOnlyNumbers")
    }, We = Ae(() => {
      const Ge = ["isAmountGreaterThanZero"];
      return a.value && f.value !== null && f.value > 0 ? (c.value || Ge.push("isGiftCardDepositSufficient"), O.value <= 0 && Ge.push("isAmountLessThanOrEqualToDeposit")) : (c.value || Ge.push("isGiftCardAmountSufficient"), O.value <= 0 && Ge.push("isAmountLessThanOrEqualToTotal")), Ge.join("|");
    });
    return (Ge, et) => {
      const ft = Ur("FormKit");
      return V(), G(cn, null, [
        E("div", {
          class: "giftcard-link",
          innerHTML: Ge.$t("vacvComponents.giftCard.messages.giftCardCheckAmountLink")
        }, null, 8, KW),
        E("div", XW, [
          E("div", JW, [
            E("div", {
              class: Et({
                "vacv-form-item": !0,
                narrow: !0,
                "hide-errors": !ne(I)
              }),
              id: "gift-form-amount"
            }, [
              it(ft, {
                type: "text",
                name: "giftcard-amount",
                id: "giftcard-amount",
                label: Ge.$t("vacvComponents.payment.labels.creditCardAmount") + "*",
                validation: We.value,
                "validation-rules": re,
                "validation-messages": le,
                "validation-visibility": "blur",
                onInput: ve,
                onBlur: et[0] || (et[0] = (De) => me(De)),
                modelValue: ne(d),
                "onUpdate:modelValue": et[1] || (et[1] = (De) => yo(d) ? d.value = De : null),
                autocomplete: "off"
              }, null, 8, ["label", "validation", "modelValue"])
            ], 2),
            E("div", QW, [
              it(ft, {
                type: "text",
                name: "giftcard-number",
                id: "giftcard-number",
                label: Ge.$t("vacvComponents.giftCard.labels.giftCardNumber"),
                validation: "required|matches:/^[0-9]+$/",
                "validation-messages": pe,
                "validation-visibility": "blur",
                modelValue: ne(x),
                "onUpdate:modelValue": et[2] || (et[2] = (De) => yo(x) ? x.value = De : null)
              }, null, 8, ["label", "modelValue"])
            ]),
            E("div", eZ, [
              it(ft, {
                type: "text",
                name: "giftcard-pin",
                id: "giftcard-pin",
                label: Ge.$t("vacvComponents.giftCard.labels.giftCardPIN"),
                validation: "required|matches:/^[0-9]+$/",
                "validation-messages": Ne,
                "validation-visibility": "blur",
                modelValue: ne($),
                "onUpdate:modelValue": et[3] || (et[3] = (De) => yo($) ? $.value = De : null)
              }, null, 8, ["label", "modelValue"])
            ])
          ])
        ])
      ], 64);
    };
  }
}), nZ = {
  id: "giftcard",
  class: "paddedbox-grey border"
}, iZ = /* @__PURE__ */ at({
  __name: "GiftCardSection",
  props: {
    lang: {}
  },
  emits: ["giftcard-amount-blur", "gift-card-selected"],
  setup(e, { emit: t }) {
    const n = Wl(), { selectedInsuranceProduct: i, hasSelectedInsuranceProduct: r } = Nn(n), c = xo(), {
      toggle2cc: d,
      isPaymentMethodGiftCard: a,
      showGiftCardTwoCardError: f,
      amountToPay: g
    } = Nn(c), x = Ae(
      () => r.value && g.value === i.value.premium
    ), $ = Ae(
      () => !x.value && !d.value
    );
    At($, (H) => {
      H || (a.value = !1);
    });
    const A = t;
    function I() {
      A("giftcard-amount-blur");
    }
    function O() {
      Rl(() => {
        a.value && A("gift-card-selected");
      });
    }
    function B() {
      !$.value && !x.value && (f.value = !0);
    }
    return (H, N) => {
      const K = Ur("FormKit");
      return V(), G("div", nZ, [
        E("div", null, [
          E("div", {
            id: "giftcard-checkbox-wrapper",
            class: Et([{ "vacv-checkbox": !0, disabled: !$.value }]),
            onClick: B
          }, [
            it(K, {
              disabled: !$.value,
              id: "giftcard-checkbox",
              name: "paymentMethodGiftCard",
              type: "checkbox",
              label: H.$t("vacvComponents.giftCard.labels.giftCard"),
              "label-class": "h2style",
              "aria-checked": ne(a) ? "true" : "false",
              "decorator-icon": ne(px),
              modelValue: ne(a),
              "onUpdate:modelValue": N[0] || (N[0] = (U) => yo(a) ? a.value = U : null),
              onInput: O
            }, null, 8, ["disabled", "label", "aria-checked", "decorator-icon", "modelValue"])
          ], 2)
        ]),
        ne(a) ? (V(), Tt(tZ, {
          key: 0,
          lang: H.lang,
          onAmountBlur: I
        }, null, 8, ["lang"])) : _e("", !0)
      ]);
    };
  }
});
class Wd extends Error {
}
class rZ extends Wd {
  constructor(t) {
    super(`Invalid DateTime: ${t.toMessage()}`);
  }
}
class sZ extends Wd {
  constructor(t) {
    super(`Invalid Interval: ${t.toMessage()}`);
  }
}
class oZ extends Wd {
  constructor(t) {
    super(`Invalid Duration: ${t.toMessage()}`);
  }
}
class Xp extends Wd {
}
class vP extends Wd {
  constructor(t) {
    super(`Invalid unit ${t}`);
  }
}
class zs extends Wd {
}
class fu extends Wd {
  constructor() {
    super("Zone is an abstract class");
  }
}
const tn = "numeric", Qa = "short", Vo = "long", dy = {
  year: tn,
  month: tn,
  day: tn
}, gP = {
  year: tn,
  month: Qa,
  day: tn
}, aZ = {
  year: tn,
  month: Qa,
  day: tn,
  weekday: Qa
}, yP = {
  year: tn,
  month: Vo,
  day: tn
}, _P = {
  year: tn,
  month: Vo,
  day: tn,
  weekday: Vo
}, bP = {
  hour: tn,
  minute: tn
}, wP = {
  hour: tn,
  minute: tn,
  second: tn
}, xP = {
  hour: tn,
  minute: tn,
  second: tn,
  timeZoneName: Qa
}, $P = {
  hour: tn,
  minute: tn,
  second: tn,
  timeZoneName: Vo
}, CP = {
  hour: tn,
  minute: tn,
  hourCycle: "h23"
}, kP = {
  hour: tn,
  minute: tn,
  second: tn,
  hourCycle: "h23"
}, SP = {
  hour: tn,
  minute: tn,
  second: tn,
  hourCycle: "h23",
  timeZoneName: Qa
}, TP = {
  hour: tn,
  minute: tn,
  second: tn,
  hourCycle: "h23",
  timeZoneName: Vo
}, IP = {
  year: tn,
  month: tn,
  day: tn,
  hour: tn,
  minute: tn
}, AP = {
  year: tn,
  month: tn,
  day: tn,
  hour: tn,
  minute: tn,
  second: tn
}, EP = {
  year: tn,
  month: Qa,
  day: tn,
  hour: tn,
  minute: tn
}, PP = {
  year: tn,
  month: Qa,
  day: tn,
  hour: tn,
  minute: tn,
  second: tn
}, lZ = {
  year: tn,
  month: Qa,
  day: tn,
  weekday: Qa,
  hour: tn,
  minute: tn
}, MP = {
  year: tn,
  month: Vo,
  day: tn,
  hour: tn,
  minute: tn,
  timeZoneName: Qa
}, DP = {
  year: tn,
  month: Vo,
  day: tn,
  hour: tn,
  minute: tn,
  second: tn,
  timeZoneName: Qa
}, LP = {
  year: tn,
  month: Vo,
  day: tn,
  weekday: Vo,
  hour: tn,
  minute: tn,
  timeZoneName: Vo
}, OP = {
  year: tn,
  month: Vo,
  day: tn,
  weekday: Vo,
  hour: tn,
  minute: tn,
  second: tn,
  timeZoneName: Vo
};
class Wm {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new fu();
  }
  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new fu();
  }
  /**
   * The IANA name of this zone.
   * Defaults to `name` if not overwritten by a subclass.
   * @abstract
   * @type {string}
   */
  get ianaName() {
    return this.name;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new fu();
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(t, n) {
    throw new fu();
  }
  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(t, n) {
    throw new fu();
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(t) {
    throw new fu();
  }
  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(t) {
    throw new fu();
  }
  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new fu();
  }
}
let Wb = null;
class o_ extends Wm {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    return Wb === null && (Wb = new o_()), Wb;
  }
  /** @override **/
  get type() {
    return "system";
  }
  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName(t, { format: n, locale: i }) {
    return WP(t, n, i);
  }
  /** @override **/
  formatOffset(t, n) {
    return lm(this.offset(t), n);
  }
  /** @override **/
  offset(t) {
    return -new Date(t).getTimezoneOffset();
  }
  /** @override **/
  equals(t) {
    return t.type === "system";
  }
  /** @override **/
  get isValid() {
    return !0;
  }
}
let wg = {};
function cZ(e) {
  return wg[e] || (wg[e] = new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: e,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    era: "short"
  })), wg[e];
}
const uZ = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function dZ(e, t) {
  const n = e.format(t).replace(/\u200E/g, ""), i = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(n), [, r, c, d, a, f, g, x] = i;
  return [d, r, c, a, f, g, x];
}
function pZ(e, t) {
  const n = e.formatToParts(t), i = [];
  for (let r = 0; r < n.length; r++) {
    const { type: c, value: d } = n[r], a = uZ[c];
    c === "era" ? i[a] = d : zn(a) || (i[a] = parseInt(d, 10));
  }
  return i;
}
let Vv = {};
class Nc extends Wm {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(t) {
    return Vv[t] || (Vv[t] = new Nc(t)), Vv[t];
  }
  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    Vv = {}, wg = {};
  }
  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
   * @return {boolean}
   */
  static isValidSpecifier(t) {
    return this.isValidZone(t);
  }
  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(t) {
    if (!t)
      return !1;
    try {
      return new Intl.DateTimeFormat("en-US", { timeZone: t }).format(), !0;
    } catch {
      return !1;
    }
  }
  constructor(t) {
    super(), this.zoneName = t, this.valid = Nc.isValidZone(t);
  }
  /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "iana";
  }
  /**
   * The name of this zone (i.e. the IANA zone name).
   * @override
   * @type {string}
   */
  get name() {
    return this.zoneName;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns false for all IANA zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return !1;
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(t, { format: n, locale: i }) {
    return WP(t, n, i, this.name);
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(t, n) {
    return lm(this.offset(t), n);
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @override
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(t) {
    const n = new Date(t);
    if (isNaN(n)) return NaN;
    const i = cZ(this.name);
    let [r, c, d, a, f, g, x] = i.formatToParts ? pZ(i, n) : dZ(i, n);
    a === "BC" && (r = -Math.abs(r) + 1);
    const A = l_({
      year: r,
      month: c,
      day: d,
      hour: f === 24 ? 0 : f,
      minute: g,
      second: x,
      millisecond: 0
    });
    let I = +n;
    const O = I % 1e3;
    return I -= O >= 0 ? O : 1e3 + O, (A - I) / (60 * 1e3);
  }
  /**
   * Return whether this Zone is equal to another zone
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(t) {
    return t.type === "iana" && t.name === this.name;
  }
  /**
   * Return whether this Zone is valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return this.valid;
  }
}
let gk = {};
function hZ(e, t = {}) {
  const n = JSON.stringify([e, t]);
  let i = gk[n];
  return i || (i = new Intl.ListFormat(e, t), gk[n] = i), i;
}
let kw = {};
function Sw(e, t = {}) {
  const n = JSON.stringify([e, t]);
  let i = kw[n];
  return i || (i = new Intl.DateTimeFormat(e, t), kw[n] = i), i;
}
let Tw = {};
function fZ(e, t = {}) {
  const n = JSON.stringify([e, t]);
  let i = Tw[n];
  return i || (i = new Intl.NumberFormat(e, t), Tw[n] = i), i;
}
let Iw = {};
function mZ(e, t = {}) {
  const { base: n, ...i } = t, r = JSON.stringify([e, i]);
  let c = Iw[r];
  return c || (c = new Intl.RelativeTimeFormat(e, t), Iw[r] = c), c;
}
let Jf = null;
function vZ() {
  return Jf || (Jf = new Intl.DateTimeFormat().resolvedOptions().locale, Jf);
}
let yk = {};
function gZ(e) {
  let t = yk[e];
  if (!t) {
    const n = new Intl.Locale(e);
    t = "getWeekInfo" in n ? n.getWeekInfo() : n.weekInfo, yk[e] = t;
  }
  return t;
}
function yZ(e) {
  const t = e.indexOf("-x-");
  t !== -1 && (e = e.substring(0, t));
  const n = e.indexOf("-u-");
  if (n === -1)
    return [e];
  {
    let i, r;
    try {
      i = Sw(e).resolvedOptions(), r = e;
    } catch {
      const f = e.substring(0, n);
      i = Sw(f).resolvedOptions(), r = f;
    }
    const { numberingSystem: c, calendar: d } = i;
    return [r, c, d];
  }
}
function _Z(e, t, n) {
  return (n || t) && (e.includes("-u-") || (e += "-u"), n && (e += `-ca-${n}`), t && (e += `-nu-${t}`)), e;
}
function bZ(e) {
  const t = [];
  for (let n = 1; n <= 12; n++) {
    const i = Sn.utc(2009, n, 1);
    t.push(e(i));
  }
  return t;
}
function wZ(e) {
  const t = [];
  for (let n = 1; n <= 7; n++) {
    const i = Sn.utc(2016, 11, 13 + n);
    t.push(e(i));
  }
  return t;
}
function Uv(e, t, n, i) {
  const r = e.listingMode();
  return r === "error" ? null : r === "en" ? n(t) : i(t);
}
function xZ(e) {
  return e.numberingSystem && e.numberingSystem !== "latn" ? !1 : e.numberingSystem === "latn" || !e.locale || e.locale.startsWith("en") || new Intl.DateTimeFormat(e.intl).resolvedOptions().numberingSystem === "latn";
}
class $Z {
  constructor(t, n, i) {
    this.padTo = i.padTo || 0, this.floor = i.floor || !1;
    const { padTo: r, floor: c, ...d } = i;
    if (!n || Object.keys(d).length > 0) {
      const a = { useGrouping: !1, ...i };
      i.padTo > 0 && (a.minimumIntegerDigits = i.padTo), this.inf = fZ(t, a);
    }
  }
  format(t) {
    if (this.inf) {
      const n = this.floor ? Math.floor(t) : t;
      return this.inf.format(n);
    } else {
      const n = this.floor ? Math.floor(t) : gx(t, 3);
      return Br(n, this.padTo);
    }
  }
}
class CZ {
  constructor(t, n, i) {
    this.opts = i, this.originalZone = void 0;
    let r;
    if (this.opts.timeZone)
      this.dt = t;
    else if (t.zone.type === "fixed") {
      const d = -1 * (t.offset / 60), a = d >= 0 ? `Etc/GMT+${d}` : `Etc/GMT${d}`;
      t.offset !== 0 && Nc.create(a).valid ? (r = a, this.dt = t) : (r = "UTC", this.dt = t.offset === 0 ? t : t.setZone("UTC").plus({ minutes: t.offset }), this.originalZone = t.zone);
    } else t.zone.type === "system" ? this.dt = t : t.zone.type === "iana" ? (this.dt = t, r = t.zone.name) : (r = "UTC", this.dt = t.setZone("UTC").plus({ minutes: t.offset }), this.originalZone = t.zone);
    const c = { ...this.opts };
    c.timeZone = c.timeZone || r, this.dtf = Sw(n, c);
  }
  format() {
    return this.originalZone ? this.formatToParts().map(({ value: t }) => t).join("") : this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    const t = this.dtf.formatToParts(this.dt.toJSDate());
    return this.originalZone ? t.map((n) => {
      if (n.type === "timeZoneName") {
        const i = this.originalZone.offsetName(this.dt.ts, {
          locale: this.dt.locale,
          format: this.opts.timeZoneName
        });
        return {
          ...n,
          value: i
        };
      } else
        return n;
    }) : t;
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}
class kZ {
  constructor(t, n, i) {
    this.opts = { style: "long", ...i }, !n && UP() && (this.rtf = mZ(t, i));
  }
  format(t, n) {
    return this.rtf ? this.rtf.format(t, n) : GZ(n, t, this.opts.numeric, this.opts.style !== "long");
  }
  formatToParts(t, n) {
    return this.rtf ? this.rtf.formatToParts(t, n) : [];
  }
}
const SZ = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [6, 7]
};
class Di {
  static fromOpts(t) {
    return Di.create(
      t.locale,
      t.numberingSystem,
      t.outputCalendar,
      t.weekSettings,
      t.defaultToEN
    );
  }
  static create(t, n, i, r, c = !1) {
    const d = t || wr.defaultLocale, a = d || (c ? "en-US" : vZ()), f = n || wr.defaultNumberingSystem, g = i || wr.defaultOutputCalendar, x = Aw(r) || wr.defaultWeekSettings;
    return new Di(a, f, g, x, d);
  }
  static resetCache() {
    Jf = null, kw = {}, Tw = {}, Iw = {};
  }
  static fromObject({ locale: t, numberingSystem: n, outputCalendar: i, weekSettings: r } = {}) {
    return Di.create(t, n, i, r);
  }
  constructor(t, n, i, r, c) {
    const [d, a, f] = yZ(t);
    this.locale = d, this.numberingSystem = n || a || null, this.outputCalendar = i || f || null, this.weekSettings = r, this.intl = _Z(this.locale, this.numberingSystem, this.outputCalendar), this.weekdaysCache = { format: {}, standalone: {} }, this.monthsCache = { format: {}, standalone: {} }, this.meridiemCache = null, this.eraCache = {}, this.specifiedLocale = c, this.fastNumbersCached = null;
  }
  get fastNumbers() {
    return this.fastNumbersCached == null && (this.fastNumbersCached = xZ(this)), this.fastNumbersCached;
  }
  listingMode() {
    const t = this.isEnglish(), n = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return t && n ? "en" : "intl";
  }
  clone(t) {
    return !t || Object.getOwnPropertyNames(t).length === 0 ? this : Di.create(
      t.locale || this.specifiedLocale,
      t.numberingSystem || this.numberingSystem,
      t.outputCalendar || this.outputCalendar,
      Aw(t.weekSettings) || this.weekSettings,
      t.defaultToEN || !1
    );
  }
  redefaultToEN(t = {}) {
    return this.clone({ ...t, defaultToEN: !0 });
  }
  redefaultToSystem(t = {}) {
    return this.clone({ ...t, defaultToEN: !1 });
  }
  months(t, n = !1) {
    return Uv(this, t, jP, () => {
      const i = n ? { month: t, day: "numeric" } : { month: t }, r = n ? "format" : "standalone";
      return this.monthsCache[r][t] || (this.monthsCache[r][t] = bZ((c) => this.extract(c, i, "month"))), this.monthsCache[r][t];
    });
  }
  weekdays(t, n = !1) {
    return Uv(this, t, KP, () => {
      const i = n ? { weekday: t, year: "numeric", month: "long", day: "numeric" } : { weekday: t }, r = n ? "format" : "standalone";
      return this.weekdaysCache[r][t] || (this.weekdaysCache[r][t] = wZ(
        (c) => this.extract(c, i, "weekday")
      )), this.weekdaysCache[r][t];
    });
  }
  meridiems() {
    return Uv(
      this,
      void 0,
      () => XP,
      () => {
        if (!this.meridiemCache) {
          const t = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [Sn.utc(2016, 11, 13, 9), Sn.utc(2016, 11, 13, 19)].map(
            (n) => this.extract(n, t, "dayperiod")
          );
        }
        return this.meridiemCache;
      }
    );
  }
  eras(t) {
    return Uv(this, t, JP, () => {
      const n = { era: t };
      return this.eraCache[t] || (this.eraCache[t] = [Sn.utc(-40, 1, 1), Sn.utc(2017, 1, 1)].map(
        (i) => this.extract(i, n, "era")
      )), this.eraCache[t];
    });
  }
  extract(t, n, i) {
    const r = this.dtFormatter(t, n), c = r.formatToParts(), d = c.find((a) => a.type.toLowerCase() === i);
    return d ? d.value : null;
  }
  numberFormatter(t = {}) {
    return new $Z(this.intl, t.forceSimple || this.fastNumbers, t);
  }
  dtFormatter(t, n = {}) {
    return new CZ(t, this.intl, n);
  }
  relFormatter(t = {}) {
    return new kZ(this.intl, this.isEnglish(), t);
  }
  listFormatter(t = {}) {
    return hZ(this.intl, t);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
  }
  getWeekSettings() {
    return this.weekSettings ? this.weekSettings : HP() ? gZ(this.locale) : SZ;
  }
  getStartOfWeek() {
    return this.getWeekSettings().firstDay;
  }
  getMinDaysInFirstWeek() {
    return this.getWeekSettings().minimalDays;
  }
  getWeekendDays() {
    return this.getWeekSettings().weekend;
  }
  equals(t) {
    return this.locale === t.locale && this.numberingSystem === t.numberingSystem && this.outputCalendar === t.outputCalendar;
  }
  toString() {
    return `Locale(${this.locale}, ${this.numberingSystem}, ${this.outputCalendar})`;
  }
}
let Zb = null;
class ro extends Wm {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    return Zb === null && (Zb = new ro(0)), Zb;
  }
  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(t) {
    return t === 0 ? ro.utcInstance : new ro(t);
  }
  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(t) {
    if (t) {
      const n = t.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (n)
        return new ro(c_(n[1], n[2]));
    }
    return null;
  }
  constructor(t) {
    super(), this.fixed = t;
  }
  /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "fixed";
  }
  /**
   * The name of this zone.
   * All fixed zones' names always start with "UTC" (plus optional offset)
   * @override
   * @type {string}
   */
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${lm(this.fixed, "narrow")}`;
  }
  /**
   * The IANA name of this zone, i.e. `Etc/UTC` or `Etc/GMT+/-nn`
   *
   * @override
   * @type {string}
   */
  get ianaName() {
    return this.fixed === 0 ? "Etc/UTC" : `Etc/GMT${lm(-this.fixed, "narrow")}`;
  }
  /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */
  offsetName() {
    return this.name;
  }
  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(t, n) {
    return lm(this.fixed, n);
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns true for all fixed offset zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return !0;
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */
  offset() {
    return this.fixed;
  }
  /**
   * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(t) {
    return t.type === "fixed" && t.fixed === this.fixed;
  }
  /**
   * Return whether this Zone is valid:
   * All fixed offset zones are valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return !0;
  }
}
class TZ extends Wm {
  constructor(t) {
    super(), this.zoneName = t;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName() {
    return null;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  equals() {
    return !1;
  }
  /** @override **/
  get isValid() {
    return !1;
  }
}
function xu(e, t) {
  if (zn(e) || e === null)
    return t;
  if (e instanceof Wm)
    return e;
  if (DZ(e)) {
    const n = e.toLowerCase();
    return n === "default" ? t : n === "local" || n === "system" ? o_.instance : n === "utc" || n === "gmt" ? ro.utcInstance : ro.parseSpecifier(n) || Nc.create(e);
  } else return Pu(e) ? ro.instance(e) : typeof e == "object" && "offset" in e && typeof e.offset == "function" ? e : new TZ(e);
}
const hx = {
  arab: "[٠-٩]",
  arabext: "[۰-۹]",
  bali: "[᭐-᭙]",
  beng: "[০-৯]",
  deva: "[०-९]",
  fullwide: "[０-９]",
  gujr: "[૦-૯]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[០-៩]",
  knda: "[೦-೯]",
  laoo: "[໐-໙]",
  limb: "[᥆-᥏]",
  mlym: "[൦-൯]",
  mong: "[᠐-᠙]",
  mymr: "[၀-၉]",
  orya: "[୦-୯]",
  tamldec: "[௦-௯]",
  telu: "[౦-౯]",
  thai: "[๐-๙]",
  tibt: "[༠-༩]",
  latn: "\\d"
}, _k = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
}, IZ = hx.hanidec.replace(/[\[|\]]/g, "").split("");
function AZ(e) {
  let t = parseInt(e, 10);
  if (isNaN(t)) {
    t = "";
    for (let n = 0; n < e.length; n++) {
      const i = e.charCodeAt(n);
      if (e[n].search(hx.hanidec) !== -1)
        t += IZ.indexOf(e[n]);
      else
        for (const r in _k) {
          const [c, d] = _k[r];
          i >= c && i <= d && (t += i - c);
        }
    }
    return parseInt(t, 10);
  } else
    return t;
}
let Up = {};
function EZ() {
  Up = {};
}
function Va({ numberingSystem: e }, t = "") {
  const n = e || "latn";
  return Up[n] || (Up[n] = {}), Up[n][t] || (Up[n][t] = new RegExp(`${hx[n]}${t}`)), Up[n][t];
}
let bk = () => Date.now(), wk = "system", xk = null, $k = null, Ck = null, kk = 60, Sk, Tk = null;
class wr {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return bk;
  }
  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(t) {
    bk = t;
  }
  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(t) {
    wk = t;
  }
  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return xu(wk, o_.instance);
  }
  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return xk;
  }
  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(t) {
    xk = t;
  }
  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return $k;
  }
  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(t) {
    $k = t;
  }
  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return Ck;
  }
  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(t) {
    Ck = t;
  }
  /**
   * @typedef {Object} WeekSettings
   * @property {number} firstDay
   * @property {number} minimalDays
   * @property {number[]} weekend
   */
  /**
   * @return {WeekSettings|null}
   */
  static get defaultWeekSettings() {
    return Tk;
  }
  /**
   * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
   * how many days are required in the first week of a year.
   * Does not affect existing instances.
   *
   * @param {WeekSettings|null} weekSettings
   */
  static set defaultWeekSettings(t) {
    Tk = Aw(t);
  }
  /**
   * Get the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   */
  static get twoDigitCutoffYear() {
    return kk;
  }
  /**
   * Set the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // all 'yy' are interpreted as 20th century
   * @example Settings.twoDigitCutoffYear = 99 // all 'yy' are interpreted as 21st century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 2049; '50' -> 1950
   * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
   */
  static set twoDigitCutoffYear(t) {
    kk = t % 100;
  }
  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return Sk;
  }
  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(t) {
    Sk = t;
  }
  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    Di.resetCache(), Nc.resetCache(), Sn.resetCache(), EZ();
  }
}
class Ga {
  constructor(t, n) {
    this.reason = t, this.explanation = n;
  }
  toMessage() {
    return this.explanation ? `${this.reason}: ${this.explanation}` : this.reason;
  }
}
const NP = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], FP = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function la(e, t) {
  return new Ga(
    "unit out of range",
    `you specified ${t} (of type ${typeof t}) as a ${e}, which is invalid`
  );
}
function fx(e, t, n) {
  const i = new Date(Date.UTC(e, t - 1, n));
  e < 100 && e >= 0 && i.setUTCFullYear(i.getUTCFullYear() - 1900);
  const r = i.getUTCDay();
  return r === 0 ? 7 : r;
}
function RP(e, t, n) {
  return n + (Zm(e) ? FP : NP)[t - 1];
}
function zP(e, t) {
  const n = Zm(e) ? FP : NP, i = n.findIndex((c) => c < t), r = t - n[i];
  return { month: i + 1, day: r };
}
function mx(e, t) {
  return (e - t + 7) % 7 + 1;
}
function py(e, t = 4, n = 1) {
  const { year: i, month: r, day: c } = e, d = RP(i, r, c), a = mx(fx(i, r, c), n);
  let f = Math.floor((d - a + 14 - t) / 7), g;
  return f < 1 ? (g = i - 1, f = Sm(g, t, n)) : f > Sm(i, t, n) ? (g = i + 1, f = 1) : g = i, { weekYear: g, weekNumber: f, weekday: a, ...u_(e) };
}
function Ik(e, t = 4, n = 1) {
  const { weekYear: i, weekNumber: r, weekday: c } = e, d = mx(fx(i, 1, t), n), a = oh(i);
  let f = r * 7 + c - d - 7 + t, g;
  f < 1 ? (g = i - 1, f += oh(g)) : f > a ? (g = i + 1, f -= oh(i)) : g = i;
  const { month: x, day: $ } = zP(g, f);
  return { year: g, month: x, day: $, ...u_(e) };
}
function qb(e) {
  const { year: t, month: n, day: i } = e, r = RP(t, n, i);
  return { year: t, ordinal: r, ...u_(e) };
}
function Ak(e) {
  const { year: t, ordinal: n } = e, { month: i, day: r } = zP(t, n);
  return { year: t, month: i, day: r, ...u_(e) };
}
function Ek(e, t) {
  if (!zn(e.localWeekday) || !zn(e.localWeekNumber) || !zn(e.localWeekYear)) {
    if (!zn(e.weekday) || !zn(e.weekNumber) || !zn(e.weekYear))
      throw new Xp(
        "Cannot mix locale-based week fields with ISO-based week fields"
      );
    return zn(e.localWeekday) || (e.weekday = e.localWeekday), zn(e.localWeekNumber) || (e.weekNumber = e.localWeekNumber), zn(e.localWeekYear) || (e.weekYear = e.localWeekYear), delete e.localWeekday, delete e.localWeekNumber, delete e.localWeekYear, {
      minDaysInFirstWeek: t.getMinDaysInFirstWeek(),
      startOfWeek: t.getStartOfWeek()
    };
  } else
    return { minDaysInFirstWeek: 4, startOfWeek: 1 };
}
function PZ(e, t = 4, n = 1) {
  const i = a_(e.weekYear), r = ca(
    e.weekNumber,
    1,
    Sm(e.weekYear, t, n)
  ), c = ca(e.weekday, 1, 7);
  return i ? r ? c ? !1 : la("weekday", e.weekday) : la("week", e.weekNumber) : la("weekYear", e.weekYear);
}
function MZ(e) {
  const t = a_(e.year), n = ca(e.ordinal, 1, oh(e.year));
  return t ? n ? !1 : la("ordinal", e.ordinal) : la("year", e.year);
}
function BP(e) {
  const t = a_(e.year), n = ca(e.month, 1, 12), i = ca(e.day, 1, hy(e.year, e.month));
  return t ? n ? i ? !1 : la("day", e.day) : la("month", e.month) : la("year", e.year);
}
function VP(e) {
  const { hour: t, minute: n, second: i, millisecond: r } = e, c = ca(t, 0, 23) || t === 24 && n === 0 && i === 0 && r === 0, d = ca(n, 0, 59), a = ca(i, 0, 59), f = ca(r, 0, 999);
  return c ? d ? a ? f ? !1 : la("millisecond", r) : la("second", i) : la("minute", n) : la("hour", t);
}
function zn(e) {
  return typeof e > "u";
}
function Pu(e) {
  return typeof e == "number";
}
function a_(e) {
  return typeof e == "number" && e % 1 === 0;
}
function DZ(e) {
  return typeof e == "string";
}
function LZ(e) {
  return Object.prototype.toString.call(e) === "[object Date]";
}
function UP() {
  try {
    return typeof Intl < "u" && !!Intl.RelativeTimeFormat;
  } catch {
    return !1;
  }
}
function HP() {
  try {
    return typeof Intl < "u" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
  } catch {
    return !1;
  }
}
function OZ(e) {
  return Array.isArray(e) ? e : [e];
}
function Pk(e, t, n) {
  if (e.length !== 0)
    return e.reduce((i, r) => {
      const c = [t(r), r];
      return i && n(i[0], c[0]) === i[0] ? i : c;
    }, null)[1];
}
function NZ(e, t) {
  return t.reduce((n, i) => (n[i] = e[i], n), {});
}
function kh(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function Aw(e) {
  if (e == null)
    return null;
  if (typeof e != "object")
    throw new zs("Week settings must be an object");
  if (!ca(e.firstDay, 1, 7) || !ca(e.minimalDays, 1, 7) || !Array.isArray(e.weekend) || e.weekend.some((t) => !ca(t, 1, 7)))
    throw new zs("Invalid week settings");
  return {
    firstDay: e.firstDay,
    minimalDays: e.minimalDays,
    weekend: Array.from(e.weekend)
  };
}
function ca(e, t, n) {
  return a_(e) && e >= t && e <= n;
}
function FZ(e, t) {
  return e - t * Math.floor(e / t);
}
function Br(e, t = 2) {
  const n = e < 0;
  let i;
  return n ? i = "-" + ("" + -e).padStart(t, "0") : i = ("" + e).padStart(t, "0"), i;
}
function _u(e) {
  if (!(zn(e) || e === null || e === ""))
    return parseInt(e, 10);
}
function fd(e) {
  if (!(zn(e) || e === null || e === ""))
    return parseFloat(e);
}
function vx(e) {
  if (!(zn(e) || e === null || e === "")) {
    const t = parseFloat("0." + e) * 1e3;
    return Math.floor(t);
  }
}
function gx(e, t, n = !1) {
  const i = 10 ** t;
  return (n ? Math.trunc : Math.round)(e * i) / i;
}
function Zm(e) {
  return e % 4 === 0 && (e % 100 !== 0 || e % 400 === 0);
}
function oh(e) {
  return Zm(e) ? 366 : 365;
}
function hy(e, t) {
  const n = FZ(t - 1, 12) + 1, i = e + (t - n) / 12;
  return n === 2 ? Zm(i) ? 29 : 28 : [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][n - 1];
}
function l_(e) {
  let t = Date.UTC(
    e.year,
    e.month - 1,
    e.day,
    e.hour,
    e.minute,
    e.second,
    e.millisecond
  );
  return e.year < 100 && e.year >= 0 && (t = new Date(t), t.setUTCFullYear(e.year, e.month - 1, e.day)), +t;
}
function Mk(e, t, n) {
  return -mx(fx(e, 1, t), n) + t - 1;
}
function Sm(e, t = 4, n = 1) {
  const i = Mk(e, t, n), r = Mk(e + 1, t, n);
  return (oh(e) - i + r) / 7;
}
function Ew(e) {
  return e > 99 ? e : e > wr.twoDigitCutoffYear ? 1900 + e : 2e3 + e;
}
function WP(e, t, n, i = null) {
  const r = new Date(e), c = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  i && (c.timeZone = i);
  const d = { timeZoneName: t, ...c }, a = new Intl.DateTimeFormat(n, d).formatToParts(r).find((f) => f.type.toLowerCase() === "timezonename");
  return a ? a.value : null;
}
function c_(e, t) {
  let n = parseInt(e, 10);
  Number.isNaN(n) && (n = 0);
  const i = parseInt(t, 10) || 0, r = n < 0 || Object.is(n, -0) ? -i : i;
  return n * 60 + r;
}
function ZP(e) {
  const t = Number(e);
  if (typeof e == "boolean" || e === "" || Number.isNaN(t))
    throw new zs(`Invalid unit value ${e}`);
  return t;
}
function fy(e, t) {
  const n = {};
  for (const i in e)
    if (kh(e, i)) {
      const r = e[i];
      if (r == null) continue;
      n[t(i)] = ZP(r);
    }
  return n;
}
function lm(e, t) {
  const n = Math.trunc(Math.abs(e / 60)), i = Math.trunc(Math.abs(e % 60)), r = e >= 0 ? "+" : "-";
  switch (t) {
    case "short":
      return `${r}${Br(n, 2)}:${Br(i, 2)}`;
    case "narrow":
      return `${r}${n}${i > 0 ? `:${i}` : ""}`;
    case "techie":
      return `${r}${Br(n, 2)}${Br(i, 2)}`;
    default:
      throw new RangeError(`Value format ${t} is out of range for property format`);
  }
}
function u_(e) {
  return NZ(e, ["hour", "minute", "second", "millisecond"]);
}
const RZ = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], qP = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
], zZ = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function jP(e) {
  switch (e) {
    case "narrow":
      return [...zZ];
    case "short":
      return [...qP];
    case "long":
      return [...RZ];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
const GP = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
], YP = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], BZ = ["M", "T", "W", "T", "F", "S", "S"];
function KP(e) {
  switch (e) {
    case "narrow":
      return [...BZ];
    case "short":
      return [...YP];
    case "long":
      return [...GP];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
const XP = ["AM", "PM"], VZ = ["Before Christ", "Anno Domini"], UZ = ["BC", "AD"], HZ = ["B", "A"];
function JP(e) {
  switch (e) {
    case "narrow":
      return [...HZ];
    case "short":
      return [...UZ];
    case "long":
      return [...VZ];
    default:
      return null;
  }
}
function WZ(e) {
  return XP[e.hour < 12 ? 0 : 1];
}
function ZZ(e, t) {
  return KP(t)[e.weekday - 1];
}
function qZ(e, t) {
  return jP(t)[e.month - 1];
}
function jZ(e, t) {
  return JP(t)[e.year < 0 ? 0 : 1];
}
function GZ(e, t, n = "always", i = !1) {
  const r = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  }, c = ["hours", "minutes", "seconds"].indexOf(e) === -1;
  if (n === "auto" && c) {
    const $ = e === "days";
    switch (t) {
      case 1:
        return $ ? "tomorrow" : `next ${r[e][0]}`;
      case -1:
        return $ ? "yesterday" : `last ${r[e][0]}`;
      case 0:
        return $ ? "today" : `this ${r[e][0]}`;
    }
  }
  const d = Object.is(t, -0) || t < 0, a = Math.abs(t), f = a === 1, g = r[e], x = i ? f ? g[1] : g[2] || g[1] : f ? r[e][0] : e;
  return d ? `${a} ${x} ago` : `in ${a} ${x}`;
}
function Dk(e, t) {
  let n = "";
  for (const i of e)
    i.literal ? n += i.val : n += t(i.val);
  return n;
}
const YZ = {
  D: dy,
  DD: gP,
  DDD: yP,
  DDDD: _P,
  t: bP,
  tt: wP,
  ttt: xP,
  tttt: $P,
  T: CP,
  TT: kP,
  TTT: SP,
  TTTT: TP,
  f: IP,
  ff: EP,
  fff: MP,
  ffff: LP,
  F: AP,
  FF: PP,
  FFF: DP,
  FFFF: OP
};
class Vs {
  static create(t, n = {}) {
    return new Vs(t, n);
  }
  static parseFormat(t) {
    let n = null, i = "", r = !1;
    const c = [];
    for (let d = 0; d < t.length; d++) {
      const a = t.charAt(d);
      a === "'" ? (i.length > 0 && c.push({ literal: r || /^\s+$/.test(i), val: i }), n = null, i = "", r = !r) : r || a === n ? i += a : (i.length > 0 && c.push({ literal: /^\s+$/.test(i), val: i }), i = a, n = a);
    }
    return i.length > 0 && c.push({ literal: r || /^\s+$/.test(i), val: i }), c;
  }
  static macroTokenToFormatOpts(t) {
    return YZ[t];
  }
  constructor(t, n) {
    this.opts = n, this.loc = t, this.systemLoc = null;
  }
  formatWithSystemDefault(t, n) {
    return this.systemLoc === null && (this.systemLoc = this.loc.redefaultToSystem()), this.systemLoc.dtFormatter(t, { ...this.opts, ...n }).format();
  }
  dtFormatter(t, n = {}) {
    return this.loc.dtFormatter(t, { ...this.opts, ...n });
  }
  formatDateTime(t, n) {
    return this.dtFormatter(t, n).format();
  }
  formatDateTimeParts(t, n) {
    return this.dtFormatter(t, n).formatToParts();
  }
  formatInterval(t, n) {
    return this.dtFormatter(t.start, n).dtf.formatRange(t.start.toJSDate(), t.end.toJSDate());
  }
  resolvedOptions(t, n) {
    return this.dtFormatter(t, n).resolvedOptions();
  }
  num(t, n = 0) {
    if (this.opts.forceSimple)
      return Br(t, n);
    const i = { ...this.opts };
    return n > 0 && (i.padTo = n), this.loc.numberFormatter(i).format(t);
  }
  formatDateTimeFromString(t, n) {
    const i = this.loc.listingMode() === "en", r = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", c = (I, O) => this.loc.extract(t, I, O), d = (I) => t.isOffsetFixed && t.offset === 0 && I.allowZ ? "Z" : t.isValid ? t.zone.formatOffset(t.ts, I.format) : "", a = () => i ? WZ(t) : c({ hour: "numeric", hourCycle: "h12" }, "dayperiod"), f = (I, O) => i ? qZ(t, I) : c(O ? { month: I } : { month: I, day: "numeric" }, "month"), g = (I, O) => i ? ZZ(t, I) : c(
      O ? { weekday: I } : { weekday: I, month: "long", day: "numeric" },
      "weekday"
    ), x = (I) => {
      const O = Vs.macroTokenToFormatOpts(I);
      return O ? this.formatWithSystemDefault(t, O) : I;
    }, $ = (I) => i ? jZ(t, I) : c({ era: I }, "era"), A = (I) => {
      switch (I) {
        case "S":
          return this.num(t.millisecond);
        case "u":
        case "SSS":
          return this.num(t.millisecond, 3);
        case "s":
          return this.num(t.second);
        case "ss":
          return this.num(t.second, 2);
        case "uu":
          return this.num(Math.floor(t.millisecond / 10), 2);
        case "uuu":
          return this.num(Math.floor(t.millisecond / 100));
        case "m":
          return this.num(t.minute);
        case "mm":
          return this.num(t.minute, 2);
        case "h":
          return this.num(t.hour % 12 === 0 ? 12 : t.hour % 12);
        case "hh":
          return this.num(t.hour % 12 === 0 ? 12 : t.hour % 12, 2);
        case "H":
          return this.num(t.hour);
        case "HH":
          return this.num(t.hour, 2);
        case "Z":
          return d({ format: "narrow", allowZ: this.opts.allowZ });
        case "ZZ":
          return d({ format: "short", allowZ: this.opts.allowZ });
        case "ZZZ":
          return d({ format: "techie", allowZ: this.opts.allowZ });
        case "ZZZZ":
          return t.zone.offsetName(t.ts, { format: "short", locale: this.loc.locale });
        case "ZZZZZ":
          return t.zone.offsetName(t.ts, { format: "long", locale: this.loc.locale });
        case "z":
          return t.zoneName;
        case "a":
          return a();
        case "d":
          return r ? c({ day: "numeric" }, "day") : this.num(t.day);
        case "dd":
          return r ? c({ day: "2-digit" }, "day") : this.num(t.day, 2);
        case "c":
          return this.num(t.weekday);
        case "ccc":
          return g("short", !0);
        case "cccc":
          return g("long", !0);
        case "ccccc":
          return g("narrow", !0);
        case "E":
          return this.num(t.weekday);
        case "EEE":
          return g("short", !1);
        case "EEEE":
          return g("long", !1);
        case "EEEEE":
          return g("narrow", !1);
        case "L":
          return r ? c({ month: "numeric", day: "numeric" }, "month") : this.num(t.month);
        case "LL":
          return r ? c({ month: "2-digit", day: "numeric" }, "month") : this.num(t.month, 2);
        case "LLL":
          return f("short", !0);
        case "LLLL":
          return f("long", !0);
        case "LLLLL":
          return f("narrow", !0);
        case "M":
          return r ? c({ month: "numeric" }, "month") : this.num(t.month);
        case "MM":
          return r ? c({ month: "2-digit" }, "month") : this.num(t.month, 2);
        case "MMM":
          return f("short", !1);
        case "MMMM":
          return f("long", !1);
        case "MMMMM":
          return f("narrow", !1);
        case "y":
          return r ? c({ year: "numeric" }, "year") : this.num(t.year);
        case "yy":
          return r ? c({ year: "2-digit" }, "year") : this.num(t.year.toString().slice(-2), 2);
        case "yyyy":
          return r ? c({ year: "numeric" }, "year") : this.num(t.year, 4);
        case "yyyyyy":
          return r ? c({ year: "numeric" }, "year") : this.num(t.year, 6);
        case "G":
          return $("short");
        case "GG":
          return $("long");
        case "GGGGG":
          return $("narrow");
        case "kk":
          return this.num(t.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(t.weekYear, 4);
        case "W":
          return this.num(t.weekNumber);
        case "WW":
          return this.num(t.weekNumber, 2);
        case "n":
          return this.num(t.localWeekNumber);
        case "nn":
          return this.num(t.localWeekNumber, 2);
        case "ii":
          return this.num(t.localWeekYear.toString().slice(-2), 2);
        case "iiii":
          return this.num(t.localWeekYear, 4);
        case "o":
          return this.num(t.ordinal);
        case "ooo":
          return this.num(t.ordinal, 3);
        case "q":
          return this.num(t.quarter);
        case "qq":
          return this.num(t.quarter, 2);
        case "X":
          return this.num(Math.floor(t.ts / 1e3));
        case "x":
          return this.num(t.ts);
        default:
          return x(I);
      }
    };
    return Dk(Vs.parseFormat(n), A);
  }
  formatDurationFromString(t, n) {
    const i = (f) => {
      switch (f[0]) {
        case "S":
          return "millisecond";
        case "s":
          return "second";
        case "m":
          return "minute";
        case "h":
          return "hour";
        case "d":
          return "day";
        case "w":
          return "week";
        case "M":
          return "month";
        case "y":
          return "year";
        default:
          return null;
      }
    }, r = (f) => (g) => {
      const x = i(g);
      return x ? this.num(f.get(x), g.length) : g;
    }, c = Vs.parseFormat(n), d = c.reduce(
      (f, { literal: g, val: x }) => g ? f : f.concat(x),
      []
    ), a = t.shiftTo(...d.map(i).filter((f) => f));
    return Dk(c, r(a));
  }
}
const QP = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function Gh(...e) {
  const t = e.reduce((n, i) => n + i.source, "");
  return RegExp(`^${t}$`);
}
function Yh(...e) {
  return (t) => e.reduce(
    ([n, i, r], c) => {
      const [d, a, f] = c(t, r);
      return [{ ...n, ...d }, a || i, f];
    },
    [{}, null, 1]
  ).slice(0, 2);
}
function Kh(e, ...t) {
  if (e == null)
    return [null, null];
  for (const [n, i] of t) {
    const r = n.exec(e);
    if (r)
      return i(r);
  }
  return [null, null];
}
function eM(...e) {
  return (t, n) => {
    const i = {};
    let r;
    for (r = 0; r < e.length; r++)
      i[e[r]] = _u(t[n + r]);
    return [i, null, n + r];
  };
}
const tM = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/, KZ = `(?:${tM.source}?(?:\\[(${QP.source})\\])?)?`, yx = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/, nM = RegExp(`${yx.source}${KZ}`), _x = RegExp(`(?:T${nM.source})?`), XZ = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/, JZ = /(\d{4})-?W(\d\d)(?:-?(\d))?/, QZ = /(\d{4})-?(\d{3})/, eq = eM("weekYear", "weekNumber", "weekDay"), tq = eM("year", "ordinal"), nq = /(\d{4})-(\d\d)-(\d\d)/, iM = RegExp(
  `${yx.source} ?(?:${tM.source}|(${QP.source}))?`
), iq = RegExp(`(?: ${iM.source})?`);
function ah(e, t, n) {
  const i = e[t];
  return zn(i) ? n : _u(i);
}
function rq(e, t) {
  return [{
    year: ah(e, t),
    month: ah(e, t + 1, 1),
    day: ah(e, t + 2, 1)
  }, null, t + 3];
}
function Xh(e, t) {
  return [{
    hours: ah(e, t, 0),
    minutes: ah(e, t + 1, 0),
    seconds: ah(e, t + 2, 0),
    milliseconds: vx(e[t + 3])
  }, null, t + 4];
}
function qm(e, t) {
  const n = !e[t] && !e[t + 1], i = c_(e[t + 1], e[t + 2]), r = n ? null : ro.instance(i);
  return [{}, r, t + 3];
}
function jm(e, t) {
  const n = e[t] ? Nc.create(e[t]) : null;
  return [{}, n, t + 1];
}
const sq = RegExp(`^T?${yx.source}$`), oq = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function aq(e) {
  const [t, n, i, r, c, d, a, f, g] = e, x = t[0] === "-", $ = f && f[0] === "-", A = (I, O = !1) => I !== void 0 && (O || I && x) ? -I : I;
  return [
    {
      years: A(fd(n)),
      months: A(fd(i)),
      weeks: A(fd(r)),
      days: A(fd(c)),
      hours: A(fd(d)),
      minutes: A(fd(a)),
      seconds: A(fd(f), f === "-0"),
      milliseconds: A(vx(g), $)
    }
  ];
}
const lq = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function bx(e, t, n, i, r, c, d) {
  const a = {
    year: t.length === 2 ? Ew(_u(t)) : _u(t),
    month: qP.indexOf(n) + 1,
    day: _u(i),
    hour: _u(r),
    minute: _u(c)
  };
  return d && (a.second = _u(d)), e && (a.weekday = e.length > 3 ? GP.indexOf(e) + 1 : YP.indexOf(e) + 1), a;
}
const cq = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function uq(e) {
  const [
    ,
    t,
    n,
    i,
    r,
    c,
    d,
    a,
    f,
    g,
    x,
    $
  ] = e, A = bx(t, r, i, n, c, d, a);
  let I;
  return f ? I = lq[f] : g ? I = 0 : I = c_(x, $), [A, new ro(I)];
}
function dq(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
const pq = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, hq = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, fq = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function Lk(e) {
  const [, t, n, i, r, c, d, a] = e;
  return [bx(t, r, i, n, c, d, a), ro.utcInstance];
}
function mq(e) {
  const [, t, n, i, r, c, d, a] = e;
  return [bx(t, a, n, i, r, c, d), ro.utcInstance];
}
const vq = Gh(XZ, _x), gq = Gh(JZ, _x), yq = Gh(QZ, _x), _q = Gh(nM), rM = Yh(
  rq,
  Xh,
  qm,
  jm
), bq = Yh(
  eq,
  Xh,
  qm,
  jm
), wq = Yh(
  tq,
  Xh,
  qm,
  jm
), xq = Yh(
  Xh,
  qm,
  jm
);
function $q(e) {
  return Kh(
    e,
    [vq, rM],
    [gq, bq],
    [yq, wq],
    [_q, xq]
  );
}
function Cq(e) {
  return Kh(dq(e), [cq, uq]);
}
function kq(e) {
  return Kh(
    e,
    [pq, Lk],
    [hq, Lk],
    [fq, mq]
  );
}
function Sq(e) {
  return Kh(e, [oq, aq]);
}
const Tq = Yh(Xh);
function Iq(e) {
  return Kh(e, [sq, Tq]);
}
const Aq = Gh(nq, iq), Eq = Gh(iM), Pq = Yh(
  Xh,
  qm,
  jm
);
function Mq(e) {
  return Kh(
    e,
    [Aq, rM],
    [Eq, Pq]
  );
}
const Ok = "Invalid Duration", sM = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1e3
  },
  hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1e3 },
  minutes: { seconds: 60, milliseconds: 60 * 1e3 },
  seconds: { milliseconds: 1e3 }
}, Dq = {
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1e3
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1e3
  },
  ...sM
}, na = 146097 / 400, Tp = 146097 / 4800, Lq = {
  years: {
    quarters: 4,
    months: 12,
    weeks: na / 7,
    days: na,
    hours: na * 24,
    minutes: na * 24 * 60,
    seconds: na * 24 * 60 * 60,
    milliseconds: na * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: na / 28,
    days: na / 4,
    hours: na * 24 / 4,
    minutes: na * 24 * 60 / 4,
    seconds: na * 24 * 60 * 60 / 4,
    milliseconds: na * 24 * 60 * 60 * 1e3 / 4
  },
  months: {
    weeks: Tp / 7,
    days: Tp,
    hours: Tp * 24,
    minutes: Tp * 24 * 60,
    seconds: Tp * 24 * 60 * 60,
    milliseconds: Tp * 24 * 60 * 60 * 1e3
  },
  ...sM
}, kd = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
], Oq = kd.slice(0).reverse();
function mu(e, t, n = !1) {
  const i = {
    values: n ? t.values : { ...e.values, ...t.values || {} },
    loc: e.loc.clone(t.loc),
    conversionAccuracy: t.conversionAccuracy || e.conversionAccuracy,
    matrix: t.matrix || e.matrix
  };
  return new _i(i);
}
function oM(e, t) {
  let n = t.milliseconds ?? 0;
  for (const i of Oq.slice(1))
    t[i] && (n += t[i] * e[i].milliseconds);
  return n;
}
function Nk(e, t) {
  const n = oM(e, t) < 0 ? -1 : 1;
  kd.reduceRight((i, r) => {
    if (zn(t[r]))
      return i;
    if (i) {
      const c = t[i] * n, d = e[r][i], a = Math.floor(c / d);
      t[r] += a * n, t[i] -= a * d * n;
    }
    return r;
  }, null), kd.reduce((i, r) => {
    if (zn(t[r]))
      return i;
    if (i) {
      const c = t[i] % 1;
      t[i] -= c, t[r] += c * e[i][r];
    }
    return r;
  }, null);
}
function Nq(e) {
  const t = {};
  for (const [n, i] of Object.entries(e))
    i !== 0 && (t[n] = i);
  return t;
}
class _i {
  /**
   * @private
   */
  constructor(t) {
    const n = t.conversionAccuracy === "longterm" || !1;
    let i = n ? Lq : Dq;
    t.matrix && (i = t.matrix), this.values = t.values, this.loc = t.loc || Di.create(), this.conversionAccuracy = n ? "longterm" : "casual", this.invalid = t.invalid || null, this.matrix = i, this.isLuxonDuration = !0;
  }
  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(t, n) {
    return _i.fromObject({ milliseconds: t }, n);
  }
  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */
  static fromObject(t, n = {}) {
    if (t == null || typeof t != "object")
      throw new zs(
        `Duration.fromObject: argument expected to be an object, got ${t === null ? "null" : typeof t}`
      );
    return new _i({
      values: fy(t, _i.normalizeUnit),
      loc: Di.fromObject(n),
      conversionAccuracy: n.conversionAccuracy,
      matrix: n.matrix
    });
  }
  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(t) {
    if (Pu(t))
      return _i.fromMillis(t);
    if (_i.isDuration(t))
      return t;
    if (typeof t == "object")
      return _i.fromObject(t);
    throw new zs(
      `Unknown duration argument ${t} of type ${typeof t}`
    );
  }
  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(t, n) {
    const [i] = Sq(t);
    return i ? _i.fromObject(i, n) : _i.invalid("unparsable", `the input "${t}" can't be parsed as ISO 8601`);
  }
  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(t, n) {
    const [i] = Iq(t);
    return i ? _i.fromObject(i, n) : _i.invalid("unparsable", `the input "${t}" can't be parsed as ISO 8601`);
  }
  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(t, n = null) {
    if (!t)
      throw new zs("need to specify a reason the Duration is invalid");
    const i = t instanceof Ga ? t : new Ga(t, n);
    if (wr.throwOnInvalid)
      throw new oZ(i);
    return new _i({ invalid: i });
  }
  /**
   * @private
   */
  static normalizeUnit(t) {
    const n = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[t && t.toLowerCase()];
    if (!n) throw new vP(t);
    return n;
  }
  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(t) {
    return t && t.isLuxonDuration || !1;
  }
  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */
  toFormat(t, n = {}) {
    const i = {
      ...n,
      floor: n.round !== !1 && n.floor !== !1
    };
    return this.isValid ? Vs.create(this.loc, i).formatDurationFromString(this, t) : Ok;
  }
  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */
  toHuman(t = {}) {
    if (!this.isValid) return Ok;
    const n = kd.map((i) => {
      const r = this.values[i];
      return zn(r) ? null : this.loc.numberFormatter({ style: "unit", unitDisplay: "long", ...t, unit: i.slice(0, -1) }).format(r);
    }).filter((i) => i);
    return this.loc.listFormatter({ type: "conjunction", style: t.listStyle || "narrow", ...t }).format(n);
  }
  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    return this.isValid ? { ...this.values } : {};
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    if (!this.isValid) return null;
    let t = "P";
    return this.years !== 0 && (t += this.years + "Y"), (this.months !== 0 || this.quarters !== 0) && (t += this.months + this.quarters * 3 + "M"), this.weeks !== 0 && (t += this.weeks + "W"), this.days !== 0 && (t += this.days + "D"), (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) && (t += "T"), this.hours !== 0 && (t += this.hours + "H"), this.minutes !== 0 && (t += this.minutes + "M"), (this.seconds !== 0 || this.milliseconds !== 0) && (t += gx(this.seconds + this.milliseconds / 1e3, 3) + "S"), t === "P" && (t += "T0S"), t;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(t = {}) {
    if (!this.isValid) return null;
    const n = this.toMillis();
    return n < 0 || n >= 864e5 ? null : (t = {
      suppressMilliseconds: !1,
      suppressSeconds: !1,
      includePrefix: !1,
      format: "extended",
      ...t,
      includeOffset: !1
    }, Sn.fromMillis(n, { zone: "UTC" }).toISOTime(t));
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }
  /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `Duration { values: ${JSON.stringify(this.values)} }` : `Duration { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? oM(this.matrix, this.values) : NaN;
  }
  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(t) {
    if (!this.isValid) return this;
    const n = _i.fromDurationLike(t), i = {};
    for (const r of kd)
      (kh(n.values, r) || kh(this.values, r)) && (i[r] = n.get(r) + this.get(r));
    return mu(this, { values: i }, !0);
  }
  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(t) {
    if (!this.isValid) return this;
    const n = _i.fromDurationLike(t);
    return this.plus(n.negate());
  }
  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(t) {
    if (!this.isValid) return this;
    const n = {};
    for (const i of Object.keys(this.values))
      n[i] = ZP(t(this.values[i], i));
    return mu(this, { values: n }, !0);
  }
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(t) {
    return this[_i.normalizeUnit(t)];
  }
  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(t) {
    if (!this.isValid) return this;
    const n = { ...this.values, ...fy(t, _i.normalizeUnit) };
    return mu(this, { values: n });
  }
  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale: t, numberingSystem: n, conversionAccuracy: i, matrix: r } = {}) {
    const d = { loc: this.loc.clone({ locale: t, numberingSystem: n }), matrix: r, conversionAccuracy: i };
    return mu(this, d);
  }
  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(t) {
    return this.isValid ? this.shiftTo(t).get(t) : NaN;
  }
  /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid) return this;
    const t = this.toObject();
    return Nk(this.matrix, t), mu(this, { values: t }, !0);
  }
  /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */
  rescale() {
    if (!this.isValid) return this;
    const t = Nq(this.normalize().shiftToAll().toObject());
    return mu(this, { values: t }, !0);
  }
  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...t) {
    if (!this.isValid) return this;
    if (t.length === 0)
      return this;
    t = t.map((d) => _i.normalizeUnit(d));
    const n = {}, i = {}, r = this.toObject();
    let c;
    for (const d of kd)
      if (t.indexOf(d) >= 0) {
        c = d;
        let a = 0;
        for (const g in i)
          a += this.matrix[g][d] * i[g], i[g] = 0;
        Pu(r[d]) && (a += r[d]);
        const f = Math.trunc(a);
        n[d] = f, i[d] = (a * 1e3 - f * 1e3) / 1e3;
      } else Pu(r[d]) && (i[d] = r[d]);
    for (const d in i)
      i[d] !== 0 && (n[c] += d === c ? i[d] : i[d] / this.matrix[c][d]);
    return Nk(this.matrix, n), mu(this, { values: n }, !0);
  }
  /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */
  shiftToAll() {
    return this.isValid ? this.shiftTo(
      "years",
      "months",
      "weeks",
      "days",
      "hours",
      "minutes",
      "seconds",
      "milliseconds"
    ) : this;
  }
  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid) return this;
    const t = {};
    for (const n of Object.keys(this.values))
      t[n] = this.values[n] === 0 ? 0 : -this.values[n];
    return mu(this, { values: t }, !0);
  }
  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(t) {
    if (!this.isValid || !t.isValid || !this.loc.equals(t.loc))
      return !1;
    function n(i, r) {
      return i === void 0 || i === 0 ? r === void 0 || r === 0 : i === r;
    }
    for (const i of kd)
      if (!n(this.values[i], t.values[i]))
        return !1;
    return !0;
  }
}
const Ip = "Invalid Interval";
function Fq(e, t) {
  return !e || !e.isValid ? _r.invalid("missing or invalid start") : !t || !t.isValid ? _r.invalid("missing or invalid end") : t < e ? _r.invalid(
    "end before start",
    `The end of an interval must be after its start, but you had start=${e.toISO()} and end=${t.toISO()}`
  ) : null;
}
class _r {
  /**
   * @private
   */
  constructor(t) {
    this.s = t.start, this.e = t.end, this.invalid = t.invalid || null, this.isLuxonInterval = !0;
  }
  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(t, n = null) {
    if (!t)
      throw new zs("need to specify a reason the Interval is invalid");
    const i = t instanceof Ga ? t : new Ga(t, n);
    if (wr.throwOnInvalid)
      throw new sZ(i);
    return new _r({ invalid: i });
  }
  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(t, n) {
    const i = Nf(t), r = Nf(n), c = Fq(i, r);
    return c ?? new _r({
      start: i,
      end: r
    });
  }
  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(t, n) {
    const i = _i.fromDurationLike(n), r = Nf(t);
    return _r.fromDateTimes(r, r.plus(i));
  }
  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(t, n) {
    const i = _i.fromDurationLike(n), r = Nf(t);
    return _r.fromDateTimes(r.minus(i), r);
  }
  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(t, n) {
    const [i, r] = (t || "").split("/", 2);
    if (i && r) {
      let c, d;
      try {
        c = Sn.fromISO(i, n), d = c.isValid;
      } catch {
        d = !1;
      }
      let a, f;
      try {
        a = Sn.fromISO(r, n), f = a.isValid;
      } catch {
        f = !1;
      }
      if (d && f)
        return _r.fromDateTimes(c, a);
      if (d) {
        const g = _i.fromISO(r, n);
        if (g.isValid)
          return _r.after(c, g);
      } else if (f) {
        const g = _i.fromISO(i, n);
        if (g.isValid)
          return _r.before(a, g);
      }
    }
    return _r.invalid("unparsable", `the input "${t}" can't be parsed as ISO 8601`);
  }
  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(t) {
    return t && t.isLuxonInterval || !1;
  }
  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }
  /**
   * Returns the end of the Interval
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }
  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }
  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(t = "milliseconds") {
    return this.isValid ? this.toDuration(t).get(t) : NaN;
  }
  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */
  count(t = "milliseconds", n) {
    if (!this.isValid) return NaN;
    const i = this.start.startOf(t, n);
    let r;
    return n != null && n.useLocaleWeeks ? r = this.end.reconfigure({ locale: i.locale }) : r = this.end, r = r.startOf(t, n), Math.floor(r.diff(i, t).get(t)) + (r.valueOf() !== this.end.valueOf());
  }
  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(t) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, t) : !1;
  }
  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(t) {
    return this.isValid ? this.s > t : !1;
  }
  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(t) {
    return this.isValid ? this.e <= t : !1;
  }
  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(t) {
    return this.isValid ? this.s <= t && this.e > t : !1;
  }
  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start: t, end: n } = {}) {
    return this.isValid ? _r.fromDateTimes(t || this.s, n || this.e) : this;
  }
  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...t) {
    if (!this.isValid) return [];
    const n = t.map(Nf).filter((d) => this.contains(d)).sort((d, a) => d.toMillis() - a.toMillis()), i = [];
    let { s: r } = this, c = 0;
    for (; r < this.e; ) {
      const d = n[c] || this.e, a = +d > +this.e ? this.e : d;
      i.push(_r.fromDateTimes(r, a)), r = a, c += 1;
    }
    return i;
  }
  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(t) {
    const n = _i.fromDurationLike(t);
    if (!this.isValid || !n.isValid || n.as("milliseconds") === 0)
      return [];
    let { s: i } = this, r = 1, c;
    const d = [];
    for (; i < this.e; ) {
      const a = this.start.plus(n.mapUnits((f) => f * r));
      c = +a > +this.e ? this.e : a, d.push(_r.fromDateTimes(i, c)), i = c, r += 1;
    }
    return d;
  }
  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(t) {
    return this.isValid ? this.splitBy(this.length() / t).slice(0, t) : [];
  }
  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(t) {
    return this.e > t.s && this.s < t.e;
  }
  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(t) {
    return this.isValid ? +this.e == +t.s : !1;
  }
  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(t) {
    return this.isValid ? +t.e == +this.s : !1;
  }
  /**
   * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(t) {
    return this.isValid ? this.s <= t.s && this.e >= t.e : !1;
  }
  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(t) {
    return !this.isValid || !t.isValid ? !1 : this.s.equals(t.s) && this.e.equals(t.e);
  }
  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(t) {
    if (!this.isValid) return this;
    const n = this.s > t.s ? this.s : t.s, i = this.e < t.e ? this.e : t.e;
    return n >= i ? null : _r.fromDateTimes(n, i);
  }
  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(t) {
    if (!this.isValid) return this;
    const n = this.s < t.s ? this.s : t.s, i = this.e > t.e ? this.e : t.e;
    return _r.fromDateTimes(n, i);
  }
  /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(t) {
    const [n, i] = t.sort((r, c) => r.s - c.s).reduce(
      ([r, c], d) => c ? c.overlaps(d) || c.abutsStart(d) ? [r, c.union(d)] : [r.concat([c]), d] : [r, d],
      [[], null]
    );
    return i && n.push(i), n;
  }
  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(t) {
    let n = null, i = 0;
    const r = [], c = t.map((f) => [
      { time: f.s, type: "s" },
      { time: f.e, type: "e" }
    ]), d = Array.prototype.concat(...c), a = d.sort((f, g) => f.time - g.time);
    for (const f of a)
      i += f.type === "s" ? 1 : -1, i === 1 ? n = f.time : (n && +n != +f.time && r.push(_r.fromDateTimes(n, f.time)), n = null);
    return _r.merge(r);
  }
  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...t) {
    return _r.xor([this].concat(t)).map((n) => this.intersection(n)).filter((n) => n && !n.isEmpty());
  }
  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    return this.isValid ? `[${this.s.toISO()} – ${this.e.toISO()})` : Ip;
  }
  /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }` : `Interval { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */
  toLocaleString(t = dy, n = {}) {
    return this.isValid ? Vs.create(this.s.loc.clone(n), t).formatInterval(this) : Ip;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(t) {
    return this.isValid ? `${this.s.toISO(t)}/${this.e.toISO(t)}` : Ip;
  }
  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    return this.isValid ? `${this.s.toISODate()}/${this.e.toISODate()}` : Ip;
  }
  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(t) {
    return this.isValid ? `${this.s.toISOTime(t)}/${this.e.toISOTime(t)}` : Ip;
  }
  /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */
  toFormat(t, { separator: n = " – " } = {}) {
    return this.isValid ? `${this.s.toFormat(t)}${n}${this.e.toFormat(t)}` : Ip;
  }
  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(t, n) {
    return this.isValid ? this.e.diff(this.s, t, n) : _i.invalid(this.invalidReason);
  }
  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(t) {
    return _r.fromDateTimes(t(this.s), t(this.e));
  }
}
class Hv {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(t = wr.defaultZone) {
    const n = Sn.now().setZone(t).set({ month: 12 });
    return !t.isUniversal && n.offset !== n.set({ month: 6 }).offset;
  }
  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(t) {
    return Nc.isValidZone(t);
  }
  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(t) {
    return xu(t, wr.defaultZone);
  }
  /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */
  static getStartOfWeek({ locale: t = null, locObj: n = null } = {}) {
    return (n || Di.create(t)).getStartOfWeek();
  }
  /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */
  static getMinimumDaysInFirstWeek({ locale: t = null, locObj: n = null } = {}) {
    return (n || Di.create(t)).getMinDaysInFirstWeek();
  }
  /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */
  static getWeekendWeekdays({ locale: t = null, locObj: n = null } = {}) {
    return (n || Di.create(t)).getWeekendDays().slice();
  }
  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(t = "long", { locale: n = null, numberingSystem: i = null, locObj: r = null, outputCalendar: c = "gregory" } = {}) {
    return (r || Di.create(n, i, c)).months(t);
  }
  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(t = "long", { locale: n = null, numberingSystem: i = null, locObj: r = null, outputCalendar: c = "gregory" } = {}) {
    return (r || Di.create(n, i, c)).months(t, !0);
  }
  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(t = "long", { locale: n = null, numberingSystem: i = null, locObj: r = null } = {}) {
    return (r || Di.create(n, i, null)).weekdays(t);
  }
  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(t = "long", { locale: n = null, numberingSystem: i = null, locObj: r = null } = {}) {
    return (r || Di.create(n, i, null)).weekdays(t, !0);
  }
  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({ locale: t = null } = {}) {
    return Di.create(t).meridiems();
  }
  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(t = "short", { locale: n = null } = {}) {
    return Di.create(n, null, "gregory").eras(t);
  }
  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */
  static features() {
    return { relative: UP(), localeWeek: HP() };
  }
}
function Fk(e, t) {
  const n = (r) => r.toUTC(0, { keepLocalTime: !0 }).startOf("day").valueOf(), i = n(t) - n(e);
  return Math.floor(_i.fromMillis(i).as("days"));
}
function Rq(e, t, n) {
  const i = [
    ["years", (f, g) => g.year - f.year],
    ["quarters", (f, g) => g.quarter - f.quarter + (g.year - f.year) * 4],
    ["months", (f, g) => g.month - f.month + (g.year - f.year) * 12],
    [
      "weeks",
      (f, g) => {
        const x = Fk(f, g);
        return (x - x % 7) / 7;
      }
    ],
    ["days", Fk]
  ], r = {}, c = e;
  let d, a;
  for (const [f, g] of i)
    n.indexOf(f) >= 0 && (d = f, r[f] = g(e, t), a = c.plus(r), a > t ? (r[f]--, e = c.plus(r), e > t && (a = e, r[f]--, e = c.plus(r))) : e = a);
  return [e, r, a, d];
}
function zq(e, t, n, i) {
  let [r, c, d, a] = Rq(e, t, n);
  const f = t - r, g = n.filter(
    ($) => ["hours", "minutes", "seconds", "milliseconds"].indexOf($) >= 0
  );
  g.length === 0 && (d < t && (d = r.plus({ [a]: 1 })), d !== r && (c[a] = (c[a] || 0) + f / (d - r)));
  const x = _i.fromObject(c, i);
  return g.length > 0 ? _i.fromMillis(f, i).shiftTo(...g).plus(x) : x;
}
const Bq = "missing Intl.DateTimeFormat.formatToParts support";
function Ai(e, t = (n) => n) {
  return { regex: e, deser: ([n]) => t(AZ(n)) };
}
const Vq = " ", aM = `[ ${Vq}]`, lM = new RegExp(aM, "g");
function Uq(e) {
  return e.replace(/\./g, "\\.?").replace(lM, aM);
}
function Rk(e) {
  return e.replace(/\./g, "").replace(lM, " ").toLowerCase();
}
function Ua(e, t) {
  return e === null ? null : {
    regex: RegExp(e.map(Uq).join("|")),
    deser: ([n]) => e.findIndex((i) => Rk(n) === Rk(i)) + t
  };
}
function zk(e, t) {
  return { regex: e, deser: ([, n, i]) => c_(n, i), groups: t };
}
function Wv(e) {
  return { regex: e, deser: ([t]) => t };
}
function Hq(e) {
  return e.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function Wq(e, t) {
  const n = Va(t), i = Va(t, "{2}"), r = Va(t, "{3}"), c = Va(t, "{4}"), d = Va(t, "{6}"), a = Va(t, "{1,2}"), f = Va(t, "{1,3}"), g = Va(t, "{1,6}"), x = Va(t, "{1,9}"), $ = Va(t, "{2,4}"), A = Va(t, "{4,6}"), I = (H) => ({ regex: RegExp(Hq(H.val)), deser: ([N]) => N, literal: !0 }), B = ((H) => {
    if (e.literal)
      return I(H);
    switch (H.val) {
      case "G":
        return Ua(t.eras("short"), 0);
      case "GG":
        return Ua(t.eras("long"), 0);
      case "y":
        return Ai(g);
      case "yy":
        return Ai($, Ew);
      case "yyyy":
        return Ai(c);
      case "yyyyy":
        return Ai(A);
      case "yyyyyy":
        return Ai(d);
      case "M":
        return Ai(a);
      case "MM":
        return Ai(i);
      case "MMM":
        return Ua(t.months("short", !0), 1);
      case "MMMM":
        return Ua(t.months("long", !0), 1);
      case "L":
        return Ai(a);
      case "LL":
        return Ai(i);
      case "LLL":
        return Ua(t.months("short", !1), 1);
      case "LLLL":
        return Ua(t.months("long", !1), 1);
      case "d":
        return Ai(a);
      case "dd":
        return Ai(i);
      case "o":
        return Ai(f);
      case "ooo":
        return Ai(r);
      case "HH":
        return Ai(i);
      case "H":
        return Ai(a);
      case "hh":
        return Ai(i);
      case "h":
        return Ai(a);
      case "mm":
        return Ai(i);
      case "m":
        return Ai(a);
      case "q":
        return Ai(a);
      case "qq":
        return Ai(i);
      case "s":
        return Ai(a);
      case "ss":
        return Ai(i);
      case "S":
        return Ai(f);
      case "SSS":
        return Ai(r);
      case "u":
        return Wv(x);
      case "uu":
        return Wv(a);
      case "uuu":
        return Ai(n);
      case "a":
        return Ua(t.meridiems(), 0);
      case "kkkk":
        return Ai(c);
      case "kk":
        return Ai($, Ew);
      case "W":
        return Ai(a);
      case "WW":
        return Ai(i);
      case "E":
      case "c":
        return Ai(n);
      case "EEE":
        return Ua(t.weekdays("short", !1), 1);
      case "EEEE":
        return Ua(t.weekdays("long", !1), 1);
      case "ccc":
        return Ua(t.weekdays("short", !0), 1);
      case "cccc":
        return Ua(t.weekdays("long", !0), 1);
      case "Z":
      case "ZZ":
        return zk(new RegExp(`([+-]${a.source})(?::(${i.source}))?`), 2);
      case "ZZZ":
        return zk(new RegExp(`([+-]${a.source})(${i.source})?`), 2);
      case "z":
        return Wv(/[a-z_+-/]{1,256}?/i);
      case " ":
        return Wv(/[^\S\n\r]/);
      default:
        return I(H);
    }
  })(e) || {
    invalidReason: Bq
  };
  return B.token = e, B;
}
const Zq = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh"
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function qq(e, t, n) {
  const { type: i, value: r } = e;
  if (i === "literal") {
    const f = /^\s+$/.test(r);
    return {
      literal: !f,
      val: f ? " " : r
    };
  }
  const c = t[i];
  let d = i;
  i === "hour" && (t.hour12 != null ? d = t.hour12 ? "hour12" : "hour24" : t.hourCycle != null ? t.hourCycle === "h11" || t.hourCycle === "h12" ? d = "hour12" : d = "hour24" : d = n.hour12 ? "hour12" : "hour24");
  let a = Zq[d];
  if (typeof a == "object" && (a = a[c]), a)
    return {
      literal: !1,
      val: a
    };
}
function jq(e) {
  return [`^${e.map((n) => n.regex).reduce((n, i) => `${n}(${i.source})`, "")}$`, e];
}
function Gq(e, t, n) {
  const i = e.match(t);
  if (i) {
    const r = {};
    let c = 1;
    for (const d in n)
      if (kh(n, d)) {
        const a = n[d], f = a.groups ? a.groups + 1 : 1;
        !a.literal && a.token && (r[a.token.val[0]] = a.deser(i.slice(c, c + f))), c += f;
      }
    return [i, r];
  } else
    return [i, {}];
}
function Yq(e) {
  const t = (c) => {
    switch (c) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };
  let n = null, i;
  return zn(e.z) || (n = Nc.create(e.z)), zn(e.Z) || (n || (n = new ro(e.Z)), i = e.Z), zn(e.q) || (e.M = (e.q - 1) * 3 + 1), zn(e.h) || (e.h < 12 && e.a === 1 ? e.h += 12 : e.h === 12 && e.a === 0 && (e.h = 0)), e.G === 0 && e.y && (e.y = -e.y), zn(e.u) || (e.S = vx(e.u)), [Object.keys(e).reduce((c, d) => {
    const a = t(d);
    return a && (c[a] = e[d]), c;
  }, {}), n, i];
}
let jb = null;
function Kq() {
  return jb || (jb = Sn.fromMillis(1555555555555)), jb;
}
function Xq(e, t) {
  if (e.literal)
    return e;
  const n = Vs.macroTokenToFormatOpts(e.val), i = pM(n, t);
  return i == null || i.includes(void 0) ? e : i;
}
function cM(e, t) {
  return Array.prototype.concat(...e.map((n) => Xq(n, t)));
}
class uM {
  constructor(t, n) {
    if (this.locale = t, this.format = n, this.tokens = cM(Vs.parseFormat(n), t), this.units = this.tokens.map((i) => Wq(i, t)), this.disqualifyingUnit = this.units.find((i) => i.invalidReason), !this.disqualifyingUnit) {
      const [i, r] = jq(this.units);
      this.regex = RegExp(i, "i"), this.handlers = r;
    }
  }
  explainFromTokens(t) {
    if (this.isValid) {
      const [n, i] = Gq(t, this.regex, this.handlers), [r, c, d] = i ? Yq(i) : [null, null, void 0];
      if (kh(i, "a") && kh(i, "H"))
        throw new Xp(
          "Can't include meridiem when specifying 24-hour format"
        );
      return {
        input: t,
        tokens: this.tokens,
        regex: this.regex,
        rawMatches: n,
        matches: i,
        result: r,
        zone: c,
        specificOffset: d
      };
    } else
      return { input: t, tokens: this.tokens, invalidReason: this.invalidReason };
  }
  get isValid() {
    return !this.disqualifyingUnit;
  }
  get invalidReason() {
    return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
  }
}
function dM(e, t, n) {
  return new uM(e, n).explainFromTokens(t);
}
function Jq(e, t, n) {
  const { result: i, zone: r, specificOffset: c, invalidReason: d } = dM(e, t, n);
  return [i, r, c, d];
}
function pM(e, t) {
  if (!e)
    return null;
  const i = Vs.create(t, e).dtFormatter(Kq()), r = i.formatToParts(), c = i.resolvedOptions();
  return r.map((d) => qq(d, e, c));
}
const Gb = "Invalid DateTime", Qq = 864e13;
function Qf(e) {
  return new Ga("unsupported zone", `the zone "${e.name}" is not supported`);
}
function Yb(e) {
  return e.weekData === null && (e.weekData = py(e.c)), e.weekData;
}
function Kb(e) {
  return e.localWeekData === null && (e.localWeekData = py(
    e.c,
    e.loc.getMinDaysInFirstWeek(),
    e.loc.getStartOfWeek()
  )), e.localWeekData;
}
function md(e, t) {
  const n = {
    ts: e.ts,
    zone: e.zone,
    c: e.c,
    o: e.o,
    loc: e.loc,
    invalid: e.invalid
  };
  return new Sn({ ...n, ...t, old: n });
}
function hM(e, t, n) {
  let i = e - t * 60 * 1e3;
  const r = n.offset(i);
  if (t === r)
    return [i, t];
  i -= (r - t) * 60 * 1e3;
  const c = n.offset(i);
  return r === c ? [i, r] : [e - Math.min(r, c) * 60 * 1e3, Math.max(r, c)];
}
function Zv(e, t) {
  e += t * 60 * 1e3;
  const n = new Date(e);
  return {
    year: n.getUTCFullYear(),
    month: n.getUTCMonth() + 1,
    day: n.getUTCDate(),
    hour: n.getUTCHours(),
    minute: n.getUTCMinutes(),
    second: n.getUTCSeconds(),
    millisecond: n.getUTCMilliseconds()
  };
}
function xg(e, t, n) {
  return hM(l_(e), t, n);
}
function Bk(e, t) {
  const n = e.o, i = e.c.year + Math.trunc(t.years), r = e.c.month + Math.trunc(t.months) + Math.trunc(t.quarters) * 3, c = {
    ...e.c,
    year: i,
    month: r,
    day: Math.min(e.c.day, hy(i, r)) + Math.trunc(t.days) + Math.trunc(t.weeks) * 7
  }, d = _i.fromObject({
    years: t.years - Math.trunc(t.years),
    quarters: t.quarters - Math.trunc(t.quarters),
    months: t.months - Math.trunc(t.months),
    weeks: t.weeks - Math.trunc(t.weeks),
    days: t.days - Math.trunc(t.days),
    hours: t.hours,
    minutes: t.minutes,
    seconds: t.seconds,
    milliseconds: t.milliseconds
  }).as("milliseconds"), a = l_(c);
  let [f, g] = hM(a, n, e.zone);
  return d !== 0 && (f += d, g = e.zone.offset(f)), { ts: f, o: g };
}
function Ap(e, t, n, i, r, c) {
  const { setZone: d, zone: a } = n;
  if (e && Object.keys(e).length !== 0 || t) {
    const f = t || a, g = Sn.fromObject(e, {
      ...n,
      zone: f,
      specificOffset: c
    });
    return d ? g : g.setZone(a);
  } else
    return Sn.invalid(
      new Ga("unparsable", `the input "${r}" can't be parsed as ${i}`)
    );
}
function qv(e, t, n = !0) {
  return e.isValid ? Vs.create(Di.create("en-US"), {
    allowZ: n,
    forceSimple: !0
  }).formatDateTimeFromString(e, t) : null;
}
function Xb(e, t) {
  const n = e.c.year > 9999 || e.c.year < 0;
  let i = "";
  return n && e.c.year >= 0 && (i += "+"), i += Br(e.c.year, n ? 6 : 4), t ? (i += "-", i += Br(e.c.month), i += "-", i += Br(e.c.day)) : (i += Br(e.c.month), i += Br(e.c.day)), i;
}
function Vk(e, t, n, i, r, c) {
  let d = Br(e.c.hour);
  return t ? (d += ":", d += Br(e.c.minute), (e.c.millisecond !== 0 || e.c.second !== 0 || !n) && (d += ":")) : d += Br(e.c.minute), (e.c.millisecond !== 0 || e.c.second !== 0 || !n) && (d += Br(e.c.second), (e.c.millisecond !== 0 || !i) && (d += ".", d += Br(e.c.millisecond, 3))), r && (e.isOffsetFixed && e.offset === 0 && !c ? d += "Z" : e.o < 0 ? (d += "-", d += Br(Math.trunc(-e.o / 60)), d += ":", d += Br(Math.trunc(-e.o % 60))) : (d += "+", d += Br(Math.trunc(e.o / 60)), d += ":", d += Br(Math.trunc(e.o % 60)))), c && (d += "[" + e.zone.ianaName + "]"), d;
}
const fM = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, ej = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, tj = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, mM = ["year", "month", "day", "hour", "minute", "second", "millisecond"], nj = [
  "weekYear",
  "weekNumber",
  "weekday",
  "hour",
  "minute",
  "second",
  "millisecond"
], ij = ["year", "ordinal", "hour", "minute", "second", "millisecond"];
function rj(e) {
  const t = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[e.toLowerCase()];
  if (!t) throw new vP(e);
  return t;
}
function Uk(e) {
  switch (e.toLowerCase()) {
    case "localweekday":
    case "localweekdays":
      return "localWeekday";
    case "localweeknumber":
    case "localweeknumbers":
      return "localWeekNumber";
    case "localweekyear":
    case "localweekyears":
      return "localWeekYear";
    default:
      return rj(e);
  }
}
function sj(e) {
  return Cg[e] || ($g === void 0 && ($g = wr.now()), Cg[e] = e.offset($g)), Cg[e];
}
function Hk(e, t) {
  const n = xu(t.zone, wr.defaultZone);
  if (!n.isValid)
    return Sn.invalid(Qf(n));
  const i = Di.fromObject(t);
  let r, c;
  if (zn(e.year))
    r = wr.now();
  else {
    for (const f of mM)
      zn(e[f]) && (e[f] = fM[f]);
    const d = BP(e) || VP(e);
    if (d)
      return Sn.invalid(d);
    const a = sj(n);
    [r, c] = xg(e, a, n);
  }
  return new Sn({ ts: r, zone: n, loc: i, o: c });
}
function Wk(e, t, n) {
  const i = zn(n.round) ? !0 : n.round, r = (d, a) => (d = gx(d, i || n.calendary ? 0 : 2, !0), t.loc.clone(n).relFormatter(n).format(d, a)), c = (d) => n.calendary ? t.hasSame(e, d) ? 0 : t.startOf(d).diff(e.startOf(d), d).get(d) : t.diff(e, d).get(d);
  if (n.unit)
    return r(c(n.unit), n.unit);
  for (const d of n.units) {
    const a = c(d);
    if (Math.abs(a) >= 1)
      return r(a, d);
  }
  return r(e > t ? -0 : 0, n.units[n.units.length - 1]);
}
function Zk(e) {
  let t = {}, n;
  return e.length > 0 && typeof e[e.length - 1] == "object" ? (t = e[e.length - 1], n = Array.from(e).slice(0, e.length - 1)) : n = Array.from(e), [t, n];
}
let $g, Cg = {};
class Sn {
  /**
   * @access private
   */
  constructor(t) {
    const n = t.zone || wr.defaultZone;
    let i = t.invalid || (Number.isNaN(t.ts) ? new Ga("invalid input") : null) || (n.isValid ? null : Qf(n));
    this.ts = zn(t.ts) ? wr.now() : t.ts;
    let r = null, c = null;
    if (!i)
      if (t.old && t.old.ts === this.ts && t.old.zone.equals(n))
        [r, c] = [t.old.c, t.old.o];
      else {
        const a = Pu(t.o) && !t.old ? t.o : n.offset(this.ts);
        r = Zv(this.ts, a), i = Number.isNaN(r.year) ? new Ga("invalid input") : null, r = i ? null : r, c = i ? null : a;
      }
    this._zone = n, this.loc = t.loc || Di.create(), this.invalid = i, this.weekData = null, this.localWeekData = null, this.c = r, this.o = c, this.isLuxonDateTime = !0;
  }
  // CONSTRUCT
  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new Sn({});
  }
  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [t, n] = Zk(arguments), [i, r, c, d, a, f, g] = n;
    return Hk({ year: i, month: r, day: c, hour: d, minute: a, second: f, millisecond: g }, t);
  }
  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [t, n] = Zk(arguments), [i, r, c, d, a, f, g] = n;
    return t.zone = ro.utcInstance, Hk({ year: i, month: r, day: c, hour: d, minute: a, second: f, millisecond: g }, t);
  }
  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(t, n = {}) {
    const i = LZ(t) ? t.valueOf() : NaN;
    if (Number.isNaN(i))
      return Sn.invalid("invalid input");
    const r = xu(n.zone, wr.defaultZone);
    return r.isValid ? new Sn({
      ts: i,
      zone: r,
      loc: Di.fromObject(n)
    }) : Sn.invalid(Qf(r));
  }
  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(t, n = {}) {
    if (Pu(t))
      return t < -864e13 || t > Qq ? Sn.invalid("Timestamp out of range") : new Sn({
        ts: t,
        zone: xu(n.zone, wr.defaultZone),
        loc: Di.fromObject(n)
      });
    throw new zs(
      `fromMillis requires a numerical input, but received a ${typeof t} with value ${t}`
    );
  }
  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(t, n = {}) {
    if (Pu(t))
      return new Sn({
        ts: t * 1e3,
        zone: xu(n.zone, wr.defaultZone),
        loc: Di.fromObject(n)
      });
    throw new zs("fromSeconds requires a numerical input");
  }
  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */
  static fromObject(t, n = {}) {
    t = t || {};
    const i = xu(n.zone, wr.defaultZone);
    if (!i.isValid)
      return Sn.invalid(Qf(i));
    const r = Di.fromObject(n), c = fy(t, Uk), { minDaysInFirstWeek: d, startOfWeek: a } = Ek(c, r), f = wr.now(), g = zn(n.specificOffset) ? i.offset(f) : n.specificOffset, x = !zn(c.ordinal), $ = !zn(c.year), A = !zn(c.month) || !zn(c.day), I = $ || A, O = c.weekYear || c.weekNumber;
    if ((I || x) && O)
      throw new Xp(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (A && x)
      throw new Xp("Can't mix ordinal dates with month/day");
    const B = O || c.weekday && !I;
    let H, N, K = Zv(f, g);
    B ? (H = nj, N = ej, K = py(K, d, a)) : x ? (H = ij, N = tj, K = qb(K)) : (H = mM, N = fM);
    let U = !1;
    for (const me of H) {
      const ve = c[me];
      zn(ve) ? U ? c[me] = N[me] : c[me] = K[me] : U = !0;
    }
    const q = B ? PZ(c, d, a) : x ? MZ(c) : BP(c), ee = q || VP(c);
    if (ee)
      return Sn.invalid(ee);
    const te = B ? Ik(c, d, a) : x ? Ak(c) : c, [ae, oe] = xg(te, g, i), de = new Sn({
      ts: ae,
      zone: i,
      o: oe,
      loc: r
    });
    return c.weekday && I && t.weekday !== de.weekday ? Sn.invalid(
      "mismatched weekday",
      `you can't specify both a weekday of ${c.weekday} and a date of ${de.toISO()}`
    ) : de.isValid ? de : Sn.invalid(de.invalid);
  }
  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(t, n = {}) {
    const [i, r] = $q(t);
    return Ap(i, r, n, "ISO 8601", t);
  }
  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(t, n = {}) {
    const [i, r] = Cq(t);
    return Ap(i, r, n, "RFC 2822", t);
  }
  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(t, n = {}) {
    const [i, r] = kq(t);
    return Ap(i, r, n, "HTTP", n);
  }
  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(t, n, i = {}) {
    if (zn(t) || zn(n))
      throw new zs("fromFormat requires an input string and a format");
    const { locale: r = null, numberingSystem: c = null } = i, d = Di.fromOpts({
      locale: r,
      numberingSystem: c,
      defaultToEN: !0
    }), [a, f, g, x] = Jq(d, t, n);
    return x ? Sn.invalid(x) : Ap(a, f, i, `format ${n}`, t, g);
  }
  /**
   * @deprecated use fromFormat instead
   */
  static fromString(t, n, i = {}) {
    return Sn.fromFormat(t, n, i);
  }
  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(t, n = {}) {
    const [i, r] = Mq(t);
    return Ap(i, r, n, "SQL", t);
  }
  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(t, n = null) {
    if (!t)
      throw new zs("need to specify a reason the DateTime is invalid");
    const i = t instanceof Ga ? t : new Ga(t, n);
    if (wr.throwOnInvalid)
      throw new rZ(i);
    return new Sn({ invalid: i });
  }
  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(t) {
    return t && t.isLuxonDateTime || !1;
  }
  /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */
  static parseFormatForOpts(t, n = {}) {
    const i = pM(t, Di.fromObject(n));
    return i ? i.map((r) => r ? r.val : null).join("") : null;
  }
  /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */
  static expandFormat(t, n = {}) {
    return cM(Vs.parseFormat(t), Di.fromObject(n)).map((r) => r.val).join("");
  }
  static resetCache() {
    $g = void 0, Cg = {};
  }
  // INFO
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(t) {
    return this[t];
  }
  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }
  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? Yb(this).weekYear : NaN;
  }
  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? Yb(this).weekNumber : NaN;
  }
  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? Yb(this).weekday : NaN;
  }
  /**
   * Returns true if this date is on a weekend according to the locale, false otherwise
   * @returns {boolean}
   */
  get isWeekend() {
    return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
  }
  /**
   * Get the day of the week according to the locale.
   * 1 is the first day of the week and 7 is the last day of the week.
   * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
   * @returns {number}
   */
  get localWeekday() {
    return this.isValid ? Kb(this).weekday : NaN;
  }
  /**
   * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
   * because the week can start on different days of the week (see localWeekday) and because a different number of days
   * is required for a week to count as the first week of a year.
   * @returns {number}
   */
  get localWeekNumber() {
    return this.isValid ? Kb(this).weekNumber : NaN;
  }
  /**
   * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
   * differently, see localWeekNumber.
   * @returns {number}
   */
  get localWeekYear() {
    return this.isValid ? Kb(this).weekYear : NaN;
  }
  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? qb(this.c).ordinal : NaN;
  }
  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? Hv.months("short", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? Hv.months("long", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? Hv.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? Hv.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "short",
      locale: this.locale
    }) : null;
  }
  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "long",
      locale: this.locale
    }) : null;
  }
  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    return this.isOffsetFixed ? !1 : this.offset > this.set({ month: 1, day: 1 }).offset || this.offset > this.set({ month: 5 }).offset;
  }
  /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */
  getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed)
      return [this];
    const t = 864e5, n = 6e4, i = l_(this.c), r = this.zone.offset(i - t), c = this.zone.offset(i + t), d = this.zone.offset(i - r * n), a = this.zone.offset(i - c * n);
    if (d === a)
      return [this];
    const f = i - d * n, g = i - a * n, x = Zv(f, d), $ = Zv(g, a);
    return x.hour === $.hour && x.minute === $.minute && x.second === $.second && x.millisecond === $.millisecond ? [md(this, { ts: f }), md(this, { ts: g })] : [this];
  }
  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return Zm(this.year);
  }
  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return hy(this.year, this.month);
  }
  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? oh(this.year) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? Sm(this.weekYear) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's local week year
   * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
   * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
   * @type {number}
   */
  get weeksInLocalWeekYear() {
    return this.isValid ? Sm(
      this.localWeekYear,
      this.loc.getMinDaysInFirstWeek(),
      this.loc.getStartOfWeek()
    ) : NaN;
  }
  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(t = {}) {
    const { locale: n, numberingSystem: i, calendar: r } = Vs.create(
      this.loc.clone(t),
      t
    ).resolvedOptions(this);
    return { locale: n, numberingSystem: i, outputCalendar: r };
  }
  // TRANSFORM
  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(t = 0, n = {}) {
    return this.setZone(ro.instance(t), n);
  }
  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(wr.defaultZone);
  }
  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(t, { keepLocalTime: n = !1, keepCalendarTime: i = !1 } = {}) {
    if (t = xu(t, wr.defaultZone), t.equals(this.zone))
      return this;
    if (t.isValid) {
      let r = this.ts;
      if (n || i) {
        const c = t.offset(this.ts), d = this.toObject();
        [r] = xg(d, c, t);
      }
      return md(this, { ts: r, zone: t });
    } else
      return Sn.invalid(Qf(t));
  }
  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale: t, numberingSystem: n, outputCalendar: i } = {}) {
    const r = this.loc.clone({ locale: t, numberingSystem: n, outputCalendar: i });
    return md(this, { loc: r });
  }
  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(t) {
    return this.reconfigure({ locale: t });
  }
  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(t) {
    if (!this.isValid) return this;
    const n = fy(t, Uk), { minDaysInFirstWeek: i, startOfWeek: r } = Ek(n, this.loc), c = !zn(n.weekYear) || !zn(n.weekNumber) || !zn(n.weekday), d = !zn(n.ordinal), a = !zn(n.year), f = !zn(n.month) || !zn(n.day), g = a || f, x = n.weekYear || n.weekNumber;
    if ((g || d) && x)
      throw new Xp(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (f && d)
      throw new Xp("Can't mix ordinal dates with month/day");
    let $;
    c ? $ = Ik(
      { ...py(this.c, i, r), ...n },
      i,
      r
    ) : zn(n.ordinal) ? ($ = { ...this.toObject(), ...n }, zn(n.day) && ($.day = Math.min(hy($.year, $.month), $.day))) : $ = Ak({ ...qb(this.c), ...n });
    const [A, I] = xg($, this.o, this.zone);
    return md(this, { ts: A, o: I });
  }
  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(t) {
    if (!this.isValid) return this;
    const n = _i.fromDurationLike(t);
    return md(this, Bk(this, n));
  }
  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(t) {
    if (!this.isValid) return this;
    const n = _i.fromDurationLike(t).negate();
    return md(this, Bk(this, n));
  }
  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(t, { useLocaleWeeks: n = !1 } = {}) {
    if (!this.isValid) return this;
    const i = {}, r = _i.normalizeUnit(t);
    switch (r) {
      case "years":
        i.month = 1;
      case "quarters":
      case "months":
        i.day = 1;
      case "weeks":
      case "days":
        i.hour = 0;
      case "hours":
        i.minute = 0;
      case "minutes":
        i.second = 0;
      case "seconds":
        i.millisecond = 0;
        break;
    }
    if (r === "weeks")
      if (n) {
        const c = this.loc.getStartOfWeek(), { weekday: d } = this;
        d < c && (i.weekNumber = this.weekNumber - 1), i.weekday = c;
      } else
        i.weekday = 1;
    if (r === "quarters") {
      const c = Math.ceil(this.month / 3);
      i.month = (c - 1) * 3 + 1;
    }
    return this.set(i);
  }
  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(t, n) {
    return this.isValid ? this.plus({ [t]: 1 }).startOf(t, n).minus(1) : this;
  }
  // OUTPUT
  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(t, n = {}) {
    return this.isValid ? Vs.create(this.loc.redefaultToEN(n)).formatDateTimeFromString(this, t) : Gb;
  }
  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(t = dy, n = {}) {
    return this.isValid ? Vs.create(this.loc.clone(n), t).formatDateTime(this) : Gb;
  }
  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(t = {}) {
    return this.isValid ? Vs.create(this.loc.clone(t), t).formatDateTimeParts(this) : [];
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */
  toISO({
    format: t = "extended",
    suppressSeconds: n = !1,
    suppressMilliseconds: i = !1,
    includeOffset: r = !0,
    extendedZone: c = !1
  } = {}) {
    if (!this.isValid)
      return null;
    const d = t === "extended";
    let a = Xb(this, d);
    return a += "T", a += Vk(this, d, n, i, r, c), a;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */
  toISODate({ format: t = "extended" } = {}) {
    return this.isValid ? Xb(this, t === "extended") : null;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return qv(this, "kkkk-'W'WW-c");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds: t = !1,
    suppressSeconds: n = !1,
    includeOffset: i = !0,
    includePrefix: r = !1,
    extendedZone: c = !1,
    format: d = "extended"
  } = {}) {
    return this.isValid ? (r ? "T" : "") + Vk(
      this,
      d === "extended",
      n,
      t,
      i,
      c
    ) : null;
  }
  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return qv(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", !1);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return qv(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */
  toSQLDate() {
    return this.isValid ? Xb(this, !0) : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset: t = !0, includeZone: n = !1, includeOffsetSpace: i = !0 } = {}) {
    let r = "HH:mm:ss.SSS";
    return (n || t) && (i && (r += " "), n ? r += "z" : t && (r += "ZZ")), qv(this, r, !0);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(t = {}) {
    return this.isValid ? `${this.toSQLDate()} ${this.toSQLTime(t)}` : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : Gb;
  }
  /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }` : `DateTime { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }
  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }
  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(t = {}) {
    if (!this.isValid) return {};
    const n = { ...this.c };
    return t.includeConfig && (n.outputCalendar = this.outputCalendar, n.numberingSystem = this.loc.numberingSystem, n.locale = this.loc.locale), n;
  }
  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  // COMPARE
  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(t, n = "milliseconds", i = {}) {
    if (!this.isValid || !t.isValid)
      return _i.invalid("created by diffing an invalid DateTime");
    const r = { locale: this.locale, numberingSystem: this.numberingSystem, ...i }, c = OZ(n).map(_i.normalizeUnit), d = t.valueOf() > this.valueOf(), a = d ? this : t, f = d ? t : this, g = zq(a, f, c, r);
    return d ? g.negate() : g;
  }
  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(t = "milliseconds", n = {}) {
    return this.diff(Sn.now(), t, n);
  }
  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */
  until(t) {
    return this.isValid ? _r.fromDateTimes(this, t) : this;
  }
  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(t, n, i) {
    if (!this.isValid) return !1;
    const r = t.valueOf(), c = this.setZone(t.zone, { keepLocalTime: !0 });
    return c.startOf(n, i) <= r && r <= c.endOf(n, i);
  }
  /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(t) {
    return this.isValid && t.isValid && this.valueOf() === t.valueOf() && this.zone.equals(t.zone) && this.loc.equals(t.loc);
  }
  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(t = {}) {
    if (!this.isValid) return null;
    const n = t.base || Sn.fromObject({}, { zone: this.zone }), i = t.padding ? this < n ? -t.padding : t.padding : 0;
    let r = ["years", "months", "days", "hours", "minutes", "seconds"], c = t.unit;
    return Array.isArray(t.unit) && (r = t.unit, c = void 0), Wk(n, this.plus(i), {
      ...t,
      numeric: "always",
      units: r,
      unit: c
    });
  }
  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(t = {}) {
    return this.isValid ? Wk(t.base || Sn.fromObject({}, { zone: this.zone }), this, {
      ...t,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: !0
    }) : null;
  }
  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...t) {
    if (!t.every(Sn.isDateTime))
      throw new zs("min requires all arguments be DateTimes");
    return Pk(t, (n) => n.valueOf(), Math.min);
  }
  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...t) {
    if (!t.every(Sn.isDateTime))
      throw new zs("max requires all arguments be DateTimes");
    return Pk(t, (n) => n.valueOf(), Math.max);
  }
  // MISC
  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(t, n, i = {}) {
    const { locale: r = null, numberingSystem: c = null } = i, d = Di.fromOpts({
      locale: r,
      numberingSystem: c,
      defaultToEN: !0
    });
    return dM(d, t, n);
  }
  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(t, n, i = {}) {
    return Sn.fromFormatExplain(t, n, i);
  }
  /**
   * Build a parser for `fmt` using the given locale. This parser can be passed
   * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
   * can be used to optimize cases where many dates need to be parsed in a
   * specific format.
   *
   * @param {String} fmt - the format the string is expected to be in (see
   * description)
   * @param {Object} options - options used to set locale and numberingSystem
   * for parser
   * @returns {TokenParser} - opaque object to be used
   */
  static buildFormatParser(t, n = {}) {
    const { locale: i = null, numberingSystem: r = null } = n, c = Di.fromOpts({
      locale: i,
      numberingSystem: r,
      defaultToEN: !0
    });
    return new uM(c, t);
  }
  /**
   * Create a DateTime from an input string and format parser.
   *
   * The format parser must have been created with the same locale as this call.
   *
   * @param {String} text - the string to parse
   * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
   * @param {Object} opts - options taken by fromFormat()
   * @returns {DateTime}
   */
  static fromFormatParser(t, n, i = {}) {
    if (zn(t) || zn(n))
      throw new zs(
        "fromFormatParser requires an input string and a format parser"
      );
    const { locale: r = null, numberingSystem: c = null } = i, d = Di.fromOpts({
      locale: r,
      numberingSystem: c,
      defaultToEN: !0
    });
    if (!d.equals(n.locale))
      throw new zs(
        `fromFormatParser called with a locale of ${d}, but the format parser was created for ${n.locale}`
      );
    const { result: a, zone: f, specificOffset: g, invalidReason: x } = n.explainFromTokens(t);
    return x ? Sn.invalid(x) : Ap(
      a,
      f,
      i,
      `format ${n.format}`,
      t,
      g
    );
  }
  // FORMAT PRESETS
  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return dy;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return gP;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return aZ;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return yP;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return _P;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return bP;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return wP;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return xP;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return $P;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return CP;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return kP;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return SP;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return TP;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return IP;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return AP;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return EP;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return PP;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return lZ;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return MP;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return DP;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return LP;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return OP;
  }
}
function Nf(e) {
  if (Sn.isDateTime(e))
    return e;
  if (e && e.valueOf && Pu(e.valueOf()))
    return Sn.fromJSDate(e);
  if (e && typeof e == "object")
    return Sn.fromObject(e);
  throw new zs(
    `Unknown datetime argument: ${e}, of type ${typeof e}`
  );
}
var oj = typeof window < "u", vM = [
  "__key",
  "__init",
  "__shim",
  "__original",
  "__index",
  "__prevKey"
];
function Jh() {
  return Math.random().toString(36).substring(2, 15);
}
function aj(e, t) {
  return [...e instanceof Set ? e : new Set(e)];
}
function Vn(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function vn(e, t, n = !0, i = ["__key"]) {
  if (e === t)
    return !0;
  if (typeof t == "object" && typeof e == "object") {
    if (e instanceof Map || e instanceof Set)
      return !1;
    if (e instanceof Date && t instanceof Date)
      return e.getTime() === t.getTime();
    if (e instanceof RegExp && t instanceof RegExp)
      return lj(e, t);
    if (e === null || t === null || Object.keys(e).length !== Object.keys(t).length)
      return !1;
    for (const r of i)
      if ((r in e || r in t) && e[r] !== t[r])
        return !1;
    for (const r in e)
      if (!(r in t) || e[r] !== t[r] && !n || n && !vn(e[r], t[r], n, i))
        return !1;
    return !0;
  }
  return !1;
}
function lj(e, t) {
  return e.source === t.source && e.flags.split("").sort().join("") === t.flags.split("").sort().join("");
}
function ma(e) {
  const t = typeof e;
  if (t === "number")
    return !1;
  if (e === void 0)
    return !0;
  if (t === "string")
    return e === "";
  if (t === "object") {
    if (e === null)
      return !0;
    for (const n in e)
      return !1;
    return !(e instanceof RegExp || e instanceof Date);
  }
  return !1;
}
function cj(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function uj(e) {
  const t = `^${cj(e)}$`, n = {
    MM: "(0[1-9]|1[012])",
    M: "([1-9]|1[012])",
    DD: "([012][0-9]|3[01])",
    D: "([012]?[0-9]|3[01])",
    YYYY: "\\d{4}",
    YY: "\\d{2}"
  }, i = Object.keys(n);
  return new RegExp(
    i.reduce((r, c) => r.replace(c, n[c]), t)
  );
}
function Od(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function lh(e) {
  return Od(e) || Array.isArray(e);
}
function Ou(e) {
  if (Od(e) === !1 || e.__FKNode__ || e.__POJO__ === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const n = t.prototype;
  return !(Od(n) === !1 || n.hasOwnProperty("isPrototypeOf") === !1);
}
var Fc = /* @__NO_SIDE_EFFECTS__ */ (e, t, n = !1, i = !1) => {
  if (t === null)
    return null;
  const r = {};
  if (typeof t == "string")
    return t;
  for (const c in e)
    if (Vn(t, c) && (t[c] !== void 0 || !i)) {
      if (n && Array.isArray(e[c]) && Array.isArray(t[c])) {
        r[c] = e[c].concat(t[c]);
        continue;
      }
      if (t[c] === void 0)
        continue;
      Ou(e[c]) && Ou(t[c]) ? r[c] = /* @__PURE__ */ Fc(
        e[c],
        t[c],
        n,
        i
      ) : r[c] = t[c];
    } else
      r[c] = e[c];
  for (const c in t)
    !Vn(r, c) && t[c] !== void 0 && (r[c] = t[c]);
  return r;
};
function dj(e) {
  if (e[0] !== '"' && e[0] !== "'" || e[0] !== e[e.length - 1])
    return !1;
  const t = e[0];
  for (let n = 1; n < e.length; n++)
    if (e[n] === t && (n === 1 || e[n - 1] !== "\\") && n !== e.length - 1)
      return !1;
  return !0;
}
function pj(e) {
  if (!e.length)
    return "";
  let t = "", n = "";
  for (let i = 0; i < e.length; i++) {
    const r = e.charAt(i);
    (r !== "\\" || n === "\\") && (t += r), n = r;
  }
  return t;
}
function Ep(...e) {
  return e.reduce((t, n) => {
    const { value: i, name: r, modelValue: c, config: d, plugins: a, ...f } = n;
    return Object.assign(t, f);
  }, {});
}
function hj(e) {
  const t = [];
  let n = "", i = 0, r = "", c = "";
  for (let d = 0; d < e.length; d++) {
    const a = e.charAt(d);
    a === r && c !== "\\" ? r = "" : (a === "'" || a === '"') && !r && c !== "\\" ? r = a : a === "(" && !r ? i++ : a === ")" && !r && i--, a === "," && !r && i === 0 ? (t.push(n), n = "") : (a !== " " || r) && (n += a), c = a;
  }
  return n && t.push(n), t;
}
function qk(e, t) {
  const n = {}, i = t.filter((c) => c instanceof RegExp), r = new Set(t);
  for (const c in e)
    !r.has(c) && !i.some((d) => d.test(c)) && (n[c] = e[c]);
  return n;
}
function jk(e, t) {
  const n = {}, i = t.filter((r) => r instanceof RegExp);
  return t.forEach((r) => {
    r instanceof RegExp || (n[r] = e[r]);
  }), Object.keys(e).forEach((r) => {
    i.some((c) => c.test(r)) && (n[r] = e[r]);
  }), n;
}
function ch(e) {
  return e.replace(
    /-([a-z0-9])/gi,
    (t, n) => n.toUpperCase()
  );
}
function gM(e) {
  return e.replace(
    /([a-z0-9])([A-Z])/g,
    (t, n, i) => n + "-" + i.toLowerCase()
  ).replace(" ", "-").toLowerCase();
}
function Pw(e, t = vM) {
  if (e !== null && typeof e == "object") {
    let n;
    if (Array.isArray(e) ? n = [...e] : Ou(e) && (n = { ...e }), n)
      return mj(e, n, t), n;
  }
  return e;
}
function Nu(e, t = vM) {
  if (e === null || e instanceof RegExp || e instanceof Date || e instanceof Map || e instanceof Set || typeof File == "function" && e instanceof File)
    return e;
  let n;
  Array.isArray(e) ? n = e.map((i) => typeof i == "object" ? Nu(i, t) : i) : n = Object.keys(e).reduce((i, r) => (i[r] = typeof e[r] == "object" ? Nu(e[r], t) : e[r], i), {});
  for (const i of t)
    i in e && Object.defineProperty(n, i, {
      enumerable: !1,
      value: e[i]
    });
  return n;
}
function ua(e) {
  return typeof e == "object" ? Nu(e) : e;
}
function fj(e, t) {
  if (!e || typeof e != "object")
    return null;
  const n = t.split(".");
  let i = e;
  for (const r in n) {
    const c = n[r];
    if (Vn(i, c) && (i = i[c]), +r === n.length - 1)
      return i;
    if (!i || typeof i != "object")
      return null;
  }
  return null;
}
function on(e) {
  return e !== void 0 && e !== "false" && e !== !1 ? !0 : void 0;
}
function Sh(e) {
  return Object.isFrozen(e) ? e : Object.defineProperty(e, "__init", {
    enumerable: !1,
    value: !0
  });
}
function wx(e) {
  return e.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]/g, " ").trim().replace(/\s+/g, "-");
}
function mj(e, t, n) {
  for (const i of n)
    i in e && Object.defineProperty(t, i, {
      enumerable: !1,
      value: e[i]
    });
  return t;
}
function Pr(e, t, n) {
  if (!oj)
    return;
  n || (n = document);
  const i = n.getElementById(e);
  if (i)
    return t(i);
  const r = new MutationObserver(() => {
    const c = n == null ? void 0 : n.getElementById(e);
    c && (r == null || r.disconnect(), t(c));
  });
  r.observe(n, { childList: !0, subtree: !0 });
}
function vj(e) {
  let t = !1;
  return (...n) => {
    if (!t)
      return t = !0, queueMicrotask(() => t = !1), e(...n);
  };
}
function gj(e) {
  if (!(e === "false" || e === !1))
    return !0;
}
function xx() {
  const e = [];
  let t = 0;
  const n = (r) => e.push(r), i = (r) => {
    const c = e[t];
    return typeof c == "function" ? c(r, (d) => (t++, i(d))) : (t = 0, r);
  };
  return n.dispatch = i, n.unshift = (r) => e.unshift(r), n.remove = (r) => {
    const c = e.indexOf(r);
    c > -1 && e.splice(c, 1);
  }, n;
}
function yM() {
  const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
  let n;
  const i = (r, c) => {
    if (n) {
      n.set(c.name, [r, c]);
      return;
    }
    e.has(c.name) && e.get(c.name).forEach((d) => {
      (c.origin === r || d.modifiers.includes("deep")) && d.listener(c);
    }), c.bubble && r.bubble(c);
  };
  return i.flush = () => {
    e.clear(), t.clear(), n == null || n.clear();
  }, i.on = (r, c, d = "push") => {
    const [a, ...f] = r.split("."), g = c.receipt || Jh(), x = {
      modifiers: f,
      event: a,
      listener: c,
      receipt: g
    };
    return e.has(a) ? e.get(a)[d](x) : e.set(a, [x]), t.has(g) ? t.get(g)[d](a) : t.set(g, [a]), g;
  }, i.off = (r) => {
    var c;
    t.has(r) && ((c = t.get(r)) == null || c.forEach((d) => {
      const a = e.get(d);
      Array.isArray(a) && e.set(
        d,
        a.filter((f) => f.receipt !== r)
      );
    }), t.delete(r));
  }, i.pause = (r) => {
    n || (n = /* @__PURE__ */ new Map()), r && r.walk((c) => c._e.pause());
  }, i.play = (r) => {
    if (!n)
      return;
    const c = n;
    n = void 0, c.forEach(([d, a]) => i(d, a)), r && r.walk((d) => d._e.play());
  }, i;
}
function yj(e, t, n, i, r = !0, c) {
  return t._e(e, {
    payload: i,
    name: n,
    bubble: r,
    origin: e,
    meta: c
  }), e;
}
function _j(e, t, n) {
  return Ym(e.parent) && e.parent._e(e.parent, n), e;
}
function bj(e, t, n, i, r) {
  return t._e.on(n, i, r);
}
function wj(e, t, n) {
  return t._e.off(n), e;
}
var $x = xx();
$x((e, t) => (e.message || (e.message = `E${e.code}`), t(e)));
var Cx = xx();
Cx((e, t) => {
  e.message || (e.message = `W${e.code}`);
  const n = t(e);
  return console && typeof console.warn == "function" && console.warn(n.message), n;
});
function Vu(e, t = {}) {
  Cx.dispatch({ code: e, data: t });
}
function _o(e, t = {}) {
  throw Error($x.dispatch({ code: e, data: t }).message);
}
function Vr(e, t) {
  return {
    blocking: !1,
    key: Jh(),
    meta: {},
    type: "state",
    visible: !0,
    ...e
  };
}
var Gk = {
  apply: Tj,
  set: $j,
  remove: _M,
  filter: kj,
  reduce: Sj,
  release: Ej,
  touch: Cj
};
function xj(e = !1) {
  const t = {};
  let n, i = e, r = [];
  const c = /* @__PURE__ */ new Map();
  let d;
  const a = new Proxy(t, {
    get(...f) {
      const [g, x] = f;
      return x === "buffer" ? i : x === "_b" ? r : x === "_m" ? c : x === "_r" ? d : Vn(Gk, x) ? Gk[x].bind(
        null,
        t,
        a,
        n
      ) : Reflect.get(...f);
    },
    set(f, g, x) {
      return g === "_n" ? (n = x, d === "__n" && bM(n, a), !0) : g === "_b" ? (r = x, !0) : g === "buffer" ? (i = x, !0) : g === "_r" ? (d = x, !0) : (_o(101, n), !1);
    }
  });
  return a;
}
function $j(e, t, n, i) {
  if (t.buffer)
    return t._b.push([[i]]), t;
  if (e[i.key] !== i) {
    if (typeof i.value == "string" && i.meta.localize !== !1) {
      const c = i.value;
      i.value = n.t(i), i.value !== c && (i.meta.locale = n.props.locale);
    }
    const r = `message-${Vn(e, i.key) ? "updated" : "added"}`;
    e[i.key] = Object.freeze(
      n.hook.message.dispatch(i)
    ), n.emit(r, i);
  }
  return t;
}
function Cj(e, t) {
  for (const n in e) {
    const i = { ...e[n] };
    t.set(i);
  }
}
function _M(e, t, n, i) {
  if (Vn(e, i)) {
    const r = e[i];
    delete e[i], n.emit("message-removed", r);
  }
  return t.buffer === !0 && (t._b = t._b.filter((r) => (r[0] = r[0].filter((c) => c.key !== i), r[1] || r[0].length))), t;
}
function kj(e, t, n, i, r) {
  for (const c in e) {
    const d = e[c];
    (!r || d.type === r) && !i(d) && _M(e, t, n, c);
  }
}
function Sj(e, t, n, i, r) {
  for (const c in e) {
    const d = e[c];
    r = i(r, d);
  }
  return r;
}
function Tj(e, t, n, i, r) {
  if (Array.isArray(i)) {
    if (t.buffer) {
      t._b.push([i, r]);
      return;
    }
    const c = new Set(
      i.map((d) => (t.set(d), d.key))
    );
    typeof r == "string" ? t.filter(
      (d) => d.type !== r || c.has(d.key)
    ) : typeof r == "function" && t.filter((d) => !r(d) || c.has(d.key));
  } else
    for (const c in i) {
      const d = n.at(c);
      d ? d.store.apply(i[c], r) : Aj(n, t, c, i[c], r);
    }
}
function Ij(e, ...t) {
  const n = `${e.name}-set`, i = (r) => /* @__PURE__ */ Vr({
    key: wx(r),
    type: "error",
    value: r,
    meta: { source: n, autoClear: !0 }
  });
  return t.filter((r) => !!r).map((r) => {
    if (typeof r == "string" && (r = [r]), Array.isArray(r))
      return r.map((c) => i(c));
    {
      const c = {};
      for (const d in r)
        Array.isArray(r[d]) ? c[d] = r[d].map(
          (a) => i(a)
        ) : c[d] = [i(r[d])];
      return c;
    }
  });
}
function Aj(e, t, n, i, r) {
  var d;
  const c = t._m;
  c.has(n) || c.set(n, []), t._r || (t._r = bM(e, t)), (d = c.get(n)) == null || d.push([i, r]);
}
function bM(e, t) {
  return e.on(
    "child.deep",
    ({ payload: n }) => {
      t._m.forEach((i, r) => {
        e.at(r) === n && (i.forEach(([c, d]) => {
          n.store.apply(c, d);
        }), t._m.delete(r));
      }), t._m.size === 0 && t._r && (e.off(t._r), t._r = void 0);
    }
  );
}
function Ej(e, t) {
  t.buffer = !1, t._b.forEach(([n, i]) => t.apply(n, i)), t._b = [];
}
function Pj() {
  const e = {};
  let t;
  return {
    count: (...n) => Mj(t, e, ...n),
    init(n) {
      t = n, n.on("message-added.deep", Yk(e, 1)), n.on("message-removed.deep", Yk(e, -1));
    },
    merge: (n) => Kk(t, e, n),
    settled(n) {
      return Vn(e, n) ? e[n].promise : Promise.resolve();
    },
    unmerge: (n) => Kk(t, e, n, !0),
    value(n) {
      return Vn(e, n) ? e[n].count : 0;
    }
  };
}
function Mj(e, t, n, i, r = 0) {
  if (i = Dj(i || n), !Vn(t, n)) {
    const c = {
      condition: i,
      count: 0,
      name: n,
      node: e,
      promise: Promise.resolve(),
      resolve: () => {
      }
      // eslint-disable-line @typescript-eslint/no-empty-function
    };
    t[n] = c, r = e.store.reduce(
      (d, a) => d + c.condition(a) * 1,
      r
    ), e.each((d) => {
      d.ledger.count(c.name, c.condition), r += d.ledger.value(c.name);
    });
  }
  return wM(t[n], r).promise;
}
function Dj(e) {
  return typeof e == "function" ? e : (t) => t.type === e;
}
function wM(e, t) {
  const n = e.count, i = e.count + t;
  return e.count = i, n === 0 && i !== 0 ? (e.node.emit(`unsettled:${e.name}`, e.count, !1), e.promise = new Promise((r) => e.resolve = r)) : n !== 0 && i === 0 && (e.node.emit(`settled:${e.name}`, e.count, !1), e.resolve()), e.node.emit(`count:${e.name}`, e.count, !1), e;
}
function Yk(e, t) {
  return (n) => {
    for (const i in e) {
      const r = e[i];
      r.condition(n.payload) && wM(r, t);
    }
  };
}
function Kk(e, t, n, i = !1) {
  const r = e;
  for (const c in t) {
    const d = t[c].condition;
    i || n.ledger.count(c, d);
    const a = n.ledger.value(c) * (i ? -1 : 1);
    if (e) {
      do
        e.ledger.count(c, d, a), e = e.parent;
      while (e);
      e = r;
    }
  }
}
var kx = /* @__PURE__ */ new Map(), kg = /* @__PURE__ */ new Map(), Sx = yM();
function Lj(e) {
  e.props.id && (kx.set(e.props.id, e), kg.set(e, e.props.id), Sx(e, {
    payload: e,
    name: e.props.id,
    bubble: !1,
    origin: e
  }));
}
function Oj(e) {
  if (kg.has(e)) {
    const t = kg.get(e);
    kg.delete(e), kx.delete(t), Sx(e, {
      payload: null,
      name: t,
      bubble: !1,
      origin: e
    });
  }
}
function Gm(e) {
  return kx.get(e);
}
function Nj(e, t) {
  return Sx.on(e, t);
}
function Mw(e, t, n) {
  let i = !0;
  return t in e.config._t ? i = !1 : e.emit(`config:${t}`, n, !1), t in e.props || (e.emit("prop", { prop: t, value: n }), e.emit(`prop:${t}`, n)), i;
}
function Fj(e = {}) {
  const t = /* @__PURE__ */ new Set(), n = {
    ...e,
    _add: (r) => t.add(r),
    _rm: (r) => t.delete(r)
  };
  return new Proxy(n, {
    set(r, c, d, a) {
      return typeof c == "string" && t.forEach((f) => Mw(f, c, d)), Reflect.set(r, c, d, a);
    }
  });
}
function xM(e, t) {
  const n = (t || document).getElementById(e);
  if (n instanceof HTMLFormElement) {
    const i = new Event("submit", { cancelable: !0, bubbles: !0 });
    n.dispatchEvent(i);
    return;
  }
  Vu(151, e);
}
function Rj(e) {
  const t = (n) => {
    for (const i in n.store) {
      const r = n.store[i];
      r.type === "error" || r.type === "ui" && i === "incomplete" ? n.store.remove(i) : r.type === "state" && n.store.set({ ...r, value: !1 });
    }
  };
  t(e), e.walk(t);
}
function $M(e, t) {
  const n = typeof e == "string" ? Gm(e) : e;
  if (n) {
    const i = (d) => {
      const a = ua(d.props.initial);
      return a !== void 0 ? a : d.type === "group" ? {} : d.type === "list" ? [] : void 0;
    };
    n._e.pause(n);
    const r = ua(t);
    return t && !ma(t) && (n.props.initial = lh(r) ? Sh(r) : r, n.props._init = n.props.initial), n.input(i(n), !1), n.walk((d) => {
      d.type === "list" && d.sync || d.input(i(d), !1);
    }), n.input(
      ma(r) && r ? r : i(n),
      !1
    ), n.type !== "input" && t && !ma(t) && lh(t) && n.walk((d) => {
      d.props.initial = lh(d.value) ? Sh(d.value) : d.value, d.props._init = d.props.initial;
    }), n._e.play(n), Rj(n), n.emit("reset", n), n;
  }
  Vu(152, e);
}
var zj = {
  delimiter: ".",
  delay: 0,
  locale: "en",
  rootClasses: (e) => ({ [`formkit-${gM(e)}`]: !0 })
}, CM = Symbol("index"), Dw = Symbol("removed"), Lw = Symbol("moved"), kM = Symbol("inserted");
function Bj(e) {
  return e.type === "list" && Array.isArray(e._value);
}
function Ym(e) {
  return e && typeof e == "object" && e.__FKNode__ === !0;
}
var Sg = (e, t, n) => {
  _o(102, [e, n]);
}, Vj = {
  _c: yi(l7, Sg, !1),
  add: yi(e7),
  addProps: yi(Qj),
  address: yi(u7, Sg, !1),
  at: yi(d7),
  bubble: yi(_j),
  clearErrors: yi(b7),
  calm: yi(Kj),
  config: yi(!1),
  define: yi(Jj),
  disturb: yi(Yj),
  destroy: yi(Xj),
  extend: yi(x7),
  hydrate: yi(jj),
  index: yi(a7, o7, !1),
  input: yi(IM),
  each: yi(i7),
  emit: yi(yj),
  find: yi(h7),
  on: yi(bj),
  off: yi(wj),
  parent: yi(!1, t7),
  plugins: yi(!1),
  remove: yi(n7),
  root: yi(m7, Sg, !1),
  reset: yi(y7),
  resetConfig: yi(s7),
  setErrors: yi(_7),
  submit: yi(g7),
  t: yi(v7),
  use: yi(Tx),
  name: yi(c7, !1, !1),
  walk: yi(r7)
};
function Uj() {
  return new Map(Object.entries(Vj));
}
function yi(e, t, n = !0) {
  return {
    get: e ? (i, r) => n ? (...c) => e(i, r, ...c) : e(i, r) : !1,
    set: t !== void 0 ? t : Sg.bind(null)
  };
}
function Hj() {
  const e = /* @__PURE__ */ new Map();
  return new Proxy(e, {
    get(t, n) {
      return e.has(n) || e.set(n, xx()), e.get(n);
    }
  });
}
var SM = 0, Wj = 0;
function Zj(e) {
  var t, n;
  return ((t = e.parent) == null ? void 0 : t.type) === "list" ? CM : e.name || `${((n = e.props) == null ? void 0 : n.type) || "input"}_${++SM}`;
}
function TM(e) {
  return e.type === "group" ? Sh(
    e.value && typeof e.value == "object" && !Array.isArray(e.value) ? e.value : {}
  ) : e.type === "list" ? Sh(Array.isArray(e.value) ? e.value : []) : e.value;
}
function IM(e, t, n, i = !0) {
  return t._value = qj(e, e.hook.input.dispatch(n)), e.emit("input", t._value), e.isCreated && e.type === "input" && vn(t._value, t.value) && !e.props.mergeStrategy ? (e.emit("commitRaw", t.value), t.settled) : (t.isSettled && e.disturb(), i ? (t._tmo && clearTimeout(t._tmo), t._tmo = setTimeout(
    my,
    e.props.delay,
    e,
    t
  )) : my(e, t), t.settled);
}
function qj(e, t) {
  switch (e.type) {
    case "input":
      break;
    case "group":
      (!t || typeof t != "object") && _o(107, [e, t]);
      break;
    case "list":
      Array.isArray(t) || _o(108, [e, t]);
      break;
  }
  return t;
}
function my(e, t, n = !0, i = !0) {
  t._value = t.value = e.hook.commit.dispatch(t._value), e.type !== "input" && i && e.hydrate(), e.emit("commitRaw", t.value), e.emit("commit", t.value), n && e.calm();
}
function AM(e, { name: t, value: n, from: i }) {
  if (!Object.isFrozen(e._value)) {
    if (Bj(e)) {
      const r = n === Dw ? [] : n === Lw && typeof i == "number" ? e._value.splice(i, 1) : [n];
      e._value.splice(
        t,
        n === Lw || i === kM ? 0 : 1,
        ...r
      );
      return;
    }
    n !== Dw ? e._value[t] = n : delete e._value[t];
  }
}
function jj(e, t) {
  const n = t._value;
  return e.type === "list" && e.sync && Gj(e, t), t.children.forEach((i) => {
    if (typeof n == "object")
      if (i.name in n) {
        const r = i.type !== "input" || n[i.name] && typeof n[i.name] == "object" ? Sh(n[i.name]) : n[i.name];
        if (!i.isSettled || (!lh(r) || i.props.mergeStrategy) && vn(r, i._value))
          return;
        i.input(r, !1);
      } else
        (e.type !== "list" || typeof i.name == "number") && AM(t, { name: i.name, value: i.value }), n.__init || (i.type === "group" ? i.input({}, !1) : i.type === "list" ? i.input([], !1) : i.input(void 0, !1));
  }), e;
}
function Gj(e, t) {
  const n = e._value;
  if (!Array.isArray(n))
    return;
  const i = [], r = new Set(t.children), c = /* @__PURE__ */ new Map();
  n.forEach((a, f) => {
    if (t.children[f] && t.children[f]._value === a)
      i.push(t.children[f]), r.delete(t.children[f]);
    else {
      i.push(null);
      const g = c.get(a) || [];
      g.push(f), c.set(a, g);
    }
  }), r.size && c.size && r.forEach((a) => {
    if (c.has(a._value)) {
      const f = c.get(a._value), g = f.shift();
      i[g] = a, r.delete(a), f.length || c.delete(a._value);
    }
  });
  const d = [];
  for (c.forEach((a) => {
    d.push(...a);
  }); r.size && d.length; ) {
    const a = r.values().next().value, f = d.shift();
    if (f === void 0)
      break;
    i[f] = a, r.delete(a);
  }
  d.forEach((a, f) => {
    i[a] = S7({ value: f });
  }), r.size && r.forEach((a) => {
    if (!("__FKP" in a)) {
      const f = a._c.parent;
      if (!f || T7(f))
        return;
      f.ledger.unmerge(a), a._c.parent = null, a.destroy();
    }
  }), t.children = i;
}
function Yj(e, t) {
  var n;
  return t._d <= 0 && (t.isSettled = !1, e.emit("settled", !1, !1), t.settled = new Promise((i) => {
    t._resolve = i;
  }), e.parent && ((n = e.parent) == null || n.disturb())), t._d++, e;
}
function Kj(e, t, n) {
  var i;
  if (n !== void 0 && e.type !== "input") {
    AM(t, n);
    const r = !!(e.config.mergeStrategy && e.config.mergeStrategy[n.name]);
    return my(e, t, !0, r);
  }
  t._d > 0 && t._d--, t._d === 0 && (t.isSettled = !0, e.emit("settled", !0, !1), e.parent && ((i = e.parent) == null || i.calm({ name: e.name, value: t.value })), t._resolve && t._resolve(t.value));
}
function Xj(e, t) {
  e.emit("destroying", e), e.store.filter(() => !1), e.parent && e.parent.remove(e), Oj(e), e.emit("destroyed", e), t._e.flush(), t._value = t.value = void 0;
  for (const n in t.context)
    delete t.context[n];
  t.plugins.clear(), t.context = null;
}
function Jj(e, t, n) {
  t.type = n.type;
  const i = Nu(n);
  e.props.__propDefs = EM(
    e.props.__propDefs ?? [],
    (i == null ? void 0 : i.props) || []
  ), i.props = e.props.__propDefs, t.props.definition = i, t.value = t._value = TM({
    type: e.type,
    value: t.value
  }), n.forceTypeProp && (e.props.type && (e.props.originalType = e.props.type), t.props.type = n.forceTypeProp), n.family && (t.props.family = n.family), n.features && n.features.forEach((r) => r(e)), n.props && e.addProps(n.props), e.emit("defined", n);
}
function Qj(e, t, n) {
  const i = Array.isArray(n) ? n : Object.keys(n), r = Array.isArray(n) ? {} : i.reduce((d, a) => ("default" in n[a] && (d[a] = n[a].default), d), {});
  if (e.props.attrs) {
    const d = { ...e.props.attrs };
    e.props._emit = !1;
    for (const f in d) {
      const g = ch(f);
      i.includes(g) && (e.props[g] = d[f], delete d[f]);
    }
    Array.isArray(n) || i.forEach((f) => {
      "default" in n[f] && e.props[f] === void 0 && (e.props[f] = r[f]);
    });
    const a = ua(t._value);
    e.props.initial = e.type !== "input" ? Sh(a) : a, e.props._emit = !0, e.props.attrs = d;
  }
  const c = EM(e.props.__propDefs ?? [], n);
  return e.props.definition && (e.props.definition.props = c), e.props.__propDefs = c, e.emit("added-props", n), e;
}
function Ow(e) {
  return Array.isArray(e) ? e.reduce((t, n) => (t[n] = {}, t), {}) : e;
}
function EM(e, t) {
  return Array.isArray(e) && Array.isArray(t) ? e.concat(t) : Fc(Ow(e), Ow(t));
}
function e7(e, t, n, i) {
  if (e.type === "input" && _o(100, e), n.parent && n.parent !== e && n.parent.remove(n), !t.children.includes(n)) {
    if (i !== void 0 && e.type === "list") {
      const r = t.children[i];
      r && "__FKP" in r ? (n._c.uid = r.uid, t.children.splice(i, 1, n)) : t.children.splice(i, 0, n), Array.isArray(e.value) && e.value.length < t.children.length && e.disturb().calm({
        name: i,
        value: n.value,
        from: kM
      });
    } else
      t.children.push(n);
    n.isSettled || e.disturb();
  }
  if (n.parent !== e) {
    if (n.parent = e, n.parent !== e)
      return e.remove(n), n.parent.add(n), e;
  } else
    n.use(e.plugins);
  return my(e, t, !1), e.ledger.merge(n), e.emit("child", n), e;
}
function t7(e, t, n, i) {
  return Ym(i) ? (e.parent && e.parent !== i && e.parent.remove(e), t.parent = i, e.resetConfig(), i.children.includes(e) ? e.use(i.plugins) : i.add(e), !0) : i === null ? (t.parent = null, !0) : !1;
}
function n7(e, t, n) {
  const i = t.children.indexOf(n);
  if (i !== -1) {
    n.isSettled && e.disturb(), t.children.splice(i, 1);
    let r = on(n.props.preserve), c = n.parent;
    for (; r === void 0 && c; )
      r = on(c.props.preserve), c = c.parent;
    r ? e.calm() : e.calm({
      name: e.type === "list" ? i : n.name,
      value: Dw
    }), n.parent = null, n.config._rmn = n;
  }
  return e.ledger.unmerge(n), e.emit("childRemoved", n), e;
}
function i7(e, t, n) {
  t.children.forEach((i) => !("__FKP" in i) && n(i));
}
function r7(e, t, n, i = !1, r = !1) {
  t.children.some((c) => {
    if ("__FKP" in c)
      return !1;
    const d = n(c);
    return i && d === !1 ? !0 : r && d === !1 ? !1 : c.walk(n, i, r);
  });
}
function s7(e, t) {
  const n = e.parent || void 0;
  t.config = PM(e.config._t, n), e.walk((i) => i.resetConfig());
}
function Tx(e, t, n, i = !0, r = !0) {
  return Array.isArray(n) || n instanceof Set ? (n.forEach((c) => Tx(e, t, c)), e) : (t.plugins.has(n) || (r && typeof n.library == "function" && n.library(e), i && n(e) !== !1 && (t.plugins.add(n), e.children.forEach((c) => c.use(n)))), e);
}
function o7(e, t, n, i) {
  if (Ym(e.parent)) {
    const r = e.parent.children, c = i >= r.length ? r.length - 1 : i < 0 ? 0 : i, d = r.indexOf(e);
    return d === -1 ? !1 : (r.splice(d, 1), r.splice(c, 0, e), e.parent.children = r, e.parent.type === "list" && e.parent.disturb().calm({ name: c, value: Lw, from: d }), !0);
  }
  return !1;
}
function a7(e) {
  if (e.parent) {
    const t = [...e.parent.children].indexOf(e);
    return t === -1 ? e.parent.children.length : t;
  }
  return -1;
}
function l7(e, t) {
  return t;
}
function c7(e, t) {
  var n;
  return ((n = e.parent) == null ? void 0 : n.type) === "list" ? e.index : t.name !== CM ? t.name : e.index;
}
function u7(e, t) {
  return t.parent ? t.parent.address.concat([e.name]) : [e.name];
}
function d7(e, t, n) {
  const i = typeof n == "string" ? n.split(e.config.delimiter) : n;
  if (!i.length)
    return;
  const r = i[0];
  let c = e.parent;
  for (c || (String(i[0]) === String(e.name) && i.shift(), c = e), r === "$parent" && i.shift(); c && i.length; ) {
    const d = i.shift();
    switch (d) {
      case "$root":
        c = e.root;
        break;
      case "$parent":
        c = c.parent;
        break;
      case "$self":
        c = e;
        break;
      default:
        c = c.children.find(
          (a) => !("__FKP" in a) && String(a.name) === String(d)
        ) || p7(c, d);
    }
  }
  return c || void 0;
}
function p7(e, t) {
  const n = String(t).match(/^(find)\((.*)\)$/);
  if (n) {
    const [, i, r] = n, c = r.split(",").map((d) => d.trim());
    switch (i) {
      case "find":
        return e.find(c[0], c[1]);
      default:
        return;
    }
  }
}
function h7(e, t, n, i) {
  return f7(e, n, i);
}
function f7(e, t, n = "name") {
  const i = typeof n == "string" ? (c) => c[n] == t : n, r = [e];
  for (; r.length; ) {
    const c = r.shift();
    if (!("__FKP" in c)) {
      if (i(c, t))
        return c;
      r.push(...c.children);
    }
  }
}
function m7(e) {
  let t = e;
  for (; t.parent; )
    t = t.parent;
  return t;
}
function PM(e = {}, t) {
  let n;
  return new Proxy(e, {
    get(...i) {
      const r = i[1];
      if (r === "_t")
        return e;
      const c = Reflect.get(...i);
      if (c !== void 0)
        return c;
      if (t) {
        const d = t.config[r];
        if (d !== void 0)
          return d;
      }
      if (e.rootConfig && typeof r == "string") {
        const d = e.rootConfig[r];
        if (d !== void 0)
          return d;
      }
      return r === "delay" && (n == null ? void 0 : n.type) === "input" ? 20 : zj[r];
    },
    set(...i) {
      const r = i[1], c = i[2];
      if (r === "_n")
        return n = c, e.rootConfig && e.rootConfig._add(n), !0;
      if (r === "_rmn")
        return e.rootConfig && e.rootConfig._rm(n), n = void 0, !0;
      if (!vn(e[r], c, !1)) {
        const d = Reflect.set(...i);
        return n && (n.emit(`config:${r}`, c, !1), Mw(n, r, c), n.walk((a) => Mw(a, r, c), !1, !0)), d;
      }
      return !0;
    }
  });
}
function v7(e, t, n, i = "ui") {
  const r = typeof n == "string" ? { key: n, value: n, type: i } : n, c = e.hook.text.dispatch(r);
  return e.emit("text", c, !1), c.value;
}
function g7(e) {
  const t = e.name;
  do {
    if (e.props.isForm === !0)
      break;
    e.parent || _o(106, t), e = e.parent;
  } while (e);
  e.props.id && xM(e.props.id, e.props.__root);
}
function y7(e, t, n) {
  return $M(e, n);
}
function _7(e, t, n, i) {
  const r = `${e.name}-set`, c = e.hook.setErrors.dispatch({ localErrors: n, childErrors: i });
  return Ij(e, c.localErrors, c.childErrors).forEach(
    (d) => {
      e.store.apply(d, (a) => a.meta.source === r);
    }
  ), e;
}
function b7(e, t, n = !0, i) {
  return e.store.filter((r) => !(i === void 0 || r.meta.source === i), "error"), n && (i = i || `${e.name}-set`, e.walk((r) => {
    r.store.filter((c) => !(c.type === "error" && c.meta && c.meta.source === i));
  })), e;
}
function w7(e) {
  const t = {
    initial: typeof e == "object" ? ua(e) : e
  };
  let n, i = !0, r = {};
  return new Proxy(t, {
    get(...c) {
      var x, $, A, I;
      const [d, a] = c;
      let f;
      Vn(t, a) ? (f = Reflect.get(...c), (x = r[a]) != null && x.boolean && (f = gj(f))) : n && typeof a == "string" && n.config[a] !== void 0 ? (f = n.config[a], a === "mergeStrategy" && (n == null ? void 0 : n.type) === "input" && Od(f) && n.name in f && (f = f[n.name])) : f = ($ = r[a]) == null ? void 0 : $.default;
      const g = (A = r[a]) == null ? void 0 : A.getter;
      return (I = r[a]) != null && I.boolean && (f = !!f), g ? g(f, n) : f;
    },
    set(c, d, a, f) {
      var A;
      if (d === "_n")
        return n = a, !0;
      if (d === "_emit")
        return i = a, !0;
      let { prop: g, value: x } = n.hook.prop.dispatch({
        prop: d,
        value: a
      });
      const $ = (A = r[g]) == null ? void 0 : A.setter;
      if (x = $ ? $(x, n) : x, !vn(t[g], x, !1) || typeof x == "object") {
        const I = Reflect.set(c, g, x, f);
        return g === "__propDefs" && (r = Ow(x)), i && (n.emit("prop", { prop: g, value: x }), typeof g == "string" && n.emit(`prop:${g}`, x)), I;
      }
      return !0;
    }
  });
}
function x7(e, t, n, i) {
  return t.traps.set(n, i), e;
}
function $7(e, t) {
  if (e.props.definition)
    return e.define(e.props.definition);
  for (const n of t) {
    if (e.props.definition)
      return;
    typeof n.library == "function" && n.library(e);
  }
}
function C7(e) {
  const t = TM(e), n = PM(e.config || {}, e.parent);
  return {
    _d: 0,
    _e: yM(),
    uid: Symbol(),
    _resolve: !1,
    _tmo: !1,
    _value: t,
    children: aj(e.children || []),
    config: n,
    hook: Hj(),
    isCreated: !1,
    isSettled: !0,
    ledger: Pj(),
    name: Zj(e),
    parent: e.parent || null,
    plugins: /* @__PURE__ */ new Set(),
    props: w7(t),
    settled: Promise.resolve(t),
    store: xj(!0),
    sync: e.sync || !1,
    traps: Uj(),
    type: e.type || "input",
    value: t
  };
}
function k7(e, t) {
  var i, r;
  const n = (i = t.props) == null ? void 0 : i.id;
  if (n || (r = t.props) == null || delete r.id, e.ledger.init(e.store._n = e.props._n = e.config._n = e), e.props._emit = !1, Object.assign(
    e.props,
    n ? {} : { id: `input_${Wj++}` },
    t.props ?? {}
  ), e.props._emit = !0, $7(
    e,
    /* @__PURE__ */ new Set([
      ...t.plugins || [],
      ...e.parent ? e.parent.plugins : []
    ])
  ), t.plugins)
    for (const c of t.plugins)
      Tx(e, e._c, c, !0, !1);
  return e.each((c) => e.add(c)), e.parent && e.parent.add(e, t.index), e.type === "input" && e.children.length && _o(100, e), IM(e, e._c, e._value, !1), e.store.release(), n && Lj(e), e.emit("created", e), e.isCreated = !0, e;
}
function S7(e) {
  return {
    __FKP: !0,
    uid: Symbol(),
    name: (e == null ? void 0 : e.name) ?? `p_${SM++}`,
    value: (e == null ? void 0 : e.value) ?? null,
    _value: (e == null ? void 0 : e.value) ?? null,
    type: (e == null ? void 0 : e.type) ?? "input",
    props: {},
    use: () => {
    },
    input(t) {
      return this._value = t, this.value = t, Promise.resolve();
    },
    isSettled: !0
  };
}
function T7(e) {
  return "__FKP" in e;
}
function I7(e) {
  const t = e || {}, n = C7(t), i = new Proxy(n, {
    get(...r) {
      const [, c] = r;
      if (c === "__FKNode__")
        return !0;
      const d = n.traps.get(c);
      return d && d.get ? d.get(i, n) : Reflect.get(...r);
    },
    set(...r) {
      const [, c, d] = r, a = n.traps.get(c);
      return a && a.set ? a.set(i, n, c, d) : Reflect.set(...r);
    }
  });
  return k7(i, t);
}
function Nd(e) {
  return typeof e != "string" && Vn(e, "$el");
}
function Tm(e) {
  return typeof e != "string" && Vn(e, "$cmp");
}
function Hp(e) {
  return !e || typeof e == "string" ? !1 : Vn(e, "if") && Vn(e, "then");
}
function A7(e) {
  return typeof e != "string" && "$formkit" in e;
}
function E7(e) {
  if (typeof e == "string")
    return {
      $el: "text",
      children: e
    };
  if (A7(e)) {
    const {
      $formkit: t,
      for: n,
      if: i,
      children: r,
      bind: c,
      ...d
    } = e;
    return Object.assign(
      {
        $cmp: "FormKit",
        props: { ...d, type: t }
      },
      i ? { if: i } : {},
      n ? { for: n } : {},
      r ? { children: r } : {},
      c ? { bind: c } : {}
    );
  }
  return e;
}
function Ha(e) {
  let t;
  const n = /* @__PURE__ */ new Set(), i = function(H, N) {
    return typeof H == "function" ? H(N) : H;
  }, r = [
    {
      "&&": (B, H, N) => i(B, N) && i(H, N),
      "||": (B, H, N) => i(B, N) || i(H, N)
    },
    {
      "===": (B, H, N) => i(B, N) === i(H, N),
      "!==": (B, H, N) => i(B, N) !== i(H, N),
      "==": (B, H, N) => i(B, N) == i(H, N),
      "!=": (B, H, N) => i(B, N) != i(H, N),
      ">=": (B, H, N) => i(B, N) >= i(H, N),
      "<=": (B, H, N) => i(B, N) <= i(H, N),
      ">": (B, H, N) => i(B, N) > i(H, N),
      "<": (B, H, N) => i(B, N) < i(H, N)
    },
    {
      "+": (B, H, N) => i(B, N) + i(H, N),
      "-": (B, H, N) => i(B, N) - i(H, N)
    },
    {
      "*": (B, H, N) => i(B, N) * i(H, N),
      "/": (B, H, N) => i(B, N) / i(H, N),
      "%": (B, H, N) => i(B, N) % i(H, N)
    }
  ], c = r.reduce((B, H) => B.concat(Object.keys(H)), []), d = new Set(c.map((B) => B.charAt(0)));
  function a(B, H, N, K) {
    const U = B.filter((q) => q.startsWith(H));
    return U.length ? U.find((q) => K.length >= N + q.length && K.substring(N, N + q.length) === q ? q : !1) : !1;
  }
  function f(B, H, N = 1) {
    let K = N ? H.substring(B + 1).trim() : H.substring(0, B).trim();
    if (!K.length)
      return -1;
    if (!N) {
      const q = K.split("").reverse(), ee = q.findIndex((te) => d.has(te));
      K = q.slice(ee).join("");
    }
    const U = K[0];
    return r.findIndex((q) => {
      const ee = Object.keys(q);
      return !!a(ee, U, 0, K);
    });
  }
  function g(B, H) {
    let N = "";
    const K = H.length;
    let U = 0;
    for (let q = B; q < K; q++) {
      const ee = H.charAt(q);
      if (ee === "(")
        U++;
      else if (ee === ")")
        U--;
      else if (U === 0 && ee === " ")
        continue;
      if (U === 0 && a(c, ee, q, H))
        return [N, q - 1];
      N += ee;
    }
    return [N, H.length - 1];
  }
  function x(B, H = 0) {
    const N = r[H], K = B.length, U = Object.keys(N);
    let q = 0, ee = !1, te = null, ae = "", oe = null, de, me = "", ve = "", re = "", le = "", pe = 0;
    const Ne = (We, Ge) => {
      We ? re += Ge : ae += Ge;
    };
    for (let We = 0; We < K; We++)
      if (me = ve, ve = B.charAt(We), (ve === "'" || ve === '"') && me !== "\\" && (q === 0 && !ee || q && !le)) {
        q ? le = ve : ee = ve, Ne(q, ve);
        continue;
      } else if (ee && (ve !== ee || me === "\\") || le && (ve !== le || me === "\\")) {
        Ne(q, ve);
        continue;
      } else if (ee === ve) {
        ee = !1, Ne(q, ve);
        continue;
      } else if (le === ve) {
        le = !1, Ne(q, ve);
        continue;
      } else {
        if (ve === " ")
          continue;
        if (ve === "(")
          q === 0 ? pe = We : re += ve, q++;
        else if (ve === ")")
          if (q--, q === 0) {
            const Ge = typeof ae == "string" && ae.startsWith("$") ? ae : void 0, et = Ge && B.charAt(We + 1) === ".";
            let ft = "";
            et && ([ft, We] = g(We + 2, B));
            const De = te ? H : f(pe, B, 0), Ke = f(We, B);
            De === -1 && Ke === -1 ? (ae = $(re, -1, Ge, ft), typeof ae == "string" && (ae = re)) : te && (De >= Ke || Ke === -1) && H === De ? (oe = te.bind(null, $(re, -1, Ge, ft)), te = null, ae = "") : Ke > De && H === Ke ? ae = $(re, -1, Ge, ft) : ae += `(${re})${et ? `.${ft}` : ""}`, re = "";
          } else
            re += ve;
        else if (q === 0 && (de = a(U, ve, We, B))) {
          We === 0 && _o(103, [de, B]), We += de.length - 1, We === B.length - 1 && _o(104, [de, B]), te ? ae && (oe = te.bind(null, $(ae, H)), te = N[de].bind(null, oe), ae = "") : oe ? (te = N[de].bind(null, $(oe, H)), oe = null) : (te = N[de].bind(null, $(ae, H)), ae = "");
          continue;
        } else
          Ne(q, ve);
      }
    return ae && te && (te = te.bind(null, $(ae, H))), te = !te && oe ? oe : te, !te && ae && (te = (We, Ge) => typeof We == "function" ? We(Ge) : We, te = te.bind(null, $(ae, H))), !te && !ae && _o(105, B), te;
  }
  function $(B, H, N, K) {
    if (N) {
      const U = $(N, r.length);
      let q, ee = K ? Ha(`$${K}`) : !1;
      if (typeof U == "function") {
        const te = hj(String(B)).map(
          (ae) => $(ae, -1)
        );
        return (ae) => {
          const oe = U(ae);
          return typeof oe != "function" ? (Vu(150, N), oe) : (q = oe(
            ...te.map(
              (de) => typeof de == "function" ? de(ae) : de
            )
          ), ee && (ee = ee.provide((de) => {
            const me = t(de);
            return de.reduce(
              (re, le) => {
                if (le === K || (K == null ? void 0 : K.startsWith(`${le}(`))) {
                  const Ne = fj(q, le);
                  re[le] = () => Ne;
                } else
                  re[le] = me[le];
                return re;
              },
              {}
            );
          })), ee ? ee() : q);
        };
      }
    } else if (typeof B == "string") {
      if (B === "true")
        return !0;
      if (B === "false")
        return !1;
      if (B === "undefined")
        return;
      if (dj(B))
        return pj(B.substring(1, B.length - 1));
      if (!isNaN(+B))
        return Number(B);
      if (H < r.length - 1)
        return x(B, H + 1);
      if (B.startsWith("$")) {
        const U = B.substring(1);
        return n.add(U), function(ee) {
          return U in ee ? ee[U]() : void 0;
        };
      }
      return B;
    }
    return B;
  }
  const A = x(
    e.startsWith("$:") ? e.substring(2) : e
  ), I = Array.from(n);
  function O(B) {
    return t = B, Object.assign(
      // @ts-ignore - @rollup/plugin-typescript doesn't like this
      A.bind(null, B(I)),
      { provide: O }
    );
  }
  return Object.assign(A, {
    provide: O
  });
}
function Tg(e, t, n) {
  return n ? typeof n == "string" ? n.split(" ").reduce(
    (r, c) => Object.assign(r, { [c]: !0 }),
    {}
  ) : typeof n == "function" ? Tg(
    e,
    t,
    n(t, e)
  ) : n : {};
}
function P7(e, t, ...n) {
  const i = n.reduce((r, c) => {
    if (!c)
      return Jb(r);
    const { $reset: d, ...a } = c;
    return Jb(d ? a : Object.assign(r, a));
  }, {});
  return Object.keys(
    e.hook.classes.dispatch({ property: t, classes: i }).classes
  ).filter((r) => i[r]).join(" ") || null;
}
function Jb(e) {
  const t = "$remove:";
  let n = !1;
  const i = Object.keys(e).filter((r) => (e[r] && r.startsWith(t) && (n = !0), e[r]));
  return i.length > 1 && n && i.filter((c) => c.startsWith(t)).map((c) => {
    const d = c.substring(t.length);
    e[d] = !1, e[c] = !1;
  }), e;
}
function M7(e, t, n) {
  const i = Gm(e);
  i ? i.setErrors(t, n) : Vu(651, e);
}
function D7(e, t = !0) {
  const n = Gm(e);
  n ? n.clearErrors(t) : Vu(652, e);
}
var vy = "1.6.9", MM = /* @__PURE__ */ new WeakSet();
function d_(e, t) {
  const n = t || Object.assign(/* @__PURE__ */ new Map(), { active: !1 }), i = /* @__PURE__ */ new Map(), r = function(x) {
    var $;
    n.active && (n.has(e) || n.set(e, /* @__PURE__ */ new Set()), ($ = n.get(e)) == null || $.add(x));
  }, c = function(x) {
    return new Proxy(x, {
      get(...$) {
        return typeof $[1] == "string" && r(`prop:${$[1]}`), Reflect.get(...$);
      }
    });
  }, d = function(x) {
    return new Proxy(x, {
      get(...$) {
        return $[1] === "value" ? (A) => (r(`count:${A}`), x.value(A)) : Reflect.get(...$);
      }
    });
  }, a = function(x, $) {
    return Ym(x) ? d_(x, n) : ($ === "value" && r("commit"), $ === "_value" && r("input"), $ === "props" ? c(x) : $ === "ledger" ? d(x) : ($ === "children" && (r("child"), r("childRemoved")), x));
  }, {
    proxy: f,
    revoke: g
  } = Proxy.revocable(e, {
    get(...x) {
      switch (x[1]) {
        case "_node":
          return e;
        case "deps":
          return n;
        case "watch":
          return (A, I, O) => OM(f, A, I, O);
        case "observe":
          return () => {
            const A = new Map(n);
            return n.clear(), n.active = !0, A;
          };
        case "stopObserve":
          return () => {
            const A = new Map(n);
            return n.active = !1, A;
          };
        case "receipts":
          return i;
        case "kill":
          return () => {
            LM(i), MM.add(x[2]), g();
          };
      }
      const $ = Reflect.get(...x);
      return typeof $ == "function" ? (...A) => {
        const I = $(...A);
        return a(I, x[1]);
      } : a($, x[1]);
    }
  });
  return f;
}
function DM(e, [t, n], i, r) {
  t.forEach((c, d) => {
    c.forEach((a) => {
      e.receipts.has(d) || e.receipts.set(d, {});
      const f = e.receipts.get(d) ?? {};
      f[a] = f[a] ?? [], f[a].push(d.on(a, i, r)), e.receipts.set(d, f);
    });
  }), n.forEach((c, d) => {
    c.forEach((a) => {
      if (e.receipts.has(d)) {
        const f = e.receipts.get(d);
        f && Vn(f, a) && (f[a].map(d.off), delete f[a], e.receipts.set(d, f));
      }
    });
  });
}
function LM(e) {
  e.forEach((t, n) => {
    for (const i in t)
      t[i].map(n.off);
  }), e.clear();
}
function OM(e, t, n, i) {
  const r = (a) => {
    const f = e.stopObserve();
    DM(
      e,
      NM(c, f),
      () => OM(e, t, n, i),
      i
    ), n && n(a);
  }, c = new Map(e.deps);
  e.observe();
  const d = t(e);
  d instanceof Promise ? d.then((a) => r(a)) : r(d);
}
function NM(e, t) {
  const n = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
  return t.forEach((r, c) => {
    if (!e.has(c))
      n.set(c, r);
    else {
      const d = /* @__PURE__ */ new Set(), a = e.get(c);
      r.forEach(
        (f) => !(a != null && a.has(f)) && d.add(f)
      ), n.set(c, d);
    }
  }), e.forEach((r, c) => {
    if (!t.has(c))
      i.set(c, r);
    else {
      const d = /* @__PURE__ */ new Set(), a = t.get(c);
      r.forEach(
        (f) => !(a != null && a.has(f)) && d.add(f)
      ), i.set(c, d);
    }
  }), [n, i];
}
function Ix(e) {
  return MM.has(e);
}
var FM = function({ value: t }) {
  return ["yes", "on", "1", 1, !0, "true"].includes(t);
};
FM.skipEmpty = !1;
var L7 = FM, O7 = function({ value: e }, t = !1) {
  const n = Date.parse(t || /* @__PURE__ */ new Date()), i = Date.parse(String(e));
  return isNaN(i) ? !1 : i > n;
}, N7 = O7, F7 = function({ value: e }, t = !1) {
  const n = Date.parse(t || /* @__PURE__ */ new Date()), i = Date.parse(String(e));
  return isNaN(i) ? !1 : i > n || i === n;
}, R7 = F7, z7 = function(e, t) {
  var r;
  if (!t)
    return !1;
  const n = Date.parse(String(e.value)), i = Date.parse(String((r = e.at(t)) == null ? void 0 : r.value));
  return isNaN(i) ? !0 : isNaN(n) ? !1 : n > i;
}, B7 = z7, V7 = function({ value: e }, t = "default") {
  const n = {
    default: new RegExp("^\\p{L}+$", "u"),
    latin: /^[a-z]+$/i
  }, i = Vn(n, t) ? t : "default";
  return n[i].test(String(e));
}, U7 = V7, H7 = function({ value: e }, t = "default") {
  const n = {
    default: /^[\p{L} ]+$/u,
    latin: /^[a-z ]+$/i
  }, i = Vn(n, t) ? t : "default";
  return n[i].test(String(e));
}, W7 = H7, Z7 = function({ value: e }, t = "default") {
  const n = {
    default: /^[0-9\p{L}]+$/u,
    latin: /^[0-9a-z]+$/i
  }, i = Vn(n, t) ? t : "default";
  return n[i].test(String(e));
}, q7 = Z7, j7 = function({ value: e }, t = !1) {
  const n = Date.parse(t || /* @__PURE__ */ new Date()), i = Date.parse(String(e));
  return isNaN(i) ? !1 : i < n;
}, G7 = j7, Y7 = function(e, t) {
  var r;
  if (!t)
    return !1;
  const n = Date.parse(String(e.value)), i = Date.parse(String((r = e.at(t)) == null ? void 0 : r.value));
  return isNaN(i) ? !0 : isNaN(n) ? !1 : n < i;
}, K7 = Y7, X7 = function({ value: e }, t = !1) {
  const n = Date.parse(t || /* @__PURE__ */ new Date()), i = Date.parse(String(e));
  return isNaN(i) ? !1 : i < n || i === n;
}, J7 = X7, Q7 = function({ value: t }, n, i) {
  if (!isNaN(t) && !isNaN(n) && !isNaN(i)) {
    const r = 1 * t;
    n = Number(n), i = Number(i);
    const [c, d] = n <= i ? [n, i] : [i, n];
    return r >= 1 * c && r <= 1 * d;
  }
  return !1;
}, e9 = Q7, Xk = /(_confirm(?:ed)?)$/, t9 = function(t, n, i = "loose") {
  var c;
  n || (n = Xk.test(t.name) ? t.name.replace(Xk, "") : `${t.name}_confirm`);
  const r = (c = t.at(n)) == null ? void 0 : c.value;
  return i === "strict" ? t.value === r : t.value == r;
}, n9 = t9, i9 = function({ value: e }, t = "default") {
  const n = {
    default: new RegExp("\\p{L}", "u"),
    latin: /[a-z]/i
  }, i = Vn(n, t) ? t : "default";
  return n[i].test(String(e));
}, r9 = i9, s9 = function({ value: e }, t = "default") {
  const n = {
    default: /[\p{L} ]/u,
    latin: /[a-z ]/i
  }, i = Vn(n, t) ? t : "default";
  return n[i].test(String(e));
}, o9 = s9, a9 = function({ value: e }, t = "default") {
  const n = {
    default: /[0-9\p{L}]/u,
    latin: /[0-9a-z]/i
  }, i = Vn(n, t) ? t : "default";
  return n[i].test(String(e));
}, l9 = a9, c9 = function({ value: e }, t = "default") {
  const n = {
    default: new RegExp("\\p{Ll}", "u"),
    latin: /[a-z]/
  }, i = Vn(n, t) ? t : "default";
  return n[i].test(String(e));
}, u9 = c9, d9 = function({ value: t }) {
  return /[0-9]/.test(String(t));
}, p9 = d9, h9 = function({ value: e }) {
  return /[!-/:-@[-`{-~]/.test(String(e));
}, f9 = h9, m9 = function({ value: e }, t = "default") {
  const n = {
    default: new RegExp("\\p{Lu}", "u"),
    latin: /[A-Z]/
  }, i = Vn(n, t) ? t : "default";
  return n[i].test(String(e));
}, v9 = m9, g9 = function({ value: t }, n, i) {
  n = n instanceof Date ? n.getTime() : Date.parse(n), i = i instanceof Date ? i.getTime() : Date.parse(i);
  const r = t instanceof Date ? t.getTime() : Date.parse(String(t));
  if (n && !i)
    i = n, n = Date.now();
  else if (!n || !r)
    return !1;
  return r >= n && r <= i;
}, y9 = g9, _9 = function({ value: t }, n) {
  return n && typeof n == "string" ? uj(n).test(String(t)) : !isNaN(Date.parse(String(t)));
}, b9 = _9, w9 = function({ value: t }) {
  return /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(String(t));
}, x9 = w9, $9 = function({ value: t }, ...n) {
  return typeof t == "string" && n.length ? n.some((i) => t.endsWith(i)) : typeof t == "string" && n.length === 0;
}, C9 = $9, k9 = function({ value: t }, ...n) {
  return n.some((i) => typeof i == "object" ? vn(i, t) : i == t);
}, S9 = k9, T9 = function({ value: t }, n = 0, i = 1 / 0) {
  n = parseInt(n), i = isNaN(parseInt(i)) ? 1 / 0 : parseInt(i);
  const r = n <= i ? n : i, c = i >= n ? i : n;
  if (typeof t == "string" || Array.isArray(t))
    return t.length >= r && t.length <= c;
  if (t && typeof t == "object") {
    const d = Object.keys(t).length;
    return d >= r && d <= c;
  }
  return !1;
}, I9 = T9, A9 = function({ value: e }, t = "default") {
  const n = {
    default: new RegExp("^\\p{Ll}+$", "u"),
    allow_non_alpha: /^[0-9\p{Ll}!-/:-@[-`{-~]+$/u,
    allow_numeric: /^[0-9\p{Ll}]+$/u,
    allow_numeric_dashes: /^[0-9\p{Ll}-]+$/u,
    latin: /^[a-z]+$/
  }, i = Vn(n, t) ? t : "default";
  return n[i].test(String(e));
}, E9 = A9, P9 = function({ value: t }, ...n) {
  return n.some((i) => (typeof i == "string" && i.substr(0, 1) === "/" && i.substr(-1) === "/" && (i = new RegExp(i.substr(1, i.length - 2))), i instanceof RegExp ? i.test(String(t)) : i === t));
}, M9 = P9, D9 = function({ value: t }, n = 10) {
  return Array.isArray(t) ? t.length <= n : Number(t) <= Number(n);
}, L9 = D9, O9 = function({ value: t }, n = 1) {
  return Array.isArray(t) ? t.length >= n : Number(t) >= Number(n);
}, N9 = O9, F9 = function({ value: t }, ...n) {
  return !n.some((i) => typeof i == "object" ? vn(i, t) : i === t);
}, R9 = F9, z9 = function({ value: t }) {
  return !isNaN(t);
}, B9 = z9, RM = function(e, ...t) {
  return ma(e.value) ? t.map((i) => {
    var r;
    return (r = e.at(i)) == null ? void 0 : r.value;
  }).some((i) => !ma(i)) : !0;
};
RM.skipEmpty = !1;
var V9 = RM, zM = function({ value: t }, n = "default") {
  return n === "trim" && typeof t == "string" ? !ma(t.trim()) : !ma(t);
};
zM.skipEmpty = !1;
var U9 = zM, H9 = function({ value: t }, ...n) {
  return typeof t == "string" && n.length ? n.some((i) => t.startsWith(i)) : typeof t == "string" && n.length === 0;
}, W9 = H9, Z9 = function({ value: e }) {
  return /^[!-/:-@[-`{-~]+$/.test(String(e));
}, q9 = Z9, j9 = function({ value: e }, t = "default") {
  const n = {
    default: new RegExp("^\\p{Lu}+$", "u"),
    latin: /^[A-Z]+$/
  }, i = Vn(n, t) ? t : "default";
  return n[i].test(String(e));
}, G9 = j9, Y9 = function({ value: t }, ...n) {
  try {
    const i = n.length ? n : ["http:", "https:"], r = new URL(String(t));
    return i.includes(r.protocol);
  } catch {
    return !1;
  }
}, K9 = Y9;
const X9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  accepted: L7,
  alpha: U7,
  alpha_spaces: W7,
  alphanumeric: q7,
  between: e9,
  confirm: n9,
  contains_alpha: r9,
  contains_alpha_spaces: o9,
  contains_alphanumeric: l9,
  contains_lowercase: u9,
  contains_numeric: p9,
  contains_symbol: f9,
  contains_uppercase: v9,
  date_after: N7,
  date_after_node: B7,
  date_after_or_equal: R7,
  date_before: G7,
  date_before_node: K7,
  date_before_or_equal: J7,
  date_between: y9,
  date_format: b9,
  email: x9,
  ends_with: C9,
  is: S9,
  length: I9,
  lowercase: E9,
  matches: M9,
  max: L9,
  min: N9,
  not: R9,
  number: B9,
  require_one: V9,
  required: U9,
  starts_with: W9,
  symbol: q9,
  uppercase: G9,
  url: K9
}, Symbol.toStringTag, { value: "Module" }));
var Nw = /* @__PURE__ */ Vr({
  type: "state",
  blocking: !0,
  visible: !1,
  value: !0,
  key: "validating"
});
function J9(e = {}) {
  return function(n) {
    let i = ua(n.props.validationRules || {}), r = { ...e, ...i };
    const c = { input: Jh(), rerun: null, isPassing: !0 };
    let d = ua(n.props.validation);
    n.on("prop:validation", ({ payload: f }) => a(f, i)), n.on(
      "prop:validationRules",
      ({ payload: f }) => a(d, f)
    );
    function a(f, g) {
      var x;
      vn(Object.keys(i || {}), Object.keys(g || {})) && vn(d, f) || (i = ua(g), d = ua(f), r = { ...e, ...i }, (x = n.props.parsedRules) == null || x.forEach(($) => {
        BM($), LM($.observer.receipts), $.observer.kill();
      }), n.store.filter(() => !1, "validation"), n.props.parsedRules = Qk(f, r, n), c.isPassing = !0, Fw(n, n.props.parsedRules, c));
    }
    n.props.parsedRules = Qk(d, r, n), Fw(n, n.props.parsedRules, c);
  };
}
function Fw(e, t, n) {
  Ix(e) || (n.input = Jh(), e.store.set(
    /* @__PURE__ */ Vr({
      key: "failing",
      value: !n.isPassing,
      visible: !1
    })
  ), n.isPassing = !0, e.store.filter((i) => !i.meta.removeImmediately, "validation"), t.forEach(
    (i) => i.debounce && clearTimeout(i.timer)
  ), t.length && (e.store.set(Nw), Rw(0, t, n, !1, () => {
    e.store.remove(Nw.key), e.store.set(
      /* @__PURE__ */ Vr({
        key: "failing",
        value: !n.isPassing,
        visible: !1
      })
    );
  })));
}
function Rw(e, t, n, i, r) {
  const c = t[e];
  if (!c)
    return r();
  const d = c.observer;
  if (Ix(d))
    return;
  const a = n.input;
  c.state = null;
  function f(g, x) {
    if (n.input !== a)
      return;
    n.isPassing = n.isPassing && !!x, c.queued = !1;
    const $ = d.stopObserve(), A = NM(c.deps, $);
    if (DM(
      d,
      A,
      function() {
        try {
          d.store.set(Nw);
        } catch {
        }
        c.queued = !0, n.rerun && clearTimeout(n.rerun), n.rerun = setTimeout(
          Fw,
          0,
          d,
          t,
          n
        );
      },
      "unshift"
      // We want these listeners to run before other events are emitted so the 'state.validating' will be reliable.
    ), c.deps = $, c.state = x, x === !1 ? eG(c, i || g) : BM(c), t.length > e + 1) {
      const I = t[e + 1];
      (x || I.force || !I.skipEmpty) && I.state === null && (I.queued = !0), Rw(e + 1, t, n, i || g, r);
    } else
      r();
  }
  (!ma(d.value) || !c.skipEmpty) && (n.isPassing || c.force) ? c.queued ? Q9(c, d, (g) => {
    g instanceof Promise ? g.then((x) => f(!0, x)) : f(!1, g);
  }) : Rw(e + 1, t, n, i, r) : ma(d.value) && c.skipEmpty && n.isPassing ? (d.observe(), d.value, f(!1, n.isPassing)) : f(!1, null);
}
function Q9(e, t, n) {
  e.debounce ? e.timer = setTimeout(() => {
    t.observe(), n(e.rule(t, ...e.args));
  }, e.debounce) : (t.observe(), n(e.rule(t, ...e.args)));
}
function BM(e) {
  const t = `rule_${e.name}`;
  e.messageObserver && (e.messageObserver = e.messageObserver.kill()), Vn(e.observer.store, t) && e.observer.store.remove(t);
}
function eG(e, t) {
  const n = e.observer;
  Ix(n) || (e.messageObserver || (e.messageObserver = d_(n._node)), e.messageObserver.watch(
    (i) => nG(
      i,
      e
    ),
    (i) => {
      const r = tG(n, e, i), c = /* @__PURE__ */ Vr({
        blocking: e.blocking,
        key: `rule_${e.name}`,
        meta: {
          /**
           * Use this key instead of the message root key to produce i18n validation
           * messages.
           */
          messageKey: e.name,
          /**
           * For messages that were created *by or after* a debounced or async
           * validation rule — we make note of it so we can immediately remove them
           * as soon as the next commit happens.
           */
          removeImmediately: t,
          /**
           * Determines if this message should be passed to localization.
           */
          localize: !r,
          /**
           * The arguments that will be passed to the validation rules
           */
          i18nArgs: i
        },
        type: "validation",
        value: r || "This field is not valid."
      });
      n.store.set(c);
    }
  ));
}
function tG(e, t, n) {
  const i = e.props.validationMessages && Vn(e.props.validationMessages, t.name) ? e.props.validationMessages[t.name] : void 0;
  return typeof i == "function" ? i(...n) : i;
}
function nG(e, t) {
  return [
    {
      node: e,
      name: Ax(e),
      args: t.args
    }
  ];
}
function Ax(e) {
  return typeof e.props.validationLabel == "function" ? e.props.validationLabel(e) : e.props.validationLabel || e.props.label || e.props.name || String(e.name);
}
var VM = "(?:[\\*+?()0-9]+)", UM = "[a-zA-Z][a-zA-Z0-9_]+", iG = new RegExp(
  `^(${VM}?${UM})(?:\\:(.*)+)?$`,
  "i"
), rG = new RegExp(`^(${VM})(${UM})$`, "i"), sG = /([\*+?]+)?(\(\d+\))([\*+?]+)?/, Jk = /\(\d+\)/, oG = {
  blocking: !0,
  debounce: 0,
  force: !1,
  skipEmpty: !0,
  name: ""
};
function Qk(e, t, n) {
  return e ? (typeof e == "string" ? aG(e) : Nu(e)).reduce((r, c) => {
    let d = c.shift();
    const a = {};
    if (typeof d == "string") {
      const [f, g] = cG(d);
      Vn(t, f) && (d = t[f], Object.assign(a, g));
    }
    return typeof d == "function" && r.push({
      observer: d_(n),
      rule: d,
      args: c,
      timer: 0,
      state: null,
      queued: !0,
      deps: /* @__PURE__ */ new Map(),
      ...oG,
      ...uG(a, d)
    }), r;
  }, []) : [];
}
function aG(e) {
  return e.split("|").reduce((t, n) => {
    const i = lG(n);
    return i && t.push(i), t;
  }, []);
}
function lG(e) {
  const t = e.trim();
  if (t) {
    const n = t.match(iG);
    if (n && typeof n[1] == "string") {
      const i = n[1].trim(), r = n[2] && typeof n[2] == "string" ? n[2].split(",").map((c) => c.trim()) : [];
      return [i, ...r];
    }
  }
  return !1;
}
function cG(e) {
  const t = e.match(rG);
  if (!t)
    return [e, { name: e }];
  const n = {
    "*": { force: !0 },
    "+": { skipEmpty: !1 },
    "?": { blocking: !1 }
  }, [, i, r] = t, c = Jk.test(i) ? i.match(sG) || [] : [, i];
  return [
    r,
    [c[1], c[2], c[3]].reduce(
      (d, a) => (a && (Jk.test(a) ? d.debounce = parseInt(a.substr(1, a.length - 1)) : a.split("").forEach(
        (f) => Vn(n, f) && Object.assign(d, n[f])
      )), d),
      { name: r }
    )
  ];
}
function uG(e, t) {
  return e.name || (e.name = t.ruleName || t.name), ["skipEmpty", "force", "debounce", "blocking"].reduce(
    (n, i) => (Vn(t, i) && !Vn(n, i) && Object.assign(n, {
      [i]: t[i]
    }), n),
    e
  );
}
function dG(e) {
  const t = /* @__PURE__ */ new Map(), n = (i) => {
    const r = [];
    for (const c in i.store) {
      const d = i.store[c];
      d.type === "validation" && d.visible && typeof d.value == "string" && r.push(d);
    }
    return r.length && t.set(i, r), i;
  };
  return n(e).walk(n), t;
}
function rn(e) {
  return e[0].toUpperCase() + e.substr(1);
}
function gy(e, t = "or") {
  return e.reduce((n, i, r) => (n += i, r <= e.length - 2 && e.length > 2 && (n += ", "), r === e.length - 2 && (n += `${e.length === 2 ? " " : ""}${t} `), n), "");
}
function Cu(e) {
  const t = typeof e == "string" ? new Date(Date.parse(e)) : e;
  return t instanceof Date ? new Intl.DateTimeFormat(void 0, {
    dateStyle: "medium",
    timeZone: "UTC"
  }).format(t) : "(unknown)";
}
function HM(e, t) {
  return Number(e) >= Number(t) ? [t, e] : [e, t];
}
var pG = {
  /**
   * Shown on a button for adding additional items.
   */
  add: "Add",
  /**
   * Shown when a button to remove items is visible.
   */
  remove: "Remove",
  /**
   * Shown when there are multiple items to remove at the same time.
   */
  removeAll: "Remove all",
  /**
   * Shown when all fields are not filled out correctly.
   */
  incomplete: "Sorry, not all fields are filled out correctly.",
  /**
   * Shown in a button inside a form to submit the form.
   */
  submit: "Submit",
  /**
   * Shown when no files are selected.
   */
  noFiles: "No file chosen",
  /**
   * Shown on buttons that move fields up in a list.
   */
  moveUp: "Move up",
  /**
   * Shown on buttons that move fields down in a list.
   */
  moveDown: "Move down",
  /**
   * Shown when something is actively loading.
   */
  isLoading: "Loading...",
  /**
   * Shown when there is more to load.
   */
  loadMore: "Load more",
  /**
   * Show on buttons that navigate state forward
   */
  next: "Next",
  /**
   * Show on buttons that navigate state backward
   */
  prev: "Previous",
  /**
   * Shown when adding all values.
   */
  addAllValues: "Add all values",
  /**
   * Shown when adding selected values.
   */
  addSelectedValues: "Add selected values",
  /**
   * Shown when removing all values.
   */
  removeAllValues: "Remove all values",
  /**
   * Shown when removing selected values.
   */
  removeSelectedValues: "Remove selected values",
  /**
   * Shown when there is a date to choose.
   */
  chooseDate: "Choose date",
  /**
   * Shown when there is a date to change.
   */
  changeDate: "Change date",
  /**
   * Shown above error summaries when someone attempts to submit a form with
   * errors and the developer has implemented `<FormKitSummary />`.
   */
  summaryHeader: "There were errors in your form.",
  /*
   * Shown when there is something to close
   */
  close: "Close",
  /**
   * Shown when there is something to open.
   */
  open: "Open"
}, hG = {
  /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */
  accepted({ name: e }) {
    return `Please accept the ${e}.`;
  },
  /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */
  date_after({ name: e, args: t }) {
    return Array.isArray(t) && t.length ? `${rn(e)} must be after ${Cu(t[0])}.` : `${rn(e)} must be in the future.`;
  },
  /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */
  alpha({ name: e }) {
    return `${rn(e)} can only contain alphabetical characters.`;
  },
  /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */
  alphanumeric({ name: e }) {
    return `${rn(e)} can only contain letters and numbers.`;
  },
  /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */
  alpha_spaces({ name: e }) {
    return `${rn(e)} can only contain letters and spaces.`;
  },
  /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */
  contains_alpha({ name: e }) {
    return `${rn(e)} must contain alphabetical characters.`;
  },
  /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */
  contains_alphanumeric({ name: e }) {
    return `${rn(e)} must contain letters or numbers.`;
  },
  /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */
  contains_alpha_spaces({ name: e }) {
    return `${rn(e)} must contain letters or spaces.`;
  },
  /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */
  contains_symbol({ name: e }) {
    return `${rn(e)} must contain a symbol.`;
  },
  /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */
  contains_uppercase({ name: e }) {
    return `${rn(e)} must contain an uppercase letter.`;
  },
  /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */
  contains_lowercase({ name: e }) {
    return `${rn(e)} must contain a lowercase letter.`;
  },
  /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */
  contains_numeric({ name: e }) {
    return `${rn(e)} must contain numbers.`;
  },
  /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */
  symbol({ name: e }) {
    return `${rn(e)} must be a symbol.`;
  },
  /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */
  uppercase({ name: e }) {
    return `${rn(e)} can only contain uppercase letters.`;
  },
  /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */
  lowercase({ name: e, args: t }) {
    let n = "";
    return Array.isArray(t) && t.length && (t[0] === "allow_non_alpha" && (n = ", numbers and symbols"), t[0] === "allow_numeric" && (n = " and numbers"), t[0] === "allow_numeric_dashes" && (n = ", numbers and dashes")), `${rn(e)} can only contain lowercase letters${n}.`;
  },
  /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */
  date_before({ name: e, args: t }) {
    return Array.isArray(t) && t.length ? `${rn(e)} must be before ${Cu(t[0])}.` : `${rn(e)} must be in the past.`;
  },
  /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */
  between({ name: e, args: t }) {
    if (isNaN(t[0]) || isNaN(t[1]))
      return "This field was configured incorrectly and can’t be submitted.";
    const [n, i] = HM(t[0], t[1]);
    return `${rn(e)} must be between ${n} and ${i}.`;
  },
  /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */
  confirm({ name: e }) {
    return `${rn(e)} does not match.`;
  },
  /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */
  date_format({ name: e, args: t }) {
    return Array.isArray(t) && t.length ? `${rn(e)} is not a valid date, please use the format ${t[0]}` : "This field was configured incorrectly and can’t be submitted";
  },
  /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */
  date_between({ name: e, args: t }) {
    return `${rn(e)} must be between ${Cu(t[0])} and ${Cu(t[1])}`;
  },
  /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */
  email: "Please enter a valid email address.",
  /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */
  ends_with({ name: e, args: t }) {
    return `${rn(e)} doesn’t end with ${gy(t)}.`;
  },
  /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */
  is({ name: e }) {
    return `${rn(e)} is not an allowed value.`;
  },
  /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */
  length({ name: e, args: [t = 0, n = 1 / 0] }) {
    const i = Number(t) <= Number(n) ? t : n, r = Number(n) >= Number(t) ? n : t;
    return i == 1 && r === 1 / 0 ? `${rn(e)} must be at least one character.` : i == 0 && r ? `${rn(e)} must be less than or equal to ${r} characters.` : i === r ? `${rn(e)} should be ${r} characters long.` : i && r === 1 / 0 ? `${rn(e)} must be greater than or equal to ${i} characters.` : `${rn(e)} must be between ${i} and ${r} characters.`;
  },
  /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */
  matches({ name: e }) {
    return `${rn(e)} is not an allowed value.`;
  },
  /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */
  max({ name: e, node: { value: t }, args: n }) {
    return Array.isArray(t) ? `Cannot have more than ${n[0]} ${e}.` : `${rn(e)} must be no more than ${n[0]}.`;
  },
  /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */
  mime({ name: e, args: t }) {
    return t[0] ? `${rn(e)} must be of the type: ${t[0]}` : "No file formats allowed.";
  },
  /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */
  min({ name: e, node: { value: t }, args: n }) {
    return Array.isArray(t) ? `Cannot have fewer than ${n[0]} ${e}.` : `${rn(e)} must be at least ${n[0]}.`;
  },
  /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */
  not({ name: e, node: { value: t } }) {
    return `“${t}” is not an allowed ${e}.`;
  },
  /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */
  number({ name: e }) {
    return `${rn(e)} must be a number.`;
  },
  /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */
  require_one: ({ name: e, node: t, args: n }) => {
    const i = n.map((r) => {
      const c = t.at(r);
      return c ? Ax(c) : !1;
    }).filter((r) => !!r);
    return i.unshift(e), `${i.join(" or ")} is required.`;
  },
  /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */
  required({ name: e }) {
    return `${rn(e)} is required.`;
  },
  /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */
  starts_with({ name: e, args: t }) {
    return `${rn(e)} doesn’t start with ${gy(t)}.`;
  },
  /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */
  url() {
    return "Please enter a valid URL.";
  },
  /**
   * Shown when the date is invalid.
   */
  invalidDate: "The selected date is invalid."
}, WM = { ui: pG, validation: hG }, fG = {
  /**
   * Shown on buttons for adding new items.
   */
  add: "Ajouter",
  /**
   * Shown when a button to remove items is visible.
   */
  remove: "Supprimer",
  /**
   * Shown when there are multiple items to remove at the same time.
   */
  removeAll: "Enlever tout",
  /**
   * Shown when all fields are not filled out correctly.
   */
  incomplete: "Désolé, tous les champs ne sont pas remplis correctement.",
  /**
   * Shown in a button inside a form to submit the form.
   */
  submit: "Valider",
  /**
   * Shown when no files are selected.
   */
  noFiles: "Aucun fichier choisi",
  /**
   * Shown on buttons that move fields up in a list.
   */
  moveUp: "Déplacez-vous",
  /**
   * Shown on buttons that move fields down in a list.
   */
  moveDown: "Déplacez-vous",
  /**
   * Shown when something is actively loading.
   */
  isLoading: "Chargement...",
  /**
   * Shown when there is more to load.
   */
  loadMore: "Chargez plus",
  /**
   * Shown on buttons that navigate state forward
   */
  next: "Suivant",
  /**
   * Shown on buttons that navigate state backward
   */
  prev: "Précédent",
  /**
   * Shown when adding all values.
   */
  addAllValues: "Ajouter toutes les valeurs",
  /**
   * Shown when adding selected values.
   */
  addSelectedValues: "Ajouter les valeurs sélectionnées",
  /**
   * Shown when removing all values.
   */
  removeAllValues: "Supprimer toutes les valeurs",
  /**
   * Shown when removing selected values.
   */
  removeSelectedValues: "Supprimer les valeurs sélectionnées",
  /**
   * Shown when there is a date to choose.
   */
  chooseDate: "Choisissez la date",
  /**
   * Shown when there is a date to change.
   */
  changeDate: "Modifier la date",
  /**
   * Shown when there is something to close
   */
  close: "Fermer",
  /**
   * Shown when there is something to open.
   */
  open: "Ouvrir"
}, mG = {
  /**
   * The value is not an accepted value.
   * @see {@link https://formkit.com/essentials/validation#accepted}
   */
  accepted({ name: e }) {
    return `Veuillez accepter le ${e}.`;
  },
  /**
   * The date is not after
   * @see {@link https://formkit.com/essentials/validation#date-after}
   */
  date_after({ name: e, args: t }) {
    return Array.isArray(t) && t.length ? `${rn(e)} doit être postérieure au ${Cu(t[0])}.` : `${rn(e)} doit être dans le futur.`;
  },
  /**
   * The value is not a letter.
   * @see {@link https://formkit.com/essentials/validation#alpha}
   */
  alpha({ name: e }) {
    return `${rn(e)} ne peut contenir que des caractères alphabétiques.`;
  },
  /**
   * The value is not alphanumeric
   * @see {@link https://formkit.com/essentials/validation#alphanumeric}
   */
  alphanumeric({ name: e }) {
    return `${rn(e)} ne peut contenir que des lettres et des chiffres.`;
  },
  /**
   * The value is not letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
   */
  alpha_spaces({ name: e }) {
    return `${rn(e)} ne peuvent contenir que des lettres et des espaces.`;
  },
  /**
   * The value have no letter.
   * @see {@link https://formkit.com/essentials/validation#contains_alpha}
   */
  contains_alpha({ name: e }) {
    return `${rn(e)} doit contenir des caractères alphabétiques.`;
  },
  /**
   * The value have no alphanumeric
   * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
   */
  contains_alphanumeric({ name: e }) {
    return `${rn(e)} doit contenir au moins un lettre ou nombre.`;
  },
  /**
   * The value have no letter and/or spaces
   * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
   */
  contains_alpha_spaces({ name: e }) {
    return `${rn(e)} doit contenir des lettres ou des espaces.`;
  },
  /**
   * The value have no symbol
   * @see {@link https://formkit.com/essentials/validation#contains_symbol}
   */
  contains_symbol({ name: e }) {
    return `${rn(e)} doit contenir un symbole.`;
  },
  /**
   * The value have no uppercase
   * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
   */
  contains_uppercase({ name: e }) {
    return `${rn(e)} doit contenir au moins une majuscule.`;
  },
  /**
   * The value have no lowercase
   * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
   */
  contains_lowercase({ name: e }) {
    return `${rn(e)} doit contenir au moins une minuscule.`;
  },
  /**
   *  The value have no numeric
   * @see {@link https://formkit.com/essentials/validation#contains_numeric}
   */
  contains_numeric({ name: e }) {
    return `${rn(e)} doit contenir des chiffres.`;
  },
  /**
   * The value is not symbol
   * @see {@link https://formkit.com/essentials/validation#symbol}
   */
  symbol({ name: e }) {
    return `${rn(e)} doit être un symbole.`;
  },
  /**
   * The value is not uppercase
   * @see {@link https://formkit.com/essentials/validation#uppercase}
   */
  uppercase({ name: e }) {
    return `${rn(e)} ne peuvent contenir que des majuscules.`;
  },
  /**
   * The value is not lowercase
   * @see {@link https://formkit.com/essentials/validation#lowercase}
   */
  lowercase({ name: e }) {
    return `${rn(e)} ne peut contenir que des lettres minuscules.`;
  },
  /**
   * The date is not before
   * @see {@link https://formkit.com/essentials/validation#date-before}
   */
  date_before({ name: e, args: t }) {
    return Array.isArray(t) && t.length ? `${rn(e)} doit être antérieure au ${Cu(t[0])}.` : `${rn(e)} doit être dans le passé.`;
  },
  /**
   * The value is not between two numbers
   * @see {@link https://formkit.com/essentials/validation#between}
   */
  between({ name: e, args: t }) {
    if (isNaN(t[0]) || isNaN(t[1]))
      return "Ce champ a été configuré de manière incorrecte et ne peut pas être soumis.";
    const [n, i] = HM(t[0], t[1]);
    return `${rn(e)} doit être comprise entre ${n} et ${i}.`;
  },
  /**
   * The confirmation field does not match
   * @see {@link https://formkit.com/essentials/validation#confirm}
   */
  confirm({ name: e }) {
    return `${rn(e)} ne correspond pas.`;
  },
  /**
   * The value is not a valid date
   * @see {@link https://formkit.com/essentials/validation#date-format}
   */
  date_format({ name: e, args: t }) {
    return Array.isArray(t) && t.length ? `${rn(
      e
    )} n'est pas une date valide, veuillez utiliser le format ${t[0]}` : "Ce champ a été configuré de manière incorrecte et ne peut pas être soumis.";
  },
  /**
   * Is not within expected date range
   * @see {@link https://formkit.com/essentials/validation#date-between}
   */
  date_between({ name: e, args: t }) {
    return `${rn(e)} doit être comprise entre ${Cu(t[0])} et ${Cu(
      t[1]
    )}`;
  },
  /**
   * Shown when the user-provided value is not a valid email address.
   * @see {@link https://formkit.com/essentials/validation#email}
   */
  email: "Veuillez saisir une adresse email valide.",
  /**
   * Does not end with the specified value
   * @see {@link https://formkit.com/essentials/validation#ends-with}
   */
  ends_with({ name: e, args: t }) {
    return `${rn(e)} ne se termine pas par ${gy(t)}.`;
  },
  /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#is}
   */
  is({ name: e }) {
    return `${rn(e)} n'est pas une valeur autorisée.`;
  },
  /**
   * Does not match specified length
   * @see {@link https://formkit.com/essentials/validation#length}
   */
  length({ name: e, args: [t = 0, n = 1 / 0] }) {
    const i = Number(t) <= Number(n) ? t : n, r = Number(n) >= Number(t) ? n : t;
    return i == 1 && r === 1 / 0 ? `${rn(e)} doit comporter au moins un caractère.` : i == 0 && r ? `${rn(e)} doit être inférieur ou égal à ${r} caractères.` : i === r ? `${rn(e)} doit contenir ${r} caractères.` : i && r === 1 / 0 ? `${rn(e)} doit être supérieur ou égal à ${i} caractères.` : `${rn(e)} doit être comprise entre ${i} et ${r} caractères.`;
  },
  /**
   * Value is not a match
   * @see {@link https://formkit.com/essentials/validation#matches}
   */
  matches({ name: e }) {
    return `${rn(e)} n'est pas une valeur autorisée.`;
  },
  /**
   * Exceeds maximum allowed value
   * @see {@link https://formkit.com/essentials/validation#max}
   */
  max({ name: e, node: { value: t }, args: n }) {
    return Array.isArray(t) ? `Ne peut pas avoir plus de ${n[0]} ${e}.` : `${rn(e)} doit être inférieur ou égal à ${n[0]}.`;
  },
  /**
   * The (field-level) value does not match specified mime type
   * @see {@link https://formkit.com/essentials/validation#mime}
   */
  mime({ name: e, args: t }) {
    return t[0] ? `${rn(e)} doit être du type: ${t[0]}` : "Aucun format de fichier n’est autorisé";
  },
  /**
   * Does not fulfill minimum allowed value
   * @see {@link https://formkit.com/essentials/validation#min}
   */
  min({ name: e, node: { value: t }, args: n }) {
    return Array.isArray(t) ? `Ne peut pas avoir moins de ${n[0]} ${e}.` : `${rn(e)} doit être au moins de ${n[0]}.`;
  },
  /**
   * Is not an allowed value
   * @see {@link https://formkit.com/essentials/validation#not}
   */
  not({ name: e, node: { value: t } }) {
    return `“${t}” n'est pas un ${e} autorisé.`;
  },
  /**
   *  Is not a number
   * @see {@link https://formkit.com/essentials/validation#number}
   */
  number({ name: e }) {
    return `${rn(e)} doit être un nombre.`;
  },
  /**
   * Require one field.
   * @see {@link https://formkit.com/essentials/validation#require-one}
   */
  require_one: ({ name: e, node: t, args: n }) => {
    const i = n.map((r) => {
      const c = t.at(r);
      return c ? Ax(c) : !1;
    }).filter((r) => !!r);
    return i.unshift(e), `${i.join(" ou ")} est requis.`;
  },
  /**
   * Required field.
   * @see {@link https://formkit.com/essentials/validation#required}
   */
  required({ name: e }) {
    return `${rn(e)} est requis.`;
  },
  /**
   * Does not start with specified value
   * @see {@link https://formkit.com/essentials/validation#starts-with}
   */
  starts_with({ name: e, args: t }) {
    return `${rn(e)} ne commence pas par ${gy(t)}.`;
  },
  /**
   * Is not a url
   * @see {@link https://formkit.com/essentials/validation#url}
   */
  url() {
    return "Entrez une URL valide.";
  },
  /**
   * Shown when the date is invalid.
   */
  invalidDate: "La date sélectionnée n'est pas valide."
}, vG = { ui: fG, validation: mG }, eS = /* @__PURE__ */ new Set();
function gG(e) {
  return function(n) {
    eS.add(n), n.on("destroying", () => eS.delete(n));
    let i = tS(n.config.locale, e), r = i ? e[i] : {};
    n.on("prop:locale", ({ payload: c }) => {
      i = tS(c, e), r = i ? e[i] : {}, n.store.touch();
    }), n.on("prop:label", () => n.store.touch()), n.on("prop:validationLabel", () => n.store.touch()), n.hook.text((c, d) => {
      var f, g;
      const a = ((f = c.meta) == null ? void 0 : f.messageKey) || c.key;
      if (Vn(r, c.type) && Vn(r[c.type], a)) {
        const x = r[c.type][a];
        typeof x == "function" ? c.value = Array.isArray((g = c.meta) == null ? void 0 : g.i18nArgs) ? x(...c.meta.i18nArgs) : x(c) : c.value = x;
      }
      return d(c);
    });
  };
}
function tS(e, t) {
  if (Vn(t, e))
    return e;
  const [n] = e.split("-");
  if (Vn(t, n))
    return n;
  for (const i in t)
    return i;
  return !1;
}
function yG(...e) {
  const t = e.reduce(
    (i, r) => Fc(i, r),
    {}
  ), n = () => {
  };
  return n.library = function(i) {
    const r = ch(i.props.type);
    Vn(t, r) && i.define(t[r]);
  }, n;
}
var _G = [
  "classes",
  "config",
  "delay",
  "errors",
  "id",
  "index",
  "inputErrors",
  "library",
  "modelValue",
  "onUpdate:modelValue",
  "name",
  "number",
  "parent",
  "plugins",
  "sectionsSchema",
  "type",
  "validation",
  "validationLabel",
  "validationMessages",
  "validationRules",
  // Runtime event props:
  "onInput",
  "onInputRaw",
  "onUpdate:modelValue",
  "onNode",
  "onSubmit",
  "onSubmitInvalid",
  "onSubmitRaw"
];
function p_(e) {
  return e && typeof e == "object" && "group" in e && Array.isArray(e.options);
}
function yy(e, t = { count: 1 }) {
  return Array.isArray(e) ? e.map(
    (n) => {
      if (typeof n == "string" || typeof n == "number")
        return {
          label: String(n),
          value: String(n)
        };
      if (typeof n == "object") {
        if ("group" in n)
          return n.options = yy(n.options || [], t), n;
        "value" in n && typeof n.value != "string" && Object.assign(n, {
          value: `__mask_${t.count++}`,
          __original: n.value
        });
      }
      return n;
    }
  ) : Object.keys(e).map((n) => ({
    label: e[n],
    value: n
  }));
}
function Fd(e, t, n = !1) {
  if (Array.isArray(e)) {
    for (const i of e)
      if (!(typeof i != "object" && i)) {
        if (p_(i)) {
          const r = Fd(i.options, t, !0);
          if (r !== void 0)
            return r;
        } else if (t == i.value)
          return "__original" in i ? i.__original : i.value;
      }
  }
  return n ? void 0 : t;
}
function Th(e, t) {
  return e === null && t === void 0 || e === void 0 && t === null ? !1 : e == t ? !0 : Ou(e) && Ou(t) ? vn(e, t) : !1;
}
function Zl(e) {
  e.hook.prop((t, n) => {
    var i;
    return t.prop === "options" && (typeof t.value == "function" ? (e.props.optionsLoader = t.value, t.value = []) : ((i = e.props)._normalizeCounter ?? (i._normalizeCounter = { count: 1 }), t.value = yy(t.value, e.props._normalizeCounter))), n(t);
  });
}
// @__NO_SIDE_EFFECTS__
function On(e, t, n = !1) {
  return (...i) => {
    const r = (c) => {
      const d = !t || typeof t == "string" ? { $el: t } : t();
      return (Nd(d) || Tm(d)) && (d.meta ? d.meta.section = e : d.meta = { section: e }, i.length && !d.children && (d.children = [
        ...i.map(
          (a) => typeof a == "function" ? a(c) : a
        )
      ]), Nd(d) && (d.attrs = {
        class: `$classes.${e}`,
        ...d.attrs || {}
      })), {
        if: `$slots.${e}`,
        then: `$slots.${e}`,
        else: e in c ? /* @__PURE__ */ Sd(d, c[e]) : d
      };
    };
    return r._s = e, n ? /* @__PURE__ */ bG(r) : r;
  };
}
// @__NO_SIDE_EFFECTS__
function bG(e) {
  return (t) => [e(t)];
}
function Im(e) {
  return !!(e && typeof e == "object" && ("$el" in e || "$cmp" in e || "$formkit" in e));
}
// @__NO_SIDE_EFFECTS__
function Sd(e, t = {}) {
  return typeof e == "string" ? Im(t) || typeof t == "string" ? t : e : Array.isArray(e) ? Im(t) ? t : e : Fc(e, t);
}
var wG = /* @__PURE__ */ On("actions", () => ({
  $el: "div",
  if: "$actions"
})), _y = /* @__PURE__ */ On("input", () => ({
  $el: "input",
  bind: "$attrs",
  attrs: {
    type: "$type",
    name: "$node.props.altName || $node.name",
    disabled: "$option.attrs.disabled || $disabled",
    onInput: "$handlers.toggleChecked",
    checked: "$fns.eq($_value, $onValue)",
    onBlur: "$handlers.blur",
    value: "$: true",
    id: "$id",
    "aria-describedby": {
      if: "$options.length",
      then: {
        if: "$option.help",
        then: '$: "help-" + $option.attrs.id',
        else: void 0
      },
      else: {
        if: "$help",
        then: '$: "help-" + $id',
        else: void 0
      }
    }
  }
})), ZM = /* @__PURE__ */ On("optionHelp", () => ({
  $el: "div",
  if: "$option.help",
  attrs: {
    id: '$: "help-" + $option.attrs.id'
  }
})), by = /* @__PURE__ */ On("inner", "span"), wy = /* @__PURE__ */ On("label", "span"), qM = /* @__PURE__ */ On("option", () => ({
  $el: "li",
  for: ["option", "$options"],
  attrs: {
    "data-disabled": "$option.attrs.disabled || $disabled || undefined"
  }
})), jM = /* @__PURE__ */ On("options", "ul"), xy = /* @__PURE__ */ On("wrapper", () => ({
  $el: "label",
  attrs: {
    "data-disabled": {
      if: "$options.length",
      then: void 0,
      else: "$disabled || undefined"
    },
    "data-checked": {
      if: "$options == undefined",
      then: "$fns.eq($_value, $onValue) || undefined",
      else: "$fns.isChecked($option.value) || undefined"
    }
  }
})), xG = /* @__PURE__ */ On("input", () => ({
  $el: "button",
  bind: "$attrs",
  attrs: {
    type: "$type",
    disabled: "$disabled",
    name: "$node.name",
    id: "$id"
  }
})), $G = /* @__PURE__ */ On("default", null), $y = /* @__PURE__ */ On("decorator", () => ({
  $el: "span",
  attrs: {
    "aria-hidden": "true"
  }
})), GM = /* @__PURE__ */ On("fieldset", () => ({
  $el: "fieldset",
  attrs: {
    id: "$id",
    "aria-describedby": {
      if: "$help",
      then: '$: "help-" + $id',
      else: void 0
    }
  }
})), CG = /* @__PURE__ */ On("input", () => ({
  $el: "input",
  bind: "$attrs",
  attrs: {
    type: "file",
    disabled: "$disabled",
    name: "$node.name",
    onChange: "$handlers.files",
    onBlur: "$handlers.blur",
    id: "$id",
    "aria-describedby": "$describedBy",
    "aria-required": "$state.required || undefined"
  }
})), kG = /* @__PURE__ */ On("fileItem", () => ({
  $el: "li",
  for: ["file", "$value"]
})), SG = /* @__PURE__ */ On("fileList", () => ({
  $el: "ul",
  if: "$value.length",
  attrs: {
    "data-has-multiple": "$_hasMultipleFiles"
  }
})), TG = /* @__PURE__ */ On("fileName", () => ({
  $el: "span",
  attrs: {
    class: "$classes.fileName"
  }
})), nS = /* @__PURE__ */ On("fileRemove", () => ({
  $el: "button",
  attrs: {
    type: "button",
    onClick: "$handlers.resetFiles"
  }
})), IG = /* @__PURE__ */ On("form", () => ({
  $el: "form",
  bind: "$attrs",
  meta: {
    autoAnimate: !0
  },
  attrs: {
    id: "$id",
    name: "$node.name",
    onSubmit: "$handlers.submit",
    "data-loading": "$state.loading || undefined"
  }
})), Ex = /* @__PURE__ */ On("wrapper", null, !0), Bl = /* @__PURE__ */ On("help", () => ({
  $el: "div",
  if: "$help",
  attrs: {
    id: '$: "help-" + $id'
  }
})), Ar = (e, t) => (/* @__PURE__ */ On(`${e}Icon`, () => {
  const n = `_raw${e.charAt(0).toUpperCase()}${e.slice(1)}Icon`;
  return {
    if: `$${e}Icon && $${n}`,
    $el: `${t || "span"}`,
    attrs: {
      class: `$classes.${e}Icon + " " + $classes.icon`,
      innerHTML: `$${n}`,
      onClick: `$handlers.iconClick(${e})`,
      role: `$fns.iconRole(${e})`,
      tabindex: `$fns.iconRole(${e}) === "button" && "0" || undefined`,
      for: {
        if: `${t === "label"}`,
        then: "$id"
      }
    }
  };
}))(), Km = /* @__PURE__ */ On("inner", "div"), Xm = /* @__PURE__ */ On("label", () => ({
  $el: "label",
  if: "$label",
  attrs: {
    for: "$id"
  }
})), YM = /* @__PURE__ */ On("legend", () => ({
  $el: "legend",
  if: "$label"
})), Vc = /* @__PURE__ */ On("message", () => ({
  $el: "li",
  for: ["message", "$messages"],
  attrs: {
    key: "$message.key",
    id: "$id + '-' + $message.key",
    "data-message-type": "$message.type"
  }
})), Uc = /* @__PURE__ */ On("messages", () => ({
  $el: "ul",
  if: "$defaultMessagePlacement && $fns.length($messages)"
})), AG = /* @__PURE__ */ On("noFiles", () => ({
  $el: "span",
  if: "$value == null || $value.length == 0"
})), EG = /* @__PURE__ */ On("optGroup", () => ({
  $el: "optgroup",
  bind: "$option.attrs",
  attrs: {
    label: "$option.group"
  }
})), iS = /* @__PURE__ */ On("option", () => ({
  $el: "option",
  bind: "$option.attrs",
  attrs: {
    class: "$classes.option",
    value: "$option.value",
    selected: "$fns.isSelected($option)"
  }
})), rS = /* @__PURE__ */ On("options", () => ({
  $el: null,
  if: "$options.length",
  for: ["option", "$option.options || $options"]
})), Uu = /* @__PURE__ */ On("outer", () => ({
  $el: "div",
  meta: {
    autoAnimate: !0
  },
  attrs: {
    key: "$id",
    "data-family": "$family || undefined",
    "data-type": "$type",
    "data-multiple": '$attrs.multiple || ($type != "select" && $options != undefined) || undefined',
    "data-has-multiple": "$_hasMultipleFiles",
    "data-disabled": '$: ($disabled !== "false" && $disabled) || undefined',
    "data-empty": "$state.empty || undefined",
    "data-complete": "$state.complete || undefined",
    "data-invalid": "$state.invalid || undefined",
    "data-errors": "$state.errors || undefined",
    "data-submitted": "$state.submitted || undefined",
    "data-prefix-icon": "$_rawPrefixIcon !== undefined || undefined",
    "data-suffix-icon": "$_rawSuffixIcon !== undefined || undefined",
    "data-prefix-icon-click": "$onPrefixIconClick !== undefined || undefined",
    "data-suffix-icon-click": "$onSuffixIconClick !== undefined || undefined"
  }
})), Vl = /* @__PURE__ */ On("prefix", null), PG = /* @__PURE__ */ On("input", () => ({
  $el: "select",
  bind: "$attrs",
  attrs: {
    id: "$id",
    "data-placeholder": "$fns.showPlaceholder($_value, $placeholder)",
    disabled: "$disabled",
    class: "$classes.input",
    name: "$node.name",
    onChange: "$handlers.onChange",
    onInput: "$handlers.selectInput",
    onBlur: "$handlers.blur",
    "aria-describedby": "$describedBy",
    "aria-required": "$state.required || undefined"
  }
})), MG = /* @__PURE__ */ On("submit", () => ({
  $cmp: "FormKit",
  bind: "$submitAttrs",
  props: {
    type: "submit",
    label: "$submitLabel"
  }
})), Ul = /* @__PURE__ */ On("suffix", null), KM = /* @__PURE__ */ On("input", () => ({
  $el: "input",
  bind: "$attrs",
  attrs: {
    type: "$type",
    disabled: "$disabled",
    name: "$node.name",
    onInput: "$handlers.DOMInput",
    onBlur: "$handlers.blur",
    value: "$_value",
    id: "$id",
    "aria-describedby": "$describedBy",
    "aria-required": "$state.required || undefined"
  }
})), DG = /* @__PURE__ */ On("input", () => ({
  $el: "textarea",
  bind: "$attrs",
  attrs: {
    disabled: "$disabled",
    name: "$node.name",
    onInput: "$handlers.DOMInput",
    onBlur: "$handlers.blur",
    value: "$_value",
    id: "$id",
    "aria-describedby": "$describedBy",
    "aria-required": "$state.required || undefined"
  },
  children: "$initialValue"
})), Qh = /* @__PURE__ */ On("wrapper", "div"), LG = 0;
function XM(e) {
  (e.type === "group" || e.type === "list") && e.plugins.add(OG);
}
function OG(e) {
  e.props.type === "radio" && (e.addProps(["altName"]), e.props.altName = `${e.name}_${LG++}`);
}
function JM(e) {
  return function(t, n) {
    return t.prop === "options" && Array.isArray(t.value) && (t.value = t.value.map((i) => {
      var r;
      return (r = i.attrs) != null && r.id ? i : Fc(i, {
        attrs: {
          id: `${e.props.id}-option-${wx(String(i.value))}`
        }
      });
    }), e.props.type === "checkbox" && !Array.isArray(e.value) && (e.isCreated ? e.input([], !1) : e.on("created", () => {
      Array.isArray(e.value) || e.input([], !1);
    }))), n(t);
  };
}
function NG(e, t) {
  const n = t.target;
  if (n instanceof HTMLInputElement) {
    const i = Array.isArray(e.props.options) ? Fd(e.props.options, n.value) : n.value;
    Array.isArray(e.props.options) && e.props.options.length ? Array.isArray(e._value) ? e._value.some((r) => Th(i, r)) ? e.input(
      e._value.filter(
        (r) => !Th(i, r)
      )
    ) : e.input([...e._value, i]) : e.input([i]) : n.checked ? e.input(e.props.onValue) : e.input(e.props.offValue);
  }
}
function FG(e, t) {
  var n, i;
  return (n = e.context) == null || n.value, (i = e.context) == null || i._value, Array.isArray(e._value) ? e._value.some(
    (r) => Th(Fd(e.props.options, t), r)
  ) : !1;
}
function RG(e) {
  e.on("created", () => {
    var t, n;
    (t = e.context) != null && t.handlers && (e.context.handlers.toggleChecked = NG.bind(null, e)), (n = e.context) != null && n.fns && (e.context.fns.isChecked = FG.bind(null, e)), Vn(e.props, "onValue") || (e.props.onValue = !0), Vn(e.props, "offValue") || (e.props.offValue = !1);
  }), e.hook.prop(JM(e));
}
function Qn(e, t) {
  return (n) => {
    n.props[`${e}Icon`] === void 0 && (n.props[`${e}Icon`] = t.startsWith("<svg") ? t : `default:${t}`);
  };
}
function h_(e) {
  e.on("created", () => {
    "disabled" in e.props && (e.props.disabled = on(e.props.disabled), e.config.disabled = on(e.props.disabled));
  }), e.hook.prop(({ prop: t, value: n }, i) => (n = t === "disabled" ? on(n) : n, i({ prop: t, value: n }))), e.on("prop:disabled", ({ payload: t }) => {
    e.config.disabled = on(t);
  });
}
function bi(e, t) {
  return (n) => {
    n.store.set(
      /* @__PURE__ */ Vr({
        key: e,
        type: "ui",
        value: t || e,
        meta: {
          localize: !0,
          i18nArgs: [n]
        }
      })
    );
  };
}
var Qb = typeof window < "u";
function QM(e) {
  e.target instanceof HTMLElement && e.target.hasAttribute("data-file-hover") && e.target.removeAttribute("data-file-hover");
}
function sS(e, t) {
  t.target instanceof HTMLInputElement ? e === "dragover" && t.target.setAttribute("data-file-hover", "true") : t.preventDefault(), e === "drop" && QM(t);
}
function zG(e) {
  bi("noFiles", "Select file")(e), bi("removeAll", "Remove all")(e), bi("remove")(e), e.addProps(["_hasMultipleFiles"]), Qb && (window._FormKit_File_Drop || (window.addEventListener(
    "dragover",
    sS.bind(null, "dragover")
  ), window.addEventListener("drop", sS.bind(null, "drop")), window.addEventListener("dragleave", QM), window._FormKit_File_Drop = !0)), e.hook.input((t, n) => n(Array.isArray(t) ? t : [])), e.on("input", ({ payload: t }) => {
    e.props._hasMultipleFiles = Array.isArray(t) && t.length > 1 ? !0 : void 0;
  }), e.on("reset", () => {
    if (e.props.id && Qb) {
      const t = document.getElementById(e.props.id);
      t && (t.value = "");
    }
  }), e.on("created", () => {
    Array.isArray(e.value) || e.input([], !1), e.context && (e.context.handlers.resetFiles = (t) => {
      if (t.preventDefault(), e.input([]), e.props.id && Qb) {
        const n = document.getElementById(e.props.id);
        n && (n.value = ""), n == null || n.focus();
      }
    }, e.context.handlers.files = (t) => {
      var i, r;
      const n = [];
      if (t.target instanceof HTMLInputElement && t.target.files) {
        for (let c = 0; c < t.target.files.length; c++) {
          let d;
          (d = t.target.files.item(c)) && n.push({ name: d.name, file: d });
        }
        e.input(n);
      }
      e.context && (e.context.files = n), typeof ((i = e.props.attrs) == null ? void 0 : i.onChange) == "function" && ((r = e.props.attrs) == null || r.onChange(t));
    });
  });
}
var oS = /* @__PURE__ */ Vr({
  key: "loading",
  value: !0,
  visible: !1
});
async function BG(e, t) {
  const n = Math.random();
  if (e.props._submitNonce = n, t.preventDefault(), await e.settled, e.ledger.value("validating") && (e.store.set(oS), await e.ledger.settled("validating"), e.store.remove("loading"), e.props._submitNonce !== n))
    return;
  const i = (r) => r.store.set(
    /* @__PURE__ */ Vr({
      key: "submitted",
      value: !0,
      visible: !1
    })
  );
  if (e.walk(i), i(e), e.emit("submit-raw"), typeof e.props.onSubmitRaw == "function" && e.props.onSubmitRaw(t, e), e.ledger.value("blocking"))
    typeof e.props.onSubmitInvalid == "function" && e.props.onSubmitInvalid(e), e.props.incompleteMessage !== !1 && eD(e);
  else if (typeof e.props.onSubmit == "function") {
    const r = e.props.onSubmit(
      e.hook.submit.dispatch(Nu(e.value)),
      e
    );
    if (r instanceof Promise) {
      const c = e.props.disabled === void 0 && e.props.submitBehavior !== "live";
      c && (e.props.disabled = !0), e.store.set(oS), await r, c && (e.props.disabled = !1), e.store.remove("loading");
    }
  } else
    t.target instanceof HTMLFormElement && t.target.submit();
}
function eD(e) {
  e.store.set(
    /* @__PURE__ */ Vr({
      blocking: !1,
      key: "incomplete",
      meta: {
        localize: e.props.incompleteMessage === void 0,
        i18nArgs: [{ node: e }],
        showAsMessage: !0
      },
      type: "ui",
      value: e.props.incompleteMessage || "Form incomplete."
    })
  );
}
function VG(e) {
  var t;
  e.props.isForm = !0, e.ledger.count("validating", (n) => n.key === "validating"), (t = e.props).submitAttrs ?? (t.submitAttrs = {
    disabled: e.props.disabled
  }), e.on("prop:disabled", ({ payload: n }) => {
    e.props.submitAttrs = { ...e.props.submitAttrs, disabled: n };
  }), e.on("created", () => {
    var n;
    (n = e.context) != null && n.handlers && (e.context.handlers.submit = BG.bind(null, e)), Vn(e.props, "actions") || (e.props.actions = !0);
  }), e.on("prop:incompleteMessage", () => {
    e.store.incomplete && eD(e);
  }), e.on("settled:blocking", () => e.store.remove("incomplete"));
}
function UG(e) {
  e.props.ignore === void 0 && (e.props.ignore = !0, e.parent = null);
}
function HG(e) {
  e.on("created", () => {
    e.context && (e.context.initialValue = e.value || "");
  });
}
function tD(e) {
  if (typeof e.props.number > "u")
    return;
  const t = ["number", "range", "hidden"].includes(e.props.type);
  e.hook.input((n, i) => {
    if (n === "")
      return i(void 0);
    const r = e.props.number === "integer" ? parseInt(n) : parseFloat(n);
    return Number.isFinite(r) ? i(r) : i(t ? void 0 : n);
  });
}
function WG(e, t) {
  t.target instanceof HTMLInputElement && e.input(Fd(e.props.options, t.target.value));
}
function ZG(e, t) {
  var n, i;
  return (n = e.context) == null || n.value, (i = e.context) == null || i._value, Th(Fd(e.props.options, t), e._value);
}
function qG(e) {
  e.on("created", () => {
    var t, n;
    Array.isArray(e.props.options) || Vu(350, {
      node: e,
      inputType: "radio"
    }), (t = e.context) != null && t.handlers && (e.context.handlers.toggleChecked = WG.bind(null, e)), (n = e.context) != null && n.fns && (e.context.fns.isChecked = ZG.bind(null, e));
  }), e.hook.prop(JM(e));
}
function jG(e, t) {
  if (p_(t))
    return !1;
  e.context && e.context.value;
  const n = "__original" in t ? t.__original : t.value;
  return Array.isArray(e._value) ? e._value.some((i) => Th(i, n)) : (e._value === void 0 || e._value === null && !nD(e.props.options, null)) && t.attrs && t.attrs["data-is-placeholder"] ? !0 : Th(n, e._value);
}
function nD(e, t) {
  return e.some((n) => p_(n) ? nD(n.options, t) : ("__original" in n ? n.__original : n.value) === t);
}
async function GG(e, t) {
  var n;
  typeof ((n = e.props.attrs) == null ? void 0 : n.onChange) == "function" && (await new Promise((i) => setTimeout(i, 0)), await e.settled, e.props.attrs.onChange(t));
}
function YG(e, t) {
  const n = t.target, i = n.hasAttribute("multiple") ? Array.from(n.selectedOptions).map(
    (r) => Fd(e.props.options, r.value)
  ) : Fd(e.props.options, n.value);
  e.input(i);
}
function aS(e, t) {
  return e.some(
    (n) => n.attrs && n.attrs["data-is-placeholder"]
  ) ? e : [
    {
      label: t,
      value: "",
      attrs: {
        hidden: !0,
        disabled: !0,
        "data-is-placeholder": "true"
      }
    },
    ...e
  ];
}
function iD(e) {
  const t = e.length > 0 ? e[0] : void 0;
  if (t)
    return p_(t) ? iD(t.options) : "__original" in t ? t.__original : t.value;
}
function KG(e) {
  e.on("created", () => {
    var n, i, r;
    const t = on((n = e.props.attrs) == null ? void 0 : n.multiple);
    !t && e.props.placeholder && Array.isArray(e.props.options) && (e.hook.prop(({ prop: c, value: d }, a) => (c === "options" && (d = aS(d, e.props.placeholder)), a({ prop: c, value: d }))), e.props.options = aS(
      e.props.options,
      e.props.placeholder
    )), t ? e.value === void 0 && e.input([], !1) : e.context && !e.context.options && (e.props.attrs = Object.assign({}, e.props.attrs, {
      value: e._value
    }), e.on("input", ({ payload: c }) => {
      e.props.attrs = Object.assign({}, e.props.attrs, {
        value: c
      });
    })), (i = e.context) != null && i.handlers && (e.context.handlers.selectInput = YG.bind(null, e), e.context.handlers.onChange = GG.bind(null, e)), (r = e.context) != null && r.fns && (e.context.fns.isSelected = jG.bind(null, e), e.context.fns.showPlaceholder = (c, d) => {
      if (!Array.isArray(e.props.options))
        return !1;
      const a = e.props.options.some(
        (f) => {
          if (f.attrs && "data-is-placeholder" in f.attrs)
            return !1;
          const g = "__original" in f ? f.__original : f.value;
          return vn(c, g);
        }
      );
      return d && !a ? !0 : void 0;
    });
  }), e.hook.input((t, n) => {
    var i, r, c;
    return !e.props.placeholder && t === void 0 && Array.isArray((i = e.props) == null ? void 0 : i.options) && e.props.options.length && !on((c = (r = e.props) == null ? void 0 : r.attrs) == null ? void 0 : c.multiple) && (t = iD(e.props.options)), n(t);
  });
}
// @__NO_SIDE_EFFECTS__
function Am(e) {
  return !!(Hp(e) && e.if && e.if.startsWith("$slots.") && typeof e.then == "string" && e.then.startsWith("$slots.") && "else" in e);
}
// @__NO_SIDE_EFFECTS__
function XG(e, t = {}) {
  const n = /* @__PURE__ */ Uu(
    /* @__PURE__ */ Qh(
      /* @__PURE__ */ Xm("$label"),
      /* @__PURE__ */ Km(/* @__PURE__ */ Ar("prefix"), /* @__PURE__ */ Vl(), e(), /* @__PURE__ */ Ul(), /* @__PURE__ */ Ar("suffix"))
    ),
    /* @__PURE__ */ Bl("$help"),
    /* @__PURE__ */ Uc(/* @__PURE__ */ Vc("$message.value"))
  );
  return (i = {}) => n(Fc(t, i));
}
// @__NO_SIDE_EFFECTS__
function Tc(e, t, n) {
  const i = (r) => {
    const c = t(r);
    if (n || Im(c) && "if" in c || /* @__PURE__ */ Am(c)) {
      const d = {
        if: e,
        then: c
      };
      return n && (d.else = n(r)), d;
    } else /* @__PURE__ */ Am(c) ? Object.assign(c.else, { if: e }) : Im(c) && Object.assign(c, { if: e });
    return c;
  };
  return i._s = Jh(), i;
}
// @__NO_SIDE_EFFECTS__
function uh(e, t) {
  const n = (i) => {
    const r = e({});
    return /* @__PURE__ */ Am(r) ? (Array.isArray(r.else) || (r.else = /* @__PURE__ */ Sd(
      /* @__PURE__ */ Sd(r.else, t),
      e._s ? i[e._s] : {}
    )), r) : /* @__PURE__ */ Sd(
      /* @__PURE__ */ Sd(r, t),
      e._s ? i[e._s] : {}
    );
  };
  return n._s = e._s, n;
}
var lS = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Uu(
    /* @__PURE__ */ Uc(/* @__PURE__ */ Vc("$message.value")),
    /* @__PURE__ */ Qh(
      /* @__PURE__ */ xG(
        /* @__PURE__ */ Ar("prefix"),
        /* @__PURE__ */ Vl(),
        /* @__PURE__ */ $G("$label || $ui.submit.value"),
        /* @__PURE__ */ Ul(),
        /* @__PURE__ */ Ar("suffix")
      )
    ),
    /* @__PURE__ */ Bl("$help")
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */
  family: "button",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [bi("submit"), UG],
  /**
   * A key to use for memoizing the schema. This is used to prevent the schema
   * from needing to be stringified when performing a memo lookup.
   */
  schemaMemoKey: "h6st4epl3j8"
}, JG = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Uu(
    /* @__PURE__ */ Tc(
      "$options == undefined",
      /**
       * Single checkbox structure.
       */
      /* @__PURE__ */ xy(
        /* @__PURE__ */ by(/* @__PURE__ */ Vl(), /* @__PURE__ */ _y(), /* @__PURE__ */ $y(/* @__PURE__ */ Ar("decorator")), /* @__PURE__ */ Ul()),
        /* @__PURE__ */ uh(/* @__PURE__ */ wy("$label"), {
          if: "$label"
        })
      ),
      /**
       * Multi checkbox structure.
       */
      /* @__PURE__ */ GM(
        /* @__PURE__ */ YM("$label"),
        /* @__PURE__ */ Bl("$help"),
        /* @__PURE__ */ jM(
          /* @__PURE__ */ qM(
            /* @__PURE__ */ xy(
              /* @__PURE__ */ by(
                /* @__PURE__ */ Vl(),
                /* @__PURE__ */ uh(/* @__PURE__ */ _y(), {
                  bind: "$option.attrs",
                  attrs: {
                    id: "$option.attrs.id",
                    value: "$option.value",
                    checked: "$fns.isChecked($option.value)"
                  }
                }),
                /* @__PURE__ */ $y(/* @__PURE__ */ Ar("decorator")),
                /* @__PURE__ */ Ul()
              ),
              /* @__PURE__ */ uh(/* @__PURE__ */ wy("$option.label"), {
                if: "$option.label"
              })
            ),
            /* @__PURE__ */ ZM("$option.help")
          )
        )
      )
    ),
    // Help text only goes under the input when it is a single.
    /* @__PURE__ */ Tc("$options == undefined && $help", /* @__PURE__ */ Bl("$help")),
    /* @__PURE__ */ Uc(/* @__PURE__ */ Vc("$message.value"))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */
  family: "box",
  /**
   * An array of extra props to accept for this input.
   */
  props: ["options", "onValue", "offValue", "optionsLoader"],
  /**
   * Additional features that should be added to your input
   */
  features: [
    Zl,
    RG,
    Qn("decorator", "checkboxDecorator")
  ],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "qje02tb3gu8"
}, QG = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Uu(
    /* @__PURE__ */ Qh(
      /* @__PURE__ */ Xm("$label"),
      /* @__PURE__ */ Km(
        /* @__PURE__ */ Ar("prefix", "label"),
        /* @__PURE__ */ Vl(),
        /* @__PURE__ */ CG(),
        /* @__PURE__ */ SG(
          /* @__PURE__ */ kG(
            /* @__PURE__ */ Ar("fileItem"),
            /* @__PURE__ */ TG("$file.name"),
            /* @__PURE__ */ Tc(
              "$value.length === 1",
              /* @__PURE__ */ nS(
                /* @__PURE__ */ Ar("fileRemove"),
                '$ui.remove.value + " " + $file.name'
              )
            )
          )
        ),
        /* @__PURE__ */ Tc("$value.length > 1", /* @__PURE__ */ nS("$ui.removeAll.value")),
        /* @__PURE__ */ AG(/* @__PURE__ */ Ar("noFiles"), "$ui.noFiles.value"),
        /* @__PURE__ */ Ul(),
        /* @__PURE__ */ Ar("suffix")
      )
    ),
    /* @__PURE__ */ Bl("$help"),
    /* @__PURE__ */ Uc(/* @__PURE__ */ Vc("$message.value"))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */
  family: "text",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [
    zG,
    Qn("fileItem", "fileItem"),
    Qn("fileRemove", "fileRemove"),
    Qn("noFiles", "noFiles")
  ],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "9kqc4852fv8"
}, eY = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ IG(
    "$slots.default",
    /* @__PURE__ */ Uc(/* @__PURE__ */ Vc("$message.value")),
    /* @__PURE__ */ wG(/* @__PURE__ */ MG())
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "group",
  /**
   * An array of extra props to accept for this input.
   */
  props: [
    "actions",
    "submit",
    "submitLabel",
    "submitAttrs",
    "submitBehavior",
    "incompleteMessage"
  ],
  /**
   * Additional features that should be added to your input
   */
  features: [VG, h_],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "5bg016redjo"
}, tY = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Ex("$slots.default"),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "group",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [h_, XM]
}, nY = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ KM(),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [tD]
}, iY = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Ex("$slots.default"),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "list",
  /**
   * An array of extra props to accept for this input.
   */
  props: ["sync", "dynamic"],
  /**
   * Additional features that should be added to your input
   */
  features: [h_, XM]
}, rY = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Ex(),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: []
}, sY = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Uu(
    /* @__PURE__ */ Tc(
      "$options == undefined",
      /**
       * Single radio structure.
       */
      /* @__PURE__ */ xy(
        /* @__PURE__ */ by(/* @__PURE__ */ Vl(), /* @__PURE__ */ _y(), /* @__PURE__ */ $y(/* @__PURE__ */ Ar("decorator")), /* @__PURE__ */ Ul()),
        /* @__PURE__ */ uh(/* @__PURE__ */ wy("$label"), {
          if: "$label"
        })
      ),
      /**
       * Multi radio structure.
       */
      /* @__PURE__ */ GM(
        /* @__PURE__ */ YM("$label"),
        /* @__PURE__ */ Bl("$help"),
        /* @__PURE__ */ jM(
          /* @__PURE__ */ qM(
            /* @__PURE__ */ xy(
              /* @__PURE__ */ by(
                /* @__PURE__ */ Vl(),
                /* @__PURE__ */ uh(/* @__PURE__ */ _y(), {
                  bind: "$option.attrs",
                  attrs: {
                    id: "$option.attrs.id",
                    value: "$option.value",
                    checked: "$fns.isChecked($option.value)"
                  }
                }),
                /* @__PURE__ */ $y(/* @__PURE__ */ Ar("decorator")),
                /* @__PURE__ */ Ul()
              ),
              /* @__PURE__ */ uh(/* @__PURE__ */ wy("$option.label"), {
                if: "$option.label"
              })
            ),
            /* @__PURE__ */ ZM("$option.help")
          )
        )
      )
    ),
    // Help text only goes under the input when it is a single.
    /* @__PURE__ */ Tc("$options == undefined && $help", /* @__PURE__ */ Bl("$help")),
    /* @__PURE__ */ Uc(/* @__PURE__ */ Vc("$message.value"))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */
  family: "box",
  /**
   * An array of extra props to accept for this input.
   */
  props: ["options", "onValue", "offValue", "optionsLoader"],
  /**
   * Additional features that should be added to your input
   */
  features: [Zl, qG, Qn("decorator", "radioDecorator")],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "qje02tb3gu8"
}, oY = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Uu(
    /* @__PURE__ */ Qh(
      /* @__PURE__ */ Xm("$label"),
      /* @__PURE__ */ Km(
        /* @__PURE__ */ Ar("prefix"),
        /* @__PURE__ */ Vl(),
        /* @__PURE__ */ PG(
          /* @__PURE__ */ Tc(
            "$slots.default",
            () => "$slots.default",
            /* @__PURE__ */ rS(
              /* @__PURE__ */ Tc(
                "$option.group",
                /* @__PURE__ */ EG(/* @__PURE__ */ rS(/* @__PURE__ */ iS("$option.label"))),
                /* @__PURE__ */ iS("$option.label")
              )
            )
          )
        ),
        /* @__PURE__ */ Tc("$attrs.multiple !== undefined", () => "", /* @__PURE__ */ Ar("select")),
        /* @__PURE__ */ Ul(),
        /* @__PURE__ */ Ar("suffix")
      )
    ),
    /* @__PURE__ */ Bl("$help"),
    /* @__PURE__ */ Uc(/* @__PURE__ */ Vc("$message.value"))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * An array of extra props to accept for this input.
   */
  props: ["options", "placeholder", "optionsLoader"],
  /**
   * Additional features that should be added to your input
   */
  features: [Zl, KG, Qn("select", "select")],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "cb119h43krg"
}, aY = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Uu(
    /* @__PURE__ */ Qh(
      /* @__PURE__ */ Xm("$label"),
      /* @__PURE__ */ Km(
        /* @__PURE__ */ Ar("prefix", "label"),
        /* @__PURE__ */ Vl(),
        /* @__PURE__ */ DG(),
        /* @__PURE__ */ Ul(),
        /* @__PURE__ */ Ar("suffix")
      )
    ),
    /* @__PURE__ */ Bl("$help"),
    /* @__PURE__ */ Uc(/* @__PURE__ */ Vc("$message.value"))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [HG],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "b1n0td79m9g"
}, vo = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: /* @__PURE__ */ Uu(
    /* @__PURE__ */ Qh(
      /* @__PURE__ */ Xm("$label"),
      /* @__PURE__ */ Km(
        /* @__PURE__ */ Ar("prefix", "label"),
        /* @__PURE__ */ Vl(),
        /* @__PURE__ */ KM(),
        /* @__PURE__ */ Ul(),
        /* @__PURE__ */ Ar("suffix")
      )
    ),
    /* @__PURE__ */ Bl("$help"),
    /* @__PURE__ */ Uc(/* @__PURE__ */ Vc("$message.value"))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: "input",
  /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */
  family: "text",
  /**
   * An array of extra props to accept for this input.
   */
  props: [],
  /**
   * Additional features that should be added to your input
   */
  features: [tD],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: "c3cc4kflsg"
}, lY = {
  button: lS,
  submit: lS,
  checkbox: JG,
  file: QG,
  form: eY,
  group: tY,
  hidden: nY,
  list: iY,
  meta: rY,
  radio: sY,
  select: oY,
  textarea: aY,
  text: vo,
  color: vo,
  date: vo,
  datetimeLocal: vo,
  email: vo,
  month: vo,
  number: vo,
  password: vo,
  search: vo,
  tel: vo,
  time: vo,
  url: vo,
  week: vo,
  range: vo
}, Ya = void 0, Sl = null, Cy, rD = !1, em = !1, cY = /* @__PURE__ */ new Promise((e) => {
  Cy = () => {
    rD = !0, e();
  };
}), Ic = typeof window < "u" && typeof fetch < "u";
Ya = Ic ? /* @__PURE__ */ getComputedStyle(document.documentElement) : void 0;
var Jp = {}, e0 = {};
function uY(e, t, n, i) {
  t && Object.assign(Jp, t), Ic && !em && (Ya != null && Ya.getPropertyValue("--formkit-theme")) ? (Cy(), em = !0) : e && !em && Ic ? dY(e) : !em && Ic && Cy();
  const r = function(d) {
    var a, f;
    d.addProps(["iconLoader", "iconLoaderUrl"]), d.props.iconHandler = cS(
      (a = d.props) != null && a.iconLoader ? d.props.iconLoader : i,
      (f = d.props) != null && f.iconLoaderUrl ? d.props.iconLoaderUrl : n
    ), fY(d, d.props.iconHandler), d.on("created", () => {
      var g, x;
      (g = d == null ? void 0 : d.context) != null && g.handlers && (d.context.handlers.iconClick = ($) => {
        const A = `on${$.charAt(0).toUpperCase()}${$.slice(1)}IconClick`, I = d.props[A];
        if (I && typeof I == "function")
          return (O) => I(d, O);
      }), (x = d == null ? void 0 : d.context) != null && x.fns && (d.context.fns.iconRole = ($) => {
        const A = `on${$.charAt(0).toUpperCase()}${$.slice(1)}IconClick`;
        return typeof d.props[A] == "function" ? "button" : null;
      });
    });
  };
  return r.iconHandler = cS(i, n), r;
}
function dY(e) {
  if (!(!e || !Ic || typeof getComputedStyle != "function") && (em = !0, Sl = document.getElementById("formkit-theme"), e && // if we have a window object
  Ic && // we don't have an existing theme OR the theme being set up is different
  (!(Ya != null && Ya.getPropertyValue("--formkit-theme")) && !Sl || Sl != null && Sl.getAttribute("data-theme") && (Sl == null ? void 0 : Sl.getAttribute("data-theme")) !== e))) {
    const n = `https://cdn.jsdelivr.net/npm/@formkit/themes@${vy.startsWith("__") ? "latest" : vy}/dist/${e}/theme.css`, i = document.createElement("link");
    i.type = "text/css", i.rel = "stylesheet", i.id = "formkit-theme", i.setAttribute("data-theme", e), i.onload = () => {
      Ya = getComputedStyle(document.documentElement), Cy();
    }, document.head.appendChild(i), i.href = n, Sl && Sl.remove();
  }
}
function cS(e, t) {
  return (n) => {
    if (typeof n != "string")
      return;
    if (n.startsWith("<svg"))
      return n;
    const i = n.startsWith("default:");
    n = i ? n.split(":")[1] : n;
    const r = n in Jp;
    let c;
    if (r)
      return Jp[n];
    if (!e0[n]) {
      if (c = pY(n), c = Ic && typeof c > "u" ? Promise.resolve(c) : c, c instanceof Promise)
        e0[n] = c.then((d) => !d && typeof n == "string" && !i ? c = typeof e == "function" ? e(n) : hY(n, t) : d).then((d) => (typeof n == "string" && (Jp[i ? `default:${n}` : n] = d), d));
      else if (typeof c == "string")
        return Jp[i ? `default:${n}` : n] = c, c;
    }
    return e0[n];
  };
}
function pY(e) {
  if (Ic)
    return rD ? uS(e) : cY.then(() => uS(e));
}
function uS(e) {
  const t = Ya == null ? void 0 : Ya.getPropertyValue(`--fk-icon-${e}`);
  if (t) {
    const n = atob(t);
    if (n.startsWith("<svg"))
      return Jp[e] = n, n;
  }
}
function hY(e, t) {
  const n = vy.startsWith("__") ? "latest" : vy, i = typeof t == "function" ? t(e) : `https://cdn.jsdelivr.net/npm/@formkit/icons@${n}/dist/icons/${e}.svg`;
  if (Ic)
    return fetch(`${i}`).then(async (r) => {
      const c = await r.text();
      if (c.startsWith("<svg"))
        return c;
    }).catch((r) => {
      console.error(r);
    });
}
function fY(e, t) {
  const n = /^[a-zA-Z-]+(?:-icon|Icon)$/;
  Object.keys(e.props).filter((r) => n.test(r)).forEach((r) => mY(e, t, r));
}
function mY(e, t, n) {
  const i = e.props[n], r = t(i), c = `_raw${n.charAt(0).toUpperCase()}${n.slice(1)}`, d = `on${n.charAt(0).toUpperCase()}${n.slice(1)}Click`;
  if (e.addProps([c, d]), e.on(`prop:${n}`, vY), r instanceof Promise)
    return r.then((a) => {
      e.props[c] = a;
    });
  e.props[c] = r;
}
function vY(e) {
  var d;
  const t = e.origin, n = e.payload, i = (d = t == null ? void 0 : t.props) == null ? void 0 : d.iconHandler, r = e.name.split(":")[1], c = `_raw${r.charAt(0).toUpperCase()}${r.slice(1)}`;
  if (i && typeof i == "function") {
    const a = i(n);
    if (a instanceof Promise)
      return a.then((f) => {
        t.props[c] = f;
      });
    t.props[c] = a;
  }
}
var dS = {
  /**
   * FormKit errors:
   */
  100: ({ data: e }) => `Only groups, lists, and forms can have children (${e.name}).`,
  101: ({ data: e }) => `You cannot directly modify the store (${e.name}). See: https://formkit.com/advanced/core#message-store`,
  102: ({
    data: [e, t]
  }) => `You cannot directly assign node.${t} (${e.name})`,
  103: ({ data: [e] }) => `Schema expressions cannot start with an operator (${e})`,
  104: ({ data: [e, t] }) => `Schema expressions cannot end with an operator (${e} in "${t}")`,
  105: ({ data: e }) => `Invalid schema expression: ${e}`,
  106: ({ data: e }) => `Cannot submit because (${e}) is not in a form.`,
  107: ({ data: [e, t] }) => `Cannot set ${e.name} to non object value: ${t}`,
  108: ({ data: [e, t] }) => `Cannot set ${e.name} to non array value: ${t}`,
  /**
   * Input specific errors:
   */
  300: ({ data: [e] }) => `Cannot set behavior prop to overscroll (on ${e.name} input) when options prop is a function.`,
  /**
   * FormKit vue errors:
   */
  600: ({ data: e }) => `Unknown input type${typeof e.props.type == "string" ? ' "' + e.props.type + '"' : ""} ("${e.name}")`,
  601: ({ data: e }) => `Input definition${typeof e.props.type == "string" ? ' "' + e.props.type + '"' : ""} is missing a schema or component property (${e.name}).`
}, pS = {
  /**
   * Core warnings:
   */
  150: ({ data: e }) => `Schema function "${e}()" is not a valid function.`,
  151: ({ data: e }) => `No form element with id: ${e}`,
  152: ({ data: e }) => `No input element with id: ${e}`,
  /**
   * Input specific warnings:
   */
  350: ({
    data: { node: e, inputType: t }
  }) => `Invalid options prop for ${e.name} input (${t}). See https://formkit.com/inputs/${t}`,
  /**
   * Vue warnings:
   */
  650: 'Schema "$get()" must use the id of an input to access.',
  651: ({ data: e }) => `Cannot setErrors() on "${e}" because no such id exists.`,
  652: ({ data: e }) => `Cannot clearErrors() on "${e}" because no such id exists.`,
  /**
   * Deprecation warnings:
   */
  800: ({ data: e }) => `${e} is deprecated.`
}, gY = (e, t) => {
  if (e.code in dS) {
    const n = dS[e.code];
    e.message = typeof n == "function" ? n(e) : n;
  }
  return t(e);
}, hS = !1;
function yY() {
  hS || ($x(gY), Cx(_Y), hS = !0);
}
var _Y = (e, t) => {
  if (e.code in pS) {
    const n = pS[e.code];
    e.message = typeof n == "function" ? n(e) : n;
  }
  return t(e);
}, bY = Object.defineProperty, wY = Object.getOwnPropertyNames, sD = (e, t) => function() {
  return e && (t = (0, e[wY(e)[0]])(e = 0)), t;
}, xY = (e, t) => {
  for (var n in t)
    bY(e, n, { get: t[n], enumerable: !0 });
}, fS, oD, aD = sD({
  "packages/vue/src/bindings.ts"() {
    fS = function(t) {
      t.ledger.count("blocking", (re) => re.blocking);
      const n = $e(!t.ledger.value("blocking"));
      t.ledger.count("errors", (re) => re.type === "error");
      const i = $e(!!t.ledger.value("errors"));
      let r = !1;
      Rl(() => {
        r = !0;
      });
      const c = Er(
        t.store.reduce((re, le) => (le.visible && (re[le.key] = le), re), {})
      ), d = $e(
        t.props.validationVisibility || (t.props.type === "checkbox" ? "dirty" : "blur")
      );
      t.on("prop:validationVisibility", ({ payload: re }) => {
        d.value = re;
      });
      const a = $e(d.value === "live"), f = $e(!1), g = (re) => {
        f.value = (re ?? []).some(
          (le) => le.name === "required"
        );
      };
      g(t.props.parsedRules), t.on("prop:parsedRules", ({ payload: re }) => g(re));
      const x = $e(t.children.map((re) => re.uid)), $ = Ae(() => {
        if (!ae.state)
          return !1;
        if (ae.state.submitted)
          return !0;
        if (!a.value && !ae.state.settled)
          return !1;
        switch (d.value) {
          case "live":
            return !0;
          case "blur":
            return ae.state.blurred;
          case "dirty":
            return ae.state.dirty;
          default:
            return !1;
        }
      }), A = Ae(() => ae.state.failing && $.value), I = Ae(() => ae && O.value ? n.value && !i.value : ae.state.dirty && !ma(ae.value)), O = $e(
        Array.isArray(t.props.parsedRules) && t.props.parsedRules.length > 0
      );
      t.on("prop:parsedRules", ({ payload: re }) => {
        O.value = Array.isArray(re) && re.length > 0;
      });
      const B = Ae(() => {
        const re = {};
        for (const le in c) {
          const pe = c[le];
          (pe.type !== "validation" || $.value) && (re[le] = pe);
        }
        return re;
      }), H = Er(
        t.store.reduce((re, le) => (le.type === "ui" && le.visible && (re[le.key] = le), re), {})
      ), N = Ae(() => !ae.state.failing), K = Er({}), U = new Proxy(K, {
        get(...re) {
          if (!t)
            return "";
          const [le, pe] = re;
          let Ne = Reflect.get(...re);
          return !Ne && typeof pe == "string" && !Vn(le, pe) && !pe.startsWith("__v") && d_(t).watch((Ge) => {
            const et = typeof Ge.config.rootClasses == "function" ? Ge.config.rootClasses(pe, Ge) : {}, ft = Ge.config.classes ? Tg(pe, Ge, Ge.config.classes[pe]) : {}, De = Tg(
              pe,
              Ge,
              Ge.props[`_${pe}Class`]
            ), Ke = Tg(
              pe,
              Ge,
              Ge.props[`${pe}Class`]
            );
            Ne = P7(
              Ge,
              pe,
              et,
              ft,
              De,
              Ke
            ), le[pe] = Ne ?? "";
          }), Ne;
        }
      });
      t.on("prop:rootClasses", () => {
        const re = Object.keys(K);
        for (const le of re)
          delete K[le];
      });
      const q = Ae(() => {
        if (!t)
          return;
        const re = [];
        ae.help && re.push(`help-${t.props.id}`);
        for (const le in B.value)
          re.push(`${t.props.id}-${le}`);
        return re.length ? re.join(" ") : void 0;
      }), ee = $e(t.value), te = $e(t.value), ae = Er({
        _value: te,
        attrs: t.props.attrs,
        disabled: t.props.disabled,
        describedBy: q,
        fns: {
          length: (re) => Object.keys(re).length,
          number: (re) => Number(re),
          string: (re) => String(re),
          json: (re) => JSON.stringify(re),
          eq: vn
        },
        handlers: {
          blur: (re) => {
            t && (t.store.set(
              /* @__PURE__ */ Vr({ key: "blurred", visible: !1, value: !0 })
            ), typeof t.props.attrs.onBlur == "function" && t.props.attrs.onBlur(re));
          },
          touch: () => {
            var pe;
            const re = ae.dirtyBehavior === "compare";
            if ((pe = t.store.dirty) != null && pe.value && !re)
              return;
            const le = !vn(t.props._init, t._value);
            !le && !re || t.store.set(
              /* @__PURE__ */ Vr({ key: "dirty", visible: !1, value: le })
            );
          },
          DOMInput: (re) => {
            t.input(re.target.value), t.emit("dom-input-event", re);
          }
        },
        help: t.props.help,
        id: t.props.id,
        items: x,
        label: t.props.label,
        messages: B,
        didMount: !1,
        node: Gy(t),
        options: t.props.options,
        defaultMessagePlacement: !0,
        slots: t.props.__slots,
        state: {
          blurred: !1,
          complete: I,
          dirty: !1,
          empty: ma(ee),
          submitted: !1,
          settled: t.isSettled,
          valid: n,
          invalid: A,
          errors: i,
          rules: O,
          validationVisible: $,
          required: f,
          failing: !1,
          passing: N
        },
        type: t.props.type,
        family: t.props.family,
        ui: H,
        value: ee,
        classes: U
      });
      t.on("created", () => {
        vn(ae.value, t.value) || (te.value = t.value, ee.value = t.value, Iv(ee), Iv(te)), (async () => (await t.settled, t && (t.props._init = ua(t.value))))();
      }), t.on("mounted", () => {
        ae.didMount = !0;
      }), t.on("settled", ({ payload: re }) => {
        ae.state.settled = re;
      });
      function oe(re) {
        (Array.isArray(re) ? re : Object.keys(re)).forEach((pe) => {
          pe = ch(pe), Vn(ae, pe) || (ae[pe] = t.props[pe]), t.on(`prop:${pe}`, ({ payload: Ne }) => {
            ae[pe] = Ne;
          });
        });
      }
      oe((() => {
        const re = [
          "__root",
          "help",
          "label",
          "disabled",
          "options",
          "type",
          "attrs",
          "preserve",
          "preserveErrors",
          "id",
          "dirtyBehavior"
        ], le = /^[a-zA-Z-]+(?:-icon|Icon)$/, pe = Object.keys(t.props).filter((Ne) => le.test(Ne));
        return re.concat(pe);
      })());
      function me(re) {
        re.props && oe(re.props);
      }
      t.props.definition && me(t.props.definition), t.on("added-props", ({ payload: re }) => oe(re)), t.on("input", ({ payload: re }) => {
        t.type !== "input" && !yo(re) && !X0(re) ? te.value = Pw(re) : (te.value = re, Iv(te));
      }), t.on("commitRaw", ({ payload: re }) => {
        t.type !== "input" && !yo(re) && !X0(re) ? ee.value = te.value = Pw(re) : (ee.value = te.value = re, Iv(ee)), t.emit("modelUpdated");
      }), t.on("commit", ({ payload: re }) => {
        var le;
        if ((!ae.state.dirty || ae.dirtyBehavior === "compare") && t.isCreated && r)
          if (!((le = t.store.validating) != null && le.value))
            ae.handlers.touch();
          else {
            const pe = t.on("message-removed", ({ payload: Ne }) => {
              Ne.key === "validating" && (ae.handlers.touch(), t.off(pe));
            });
          }
        I && t.type === "input" && i.value && !on(t.props.preserveErrors) && t.store.filter(
          (pe) => {
            var Ne;
            return !(pe.type === "error" && ((Ne = pe.meta) == null ? void 0 : Ne.autoClear) === !0);
          }
        ), t.type === "list" && t.sync && (x.value = t.children.map((pe) => pe.uid)), ae.state.empty = ma(re);
      });
      const ve = async (re) => {
        re.type === "ui" && re.visible && !re.meta.showAsMessage ? H[re.key] = re : re.visible ? c[re.key] = re : re.type === "state" && (ae.state[re.key] = !!re.value);
      };
      t.on("message-added", (re) => ve(re.payload)), t.on("message-updated", (re) => ve(re.payload)), t.on("message-removed", ({ payload: re }) => {
        delete H[re.key], delete c[re.key], delete ae.state[re.key];
      }), t.on("settled:blocking", () => {
        n.value = !0;
      }), t.on("unsettled:blocking", () => {
        n.value = !1;
      }), t.on("settled:errors", () => {
        i.value = !1;
      }), t.on("unsettled:errors", () => {
        i.value = !0;
      }), At($, (re) => {
        re && (a.value = !0);
      }), t.context = ae, t.emit("context", t, !1), t.on("destroyed", () => {
        t.context = void 0, t = null;
      });
    }, oD = fS;
  }
}), $Y = {};
xY($Y, {
  defaultConfig: () => Px
});
var Px, CY = sD({
  "packages/vue/src/defaultConfig.ts"() {
    aD(), Px = (e = {}) => {
      yY();
      const {
        rules: t = {},
        locales: n = {},
        inputs: i = {},
        messages: r = {},
        locale: c = void 0,
        theme: d = void 0,
        iconLoaderUrl: a = void 0,
        iconLoader: f = void 0,
        icons: g = {},
        ...x
      } = e, $ = J9({
        ...X9,
        ...t || {}
      }), A = gG(
        Fc({ en: WM, ...n || {} }, r)
      ), I = yG(lY, i), O = uY(d, g, a, f);
      return Fc(
        {
          plugins: [I, O, oD, A, $],
          ...c ? { config: { locale: c } } : {}
        },
        x || {},
        !0
      );
    };
  }
}), kY = typeof window > "u", t0 = /* @__PURE__ */ new Map();
function SY(e, t) {
  var n;
  !kY || !e || (t0.has(e) || t0.set(e, /* @__PURE__ */ new Set()), (n = t0.get(e)) == null || n.add(t));
}
var lD = typeof window > "u", cm = {}, dh = {}, io, Cc = /* @__PURE__ */ new WeakMap(), TY = "__raw__", IY = /[a-zA-Z0-9\-][cC]lass$/;
function AY(e, t) {
  const n = $e(null);
  if (e === "get") {
    const r = {};
    return n.value = EY.bind(null, r), n;
  }
  const i = e.split(".");
  return ra(() => {
    n.value = Mx(
      yo(t) ? t.value : t,
      i
    );
  }), n;
}
function Mx(e, t) {
  if (Array.isArray(e)) {
    for (const r of e) {
      const c = r !== !1 && Mx(r, t);
      if (c !== void 0)
        return c;
    }
    return;
  }
  let n, i = e;
  for (const r in t) {
    const c = t[r];
    if (typeof i != "object" || i === null) {
      n = void 0;
      break;
    }
    const d = i[c];
    if (Number(r) === t.length - 1 && d !== void 0) {
      n = typeof d == "function" ? d.bind(i) : d;
      break;
    }
    i = d;
  }
  return n;
}
function EY(e, t) {
  if (typeof t != "string")
    return Vu(650);
  if (t in e || (e[t] = $e(void 0)), e[t].value === void 0) {
    e[t].value = null;
    const n = Gm(t);
    n && (e[t].value = n.context), Nj(t, ({ payload: i }) => {
      e[t].value = Ym(i) ? i.context : i;
    });
  }
  return e[t].value;
}
function mS(e, t, n) {
  function i(I, O) {
    const B = $(Ha(O.if), { if: !0 }), H = g(I, O.then), N = O.else ? g(I, O.else) : null;
    return [B, H, N];
  }
  function r(I, O) {
    var K, U;
    const B = $(Ha(I.if));
    let H = () => O, N = () => O;
    return typeof I.then == "object" ? N = c(I.then, void 0) : typeof I.then == "string" && ((K = I.then) != null && K.startsWith("$")) ? N = $(Ha(I.then)) : N = () => I.then, Vn(I, "else") && (typeof I.else == "object" ? H = c(I.else) : typeof I.else == "string" && ((U = I.else) != null && U.startsWith("$")) ? H = $(Ha(I.else)) : H = () => I.else), () => B() ? N() : H();
  }
  function c(I, O, B = {}) {
    const H = new Set(Object.keys(I || {})), N = O ? $(Ha(O)) : () => ({}), K = [
      (U) => {
        const q = N();
        for (const ee in q)
          H.has(ee) || (U[ee] = q[ee]);
      }
    ];
    if (I) {
      if (Hp(I))
        return r(
          I,
          B
        );
      for (let U in I) {
        const q = I[U];
        let ee;
        const te = typeof q == "string";
        U.startsWith(TY) ? (U = U.substring(7), ee = () => q) : te && q.startsWith("$") && q.length > 1 && !(q.startsWith("$reset") && IY.test(U)) ? ee = $(Ha(q)) : typeof q == "object" && Hp(q) ? ee = r(q, void 0) : typeof q == "object" && Ou(q) ? ee = c(q) : ee = () => q, K.push((ae) => {
          ae[U] = ee();
        });
      }
    }
    return () => {
      const U = Array.isArray(I) ? [] : {};
      return K.forEach((q) => q(U)), U;
    };
  }
  function d(I, O) {
    let B = null, H = () => null, N = !1, K = null, U = null, q = null, ee = !1;
    const te = E7(O);
    if (Nd(te) ? (B = te.$el, H = te.$el !== "text" ? c(te.attrs, te.bind) : () => null) : Tm(te) ? (typeof te.$cmp == "string" ? Vn(I, te.$cmp) ? B = I[te.$cmp] : (B = te.$cmp, ee = !0) : B = te.$cmp, H = c(te.props, te.bind)) : Hp(te) && ([N, K, U] = i(I, te)), !Hp(te) && "if" in te ? N = $(Ha(te.if)) : !Hp(te) && B === null && (N = () => !0), "children" in te && te.children)
      if (typeof te.children == "string")
        if (te.children.startsWith("$slots."))
          B = B === "text" ? "slot" : B, K = $(Ha(te.children));
        else if (te.children.startsWith("$") && te.children.length > 1) {
          const ae = $(Ha(te.children));
          K = () => String(ae());
        } else
          K = () => String(te.children);
      else if (Array.isArray(te.children))
        K = g(I, te.children);
      else {
        const [ae, oe, de] = i(I, te.children);
        K = (me) => ae && ae() ? oe && oe(me) : de && de(me);
      }
    if (Tm(te))
      if (K) {
        const ae = K;
        K = (oe) => ({
          default(de, me) {
            var le, pe, Ne, We;
            const ve = io;
            me && (io = me), de && ((le = Cc.get(io)) == null || le.unshift(de)), oe && ((pe = Cc.get(io)) == null || pe.unshift(oe));
            const re = ae(oe);
            return de && ((Ne = Cc.get(io)) == null || Ne.shift()), oe && ((We = Cc.get(io)) == null || We.shift()), io = ve, re;
          }
        }), K.slot = !0;
      } else
        K = () => ({});
    if ("for" in te && te.for) {
      const ae = te.for.length === 3 ? te.for[2] : te.for[1];
      q = [
        typeof ae == "string" && ae.startsWith("$") ? $(Ha(ae)) : () => ae,
        te.for[0],
        te.for.length === 3 ? String(te.for[1]) : null
      ];
    }
    return [N, B, H, K, U, q, ee];
  }
  function a(I, O) {
    const B = I(O), H = io;
    return Object.keys(B).reduce((N, K) => {
      const U = B && B[K];
      return N[K] = (q) => U && U(q, H) || null, N;
    }, {});
  }
  function f(I, O) {
    const [B, H, N, K, U, q, ee] = d(I, O);
    let te = (ae) => {
      if (B && H === null && K)
        return B() ? K(ae) : U && U(ae);
      if (H && (!B || B())) {
        if (H === "text" && K)
          return mt(String(K()));
        if (H === "slot" && K)
          return K(ae);
        const oe = ee ? Ur(H) : H, de = K != null && K.slot ? a(K, ae) : null;
        return ym(
          oe,
          N(),
          de || (K ? K(ae) : [])
        );
      }
      return typeof U == "function" ? U(ae) : U;
    };
    if (q) {
      const ae = te, [oe, de, me] = q;
      te = () => {
        const ve = oe(), re = Number.isFinite(ve) ? Array(Number(ve)).fill(0).map((We, Ge) => Ge) : ve, le = [];
        if (typeof re != "object")
          return null;
        const pe = Cc.get(io) || [], Ne = Array.isArray(re);
        for (const We in re) {
          if (Ne && We in Array.prototype)
            continue;
          const Ge = Object.defineProperty(
            {
              ...pe.reduce(
                (et, ft) => et.__idata ? { ...et, ...ft } : ft,
                {}
              ),
              [de]: re[We],
              ...me !== null ? { [me]: Ne ? Number(We) : We } : {}
            },
            "__idata",
            { enumerable: !1, value: !0 }
          );
          pe.unshift(Ge), le.push(ae.bind(null, Ge)()), pe.shift();
        }
        return le;
      };
    }
    return te;
  }
  function g(I, O) {
    if (Array.isArray(O)) {
      const H = O.map(f.bind(null, I));
      return (N) => H.map((K) => K(N));
    }
    const B = f(I, O);
    return (H) => B(H);
  }
  const x = [];
  function $(I, O = {}) {
    const B = /* @__PURE__ */ new WeakMap();
    return x.push((H, N) => {
      B.set(
        N,
        I.provide((K) => H(K, O))
      );
    }), () => B.get(io)();
  }
  function A(I, O) {
    n ?? (n = uD(t));
    const [B, H] = Vn(cm, n) ? cm[n] : [g(e, t), x];
    return lD || (dh[n] ?? (dh[n] = 0), dh[n]++, cm[n] = [B, H]), H.forEach((N) => {
      N(I, O);
    }), () => (io = O, B());
  }
  return A;
}
function cD(e, t) {
  const n = Cc.get(io) || [];
  let i;
  return n.length && (i = Mx(n, e.split("."))), i === void 0 ? t : i;
}
function PY(e, t) {
  return new Proxy(e, {
    get(...n) {
      let i;
      const r = n[1];
      if (typeof r == "string") {
        const c = io;
        io = t, i = cD(r, void 0), io = c;
      }
      return i !== void 0 ? i : Reflect.get(...n);
    }
  });
}
function vS(e, t, n) {
  return e(
    (i, r = {}) => i.reduce((c, d) => {
      if (d.startsWith("slots.")) {
        const a = d.substring(6), f = () => t.slots && Vn(t.slots, a) && typeof t.slots[a] == "function";
        if (r.if)
          c[d] = f;
        else if (t.slots) {
          const g = PY(t, n);
          c[d] = () => f() ? t.slots[a](g) : null;
        }
      } else {
        const a = AY(d, t);
        c[d] = () => cD(d, a.value);
      }
      return c;
    }, {}),
    n
  );
}
function gS(e, t, n) {
  if (t ?? (t = uD(e)), dh[t]--, dh[t] === 0) {
    delete dh[t];
    const [, i] = cm[t];
    delete cm[t], i.length = 0;
  }
  Cc.delete(n);
}
function uD(e) {
  return JSON.stringify(e, (t, n) => typeof n == "function" ? n.toString() : n);
}
var dD = /* @__PURE__ */ at({
  name: "FormKitSchema",
  props: {
    schema: {
      type: [Array, Object],
      required: !0
    },
    data: {
      type: Object,
      default: () => ({})
    },
    library: {
      type: Object,
      default: () => ({})
    },
    memoKey: {
      type: String,
      required: !1
    }
  },
  emits: ["mounted"],
  setup(e, t) {
    var g;
    const n = Du();
    let i = {};
    Cc.set(i, []);
    const r = { FormKit: Gy(Dx), ...e.library };
    let c = mS(r, e.schema, e.memoKey), d, a;
    lD || At(
      () => e.schema,
      (x, $) => {
        var I;
        const A = i;
        i = {}, Cc.set(i, []), c = mS(r, e.schema, e.memoKey), d = vS(c, a, i), x === $ && ((I = n == null ? void 0 : n.proxy) == null ? void 0 : I.$forceUpdate).call(I), gS(e.schema, e.memoKey, A);
      },
      { deep: !0 }
    ), ra(() => {
      a = Object.assign(Er(e.data ?? {}), {
        slots: t.slots
      }), t.slots, d = vS(c, a, i);
    });
    function f() {
      gS(e.schema, e.memoKey, i), a && (a.node && a.node.destroy(), a.slots = null, a = null), d = null;
    }
    return Li(() => t.emit("mounted")), f1(f), SY((g = Du()) == null ? void 0 : g.appContext.app, f), () => d ? d() : null;
  }
}), pD = dD, MY = typeof window > "u", zw = Symbol("FormKitParent"), DY = Symbol("FormKitComponentCallback");
function LY(e, t) {
  const n = VY(e, t);
  if (n.props.definition || _o(600, n), n.props.definition.component)
    return () => {
      var g;
      return ym(
        (g = n.props.definition) == null ? void 0 : g.component,
        {
          context: n.context
        },
        { ...t.slots }
      );
    };
  const i = $e([]);
  let r = n.props.definition.schemaMemoKey;
  const c = () => {
    var x, $;
    const g = ($ = (x = n.props) == null ? void 0 : x.definition) == null ? void 0 : $.schema;
    g || _o(601, n), typeof g == "function" ? (i.value = g({ ...e.sectionsSchema || {} }), (r && e.sectionsSchema || "memoKey" in g && typeof g.memoKey == "string") && (r = (r ?? (g == null ? void 0 : g.memoKey)) + JSON.stringify(e.sectionsSchema))) : i.value = g;
  };
  c(), MY || n.on("schema", () => {
    r += "♻️", c();
  }), t.emit("node", n);
  const d = n.props.definition.library, a = {
    FormKit: Gy(hD),
    ...d,
    ...e.library ?? {}
  };
  function f() {
    n.emit("mounted");
  }
  return t.expose({ node: n }), () => ym(
    dD,
    {
      schema: i.value,
      data: n.context,
      onMounted: f,
      library: a,
      memoKey: r
    },
    { ...t.slots }
  );
}
var hD = /* @__PURE__ */ at(
  LY,
  {
    props: _G,
    inheritAttrs: !1
  }
), Dx = hD, OY = Symbol();
function NY(e, t) {
  return e.component(t.alias || "FormKit", Dx).component(t.schemaAlias || "FormKitSchema", pD), {
    get: Gm,
    setLocale: (n) => {
      var i;
      (i = t.config) != null && i.rootConfig && (t.config.rootConfig.locale = n);
    },
    clearErrors: D7,
    setErrors: M7,
    submit: xM,
    reset: $M
  };
}
var fD = Symbol.for("FormKitOptions"), FY = Symbol.for("FormKitConfig"), zTe = {
  install(e, t) {
    const n = Object.assign(
      {
        alias: "FormKit",
        schemaAlias: "FormKitSchema"
      },
      typeof t == "function" ? t() : t
    ), i = Fj(n.config || {});
    n.config = { rootConfig: i }, e.config.globalProperties.$formkit = NY(e, n), e.provide(fD, n), e.provide(FY, i), typeof window < "u" && (globalThis.__FORMKIT_CONFIGS__ = (globalThis.__FORMKIT_CONFIGS__ || []).concat([i]));
  }
}, RY = typeof window < "u", n0 = [
  // Boolean props
  "ignore",
  "disabled",
  "preserve",
  // String props
  "help",
  "label",
  /^preserve(-e|E)rrors/,
  /^[a-z]+(?:-visibility|Visibility|-behavior|Behavior)$/,
  /^[a-zA-Z-]+(?:-class|Class)$/,
  "prefixIcon",
  "suffixIcon",
  /^[a-zA-Z-]+(?:-icon|Icon)$/
], zY = ["disabled", "ignore", "preserve"];
function yS(e, t) {
  t.classes && Object.keys(t.classes).forEach(
    (n) => {
      typeof n == "string" && (e.props[`_${n}Class`] = t.classes[n], lh(t.classes[n]) && n === "inner" && Object.values(t.classes[n]));
    }
  );
}
function BY(e) {
  return e ? ["Submit", "SubmitRaw", "SubmitInvalid"].reduce(
    (n, i) => {
      const r = `on${i}`;
      return r in e && typeof e[r] == "function" && (n[r] = e[r]), n;
    },
    {}
  ) : {};
}
function VY(e, t, n = {}) {
  const i = Object.assign({}, Xi(fD) || {}, n), r = Xi(OY, $e(RY ? document : void 0)), c = Xi(DY, () => {
  }), d = Du(), a = BY(d == null ? void 0 : d.vnode.props), f = ["modelValue", "model-value"].some(
    (te) => te in ((d == null ? void 0 : d.vnode.props) ?? {})
  );
  let g = !1;
  Li(() => {
    g = !0;
  });
  const x = e.modelValue !== void 0 ? e.modelValue : ua(t.attrs.value);
  function $() {
    const te = {
      ...Ep(e),
      ...a,
      type: e.type ?? "text",
      __root: r.value,
      __slots: t.slots
    }, ae = qk(Ep(t.attrs), n0);
    ae.key || (ae.key = Jh()), te.attrs = ae;
    const oe = jk(Ep(t.attrs), n0);
    for (const me in oe)
      zY.includes(me) && oe[me] === "" && (oe[me] = !0), te[ch(me)] = oe[me];
    const de = { props: {} };
    return yS(de, e), Object.assign(te, de.props), typeof te.type != "string" && (te.definition = te.type, delete te.type), te;
  }
  const A = $(), I = A.ignore ? null : e.parent || Xi(zw, null), O = I7(
    Fc(
      i || {},
      {
        name: e.name || void 0,
        value: x,
        parent: I,
        plugins: (i.plugins || []).concat(e.plugins ?? []),
        config: e.config || {},
        props: A,
        index: e.index,
        sync: !!on(t.attrs.sync || t.attrs.dynamic)
      },
      !1,
      !0
    )
  );
  c(O), O.props.definition || _o(600, O);
  const B = $e(
    new Set(
      Array.isArray(O.props.__propDefs) ? O.props.__propDefs : Object.keys(O.props.__propDefs ?? {})
    )
  );
  O.on(
    "added-props",
    ({ payload: te }) => {
      (Array.isArray(te) ? te : Object.keys(te ?? {})).forEach((oe) => B.value.add(oe));
    }
  );
  const H = Ae(
    () => n0.concat([...B.value]).reduce((te, ae) => (typeof ae == "string" ? (te.push(ch(ae)), te.push(gM(ae))) : te.push(ae), te), [])
  );
  ra(() => yS(O, e));
  const N = Ep(e);
  for (const te in N)
    At(
      () => e[te],
      () => {
        e[te] !== void 0 && (O.props[te] = e[te]);
      }
    );
  ra(() => {
    O.props.__root = r.value;
  });
  const K = /* @__PURE__ */ new Set(), U = Ep(t.attrs);
  ra(() => {
    q(jk(U, H.value));
  });
  function q(te) {
    K.forEach((ae) => {
      ae(), K.delete(ae);
    });
    for (const ae in te) {
      const oe = ch(ae);
      K.add(
        At(
          () => t.attrs[ae],
          () => {
            O.props[oe] = t.attrs[ae];
          }
        )
      );
    }
  }
  if (ra(() => {
    const te = qk(Ep(t.attrs), H.value);
    "multiple" in te && (te.multiple = on(te.multiple)), typeof te.onBlur == "function" && (te.onBlur = vj(te.onBlur)), O.props.attrs = Object.assign({}, O.props.attrs || {}, te);
  }), ra(() => {
    const te = (e.errors ?? []).map(
      (ae) => /* @__PURE__ */ Vr({
        key: wx(ae),
        type: "error",
        value: ae,
        meta: { source: "prop" }
      })
    );
    O.store.apply(
      te,
      (ae) => ae.type === "error" && ae.meta.source === "prop"
    );
  }), O.type !== "input") {
    const te = `${O.name}-prop`;
    ra(() => {
      const ae = e.inputErrors ?? {}, oe = Object.keys(ae);
      oe.length || O.clearErrors(!0, te);
      const de = oe.reduce((me, ve) => {
        let re = ae[ve];
        return typeof re == "string" && (re = [re]), Array.isArray(re) && (me[ve] = re.map(
          (le) => /* @__PURE__ */ Vr({
            key: le,
            type: "error",
            value: le,
            meta: { source: te }
          })
        )), me;
      }, {});
      O.store.apply(
        de,
        (me) => me.type === "error" && me.meta.source === te
      );
    });
  }
  ra(() => Object.assign(O.config, e.config)), O.type !== "input" && J0(zw, O);
  let ee;
  return O.on("modelUpdated", () => {
    var te, ae;
    t.emit("inputRaw", (te = O.context) == null ? void 0 : te.value, O), g && t.emit("input", (ae = O.context) == null ? void 0 : ae.value, O), f && O.context && (ee = ua(O.value), t.emit("update:modelValue", Pw(O.value)));
  }), f && (At(
    eh(e, "modelValue"),
    (te) => {
      vn(ee, te) || O.input(te, !1);
    },
    { deep: !0 }
  ), O.value !== x && O.emit("modelUpdated")), tl(() => O.destroy()), O;
}
var UY = 1;
function HY(e) {
  return typeof e == "function" && e.length === 2 || typeof e == "object" && !Array.isArray(e) && !("$el" in e) && !("$cmp" in e) && !("if" in e);
}
function mD(e, t = {}, n = {}) {
  const i = {
    type: "input",
    ...t
  };
  let r;
  if (HY(e)) {
    const c = `SchemaComponent${UY++}`;
    r = /* @__PURE__ */ On("input", () => ({
      $cmp: c,
      props: {
        context: "$node.context"
      }
    })), i.library = { [c]: Gy(e) };
  } else typeof e == "function" ? r = e : r = /* @__PURE__ */ On("input", () => ua(e));
  return i.schema = /* @__PURE__ */ XG(r || "Schema undefined", n), i.schemaMemoKey || (i.schemaMemoKey = `${Math.random()}`), i;
}
var WY = /* @__PURE__ */ On("messages", () => ({
  $el: "ul",
  if: "$fns.length($messages)"
})), ZY = /* @__PURE__ */ On("message", () => ({
  $el: "li",
  for: ["message", "$messages"],
  attrs: {
    key: "$message.key",
    id: "$id + '-' + $message.key",
    "data-message-type": "$message.type"
  }
})), qY = WY(ZY("$message.value")), jY = /* @__PURE__ */ at({
  props: {
    node: {
      type: Object,
      required: !1
    },
    sectionsSchema: {
      type: Object,
      default: {}
    },
    defaultPosition: {
      type: [String, Boolean],
      default: !1
    },
    library: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e, t) {
    const n = Ae(() => e.node || Xi(zw, void 0));
    At(
      n,
      () => {
        var c;
        (c = n.value) != null && c.context && !on(e.defaultPosition) && (n.value.context.defaultMessagePlacement = !1);
      },
      { immediate: !0 }
    );
    const i = qY(e.sectionsSchema || {}), r = Ae(() => {
      var c, d, a, f, g, x;
      return {
        messages: ((d = (c = n.value) == null ? void 0 : c.context) == null ? void 0 : d.messages) || {},
        fns: ((f = (a = n.value) == null ? void 0 : a.context) == null ? void 0 : f.fns) || {},
        classes: ((x = (g = n.value) == null ? void 0 : g.context) == null ? void 0 : x.classes) || {}
      };
    });
    return () => {
      var c;
      return (c = n.value) != null && c.context ? ym(
        pD,
        { schema: i, data: r.value, library: e.library },
        { ...t.slots }
      ) : null;
    };
  }
}), GY = /* @__PURE__ */ On("summary", () => ({
  $el: "div",
  attrs: {
    "aria-live": "polite"
  }
})), YY = /* @__PURE__ */ On("summaryInner", () => ({
  $el: "div",
  if: "$summaries.length && $showSummaries"
})), KY = /* @__PURE__ */ On("messages", () => ({
  $el: "ul",
  if: "$summaries.length && $showSummaries"
})), XY = /* @__PURE__ */ On("message", () => ({
  $el: "li",
  for: ["summary", "$summaries"],
  attrs: {
    key: "$summary.key",
    "data-message-type": "$summary.type"
  }
})), JY = /* @__PURE__ */ On("summaryHeader", () => ({
  $el: "h2",
  attrs: {
    id: "$id"
  }
})), QY = /* @__PURE__ */ On("messageLink", () => ({
  $el: "a",
  attrs: {
    id: "$summary.key",
    href: '$: "#" + $summary.id',
    onClick: "$jumpLink"
  }
}));
GY(
  YY(
    JY("$summaryHeader"),
    KY(XY(QY("$summary.message")))
  )
);
CY();
aD();
const eK = ["id", "placeholder"], tK = ["id", "placeholder"], nK = ["id", "placeholder"], iK = {
  __name: "DOBInput",
  props: {
    context: Object
  },
  setup(e) {
    const t = e, n = $e(null), i = $e(null), r = Er({
      d: "",
      m: "",
      y: ""
    });
    At(
      () => t.context.dob,
      () => {
        t.context.dob && (r.d = t.context.dob.substring(6, 8), r.m = t.context.dob.substring(4, 6), r.y = t.context.dob.substring(0, 4));
      }
    );
    const c = (f, g) => {
      const { target: x } = f;
      g === "y" && x.value.length > 4 && (x.value = x.value.slice(0, 4)), r[g] = x.value.replace(/\D/g, "");
    }, d = (f, g) => {
      const { target: x } = f, $ = x.value;
      r[g] = ("" + $).length === 1 ? "0" + $ : $;
    };
    At(
      () => r.d,
      (f) => {
        (f > 3 || f <= 3 && f.length === 2) && (r.d = f.toString().slice(0, 2), n.value.focus());
      }
    ), At(
      () => r.m,
      (f) => {
        (f > 1 || f <= 1 && f.length === 2) && (r.m = f.toString().slice(0, 2), i.value.focus());
      }
    ), At(
      () => r.y,
      (f) => {
        f.length === 4 && i.value.blur();
      }
    ), At(
      () => [r.d, r.m, r.y],
      ([f, g, x]) => {
        const $ = x + "-" + g + "-" + f;
        t.context.node.input($);
      }
    );
    const a = Er({
      d: !1,
      m: !1,
      y: !1
    });
    return At(
      () => [!a.d, !a.m, !a.y],
      ([f, g, x]) => {
        f && g && x && t.context.handlers.blur();
      }
    ), (f, g) => (V(), G(cn, null, [
      xr(E("input", {
        type: "mask",
        "onUpdate:modelValue": g[0] || (g[0] = (x) => r.d = x),
        mask: "##",
        id: `dd-${e.context.id}`,
        class: "formkit-input",
        placeholder: f.$t("vacvComponents.traveller.placeholders.birthDay"),
        maxlength: 2,
        onInput: g[1] || (g[1] = (x) => c(x, "d")),
        onFocus: g[2] || (g[2] = (x) => a.d = !0),
        onBlur: g[3] || (g[3] = (x) => {
          d(x, "d"), a.d = !1;
        })
      }, null, 40, eK), [
        [_b, r.d]
      ]),
      xr(E("input", {
        type: "mask",
        ref_key: "MM",
        ref: n,
        "onUpdate:modelValue": g[4] || (g[4] = (x) => r.m = x),
        mask: "##",
        id: `mm-${e.context.id}`,
        class: "formkit-input",
        placeholder: f.$t("vacvComponents.traveller.placeholders.birthMonth"),
        maxlength: 2,
        onInput: g[5] || (g[5] = (x) => c(x, "m")),
        onFocus: g[6] || (g[6] = (x) => a.m = !0),
        onBlur: g[7] || (g[7] = (x) => {
          d(x, "m"), a.m = !1;
        })
      }, null, 40, tK), [
        [_b, r.m]
      ]),
      xr(E("input", {
        type: "mask",
        ref_key: "YYYY",
        ref: i,
        "onUpdate:modelValue": g[8] || (g[8] = (x) => r.y = x),
        mask: "####",
        id: `yyyy-${e.context.id}`,
        class: "formkit-input year",
        placeholder: f.$t("vacvComponents.traveller.placeholders.birthYear"),
        maxlength: 4,
        onInput: g[9] || (g[9] = (x) => c(x, "y")),
        onFocus: g[10] || (g[10] = (x) => a.y = !0),
        onBlur: g[11] || (g[11] = (x) => a.y = !1)
      }, null, 40, nK), [
        [_b, r.y]
      ])
    ], 64));
  }
}, rK = /* @__PURE__ */ Zn(iK, [["__scopeId", "data-v-d8c63c36"]]), sK = (e) => (nl("data-v-8675d7a6"), e = e(), il(), e), oK = { class: "checkout-form" }, aK = { class: "traveller-section step1" }, lK = { class: "traveller-item" }, cK = { class: "traveller-item-title" }, uK = { class: "note" }, dK = { class: "traveller-form-title vacv-form-row vacv-radio" }, pK = { class: "vacv-radio-group" }, hK = { class: "traveller-form-name vacv-form-row vacv-input" }, fK = { class: "vacv-form-item" }, mK = { class: "vacv-form-item" }, vK = { class: "vacv-form-item" }, gK = { class: "traveller-form-birthdate vacv-form-row vacv-input" }, yK = ["id"], _K = /* @__PURE__ */ sK(() => /* @__PURE__ */ E("div", { class: "break" }, null, -1)), bK = ["innerHTML"], wK = {
  key: 0,
  class: "traveller-form-contact vacv-form-row vacv-input"
}, xK = { class: "vacv-form-item tooltip-wrapper" }, $K = { class: "vacv-form-item" }, CK = { class: "traveller-form-aeroplan vacv-form-row vacv-input" }, kK = { class: "vacv-form-item" }, SK = /* @__PURE__ */ at({
  __name: "TravellerForm",
  props: {
    index: {},
    type: {},
    age: {},
    travelDate: {},
    aeroplanDOB: {},
    userNameLocked: { type: Boolean }
  },
  setup(e) {
    const t = e, n = mD(rK, {
      props: ["dob"]
    }), i = $e(""), r = /^(?![\s\S]*\s)(?!.*\.\.|[.-])[\w.-]+[\w]@[^.-][\w]+([.-]?[\w]+)*\.[A-Za-z]{2,}$/, c = $e(!1), d = Ae(() => t.age !== void 0 ? t.age : 18), a = Ae(() => t.age !== void 0 ? t.age + 1 : 130), f = (re) => {
      var pe, Ne;
      const le = re.value;
      if (c.value = !1, le && le.length === 10) {
        const We = Sn.fromFormat(le, "yyyy-MM-dd");
        if (t.type === "infant" && ((pe = t.travelDate) != null && pe.returnLastDate)) {
          const et = Sn.fromFormat(
            t.travelDate.returnLastDate,
            "yyyyMMdd"
          ).diff(We, ["years"]).years;
          return et >= 0 && et <= 3;
        } else if ((Ne = t.travelDate) != null && Ne.departureFirstDate) {
          const Ge = Sn.fromFormat(
            t.travelDate.departureFirstDate,
            "yyyyMMdd"
          ), et = We.plus({ years: d.value }), ft = We.plus({ years: a.value });
          return Ge >= et && Ge < ft;
        } else
          return !1;
      }
      return !1;
    }, g = (re) => {
      var pe;
      const le = re.value;
      if ((pe = t.travelDate) != null && pe.returnLastDate && le && le.length === 10) {
        const Ne = le.replace(/-/g, ""), We = Sn.fromFormat(
          t.travelDate.returnLastDate,
          "yyyyMMdd"
        ), Ge = Sn.fromFormat(Ne, "yyyyMMdd"), et = We.diff(Ge, ["years"]).years;
        return t.type === "infant" && et >= 2 ? (c.value = !0, !1) : (c.value = !1, !0);
      }
      return c.value = !0, !1;
    }, { t: x } = ki({ useScope: "global" }), $ = Ae(() => "required|length:0," + Mf + `|matches:${dw.personName}`), A = Ae(() => "length:0," + Mf + `|matches:${dw.personName}`), I = t.type === "adult" && t.index === 1, O = Ae(() => ({
      required: x(I ? "vacvComponents.traveller.errors.noFirstNameEntered" : "vacvComponents.traveller.errors.noOtherTravellerFirstName"),
      length: x(
        t.userNameLocked ? "vacvComponents.traveller.errors.employeeNamePrefilled" : "vacvComponents.traveller.errors.firstNameTextLength"
      ),
      matches: x(
        t.userNameLocked ? "vacvComponents.traveller.errors.employeeNamePrefilled" : "vacvComponents.traveller.errors.nameWrongFormat"
      )
    })), B = Ae(() => ({
      length: x(
        t.userNameLocked ? "vacvComponents.traveller.errors.employeeNamePrefilled" : "vacvComponents.traveller.errors.firstNameTextLength"
      ),
      matches: x(
        t.userNameLocked ? "vacvComponents.traveller.errors.employeeNamePrefilled" : "vacvComponents.traveller.errors.nameWrongFormat"
      )
    })), H = Ae(() => ({
      required: x(I ? "vacvComponents.traveller.errors.noLastNameEntered" : "vacvComponents.traveller.errors.noOtherTravellerLastName"),
      length: x(
        t.userNameLocked ? "vacvComponents.traveller.errors.employeeNamePrefilled" : "vacvComponents.traveller.errors.lastNameTextLength"
      ),
      matches: x(
        t.userNameLocked ? "vacvComponents.traveller.errors.employeeNamePrefilled" : "vacvComponents.traveller.errors.nameWrongFormat"
      )
    })), N = {
      required: x(I ? "vacvComponents.traveller.errors.noDOBEntered" : "vacvComponents.traveller.errors.noOtherTravellerDateOfBirth"),
      date_format: x("vacvComponents.traveller.errors.invalidDOB"),
      length: x("vacvComponents.traveller.errors.invalidDOB"),
      right_age: t.type === "adult" ? x("vacvComponents.traveller.errors.invalidDOB") : x("vacvComponents.traveller.errors.invalidChildDOB"),
      age_on_return: x("vacvComponents.traveller.errors.invalidInfantReturnDOB")
    }, K = {
      required: x(I ? "vacvComponents.traveller.errors.noTitleSelected" : "vacvComponents.traveller.errors.noOtherTravellerTitleField")
    }, U = {
      required: x("vacvComponents.traveller.errors.noPhoneNumberEntered"),
      matches: x("vacvComponents.traveller.errors.phoneNumberWrongFormat"),
      length: x("vacvComponents.traveller.errors.phoneNumberTextLength")
    }, q = {
      required: x("vacvComponents.traveller.errors.noEmailEntered"),
      length: x("vacvComponents.traveller.errors.emailTextLength"),
      matches: x("vacvComponents.traveller.errors.emailWrongFormat")
    }, ee = {
      matches: x("vacvComponents.traveller.errors.aeroplanNumberWrongFormat"),
      length: x("vacvComponents.traveller.errors.aeroplanInvalidNumber"),
      isLuhnValidRule: x("vacvComponents.traveller.errors.aeroplanInvalidNumber")
    }, te = Ae(() => x(fP(de))), ae = $e(), oe = $e(!1);
    let de = null;
    Ru(async () => {
      de = await window.sso.getUserToken();
    }), At(
      () => t.userNameLocked,
      (re) => {
        var le, pe;
        if (re) {
          const Ne = ae.value;
          if ((pe = (le = Ne == null ? void 0 : Ne.node) == null ? void 0 : le.children) != null && pe.length) {
            const We = /* @__PURE__ */ new Set([
              "firstname-adult-1",
              "middlename-adult-1",
              "lastname-adult-1"
            ]);
            Ne.node.walk((Ge) => {
              We.has(Ge.name) && Ge.store.set(
                Vr({
                  key: "submitted",
                  value: !0,
                  visible: !1
                })
              ), Ge.name === "middlename-adult-1" && Ge.value && (oe.value = !0);
            });
          }
        }
      }
    );
    const me = (re) => {
      re.preventDefault();
    }, ve = Ae(() => {
      const { type: re, index: le, age: pe } = t, Ne = le === 1 ? "er" : "e";
      if (re === "adult") {
        let We = x("vacvComponents.traveller.labels.adult", { index: le, pos: Ne });
        return I && (We += ` ${x("vacvComponents.traveller.messages.mainTraveller")}`), We;
      }
      return re === "child" ? x("vacvComponents.traveller.labels.child", { index: le, age: pe, pos: Ne }) : re === "infant" ? x("vacvComponents.traveller.labels.infant", { index: le, age: pe, pos: Ne }) : "";
    });
    return (re, le) => {
      const pe = Ur("FormKit");
      return V(), Tt(pe, {
        delay: 0,
        type: "group",
        name: `passenger-${re.type}-${re.index}`,
        ref_key: "formRef",
        ref: ae
      }, {
        default: Qt(() => [
          E("div", oK, [
            E("section", aK, [
              E("div", lK, [
                E("div", cK, [
                  E("h2", null, Y(ve.value), 1),
                  E("div", uK, Y(ne(x)("vacvComponents.traveller.messages.travellerName")), 1)
                ]),
                E("div", dK, [
                  E("div", pK, [
                    it(pe, {
                      delay: 0,
                      type: "radio",
                      name: `title-${re.type}-${re.index}`,
                      id: `title-${re.type}-${re.index}`,
                      label: ne(x)("vacvComponents.traveller.labels.travellerTitleField") + "*",
                      options: [
                        ne(x)("vacvComponents.traveller.labels.travellerTitleMr"),
                        ne(x)("vacvComponents.traveller.labels.travellerTitleMrs"),
                        ne(x)("vacvComponents.traveller.labels.travellerTitleMs")
                      ],
                      validation: "required",
                      "validation-messages": K,
                      onInput: le[0] || (le[0] = (Ne) => re.$emit("trackPaxFormInput", Ne, re.index, re.type, "Title"))
                    }, null, 8, ["name", "id", "label", "options"])
                  ])
                ]),
                E("div", hK, [
                  E("div", fK, [
                    it(pe, {
                      type: "text",
                      disabled: re.userNameLocked,
                      name: `firstname-${re.type}-${re.index}`,
                      id: `firstname-${re.type}-${re.index}`,
                      label: ne(x)("vacvComponents.traveller.labels.travellerFirstName") + "*",
                      validation: $.value,
                      "validation-messages": O.value,
                      maxlength: ne(Mf),
                      onInput: le[1] || (le[1] = (Ne) => re.$emit("trackPaxFormInput", Ne, re.index, re.type, "First Name"))
                    }, null, 8, ["disabled", "name", "id", "label", "validation", "validation-messages", "maxlength"])
                  ]),
                  E("div", mK, [
                    it(pe, {
                      type: "text",
                      disabled: oe.value,
                      name: `middlename-${re.type}-${re.index}`,
                      id: `middlename-${re.type}-${re.index}`,
                      label: ne(x)("vacvComponents.traveller.labels.travellerMiddleName"),
                      validation: A.value,
                      "validation-messages": B.value,
                      maxlength: ne(Mf),
                      onInput: le[2] || (le[2] = (Ne) => re.$emit("trackPaxFormInput", Ne, re.index, re.type, "Middle Name"))
                    }, null, 8, ["disabled", "name", "id", "label", "validation", "validation-messages", "maxlength"])
                  ]),
                  E("div", vK, [
                    it(pe, {
                      type: "text",
                      disabled: re.userNameLocked,
                      name: `lastname-${re.type}-${re.index}`,
                      id: `lastname-${re.type}-${re.index}`,
                      label: ne(x)("vacvComponents.traveller.labels.travellerLastName") + "*",
                      validation: $.value,
                      "validation-messages": H.value,
                      maxlength: ne(Mf),
                      onInput: le[3] || (le[3] = (Ne) => re.$emit("trackPaxFormInput", Ne, re.index, re.type, "Last Name"))
                    }, null, 8, ["disabled", "name", "id", "label", "validation", "validation-messages", "maxlength"])
                  ])
                ]),
                E("div", gK, [
                  E("legend", null, Y(`${ne(x)("vacvComponents.traveller.labels.dateOfBirth")}*`), 1),
                  it(pe, {
                    name: "dateOfBirth",
                    type: "group"
                  }, {
                    default: Qt(() => [
                      E("div", {
                        class: "vacv-form-item narrow3 birthdate",
                        id: `traveller-${re.index}-dob`
                      }, [
                        it(pe, {
                          type: ne(n),
                          dob: re.aeroplanDOB,
                          classes: {
                            inner: "flex"
                          },
                          modelValue: i.value,
                          "onUpdate:modelValue": le[4] || (le[4] = (Ne) => i.value = Ne),
                          index: re.index,
                          name: `dob-${re.type}-${re.index}`,
                          id: `dob-${re.type}-${re.index}`,
                          validation: [
                            ["length", 8],
                            ["required"],
                            ["date_format", "YYYY-MM-DD"],
                            ["right_age"],
                            ["age_on_return"]
                          ],
                          "validation-visibility": "blur",
                          "validation-rules": {
                            right_age: f,
                            age_on_return: g
                          },
                          "validation-messages": N,
                          onInput: le[5] || (le[5] = (Ne) => re.$emit(
                            "trackPaxFormInput",
                            Ne,
                            re.index,
                            re.type,
                            "Date of Birth - Date > Month > Year"
                          ))
                        }, null, 8, ["type", "dob", "modelValue", "index", "name", "id", "validation-rules"])
                      ], 8, yK),
                      _K,
                      c.value ? (V(), G("div", {
                        key: 0,
                        class: "vacv-form-item return-age-error-details",
                        innerHTML: ne(x)(
                          "vacvComponents.traveller.errors.invalidInfantReturnDOBDetails",
                          { num: te.value }
                        )
                      }, null, 8, bK)) : _e("", !0)
                    ]),
                    _: 1
                  })
                ]),
                re.type === "adult" && re.index === 1 ? (V(), G("div", wK, [
                  E("div", xK, [
                    it(pe, {
                      type: "email",
                      name: "main-email",
                      id: "main-email",
                      inputmode: "email",
                      label: ne(x)("vacvComponents.traveller.labels.travellerEmail") + "*",
                      validation: [
                        ["required"],
                        ["length", 0, 50],
                        ["matches", r]
                      ],
                      "validation-messages": q,
                      onInput: le[6] || (le[6] = (Ne) => re.$emit("trackPaxFormInput", Ne, re.index, re.type, "Email ")),
                      onBlur: le[7] || (le[7] = (Ne) => Ne.target.value = Ne.target.value.trim())
                    }, null, 8, ["label", "validation"])
                  ]),
                  E("div", $K, [
                    it(pe, {
                      type: "mask",
                      mode: "replace",
                      mask: "(###) ###-####",
                      name: "main-tel",
                      id: "main-tel",
                      "unmask-value": "true",
                      "show-mask": !0,
                      label: ne(x)("vacvComponents.traveller.labels.travellerPhoneNumber") + "*",
                      validation: [
                        ["required"],
                        ["matches", /^[\d\s+,\(\)-]+$/],
                        ["length", 0, ne(WB)]
                      ],
                      "validation-messages": U,
                      autocomplete: "tel-national",
                      onInput: le[8] || (le[8] = (Ne) => re.$emit(
                        "trackPaxFormInput",
                        Ne,
                        re.index,
                        re.type,
                        "Phone Number"
                      )),
                      onPaste: me
                    }, null, 8, ["label", "validation"])
                  ])
                ])) : _e("", !0),
                E("div", CK, [
                  E("div", kK, [
                    it(pe, {
                      type: "number",
                      name: `aeroplan-${re.type}-${re.index}`,
                      id: `aeroplan-${re.type}-${re.index}`,
                      label: ne(x)("vacvComponents.traveller.labels.travellerAeroplanNumber"),
                      validation: "matches:/^[0-9]*$/|length:9,9|isLuhnValidRule",
                      "validation-visibility": "blur",
                      "validation-rules": { isLuhnValidRule: ne(lV) },
                      "validation-messages": ee,
                      onInput: le[9] || (le[9] = (Ne) => re.$emit(
                        "trackPaxFormInput",
                        Ne,
                        re.index,
                        re.type,
                        "Aeroplan Number"
                      ))
                    }, null, 8, ["name", "id", "label", "validation-rules"])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["name"]);
    };
  }
}), BTe = /* @__PURE__ */ Zn(SK, [["__scopeId", "data-v-8675d7a6"]]), TK = { class: "navback-navbar" }, IK = { class: "navback-wrapper" }, AK = {
  href: "http://vacations.aircanada.com",
  class: "navback-link link"
}, EK = /* @__PURE__ */ E("i", {
  class: "fa-solid fa-chevron-left",
  "aria-hidden": "true"
}, null, -1), PK = ["aria-expanded"], MK = /* @__PURE__ */ E("i", {
  class: "fa-solid fa-chevron-down",
  "aria-hidden": "true"
}, null, -1), DK = {
  key: 0,
  class: "progressbar-wrapper",
  id: "progressBar"
}, LK = { class: "progressbar" }, OK = /* @__PURE__ */ E("div", { class: "progressline-wrapper" }, [
  /* @__PURE__ */ E("div", { class: "progressline" }),
  /* @__PURE__ */ E("div", { class: "marker" }, [
    /* @__PURE__ */ E("i", {
      class: "fa-solid fa-check",
      "aria-hidden": "true"
    })
  ])
], -1), NK = { class: "link-wrapper" }, VTe = /* @__PURE__ */ at({
  __name: "ProgressBar",
  props: {
    currentStep: {},
    spaType: {}
  },
  setup(e, { expose: t }) {
    const n = e, { t: i } = ki({ useScope: "global" }), { width: r } = ex(), c = $e(), d = $e(!1), a = n.spaType && n.spaType === ps.HotelsSpa ? Er({
      1: "hotel",
      2: "room",
      3: "payment"
    }) : Er({
      1: "hotel",
      2: "room",
      3: "flight",
      4: "extras",
      5: "payment"
    });
    At(d, () => {
      d.value ? c.value = RI(
        ["mobile-menu-opener", "progressbar-wrapper"],
        g
      ) : zI(c.value);
    });
    const f = Ae(() => d.value || r.value >= Qg.tablet), g = () => (d.value = !d.value, d.value), x = (I) => I === void 0 ? "" : i("vacvComponents.progressbar.labels." + I), $ = (I, O) => I === O, A = (I, O) => I === 1 ? !0 : I < O;
    return t({
      width: r,
      isProgressBarVisible: d,
      labelsForSteps: x,
      Steps: a
    }), (I, O) => (V(), G("div", TK, [
      E("div", IK, [
        E("a", AK, [
          EK,
          mt(Y(I.$t("vacvComponents.progressbar.labels.navback")), 1)
        ])
      ]),
      E("div", {
        class: Et(f.value ? "navbar-wrapper open" : "navbar-wrapper")
      }, [
        E("button", {
          class: "mobile-menu-opener",
          onClick: g,
          "aria-expanded": f.value,
          "aria-controls": "progressBar"
        }, [
          mt(Y(I.$t("vacvComponents.progressbar.labels.stepofsteps", {
            step: I.currentStep,
            steps: Object.keys(ne(a)).length
          })) + Y(x(ne(a)[I.currentStep])), 1),
          MK
        ], 8, PK),
        f.value ? (V(), G("nav", DK, [
          E("ul", LK, [
            (V(!0), G(cn, null, Pn(ne(a), (B, H) => (V(), G("li", {
              key: B + H,
              class: Et([
                B,
                { active: $(parseInt(H), I.currentStep) },
                {
                  visited: A(parseInt(H), I.currentStep)
                }
              ])
            }, [
              OK,
              E("div", NK, Y(H) + ". " + Y(x(B)), 1)
            ], 2))), 128))
          ])
        ])) : _e("", !0)
      ], 2)
    ]));
  }
}), FK = {
  key: 0,
  class: "message-box"
}, RK = ["innerHTML"], zK = ["innerHTML"], UTe = /* @__PURE__ */ at({
  __name: "MessageBox",
  props: {
    title: {},
    message: {}
  },
  setup(e) {
    return (t, n) => t.message ? (V(), G("div", FK, [
      t.title ? (V(), G("div", {
        key: 0,
        class: "title h3style",
        innerHTML: t.title
      }, null, 8, RK)) : _e("", !0),
      E("div", {
        class: "message vacv-editor special-list",
        innerHTML: t.message
      }, null, 8, zK)
    ])) : _e("", !0);
  }
}), BK = { class: "confirmation-modal" }, VK = ["innerHTML"], UK = ["innerHTML"], HK = { class: "modal-cta-container" }, WK = /* @__PURE__ */ at({
  __name: "ConfirmationModalDialog",
  props: {
    title: {},
    message: {},
    primaryCta: {},
    secondaryCta: {}
  },
  emits: ["confirm", "cancel"],
  setup(e, { emit: t }) {
    const n = t, i = () => {
      n("confirm");
    }, r = () => {
      n("cancel");
    };
    return (c, d) => (V(), G("div", BK, [
      c.title ? (V(), G("h2", {
        key: 0,
        class: "modal-title",
        innerHTML: c.title
      }, null, 8, VK)) : _e("", !0),
      E("div", {
        class: "modal-content",
        innerHTML: c.message
      }, null, 8, UK),
      E("div", HK, [
        c.primaryCta ? (V(), G("button", {
          key: 0,
          type: "submit",
          onClick: i,
          class: "vacv-btn-primary confirm"
        }, Y(c.primaryCta), 1)) : _e("", !0),
        c.secondaryCta ? (V(), G("button", {
          key: 1,
          type: "button",
          onClick: r,
          class: "vacv-btn-secondary cancel"
        }, Y(c.secondaryCta), 1)) : _e("", !0)
      ])
    ]));
  }
}), HTe = /* @__PURE__ */ at({
  __name: "ConfirmationModal",
  props: {
    show: { type: Boolean },
    hideClose: { type: Boolean },
    size: {},
    title: {},
    message: {},
    primaryCta: {},
    secondaryCta: {}
  },
  emits: ["close", "cancel", "confirm"],
  setup(e, { emit: t }) {
    const n = e, i = $e(n.show);
    At(
      () => n.show,
      () => {
        i.value = n.show;
      }
    );
    const r = t, c = () => {
      i.value = !1, r("close");
    }, d = () => {
      i.value = !1, r("cancel");
    }, a = () => {
      i.value = !1, r("confirm");
    };
    return (f, g) => (V(), Tt(rl, {
      onClose: c,
      modelValue: i.value,
      "onUpdate:modelValue": g[0] || (g[0] = (x) => i.value = x),
      class: "vacv-modal modal-fullscreen vacv-modal-centered confirmation-modal",
      "click-to-close": !1,
      "hide-close": f.hideClose,
      size: f.size,
      "aria-label": f.$t("vacvComponents.dialogs.confirmation.modal-label-accessibility")
    }, {
      default: Qt(() => [
        it(WK, {
          title: f.title,
          message: f.message,
          primaryCta: f.primaryCta,
          secondaryCta: f.secondaryCta,
          onConfirm: a,
          onCancel: d
        }, null, 8, ["title", "message", "primaryCta", "secondaryCta"])
      ]),
      _: 1
    }, 8, ["modelValue", "hide-close", "size", "aria-label"]));
  }
}), ZK = ["innerHTML"], qK = { class: "vacv-radio-group" }, jK = { for: "cubaPopupYes" }, GK = { for: "cubaPopupNo" }, YK = ["innerHTML"], KK = { class: "align-center" }, XK = ["disabled"], JK = {
  key: 1,
  class: "change-destination align-center padding-top"
}, QK = /* @__PURE__ */ E("i", { class: "fa-solid fa-pen-circle" }, null, -1), eX = /* @__PURE__ */ at({
  __name: "VacvCubaPopupDialog",
  emits: ["continue", "cancel"],
  setup(e, { emit: t }) {
    const n = t, i = () => {
      n("continue");
    }, r = () => {
      n("cancel");
    }, c = $e("no");
    return (d, a) => (V(), G("form", {
      onSubmit: zi(i, ["prevent"]),
      class: "cubaPopup"
    }, [
      E("h2", null, Y(d.$t("vacvComponents.dialogs.cubaPopup.title")), 1),
      E("div", {
        class: "cuba-question",
        innerHTML: d.$t("vacvComponents.dialogs.cubaPopup.question")
      }, null, 8, ZK),
      E("ul", qK, [
        E("li", null, [
          xr(E("input", {
            "onUpdate:modelValue": a[0] || (a[0] = (f) => c.value = f),
            class: "formkit-input vacv-custom",
            id: "cubaPopupYes",
            type: "radio",
            name: "yesno",
            value: "yes"
          }, null, 512), [
            [Gp, c.value]
          ]),
          E("label", jK, Y(d.$t("vacvComponents.dialogs.cubaPopup.yes")), 1)
        ]),
        E("li", null, [
          xr(E("input", {
            "onUpdate:modelValue": a[1] || (a[1] = (f) => c.value = f),
            id: "cubaPopupNo",
            class: "formkit-input vacv-custom",
            type: "radio",
            name: "yesno",
            value: "no",
            selected: ""
          }, null, 512), [
            [Gp, c.value]
          ]),
          E("label", GK, Y(d.$t("vacvComponents.dialogs.cubaPopup.no")), 1)
        ])
      ]),
      c.value === "yes" ? (V(), G("div", {
        key: 0,
        class: "dialog-scrolling-content",
        innerHTML: d.$t("vacvComponents.dialogs.cubaPopup.yesSelected")
      }, null, 8, YK)) : _e("", !0),
      E("div", KK, [
        E("button", {
          type: "submit",
          class: "vacv-btn-primary continue",
          disabled: c.value !== "yes" && c.value !== "no"
        }, Y(d.$t("vacvComponents.dialogs.cubaPopup.continue")), 9, XK)
      ]),
      c.value === "yes" ? (V(), G("div", JK, [
        E("a", {
          href: "/",
          onClick: zi(r, ["prevent"])
        }, [
          QK,
          mt(Y(d.$t("vacvComponents.dialogs.cubaPopup.changeDestination")), 1)
        ])
      ])) : _e("", !0)
    ], 32));
  }
}), WTe = /* @__PURE__ */ at({
  __name: "VacvCubaPopup",
  props: {
    show: { type: Boolean }
  },
  emits: ["cancel", "continue"],
  setup(e, { emit: t }) {
    const n = e, i = $e(n.show);
    At(
      () => n.show,
      () => {
        i.value = n.show;
      }
    );
    const r = t, c = () => {
      i.value = !1, r("cancel");
    }, d = () => {
      i.value = !1, r("continue");
    };
    return f1(c), (a, f) => (V(), Tt(rl, {
      onClose: c,
      modelValue: i.value,
      "onUpdate:modelValue": f[0] || (f[0] = (g) => i.value = g),
      class: "vacv-modal modal-fullscreen vacv-modal-centered cuba-popup-modal",
      "click-to-close": !1
    }, {
      default: Qt(() => [
        it(eX, {
          onContinue: d,
          onCancel: c
        })
      ]),
      _: 1
    }, 8, ["modelValue"]));
  }
}), tX = {
  id: "ae-signin-form",
  class: "ae-signin-container"
}, nX = {
  key: 0,
  class: "ae-signin-logo"
}, iX = ["src", "alt"], rX = { class: "text" }, sX = { class: "ae-btn-wrapper" }, oX = ["href"], aX = /* @__PURE__ */ at({
  __name: "VacvAeSignIn",
  props: {
    aeroplanSignInUrl: {},
    aeroplanLogoUrl: { default: "/img/aeroplan-logo.png" }
  },
  emits: ["continue-as-guest", "sign-in"],
  setup(e, { emit: t }) {
    const n = t, i = () => {
      n("sign-in");
    }, r = () => {
      n("continue-as-guest");
    };
    return (c, d) => (V(), G("div", tX, [
      c.aeroplanLogoUrl ? (V(), G("div", nX, [
        E("img", {
          src: c.aeroplanLogoUrl,
          alt: c.$t("vacvComponents.aeroplan.aeroplan")
        }, null, 8, iX)
      ])) : _e("", !0),
      E("div", rX, Y(c.$t("vacvComponents.aeroplan.earn-or-book-and-save")), 1),
      E("div", sX, [
        E("a", {
          class: "ae-link vacv-btn-primary",
          href: c.aeroplanSignInUrl,
          rel: "noreferrer noopener",
          onClick: d[0] || (d[0] = (a) => i())
        }, Y(c.$t("vacvComponents.aeroplan.signin-btn")), 9, oX),
        it(hP, {
          secondary: !0,
          label: c.$t("vacvComponents.aeroplan.cont-as-guest-btn"),
          onClick: d[1] || (d[1] = (a) => r())
        }, null, 8, ["label"])
      ])
    ]));
  }
}), lX = /* @__PURE__ */ at({
  __name: "VacvAeSignInModal",
  props: {
    aeroplanSignInUrl: {},
    aeroplanLogoUrl: {}
  },
  emits: ["continue-as-guest", "sign-in", "close"],
  setup(e, { emit: t }) {
    const n = $e(!0), i = t, r = () => {
      n.value = !1, i("continue-as-guest");
    }, c = () => {
      i("sign-in");
    }, d = () => {
      n.value = !1, i("close");
    };
    return (a, f) => (V(), Tt(rl, {
      modelValue: n.value,
      "onUpdate:modelValue": f[2] || (f[2] = (g) => n.value = g),
      onClose: f[3] || (f[3] = (g) => d()),
      class: "vacv-modal modal-fullscreen vacv-modal-centered"
    }, {
      default: Qt(() => [
        it(aX, {
          "aeroplan-sign-in-url": a.aeroplanSignInUrl,
          "aeroplan-logo-url": a.aeroplanLogoUrl,
          onContinueAsGuest: f[0] || (f[0] = (g) => r()),
          onSignIn: f[1] || (f[1] = (g) => c())
        }, null, 8, ["aeroplan-sign-in-url", "aeroplan-logo-url"])
      ]),
      _: 1
    }, 8, ["modelValue"]));
  }
}), ZTe = /* @__PURE__ */ at({
  __name: "VacvFormkitWrapper",
  props: {
    modelValue: {},
    name: {},
    componentClasses: {}
  },
  setup(e) {
    const t = kI();
    return (n, i) => (V(), Tt(ne(Dx), jf({
      type: "custom",
      name: n.name,
      "model-value": n.modelValue
    }, ne(t)), {
      default: Qt(() => [
        er(n.$slots, "default")
      ]),
      _: 3
    }, 16, ["name", "model-value"]));
  }
}), cX = {}, uX = (e) => (nl("data-v-2026153c"), e = e(), il(), e), dX = { class: "rotate-screen-icon" }, pX = /* @__PURE__ */ uX(() => /* @__PURE__ */ E("i", { class: "fa-kit fa-screen-rotate-acv" }, null, -1)), hX = [
  pX
];
function fX(e, t) {
  return V(), G("div", dX, hX);
}
const mX = /* @__PURE__ */ Zn(cX, [["render", fX], ["__scopeId", "data-v-2026153c"]]), vX = /* @__PURE__ */ at({
  __name: "ImageCarouselTransition",
  props: {
    direction: {}
  },
  setup(e) {
    return (t, n) => (V(), G(cn, null, [
      it($r, { name: "overlay" }, {
        default: Qt(() => [
          er(t.$slots, "fallback")
        ]),
        _: 3
      }),
      it($r, { name: t.direction }, {
        default: Qt(() => [
          er(t.$slots, "image")
        ]),
        _: 3
      }, 8, ["name"])
    ], 64));
  }
}), gX = (e, t) => {
  const n = $e(null);
  return F6(e, {
    passive: !0,
    onSwipeEnd(i, r) {
      switch (r) {
        case "left":
        case "right":
          n.value = r, t[r]();
          break;
        default:
          n.value = r;
      }
    }
  }), {
    swipeDirection: n
  };
}, yX = ["aria-label"], _X = /* @__PURE__ */ E("span", { class: "btn-prev fa-chevron-left" }, null, -1), bX = [
  _X
], wX = ["src", "alt"], xX = ["aria-label"], $X = /* @__PURE__ */ E("span", { class: "btn-next fa-chevron-right" }, null, -1), CX = [
  $X
], kX = { class: "vacv-carousel-caption" }, SX = { class: "caption-full" }, TX = { key: 0 }, IX = 1, _S = /* @__PURE__ */ at({
  __name: "ImageCarouselSlide",
  props: {
    indexPosition: {},
    imagesCount: {},
    imageUrl: {},
    direction: {},
    overlay: { type: Boolean },
    altText: {},
    description: {},
    mode: {}
  },
  emits: ["prev", "next", "on-select-image", "on-loaded"],
  setup(e, { emit: t }) {
    const n = e, i = t, r = $e(null);
    gX(r, {
      left: () => i("next"),
      right: () => i("prev")
    });
    const c = Xi("defaultImage"), d = (x) => {
      const $ = x.target;
      let A = parseInt($.getAttribute("data-retry-count") || "0");
      if (A >= IX) {
        $.src = "", $.alt = "Image failed to load";
        return;
      }
      A += 1, $.setAttribute("data-retry-count", A.toString()), $.src = c ?? "";
    }, a = Ae(() => n.mode === "cinema" ? !1 : n.overlay), f = Ae(() => n.imageUrl ? n.overlay : !1), g = Ae(() => n.imageUrl ?? c);
    return (x, $) => (V(), G(cn, null, [
      E("div", {
        class: "vacv-carousel__slide",
        ref_key: "swipeHandler",
        ref: r
      }, [
        x.imagesCount > 1 ? (V(), G("button", {
          key: 0,
          onClick: $[0] || ($[0] = zi((A) => x.$emit("prev"), ["stop"])),
          class: "left vacv-carousel-control",
          "aria-label": x.$t("vacvComponents.carousel.aria-previous")
        }, bX, 8, yX)) : _e("", !0),
        it(vX, { direction: x.direction }, {
          fallback: Qt(() => [
            xr(E("span", {
              class: Et(["vacv-carousel__overlay", { "vacv-carousel__overlay--cinema": x.mode === "cinema" }])
            }, null, 2), [
              [th, f.value]
            ])
          ]),
          image: Qt(() => [
            (V(), G("img", {
              ref: "smallImage",
              class: Et(["vacv-carousel__img", { "vacv-carousel__img--cinema": x.mode === "cinema" }]),
              src: a.value ? "" : g.value,
              alt: x.altText,
              tabindex: "0",
              onLoad: $[1] || ($[1] = (A) => x.$emit("on-loaded", x.imageUrl)),
              onClick: $[2] || ($[2] = (A) => x.$emit("on-select-image")),
              onKeyup: $[3] || ($[3] = jy((A) => x.$emit("on-select-image"), ["enter"])),
              onError: d,
              key: x.imageUrl,
              role: "button"
            }, null, 42, wX))
          ]),
          _: 1
        }, 8, ["direction"]),
        x.imagesCount > 1 ? (V(), G("button", {
          key: 1,
          onClick: $[4] || ($[4] = zi((A) => x.$emit("next"), ["stop"])),
          class: "right vacv-carousel-control",
          "aria-label": x.$t("vacvComponents.carousel.aria-next")
        }, CX, 8, xX)) : _e("", !0)
      ], 512),
      E("div", kX, [
        E("span", SX, [
          mt(Y(x.indexPosition + 1) + " " + Y(x.$t("vacvComponents.carousel.slidenum")) + " " + Y(x.imagesCount) + " ", 1),
          x.description ? (V(), G("span", TX, " - ")) : _e("", !0),
          mt(" " + Y(x.description), 1)
        ])
      ])
    ], 64));
  }
}), AX = {
  class: "vacv-carousel vacv-carousel-thumbs",
  id: "carousel-thumbs"
}, EX = ["aria-label"], PX = /* @__PURE__ */ E("span", { class: "btn-prev fa-chevron-left" }, null, -1), MX = [
  PX
], DX = { class: "vacv-carousel-inner" }, LX = ["data-index"], OX = { class: "thumb" }, NX = ["onClick"], FX = ["src", "alt"], RX = ["aria-label"], zX = /* @__PURE__ */ E("span", { class: "btn-next fa-chevron-right" }, null, -1), BX = [
  zX
], go = 6, VX = /* @__PURE__ */ at({
  __name: "ImageCarouselThumbs",
  props: {
    position: {},
    images: {},
    direction: {},
    availableVariations: {}
  },
  emits: ["select"],
  setup(e, { emit: t }) {
    const n = e, i = t, r = Xi("defaultImage"), c = (O) => {
      O.target.src = r ?? "";
    }, d = (O) => {
      const B = n.images[O];
      return Wg(
        B.small,
        "cinema",
        n.availableVariations
      );
    }, a = n.images.map((O, B) => ({
      ...O,
      thumbnail: d(B)
    })), f = $e(Math.floor(n.position / go) * go), g = $e(f.value + go), x = Ae(() => a.slice(f.value, g.value));
    At(
      () => n.position,
      (O) => {
        O !== void 0 && (O >= g.value ? n.direction === "backward" ? $() : A() : O === 0 ? (f.value = 0, g.value = go) : O < f.value && (f.value -= go, g.value -= go));
      }
    );
    const $ = () => {
      f.value === 0 ? (f.value = (Math.ceil(n.images.length / go) - 1) * go, g.value = f.value + go) : (f.value -= go, g.value -= go);
    }, A = () => {
      g.value < n.images.length ? (f.value += go, g.value += go) : (f.value = 0, g.value = go);
    }, I = Ae(() => n.images.length > 6);
    return (O, B) => (V(), G("div", AX, [
      I.value ? (V(), G("button", {
        key: 0,
        onClick: zi($, ["stop"]),
        class: "left vacv-carousel-control",
        "aria-label": O.$t("vacvComponents.carousel.aria-previous")
      }, MX, 8, EX)) : _e("", !0),
      E("div", DX, [
        (V(!0), G(cn, null, Pn(x.value, (H, N) => (V(), G("div", {
          key: H.small,
          "data-index": N,
          class: Et(["item", {
            selected: O.position !== void 0 && O.position - f.value === N
          }])
        }, [
          E("div", OX, [
            E("a", {
              onClick: zi((K) => i("select", f.value + N), ["prevent"]),
              href: "/",
              role: "button"
            }, [
              E("img", {
                src: H.thumbnail,
                alt: H.altText,
                onError: c
              }, null, 40, FX)
            ], 8, NX)
          ])
        ], 10, LX))), 128))
      ]),
      I.value ? (V(), G("button", {
        key: 1,
        onClick: zi(A, ["stop"]),
        class: "right vacv-carousel-control",
        "aria-label": O.$t("vacvComponents.carousel.aria-next")
      }, BX, 8, RX)) : _e("", !0)
    ]));
  }
}), UX = (e, t) => {
  const n = $e("forward"), i = O6(e), r = "backward", c = "forward", d = $e(0), a = Ae(() => n.value === c), f = Ae(() => n.value === r);
  return {
    ...i,
    prev: () => {
      n.value = "backward", i.prev(), d.value = (d.value - 1 + e.length) % e.length;
    },
    next: () => {
      n.value = "forward", i.next(), d.value = (d.value + 1) % e.length;
    },
    direction: n,
    isForward: a,
    isBackward: f,
    currentIndex: d
  };
};
function Lx(e) {
  return m1() ? (v1(e), !0) : !1;
}
const vD = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const HX = (e) => e != null, WX = Object.prototype.toString, ZX = (e) => WX.call(e) === "[object Object]", Ig = () => {
}, bS = /* @__PURE__ */ qX();
function qX() {
  var e, t;
  return vD && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function Ag(e) {
  return Array.isArray(e) ? e : [e];
}
function jX(...e) {
  if (e.length !== 1)
    return eh(...e);
  const t = e[0];
  return typeof t == "function" ? Zy(CI(() => ({ get: t, set: Ig }))) : $e(t);
}
function GX(e, t, n) {
  return At(
    e,
    t,
    {
      ...n,
      immediate: !0
    }
  );
}
const gD = vD ? window : void 0;
function Eg(e) {
  var t;
  const n = kc(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
function YX(...e) {
  const t = [], n = () => {
    t.forEach((a) => a()), t.length = 0;
  }, i = (a, f, g, x) => (a.addEventListener(f, g, x), () => a.removeEventListener(f, g, x)), r = Ae(() => {
    const a = Ag(kc(e[0])).filter((f) => f != null);
    return a.every((f) => typeof f != "string") ? a : void 0;
  }), c = GX(
    () => {
      var a, f;
      return [
        (f = (a = r.value) == null ? void 0 : a.map((g) => Eg(g))) != null ? f : [gD].filter((g) => g != null),
        Ag(kc(r.value ? e[1] : e[0])),
        Ag(ne(r.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        kc(r.value ? e[3] : e[2])
      ];
    },
    ([a, f, g, x]) => {
      if (n(), !(a != null && a.length) || !(f != null && f.length) || !(g != null && g.length))
        return;
      const $ = ZX(x) ? { ...x } : x;
      t.push(
        ...a.flatMap(
          (A) => f.flatMap(
            (I) => g.map((O) => i(A, I, O, $))
          )
        )
      );
    },
    { flush: "post" }
  ), d = () => {
    c(), n();
  };
  return Lx(n), d;
}
function KX() {
  const e = qy(!1), t = Du();
  return t && Li(() => {
    e.value = !0;
  }, t), e;
}
function XX(e) {
  const t = KX();
  return Ae(() => (t.value, !!e()));
}
function wS(e, t, n = {}) {
  const {
    root: i,
    rootMargin: r = "0px",
    threshold: c = 0,
    window: d = gD,
    immediate: a = !0
  } = n, f = XX(() => d && "IntersectionObserver" in d), g = Ae(() => {
    const O = kc(e);
    return Ag(O).map(Eg).filter(HX);
  });
  let x = Ig;
  const $ = $e(a), A = f.value ? At(
    () => [g.value, Eg(i), $.value],
    ([O, B]) => {
      if (x(), !$.value || !O.length)
        return;
      const H = new IntersectionObserver(
        t,
        {
          root: Eg(B),
          rootMargin: r,
          threshold: c
        }
      );
      O.forEach((N) => N && H.observe(N)), x = () => {
        H.disconnect(), x = Ig;
      };
    },
    { immediate: a, flush: "post" }
  ) : Ig, I = () => {
    x(), A(), $.value = !1;
  };
  return Lx(I), {
    isSupported: f,
    isActive: $,
    pause() {
      x(), $.value = !1;
    },
    resume() {
      $.value = !0;
    },
    stop: I
  };
}
function i0(e) {
  return typeof Window < "u" && e instanceof Window ? e.document.documentElement : typeof Document < "u" && e instanceof Document ? e.documentElement : e;
}
const Zd = {
  mounted(e, t) {
    typeof t.value == "function" ? wS(e, t.value) : wS(e, ...t.value);
  }
};
function yD(e) {
  const t = window.getComputedStyle(e);
  if (t.overflowX === "scroll" || t.overflowY === "scroll" || t.overflowX === "auto" && e.clientWidth < e.scrollWidth || t.overflowY === "auto" && e.clientHeight < e.scrollHeight)
    return !0;
  {
    const n = e.parentNode;
    return !n || n.tagName === "BODY" ? !1 : yD(n);
  }
}
function JX(e) {
  const t = e || window.event, n = t.target;
  return yD(n) ? !1 : t.touches.length > 1 ? !0 : (t.preventDefault && t.preventDefault(), !1);
}
const r0 = /* @__PURE__ */ new WeakMap();
function QX(e, t = !1) {
  const n = $e(t);
  let i = null, r = "";
  At(jX(e), (a) => {
    const f = i0(kc(a));
    if (f) {
      const g = f;
      if (r0.get(g) || r0.set(g, g.style.overflow), g.style.overflow !== "hidden" && (r = g.style.overflow), g.style.overflow === "hidden")
        return n.value = !0;
      if (n.value)
        return g.style.overflow = "hidden";
    }
  }, {
    immediate: !0
  });
  const c = () => {
    const a = i0(kc(e));
    !a || n.value || (bS && (i = YX(
      a,
      "touchmove",
      (f) => {
        JX(f);
      },
      { passive: !1 }
    )), a.style.overflow = "hidden", n.value = !0);
  }, d = () => {
    const a = i0(kc(e));
    !a || !n.value || (bS && (i == null || i()), a.style.overflow = r, r0.delete(a), n.value = !1);
  };
  return Lx(d), Ae({
    get() {
      return n.value;
    },
    set(a) {
      a ? c() : d();
    }
  });
}
function eJ() {
  let e = !1;
  const t = qy(!1);
  return (n, i) => {
    if (t.value = i.value, e)
      return;
    e = !0;
    const r = QX(n, i.value);
    At(t, (c) => r.value = c);
  };
}
eJ();
const tJ = {
  key: 0,
  class: "vacv-carousel"
}, nJ = { class: "vacv-carousel-inner" }, iJ = { class: "item" }, rJ = ["src", "onLoad", "onError"], sJ = {
  id: "carousel-full",
  class: "vacv-carousel carousel-full",
  "data-interval": "false"
}, oJ = { class: "vacv-carousel-inner" }, aJ = { class: "item-wrapper" }, Ox = /* @__PURE__ */ at({
  __name: "VacvImageCarousel",
  props: {
    images: {},
    sizes: {},
    hotelName: {},
    displaySize: {},
    displayVariation: {},
    availableVariations: {},
    isPlpRoomDetails: { type: Boolean }
  },
  setup(e) {
    const t = e, n = $e(!1), i = Ae(() => t.images.length), r = Ae(() => t.images.map((pe) => {
      const Ne = Wg(
        pe.url,
        n.value ? "cinema" : t.displayVariation,
        t.availableVariations
      ), We = { ...pe, url: Ne }, Ge = qF(We, t.sizes);
      return {
        ...We,
        url: Ge[t.displaySize],
        ...Ge
      };
    })), c = Ae(() => {
      const le = r.value[I.value].xlarge, pe = "cinema", Ne = t.availableVariations;
      return Wg(le, pe, Ne);
    });
    function d(le, pe, Ne) {
      const We = pe === "medium" ? Ne[le].medium : Ne[le].large, Ge = pe === "medium" ? "tabletLandscape" : "cinema";
      return We && t.availableVariations ? jF(We, Ge, t.availableVariations) : We;
    }
    const a = Ae(() => d(
      I.value,
      t.displaySize,
      r.value
    )), f = Ae(() => d(
      O.value,
      t.displaySize,
      r.value
    )), g = Ae(() => d(
      B.value,
      t.displaySize,
      r.value
    )), { next: x, prev: $, direction: A, currentIndex: I } = UX(
      r.value
    ), O = Ae(
      () => (I.value - 1 + i.value) % i.value
    ), B = Ae(() => (I.value + 1) % i.value), H = Er(
      /* @__PURE__ */ new Map([
        [r.value[O.value].url, !1],
        [r.value[I.value].url, !1],
        [r.value[B.value].url, !1]
      ])
    );
    At([I, n], ([, le]) => {
      le && (N(r.value[O.value].xlarge), N(r.value[B.value].xlarge), N(a.value)), N(f.value), N(g.value);
    });
    const N = (le) => {
      H.get(le) || H.set(le, !1);
    }, K = $e(!1), U = ([
      { isIntersecting: le }
    ]) => {
      le && (K.value = le);
    }, q = (le) => {
      A.value = le < I.value ? "backward" : "forward", I.value = le;
    }, ee = Ae(() => !!H.get(r.value[I.value].url)), te = Ae(() => !!H.get(r.value[I.value].xlarge)), ae = Ae(() => !(K.value && ee.value)), oe = Ae(() => !te.value), de = (le) => {
      H.set(le, !0);
    }, me = (le) => {
      H.set(le, "ERROR");
    }, ve = () => {
      N(r.value[O.value].xlarge), N(r.value[I.value].xlarge), N(r.value[B.value].xlarge), n.value = !0, document.documentElement.style.setProperty("overflow-x", "unset"), t.hotelName && (t.isPlpRoomDetails ? ia("Room Modal - Room Picture", t.hotelName) : ia("Hotel Picture", t.hotelName));
    }, re = () => {
      document.documentElement.style.removeProperty("overflow-x"), n.value = !1;
    };
    return (le, pe) => i.value ? (V(), G("div", tJ, [
      xr((V(), G("div", nJ, [
        E("div", iJ, [
          K.value ? (V(!0), G(cn, { key: 0 }, Pn(H, ([Ne]) => (V(), G("img", {
            class: "vacv-carousel__img--preload",
            src: Ne,
            key: Ne,
            onLoad: (We) => de(Ne),
            onError: (We) => me(Ne),
            alt: ""
          }, null, 40, rJ))), 128)) : _e("", !0),
          it(_S, {
            direction: ne(A),
            overlay: ae.value,
            "alt-text": le.$t("vacvComponents.carousel.photo") + r.value[ne(I)].altText,
            "image-url": r.value[ne(I)].url,
            "index-position": ne(I),
            "images-count": i.value,
            onOnSelectImage: ve,
            onPrev: ne($),
            onNext: ne(x)
          }, null, 8, ["direction", "overlay", "alt-text", "image-url", "index-position", "images-count", "onPrev", "onNext"]),
          it(rl, {
            modelValue: n.value,
            "onUpdate:modelValue": pe[1] || (pe[1] = (Ne) => n.value = Ne),
            class: "vacv-modal modal-fullscreen vacv-modal-carousel",
            id: "vacv-carousel-modal",
            onClose: re
          }, {
            default: Qt(() => [
              it(mX),
              E("div", sJ, [
                E("div", oJ, [
                  E("div", aJ, [
                    it(_S, {
                      direction: ne(A),
                      "alt-text": r.value[ne(I)].altText,
                      "image-url": c.value,
                      description: r.value[ne(I)].description,
                      "index-position": ne(I),
                      "images-count": i.value,
                      overlay: oe.value,
                      mode: "cinema",
                      onOnLoaded: de,
                      onPrev: ne($),
                      onNext: ne(x)
                    }, null, 8, ["direction", "alt-text", "image-url", "description", "index-position", "images-count", "overlay", "onPrev", "onNext"])
                  ]),
                  it(VX, {
                    direction: ne(A),
                    position: ne(I),
                    images: r.value,
                    "available-variations": le.availableVariations,
                    onSelect: pe[0] || (pe[0] = (Ne) => q(Ne))
                  }, null, 8, ["direction", "position", "images", "available-variations"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ])), [
        [ne(Zd), U]
      ])
    ])) : _e("", !0);
  }
}), lJ = { class: "insurance-notes" }, cJ = ["innerHTML"], uJ = /* @__PURE__ */ at({
  __name: "InsuranceNotes",
  props: {
    insuranceNotes: {}
  },
  setup(e) {
    return (t, n) => (V(), G("div", lJ, [
      E("div", {
        class: "notes vacv-editor special-list",
        innerHTML: t.insuranceNotes
      }, null, 8, cJ)
    ]));
  }
}), dJ = { class: "insurance-section" }, pJ = { class: "insurance-box paddedbox-grey" }, hJ = {
  key: 0,
  class: "insurance-info"
}, fJ = { class: "insurance-product" }, mJ = { class: "insurance-travellers-number" }, vJ = { class: "insurance-amount" }, gJ = {
  key: 1,
  class: "insurance-optout"
}, yJ = {
  key: 2,
  class: "insurance-optout"
}, qTe = /* @__PURE__ */ at({
  __name: "InsuranceDetails",
  props: {
    insuranceNotes: {},
    insuranceNbPax: {},
    travelInsuranceFailedOnReQuote: { type: Boolean }
  },
  setup(e) {
    const t = Wl(), {
      selectedInsuranceProduct: n,
      declinedTravelInsurance: i,
      hasSelectedInsuranceProduct: r
    } = Nn(t);
    return (c, d) => (V(), G("section", dJ, [
      E("h2", null, Y(c.$t("vacvComponents.payment.labels.allianzTravelInsuranceTitle")), 1),
      ne(r) ? (V(), Tt(uJ, {
        key: 0,
        insuranceNotes: c.insuranceNotes
      }, null, 8, ["insuranceNotes"])) : _e("", !0),
      E("div", pJ, [
        ne(r) ? (V(), G("div", hJ, [
          E("span", fJ, Y(ne(n).title), 1),
          E("span", mJ, Y(c.$t("vacvComponents.payment.labels.insuranceForXTravellers", {
            x: c.insuranceNbPax
          })), 1),
          E("span", vJ, Y(ne(Wn)(ne(n).premium, c.$n)) + " " + Y(c.$t("vacvComponents.payment.labels.plusTaxes")), 1)
        ])) : ne(i) ? (V(), G("div", gJ, Y(c.$t("vacvComponents.payment.labels.allianzOptedOutInsurance")), 1)) : c.travelInsuranceFailedOnReQuote ? (V(), G("div", yJ, Y(c.$t("vacvComponents.payment.messages.travelInsuranceNoOptions")), 1)) : _e("", !0)
      ])
    ]));
  }
}), _J = { class: "decline-insurance" }, bJ = { class: "vacv-checkbox" }, jTe = /* @__PURE__ */ at({
  __name: "InsuranceDecline",
  setup(e) {
    const t = Wl(), { declineInsurance: n } = t, { declinedTravelInsurance: i } = Nn(t);
    function r() {
      const c = i.value;
      n(!c), c || zE("Decline Insurance");
    }
    return (c, d) => {
      const a = Ur("FormKit");
      return V(), G("div", _J, [
        E("div", bJ, [
          it(a, {
            name: "insurance-decline",
            id: "insurance-decline",
            type: "checkbox",
            label: c.$t("vacvComponents.payment.labels.allianzDeclineTravelInsurance"),
            modelValue: ne(i),
            "onUpdate:modelValue": d[0] || (d[0] = (f) => yo(i) ? i.value = f : null),
            "decorator-icon": ne(Lu),
            onClick: r,
            "aria-checked": ne(i) ? "true" : "false"
          }, null, 8, ["label", "modelValue", "decorator-icon", "aria-checked"])
        ])
      ]);
    };
  }
}), wJ = { class: "insurance-description" }, xJ = { class: "description" }, $J = ["src"], GTe = /* @__PURE__ */ at({
  __name: "InsuranceDescription",
  props: {
    insuranceCompanyLogo: {}
  },
  setup(e) {
    return (t, n) => (V(), G("div", wJ, [
      E("div", xJ, [
        E("img", {
          src: t.insuranceCompanyLogo,
          height: "56",
          alt: ""
        }, null, 8, $J),
        E("p", null, Y(t.$t("vacvComponents.payment.labels.allianzTravelInsuranceDescription")), 1),
        E("p", null, [
          E("strong", null, Y(t.$t("vacvComponents.payment.labels.allianzTravelInsuranceDescription2")), 1)
        ])
      ])
    ]));
  }
}), CJ = { class: "insurance-disclaimer" }, kJ = ["innerHTML"], YTe = /* @__PURE__ */ at({
  __name: "InsuranceDisclaimer",
  props: {
    insuranceDisclaimer: {}
  },
  setup(e) {
    return (t, n) => (V(), G("div", CJ, [
      E("div", {
        class: "disclaimer vacv-editor",
        innerHTML: t.insuranceDisclaimer
      }, null, 8, kJ)
    ]));
  }
}), SJ = { class: "insurance-table insurance-table-desktop" }, TJ = { class: "table-recommended-row" }, IJ = {
  id: "empty-recomended-line",
  style: { width: "30%" }
}, AJ = { class: "sr-only" }, EJ = ["id"], PJ = {
  key: 0,
  class: "insurance-header-sup"
}, MJ = /* @__PURE__ */ E("i", {
  class: "fa-solid fa-thumbs-up",
  "aria-hidden": "true"
}, null, -1), DJ = {
  key: 1,
  class: "sr-only"
}, LJ = { class: "table-header-row" }, OJ = {
  id: "title-line-empty",
  class: "insurance-item-title",
  style: { width: "30%" }
}, NJ = { class: "sr-only" }, FJ = ["id"], RJ = { class: "table-row" }, zJ = {
  class: "table-left-column product-title product-price",
  style: { width: "30%" }
}, BJ = {
  class: "table-left-column product-title",
  style: { width: "30%" }
}, VJ = ["onClick", "aria-label"], UJ = /* @__PURE__ */ E("span", { class: "round-icon" }, null, -1), HJ = [
  UJ
], WJ = {
  key: 0,
  class: "fa-solid fa-check"
}, ZJ = { class: "table-button-row" }, qJ = /* @__PURE__ */ E("td", {
  class: "table-left-column",
  style: { width: "30%" }
}, null, -1), jJ = ["onclick"], GJ = { class: "add" }, YJ = { class: "sr-only" }, KJ = { class: "added" }, XJ = /* @__PURE__ */ E("i", {
  class: "fa-solid fa-check",
  "aria-hidden": "true"
}, null, -1), JJ = { class: "sr-only" }, QJ = { class: "table-terms-row" }, eQ = /* @__PURE__ */ E("td", { style: { width: "30%" } }, null, -1), tQ = ["href", "innerHTML"], nQ = ["href", "innerHTML"], iQ = /* @__PURE__ */ at({
  __name: "InsuranceOptionsDesktop",
  props: {
    travelInsuranceProducts: {},
    numberOfInsuredPassengers: {}
  },
  emits: ["handleSelectionOfInsuranceProduct"],
  setup(e, { emit: t }) {
    const n = t, i = Wl(), { setShowModalInclusionDetails: r, setModalContent: c, setModalTitle: d } = i, { selectedInsuranceProduct: a, travelInsuranceInclusionsMatrix: f } = Nn(i), g = (x, $) => {
      c($), d(x), r(!0);
    };
    return (x, $) => (V(), G("table", SJ, [
      E("tr", TJ, [
        E("th", IJ, [
          E("div", AJ, Y(x.$t("vacvComponents.ancillary.access.table-cell-empty")), 1)
        ]),
        (V(!0), G(cn, null, Pn(x.travelInsuranceProducts, (A) => (V(), G("th", {
          key: A.productCode,
          id: `recomended-line-product-${A.productCode}`,
          class: "table-recommended-line"
        }, [
          A.recommended ? (V(), G("div", PJ, [
            MJ,
            mt(" " + Y(x.$t("vacvComponents.payment.labels.mostPopular")), 1)
          ])) : _e("", !0),
          A.recommended ? (V(), G("div", DJ, Y(x.$t("vacvComponents.ancillary.access.table-cell-empty")), 1)) : _e("", !0)
        ], 8, EJ))), 128))
      ]),
      E("tr", LJ, [
        E("th", OJ, [
          E("div", NJ, Y(x.$t("vacvComponents.ancillary.access.table-cell-empty")), 1)
        ]),
        (V(!0), G(cn, null, Pn(x.travelInsuranceProducts, (A) => {
          var I;
          return V(), G("th", {
            key: A.productCode,
            id: `title-line-product-${A.productCode}`,
            class: Et([
              "insurance-item-title",
              {
                "selected-product-column": ((I = ne(a)) == null ? void 0 : I.productCode) == A.productCode
              }
            ])
          }, Y(A.title), 11, FJ);
        }), 128))
      ]),
      E("tr", RJ, [
        E("td", zJ, Y(x.numberOfInsuredPassengers > 1 ? x.$t(
          "vacvComponents.payment.labels.priceTitle",
          x.numberOfInsuredPassengers
        ) : x.$t("vacvComponents.payment.labels.priceTitle")), 1),
        (V(!0), G(cn, null, Pn(x.travelInsuranceProducts, (A, I) => {
          var O;
          return V(), G("td", {
            key: A.productCode,
            class: Et([
              "h1style",
              {
                "selected-product-column": ((O = ne(a)) == null ? void 0 : O.productCode) == A.productCode
              },
              {
                "table-right-column": I === x.travelInsuranceProducts.length - 1
              }
            ])
          }, Y("+ " + ne(Wn)(A.premium, x.$n)), 3);
        }), 128))
      ]),
      (V(!0), G(cn, null, Pn(ne(f), (A, I) => (V(), G("tr", {
        class: "table-row",
        key: I
      }, [
        E("td", BJ, [
          mt(Y(I), 1),
          A ? (V(), G("button", {
            key: 0,
            onClick: (O) => g(I, A),
            class: "price-popover-link",
            "aria-haspopup": "true",
            "aria-label": `${x.$t("vacvComponents.ancillary.access.know-more-about")} ${I}`
          }, HJ, 8, VJ)) : _e("", !0)
        ]),
        (V(!0), G(cn, null, Pn(x.travelInsuranceProducts, (O, B) => {
          var H;
          return V(), G("td", {
            key: O.productCode,
            class: Et([
              { "content-middle": B === 0 },
              {
                "selected-product-column": ((H = ne(a)) == null ? void 0 : H.productCode) === O.productCode
              },
              {
                "table-right-column": B === x.travelInsuranceProducts.length - 1
              }
            ])
          }, [
            O.inclusions.some(
              (N) => N.title === I
            ) ? (V(), G("i", WJ)) : _e("", !0)
          ], 2);
        }), 128))
      ]))), 128)),
      E("tr", ZJ, [
        qJ,
        (V(!0), G(cn, null, Pn(x.travelInsuranceProducts, (A, I) => {
          var O, B;
          return V(), G("td", {
            key: A.productCode,
            class: Et([
              {
                "selected-product-column": ((O = ne(a)) == null ? void 0 : O.productCode) == A.productCode
              },
              {
                "table-right-column": I === x.travelInsuranceProducts.length - 1
              }
            ])
          }, [
            E("button", {
              class: Et(["vacv-btn-secondary", {
                active: ((B = ne(a)) == null ? void 0 : B.productCode) === A.productCode
              }]),
              onclick: () => n("handleSelectionOfInsuranceProduct", A)
            }, [
              E("span", GJ, [
                mt(Y(x.$t("vacvComponents.common.buttons.add")) + " ", 1),
                E("span", YJ, Y(A.title), 1)
              ]),
              E("span", KJ, [
                XJ,
                E("span", JJ, Y(A.title), 1),
                mt(" " + Y(x.$t("vacvComponents.common.buttons.added")), 1)
              ])
            ], 10, jJ)
          ], 2);
        }), 128))
      ]),
      E("tr", QJ, [
        eQ,
        (V(!0), G(cn, null, Pn(x.travelInsuranceProducts, (A) => {
          var I;
          return V(), G("td", {
            key: A.productCode,
            class: Et([
              {
                "selected-product-column": ((I = ne(a)) == null ? void 0 : I.productCode) == A.productCode
              }
            ]),
            style: { width: "23.3%" }
          }, [
            A.termsConditionsUrl ? (V(), G("a", {
              key: 0,
              href: A.termsConditionsUrl,
              target: "_blank",
              class: "navback-link link product-terms",
              innerHTML: x.$t("vacvComponents.payment.labels.allianzTermsAndConditions")
            }, null, 8, tQ)) : _e("", !0),
            A.productUrl ? (V(), G("a", {
              key: 1,
              href: A.productUrl,
              target: "_blank",
              class: "navback-link link product-terms",
              innerHTML: x.$t("vacvComponents.payment.labels.allianzProductSummary")
            }, null, 8, nQ)) : _e("", !0)
          ], 2);
        }), 128))
      ])
    ]));
  }
}), rQ = { class: "mobile-scroller-wrapper" }, sQ = { class: "mobile-scroller" }, oQ = {
  key: 0,
  class: "insurance-header-sup"
}, aQ = /* @__PURE__ */ E("i", {
  class: "fa-solid fa-thumbs-up",
  "aria-hidden": "true"
}, null, -1), lQ = { class: "table-header-row" }, cQ = {
  class: "insurance-item-title",
  colspan: "2"
}, uQ = { class: "table-row" }, dQ = { class: "product-title product-price" }, pQ = { class: "h1style" }, hQ = { class: "product-title" }, fQ = ["onClick", "aria-label"], mQ = /* @__PURE__ */ E("span", { class: "round-icon" }, null, -1), vQ = [
  mQ
], gQ = {
  key: 0,
  class: "fa-solid fa-check",
  "aria-hidden": "true"
}, yQ = { class: "table-button-row" }, _Q = { colspan: "2" }, bQ = ["onclick"], wQ = { class: "add" }, xQ = { class: "sr-only" }, $Q = { class: "added" }, CQ = /* @__PURE__ */ E("i", {
  class: "fa-solid fa-check",
  "aria-hidden": "true"
}, null, -1), kQ = { class: "sr-only" }, SQ = { class: "table-terms-row" }, TQ = { colspan: "2" }, IQ = ["href", "innerHTML"], AQ = ["href", "innerHTML"], EQ = /* @__PURE__ */ at({
  __name: "InsuranceOptionsMobile",
  props: {
    travelInsuranceProducts: {},
    numberOfInsuredPassengers: {}
  },
  emits: ["handleSelectionOfInsuranceProduct"],
  setup(e, { emit: t }) {
    const n = t, i = Wl(), { setModalContent: r, setModalTitle: c, setShowModalInclusionDetails: d } = i, { selectedInsuranceProduct: a, travelInsuranceInclusionsMatrix: f } = Nn(i), g = (x, $) => {
      r($), c(x), d(!0);
    };
    return (x, $) => (V(), G("div", rQ, [
      E("div", sQ, [
        (V(!0), G(cn, null, Pn(x.travelInsuranceProducts, (A, I) => {
          var O, B;
          return V(), G("div", {
            key: A.productCode,
            class: "mobile-table-container"
          }, [
            A.recommended ?? !1 ? (V(), G("div", oQ, [
              aQ,
              mt(" " + Y(x.$t("vacvComponents.payment.labels.mostPopular")), 1)
            ])) : _e("", !0),
            E("table", {
              class: Et([
                "insurance-table insurance-table-mobile",
                {
                  "selected-product-column": ((O = ne(a)) == null ? void 0 : O.productCode) == A.productCode
                }
              ])
            }, [
              E("tr", lQ, [
                E("th", cQ, Y(A.title), 1)
              ]),
              E("tr", uQ, [
                E("td", dQ, Y(x.numberOfInsuredPassengers > 1 ? x.$t(
                  "vacvComponents.payment.labels.priceTitle",
                  x.numberOfInsuredPassengers
                ) : x.$t("vacvComponents.payment.labels.priceTitle")), 1),
                E("td", pQ, Y("+ " + ne(Wn)(A.premium, x.$n)), 1)
              ]),
              (V(!0), G(cn, null, Pn(ne(f), (H, N) => (V(), G("tr", {
                class: "table-row",
                key: N
              }, [
                E("td", hQ, [
                  mt(Y(N), 1),
                  H ? (V(), G("button", {
                    key: 0,
                    class: "price-popover-link",
                    onClick: (K) => g(N, H),
                    "aria-haspopup": "true",
                    "aria-label": `${x.$t("ancillary.access.know-more-about")} ${N}`
                  }, vQ, 8, fQ)) : _e("", !0)
                ]),
                E("td", null, [
                  x.travelInsuranceProducts[I].inclusions.some(
                    (K) => K.title === N
                  ) ? (V(), G("i", gQ)) : _e("", !0)
                ])
              ]))), 128)),
              E("tr", yQ, [
                E("td", _Q, [
                  E("button", {
                    class: Et(["vacv-btn-secondary", {
                      active: ((B = ne(a)) == null ? void 0 : B.productCode) === A.productCode
                    }]),
                    onclick: () => n("handleSelectionOfInsuranceProduct", A)
                  }, [
                    E("span", wQ, [
                      mt(Y(x.$t("vacvComponents.common.buttons.add")) + " ", 1),
                      E("span", xQ, Y(A.title), 1)
                    ]),
                    E("span", $Q, [
                      CQ,
                      E("span", kQ, Y(A.title), 1),
                      mt(" " + Y(x.$t("vacvComponents.common.buttons.added")), 1)
                    ])
                  ], 10, bQ)
                ])
              ]),
              E("tr", SQ, [
                E("td", TQ, [
                  A.termsConditionsUrl ? (V(), G("a", {
                    key: 0,
                    href: A.termsConditionsUrl,
                    target: "_blank",
                    class: "navback-link link product-terms",
                    innerHTML: x.$t("vacvComponents.payment.labels.allianzTermsAndConditions")
                  }, null, 8, IQ)) : _e("", !0),
                  A.productUrl ? (V(), G("a", {
                    key: 1,
                    href: A.productUrl,
                    target: "_blank",
                    class: "navback-link link product-terms",
                    innerHTML: x.$t("vacvComponents.payment.labels.allianzProductSummary")
                  }, null, 8, AQ)) : _e("", !0)
                ])
              ])
            ], 2)
          ]);
        }), 128))
      ])
    ]));
  }
}), PQ = ["innerHTML"], MQ = ["innerHTML"], KTe = /* @__PURE__ */ at({
  __name: "InsuranceOptions",
  props: {
    travelInsuranceProducts: {},
    numberOfInsuredPassengers: {}
  },
  setup(e) {
    const t = Wl(), { selectTravelInsuranceProduct: n } = t, { modalTitle: i, modalContent: r } = Nn(t), { isTabletAndUp: c } = L5(), d = () => {
      t.setShowModalInclusionDetails(!1);
    };
    function a(f) {
      n(f), zE(f.productCode);
    }
    return (f, g) => (V(), G(cn, null, [
      it(rl, {
        onClose: d,
        modelValue: ne(t).showModalInclusionDetails,
        "onUpdate:modelValue": g[0] || (g[0] = (x) => ne(t).showModalInclusionDetails = x),
        class: "vacv-modal modal-fullscreen vacv-modal-centered"
      }, {
        default: Qt(() => [
          E("div", {
            id: "inclusions-modal-title",
            class: "h3style",
            innerHTML: ne(i)
          }, null, 8, PQ),
          E("div", {
            id: "inclusions-modal-content",
            class: "vacv-editor",
            innerHTML: ne(r)
          }, null, 8, MQ)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      ne(c) ? (V(), Tt(iQ, {
        key: 0,
        "travel-insurance-products": f.travelInsuranceProducts,
        "number-of-insured-passengers": f.numberOfInsuredPassengers,
        onHandleSelectionOfInsuranceProduct: a
      }, null, 8, ["travel-insurance-products", "number-of-insured-passengers"])) : (V(), Tt(EQ, {
        key: 1,
        "travel-insurance-products": f.travelInsuranceProducts,
        "number-of-insured-passengers": f.numberOfInsuredPassengers,
        onHandleSelectionOfInsuranceProduct: a
      }, null, 8, ["travel-insurance-products", "number-of-insured-passengers"]))
    ], 64));
  }
}), DQ = {
  key: 0,
  class: "filter-section filteredby",
  "aria-live": "polite"
}, LQ = { class: "vacv-label-sm" }, OQ = { class: "filteredby-wrapper" }, NQ = /* @__PURE__ */ at({
  __name: "FilteredBy",
  props: {
    maxPriceRange: {}
  },
  emits: ["clear-filters"],
  setup(e, { emit: t }) {
    const n = t, i = e, r = Bc(), { filters: c, selectedRangeFilters: d, selectedFixedFilters: a } = Nn(r), { t: f, n: g } = ki({ useScope: "global" });
    function x(q) {
      return Ae(() => {
        var ee;
        return q((ee = c.value) == null ? void 0 : ee.fixedValueFilters);
      });
    }
    const $ = x(nV), A = x(QB), I = x(eV), O = x(tV), B = (q) => {
      switch (q) {
        case "2-5":
          return f("vacvComponents.filters.starRatingOptions.2");
        case "3-5":
          return f("vacvComponents.filters.starRatingOptions.3");
        case "4-5":
          return f("vacvComponents.filters.starRatingOptions.4");
        case "5-5":
          return f("vacvComponents.filters.starRatingOptions.5");
        default:
          return "";
      }
    };
    function H(q, ee, te) {
      (q == null ? void 0 : q.length) > 0 && q.forEach((ae) => {
        const oe = ee.get(ae);
        oe && te.push(oe);
      });
    }
    const N = () => {
      const q = [], ee = a.value.find(
        (ve) => ve.name === "DEALS"
      );
      H((ee == null ? void 0 : ee.selectedIds) || [], $.value, q);
      const te = d.value.find(
        (ve) => ve.name === "PRICE"
      );
      te && (te.selectedLow !== 0 || te.selectedHigh !== i.maxPriceRange) && q.push(
        Wn(te.selectedLow, g, !0) + " - " + Wn(te.selectedHigh, g, !0) + `${te.selectedHigh === i.maxPriceRange ? " +" : ""}`
      );
      const ae = d.value.find(
        (ve) => ve.name === "RATING"
      );
      if (ae && (ae.selectedLow > 0 || ae.selectedHigh < 5)) {
        const ve = `${ae.selectedLow}-${ae.selectedHigh}`;
        q.push(B(ve));
      }
      const oe = a.value.find(
        (ve) => ve.name === "DESTINATION"
      );
      H(
        (oe == null ? void 0 : oe.selectedIds) || [],
        A.value,
        q
      );
      const de = a.value.find(
        (ve) => ve.name === "AMENITIES"
      );
      H(
        (de == null ? void 0 : de.selectedIds) || [],
        I.value,
        q
      );
      const me = a.value.find(
        (ve) => ve.name === "VACATION_TYPE"
      );
      return H(
        (me == null ? void 0 : me.selectedIds) || [],
        O.value,
        q
      ), q;
    }, K = Ae(() => N()), U = () => {
      n("clear-filters");
    };
    return (q, ee) => K.value.length > 0 ? (V(), G("section", DQ, [
      E("div", LQ, Y(q.$t("vacvComponents.filters.filteredBy")), 1),
      E("div", OQ, [
        (V(!0), G(cn, null, Pn(K.value, (te) => (V(), G("span", { key: te }, Y(te), 1))), 128))
      ]),
      E("button", {
        class: "link linklook",
        onClick: zi(U, ["prevent"]),
        type: "button",
        "data-test": "clearAllButton"
      }, Y(q.$t("vacvComponents.filters.clearFilters")), 1)
    ])) : _e("", !0);
  }
}), FQ = { class: "vacv-rangeslider-wrapper" }, RQ = /* @__PURE__ */ at({
  __name: "RangeSlider",
  emits: ["change-price-range"],
  setup(e, { emit: t }) {
    const n = t, i = Bc(), { filters: r, selectedRangeFilters: c } = Nn(i), d = Ae(() => {
      var $, A;
      const x = (A = ($ = r.value) == null ? void 0 : $.rangeValueFilters) == null ? void 0 : A.find(
        (I) => I.name === "PRICE"
      );
      return {
        min: (x == null ? void 0 : x.low) ?? 0,
        max: (x == null ? void 0 : x.high) ?? 5e3
      };
    }), a = Ae(() => [
      d.value.min,
      d.value.max
    ]), f = $e(a.value);
    function g() {
      const x = c.value.find(
        (O) => O.name === "PRICE"
      ), $ = (x == null ? void 0 : x.selectedLow) ?? d.value.min, A = (x == null ? void 0 : x.selectedHigh) ?? d.value.max, I = [
        Math.max(
          d.value.min,
          Math.min($, d.value.max)
        ),
        Math.max(
          d.value.min,
          Math.min(A, d.value.max)
        )
      ];
      f.value.splice(0, 2, I[0], I[1]);
    }
    return Li(() => {
      g();
    }), At(
      () => c.value.find((x) => x.name === "PRICE"),
      () => {
        g();
      },
      { deep: !0 }
    ), At(
      () => r.value,
      () => {
        g();
      },
      { deep: !0 }
    ), At(
      f,
      (x) => {
        n("change-price-range", x);
      },
      { deep: !0 }
    ), Ru(() => {
      f.value = a.value;
    }), (x, $) => {
      const A = Ur("FormKit");
      return V(), G("div", FQ, [
        it(A, {
          modelValue: f.value,
          "onUpdate:modelValue": $[0] || ($[0] = (I) => f.value = I),
          type: "slider",
          "outer-class": "vacv-formkit-rangeslider",
          min: d.value.min,
          max: d.value.max,
          value: f.value,
          tooltip: "false",
          "show-input": "",
          name: "priceRange",
          "min-input-attrs": {
            onpaste: "return false;"
          },
          "max-input-attrs": {
            onpaste: "return false;",
            sectionsSchema: {
              prefix: {
                $el: "span",
                children: "+",
                attrs: {
                  class: {
                    if: `$_value !== ${d.value.max}`,
                    then: "hidden"
                  }
                }
              }
            }
          }
        }, null, 8, ["modelValue", "min", "max", "value", "max-input-attrs"])
      ]);
    };
  }
}), zQ = { class: "filter-section starrating" }, BQ = { class: "vacv-radio" }, VQ = { class: "vacv-radio-group column" }, UQ = {
  class: "formkit-outer",
  "data-family": "box",
  "data-type": "radio",
  "data-multiple": "true",
  "data-complete": "true"
}, HQ = { class: "formkit-fieldset" }, WQ = { class: "formkit-legend" }, ZQ = { class: "formkit-options" }, qQ = { class: "formkit-option" }, jQ = { class: "formkit-wrapper" }, GQ = { class: "formkit-inner" }, YQ = { class: "formkit-label" }, KQ = /* @__PURE__ */ DN('<i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i>', 5), XQ = { class: "sr-only" }, JQ = { class: "formkit-option" }, QQ = { class: "formkit-wrapper" }, eee = { class: "formkit-inner" }, tee = { class: "formkit-label" }, nee = /* @__PURE__ */ E("i", { class: "fa-solid fa-star" }, null, -1), iee = /* @__PURE__ */ E("i", { class: "fa-solid fa-star" }, null, -1), ree = /* @__PURE__ */ E("i", { class: "fa-solid fa-star" }, null, -1), see = /* @__PURE__ */ E("i", { class: "fa-solid fa-star" }, null, -1), oee = { class: "sr-only" }, aee = { class: "formkit-option" }, lee = { class: "formkit-wrapper" }, cee = { class: "formkit-inner" }, uee = { class: "formkit-label" }, dee = /* @__PURE__ */ E("i", { class: "fa-solid fa-star" }, null, -1), pee = /* @__PURE__ */ E("i", { class: "fa-solid fa-star" }, null, -1), hee = /* @__PURE__ */ E("i", { class: "fa-solid fa-star" }, null, -1), fee = { class: "sr-only" }, mee = { class: "formkit-option" }, vee = { class: "formkit-wrapper" }, gee = { class: "formkit-inner" }, yee = { class: "formkit-label" }, _ee = /* @__PURE__ */ E("i", { class: "fa-solid fa-star" }, null, -1), bee = /* @__PURE__ */ E("i", { class: "fa-solid fa-star" }, null, -1), wee = { class: "sr-only" }, xee = /* @__PURE__ */ at({
  __name: "StarRatingFilter",
  emits: ["change-rating"],
  setup(e, { emit: t }) {
    const n = t, i = Bc(), { selectedRangeFilters: r } = Nn(i), c = $e(""), d = [2, 3, 4, 5], a = d.map(() => $e(null));
    async function f() {
      const x = r.value.find(
        (O) => O.name === "RATING"
      ), $ = (x == null ? void 0 : x.selectedLow) ?? 0, A = (x == null ? void 0 : x.selectedHigh) ?? 5, I = $ > 0 && A === 5 ? String($) : "";
      c.value = d.includes(Number(I)) ? I + "-5" : "";
    }
    Li(() => {
      f();
    }), At(
      () => r.value.find((x) => x.name === "RATING"),
      () => {
        f();
      },
      { deep: !0 }
    );
    const g = (x) => {
      c.value = x, n("change-rating", c.value);
    };
    return Ru(() => {
      c.value = "";
    }), (x, $) => {
      const A = Ur("FormKit");
      return V(), G("section", zQ, [
        E("div", BQ, [
          E("div", VQ, [
            E("div", UQ, [
              it(A, {
                modelValue: c.value,
                "onUpdate:modelValue": $[0] || ($[0] = (I) => c.value = I),
                name: "rating",
                type: "hidden"
              }, null, 8, ["modelValue"]),
              E("fieldset", HQ, [
                E("legend", WQ, Y(x.$t("vacvComponents.filters.starRating")), 1),
                E("ul", ZQ, [
                  E("li", qQ, [
                    E("label", jQ, [
                      E("div", GQ, [
                        xr(E("input", {
                          ref: ne(a)[0],
                          class: "formkit-input vacv-custom",
                          type: "radio",
                          name: "frating",
                          id: "starrating-option-5-stars",
                          value: "5-5",
                          "onUpdate:modelValue": $[1] || ($[1] = (I) => c.value = I),
                          "data-test": "star-rating-input",
                          onChange: $[2] || ($[2] = (I) => g("5-5"))
                        }, null, 544), [
                          [Gp, c.value]
                        ])
                      ]),
                      E("span", YQ, [
                        KQ,
                        E("span", XQ, "5 " + Y(x.$t("vacvComponents.filters.starslabel.stars")), 1)
                      ])
                    ])
                  ]),
                  E("li", JQ, [
                    E("label", QQ, [
                      E("div", eee, [
                        xr(E("input", {
                          ref: ne(a)[1],
                          class: "formkit-input vacv-custom",
                          type: "radio",
                          name: "frating",
                          id: "starrating-option-4-stars-up",
                          value: "4-5",
                          "onUpdate:modelValue": $[3] || ($[3] = (I) => c.value = I),
                          "data-test": "star-rating-input",
                          onChange: $[4] || ($[4] = (I) => g("4-5"))
                        }, null, 544), [
                          [Gp, c.value]
                        ])
                      ]),
                      E("span", tee, [
                        nee,
                        iee,
                        ree,
                        see,
                        E("span", oee, "4 " + Y(x.$t("vacvComponents.filters.starslabel.stars")), 1),
                        mt(Y(x.$t("vacvComponents.filters.starslabel.andup")), 1)
                      ])
                    ])
                  ]),
                  E("li", aee, [
                    E("label", lee, [
                      E("div", cee, [
                        xr(E("input", {
                          ref: ne(a)[2],
                          class: "formkit-input vacv-custom",
                          type: "radio",
                          name: "frating",
                          id: "starrating-option-3-stars-up",
                          value: "3-5",
                          "onUpdate:modelValue": $[5] || ($[5] = (I) => c.value = I),
                          "data-test": "star-rating-input",
                          onChange: $[6] || ($[6] = (I) => g("3-5"))
                        }, null, 544), [
                          [Gp, c.value]
                        ])
                      ]),
                      E("span", uee, [
                        dee,
                        pee,
                        hee,
                        E("span", fee, "3 " + Y(x.$t("vacvComponents.filters.starslabel.stars")), 1),
                        mt(Y(x.$t("vacvComponents.filters.starslabel.andup")), 1)
                      ])
                    ])
                  ]),
                  E("li", mee, [
                    E("label", vee, [
                      E("div", gee, [
                        xr(E("input", {
                          ref: ne(a)[3],
                          class: "formkit-input vacv-custom",
                          type: "radio",
                          name: "frating",
                          id: "starrating-option-2-stars-up",
                          value: "2-5",
                          "onUpdate:modelValue": $[7] || ($[7] = (I) => c.value = I),
                          "data-test": "star-rating-input",
                          onChange: $[8] || ($[8] = (I) => g("2-5"))
                        }, null, 544), [
                          [Gp, c.value]
                        ])
                      ]),
                      E("span", yee, [
                        _ee,
                        bee,
                        E("span", wee, "2 " + Y(x.$t("vacvComponents.filters.starslabel.stars")), 1),
                        mt(Y(x.$t("vacvComponents.filters.starslabel.andup")), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]);
    };
  }
}), $ee = {
  key: 0,
  class: "filter-section deals"
}, Cee = { class: "vacv-checkbox" }, kee = /* @__PURE__ */ at({
  __name: "DealsFilter",
  emits: ["change-deals"],
  setup(e, { emit: t }) {
    const n = t, i = Bc(), { filters: r, selectedFixedFilters: c } = Nn(i), d = $e(VC(r.value)), a = $e([]);
    function f(x = []) {
      const $ = d.value.map((I) => String(I.value)), A = x.filter((I) => $.includes(I));
      a.value.splice(0, a.value.length, ...A);
    }
    Li(() => {
      const x = c.value.find(
        (A) => A.name === "DEALS"
      ), $ = x ? x.selectedIds : [];
      f($);
    }), At(
      () => r.value,
      (x) => {
        d.value = VC(x);
        const $ = c.value.find(
          (I) => I.name === "DEALS"
        ), A = $ ? $.selectedIds : [];
        f(A);
      },
      { deep: !0 }
    ), At(
      () => {
        var x;
        return (x = c.value.find(($) => $.name === "DEALS")) == null ? void 0 : x.selectedIds;
      },
      (x) => {
        f(x || []);
      },
      { deep: !0 }
    ), At(
      a,
      (x) => {
        const $ = [...x].sort();
        n("change-deals", $);
      },
      { deep: !0 }
    );
    const g = Ae(() => d.value);
    return Ru(() => {
      a.value = [];
    }), (x, $) => {
      const A = Ur("FormKit");
      return g.value.length ? (V(), G("section", $ee, [
        E("div", Cee, [
          it(A, {
            id: "dealsFilter",
            modelValue: a.value,
            "onUpdate:modelValue": $[0] || ($[0] = (I) => a.value = I),
            name: "deals",
            type: "checkbox",
            label: x.$t("vacvComponents.filters.deals"),
            options: g.value,
            "decorator-icon": ne(Lu)
          }, null, 8, ["modelValue", "label", "options", "decorator-icon"])
        ])
      ])) : _e("", !0);
    };
  }
}), See = {
  key: 0,
  class: "filter-section destinations"
}, Tee = { class: "vacv-checkbox" }, Iee = { class: "vacv-checkbox" }, Aee = ["aria-expanded"], Ff = 5, Eee = /* @__PURE__ */ at({
  __name: "DestinationsFilter",
  emits: ["change-destinations"],
  setup(e, { emit: t }) {
    Hl((N) => ({
      "0317db4f": B.value
    }));
    const n = t, i = Bc(), { filters: r, selectedFixedFilters: c, moreDestinationsShow: d } = Nn(i), a = $e(pw(r.value)), f = $e([]), g = $e([]);
    async function x(N = []) {
      const K = a.value.map(
        (te) => String(te.value)
      ), U = N.filter((te) => K.includes(te)), q = a.value.slice(0, Ff).map((te) => String(te.value)), ee = a.value.slice(Ff).map((te) => String(te.value));
      f.value.splice(
        0,
        f.value.length,
        ...q.filter((te) => U.includes(te))
      ), g.value.splice(
        0,
        g.value.length,
        ...ee.filter((te) => U.includes(te))
      );
    }
    Li(() => {
      const N = c.value.find(
        (U) => U.name === "DESTINATION"
      ), K = N ? N.selectedIds : [];
      x(K);
    }), At(
      () => r.value,
      (N) => {
        a.value = pw(N), x();
      },
      { deep: !0 }
    ), At(
      () => {
        var N;
        return (N = c.value.find((K) => K.name === "DESTINATION")) == null ? void 0 : N.selectedIds;
      },
      (N) => {
        x(N || []);
      },
      { deep: !0 }
    ), At(
      [f, g],
      ([N, K]) => {
        const U = N.concat(K);
        n("change-destinations", U);
      },
      { deep: !0 }
    );
    const $ = Ae(
      () => a.value.slice(0, Ff)
    ), A = Ae(
      () => a.value.slice(Ff)
    ), I = Ae(() => a.value.length), O = () => {
      d.value = !d.value;
    }, B = $e("0px"), H = $e();
    return At(H, async (N) => {
      N != null && N.scrollHeight && (B.value = N.scrollHeight + "px");
    }), Ru(() => {
      f.value = [], g.value = [];
    }), (N, K) => {
      const U = Ur("FormKit");
      return I.value > 0 ? (V(), G("section", See, [
        E("div", Tee, [
          it(U, {
            id: "destinationsFilter",
            modelValue: f.value,
            "onUpdate:modelValue": K[0] || (K[0] = (q) => f.value = q),
            name: "destinations",
            type: "checkbox",
            label: N.$t("vacvComponents.filters.destinations"),
            options: $.value,
            "decorator-icon": ne(Lu)
          }, null, 8, ["modelValue", "label", "options", "decorator-icon"])
        ]),
        it($r, { name: "collapsible" }, {
          default: Qt(() => [
            ne(d) ? (V(), G("div", {
              key: 0,
              id: "destinationsMoreAccordion",
              class: "hotel-accordion-wrapper",
              role: "region",
              "aria-live": "polite",
              ref_key: "scrollHeightDestinationsRef",
              ref: H
            }, [
              E("div", Iee, [
                it(U, {
                  id: "destinationsMoreFilter",
                  modelValue: g.value,
                  "onUpdate:modelValue": K[1] || (K[1] = (q) => g.value = q),
                  name: "destinationsMore",
                  type: "checkbox",
                  label: N.$t("vacvComponents.filters.moreDestinations"),
                  options: A.value,
                  "decorator-icon": ne(Lu)
                }, null, 8, ["modelValue", "label", "options", "decorator-icon"])
              ])
            ], 512)) : _e("", !0)
          ]),
          _: 1
        }),
        I.value > Ff ? (V(), G("button", {
          key: 0,
          onClick: zi(O, ["prevent"]),
          type: "button",
          class: "details-link link linklook",
          "aria-expanded": ne(d),
          "aria-controls": "destinationsMoreAccordion"
        }, [
          E("i", {
            class: Et(
              "fa-solid " + (ne(d) ? "fa-circle-minus" : "fa-circle-plus")
            ),
            "aria-hidden": "true"
          }, null, 2),
          mt(Y(ne(d) ? N.$t("vacvComponents.filters.showLess") : N.$t("vacvComponents.filters.showMore")), 1)
        ], 8, Aee)) : _e("", !0)
      ])) : _e("", !0);
    };
  }
}), Pee = {
  key: 0,
  class: "filter-section amenities"
}, Mee = { class: "vacv-checkbox" }, Dee = { class: "vacv-checkbox" }, Lee = ["aria-expanded"], jv = 5, Oee = /* @__PURE__ */ at({
  __name: "AmenitiesFilter",
  emits: ["change-amenities"],
  setup(e, { emit: t }) {
    Hl((N) => ({
      "2046be96": H.value
    }));
    const n = t, i = Bc(), { filters: r, selectedFixedFilters: c, moreAmenitiesShow: d } = Nn(i), a = $e(UC(r.value)), f = $e([]), g = $e([]);
    function x(N = []) {
      const K = a.value.map(
        (te) => String(te.value)
      ), U = N.filter((te) => K.includes(te)), q = a.value.slice(0, jv).map((te) => String(te.value)), ee = a.value.slice(jv).map((te) => String(te.value));
      f.value.splice(
        0,
        f.value.length,
        ...q.filter((te) => U.includes(te))
      ), g.value.splice(
        0,
        g.value.length,
        ...ee.filter((te) => U.includes(te))
      );
    }
    Li(() => {
      const N = c.value.find(
        (U) => U.name === "AMENITIES"
      ), K = N ? N.selectedIds : [];
      x(K);
    }), At(
      () => r.value,
      (N) => {
        a.value = UC(N), x();
      },
      { deep: !0 }
    ), At(
      () => {
        var N;
        return (N = c.value.find((K) => K.name === "AMENITIES")) == null ? void 0 : N.selectedIds;
      },
      (N) => {
        x(N || []);
      },
      { deep: !0 }
    ), At(
      [f, g],
      ([N, K]) => {
        const U = N.concat(K);
        n("change-amenities", U);
      },
      { deep: !0 }
    );
    const $ = Ae(
      () => a.value.slice(0, jv)
    ), A = Ae(
      () => a.value.slice(jv)
    ), I = () => {
      d.value = !d.value;
    }, O = Ae(() => a.value.length), B = $e("0px"), H = $e();
    return At(H, async (N) => {
      N != null && N.scrollHeight && (B.value = N.scrollHeight + "px");
    }), Ru(() => {
      f.value = [], g.value = [];
    }), (N, K) => {
      const U = Ur("FormKit");
      return O.value > 0 ? (V(), G("section", Pee, [
        E("div", Mee, [
          it(U, {
            modelValue: f.value,
            "onUpdate:modelValue": K[0] || (K[0] = (q) => f.value = q),
            name: "amenities",
            type: "checkbox",
            id: "amenitiesFilter",
            label: N.$t("vacvComponents.filters.amenities"),
            options: $.value,
            "decorator-icon": ne(Lu),
            "data-test": "amenities-input"
          }, null, 8, ["modelValue", "label", "options", "decorator-icon"])
        ]),
        it($r, { name: "collapsible" }, {
          default: Qt(() => [
            ne(d) ? (V(), G("div", {
              key: 0,
              id: "amenitiesMoreAccordion",
              class: "hotel-accordion-wrapper",
              role: "region",
              "aria-live": "polite",
              ref_key: "scrollHeightAmenitiesRef",
              ref: H
            }, [
              E("div", Dee, [
                it(U, {
                  modelValue: g.value,
                  "onUpdate:modelValue": K[1] || (K[1] = (q) => g.value = q),
                  id: "amenitiesMoreFilter",
                  name: "amenitiesMore",
                  type: "checkbox",
                  label: N.$t("vacvComponents.filters.moreAmenities"),
                  options: A.value,
                  "decorator-icon": ne(Lu)
                }, null, 8, ["modelValue", "label", "options", "decorator-icon"])
              ])
            ], 512)) : _e("", !0)
          ]),
          _: 1
        }),
        O.value > 5 ? (V(), G("button", {
          key: 0,
          onClick: K[2] || (K[2] = zi((q) => I(), ["prevent"])),
          type: "button",
          class: "details-link link linklook",
          "aria-expanded": ne(d),
          "aria-controls": "amenitiesMoreAccordion",
          id: "amenities-showmore"
        }, [
          E("i", {
            class: Et(
              "fa-solid " + (ne(d) ? "fa-circle-minus" : "fa-circle-plus")
            ),
            "aria-hidden": "true"
          }, null, 2),
          mt(" " + Y(ne(d) ? N.$t("vacvComponents.filters.showLess") : N.$t("vacvComponents.filters.showMore")), 1)
        ], 8, Lee)) : _e("", !0)
      ])) : _e("", !0);
    };
  }
}), Nee = {
  key: 0,
  class: "filter-section vacationtype"
}, Fee = { class: "vacv-checkbox" }, Ree = /* @__PURE__ */ at({
  __name: "VacationTypeFilter",
  emits: ["change-vacation-types"],
  setup(e, { emit: t }) {
    const n = t, i = Bc(), { filters: r, selectedFixedFilters: c } = Nn(i), d = $e(HC(r.value)), a = Ae(() => d.value.length), f = $e([]);
    async function g($ = []) {
      const A = d.value.map(
        (O) => String(O.value)
      ), I = $.filter((O) => A.includes(O));
      f.value.splice(0, f.value.length, ...I);
    }
    Li(() => {
      const $ = c.value.find(
        (I) => I.name === "VACATION_TYPE"
      ), A = $ ? $.selectedIds : [];
      g(A);
    }), At(
      () => r.value,
      ($) => {
        d.value = HC($);
        const A = c.value.find(
          (O) => O.name === "VACATION_TYPE"
        ), I = A ? A.selectedIds : [];
        g(I);
      },
      { deep: !0 }
    ), At(
      () => {
        var $;
        return ($ = c.value.find((A) => A.name === "VACATION_TYPE")) == null ? void 0 : $.selectedIds;
      },
      ($) => {
        g($ || []);
      },
      { deep: !0 }
    ), At(
      f,
      ($) => {
        n("change-vacation-types", $);
      },
      { deep: !0 }
    );
    const x = Ae(() => d.value);
    return Ru(() => {
      f.value = [];
    }), ($, A) => {
      const I = Ur("FormKit");
      return a.value > 0 ? (V(), G("section", Nee, [
        E("div", Fee, [
          it(I, {
            id: "vacationTypeFilter",
            modelValue: f.value,
            "onUpdate:modelValue": A[0] || (A[0] = (O) => f.value = O),
            name: "vacationType",
            type: "checkbox",
            label: $.$t("vacvComponents.filters.vacationType"),
            options: x.value,
            "decorator-icon": ne(Lu),
            "data-test": "vacation-types-input"
          }, null, 8, ["modelValue", "label", "options", "decorator-icon"])
        ])
      ])) : _e("", !0);
    };
  }
}), zee = { class: "spa-aside-wrapper" }, Bee = {
  id: "filter-title",
  class: "sr-only"
}, Vee = ["aria-label"], Uee = { class: "filter-section pricerange" }, Hee = { class: "vacv-label-sm" }, Wee = {
  key: 0,
  class: "vacv-error",
  "aria-live": "polite"
}, Zee = {
  type: "submit",
  class: "vacv-btn-secondary"
}, XTe = /* @__PURE__ */ at({
  __name: "PlpFilter",
  props: {
    openFilter: { type: Boolean },
    maxPriceRange: { default: 5e3 },
    unlimitedPriceRange: { default: 1e6 }
  },
  emits: ["apply-filters", "close-filter"],
  setup(e, { emit: t }) {
    const n = e, i = Bc(), {
      updateSelectedRangeFilters: r,
      updateSelectedFixedFilters: c,
      resetFilters: d,
      filters: a
    } = i, { hasPreviouslyAppliedFilters: f } = Nn(i), g = OE(), x = $e(), $ = $e(), A = $e([]), I = $e([]), O = $e([]), B = $e([]), H = $e(""), N = [0, n.maxPriceRange], K = $e(N), U = $e(), q = $e(!1), ee = $e(!1);
    function te() {
      return {
        destinations: I.value,
        rating: H.value,
        amenities: O.value,
        vacationType: B.value,
        priceRange: K.value,
        deals: A.value
      };
    }
    const ae = t;
    function oe() {
      const { selectedRangeFilters: tt, selectedFixedFilters: dt } = i, bt = tt.find((Ht) => Ht.name === "PRICE");
      bt && (K.value = [
        bt.selectedLow,
        bt.selectedHigh
      ]);
      const qt = tt.find((Ht) => Ht.name === "RATING");
      qt && (qt.selectedLow > 0 || qt.selectedHigh < 5) && (H.value = `${qt.selectedLow}-${qt.selectedHigh}`);
      const Oe = dt.find((Ht) => Ht.name === "DEALS");
      Oe && (A.value = [...Oe.selectedIds]);
      const Bt = dt.find(
        (Ht) => Ht.name === "DESTINATION"
      );
      Bt && (I.value = [...Bt.selectedIds]);
      const Tn = dt.find(
        (Ht) => Ht.name === "AMENITIES"
      );
      Tn && (O.value = [...Tn.selectedIds]);
      const hn = dt.find(
        (Ht) => Ht.name === "VACATION_TYPE"
      );
      hn && (B.value = [...hn.selectedIds]), me();
    }
    const de = (tt) => tt.destinations.length > 0 || tt.rating.length > 0 || tt.amenities.length > 0 || tt.vacationType.length > 0 || tt.deals.length > 0 || tt.priceRange.length === 2 && (tt.priceRange[0] !== 0 || tt.priceRange[1] !== n.maxPriceRange), me = () => {
      const tt = te(), dt = de(tt);
      f.value ? ve(!0) : ve(dt), ee.value = !1;
    }, ve = (tt) => {
      g.value || (document.body.style.overflow = tt ? "hidden" : "", document.body.style.height = tt ? "100%" : ""), q.value = tt;
    };
    function re(tt) {
      var qt, Oe, Bt, Tn;
      const dt = te();
      le();
      const bt = {};
      (qt = dt.destinations) != null && qt.length && (bt.fdest = dt.destinations.join(",")), dt.rating && dt.rating !== "0-5" && (bt.frating = dt.rating), (Oe = dt.amenities) != null && Oe.length && (bt.famenities = dt.amenities.join(",")), (Bt = dt.vacationType) != null && Bt.length && (bt.fVacationType = dt.vacationType.join(",")), (Tn = dt.deals) != null && Tn.length && (bt.fdeal = dt.deals.join(",")), dt.priceRange && (bt.fprice = rE(
        dt.priceRange,
        n.maxPriceRange,
        n.unlimitedPriceRange
      )), ae("apply-filters", bt, tt);
    }
    function le() {
      if (r(
        "PRICE",
        K.value[0],
        K.value[1]
      ), H.value) {
        const [tt, dt] = H.value.split("-").map(Number);
        r("RATING", tt, dt);
      } else
        r("RATING", 0, 5);
      c("DESTINATION", I.value), c("AMENITIES", O.value), c("DEALS", A.value), c("VACATION_TYPE", B.value);
    }
    function pe(tt, dt) {
      a && n6(a, tt), Ge(), re(dt), f.value = !0;
    }
    function Ne(tt) {
      g.value ? f.value ? (re(tt), f.value = !1) : ee.value = !0 : (Ge(), re(tt));
    }
    const We = () => {
      const tt = te(), dt = de(tt);
      ve(!1), dt ? pe(tt, dt) : Ne(dt);
    };
    function Ge() {
      ee.value = !1, g.value || ae("close-filter");
    }
    const et = (tt) => {
      Hg(tt, ["spa-col-aside", "btn-close"]) && (window.removeEventListener("mousedown", et), window.removeEventListener("touchstart", et), Ge());
    }, ft = () => {
      if (!g.value) {
        window.addEventListener("mousedown", et), window.addEventListener("touchstart", et);
        const tt = te(), dt = de(tt);
        f.value ? ve(!1) : ve(dt), ee.value = !1, setTimeout(() => {
          x.value && (x.value.tabIndex = 1), $.value && $.value.focus();
        }, 100);
      }
    }, De = () => {
      g.value || (ee.value = !1, ve(!1), window.removeEventListener("mousedown", et), window.removeEventListener("touchstart", et));
    };
    At(
      () => n.openFilter,
      (tt) => {
        tt ? ft() : De();
      }
    );
    const Ke = $e("0px"), gt = $e();
    At(gt, async (tt) => {
      tt != null && tt.scrollHeight && (Ke.value = tt.scrollHeight + "px");
    });
    const qe = async () => {
      I.value = [], A.value = [], O.value = [], B.value = [], H.value = "", K.value = N, d(), me(), We();
    }, rt = (tt) => {
      K.value = tt, me();
    }, Le = (tt) => {
      H.value = tt, me();
    }, Je = (tt) => {
      A.value = tt, me();
    }, je = (tt) => {
      I.value = tt, me();
    }, ot = (tt) => {
      O.value = tt, me();
    }, Xe = (tt) => {
      B.value = tt, me();
    };
    return Li(() => {
      oe();
    }), (tt, dt) => {
      const bt = Ur("FormKit");
      return ne(a) ? (V(), G("aside", {
        key: 0,
        ref_key: "filterPanelRef",
        ref: x,
        id: "mobile-filter-panel",
        class: Et({
          "col-md-3": !0,
          "spa-col-aside": !0,
          open: n.openFilter,
          sticky: q.value
        }),
        "aria-live": "polite",
        "aria-labelledby": "filter-title"
      }, [
        E("div", zee, [
          E("h2", Bee, Y(tt.$t("vacvComponents.filters.filterBy")), 1),
          it(bt, {
            ref_key: "formRef",
            ref: U,
            id: "filter-form",
            type: "form",
            actions: !1,
            onSubmit: We,
            novalidate: ""
          }, {
            default: Qt(() => [
              E("button", {
                ref_key: "mobileCloseButtonRef",
                ref: $,
                onClick: zi(Ge, ["prevent"]),
                "data-test": "closeButton",
                class: "btn-close mobile-only",
                "aria-label": tt.$t("vacvComponents.common.buttons.close"),
                "aria-expanded": "true",
                "aria-controls": "mobile-filter-panel"
              }, null, 8, Vee),
              it(NQ, {
                "max-price-range": tt.maxPriceRange,
                onClearFilters: qe
              }, null, 8, ["max-price-range"]),
              E("section", Uee, [
                E("div", Hee, Y(tt.$t("vacvComponents.filters.rangeSlider")), 1),
                it(RQ, { onChangePriceRange: rt })
              ]),
              it(kee, { onChangeDeals: Je }),
              it(xee, { onChangeRating: Le }),
              it(Eee, { onChangeDestinations: je }),
              it(Oee, { onChangeAmenities: ot }),
              it(Ree, { onChangeVacationTypes: Xe }),
              E("div", {
                class: Et(q.value ? "filter-apply sticky" : "filter-apply")
              }, [
                ee.value ? (V(), G("div", Wee, Y(tt.$t("vacvComponents.filters.error")), 1)) : _e("", !0),
                E("button", Zee, Y(tt.$t("vacvComponents.filters.applyButton")), 1)
              ], 2)
            ]),
            _: 1
          }, 512)
        ])
      ], 2)) : _e("", !0);
    };
  }
}), qee = { "data-test": "pdp-hotel-overview-section-title" }, jee = {
  key: 0,
  class: "sub-section"
}, Gee = ["innerHTML"], Yee = { class: "spa-list details-2col" }, Kee = { key: 0 }, Xee = { key: 1 }, Jee = { key: 2 }, Qee = { key: 3 }, ete = { key: 4 }, tte = { key: 5 }, nte = {
  key: 1,
  class: "sub-section"
}, ite = {
  class: "spa-list details-2col",
  id: "subsection-details-list"
}, rte = ["id"], ste = ["id"], ote = {
  key: 2,
  class: "sub-section"
}, ate = {
  class: "spa-list details-2col",
  id: "subsection-details-list-other-services"
}, lte = ["id"], JTe = /* @__PURE__ */ at({
  __name: "PdpOverview",
  props: {
    overview: {},
    inclusions: {},
    lang: {}
  },
  setup(e) {
    const { onIntersectionObserver: t, section: n } = qh();
    return (i, r) => {
      var c, d, a, f;
      return V(), G("section", {
        id: "overview",
        class: "pdp-section overview",
        ref_key: "section",
        ref: n
      }, [
        xr((V(), G("h2", qee, [
          mt(Y(i.$t("vacvComponents.productDetails.overview.title")), 1)
        ])), [
          [ne(Zd), [ne(t), { section: ne(n) }]]
        ]),
        i.overview.description ? (V(), G("div", jee, [
          E("div", {
            class: "text vacv-editor",
            innerHTML: i.overview.description
          }, null, 8, Gee),
          E("ul", Yee, [
            i.overview.checkIn ? (V(), G("li", Kee, [
              E("span", null, Y(i.$t("vacvComponents.productDetails.overview.checkin")), 1),
              mt(" " + Y(ne(RC)(i.lang, i.overview.checkIn)), 1)
            ])) : _e("", !0),
            i.overview.checkOut ? (V(), G("li", Xee, [
              E("span", null, Y(i.$t("vacvComponents.productDetails.overview.checkout")), 1),
              mt(" " + Y(ne(RC)(i.lang, i.overview.checkOut)), 1)
            ])) : _e("", !0),
            i.overview.numBars ? (V(), G("li", Jee, [
              E("span", null, Y(i.$t("vacvComponents.productDetails.overview.numberBars")), 1),
              mt(" " + Y(i.overview.numBars), 1)
            ])) : _e("", !0),
            i.overview.numRestaurants ? (V(), G("li", Qee, [
              E("span", null, Y(i.$t("vacvComponents.productDetails.overview.numberRestaurants")), 1),
              mt(" " + Y(i.overview.numRestaurants), 1)
            ])) : _e("", !0),
            i.overview.numRooms ? (V(), G("li", ete, [
              E("span", null, Y(i.$t("vacvComponents.productDetails.overview.numberRooms")), 1),
              mt(" " + Y(i.overview.numRooms), 1)
            ])) : _e("", !0),
            i.overview.numOutdoorPools ? (V(), G("li", tte, [
              E("span", null, Y(i.$t("vacvComponents.productDetails.overview.numberPoolsOutdoor")), 1),
              mt(" " + Y(i.overview.numOutdoorPools), 1)
            ])) : _e("", !0)
          ])
        ])) : _e("", !0),
        (c = i.overview.hotelLevelInclusions) != null && c.length || (a = (d = i.inclusions) == null ? void 0 : d.activitiesInclusions) != null && a.length ? (V(), G("div", nte, [
          E("h3", null, Y(i.$t("vacvComponents.productDetails.overview.inclusions")), 1),
          E("ul", ite, [
            (V(!0), G(cn, null, Pn(i.overview.hotelLevelInclusions, (g, x) => (V(), G("li", {
              key: x,
              id: "pdp-hotel-inclusion-item-" + x
            }, Y(g), 9, rte))), 128)),
            (V(!0), G(cn, null, Pn((f = i.inclusions) == null ? void 0 : f.activitiesInclusions, (g, x) => (V(), G("li", {
              key: x,
              id: "pdp-hotel-inclusion-item-" + x
            }, Y(g), 9, ste))), 128))
          ])
        ])) : _e("", !0),
        i.overview.otherServicesAtACharge && i.overview.otherServicesAtACharge.length ? (V(), G("div", ote, [
          E("h3", null, Y(i.$t("vacvComponents.productDetails.overview.otherServices")), 1),
          E("ul", ate, [
            (V(!0), G(cn, null, Pn(i.overview.otherServicesAtACharge, (g, x) => (V(), G("li", {
              key: x,
              id: "pdp-hotel-other-services-item-" + x
            }, Y(g), 9, lte))), 128))
          ])
        ])) : _e("", !0)
      ], 512);
    };
  }
}), cte = { "data-test": "pdp-hotel-importantinfo-section-title" }, ute = { key: 0 }, dte = ["innerHTML"], pte = /* @__PURE__ */ at({
  __name: "PdpImportantInformation",
  props: {
    hints: {}
  },
  setup(e) {
    const { onIntersectionObserver: t, section: n } = qh();
    return (i, r) => (V(), G("section", {
      id: "importantInformation",
      class: "pdp-section importantinfo",
      ref_key: "section",
      ref: n
    }, [
      xr((V(), G("h2", cte, [
        mt(Y(i.$t("vacvComponents.productDetails.important.title")), 1)
      ])), [
        [ne(Zd), [ne(t), { section: ne(n) }]]
      ]),
      (V(!0), G(cn, null, Pn(i.hints, (c, d) => (V(), G("div", {
        key: d,
        class: "sub-section"
      }, [
        c.title ? (V(), G("h3", ute, Y(c.title), 1)) : _e("", !0),
        c.description ? (V(), G("div", {
          key: 1,
          class: "text vacv-editor",
          innerHTML: c.description
        }, null, 8, dte)) : _e("", !0)
      ]))), 128))
    ], 512));
  }
});
var Em = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Nx(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function hte(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function i() {
      return this instanceof i ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(i) {
    var r = Object.getOwnPropertyDescriptor(e, i);
    Object.defineProperty(n, i, r.get ? r : {
      enumerable: !0,
      get: function() {
        return e[i];
      }
    });
  }), n;
}
var Gv = { exports: {} };
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */
var xS;
function _D() {
  return xS || (xS = 1, function(e, t) {
    (function(n, i) {
      i(t);
    })(Em, function(n) {
      var i = "1.9.4";
      function r(p) {
        var y, T, F, j;
        for (T = 1, F = arguments.length; T < F; T++) {
          j = arguments[T];
          for (y in j)
            p[y] = j[y];
        }
        return p;
      }
      var c = Object.create || /* @__PURE__ */ function() {
        function p() {
        }
        return function(y) {
          return p.prototype = y, new p();
        };
      }();
      function d(p, y) {
        var T = Array.prototype.slice;
        if (p.bind)
          return p.bind.apply(p, T.call(arguments, 1));
        var F = T.call(arguments, 2);
        return function() {
          return p.apply(y, F.length ? F.concat(T.call(arguments)) : arguments);
        };
      }
      var a = 0;
      function f(p) {
        return "_leaflet_id" in p || (p._leaflet_id = ++a), p._leaflet_id;
      }
      function g(p, y, T) {
        var F, j, ge, xe;
        return xe = function() {
          F = !1, j && (ge.apply(T, j), j = !1);
        }, ge = function() {
          F ? j = arguments : (p.apply(T, arguments), setTimeout(xe, y), F = !0);
        }, ge;
      }
      function x(p, y, T) {
        var F = y[1], j = y[0], ge = F - j;
        return p === F && T ? p : ((p - j) % ge + ge) % ge + j;
      }
      function $() {
        return !1;
      }
      function A(p, y) {
        if (y === !1)
          return p;
        var T = Math.pow(10, y === void 0 ? 6 : y);
        return Math.round(p * T) / T;
      }
      function I(p) {
        return p.trim ? p.trim() : p.replace(/^\s+|\s+$/g, "");
      }
      function O(p) {
        return I(p).split(/\s+/);
      }
      function B(p, y) {
        Object.prototype.hasOwnProperty.call(p, "options") || (p.options = p.options ? c(p.options) : {});
        for (var T in y)
          p.options[T] = y[T];
        return p.options;
      }
      function H(p, y, T) {
        var F = [];
        for (var j in p)
          F.push(encodeURIComponent(T ? j.toUpperCase() : j) + "=" + encodeURIComponent(p[j]));
        return (!y || y.indexOf("?") === -1 ? "?" : "&") + F.join("&");
      }
      var N = /\{ *([\w_ -]+) *\}/g;
      function K(p, y) {
        return p.replace(N, function(T, F) {
          var j = y[F];
          if (j === void 0)
            throw new Error("No value provided for variable " + T);
          return typeof j == "function" && (j = j(y)), j;
        });
      }
      var U = Array.isArray || function(p) {
        return Object.prototype.toString.call(p) === "[object Array]";
      };
      function q(p, y) {
        for (var T = 0; T < p.length; T++)
          if (p[T] === y)
            return T;
        return -1;
      }
      var ee = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
      function te(p) {
        return window["webkit" + p] || window["moz" + p] || window["ms" + p];
      }
      var ae = 0;
      function oe(p) {
        var y = +/* @__PURE__ */ new Date(), T = Math.max(0, 16 - (y - ae));
        return ae = y + T, window.setTimeout(p, T);
      }
      var de = window.requestAnimationFrame || te("RequestAnimationFrame") || oe, me = window.cancelAnimationFrame || te("CancelAnimationFrame") || te("CancelRequestAnimationFrame") || function(p) {
        window.clearTimeout(p);
      };
      function ve(p, y, T) {
        if (T && de === oe)
          p.call(y);
        else
          return de.call(window, d(p, y));
      }
      function re(p) {
        p && me.call(window, p);
      }
      var le = {
        __proto__: null,
        extend: r,
        create: c,
        bind: d,
        get lastId() {
          return a;
        },
        stamp: f,
        throttle: g,
        wrapNum: x,
        falseFn: $,
        formatNum: A,
        trim: I,
        splitWords: O,
        setOptions: B,
        getParamString: H,
        template: K,
        isArray: U,
        indexOf: q,
        emptyImageUrl: ee,
        requestFn: de,
        cancelFn: me,
        requestAnimFrame: ve,
        cancelAnimFrame: re
      };
      function pe() {
      }
      pe.extend = function(p) {
        var y = function() {
          B(this), this.initialize && this.initialize.apply(this, arguments), this.callInitHooks();
        }, T = y.__super__ = this.prototype, F = c(T);
        F.constructor = y, y.prototype = F;
        for (var j in this)
          Object.prototype.hasOwnProperty.call(this, j) && j !== "prototype" && j !== "__super__" && (y[j] = this[j]);
        return p.statics && r(y, p.statics), p.includes && (Ne(p.includes), r.apply(null, [F].concat(p.includes))), r(F, p), delete F.statics, delete F.includes, F.options && (F.options = T.options ? c(T.options) : {}, r(F.options, p.options)), F._initHooks = [], F.callInitHooks = function() {
          if (!this._initHooksCalled) {
            T.callInitHooks && T.callInitHooks.call(this), this._initHooksCalled = !0;
            for (var ge = 0, xe = F._initHooks.length; ge < xe; ge++)
              F._initHooks[ge].call(this);
          }
        }, y;
      }, pe.include = function(p) {
        var y = this.prototype.options;
        return r(this.prototype, p), p.options && (this.prototype.options = y, this.mergeOptions(p.options)), this;
      }, pe.mergeOptions = function(p) {
        return r(this.prototype.options, p), this;
      }, pe.addInitHook = function(p) {
        var y = Array.prototype.slice.call(arguments, 1), T = typeof p == "function" ? p : function() {
          this[p].apply(this, y);
        };
        return this.prototype._initHooks = this.prototype._initHooks || [], this.prototype._initHooks.push(T), this;
      };
      function Ne(p) {
        if (!(typeof L > "u" || !L || !L.Mixin)) {
          p = U(p) ? p : [p];
          for (var y = 0; y < p.length; y++)
            p[y] === L.Mixin.Events && console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
        }
      }
      var We = {
        /* @method on(type: String, fn: Function, context?: Object): this
         * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
         *
         * @alternative
         * @method on(eventMap: Object): this
         * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
         */
        on: function(p, y, T) {
          if (typeof p == "object")
            for (var F in p)
              this._on(F, p[F], y);
          else {
            p = O(p);
            for (var j = 0, ge = p.length; j < ge; j++)
              this._on(p[j], y, T);
          }
          return this;
        },
        /* @method off(type: String, fn?: Function, context?: Object): this
         * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
         *
         * @alternative
         * @method off(eventMap: Object): this
         * Removes a set of type/listener pairs.
         *
         * @alternative
         * @method off: this
         * Removes all listeners to all events on the object. This includes implicitly attached events.
         */
        off: function(p, y, T) {
          if (!arguments.length)
            delete this._events;
          else if (typeof p == "object")
            for (var F in p)
              this._off(F, p[F], y);
          else {
            p = O(p);
            for (var j = arguments.length === 1, ge = 0, xe = p.length; ge < xe; ge++)
              j ? this._off(p[ge]) : this._off(p[ge], y, T);
          }
          return this;
        },
        // attach listener (without syntactic sugar now)
        _on: function(p, y, T, F) {
          if (typeof y != "function") {
            console.warn("wrong listener type: " + typeof y);
            return;
          }
          if (this._listens(p, y, T) === !1) {
            T === this && (T = void 0);
            var j = { fn: y, ctx: T };
            F && (j.once = !0), this._events = this._events || {}, this._events[p] = this._events[p] || [], this._events[p].push(j);
          }
        },
        _off: function(p, y, T) {
          var F, j, ge;
          if (this._events && (F = this._events[p], !!F)) {
            if (arguments.length === 1) {
              if (this._firingCount)
                for (j = 0, ge = F.length; j < ge; j++)
                  F[j].fn = $;
              delete this._events[p];
              return;
            }
            if (typeof y != "function") {
              console.warn("wrong listener type: " + typeof y);
              return;
            }
            var xe = this._listens(p, y, T);
            if (xe !== !1) {
              var Ve = F[xe];
              this._firingCount && (Ve.fn = $, this._events[p] = F = F.slice()), F.splice(xe, 1);
            }
          }
        },
        // @method fire(type: String, data?: Object, propagate?: Boolean): this
        // Fires an event of the specified type. You can optionally provide a data
        // object — the first argument of the listener function will contain its
        // properties. The event can optionally be propagated to event parents.
        fire: function(p, y, T) {
          if (!this.listens(p, T))
            return this;
          var F = r({}, y, {
            type: p,
            target: this,
            sourceTarget: y && y.sourceTarget || this
          });
          if (this._events) {
            var j = this._events[p];
            if (j) {
              this._firingCount = this._firingCount + 1 || 1;
              for (var ge = 0, xe = j.length; ge < xe; ge++) {
                var Ve = j[ge], pt = Ve.fn;
                Ve.once && this.off(p, pt, Ve.ctx), pt.call(Ve.ctx || this, F);
              }
              this._firingCount--;
            }
          }
          return T && this._propagateEvent(F), this;
        },
        // @method listens(type: String, propagate?: Boolean): Boolean
        // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
        // Returns `true` if a particular event type has any listeners attached to it.
        // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
        listens: function(p, y, T, F) {
          typeof p != "string" && console.warn('"string" type argument expected');
          var j = y;
          typeof y != "function" && (F = !!y, j = void 0, T = void 0);
          var ge = this._events && this._events[p];
          if (ge && ge.length && this._listens(p, j, T) !== !1)
            return !0;
          if (F) {
            for (var xe in this._eventParents)
              if (this._eventParents[xe].listens(p, y, T, F))
                return !0;
          }
          return !1;
        },
        // returns the index (number) or false
        _listens: function(p, y, T) {
          if (!this._events)
            return !1;
          var F = this._events[p] || [];
          if (!y)
            return !!F.length;
          T === this && (T = void 0);
          for (var j = 0, ge = F.length; j < ge; j++)
            if (F[j].fn === y && F[j].ctx === T)
              return j;
          return !1;
        },
        // @method once(…): this
        // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
        once: function(p, y, T) {
          if (typeof p == "object")
            for (var F in p)
              this._on(F, p[F], y, !0);
          else {
            p = O(p);
            for (var j = 0, ge = p.length; j < ge; j++)
              this._on(p[j], y, T, !0);
          }
          return this;
        },
        // @method addEventParent(obj: Evented): this
        // Adds an event parent - an `Evented` that will receive propagated events
        addEventParent: function(p) {
          return this._eventParents = this._eventParents || {}, this._eventParents[f(p)] = p, this;
        },
        // @method removeEventParent(obj: Evented): this
        // Removes an event parent, so it will stop receiving propagated events
        removeEventParent: function(p) {
          return this._eventParents && delete this._eventParents[f(p)], this;
        },
        _propagateEvent: function(p) {
          for (var y in this._eventParents)
            this._eventParents[y].fire(p.type, r({
              layer: p.target,
              propagatedFrom: p.target
            }, p), !0);
        }
      };
      We.addEventListener = We.on, We.removeEventListener = We.clearAllEventListeners = We.off, We.addOneTimeEventListener = We.once, We.fireEvent = We.fire, We.hasEventListeners = We.listens;
      var Ge = pe.extend(We);
      function et(p, y, T) {
        this.x = T ? Math.round(p) : p, this.y = T ? Math.round(y) : y;
      }
      var ft = Math.trunc || function(p) {
        return p > 0 ? Math.floor(p) : Math.ceil(p);
      };
      et.prototype = {
        // @method clone(): Point
        // Returns a copy of the current point.
        clone: function() {
          return new et(this.x, this.y);
        },
        // @method add(otherPoint: Point): Point
        // Returns the result of addition of the current and the given points.
        add: function(p) {
          return this.clone()._add(De(p));
        },
        _add: function(p) {
          return this.x += p.x, this.y += p.y, this;
        },
        // @method subtract(otherPoint: Point): Point
        // Returns the result of subtraction of the given point from the current.
        subtract: function(p) {
          return this.clone()._subtract(De(p));
        },
        _subtract: function(p) {
          return this.x -= p.x, this.y -= p.y, this;
        },
        // @method divideBy(num: Number): Point
        // Returns the result of division of the current point by the given number.
        divideBy: function(p) {
          return this.clone()._divideBy(p);
        },
        _divideBy: function(p) {
          return this.x /= p, this.y /= p, this;
        },
        // @method multiplyBy(num: Number): Point
        // Returns the result of multiplication of the current point by the given number.
        multiplyBy: function(p) {
          return this.clone()._multiplyBy(p);
        },
        _multiplyBy: function(p) {
          return this.x *= p, this.y *= p, this;
        },
        // @method scaleBy(scale: Point): Point
        // Multiply each coordinate of the current point by each coordinate of
        // `scale`. In linear algebra terms, multiply the point by the
        // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
        // defined by `scale`.
        scaleBy: function(p) {
          return new et(this.x * p.x, this.y * p.y);
        },
        // @method unscaleBy(scale: Point): Point
        // Inverse of `scaleBy`. Divide each coordinate of the current point by
        // each coordinate of `scale`.
        unscaleBy: function(p) {
          return new et(this.x / p.x, this.y / p.y);
        },
        // @method round(): Point
        // Returns a copy of the current point with rounded coordinates.
        round: function() {
          return this.clone()._round();
        },
        _round: function() {
          return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
        },
        // @method floor(): Point
        // Returns a copy of the current point with floored coordinates (rounded down).
        floor: function() {
          return this.clone()._floor();
        },
        _floor: function() {
          return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
        },
        // @method ceil(): Point
        // Returns a copy of the current point with ceiled coordinates (rounded up).
        ceil: function() {
          return this.clone()._ceil();
        },
        _ceil: function() {
          return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
        },
        // @method trunc(): Point
        // Returns a copy of the current point with truncated coordinates (rounded towards zero).
        trunc: function() {
          return this.clone()._trunc();
        },
        _trunc: function() {
          return this.x = ft(this.x), this.y = ft(this.y), this;
        },
        // @method distanceTo(otherPoint: Point): Number
        // Returns the cartesian distance between the current and the given points.
        distanceTo: function(p) {
          p = De(p);
          var y = p.x - this.x, T = p.y - this.y;
          return Math.sqrt(y * y + T * T);
        },
        // @method equals(otherPoint: Point): Boolean
        // Returns `true` if the given point has the same coordinates.
        equals: function(p) {
          return p = De(p), p.x === this.x && p.y === this.y;
        },
        // @method contains(otherPoint: Point): Boolean
        // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
        contains: function(p) {
          return p = De(p), Math.abs(p.x) <= Math.abs(this.x) && Math.abs(p.y) <= Math.abs(this.y);
        },
        // @method toString(): String
        // Returns a string representation of the point for debugging purposes.
        toString: function() {
          return "Point(" + A(this.x) + ", " + A(this.y) + ")";
        }
      };
      function De(p, y, T) {
        return p instanceof et ? p : U(p) ? new et(p[0], p[1]) : p == null ? p : typeof p == "object" && "x" in p && "y" in p ? new et(p.x, p.y) : new et(p, y, T);
      }
      function Ke(p, y) {
        if (p)
          for (var T = y ? [p, y] : p, F = 0, j = T.length; F < j; F++)
            this.extend(T[F]);
      }
      Ke.prototype = {
        // @method extend(point: Point): this
        // Extends the bounds to contain the given point.
        // @alternative
        // @method extend(otherBounds: Bounds): this
        // Extend the bounds to contain the given bounds
        extend: function(p) {
          var y, T;
          if (!p)
            return this;
          if (p instanceof et || typeof p[0] == "number" || "x" in p)
            y = T = De(p);
          else if (p = gt(p), y = p.min, T = p.max, !y || !T)
            return this;
          return !this.min && !this.max ? (this.min = y.clone(), this.max = T.clone()) : (this.min.x = Math.min(y.x, this.min.x), this.max.x = Math.max(T.x, this.max.x), this.min.y = Math.min(y.y, this.min.y), this.max.y = Math.max(T.y, this.max.y)), this;
        },
        // @method getCenter(round?: Boolean): Point
        // Returns the center point of the bounds.
        getCenter: function(p) {
          return De(
            (this.min.x + this.max.x) / 2,
            (this.min.y + this.max.y) / 2,
            p
          );
        },
        // @method getBottomLeft(): Point
        // Returns the bottom-left point of the bounds.
        getBottomLeft: function() {
          return De(this.min.x, this.max.y);
        },
        // @method getTopRight(): Point
        // Returns the top-right point of the bounds.
        getTopRight: function() {
          return De(this.max.x, this.min.y);
        },
        // @method getTopLeft(): Point
        // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
        getTopLeft: function() {
          return this.min;
        },
        // @method getBottomRight(): Point
        // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
        getBottomRight: function() {
          return this.max;
        },
        // @method getSize(): Point
        // Returns the size of the given bounds
        getSize: function() {
          return this.max.subtract(this.min);
        },
        // @method contains(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains(point: Point): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(p) {
          var y, T;
          return typeof p[0] == "number" || p instanceof et ? p = De(p) : p = gt(p), p instanceof Ke ? (y = p.min, T = p.max) : y = T = p, y.x >= this.min.x && T.x <= this.max.x && y.y >= this.min.y && T.y <= this.max.y;
        },
        // @method intersects(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds
        // intersect if they have at least one point in common.
        intersects: function(p) {
          p = gt(p);
          var y = this.min, T = this.max, F = p.min, j = p.max, ge = j.x >= y.x && F.x <= T.x, xe = j.y >= y.y && F.y <= T.y;
          return ge && xe;
        },
        // @method overlaps(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds
        // overlap if their intersection is an area.
        overlaps: function(p) {
          p = gt(p);
          var y = this.min, T = this.max, F = p.min, j = p.max, ge = j.x > y.x && F.x < T.x, xe = j.y > y.y && F.y < T.y;
          return ge && xe;
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
          return !!(this.min && this.max);
        },
        // @method pad(bufferRatio: Number): Bounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(p) {
          var y = this.min, T = this.max, F = Math.abs(y.x - T.x) * p, j = Math.abs(y.y - T.y) * p;
          return gt(
            De(y.x - F, y.y - j),
            De(T.x + F, T.y + j)
          );
        },
        // @method equals(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle is equivalent to the given bounds.
        equals: function(p) {
          return p ? (p = gt(p), this.min.equals(p.getTopLeft()) && this.max.equals(p.getBottomRight())) : !1;
        }
      };
      function gt(p, y) {
        return !p || p instanceof Ke ? p : new Ke(p, y);
      }
      function qe(p, y) {
        if (p)
          for (var T = y ? [p, y] : p, F = 0, j = T.length; F < j; F++)
            this.extend(T[F]);
      }
      qe.prototype = {
        // @method extend(latlng: LatLng): this
        // Extend the bounds to contain the given point
        // @alternative
        // @method extend(otherBounds: LatLngBounds): this
        // Extend the bounds to contain the given bounds
        extend: function(p) {
          var y = this._southWest, T = this._northEast, F, j;
          if (p instanceof Le)
            F = p, j = p;
          else if (p instanceof qe) {
            if (F = p._southWest, j = p._northEast, !F || !j)
              return this;
          } else
            return p ? this.extend(Je(p) || rt(p)) : this;
          return !y && !T ? (this._southWest = new Le(F.lat, F.lng), this._northEast = new Le(j.lat, j.lng)) : (y.lat = Math.min(F.lat, y.lat), y.lng = Math.min(F.lng, y.lng), T.lat = Math.max(j.lat, T.lat), T.lng = Math.max(j.lng, T.lng)), this;
        },
        // @method pad(bufferRatio: Number): LatLngBounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(p) {
          var y = this._southWest, T = this._northEast, F = Math.abs(y.lat - T.lat) * p, j = Math.abs(y.lng - T.lng) * p;
          return new qe(
            new Le(y.lat - F, y.lng - j),
            new Le(T.lat + F, T.lng + j)
          );
        },
        // @method getCenter(): LatLng
        // Returns the center point of the bounds.
        getCenter: function() {
          return new Le(
            (this._southWest.lat + this._northEast.lat) / 2,
            (this._southWest.lng + this._northEast.lng) / 2
          );
        },
        // @method getSouthWest(): LatLng
        // Returns the south-west point of the bounds.
        getSouthWest: function() {
          return this._southWest;
        },
        // @method getNorthEast(): LatLng
        // Returns the north-east point of the bounds.
        getNorthEast: function() {
          return this._northEast;
        },
        // @method getNorthWest(): LatLng
        // Returns the north-west point of the bounds.
        getNorthWest: function() {
          return new Le(this.getNorth(), this.getWest());
        },
        // @method getSouthEast(): LatLng
        // Returns the south-east point of the bounds.
        getSouthEast: function() {
          return new Le(this.getSouth(), this.getEast());
        },
        // @method getWest(): Number
        // Returns the west longitude of the bounds
        getWest: function() {
          return this._southWest.lng;
        },
        // @method getSouth(): Number
        // Returns the south latitude of the bounds
        getSouth: function() {
          return this._southWest.lat;
        },
        // @method getEast(): Number
        // Returns the east longitude of the bounds
        getEast: function() {
          return this._northEast.lng;
        },
        // @method getNorth(): Number
        // Returns the north latitude of the bounds
        getNorth: function() {
          return this._northEast.lat;
        },
        // @method contains(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains (latlng: LatLng): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(p) {
          typeof p[0] == "number" || p instanceof Le || "lat" in p ? p = Je(p) : p = rt(p);
          var y = this._southWest, T = this._northEast, F, j;
          return p instanceof qe ? (F = p.getSouthWest(), j = p.getNorthEast()) : F = j = p, F.lat >= y.lat && j.lat <= T.lat && F.lng >= y.lng && j.lng <= T.lng;
        },
        // @method intersects(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
        intersects: function(p) {
          p = rt(p);
          var y = this._southWest, T = this._northEast, F = p.getSouthWest(), j = p.getNorthEast(), ge = j.lat >= y.lat && F.lat <= T.lat, xe = j.lng >= y.lng && F.lng <= T.lng;
          return ge && xe;
        },
        // @method overlaps(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
        overlaps: function(p) {
          p = rt(p);
          var y = this._southWest, T = this._northEast, F = p.getSouthWest(), j = p.getNorthEast(), ge = j.lat > y.lat && F.lat < T.lat, xe = j.lng > y.lng && F.lng < T.lng;
          return ge && xe;
        },
        // @method toBBoxString(): String
        // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
        toBBoxString: function() {
          return [this.getWest(), this.getSouth(), this.getEast(), this.getNorth()].join(",");
        },
        // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
        // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(p, y) {
          return p ? (p = rt(p), this._southWest.equals(p.getSouthWest(), y) && this._northEast.equals(p.getNorthEast(), y)) : !1;
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
          return !!(this._southWest && this._northEast);
        }
      };
      function rt(p, y) {
        return p instanceof qe ? p : new qe(p, y);
      }
      function Le(p, y, T) {
        if (isNaN(p) || isNaN(y))
          throw new Error("Invalid LatLng object: (" + p + ", " + y + ")");
        this.lat = +p, this.lng = +y, T !== void 0 && (this.alt = +T);
      }
      Le.prototype = {
        // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
        // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(p, y) {
          if (!p)
            return !1;
          p = Je(p);
          var T = Math.max(
            Math.abs(this.lat - p.lat),
            Math.abs(this.lng - p.lng)
          );
          return T <= (y === void 0 ? 1e-9 : y);
        },
        // @method toString(): String
        // Returns a string representation of the point (for debugging purposes).
        toString: function(p) {
          return "LatLng(" + A(this.lat, p) + ", " + A(this.lng, p) + ")";
        },
        // @method distanceTo(otherLatLng: LatLng): Number
        // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
        distanceTo: function(p) {
          return ot.distance(this, Je(p));
        },
        // @method wrap(): LatLng
        // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
        wrap: function() {
          return ot.wrapLatLng(this);
        },
        // @method toBounds(sizeInMeters: Number): LatLngBounds
        // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
        toBounds: function(p) {
          var y = 180 * p / 40075017, T = y / Math.cos(Math.PI / 180 * this.lat);
          return rt(
            [this.lat - y, this.lng - T],
            [this.lat + y, this.lng + T]
          );
        },
        clone: function() {
          return new Le(this.lat, this.lng, this.alt);
        }
      };
      function Je(p, y, T) {
        return p instanceof Le ? p : U(p) && typeof p[0] != "object" ? p.length === 3 ? new Le(p[0], p[1], p[2]) : p.length === 2 ? new Le(p[0], p[1]) : null : p == null ? p : typeof p == "object" && "lat" in p ? new Le(p.lat, "lng" in p ? p.lng : p.lon, p.alt) : y === void 0 ? null : new Le(p, y, T);
      }
      var je = {
        // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
        // Projects geographical coordinates into pixel coordinates for a given zoom.
        latLngToPoint: function(p, y) {
          var T = this.projection.project(p), F = this.scale(y);
          return this.transformation._transform(T, F);
        },
        // @method pointToLatLng(point: Point, zoom: Number): LatLng
        // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
        // zoom into geographical coordinates.
        pointToLatLng: function(p, y) {
          var T = this.scale(y), F = this.transformation.untransform(p, T);
          return this.projection.unproject(F);
        },
        // @method project(latlng: LatLng): Point
        // Projects geographical coordinates into coordinates in units accepted for
        // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
        project: function(p) {
          return this.projection.project(p);
        },
        // @method unproject(point: Point): LatLng
        // Given a projected coordinate returns the corresponding LatLng.
        // The inverse of `project`.
        unproject: function(p) {
          return this.projection.unproject(p);
        },
        // @method scale(zoom: Number): Number
        // Returns the scale used when transforming projected coordinates into
        // pixel coordinates for a particular zoom. For example, it returns
        // `256 * 2^zoom` for Mercator-based CRS.
        scale: function(p) {
          return 256 * Math.pow(2, p);
        },
        // @method zoom(scale: Number): Number
        // Inverse of `scale()`, returns the zoom level corresponding to a scale
        // factor of `scale`.
        zoom: function(p) {
          return Math.log(p / 256) / Math.LN2;
        },
        // @method getProjectedBounds(zoom: Number): Bounds
        // Returns the projection's bounds scaled and transformed for the provided `zoom`.
        getProjectedBounds: function(p) {
          if (this.infinite)
            return null;
          var y = this.projection.bounds, T = this.scale(p), F = this.transformation.transform(y.min, T), j = this.transformation.transform(y.max, T);
          return new Ke(F, j);
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates.
        // @property code: String
        // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
        //
        // @property wrapLng: Number[]
        // An array of two numbers defining whether the longitude (horizontal) coordinate
        // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
        // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
        //
        // @property wrapLat: Number[]
        // Like `wrapLng`, but for the latitude (vertical) axis.
        // wrapLng: [min, max],
        // wrapLat: [min, max],
        // @property infinite: Boolean
        // If true, the coordinate space will be unbounded (infinite in both axes)
        infinite: !1,
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where lat and lng has been wrapped according to the
        // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
        wrapLatLng: function(p) {
          var y = this.wrapLng ? x(p.lng, this.wrapLng, !0) : p.lng, T = this.wrapLat ? x(p.lat, this.wrapLat, !0) : p.lat, F = p.alt;
          return new Le(T, y, F);
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring
        // that its center is within the CRS's bounds.
        // Only accepts actual `L.LatLngBounds` instances, not arrays.
        wrapLatLngBounds: function(p) {
          var y = p.getCenter(), T = this.wrapLatLng(y), F = y.lat - T.lat, j = y.lng - T.lng;
          if (F === 0 && j === 0)
            return p;
          var ge = p.getSouthWest(), xe = p.getNorthEast(), Ve = new Le(ge.lat - F, ge.lng - j), pt = new Le(xe.lat - F, xe.lng - j);
          return new qe(Ve, pt);
        }
      }, ot = r({}, je, {
        wrapLng: [-180, 180],
        // Mean Earth Radius, as recommended for use by
        // the International Union of Geodesy and Geophysics,
        // see https://rosettacode.org/wiki/Haversine_formula
        R: 6371e3,
        // distance between two geographical points using spherical law of cosines approximation
        distance: function(p, y) {
          var T = Math.PI / 180, F = p.lat * T, j = y.lat * T, ge = Math.sin((y.lat - p.lat) * T / 2), xe = Math.sin((y.lng - p.lng) * T / 2), Ve = ge * ge + Math.cos(F) * Math.cos(j) * xe * xe, pt = 2 * Math.atan2(Math.sqrt(Ve), Math.sqrt(1 - Ve));
          return this.R * pt;
        }
      }), Xe = 6378137, tt = {
        R: Xe,
        MAX_LATITUDE: 85.0511287798,
        project: function(p) {
          var y = Math.PI / 180, T = this.MAX_LATITUDE, F = Math.max(Math.min(T, p.lat), -T), j = Math.sin(F * y);
          return new et(
            this.R * p.lng * y,
            this.R * Math.log((1 + j) / (1 - j)) / 2
          );
        },
        unproject: function(p) {
          var y = 180 / Math.PI;
          return new Le(
            (2 * Math.atan(Math.exp(p.y / this.R)) - Math.PI / 2) * y,
            p.x * y / this.R
          );
        },
        bounds: function() {
          var p = Xe * Math.PI;
          return new Ke([-p, -p], [p, p]);
        }()
      };
      function dt(p, y, T, F) {
        if (U(p)) {
          this._a = p[0], this._b = p[1], this._c = p[2], this._d = p[3];
          return;
        }
        this._a = p, this._b = y, this._c = T, this._d = F;
      }
      dt.prototype = {
        // @method transform(point: Point, scale?: Number): Point
        // Returns a transformed point, optionally multiplied by the given scale.
        // Only accepts actual `L.Point` instances, not arrays.
        transform: function(p, y) {
          return this._transform(p.clone(), y);
        },
        // destructive transform (faster)
        _transform: function(p, y) {
          return y = y || 1, p.x = y * (this._a * p.x + this._b), p.y = y * (this._c * p.y + this._d), p;
        },
        // @method untransform(point: Point, scale?: Number): Point
        // Returns the reverse transformation of the given point, optionally divided
        // by the given scale. Only accepts actual `L.Point` instances, not arrays.
        untransform: function(p, y) {
          return y = y || 1, new et(
            (p.x / y - this._b) / this._a,
            (p.y / y - this._d) / this._c
          );
        }
      };
      function bt(p, y, T, F) {
        return new dt(p, y, T, F);
      }
      var qt = r({}, ot, {
        code: "EPSG:3857",
        projection: tt,
        transformation: function() {
          var p = 0.5 / (Math.PI * tt.R);
          return bt(p, 0.5, -p, 0.5);
        }()
      }), Oe = r({}, qt, {
        code: "EPSG:900913"
      });
      function Bt(p) {
        return document.createElementNS("http://www.w3.org/2000/svg", p);
      }
      function Tn(p, y) {
        var T = "", F, j, ge, xe, Ve, pt;
        for (F = 0, ge = p.length; F < ge; F++) {
          for (Ve = p[F], j = 0, xe = Ve.length; j < xe; j++)
            pt = Ve[j], T += (j ? "L" : "M") + pt.x + " " + pt.y;
          T += y ? nt.svg ? "z" : "x" : "";
        }
        return T || "M0 0";
      }
      var hn = document.documentElement.style, Ht = "ActiveXObject" in window, qn = Ht && !document.addEventListener, vi = "msLaunchUri" in navigator && !("documentMode" in document), It = Ye("webkit"), wn = Ye("android"), Oi = Ye("android 2") || Ye("android 3"), hr = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10), qi = wn && Ye("Google") && hr < 537 && !("AudioNode" in window), kt = !!window.opera, wi = !vi && Ye("chrome"), ai = Ye("gecko") && !It && !kt && !Ht, Hr = !wi && Ye("safari"), hs = Ye("phantom"), Pt = "OTransition" in hn, $n = navigator.platform.indexOf("Win") === 0, yn = Ht && "transition" in hn, Qi = "WebKitCSSMatrix" in window && "m11" in new window.WebKitCSSMatrix() && !Oi, Gi = "MozPerspective" in hn, Cn = !window.L_DISABLE_3D && (yn || Qi || Gi) && !Pt && !hs, or = typeof orientation < "u" || Ye("mobile"), Wr = or && It, kr = or && Qi, fs = !window.PointerEvent && window.MSPointerEvent, tr = !!(window.PointerEvent || fs), pi = "ontouchstart" in window || !!window.TouchEvent, ga = !window.L_NO_TOUCH && (pi || tr), As = or && kt, Te = or && ai, se = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1, ue = function() {
        var p = !1;
        try {
          var y = Object.defineProperty({}, "passive", {
            get: function() {
              p = !0;
            }
          });
          window.addEventListener("testPassiveEventSupport", $, y), window.removeEventListener("testPassiveEventSupport", $, y);
        } catch {
        }
        return p;
      }(), be = function() {
        return !!document.createElement("canvas").getContext;
      }(), Pe = !!(document.createElementNS && Bt("svg").createSVGRect), Fe = !!Pe && function() {
        var p = document.createElement("div");
        return p.innerHTML = "<svg/>", (p.firstChild && p.firstChild.namespaceURI) === "http://www.w3.org/2000/svg";
      }(), Ze = !Pe && function() {
        try {
          var p = document.createElement("div");
          p.innerHTML = '<v:shape adj="1"/>';
          var y = p.firstChild;
          return y.style.behavior = "url(#default#VML)", y && typeof y.adj == "object";
        } catch {
          return !1;
        }
      }(), ze = navigator.platform.indexOf("Mac") === 0, Re = navigator.platform.indexOf("Linux") === 0;
      function Ye(p) {
        return navigator.userAgent.toLowerCase().indexOf(p) >= 0;
      }
      var nt = {
        ie: Ht,
        ielt9: qn,
        edge: vi,
        webkit: It,
        android: wn,
        android23: Oi,
        androidStock: qi,
        opera: kt,
        chrome: wi,
        gecko: ai,
        safari: Hr,
        phantom: hs,
        opera12: Pt,
        win: $n,
        ie3d: yn,
        webkit3d: Qi,
        gecko3d: Gi,
        any3d: Cn,
        mobile: or,
        mobileWebkit: Wr,
        mobileWebkit3d: kr,
        msPointer: fs,
        pointer: tr,
        touch: ga,
        touchNative: pi,
        mobileOpera: As,
        mobileGecko: Te,
        retina: se,
        passiveEvents: ue,
        canvas: be,
        svg: Pe,
        vml: Ze,
        inlineSvg: Fe,
        mac: ze,
        linux: Re
      }, _t = nt.msPointer ? "MSPointerDown" : "pointerdown", yt = nt.msPointer ? "MSPointerMove" : "pointermove", un = nt.msPointer ? "MSPointerUp" : "pointerup", bn = nt.msPointer ? "MSPointerCancel" : "pointercancel", Kt = {
        touchstart: _t,
        touchmove: yt,
        touchend: un,
        touchcancel: bn
      }, an = {
        touchstart: ar,
        touchmove: Dr,
        touchend: Dr,
        touchcancel: Dr
      }, dn = {}, Bn = !1;
      function An(p, y, T) {
        return y === "touchstart" && Ni(), an[y] ? (T = an[y].bind(this, T), p.addEventListener(Kt[y], T, !1), T) : (console.warn("wrong event specified:", y), $);
      }
      function Un(p, y, T) {
        if (!Kt[y]) {
          console.warn("wrong event specified:", y);
          return;
        }
        p.removeEventListener(Kt[y], T, !1);
      }
      function ei(p) {
        dn[p.pointerId] = p;
      }
      function Yi(p) {
        dn[p.pointerId] && (dn[p.pointerId] = p);
      }
      function _n(p) {
        delete dn[p.pointerId];
      }
      function Ni() {
        Bn || (document.addEventListener(_t, ei, !0), document.addEventListener(yt, Yi, !0), document.addEventListener(un, _n, !0), document.addEventListener(bn, _n, !0), Bn = !0);
      }
      function Dr(p, y) {
        if (y.pointerType !== (y.MSPOINTER_TYPE_MOUSE || "mouse")) {
          y.touches = [];
          for (var T in dn)
            y.touches.push(dn[T]);
          y.changedTouches = [y], p(y);
        }
      }
      function ar(p, y) {
        y.MSPOINTER_TYPE_TOUCH && y.pointerType === y.MSPOINTER_TYPE_TOUCH && lr(y), Dr(p, y);
      }
      function Zr(p) {
        var y = {}, T, F;
        for (F in p)
          T = p[F], y[F] = T && T.bind ? T.bind(p) : T;
        return p = y, y.type = "dblclick", y.detail = 2, y.isTrusted = !1, y._simulated = !0, y;
      }
      var ns = 200;
      function Uo(p, y) {
        p.addEventListener("dblclick", y);
        var T = 0, F;
        function j(ge) {
          if (ge.detail !== 1) {
            F = ge.detail;
            return;
          }
          if (!(ge.pointerType === "mouse" || ge.sourceCapabilities && !ge.sourceCapabilities.firesTouchEvents)) {
            var xe = Wo(ge);
            if (!(xe.some(function(pt) {
              return pt instanceof HTMLLabelElement && pt.attributes.for;
            }) && !xe.some(function(pt) {
              return pt instanceof HTMLInputElement || pt instanceof HTMLSelectElement;
            }))) {
              var Ve = Date.now();
              Ve - T <= ns ? (F++, F === 2 && y(Zr(ge))) : F = 1, T = Ve;
            }
          }
        }
        return p.addEventListener("click", j), {
          dblclick: y,
          simDblclick: j
        };
      }
      function al(p, y) {
        p.removeEventListener("dblclick", y.dblclick), p.removeEventListener("click", y.simDblclick);
      }
      var Bi = In(
        ["transform", "webkitTransform", "OTransform", "MozTransform", "msTransform"]
      ), Us = In(
        ["webkitTransition", "transition", "OTransition", "MozTransition", "msTransition"]
      ), Es = Us === "webkitTransition" || Us === "OTransition" ? Us + "End" : "transitionend";
      function Vi(p) {
        return typeof p == "string" ? document.getElementById(p) : p;
      }
      function ao(p, y) {
        var T = p.style[y] || p.currentStyle && p.currentStyle[y];
        if ((!T || T === "auto") && document.defaultView) {
          var F = document.defaultView.getComputedStyle(p, null);
          T = F ? F[y] : null;
        }
        return T === "auto" ? null : T;
      }
      function Ln(p, y, T) {
        var F = document.createElement(p);
        return F.className = y || "", T && T.appendChild(F), F;
      }
      function xi(p) {
        var y = p.parentNode;
        y && y.removeChild(p);
      }
      function Ki(p) {
        for (; p.firstChild; )
          p.removeChild(p.firstChild);
      }
      function Hs(p) {
        var y = p.parentNode;
        y && y.lastChild !== p && y.appendChild(p);
      }
      function ms(p) {
        var y = p.parentNode;
        y && y.firstChild !== p && y.insertBefore(p, y.firstChild);
      }
      function Ps(p, y) {
        if (p.classList !== void 0)
          return p.classList.contains(y);
        var T = ko(p);
        return T.length > 0 && new RegExp("(^|\\s)" + y + "(\\s|$)").test(T);
      }
      function jt(p, y) {
        if (p.classList !== void 0)
          for (var T = O(y), F = 0, j = T.length; F < j; F++)
            p.classList.add(T[F]);
        else if (!Ps(p, y)) {
          var ge = ko(p);
          qr(p, (ge ? ge + " " : "") + y);
        }
      }
      function hi(p, y) {
        p.classList !== void 0 ? p.classList.remove(y) : qr(p, I((" " + ko(p) + " ").replace(" " + y + " ", " ")));
      }
      function qr(p, y) {
        p.className.baseVal === void 0 ? p.className = y : p.className.baseVal = y;
      }
      function ko(p) {
        return p.correspondingElement && (p = p.correspondingElement), p.className.baseVal === void 0 ? p.className : p.className.baseVal;
      }
      function Mt(p, y) {
        "opacity" in p.style ? p.style.opacity = y : "filter" in p.style && Fn(p, y);
      }
      function Fn(p, y) {
        var T = !1, F = "DXImageTransform.Microsoft.Alpha";
        try {
          T = p.filters.item(F);
        } catch {
          if (y === 1)
            return;
        }
        y = Math.round(y * 100), T ? (T.Enabled = y !== 100, T.Opacity = y) : p.style.filter += " progid:" + F + "(opacity=" + y + ")";
      }
      function In(p) {
        for (var y = document.documentElement.style, T = 0; T < p.length; T++)
          if (p[T] in y)
            return p[T];
        return !1;
      }
      function ti(p, y, T) {
        var F = y || new et(0, 0);
        p.style[Bi] = (nt.ie3d ? "translate(" + F.x + "px," + F.y + "px)" : "translate3d(" + F.x + "px," + F.y + "px,0)") + (T ? " scale(" + T + ")" : "");
      }
      function Xn(p, y) {
        p._leaflet_pos = y, nt.any3d ? ti(p, y) : (p.style.left = y.x + "px", p.style.top = y.y + "px");
      }
      function ya(p) {
        return p._leaflet_pos || new et(0, 0);
      }
      var ll, Gl, Yl;
      if ("onselectstart" in document)
        ll = function() {
          Mn(window, "selectstart", lr);
        }, Gl = function() {
          li(window, "selectstart", lr);
        };
      else {
        var _a = In(
          ["userSelect", "WebkitUserSelect", "OUserSelect", "MozUserSelect", "msUserSelect"]
        );
        ll = function() {
          if (_a) {
            var p = document.documentElement.style;
            Yl = p[_a], p[_a] = "none";
          }
        }, Gl = function() {
          _a && (document.documentElement.style[_a] = Yl, Yl = void 0);
        };
      }
      function Kl() {
        Mn(window, "dragstart", lr);
      }
      function Wc() {
        li(window, "dragstart", lr);
      }
      var Xl, Ws;
      function cl(p) {
        for (; p.tabIndex === -1; )
          p = p.parentNode;
        p.style && (jr(), Xl = p, Ws = p.style.outlineStyle, p.style.outlineStyle = "none", Mn(window, "keydown", jr));
      }
      function jr() {
        Xl && (Xl.style.outlineStyle = Ws, Xl = void 0, Ws = void 0, li(window, "keydown", jr));
      }
      function Jl(p) {
        do
          p = p.parentNode;
        while ((!p.offsetWidth || !p.offsetHeight) && p !== document.body);
        return p;
      }
      function ba(p) {
        var y = p.getBoundingClientRect();
        return {
          x: y.width / p.offsetWidth || 1,
          y: y.height / p.offsetHeight || 1,
          boundingClientRect: y
        };
      }
      var ul = {
        __proto__: null,
        TRANSFORM: Bi,
        TRANSITION: Us,
        TRANSITION_END: Es,
        get: Vi,
        getStyle: ao,
        create: Ln,
        remove: xi,
        empty: Ki,
        toFront: Hs,
        toBack: ms,
        hasClass: Ps,
        addClass: jt,
        removeClass: hi,
        setClass: qr,
        getClass: ko,
        setOpacity: Mt,
        testProp: In,
        setTransform: ti,
        setPosition: Xn,
        getPosition: ya,
        get disableTextSelection() {
          return ll;
        },
        get enableTextSelection() {
          return Gl;
        },
        disableImageDrag: Kl,
        enableImageDrag: Wc,
        preventOutline: cl,
        restoreOutline: jr,
        getSizedParentNode: Jl,
        getScale: ba
      };
      function Mn(p, y, T, F) {
        if (y && typeof y == "object")
          for (var j in y)
            Gr(p, j, y[j], T);
        else {
          y = O(y);
          for (var ge = 0, xe = y.length; ge < xe; ge++)
            Gr(p, y[ge], T, F);
        }
        return this;
      }
      var vs = "_leaflet_events";
      function li(p, y, T, F) {
        if (arguments.length === 1)
          wa(p), delete p[vs];
        else if (y && typeof y == "object")
          for (var j in y)
            Yr(p, j, y[j], T);
        else if (y = O(y), arguments.length === 2)
          wa(p, function(Ve) {
            return q(y, Ve) !== -1;
          });
        else
          for (var ge = 0, xe = y.length; ge < xe; ge++)
            Yr(p, y[ge], T, F);
        return this;
      }
      function wa(p, y) {
        for (var T in p[vs]) {
          var F = T.split(/\d/)[0];
          (!y || y(F)) && Yr(p, F, null, null, T);
        }
      }
      var dl = {
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        wheel: !("onwheel" in window) && "mousewheel"
      };
      function Gr(p, y, T, F) {
        var j = y + f(T) + (F ? "_" + f(F) : "");
        if (p[vs] && p[vs][j])
          return this;
        var ge = function(Ve) {
          return T.call(F || p, Ve || window.event);
        }, xe = ge;
        !nt.touchNative && nt.pointer && y.indexOf("touch") === 0 ? ge = An(p, y, ge) : nt.touch && y === "dblclick" ? ge = Uo(p, ge) : "addEventListener" in p ? y === "touchstart" || y === "touchmove" || y === "wheel" || y === "mousewheel" ? p.addEventListener(dl[y] || y, ge, nt.passiveEvents ? { passive: !1 } : !1) : y === "mouseenter" || y === "mouseleave" ? (ge = function(Ve) {
          Ve = Ve || window.event, Zc(p, Ve) && xe(Ve);
        }, p.addEventListener(dl[y], ge, !1)) : p.addEventListener(y, xe, !1) : p.attachEvent("on" + y, ge), p[vs] = p[vs] || {}, p[vs][j] = ge;
      }
      function Yr(p, y, T, F, j) {
        j = j || y + f(T) + (F ? "_" + f(F) : "");
        var ge = p[vs] && p[vs][j];
        if (!ge)
          return this;
        !nt.touchNative && nt.pointer && y.indexOf("touch") === 0 ? Un(p, y, ge) : nt.touch && y === "dblclick" ? al(p, ge) : "removeEventListener" in p ? p.removeEventListener(dl[y] || y, ge, !1) : p.detachEvent("on" + y, ge), p[vs][j] = null;
      }
      function So(p) {
        return p.stopPropagation ? p.stopPropagation() : p.originalEvent ? p.originalEvent._stopped = !0 : p.cancelBubble = !0, this;
      }
      function pl(p) {
        return Gr(p, "wheel", So), this;
      }
      function Ho(p) {
        return Mn(p, "mousedown touchstart dblclick contextmenu", So), p._leaflet_disable_click = !0, this;
      }
      function lr(p) {
        return p.preventDefault ? p.preventDefault() : p.returnValue = !1, this;
      }
      function Zs(p) {
        return lr(p), So(p), this;
      }
      function Wo(p) {
        if (p.composedPath)
          return p.composedPath();
        for (var y = [], T = p.target; T; )
          y.push(T), T = T.parentNode;
        return y;
      }
      function Yn(p, y) {
        if (!y)
          return new et(p.clientX, p.clientY);
        var T = ba(y), F = T.boundingClientRect;
        return new et(
          // offset.left/top values are in page scale (like clientX/Y),
          // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
          (p.clientX - F.left) / T.x - y.clientLeft,
          (p.clientY - F.top) / T.y - y.clientTop
        );
      }
      var Wu = nt.linux && nt.chrome ? window.devicePixelRatio : nt.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
      function Ql(p) {
        return nt.edge ? p.wheelDeltaY / 2 : (
          // Don't trust window-geometry-based delta
          p.deltaY && p.deltaMode === 0 ? -p.deltaY / Wu : (
            // Pixels
            p.deltaY && p.deltaMode === 1 ? -p.deltaY * 20 : (
              // Lines
              p.deltaY && p.deltaMode === 2 ? -p.deltaY * 60 : (
                // Pages
                p.deltaX || p.deltaZ ? 0 : (
                  // Skip horizontal/depth wheel events
                  p.wheelDelta ? (p.wheelDeltaY || p.wheelDelta) / 2 : (
                    // Legacy IE pixels
                    p.detail && Math.abs(p.detail) < 32765 ? -p.detail * 20 : (
                      // Legacy Moz lines
                      p.detail ? p.detail / -32765 * 60 : (
                        // Legacy Moz pages
                        0
                      )
                    )
                  )
                )
              )
            )
          )
        );
      }
      function Zc(p, y) {
        var T = y.relatedTarget;
        if (!T)
          return !0;
        try {
          for (; T && T !== p; )
            T = T.parentNode;
        } catch {
          return !1;
        }
        return T !== p;
      }
      var Yd = {
        __proto__: null,
        on: Mn,
        off: li,
        stopPropagation: So,
        disableScrollPropagation: pl,
        disableClickPropagation: Ho,
        preventDefault: lr,
        stop: Zs,
        getPropagationPath: Wo,
        getMousePosition: Yn,
        getWheelDelta: Ql,
        isExternalTarget: Zc,
        addListener: Mn,
        removeListener: li
      }, xa = Ge.extend({
        // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
        // Run an animation of a given element to a new position, optionally setting
        // duration in seconds (`0.25` by default) and easing linearity factor (3rd
        // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
        // `0.5` by default).
        run: function(p, y, T, F) {
          this.stop(), this._el = p, this._inProgress = !0, this._duration = T || 0.25, this._easeOutPower = 1 / Math.max(F || 0.5, 0.2), this._startPos = ya(p), this._offset = y.subtract(this._startPos), this._startTime = +/* @__PURE__ */ new Date(), this.fire("start"), this._animate();
        },
        // @method stop()
        // Stops the animation (if currently running).
        stop: function() {
          this._inProgress && (this._step(!0), this._complete());
        },
        _animate: function() {
          this._animId = ve(this._animate, this), this._step();
        },
        _step: function(p) {
          var y = +/* @__PURE__ */ new Date() - this._startTime, T = this._duration * 1e3;
          y < T ? this._runFrame(this._easeOut(y / T), p) : (this._runFrame(1), this._complete());
        },
        _runFrame: function(p, y) {
          var T = this._startPos.add(this._offset.multiplyBy(p));
          y && T._round(), Xn(this._el, T), this.fire("step");
        },
        _complete: function() {
          re(this._animId), this._inProgress = !1, this.fire("end");
        },
        _easeOut: function(p) {
          return 1 - Math.pow(1 - p, this._easeOutPower);
        }
      }), Jn = Ge.extend({
        options: {
          // @section Map State Options
          // @option crs: CRS = L.CRS.EPSG3857
          // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
          // sure what it means.
          crs: qt,
          // @option center: LatLng = undefined
          // Initial geographic center of the map
          center: void 0,
          // @option zoom: Number = undefined
          // Initial map zoom level
          zoom: void 0,
          // @option minZoom: Number = *
          // Minimum zoom level of the map.
          // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
          // the lowest of their `minZoom` options will be used instead.
          minZoom: void 0,
          // @option maxZoom: Number = *
          // Maximum zoom level of the map.
          // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
          // the highest of their `maxZoom` options will be used instead.
          maxZoom: void 0,
          // @option layers: Layer[] = []
          // Array of layers that will be added to the map initially
          layers: [],
          // @option maxBounds: LatLngBounds = null
          // When this option is set, the map restricts the view to the given
          // geographical bounds, bouncing the user back if the user tries to pan
          // outside the view. To set the restriction dynamically, use
          // [`setMaxBounds`](#map-setmaxbounds) method.
          maxBounds: void 0,
          // @option renderer: Renderer = *
          // The default method for drawing vector layers on the map. `L.SVG`
          // or `L.Canvas` by default depending on browser support.
          renderer: void 0,
          // @section Animation Options
          // @option zoomAnimation: Boolean = true
          // Whether the map zoom animation is enabled. By default it's enabled
          // in all browsers that support CSS3 Transitions except Android.
          zoomAnimation: !0,
          // @option zoomAnimationThreshold: Number = 4
          // Won't animate zoom if the zoom difference exceeds this value.
          zoomAnimationThreshold: 4,
          // @option fadeAnimation: Boolean = true
          // Whether the tile fade animation is enabled. By default it's enabled
          // in all browsers that support CSS3 Transitions except Android.
          fadeAnimation: !0,
          // @option markerZoomAnimation: Boolean = true
          // Whether markers animate their zoom with the zoom animation, if disabled
          // they will disappear for the length of the animation. By default it's
          // enabled in all browsers that support CSS3 Transitions except Android.
          markerZoomAnimation: !0,
          // @option transform3DLimit: Number = 2^23
          // Defines the maximum size of a CSS translation transform. The default
          // value should not be changed unless a web browser positions layers in
          // the wrong place after doing a large `panBy`.
          transform3DLimit: 8388608,
          // Precision limit of a 32-bit float
          // @section Interaction Options
          // @option zoomSnap: Number = 1
          // Forces the map's zoom level to always be a multiple of this, particularly
          // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
          // By default, the zoom level snaps to the nearest integer; lower values
          // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
          // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
          zoomSnap: 1,
          // @option zoomDelta: Number = 1
          // Controls how much the map's zoom level will change after a
          // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
          // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
          // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
          zoomDelta: 1,
          // @option trackResize: Boolean = true
          // Whether the map automatically handles browser window resize to update itself.
          trackResize: !0
        },
        initialize: function(p, y) {
          y = B(this, y), this._handlers = [], this._layers = {}, this._zoomBoundLayers = {}, this._sizeChanged = !0, this._initContainer(p), this._initLayout(), this._onResize = d(this._onResize, this), this._initEvents(), y.maxBounds && this.setMaxBounds(y.maxBounds), y.zoom !== void 0 && (this._zoom = this._limitZoom(y.zoom)), y.center && y.zoom !== void 0 && this.setView(Je(y.center), y.zoom, { reset: !0 }), this.callInitHooks(), this._zoomAnimated = Us && nt.any3d && !nt.mobileOpera && this.options.zoomAnimation, this._zoomAnimated && (this._createAnimProxy(), Mn(this._proxy, Es, this._catchTransitionEnd, this)), this._addLayers(this.options.layers);
        },
        // @section Methods for modifying map state
        // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) with the given
        // animation options.
        setView: function(p, y, T) {
          if (y = y === void 0 ? this._zoom : this._limitZoom(y), p = this._limitCenter(Je(p), y, this.options.maxBounds), T = T || {}, this._stop(), this._loaded && !T.reset && T !== !0) {
            T.animate !== void 0 && (T.zoom = r({ animate: T.animate }, T.zoom), T.pan = r({ animate: T.animate, duration: T.duration }, T.pan));
            var F = this._zoom !== y ? this._tryAnimatedZoom && this._tryAnimatedZoom(p, y, T.zoom) : this._tryAnimatedPan(p, T.pan);
            if (F)
              return clearTimeout(this._sizeTimer), this;
          }
          return this._resetView(p, y, T.pan && T.pan.noMoveStart), this;
        },
        // @method setZoom(zoom: Number, options?: Zoom/pan options): this
        // Sets the zoom of the map.
        setZoom: function(p, y) {
          return this._loaded ? this.setView(this.getCenter(), p, { zoom: y }) : (this._zoom = p, this);
        },
        // @method zoomIn(delta?: Number, options?: Zoom options): this
        // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomIn: function(p, y) {
          return p = p || (nt.any3d ? this.options.zoomDelta : 1), this.setZoom(this._zoom + p, y);
        },
        // @method zoomOut(delta?: Number, options?: Zoom options): this
        // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomOut: function(p, y) {
          return p = p || (nt.any3d ? this.options.zoomDelta : 1), this.setZoom(this._zoom - p, y);
        },
        // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified geographical point on the map
        // stationary (e.g. used internally for scroll zoom and double-click zoom).
        // @alternative
        // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
        setZoomAround: function(p, y, T) {
          var F = this.getZoomScale(y), j = this.getSize().divideBy(2), ge = p instanceof et ? p : this.latLngToContainerPoint(p), xe = ge.subtract(j).multiplyBy(1 - 1 / F), Ve = this.containerPointToLatLng(j.add(xe));
          return this.setView(Ve, y, { zoom: T });
        },
        _getBoundsCenterZoom: function(p, y) {
          y = y || {}, p = p.getBounds ? p.getBounds() : rt(p);
          var T = De(y.paddingTopLeft || y.padding || [0, 0]), F = De(y.paddingBottomRight || y.padding || [0, 0]), j = this.getBoundsZoom(p, !1, T.add(F));
          if (j = typeof y.maxZoom == "number" ? Math.min(y.maxZoom, j) : j, j === 1 / 0)
            return {
              center: p.getCenter(),
              zoom: j
            };
          var ge = F.subtract(T).divideBy(2), xe = this.project(p.getSouthWest(), j), Ve = this.project(p.getNorthEast(), j), pt = this.unproject(xe.add(Ve).divideBy(2).add(ge), j);
          return {
            center: pt,
            zoom: j
          };
        },
        // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets a map view that contains the given geographical bounds with the
        // maximum zoom level possible.
        fitBounds: function(p, y) {
          if (p = rt(p), !p.isValid())
            throw new Error("Bounds are not valid.");
          var T = this._getBoundsCenterZoom(p, y);
          return this.setView(T.center, T.zoom, y);
        },
        // @method fitWorld(options?: fitBounds options): this
        // Sets a map view that mostly contains the whole world with the maximum
        // zoom level possible.
        fitWorld: function(p) {
          return this.fitBounds([[-90, -180], [90, 180]], p);
        },
        // @method panTo(latlng: LatLng, options?: Pan options): this
        // Pans the map to a given center.
        panTo: function(p, y) {
          return this.setView(p, this._zoom, { pan: y });
        },
        // @method panBy(offset: Point, options?: Pan options): this
        // Pans the map by a given number of pixels (animated).
        panBy: function(p, y) {
          if (p = De(p).round(), y = y || {}, !p.x && !p.y)
            return this.fire("moveend");
          if (y.animate !== !0 && !this.getSize().contains(p))
            return this._resetView(this.unproject(this.project(this.getCenter()).add(p)), this.getZoom()), this;
          if (this._panAnim || (this._panAnim = new xa(), this._panAnim.on({
            step: this._onPanTransitionStep,
            end: this._onPanTransitionEnd
          }, this)), y.noMoveStart || this.fire("movestart"), y.animate !== !1) {
            jt(this._mapPane, "leaflet-pan-anim");
            var T = this._getMapPanePos().subtract(p).round();
            this._panAnim.run(this._mapPane, T, y.duration || 0.25, y.easeLinearity);
          } else
            this._rawPanBy(p), this.fire("move").fire("moveend");
          return this;
        },
        // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) performing a smooth
        // pan-zoom animation.
        flyTo: function(p, y, T) {
          if (T = T || {}, T.animate === !1 || !nt.any3d)
            return this.setView(p, y, T);
          this._stop();
          var F = this.project(this.getCenter()), j = this.project(p), ge = this.getSize(), xe = this._zoom;
          p = Je(p), y = y === void 0 ? xe : y;
          var Ve = Math.max(ge.x, ge.y), pt = Ve * this.getZoomScale(xe, y), $t = j.distanceTo(F) || 1, Jt = 1.42, pn = Jt * Jt;
          function Hn(Pi) {
            var Da = Pi ? -1 : 1, vc = Pi ? pt : Ve, od = pt * pt - Ve * Ve + Da * pn * pn * $t * $t, $l = 2 * vc * pn * $t, Eo = od / $l, su = Math.sqrt(Eo * Eo + 1) - Eo, ou = su < 1e-9 ? -18 : Math.log(su);
            return ou;
          }
          function Hi(Pi) {
            return (Math.exp(Pi) - Math.exp(-Pi)) / 2;
          }
          function fr(Pi) {
            return (Math.exp(Pi) + Math.exp(-Pi)) / 2;
          }
          function ir(Pi) {
            return Hi(Pi) / fr(Pi);
          }
          var Kn = Hn(0);
          function Ri(Pi) {
            return Ve * (fr(Kn) / fr(Kn + Jt * Pi));
          }
          function sp(Pi) {
            return Ve * (fr(Kn) * ir(Kn + Jt * Pi) - Hi(Kn)) / pn;
          }
          function xl(Pi) {
            return 1 - Math.pow(1 - Pi, 1.5);
          }
          var iu = Date.now(), ru = (Hn(1) - Kn) / Jt, fo = T.duration ? 1e3 * T.duration : 1e3 * ru * 0.8;
          function mc() {
            var Pi = (Date.now() - iu) / fo, Da = xl(Pi) * ru;
            Pi <= 1 ? (this._flyToFrame = ve(mc, this), this._move(
              this.unproject(F.add(j.subtract(F).multiplyBy(sp(Da) / $t)), xe),
              this.getScaleZoom(Ve / Ri(Da), xe),
              { flyTo: !0 }
            )) : this._move(p, y)._moveEnd(!0);
          }
          return this._moveStart(!0, T.noMoveStart), mc.call(this), this;
        },
        // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
        // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
        flyToBounds: function(p, y) {
          var T = this._getBoundsCenterZoom(p, y);
          return this.flyTo(T.center, T.zoom, y);
        },
        // @method setMaxBounds(bounds: LatLngBounds): this
        // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
        setMaxBounds: function(p) {
          return p = rt(p), this.listens("moveend", this._panInsideMaxBounds) && this.off("moveend", this._panInsideMaxBounds), p.isValid() ? (this.options.maxBounds = p, this._loaded && this._panInsideMaxBounds(), this.on("moveend", this._panInsideMaxBounds)) : (this.options.maxBounds = null, this);
        },
        // @method setMinZoom(zoom: Number): this
        // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
        setMinZoom: function(p) {
          var y = this.options.minZoom;
          return this.options.minZoom = p, this._loaded && y !== p && (this.fire("zoomlevelschange"), this.getZoom() < this.options.minZoom) ? this.setZoom(p) : this;
        },
        // @method setMaxZoom(zoom: Number): this
        // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
        setMaxZoom: function(p) {
          var y = this.options.maxZoom;
          return this.options.maxZoom = p, this._loaded && y !== p && (this.fire("zoomlevelschange"), this.getZoom() > this.options.maxZoom) ? this.setZoom(p) : this;
        },
        // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
        // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
        panInsideBounds: function(p, y) {
          this._enforcingBounds = !0;
          var T = this.getCenter(), F = this._limitCenter(T, this._zoom, rt(p));
          return T.equals(F) || this.panTo(F, y), this._enforcingBounds = !1, this;
        },
        // @method panInside(latlng: LatLng, options?: padding options): this
        // Pans the map the minimum amount to make the `latlng` visible. Use
        // padding options to fit the display to more restricted bounds.
        // If `latlng` is already within the (optionally padded) display bounds,
        // the map will not be panned.
        panInside: function(p, y) {
          y = y || {};
          var T = De(y.paddingTopLeft || y.padding || [0, 0]), F = De(y.paddingBottomRight || y.padding || [0, 0]), j = this.project(this.getCenter()), ge = this.project(p), xe = this.getPixelBounds(), Ve = gt([xe.min.add(T), xe.max.subtract(F)]), pt = Ve.getSize();
          if (!Ve.contains(ge)) {
            this._enforcingBounds = !0;
            var $t = ge.subtract(Ve.getCenter()), Jt = Ve.extend(ge).getSize().subtract(pt);
            j.x += $t.x < 0 ? -Jt.x : Jt.x, j.y += $t.y < 0 ? -Jt.y : Jt.y, this.panTo(this.unproject(j), y), this._enforcingBounds = !1;
          }
          return this;
        },
        // @method invalidateSize(options: Zoom/pan options): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default. If `options.pan` is `false`, panning will not occur.
        // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
        // that it doesn't happen often even if the method is called many
        // times in a row.
        // @alternative
        // @method invalidateSize(animate: Boolean): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default.
        invalidateSize: function(p) {
          if (!this._loaded)
            return this;
          p = r({
            animate: !1,
            pan: !0
          }, p === !0 ? { animate: !0 } : p);
          var y = this.getSize();
          this._sizeChanged = !0, this._lastCenter = null;
          var T = this.getSize(), F = y.divideBy(2).round(), j = T.divideBy(2).round(), ge = F.subtract(j);
          return !ge.x && !ge.y ? this : (p.animate && p.pan ? this.panBy(ge) : (p.pan && this._rawPanBy(ge), this.fire("move"), p.debounceMoveend ? (clearTimeout(this._sizeTimer), this._sizeTimer = setTimeout(d(this.fire, this, "moveend"), 200)) : this.fire("moveend")), this.fire("resize", {
            oldSize: y,
            newSize: T
          }));
        },
        // @section Methods for modifying map state
        // @method stop(): this
        // Stops the currently running `panTo` or `flyTo` animation, if any.
        stop: function() {
          return this.setZoom(this._limitZoom(this._zoom)), this.options.zoomSnap || this.fire("viewreset"), this._stop();
        },
        // @section Geolocation methods
        // @method locate(options?: Locate options): this
        // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
        // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
        // and optionally sets the map view to the user's location with respect to
        // detection accuracy (or to the world view if geolocation failed).
        // Note that, if your page doesn't use HTTPS, this method will fail in
        // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
        // See `Locate options` for more details.
        locate: function(p) {
          if (p = this._locateOptions = r({
            timeout: 1e4,
            watch: !1
            // setView: false
            // maxZoom: <Number>
            // maximumAge: 0
            // enableHighAccuracy: false
          }, p), !("geolocation" in navigator))
            return this._handleGeolocationError({
              code: 0,
              message: "Geolocation not supported."
            }), this;
          var y = d(this._handleGeolocationResponse, this), T = d(this._handleGeolocationError, this);
          return p.watch ? this._locationWatchId = navigator.geolocation.watchPosition(y, T, p) : navigator.geolocation.getCurrentPosition(y, T, p), this;
        },
        // @method stopLocate(): this
        // Stops watching location previously initiated by `map.locate({watch: true})`
        // and aborts resetting the map view if map.locate was called with
        // `{setView: true}`.
        stopLocate: function() {
          return navigator.geolocation && navigator.geolocation.clearWatch && navigator.geolocation.clearWatch(this._locationWatchId), this._locateOptions && (this._locateOptions.setView = !1), this;
        },
        _handleGeolocationError: function(p) {
          if (this._container._leaflet_id) {
            var y = p.code, T = p.message || (y === 1 ? "permission denied" : y === 2 ? "position unavailable" : "timeout");
            this._locateOptions.setView && !this._loaded && this.fitWorld(), this.fire("locationerror", {
              code: y,
              message: "Geolocation error: " + T + "."
            });
          }
        },
        _handleGeolocationResponse: function(p) {
          if (this._container._leaflet_id) {
            var y = p.coords.latitude, T = p.coords.longitude, F = new Le(y, T), j = F.toBounds(p.coords.accuracy * 2), ge = this._locateOptions;
            if (ge.setView) {
              var xe = this.getBoundsZoom(j);
              this.setView(F, ge.maxZoom ? Math.min(xe, ge.maxZoom) : xe);
            }
            var Ve = {
              latlng: F,
              bounds: j,
              timestamp: p.timestamp
            };
            for (var pt in p.coords)
              typeof p.coords[pt] == "number" && (Ve[pt] = p.coords[pt]);
            this.fire("locationfound", Ve);
          }
        },
        // TODO Appropriate docs section?
        // @section Other Methods
        // @method addHandler(name: String, HandlerClass: Function): this
        // Adds a new `Handler` to the map, given its name and constructor function.
        addHandler: function(p, y) {
          if (!y)
            return this;
          var T = this[p] = new y(this);
          return this._handlers.push(T), this.options[p] && T.enable(), this;
        },
        // @method remove(): this
        // Destroys the map and clears all related event listeners.
        remove: function() {
          if (this._initEvents(!0), this.options.maxBounds && this.off("moveend", this._panInsideMaxBounds), this._containerId !== this._container._leaflet_id)
            throw new Error("Map container is being reused by another instance");
          try {
            delete this._container._leaflet_id, delete this._containerId;
          } catch {
            this._container._leaflet_id = void 0, this._containerId = void 0;
          }
          this._locationWatchId !== void 0 && this.stopLocate(), this._stop(), xi(this._mapPane), this._clearControlPos && this._clearControlPos(), this._resizeRequest && (re(this._resizeRequest), this._resizeRequest = null), this._clearHandlers(), this._loaded && this.fire("unload");
          var p;
          for (p in this._layers)
            this._layers[p].remove();
          for (p in this._panes)
            xi(this._panes[p]);
          return this._layers = [], this._panes = [], delete this._mapPane, delete this._renderer, this;
        },
        // @section Other Methods
        // @method createPane(name: String, container?: HTMLElement): HTMLElement
        // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
        // then returns it. The pane is created as a child of `container`, or
        // as a child of the main map pane if not set.
        createPane: function(p, y) {
          var T = "leaflet-pane" + (p ? " leaflet-" + p.replace("Pane", "") + "-pane" : ""), F = Ln("div", T, y || this._mapPane);
          return p && (this._panes[p] = F), F;
        },
        // @section Methods for Getting Map State
        // @method getCenter(): LatLng
        // Returns the geographical center of the map view
        getCenter: function() {
          return this._checkIfLoaded(), this._lastCenter && !this._moved() ? this._lastCenter.clone() : this.layerPointToLatLng(this._getCenterLayerPoint());
        },
        // @method getZoom(): Number
        // Returns the current zoom level of the map view
        getZoom: function() {
          return this._zoom;
        },
        // @method getBounds(): LatLngBounds
        // Returns the geographical bounds visible in the current map view
        getBounds: function() {
          var p = this.getPixelBounds(), y = this.unproject(p.getBottomLeft()), T = this.unproject(p.getTopRight());
          return new qe(y, T);
        },
        // @method getMinZoom(): Number
        // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
        getMinZoom: function() {
          return this.options.minZoom === void 0 ? this._layersMinZoom || 0 : this.options.minZoom;
        },
        // @method getMaxZoom(): Number
        // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
        getMaxZoom: function() {
          return this.options.maxZoom === void 0 ? this._layersMaxZoom === void 0 ? 1 / 0 : this._layersMaxZoom : this.options.maxZoom;
        },
        // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
        // Returns the maximum zoom level on which the given bounds fit to the map
        // view in its entirety. If `inside` (optional) is set to `true`, the method
        // instead returns the minimum zoom level on which the map view fits into
        // the given bounds in its entirety.
        getBoundsZoom: function(p, y, T) {
          p = rt(p), T = De(T || [0, 0]);
          var F = this.getZoom() || 0, j = this.getMinZoom(), ge = this.getMaxZoom(), xe = p.getNorthWest(), Ve = p.getSouthEast(), pt = this.getSize().subtract(T), $t = gt(this.project(Ve, F), this.project(xe, F)).getSize(), Jt = nt.any3d ? this.options.zoomSnap : 1, pn = pt.x / $t.x, Hn = pt.y / $t.y, Hi = y ? Math.max(pn, Hn) : Math.min(pn, Hn);
          return F = this.getScaleZoom(Hi, F), Jt && (F = Math.round(F / (Jt / 100)) * (Jt / 100), F = y ? Math.ceil(F / Jt) * Jt : Math.floor(F / Jt) * Jt), Math.max(j, Math.min(ge, F));
        },
        // @method getSize(): Point
        // Returns the current size of the map container (in pixels).
        getSize: function() {
          return (!this._size || this._sizeChanged) && (this._size = new et(
            this._container.clientWidth || 0,
            this._container.clientHeight || 0
          ), this._sizeChanged = !1), this._size.clone();
        },
        // @method getPixelBounds(): Bounds
        // Returns the bounds of the current map view in projected pixel
        // coordinates (sometimes useful in layer and overlay implementations).
        getPixelBounds: function(p, y) {
          var T = this._getTopLeftPoint(p, y);
          return new Ke(T, T.add(this.getSize()));
        },
        // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
        // the map pane? "left point of the map layer" can be confusing, specially
        // since there can be negative offsets.
        // @method getPixelOrigin(): Point
        // Returns the projected pixel coordinates of the top left point of
        // the map layer (useful in custom layer and overlay implementations).
        getPixelOrigin: function() {
          return this._checkIfLoaded(), this._pixelOrigin;
        },
        // @method getPixelWorldBounds(zoom?: Number): Bounds
        // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
        // If `zoom` is omitted, the map's current zoom level is used.
        getPixelWorldBounds: function(p) {
          return this.options.crs.getProjectedBounds(p === void 0 ? this.getZoom() : p);
        },
        // @section Other Methods
        // @method getPane(pane: String|HTMLElement): HTMLElement
        // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
        getPane: function(p) {
          return typeof p == "string" ? this._panes[p] : p;
        },
        // @method getPanes(): Object
        // Returns a plain object containing the names of all [panes](#map-pane) as keys and
        // the panes as values.
        getPanes: function() {
          return this._panes;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the map.
        getContainer: function() {
          return this._container;
        },
        // @section Conversion Methods
        // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
        // Returns the scale factor to be applied to a map transition from zoom level
        // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
        getZoomScale: function(p, y) {
          var T = this.options.crs;
          return y = y === void 0 ? this._zoom : y, T.scale(p) / T.scale(y);
        },
        // @method getScaleZoom(scale: Number, fromZoom: Number): Number
        // Returns the zoom level that the map would end up at, if it is at `fromZoom`
        // level and everything is scaled by a factor of `scale`. Inverse of
        // [`getZoomScale`](#map-getZoomScale).
        getScaleZoom: function(p, y) {
          var T = this.options.crs;
          y = y === void 0 ? this._zoom : y;
          var F = T.zoom(p * T.scale(y));
          return isNaN(F) ? 1 / 0 : F;
        },
        // @method project(latlng: LatLng, zoom: Number): Point
        // Projects a geographical coordinate `LatLng` according to the projection
        // of the map's CRS, then scales it according to `zoom` and the CRS's
        // `Transformation`. The result is pixel coordinate relative to
        // the CRS origin.
        project: function(p, y) {
          return y = y === void 0 ? this._zoom : y, this.options.crs.latLngToPoint(Je(p), y);
        },
        // @method unproject(point: Point, zoom: Number): LatLng
        // Inverse of [`project`](#map-project).
        unproject: function(p, y) {
          return y = y === void 0 ? this._zoom : y, this.options.crs.pointToLatLng(De(p), y);
        },
        // @method layerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding geographical coordinate (for the current zoom level).
        layerPointToLatLng: function(p) {
          var y = De(p).add(this.getPixelOrigin());
          return this.unproject(y);
        },
        // @method latLngToLayerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the [origin pixel](#map-getpixelorigin).
        latLngToLayerPoint: function(p) {
          var y = this.project(Je(p))._round();
          return y._subtract(this.getPixelOrigin());
        },
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
        // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
        // CRS's bounds.
        // By default this means longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees.
        wrapLatLng: function(p) {
          return this.options.crs.wrapLatLng(Je(p));
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring that
        // its center is within the CRS's bounds.
        // By default this means the center longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees, and the majority of the bounds
        // overlaps the CRS's bounds.
        wrapLatLngBounds: function(p) {
          return this.options.crs.wrapLatLngBounds(rt(p));
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates according to
        // the map's CRS. By default this measures distance in meters.
        distance: function(p, y) {
          return this.options.crs.distance(Je(p), Je(y));
        },
        // @method containerPointToLayerPoint(point: Point): Point
        // Given a pixel coordinate relative to the map container, returns the corresponding
        // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
        containerPointToLayerPoint: function(p) {
          return De(p).subtract(this._getMapPanePos());
        },
        // @method layerPointToContainerPoint(point: Point): Point
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding pixel coordinate relative to the map container.
        layerPointToContainerPoint: function(p) {
          return De(p).add(this._getMapPanePos());
        },
        // @method containerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the map container, returns
        // the corresponding geographical coordinate (for the current zoom level).
        containerPointToLatLng: function(p) {
          var y = this.containerPointToLayerPoint(De(p));
          return this.layerPointToLatLng(y);
        },
        // @method latLngToContainerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the map container.
        latLngToContainerPoint: function(p) {
          return this.layerPointToContainerPoint(this.latLngToLayerPoint(Je(p)));
        },
        // @method mouseEventToContainerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to the
        // map container where the event took place.
        mouseEventToContainerPoint: function(p) {
          return Yn(p, this._container);
        },
        // @method mouseEventToLayerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to
        // the [origin pixel](#map-getpixelorigin) where the event took place.
        mouseEventToLayerPoint: function(p) {
          return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(p));
        },
        // @method mouseEventToLatLng(ev: MouseEvent): LatLng
        // Given a MouseEvent object, returns geographical coordinate where the
        // event took place.
        mouseEventToLatLng: function(p) {
          return this.layerPointToLatLng(this.mouseEventToLayerPoint(p));
        },
        // map initialization methods
        _initContainer: function(p) {
          var y = this._container = Vi(p);
          if (y) {
            if (y._leaflet_id)
              throw new Error("Map container is already initialized.");
          } else throw new Error("Map container not found.");
          Mn(y, "scroll", this._onScroll, this), this._containerId = f(y);
        },
        _initLayout: function() {
          var p = this._container;
          this._fadeAnimated = this.options.fadeAnimation && nt.any3d, jt(p, "leaflet-container" + (nt.touch ? " leaflet-touch" : "") + (nt.retina ? " leaflet-retina" : "") + (nt.ielt9 ? " leaflet-oldie" : "") + (nt.safari ? " leaflet-safari" : "") + (this._fadeAnimated ? " leaflet-fade-anim" : ""));
          var y = ao(p, "position");
          y !== "absolute" && y !== "relative" && y !== "fixed" && y !== "sticky" && (p.style.position = "relative"), this._initPanes(), this._initControlPos && this._initControlPos();
        },
        _initPanes: function() {
          var p = this._panes = {};
          this._paneRenderers = {}, this._mapPane = this.createPane("mapPane", this._container), Xn(this._mapPane, new et(0, 0)), this.createPane("tilePane"), this.createPane("overlayPane"), this.createPane("shadowPane"), this.createPane("markerPane"), this.createPane("tooltipPane"), this.createPane("popupPane"), this.options.markerZoomAnimation || (jt(p.markerPane, "leaflet-zoom-hide"), jt(p.shadowPane, "leaflet-zoom-hide"));
        },
        // private methods that modify map state
        // @section Map state change events
        _resetView: function(p, y, T) {
          Xn(this._mapPane, new et(0, 0));
          var F = !this._loaded;
          this._loaded = !0, y = this._limitZoom(y), this.fire("viewprereset");
          var j = this._zoom !== y;
          this._moveStart(j, T)._move(p, y)._moveEnd(j), this.fire("viewreset"), F && this.fire("load");
        },
        _moveStart: function(p, y) {
          return p && this.fire("zoomstart"), y || this.fire("movestart"), this;
        },
        _move: function(p, y, T, F) {
          y === void 0 && (y = this._zoom);
          var j = this._zoom !== y;
          return this._zoom = y, this._lastCenter = p, this._pixelOrigin = this._getNewPixelOrigin(p), F ? T && T.pinch && this.fire("zoom", T) : ((j || T && T.pinch) && this.fire("zoom", T), this.fire("move", T)), this;
        },
        _moveEnd: function(p) {
          return p && this.fire("zoomend"), this.fire("moveend");
        },
        _stop: function() {
          return re(this._flyToFrame), this._panAnim && this._panAnim.stop(), this;
        },
        _rawPanBy: function(p) {
          Xn(this._mapPane, this._getMapPanePos().subtract(p));
        },
        _getZoomSpan: function() {
          return this.getMaxZoom() - this.getMinZoom();
        },
        _panInsideMaxBounds: function() {
          this._enforcingBounds || this.panInsideBounds(this.options.maxBounds);
        },
        _checkIfLoaded: function() {
          if (!this._loaded)
            throw new Error("Set map center and zoom first.");
        },
        // DOM event handling
        // @section Interaction events
        _initEvents: function(p) {
          this._targets = {}, this._targets[f(this._container)] = this;
          var y = p ? li : Mn;
          y(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this), this.options.trackResize && y(window, "resize", this._onResize, this), nt.any3d && this.options.transform3DLimit && (p ? this.off : this.on).call(this, "moveend", this._onMoveEnd);
        },
        _onResize: function() {
          re(this._resizeRequest), this._resizeRequest = ve(
            function() {
              this.invalidateSize({ debounceMoveend: !0 });
            },
            this
          );
        },
        _onScroll: function() {
          this._container.scrollTop = 0, this._container.scrollLeft = 0;
        },
        _onMoveEnd: function() {
          var p = this._getMapPanePos();
          Math.max(Math.abs(p.x), Math.abs(p.y)) >= this.options.transform3DLimit && this._resetView(this.getCenter(), this.getZoom());
        },
        _findEventTargets: function(p, y) {
          for (var T = [], F, j = y === "mouseout" || y === "mouseover", ge = p.target || p.srcElement, xe = !1; ge; ) {
            if (F = this._targets[f(ge)], F && (y === "click" || y === "preclick") && this._draggableMoved(F)) {
              xe = !0;
              break;
            }
            if (F && F.listens(y, !0) && (j && !Zc(ge, p) || (T.push(F), j)) || ge === this._container)
              break;
            ge = ge.parentNode;
          }
          return !T.length && !xe && !j && this.listens(y, !0) && (T = [this]), T;
        },
        _isClickDisabled: function(p) {
          for (; p && p !== this._container; ) {
            if (p._leaflet_disable_click)
              return !0;
            p = p.parentNode;
          }
        },
        _handleDOMEvent: function(p) {
          var y = p.target || p.srcElement;
          if (!(!this._loaded || y._leaflet_disable_events || p.type === "click" && this._isClickDisabled(y))) {
            var T = p.type;
            T === "mousedown" && cl(y), this._fireDOMEvent(p, T);
          }
        },
        _mouseEvents: ["click", "dblclick", "mouseover", "mouseout", "contextmenu"],
        _fireDOMEvent: function(p, y, T) {
          if (p.type === "click") {
            var F = r({}, p);
            F.type = "preclick", this._fireDOMEvent(F, F.type, T);
          }
          var j = this._findEventTargets(p, y);
          if (T) {
            for (var ge = [], xe = 0; xe < T.length; xe++)
              T[xe].listens(y, !0) && ge.push(T[xe]);
            j = ge.concat(j);
          }
          if (j.length) {
            y === "contextmenu" && lr(p);
            var Ve = j[0], pt = {
              originalEvent: p
            };
            if (p.type !== "keypress" && p.type !== "keydown" && p.type !== "keyup") {
              var $t = Ve.getLatLng && (!Ve._radius || Ve._radius <= 10);
              pt.containerPoint = $t ? this.latLngToContainerPoint(Ve.getLatLng()) : this.mouseEventToContainerPoint(p), pt.layerPoint = this.containerPointToLayerPoint(pt.containerPoint), pt.latlng = $t ? Ve.getLatLng() : this.layerPointToLatLng(pt.layerPoint);
            }
            for (xe = 0; xe < j.length; xe++)
              if (j[xe].fire(y, pt, !0), pt.originalEvent._stopped || j[xe].options.bubblingMouseEvents === !1 && q(this._mouseEvents, y) !== -1)
                return;
          }
        },
        _draggableMoved: function(p) {
          return p = p.dragging && p.dragging.enabled() ? p : this, p.dragging && p.dragging.moved() || this.boxZoom && this.boxZoom.moved();
        },
        _clearHandlers: function() {
          for (var p = 0, y = this._handlers.length; p < y; p++)
            this._handlers[p].disable();
        },
        // @section Other Methods
        // @method whenReady(fn: Function, context?: Object): this
        // Runs the given function `fn` when the map gets initialized with
        // a view (center and zoom) and at least one layer, or immediately
        // if it's already initialized, optionally passing a function context.
        whenReady: function(p, y) {
          return this._loaded ? p.call(y || this, { target: this }) : this.on("load", p, y), this;
        },
        // private methods for getting map state
        _getMapPanePos: function() {
          return ya(this._mapPane) || new et(0, 0);
        },
        _moved: function() {
          var p = this._getMapPanePos();
          return p && !p.equals([0, 0]);
        },
        _getTopLeftPoint: function(p, y) {
          var T = p && y !== void 0 ? this._getNewPixelOrigin(p, y) : this.getPixelOrigin();
          return T.subtract(this._getMapPanePos());
        },
        _getNewPixelOrigin: function(p, y) {
          var T = this.getSize()._divideBy(2);
          return this.project(p, y)._subtract(T)._add(this._getMapPanePos())._round();
        },
        _latLngToNewLayerPoint: function(p, y, T) {
          var F = this._getNewPixelOrigin(T, y);
          return this.project(p, y)._subtract(F);
        },
        _latLngBoundsToNewLayerBounds: function(p, y, T) {
          var F = this._getNewPixelOrigin(T, y);
          return gt([
            this.project(p.getSouthWest(), y)._subtract(F),
            this.project(p.getNorthWest(), y)._subtract(F),
            this.project(p.getSouthEast(), y)._subtract(F),
            this.project(p.getNorthEast(), y)._subtract(F)
          ]);
        },
        // layer point of the current center
        _getCenterLayerPoint: function() {
          return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
        },
        // offset of the specified place to the current center in pixels
        _getCenterOffset: function(p) {
          return this.latLngToLayerPoint(p).subtract(this._getCenterLayerPoint());
        },
        // adjust center for view to get inside bounds
        _limitCenter: function(p, y, T) {
          if (!T)
            return p;
          var F = this.project(p, y), j = this.getSize().divideBy(2), ge = new Ke(F.subtract(j), F.add(j)), xe = this._getBoundsOffset(ge, T, y);
          return Math.abs(xe.x) <= 1 && Math.abs(xe.y) <= 1 ? p : this.unproject(F.add(xe), y);
        },
        // adjust offset for view to get inside bounds
        _limitOffset: function(p, y) {
          if (!y)
            return p;
          var T = this.getPixelBounds(), F = new Ke(T.min.add(p), T.max.add(p));
          return p.add(this._getBoundsOffset(F, y));
        },
        // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
        _getBoundsOffset: function(p, y, T) {
          var F = gt(
            this.project(y.getNorthEast(), T),
            this.project(y.getSouthWest(), T)
          ), j = F.min.subtract(p.min), ge = F.max.subtract(p.max), xe = this._rebound(j.x, -ge.x), Ve = this._rebound(j.y, -ge.y);
          return new et(xe, Ve);
        },
        _rebound: function(p, y) {
          return p + y > 0 ? Math.round(p - y) / 2 : Math.max(0, Math.ceil(p)) - Math.max(0, Math.floor(y));
        },
        _limitZoom: function(p) {
          var y = this.getMinZoom(), T = this.getMaxZoom(), F = nt.any3d ? this.options.zoomSnap : 1;
          return F && (p = Math.round(p / F) * F), Math.max(y, Math.min(T, p));
        },
        _onPanTransitionStep: function() {
          this.fire("move");
        },
        _onPanTransitionEnd: function() {
          hi(this._mapPane, "leaflet-pan-anim"), this.fire("moveend");
        },
        _tryAnimatedPan: function(p, y) {
          var T = this._getCenterOffset(p)._trunc();
          return (y && y.animate) !== !0 && !this.getSize().contains(T) ? !1 : (this.panBy(T, y), !0);
        },
        _createAnimProxy: function() {
          var p = this._proxy = Ln("div", "leaflet-proxy leaflet-zoom-animated");
          this._panes.mapPane.appendChild(p), this.on("zoomanim", function(y) {
            var T = Bi, F = this._proxy.style[T];
            ti(this._proxy, this.project(y.center, y.zoom), this.getZoomScale(y.zoom, 1)), F === this._proxy.style[T] && this._animatingZoom && this._onZoomTransitionEnd();
          }, this), this.on("load moveend", this._animMoveEnd, this), this._on("unload", this._destroyAnimProxy, this);
        },
        _destroyAnimProxy: function() {
          xi(this._proxy), this.off("load moveend", this._animMoveEnd, this), delete this._proxy;
        },
        _animMoveEnd: function() {
          var p = this.getCenter(), y = this.getZoom();
          ti(this._proxy, this.project(p, y), this.getZoomScale(y, 1));
        },
        _catchTransitionEnd: function(p) {
          this._animatingZoom && p.propertyName.indexOf("transform") >= 0 && this._onZoomTransitionEnd();
        },
        _nothingToAnimate: function() {
          return !this._container.getElementsByClassName("leaflet-zoom-animated").length;
        },
        _tryAnimatedZoom: function(p, y, T) {
          if (this._animatingZoom)
            return !0;
          if (T = T || {}, !this._zoomAnimated || T.animate === !1 || this._nothingToAnimate() || Math.abs(y - this._zoom) > this.options.zoomAnimationThreshold)
            return !1;
          var F = this.getZoomScale(y), j = this._getCenterOffset(p)._divideBy(1 - 1 / F);
          return T.animate !== !0 && !this.getSize().contains(j) ? !1 : (ve(function() {
            this._moveStart(!0, T.noMoveStart || !1)._animateZoom(p, y, !0);
          }, this), !0);
        },
        _animateZoom: function(p, y, T, F) {
          this._mapPane && (T && (this._animatingZoom = !0, this._animateToCenter = p, this._animateToZoom = y, jt(this._mapPane, "leaflet-zoom-anim")), this.fire("zoomanim", {
            center: p,
            zoom: y,
            noUpdate: F
          }), this._tempFireZoomEvent || (this._tempFireZoomEvent = this._zoom !== this._animateToZoom), this._move(this._animateToCenter, this._animateToZoom, void 0, !0), setTimeout(d(this._onZoomTransitionEnd, this), 250));
        },
        _onZoomTransitionEnd: function() {
          this._animatingZoom && (this._mapPane && hi(this._mapPane, "leaflet-zoom-anim"), this._animatingZoom = !1, this._move(this._animateToCenter, this._animateToZoom, void 0, !0), this._tempFireZoomEvent && this.fire("zoom"), delete this._tempFireZoomEvent, this.fire("move"), this._moveEnd(!0));
        }
      });
      function rf(p, y) {
        return new Jn(p, y);
      }
      var qs = pe.extend({
        // @section
        // @aka Control Options
        options: {
          // @option position: String = 'topright'
          // The position of the control (one of the map corners). Possible values are `'topleft'`,
          // `'topright'`, `'bottomleft'` or `'bottomright'`
          position: "topright"
        },
        initialize: function(p) {
          B(this, p);
        },
        /* @section
         * Classes extending L.Control will inherit the following methods:
         *
         * @method getPosition: string
         * Returns the position of the control.
         */
        getPosition: function() {
          return this.options.position;
        },
        // @method setPosition(position: string): this
        // Sets the position of the control.
        setPosition: function(p) {
          var y = this._map;
          return y && y.removeControl(this), this.options.position = p, y && y.addControl(this), this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTMLElement that contains the control.
        getContainer: function() {
          return this._container;
        },
        // @method addTo(map: Map): this
        // Adds the control to the given map.
        addTo: function(p) {
          this.remove(), this._map = p;
          var y = this._container = this.onAdd(p), T = this.getPosition(), F = p._controlCorners[T];
          return jt(y, "leaflet-control"), T.indexOf("bottom") !== -1 ? F.insertBefore(y, F.firstChild) : F.appendChild(y), this._map.on("unload", this.remove, this), this;
        },
        // @method remove: this
        // Removes the control from the map it is currently active on.
        remove: function() {
          return this._map ? (xi(this._container), this.onRemove && this.onRemove(this._map), this._map.off("unload", this.remove, this), this._map = null, this) : this;
        },
        _refocusOnMap: function(p) {
          this._map && p && p.screenX > 0 && p.screenY > 0 && this._map.getContainer().focus();
        }
      }), ec = function(p) {
        return new qs(p);
      };
      Jn.include({
        // @method addControl(control: Control): this
        // Adds the given control to the map
        addControl: function(p) {
          return p.addTo(this), this;
        },
        // @method removeControl(control: Control): this
        // Removes the given control from the map
        removeControl: function(p) {
          return p.remove(), this;
        },
        _initControlPos: function() {
          var p = this._controlCorners = {}, y = "leaflet-", T = this._controlContainer = Ln("div", y + "control-container", this._container);
          function F(j, ge) {
            var xe = y + j + " " + y + ge;
            p[j + ge] = Ln("div", xe, T);
          }
          F("top", "left"), F("top", "right"), F("bottom", "left"), F("bottom", "right");
        },
        _clearControlPos: function() {
          for (var p in this._controlCorners)
            xi(this._controlCorners[p]);
          xi(this._controlContainer), delete this._controlCorners, delete this._controlContainer;
        }
      });
      var Kd = qs.extend({
        // @section
        // @aka Control.Layers options
        options: {
          // @option collapsed: Boolean = true
          // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
          collapsed: !0,
          position: "topright",
          // @option autoZIndex: Boolean = true
          // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
          autoZIndex: !0,
          // @option hideSingleBase: Boolean = false
          // If `true`, the base layers in the control will be hidden when there is only one.
          hideSingleBase: !1,
          // @option sortLayers: Boolean = false
          // Whether to sort the layers. When `false`, layers will keep the order
          // in which they were added to the control.
          sortLayers: !1,
          // @option sortFunction: Function = *
          // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
          // that will be used for sorting the layers, when `sortLayers` is `true`.
          // The function receives both the `L.Layer` instances and their names, as in
          // `sortFunction(layerA, layerB, nameA, nameB)`.
          // By default, it sorts layers alphabetically by their name.
          sortFunction: function(p, y, T, F) {
            return T < F ? -1 : F < T ? 1 : 0;
          }
        },
        initialize: function(p, y, T) {
          B(this, T), this._layerControlInputs = [], this._layers = [], this._lastZIndex = 0, this._handlingClick = !1, this._preventClick = !1;
          for (var F in p)
            this._addLayer(p[F], F);
          for (F in y)
            this._addLayer(y[F], F, !0);
        },
        onAdd: function(p) {
          this._initLayout(), this._update(), this._map = p, p.on("zoomend", this._checkDisabledLayers, this);
          for (var y = 0; y < this._layers.length; y++)
            this._layers[y].layer.on("add remove", this._onLayerChange, this);
          return this._container;
        },
        addTo: function(p) {
          return qs.prototype.addTo.call(this, p), this._expandIfNotCollapsed();
        },
        onRemove: function() {
          this._map.off("zoomend", this._checkDisabledLayers, this);
          for (var p = 0; p < this._layers.length; p++)
            this._layers[p].layer.off("add remove", this._onLayerChange, this);
        },
        // @method addBaseLayer(layer: Layer, name: String): this
        // Adds a base layer (radio button entry) with the given name to the control.
        addBaseLayer: function(p, y) {
          return this._addLayer(p, y), this._map ? this._update() : this;
        },
        // @method addOverlay(layer: Layer, name: String): this
        // Adds an overlay (checkbox entry) with the given name to the control.
        addOverlay: function(p, y) {
          return this._addLayer(p, y, !0), this._map ? this._update() : this;
        },
        // @method removeLayer(layer: Layer): this
        // Remove the given layer from the control.
        removeLayer: function(p) {
          p.off("add remove", this._onLayerChange, this);
          var y = this._getLayer(f(p));
          return y && this._layers.splice(this._layers.indexOf(y), 1), this._map ? this._update() : this;
        },
        // @method expand(): this
        // Expand the control container if collapsed.
        expand: function() {
          jt(this._container, "leaflet-control-layers-expanded"), this._section.style.height = null;
          var p = this._map.getSize().y - (this._container.offsetTop + 50);
          return p < this._section.clientHeight ? (jt(this._section, "leaflet-control-layers-scrollbar"), this._section.style.height = p + "px") : hi(this._section, "leaflet-control-layers-scrollbar"), this._checkDisabledLayers(), this;
        },
        // @method collapse(): this
        // Collapse the control container if expanded.
        collapse: function() {
          return hi(this._container, "leaflet-control-layers-expanded"), this;
        },
        _initLayout: function() {
          var p = "leaflet-control-layers", y = this._container = Ln("div", p), T = this.options.collapsed;
          y.setAttribute("aria-haspopup", !0), Ho(y), pl(y);
          var F = this._section = Ln("section", p + "-list");
          T && (this._map.on("click", this.collapse, this), Mn(y, {
            mouseenter: this._expandSafely,
            mouseleave: this.collapse
          }, this));
          var j = this._layersLink = Ln("a", p + "-toggle", y);
          j.href = "#", j.title = "Layers", j.setAttribute("role", "button"), Mn(j, {
            keydown: function(ge) {
              ge.keyCode === 13 && this._expandSafely();
            },
            // Certain screen readers intercept the key event and instead send a click event
            click: function(ge) {
              lr(ge), this._expandSafely();
            }
          }, this), T || this.expand(), this._baseLayersList = Ln("div", p + "-base", F), this._separator = Ln("div", p + "-separator", F), this._overlaysList = Ln("div", p + "-overlays", F), y.appendChild(F);
        },
        _getLayer: function(p) {
          for (var y = 0; y < this._layers.length; y++)
            if (this._layers[y] && f(this._layers[y].layer) === p)
              return this._layers[y];
        },
        _addLayer: function(p, y, T) {
          this._map && p.on("add remove", this._onLayerChange, this), this._layers.push({
            layer: p,
            name: y,
            overlay: T
          }), this.options.sortLayers && this._layers.sort(d(function(F, j) {
            return this.options.sortFunction(F.layer, j.layer, F.name, j.name);
          }, this)), this.options.autoZIndex && p.setZIndex && (this._lastZIndex++, p.setZIndex(this._lastZIndex)), this._expandIfNotCollapsed();
        },
        _update: function() {
          if (!this._container)
            return this;
          Ki(this._baseLayersList), Ki(this._overlaysList), this._layerControlInputs = [];
          var p, y, T, F, j = 0;
          for (T = 0; T < this._layers.length; T++)
            F = this._layers[T], this._addItem(F), y = y || F.overlay, p = p || !F.overlay, j += F.overlay ? 0 : 1;
          return this.options.hideSingleBase && (p = p && j > 1, this._baseLayersList.style.display = p ? "" : "none"), this._separator.style.display = y && p ? "" : "none", this;
        },
        _onLayerChange: function(p) {
          this._handlingClick || this._update();
          var y = this._getLayer(f(p.target)), T = y.overlay ? p.type === "add" ? "overlayadd" : "overlayremove" : p.type === "add" ? "baselayerchange" : null;
          T && this._map.fire(T, y);
        },
        // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
        _createRadioElement: function(p, y) {
          var T = '<input type="radio" class="leaflet-control-layers-selector" name="' + p + '"' + (y ? ' checked="checked"' : "") + "/>", F = document.createElement("div");
          return F.innerHTML = T, F.firstChild;
        },
        _addItem: function(p) {
          var y = document.createElement("label"), T = this._map.hasLayer(p.layer), F;
          p.overlay ? (F = document.createElement("input"), F.type = "checkbox", F.className = "leaflet-control-layers-selector", F.defaultChecked = T) : F = this._createRadioElement("leaflet-base-layers_" + f(this), T), this._layerControlInputs.push(F), F.layerId = f(p.layer), Mn(F, "click", this._onInputClick, this);
          var j = document.createElement("span");
          j.innerHTML = " " + p.name;
          var ge = document.createElement("span");
          y.appendChild(ge), ge.appendChild(F), ge.appendChild(j);
          var xe = p.overlay ? this._overlaysList : this._baseLayersList;
          return xe.appendChild(y), this._checkDisabledLayers(), y;
        },
        _onInputClick: function() {
          if (!this._preventClick) {
            var p = this._layerControlInputs, y, T, F = [], j = [];
            this._handlingClick = !0;
            for (var ge = p.length - 1; ge >= 0; ge--)
              y = p[ge], T = this._getLayer(y.layerId).layer, y.checked ? F.push(T) : y.checked || j.push(T);
            for (ge = 0; ge < j.length; ge++)
              this._map.hasLayer(j[ge]) && this._map.removeLayer(j[ge]);
            for (ge = 0; ge < F.length; ge++)
              this._map.hasLayer(F[ge]) || this._map.addLayer(F[ge]);
            this._handlingClick = !1, this._refocusOnMap();
          }
        },
        _checkDisabledLayers: function() {
          for (var p = this._layerControlInputs, y, T, F = this._map.getZoom(), j = p.length - 1; j >= 0; j--)
            y = p[j], T = this._getLayer(y.layerId).layer, y.disabled = T.options.minZoom !== void 0 && F < T.options.minZoom || T.options.maxZoom !== void 0 && F > T.options.maxZoom;
        },
        _expandIfNotCollapsed: function() {
          return this._map && !this.options.collapsed && this.expand(), this;
        },
        _expandSafely: function() {
          var p = this._section;
          this._preventClick = !0, Mn(p, "click", lr), this.expand();
          var y = this;
          setTimeout(function() {
            li(p, "click", lr), y._preventClick = !1;
          });
        }
      }), sf = function(p, y, T) {
        return new Kd(p, y, T);
      }, tc = qs.extend({
        // @section
        // @aka Control.Zoom options
        options: {
          position: "topleft",
          // @option zoomInText: String = '<span aria-hidden="true">+</span>'
          // The text set on the 'zoom in' button.
          zoomInText: '<span aria-hidden="true">+</span>',
          // @option zoomInTitle: String = 'Zoom in'
          // The title set on the 'zoom in' button.
          zoomInTitle: "Zoom in",
          // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
          // The text set on the 'zoom out' button.
          zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
          // @option zoomOutTitle: String = 'Zoom out'
          // The title set on the 'zoom out' button.
          zoomOutTitle: "Zoom out"
        },
        onAdd: function(p) {
          var y = "leaflet-control-zoom", T = Ln("div", y + " leaflet-bar"), F = this.options;
          return this._zoomInButton = this._createButton(
            F.zoomInText,
            F.zoomInTitle,
            y + "-in",
            T,
            this._zoomIn
          ), this._zoomOutButton = this._createButton(
            F.zoomOutText,
            F.zoomOutTitle,
            y + "-out",
            T,
            this._zoomOut
          ), this._updateDisabled(), p.on("zoomend zoomlevelschange", this._updateDisabled, this), T;
        },
        onRemove: function(p) {
          p.off("zoomend zoomlevelschange", this._updateDisabled, this);
        },
        disable: function() {
          return this._disabled = !0, this._updateDisabled(), this;
        },
        enable: function() {
          return this._disabled = !1, this._updateDisabled(), this;
        },
        _zoomIn: function(p) {
          !this._disabled && this._map._zoom < this._map.getMaxZoom() && this._map.zoomIn(this._map.options.zoomDelta * (p.shiftKey ? 3 : 1));
        },
        _zoomOut: function(p) {
          !this._disabled && this._map._zoom > this._map.getMinZoom() && this._map.zoomOut(this._map.options.zoomDelta * (p.shiftKey ? 3 : 1));
        },
        _createButton: function(p, y, T, F, j) {
          var ge = Ln("a", T, F);
          return ge.innerHTML = p, ge.href = "#", ge.title = y, ge.setAttribute("role", "button"), ge.setAttribute("aria-label", y), Ho(ge), Mn(ge, "click", Zs), Mn(ge, "click", j, this), Mn(ge, "click", this._refocusOnMap, this), ge;
        },
        _updateDisabled: function() {
          var p = this._map, y = "leaflet-disabled";
          hi(this._zoomInButton, y), hi(this._zoomOutButton, y), this._zoomInButton.setAttribute("aria-disabled", "false"), this._zoomOutButton.setAttribute("aria-disabled", "false"), (this._disabled || p._zoom === p.getMinZoom()) && (jt(this._zoomOutButton, y), this._zoomOutButton.setAttribute("aria-disabled", "true")), (this._disabled || p._zoom === p.getMaxZoom()) && (jt(this._zoomInButton, y), this._zoomInButton.setAttribute("aria-disabled", "true"));
        }
      });
      Jn.mergeOptions({
        zoomControl: !0
      }), Jn.addInitHook(function() {
        this.options.zoomControl && (this.zoomControl = new tc(), this.addControl(this.zoomControl));
      });
      var qc = function(p) {
        return new tc(p);
      }, jc = qs.extend({
        // @section
        // @aka Control.Scale options
        options: {
          position: "bottomleft",
          // @option maxWidth: Number = 100
          // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
          maxWidth: 100,
          // @option metric: Boolean = True
          // Whether to show the metric scale line (m/km).
          metric: !0,
          // @option imperial: Boolean = True
          // Whether to show the imperial scale line (mi/ft).
          imperial: !0
          // @option updateWhenIdle: Boolean = false
          // If `true`, the control is updated on [`moveend`](#map-moveend), otherwise it's always up-to-date (updated on [`move`](#map-move)).
        },
        onAdd: function(p) {
          var y = "leaflet-control-scale", T = Ln("div", y), F = this.options;
          return this._addScales(F, y + "-line", T), p.on(F.updateWhenIdle ? "moveend" : "move", this._update, this), p.whenReady(this._update, this), T;
        },
        onRemove: function(p) {
          p.off(this.options.updateWhenIdle ? "moveend" : "move", this._update, this);
        },
        _addScales: function(p, y, T) {
          p.metric && (this._mScale = Ln("div", y, T)), p.imperial && (this._iScale = Ln("div", y, T));
        },
        _update: function() {
          var p = this._map, y = p.getSize().y / 2, T = p.distance(
            p.containerPointToLatLng([0, y]),
            p.containerPointToLatLng([this.options.maxWidth, y])
          );
          this._updateScales(T);
        },
        _updateScales: function(p) {
          this.options.metric && p && this._updateMetric(p), this.options.imperial && p && this._updateImperial(p);
        },
        _updateMetric: function(p) {
          var y = this._getRoundNum(p), T = y < 1e3 ? y + " m" : y / 1e3 + " km";
          this._updateScale(this._mScale, T, y / p);
        },
        _updateImperial: function(p) {
          var y = p * 3.2808399, T, F, j;
          y > 5280 ? (T = y / 5280, F = this._getRoundNum(T), this._updateScale(this._iScale, F + " mi", F / T)) : (j = this._getRoundNum(y), this._updateScale(this._iScale, j + " ft", j / y));
        },
        _updateScale: function(p, y, T) {
          p.style.width = Math.round(this.options.maxWidth * T) + "px", p.innerHTML = y;
        },
        _getRoundNum: function(p) {
          var y = Math.pow(10, (Math.floor(p) + "").length - 1), T = p / y;
          return T = T >= 10 ? 10 : T >= 5 ? 5 : T >= 3 ? 3 : T >= 2 ? 2 : 1, y * T;
        }
      }), Zu = function(p) {
        return new jc(p);
      }, hl = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>', Gc = qs.extend({
        // @section
        // @aka Control.Attribution options
        options: {
          position: "bottomright",
          // @option prefix: String|false = 'Leaflet'
          // The HTML text shown before the attributions. Pass `false` to disable.
          prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (nt.inlineSvg ? hl + " " : "") + "Leaflet</a>"
        },
        initialize: function(p) {
          B(this, p), this._attributions = {};
        },
        onAdd: function(p) {
          p.attributionControl = this, this._container = Ln("div", "leaflet-control-attribution"), Ho(this._container);
          for (var y in p._layers)
            p._layers[y].getAttribution && this.addAttribution(p._layers[y].getAttribution());
          return this._update(), p.on("layeradd", this._addAttribution, this), this._container;
        },
        onRemove: function(p) {
          p.off("layeradd", this._addAttribution, this);
        },
        _addAttribution: function(p) {
          p.layer.getAttribution && (this.addAttribution(p.layer.getAttribution()), p.layer.once("remove", function() {
            this.removeAttribution(p.layer.getAttribution());
          }, this));
        },
        // @method setPrefix(prefix: String|false): this
        // The HTML text shown before the attributions. Pass `false` to disable.
        setPrefix: function(p) {
          return this.options.prefix = p, this._update(), this;
        },
        // @method addAttribution(text: String): this
        // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
        addAttribution: function(p) {
          return p ? (this._attributions[p] || (this._attributions[p] = 0), this._attributions[p]++, this._update(), this) : this;
        },
        // @method removeAttribution(text: String): this
        // Removes an attribution text.
        removeAttribution: function(p) {
          return p ? (this._attributions[p] && (this._attributions[p]--, this._update()), this) : this;
        },
        _update: function() {
          if (this._map) {
            var p = [];
            for (var y in this._attributions)
              this._attributions[y] && p.push(y);
            var T = [];
            this.options.prefix && T.push(this.options.prefix), p.length && T.push(p.join(", ")), this._container.innerHTML = T.join(' <span aria-hidden="true">|</span> ');
          }
        }
      });
      Jn.mergeOptions({
        attributionControl: !0
      }), Jn.addInitHook(function() {
        this.options.attributionControl && new Gc().addTo(this);
      });
      var Xd = function(p) {
        return new Gc(p);
      };
      qs.Layers = Kd, qs.Zoom = tc, qs.Scale = jc, qs.Attribution = Gc, ec.layers = sf, ec.zoom = qc, ec.scale = Zu, ec.attribution = Xd;
      var Ms = pe.extend({
        initialize: function(p) {
          this._map = p;
        },
        // @method enable(): this
        // Enables the handler
        enable: function() {
          return this._enabled ? this : (this._enabled = !0, this.addHooks(), this);
        },
        // @method disable(): this
        // Disables the handler
        disable: function() {
          return this._enabled ? (this._enabled = !1, this.removeHooks(), this) : this;
        },
        // @method enabled(): Boolean
        // Returns `true` if the handler is enabled
        enabled: function() {
          return !!this._enabled;
        }
        // @section Extension methods
        // Classes inheriting from `Handler` must implement the two following methods:
        // @method addHooks()
        // Called when the handler is enabled, should add event hooks.
        // @method removeHooks()
        // Called when the handler is disabled, should remove the event hooks added previously.
      });
      Ms.addTo = function(p, y) {
        return p.addHandler(y, this), this;
      };
      var $a = { Events: We }, qu = nt.touch ? "touchstart mousedown" : "mousedown", gs = Ge.extend({
        options: {
          // @section
          // @aka Draggable options
          // @option clickTolerance: Number = 3
          // The max number of pixels a user can shift the mouse pointer during a click
          // for it to be considered a valid click (as opposed to a mouse drag).
          clickTolerance: 3
        },
        // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
        // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
        initialize: function(p, y, T, F) {
          B(this, F), this._element = p, this._dragStartTarget = y || p, this._preventOutline = T;
        },
        // @method enable()
        // Enables the dragging ability
        enable: function() {
          this._enabled || (Mn(this._dragStartTarget, qu, this._onDown, this), this._enabled = !0);
        },
        // @method disable()
        // Disables the dragging ability
        disable: function() {
          this._enabled && (gs._dragging === this && this.finishDrag(!0), li(this._dragStartTarget, qu, this._onDown, this), this._enabled = !1, this._moved = !1);
        },
        _onDown: function(p) {
          if (this._enabled && (this._moved = !1, !Ps(this._element, "leaflet-zoom-anim"))) {
            if (p.touches && p.touches.length !== 1) {
              gs._dragging === this && this.finishDrag();
              return;
            }
            if (!(gs._dragging || p.shiftKey || p.which !== 1 && p.button !== 1 && !p.touches) && (gs._dragging = this, this._preventOutline && cl(this._element), Kl(), ll(), !this._moving)) {
              this.fire("down");
              var y = p.touches ? p.touches[0] : p, T = Jl(this._element);
              this._startPoint = new et(y.clientX, y.clientY), this._startPos = ya(this._element), this._parentScale = ba(T);
              var F = p.type === "mousedown";
              Mn(document, F ? "mousemove" : "touchmove", this._onMove, this), Mn(document, F ? "mouseup" : "touchend touchcancel", this._onUp, this);
            }
          }
        },
        _onMove: function(p) {
          if (this._enabled) {
            if (p.touches && p.touches.length > 1) {
              this._moved = !0;
              return;
            }
            var y = p.touches && p.touches.length === 1 ? p.touches[0] : p, T = new et(y.clientX, y.clientY)._subtract(this._startPoint);
            !T.x && !T.y || Math.abs(T.x) + Math.abs(T.y) < this.options.clickTolerance || (T.x /= this._parentScale.x, T.y /= this._parentScale.y, lr(p), this._moved || (this.fire("dragstart"), this._moved = !0, jt(document.body, "leaflet-dragging"), this._lastTarget = p.target || p.srcElement, window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance && (this._lastTarget = this._lastTarget.correspondingUseElement), jt(this._lastTarget, "leaflet-drag-target")), this._newPos = this._startPos.add(T), this._moving = !0, this._lastEvent = p, this._updatePosition());
          }
        },
        _updatePosition: function() {
          var p = { originalEvent: this._lastEvent };
          this.fire("predrag", p), Xn(this._element, this._newPos), this.fire("drag", p);
        },
        _onUp: function() {
          this._enabled && this.finishDrag();
        },
        finishDrag: function(p) {
          hi(document.body, "leaflet-dragging"), this._lastTarget && (hi(this._lastTarget, "leaflet-drag-target"), this._lastTarget = null), li(document, "mousemove touchmove", this._onMove, this), li(document, "mouseup touchend touchcancel", this._onUp, this), Wc(), Gl();
          var y = this._moved && this._moving;
          this._moving = !1, gs._dragging = !1, y && this.fire("dragend", {
            noInertia: p,
            distance: this._newPos.distanceTo(this._startPos)
          });
        }
      });
      function Ca(p, y, T) {
        var F, j = [1, 4, 2, 8], ge, xe, Ve, pt, $t, Jt, pn, Hn;
        for (ge = 0, Jt = p.length; ge < Jt; ge++)
          p[ge]._code = lo(p[ge], y);
        for (Ve = 0; Ve < 4; Ve++) {
          for (pn = j[Ve], F = [], ge = 0, Jt = p.length, xe = Jt - 1; ge < Jt; xe = ge++)
            pt = p[ge], $t = p[xe], pt._code & pn ? $t._code & pn || (Hn = fl($t, pt, pn, y, T), Hn._code = lo(Hn, y), F.push(Hn)) : ($t._code & pn && (Hn = fl($t, pt, pn, y, T), Hn._code = lo(Hn, y), F.push(Hn)), F.push(pt));
          p = F;
        }
        return p;
      }
      function ju(p, y) {
        var T, F, j, ge, xe, Ve, pt, $t, Jt;
        if (!p || p.length === 0)
          throw new Error("latlngs not passed");
        kn(p) || (console.warn("latlngs are not flat! Only the first ring will be used"), p = p[0]);
        var pn = Je([0, 0]), Hn = rt(p), Hi = Hn.getNorthWest().distanceTo(Hn.getSouthWest()) * Hn.getNorthEast().distanceTo(Hn.getNorthWest());
        Hi < 1700 && (pn = nc(p));
        var fr = p.length, ir = [];
        for (T = 0; T < fr; T++) {
          var Kn = Je(p[T]);
          ir.push(y.project(Je([Kn.lat - pn.lat, Kn.lng - pn.lng])));
        }
        for (Ve = pt = $t = 0, T = 0, F = fr - 1; T < fr; F = T++)
          j = ir[T], ge = ir[F], xe = j.y * ge.x - ge.y * j.x, pt += (j.x + ge.x) * xe, $t += (j.y + ge.y) * xe, Ve += xe * 3;
        Ve === 0 ? Jt = ir[0] : Jt = [pt / Ve, $t / Ve];
        var Ri = y.unproject(De(Jt));
        return Je([Ri.lat + pn.lat, Ri.lng + pn.lng]);
      }
      function nc(p) {
        for (var y = 0, T = 0, F = 0, j = 0; j < p.length; j++) {
          var ge = Je(p[j]);
          y += ge.lat, T += ge.lng, F++;
        }
        return Je([y / F, T / F]);
      }
      var ci = {
        __proto__: null,
        clipPolygon: Ca,
        polygonCenter: ju,
        centroid: nc
      };
      function ic(p, y) {
        if (!y || !p.length)
          return p.slice();
        var T = y * y;
        return p = Yu(p, T), p = rc(p, T), p;
      }
      function Jd(p, y, T) {
        return Math.sqrt(ka(p, y, T, !0));
      }
      function Qd(p, y, T) {
        return ka(p, y, T);
      }
      function rc(p, y) {
        var T = p.length, F = typeof Uint8Array < "u" ? Uint8Array : Array, j = new F(T);
        j[0] = j[T - 1] = 1, Gu(p, j, y, 0, T - 1);
        var ge, xe = [];
        for (ge = 0; ge < T; ge++)
          j[ge] && xe.push(p[ge]);
        return xe;
      }
      function Gu(p, y, T, F, j) {
        var ge = 0, xe, Ve, pt;
        for (Ve = F + 1; Ve <= j - 1; Ve++)
          pt = ka(p[Ve], p[F], p[j], !0), pt > ge && (xe = Ve, ge = pt);
        ge > T && (y[xe] = 1, Gu(p, y, T, F, xe), Gu(p, y, T, xe, j));
      }
      function Yu(p, y) {
        for (var T = [p[0]], F = 1, j = 0, ge = p.length; F < ge; F++)
          Ui(p[F], p[j]) > y && (T.push(p[F]), j = F);
        return j < ge - 1 && T.push(p[ge - 1]), T;
      }
      var Ku;
      function ep(p, y, T, F, j) {
        var ge = F ? Ku : lo(p, T), xe = lo(y, T), Ve, pt, $t;
        for (Ku = xe; ; ) {
          if (!(ge | xe))
            return [p, y];
          if (ge & xe)
            return !1;
          Ve = ge || xe, pt = fl(p, y, Ve, T, j), $t = lo(pt, T), Ve === ge ? (p = pt, ge = $t) : (y = pt, xe = $t);
        }
      }
      function fl(p, y, T, F, j) {
        var ge = y.x - p.x, xe = y.y - p.y, Ve = F.min, pt = F.max, $t, Jt;
        return T & 8 ? ($t = p.x + ge * (pt.y - p.y) / xe, Jt = pt.y) : T & 4 ? ($t = p.x + ge * (Ve.y - p.y) / xe, Jt = Ve.y) : T & 2 ? ($t = pt.x, Jt = p.y + xe * (pt.x - p.x) / ge) : T & 1 && ($t = Ve.x, Jt = p.y + xe * (Ve.x - p.x) / ge), new et($t, Jt, j);
      }
      function lo(p, y) {
        var T = 0;
        return p.x < y.min.x ? T |= 1 : p.x > y.max.x && (T |= 2), p.y < y.min.y ? T |= 4 : p.y > y.max.y && (T |= 8), T;
      }
      function Ui(p, y) {
        var T = y.x - p.x, F = y.y - p.y;
        return T * T + F * F;
      }
      function ka(p, y, T, F) {
        var j = y.x, ge = y.y, xe = T.x - j, Ve = T.y - ge, pt = xe * xe + Ve * Ve, $t;
        return pt > 0 && ($t = ((p.x - j) * xe + (p.y - ge) * Ve) / pt, $t > 1 ? (j = T.x, ge = T.y) : $t > 0 && (j += xe * $t, ge += Ve * $t)), xe = p.x - j, Ve = p.y - ge, F ? xe * xe + Ve * Ve : new et(j, ge);
      }
      function kn(p) {
        return !U(p[0]) || typeof p[0][0] != "object" && typeof p[0][0] < "u";
      }
      function sc(p) {
        return console.warn("Deprecated use of _flat, please use L.LineUtil.isFlat instead."), kn(p);
      }
      function $i(p, y) {
        var T, F, j, ge, xe, Ve, pt, $t;
        if (!p || p.length === 0)
          throw new Error("latlngs not passed");
        kn(p) || (console.warn("latlngs are not flat! Only the first ring will be used"), p = p[0]);
        var Jt = Je([0, 0]), pn = rt(p), Hn = pn.getNorthWest().distanceTo(pn.getSouthWest()) * pn.getNorthEast().distanceTo(pn.getNorthWest());
        Hn < 1700 && (Jt = nc(p));
        var Hi = p.length, fr = [];
        for (T = 0; T < Hi; T++) {
          var ir = Je(p[T]);
          fr.push(y.project(Je([ir.lat - Jt.lat, ir.lng - Jt.lng])));
        }
        for (T = 0, F = 0; T < Hi - 1; T++)
          F += fr[T].distanceTo(fr[T + 1]) / 2;
        if (F === 0)
          $t = fr[0];
        else
          for (T = 0, ge = 0; T < Hi - 1; T++)
            if (xe = fr[T], Ve = fr[T + 1], j = xe.distanceTo(Ve), ge += j, ge > F) {
              pt = (ge - F) / j, $t = [
                Ve.x - pt * (Ve.x - xe.x),
                Ve.y - pt * (Ve.y - xe.y)
              ];
              break;
            }
        var Kn = y.unproject(De($t));
        return Je([Kn.lat + Jt.lat, Kn.lng + Jt.lng]);
      }
      var Ci = {
        __proto__: null,
        simplify: ic,
        pointToSegmentDistance: Jd,
        closestPointOnSegment: Qd,
        clipSegment: ep,
        _getEdgeIntersection: fl,
        _getBitCode: lo,
        _sqClosestPointOnSegment: ka,
        isFlat: kn,
        _flat: sc,
        polylineCenter: $i
      }, Zo = {
        project: function(p) {
          return new et(p.lng, p.lat);
        },
        unproject: function(p) {
          return new Le(p.y, p.x);
        },
        bounds: new Ke([-180, -90], [180, 90])
      }, Yc = {
        R: 6378137,
        R_MINOR: 6356752314245179e-9,
        bounds: new Ke([-2003750834279e-5, -1549657073972e-5], [2003750834279e-5, 1876465623138e-5]),
        project: function(p) {
          var y = Math.PI / 180, T = this.R, F = p.lat * y, j = this.R_MINOR / T, ge = Math.sqrt(1 - j * j), xe = ge * Math.sin(F), Ve = Math.tan(Math.PI / 4 - F / 2) / Math.pow((1 - xe) / (1 + xe), ge / 2);
          return F = -T * Math.log(Math.max(Ve, 1e-10)), new et(p.lng * y * T, F);
        },
        unproject: function(p) {
          for (var y = 180 / Math.PI, T = this.R, F = this.R_MINOR / T, j = Math.sqrt(1 - F * F), ge = Math.exp(-p.y / T), xe = Math.PI / 2 - 2 * Math.atan(ge), Ve = 0, pt = 0.1, $t; Ve < 15 && Math.abs(pt) > 1e-7; Ve++)
            $t = j * Math.sin(xe), $t = Math.pow((1 - $t) / (1 + $t), j / 2), pt = Math.PI / 2 - 2 * Math.atan(ge * $t) - xe, xe += pt;
          return new Le(xe * y, p.x * y / T);
        }
      }, Xu = {
        __proto__: null,
        LonLat: Zo,
        Mercator: Yc,
        SphericalMercator: tt
      }, of = r({}, ot, {
        code: "EPSG:3395",
        projection: Yc,
        transformation: function() {
          var p = 0.5 / (Math.PI * Yc.R);
          return bt(p, 0.5, -p, 0.5);
        }()
      }), Ju = r({}, ot, {
        code: "EPSG:4326",
        projection: Zo,
        transformation: bt(1 / 180, 1, -1 / 180, 0.5)
      }), Kc = r({}, je, {
        projection: Zo,
        transformation: bt(1, 0, -1, 0),
        scale: function(p) {
          return Math.pow(2, p);
        },
        zoom: function(p) {
          return Math.log(p) / Math.LN2;
        },
        distance: function(p, y) {
          var T = y.lng - p.lng, F = y.lat - p.lat;
          return Math.sqrt(T * T + F * F);
        },
        infinite: !0
      });
      je.Earth = ot, je.EPSG3395 = of, je.EPSG3857 = qt, je.EPSG900913 = Oe, je.EPSG4326 = Ju, je.Simple = Kc;
      var is = Ge.extend({
        // Classes extending `L.Layer` will inherit the following options:
        options: {
          // @option pane: String = 'overlayPane'
          // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
          pane: "overlayPane",
          // @option attribution: String = null
          // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
          attribution: null,
          bubblingMouseEvents: !0
        },
        /* @section
         * Classes extending `L.Layer` will inherit the following methods:
         *
         * @method addTo(map: Map|LayerGroup): this
         * Adds the layer to the given map or layer group.
         */
        addTo: function(p) {
          return p.addLayer(this), this;
        },
        // @method remove: this
        // Removes the layer from the map it is currently active on.
        remove: function() {
          return this.removeFrom(this._map || this._mapToAdd);
        },
        // @method removeFrom(map: Map): this
        // Removes the layer from the given map
        //
        // @alternative
        // @method removeFrom(group: LayerGroup): this
        // Removes the layer from the given `LayerGroup`
        removeFrom: function(p) {
          return p && p.removeLayer(this), this;
        },
        // @method getPane(name? : String): HTMLElement
        // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
        getPane: function(p) {
          return this._map.getPane(p ? this.options[p] || p : this.options.pane);
        },
        addInteractiveTarget: function(p) {
          return this._map._targets[f(p)] = this, this;
        },
        removeInteractiveTarget: function(p) {
          return delete this._map._targets[f(p)], this;
        },
        // @method getAttribution: String
        // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
        getAttribution: function() {
          return this.options.attribution;
        },
        _layerAdd: function(p) {
          var y = p.target;
          if (y.hasLayer(this)) {
            if (this._map = y, this._zoomAnimated = y._zoomAnimated, this.getEvents) {
              var T = this.getEvents();
              y.on(T, this), this.once("remove", function() {
                y.off(T, this);
              }, this);
            }
            this.onAdd(y), this.fire("add"), y.fire("layeradd", { layer: this });
          }
        }
      });
      Jn.include({
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the map
        addLayer: function(p) {
          if (!p._layerAdd)
            throw new Error("The provided object is not a Layer.");
          var y = f(p);
          return this._layers[y] ? this : (this._layers[y] = p, p._mapToAdd = this, p.beforeAdd && p.beforeAdd(this), this.whenReady(p._layerAdd, p), this);
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the map.
        removeLayer: function(p) {
          var y = f(p);
          return this._layers[y] ? (this._loaded && p.onRemove(this), delete this._layers[y], this._loaded && (this.fire("layerremove", { layer: p }), p.fire("remove")), p._map = p._mapToAdd = null, this) : this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the map
        hasLayer: function(p) {
          return f(p) in this._layers;
        },
        /* @method eachLayer(fn: Function, context?: Object): this
         * Iterates over the layers of the map, optionally specifying context of the iterator function.
         * ```
         * map.eachLayer(function(layer){
         *     layer.bindPopup('Hello');
         * });
         * ```
         */
        eachLayer: function(p, y) {
          for (var T in this._layers)
            p.call(y, this._layers[T]);
          return this;
        },
        _addLayers: function(p) {
          p = p ? U(p) ? p : [p] : [];
          for (var y = 0, T = p.length; y < T; y++)
            this.addLayer(p[y]);
        },
        _addZoomLimit: function(p) {
          (!isNaN(p.options.maxZoom) || !isNaN(p.options.minZoom)) && (this._zoomBoundLayers[f(p)] = p, this._updateZoomLevels());
        },
        _removeZoomLimit: function(p) {
          var y = f(p);
          this._zoomBoundLayers[y] && (delete this._zoomBoundLayers[y], this._updateZoomLevels());
        },
        _updateZoomLevels: function() {
          var p = 1 / 0, y = -1 / 0, T = this._getZoomSpan();
          for (var F in this._zoomBoundLayers) {
            var j = this._zoomBoundLayers[F].options;
            p = j.minZoom === void 0 ? p : Math.min(p, j.minZoom), y = j.maxZoom === void 0 ? y : Math.max(y, j.maxZoom);
          }
          this._layersMaxZoom = y === -1 / 0 ? void 0 : y, this._layersMinZoom = p === 1 / 0 ? void 0 : p, T !== this._getZoomSpan() && this.fire("zoomlevelschange"), this.options.maxZoom === void 0 && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom && this.setZoom(this._layersMaxZoom), this.options.minZoom === void 0 && this._layersMinZoom && this.getZoom() < this._layersMinZoom && this.setZoom(this._layersMinZoom);
        }
      });
      var qo = is.extend({
        initialize: function(p, y) {
          B(this, y), this._layers = {};
          var T, F;
          if (p)
            for (T = 0, F = p.length; T < F; T++)
              this.addLayer(p[T]);
        },
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the group.
        addLayer: function(p) {
          var y = this.getLayerId(p);
          return this._layers[y] = p, this._map && this._map.addLayer(p), this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the group.
        // @alternative
        // @method removeLayer(id: Number): this
        // Removes the layer with the given internal ID from the group.
        removeLayer: function(p) {
          var y = p in this._layers ? p : this.getLayerId(p);
          return this._map && this._layers[y] && this._map.removeLayer(this._layers[y]), delete this._layers[y], this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the group.
        // @alternative
        // @method hasLayer(id: Number): Boolean
        // Returns `true` if the given internal ID is currently added to the group.
        hasLayer: function(p) {
          var y = typeof p == "number" ? p : this.getLayerId(p);
          return y in this._layers;
        },
        // @method clearLayers(): this
        // Removes all the layers from the group.
        clearLayers: function() {
          return this.eachLayer(this.removeLayer, this);
        },
        // @method invoke(methodName: String, …): this
        // Calls `methodName` on every layer contained in this group, passing any
        // additional parameters. Has no effect if the layers contained do not
        // implement `methodName`.
        invoke: function(p) {
          var y = Array.prototype.slice.call(arguments, 1), T, F;
          for (T in this._layers)
            F = this._layers[T], F[p] && F[p].apply(F, y);
          return this;
        },
        onAdd: function(p) {
          this.eachLayer(p.addLayer, p);
        },
        onRemove: function(p) {
          this.eachLayer(p.removeLayer, p);
        },
        // @method eachLayer(fn: Function, context?: Object): this
        // Iterates over the layers of the group, optionally specifying context of the iterator function.
        // ```js
        // group.eachLayer(function (layer) {
        // 	layer.bindPopup('Hello');
        // });
        // ```
        eachLayer: function(p, y) {
          for (var T in this._layers)
            p.call(y, this._layers[T]);
          return this;
        },
        // @method getLayer(id: Number): Layer
        // Returns the layer with the given internal ID.
        getLayer: function(p) {
          return this._layers[p];
        },
        // @method getLayers(): Layer[]
        // Returns an array of all the layers added to the group.
        getLayers: function() {
          var p = [];
          return this.eachLayer(p.push, p), p;
        },
        // @method setZIndex(zIndex: Number): this
        // Calls `setZIndex` on every layer contained in this group, passing the z-index.
        setZIndex: function(p) {
          return this.invoke("setZIndex", p);
        },
        // @method getLayerId(layer: Layer): Number
        // Returns the internal ID for a layer
        getLayerId: function(p) {
          return f(p);
        }
      }), Qu = function(p, y) {
        return new qo(p, y);
      }, ys = qo.extend({
        addLayer: function(p) {
          return this.hasLayer(p) ? this : (p.addEventParent(this), qo.prototype.addLayer.call(this, p), this.fire("layeradd", { layer: p }));
        },
        removeLayer: function(p) {
          return this.hasLayer(p) ? (p in this._layers && (p = this._layers[p]), p.removeEventParent(this), qo.prototype.removeLayer.call(this, p), this.fire("layerremove", { layer: p })) : this;
        },
        // @method setStyle(style: Path options): this
        // Sets the given path options to each layer of the group that has a `setStyle` method.
        setStyle: function(p) {
          return this.invoke("setStyle", p);
        },
        // @method bringToFront(): this
        // Brings the layer group to the top of all other layers
        bringToFront: function() {
          return this.invoke("bringToFront");
        },
        // @method bringToBack(): this
        // Brings the layer group to the back of all other layers
        bringToBack: function() {
          return this.invoke("bringToBack");
        },
        // @method getBounds(): LatLngBounds
        // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
        getBounds: function() {
          var p = new qe();
          for (var y in this._layers) {
            var T = this._layers[y];
            p.extend(T.getBounds ? T.getBounds() : T.getLatLng());
          }
          return p;
        }
      }), oc = function(p, y) {
        return new ys(p, y);
      }, ml = pe.extend({
        /* @section
         * @aka Icon options
         *
         * @option iconUrl: String = null
         * **(required)** The URL to the icon image (absolute or relative to your script path).
         *
         * @option iconRetinaUrl: String = null
         * The URL to a retina sized version of the icon image (absolute or relative to your
         * script path). Used for Retina screen devices.
         *
         * @option iconSize: Point = null
         * Size of the icon image in pixels.
         *
         * @option iconAnchor: Point = null
         * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
         * will be aligned so that this point is at the marker's geographical location. Centered
         * by default if size is specified, also can be set in CSS with negative margins.
         *
         * @option popupAnchor: Point = [0, 0]
         * The coordinates of the point from which popups will "open", relative to the icon anchor.
         *
         * @option tooltipAnchor: Point = [0, 0]
         * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
         *
         * @option shadowUrl: String = null
         * The URL to the icon shadow image. If not specified, no shadow image will be created.
         *
         * @option shadowRetinaUrl: String = null
         *
         * @option shadowSize: Point = null
         * Size of the shadow image in pixels.
         *
         * @option shadowAnchor: Point = null
         * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
         * as iconAnchor if not specified).
         *
         * @option className: String = ''
         * A custom class name to assign to both icon and shadow images. Empty by default.
         */
        options: {
          popupAnchor: [0, 0],
          tooltipAnchor: [0, 0],
          // @option crossOrigin: Boolean|String = false
          // Whether the crossOrigin attribute will be added to the tiles.
          // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
          // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
          crossOrigin: !1
        },
        initialize: function(p) {
          B(this, p);
        },
        // @method createIcon(oldIcon?: HTMLElement): HTMLElement
        // Called internally when the icon has to be shown, returns a `<img>` HTML element
        // styled according to the options.
        createIcon: function(p) {
          return this._createIcon("icon", p);
        },
        // @method createShadow(oldIcon?: HTMLElement): HTMLElement
        // As `createIcon`, but for the shadow beneath it.
        createShadow: function(p) {
          return this._createIcon("shadow", p);
        },
        _createIcon: function(p, y) {
          var T = this._getIconUrl(p);
          if (!T) {
            if (p === "icon")
              throw new Error("iconUrl not set in Icon options (see the docs).");
            return null;
          }
          var F = this._createImg(T, y && y.tagName === "IMG" ? y : null);
          return this._setIconStyles(F, p), (this.options.crossOrigin || this.options.crossOrigin === "") && (F.crossOrigin = this.options.crossOrigin === !0 ? "" : this.options.crossOrigin), F;
        },
        _setIconStyles: function(p, y) {
          var T = this.options, F = T[y + "Size"];
          typeof F == "number" && (F = [F, F]);
          var j = De(F), ge = De(y === "shadow" && T.shadowAnchor || T.iconAnchor || j && j.divideBy(2, !0));
          p.className = "leaflet-marker-" + y + " " + (T.className || ""), ge && (p.style.marginLeft = -ge.x + "px", p.style.marginTop = -ge.y + "px"), j && (p.style.width = j.x + "px", p.style.height = j.y + "px");
        },
        _createImg: function(p, y) {
          return y = y || document.createElement("img"), y.src = p, y;
        },
        _getIconUrl: function(p) {
          return nt.retina && this.options[p + "RetinaUrl"] || this.options[p + "Url"];
        }
      });
      function tp(p) {
        return new ml(p);
      }
      var Fi = ml.extend({
        options: {
          iconUrl: "marker-icon.png",
          iconRetinaUrl: "marker-icon-2x.png",
          shadowUrl: "marker-shadow.png",
          iconSize: [25, 41],
          iconAnchor: [12, 41],
          popupAnchor: [1, -34],
          tooltipAnchor: [16, -28],
          shadowSize: [41, 41]
        },
        _getIconUrl: function(p) {
          return typeof Fi.imagePath != "string" && (Fi.imagePath = this._detectIconPath()), (this.options.imagePath || Fi.imagePath) + ml.prototype._getIconUrl.call(this, p);
        },
        _stripUrl: function(p) {
          var y = function(T, F, j) {
            var ge = F.exec(T);
            return ge && ge[j];
          };
          return p = y(p, /^url\((['"])?(.+)\1\)$/, 2), p && y(p, /^(.*)marker-icon\.png$/, 1);
        },
        _detectIconPath: function() {
          var p = Ln("div", "leaflet-default-icon-path", document.body), y = ao(p, "background-image") || ao(p, "backgroundImage");
          if (document.body.removeChild(p), y = this._stripUrl(y), y)
            return y;
          var T = document.querySelector('link[href$="leaflet.css"]');
          return T ? T.href.substring(0, T.href.length - 11 - 1) : "";
        }
      }), jo = Ms.extend({
        initialize: function(p) {
          this._marker = p;
        },
        addHooks: function() {
          var p = this._marker._icon;
          this._draggable || (this._draggable = new gs(p, p, !0)), this._draggable.on({
            dragstart: this._onDragStart,
            predrag: this._onPreDrag,
            drag: this._onDrag,
            dragend: this._onDragEnd
          }, this).enable(), jt(p, "leaflet-marker-draggable");
        },
        removeHooks: function() {
          this._draggable.off({
            dragstart: this._onDragStart,
            predrag: this._onPreDrag,
            drag: this._onDrag,
            dragend: this._onDragEnd
          }, this).disable(), this._marker._icon && hi(this._marker._icon, "leaflet-marker-draggable");
        },
        moved: function() {
          return this._draggable && this._draggable._moved;
        },
        _adjustPan: function(p) {
          var y = this._marker, T = y._map, F = this._marker.options.autoPanSpeed, j = this._marker.options.autoPanPadding, ge = ya(y._icon), xe = T.getPixelBounds(), Ve = T.getPixelOrigin(), pt = gt(
            xe.min._subtract(Ve).add(j),
            xe.max._subtract(Ve).subtract(j)
          );
          if (!pt.contains(ge)) {
            var $t = De(
              (Math.max(pt.max.x, ge.x) - pt.max.x) / (xe.max.x - pt.max.x) - (Math.min(pt.min.x, ge.x) - pt.min.x) / (xe.min.x - pt.min.x),
              (Math.max(pt.max.y, ge.y) - pt.max.y) / (xe.max.y - pt.max.y) - (Math.min(pt.min.y, ge.y) - pt.min.y) / (xe.min.y - pt.min.y)
            ).multiplyBy(F);
            T.panBy($t, { animate: !1 }), this._draggable._newPos._add($t), this._draggable._startPos._add($t), Xn(y._icon, this._draggable._newPos), this._onDrag(p), this._panRequest = ve(this._adjustPan.bind(this, p));
          }
        },
        _onDragStart: function() {
          this._oldLatLng = this._marker.getLatLng(), this._marker.closePopup && this._marker.closePopup(), this._marker.fire("movestart").fire("dragstart");
        },
        _onPreDrag: function(p) {
          this._marker.options.autoPan && (re(this._panRequest), this._panRequest = ve(this._adjustPan.bind(this, p)));
        },
        _onDrag: function(p) {
          var y = this._marker, T = y._shadow, F = ya(y._icon), j = y._map.layerPointToLatLng(F);
          T && Xn(T, F), y._latlng = j, p.latlng = j, p.oldLatLng = this._oldLatLng, y.fire("move", p).fire("drag", p);
        },
        _onDragEnd: function(p) {
          re(this._panRequest), delete this._oldLatLng, this._marker.fire("moveend").fire("dragend", p);
        }
      }), Kr = is.extend({
        // @section
        // @aka Marker options
        options: {
          // @option icon: Icon = *
          // Icon instance to use for rendering the marker.
          // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
          // If not specified, a common instance of `L.Icon.Default` is used.
          icon: new Fi(),
          // Option inherited from "Interactive layer" abstract class
          interactive: !0,
          // @option keyboard: Boolean = true
          // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
          keyboard: !0,
          // @option title: String = ''
          // Text for the browser tooltip that appear on marker hover (no tooltip by default).
          // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
          title: "",
          // @option alt: String = 'Marker'
          // Text for the `alt` attribute of the icon image.
          // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
          alt: "Marker",
          // @option zIndexOffset: Number = 0
          // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
          zIndexOffset: 0,
          // @option opacity: Number = 1.0
          // The opacity of the marker.
          opacity: 1,
          // @option riseOnHover: Boolean = false
          // If `true`, the marker will get on top of others when you hover the mouse over it.
          riseOnHover: !1,
          // @option riseOffset: Number = 250
          // The z-index offset used for the `riseOnHover` feature.
          riseOffset: 250,
          // @option pane: String = 'markerPane'
          // `Map pane` where the markers icon will be added.
          pane: "markerPane",
          // @option shadowPane: String = 'shadowPane'
          // `Map pane` where the markers shadow will be added.
          shadowPane: "shadowPane",
          // @option bubblingMouseEvents: Boolean = false
          // When `true`, a mouse event on this marker will trigger the same event on the map
          // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
          bubblingMouseEvents: !1,
          // @option autoPanOnFocus: Boolean = true
          // When `true`, the map will pan whenever the marker is focused (via
          // e.g. pressing `tab` on the keyboard) to ensure the marker is
          // visible within the map's bounds
          autoPanOnFocus: !0,
          // @section Draggable marker options
          // @option draggable: Boolean = false
          // Whether the marker is draggable with mouse/touch or not.
          draggable: !1,
          // @option autoPan: Boolean = false
          // Whether to pan the map when dragging this marker near its edge or not.
          autoPan: !1,
          // @option autoPanPadding: Point = Point(50, 50)
          // Distance (in pixels to the left/right and to the top/bottom) of the
          // map edge to start panning the map.
          autoPanPadding: [50, 50],
          // @option autoPanSpeed: Number = 10
          // Number of pixels the map should pan by.
          autoPanSpeed: 10
        },
        /* @section
         *
         * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
         */
        initialize: function(p, y) {
          B(this, y), this._latlng = Je(p);
        },
        onAdd: function(p) {
          this._zoomAnimated = this._zoomAnimated && p.options.markerZoomAnimation, this._zoomAnimated && p.on("zoomanim", this._animateZoom, this), this._initIcon(), this.update();
        },
        onRemove: function(p) {
          this.dragging && this.dragging.enabled() && (this.options.draggable = !0, this.dragging.removeHooks()), delete this.dragging, this._zoomAnimated && p.off("zoomanim", this._animateZoom, this), this._removeIcon(), this._removeShadow();
        },
        getEvents: function() {
          return {
            zoom: this.update,
            viewreset: this.update
          };
        },
        // @method getLatLng: LatLng
        // Returns the current geographical position of the marker.
        getLatLng: function() {
          return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Changes the marker position to the given point.
        setLatLng: function(p) {
          var y = this._latlng;
          return this._latlng = Je(p), this.update(), this.fire("move", { oldLatLng: y, latlng: this._latlng });
        },
        // @method setZIndexOffset(offset: Number): this
        // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
        setZIndexOffset: function(p) {
          return this.options.zIndexOffset = p, this.update();
        },
        // @method getIcon: Icon
        // Returns the current icon used by the marker
        getIcon: function() {
          return this.options.icon;
        },
        // @method setIcon(icon: Icon): this
        // Changes the marker icon.
        setIcon: function(p) {
          return this.options.icon = p, this._map && (this._initIcon(), this.update()), this._popup && this.bindPopup(this._popup, this._popup.options), this;
        },
        getElement: function() {
          return this._icon;
        },
        update: function() {
          if (this._icon && this._map) {
            var p = this._map.latLngToLayerPoint(this._latlng).round();
            this._setPos(p);
          }
          return this;
        },
        _initIcon: function() {
          var p = this.options, y = "leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide"), T = p.icon.createIcon(this._icon), F = !1;
          T !== this._icon && (this._icon && this._removeIcon(), F = !0, p.title && (T.title = p.title), T.tagName === "IMG" && (T.alt = p.alt || "")), jt(T, y), p.keyboard && (T.tabIndex = "0", T.setAttribute("role", "button")), this._icon = T, p.riseOnHover && this.on({
            mouseover: this._bringToFront,
            mouseout: this._resetZIndex
          }), this.options.autoPanOnFocus && Mn(T, "focus", this._panOnFocus, this);
          var j = p.icon.createShadow(this._shadow), ge = !1;
          j !== this._shadow && (this._removeShadow(), ge = !0), j && (jt(j, y), j.alt = ""), this._shadow = j, p.opacity < 1 && this._updateOpacity(), F && this.getPane().appendChild(this._icon), this._initInteraction(), j && ge && this.getPane(p.shadowPane).appendChild(this._shadow);
        },
        _removeIcon: function() {
          this.options.riseOnHover && this.off({
            mouseover: this._bringToFront,
            mouseout: this._resetZIndex
          }), this.options.autoPanOnFocus && li(this._icon, "focus", this._panOnFocus, this), xi(this._icon), this.removeInteractiveTarget(this._icon), this._icon = null;
        },
        _removeShadow: function() {
          this._shadow && xi(this._shadow), this._shadow = null;
        },
        _setPos: function(p) {
          this._icon && Xn(this._icon, p), this._shadow && Xn(this._shadow, p), this._zIndex = p.y + this.options.zIndexOffset, this._resetZIndex();
        },
        _updateZIndex: function(p) {
          this._icon && (this._icon.style.zIndex = this._zIndex + p);
        },
        _animateZoom: function(p) {
          var y = this._map._latLngToNewLayerPoint(this._latlng, p.zoom, p.center).round();
          this._setPos(y);
        },
        _initInteraction: function() {
          if (this.options.interactive && (jt(this._icon, "leaflet-interactive"), this.addInteractiveTarget(this._icon), jo)) {
            var p = this.options.draggable;
            this.dragging && (p = this.dragging.enabled(), this.dragging.disable()), this.dragging = new jo(this), p && this.dragging.enable();
          }
        },
        // @method setOpacity(opacity: Number): this
        // Changes the opacity of the marker.
        setOpacity: function(p) {
          return this.options.opacity = p, this._map && this._updateOpacity(), this;
        },
        _updateOpacity: function() {
          var p = this.options.opacity;
          this._icon && Mt(this._icon, p), this._shadow && Mt(this._shadow, p);
        },
        _bringToFront: function() {
          this._updateZIndex(this.options.riseOffset);
        },
        _resetZIndex: function() {
          this._updateZIndex(0);
        },
        _panOnFocus: function() {
          var p = this._map;
          if (p) {
            var y = this.options.icon.options, T = y.iconSize ? De(y.iconSize) : De(0, 0), F = y.iconAnchor ? De(y.iconAnchor) : De(0, 0);
            p.panInside(this._latlng, {
              paddingTopLeft: F,
              paddingBottomRight: T.subtract(F)
            });
          }
        },
        _getPopupAnchor: function() {
          return this.options.icon.options.popupAnchor;
        },
        _getTooltipAnchor: function() {
          return this.options.icon.options.tooltipAnchor;
        }
      });
      function np(p, y) {
        return new Kr(p, y);
      }
      var co = is.extend({
        // @section
        // @aka Path options
        options: {
          // @option stroke: Boolean = true
          // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
          stroke: !0,
          // @option color: String = '#3388ff'
          // Stroke color
          color: "#3388ff",
          // @option weight: Number = 3
          // Stroke width in pixels
          weight: 3,
          // @option opacity: Number = 1.0
          // Stroke opacity
          opacity: 1,
          // @option lineCap: String= 'round'
          // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
          lineCap: "round",
          // @option lineJoin: String = 'round'
          // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
          lineJoin: "round",
          // @option dashArray: String = null
          // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
          dashArray: null,
          // @option dashOffset: String = null
          // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
          dashOffset: null,
          // @option fill: Boolean = depends
          // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
          fill: !1,
          // @option fillColor: String = *
          // Fill color. Defaults to the value of the [`color`](#path-color) option
          fillColor: null,
          // @option fillOpacity: Number = 0.2
          // Fill opacity.
          fillOpacity: 0.2,
          // @option fillRule: String = 'evenodd'
          // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
          fillRule: "evenodd",
          // className: '',
          // Option inherited from "Interactive layer" abstract class
          interactive: !0,
          // @option bubblingMouseEvents: Boolean = true
          // When `true`, a mouse event on this path will trigger the same event on the map
          // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
          bubblingMouseEvents: !0
        },
        beforeAdd: function(p) {
          this._renderer = p.getRenderer(this);
        },
        onAdd: function() {
          this._renderer._initPath(this), this._reset(), this._renderer._addPath(this);
        },
        onRemove: function() {
          this._renderer._removePath(this);
        },
        // @method redraw(): this
        // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
        redraw: function() {
          return this._map && this._renderer._updatePath(this), this;
        },
        // @method setStyle(style: Path options): this
        // Changes the appearance of a Path based on the options in the `Path options` object.
        setStyle: function(p) {
          return B(this, p), this._renderer && (this._renderer._updateStyle(this), this.options.stroke && p && Object.prototype.hasOwnProperty.call(p, "weight") && this._updateBounds()), this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all path layers.
        bringToFront: function() {
          return this._renderer && this._renderer._bringToFront(this), this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all path layers.
        bringToBack: function() {
          return this._renderer && this._renderer._bringToBack(this), this;
        },
        getElement: function() {
          return this._path;
        },
        _reset: function() {
          this._project(), this._update();
        },
        _clickTolerance: function() {
          return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
        }
      }), ac = co.extend({
        // @section
        // @aka CircleMarker options
        options: {
          fill: !0,
          // @option radius: Number = 10
          // Radius of the circle marker, in pixels
          radius: 10
        },
        initialize: function(p, y) {
          B(this, y), this._latlng = Je(p), this._radius = this.options.radius;
        },
        // @method setLatLng(latLng: LatLng): this
        // Sets the position of a circle marker to a new location.
        setLatLng: function(p) {
          var y = this._latlng;
          return this._latlng = Je(p), this.redraw(), this.fire("move", { oldLatLng: y, latlng: this._latlng });
        },
        // @method getLatLng(): LatLng
        // Returns the current geographical position of the circle marker
        getLatLng: function() {
          return this._latlng;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle marker. Units are in pixels.
        setRadius: function(p) {
          return this.options.radius = this._radius = p, this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of the circle
        getRadius: function() {
          return this._radius;
        },
        setStyle: function(p) {
          var y = p && p.radius || this._radius;
          return co.prototype.setStyle.call(this, p), this.setRadius(y), this;
        },
        _project: function() {
          this._point = this._map.latLngToLayerPoint(this._latlng), this._updateBounds();
        },
        _updateBounds: function() {
          var p = this._radius, y = this._radiusY || p, T = this._clickTolerance(), F = [p + T, y + T];
          this._pxBounds = new Ke(this._point.subtract(F), this._point.add(F));
        },
        _update: function() {
          this._map && this._updatePath();
        },
        _updatePath: function() {
          this._renderer._updateCircle(this);
        },
        _empty: function() {
          return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
          return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
        }
      });
      function Sa(p, y) {
        return new ac(p, y);
      }
      var Ta = ac.extend({
        initialize: function(p, y, T) {
          if (typeof y == "number" && (y = r({}, T, { radius: y })), B(this, y), this._latlng = Je(p), isNaN(this.options.radius))
            throw new Error("Circle radius cannot be NaN");
          this._mRadius = this.options.radius;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle. Units are in meters.
        setRadius: function(p) {
          return this._mRadius = p, this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of a circle. Units are in meters.
        getRadius: function() {
          return this._mRadius;
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
          var p = [this._radius, this._radiusY || this._radius];
          return new qe(
            this._map.layerPointToLatLng(this._point.subtract(p)),
            this._map.layerPointToLatLng(this._point.add(p))
          );
        },
        setStyle: co.prototype.setStyle,
        _project: function() {
          var p = this._latlng.lng, y = this._latlng.lat, T = this._map, F = T.options.crs;
          if (F.distance === ot.distance) {
            var j = Math.PI / 180, ge = this._mRadius / ot.R / j, xe = T.project([y + ge, p]), Ve = T.project([y - ge, p]), pt = xe.add(Ve).divideBy(2), $t = T.unproject(pt).lat, Jt = Math.acos((Math.cos(ge * j) - Math.sin(y * j) * Math.sin($t * j)) / (Math.cos(y * j) * Math.cos($t * j))) / j;
            (isNaN(Jt) || Jt === 0) && (Jt = ge / Math.cos(Math.PI / 180 * y)), this._point = pt.subtract(T.getPixelOrigin()), this._radius = isNaN(Jt) ? 0 : pt.x - T.project([$t, p - Jt]).x, this._radiusY = pt.y - xe.y;
          } else {
            var pn = F.unproject(F.project(this._latlng).subtract([this._mRadius, 0]));
            this._point = T.latLngToLayerPoint(this._latlng), this._radius = this._point.x - T.latLngToLayerPoint(pn).x;
          }
          this._updateBounds();
        }
      });
      function vl(p, y, T) {
        return new Ta(p, y, T);
      }
      var uo = co.extend({
        // @section
        // @aka Polyline options
        options: {
          // @option smoothFactor: Number = 1.0
          // How much to simplify the polyline on each zoom level. More means
          // better performance and smoother look, and less means more accurate representation.
          smoothFactor: 1,
          // @option noClip: Boolean = false
          // Disable polyline clipping.
          noClip: !1
        },
        initialize: function(p, y) {
          B(this, y), this._setLatLngs(p);
        },
        // @method getLatLngs(): LatLng[]
        // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
        getLatLngs: function() {
          return this._latlngs;
        },
        // @method setLatLngs(latlngs: LatLng[]): this
        // Replaces all the points in the polyline with the given array of geographical points.
        setLatLngs: function(p) {
          return this._setLatLngs(p), this.redraw();
        },
        // @method isEmpty(): Boolean
        // Returns `true` if the Polyline has no LatLngs.
        isEmpty: function() {
          return !this._latlngs.length;
        },
        // @method closestLayerPoint(p: Point): Point
        // Returns the point closest to `p` on the Polyline.
        closestLayerPoint: function(p) {
          for (var y = 1 / 0, T = null, F = ka, j, ge, xe = 0, Ve = this._parts.length; xe < Ve; xe++)
            for (var pt = this._parts[xe], $t = 1, Jt = pt.length; $t < Jt; $t++) {
              j = pt[$t - 1], ge = pt[$t];
              var pn = F(p, j, ge, !0);
              pn < y && (y = pn, T = F(p, j, ge));
            }
          return T && (T.distance = Math.sqrt(y)), T;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
        getCenter: function() {
          if (!this._map)
            throw new Error("Must add layer to map before using getCenter()");
          return $i(this._defaultShape(), this._map.options.crs);
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
          return this._bounds;
        },
        // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
        // Adds a given point to the polyline. By default, adds to the first ring of
        // the polyline in case of a multi-polyline, but can be overridden by passing
        // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
        addLatLng: function(p, y) {
          return y = y || this._defaultShape(), p = Je(p), y.push(p), this._bounds.extend(p), this.redraw();
        },
        _setLatLngs: function(p) {
          this._bounds = new qe(), this._latlngs = this._convertLatLngs(p);
        },
        _defaultShape: function() {
          return kn(this._latlngs) ? this._latlngs : this._latlngs[0];
        },
        // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
        _convertLatLngs: function(p) {
          for (var y = [], T = kn(p), F = 0, j = p.length; F < j; F++)
            T ? (y[F] = Je(p[F]), this._bounds.extend(y[F])) : y[F] = this._convertLatLngs(p[F]);
          return y;
        },
        _project: function() {
          var p = new Ke();
          this._rings = [], this._projectLatlngs(this._latlngs, this._rings, p), this._bounds.isValid() && p.isValid() && (this._rawPxBounds = p, this._updateBounds());
        },
        _updateBounds: function() {
          var p = this._clickTolerance(), y = new et(p, p);
          this._rawPxBounds && (this._pxBounds = new Ke([
            this._rawPxBounds.min.subtract(y),
            this._rawPxBounds.max.add(y)
          ]));
        },
        // recursively turns latlngs into a set of rings with projected coordinates
        _projectLatlngs: function(p, y, T) {
          var F = p[0] instanceof Le, j = p.length, ge, xe;
          if (F) {
            for (xe = [], ge = 0; ge < j; ge++)
              xe[ge] = this._map.latLngToLayerPoint(p[ge]), T.extend(xe[ge]);
            y.push(xe);
          } else
            for (ge = 0; ge < j; ge++)
              this._projectLatlngs(p[ge], y, T);
        },
        // clip polyline by renderer bounds so that we have less to render for performance
        _clipPoints: function() {
          var p = this._renderer._bounds;
          if (this._parts = [], !(!this._pxBounds || !this._pxBounds.intersects(p))) {
            if (this.options.noClip) {
              this._parts = this._rings;
              return;
            }
            var y = this._parts, T, F, j, ge, xe, Ve, pt;
            for (T = 0, j = 0, ge = this._rings.length; T < ge; T++)
              for (pt = this._rings[T], F = 0, xe = pt.length; F < xe - 1; F++)
                Ve = ep(pt[F], pt[F + 1], p, F, !0), Ve && (y[j] = y[j] || [], y[j].push(Ve[0]), (Ve[1] !== pt[F + 1] || F === xe - 2) && (y[j].push(Ve[1]), j++));
          }
        },
        // simplify each clipped part of the polyline for performance
        _simplifyPoints: function() {
          for (var p = this._parts, y = this.options.smoothFactor, T = 0, F = p.length; T < F; T++)
            p[T] = ic(p[T], y);
        },
        _update: function() {
          this._map && (this._clipPoints(), this._simplifyPoints(), this._updatePath());
        },
        _updatePath: function() {
          this._renderer._updatePoly(this);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p, y) {
          var T, F, j, ge, xe, Ve, pt = this._clickTolerance();
          if (!this._pxBounds || !this._pxBounds.contains(p))
            return !1;
          for (T = 0, ge = this._parts.length; T < ge; T++)
            for (Ve = this._parts[T], F = 0, xe = Ve.length, j = xe - 1; F < xe; j = F++)
              if (!(!y && F === 0) && Jd(p, Ve[j], Ve[F]) <= pt)
                return !0;
          return !1;
        }
      });
      function ed(p, y) {
        return new uo(p, y);
      }
      uo._flat = sc;
      var Go = uo.extend({
        options: {
          fill: !0
        },
        isEmpty: function() {
          return !this._latlngs.length || !this._latlngs[0].length;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
        getCenter: function() {
          if (!this._map)
            throw new Error("Must add layer to map before using getCenter()");
          return ju(this._defaultShape(), this._map.options.crs);
        },
        _convertLatLngs: function(p) {
          var y = uo.prototype._convertLatLngs.call(this, p), T = y.length;
          return T >= 2 && y[0] instanceof Le && y[0].equals(y[T - 1]) && y.pop(), y;
        },
        _setLatLngs: function(p) {
          uo.prototype._setLatLngs.call(this, p), kn(this._latlngs) && (this._latlngs = [this._latlngs]);
        },
        _defaultShape: function() {
          return kn(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
        },
        _clipPoints: function() {
          var p = this._renderer._bounds, y = this.options.weight, T = new et(y, y);
          if (p = new Ke(p.min.subtract(T), p.max.add(T)), this._parts = [], !(!this._pxBounds || !this._pxBounds.intersects(p))) {
            if (this.options.noClip) {
              this._parts = this._rings;
              return;
            }
            for (var F = 0, j = this._rings.length, ge; F < j; F++)
              ge = Ca(this._rings[F], p, !0), ge.length && this._parts.push(ge);
          }
        },
        _updatePath: function() {
          this._renderer._updatePoly(this, !0);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
          var y = !1, T, F, j, ge, xe, Ve, pt, $t;
          if (!this._pxBounds || !this._pxBounds.contains(p))
            return !1;
          for (ge = 0, pt = this._parts.length; ge < pt; ge++)
            for (T = this._parts[ge], xe = 0, $t = T.length, Ve = $t - 1; xe < $t; Ve = xe++)
              F = T[xe], j = T[Ve], F.y > p.y != j.y > p.y && p.x < (j.x - F.x) * (p.y - F.y) / (j.y - F.y) + F.x && (y = !y);
          return y || uo.prototype._containsPoint.call(this, p, !0);
        }
      });
      function ip(p, y) {
        return new Go(p, y);
      }
      var Ds = ys.extend({
        /* @section
         * @aka GeoJSON options
         *
         * @option pointToLayer: Function = *
         * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
         * called when data is added, passing the GeoJSON point feature and its `LatLng`.
         * The default is to spawn a default `Marker`:
         * ```js
         * function(geoJsonPoint, latlng) {
         * 	return L.marker(latlng);
         * }
         * ```
         *
         * @option style: Function = *
         * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
         * called internally when data is added.
         * The default value is to not override any defaults:
         * ```js
         * function (geoJsonFeature) {
         * 	return {}
         * }
         * ```
         *
         * @option onEachFeature: Function = *
         * A `Function` that will be called once for each created `Feature`, after it has
         * been created and styled. Useful for attaching events and popups to features.
         * The default is to do nothing with the newly created layers:
         * ```js
         * function (feature, layer) {}
         * ```
         *
         * @option filter: Function = *
         * A `Function` that will be used to decide whether to include a feature or not.
         * The default is to include all features:
         * ```js
         * function (geoJsonFeature) {
         * 	return true;
         * }
         * ```
         * Note: dynamically changing the `filter` option will have effect only on newly
         * added data. It will _not_ re-evaluate already included features.
         *
         * @option coordsToLatLng: Function = *
         * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
         * The default is the `coordsToLatLng` static method.
         *
         * @option markersInheritOptions: Boolean = false
         * Whether default Markers for "Point" type Features inherit from group options.
         */
        initialize: function(p, y) {
          B(this, y), this._layers = {}, p && this.addData(p);
        },
        // @method addData( <GeoJSON> data ): this
        // Adds a GeoJSON object to the layer.
        addData: function(p) {
          var y = U(p) ? p : p.features, T, F, j;
          if (y) {
            for (T = 0, F = y.length; T < F; T++)
              j = y[T], (j.geometries || j.geometry || j.features || j.coordinates) && this.addData(j);
            return this;
          }
          var ge = this.options;
          if (ge.filter && !ge.filter(p))
            return this;
          var xe = _s(p, ge);
          return xe ? (xe.feature = Ea(p), xe.defaultOptions = xe.options, this.resetStyle(xe), ge.onEachFeature && ge.onEachFeature(p, xe), this.addLayer(xe)) : this;
        },
        // @method resetStyle( <Path> layer? ): this
        // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
        // If `layer` is omitted, the style of all features in the current layer is reset.
        resetStyle: function(p) {
          return p === void 0 ? this.eachLayer(this.resetStyle, this) : (p.options = r({}, p.defaultOptions), this._setLayerStyle(p, this.options.style), this);
        },
        // @method setStyle( <Function> style ): this
        // Changes styles of GeoJSON vector layers with the given style function.
        setStyle: function(p) {
          return this.eachLayer(function(y) {
            this._setLayerStyle(y, p);
          }, this);
        },
        _setLayerStyle: function(p, y) {
          p.setStyle && (typeof y == "function" && (y = y(p.feature)), p.setStyle(y));
        }
      });
      function _s(p, y) {
        var T = p.type === "Feature" ? p.geometry : p, F = T ? T.coordinates : null, j = [], ge = y && y.pointToLayer, xe = y && y.coordsToLatLng || gl, Ve, pt, $t, Jt;
        if (!F && !T)
          return null;
        switch (T.type) {
          case "Point":
            return Ve = xe(F), lc(ge, p, Ve, y);
          case "MultiPoint":
            for ($t = 0, Jt = F.length; $t < Jt; $t++)
              Ve = xe(F[$t]), j.push(lc(ge, p, Ve, y));
            return new ys(j);
          case "LineString":
          case "MultiLineString":
            return pt = cc(F, T.type === "LineString" ? 0 : 1, xe), new uo(pt, y);
          case "Polygon":
          case "MultiPolygon":
            return pt = cc(F, T.type === "Polygon" ? 1 : 2, xe), new Go(pt, y);
          case "GeometryCollection":
            for ($t = 0, Jt = T.geometries.length; $t < Jt; $t++) {
              var pn = _s({
                geometry: T.geometries[$t],
                type: "Feature",
                properties: p.properties
              }, y);
              pn && j.push(pn);
            }
            return new ys(j);
          case "FeatureCollection":
            for ($t = 0, Jt = T.features.length; $t < Jt; $t++) {
              var Hn = _s(T.features[$t], y);
              Hn && j.push(Hn);
            }
            return new ys(j);
          default:
            throw new Error("Invalid GeoJSON object.");
        }
      }
      function lc(p, y, T, F) {
        return p ? p(y, T) : new Kr(T, F && F.markersInheritOptions && F);
      }
      function gl(p) {
        return new Le(p[1], p[0], p[2]);
      }
      function cc(p, y, T) {
        for (var F = [], j = 0, ge = p.length, xe; j < ge; j++)
          xe = y ? cc(p[j], y - 1, T) : (T || gl)(p[j]), F.push(xe);
        return F;
      }
      function Ia(p, y) {
        return p = Je(p), p.alt !== void 0 ? [A(p.lng, y), A(p.lat, y), A(p.alt, y)] : [A(p.lng, y), A(p.lat, y)];
      }
      function uc(p, y, T, F) {
        for (var j = [], ge = 0, xe = p.length; ge < xe; ge++)
          j.push(y ? uc(p[ge], kn(p[ge]) ? 0 : y - 1, T, F) : Ia(p[ge], F));
        return !y && T && j.length > 0 && j.push(j[0].slice()), j;
      }
      function Aa(p, y) {
        return p.feature ? r({}, p.feature, { geometry: y }) : Ea(y);
      }
      function Ea(p) {
        return p.type === "Feature" || p.type === "FeatureCollection" ? p : {
          type: "Feature",
          properties: {},
          geometry: p
        };
      }
      var Xc = {
        toGeoJSON: function(p) {
          return Aa(this, {
            type: "Point",
            coordinates: Ia(this.getLatLng(), p)
          });
        }
      };
      Kr.include(Xc), Ta.include(Xc), ac.include(Xc), uo.include({
        toGeoJSON: function(p) {
          var y = !kn(this._latlngs), T = uc(this._latlngs, y ? 1 : 0, !1, p);
          return Aa(this, {
            type: (y ? "Multi" : "") + "LineString",
            coordinates: T
          });
        }
      }), Go.include({
        toGeoJSON: function(p) {
          var y = !kn(this._latlngs), T = y && !kn(this._latlngs[0]), F = uc(this._latlngs, T ? 2 : y ? 1 : 0, !0, p);
          return y || (F = [F]), Aa(this, {
            type: (T ? "Multi" : "") + "Polygon",
            coordinates: F
          });
        }
      }), qo.include({
        toMultiPoint: function(p) {
          var y = [];
          return this.eachLayer(function(T) {
            y.push(T.toGeoJSON(p).geometry.coordinates);
          }), Aa(this, {
            type: "MultiPoint",
            coordinates: y
          });
        },
        // @method toGeoJSON(precision?: Number|false): Object
        // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
        // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
        toGeoJSON: function(p) {
          var y = this.feature && this.feature.geometry && this.feature.geometry.type;
          if (y === "MultiPoint")
            return this.toMultiPoint(p);
          var T = y === "GeometryCollection", F = [];
          return this.eachLayer(function(j) {
            if (j.toGeoJSON) {
              var ge = j.toGeoJSON(p);
              if (T)
                F.push(ge.geometry);
              else {
                var xe = Ea(ge);
                xe.type === "FeatureCollection" ? F.push.apply(F, xe.features) : F.push(xe);
              }
            }
          }), T ? Aa(this, {
            geometries: F,
            type: "GeometryCollection"
          }) : {
            type: "FeatureCollection",
            features: F
          };
        }
      });
      function js(p, y) {
        return new Ds(p, y);
      }
      var Ls = js, Yo = is.extend({
        // @section
        // @aka ImageOverlay options
        options: {
          // @option opacity: Number = 1.0
          // The opacity of the image overlay.
          opacity: 1,
          // @option alt: String = ''
          // Text for the `alt` attribute of the image (useful for accessibility).
          alt: "",
          // @option interactive: Boolean = false
          // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
          interactive: !1,
          // @option crossOrigin: Boolean|String = false
          // Whether the crossOrigin attribute will be added to the image.
          // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
          // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
          crossOrigin: !1,
          // @option errorOverlayUrl: String = ''
          // URL to the overlay image to show in place of the overlay that failed to load.
          errorOverlayUrl: "",
          // @option zIndex: Number = 1
          // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
          zIndex: 1,
          // @option className: String = ''
          // A custom class name to assign to the image. Empty by default.
          className: ""
        },
        initialize: function(p, y, T) {
          this._url = p, this._bounds = rt(y), B(this, T);
        },
        onAdd: function() {
          this._image || (this._initImage(), this.options.opacity < 1 && this._updateOpacity()), this.options.interactive && (jt(this._image, "leaflet-interactive"), this.addInteractiveTarget(this._image)), this.getPane().appendChild(this._image), this._reset();
        },
        onRemove: function() {
          xi(this._image), this.options.interactive && this.removeInteractiveTarget(this._image);
        },
        // @method setOpacity(opacity: Number): this
        // Sets the opacity of the overlay.
        setOpacity: function(p) {
          return this.options.opacity = p, this._image && this._updateOpacity(), this;
        },
        setStyle: function(p) {
          return p.opacity && this.setOpacity(p.opacity), this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all overlays.
        bringToFront: function() {
          return this._map && Hs(this._image), this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all overlays.
        bringToBack: function() {
          return this._map && ms(this._image), this;
        },
        // @method setUrl(url: String): this
        // Changes the URL of the image.
        setUrl: function(p) {
          return this._url = p, this._image && (this._image.src = p), this;
        },
        // @method setBounds(bounds: LatLngBounds): this
        // Update the bounds that this ImageOverlay covers
        setBounds: function(p) {
          return this._bounds = rt(p), this._map && this._reset(), this;
        },
        getEvents: function() {
          var p = {
            zoom: this._reset,
            viewreset: this._reset
          };
          return this._zoomAnimated && (p.zoomanim = this._animateZoom), p;
        },
        // @method setZIndex(value: Number): this
        // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
        setZIndex: function(p) {
          return this.options.zIndex = p, this._updateZIndex(), this;
        },
        // @method getBounds(): LatLngBounds
        // Get the bounds that this ImageOverlay covers
        getBounds: function() {
          return this._bounds;
        },
        // @method getElement(): HTMLElement
        // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
        // used by this overlay.
        getElement: function() {
          return this._image;
        },
        _initImage: function() {
          var p = this._url.tagName === "IMG", y = this._image = p ? this._url : Ln("img");
          if (jt(y, "leaflet-image-layer"), this._zoomAnimated && jt(y, "leaflet-zoom-animated"), this.options.className && jt(y, this.options.className), y.onselectstart = $, y.onmousemove = $, y.onload = d(this.fire, this, "load"), y.onerror = d(this._overlayOnError, this, "error"), (this.options.crossOrigin || this.options.crossOrigin === "") && (y.crossOrigin = this.options.crossOrigin === !0 ? "" : this.options.crossOrigin), this.options.zIndex && this._updateZIndex(), p) {
            this._url = y.src;
            return;
          }
          y.src = this._url, y.alt = this.options.alt;
        },
        _animateZoom: function(p) {
          var y = this._map.getZoomScale(p.zoom), T = this._map._latLngBoundsToNewLayerBounds(this._bounds, p.zoom, p.center).min;
          ti(this._image, T, y);
        },
        _reset: function() {
          var p = this._image, y = new Ke(
            this._map.latLngToLayerPoint(this._bounds.getNorthWest()),
            this._map.latLngToLayerPoint(this._bounds.getSouthEast())
          ), T = y.getSize();
          Xn(p, y.min), p.style.width = T.x + "px", p.style.height = T.y + "px";
        },
        _updateOpacity: function() {
          Mt(this._image, this.options.opacity);
        },
        _updateZIndex: function() {
          this._image && this.options.zIndex !== void 0 && this.options.zIndex !== null && (this._image.style.zIndex = this.options.zIndex);
        },
        _overlayOnError: function() {
          this.fire("error");
          var p = this.options.errorOverlayUrl;
          p && this._url !== p && (this._url = p, this._image.src = p);
        },
        // @method getCenter(): LatLng
        // Returns the center of the ImageOverlay.
        getCenter: function() {
          return this._bounds.getCenter();
        }
      }), nr = function(p, y, T) {
        return new Yo(p, y, T);
      }, To = Yo.extend({
        // @section
        // @aka VideoOverlay options
        options: {
          // @option autoplay: Boolean = true
          // Whether the video starts playing automatically when loaded.
          // On some browsers autoplay will only work with `muted: true`
          autoplay: !0,
          // @option loop: Boolean = true
          // Whether the video will loop back to the beginning when played.
          loop: !0,
          // @option keepAspectRatio: Boolean = true
          // Whether the video will save aspect ratio after the projection.
          // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
          keepAspectRatio: !0,
          // @option muted: Boolean = false
          // Whether the video starts on mute when loaded.
          muted: !1,
          // @option playsInline: Boolean = true
          // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
          playsInline: !0
        },
        _initImage: function() {
          var p = this._url.tagName === "VIDEO", y = this._image = p ? this._url : Ln("video");
          if (jt(y, "leaflet-image-layer"), this._zoomAnimated && jt(y, "leaflet-zoom-animated"), this.options.className && jt(y, this.options.className), y.onselectstart = $, y.onmousemove = $, y.onloadeddata = d(this.fire, this, "load"), p) {
            for (var T = y.getElementsByTagName("source"), F = [], j = 0; j < T.length; j++)
              F.push(T[j].src);
            this._url = T.length > 0 ? F : [y.src];
            return;
          }
          U(this._url) || (this._url = [this._url]), !this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(y.style, "objectFit") && (y.style.objectFit = "fill"), y.autoplay = !!this.options.autoplay, y.loop = !!this.options.loop, y.muted = !!this.options.muted, y.playsInline = !!this.options.playsInline;
          for (var ge = 0; ge < this._url.length; ge++) {
            var xe = Ln("source");
            xe.src = this._url[ge], y.appendChild(xe);
          }
        }
        // @method getElement(): HTMLVideoElement
        // Returns the instance of [`HTMLVideoElement`](https://developer.mozilla.org/docs/Web/API/HTMLVideoElement)
        // used by this overlay.
      });
      function af(p, y, T) {
        return new To(p, y, T);
      }
      var rp = Yo.extend({
        _initImage: function() {
          var p = this._image = this._url;
          jt(p, "leaflet-image-layer"), this._zoomAnimated && jt(p, "leaflet-zoom-animated"), this.options.className && jt(p, this.options.className), p.onselectstart = $, p.onmousemove = $;
        }
        // @method getElement(): SVGElement
        // Returns the instance of [`SVGElement`](https://developer.mozilla.org/docs/Web/API/SVGElement)
        // used by this overlay.
      });
      function lf(p, y, T) {
        return new rp(p, y, T);
      }
      var Xr = is.extend({
        // @section
        // @aka DivOverlay options
        options: {
          // @option interactive: Boolean = false
          // If true, the popup/tooltip will listen to the mouse events.
          interactive: !1,
          // @option offset: Point = Point(0, 0)
          // The offset of the overlay position.
          offset: [0, 0],
          // @option className: String = ''
          // A custom CSS class name to assign to the overlay.
          className: "",
          // @option pane: String = undefined
          // `Map pane` where the overlay will be added.
          pane: void 0,
          // @option content: String|HTMLElement|Function = ''
          // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
          // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
          content: ""
        },
        initialize: function(p, y) {
          p && (p instanceof Le || U(p)) ? (this._latlng = Je(p), B(this, y)) : (B(this, p), this._source = y), this.options.content && (this._content = this.options.content);
        },
        // @method openOn(map: Map): this
        // Adds the overlay to the map.
        // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
        openOn: function(p) {
          return p = arguments.length ? p : this._source._map, p.hasLayer(this) || p.addLayer(this), this;
        },
        // @method close(): this
        // Closes the overlay.
        // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
        // and `layer.closePopup()`/`.closeTooltip()`.
        close: function() {
          return this._map && this._map.removeLayer(this), this;
        },
        // @method toggle(layer?: Layer): this
        // Opens or closes the overlay bound to layer depending on its current state.
        // Argument may be omitted only for overlay bound to layer.
        // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
        toggle: function(p) {
          return this._map ? this.close() : (arguments.length ? this._source = p : p = this._source, this._prepareOpen(), this.openOn(p._map)), this;
        },
        onAdd: function(p) {
          this._zoomAnimated = p._zoomAnimated, this._container || this._initLayout(), p._fadeAnimated && Mt(this._container, 0), clearTimeout(this._removeTimeout), this.getPane().appendChild(this._container), this.update(), p._fadeAnimated && Mt(this._container, 1), this.bringToFront(), this.options.interactive && (jt(this._container, "leaflet-interactive"), this.addInteractiveTarget(this._container));
        },
        onRemove: function(p) {
          p._fadeAnimated ? (Mt(this._container, 0), this._removeTimeout = setTimeout(d(xi, void 0, this._container), 200)) : xi(this._container), this.options.interactive && (hi(this._container, "leaflet-interactive"), this.removeInteractiveTarget(this._container));
        },
        // @namespace DivOverlay
        // @method getLatLng: LatLng
        // Returns the geographical point of the overlay.
        getLatLng: function() {
          return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Sets the geographical point where the overlay will open.
        setLatLng: function(p) {
          return this._latlng = Je(p), this._map && (this._updatePosition(), this._adjustPan()), this;
        },
        // @method getContent: String|HTMLElement
        // Returns the content of the overlay.
        getContent: function() {
          return this._content;
        },
        // @method setContent(htmlContent: String|HTMLElement|Function): this
        // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
        // The function should return a `String` or `HTMLElement` to be used in the overlay.
        setContent: function(p) {
          return this._content = p, this.update(), this;
        },
        // @method getElement: String|HTMLElement
        // Returns the HTML container of the overlay.
        getElement: function() {
          return this._container;
        },
        // @method update: null
        // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
        update: function() {
          this._map && (this._container.style.visibility = "hidden", this._updateContent(), this._updateLayout(), this._updatePosition(), this._container.style.visibility = "", this._adjustPan());
        },
        getEvents: function() {
          var p = {
            zoom: this._updatePosition,
            viewreset: this._updatePosition
          };
          return this._zoomAnimated && (p.zoomanim = this._animateZoom), p;
        },
        // @method isOpen: Boolean
        // Returns `true` when the overlay is visible on the map.
        isOpen: function() {
          return !!this._map && this._map.hasLayer(this);
        },
        // @method bringToFront: this
        // Brings this overlay in front of other overlays (in the same map pane).
        bringToFront: function() {
          return this._map && Hs(this._container), this;
        },
        // @method bringToBack: this
        // Brings this overlay to the back of other overlays (in the same map pane).
        bringToBack: function() {
          return this._map && ms(this._container), this;
        },
        // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
        _prepareOpen: function(p) {
          var y = this._source;
          if (!y._map)
            return !1;
          if (y instanceof ys) {
            y = null;
            var T = this._source._layers;
            for (var F in T)
              if (T[F]._map) {
                y = T[F];
                break;
              }
            if (!y)
              return !1;
            this._source = y;
          }
          if (!p)
            if (y.getCenter)
              p = y.getCenter();
            else if (y.getLatLng)
              p = y.getLatLng();
            else if (y.getBounds)
              p = y.getBounds().getCenter();
            else
              throw new Error("Unable to get source layer LatLng.");
          return this.setLatLng(p), this._map && this.update(), !0;
        },
        _updateContent: function() {
          if (this._content) {
            var p = this._contentNode, y = typeof this._content == "function" ? this._content(this._source || this) : this._content;
            if (typeof y == "string")
              p.innerHTML = y;
            else {
              for (; p.hasChildNodes(); )
                p.removeChild(p.firstChild);
              p.appendChild(y);
            }
            this.fire("contentupdate");
          }
        },
        _updatePosition: function() {
          if (this._map) {
            var p = this._map.latLngToLayerPoint(this._latlng), y = De(this.options.offset), T = this._getAnchor();
            this._zoomAnimated ? Xn(this._container, p.add(T)) : y = y.add(p).add(T);
            var F = this._containerBottom = -y.y, j = this._containerLeft = -Math.round(this._containerWidth / 2) + y.x;
            this._container.style.bottom = F + "px", this._container.style.left = j + "px";
          }
        },
        _getAnchor: function() {
          return [0, 0];
        }
      });
      Jn.include({
        _initOverlay: function(p, y, T, F) {
          var j = y;
          return j instanceof p || (j = new p(F).setContent(y)), T && j.setLatLng(T), j;
        }
      }), is.include({
        _initOverlay: function(p, y, T, F) {
          var j = T;
          return j instanceof p ? (B(j, F), j._source = this) : (j = y && !F ? y : new p(F, this), j.setContent(T)), j;
        }
      });
      var Ko = Xr.extend({
        // @section
        // @aka Popup options
        options: {
          // @option pane: String = 'popupPane'
          // `Map pane` where the popup will be added.
          pane: "popupPane",
          // @option offset: Point = Point(0, 7)
          // The offset of the popup position.
          offset: [0, 7],
          // @option maxWidth: Number = 300
          // Max width of the popup, in pixels.
          maxWidth: 300,
          // @option minWidth: Number = 50
          // Min width of the popup, in pixels.
          minWidth: 50,
          // @option maxHeight: Number = null
          // If set, creates a scrollable container of the given height
          // inside a popup if its content exceeds it.
          // The scrollable container can be styled using the
          // `leaflet-popup-scrolled` CSS class selector.
          maxHeight: null,
          // @option autoPan: Boolean = true
          // Set it to `false` if you don't want the map to do panning animation
          // to fit the opened popup.
          autoPan: !0,
          // @option autoPanPaddingTopLeft: Point = null
          // The margin between the popup and the top left corner of the map
          // view after autopanning was performed.
          autoPanPaddingTopLeft: null,
          // @option autoPanPaddingBottomRight: Point = null
          // The margin between the popup and the bottom right corner of the map
          // view after autopanning was performed.
          autoPanPaddingBottomRight: null,
          // @option autoPanPadding: Point = Point(5, 5)
          // Equivalent of setting both top left and bottom right autopan padding to the same value.
          autoPanPadding: [5, 5],
          // @option keepInView: Boolean = false
          // Set it to `true` if you want to prevent users from panning the popup
          // off of the screen while it is open.
          keepInView: !1,
          // @option closeButton: Boolean = true
          // Controls the presence of a close button in the popup.
          closeButton: !0,
          // @option autoClose: Boolean = true
          // Set it to `false` if you want to override the default behavior of
          // the popup closing when another popup is opened.
          autoClose: !0,
          // @option closeOnEscapeKey: Boolean = true
          // Set it to `false` if you want to override the default behavior of
          // the ESC key for closing of the popup.
          closeOnEscapeKey: !0,
          // @option closeOnClick: Boolean = *
          // Set it if you want to override the default behavior of the popup closing when user clicks
          // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
          // @option className: String = ''
          // A custom CSS class name to assign to the popup.
          className: ""
        },
        // @namespace Popup
        // @method openOn(map: Map): this
        // Alternative to `map.openPopup(popup)`.
        // Adds the popup to the map and closes the previous one.
        openOn: function(p) {
          return p = arguments.length ? p : this._source._map, !p.hasLayer(this) && p._popup && p._popup.options.autoClose && p.removeLayer(p._popup), p._popup = this, Xr.prototype.openOn.call(this, p);
        },
        onAdd: function(p) {
          Xr.prototype.onAdd.call(this, p), p.fire("popupopen", { popup: this }), this._source && (this._source.fire("popupopen", { popup: this }, !0), this._source instanceof co || this._source.on("preclick", So));
        },
        onRemove: function(p) {
          Xr.prototype.onRemove.call(this, p), p.fire("popupclose", { popup: this }), this._source && (this._source.fire("popupclose", { popup: this }, !0), this._source instanceof co || this._source.off("preclick", So));
        },
        getEvents: function() {
          var p = Xr.prototype.getEvents.call(this);
          return (this.options.closeOnClick !== void 0 ? this.options.closeOnClick : this._map.options.closePopupOnClick) && (p.preclick = this.close), this.options.keepInView && (p.moveend = this._adjustPan), p;
        },
        _initLayout: function() {
          var p = "leaflet-popup", y = this._container = Ln(
            "div",
            p + " " + (this.options.className || "") + " leaflet-zoom-animated"
          ), T = this._wrapper = Ln("div", p + "-content-wrapper", y);
          if (this._contentNode = Ln("div", p + "-content", T), Ho(y), pl(this._contentNode), Mn(y, "contextmenu", So), this._tipContainer = Ln("div", p + "-tip-container", y), this._tip = Ln("div", p + "-tip", this._tipContainer), this.options.closeButton) {
            var F = this._closeButton = Ln("a", p + "-close-button", y);
            F.setAttribute("role", "button"), F.setAttribute("aria-label", "Close popup"), F.href = "#close", F.innerHTML = '<span aria-hidden="true">&#215;</span>', Mn(F, "click", function(j) {
              lr(j), this.close();
            }, this);
          }
        },
        _updateLayout: function() {
          var p = this._contentNode, y = p.style;
          y.width = "", y.whiteSpace = "nowrap";
          var T = p.offsetWidth;
          T = Math.min(T, this.options.maxWidth), T = Math.max(T, this.options.minWidth), y.width = T + 1 + "px", y.whiteSpace = "", y.height = "";
          var F = p.offsetHeight, j = this.options.maxHeight, ge = "leaflet-popup-scrolled";
          j && F > j ? (y.height = j + "px", jt(p, ge)) : hi(p, ge), this._containerWidth = this._container.offsetWidth;
        },
        _animateZoom: function(p) {
          var y = this._map._latLngToNewLayerPoint(this._latlng, p.zoom, p.center), T = this._getAnchor();
          Xn(this._container, y.add(T));
        },
        _adjustPan: function() {
          if (this.options.autoPan) {
            if (this._map._panAnim && this._map._panAnim.stop(), this._autopanning) {
              this._autopanning = !1;
              return;
            }
            var p = this._map, y = parseInt(ao(this._container, "marginBottom"), 10) || 0, T = this._container.offsetHeight + y, F = this._containerWidth, j = new et(this._containerLeft, -T - this._containerBottom);
            j._add(ya(this._container));
            var ge = p.layerPointToContainerPoint(j), xe = De(this.options.autoPanPadding), Ve = De(this.options.autoPanPaddingTopLeft || xe), pt = De(this.options.autoPanPaddingBottomRight || xe), $t = p.getSize(), Jt = 0, pn = 0;
            ge.x + F + pt.x > $t.x && (Jt = ge.x + F - $t.x + pt.x), ge.x - Jt - Ve.x < 0 && (Jt = ge.x - Ve.x), ge.y + T + pt.y > $t.y && (pn = ge.y + T - $t.y + pt.y), ge.y - pn - Ve.y < 0 && (pn = ge.y - Ve.y), (Jt || pn) && (this.options.keepInView && (this._autopanning = !0), p.fire("autopanstart").panBy([Jt, pn]));
          }
        },
        _getAnchor: function() {
          return De(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [0, 0]);
        }
      }), po = function(p, y) {
        return new Ko(p, y);
      };
      Jn.mergeOptions({
        closePopupOnClick: !0
      }), Jn.include({
        // @method openPopup(popup: Popup): this
        // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
        // @alternative
        // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
        // Creates a popup with the specified content and options and opens it in the given point on a map.
        openPopup: function(p, y, T) {
          return this._initOverlay(Ko, p, y, T).openOn(this), this;
        },
        // @method closePopup(popup?: Popup): this
        // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
        closePopup: function(p) {
          return p = arguments.length ? p : this._popup, p && p.close(), this;
        }
      }), is.include({
        // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
        // Binds a popup to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindPopup: function(p, y) {
          return this._popup = this._initOverlay(Ko, this._popup, p, y), this._popupHandlersAdded || (this.on({
            click: this._openPopup,
            keypress: this._onKeyPress,
            remove: this.closePopup,
            move: this._movePopup
          }), this._popupHandlersAdded = !0), this;
        },
        // @method unbindPopup(): this
        // Removes the popup previously bound with `bindPopup`.
        unbindPopup: function() {
          return this._popup && (this.off({
            click: this._openPopup,
            keypress: this._onKeyPress,
            remove: this.closePopup,
            move: this._movePopup
          }), this._popupHandlersAdded = !1, this._popup = null), this;
        },
        // @method openPopup(latlng?: LatLng): this
        // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
        openPopup: function(p) {
          return this._popup && (this instanceof ys || (this._popup._source = this), this._popup._prepareOpen(p || this._latlng) && this._popup.openOn(this._map)), this;
        },
        // @method closePopup(): this
        // Closes the popup bound to this layer if it is open.
        closePopup: function() {
          return this._popup && this._popup.close(), this;
        },
        // @method togglePopup(): this
        // Opens or closes the popup bound to this layer depending on its current state.
        togglePopup: function() {
          return this._popup && this._popup.toggle(this), this;
        },
        // @method isPopupOpen(): boolean
        // Returns `true` if the popup bound to this layer is currently open.
        isPopupOpen: function() {
          return this._popup ? this._popup.isOpen() : !1;
        },
        // @method setPopupContent(content: String|HTMLElement|Popup): this
        // Sets the content of the popup bound to this layer.
        setPopupContent: function(p) {
          return this._popup && this._popup.setContent(p), this;
        },
        // @method getPopup(): Popup
        // Returns the popup bound to this layer.
        getPopup: function() {
          return this._popup;
        },
        _openPopup: function(p) {
          if (!(!this._popup || !this._map)) {
            Zs(p);
            var y = p.layer || p.target;
            if (this._popup._source === y && !(y instanceof co)) {
              this._map.hasLayer(this._popup) ? this.closePopup() : this.openPopup(p.latlng);
              return;
            }
            this._popup._source = y, this.openPopup(p.latlng);
          }
        },
        _movePopup: function(p) {
          this._popup.setLatLng(p.latlng);
        },
        _onKeyPress: function(p) {
          p.originalEvent.keyCode === 13 && this._openPopup(p);
        }
      });
      var Zt = Xr.extend({
        // @section
        // @aka Tooltip options
        options: {
          // @option pane: String = 'tooltipPane'
          // `Map pane` where the tooltip will be added.
          pane: "tooltipPane",
          // @option offset: Point = Point(0, 0)
          // Optional offset of the tooltip position.
          offset: [0, 0],
          // @option direction: String = 'auto'
          // Direction where to open the tooltip. Possible values are: `right`, `left`,
          // `top`, `bottom`, `center`, `auto`.
          // `auto` will dynamically switch between `right` and `left` according to the tooltip
          // position on the map.
          direction: "auto",
          // @option permanent: Boolean = false
          // Whether to open the tooltip permanently or only on mouseover.
          permanent: !1,
          // @option sticky: Boolean = false
          // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
          sticky: !1,
          // @option opacity: Number = 0.9
          // Tooltip container opacity.
          opacity: 0.9
        },
        onAdd: function(p) {
          Xr.prototype.onAdd.call(this, p), this.setOpacity(this.options.opacity), p.fire("tooltipopen", { tooltip: this }), this._source && (this.addEventParent(this._source), this._source.fire("tooltipopen", { tooltip: this }, !0));
        },
        onRemove: function(p) {
          Xr.prototype.onRemove.call(this, p), p.fire("tooltipclose", { tooltip: this }), this._source && (this.removeEventParent(this._source), this._source.fire("tooltipclose", { tooltip: this }, !0));
        },
        getEvents: function() {
          var p = Xr.prototype.getEvents.call(this);
          return this.options.permanent || (p.preclick = this.close), p;
        },
        _initLayout: function() {
          var p = "leaflet-tooltip", y = p + " " + (this.options.className || "") + " leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
          this._contentNode = this._container = Ln("div", y), this._container.setAttribute("role", "tooltip"), this._container.setAttribute("id", "leaflet-tooltip-" + f(this));
        },
        _updateLayout: function() {
        },
        _adjustPan: function() {
        },
        _setPosition: function(p) {
          var y, T, F = this._map, j = this._container, ge = F.latLngToContainerPoint(F.getCenter()), xe = F.layerPointToContainerPoint(p), Ve = this.options.direction, pt = j.offsetWidth, $t = j.offsetHeight, Jt = De(this.options.offset), pn = this._getAnchor();
          Ve === "top" ? (y = pt / 2, T = $t) : Ve === "bottom" ? (y = pt / 2, T = 0) : Ve === "center" ? (y = pt / 2, T = $t / 2) : Ve === "right" ? (y = 0, T = $t / 2) : Ve === "left" ? (y = pt, T = $t / 2) : xe.x < ge.x ? (Ve = "right", y = 0, T = $t / 2) : (Ve = "left", y = pt + (Jt.x + pn.x) * 2, T = $t / 2), p = p.subtract(De(y, T, !0)).add(Jt).add(pn), hi(j, "leaflet-tooltip-right"), hi(j, "leaflet-tooltip-left"), hi(j, "leaflet-tooltip-top"), hi(j, "leaflet-tooltip-bottom"), jt(j, "leaflet-tooltip-" + Ve), Xn(j, p);
        },
        _updatePosition: function() {
          var p = this._map.latLngToLayerPoint(this._latlng);
          this._setPosition(p);
        },
        setOpacity: function(p) {
          this.options.opacity = p, this._container && Mt(this._container, p);
        },
        _animateZoom: function(p) {
          var y = this._map._latLngToNewLayerPoint(this._latlng, p.zoom, p.center);
          this._setPosition(y);
        },
        _getAnchor: function() {
          return De(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [0, 0]);
        }
      }), Jc = function(p, y) {
        return new Zt(p, y);
      };
      Jn.include({
        // @method openTooltip(tooltip: Tooltip): this
        // Opens the specified tooltip.
        // @alternative
        // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
        // Creates a tooltip with the specified content and options and open it.
        openTooltip: function(p, y, T) {
          return this._initOverlay(Zt, p, y, T).openOn(this), this;
        },
        // @method closeTooltip(tooltip: Tooltip): this
        // Closes the tooltip given as parameter.
        closeTooltip: function(p) {
          return p.close(), this;
        }
      }), is.include({
        // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
        // Binds a tooltip to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindTooltip: function(p, y) {
          return this._tooltip && this.isTooltipOpen() && this.unbindTooltip(), this._tooltip = this._initOverlay(Zt, this._tooltip, p, y), this._initTooltipInteractions(), this._tooltip.options.permanent && this._map && this._map.hasLayer(this) && this.openTooltip(), this;
        },
        // @method unbindTooltip(): this
        // Removes the tooltip previously bound with `bindTooltip`.
        unbindTooltip: function() {
          return this._tooltip && (this._initTooltipInteractions(!0), this.closeTooltip(), this._tooltip = null), this;
        },
        _initTooltipInteractions: function(p) {
          if (!(!p && this._tooltipHandlersAdded)) {
            var y = p ? "off" : "on", T = {
              remove: this.closeTooltip,
              move: this._moveTooltip
            };
            this._tooltip.options.permanent ? T.add = this._openTooltip : (T.mouseover = this._openTooltip, T.mouseout = this.closeTooltip, T.click = this._openTooltip, this._map ? this._addFocusListeners() : T.add = this._addFocusListeners), this._tooltip.options.sticky && (T.mousemove = this._moveTooltip), this[y](T), this._tooltipHandlersAdded = !p;
          }
        },
        // @method openTooltip(latlng?: LatLng): this
        // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
        openTooltip: function(p) {
          return this._tooltip && (this instanceof ys || (this._tooltip._source = this), this._tooltip._prepareOpen(p) && (this._tooltip.openOn(this._map), this.getElement ? this._setAriaDescribedByOnLayer(this) : this.eachLayer && this.eachLayer(this._setAriaDescribedByOnLayer, this))), this;
        },
        // @method closeTooltip(): this
        // Closes the tooltip bound to this layer if it is open.
        closeTooltip: function() {
          if (this._tooltip)
            return this._tooltip.close();
        },
        // @method toggleTooltip(): this
        // Opens or closes the tooltip bound to this layer depending on its current state.
        toggleTooltip: function() {
          return this._tooltip && this._tooltip.toggle(this), this;
        },
        // @method isTooltipOpen(): boolean
        // Returns `true` if the tooltip bound to this layer is currently open.
        isTooltipOpen: function() {
          return this._tooltip.isOpen();
        },
        // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
        // Sets the content of the tooltip bound to this layer.
        setTooltipContent: function(p) {
          return this._tooltip && this._tooltip.setContent(p), this;
        },
        // @method getTooltip(): Tooltip
        // Returns the tooltip bound to this layer.
        getTooltip: function() {
          return this._tooltip;
        },
        _addFocusListeners: function() {
          this.getElement ? this._addFocusListenersOnLayer(this) : this.eachLayer && this.eachLayer(this._addFocusListenersOnLayer, this);
        },
        _addFocusListenersOnLayer: function(p) {
          var y = typeof p.getElement == "function" && p.getElement();
          y && (Mn(y, "focus", function() {
            this._tooltip._source = p, this.openTooltip();
          }, this), Mn(y, "blur", this.closeTooltip, this));
        },
        _setAriaDescribedByOnLayer: function(p) {
          var y = typeof p.getElement == "function" && p.getElement();
          y && y.setAttribute("aria-describedby", this._tooltip._container.id);
        },
        _openTooltip: function(p) {
          if (!(!this._tooltip || !this._map)) {
            if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
              this._openOnceFlag = !0;
              var y = this;
              this._map.once("moveend", function() {
                y._openOnceFlag = !1, y._openTooltip(p);
              });
              return;
            }
            this._tooltip._source = p.layer || p.target, this.openTooltip(this._tooltip.options.sticky ? p.latlng : void 0);
          }
        },
        _moveTooltip: function(p) {
          var y = p.latlng, T, F;
          this._tooltip.options.sticky && p.originalEvent && (T = this._map.mouseEventToContainerPoint(p.originalEvent), F = this._map.containerPointToLayerPoint(T), y = this._map.layerPointToLatLng(F)), this._tooltip.setLatLng(y);
        }
      });
      var yl = ml.extend({
        options: {
          // @section
          // @aka DivIcon options
          iconSize: [12, 12],
          // also can be set through CSS
          // iconAnchor: (Point),
          // popupAnchor: (Point),
          // @option html: String|HTMLElement = ''
          // Custom HTML code to put inside the div element, empty by default. Alternatively,
          // an instance of `HTMLElement`.
          html: !1,
          // @option bgPos: Point = [0, 0]
          // Optional relative position of the background, in pixels
          bgPos: null,
          className: "leaflet-div-icon"
        },
        createIcon: function(p) {
          var y = p && p.tagName === "DIV" ? p : document.createElement("div"), T = this.options;
          if (T.html instanceof Element ? (Ki(y), y.appendChild(T.html)) : y.innerHTML = T.html !== !1 ? T.html : "", T.bgPos) {
            var F = De(T.bgPos);
            y.style.backgroundPosition = -F.x + "px " + -F.y + "px";
          }
          return this._setIconStyles(y, "icon"), y;
        },
        createShadow: function() {
          return null;
        }
      });
      function Io(p) {
        return new yl(p);
      }
      ml.Default = Fi;
      var _l = is.extend({
        // @section
        // @aka GridLayer options
        options: {
          // @option tileSize: Number|Point = 256
          // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
          tileSize: 256,
          // @option opacity: Number = 1.0
          // Opacity of the tiles. Can be used in the `createTile()` function.
          opacity: 1,
          // @option updateWhenIdle: Boolean = (depends)
          // Load new tiles only when panning ends.
          // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
          // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
          // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
          updateWhenIdle: nt.mobile,
          // @option updateWhenZooming: Boolean = true
          // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
          updateWhenZooming: !0,
          // @option updateInterval: Number = 200
          // Tiles will not update more than once every `updateInterval` milliseconds when panning.
          updateInterval: 200,
          // @option zIndex: Number = 1
          // The explicit zIndex of the tile layer.
          zIndex: 1,
          // @option bounds: LatLngBounds = undefined
          // If set, tiles will only be loaded inside the set `LatLngBounds`.
          bounds: null,
          // @option minZoom: Number = 0
          // The minimum zoom level down to which this layer will be displayed (inclusive).
          minZoom: 0,
          // @option maxZoom: Number = undefined
          // The maximum zoom level up to which this layer will be displayed (inclusive).
          maxZoom: void 0,
          // @option maxNativeZoom: Number = undefined
          // Maximum zoom number the tile source has available. If it is specified,
          // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
          // from `maxNativeZoom` level and auto-scaled.
          maxNativeZoom: void 0,
          // @option minNativeZoom: Number = undefined
          // Minimum zoom number the tile source has available. If it is specified,
          // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
          // from `minNativeZoom` level and auto-scaled.
          minNativeZoom: void 0,
          // @option noWrap: Boolean = false
          // Whether the layer is wrapped around the antimeridian. If `true`, the
          // GridLayer will only be displayed once at low zoom levels. Has no
          // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
          // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
          // tiles outside the CRS limits.
          noWrap: !1,
          // @option pane: String = 'tilePane'
          // `Map pane` where the grid layer will be added.
          pane: "tilePane",
          // @option className: String = ''
          // A custom class name to assign to the tile layer. Empty by default.
          className: "",
          // @option keepBuffer: Number = 2
          // When panning the map, keep this many rows and columns of tiles before unloading them.
          keepBuffer: 2
        },
        initialize: function(p) {
          B(this, p);
        },
        onAdd: function() {
          this._initContainer(), this._levels = {}, this._tiles = {}, this._resetView();
        },
        beforeAdd: function(p) {
          p._addZoomLimit(this);
        },
        onRemove: function(p) {
          this._removeAllTiles(), xi(this._container), p._removeZoomLimit(this), this._container = null, this._tileZoom = void 0;
        },
        // @method bringToFront: this
        // Brings the tile layer to the top of all tile layers.
        bringToFront: function() {
          return this._map && (Hs(this._container), this._setAutoZIndex(Math.max)), this;
        },
        // @method bringToBack: this
        // Brings the tile layer to the bottom of all tile layers.
        bringToBack: function() {
          return this._map && (ms(this._container), this._setAutoZIndex(Math.min)), this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the tiles for this layer.
        getContainer: function() {
          return this._container;
        },
        // @method setOpacity(opacity: Number): this
        // Changes the [opacity](#gridlayer-opacity) of the grid layer.
        setOpacity: function(p) {
          return this.options.opacity = p, this._updateOpacity(), this;
        },
        // @method setZIndex(zIndex: Number): this
        // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
        setZIndex: function(p) {
          return this.options.zIndex = p, this._updateZIndex(), this;
        },
        // @method isLoading: Boolean
        // Returns `true` if any tile in the grid layer has not finished loading.
        isLoading: function() {
          return this._loading;
        },
        // @method redraw: this
        // Causes the layer to clear all the tiles and request them again.
        redraw: function() {
          if (this._map) {
            this._removeAllTiles();
            var p = this._clampZoom(this._map.getZoom());
            p !== this._tileZoom && (this._tileZoom = p, this._updateLevels()), this._update();
          }
          return this;
        },
        getEvents: function() {
          var p = {
            viewprereset: this._invalidateAll,
            viewreset: this._resetView,
            zoom: this._resetView,
            moveend: this._onMoveEnd
          };
          return this.options.updateWhenIdle || (this._onMove || (this._onMove = g(this._onMoveEnd, this.options.updateInterval, this)), p.move = this._onMove), this._zoomAnimated && (p.zoomanim = this._animateZoom), p;
        },
        // @section Extension methods
        // Layers extending `GridLayer` shall reimplement the following method.
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, must be overridden by classes extending `GridLayer`.
        // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
        // is specified, it must be called when the tile has finished loading and drawing.
        createTile: function() {
          return document.createElement("div");
        },
        // @section
        // @method getTileSize: Point
        // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
        getTileSize: function() {
          var p = this.options.tileSize;
          return p instanceof et ? p : new et(p, p);
        },
        _updateZIndex: function() {
          this._container && this.options.zIndex !== void 0 && this.options.zIndex !== null && (this._container.style.zIndex = this.options.zIndex);
        },
        _setAutoZIndex: function(p) {
          for (var y = this.getPane().children, T = -p(-1 / 0, 1 / 0), F = 0, j = y.length, ge; F < j; F++)
            ge = y[F].style.zIndex, y[F] !== this._container && ge && (T = p(T, +ge));
          isFinite(T) && (this.options.zIndex = T + p(-1, 1), this._updateZIndex());
        },
        _updateOpacity: function() {
          if (this._map && !nt.ielt9) {
            Mt(this._container, this.options.opacity);
            var p = +/* @__PURE__ */ new Date(), y = !1, T = !1;
            for (var F in this._tiles) {
              var j = this._tiles[F];
              if (!(!j.current || !j.loaded)) {
                var ge = Math.min(1, (p - j.loaded) / 200);
                Mt(j.el, ge), ge < 1 ? y = !0 : (j.active ? T = !0 : this._onOpaqueTile(j), j.active = !0);
              }
            }
            T && !this._noPrune && this._pruneTiles(), y && (re(this._fadeFrame), this._fadeFrame = ve(this._updateOpacity, this));
          }
        },
        _onOpaqueTile: $,
        _initContainer: function() {
          this._container || (this._container = Ln("div", "leaflet-layer " + (this.options.className || "")), this._updateZIndex(), this.options.opacity < 1 && this._updateOpacity(), this.getPane().appendChild(this._container));
        },
        _updateLevels: function() {
          var p = this._tileZoom, y = this.options.maxZoom;
          if (p !== void 0) {
            for (var T in this._levels)
              T = Number(T), this._levels[T].el.children.length || T === p ? (this._levels[T].el.style.zIndex = y - Math.abs(p - T), this._onUpdateLevel(T)) : (xi(this._levels[T].el), this._removeTilesAtZoom(T), this._onRemoveLevel(T), delete this._levels[T]);
            var F = this._levels[p], j = this._map;
            return F || (F = this._levels[p] = {}, F.el = Ln("div", "leaflet-tile-container leaflet-zoom-animated", this._container), F.el.style.zIndex = y, F.origin = j.project(j.unproject(j.getPixelOrigin()), p).round(), F.zoom = p, this._setZoomTransform(F, j.getCenter(), j.getZoom()), $(F.el.offsetWidth), this._onCreateLevel(F)), this._level = F, F;
          }
        },
        _onUpdateLevel: $,
        _onRemoveLevel: $,
        _onCreateLevel: $,
        _pruneTiles: function() {
          if (this._map) {
            var p, y, T = this._map.getZoom();
            if (T > this.options.maxZoom || T < this.options.minZoom) {
              this._removeAllTiles();
              return;
            }
            for (p in this._tiles)
              y = this._tiles[p], y.retain = y.current;
            for (p in this._tiles)
              if (y = this._tiles[p], y.current && !y.active) {
                var F = y.coords;
                this._retainParent(F.x, F.y, F.z, F.z - 5) || this._retainChildren(F.x, F.y, F.z, F.z + 2);
              }
            for (p in this._tiles)
              this._tiles[p].retain || this._removeTile(p);
          }
        },
        _removeTilesAtZoom: function(p) {
          for (var y in this._tiles)
            this._tiles[y].coords.z === p && this._removeTile(y);
        },
        _removeAllTiles: function() {
          for (var p in this._tiles)
            this._removeTile(p);
        },
        _invalidateAll: function() {
          for (var p in this._levels)
            xi(this._levels[p].el), this._onRemoveLevel(Number(p)), delete this._levels[p];
          this._removeAllTiles(), this._tileZoom = void 0;
        },
        _retainParent: function(p, y, T, F) {
          var j = Math.floor(p / 2), ge = Math.floor(y / 2), xe = T - 1, Ve = new et(+j, +ge);
          Ve.z = +xe;
          var pt = this._tileCoordsToKey(Ve), $t = this._tiles[pt];
          return $t && $t.active ? ($t.retain = !0, !0) : ($t && $t.loaded && ($t.retain = !0), xe > F ? this._retainParent(j, ge, xe, F) : !1);
        },
        _retainChildren: function(p, y, T, F) {
          for (var j = 2 * p; j < 2 * p + 2; j++)
            for (var ge = 2 * y; ge < 2 * y + 2; ge++) {
              var xe = new et(j, ge);
              xe.z = T + 1;
              var Ve = this._tileCoordsToKey(xe), pt = this._tiles[Ve];
              if (pt && pt.active) {
                pt.retain = !0;
                continue;
              } else pt && pt.loaded && (pt.retain = !0);
              T + 1 < F && this._retainChildren(j, ge, T + 1, F);
            }
        },
        _resetView: function(p) {
          var y = p && (p.pinch || p.flyTo);
          this._setView(this._map.getCenter(), this._map.getZoom(), y, y);
        },
        _animateZoom: function(p) {
          this._setView(p.center, p.zoom, !0, p.noUpdate);
        },
        _clampZoom: function(p) {
          var y = this.options;
          return y.minNativeZoom !== void 0 && p < y.minNativeZoom ? y.minNativeZoom : y.maxNativeZoom !== void 0 && y.maxNativeZoom < p ? y.maxNativeZoom : p;
        },
        _setView: function(p, y, T, F) {
          var j = Math.round(y);
          this.options.maxZoom !== void 0 && j > this.options.maxZoom || this.options.minZoom !== void 0 && j < this.options.minZoom ? j = void 0 : j = this._clampZoom(j);
          var ge = this.options.updateWhenZooming && j !== this._tileZoom;
          (!F || ge) && (this._tileZoom = j, this._abortLoading && this._abortLoading(), this._updateLevels(), this._resetGrid(), j !== void 0 && this._update(p), T || this._pruneTiles(), this._noPrune = !!T), this._setZoomTransforms(p, y);
        },
        _setZoomTransforms: function(p, y) {
          for (var T in this._levels)
            this._setZoomTransform(this._levels[T], p, y);
        },
        _setZoomTransform: function(p, y, T) {
          var F = this._map.getZoomScale(T, p.zoom), j = p.origin.multiplyBy(F).subtract(this._map._getNewPixelOrigin(y, T)).round();
          nt.any3d ? ti(p.el, j, F) : Xn(p.el, j);
        },
        _resetGrid: function() {
          var p = this._map, y = p.options.crs, T = this._tileSize = this.getTileSize(), F = this._tileZoom, j = this._map.getPixelWorldBounds(this._tileZoom);
          j && (this._globalTileRange = this._pxBoundsToTileRange(j)), this._wrapX = y.wrapLng && !this.options.noWrap && [
            Math.floor(p.project([0, y.wrapLng[0]], F).x / T.x),
            Math.ceil(p.project([0, y.wrapLng[1]], F).x / T.y)
          ], this._wrapY = y.wrapLat && !this.options.noWrap && [
            Math.floor(p.project([y.wrapLat[0], 0], F).y / T.x),
            Math.ceil(p.project([y.wrapLat[1], 0], F).y / T.y)
          ];
        },
        _onMoveEnd: function() {
          !this._map || this._map._animatingZoom || this._update();
        },
        _getTiledPixelBounds: function(p) {
          var y = this._map, T = y._animatingZoom ? Math.max(y._animateToZoom, y.getZoom()) : y.getZoom(), F = y.getZoomScale(T, this._tileZoom), j = y.project(p, this._tileZoom).floor(), ge = y.getSize().divideBy(F * 2);
          return new Ke(j.subtract(ge), j.add(ge));
        },
        // Private method to load tiles in the grid's active zoom level according to map bounds
        _update: function(p) {
          var y = this._map;
          if (y) {
            var T = this._clampZoom(y.getZoom());
            if (p === void 0 && (p = y.getCenter()), this._tileZoom !== void 0) {
              var F = this._getTiledPixelBounds(p), j = this._pxBoundsToTileRange(F), ge = j.getCenter(), xe = [], Ve = this.options.keepBuffer, pt = new Ke(
                j.getBottomLeft().subtract([Ve, -Ve]),
                j.getTopRight().add([Ve, -Ve])
              );
              if (!(isFinite(j.min.x) && isFinite(j.min.y) && isFinite(j.max.x) && isFinite(j.max.y)))
                throw new Error("Attempted to load an infinite number of tiles");
              for (var $t in this._tiles) {
                var Jt = this._tiles[$t].coords;
                (Jt.z !== this._tileZoom || !pt.contains(new et(Jt.x, Jt.y))) && (this._tiles[$t].current = !1);
              }
              if (Math.abs(T - this._tileZoom) > 1) {
                this._setView(p, T);
                return;
              }
              for (var pn = j.min.y; pn <= j.max.y; pn++)
                for (var Hn = j.min.x; Hn <= j.max.x; Hn++) {
                  var Hi = new et(Hn, pn);
                  if (Hi.z = this._tileZoom, !!this._isValidTile(Hi)) {
                    var fr = this._tiles[this._tileCoordsToKey(Hi)];
                    fr ? fr.current = !0 : xe.push(Hi);
                  }
                }
              if (xe.sort(function(Kn, Ri) {
                return Kn.distanceTo(ge) - Ri.distanceTo(ge);
              }), xe.length !== 0) {
                this._loading || (this._loading = !0, this.fire("loading"));
                var ir = document.createDocumentFragment();
                for (Hn = 0; Hn < xe.length; Hn++)
                  this._addTile(xe[Hn], ir);
                this._level.el.appendChild(ir);
              }
            }
          }
        },
        _isValidTile: function(p) {
          var y = this._map.options.crs;
          if (!y.infinite) {
            var T = this._globalTileRange;
            if (!y.wrapLng && (p.x < T.min.x || p.x > T.max.x) || !y.wrapLat && (p.y < T.min.y || p.y > T.max.y))
              return !1;
          }
          if (!this.options.bounds)
            return !0;
          var F = this._tileCoordsToBounds(p);
          return rt(this.options.bounds).overlaps(F);
        },
        _keyToBounds: function(p) {
          return this._tileCoordsToBounds(this._keyToTileCoords(p));
        },
        _tileCoordsToNwSe: function(p) {
          var y = this._map, T = this.getTileSize(), F = p.scaleBy(T), j = F.add(T), ge = y.unproject(F, p.z), xe = y.unproject(j, p.z);
          return [ge, xe];
        },
        // converts tile coordinates to its geographical bounds
        _tileCoordsToBounds: function(p) {
          var y = this._tileCoordsToNwSe(p), T = new qe(y[0], y[1]);
          return this.options.noWrap || (T = this._map.wrapLatLngBounds(T)), T;
        },
        // converts tile coordinates to key for the tile cache
        _tileCoordsToKey: function(p) {
          return p.x + ":" + p.y + ":" + p.z;
        },
        // converts tile cache key to coordinates
        _keyToTileCoords: function(p) {
          var y = p.split(":"), T = new et(+y[0], +y[1]);
          return T.z = +y[2], T;
        },
        _removeTile: function(p) {
          var y = this._tiles[p];
          y && (xi(y.el), delete this._tiles[p], this.fire("tileunload", {
            tile: y.el,
            coords: this._keyToTileCoords(p)
          }));
        },
        _initTile: function(p) {
          jt(p, "leaflet-tile");
          var y = this.getTileSize();
          p.style.width = y.x + "px", p.style.height = y.y + "px", p.onselectstart = $, p.onmousemove = $, nt.ielt9 && this.options.opacity < 1 && Mt(p, this.options.opacity);
        },
        _addTile: function(p, y) {
          var T = this._getTilePos(p), F = this._tileCoordsToKey(p), j = this.createTile(this._wrapCoords(p), d(this._tileReady, this, p));
          this._initTile(j), this.createTile.length < 2 && ve(d(this._tileReady, this, p, null, j)), Xn(j, T), this._tiles[F] = {
            el: j,
            coords: p,
            current: !0
          }, y.appendChild(j), this.fire("tileloadstart", {
            tile: j,
            coords: p
          });
        },
        _tileReady: function(p, y, T) {
          y && this.fire("tileerror", {
            error: y,
            tile: T,
            coords: p
          });
          var F = this._tileCoordsToKey(p);
          T = this._tiles[F], T && (T.loaded = +/* @__PURE__ */ new Date(), this._map._fadeAnimated ? (Mt(T.el, 0), re(this._fadeFrame), this._fadeFrame = ve(this._updateOpacity, this)) : (T.active = !0, this._pruneTiles()), y || (jt(T.el, "leaflet-tile-loaded"), this.fire("tileload", {
            tile: T.el,
            coords: p
          })), this._noTilesToLoad() && (this._loading = !1, this.fire("load"), nt.ielt9 || !this._map._fadeAnimated ? ve(this._pruneTiles, this) : setTimeout(d(this._pruneTiles, this), 250)));
        },
        _getTilePos: function(p) {
          return p.scaleBy(this.getTileSize()).subtract(this._level.origin);
        },
        _wrapCoords: function(p) {
          var y = new et(
            this._wrapX ? x(p.x, this._wrapX) : p.x,
            this._wrapY ? x(p.y, this._wrapY) : p.y
          );
          return y.z = p.z, y;
        },
        _pxBoundsToTileRange: function(p) {
          var y = this.getTileSize();
          return new Ke(
            p.min.unscaleBy(y).floor(),
            p.max.unscaleBy(y).ceil().subtract([1, 1])
          );
        },
        _noTilesToLoad: function() {
          for (var p in this._tiles)
            if (!this._tiles[p].loaded)
              return !1;
          return !0;
        }
      });
      function Rt(p) {
        return new _l(p);
      }
      var Ao = _l.extend({
        // @section
        // @aka TileLayer options
        options: {
          // @option minZoom: Number = 0
          // The minimum zoom level down to which this layer will be displayed (inclusive).
          minZoom: 0,
          // @option maxZoom: Number = 18
          // The maximum zoom level up to which this layer will be displayed (inclusive).
          maxZoom: 18,
          // @option subdomains: String|String[] = 'abc'
          // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
          subdomains: "abc",
          // @option errorTileUrl: String = ''
          // URL to the tile image to show in place of the tile that failed to load.
          errorTileUrl: "",
          // @option zoomOffset: Number = 0
          // The zoom number used in tile URLs will be offset with this value.
          zoomOffset: 0,
          // @option tms: Boolean = false
          // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
          tms: !1,
          // @option zoomReverse: Boolean = false
          // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
          zoomReverse: !1,
          // @option detectRetina: Boolean = false
          // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
          detectRetina: !1,
          // @option crossOrigin: Boolean|String = false
          // Whether the crossOrigin attribute will be added to the tiles.
          // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
          // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
          crossOrigin: !1,
          // @option referrerPolicy: Boolean|String = false
          // Whether the referrerPolicy attribute will be added to the tiles.
          // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
          // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
          // (e.g. to validate an API token).
          // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
          referrerPolicy: !1
        },
        initialize: function(p, y) {
          this._url = p, y = B(this, y), y.detectRetina && nt.retina && y.maxZoom > 0 ? (y.tileSize = Math.floor(y.tileSize / 2), y.zoomReverse ? (y.zoomOffset--, y.minZoom = Math.min(y.maxZoom, y.minZoom + 1)) : (y.zoomOffset++, y.maxZoom = Math.max(y.minZoom, y.maxZoom - 1)), y.minZoom = Math.max(0, y.minZoom)) : y.zoomReverse ? y.minZoom = Math.min(y.maxZoom, y.minZoom) : y.maxZoom = Math.max(y.minZoom, y.maxZoom), typeof y.subdomains == "string" && (y.subdomains = y.subdomains.split("")), this.on("tileunload", this._onTileRemove);
        },
        // @method setUrl(url: String, noRedraw?: Boolean): this
        // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
        // If the URL does not change, the layer will not be redrawn unless
        // the noRedraw parameter is set to false.
        setUrl: function(p, y) {
          return this._url === p && y === void 0 && (y = !0), this._url = p, y || this.redraw(), this;
        },
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
        // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
        // callback is called when the tile has been loaded.
        createTile: function(p, y) {
          var T = document.createElement("img");
          return Mn(T, "load", d(this._tileOnLoad, this, y, T)), Mn(T, "error", d(this._tileOnError, this, y, T)), (this.options.crossOrigin || this.options.crossOrigin === "") && (T.crossOrigin = this.options.crossOrigin === !0 ? "" : this.options.crossOrigin), typeof this.options.referrerPolicy == "string" && (T.referrerPolicy = this.options.referrerPolicy), T.alt = "", T.src = this.getTileUrl(p), T;
        },
        // @section Extension methods
        // @uninheritable
        // Layers extending `TileLayer` might reimplement the following method.
        // @method getTileUrl(coords: Object): String
        // Called only internally, returns the URL for a tile given its coordinates.
        // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
        getTileUrl: function(p) {
          var y = {
            r: nt.retina ? "@2x" : "",
            s: this._getSubdomain(p),
            x: p.x,
            y: p.y,
            z: this._getZoomForUrl()
          };
          if (this._map && !this._map.options.crs.infinite) {
            var T = this._globalTileRange.max.y - p.y;
            this.options.tms && (y.y = T), y["-y"] = T;
          }
          return K(this._url, r(y, this.options));
        },
        _tileOnLoad: function(p, y) {
          nt.ielt9 ? setTimeout(d(p, this, null, y), 0) : p(null, y);
        },
        _tileOnError: function(p, y, T) {
          var F = this.options.errorTileUrl;
          F && y.getAttribute("src") !== F && (y.src = F), p(T, y);
        },
        _onTileRemove: function(p) {
          p.tile.onload = null;
        },
        _getZoomForUrl: function() {
          var p = this._tileZoom, y = this.options.maxZoom, T = this.options.zoomReverse, F = this.options.zoomOffset;
          return T && (p = y - p), p + F;
        },
        _getSubdomain: function(p) {
          var y = Math.abs(p.x + p.y) % this.options.subdomains.length;
          return this.options.subdomains[y];
        },
        // stops loading all tiles in the background layer
        _abortLoading: function() {
          var p, y;
          for (p in this._tiles)
            if (this._tiles[p].coords.z !== this._tileZoom && (y = this._tiles[p].el, y.onload = $, y.onerror = $, !y.complete)) {
              y.src = ee;
              var T = this._tiles[p].coords;
              xi(y), delete this._tiles[p], this.fire("tileabort", {
                tile: y,
                coords: T
              });
            }
        },
        _removeTile: function(p) {
          var y = this._tiles[p];
          if (y)
            return y.el.setAttribute("src", ee), _l.prototype._removeTile.call(this, p);
        },
        _tileReady: function(p, y, T) {
          if (!(!this._map || T && T.getAttribute("src") === ee))
            return _l.prototype._tileReady.call(this, p, y, T);
        }
      });
      function Qc(p, y) {
        return new Ao(p, y);
      }
      var td = Ao.extend({
        // @section
        // @aka TileLayer.WMS options
        // If any custom options not documented here are used, they will be sent to the
        // WMS server as extra parameters in each request URL. This can be useful for
        // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
        defaultWmsParams: {
          service: "WMS",
          request: "GetMap",
          // @option layers: String = ''
          // **(required)** Comma-separated list of WMS layers to show.
          layers: "",
          // @option styles: String = ''
          // Comma-separated list of WMS styles.
          styles: "",
          // @option format: String = 'image/jpeg'
          // WMS image format (use `'image/png'` for layers with transparency).
          format: "image/jpeg",
          // @option transparent: Boolean = false
          // If `true`, the WMS service will return images with transparency.
          transparent: !1,
          // @option version: String = '1.1.1'
          // Version of the WMS service to use
          version: "1.1.1"
        },
        options: {
          // @option crs: CRS = null
          // Coordinate Reference System to use for the WMS requests, defaults to
          // map CRS. Don't change this if you're not sure what it means.
          crs: null,
          // @option uppercase: Boolean = false
          // If `true`, WMS request parameter keys will be uppercase.
          uppercase: !1
        },
        initialize: function(p, y) {
          this._url = p;
          var T = r({}, this.defaultWmsParams);
          for (var F in y)
            F in this.options || (T[F] = y[F]);
          y = B(this, y);
          var j = y.detectRetina && nt.retina ? 2 : 1, ge = this.getTileSize();
          T.width = ge.x * j, T.height = ge.y * j, this.wmsParams = T;
        },
        onAdd: function(p) {
          this._crs = this.options.crs || p.options.crs, this._wmsVersion = parseFloat(this.wmsParams.version);
          var y = this._wmsVersion >= 1.3 ? "crs" : "srs";
          this.wmsParams[y] = this._crs.code, Ao.prototype.onAdd.call(this, p);
        },
        getTileUrl: function(p) {
          var y = this._tileCoordsToNwSe(p), T = this._crs, F = gt(T.project(y[0]), T.project(y[1])), j = F.min, ge = F.max, xe = (this._wmsVersion >= 1.3 && this._crs === Ju ? [j.y, j.x, ge.y, ge.x] : [j.x, j.y, ge.x, ge.y]).join(","), Ve = Ao.prototype.getTileUrl.call(this, p);
          return Ve + H(this.wmsParams, Ve, this.options.uppercase) + (this.options.uppercase ? "&BBOX=" : "&bbox=") + xe;
        },
        // @method setParams(params: Object, noRedraw?: Boolean): this
        // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
        setParams: function(p, y) {
          return r(this.wmsParams, p), y || this.redraw(), this;
        }
      });
      function eu(p, y) {
        return new td(p, y);
      }
      Ao.WMS = td, Qc.wms = eu;
      var ho = is.extend({
        // @section
        // @aka Renderer options
        options: {
          // @option padding: Number = 0.1
          // How much to extend the clip area around the map view (relative to its size)
          // e.g. 0.1 would be 10% of map view in each direction
          padding: 0.1
        },
        initialize: function(p) {
          B(this, p), f(this), this._layers = this._layers || {};
        },
        onAdd: function() {
          this._container || (this._initContainer(), jt(this._container, "leaflet-zoom-animated")), this.getPane().appendChild(this._container), this._update(), this.on("update", this._updatePaths, this);
        },
        onRemove: function() {
          this.off("update", this._updatePaths, this), this._destroyContainer();
        },
        getEvents: function() {
          var p = {
            viewreset: this._reset,
            zoom: this._onZoom,
            moveend: this._update,
            zoomend: this._onZoomEnd
          };
          return this._zoomAnimated && (p.zoomanim = this._onAnimZoom), p;
        },
        _onAnimZoom: function(p) {
          this._updateTransform(p.center, p.zoom);
        },
        _onZoom: function() {
          this._updateTransform(this._map.getCenter(), this._map.getZoom());
        },
        _updateTransform: function(p, y) {
          var T = this._map.getZoomScale(y, this._zoom), F = this._map.getSize().multiplyBy(0.5 + this.options.padding), j = this._map.project(this._center, y), ge = F.multiplyBy(-T).add(j).subtract(this._map._getNewPixelOrigin(p, y));
          nt.any3d ? ti(this._container, ge, T) : Xn(this._container, ge);
        },
        _reset: function() {
          this._update(), this._updateTransform(this._center, this._zoom);
          for (var p in this._layers)
            this._layers[p]._reset();
        },
        _onZoomEnd: function() {
          for (var p in this._layers)
            this._layers[p]._project();
        },
        _updatePaths: function() {
          for (var p in this._layers)
            this._layers[p]._update();
        },
        _update: function() {
          var p = this.options.padding, y = this._map.getSize(), T = this._map.containerPointToLayerPoint(y.multiplyBy(-p)).round();
          this._bounds = new Ke(T, T.add(y.multiplyBy(1 + p * 2)).round()), this._center = this._map.getCenter(), this._zoom = this._map.getZoom();
        }
      }), dc = ho.extend({
        // @section
        // @aka Canvas options
        options: {
          // @option tolerance: Number = 0
          // How much to extend the click tolerance around a path/object on the map.
          tolerance: 0
        },
        getEvents: function() {
          var p = ho.prototype.getEvents.call(this);
          return p.viewprereset = this._onViewPreReset, p;
        },
        _onViewPreReset: function() {
          this._postponeUpdatePaths = !0;
        },
        onAdd: function() {
          ho.prototype.onAdd.call(this), this._draw();
        },
        _initContainer: function() {
          var p = this._container = document.createElement("canvas");
          Mn(p, "mousemove", this._onMouseMove, this), Mn(p, "click dblclick mousedown mouseup contextmenu", this._onClick, this), Mn(p, "mouseout", this._handleMouseOut, this), p._leaflet_disable_events = !0, this._ctx = p.getContext("2d");
        },
        _destroyContainer: function() {
          re(this._redrawRequest), delete this._ctx, xi(this._container), li(this._container), delete this._container;
        },
        _updatePaths: function() {
          if (!this._postponeUpdatePaths) {
            var p;
            this._redrawBounds = null;
            for (var y in this._layers)
              p = this._layers[y], p._update();
            this._redraw();
          }
        },
        _update: function() {
          if (!(this._map._animatingZoom && this._bounds)) {
            ho.prototype._update.call(this);
            var p = this._bounds, y = this._container, T = p.getSize(), F = nt.retina ? 2 : 1;
            Xn(y, p.min), y.width = F * T.x, y.height = F * T.y, y.style.width = T.x + "px", y.style.height = T.y + "px", nt.retina && this._ctx.scale(2, 2), this._ctx.translate(-p.min.x, -p.min.y), this.fire("update");
          }
        },
        _reset: function() {
          ho.prototype._reset.call(this), this._postponeUpdatePaths && (this._postponeUpdatePaths = !1, this._updatePaths());
        },
        _initPath: function(p) {
          this._updateDashArray(p), this._layers[f(p)] = p;
          var y = p._order = {
            layer: p,
            prev: this._drawLast,
            next: null
          };
          this._drawLast && (this._drawLast.next = y), this._drawLast = y, this._drawFirst = this._drawFirst || this._drawLast;
        },
        _addPath: function(p) {
          this._requestRedraw(p);
        },
        _removePath: function(p) {
          var y = p._order, T = y.next, F = y.prev;
          T ? T.prev = F : this._drawLast = F, F ? F.next = T : this._drawFirst = T, delete p._order, delete this._layers[f(p)], this._requestRedraw(p);
        },
        _updatePath: function(p) {
          this._extendRedrawBounds(p), p._project(), p._update(), this._requestRedraw(p);
        },
        _updateStyle: function(p) {
          this._updateDashArray(p), this._requestRedraw(p);
        },
        _updateDashArray: function(p) {
          if (typeof p.options.dashArray == "string") {
            var y = p.options.dashArray.split(/[, ]+/), T = [], F, j;
            for (j = 0; j < y.length; j++) {
              if (F = Number(y[j]), isNaN(F))
                return;
              T.push(F);
            }
            p.options._dashArray = T;
          } else
            p.options._dashArray = p.options.dashArray;
        },
        _requestRedraw: function(p) {
          this._map && (this._extendRedrawBounds(p), this._redrawRequest = this._redrawRequest || ve(this._redraw, this));
        },
        _extendRedrawBounds: function(p) {
          if (p._pxBounds) {
            var y = (p.options.weight || 0) + 1;
            this._redrawBounds = this._redrawBounds || new Ke(), this._redrawBounds.extend(p._pxBounds.min.subtract([y, y])), this._redrawBounds.extend(p._pxBounds.max.add([y, y]));
          }
        },
        _redraw: function() {
          this._redrawRequest = null, this._redrawBounds && (this._redrawBounds.min._floor(), this._redrawBounds.max._ceil()), this._clear(), this._draw(), this._redrawBounds = null;
        },
        _clear: function() {
          var p = this._redrawBounds;
          if (p) {
            var y = p.getSize();
            this._ctx.clearRect(p.min.x, p.min.y, y.x, y.y);
          } else
            this._ctx.save(), this._ctx.setTransform(1, 0, 0, 1, 0, 0), this._ctx.clearRect(0, 0, this._container.width, this._container.height), this._ctx.restore();
        },
        _draw: function() {
          var p, y = this._redrawBounds;
          if (this._ctx.save(), y) {
            var T = y.getSize();
            this._ctx.beginPath(), this._ctx.rect(y.min.x, y.min.y, T.x, T.y), this._ctx.clip();
          }
          this._drawing = !0;
          for (var F = this._drawFirst; F; F = F.next)
            p = F.layer, (!y || p._pxBounds && p._pxBounds.intersects(y)) && p._updatePath();
          this._drawing = !1, this._ctx.restore();
        },
        _updatePoly: function(p, y) {
          if (this._drawing) {
            var T, F, j, ge, xe = p._parts, Ve = xe.length, pt = this._ctx;
            if (Ve) {
              for (pt.beginPath(), T = 0; T < Ve; T++) {
                for (F = 0, j = xe[T].length; F < j; F++)
                  ge = xe[T][F], pt[F ? "lineTo" : "moveTo"](ge.x, ge.y);
                y && pt.closePath();
              }
              this._fillStroke(pt, p);
            }
          }
        },
        _updateCircle: function(p) {
          if (!(!this._drawing || p._empty())) {
            var y = p._point, T = this._ctx, F = Math.max(Math.round(p._radius), 1), j = (Math.max(Math.round(p._radiusY), 1) || F) / F;
            j !== 1 && (T.save(), T.scale(1, j)), T.beginPath(), T.arc(y.x, y.y / j, F, 0, Math.PI * 2, !1), j !== 1 && T.restore(), this._fillStroke(T, p);
          }
        },
        _fillStroke: function(p, y) {
          var T = y.options;
          T.fill && (p.globalAlpha = T.fillOpacity, p.fillStyle = T.fillColor || T.color, p.fill(T.fillRule || "evenodd")), T.stroke && T.weight !== 0 && (p.setLineDash && p.setLineDash(y.options && y.options._dashArray || []), p.globalAlpha = T.opacity, p.lineWidth = T.weight, p.strokeStyle = T.color, p.lineCap = T.lineCap, p.lineJoin = T.lineJoin, p.stroke());
        },
        // Canvas obviously doesn't have mouse events for individual drawn objects,
        // so we emulate that by calculating what's under the mouse on mousemove/click manually
        _onClick: function(p) {
          for (var y = this._map.mouseEventToLayerPoint(p), T, F, j = this._drawFirst; j; j = j.next)
            T = j.layer, T.options.interactive && T._containsPoint(y) && (!(p.type === "click" || p.type === "preclick") || !this._map._draggableMoved(T)) && (F = T);
          this._fireEvent(F ? [F] : !1, p);
        },
        _onMouseMove: function(p) {
          if (!(!this._map || this._map.dragging.moving() || this._map._animatingZoom)) {
            var y = this._map.mouseEventToLayerPoint(p);
            this._handleMouseHover(p, y);
          }
        },
        _handleMouseOut: function(p) {
          var y = this._hoveredLayer;
          y && (hi(this._container, "leaflet-interactive"), this._fireEvent([y], p, "mouseout"), this._hoveredLayer = null, this._mouseHoverThrottled = !1);
        },
        _handleMouseHover: function(p, y) {
          if (!this._mouseHoverThrottled) {
            for (var T, F, j = this._drawFirst; j; j = j.next)
              T = j.layer, T.options.interactive && T._containsPoint(y) && (F = T);
            F !== this._hoveredLayer && (this._handleMouseOut(p), F && (jt(this._container, "leaflet-interactive"), this._fireEvent([F], p, "mouseover"), this._hoveredLayer = F)), this._fireEvent(this._hoveredLayer ? [this._hoveredLayer] : !1, p), this._mouseHoverThrottled = !0, setTimeout(d(function() {
              this._mouseHoverThrottled = !1;
            }, this), 32);
          }
        },
        _fireEvent: function(p, y, T) {
          this._map._fireDOMEvent(y, T || y.type, p);
        },
        _bringToFront: function(p) {
          var y = p._order;
          if (y) {
            var T = y.next, F = y.prev;
            if (T)
              T.prev = F;
            else
              return;
            F ? F.next = T : T && (this._drawFirst = T), y.prev = this._drawLast, this._drawLast.next = y, y.next = null, this._drawLast = y, this._requestRedraw(p);
          }
        },
        _bringToBack: function(p) {
          var y = p._order;
          if (y) {
            var T = y.next, F = y.prev;
            if (F)
              F.next = T;
            else
              return;
            T ? T.prev = F : F && (this._drawLast = F), y.prev = null, y.next = this._drawFirst, this._drawFirst.prev = y, this._drawFirst = y, this._requestRedraw(p);
          }
        }
      });
      function pc(p) {
        return nt.canvas ? new dc(p) : null;
      }
      var bl = function() {
        try {
          return document.namespaces.add("lvml", "urn:schemas-microsoft-com:vml"), function(p) {
            return document.createElement("<lvml:" + p + ' class="lvml">');
          };
        } catch {
        }
        return function(p) {
          return document.createElement("<" + p + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
        };
      }(), nd = {
        _initContainer: function() {
          this._container = Ln("div", "leaflet-vml-container");
        },
        _update: function() {
          this._map._animatingZoom || (ho.prototype._update.call(this), this.fire("update"));
        },
        _initPath: function(p) {
          var y = p._container = bl("shape");
          jt(y, "leaflet-vml-shape " + (this.options.className || "")), y.coordsize = "1 1", p._path = bl("path"), y.appendChild(p._path), this._updateStyle(p), this._layers[f(p)] = p;
        },
        _addPath: function(p) {
          var y = p._container;
          this._container.appendChild(y), p.options.interactive && p.addInteractiveTarget(y);
        },
        _removePath: function(p) {
          var y = p._container;
          xi(y), p.removeInteractiveTarget(y), delete this._layers[f(p)];
        },
        _updateStyle: function(p) {
          var y = p._stroke, T = p._fill, F = p.options, j = p._container;
          j.stroked = !!F.stroke, j.filled = !!F.fill, F.stroke ? (y || (y = p._stroke = bl("stroke")), j.appendChild(y), y.weight = F.weight + "px", y.color = F.color, y.opacity = F.opacity, F.dashArray ? y.dashStyle = U(F.dashArray) ? F.dashArray.join(" ") : F.dashArray.replace(/( *, *)/g, " ") : y.dashStyle = "", y.endcap = F.lineCap.replace("butt", "flat"), y.joinstyle = F.lineJoin) : y && (j.removeChild(y), p._stroke = null), F.fill ? (T || (T = p._fill = bl("fill")), j.appendChild(T), T.color = F.fillColor || F.color, T.opacity = F.fillOpacity) : T && (j.removeChild(T), p._fill = null);
        },
        _updateCircle: function(p) {
          var y = p._point.round(), T = Math.round(p._radius), F = Math.round(p._radiusY || T);
          this._setPath(p, p._empty() ? "M0 0" : "AL " + y.x + "," + y.y + " " + T + "," + F + " 0," + 65535 * 360);
        },
        _setPath: function(p, y) {
          p._path.v = y;
        },
        _bringToFront: function(p) {
          Hs(p._container);
        },
        _bringToBack: function(p) {
          ms(p._container);
        }
      }, Pa = nt.vml ? bl : Bt, Ma = ho.extend({
        _initContainer: function() {
          this._container = Pa("svg"), this._container.setAttribute("pointer-events", "none"), this._rootGroup = Pa("g"), this._container.appendChild(this._rootGroup);
        },
        _destroyContainer: function() {
          xi(this._container), li(this._container), delete this._container, delete this._rootGroup, delete this._svgSize;
        },
        _update: function() {
          if (!(this._map._animatingZoom && this._bounds)) {
            ho.prototype._update.call(this);
            var p = this._bounds, y = p.getSize(), T = this._container;
            (!this._svgSize || !this._svgSize.equals(y)) && (this._svgSize = y, T.setAttribute("width", y.x), T.setAttribute("height", y.y)), Xn(T, p.min), T.setAttribute("viewBox", [p.min.x, p.min.y, y.x, y.y].join(" ")), this.fire("update");
          }
        },
        // methods below are called by vector layers implementations
        _initPath: function(p) {
          var y = p._path = Pa("path");
          p.options.className && jt(y, p.options.className), p.options.interactive && jt(y, "leaflet-interactive"), this._updateStyle(p), this._layers[f(p)] = p;
        },
        _addPath: function(p) {
          this._rootGroup || this._initContainer(), this._rootGroup.appendChild(p._path), p.addInteractiveTarget(p._path);
        },
        _removePath: function(p) {
          xi(p._path), p.removeInteractiveTarget(p._path), delete this._layers[f(p)];
        },
        _updatePath: function(p) {
          p._project(), p._update();
        },
        _updateStyle: function(p) {
          var y = p._path, T = p.options;
          y && (T.stroke ? (y.setAttribute("stroke", T.color), y.setAttribute("stroke-opacity", T.opacity), y.setAttribute("stroke-width", T.weight), y.setAttribute("stroke-linecap", T.lineCap), y.setAttribute("stroke-linejoin", T.lineJoin), T.dashArray ? y.setAttribute("stroke-dasharray", T.dashArray) : y.removeAttribute("stroke-dasharray"), T.dashOffset ? y.setAttribute("stroke-dashoffset", T.dashOffset) : y.removeAttribute("stroke-dashoffset")) : y.setAttribute("stroke", "none"), T.fill ? (y.setAttribute("fill", T.fillColor || T.color), y.setAttribute("fill-opacity", T.fillOpacity), y.setAttribute("fill-rule", T.fillRule || "evenodd")) : y.setAttribute("fill", "none"));
        },
        _updatePoly: function(p, y) {
          this._setPath(p, Tn(p._parts, y));
        },
        _updateCircle: function(p) {
          var y = p._point, T = Math.max(Math.round(p._radius), 1), F = Math.max(Math.round(p._radiusY), 1) || T, j = "a" + T + "," + F + " 0 1,0 ", ge = p._empty() ? "M0 0" : "M" + (y.x - T) + "," + y.y + j + T * 2 + ",0 " + j + -T * 2 + ",0 ";
          this._setPath(p, ge);
        },
        _setPath: function(p, y) {
          p._path.setAttribute("d", y);
        },
        // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
        _bringToFront: function(p) {
          Hs(p._path);
        },
        _bringToBack: function(p) {
          ms(p._path);
        }
      });
      nt.vml && Ma.include(nd);
      function wl(p) {
        return nt.svg || nt.vml ? new Ma(p) : null;
      }
      Jn.include({
        // @namespace Map; @method getRenderer(layer: Path): Renderer
        // Returns the instance of `Renderer` that should be used to render the given
        // `Path`. It will ensure that the `renderer` options of the map and paths
        // are respected, and that the renderers do exist on the map.
        getRenderer: function(p) {
          var y = p.options.renderer || this._getPaneRenderer(p.options.pane) || this.options.renderer || this._renderer;
          return y || (y = this._renderer = this._createRenderer()), this.hasLayer(y) || this.addLayer(y), y;
        },
        _getPaneRenderer: function(p) {
          if (p === "overlayPane" || p === void 0)
            return !1;
          var y = this._paneRenderers[p];
          return y === void 0 && (y = this._createRenderer({ pane: p }), this._paneRenderers[p] = y), y;
        },
        _createRenderer: function(p) {
          return this.options.preferCanvas && pc(p) || wl(p);
        }
      });
      var Jr = Go.extend({
        initialize: function(p, y) {
          Go.prototype.initialize.call(this, this._boundsToLatLngs(p), y);
        },
        // @method setBounds(latLngBounds: LatLngBounds): this
        // Redraws the rectangle with the passed bounds.
        setBounds: function(p) {
          return this.setLatLngs(this._boundsToLatLngs(p));
        },
        _boundsToLatLngs: function(p) {
          return p = rt(p), [
            p.getSouthWest(),
            p.getNorthWest(),
            p.getNorthEast(),
            p.getSouthEast()
          ];
        }
      });
      function Xo(p, y) {
        return new Jr(p, y);
      }
      Ma.create = Pa, Ma.pointsToPath = Tn, Ds.geometryToLayer = _s, Ds.coordsToLatLng = gl, Ds.coordsToLatLngs = cc, Ds.latLngToCoords = Ia, Ds.latLngsToCoords = uc, Ds.getFeature = Aa, Ds.asFeature = Ea, Jn.mergeOptions({
        // @option boxZoom: Boolean = true
        // Whether the map can be zoomed to a rectangular area specified by
        // dragging the mouse while pressing the shift key.
        boxZoom: !0
      });
      var id = Ms.extend({
        initialize: function(p) {
          this._map = p, this._container = p._container, this._pane = p._panes.overlayPane, this._resetStateTimeout = 0, p.on("unload", this._destroy, this);
        },
        addHooks: function() {
          Mn(this._container, "mousedown", this._onMouseDown, this);
        },
        removeHooks: function() {
          li(this._container, "mousedown", this._onMouseDown, this);
        },
        moved: function() {
          return this._moved;
        },
        _destroy: function() {
          xi(this._pane), delete this._pane;
        },
        _resetState: function() {
          this._resetStateTimeout = 0, this._moved = !1;
        },
        _clearDeferredResetState: function() {
          this._resetStateTimeout !== 0 && (clearTimeout(this._resetStateTimeout), this._resetStateTimeout = 0);
        },
        _onMouseDown: function(p) {
          if (!p.shiftKey || p.which !== 1 && p.button !== 1)
            return !1;
          this._clearDeferredResetState(), this._resetState(), ll(), Kl(), this._startPoint = this._map.mouseEventToContainerPoint(p), Mn(document, {
            contextmenu: Zs,
            mousemove: this._onMouseMove,
            mouseup: this._onMouseUp,
            keydown: this._onKeyDown
          }, this);
        },
        _onMouseMove: function(p) {
          this._moved || (this._moved = !0, this._box = Ln("div", "leaflet-zoom-box", this._container), jt(this._container, "leaflet-crosshair"), this._map.fire("boxzoomstart")), this._point = this._map.mouseEventToContainerPoint(p);
          var y = new Ke(this._point, this._startPoint), T = y.getSize();
          Xn(this._box, y.min), this._box.style.width = T.x + "px", this._box.style.height = T.y + "px";
        },
        _finish: function() {
          this._moved && (xi(this._box), hi(this._container, "leaflet-crosshair")), Gl(), Wc(), li(document, {
            contextmenu: Zs,
            mousemove: this._onMouseMove,
            mouseup: this._onMouseUp,
            keydown: this._onKeyDown
          }, this);
        },
        _onMouseUp: function(p) {
          if (!(p.which !== 1 && p.button !== 1) && (this._finish(), !!this._moved)) {
            this._clearDeferredResetState(), this._resetStateTimeout = setTimeout(d(this._resetState, this), 0);
            var y = new qe(
              this._map.containerPointToLatLng(this._startPoint),
              this._map.containerPointToLatLng(this._point)
            );
            this._map.fitBounds(y).fire("boxzoomend", { boxZoomBounds: y });
          }
        },
        _onKeyDown: function(p) {
          p.keyCode === 27 && (this._finish(), this._clearDeferredResetState(), this._resetState());
        }
      });
      Jn.addInitHook("addHandler", "boxZoom", id), Jn.mergeOptions({
        // @option doubleClickZoom: Boolean|String = true
        // Whether the map can be zoomed in by double clicking on it and
        // zoomed out by double clicking while holding shift. If passed
        // `'center'`, double-click zoom will zoom to the center of the
        //  view regardless of where the mouse was.
        doubleClickZoom: !0
      });
      var tu = Ms.extend({
        addHooks: function() {
          this._map.on("dblclick", this._onDoubleClick, this);
        },
        removeHooks: function() {
          this._map.off("dblclick", this._onDoubleClick, this);
        },
        _onDoubleClick: function(p) {
          var y = this._map, T = y.getZoom(), F = y.options.zoomDelta, j = p.originalEvent.shiftKey ? T - F : T + F;
          y.options.doubleClickZoom === "center" ? y.setZoom(j) : y.setZoomAround(p.containerPoint, j);
        }
      });
      Jn.addInitHook("addHandler", "doubleClickZoom", tu), Jn.mergeOptions({
        // @option dragging: Boolean = true
        // Whether the map is draggable with mouse/touch or not.
        dragging: !0,
        // @section Panning Inertia Options
        // @option inertia: Boolean = *
        // If enabled, panning of the map will have an inertia effect where
        // the map builds momentum while dragging and continues moving in
        // the same direction for some time. Feels especially nice on touch
        // devices. Enabled by default.
        inertia: !0,
        // @option inertiaDeceleration: Number = 3000
        // The rate with which the inertial movement slows down, in pixels/second².
        inertiaDeceleration: 3400,
        // px/s^2
        // @option inertiaMaxSpeed: Number = Infinity
        // Max speed of the inertial movement, in pixels/second.
        inertiaMaxSpeed: 1 / 0,
        // px/s
        // @option easeLinearity: Number = 0.2
        easeLinearity: 0.2,
        // TODO refactor, move to CRS
        // @option worldCopyJump: Boolean = false
        // With this option enabled, the map tracks when you pan to another "copy"
        // of the world and seamlessly jumps to the original one so that all overlays
        // like markers and vector layers are still visible.
        worldCopyJump: !1,
        // @option maxBoundsViscosity: Number = 0.0
        // If `maxBounds` is set, this option will control how solid the bounds
        // are when dragging the map around. The default value of `0.0` allows the
        // user to drag outside the bounds at normal speed, higher values will
        // slow down map dragging outside bounds, and `1.0` makes the bounds fully
        // solid, preventing the user from dragging outside the bounds.
        maxBoundsViscosity: 0
      });
      var hc = Ms.extend({
        addHooks: function() {
          if (!this._draggable) {
            var p = this._map;
            this._draggable = new gs(p._mapPane, p._container), this._draggable.on({
              dragstart: this._onDragStart,
              drag: this._onDrag,
              dragend: this._onDragEnd
            }, this), this._draggable.on("predrag", this._onPreDragLimit, this), p.options.worldCopyJump && (this._draggable.on("predrag", this._onPreDragWrap, this), p.on("zoomend", this._onZoomEnd, this), p.whenReady(this._onZoomEnd, this));
          }
          jt(this._map._container, "leaflet-grab leaflet-touch-drag"), this._draggable.enable(), this._positions = [], this._times = [];
        },
        removeHooks: function() {
          hi(this._map._container, "leaflet-grab"), hi(this._map._container, "leaflet-touch-drag"), this._draggable.disable();
        },
        moved: function() {
          return this._draggable && this._draggable._moved;
        },
        moving: function() {
          return this._draggable && this._draggable._moving;
        },
        _onDragStart: function() {
          var p = this._map;
          if (p._stop(), this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
            var y = rt(this._map.options.maxBounds);
            this._offsetLimit = gt(
              this._map.latLngToContainerPoint(y.getNorthWest()).multiplyBy(-1),
              this._map.latLngToContainerPoint(y.getSouthEast()).multiplyBy(-1).add(this._map.getSize())
            ), this._viscosity = Math.min(1, Math.max(0, this._map.options.maxBoundsViscosity));
          } else
            this._offsetLimit = null;
          p.fire("movestart").fire("dragstart"), p.options.inertia && (this._positions = [], this._times = []);
        },
        _onDrag: function(p) {
          if (this._map.options.inertia) {
            var y = this._lastTime = +/* @__PURE__ */ new Date(), T = this._lastPos = this._draggable._absPos || this._draggable._newPos;
            this._positions.push(T), this._times.push(y), this._prunePositions(y);
          }
          this._map.fire("move", p).fire("drag", p);
        },
        _prunePositions: function(p) {
          for (; this._positions.length > 1 && p - this._times[0] > 50; )
            this._positions.shift(), this._times.shift();
        },
        _onZoomEnd: function() {
          var p = this._map.getSize().divideBy(2), y = this._map.latLngToLayerPoint([0, 0]);
          this._initialWorldOffset = y.subtract(p).x, this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
        },
        _viscousLimit: function(p, y) {
          return p - (p - y) * this._viscosity;
        },
        _onPreDragLimit: function() {
          if (!(!this._viscosity || !this._offsetLimit)) {
            var p = this._draggable._newPos.subtract(this._draggable._startPos), y = this._offsetLimit;
            p.x < y.min.x && (p.x = this._viscousLimit(p.x, y.min.x)), p.y < y.min.y && (p.y = this._viscousLimit(p.y, y.min.y)), p.x > y.max.x && (p.x = this._viscousLimit(p.x, y.max.x)), p.y > y.max.y && (p.y = this._viscousLimit(p.y, y.max.y)), this._draggable._newPos = this._draggable._startPos.add(p);
          }
        },
        _onPreDragWrap: function() {
          var p = this._worldWidth, y = Math.round(p / 2), T = this._initialWorldOffset, F = this._draggable._newPos.x, j = (F - y + T) % p + y - T, ge = (F + y + T) % p - y - T, xe = Math.abs(j + T) < Math.abs(ge + T) ? j : ge;
          this._draggable._absPos = this._draggable._newPos.clone(), this._draggable._newPos.x = xe;
        },
        _onDragEnd: function(p) {
          var y = this._map, T = y.options, F = !T.inertia || p.noInertia || this._times.length < 2;
          if (y.fire("dragend", p), F)
            y.fire("moveend");
          else {
            this._prunePositions(+/* @__PURE__ */ new Date());
            var j = this._lastPos.subtract(this._positions[0]), ge = (this._lastTime - this._times[0]) / 1e3, xe = T.easeLinearity, Ve = j.multiplyBy(xe / ge), pt = Ve.distanceTo([0, 0]), $t = Math.min(T.inertiaMaxSpeed, pt), Jt = Ve.multiplyBy($t / pt), pn = $t / (T.inertiaDeceleration * xe), Hn = Jt.multiplyBy(-pn / 2).round();
            !Hn.x && !Hn.y ? y.fire("moveend") : (Hn = y._limitOffset(Hn, y.options.maxBounds), ve(function() {
              y.panBy(Hn, {
                duration: pn,
                easeLinearity: xe,
                noMoveStart: !0,
                animate: !0
              });
            }));
          }
        }
      });
      Jn.addInitHook("addHandler", "dragging", hc), Jn.mergeOptions({
        // @option keyboard: Boolean = true
        // Makes the map focusable and allows users to navigate the map with keyboard
        // arrows and `+`/`-` keys.
        keyboard: !0,
        // @option keyboardPanDelta: Number = 80
        // Amount of pixels to pan when pressing an arrow key.
        keyboardPanDelta: 80
      });
      var nu = Ms.extend({
        keyCodes: {
          left: [37],
          right: [39],
          down: [40],
          up: [38],
          zoomIn: [187, 107, 61, 171],
          zoomOut: [189, 109, 54, 173]
        },
        initialize: function(p) {
          this._map = p, this._setPanDelta(p.options.keyboardPanDelta), this._setZoomDelta(p.options.zoomDelta);
        },
        addHooks: function() {
          var p = this._map._container;
          p.tabIndex <= 0 && (p.tabIndex = "0"), Mn(p, {
            focus: this._onFocus,
            blur: this._onBlur,
            mousedown: this._onMouseDown
          }, this), this._map.on({
            focus: this._addHooks,
            blur: this._removeHooks
          }, this);
        },
        removeHooks: function() {
          this._removeHooks(), li(this._map._container, {
            focus: this._onFocus,
            blur: this._onBlur,
            mousedown: this._onMouseDown
          }, this), this._map.off({
            focus: this._addHooks,
            blur: this._removeHooks
          }, this);
        },
        _onMouseDown: function() {
          if (!this._focused) {
            var p = document.body, y = document.documentElement, T = p.scrollTop || y.scrollTop, F = p.scrollLeft || y.scrollLeft;
            this._map._container.focus(), window.scrollTo(F, T);
          }
        },
        _onFocus: function() {
          this._focused = !0, this._map.fire("focus");
        },
        _onBlur: function() {
          this._focused = !1, this._map.fire("blur");
        },
        _setPanDelta: function(p) {
          var y = this._panKeys = {}, T = this.keyCodes, F, j;
          for (F = 0, j = T.left.length; F < j; F++)
            y[T.left[F]] = [-1 * p, 0];
          for (F = 0, j = T.right.length; F < j; F++)
            y[T.right[F]] = [p, 0];
          for (F = 0, j = T.down.length; F < j; F++)
            y[T.down[F]] = [0, p];
          for (F = 0, j = T.up.length; F < j; F++)
            y[T.up[F]] = [0, -1 * p];
        },
        _setZoomDelta: function(p) {
          var y = this._zoomKeys = {}, T = this.keyCodes, F, j;
          for (F = 0, j = T.zoomIn.length; F < j; F++)
            y[T.zoomIn[F]] = p;
          for (F = 0, j = T.zoomOut.length; F < j; F++)
            y[T.zoomOut[F]] = -p;
        },
        _addHooks: function() {
          Mn(document, "keydown", this._onKeyDown, this);
        },
        _removeHooks: function() {
          li(document, "keydown", this._onKeyDown, this);
        },
        _onKeyDown: function(p) {
          if (!(p.altKey || p.ctrlKey || p.metaKey)) {
            var y = p.keyCode, T = this._map, F;
            if (y in this._panKeys) {
              if (!T._panAnim || !T._panAnim._inProgress)
                if (F = this._panKeys[y], p.shiftKey && (F = De(F).multiplyBy(3)), T.options.maxBounds && (F = T._limitOffset(De(F), T.options.maxBounds)), T.options.worldCopyJump) {
                  var j = T.wrapLatLng(T.unproject(T.project(T.getCenter()).add(F)));
                  T.panTo(j);
                } else
                  T.panBy(F);
            } else if (y in this._zoomKeys)
              T.setZoom(T.getZoom() + (p.shiftKey ? 3 : 1) * this._zoomKeys[y]);
            else if (y === 27 && T._popup && T._popup.options.closeOnEscapeKey)
              T.closePopup();
            else
              return;
            Zs(p);
          }
        }
      });
      Jn.addInitHook("addHandler", "keyboard", nu), Jn.mergeOptions({
        // @section Mouse wheel options
        // @option scrollWheelZoom: Boolean|String = true
        // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
        // it will zoom to the center of the view regardless of where the mouse was.
        scrollWheelZoom: !0,
        // @option wheelDebounceTime: Number = 40
        // Limits the rate at which a wheel can fire (in milliseconds). By default
        // user can't zoom via wheel more often than once per 40 ms.
        wheelDebounceTime: 40,
        // @option wheelPxPerZoomLevel: Number = 60
        // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
        // mean a change of one full zoom level. Smaller values will make wheel-zooming
        // faster (and vice versa).
        wheelPxPerZoomLevel: 60
      });
      var rd = Ms.extend({
        addHooks: function() {
          Mn(this._map._container, "wheel", this._onWheelScroll, this), this._delta = 0;
        },
        removeHooks: function() {
          li(this._map._container, "wheel", this._onWheelScroll, this);
        },
        _onWheelScroll: function(p) {
          var y = Ql(p), T = this._map.options.wheelDebounceTime;
          this._delta += y, this._lastMousePos = this._map.mouseEventToContainerPoint(p), this._startTime || (this._startTime = +/* @__PURE__ */ new Date());
          var F = Math.max(T - (+/* @__PURE__ */ new Date() - this._startTime), 0);
          clearTimeout(this._timer), this._timer = setTimeout(d(this._performZoom, this), F), Zs(p);
        },
        _performZoom: function() {
          var p = this._map, y = p.getZoom(), T = this._map.options.zoomSnap || 0;
          p._stop();
          var F = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), j = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(F)))) / Math.LN2, ge = T ? Math.ceil(j / T) * T : j, xe = p._limitZoom(y + (this._delta > 0 ? ge : -ge)) - y;
          this._delta = 0, this._startTime = null, xe && (p.options.scrollWheelZoom === "center" ? p.setZoom(y + xe) : p.setZoomAround(this._lastMousePos, y + xe));
        }
      });
      Jn.addInitHook("addHandler", "scrollWheelZoom", rd);
      var Os = 600;
      Jn.mergeOptions({
        // @section Touch interaction options
        // @option tapHold: Boolean
        // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
        tapHold: nt.touchNative && nt.safari && nt.mobile,
        // @option tapTolerance: Number = 15
        // The max number of pixels a user can shift his finger during touch
        // for it to be considered a valid tap.
        tapTolerance: 15
      });
      var Ei = Ms.extend({
        addHooks: function() {
          Mn(this._map._container, "touchstart", this._onDown, this);
        },
        removeHooks: function() {
          li(this._map._container, "touchstart", this._onDown, this);
        },
        _onDown: function(p) {
          if (clearTimeout(this._holdTimeout), p.touches.length === 1) {
            var y = p.touches[0];
            this._startPos = this._newPos = new et(y.clientX, y.clientY), this._holdTimeout = setTimeout(d(function() {
              this._cancel(), this._isTapValid() && (Mn(document, "touchend", lr), Mn(document, "touchend touchcancel", this._cancelClickPrevent), this._simulateEvent("contextmenu", y));
            }, this), Os), Mn(document, "touchend touchcancel contextmenu", this._cancel, this), Mn(document, "touchmove", this._onMove, this);
          }
        },
        _cancelClickPrevent: function p() {
          li(document, "touchend", lr), li(document, "touchend touchcancel", p);
        },
        _cancel: function() {
          clearTimeout(this._holdTimeout), li(document, "touchend touchcancel contextmenu", this._cancel, this), li(document, "touchmove", this._onMove, this);
        },
        _onMove: function(p) {
          var y = p.touches[0];
          this._newPos = new et(y.clientX, y.clientY);
        },
        _isTapValid: function() {
          return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
        },
        _simulateEvent: function(p, y) {
          var T = new MouseEvent(p, {
            bubbles: !0,
            cancelable: !0,
            view: window,
            // detail: 1,
            screenX: y.screenX,
            screenY: y.screenY,
            clientX: y.clientX,
            clientY: y.clientY
            // button: 2,
            // buttons: 2
          });
          T._simulated = !0, y.target.dispatchEvent(T);
        }
      });
      Jn.addInitHook("addHandler", "tapHold", Ei), Jn.mergeOptions({
        // @section Touch interaction options
        // @option touchZoom: Boolean|String = *
        // Whether the map can be zoomed by touch-dragging with two fingers. If
        // passed `'center'`, it will zoom to the center of the view regardless of
        // where the touch events (fingers) were. Enabled for touch-capable web
        // browsers.
        touchZoom: nt.touch,
        // @option bounceAtZoomLimits: Boolean = true
        // Set it to false if you don't want the map to zoom beyond min/max zoom
        // and then bounce back when pinch-zooming.
        bounceAtZoomLimits: !0
      });
      var fc = Ms.extend({
        addHooks: function() {
          jt(this._map._container, "leaflet-touch-zoom"), Mn(this._map._container, "touchstart", this._onTouchStart, this);
        },
        removeHooks: function() {
          hi(this._map._container, "leaflet-touch-zoom"), li(this._map._container, "touchstart", this._onTouchStart, this);
        },
        _onTouchStart: function(p) {
          var y = this._map;
          if (!(!p.touches || p.touches.length !== 2 || y._animatingZoom || this._zooming)) {
            var T = y.mouseEventToContainerPoint(p.touches[0]), F = y.mouseEventToContainerPoint(p.touches[1]);
            this._centerPoint = y.getSize()._divideBy(2), this._startLatLng = y.containerPointToLatLng(this._centerPoint), y.options.touchZoom !== "center" && (this._pinchStartLatLng = y.containerPointToLatLng(T.add(F)._divideBy(2))), this._startDist = T.distanceTo(F), this._startZoom = y.getZoom(), this._moved = !1, this._zooming = !0, y._stop(), Mn(document, "touchmove", this._onTouchMove, this), Mn(document, "touchend touchcancel", this._onTouchEnd, this), lr(p);
          }
        },
        _onTouchMove: function(p) {
          if (!(!p.touches || p.touches.length !== 2 || !this._zooming)) {
            var y = this._map, T = y.mouseEventToContainerPoint(p.touches[0]), F = y.mouseEventToContainerPoint(p.touches[1]), j = T.distanceTo(F) / this._startDist;
            if (this._zoom = y.getScaleZoom(j, this._startZoom), !y.options.bounceAtZoomLimits && (this._zoom < y.getMinZoom() && j < 1 || this._zoom > y.getMaxZoom() && j > 1) && (this._zoom = y._limitZoom(this._zoom)), y.options.touchZoom === "center") {
              if (this._center = this._startLatLng, j === 1)
                return;
            } else {
              var ge = T._add(F)._divideBy(2)._subtract(this._centerPoint);
              if (j === 1 && ge.x === 0 && ge.y === 0)
                return;
              this._center = y.unproject(y.project(this._pinchStartLatLng, this._zoom).subtract(ge), this._zoom);
            }
            this._moved || (y._moveStart(!0, !1), this._moved = !0), re(this._animRequest);
            var xe = d(y._move, y, this._center, this._zoom, { pinch: !0, round: !1 }, void 0);
            this._animRequest = ve(xe, this, !0), lr(p);
          }
        },
        _onTouchEnd: function() {
          if (!this._moved || !this._zooming) {
            this._zooming = !1;
            return;
          }
          this._zooming = !1, re(this._animRequest), li(document, "touchmove", this._onTouchMove, this), li(document, "touchend touchcancel", this._onTouchEnd, this), this._map.options.zoomAnimation ? this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), !0, this._map.options.zoomSnap) : this._map._resetView(this._center, this._map._limitZoom(this._zoom));
        }
      });
      Jn.addInitHook("addHandler", "touchZoom", fc), Jn.BoxZoom = id, Jn.DoubleClickZoom = tu, Jn.Drag = hc, Jn.Keyboard = nu, Jn.ScrollWheelZoom = rd, Jn.TapHold = Ei, Jn.TouchZoom = fc, n.Bounds = Ke, n.Browser = nt, n.CRS = je, n.Canvas = dc, n.Circle = Ta, n.CircleMarker = ac, n.Class = pe, n.Control = qs, n.DivIcon = yl, n.DivOverlay = Xr, n.DomEvent = Yd, n.DomUtil = ul, n.Draggable = gs, n.Evented = Ge, n.FeatureGroup = ys, n.GeoJSON = Ds, n.GridLayer = _l, n.Handler = Ms, n.Icon = ml, n.ImageOverlay = Yo, n.LatLng = Le, n.LatLngBounds = qe, n.Layer = is, n.LayerGroup = qo, n.LineUtil = Ci, n.Map = Jn, n.Marker = Kr, n.Mixin = $a, n.Path = co, n.Point = et, n.PolyUtil = ci, n.Polygon = Go, n.Polyline = uo, n.Popup = Ko, n.PosAnimation = xa, n.Projection = Xu, n.Rectangle = Jr, n.Renderer = ho, n.SVG = Ma, n.SVGOverlay = rp, n.TileLayer = Ao, n.Tooltip = Zt, n.Transformation = dt, n.Util = le, n.VideoOverlay = To, n.bind = d, n.bounds = gt, n.canvas = pc, n.circle = vl, n.circleMarker = Sa, n.control = ec, n.divIcon = Io, n.extend = r, n.featureGroup = oc, n.geoJSON = js, n.geoJson = Ls, n.gridLayer = Rt, n.icon = tp, n.imageOverlay = nr, n.latLng = Je, n.latLngBounds = rt, n.layerGroup = Qu, n.map = rf, n.marker = np, n.point = De, n.polygon = ip, n.polyline = ed, n.popup = po, n.rectangle = Xo, n.setOptions = B, n.stamp = f, n.svg = wl, n.svgOverlay = lf, n.tileLayer = Qc, n.tooltip = Jc, n.transformation = bt, n.version = i, n.videoOverlay = af;
      var sd = window.L;
      n.noConflict = function() {
        return window.L = sd, this;
      }, window.L = n;
    });
  }(Gv, Gv.exports)), Gv.exports;
}
var fte = _D();
const Pp = /* @__PURE__ */ Nx(fte);
var mte = { exports: {} };
(function(e) {
  (function(t, n) {
    e.exports ? e.exports = n(_D()) : n(t.L);
  })(typeof self < "u" ? self : Em, (t) => {
    if (typeof document > "u")
      return console.warn('"window.document" is undefined; leaflet.fullscreen requires this object to access the DOM'), !1;
    const n = (() => {
      const c = [
        // Standard
        [
          "requestFullscreen",
          "exitFullscreen",
          "fullscreenElement",
          "fullscreenEnabled",
          "fullscreenchange",
          "fullscreenerror"
        ],
        // New WebKit
        [
          "webkitRequestFullscreen",
          "webkitExitFullscreen",
          "webkitFullscreenElement",
          "webkitFullscreenEnabled",
          "webkitfullscreenchange",
          "webkitfullscreenerror"
        ]
      ], d = c[0], a = {};
      for (const f of c)
        if (f[1] in document) {
          for (let g = 0; g < f.length; g++)
            a[d[g]] = f[g];
          return a;
        }
      return !1;
    })(), i = {
      change: n.fullscreenchange,
      error: n.fullscreenerror
    }, r = {
      request(c, d) {
        return new Promise((a, f) => {
          const g = (function() {
            this.off("change", g), a();
          }).bind(this);
          this.on("change", g), c = c || document.documentElement;
          const x = c[n.requestFullscreen](d);
          x instanceof Promise && x.then(g).catch(f);
        });
      },
      exit() {
        return new Promise((c, d) => {
          if (!this.isFullscreen) {
            c();
            return;
          }
          const a = (function() {
            this.off("change", a), c();
          }).bind(this);
          this.on("change", a);
          const f = document[n.exitFullscreen]();
          f instanceof Promise && f.then(a).catch(d);
        });
      },
      on(c, d) {
        const a = i[c];
        a && document.addEventListener(a, d, !1);
      },
      off(c, d) {
        const a = i[c];
        a && document.removeEventListener(a, d, !1);
      },
      nativeAPI: n
    };
    return Object.defineProperties(r, {
      isFullscreen: {
        get() {
          return !!document[n.fullscreenElement];
        }
      },
      isEnabled: {
        enumerable: !0,
        get() {
          return !!document[n.fullscreenEnabled];
        }
      }
    }), t.Control.FullScreen = t.Control.extend({
      options: {
        position: "topleft",
        title: "Full Screen",
        titleCancel: "Exit Full Screen",
        forceSeparateButton: !1,
        forcePseudoFullscreen: !1,
        fullscreenElement: !1
      },
      _screenfull: r,
      onAdd(c) {
        let d = "leaflet-control-zoom-fullscreen", a, f = "";
        return c.zoomControl && !this.options.forceSeparateButton ? a = c.zoomControl._container : a = t.DomUtil.create("div", "leaflet-bar"), this.options.content ? f = this.options.content : d += " fullscreen-icon", this._createButton(this.options.title, d, f, a, this.toggleFullScreen, this), this._map.fullscreenControl = this, this._map.on("enterFullscreen exitFullscreen", this._toggleState, this), a;
      },
      onRemove() {
        t.DomEvent.off(this.link, "click", t.DomEvent.stop).off(this.link, "click", this.toggleFullScreen, this), this._screenfull.isEnabled && (t.DomEvent.off(this._container, this._screenfull.nativeAPI.fullscreenchange, t.DomEvent.stop).off(this._container, this._screenfull.nativeAPI.fullscreenchange, this._handleFullscreenChange, this), t.DomEvent.off(document, this._screenfull.nativeAPI.fullscreenchange, t.DomEvent.stop).off(document, this._screenfull.nativeAPI.fullscreenchange, this._handleFullscreenChange, this));
      },
      _createButton(c, d, a, f, g, x) {
        return this.link = t.DomUtil.create("a", d, f), this.link.href = "#", this.link.title = c, this.link.innerHTML = a, this.link.setAttribute("role", "button"), this.link.setAttribute("aria-label", c), L.DomEvent.disableClickPropagation(f), t.DomEvent.on(this.link, "click", t.DomEvent.stop).on(this.link, "click", g, x), this._screenfull.isEnabled && (t.DomEvent.on(f, this._screenfull.nativeAPI.fullscreenchange, t.DomEvent.stop).on(f, this._screenfull.nativeAPI.fullscreenchange, this._handleFullscreenChange, x), t.DomEvent.on(document, this._screenfull.nativeAPI.fullscreenchange, t.DomEvent.stop).on(document, this._screenfull.nativeAPI.fullscreenchange, this._handleFullscreenChange, x)), this.link;
      },
      toggleFullScreen() {
        const c = this._map;
        c._exitFired = !1, c._isFullscreen ? (this._screenfull.isEnabled && !this.options.forcePseudoFullscreen ? this._screenfull.exit().then(() => c.invalidateSize()) : (t.DomUtil.removeClass(this.options.fullscreenElement ? this.options.fullscreenElement : c._container, "leaflet-pseudo-fullscreen"), c.invalidateSize()), c.fire("exitFullscreen"), c._exitFired = !0, c._isFullscreen = !1) : (this._screenfull.isEnabled && !this.options.forcePseudoFullscreen ? this._screenfull.request(this.options.fullscreenElement ? this.options.fullscreenElement : c._container).then(() => c.invalidateSize()) : (t.DomUtil.addClass(this.options.fullscreenElement ? this.options.fullscreenElement : c._container, "leaflet-pseudo-fullscreen"), c.invalidateSize()), c.fire("enterFullscreen"), c._isFullscreen = !0);
      },
      _toggleState() {
        this.link.title = this._map._isFullscreen ? this.options.title : this.options.titleCancel, this._map._isFullscreen ? L.DomUtil.removeClass(this.link, "leaflet-fullscreen-on") : L.DomUtil.addClass(this.link, "leaflet-fullscreen-on");
      },
      _handleFullscreenChange(c) {
        const d = this._map;
        c.target === d.getContainer() && !this._screenfull.isFullscreen && !d._exitFired && (this._screenfull.exit().then(() => d.invalidateSize()), d.fire("exitFullscreen"), d._exitFired = !0, d._isFullscreen = !1);
      }
    }), t.Map.include({
      toggleFullscreen() {
        this.fullscreenControl.toggleFullScreen();
      }
    }), t.Map.addInitHook(function() {
      this.options.fullscreenControl && this.addControl(t.control.fullscreen(this.options.fullscreenControlOptions));
    }), t.control.fullscreen = function(c) {
      return new t.Control.FullScreen(c);
    }, { leaflet: t };
  });
})(mte);
const vte = { class: "map-height" }, $S = 48, gte = 14, yte = /* @__PURE__ */ at({
  __name: "VacationsMap",
  props: {
    cdnBaseUrl: {},
    hotel: {}
  },
  setup(e) {
    var O, B;
    const t = e, { t: n } = ki({ useScope: "global" });
    let i;
    const r = $e(), c = $e(!0), d = Pp.icon({
      iconUrl: `${t.cdnBaseUrl}/img/icon-location-48.png`,
      iconRetinaUrl: `${t.cdnBaseUrl}/img/icon-location-96.png`,
      iconSize: [$S, $S]
    }), a = parseFloat((O = t.hotel.location) == null ? void 0 : O.latitude), f = parseFloat((B = t.hotel.location) == null ? void 0 : B.longitude), g = [a, f], x = Pp.marker(g, { icon: d });
    x.bindPopup(
      `<div style="text-align: center;">
      <h4>${t.hotel.name}</h4>
    </div>`
    );
    function $(H) {
      const N = Pp.map(H, { zoomControl: !1 }).setView(
        g,
        gte
      );
      N.on("enterFullscreen", function() {
        t.hotel.name && t.hotel.destination && RE(t.hotel.name, t.hotel.destination);
      }), Pp.control.fullscreen({
        position: "topleft",
        // change the position of the button can be topleft, topright, bottomright or bottomleft, default topleft
        title: n("vacvComponents.productDetails.map.enter-full-screen"),
        // change the title of the button, default Full Screen
        titleCancel: n("vacvComponents.productDetails.map.exit-full-screen"),
        // change the title of the button when fullscreen is on, default Exit Full Screen
        content: null,
        // change the content of the button, can be HTML, default null
        forceSeparateButton: !0,
        // force separate button to detach from zoom buttons, default false
        forcePseudoFullscreen: !0,
        // force use of pseudo full screen even if full screen API is available, default false
        fullscreenElement: !1
        // Dom element to render in full screen, false by default, fallback to map._container
      }).addTo(N), Pp.control.zoom({
        zoomInText: '<span aria-hidden="true">+</span>',
        zoomInTitle: n("vacvComponents.productDetails.map.zoom-in"),
        zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
        zoomOutTitle: n("vacvComponents.productDetails.map.zoom-out")
      }).addTo(N), Pp.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      }).addTo(N), x.addTo(N);
      const K = N.getContainer();
      if (K) {
        const U = K.querySelector(
          ".leaflet-attribution-flag"
        );
        U && U.remove();
      }
      return N;
    }
    function A() {
      i && (i.remove(), i = void 0);
    }
    const I = new IntersectionObserver(
      function(H) {
        H[0].isIntersecting === !0 && r.value ? (A(), i = $(r.value)) : A();
      },
      { threshold: [0.9] }
    );
    return Li(() => {
      r.value && I.observe(r.value);
    }), tl(() => {
      I.disconnect(), A();
    }), (H, N) => (V(), Tt($r, { name: "slide" }, {
      default: Qt(() => [
        xr(E("div", vte, [
          N[0] || (Bg(-1), (N[0] = E("div", {
            class: "map-height",
            ref_key: "mapElement",
            ref: r
          }, null, 512)).cacheIndex = 0, Bg(1), N[0])
        ], 512), [
          [th, c.value]
        ])
      ]),
      _: 1
    }));
  }
}), _te = /* @__PURE__ */ Zn(yte, [["__scopeId", "data-v-7b0cee79"]]), bte = { "data-test": "pdp-hotel-location-section-title" }, wte = {
  key: 1,
  class: "sub-section"
}, xte = {
  class: "text",
  "data-test": "hotel-address"
}, $te = /* @__PURE__ */ E("i", { class: "fa-solid fa-location-dot" }, null, -1), Cte = {
  key: 2,
  class: "spa-list special-list details-2col"
}, kte = { key: 0 }, Ste = { key: 1 }, Tte = {
  key: 3,
  class: "spa-list special-list details-2col"
}, Ite = ["id"], QTe = /* @__PURE__ */ at({
  __name: "PdpLocation",
  props: {
    cdnBaseUrl: {}
  },
  setup(e) {
    const t = Xi("hotel"), { onIntersectionObserver: n, section: i } = qh();
    return (r, c) => {
      var d, a, f, g, x, $;
      return V(), G("section", {
        id: "location",
        class: "pdp-section location",
        ref_key: "section",
        ref: i
      }, [
        xr((V(), G("h2", bte, [
          mt(Y(r.$t("vacvComponents.productDetails.labels.hotel.location.title")), 1)
        ])), [
          [ne(Zd), [ne(n), { section: ne(i) }]]
        ]),
        (d = ne(t).location) != null && d.latitude && ((a = ne(t).location) != null && a.longitude) ? (V(), Tt(_te, {
          key: 0,
          hotel: ne(t),
          cdnBaseUrl: r.cdnBaseUrl,
          "data-test": "pdp-hotel-location-map"
        }, null, 8, ["hotel", "cdnBaseUrl"])) : _e("", !0),
        (f = ne(t).location) != null && f.address ? (V(), G("div", wte, [
          E("div", xte, [
            $te,
            mt(Y(ne(t).location.address), 1)
          ])
        ])) : _e("", !0),
        (g = ne(t).location) != null && g.kmToAirport && ne(t).location.kmToAirport !== "" || (x = ne(t).location) != null && x.specificLocation && ne(t).location.specificLocation !== "" ? (V(), G("ul", Cte, [
          ne(t).location.kmToAirport && ne(t).location.kmToAirport !== "" ? (V(), G("li", kte, Y(ne(t).location.kmToAirport), 1)) : _e("", !0),
          ne(t).location.specificLocation && ne(t).location.specificLocation !== "" ? (V(), G("li", Ste, Y(ne(t).location.specificLocation), 1)) : _e("", !0)
        ])) : _e("", !0),
        ($ = ne(t).location) != null && $.distancePointOfInterests && ne(t).location.distancePointOfInterests.length ? (V(), G("ul", Tte, [
          (V(!0), G(cn, null, Pn(ne(t).location.distancePointOfInterests, (A, I) => (V(), G("li", {
            key: I,
            id: "pdp-hotel-inclusion-item-" + I,
            "data-test": "POI"
          }, Y(A), 9, Ite))), 128))
        ])) : _e("", !0)
      ], 512);
    };
  }
}), Ate = { class: "toggletext" }, bD = /* @__PURE__ */ at({
  __name: "ExpandableButton",
  props: {
    isExpanded: { type: Boolean },
    showText: {},
    hideText: {}
  },
  emits: ["toggle-learn-more"],
  setup(e, { emit: t }) {
    const n = t, i = () => {
      n("toggle-learn-more");
    };
    return (r, c) => (V(), G("button", {
      class: "details-link link linklook",
      onClick: i
    }, [
      E("span", Ate, [
        E("i", {
          class: Et(
            "fa-solid " + (r.isExpanded ? "fa-circle-minus" : "fa-circle-plus")
          ),
          "aria-hidden": "true"
        }, null, 2),
        mt(" " + Y(r.isExpanded ? r.hideText : r.showText), 1)
      ])
    ]));
  }
});
function wD(e) {
  const t = e + "px", n = $e(!1), i = $e(!1), r = $e(), c = $e("0px"), d = () => {
    i.value = !i.value;
  };
  Li(() => {
    var g;
    const f = (g = r.value) == null ? void 0 : g.clientHeight;
    f && f > e && (n.value = !0, c.value = `${f}px`), i.value = !1;
  });
  const a = Ae(() => {
    const f = "spa-list-expandwrap", g = i.value ? " expanded" : " rolledup";
    return `${f}${n.value ? g : ""}`;
  });
  return {
    toggleLearnMore: d,
    expandableContent: r,
    isExpandable: n,
    isExpanded: i,
    expandedHeight: c,
    defaultRollupHeightPX: t,
    expandableContentClass: a
  };
}
const Ete = { class: "sub-section" }, Pte = { class: "sub-row" }, Mte = {
  key: 0,
  class: "vacv-collection-icon"
}, Dte = ["src"], Lte = {
  key: 0,
  class: "mobile-only h3style"
}, Ote = { class: "sub-content" }, Nte = { key: 0 }, Fte = ["innerHTML"], Rte = 100, zte = /* @__PURE__ */ at({
  __name: "PdpBestForItem",
  props: {
    collection: {}
  },
  setup(e) {
    Hl(($) => ({
      ee70e452: ne(a),
      "06f70251": ne(d)
    }));
    const t = e, {
      toggleLearnMore: n,
      expandableContent: i,
      isExpandable: r,
      isExpanded: c,
      expandedHeight: d,
      defaultRollupHeightPX: a,
      expandableContentClass: f
    } = wD(Rte), g = Ae(
      () => {
        var $, A;
        return ((A = ($ = t.collection) == null ? void 0 : $.description) == null ? void 0 : A.filter(Boolean)) || [];
      }
    ), x = Ae(() => g.value.length > 1);
    return ($, A) => (V(), G("div", Ete, [
      E("div", Pte, [
        $.collection.icon ? (V(), G("div", Mte, [
          E("img", {
            alt: "",
            src: $.collection.icon,
            "aria-hidden": "true"
          }, null, 8, Dte),
          $.collection.title ? (V(), G("div", Lte, Y($.collection.title), 1)) : _e("", !0)
        ])) : _e("", !0),
        E("div", Ote, [
          $.collection.title ? (V(), G("h3", Nte, Y($.collection.title), 1)) : _e("", !0),
          g.value.length ? (V(), G("div", {
            key: 1,
            ref_key: "expandableContent",
            ref: i,
            class: Et(ne(f))
          }, [
            E("ul", {
              class: Et(x.value ? "spa-list special-list" : "spa-list")
            }, [
              (V(!0), G(cn, null, Pn(g.value, (I) => (V(), G("li", {
                key: I,
                class: "spa-list-item vacv-editor",
                innerHTML: I
              }, null, 8, Fte))), 128))
            ], 2)
          ], 2)) : _e("", !0),
          ne(r) ? (V(), Tt(bD, {
            key: 2,
            "is-expanded": ne(c),
            "show-text": $.$t("vacvComponents.productDetails.bestFor.learnMore"),
            "hide-text": $.$t("vacvComponents.productDetails.bestFor.hideDetails"),
            onToggleLearnMore: ne(n)
          }, null, 8, ["is-expanded", "show-text", "hide-text", "onToggleLearnMore"])) : _e("", !0)
        ])
      ])
    ]));
  }
}), Bte = /* @__PURE__ */ Zn(zte, [["__scopeId", "data-v-23c5537a"]]), Vte = { "data-test": "pdp-hotel-best-for-section-title" }, eIe = /* @__PURE__ */ at({
  __name: "PdpBestFor",
  props: {
    bestFor: {}
  },
  setup(e) {
    const { onIntersectionObserver: t, section: n } = qh();
    return (i, r) => (V(), G("section", {
      id: "bestFor",
      class: "pdp-section bestfor",
      ref_key: "section",
      ref: n
    }, [
      xr((V(), G("h2", Vte, [
        mt(Y(i.$t("vacvComponents.productDetails.bestFor.title")), 1)
      ])), [
        [ne(Zd), [ne(t), { section: ne(n) }]]
      ]),
      (V(!0), G(cn, null, Pn(i.bestFor, (c, d) => (V(), Tt(Bte, {
        key: d,
        collection: c
      }, null, 8, ["collection"]))), 128))
    ], 512));
  }
}), Ute = { key: 0 }, Hte = { key: 0 }, Wte = ["innerHTML"], Zte = {
  key: 2,
  class: "terms"
}, qte = ["id"], jte = { class: "h4style" }, Gte = ["innerHTML"], Yte = ["aria-expanded", "aria-controls"], Kte = { class: "toggletext" }, Xte = /* @__PURE__ */ at({
  __name: "OffersItem",
  props: {
    promotion: {},
    index: {}
  },
  setup(e) {
    Hl((f) => ({
      "7714c2ca": i.value
    }));
    const { t } = ki({ useScope: "global" }), n = $e(!1), i = $e("0px"), r = $e(null);
    At(r, (f) => {
      f != null && f.scrollHeight && (i.value = f.scrollHeight + "px");
    });
    const c = () => {
      n.value = !n.value;
    }, d = Ae(
      () => `fa-solid ${n.value ? "fa-circle-minus" : "fa-circle-plus"}`
    ), a = Ae(
      () => n.value ? t("vacvComponents.productDetails.offers.showLess") : t("vacvComponents.productDetails.offers.terms")
    );
    return (f, g) => {
      var x, $, A;
      return (x = f.promotion) != null && x.title || ($ = f.promotion) != null && $.description || (A = f.promotion) != null && A.termsAndConditions ? (V(), G("div", Ute, [
        f.promotion.title ? (V(), G("h3", Hte, Y(f.promotion.title), 1)) : _e("", !0),
        f.promotion.description ? (V(), G("div", {
          key: 1,
          class: "text vacv-editor",
          innerHTML: f.promotion.description,
          "data-test": "description"
        }, null, 8, Wte)) : _e("", !0),
        f.promotion.termsAndConditions ? (V(), G("div", Zte, [
          it($r, { name: "collapsible" }, {
            default: Qt(() => [
              n.value ? (V(), G("section", {
                key: 0,
                id: `offersTermsAccordion-${f.index}`,
                class: Et(["hotel-accordion-wrapper mini", { open: n.value }]),
                "aria-live": "polite",
                "aria-label": "Terms & Conditions",
                ref_key: "scrollHeightRef",
                ref: r
              }, [
                E("div", jte, Y(f.$t("vacvComponents.productDetails.offers.terms")), 1),
                E("div", {
                  class: "text vacv-editor",
                  innerHTML: f.promotion.termsAndConditions,
                  "data-test": "termsAndConditions"
                }, null, 8, Gte)
              ], 10, qte)) : _e("", !0)
            ]),
            _: 1
          }),
          E("button", {
            class: "details-link link linklook",
            "aria-expanded": n.value,
            "aria-controls": `offersTermsAccordion-${f.index}`,
            onClick: c
          }, [
            E("span", Kte, [
              E("i", {
                class: Et(d.value),
                "aria-hidden": "true"
              }, null, 2),
              mt(" " + Y(a.value), 1)
            ])
          ], 8, Yte)
        ])) : _e("", !0)
      ])) : _e("", !0);
    };
  }
}), tIe = /* @__PURE__ */ at({
  __name: "Offers",
  props: {
    promotions: {}
  },
  setup(e) {
    const { onIntersectionObserver: t, section: n } = qh();
    return (i, r) => (V(), G("section", {
      id: "offers",
      class: "pdp-section offers",
      ref_key: "section",
      ref: n
    }, [
      xr((V(), G("h2", null, [
        mt(Y(i.$t("vacvComponents.productDetails.offers.title")), 1)
      ])), [
        [ne(Zd), [ne(t), { section: ne(n) }]]
      ]),
      (V(!0), G(cn, null, Pn(i.promotions, (c, d) => (V(), G("div", {
        key: d,
        class: "sub-section"
      }, [
        it(Xte, {
          promotion: c,
          index: d
        }, null, 8, ["promotion", "index"])
      ]))), 128))
    ], 512));
  }
}), Jte = {
  key: 0,
  class: "sub-content"
}, Qte = { class: "h3style" }, ene = {
  key: 0,
  class: "description"
}, tne = { class: "spa-list special-list" }, nne = { class: "restaurant-name" }, ine = {
  key: 0,
  class: "restaurant-description"
}, rne = /* @__PURE__ */ at({
  __name: "FacilitiesSubSectionRestaurants",
  props: {
    restaurant: {},
    title: {}
  },
  setup(e) {
    const t = e, { t: n } = ki({ useScope: "global" }), i = Ae(() => {
      var c;
      return ((c = t.restaurant.info) == null ? void 0 : c.filter((d) => d.name).map((d) => ({
        ...d,
        description: r(d)
      }))) || [];
    });
    function r(c) {
      const d = [];
      return c.type && d.push(
        `${n("vacvComponents.productDetails.facilities.restaurantType")}: ${c.type}`
      ), c.cuisineType && d.push(
        `${n("vacvComponents.productDetails.facilities.restaurantCuisine")}: ${c.cuisineType}`
      ), c.additionnalInfo && d.push(
        `${n("vacvComponents.productDetails.facilities.restaurantNote")}: ${c.additionnalInfo}`
      ), d.join(" | ");
    }
    return (c, d) => c.restaurant.info ? (V(), G("div", Jte, [
      E("h4", Qte, Y(c.title), 1),
      c.restaurant.title ? (V(), G("p", ene, Y(c.restaurant.title), 1)) : _e("", !0),
      E("ul", tne, [
        (V(!0), G(cn, null, Pn(i.value, (a) => (V(), G("li", {
          key: a.name,
          class: "spa-list-item"
        }, [
          E("span", nne, Y(a.name), 1),
          a.description ? (V(), G("span", ine, Y(a.description), 1)) : _e("", !0)
        ]))), 128))
      ])
    ])) : _e("", !0);
  }
}), sne = /* @__PURE__ */ Zn(rne, [["__scopeId", "data-v-4f5aaece"]]), one = {
  key: 1,
  class: "sub-content"
}, ane = {
  key: 0,
  class: "h3style"
}, lne = {
  key: 1,
  class: "description"
}, cne = {
  key: 2,
  class: "description"
}, une = { class: "spa-list special-list details-2col" }, dne = {
  key: 3,
  class: "disclaimer"
}, pne = {
  key: 4,
  class: "disclaimer pet"
}, CS = /* @__PURE__ */ at({
  __name: "FacilitiesSubSection",
  props: {
    subsection: {},
    restaurantSubsection: {},
    keyName: {}
  },
  setup(e) {
    const t = e, { t: n } = ki({ useScope: "global" }), i = Ae(() => ({
      pools: n("vacvComponents.productDetails.facilities.pools"),
      landSports: n("vacvComponents.productDetails.facilities.landSports"),
      waterSports: n("vacvComponents.productDetails.facilities.waterSports"),
      entertainment: n("vacvComponents.productDetails.facilities.entertainment"),
      golf: n("vacvComponents.productDetails.facilities.golf"),
      bars: n("vacvComponents.productDetails.facilities.bars") + ":",
      restaurants: n("vacvComponents.productDetails.facilities.restaurants") + ":",
      health: n("vacvComponents.productDetails.facilities.health")
    })), r = Ae(() => i.value[t.keyName] ?? null), c = (a = [], f = []) => [...a, ...f], d = Ae(() => {
      var a, f;
      return ((a = t.subsection) == null ? void 0 : a.description) || ((f = t.subsection) == null ? void 0 : f.title) || null;
    });
    return (a, f) => {
      var g, x, $, A;
      return a.restaurantSubsection ? (V(), Tt(sne, {
        key: 0,
        restaurant: a.restaurantSubsection,
        title: r.value
      }, null, 8, ["restaurant", "title"])) : (x = (g = a.subsection) == null ? void 0 : g.names) != null && x.length || ($ = a.subsection) != null && $.additionalInformation || (A = a.subsection) != null && A.description ? (V(), G("div", one, [
        r.value ? (V(), G("h4", ane, Y(r.value), 1)) : _e("", !0),
        d.value ? (V(), G("p", lne, Y(d.value), 1)) : _e("", !0),
        a.subsection.additionalInformation ? (V(), G("p", cne, Y(a.subsection.additionalInformation), 1)) : _e("", !0),
        E("ul", une, [
          (V(!0), G(cn, null, Pn(c(a.subsection.names, a.subsection.more), (I) => (V(), G("li", {
            key: I,
            class: "spa-list-item"
          }, Y(I), 1))), 128))
        ]),
        a.subsection.hasDisclaimer ? (V(), G("p", dne, Y(a.$t("vacvComponents.productDetails.facilities.disclaimer")), 1)) : _e("", !0),
        "petFriendlyDisclamer" in a.subsection && a.subsection.petFriendlyDisclamer ? (V(), G("p", pne, Y(a.$t("vacvComponents.productDetails.facilities.disclaimerPetFriendly")), 1)) : _e("", !0)
      ])) : _e("", !0);
    };
  }
}), xD = (e) => (nl("data-v-9bc8b279"), e = e(), il(), e), hne = {
  key: 0,
  class: "sub-section"
}, fne = { class: "h2style" }, mne = {
  key: 0,
  class: "fooddrink-icon"
}, vne = /* @__PURE__ */ xD(() => /* @__PURE__ */ E("i", {
  class: "fa-solid fa-utensils",
  "aria-hidden": "true"
}, null, -1)), gne = /* @__PURE__ */ xD(() => /* @__PURE__ */ E("i", {
  class: "fa-solid fa-wine-glass",
  "aria-hidden": "true"
}, null, -1)), yne = [
  vne,
  gne
], _ne = {
  key: 1,
  class: "fa-solid fa-water-ladder",
  "aria-hidden": "true"
}, bne = { key: 2 }, wne = 250, xne = /* @__PURE__ */ at({
  __name: "FacilitiesItem",
  props: {
    facility: {},
    facilityName: {}
  },
  setup(e) {
    Hl((I) => ({
      "2179f2a2": ne(a),
      bf34c834: ne(d)
    }));
    const t = e, {
      toggleLearnMore: n,
      expandableContent: i,
      isExpandable: r,
      isExpanded: c,
      expandedHeight: d,
      defaultRollupHeightPX: a,
      expandableContentClass: f
    } = wD(wne), { t: g } = ki({ useScope: "global" }), x = (I) => ({
      foodAndDrink: g("vacvComponents.productDetails.facilities.foodAndDrinks"),
      activities: g("vacvComponents.productDetails.facilities.activities"),
      otherFacilityAndServices: g(
        "vacvComponents.productDetails.facilities.otherFacilitiesAndServices"
      )
    })[I] ?? null, $ = () => {
      if (t.facilityName === "otherFacilityAndServices" || t.facilityName === "foodAndDrink")
        return !0;
      for (const I in t.facility) {
        const O = t.facility[I];
        if (!O)
          return !1;
        const B = O.names && O.names.length, H = O.more && O.more.length;
        return B || H;
      }
      return !1;
    }, A = Ae(() => !x(t.facilityName) || !t.facility || Object.keys(t.facility).length === 0 ? !1 : $());
    return (I, O) => A.value ? (V(), G("div", hne, [
      E("h3", fne, [
        I.facilityName === "foodAndDrink" ? (V(), G("span", mne, yne)) : _e("", !0),
        I.facilityName === "activities" ? (V(), G("i", _ne)) : _e("", !0),
        I.facilityName === "otherFacilityAndServices" ? (V(), G("span", bne, " ($) ")) : _e("", !0),
        mt(" " + Y(x(I.facilityName)), 1)
      ]),
      I.facilityName !== "otherFacilityAndServices" ? (V(), G("div", {
        key: 0,
        class: Et(ne(f)),
        ref_key: "expandableContent",
        ref: i
      }, [
        (V(!0), G(cn, null, Pn(I.facility, (B, H) => (V(), Tt(CS, {
          key: H,
          keyName: H,
          subsection: B,
          restaurantSubsection: "info" in B ? B : void 0
        }, null, 8, ["keyName", "subsection", "restaurantSubsection"]))), 128))
      ], 2)) : (V(), G("div", {
        key: 1,
        class: Et(ne(f)),
        ref_key: "expandableContent",
        ref: i
      }, [
        it(CS, {
          keyName: "otherFacilityAndServices",
          subsection: I.facility
        }, null, 8, ["subsection"])
      ], 2)),
      ne(r) ? (V(), Tt(bD, {
        key: 2,
        "is-expanded": ne(c),
        "show-text": I.$t("vacvComponents.productDetails.facilities.showMore"),
        "hide-text": I.$t("vacvComponents.productDetails.facilities.showLess"),
        onToggleLearnMore: ne(n)
      }, null, 8, ["is-expanded", "show-text", "hide-text", "onToggleLearnMore"])) : _e("", !0)
    ])) : _e("", !0);
  }
}), $ne = /* @__PURE__ */ Zn(xne, [["__scopeId", "data-v-9bc8b279"]]), Cne = { "data-test": "pdp-hotel-facilities-section-title" }, nIe = /* @__PURE__ */ at({
  __name: "Facilities",
  props: {
    facilities: {}
  },
  setup(e) {
    const { onIntersectionObserver: t, section: n } = qh();
    return (i, r) => (V(), G("section", {
      id: "facilities",
      class: "pdp-section facilities",
      ref_key: "section",
      ref: n
    }, [
      xr((V(), G("h2", Cne, [
        mt(Y(i.$t("vacvComponents.productDetails.facilities.title")), 1)
      ])), [
        [ne(Zd), [ne(t), { section: ne(n) }]]
      ]),
      (V(!0), G(cn, null, Pn(i.facilities, (c, d, a) => (V(), G(cn, null, [
        c ? (V(), Tt($ne, {
          key: a,
          facility: c,
          "facility-name": d
        }, null, 8, ["facility", "facility-name"])) : _e("", !0)
      ], 64))), 256))
    ], 512));
  }
}), kne = { class: "sr-only" }, Sne = { class: "sr-only" }, Tne = { class: "sr-only" }, Ine = { class: "sr-only" }, Ane = { class: "sr-only" }, Ene = { class: "sr-only" }, Pne = { class: "sr-only" }, Mne = /* @__PURE__ */ at({
  __name: "PdpNavAnchors",
  props: {
    hasOverviewData: { type: Boolean },
    hasLocationData: { type: Boolean },
    hasBestForData: { type: Boolean },
    hasFacilitesData: { type: Boolean },
    hasPromotionsData: { type: Boolean },
    hasImportantInformation: { type: Boolean }
  },
  setup(e) {
    const t = AE(), { PDP: n, setPDPSectionDisplayed: i } = t, r = Ae(() => n.PDPSectionInView), c = $e(null), d = $e(null), a = (f, g) => {
      var A;
      const $ = (A = f.target.getAttribute("href")) == null ? void 0 : A.replace("#", "");
      return i($, !0), e6(g), !1;
    };
    return tl(() => {
      i(null, !0);
    }), At(
      r,
      () => {
        var g, x, $;
        const { width: f } = ex();
        if (c.value && ((g = c.value) == null ? void 0 : g.scrollWidth) > f.value) {
          const A = (x = c.value) == null ? void 0 : x.childNodes.length, I = [].findIndex.call(
            ($ = c.value) == null ? void 0 : $.childNodes,
            (N) => {
              var K;
              return ((K = N == null ? void 0 : N.classList) == null ? void 0 : K.contains) !== void 0 ? N.classList.contains("active") : !1;
            }
          );
          let O = 0;
          A > 5 && I > 3 && (O = 300);
          const { x: B } = N6(c.value, { behavior: "smooth" });
          HE(() => {
            B.value = O;
          }, 800);
        }
      },
      {
        flush: "post"
      }
    ), (f, g) => (V(), G("nav", {
      ref_key: "navEl",
      ref: d
    }, [
      E("ul", {
        class: "nav-scroller",
        ref_key: "listEl",
        ref: c,
        "data-test": "navbar"
      }, [
        E("li", {
          class: Et({ active: r.value === "rooms" })
        }, [
          E("a", {
            href: "#rooms",
            onClick: g[0] || (g[0] = (x) => a(x, "Rooms"))
          }, [
            E("span", kne, Y(f.$t("vacvComponents.productDetails.labels.accessibleAnchor")), 1),
            mt(Y(f.$t("vacvComponents.productDetails.rooms")), 1)
          ])
        ], 2),
        f.hasOverviewData ? (V(), G("li", {
          key: 0,
          class: Et({ active: r.value === "overview" })
        }, [
          E("a", {
            href: "#overview",
            onClick: g[1] || (g[1] = (x) => a(x, "Overview"))
          }, [
            E("span", Sne, Y(f.$t("vacvComponents.productDetails.labels.accessibleAnchor")), 1),
            mt(Y(f.$t("vacvComponents.productDetails.labels.hotel.overview.title")), 1)
          ])
        ], 2)) : _e("", !0),
        f.hasLocationData ? (V(), G("li", {
          key: 1,
          class: Et({ active: r.value === "location" })
        }, [
          E("a", {
            href: "#location",
            onClick: g[2] || (g[2] = (x) => a(x, "Location"))
          }, [
            E("span", Tne, Y(f.$t("vacvComponents.productDetails.labels.accessibleAnchor")), 1),
            mt(Y(f.$t("vacvComponents.productDetails.labels.hotel.location.title")), 1)
          ])
        ], 2)) : _e("", !0),
        f.hasBestForData ? (V(), G("li", {
          key: 2,
          class: Et({ active: r.value === "bestFor" })
        }, [
          E("a", {
            href: "#bestFor",
            onClick: g[3] || (g[3] = (x) => a(x, "Ideal For"))
          }, [
            E("span", Ine, Y(f.$t("vacvComponents.productDetails.labels.accessibleAnchor")), 1),
            mt(Y(f.$t("vacvComponents.productDetails.bestFor.title")), 1)
          ])
        ], 2)) : _e("", !0),
        f.hasFacilitesData ? (V(), G("li", {
          key: 3,
          class: Et({ active: r.value === "facilities" })
        }, [
          E("a", {
            href: "#facilities",
            onClick: g[4] || (g[4] = (x) => a(x, "Facilities"))
          }, [
            E("span", Ane, Y(f.$t("vacvComponents.productDetails.labels.accessibleAnchor")), 1),
            mt(Y(f.$t("vacvComponents.productDetails.labels.hotel.facilities.title")), 1)
          ])
        ], 2)) : _e("", !0),
        f.hasPromotionsData ? (V(), G("li", {
          key: 4,
          class: Et({ active: r.value === "offers" })
        }, [
          E("a", {
            href: "#offers",
            onClick: g[5] || (g[5] = (x) => a(x, "Offers"))
          }, [
            E("span", Ene, Y(f.$t("vacvComponents.productDetails.labels.accessibleAnchor")), 1),
            mt(Y(f.$t("vacvComponents.productDetails.labels.hotel.offers.title")), 1)
          ])
        ], 2)) : _e("", !0),
        f.hasImportantInformation ? (V(), G("li", {
          key: 5,
          class: Et({ active: r.value === "importantInformation" })
        }, [
          E("a", {
            href: "#importantInformation",
            onClick: g[6] || (g[6] = (x) => a(x, "Important Information"))
          }, [
            E("span", Pne, Y(f.$t("vacvComponents.productDetails.labels.accessibleAnchor")), 1),
            mt(Y(f.$t("vacvComponents.productDetails.labels.hotel.important.title")), 1)
          ])
        ], 2)) : _e("", !0)
      ], 512)
    ], 512));
  }
}), iIe = /* @__PURE__ */ Zn(Mne, [["__scopeId", "data-v-6861974c"]]), $D = (e) => !!e && (e == null ? void 0 : e.source) === "TA" && !!(e != null && e.ratingImageUrl) && !!(e != null && e.reviews) && !!(e != null && e.value);
function Dne(e = 20) {
  const t = Sn.now().toFormat("MM-yy"), n = Sn.now().plus({ years: e }).toFormat("MM-yy");
  return [t, n];
}
const Lne = (e) => (nl("data-v-5a8ac10d"), e = e(), il(), e), One = { class: "rating-ta-wrapper" }, Nne = {
  key: 0,
  class: "rating-wrapper"
}, Fne = {
  key: 0,
  class: "hotel-rating"
}, Rne = { class: "stars" }, zne = /* @__PURE__ */ Lne(() => /* @__PURE__ */ E("i", {
  class: "fa-solid fa-star",
  "aria-hidden": "true"
}, null, -1)), Bne = { class: "sr-only" }, Vne = {
  key: 1,
  class: "hotel-plan"
}, Une = {
  key: 2,
  class: "hotel-city"
}, Hne = /* @__PURE__ */ at({
  __name: "VacvHotelRating",
  props: {
    hotel: {},
    package: {}
  },
  setup(e) {
    return (t, n) => {
      var i, r, c, d;
      return V(), G("div", One, [
        t.hotel.starCategory || t.hotel.destination ? (V(), G("div", Nne, [
          t.hotel.starCategory ? (V(), G("span", Fne, [
            E("span", Rne, [
              mt(Y(t.hotel.starCategory), 1),
              zne,
              E("span", Bne, Y(t.$t("vacvComponents.hotelRating.stars")), 1)
            ])
          ])) : _e("", !0),
          (r = (i = t.package) == null ? void 0 : i.information) != null && r.mealPlanName ? (V(), G("span", Vne, Y((d = (c = t.package) == null ? void 0 : c.information) == null ? void 0 : d.mealPlanName), 1)) : _e("", !0),
          t.hotel.destination ? (V(), G("span", Une, Y(t.hotel.destination), 1)) : _e("", !0)
        ])) : _e("", !0),
        er(t.$slots, "default", {}, void 0, !0)
      ]);
    };
  }
}), CD = /* @__PURE__ */ Zn(Hne, [["__scopeId", "data-v-5a8ac10d"]]), Wne = { class: "pdp-header" }, Zne = /* @__PURE__ */ at({
  __name: "VacvPdpHeader",
  setup(e) {
    const t = Xi("hotel");
    return (n, i) => (V(), G("header", Wne, [
      E("h1", null, Y(ne(t).name), 1),
      it(CD, { hotel: ne(t) }, {
        default: Qt(() => [
          ne(t).rating && ne($D)(ne(t).rating) ? (V(), Tt(BE, {
            key: 0,
            rating: ne(t).rating
          }, null, 8, ["rating"])) : _e("", !0)
        ]),
        _: 1
      }, 8, ["hotel"])
    ]));
  }
}), rIe = /* @__PURE__ */ Zn(Zne, [["__scopeId", "data-v-af5f66de"]]), qne = { class: "traveller-summary" }, jne = { class: "traveller-item-title" }, Gne = { class: "h2style passenger-title" }, Yne = {
  key: 0,
  class: "note--mainemail"
}, Kne = { class: "h3style passenger-name" }, Xne = { key: 0 }, Jne = { key: 1 }, Qne = { key: 2 }, eie = { key: 3 }, tie = {
  key: 0,
  class: "item-detail dob"
}, nie = {
  key: 1,
  class: "item-detail email"
}, iie = {
  key: 2,
  class: "item-detail phone"
}, rie = {
  key: 3,
  class: "item-detail aeroplan"
}, kD = /* @__PURE__ */ at({
  __name: "TravellerSummary",
  props: {
    passenger: {},
    showDOB: { type: Boolean, default: !0 }
  },
  setup(e) {
    const { t } = ki({ useScope: "global" }), n = e, i = Ae(() => {
      const { passenger: r, showDOB: c } = n, d = r.orderIndex, a = d === 1 ? "er" : "e";
      if (r.adult) {
        let f = t("vacvComponents.traveller.labels.adult", { index: d, pos: a });
        return r.orderIndex === 1 && (f += ` ${t("vacvComponents.traveller.messages.mainTraveller")}`), f;
      }
      return r.age !== void 0 && r.age < 2 ? c === !1 ? t("vacvComponents.traveller.labels.infantHideAge", { index: d, pos: a }) : t("vacvComponents.traveller.labels.infant", {
        index: d,
        age: r.age,
        pos: a
      }) : c === !1 ? t("vacvComponents.traveller.labels.childHideAge", { index: d, pos: a }) : t("vacvComponents.traveller.labels.child", {
        index: d,
        age: r.age,
        pos: a
      });
    });
    return (r, c) => (V(), G("div", qne, [
      E("div", jne, [
        E("div", Gne, Y(i.value), 1),
        r.passenger.adult && r.passenger.orderIndex === 1 ? (V(), G("div", Yne, Y(r.$t("vacvComponents.traveller.messages.travellerEmailDisclaimer")), 1)) : _e("", !0)
      ]),
      E("div", null, [
        E("div", Kne, [
          r.passenger.title === "MR" ? (V(), G("span", Xne, Y(r.$t("vacvComponents.traveller.labels.travellerTitleMr")), 1)) : _e("", !0),
          r.passenger.title === "MRS" ? (V(), G("span", Jne, Y(r.$t("vacvComponents.traveller.labels.travellerTitleMrs")), 1)) : _e("", !0),
          r.passenger.title === "MS" ? (V(), G("span", Qne, Y(r.$t("vacvComponents.traveller.labels.travellerTitleMs")), 1)) : _e("", !0),
          mt(" " + Y(r.passenger.firstName) + " ", 1),
          r.passenger.middleName ? (V(), G("span", eie, Y(r.passenger.middleName), 1)) : _e("", !0),
          mt(" " + Y(r.passenger.lastName), 1)
        ]),
        r.passenger.birthdayFormatted && r.showDOB !== !1 ? (V(), G("div", tie, [
          mt(Y(r.$t("vacvComponents.traveller.labels.dateOfBirth-filled")) + " ", 1),
          E("span", null, Y(r.passenger.birthdayFormatted), 1)
        ])) : _e("", !0),
        r.passenger.emailAddress ? (V(), G("div", nie, Y(r.$t("vacvComponents.traveller.labels.travellerEmail-filled")) + " " + Y(r.passenger.emailAddress), 1)) : _e("", !0),
        r.passenger.phoneNumber ? (V(), G("div", iie, Y(r.$t("vacvComponents.traveller.labels.travellerPhoneNumber-filled")) + " " + Y(r.passenger.phoneNumber), 1)) : _e("", !0),
        r.passenger.aeroplanNum ? (V(), G("div", rie, Y(r.$t("vacvComponents.traveller.labels.travellerAeroplanNumber-filled")) + " " + Y(r.passenger.aeroplanNum), 1)) : _e("", !0)
      ])
    ]));
  }
}), sie = { class: "paddedbox-grey" }, oie = {
  key: 0,
  class: "note"
}, aie = { class: "traveller-list" }, lie = ["index", "passenger"], sIe = /* @__PURE__ */ at({
  __name: "TravellersSummary",
  props: {
    passengers: {},
    showDOB: { type: Boolean, default: !0 },
    stepNumber: {}
  },
  emits: ["update-information"],
  setup(e, { emit: t }) {
    const n = e, i = t, r = () => {
      i("update-information");
    }, c = Ae(() => {
      var d;
      return (d = n.passengers) == null ? void 0 : d.some((a) => a.nameModified);
    });
    return (d, a) => (V(), G("section", {
      class: Et(["travellers-summary", `step-${d.stepNumber}`])
    }, [
      E("div", sie, [
        c.value ? (V(), G("p", oie, [
          E("strong", null, Y(d.$t("vacvComponents.payment.labels.note")), 1),
          mt(" " + Y(d.$t("vacvComponents.payment.labels.travellerInfoNormalizedNote")), 1)
        ])) : _e("", !0),
        E("ul", aie, [
          (V(!0), G(cn, null, Pn(d.passengers, (f, g) => (V(), G("li", {
            key: f.id,
            index: g,
            passenger: f,
            class: "traveller-item"
          }, [
            it(kD, {
              passenger: f,
              showDOB: d.showDOB
            }, null, 8, ["passenger", "showDOB"])
          ], 8, lie))), 128))
        ]),
        d.stepNumber !== 2 ? (V(), G("button", {
          key: 1,
          class: "update-info vacv-btn-secondary",
          onClick: r
        }, [
          E("span", null, Y(d.$t("vacvComponents.payment.labels.updateInformation")), 1)
        ])) : _e("", !0)
      ])
    ], 2));
  }
}), cie = { class: "qty" }, uie = /* @__PURE__ */ at({
  __name: "TravellerQuantity",
  props: {
    pricing: {},
    taxes: { type: Boolean, default: !1 },
    showDOB: { type: Boolean }
  },
  setup(e) {
    const t = e, { t: n } = ki({ useScope: "global" }), i = Ae(() => {
      const { pricing: r, taxes: c, showDOB: d } = t, a = r.paxCount;
      let f;
      r.paxType === "A" ? f = "adult" : r.paxAge && r.paxAge >= 2 ? f = "child" : f = "infant";
      const g = V1(r) ? 2 : 1, x = n(`vacvComponents.pricedetails.${f}`, g);
      let $ = `${a} ${x}`;
      if (d && !c && r.paxAge && r.paxType !== "A") {
        const A = r.paxAge >= 2 ? r.paxAge : n("vacvComponents.pricedetails.infantAge");
        $ += ` (${A})`;
      }
      return c && ($ += ` ${n("vacvComponents.pricedetails.taxesFees")}`), $;
    });
    return (r, c) => (V(), G("div", cie, Y(i.value), 1));
  }
}), die = /* @__PURE__ */ Zn(uie, [["__scopeId", "data-v-18b0fa03"]]), pie = /* @__PURE__ */ at({
  __name: "TravellerEach",
  props: {
    amount: {}
  },
  setup(e) {
    const t = e;
    return (n, i) => (V(), G("div", null, "   x " + Y(ne(Wn)(t.amount, n.$n)), 1));
  }
}), hie = { class: "total" }, fie = /* @__PURE__ */ at({
  __name: "TravellerTotal",
  props: {
    amount: {}
  },
  setup(e) {
    const t = e;
    return (n, i) => (V(), G("div", hie, Y(ne(Wn)(t.amount, n.$n)), 1));
  }
}), kS = /* @__PURE__ */ at({
  __name: "TravellerSection",
  props: {
    pricing: {},
    taxes: { type: Boolean, default: !1 },
    showDOB: { type: Boolean }
  },
  setup(e) {
    const t = e, n = Ae(
      () => t.taxes ? t.pricing.taxFees : t.pricing.price
    ), i = Ae(() => t.pricing.paxCount);
    return (r, c) => (V(), G(cn, null, [
      it(die, {
        showDOB: r.showDOB,
        pricing: r.pricing,
        taxes: r.taxes
      }, null, 8, ["showDOB", "pricing", "taxes"]),
      typeof n.value == "number" && ne(V1)(r.pricing) ? (V(), Tt(pie, {
        key: 0,
        amount: n.value
      }, null, 8, ["amount"])) : _e("", !0),
      typeof n.value == "number" && typeof i.value == "number" ? (V(), Tt(fie, {
        key: 1,
        amount: n.value * i.value
      }, null, 8, ["amount"])) : _e("", !0)
    ], 64));
  }
}), mie = { class: "breakdown-price-section" }, vie = {
  key: 0,
  class: "extras-included"
}, gie = !0, yie = /* @__PURE__ */ at({
  __name: "TravellerSections",
  props: {
    pricing: {},
    extrasIncluded: { type: Boolean },
    showDOB: { type: Boolean }
  },
  setup(e) {
    const t = e, n = Ae(
      () => V1(t.pricing) ? "multiple price-row " : "price-row "
    );
    return (i, r) => (V(), G("ul", mie, [
      E("li", {
        class: Et(`${n.value} baseprice`)
      }, [
        it(kS, {
          showDOB: i.showDOB,
          pricing: t.pricing
        }, null, 8, ["showDOB", "pricing"])
      ], 2),
      i.extrasIncluded ? (V(), G("li", vie, Y(i.$t("vacvComponents.pricedetails.extras-included")), 1)) : _e("", !0),
      E("li", {
        class: Et(`${n.value} taxfees`)
      }, [
        it(kS, {
          showDOB: i.showDOB,
          pricing: t.pricing,
          taxes: gie
        }, null, 8, ["showDOB", "pricing"])
      ], 2)
    ]));
  }
}), _ie = /* @__PURE__ */ Zn(yie, [["__scopeId", "data-v-763b50b6"]]), bie = { class: "breakdown-travellerList" }, wie = /* @__PURE__ */ at({
  __name: "TravellerType",
  props: {
    pricing: {},
    extrasIncluded: { type: Boolean },
    showDOB: { type: Boolean }
  },
  setup(e) {
    return (t, n) => (V(), G("ul", bie, [
      (V(!0), G(cn, null, Pn(t.pricing, (i, r) => (V(), G("li", { key: r }, [
        it(_ie, {
          showDOB: t.showDOB,
          pricing: i,
          extrasIncluded: t.extrasIncluded
        }, null, 8, ["showDOB", "pricing", "extrasIncluded"])
      ]))), 128))
    ]));
  }
}), xie = {};
function $ie(e, t) {
  return er(e.$slots, "priceBreakdownLines");
}
const SS = /* @__PURE__ */ Zn(xie, [["render", $ie]]);
var ef = TypeError;
const Cie = {}, kie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Cie
}, Symbol.toStringTag, { value: "Module" })), Sie = /* @__PURE__ */ hte(kie);
var Fx = typeof Map == "function" && Map.prototype, s0 = Object.getOwnPropertyDescriptor && Fx ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, ky = Fx && s0 && typeof s0.get == "function" ? s0.get : null, TS = Fx && Map.prototype.forEach, Rx = typeof Set == "function" && Set.prototype, o0 = Object.getOwnPropertyDescriptor && Rx ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, Sy = Rx && o0 && typeof o0.get == "function" ? o0.get : null, IS = Rx && Set.prototype.forEach, Tie = typeof WeakMap == "function" && WeakMap.prototype, um = Tie ? WeakMap.prototype.has : null, Iie = typeof WeakSet == "function" && WeakSet.prototype, dm = Iie ? WeakSet.prototype.has : null, Aie = typeof WeakRef == "function" && WeakRef.prototype, AS = Aie ? WeakRef.prototype.deref : null, Eie = Boolean.prototype.valueOf, Pie = Object.prototype.toString, Mie = Function.prototype.toString, Die = String.prototype.match, zx = String.prototype.slice, ku = String.prototype.replace, Lie = String.prototype.toUpperCase, ES = String.prototype.toLowerCase, SD = RegExp.prototype.test, PS = Array.prototype.concat, Pl = Array.prototype.join, Oie = Array.prototype.slice, MS = Math.floor, Bw = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, a0 = Object.getOwnPropertySymbols, Vw = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, Ih = typeof Symbol == "function" && typeof Symbol.iterator == "object", pm = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === Ih || !0) ? Symbol.toStringTag : null, TD = Object.prototype.propertyIsEnumerable, DS = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(e) {
  return e.__proto__;
} : null);
function LS(e, t) {
  if (e === 1 / 0 || e === -1 / 0 || e !== e || e && e > -1e3 && e < 1e3 || SD.call(/e/, t))
    return t;
  var n = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if (typeof e == "number") {
    var i = e < 0 ? -MS(-e) : MS(e);
    if (i !== e) {
      var r = String(i), c = zx.call(t, r.length + 1);
      return ku.call(r, n, "$&_") + "." + ku.call(ku.call(c, /([0-9]{3})/g, "$&_"), /_$/, "");
    }
  }
  return ku.call(t, n, "$&_");
}
var Uw = Sie, OS = Uw.custom, NS = ED(OS) ? OS : null, ID = {
  __proto__: null,
  double: '"',
  single: "'"
}, Nie = {
  __proto__: null,
  double: /(["\\])/g,
  single: /(['\\])/g
}, f_ = function e(t, n, i, r) {
  var c = n || {};
  if ($c(c, "quoteStyle") && !$c(ID, c.quoteStyle))
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  if ($c(c, "maxStringLength") && (typeof c.maxStringLength == "number" ? c.maxStringLength < 0 && c.maxStringLength !== 1 / 0 : c.maxStringLength !== null))
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  var d = $c(c, "customInspect") ? c.customInspect : !0;
  if (typeof d != "boolean" && d !== "symbol")
    throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
  if ($c(c, "indent") && c.indent !== null && c.indent !== "	" && !(parseInt(c.indent, 10) === c.indent && c.indent > 0))
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  if ($c(c, "numericSeparator") && typeof c.numericSeparator != "boolean")
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  var a = c.numericSeparator;
  if (typeof t > "u")
    return "undefined";
  if (t === null)
    return "null";
  if (typeof t == "boolean")
    return t ? "true" : "false";
  if (typeof t == "string")
    return MD(t, c);
  if (typeof t == "number") {
    if (t === 0)
      return 1 / 0 / t > 0 ? "0" : "-0";
    var f = String(t);
    return a ? LS(t, f) : f;
  }
  if (typeof t == "bigint") {
    var g = String(t) + "n";
    return a ? LS(t, g) : g;
  }
  var x = typeof c.depth > "u" ? 5 : c.depth;
  if (typeof i > "u" && (i = 0), i >= x && x > 0 && typeof t == "object")
    return Hw(t) ? "[Array]" : "[Object]";
  var $ = ere(c, i);
  if (typeof r > "u")
    r = [];
  else if (PD(r, t) >= 0)
    return "[Circular]";
  function A(le, pe, Ne) {
    if (pe && (r = Oie.call(r), r.push(pe)), Ne) {
      var We = {
        depth: c.depth
      };
      return $c(c, "quoteStyle") && (We.quoteStyle = c.quoteStyle), e(le, We, i + 1, r);
    }
    return e(le, c, i + 1, r);
  }
  if (typeof t == "function" && !FS(t)) {
    var I = Zie(t), O = Yv(t, A);
    return "[Function" + (I ? ": " + I : " (anonymous)") + "]" + (O.length > 0 ? " { " + Pl.call(O, ", ") + " }" : "");
  }
  if (ED(t)) {
    var B = Ih ? ku.call(String(t), /^(Symbol\(.*\))_[^)]*$/, "$1") : Vw.call(t);
    return typeof t == "object" && !Ih ? Rf(B) : B;
  }
  if (Xie(t)) {
    for (var H = "<" + ES.call(String(t.nodeName)), N = t.attributes || [], K = 0; K < N.length; K++)
      H += " " + N[K].name + "=" + AD(Fie(N[K].value), "double", c);
    return H += ">", t.childNodes && t.childNodes.length && (H += "..."), H += "</" + ES.call(String(t.nodeName)) + ">", H;
  }
  if (Hw(t)) {
    if (t.length === 0)
      return "[]";
    var U = Yv(t, A);
    return $ && !Qie(U) ? "[" + Ww(U, $) + "]" : "[ " + Pl.call(U, ", ") + " ]";
  }
  if (zie(t)) {
    var q = Yv(t, A);
    return !("cause" in Error.prototype) && "cause" in t && !TD.call(t, "cause") ? "{ [" + String(t) + "] " + Pl.call(PS.call("[cause]: " + A(t.cause), q), ", ") + " }" : q.length === 0 ? "[" + String(t) + "]" : "{ [" + String(t) + "] " + Pl.call(q, ", ") + " }";
  }
  if (typeof t == "object" && d) {
    if (NS && typeof t[NS] == "function" && Uw)
      return Uw(t, { depth: x - i });
    if (d !== "symbol" && typeof t.inspect == "function")
      return t.inspect();
  }
  if (qie(t)) {
    var ee = [];
    return TS && TS.call(t, function(le, pe) {
      ee.push(A(pe, t, !0) + " => " + A(le, t));
    }), RS("Map", ky.call(t), ee, $);
  }
  if (Yie(t)) {
    var te = [];
    return IS && IS.call(t, function(le) {
      te.push(A(le, t));
    }), RS("Set", Sy.call(t), te, $);
  }
  if (jie(t))
    return l0("WeakMap");
  if (Kie(t))
    return l0("WeakSet");
  if (Gie(t))
    return l0("WeakRef");
  if (Vie(t))
    return Rf(A(Number(t)));
  if (Hie(t))
    return Rf(A(Bw.call(t)));
  if (Uie(t))
    return Rf(Eie.call(t));
  if (Bie(t))
    return Rf(A(String(t)));
  if (typeof window < "u" && t === window)
    return "{ [object Window] }";
  if (typeof globalThis < "u" && t === globalThis || typeof Em < "u" && t === Em)
    return "{ [object globalThis] }";
  if (!Rie(t) && !FS(t)) {
    var ae = Yv(t, A), oe = DS ? DS(t) === Object.prototype : t instanceof Object || t.constructor === Object, de = t instanceof Object ? "" : "null prototype", me = !oe && pm && Object(t) === t && pm in t ? zx.call(Hu(t), 8, -1) : de ? "Object" : "", ve = oe || typeof t.constructor != "function" ? "" : t.constructor.name ? t.constructor.name + " " : "", re = ve + (me || de ? "[" + Pl.call(PS.call([], me || [], de || []), ": ") + "] " : "");
    return ae.length === 0 ? re + "{}" : $ ? re + "{" + Ww(ae, $) + "}" : re + "{ " + Pl.call(ae, ", ") + " }";
  }
  return String(t);
};
function AD(e, t, n) {
  var i = n.quoteStyle || t, r = ID[i];
  return r + e + r;
}
function Fie(e) {
  return ku.call(String(e), /"/g, "&quot;");
}
function qd(e) {
  return !pm || !(typeof e == "object" && (pm in e || typeof e[pm] < "u"));
}
function Hw(e) {
  return Hu(e) === "[object Array]" && qd(e);
}
function Rie(e) {
  return Hu(e) === "[object Date]" && qd(e);
}
function FS(e) {
  return Hu(e) === "[object RegExp]" && qd(e);
}
function zie(e) {
  return Hu(e) === "[object Error]" && qd(e);
}
function Bie(e) {
  return Hu(e) === "[object String]" && qd(e);
}
function Vie(e) {
  return Hu(e) === "[object Number]" && qd(e);
}
function Uie(e) {
  return Hu(e) === "[object Boolean]" && qd(e);
}
function ED(e) {
  if (Ih)
    return e && typeof e == "object" && e instanceof Symbol;
  if (typeof e == "symbol")
    return !0;
  if (!e || typeof e != "object" || !Vw)
    return !1;
  try {
    return Vw.call(e), !0;
  } catch {
  }
  return !1;
}
function Hie(e) {
  if (!e || typeof e != "object" || !Bw)
    return !1;
  try {
    return Bw.call(e), !0;
  } catch {
  }
  return !1;
}
var Wie = Object.prototype.hasOwnProperty || function(e) {
  return e in this;
};
function $c(e, t) {
  return Wie.call(e, t);
}
function Hu(e) {
  return Pie.call(e);
}
function Zie(e) {
  if (e.name)
    return e.name;
  var t = Die.call(Mie.call(e), /^function\s*([\w$]+)/);
  return t ? t[1] : null;
}
function PD(e, t) {
  if (e.indexOf)
    return e.indexOf(t);
  for (var n = 0, i = e.length; n < i; n++)
    if (e[n] === t)
      return n;
  return -1;
}
function qie(e) {
  if (!ky || !e || typeof e != "object")
    return !1;
  try {
    ky.call(e);
    try {
      Sy.call(e);
    } catch {
      return !0;
    }
    return e instanceof Map;
  } catch {
  }
  return !1;
}
function jie(e) {
  if (!um || !e || typeof e != "object")
    return !1;
  try {
    um.call(e, um);
    try {
      dm.call(e, dm);
    } catch {
      return !0;
    }
    return e instanceof WeakMap;
  } catch {
  }
  return !1;
}
function Gie(e) {
  if (!AS || !e || typeof e != "object")
    return !1;
  try {
    return AS.call(e), !0;
  } catch {
  }
  return !1;
}
function Yie(e) {
  if (!Sy || !e || typeof e != "object")
    return !1;
  try {
    Sy.call(e);
    try {
      ky.call(e);
    } catch {
      return !0;
    }
    return e instanceof Set;
  } catch {
  }
  return !1;
}
function Kie(e) {
  if (!dm || !e || typeof e != "object")
    return !1;
  try {
    dm.call(e, dm);
    try {
      um.call(e, um);
    } catch {
      return !0;
    }
    return e instanceof WeakSet;
  } catch {
  }
  return !1;
}
function Xie(e) {
  return !e || typeof e != "object" ? !1 : typeof HTMLElement < "u" && e instanceof HTMLElement ? !0 : typeof e.nodeName == "string" && typeof e.getAttribute == "function";
}
function MD(e, t) {
  if (e.length > t.maxStringLength) {
    var n = e.length - t.maxStringLength, i = "... " + n + " more character" + (n > 1 ? "s" : "");
    return MD(zx.call(e, 0, t.maxStringLength), t) + i;
  }
  var r = Nie[t.quoteStyle || "single"];
  r.lastIndex = 0;
  var c = ku.call(ku.call(e, r, "\\$1"), /[\x00-\x1f]/g, Jie);
  return AD(c, "single", t);
}
function Jie(e) {
  var t = e.charCodeAt(0), n = {
    8: "b",
    9: "t",
    10: "n",
    12: "f",
    13: "r"
  }[t];
  return n ? "\\" + n : "\\x" + (t < 16 ? "0" : "") + Lie.call(t.toString(16));
}
function Rf(e) {
  return "Object(" + e + ")";
}
function l0(e) {
  return e + " { ? }";
}
function RS(e, t, n, i) {
  var r = i ? Ww(n, i) : Pl.call(n, ", ");
  return e + " (" + t + ") {" + r + "}";
}
function Qie(e) {
  for (var t = 0; t < e.length; t++)
    if (PD(e[t], `
`) >= 0)
      return !1;
  return !0;
}
function ere(e, t) {
  var n;
  if (e.indent === "	")
    n = "	";
  else if (typeof e.indent == "number" && e.indent > 0)
    n = Pl.call(Array(e.indent + 1), " ");
  else
    return null;
  return {
    base: n,
    prev: Pl.call(Array(t + 1), n)
  };
}
function Ww(e, t) {
  if (e.length === 0)
    return "";
  var n = `
` + t.prev + t.base;
  return n + Pl.call(e, "," + n) + `
` + t.prev;
}
function Yv(e, t) {
  var n = Hw(e), i = [];
  if (n) {
    i.length = e.length;
    for (var r = 0; r < e.length; r++)
      i[r] = $c(e, r) ? t(e[r], e) : "";
  }
  var c = typeof a0 == "function" ? a0(e) : [], d;
  if (Ih) {
    d = {};
    for (var a = 0; a < c.length; a++)
      d["$" + c[a]] = c[a];
  }
  for (var f in e)
    $c(e, f) && (n && String(Number(f)) === f && f < e.length || Ih && d["$" + f] instanceof Symbol || (SD.call(/[^\w$]/, f) ? i.push(t(f, e) + ": " + t(e[f], e)) : i.push(f + ": " + t(e[f], e))));
  if (typeof a0 == "function")
    for (var g = 0; g < c.length; g++)
      TD.call(e, c[g]) && i.push("[" + t(c[g]) + "]: " + t(e[c[g]], e));
  return i;
}
var tre = f_, nre = ef, m_ = function(e, t, n) {
  for (var i = e, r; (r = i.next) != null; i = r)
    if (r.key === t)
      return i.next = r.next, n || (r.next = /** @type {NonNullable<typeof list.next>} */
      e.next, e.next = r), r;
}, ire = function(e, t) {
  if (e) {
    var n = m_(e, t);
    return n && n.value;
  }
}, rre = function(e, t, n) {
  var i = m_(e, t);
  i ? i.value = n : e.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */
  {
    // eslint-disable-line no-param-reassign, no-extra-parens
    key: t,
    next: e.next,
    value: n
  };
}, sre = function(e, t) {
  return e ? !!m_(e, t) : !1;
}, ore = function(e, t) {
  if (e)
    return m_(e, t, !0);
}, are = function() {
  var t, n = {
    assert: function(i) {
      if (!n.has(i))
        throw new nre("Side channel does not contain " + tre(i));
    },
    delete: function(i) {
      var r = t && t.next, c = ore(t, i);
      return c && r && r === c && (t = void 0), !!c;
    },
    get: function(i) {
      return ire(t, i);
    },
    has: function(i) {
      return sre(t, i);
    },
    set: function(i, r) {
      t || (t = {
        next: void 0
      }), rre(
        /** @type {NonNullable<typeof $o>} */
        t,
        i,
        r
      );
    }
  };
  return n;
}, DD = Object, lre = Error, cre = EvalError, ure = RangeError, dre = ReferenceError, pre = SyntaxError, hre = URIError, fre = Math.abs, mre = Math.floor, vre = Math.max, gre = Math.min, yre = Math.pow, _re = Math.round, bre = Number.isNaN || function(t) {
  return t !== t;
}, wre = bre, xre = function(t) {
  return wre(t) || t === 0 ? t : t < 0 ? -1 : 1;
}, $re = Object.getOwnPropertyDescriptor, Pg = $re;
if (Pg)
  try {
    Pg([], "length");
  } catch {
    Pg = null;
  }
var LD = Pg, Mg = Object.defineProperty || !1;
if (Mg)
  try {
    Mg({}, "a", { value: 1 });
  } catch {
    Mg = !1;
  }
var Cre = Mg, c0, zS;
function kre() {
  return zS || (zS = 1, c0 = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var t = {}, n = Symbol("test"), i = Object(n);
    if (typeof n == "string" || Object.prototype.toString.call(n) !== "[object Symbol]" || Object.prototype.toString.call(i) !== "[object Symbol]")
      return !1;
    var r = 42;
    t[n] = r;
    for (var c in t)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(t).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(t).length !== 0)
      return !1;
    var d = Object.getOwnPropertySymbols(t);
    if (d.length !== 1 || d[0] !== n || !Object.prototype.propertyIsEnumerable.call(t, n))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var a = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(t, n)
      );
      if (a.value !== r || a.enumerable !== !0)
        return !1;
    }
    return !0;
  }), c0;
}
var u0, BS;
function Sre() {
  if (BS) return u0;
  BS = 1;
  var e = typeof Symbol < "u" && Symbol, t = kre();
  return u0 = function() {
    return typeof e != "function" || typeof Symbol != "function" || typeof e("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : t();
  }, u0;
}
var d0, VS;
function OD() {
  return VS || (VS = 1, d0 = typeof Reflect < "u" && Reflect.getPrototypeOf || null), d0;
}
var p0, US;
function ND() {
  if (US) return p0;
  US = 1;
  var e = DD;
  return p0 = e.getPrototypeOf || null, p0;
}
var h0, HS;
function Tre() {
  if (HS) return h0;
  HS = 1;
  var e = "Function.prototype.bind called on incompatible ", t = Object.prototype.toString, n = Math.max, i = "[object Function]", r = function(f, g) {
    for (var x = [], $ = 0; $ < f.length; $ += 1)
      x[$] = f[$];
    for (var A = 0; A < g.length; A += 1)
      x[A + f.length] = g[A];
    return x;
  }, c = function(f, g) {
    for (var x = [], $ = g, A = 0; $ < f.length; $ += 1, A += 1)
      x[A] = f[$];
    return x;
  }, d = function(a, f) {
    for (var g = "", x = 0; x < a.length; x += 1)
      g += a[x], x + 1 < a.length && (g += f);
    return g;
  };
  return h0 = function(f) {
    var g = this;
    if (typeof g != "function" || t.apply(g) !== i)
      throw new TypeError(e + g);
    for (var x = c(arguments, 1), $, A = function() {
      if (this instanceof $) {
        var N = g.apply(
          this,
          r(x, arguments)
        );
        return Object(N) === N ? N : this;
      }
      return g.apply(
        f,
        r(x, arguments)
      );
    }, I = n(0, g.length - x.length), O = [], B = 0; B < I; B++)
      O[B] = "$" + B;
    if ($ = Function("binder", "return function (" + d(O, ",") + "){ return binder.apply(this,arguments); }")(A), g.prototype) {
      var H = function() {
      };
      H.prototype = g.prototype, $.prototype = new H(), H.prototype = null;
    }
    return $;
  }, h0;
}
var f0, WS;
function v_() {
  if (WS) return f0;
  WS = 1;
  var e = Tre();
  return f0 = Function.prototype.bind || e, f0;
}
var m0, ZS;
function Bx() {
  return ZS || (ZS = 1, m0 = Function.prototype.call), m0;
}
var v0, qS;
function FD() {
  return qS || (qS = 1, v0 = Function.prototype.apply), v0;
}
var Ire = typeof Reflect < "u" && Reflect && Reflect.apply, Are = v_(), Ere = FD(), Pre = Bx(), Mre = Ire, Dre = Mre || Are.call(Pre, Ere), Lre = v_(), Ore = ef, Nre = Bx(), Fre = Dre, RD = function(t) {
  if (t.length < 1 || typeof t[0] != "function")
    throw new Ore("a function is required");
  return Fre(Lre, Nre, t);
}, g0, jS;
function Rre() {
  if (jS) return g0;
  jS = 1;
  var e = RD, t = LD, n;
  try {
    n = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (d) {
    if (!d || typeof d != "object" || !("code" in d) || d.code !== "ERR_PROTO_ACCESS")
      throw d;
  }
  var i = !!n && t && t(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  ), r = Object, c = r.getPrototypeOf;
  return g0 = i && typeof i.get == "function" ? e([i.get]) : typeof c == "function" ? (
    /** @type {import('./get')} */
    function(a) {
      return c(a == null ? a : r(a));
    }
  ) : !1, g0;
}
var y0, GS;
function zre() {
  if (GS) return y0;
  GS = 1;
  var e = OD(), t = ND(), n = Rre();
  return y0 = e ? function(r) {
    return e(r);
  } : t ? function(r) {
    if (!r || typeof r != "object" && typeof r != "function")
      throw new TypeError("getProto: not an object");
    return t(r);
  } : n ? function(r) {
    return n(r);
  } : null, y0;
}
var _0, YS;
function Bre() {
  if (YS) return _0;
  YS = 1;
  var e = Function.prototype.call, t = Object.prototype.hasOwnProperty, n = v_();
  return _0 = n.call(e, t), _0;
}
var ri, Vre = DD, Ure = lre, Hre = cre, Wre = ure, Zre = dre, Ah = pre, ph = ef, qre = hre, jre = fre, Gre = mre, Yre = vre, Kre = gre, Xre = yre, Jre = _re, Qre = xre, zD = Function, b0 = function(e) {
  try {
    return zD('"use strict"; return (' + e + ").constructor;")();
  } catch {
  }
}, Pm = LD, ese = Cre, w0 = function() {
  throw new ph();
}, tse = Pm ? function() {
  try {
    return arguments.callee, w0;
  } catch {
    try {
      return Pm(arguments, "callee").get;
    } catch {
      return w0;
    }
  }
}() : w0, Mp = Sre()(), ds = zre(), nse = ND(), ise = OD(), BD = FD(), Jm = Bx(), Wp = {}, rse = typeof Uint8Array > "u" || !ds ? ri : ds(Uint8Array), Ed = {
  __proto__: null,
  "%AggregateError%": typeof AggregateError > "u" ? ri : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? ri : ArrayBuffer,
  "%ArrayIteratorPrototype%": Mp && ds ? ds([][Symbol.iterator]()) : ri,
  "%AsyncFromSyncIteratorPrototype%": ri,
  "%AsyncFunction%": Wp,
  "%AsyncGenerator%": Wp,
  "%AsyncGeneratorFunction%": Wp,
  "%AsyncIteratorPrototype%": Wp,
  "%Atomics%": typeof Atomics > "u" ? ri : Atomics,
  "%BigInt%": typeof BigInt > "u" ? ri : BigInt,
  "%BigInt64Array%": typeof BigInt64Array > "u" ? ri : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array > "u" ? ri : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? ri : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": Ure,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": Hre,
  "%Float16Array%": typeof Float16Array > "u" ? ri : Float16Array,
  "%Float32Array%": typeof Float32Array > "u" ? ri : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? ri : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? ri : FinalizationRegistry,
  "%Function%": zD,
  "%GeneratorFunction%": Wp,
  "%Int8Array%": typeof Int8Array > "u" ? ri : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? ri : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? ri : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": Mp && ds ? ds(ds([][Symbol.iterator]())) : ri,
  "%JSON%": typeof JSON == "object" ? JSON : ri,
  "%Map%": typeof Map > "u" ? ri : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !Mp || !ds ? ri : ds((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Vre,
  "%Object.getOwnPropertyDescriptor%": Pm,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? ri : Promise,
  "%Proxy%": typeof Proxy > "u" ? ri : Proxy,
  "%RangeError%": Wre,
  "%ReferenceError%": Zre,
  "%Reflect%": typeof Reflect > "u" ? ri : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? ri : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !Mp || !ds ? ri : ds((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? ri : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": Mp && ds ? ds(""[Symbol.iterator]()) : ri,
  "%Symbol%": Mp ? Symbol : ri,
  "%SyntaxError%": Ah,
  "%ThrowTypeError%": tse,
  "%TypedArray%": rse,
  "%TypeError%": ph,
  "%Uint8Array%": typeof Uint8Array > "u" ? ri : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? ri : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? ri : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? ri : Uint32Array,
  "%URIError%": qre,
  "%WeakMap%": typeof WeakMap > "u" ? ri : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? ri : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? ri : WeakSet,
  "%Function.prototype.call%": Jm,
  "%Function.prototype.apply%": BD,
  "%Object.defineProperty%": ese,
  "%Object.getPrototypeOf%": nse,
  "%Math.abs%": jre,
  "%Math.floor%": Gre,
  "%Math.max%": Yre,
  "%Math.min%": Kre,
  "%Math.pow%": Xre,
  "%Math.round%": Jre,
  "%Math.sign%": Qre,
  "%Reflect.getPrototypeOf%": ise
};
if (ds)
  try {
    null.error;
  } catch (e) {
    var sse = ds(ds(e));
    Ed["%Error.prototype%"] = sse;
  }
var ose = function e(t) {
  var n;
  if (t === "%AsyncFunction%")
    n = b0("async function () {}");
  else if (t === "%GeneratorFunction%")
    n = b0("function* () {}");
  else if (t === "%AsyncGeneratorFunction%")
    n = b0("async function* () {}");
  else if (t === "%AsyncGenerator%") {
    var i = e("%AsyncGeneratorFunction%");
    i && (n = i.prototype);
  } else if (t === "%AsyncIteratorPrototype%") {
    var r = e("%AsyncGenerator%");
    r && ds && (n = ds(r.prototype));
  }
  return Ed[t] = n, n;
}, KS = {
  __proto__: null,
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, Qm = v_(), Ty = Bre(), ase = Qm.call(Jm, Array.prototype.concat), lse = Qm.call(BD, Array.prototype.splice), XS = Qm.call(Jm, String.prototype.replace), Iy = Qm.call(Jm, String.prototype.slice), cse = Qm.call(Jm, RegExp.prototype.exec), use = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, dse = /\\(\\)?/g, pse = function(t) {
  var n = Iy(t, 0, 1), i = Iy(t, -1);
  if (n === "%" && i !== "%")
    throw new Ah("invalid intrinsic syntax, expected closing `%`");
  if (i === "%" && n !== "%")
    throw new Ah("invalid intrinsic syntax, expected opening `%`");
  var r = [];
  return XS(t, use, function(c, d, a, f) {
    r[r.length] = a ? XS(f, dse, "$1") : d || c;
  }), r;
}, hse = function(t, n) {
  var i = t, r;
  if (Ty(KS, i) && (r = KS[i], i = "%" + r[0] + "%"), Ty(Ed, i)) {
    var c = Ed[i];
    if (c === Wp && (c = ose(i)), typeof c > "u" && !n)
      throw new ph("intrinsic " + t + " exists, but is not available. Please file an issue!");
    return {
      alias: r,
      name: i,
      value: c
    };
  }
  throw new Ah("intrinsic " + t + " does not exist!");
}, Vx = function(t, n) {
  if (typeof t != "string" || t.length === 0)
    throw new ph("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof n != "boolean")
    throw new ph('"allowMissing" argument must be a boolean');
  if (cse(/^%?[^%]*%?$/, t) === null)
    throw new Ah("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var i = pse(t), r = i.length > 0 ? i[0] : "", c = hse("%" + r + "%", n), d = c.name, a = c.value, f = !1, g = c.alias;
  g && (r = g[0], lse(i, ase([0, 1], g)));
  for (var x = 1, $ = !0; x < i.length; x += 1) {
    var A = i[x], I = Iy(A, 0, 1), O = Iy(A, -1);
    if ((I === '"' || I === "'" || I === "`" || O === '"' || O === "'" || O === "`") && I !== O)
      throw new Ah("property names with quotes must have matching quotes");
    if ((A === "constructor" || !$) && (f = !0), r += "." + A, d = "%" + r + "%", Ty(Ed, d))
      a = Ed[d];
    else if (a != null) {
      if (!(A in a)) {
        if (!n)
          throw new ph("base intrinsic for " + t + " exists, but the property is not available.");
        return;
      }
      if (Pm && x + 1 >= i.length) {
        var B = Pm(a, A);
        $ = !!B, $ && "get" in B && !("originalValue" in B.get) ? a = B.get : a = a[A];
      } else
        $ = Ty(a, A), a = a[A];
      $ && !f && (Ed[d] = a);
    }
  }
  return a;
}, VD = Vx, UD = RD, fse = UD([VD("%String.prototype.indexOf%")]), HD = function(t, n) {
  var i = (
    /** @type {Parameters<typeof callBindBasic>[0][0]} */
    VD(t, !!n)
  );
  return typeof i == "function" && fse(t, ".prototype.") > -1 ? UD([i]) : i;
}, mse = Vx, ev = HD, vse = f_, gse = ef, JS = mse("%Map%", !0), yse = ev("Map.prototype.get", !0), _se = ev("Map.prototype.set", !0), bse = ev("Map.prototype.has", !0), wse = ev("Map.prototype.delete", !0), xse = ev("Map.prototype.size", !0), WD = !!JS && /** @type {Exclude<import('.'), false>} */
function() {
  var t, n = {
    assert: function(i) {
      if (!n.has(i))
        throw new gse("Side channel does not contain " + vse(i));
    },
    delete: function(i) {
      if (t) {
        var r = wse(t, i);
        return xse(t) === 0 && (t = void 0), r;
      }
      return !1;
    },
    get: function(i) {
      if (t)
        return yse(t, i);
    },
    has: function(i) {
      return t ? bse(t, i) : !1;
    },
    set: function(i, r) {
      t || (t = new JS()), _se(t, i, r);
    }
  };
  return n;
}, $se = Vx, g_ = HD, Cse = f_, Kv = WD, kse = ef, Dp = $se("%WeakMap%", !0), Sse = g_("WeakMap.prototype.get", !0), Tse = g_("WeakMap.prototype.set", !0), Ise = g_("WeakMap.prototype.has", !0), Ase = g_("WeakMap.prototype.delete", !0), Ese = Dp ? (
  /** @type {Exclude<import('.'), false>} */
  function() {
    var t, n, i = {
      assert: function(r) {
        if (!i.has(r))
          throw new kse("Side channel does not contain " + Cse(r));
      },
      delete: function(r) {
        if (Dp && r && (typeof r == "object" || typeof r == "function")) {
          if (t)
            return Ase(t, r);
        } else if (Kv && n)
          return n.delete(r);
        return !1;
      },
      get: function(r) {
        return Dp && r && (typeof r == "object" || typeof r == "function") && t ? Sse(t, r) : n && n.get(r);
      },
      has: function(r) {
        return Dp && r && (typeof r == "object" || typeof r == "function") && t ? Ise(t, r) : !!n && n.has(r);
      },
      set: function(r, c) {
        Dp && r && (typeof r == "object" || typeof r == "function") ? (t || (t = new Dp()), Tse(t, r, c)) : Kv && (n || (n = Kv()), n.set(r, c));
      }
    };
    return i;
  }
) : Kv, Pse = ef, Mse = f_, Dse = are, Lse = WD, Ose = Ese, Nse = Ose || Lse || Dse, Fse = function() {
  var t, n = {
    assert: function(i) {
      if (!n.has(i))
        throw new Pse("Side channel does not contain " + Mse(i));
    },
    delete: function(i) {
      return !!t && t.delete(i);
    },
    get: function(i) {
      return t && t.get(i);
    },
    has: function(i) {
      return !!t && t.has(i);
    },
    set: function(i, r) {
      t || (t = Nse()), t.set(i, r);
    }
  };
  return n;
}, Rse = String.prototype.replace, zse = /%20/g, x0 = {
  RFC1738: "RFC1738",
  RFC3986: "RFC3986"
}, Ux = {
  default: x0.RFC3986,
  formatters: {
    RFC1738: function(e) {
      return Rse.call(e, zse, "+");
    },
    RFC3986: function(e) {
      return String(e);
    }
  },
  RFC1738: x0.RFC1738,
  RFC3986: x0.RFC3986
}, Bse = Ux, $0 = Object.prototype.hasOwnProperty, bd = Array.isArray, Tl = function() {
  for (var e = [], t = 0; t < 256; ++t)
    e.push("%" + ((t < 16 ? "0" : "") + t.toString(16)).toUpperCase());
  return e;
}(), Vse = function(t) {
  for (; t.length > 1; ) {
    var n = t.pop(), i = n.obj[n.prop];
    if (bd(i)) {
      for (var r = [], c = 0; c < i.length; ++c)
        typeof i[c] < "u" && r.push(i[c]);
      n.obj[n.prop] = r;
    }
  }
}, ZD = function(t, n) {
  for (var i = n && n.plainObjects ? { __proto__: null } : {}, r = 0; r < t.length; ++r)
    typeof t[r] < "u" && (i[r] = t[r]);
  return i;
}, Use = function e(t, n, i) {
  if (!n)
    return t;
  if (typeof n != "object" && typeof n != "function") {
    if (bd(t))
      t.push(n);
    else if (t && typeof t == "object")
      (i && (i.plainObjects || i.allowPrototypes) || !$0.call(Object.prototype, n)) && (t[n] = !0);
    else
      return [t, n];
    return t;
  }
  if (!t || typeof t != "object")
    return [t].concat(n);
  var r = t;
  return bd(t) && !bd(n) && (r = ZD(t, i)), bd(t) && bd(n) ? (n.forEach(function(c, d) {
    if ($0.call(t, d)) {
      var a = t[d];
      a && typeof a == "object" && c && typeof c == "object" ? t[d] = e(a, c, i) : t.push(c);
    } else
      t[d] = c;
  }), t) : Object.keys(n).reduce(function(c, d) {
    var a = n[d];
    return $0.call(c, d) ? c[d] = e(c[d], a, i) : c[d] = a, c;
  }, r);
}, Hse = function(t, n) {
  return Object.keys(n).reduce(function(i, r) {
    return i[r] = n[r], i;
  }, t);
}, Wse = function(e, t, n) {
  var i = e.replace(/\+/g, " ");
  if (n === "iso-8859-1")
    return i.replace(/%[0-9a-f]{2}/gi, unescape);
  try {
    return decodeURIComponent(i);
  } catch {
    return i;
  }
}, C0 = 1024, Zse = function(t, n, i, r, c) {
  if (t.length === 0)
    return t;
  var d = t;
  if (typeof t == "symbol" ? d = Symbol.prototype.toString.call(t) : typeof t != "string" && (d = String(t)), i === "iso-8859-1")
    return escape(d).replace(/%u[0-9a-f]{4}/gi, function(I) {
      return "%26%23" + parseInt(I.slice(2), 16) + "%3B";
    });
  for (var a = "", f = 0; f < d.length; f += C0) {
    for (var g = d.length >= C0 ? d.slice(f, f + C0) : d, x = [], $ = 0; $ < g.length; ++$) {
      var A = g.charCodeAt($);
      if (A === 45 || A === 46 || A === 95 || A === 126 || A >= 48 && A <= 57 || A >= 65 && A <= 90 || A >= 97 && A <= 122 || c === Bse.RFC1738 && (A === 40 || A === 41)) {
        x[x.length] = g.charAt($);
        continue;
      }
      if (A < 128) {
        x[x.length] = Tl[A];
        continue;
      }
      if (A < 2048) {
        x[x.length] = Tl[192 | A >> 6] + Tl[128 | A & 63];
        continue;
      }
      if (A < 55296 || A >= 57344) {
        x[x.length] = Tl[224 | A >> 12] + Tl[128 | A >> 6 & 63] + Tl[128 | A & 63];
        continue;
      }
      $ += 1, A = 65536 + ((A & 1023) << 10 | g.charCodeAt($) & 1023), x[x.length] = Tl[240 | A >> 18] + Tl[128 | A >> 12 & 63] + Tl[128 | A >> 6 & 63] + Tl[128 | A & 63];
    }
    a += x.join("");
  }
  return a;
}, qse = function(t) {
  for (var n = [{ obj: { o: t }, prop: "o" }], i = [], r = 0; r < n.length; ++r)
    for (var c = n[r], d = c.obj[c.prop], a = Object.keys(d), f = 0; f < a.length; ++f) {
      var g = a[f], x = d[g];
      typeof x == "object" && x !== null && i.indexOf(x) === -1 && (n.push({ obj: d, prop: g }), i.push(x));
    }
  return Vse(n), t;
}, jse = function(t) {
  return Object.prototype.toString.call(t) === "[object RegExp]";
}, Gse = function(t) {
  return !t || typeof t != "object" ? !1 : !!(t.constructor && t.constructor.isBuffer && t.constructor.isBuffer(t));
}, Yse = function(t, n) {
  return [].concat(t, n);
}, Kse = function(t, n) {
  if (bd(t)) {
    for (var i = [], r = 0; r < t.length; r += 1)
      i.push(n(t[r]));
    return i;
  }
  return n(t);
}, qD = {
  arrayToObject: ZD,
  assign: Hse,
  combine: Yse,
  compact: qse,
  decode: Wse,
  encode: Zse,
  isBuffer: Gse,
  isRegExp: jse,
  maybeMap: Kse,
  merge: Use
}, jD = Fse, Dg = qD, hm = Ux, Xse = Object.prototype.hasOwnProperty, GD = {
  brackets: function(t) {
    return t + "[]";
  },
  comma: "comma",
  indices: function(t, n) {
    return t + "[" + n + "]";
  },
  repeat: function(t) {
    return t;
  }
}, El = Array.isArray, Jse = Array.prototype.push, YD = function(e, t) {
  Jse.apply(e, El(t) ? t : [t]);
}, Qse = Date.prototype.toISOString, QS = hm.default, Qr = {
  addQueryPrefix: !1,
  allowDots: !1,
  allowEmptyArrays: !1,
  arrayFormat: "indices",
  charset: "utf-8",
  charsetSentinel: !1,
  commaRoundTrip: !1,
  delimiter: "&",
  encode: !0,
  encodeDotInKeys: !1,
  encoder: Dg.encode,
  encodeValuesOnly: !1,
  filter: void 0,
  format: QS,
  formatter: hm.formatters[QS],
  // deprecated
  indices: !1,
  serializeDate: function(t) {
    return Qse.call(t);
  },
  skipNulls: !1,
  strictNullHandling: !1
}, eoe = function(t) {
  return typeof t == "string" || typeof t == "number" || typeof t == "boolean" || typeof t == "symbol" || typeof t == "bigint";
}, k0 = {}, toe = function e(t, n, i, r, c, d, a, f, g, x, $, A, I, O, B, H, N, K) {
  for (var U = t, q = K, ee = 0, te = !1; (q = q.get(k0)) !== void 0 && !te; ) {
    var ae = q.get(t);
    if (ee += 1, typeof ae < "u") {
      if (ae === ee)
        throw new RangeError("Cyclic object value");
      te = !0;
    }
    typeof q.get(k0) > "u" && (ee = 0);
  }
  if (typeof x == "function" ? U = x(n, U) : U instanceof Date ? U = I(U) : i === "comma" && El(U) && (U = Dg.maybeMap(U, function(De) {
    return De instanceof Date ? I(De) : De;
  })), U === null) {
    if (d)
      return g && !H ? g(n, Qr.encoder, N, "key", O) : n;
    U = "";
  }
  if (eoe(U) || Dg.isBuffer(U)) {
    if (g) {
      var oe = H ? n : g(n, Qr.encoder, N, "key", O);
      return [B(oe) + "=" + B(g(U, Qr.encoder, N, "value", O))];
    }
    return [B(n) + "=" + B(String(U))];
  }
  var de = [];
  if (typeof U > "u")
    return de;
  var me;
  if (i === "comma" && El(U))
    H && g && (U = Dg.maybeMap(U, g)), me = [{ value: U.length > 0 ? U.join(",") || null : void 0 }];
  else if (El(x))
    me = x;
  else {
    var ve = Object.keys(U);
    me = $ ? ve.sort($) : ve;
  }
  var re = f ? String(n).replace(/\./g, "%2E") : String(n), le = r && El(U) && U.length === 1 ? re + "[]" : re;
  if (c && El(U) && U.length === 0)
    return le + "[]";
  for (var pe = 0; pe < me.length; ++pe) {
    var Ne = me[pe], We = typeof Ne == "object" && Ne && typeof Ne.value < "u" ? Ne.value : U[Ne];
    if (!(a && We === null)) {
      var Ge = A && f ? String(Ne).replace(/\./g, "%2E") : String(Ne), et = El(U) ? typeof i == "function" ? i(le, Ge) : le : le + (A ? "." + Ge : "[" + Ge + "]");
      K.set(t, ee);
      var ft = jD();
      ft.set(k0, K), YD(de, e(
        We,
        et,
        i,
        r,
        c,
        d,
        a,
        f,
        i === "comma" && H && El(U) ? null : g,
        x,
        $,
        A,
        I,
        O,
        B,
        H,
        N,
        ft
      ));
    }
  }
  return de;
}, noe = function(t) {
  if (!t)
    return Qr;
  if (typeof t.allowEmptyArrays < "u" && typeof t.allowEmptyArrays != "boolean")
    throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
  if (typeof t.encodeDotInKeys < "u" && typeof t.encodeDotInKeys != "boolean")
    throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
  if (t.encoder !== null && typeof t.encoder < "u" && typeof t.encoder != "function")
    throw new TypeError("Encoder has to be a function.");
  var n = t.charset || Qr.charset;
  if (typeof t.charset < "u" && t.charset !== "utf-8" && t.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var i = hm.default;
  if (typeof t.format < "u") {
    if (!Xse.call(hm.formatters, t.format))
      throw new TypeError("Unknown format option provided.");
    i = t.format;
  }
  var r = hm.formatters[i], c = Qr.filter;
  (typeof t.filter == "function" || El(t.filter)) && (c = t.filter);
  var d;
  if (t.arrayFormat in GD ? d = t.arrayFormat : "indices" in t ? d = t.indices ? "indices" : "repeat" : d = Qr.arrayFormat, "commaRoundTrip" in t && typeof t.commaRoundTrip != "boolean")
    throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
  var a = typeof t.allowDots > "u" ? t.encodeDotInKeys === !0 ? !0 : Qr.allowDots : !!t.allowDots;
  return {
    addQueryPrefix: typeof t.addQueryPrefix == "boolean" ? t.addQueryPrefix : Qr.addQueryPrefix,
    allowDots: a,
    allowEmptyArrays: typeof t.allowEmptyArrays == "boolean" ? !!t.allowEmptyArrays : Qr.allowEmptyArrays,
    arrayFormat: d,
    charset: n,
    charsetSentinel: typeof t.charsetSentinel == "boolean" ? t.charsetSentinel : Qr.charsetSentinel,
    commaRoundTrip: !!t.commaRoundTrip,
    delimiter: typeof t.delimiter > "u" ? Qr.delimiter : t.delimiter,
    encode: typeof t.encode == "boolean" ? t.encode : Qr.encode,
    encodeDotInKeys: typeof t.encodeDotInKeys == "boolean" ? t.encodeDotInKeys : Qr.encodeDotInKeys,
    encoder: typeof t.encoder == "function" ? t.encoder : Qr.encoder,
    encodeValuesOnly: typeof t.encodeValuesOnly == "boolean" ? t.encodeValuesOnly : Qr.encodeValuesOnly,
    filter: c,
    format: i,
    formatter: r,
    serializeDate: typeof t.serializeDate == "function" ? t.serializeDate : Qr.serializeDate,
    skipNulls: typeof t.skipNulls == "boolean" ? t.skipNulls : Qr.skipNulls,
    sort: typeof t.sort == "function" ? t.sort : null,
    strictNullHandling: typeof t.strictNullHandling == "boolean" ? t.strictNullHandling : Qr.strictNullHandling
  };
}, ioe = function(e, t) {
  var n = e, i = noe(t), r, c;
  typeof i.filter == "function" ? (c = i.filter, n = c("", n)) : El(i.filter) && (c = i.filter, r = c);
  var d = [];
  if (typeof n != "object" || n === null)
    return "";
  var a = GD[i.arrayFormat], f = a === "comma" && i.commaRoundTrip;
  r || (r = Object.keys(n)), i.sort && r.sort(i.sort);
  for (var g = jD(), x = 0; x < r.length; ++x) {
    var $ = r[x], A = n[$];
    i.skipNulls && A === null || YD(d, toe(
      A,
      $,
      a,
      f,
      i.allowEmptyArrays,
      i.strictNullHandling,
      i.skipNulls,
      i.encodeDotInKeys,
      i.encode ? i.encoder : null,
      i.filter,
      i.sort,
      i.allowDots,
      i.serializeDate,
      i.format,
      i.formatter,
      i.encodeValuesOnly,
      i.charset,
      g
    ));
  }
  var I = d.join(i.delimiter), O = i.addQueryPrefix === !0 ? "?" : "";
  return i.charsetSentinel && (i.charset === "iso-8859-1" ? O += "utf8=%26%2310003%3B&" : O += "utf8=%E2%9C%93&"), I.length > 0 ? O + I : "";
}, Rd = qD, Zw = Object.prototype.hasOwnProperty, eT = Array.isArray, gr = {
  allowDots: !1,
  allowEmptyArrays: !1,
  allowPrototypes: !1,
  allowSparse: !1,
  arrayLimit: 20,
  charset: "utf-8",
  charsetSentinel: !1,
  comma: !1,
  decodeDotInKeys: !1,
  decoder: Rd.decode,
  delimiter: "&",
  depth: 5,
  duplicates: "combine",
  ignoreQueryPrefix: !1,
  interpretNumericEntities: !1,
  parameterLimit: 1e3,
  parseArrays: !0,
  plainObjects: !1,
  strictDepth: !1,
  strictNullHandling: !1,
  throwOnLimitExceeded: !1
}, roe = function(e) {
  return e.replace(/&#(\d+);/g, function(t, n) {
    return String.fromCharCode(parseInt(n, 10));
  });
}, KD = function(e, t, n) {
  if (e && typeof e == "string" && t.comma && e.indexOf(",") > -1)
    return e.split(",");
  if (t.throwOnLimitExceeded && n >= t.arrayLimit)
    throw new RangeError("Array limit exceeded. Only " + t.arrayLimit + " element" + (t.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
  return e;
}, soe = "utf8=%26%2310003%3B", ooe = "utf8=%E2%9C%93", aoe = function(t, n) {
  var i = { __proto__: null }, r = n.ignoreQueryPrefix ? t.replace(/^\?/, "") : t;
  r = r.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
  var c = n.parameterLimit === 1 / 0 ? void 0 : n.parameterLimit, d = r.split(
    n.delimiter,
    n.throwOnLimitExceeded ? c + 1 : c
  );
  if (n.throwOnLimitExceeded && d.length > c)
    throw new RangeError("Parameter limit exceeded. Only " + c + " parameter" + (c === 1 ? "" : "s") + " allowed.");
  var a = -1, f, g = n.charset;
  if (n.charsetSentinel)
    for (f = 0; f < d.length; ++f)
      d[f].indexOf("utf8=") === 0 && (d[f] === ooe ? g = "utf-8" : d[f] === soe && (g = "iso-8859-1"), a = f, f = d.length);
  for (f = 0; f < d.length; ++f)
    if (f !== a) {
      var x = d[f], $ = x.indexOf("]="), A = $ === -1 ? x.indexOf("=") : $ + 1, I, O;
      A === -1 ? (I = n.decoder(x, gr.decoder, g, "key"), O = n.strictNullHandling ? null : "") : (I = n.decoder(x.slice(0, A), gr.decoder, g, "key"), O = Rd.maybeMap(
        KD(
          x.slice(A + 1),
          n,
          eT(i[I]) ? i[I].length : 0
        ),
        function(H) {
          return n.decoder(H, gr.decoder, g, "value");
        }
      )), O && n.interpretNumericEntities && g === "iso-8859-1" && (O = roe(String(O))), x.indexOf("[]=") > -1 && (O = eT(O) ? [O] : O);
      var B = Zw.call(i, I);
      B && n.duplicates === "combine" ? i[I] = Rd.combine(i[I], O) : (!B || n.duplicates === "last") && (i[I] = O);
    }
  return i;
}, loe = function(e, t, n, i) {
  var r = 0;
  if (e.length > 0 && e[e.length - 1] === "[]") {
    var c = e.slice(0, -1).join("");
    r = Array.isArray(t) && t[c] ? t[c].length : 0;
  }
  for (var d = i ? t : KD(t, n, r), a = e.length - 1; a >= 0; --a) {
    var f, g = e[a];
    if (g === "[]" && n.parseArrays)
      f = n.allowEmptyArrays && (d === "" || n.strictNullHandling && d === null) ? [] : Rd.combine([], d);
    else {
      f = n.plainObjects ? { __proto__: null } : {};
      var x = g.charAt(0) === "[" && g.charAt(g.length - 1) === "]" ? g.slice(1, -1) : g, $ = n.decodeDotInKeys ? x.replace(/%2E/g, ".") : x, A = parseInt($, 10);
      !n.parseArrays && $ === "" ? f = { 0: d } : !isNaN(A) && g !== $ && String(A) === $ && A >= 0 && n.parseArrays && A <= n.arrayLimit ? (f = [], f[A] = d) : $ !== "__proto__" && (f[$] = d);
    }
    d = f;
  }
  return d;
}, coe = function(t, n, i, r) {
  if (t) {
    var c = i.allowDots ? t.replace(/\.([^.[]+)/g, "[$1]") : t, d = /(\[[^[\]]*])/, a = /(\[[^[\]]*])/g, f = i.depth > 0 && d.exec(c), g = f ? c.slice(0, f.index) : c, x = [];
    if (g) {
      if (!i.plainObjects && Zw.call(Object.prototype, g) && !i.allowPrototypes)
        return;
      x.push(g);
    }
    for (var $ = 0; i.depth > 0 && (f = a.exec(c)) !== null && $ < i.depth; ) {
      if ($ += 1, !i.plainObjects && Zw.call(Object.prototype, f[1].slice(1, -1)) && !i.allowPrototypes)
        return;
      x.push(f[1]);
    }
    if (f) {
      if (i.strictDepth === !0)
        throw new RangeError("Input depth exceeded depth option of " + i.depth + " and strictDepth is true");
      x.push("[" + c.slice(f.index) + "]");
    }
    return loe(x, n, i, r);
  }
}, uoe = function(t) {
  if (!t)
    return gr;
  if (typeof t.allowEmptyArrays < "u" && typeof t.allowEmptyArrays != "boolean")
    throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
  if (typeof t.decodeDotInKeys < "u" && typeof t.decodeDotInKeys != "boolean")
    throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
  if (t.decoder !== null && typeof t.decoder < "u" && typeof t.decoder != "function")
    throw new TypeError("Decoder has to be a function.");
  if (typeof t.charset < "u" && t.charset !== "utf-8" && t.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  if (typeof t.throwOnLimitExceeded < "u" && typeof t.throwOnLimitExceeded != "boolean")
    throw new TypeError("`throwOnLimitExceeded` option must be a boolean");
  var n = typeof t.charset > "u" ? gr.charset : t.charset, i = typeof t.duplicates > "u" ? gr.duplicates : t.duplicates;
  if (i !== "combine" && i !== "first" && i !== "last")
    throw new TypeError("The duplicates option must be either combine, first, or last");
  var r = typeof t.allowDots > "u" ? t.decodeDotInKeys === !0 ? !0 : gr.allowDots : !!t.allowDots;
  return {
    allowDots: r,
    allowEmptyArrays: typeof t.allowEmptyArrays == "boolean" ? !!t.allowEmptyArrays : gr.allowEmptyArrays,
    allowPrototypes: typeof t.allowPrototypes == "boolean" ? t.allowPrototypes : gr.allowPrototypes,
    allowSparse: typeof t.allowSparse == "boolean" ? t.allowSparse : gr.allowSparse,
    arrayLimit: typeof t.arrayLimit == "number" ? t.arrayLimit : gr.arrayLimit,
    charset: n,
    charsetSentinel: typeof t.charsetSentinel == "boolean" ? t.charsetSentinel : gr.charsetSentinel,
    comma: typeof t.comma == "boolean" ? t.comma : gr.comma,
    decodeDotInKeys: typeof t.decodeDotInKeys == "boolean" ? t.decodeDotInKeys : gr.decodeDotInKeys,
    decoder: typeof t.decoder == "function" ? t.decoder : gr.decoder,
    delimiter: typeof t.delimiter == "string" || Rd.isRegExp(t.delimiter) ? t.delimiter : gr.delimiter,
    // eslint-disable-next-line no-implicit-coercion, no-extra-parens
    depth: typeof t.depth == "number" || t.depth === !1 ? +t.depth : gr.depth,
    duplicates: i,
    ignoreQueryPrefix: t.ignoreQueryPrefix === !0,
    interpretNumericEntities: typeof t.interpretNumericEntities == "boolean" ? t.interpretNumericEntities : gr.interpretNumericEntities,
    parameterLimit: typeof t.parameterLimit == "number" ? t.parameterLimit : gr.parameterLimit,
    parseArrays: t.parseArrays !== !1,
    plainObjects: typeof t.plainObjects == "boolean" ? t.plainObjects : gr.plainObjects,
    strictDepth: typeof t.strictDepth == "boolean" ? !!t.strictDepth : gr.strictDepth,
    strictNullHandling: typeof t.strictNullHandling == "boolean" ? t.strictNullHandling : gr.strictNullHandling,
    throwOnLimitExceeded: typeof t.throwOnLimitExceeded == "boolean" ? t.throwOnLimitExceeded : !1
  };
}, doe = function(e, t) {
  var n = uoe(t);
  if (e === "" || e === null || typeof e > "u")
    return n.plainObjects ? { __proto__: null } : {};
  for (var i = typeof e == "string" ? aoe(e, n) : e, r = n.plainObjects ? { __proto__: null } : {}, c = Object.keys(i), d = 0; d < c.length; ++d) {
    var a = c[d], f = coe(a, i[a], n, typeof e == "string");
    r = Rd.merge(r, f, n);
  }
  return n.allowSparse === !0 ? r : Rd.compact(r);
}, poe = ioe, hoe = doe, foe = Ux, moe = {
  formats: foe,
  parse: hoe,
  stringify: poe
};
const voe = /* @__PURE__ */ Nx(moe), goe = (e, t) => {
  const n = voe.parse(t.substring(t.indexOf("?") + 1)), i = Object.entries(n).filter((d) => d[0].startsWith("non_adult")).map((d) => {
    let a = 0;
    typeof d[0] == "string" && (a = parseInt(d[0].substring(9)));
    let f = 0;
    return typeof d[1] == "string" && (f = parseInt(d[1])), [a, f];
  });
  i.sort((d, a) => d[0] < a[0] ? -1 : 1);
  const r = i.map((d) => d[1]), c = [...e ?? []];
  return c.sort(function(d, a) {
    if (d.paxType === "C" && a.paxType === "C" && typeof d.paxAge == "number" && typeof a.paxAge == "number") {
      const f = r.indexOf(d.paxAge), g = r.indexOf(a.paxAge);
      return f > g ? 1 : -1;
    }
    return 0;
  }), c;
}, yoe = {
  key: 0,
  class: "breakdown-wrapper"
}, _oe = { class: "vacv-label-sm" }, boe = { class: "breakdown-travellerList" }, woe = { class: "breakdown-price-section" }, xoe = { class: "price-row baseprice" }, $oe = { class: "qty" }, Coe = { class: "total" }, koe = { class: "price-row" }, Soe = { class: "qty" }, Toe = { class: "total" }, Ioe = {
  key: 1,
  class: "breakdown-wrapper"
}, Aoe = { class: "vacv-label-sm" }, Eoe = {
  key: 0,
  class: "packageInclusions"
}, Hx = /* @__PURE__ */ at({
  __name: "PriceBreakdown",
  props: {
    prePackagePricing: {},
    packageInclusions: {},
    extrasIncluded: { type: Boolean },
    spaType: {},
    showDOB: { type: Boolean }
  },
  setup(e) {
    const t = e, n = Ae(() => {
      var d;
      const c = (d = t == null ? void 0 : t.prePackagePricing) == null ? void 0 : d.perPaxType;
      return goe(c, document.location.search);
    }), i = Ae(() => t.prePackagePricing), r = t.spaType === ps.HotelsSpa;
    return (c, d) => r ? (V(), G("div", yoe, [
      E("h3", _oe, Y(c.$t("vacvComponents.pricedetails.titleHotelsSpa")), 1),
      E("ul", boe, [
        E("li", null, [
          E("ul", woe, [
            E("li", xoe, [
              E("div", $oe, [
                mt(Y(i.value.numberOfNights) + " ", 1),
                E("span", null, Y(c.$t("vacvComponents.pricedetails.nights")), 1),
                E("div", null, "    x " + Y(ne(Wn)(i.value.perNightWithOutTax, c.$n)), 1)
              ]),
              E("div", Coe, Y(ne(Wn)(i.value.totalWithOutTax, c.$n)), 1)
            ]),
            E("li", koe, [
              E("div", Soe, [
                mt("  "),
                E("span", null, Y(c.$t("vacvComponents.pricedetails.taxesAndFees")), 1)
              ]),
              E("div", Toe, Y(ne(Wn)(i.value.totalTax, c.$n)), 1)
            ])
          ])
        ])
      ]),
      it(SS, null, {
        priceBreakdownLines: Qt(() => [
          er(c.$slots, "priceBreakdownLines")
        ]),
        _: 3
      }),
      er(c.$slots, "default")
    ])) : (V(), G("div", Ioe, [
      E("h3", Aoe, [
        mt(Y(c.$t("vacvComponents.pricedetails.title")) + " ", 1),
        c.packageInclusions ? (V(), G("span", Eoe, "(" + Y(c.packageInclusions) + ")", 1)) : _e("", !0)
      ]),
      it(wie, {
        showDOB: c.showDOB,
        pricing: n.value,
        extrasIncluded: c.extrasIncluded
      }, null, 8, ["showDOB", "pricing", "extrasIncluded"]),
      it(SS, null, {
        priceBreakdownLines: Qt(() => [
          er(c.$slots, "priceBreakdownLines")
        ]),
        _: 3
      }),
      er(c.$slots, "default")
    ]));
  }
}), Poe = (e) => (nl("data-v-ace4b36f"), e = e(), il(), e), Moe = { class: "price" }, Doe = /* @__PURE__ */ Poe(() => /* @__PURE__ */ E("span", {
  class: "round-icon",
  "aria-hidden": "true"
}, null, -1)), Loe = {
  key: 0,
  class: "aeroplan-applied"
}, Ooe = /* @__PURE__ */ at({
  __name: "PriceTotal",
  props: {
    total: {},
    aeroplanPoints: {}
  },
  emits: ["hide"],
  setup(e) {
    const t = e, n = Ae(
      () => {
        var i;
        return t.aeroplanPoints && ((i = t.aeroplanPoints) == null ? void 0 : i.pointsCashValue) > 0;
      }
    );
    return (i, r) => {
      var c;
      return V(), G(cn, null, [
        E("button", {
          class: "price-popover-link link",
          onClick: r[0] || (r[0] = zi((d) => i.$emit("hide"), ["stop"])),
          "aria-haspopup": "true"
        }, [
          E("span", Moe, Y(ne(Wn)(t.total, i.$n)), 1),
          mt(" " + Y(i.$t("vacvComponents.pricedetails.total")) + " ", 1),
          Doe
        ]),
        n.value ? (V(), G("div", Loe, Y(i.$n((c = i.aeroplanPoints) == null ? void 0 : c.amountOfPoints, "decimal")) + " " + Y(i.$t("vacvComponents.pricedetails.aeroplan-points-applied")), 1)) : _e("", !0)
      ], 64);
    };
  }
}), Noe = /* @__PURE__ */ Zn(Ooe, [["__scopeId", "data-v-ace4b36f"]]), Foe = {}, Roe = { class: "pricedisclaimer-section" }, zoe = { class: "legal" };
function Boe(e, t) {
  return V(), G("section", Roe, [
    E("div", zoe, Y(e.$t("vacvComponents.legal.disclaimer.price")), 1)
  ]);
}
const qw = /* @__PURE__ */ Zn(Foe, [["render", Boe]]), Voe = ["innerHTML"], Uoe = /* @__PURE__ */ at({
  __name: "BreakdownRow",
  props: {
    title: {},
    value: {},
    reverseOrder: { type: Boolean, default: !1 },
    titleClasses: {},
    valueClasses: {}
  },
  setup(e) {
    return (t, n) => (V(), G("div", {
      class: Et(["bdrow", [
        {
          "bdrow--reversed": t.reverseOrder
        },
        t.$attrs.class
      ]])
    }, [
      E("div", {
        innerHTML: t.title,
        class: Et(["bdrow__title", t.titleClasses])
      }, null, 10, Voe),
      t.value ? (V(), G("div", {
        key: 0,
        class: Et(["bdrow__value", t.valueClasses])
      }, Y(t.value), 3)) : _e("", !0)
    ], 2));
  }
}), Fu = /* @__PURE__ */ Zn(Uoe, [["__scopeId", "data-v-60635fea"]]), Hoe = {}, Woe = { class: "non-refundable-rate" };
function Zoe(e, t) {
  return V(), G("div", Woe, Y(e.$t("vacvComponents.pricedetails.nonRefundableRate")), 1);
}
const Wx = /* @__PURE__ */ Zn(Hoe, [["render", Zoe]]), qoe = /* @__PURE__ */ at({
  __name: "PriceTotalRow",
  props: {
    priceTotal: {},
    estimated: { type: Boolean, default: !0 },
    reverseOrder: { type: Boolean, default: !1 },
    modifier: {},
    isSection: { type: Boolean },
    isRefundable: { type: Boolean, default: !0 },
    includesTravelInsurance: { type: Boolean },
    spaType: {}
  },
  setup(e) {
    const t = e, { t: n } = ki({ useScope: "global" }), i = Ae(() => t.spaType === ps.HotelsSpa || t.estimated ? n("vacvComponents.pricedetails.estimatedTotal") : n("vacvComponents.pricedetails.total")), r = Ae(
      () => t.includesTravelInsurance ? i.value + "<sup>†</sup>" : i.value
    ), c = Ae(() => ({
      "bdrow--grand": t.modifier === "grand",
      "bdrow--amount": t.modifier === "amount",
      "bdrow--popover": t.modifier === "popover",
      "bdrow--confirmation": t.modifier === "confirmation",
      "bdrow--checkout-mobile": t.modifier === "checkout-mobile",
      "bdrow--mobile": t.modifier === "mobile"
    }));
    return (d, a) => (V(), G("div", {
      class: Et(["grand-total pricetotalrow", { "pricetotalrow--section": d.isSection }])
    }, [
      it(Fu, {
        title: r.value,
        value: d.priceTotal != null && !isNaN(d.priceTotal) ? ne(Wn)(d.priceTotal, d.$n) : "",
        "reverse-order": d.reverseOrder,
        class: Et(c.value)
      }, null, 8, ["title", "value", "reverse-order", "class"]),
      d.isRefundable ? _e("", !0) : (V(), Tt(Wx, { key: 0 }))
    ], 2));
  }
}), Zx = /* @__PURE__ */ Zn(qoe, [["__scopeId", "data-v-c78529f3"]]), joe = {
  key: 0,
  class: "subtotal subtotal--section"
}, Goe = /* @__PURE__ */ at({
  __name: "SubTotalRow",
  props: {
    subTotal: {}
  },
  setup(e) {
    return (t, n) => t.subTotal && t.subTotal > 0 ? (V(), G("div", joe, [
      it(Fu, {
        title: t.$t("vacvComponents.pricedetails.paymentSubtotal"),
        value: ne(Wn)(t.subTotal, t.$n),
        class: "bdrow--amount-total"
      }, null, 8, ["title", "value"])
    ])) : _e("", !0);
  }
}), XD = /* @__PURE__ */ Zn(Goe, [["__scopeId", "data-v-206ae3c0"]]), Yoe = { class: "price-left" }, Koe = ["aria-label"], Xoe = { class: "disclaimer legal" }, Joe = { class: "total-wrapper" }, Qoe = { class: "price-per" }, eae = { class: "vacv-price" }, tae = {
  key: 0,
  class: "per"
}, nae = {
  key: 1,
  class: "per"
}, iae = { class: "price-total" }, rae = ["aria-label"], sae = { class: "price-taxes" }, oae = /* @__PURE__ */ at({
  __name: "PriceDetails",
  props: {
    prePackagePricing: {},
    aeroplanPoints: {},
    price: {},
    total: {},
    showDifference: { type: Boolean },
    wasPricePerAdult: {},
    savingsPercentage: {},
    savingsThreshold: {},
    wasPriceTooltipEnabled: { type: Boolean },
    spaType: {}
  },
  emits: ["price-total-click", "was-price-click"],
  setup(e, { emit: t }) {
    const n = e, i = t, r = $e(!1), c = $e(!1), d = () => {
      window.addEventListener("mousedown", f), window.addEventListener("touchstart", f);
    }, a = () => {
      window.removeEventListener("mousedown", f), window.removeEventListener("touchstart", f);
    }, f = (O) => {
      Hg(O, ["popper", "price-popover-link"]) && (r.value = !1, a()), Hg(O, ["popper", "was-price-popover-link"]) && (c.value = !1, a());
    }, { placement: g } = O5(), x = Ae(() => n.savingsPercentage !== void 0 && n.savingsPercentage >= (n.savingsThreshold ?? 0)), $ = () => {
      c.value = !c.value, c.value ? (i("was-price-click"), d()) : a();
    }, A = () => {
      r.value = !r.value, r.value ? (d(), i("price-total-click")) : a();
    }, I = Ae(() => n.spaType === ps.HotelsSpa);
    return (O, B) => (V(), G("div", Yoe, [
      x.value ? (V(), G("div", {
        key: 0,
        class: Et(["was-price-wrapper", { "tooltip-none": !O.wasPriceTooltipEnabled }])
      }, [
        it(ne(uy), {
          arrow: "",
          show: c.value,
          placement: ne(g),
          onClick: $
        }, zg({
          default: Qt(() => [
            O.savingsPercentage ? (V(), Tt(u6, {
              key: 0,
              percentage: O.savingsPercentage,
              "was-price": O.wasPricePerAdult,
              "show-fraction": !0
            }, null, 8, ["percentage", "was-price"])) : _e("", !0)
          ]),
          _: 2
        }, [
          c.value ? {
            name: "content",
            fn: Qt(() => [
              E("button", {
                class: "btn-close",
                onClick: zi($, ["stop"]),
                "aria-label": O.$t("vacvComponents.common.buttons.close")
              }, null, 8, Koe),
              E("span", Xoe, Y(O.$t("vacvComponents.legal.disclaimer.was-price")), 1)
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["show", "placement"])
      ], 2)) : _e("", !0),
      E("div", Joe, [
        E("div", Qoe, [
          E("span", eae, Y(O.showDifference ? "+" : "") + " " + Y(ne(Wn)(O.price, O.$n)), 1),
          I.value ? (V(), G("span", tae, Y(O.$t("vacvComponents.common.pricedetails.perNight")), 1)) : (V(), G("span", nae, Y(O.$t("vacvComponents.common.pricedetails.peradult")), 1))
        ]),
        E("div", iae, [
          it(ne(uy), {
            arrow: "",
            show: r.value,
            placement: ne(g),
            onClick: A
          }, zg({
            default: Qt(() => [
              it(Noe, {
                total: O.total,
                aeroplanPoints: O.aeroplanPoints,
                onHide: A
              }, null, 8, ["total", "aeroplanPoints"])
            ]),
            _: 2
          }, [
            r.value ? {
              name: "content",
              fn: Qt(() => [
                E("button", {
                  class: "btn-close",
                  onClick: zi(A, ["stop"]),
                  "aria-label": O.$t("vacvComponents.common.buttons.close")
                }, null, 8, rae),
                it(Hx, {
                  "pre-package-pricing": O.prePackagePricing,
                  spaType: O.spaType,
                  onHide: A,
                  showDOB: !0
                }, {
                  priceBreakdownLines: Qt(() => [
                    er(O.$slots, "priceBreakdownLines", {}, void 0, !0)
                  ]),
                  default: Qt(() => [
                    B[0] || (Bg(-1), (B[0] = it(qw)).cacheIndex = 0, Bg(1), B[0])
                  ]),
                  _: 3
                }, 8, ["pre-package-pricing", "spaType"])
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["show", "placement"])
        ]),
        E("div", sae, Y(O.$t("vacvComponents.common.pricedetails.taxesincl")), 1)
      ])
    ]));
  }
}), JD = /* @__PURE__ */ Zn(oae, [["__scopeId", "data-v-7595116b"]]), aae = {
  key: 0,
  class: "aeroplanpoints-row"
}, lae = /* @__PURE__ */ at({
  __name: "AeroplanPointsRow",
  props: {
    pointsToRedeem: {},
    dollarValue: {}
  },
  setup(e) {
    const { n: t, t: n } = ki({ useScope: "global" }), i = e, r = Ae(
      () => t(i.pointsToRedeem) + " " + n("vacvComponents.pricedetails.paymentAEPoints")
    );
    return (c, d) => c.dollarValue > 0 ? (V(), G("div", aae, [
      it(Fu, {
        title: r.value,
        value: "-" + ne(Wn)(c.dollarValue, c.$n),
        "value-classes": "text-red",
        class: "bdrow--small"
      }, null, 8, ["title", "value"])
    ])) : _e("", !0);
  }
}), QD = /* @__PURE__ */ Zn(lae, [["__scopeId", "data-v-f05da014"]]), cae = {
  key: 0,
  class: "information-notes-section"
}, uae = ["innerHTML"], dae = /* @__PURE__ */ at({
  __name: "ConfirmationImportantNotes",
  props: {
    activity: {}
  },
  setup(e) {
    return (t, n) => t.activity.importantNotes ? (V(), G("section", cae, [
      E("div", {
        id: "notes-div",
        class: "paddedbox-grey note",
        innerHTML: t.activity.importantNotes
      }, null, 8, uae)
    ])) : _e("", !0);
  }
}), pae = { class: "confirm-success-section" }, hae = /* @__PURE__ */ E("i", {
  class: "fa-solid fa-check",
  "aria-hidden": "true"
}, null, -1), fae = { class: "h2style" }, mae = { class: "number" }, vae = { class: "note" }, oIe = /* @__PURE__ */ at({
  __name: "ConfirmationSuccess",
  props: {
    bookingNumber: {},
    activities: {},
    selectedActivitiesIds: {}
  },
  setup(e) {
    const t = e, n = Ae(() => {
      var r, c;
      return (r = t.selectedActivitiesIds) != null && r.length ? (c = t.selectedActivitiesIds) == null ? void 0 : c.map(
        (d) => Object.values(t.activities ?? {}).filter((a) => {
          const f = d.split("-");
          return !!a.subOptions[`${f[0]}-${f[1]}`];
        })
      ).flat() : [];
    }), i = () => {
      window.print();
    };
    return (r, c) => (V(), G("section", pae, [
      E("h1", null, [
        hae,
        mt(Y(r.$t("vacvComponents.confirmation.labels.title")), 1)
      ]),
      E("div", fae, Y(r.$t("vacvComponents.confirmation.messages.thankYou")), 1),
      E("div", mae, [
        mt(Y(r.$t("vacvComponents.confirmation.labels.bookingNumber")) + " ", 1),
        E("strong", null, Y(r.bookingNumber), 1)
      ]),
      E("div", vae, Y(r.$t("vacvComponents.confirmation.messages.checkInbox")), 1),
      E("button", {
        class: "vacv-btn-primary print-btn",
        onClick: i
      }, Y(r.$t("vacvComponents.confirmation.labels.print")), 1),
      (V(!0), G(cn, null, Pn(n.value, (d) => (V(), Tt(dae, {
        key: d.id,
        activity: d
      }, null, 8, ["activity"]))), 128))
    ]));
  }
}), gae = { class: "confirm-aeroplan-section" }, yae = { class: "logo" }, _ae = ["src", "alt"], bae = { class: "text" }, wae = ["innerHTML"], aIe = /* @__PURE__ */ at({
  __name: "ConfirmationAeroplan",
  props: {
    cdnBaseUrl: {},
    firstName: {}
  },
  setup(e) {
    return (t, n) => (V(), G("section", gae, [
      E("div", yae, [
        E("img", {
          src: `${t.cdnBaseUrl}/img/aeroplan-logo.svg`,
          alt: t.$t("vacvComponents.common.labels.aeroplan")
        }, null, 8, _ae)
      ]),
      E("h2", null, Y(t.$t("vacvComponents.confirmation.labels.congrats")) + " " + Y(t.firstName) + "! ", 1),
      E("div", bae, Y(t.$t(
        "vacvComponents.confirmation.messages.aeroplan-points-confirmation-0"
      )), 1),
      E("div", {
        class: "text",
        innerHTML: t.$t(
          "vacvComponents.confirmation.messages.aeroplan-points-confirmation-1"
        )
      }, null, 8, wae)
    ]));
  }
}), xae = { class: "confirm-aeroplan-section" }, $ae = { class: "logo" }, Cae = ["src", "alt"], kae = ["innerHTML"], Sae = ["innerHTML"], Tae = { class: "button-wrapper" }, Iae = ["href"], Aae = ["innerHTML"], Eae = { class: "text" }, Pae = ["href"], lIe = /* @__PURE__ */ at({
  __name: "ConfirmationAeroplanEnroll",
  props: {
    cdnBaseUrl: {}
  },
  setup(e) {
    const t = () => {
      R5();
    }, n = () => {
      z5();
    };
    return (i, r) => (V(), G("section", xae, [
      E("div", $ae, [
        E("img", {
          src: `${i.cdnBaseUrl}/img/aeroplan-logo.svg`,
          alt: i.$t("vacvComponents.common.labels.aeroplan")
        }, null, 8, Cae)
      ]),
      E("div", {
        class: "text",
        innerHTML: i.$t("vacvComponents.confirmation.messages.aeroplanEnroll")
      }, null, 8, kae),
      E("div", {
        class: "text",
        innerHTML: i.$t("vacvComponents.confirmation.messages.aeroplanBenefits")
      }, null, 8, Sae),
      E("div", Tae, [
        E("a", {
          href: i.$t("vacvComponents.confirmation.labels.aeroplanJoinLink"),
          target: "_blank",
          onClick: t,
          class: "vacv-btn-primary",
          rel: "noreferrer noopener"
        }, Y(i.$t("vacvComponents.confirmation.labels.aeroplanJoin")), 9, Iae)
      ]),
      E("div", {
        class: "text",
        innerHTML: i.$t("vacvComponents.confirmation.messages.aeroplanAlready")
      }, null, 8, Aae),
      E("div", Eae, [
        E("a", {
          href: i.$t("vacvComponents.confirmation.labels.aeroplanAddNumberLink"),
          target: "_blank",
          onClick: n,
          class: "link addNumber",
          rel: "noreferrer noopener"
        }, Y(i.$t("vacvComponents.confirmation.labels.aeroplanAddNumber")), 9, Pae)
      ])
    ]));
  }
}), Mae = { class: "tp-product" }, Dae = {
  key: 0,
  class: "logo"
}, Lae = ["src"], Oae = {
  key: 1,
  class: "logo fallback"
}, Nae = ["src"], Fae = { class: "h2style" }, Rae = {
  key: 2,
  class: "content"
}, zae = { class: "text" }, Bae = ["innerHTML"], Vae = {
  key: 3,
  class: "content"
}, Uae = { class: "text" }, Hae = /* @__PURE__ */ at({
  __name: "ConfirmationAncillaryProduct",
  props: {
    ancillary: {}
  },
  setup(e) {
    var x;
    const { ancillary: t } = e, { t: n } = ki(), i = Xi("cdnBaseUrl"), r = t.type === "travelProtection", c = r ? (x = t == null ? void 0 : t.category) == null ? void 0 : x.toUpperCase() : null, d = t.title, a = n("vacvComponents.ancillary.labels.travelprotection") + " - " + d, f = r ? a : d, g = Object.values(t.subOptions)[0].title;
    return ($, A) => (V(), G("div", Mae, [
      $.ancillary.icon ? (V(), G("div", Dae, [
        E("img", {
          src: $.ancillary.icon,
          width: "80",
          alt: ""
        }, null, 8, Lae)
      ])) : (V(), G("div", Oae, [
        E("img", {
          src: `${ne(i)}/img/fallback-img.jpg`,
          width: "90",
          alt: ""
        }, null, 8, Nae)
      ])),
      E("h4", Fae, Y(ne(f)), 1),
      ne(c) ? (V(), G("div", Rae, [
        E("div", zae, Y($.$t(
          `vacvComponents.confirmation.labels.${ne(c)}.inclusions`
        )), 1),
        E("div", {
          innerHTML: $.$t(
            "vacvComponents.confirmation.messages.ancillaryTravelProtectionLink"
          )
        }, null, 8, Bae)
      ])) : (V(), G("div", Vae, [
        E("div", Uae, Y(ne(g)), 1)
      ]))
    ]));
  }
}), eL = (e) => (nl("data-v-acb2d943"), e = e(), il(), e), Wae = {
  class: "confirm-summary-hotel",
  "data-test": "confirm-summary-hotel"
}, Zae = { class: "vacv-section-title" }, qae = { class: "summary-hotel-wrapper" }, jae = {
  key: 0,
  class: "hotel-image"
}, Gae = ["src", "alt"], Yae = { class: "hotel-info" }, Kae = { class: "h2style" }, Xae = { class: "stars" }, Jae = /* @__PURE__ */ eL(() => /* @__PURE__ */ E("i", {
  class: "fa-solid fa-star",
  "aria-hidden": "true"
}, null, -1)), Qae = /* @__PURE__ */ eL(() => /* @__PURE__ */ E("span", { class: "sr-only" }, "stars", -1)), ele = {
  key: 0,
  class: "room-type"
}, tle = { class: "hotel-checkinout" }, nle = { key: 0 }, ile = { key: 0 }, rle = /* @__PURE__ */ at({
  __name: "ConfirmationHotel",
  props: {
    hotel: {},
    checkIn: {},
    checkOut: {},
    roomId: {}
  },
  setup(e) {
    var a, f;
    const t = e, n = t.checkIn ? Wa(t.checkIn) : null, i = t.checkOut ? Wa(t.checkOut) : null, r = Ae(() => {
      var O, B, H, N, K, U, q, ee;
      const g = (H = (B = (O = t.hotel) == null ? void 0 : O.media) == null ? void 0 : B.images) == null ? void 0 : H[0], x = (U = (K = (N = t.hotel) == null ? void 0 : N.media) == null ? void 0 : K.sizes) == null ? void 0 : U.small, $ = (ee = (q = t.hotel) == null ? void 0 : q.media) == null ? void 0 : ee.variations;
      if (!(g != null && g.url) || !x)
        return null;
      const A = Wg(
        g.url.replace("{SIZE}", x),
        "tabletLandscape",
        $
      ), I = g.altText ?? g.description ?? "";
      return { url: A, alt: I };
    }), c = t.roomId ? (f = (a = t.hotel) == null ? void 0 : a.rooms) == null ? void 0 : f[t.roomId] : null, d = c != null && c.mealPlanName ? " - " + c.mealPlanName : "";
    return (g, x) => {
      var $, A;
      return V(), G("div", Wae, [
        E("h3", Zae, Y(g.$t("vacvComponents.confirmation.labels.hotelTitle")), 1),
        E("div", qae, [
          r.value ? (V(), G("div", jae, [
            E("img", {
              src: r.value.url,
              alt: r.value.alt
            }, null, 8, Gae)
          ])) : _e("", !0),
          E("div", Yae, [
            E("h3", Kae, [
              mt(Y(g.hotel.name), 1),
              E("span", Xae, [
                mt(Y(g.hotel.starCategory), 1),
                Jae,
                Qae
              ])
            ]),
            g.roomId && ((A = ($ = g.hotel) == null ? void 0 : $.rooms) != null && A[g.roomId].name) ? (V(), G("div", ele, Y(g.hotel.rooms[g.roomId].name) + Y(ne(d)), 1)) : _e("", !0),
            E("div", tle, [
              E("span", null, [
                mt(Y(g.$t("vacvComponents.confirmation.labels.checkInTime")) + " ", 1),
                ne(n) ? (V(), G("span", nle, Y(g.$d(ne(n), "short")), 1)) : _e("", !0)
              ]),
              E("span", null, [
                mt(Y(g.$t("vacvComponents.confirmation.labels.checkOutTime")) + " ", 1),
                ne(i) ? (V(), G("span", ile, Y(g.$d(ne(i), "short")), 1)) : _e("", !0)
              ])
            ])
          ])
        ])
      ]);
    };
  }
}), sle = /* @__PURE__ */ Zn(rle, [["__scopeId", "data-v-acb2d943"]]), ole = { class: "confirm-insurance-section" }, ale = { class: "vacv-section-title" }, lle = { class: "logo-wrapper" }, cle = { class: "logo" }, ule = ["src"], dle = { class: "logo-title" }, ple = { class: "text" }, hle = { class: "button-wrapper" }, fle = ["innerHTML"], mle = { class: "note" };
var tL = /* @__PURE__ */ ((e) => (e.en = "https://sales.allianz-assistance.ca/en-US/aircanadavacations/Sales/Quote", e.fr = "https://sales.allianz-assistance.ca/fr-CA/aircanadavacations/Sales/Quote", e))(tL || {});
const vle = /* @__PURE__ */ at({
  __name: "ConfirmationTravelInsurance",
  props: {
    booking: {},
    language: {}
  },
  setup(e) {
    const t = e, n = Xi("cdnBaseUrl"), i = () => {
      bw(t.booking, "confirmationTravelInsurance"), window.open(
        tL[t.language],
        "_blank",
        "noreferrer"
      );
    };
    return (r, c) => (V(), G("section", ole, [
      E("h3", ale, Y(r.$t("vacvComponents.confirmation.labels.insuranceTitle")), 1),
      E("div", lle, [
        E("div", cle, [
          E("img", {
            src: `${ne(n)}/img/allianz-global-assistance-logo.png`,
            width: "90",
            alt: ""
          }, null, 8, ule)
        ]),
        E("div", dle, Y(r.$t("vacvComponents.confirmation.labels.insuranceLogoTitle")), 1)
      ]),
      E("div", ple, Y(r.$t("vacvComponents.confirmation.labels.insuranceDescription")), 1),
      E("div", hle, [
        E("button", {
          class: "vacv-btn-primary",
          onClick: c[0] || (c[0] = (d) => i())
        }, Y(r.$t("vacvComponents.confirmation.labels.insuranceBtn")), 1)
      ]),
      E("div", {
        class: "insurance-contact",
        innerHTML: r.$t("vacvComponents.confirmation.labels.insuranceContact")
      }, null, 8, fle),
      E("div", mle, Y(r.$t("vacvComponents.confirmation.labels.insuranceNote")), 1)
    ]));
  }
}), gle = { class: "h1style" }, yle = {
  key: 0,
  class: "private-transfer-section"
}, _le = { class: "vacv-section-title" }, ble = { class: "private-transfer-wrapper" }, wle = { class: "private-transfer-image" }, xle = ["src", "alt"], $le = ["src", "alt"], Cle = { class: "text" }, kle = { class: "button-wrapper" }, Sle = ["href"], Tle = { class: "confirm-seatselection-section" }, Ile = { class: "vacv-section-title" }, Ale = { class: "spa-list special-list details-2col" }, Ele = ["innerHTML"], Ple = { class: "button-wrapper" }, Mle = ["href"];
var jw = /* @__PURE__ */ ((e) => (e.en = "https://vacations.aircanada.com/en/travel-info/manage-your-booking", e.fr = "https://vacations.aircanada.com/fr/infos-de-voyage/gestion-reservation", e))(jw || {});
const Dle = /* @__PURE__ */ at({
  __name: "ConfirmationGetReady",
  props: {
    booking: {},
    language: {}
  },
  setup(e) {
    var A, I, O;
    const t = e, n = Xi("cdnBaseUrl"), i = t.booking.tripLink ?? jw[t.language], r = () => {
      bw(t.booking, "confirmationSeatSelect"), window.open(i, "_blank", "noreferrer");
    }, c = jw[t.language], d = () => {
      bw(t.booking, "confirmationPrivTransfer"), window.open(c, "_blank", "noreferrer");
    }, a = b1(t.booking), f = ((A = a == null ? void 0 : a.selectedOptionIds) == null ? void 0 : A.privateTransferId) ?? "", g = ((O = (I = t.booking) == null ? void 0 : I.ancillaryOptions) == null ? void 0 : O.privateTransfers) ?? {}, x = Object.values(g).find(
      (B) => Object.values(B.subOptions)[0].id === f
    ) ?? void 0, $ = Object.values(g)[0];
    return (B, H) => {
      var N;
      return V(), G(cn, null, [
        E("h2", gle, Y(B.$t("vacvComponents.confirmation.labels.getReadyTitle")), 1),
        !ne(x) && ((N = ne($)) != null && N.title) ? (V(), G("section", yle, [
          E("h3", _le, Y(ne($).title), 1),
          E("div", ble, [
            E("div", wle, [
              ne($).icon ? (V(), G("img", {
                key: 0,
                src: ne($).icon,
                alt: ne($).title
              }, null, 8, xle)) : (V(), G("img", {
                key: 1,
                src: `${ne(n)}/img/carousel-fallback-img_${B.language}.jpg`,
                alt: B.$t("vacvComponents.common.messages.fallback-img")
              }, null, 8, $le))
            ]),
            E("div", null, [
              E("div", Cle, Y(B.$t("vacvComponents.confirmation.labels.privateTransferDescription")), 1),
              E("div", kle, [
                E("a", {
                  class: "vacv-btn-primary",
                  href: ne(c),
                  target: "_blank",
                  rel: "noreferrer",
                  onClick: zi(d, ["prevent"])
                }, Y(B.$t("vacvComponents.confirmation.labels.privateTransferButton")), 9, Sle)
              ])
            ])
          ])
        ])) : _e("", !0),
        E("section", Tle, [
          E("h3", Ile, Y(B.$t("vacvComponents.confirmation.labels.seatSelTitle")), 1),
          E("ul", Ale, [
            E("li", null, Y(B.$t("vacvComponents.confirmation.labels.seatSelOption1")), 1),
            E("li", {
              innerHTML: B.$t("vacvComponents.confirmation.labels.seatSelOption2")
            }, null, 8, Ele),
            E("li", null, Y(B.$t("vacvComponents.confirmation.labels.seatSelOption3")), 1)
          ]),
          E("div", Ple, [
            E("a", {
              class: "vacv-btn-primary",
              href: ne(i),
              target: "_blank",
              rel: "noreferrer",
              onClick: zi(r, ["prevent"])
            }, Y(B.$t("vacvComponents.confirmation.labels.seatSelBtn")), 9, Mle)
          ])
        ])
      ], 64);
    };
  }
}), Lle = {
  key: 0,
  class: "opc-tax opc-tax--section"
}, Ole = /* @__PURE__ */ at({
  __name: "OpcTaxRow",
  props: {
    opcTax: {}
  },
  setup(e) {
    return (t, n) => t.opcTax > 0 ? (V(), G("div", Lle, [
      it(Fu, {
        title: t.$t("vacvComponents.confirmation.labels.CFCTA"),
        value: ne(Wn)(t.opcTax, t.$n)
      }, null, 8, ["title", "value"])
    ])) : _e("", !0);
  }
}), Nle = /* @__PURE__ */ Zn(Ole, [["__scopeId", "data-v-89605c18"]]), Fle = {
  key: 0,
  class: "promo-code"
}, Rle = /* @__PURE__ */ at({
  __name: "PromoCodeRow",
  props: {
    prePackagePricing: {}
  },
  setup(e) {
    const t = e, n = Ae(
      () => {
        var i, r, c, d;
        return ((r = (i = t.prePackagePricing) == null ? void 0 : i.promo) == null ? void 0 : r.value) && ((d = (c = t.prePackagePricing) == null ? void 0 : c.promo) == null ? void 0 : d.value) > 0;
      }
    );
    return (i, r) => {
      var c, d, a, f;
      return n.value ? (V(), G("div", Fle, [
        it(Fu, {
          title: i.$t("vacvComponents.prices.labels.promoCode") + " " + (((d = (c = i.prePackagePricing) == null ? void 0 : c.promo) == null ? void 0 : d.code) ?? ""),
          value: "-" + ne(Wn)((f = (a = i.prePackagePricing) == null ? void 0 : a.promo) == null ? void 0 : f.value, i.$n),
          "value-classes": "text-red",
          class: "bdrow--small"
        }, null, 8, ["title", "value"])
      ])) : _e("", !0);
    };
  }
}), zle = /* @__PURE__ */ Zn(Rle, [["__scopeId", "data-v-31e7814d"]]), Ble = /* @__PURE__ */ at({
  __name: "DepositRow",
  props: {
    prePackagePricing: {},
    totalPrice: {},
    dueAmount: {},
    reverseOrder: { type: Boolean },
    modifier: {},
    isSection: { type: Boolean },
    insurancePremium: {},
    lang: {}
  },
  setup(e) {
    const { t, d: n, n: i } = ki({ useScope: "global" }), r = e, c = Ae(() => {
      var x, $;
      return r.dueAmount ? ((x = r == null ? void 0 : r.prePackagePricing) == null ? void 0 : x.minimumDeposit) ?? 0 : ($ = r == null ? void 0 : r.prePackagePricing) != null && $.minimumDeposit ? (r == null ? void 0 : r.prePackagePricing.minimumDeposit) + r.insurancePremium : 0;
    }), d = Ae(() => {
      if (r.dueAmount)
        return r.dueAmount;
      if (r.totalPrice)
        return r.totalPrice - c.value;
    }), a = Ae(() => {
      var x;
      if ((x = r == null ? void 0 : r.prePackagePricing) != null && x.minimumDepositDueDate)
        return r.dueAmount ? n(
          Wa(
            r.prePackagePricing.minimumDepositDueDate
          ),
          "short"
        ) : Sn.fromFormat(
          r.prePackagePricing.minimumDepositDueDate,
          "yyyyMMdd"
        ).setLocale(r.lang).toFormat(r.lang === "fr" ? "dd LLL yyyy" : "LLL. dd, yyyy");
    }), f = Ae(() => r != null && r.reverseOrder ? t(
      "vacvComponents.prices.deposit-payment-remaining-balance-mobile-message",
      {
        remaining: Wn(d.value, i),
        date: a.value
      }
    ) : t(
      "vacvComponents.prices.deposit-payment-remaining-balance-message",
      { date: a.value }
    )), g = Ae(() => ({
      "bdrow--deposit": r.modifier === "deposit",
      "bdrow--confirmation-deposit": r.modifier === "confirmation-deposit",
      "bdrow--mobile-deposit": r.modifier === "mobile-deposit"
    }));
    return (x, $) => c.value > 0 ? (V(), G("div", {
      key: 0,
      class: Et(["grand-total depositrow", { "deposit--section": x.isSection }]),
      "data-test": "minimum-deposit"
    }, [
      it(Fu, {
        title: x.$t("vacvComponents.prices.deposit"),
        value: ne(Wn)(c.value, x.$n),
        reverseOrder: x.reverseOrder,
        class: "bdrow--deposit-grand"
      }, null, 8, ["title", "value", "reverseOrder"]),
      it(Fu, {
        title: f.value,
        value: r != null && r.reverseOrder ? void 0 : ne(Wn)(d.value, x.$n),
        class: Et(["depositrow--balance", g.value]),
        titleClasses: "depositrow--balance--title"
      }, null, 8, ["title", "value", "class"])
    ], 2)) : _e("", !0);
  }
}), Vle = /* @__PURE__ */ Zn(Ble, [["__scopeId", "data-v-c5338106"]]), Ule = { class: "total-title" }, Hle = { key: 0 }, Wle = { key: 1 }, Zle = { class: "total-grand" }, tT = /* @__PURE__ */ at({
  __name: "PricePaymentMethods",
  props: {
    amount: {},
    cardNumber: {},
    type: {},
    creditCardType: {}
  },
  setup(e) {
    const t = e, n = (r) => r.charAt(0).toUpperCase() + r.slice(1), i = () => String(t.cardNumber).slice(-4);
    return (r, c) => (V(), G(cn, null, [
      E("div", Ule, [
        r.type === "creditCard" ? (V(), G("span", Hle, [
          mt(Y(r.creditCardType && n(r.creditCardType)) + " ", 1),
          E("strong", null, Y(r.$t("vacvComponents.confirmation.labels.endingWith")), 1)
        ])) : r.type === "giftCard" ? (V(), G("span", Wle, Y(r.$t("vacvComponents.confirmation.labels.giftCard")), 1)) : _e("", !0),
        mt(" " + Y(i()), 1)
      ]),
      E("div", Zle, Y(ne(Wn)(r.amount, r.$n)), 1)
    ], 64));
  }
}), qle = { class: "hotel-accordion" }, jle = { class: "accordion-content" }, Gle = { class: "breakdown-price-section breakdown-travellerList" }, Yle = { class: "title" }, Kle = {
  key: 0,
  class: "description"
}, Xle = {
  key: 1,
  class: "price-row"
}, Jle = { class: "qty" }, Qle = { key: 0 }, ece = { class: "total" }, tce = {
  key: 2,
  class: "price-row"
}, nce = { key: 0 }, ice = { class: "total" }, rce = {
  class: "accordion-content",
  style: { display: "none" }
}, sce = {
  class: "vacv-form-error",
  "aria-live": "polite"
}, oce = /* @__PURE__ */ at({
  __name: "AncillarySection",
  props: {
    ancillaries: {},
    pricing: {},
    selectedOptionIds: {}
  },
  setup(e) {
    const t = e, { t: n, n: i } = ki({ useScope: "global" }), r = Ud(), { hasSelectedAncillaries: c } = Nn(r), d = Ae(() => {
      var B;
      return oV((B = t.pricing) == null ? void 0 : B.perPaxType);
    }), a = Ae(
      () => {
        var B;
        return (B = t.ancillaries) != null && B.length ? t.ancillaries : [];
      }
    ), f = (B) => B.type === "travelProtection", g = (B) => f(B) ? n("vacvComponents.ancillary.labels.travelprotection") + " - " + B.title : B.title, x = (B) => Wn(Object.values(B.subOptions)[0].price, i), $ = (B) => Wn(
      Object.values(B.subOptions)[0].price * d.value,
      i
    ), A = (B) => c.value ? r.geSubOptionTitle(B.id) : Object.values(B.subOptions)[0].title, I = (B) => (B == null ? void 0 : B.type) === "activity", O = (B) => (B == null ? void 0 : B.type) === "mealPlan";
    return (B, H) => (V(), G("div", qle, [
      E("div", jle, [
        E("ul", Gle, [
          (V(!0), G(cn, null, Pn(a.value, (N) => (V(), G("li", {
            key: N == null ? void 0 : N.id
          }, [
            E("div", Yle, Y(g(N)), 1),
            O(N) || I(N) ? (V(), G("div", Kle, Y(A(N)), 1)) : _e("", !0),
            f(N) ? (V(), G("div", Xle, [
              E("div", Jle, [
                mt(Y(d.value) + " ", 1),
                E("span", null, [
                  mt(Y(B.$t("vacvComponents.common.bookingsummary.labels.traveller")), 1),
                  d.value > 1 ? (V(), G("span", Qle, "s")) : _e("", !0)
                ])
              ]),
              E("div", null, "    x " + Y(x(N)), 1),
              E("div", ece, Y($(N)), 1)
            ])) : (V(), G("div", tce, [
              E("div", null, [
                E("span", null, [
                  mt(Y(d.value) + " ", 1),
                  E("span", null, [
                    mt(Y(B.$t("vacvComponents.common.bookingsummary.labels.traveller")), 1),
                    d.value > 1 ? (V(), G("span", nce, "s")) : _e("", !0)
                  ])
                ])
              ]),
              E("div", ice, Y(B.$t("vacvComponents.common.bookingsummary.labels.included")), 1)
            ]))
          ]))), 128))
        ])
      ]),
      E("div", rce, [
        E("p", sce, Y(B.$t("vacvComponents.common.bookingsummary.errors.ancillary")), 1)
      ])
    ]));
  }
}), nL = /* @__PURE__ */ Zn(oce, [["__scopeId", "data-v-525296ad"]]), ace = { key: 0 }, lce = { key: 1 }, cce = { key: 2 }, Ay = /* @__PURE__ */ at({
  __name: "FlightStops",
  props: {
    connections: {}
  },
  setup(e) {
    const t = e;
    return (n, i) => t.connections === 0 ? (V(), G("span", ace, Y(n.$t("vacvComponents.flight.labels.stops", 0)), 1)) : t.connections === 1 ? (V(), G("span", lce, Y(n.$t("vacvComponents.flight.labels.stops", 1)), 1)) : t.connections && t.connections > 1 ? (V(), G("span", cce, Y(n.$t(
      "vacvComponents.flight.labels.stops",
      {
        count: t.connections
      },
      2
    )), 1)) : _e("", !0);
  }
}), Ey = /* @__PURE__ */ at({
  __name: "FlightStopsDots",
  props: {
    connections: {}
  },
  setup(e) {
    const t = e;
    return (n, i) => (V(), G("div", null, [
      (V(!0), G(cn, null, Pn(t.connections, (r) => (V(), G("span", {
        key: r,
        class: Et("dot dot-" + r)
      }, null, 2))), 128))
    ]));
  }
}), uce = { class: "flight-segment" }, dce = {
  class: "flight-trip",
  "data-test": "flight-trip"
}, pce = {
  class: "flight-row city-stop",
  "data-test": "city-stop"
}, hce = {
  class: "city origin",
  "data-test": "city-origin"
}, fce = {
  class: "code",
  "data-test": "city-origin-code"
}, mce = {
  class: "desktop-only stops",
  "data-test": "desktop-stops"
}, vce = {
  class: "city destination",
  "data-test": "city-destination"
}, gce = {
  class: "code",
  "data-test": "city-destination-code"
}, yce = {
  class: "flight-row time-duration",
  "data-test": "time-duration"
}, _ce = { class: "datetime origin" }, bce = {
  class: "date",
  "data-test": "datetime-origin-date"
}, wce = {
  class: "time",
  "data-test": "datetime-origin-time"
}, xce = {
  key: 0,
  class: "desktop-only duration",
  "data-test": "desktop-duration"
}, $ce = { class: "datetime destination" }, Cce = {
  class: "date",
  "data-test": "datetime-destination-date"
}, kce = {
  class: "time",
  "data-test": "datetime-destination-time"
}, Sce = {
  class: "mobile-only stop-duration",
  "data-test": "mobile-stop-duration"
}, Tce = {
  class: "stops",
  "data-test": "mobile-stops"
}, Ice = {
  key: 0,
  class: "duration",
  "data-test": "mobile-duration"
}, Ace = {
  key: 0,
  class: "segment-details",
  "data-test": "segment-details"
}, Ece = {
  key: 0,
  class: "airline",
  "data-test": "flight-airline"
}, Pce = {
  key: 1,
  class: "airline",
  "data-test": "flight-airline"
}, Mce = {
  key: 2,
  class: "flightnum"
}, Dce = {
  class: "cabinClass",
  "data-test": "flight-class"
}, Lce = {
  key: 1,
  class: "segment-details",
  "data-test": "segment-details"
}, Oce = { class: "info" }, Nce = {
  key: 0,
  class: "airline",
  "data-test": "flight-airline"
}, Fce = {
  key: 1,
  class: "airline",
  "data-test": "flight-airline"
}, Rce = { class: "flightnum" }, zce = {
  class: "cabinClass",
  "data-test": "flight-class"
}, Bce = {
  key: 2,
  class: "layover",
  "data-test": "layover-block"
}, Vce = { class: "duration" }, nT = /* @__PURE__ */ at({
  __name: "FlightSegment",
  props: {
    segments: {},
    expanded: { type: Boolean },
    index: {},
    displayDuration: { type: Boolean, default: !0 }
  },
  setup(e) {
    const t = e, n = t.segments[t.index].originName, i = t.segments[t.index].origin, r = t.expanded ? t.segments[t.index].destinationName : t.segments[t.segments.length - 1].destinationName, c = t.expanded ? t.segments[t.index].destination : t.segments[t.segments.length - 1].destination, d = Ae(
      () => t.expanded ? Kp(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        t.segments[t.index].departureDate,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        t.segments[t.index].departureTime
      ) : Kp(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        t.segments[0].departureDate,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        t.segments[0].departureTime
      )
    ), a = Ae(
      () => t.expanded ? Kp(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        t.segments[t.index].arrivalDate,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        t.segments[t.index].arrivalTime
      ) : Kp(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        t.segments[t.segments.length - 1].arrivalDate,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        t.segments[t.segments.length - 1].arrivalTime
      )
    ), f = Ae(
      () => {
        var $;
        return ($ = t.segments[t.index]) == null ? void 0 : $.totalFlightDuration;
      }
    ), g = Ae(() => f.value ? f.value.substring(0, 2) + "h" + f.value.substring(2) : null), x = Ae(
      () => {
        var $;
        return (($ = t.segments[t.index]) == null ? void 0 : $.numConnections) ?? t.segments.length - 1;
      }
    );
    return ($, A) => (V(), G("div", uce, [
      E("div", dce, [
        E("div", pce, [
          E("div", hce, [
            mt(Y(ne(n)) + " ", 1),
            E("span", fce, Y(ne(i)), 1)
          ]),
          E("div", mce, [
            it(Ay, {
              connections: $.expanded ? void 0 : x.value
            }, null, 8, ["connections"]),
            it(Ey, {
              class: Et("line stop-" + x.value),
              connections: $.expanded ? void 0 : x.value
            }, null, 8, ["class", "connections"])
          ]),
          E("div", vce, [
            mt(Y(ne(r)) + " ", 1),
            E("span", gce, Y(ne(c)), 1)
          ])
        ]),
        E("div", yce, [
          it(Ey, {
            class: Et("mobile-only line stop-" + x.value),
            connections: $.expanded ? void 0 : x.value
          }, null, 8, ["class", "connections"]),
          E("div", _ce, [
            E("span", bce, Y($.$d(d.value, "short")), 1),
            E("span", wce, Y($.$d(d.value, "time")), 1)
          ]),
          g.value && $.displayDuration ? (V(), G("div", xce, [
            mt(Y($.$t("vacvComponents.flight.labels.duration")) + ": ", 1),
            E("span", null, " " + Y(g.value), 1)
          ])) : _e("", !0),
          E("div", $ce, [
            E("span", Cce, Y($.$d(a.value, "short")), 1),
            E("span", kce, Y($.$d(a.value, "time")), 1)
          ])
        ])
      ]),
      E("div", Sce, [
        E("div", Tce, [
          it(Ay, {
            connections: $.expanded ? void 0 : x.value
          }, null, 8, ["connections"])
        ]),
        g.value && $.displayDuration ? (V(), G("div", Ice, [
          mt(Y($.$t("vacvComponents.flight.labels.duration")) + ": ", 1),
          E("span", null, " " + Y(g.value), 1)
        ])) : _e("", !0)
      ]),
      $.expanded ? (V(), G("div", Lce, [
        E("div", Oce, [
          $.segments[$.index].operatingAirline ? (V(), G("span", Nce, Y($.$t("vacvComponents.flight.labels.operatedBy")) + " " + Y($.segments[$.index].operatingAirline) + ", ", 1)) : (V(), G("span", Fce, Y($.segments[$.index].carrierName) + ", ", 1)),
          E("span", Rce, Y($.segments[$.index].carrierCode) + " " + Y($.segments[$.index].flightNumber) + ", ", 1),
          E("span", zce, Y($.segments[$.index].cabinClassName), 1)
        ])
      ])) : (V(), G("div", Ace, [
        (V(!0), G(cn, null, Pn($.segments, (I, O) => (V(), G("div", {
          class: "info",
          key: O
        }, [
          I.operatingAirline ? (V(), G("span", Ece, Y($.$t("vacvComponents.flight.labels.operatedBy")) + " " + Y(I.operatingAirline) + ", ", 1)) : (V(), G("span", Pce, Y(I.carrierName) + ", ", 1)),
          $.displayDuration ? _e("", !0) : (V(), G("span", Mce, Y(I.carrierCode) + " " + Y(I.flightNumber) + ", ", 1)),
          E("span", Dce, Y(I.cabinClassName), 1)
        ]))), 128))
      ])),
      $.expanded && $.segments[$.index].layoverDuration ? (V(), G("div", Bce, [
        E("div", Vce, [
          mt(Y($.$t("vacvComponents.flight.labels.layoverDuration")) + " ", 1),
          E("span", null, Y($.segments[$.index].layoverDuration), 1)
        ])
      ])) : _e("", !0)
    ]));
  }
}), Uce = { class: "title-wrapper" }, Hce = { class: "flight-title-multi fa-plane" }, Wce = { class: "see" }, Zce = { class: "flights-wrapper" }, qce = {
  key: 0,
  class: "segment-wrapper"
}, jce = {
  key: 0,
  class: "desktop-only link-wrapper"
}, Gce = { class: "see" }, Py = /* @__PURE__ */ at({
  __name: "FlightDetailsSegmentMulti",
  props: {
    segments: {},
    displayDuration: { type: Boolean },
    modifier: {}
  },
  setup(e) {
    const t = e, n = $e(!1), { t: i } = ki({ useScope: "global" }), r = Ae(() => {
      var g;
      return (g = t.segments) == null ? void 0 : g[0].bound;
    }), c = Ae(() => r.value === "O" ? i("vacvComponents.flight.labels.departure") : i("vacvComponents.flight.labels.return")), d = Ae(() => n.value ? i("vacvComponents.flight.labels.hideDetails") : i("vacvComponents.flight.labels.showDetails")), a = Ae(() => n.value ? "fa-solid fa-circle-minus" : "fa-solid fa-circle-plus"), f = Ae(() => ({
      "hide-button": t.modifier === "hideButtonOnMobile"
    }));
    return (g, x) => (V(), G("div", {
      class: Et(["accordion-content", r.value])
    }, [
      E("div", Uce, [
        E("div", Hce, [
          E("span", null, Y(c.value), 1)
        ]),
        g.segments.length > 1 ? (V(), G("div", {
          key: 0,
          class: Et(["mobile-only link-wrapper", f.value])
        }, [
          E("button", {
            class: "details-link link linklook",
            onClick: x[0] || (x[0] = ($) => n.value = !n.value)
          }, [
            E("span", Wce, [
              E("i", {
                class: Et(a.value),
                "aria-hidden": "true"
              }, null, 2),
              mt(Y(d.value), 1)
            ])
          ])
        ], 2)) : _e("", !0)
      ]),
      E("div", Zce, [
        n.value ? (V(), G("div", qce, [
          (V(!0), G(cn, null, Pn(g.segments, ($, A) => (V(), Tt(nT, {
            key: $.flightNumber,
            expanded: n.value,
            segments: g.segments,
            index: A,
            displayDuration: g.displayDuration
          }, null, 8, ["expanded", "segments", "index", "displayDuration"]))), 128))
        ])) : (V(), Tt(nT, {
          key: 1,
          segments: g.segments,
          expanded: n.value,
          index: 0,
          displayDuration: g.displayDuration
        }, null, 8, ["segments", "expanded", "displayDuration"]))
      ]),
      g.segments.length > 1 ? (V(), G("div", jce, [
        E("button", {
          class: "details-link link linklook",
          onClick: x[1] || (x[1] = ($) => n.value = !n.value)
        }, [
          E("span", Gce, [
            E("i", {
              class: Et(a.value),
              "aria-hidden": "true"
            }, null, 2),
            mt(Y(d.value), 1)
          ])
        ])
      ])) : _e("", !0)
    ], 2));
  }
}), Yce = { class: "confirm-summary-section" }, Kce = { class: "spa-col-main" }, Xce = { class: "h1style" }, Jce = {
  key: 0,
  class: "confirm-summary-travellers"
}, Qce = { class: "vacv-section-title" }, eue = { class: "travellers-summary" }, tue = { class: "paddedbox-grey" }, nue = {
  key: 0,
  class: "note--modifiedname"
}, iue = { class: "traveller-list" }, rue = ["index", "passenger"], sue = {
  key: 2,
  class: "confirm-summary-flights"
}, oue = { class: "vacv-section-title" }, aue = {
  key: 0,
  class: "hotel-accordion-wrapper flight-details multi",
  "data-test": "flight-details-multi"
}, lue = { class: "hotel-accordion" }, cue = {
  key: 3,
  class: "confirm-summary-ancillary"
}, uue = { class: "vacv-section-title" }, due = { class: "confirm-travelprotection-section" }, pue = {
  key: 4,
  class: "confirm-summary-pricedetails"
}, hue = { class: "vacv-section-title" }, fue = { class: "price-details" }, mue = {
  key: 0,
  class: "ancillaries-wrapper"
}, vue = { class: "vacv-label-sm" }, gue = {
  key: 0,
  "data-test": "payment-forms-uplift",
  class: "breakdown-wrapper payment"
}, yue = { class: "breakdown-price-section" }, _ue = { class: "payment-title" }, bue = { class: "price-row" }, wue = {
  key: 1,
  "data-test": "payment-forms-container",
  class: "breakdown-wrapper payment"
}, xue = { class: "breakdown-price-section" }, $ue = { class: "payment-title" }, Cue = {
  key: 5,
  class: "confirm-summary-getready"
}, cIe = /* @__PURE__ */ at({
  __name: "ConfirmationSummary",
  props: {
    bookingResponse: {},
    language: {}
  },
  setup(e) {
    var pe, Ne, We, Ge, et, ft, De, Ke, gt, qe, rt, Le, Je, je, ot;
    const { bookingResponse: t, language: n } = e, i = b1(t), r = Wl(), { insurancePremium: c } = Nn(r), d = !!((We = (Ne = (pe = t.payment) == null ? void 0 : pe.creditCards) == null ? void 0 : Ne[0]) != null && We.trace && t.payment.creditCards[0].correlation), a = (i == null ? void 0 : i.hotelId) ?? "", f = (Ge = t == null ? void 0 : t.hotels) == null ? void 0 : Ge[a], g = (ft = (et = t == null ? void 0 : t.payment) == null ? void 0 : et.billingAddress) == null ? void 0 : ft.phone, x = (Ke = (De = t.payment) == null ? void 0 : De.billingAddress) == null ? void 0 : Ke.email, $ = XF(t), A = ($ == null ? void 0 : $.itineraryId) ?? "", I = $ != null && $.itinerary && A ? $.itinerary : null, O = I && I.segments.filter((Xe) => Xe.bound === "O"), B = I && ((gt = I.segments) == null ? void 0 : gt.filter((Xe) => Xe.bound === "I")), H = i && "packageInclusions" in i.information ? i.information.packageInclusions : void 0, N = "travelInsurance" in t ? t.travelInsurance : void 0, K = iV(
      t.passengers,
      g,
      x,
      LB(t, A)
    ), U = (rt = (qe = t.payment) == null ? void 0 : qe.aeroplanPoints) == null ? void 0 : rt[0], q = (Le = t.payment) == null ? void 0 : Le.creditCards, ee = (Je = t.payment) == null ? void 0 : Je.giftCards;
    function te() {
      const Xe = i == null ? void 0 : i.selectedOptionIds, tt = t.ancillaryOptions;
      return !Xe || !tt ? [] : sE(
        sV(
          Xe,
          tt
        )
      );
    }
    const ae = te(), oe = ae.length > 0, de = {
      dollarValue: U == null ? void 0 : U.pointsCashValue,
      priceAncillaries: 0,
      allowOpcTax: !0,
      allowPromoCode: !0
    }, me = wV(i == null ? void 0 : i.pricing, de), ve = (je = t.passengers) == null ? void 0 : je.some(
      (Xe) => Xe.nameModified
    ), re = (ot = i == null ? void 0 : i.pricing) == null ? void 0 : ot.opcTax, le = Ae(() => !("itineraries" in t));
    return (Xe, tt) => {
      var dt, bt, qt, Oe, Bt, Tn, hn, Ht, qn, vi;
      return V(), G("section", Yce, [
        E("div", Kce, [
          E("h2", Xce, Y(Xe.$t("vacvComponents.confirmation.labels.bookingSummaryTitle")), 1),
          ne(K) ? (V(), G("div", Jce, [
            E("h3", Qce, Y(Xe.$t("vacvComponents.confirmation.labels.travellersTitle")), 1),
            E("div", eue, [
              E("div", tue, [
                ne(ve) ? (V(), G("div", nue, [
                  E("strong", null, Y(Xe.$t("vacvComponents.payment.labels.note")), 1),
                  mt(" " + Y(Xe.$t("vacvComponents.payment.labels.travellerInfoNormalizedNote")), 1)
                ])) : _e("", !0),
                E("ul", iue, [
                  (V(!0), G(cn, null, Pn(ne(K), (It, wn) => (V(), G("li", {
                    key: wn,
                    index: wn,
                    passenger: It,
                    class: "traveller-item"
                  }, [
                    It ? (V(), Tt(kD, {
                      key: 0,
                      passenger: It,
                      showDOB: !1
                    }, null, 8, ["passenger"])) : _e("", !0)
                  ], 8, rue))), 128))
                ])
              ])
            ])
          ])) : _e("", !0),
          ne(f) ? (V(), Tt(sle, {
            key: 1,
            hotel: ne(f),
            checkIn: (bt = (dt = ne(i)) == null ? void 0 : dt.information) == null ? void 0 : bt.checkIn,
            checkOut: (Oe = (qt = ne(i)) == null ? void 0 : qt.information) == null ? void 0 : Oe.checkOut,
            "room-id": (Bt = ne(i)) == null ? void 0 : Bt.roomId
          }, null, 8, ["hotel", "checkIn", "checkOut", "room-id"])) : _e("", !0),
          le.value ? _e("", !0) : (V(), G("div", sue, [
            E("h3", oue, Y(Xe.$t("vacvComponents.confirmation.labels.flightTitle")), 1),
            ne(O) && ne(B) ? (V(), G("div", aue, [
              E("div", lue, [
                it(Py, {
                  class: "outbound",
                  segments: ne(O)
                }, null, 8, ["segments"]),
                it(Py, {
                  class: "inbound",
                  segments: ne(B)
                }, null, 8, ["segments"])
              ])
            ])) : _e("", !0)
          ])),
          oe && ((Tn = ne(i)) != null && Tn.selectedOptionIds) ? (V(), G("div", cue, [
            E("h3", uue, Y(Xe.$t("vacvComponents.confirmation.labels.ancillaryTitle")), 1),
            E("div", due, [
              (V(!0), G(cn, null, Pn(ne(ae), (It) => (V(), Tt(Hae, {
                key: It.id,
                ancillary: It
              }, null, 8, ["ancillary"]))), 128))
            ])
          ])) : _e("", !0),
          (hn = ne(i)) != null && hn.pricing ? (V(), G("div", pue, [
            E("h3", hue, Y(Xe.$t("vacvComponents.confirmation.labels.priceDetailsTitle")), 1),
            E("div", fue, [
              it(Hx, {
                prePackagePricing: ne(i).pricing,
                "package-inclusions": ne(H),
                ancillaries: ne(ae),
                extrasIncluded: oe,
                showDOB: !1,
                spaType: le.value ? ne(ps).HotelsSpa : ne(ps).PackagesSpa
              }, {
                priceBreakdownLines: Qt(() => {
                  var It, wn, Oi, hr, qi, kt;
                  return [
                    (It = ne(ae)) != null && It.length ? (V(), G("div", mue, [
                      E("h3", vue, Y(Xe.$t("vacvComponents.confirmation.labels.ancillaryTitle")), 1),
                      it(nL, {
                        ancillaries: ne(ae),
                        pricing: ne(i).pricing,
                        selectedOptionIds: ne(i).selectedOptionIds
                      }, null, 8, ["ancillaries", "pricing", "selectedOptionIds"])
                    ])) : _e("", !0),
                    ne(re) ? (V(), Tt(Nle, {
                      key: 1,
                      opcTax: ne(re)
                    }, null, 8, ["opcTax"])) : _e("", !0),
                    it(XD, {
                      subTotal: ne(me).subTotal
                    }, null, 8, ["subTotal"]),
                    it(zle, {
                      "pre-package-pricing": ne(i).pricing
                    }, null, 8, ["pre-package-pricing"]),
                    ne(U) ? (V(), Tt(QD, {
                      key: 2,
                      "dollar-value": (wn = ne(U)) == null ? void 0 : wn.pointsCashValue,
                      "points-to-redeem": (Oi = ne(U)) == null ? void 0 : Oi.amountOfPoints
                    }, null, 8, ["dollar-value", "points-to-redeem"])) : _e("", !0),
                    it(Zx, {
                      "price-total": ne(me).total,
                      estimated: !1,
                      modifier: "confirmation",
                      "is-section": "",
                      "is-refundable": (qi = (hr = ne(i)) == null ? void 0 : hr.information) == null ? void 0 : qi.refundable
                    }, null, 8, ["price-total", "is-refundable"]),
                    (kt = Xe.bookingResponse.payment) != null && kt.isMinDepositApplied ? (V(), Tt(Vle, {
                      key: 3,
                      "pre-package-pricing": ne(i).pricing,
                      "due-amount": Xe.bookingResponse.payment.paymentDueAmount,
                      "insurance-premium": ne(c),
                      modifier: "confirmation-deposit",
                      "is-section": "",
                      lang: Xe.language
                    }, null, 8, ["pre-package-pricing", "due-amount", "insurance-premium", "lang"])) : _e("", !0)
                  ];
                }),
                _: 1
              }, 8, ["prePackagePricing", "package-inclusions", "ancillaries", "spaType"]),
              d ? (V(), G("div", gue, [
                E("ul", yue, [
                  E("li", _ue, Y(Xe.$t("vacvComponents.confirmation.labels.paymentTitle")), 1),
                  E("li", bue, Y(Xe.$t("vacvComponents.confirmation.labels.uplift")), 1)
                ])
              ])) : (Ht = ne(ee)) != null && Ht.length || (qn = ne(q)) != null && qn.length ? (V(), G("div", wue, [
                E("ul", xue, [
                  E("li", $ue, Y(Xe.$t("vacvComponents.confirmation.labels.paymentTitle")), 1),
                  (V(!0), G(cn, null, Pn(ne(ee), (It) => (V(), G("li", {
                    key: It.number,
                    class: "price-row"
                  }, [
                    it(tT, {
                      amount: It.amount,
                      "card-number": It.number,
                      type: "giftCard"
                    }, null, 8, ["amount", "card-number"])
                  ]))), 128)),
                  (V(!0), G(cn, null, Pn(ne(q), (It) => (V(), G("li", {
                    key: It.creditCardToken,
                    class: "price-row"
                  }, [
                    it(tT, {
                      amount: It.amount,
                      "card-number": It.creditCardToken,
                      type: "creditCard",
                      "credit-card-type": It.creditCardTypeEnum
                    }, null, 8, ["amount", "card-number", "credit-card-type"])
                  ]))), 128))
                ])
              ])) : _e("", !0)
            ])
          ])) : _e("", !0),
          le.value ? _e("", !0) : (V(), G("div", Cue, [
            it(Dle, {
              booking: Xe.bookingResponse,
              language: Xe.language
            }, null, 8, ["booking", "language"]),
            ((vi = ne(N)) == null ? void 0 : vi.status) !== "FAILED" ? (V(), Tt(vle, {
              key: 0,
              booking: Xe.bookingResponse,
              language: Xe.language
            }, null, 8, ["booking", "language"])) : _e("", !0)
          ]))
        ])
      ]);
    };
  }
}), kue = {}, Sue = { class: "passengerprotection-section" }, Tue = { class: "text" }, Iue = ["innerHTML"];
function Aue(e, t) {
  return V(), G("section", Sue, [
    E("h2", null, Y(e.$t("vacvComponents.payment.labels.passengerProtection")), 1),
    E("div", Tue, Y(e.$t("vacvComponents.payment.messages.passengerProtection-1")), 1),
    E("div", {
      class: "text",
      innerHTML: e.$t("vacvComponents.payment.messages.passengerProtection-2")
    }, null, 8, Iue)
  ]);
}
const Eue = /* @__PURE__ */ Zn(kue, [["render", Aue]]), Pue = (e) => (nl("data-v-e5fa5ef8"), e = e(), il(), e), Mue = { key: 0 }, Due = { class: "formkit-messages" }, Lue = {
  class: "formkit-message",
  "data-message-type": "validation"
}, Oue = { key: 1 }, Nue = {
  class: "spa-alertbox info",
  role: "alert",
  "aria-live": "polite"
}, Fue = { class: "text" }, Rue = { key: 2 }, zue = { class: "formkit-messages" }, Bue = {
  class: "formkit-message",
  "data-message-type": "validation"
}, Vue = /* @__PURE__ */ Pue(() => /* @__PURE__ */ E("br", null, null, -1)), Uue = /* @__PURE__ */ at({
  __name: "PaymentErrors",
  setup(e) {
    const t = xo(), {
      showGiftCardTwoCardError: n,
      showGiftCardPayInFullMessage: i,
      showPaymentMethodError: r
    } = Nn(t);
    return (c, d) => ne(r) ? (V(), G("div", Mue, [
      E("ul", Due, [
        E("li", Lue, Y(c.$t("vacvComponents.payment.validation.paymentMethod")), 1)
      ])
    ])) : ne(i) ? (V(), G("div", Oue, [
      E("div", Nue, [
        E("div", Fue, Y(c.$t("vacvComponents.payment.errors.giftCardPayInFull")), 1)
      ])
    ])) : ne(n) ? (V(), G("div", Rue, [
      E("ul", zue, [
        E("li", Bue, Y(c.$t("vacvComponents.payment.errors.maxTwoPaymentMethods")), 1)
      ]),
      Vue
    ])) : _e("", !0);
  }
}), Hue = /* @__PURE__ */ Zn(Uue, [["__scopeId", "data-v-e5fa5ef8"]]), Wue = /* @__PURE__ */ at({
  __name: "SeparateBillingAddress",
  props: {
    lang: {}
  },
  setup(e) {
    const t = xo(), {
      isPaymentMethodCreditCard: n,
      isPaymentMethodGiftCard: i,
      isPaymentMethodUplift: r,
      amountToPay: c
    } = Nn(t), d = Dd(), { upliftOfferAvailable: a } = Nn(d), f = Ae(
      () => i.value && !n.value || r.value
    ), g = Ae(
      () => c.value === 0 || f.value
    );
    return (x, $) => g.value ? (V(), G("div", {
      key: 0,
      id: "separate-billing-address",
      class: Et([
        ne(a) ? "paddedbox-grey border uplift-billing" : "paddedbox-grey border"
      ])
    }, [
      E("h3", null, Y(x.$t("vacvComponents.payment.labels.creditCardAddressTitle")), 1),
      it(mP, {
        creditCardName: "ccframe1",
        lang: x.lang
      }, null, 8, ["lang"])
    ], 2)) : _e("", !0);
  }
}), Zue = { key: 0 }, que = { class: "formkit-messages uplift-error-container" }, jue = {
  class: "formkit-message",
  "data-message-type": "validation"
}, Gue = { key: 1 }, Yue = { class: "formkit-messages uplift-error-container" }, Kue = {
  class: "formkit-message",
  "data-message-type": "validation"
}, Xue = /* @__PURE__ */ at({
  __name: "UpliftPaymentErrors",
  setup(e) {
    const t = Dd(), { showFormIncompleteError: n, showUnableToGetUpliftTokenError: i } = Nn(t);
    return (r, c) => (V(), G(cn, null, [
      ne(n) ? (V(), G("div", Zue, [
        E("ul", que, [
          E("li", jue, Y(r.$t("vacvComponents.payment.errors.upliftFormNotCompleted")), 1)
        ])
      ])) : _e("", !0),
      ne(i) ? (V(), G("div", Gue, [
        E("ul", Yue, [
          E("li", Kue, Y(r.$t("vacvComponents.payment.errors.unableGetUpliftToken")), 1)
        ])
      ])) : _e("", !0)
    ], 64));
  }
}), Jue = ["innerHTML", "location"], Que = {
  id: "uplift-warning-modal-content",
  class: "vacv-editor"
}, ede = { class: "message" }, tde = { class: "uplift-warning-modal-ok-btn" }, nde = ["aria-label"], ide = /* @__PURE__ */ E("i", { class: "fa-solid fa-circle-xmark" }, null, -1), y_ = /* @__PURE__ */ at({
  __name: "UpliftWarningMessage",
  props: {
    displayUpliftWarningModal: { type: Boolean },
    location: {}
  },
  emits: ["on-close-uplift-warning-modal"],
  setup(e, { emit: t }) {
    const { t: n } = ki({ useScope: "global" }), i = e, r = Ae(() => i.displayUpliftWarningModal), c = t, d = (a) => {
      c("on-close-uplift-warning-modal", a);
    };
    return (a, f) => (V(), Tt(rl, {
      onClose: f[2] || (f[2] = (g) => d("CLOSE")),
      modelValue: r.value,
      "onUpdate:modelValue": f[3] || (f[3] = (g) => r.value = g),
      class: "vacv-modal modal-fullscreen vacv-modal-centered",
      id: "uplift-warning-modal"
    }, {
      default: Qt(() => [
        E("div", {
          id: "uplift-warning-modal-title",
          class: "h3style",
          innerHTML: ne(n)("vacvComponents.payment.labels.upliftWarningModalTitle"),
          location: a.location
        }, null, 8, Jue),
        E("div", Que, [
          E("div", ede, Y(ne(n)("vacvComponents.payment.messages.upliftWarningMessage")), 1),
          E("div", tde, [
            E("button", {
              class: "vacv-btn-primary",
              onClick: f[0] || (f[0] = (g) => d("OK"))
            }, Y(ne(n)("vacvComponents.payment.labels.upLiftWarningModalBtnOK")), 1)
          ]),
          E("button", {
            onClick: f[1] || (f[1] = (g) => d("CANCEL")),
            class: "uplift-linklook",
            "aria-expanded": "false",
            "aria-label": ne(n)("vacvComponents.common.buttons.close")
          }, [
            ide,
            mt(Y(ne(n)("vacvComponents.payment.labels.upliftWarningModalBtnCancel")), 1)
          ], 8, nde)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]));
  }
}), rde = {
  class: "h1style",
  id: "payment-section-title"
}, sde = { class: "options-wrapper" }, ode = { class: "payment-amount" }, ade = { class: "vacv-price" }, lde = { class: "payment-select" }, cde = { class: "vacv-btn-secondary noclick" }, ude = { key: 0 }, dde = /* @__PURE__ */ E("i", {
  class: "fa-solid fa-check",
  "aria-hidden": "true"
}, null, -1), pde = { key: 1 }, hde = { class: "payment-amount" }, fde = ["aria-label"], mde = /* @__PURE__ */ E("span", { class: "round-icon" }, null, -1), vde = [
  mde
], gde = ["innerHTML"], yde = ["innerHTML"], _de = {
  class: "vacv-price",
  id: "deposit-price"
}, bde = { class: "text" }, wde = ["innerHTML"], xde = { class: "payment-select" }, $de = { class: "vacv-btn-secondary noclick" }, Cde = { key: 0 }, kde = /* @__PURE__ */ E("i", {
  class: "fa-solid fa-check",
  "aria-hidden": "true"
}, null, -1), Sde = { key: 1 }, Tde = { id: "up-pay-monthly-selector" }, Ide = ["data-up-price-value"], Ade = /* @__PURE__ */ E("span", { "data-up-from-currency-unit-major": "" }, null, -1), Ede = ["aria-label"], Pde = {
  id: "up-offer-not-available",
  "data-up-error": "",
  style: { display: "none" }
}, Mde = /* @__PURE__ */ E("span", { "data-up-tooltip": "" }, null, -1), Dde = { class: "payment-select" }, Lde = { class: "vacv-btn-secondary noclick" }, Ode = { key: 0 }, Nde = /* @__PURE__ */ E("i", {
  class: "fa-solid fa-check",
  "aria-hidden": "true"
}, null, -1), Fde = { key: 1 }, uIe = /* @__PURE__ */ at({
  __name: "PaymentOptions",
  props: {
    totalAmountToPay: {},
    minimumDeposit: {},
    minimumDepositDueDate: {},
    depositTermsAndCondition: {},
    reset: { type: Boolean },
    ENABLE_UPLIFT: { type: Boolean },
    SHOULD_SEND_SENTRY: { type: Boolean },
    SENTRY_ERROR_CODE_FILTER: {},
    UPLIFT_LIB_UPC: {},
    UPLIFT_LIB_API_KEY: {},
    UPLIFT_MIN_AMOUNT: {},
    UPLIFT_MAX_AMOUNT: {}
  },
  setup(e) {
    const { n: t } = ki({ useScope: "global" }), n = e, {
      deselectUpliftPayment: i,
      selectUpliftPayment: r,
      isUpliftReady: c,
      upliftNotReadyError: d
    } = oE(
      n.ENABLE_UPLIFT,
      n.SHOULD_SEND_SENTRY,
      n.SENTRY_ERROR_CODE_FILTER,
      n.UPLIFT_LIB_UPC,
      n.UPLIFT_LIB_API_KEY
    ), a = Wl(), { selectedInsuranceProduct: f } = Nn(a), g = Dd(), {
      setShowFormIncompleteError: x,
      setShowUnableToGetUpliftTokenError: $,
      setUpliftWasDisabledByNonEligibility: A
    } = Dd(), {
      upliftTokenAvailable: I,
      passengerIsOldEnough: O,
      upliftWasDisabledByNonEligibility: B,
      upliftOfferAvailable: H
    } = Nn(g), N = xo(), {
      setDepositAmountToNull: K,
      setSelectDeposit: U,
      setDepositAmount: q,
      setIsPaymentMethodUplift: ee,
      setSelectedPlan: te
    } = N, { isPaymentMethodUplift: ae, selectedPlan: oe } = Nn(N), de = da(), me = n.ENABLE_UPLIFT, ve = n.UPLIFT_MIN_AMOUNT, re = n.UPLIFT_MAX_AMOUNT, le = $e(!1), pe = $e(!1), Ne = $e(), We = $e(no.full), Ge = Ae(() => n.totalAmountToPay - (n.minimumDeposit ? n.minimumDeposit : 0)), et = Ae(
      () => !!n.minimumDeposit && !!n.minimumDepositDueDate && n.minimumDeposit < n.totalAmountToPay && Ge.value > 0
    ), ft = Ae(
      () => !!(n.totalAmountToPay && n.totalAmountToPay > ve && n.totalAmountToPay < re && O.value && me && H.value && !f.value)
    ), De = Ae(() => n.totalAmountToPay > 0), Ke = () => {
      le.value = !0;
    }, gt = () => {
      pe.value = !0;
    }, qe = () => {
      le.value = !1;
    }, rt = (Oe) => {
      if (Oe === "OK") {
        pe.value = !1, Je(We.value);
        const Bt = Ne.value;
        Bt && Bt();
      } else
        pe.value = !1;
    }, Le = (Oe) => {
      We.value = Oe, ae.value && I.value && !n.reset ? gt() : (Je(Oe), Oe == "deposit" ? Xe() : ot());
    }, Je = (Oe) => {
      x(!1), $(!1), ee(!1), i(Oe);
    }, je = () => {
      te(no.uplift), K(), U(!1);
    }, ot = () => {
      te(no.full), K(), U(!1);
    }, Xe = () => {
      te(no.deposit), q(n.minimumDeposit), U(!0);
    }, tt = () => {
      ae.value ? (Ne.value = ot, Le(no.full)) : ot();
    }, dt = () => {
      ae.value ? (Ne.value = Xe, Le(no.deposit)) : Xe();
    }, bt = () => {
      c() ? (r(), je(), ee(!0)) : (d(), $(!0));
    }, qt = Ae(() => {
      const Oe = de === "fr" ? "dd LLL yyyy" : "LLL. dd, yyyy";
      return n.minimumDepositDueDate ? Sn.fromFormat(n.minimumDepositDueDate, "yyyyMMdd").setLocale(de).toFormat(Oe) : "";
    });
    return At(et, (Oe) => {
      Oe || tt();
    }), At(
      () => n.reset,
      (Oe) => {
        Oe && (ae.value || tt());
      }
    ), At(O, (Oe) => {
      Oe || tt();
    }), At(ft, (Oe) => {
      Oe || (Je(no.full), ot());
    }), Li(() => {
      if (ae.value && !H.value) {
        const Oe = At(H, async (Bt) => {
          Bt && (bt(), Oe());
        });
      }
    }), At(B, (Oe) => {
      Oe && (tt(), A(!1));
    }), (Oe, Bt) => (V(), G("section", {
      class: Et([{ hidden: !De.value }, "paymentoptions-section"])
    }, [
      E("h2", rde, Y(Oe.$t("vacvComponents.payment.labels.paymentOptions")), 1),
      it(Xue),
      E("div", sde, [
        E("button", {
          class: Et(["optionbox payment-full", {
            selected: ne(oe) === ne(no).full,
            solo: !et.value
          }]),
          onClick: tt
        }, [
          E("div", ode, [
            E("h3", null, Y(Oe.$t("vacvComponents.payment.labels.payInFull")), 1),
            E("div", ade, Y(ne(Wn)(Oe.totalAmountToPay, ne(t))), 1)
          ]),
          E("div", lde, [
            E("div", cde, [
              ne(oe) === ne(no).full ? (V(), G("span", ude, [
                dde,
                mt(Y(Oe.$t("vacvComponents.common.buttons.selected")), 1)
              ])) : (V(), G("span", pde, Y(Oe.$t("vacvComponents.common.buttons.select")), 1))
            ])
          ])
        ], 2),
        et.value ? (V(), G("button", {
          key: 0,
          class: Et(["optionbox payment-deposit", { selected: ne(oe) === ne(no).deposit }]),
          onClick: dt
        }, [
          E("div", hde, [
            E("h3", null, [
              mt(Y(Oe.$t("vacvComponents.payment.labels.payWithDeposit")), 1),
              E("button", {
                onClick: Ke,
                class: "price-popover-link link",
                "aria-haspopup": "true",
                "aria-label": Oe.$t("vacvComponents.ancillary.access.details"),
                "aria-describedby": "deposit-modal-title"
              }, vde, 8, fde)
            ]),
            it(rl, {
              onClose: qe,
              modelValue: le.value,
              "onUpdate:modelValue": Bt[0] || (Bt[0] = (Tn) => le.value = Tn),
              class: "vacv-modal modal-fullscreen vacv-modal-centered"
            }, {
              default: Qt(() => {
                var Tn, hn;
                return [
                  E("div", {
                    id: "deposit-modal-title",
                    class: "h2style",
                    innerHTML: (Tn = Oe.depositTermsAndCondition) == null ? void 0 : Tn.name
                  }, null, 8, gde),
                  E("div", {
                    id: "deposit-modal-content",
                    class: "vacv-editor",
                    innerHTML: (hn = Oe.depositTermsAndCondition) == null ? void 0 : hn.description
                  }, null, 8, yde)
                ];
              }),
              _: 1
            }, 8, ["modelValue"]),
            E("div", _de, Y(ne(Wn)(Oe.minimumDeposit, ne(t))), 1),
            E("div", bde, [
              E("span", {
                innerHTML: Oe.$t("vacvComponents.payment.messages.amountDueBy", {
                  amount: ne(Wn)(Ge.value, ne(t)),
                  date: qt.value
                })
              }, null, 8, wde)
            ])
          ]),
          E("div", xde, [
            E("div", $de, [
              ne(oe) === ne(no).deposit ? (V(), G("span", Cde, [
                kde,
                mt(Y(Oe.$t("vacvComponents.common.buttons.selected")), 1)
              ])) : (V(), G("span", Sde, Y(Oe.$t("vacvComponents.common.buttons.select")), 1))
            ])
          ])
        ], 2)) : _e("", !0),
        E("button", {
          class: Et([
            {
              selected: ne(oe) === ne(no).uplift,
              solo: !et.value
            },
            { hidden: !ft.value },
            "optionbox payment-uplift"
          ]),
          onClick: bt
        }, [
          E("div", Tde, [
            E("h3", null, Y(Oe.$t("vacvComponents.payment.labels.payWithUplift")), 1),
            it(y_, {
              location: "PaymentOptions",
              "display-uplift-warning-modal": pe.value,
              onOnCloseUpliftWarningModal: rt
            }, null, 8, ["display-uplift-warning-modal"]),
            E("span", {
              id: "up-pay-monthly-selector-from-pricing",
              style: { cursor: "pointer" },
              "data-up-price-type": "total",
              "data-up-price-value": Oe.totalAmountToPay * 100
            }, [
              mt(Y(Oe.$t("vacvComponents.payment.labels.upliftFrom")), 1),
              Ade,
              mt(Y(Oe.$t("vacvComponents.payment.labels.payMonthlyOffer")), 1),
              E("span", {
                "data-up-tooltip": "",
                class: "round-icon info",
                role: "button",
                "aria-haspopup": "true",
                "aria-label": Oe.$t("vacvComponents.ancillary.access.details"),
                tabindex: "0"
              }, null, 8, Ede)
            ], 8, Ide),
            E("span", Pde, [
              mt(Y(Oe.$t("vacvComponents.payment.errors.offerNotAvailable")) + " ", 1),
              Mde
            ])
          ]),
          E("div", Dde, [
            E("div", Lde, [
              ne(oe) === ne(no).uplift ? (V(), G("span", Ode, [
                Nde,
                mt(Y(Oe.$t("vacvComponents.common.buttons.selected")), 1)
              ])) : (V(), G("span", Fde, Y(Oe.$t("vacvComponents.common.buttons.select")), 1))
            ])
          ])
        ], 2)
      ])
    ], 2));
  }
}), Rde = {
  key: 0,
  class: "bill96-section vacv-checkbox"
}, zde = { class: "h3style" }, Bde = /* @__PURE__ */ at({
  __name: "Bill96Checkbox",
  setup(e) {
    const t = xo(), { bill96: n, showBill96Checkbox: i } = Nn(t);
    return (r, c) => {
      const d = Ur("FormKit");
      return ne(i) ? (V(), G("section", Rde, [
        E("div", zde, Y(r.$t("vacvComponents.payment.messages.bill96-disclaimer")), 1),
        it(d, {
          name: "bill96",
          type: "checkbox",
          label: r.$t("vacvComponents.payment.messages.bill96-checkbox"),
          modelValue: ne(n),
          "onUpdate:modelValue": c[0] || (c[0] = (a) => yo(n) ? n.value = a : null),
          "decorator-icon": ne(px)
        }, null, 8, ["label", "modelValue", "decorator-icon"])
      ])) : _e("", !0);
    };
  }
}), Vde = { class: "creditcard-logos" }, Ude = { class: "cc-logo" }, Hde = ["src"], Wde = { class: "cc-logo" }, Zde = ["src"], qde = { class: "cc-logo" }, jde = ["src"], Gde = /* @__PURE__ */ at({
  __name: "CreditCardLogos",
  setup(e) {
    const t = Xi("cdnBaseUrl");
    return (n, i) => (V(), G("div", Vde, [
      E("span", Ude, [
        E("img", {
          src: `${ne(t)}/img/payment-mastercard.png`,
          alt: "Mastercard",
          "data-test": "mastercard-logo"
        }, null, 8, Hde)
      ]),
      E("span", Wde, [
        E("img", {
          src: `${ne(t)}/img/payment-visa.png`,
          alt: "Visa",
          "data-test": "visa-logo"
        }, null, 8, Zde)
      ]),
      E("span", qde, [
        E("img", {
          src: `${ne(t)}/img/payment-amex.png`,
          alt: "American Express",
          "data-test": "amex-logo"
        }, null, 8, jde)
      ])
    ]));
  }
}), Yde = {
  id: "creditcard",
  class: "paddedbox-grey border"
}, Kde = { class: "payment-section-title" }, Xde = { class: "vacv-checkbox" }, Jde = {
  key: 0,
  class: "twocards-section"
}, Qde = {
  key: 0,
  class: "cc-toggle-section"
}, epe = { class: "sr-only" }, tpe = {
  key: 1,
  class: "insurance-note"
}, npe = { class: "insurance-note-title" }, ipe = { class: "insurance-note-notes" }, rpe = { class: "insurance-note-notes-first-note" }, spe = { class: "insurance-note-notes-second-note" }, ope = /* @__PURE__ */ at({
  __name: "CreditCardSection",
  props: {
    hpciConfig: {},
    TWO_CC_THRESHOLD: {}
  },
  emits: ["change-twocards", "credit-card-selected"],
  setup(e, { expose: t, emit: n }) {
    const i = e, r = da(), c = Wl(), d = xo(), {
      isPaymentMethodCreditCard: a,
      isPaymentMethodGiftCard: f,
      amountToPay: g,
      toggle2cc: x
    } = Nn(d), { dollarValue: $ } = Nn(zu()), A = Ae(
      () => {
        var ee;
        return ((ee = c.selectedInsuranceProduct) == null ? void 0 : ee.premium) ?? 0;
      }
    ), I = Ae(() => !(f.value || $.value > 0 || !isNaN(i.TWO_CC_THRESHOLD) && g.value + A.value < i.TWO_CC_THRESHOLD)), O = Ae(() => A.value > 0 || a.value), B = n;
    function H(ee) {
      var ae;
      const te = !!((ae = ee == null ? void 0 : ee.target) != null && ae.checked);
      B("change-twocards", te), x.value = te;
    }
    function N() {
      Rl(() => {
        a.value && B("credit-card-selected");
      });
    }
    const K = $e(), U = $e();
    function q() {
      var ee, te;
      (ee = K.value) != null && ee.resetIFrame && K.value.resetIFrame(), (te = U.value) != null && te.resetIFrame && U.value.resetIFrame();
    }
    return t({
      resetIframes: q
    }), (ee, te) => {
      const ae = Ur("FormKit");
      return V(), G("div", Yde, [
        E("div", Kde, [
          E("div", Xde, [
            it(ae, {
              name: "paymentMethodCreditCard",
              id: "creditcard-checkbox",
              type: "checkbox",
              label: ee.$t("vacvComponents.payment.labels.creditCard"),
              "aria-checked": O.value ? "true" : "false",
              "decorator-icon": ne(px),
              "label-class": "h2style",
              disabled: !!ne(c).selectedInsuranceProduct,
              checked: O.value,
              modelValue: ne(a),
              "onUpdate:modelValue": te[0] || (te[0] = (oe) => yo(a) ? a.value = oe : null),
              onInput: N
            }, null, 8, ["label", "aria-checked", "decorator-icon", "disabled", "checked", "modelValue"])
          ]),
          it(Gde)
        ]),
        ne(a) ? (V(), G("div", Jde, [
          I.value && !ne(f) ? (V(), G("div", Qde, [
            E("span", epe, Y(ee.$t("vacvComponents.payment.labels.twoCreditCards")), 1),
            it(ae, {
              type: "toggle",
              name: "toggle-2cc",
              id: "toggle2cc",
              label: ee.$t("vacvComponents.payment.labels.twoCreditCards"),
              onChange: H,
              modelValue: ne(x),
              "onUpdate:modelValue": te[1] || (te[1] = (oe) => yo(x) ? x.value = oe : null)
            }, null, 8, ["label", "modelValue"])
          ])) : _e("", !0),
          A.value > 0 ? (V(), G("div", tpe, [
            E("div", npe, Y(ee.$t("vacvComponents.payment.labels.allianzDescriptionNotesTitle")), 1),
            E("ul", ipe, [
              E("li", rpe, Y(ee.$t("vacvComponents.payment.labels.allianzDescriptionNotesNoteOne")), 1),
              E("li", spe, Y(ee.$t("vacvComponents.payment.labels.allianzDescriptionNotesNoteTwo")), 1)
            ])
          ])) : _e("", !0),
          it(vk, {
            ref_key: "card1Ref",
            ref: K,
            "credit-card-name": "ccframe1",
            hpciConfig: ee.hpciConfig,
            lang: ne(r),
            "insurance-premium": A.value
          }, null, 8, ["hpciConfig", "lang", "insurance-premium"]),
          ne(x) ? (V(), Tt(vk, {
            key: 2,
            ref_key: "card2Ref",
            ref: U,
            creditCardName: "ccframe2",
            hpciConfig: ee.hpciConfig,
            lang: ne(r)
          }, null, 8, ["hpciConfig", "lang"])) : _e("", !0)
        ])) : _e("", !0)
      ]);
    };
  }
}), ape = { class: "loading-spinner" }, lpe = ["src"], iL = /* @__PURE__ */ at({
  __name: "LoadingSpinner",
  props: {
    cdnBaseUrl: {}
  },
  setup(e) {
    return (t, n) => (V(), G("div", ape, [
      E("img", {
        src: `${t.cdnBaseUrl}/img/spinner-dots.png`,
        alt: ""
      }, null, 8, lpe)
    ]));
  }
}), cpe = {
  class: "waiting-screen-overlay overlay-open",
  "data-test": "waiting-screen"
}, upe = { class: "waiting-screen-content" }, dpe = { class: "title" }, ppe = ["innerHTML"], hpe = /* @__PURE__ */ at({
  __name: "WaitingScreen",
  props: {
    title: {},
    text: {},
    cdnBaseUrl: {}
  },
  setup(e) {
    return (t, n) => (V(), G("div", cpe, [
      E("div", upe, [
        it(iL, { cdnBaseUrl: t.cdnBaseUrl }, null, 8, ["cdnBaseUrl"]),
        E("div", dpe, Y(t.title), 1),
        E("div", {
          class: "text",
          innerHTML: t.text
        }, null, 8, ppe)
      ])
    ]));
  }
}), fpe = { id: "threeDSwrapper" }, mpe = ["action"], vpe = ["value"], gpe = ["value"], ype = ["value"], _pe = ["width", "height"], iT = /* @__PURE__ */ at({
  __name: "ThreeDomainSecureIframe",
  props: {
    actionURL: {},
    challengeData: {},
    threeDSServerTransId: {},
    threeDSMethodData: {}
  },
  setup(e) {
    const t = e, n = $e(), { width: i } = ex(), r = Ae(
      () => i.value < Qg.tablet ? "100%" : "600px"
    ), c = Ae(
      () => i.value < Qg.tablet ? "0" : "border: 10px solid white; border-radius: 5px;"
    ), d = Ae(
      () => t != null && t.challengeData ? r.value : "0"
    ), a = Ae(
      () => t != null && t.challengeData ? c.value : "display: none;"
    );
    return Li(() => {
      n.value.submit();
    }), (f, g) => (V(), G("div", fpe, [
      E("form", {
        id: "threeDSForm",
        action: f.actionURL,
        target: "threeDSiFrame",
        method: "POST",
        ref_key: "threeDSForm",
        ref: n
      }, [
        f.challengeData ? (V(), G("input", {
          key: 0,
          type: "hidden",
          name: "creq",
          id: "creq",
          value: f.challengeData
        }, null, 8, vpe)) : _e("", !0),
        f.threeDSServerTransId ? (V(), G("input", {
          key: 1,
          type: "hidden",
          id: "threeDSServerTransId",
          name: "threeDSServerTransId",
          value: f.threeDSServerTransId
        }, null, 8, gpe)) : _e("", !0),
        f.threeDSMethodData ? (V(), G("input", {
          key: 2,
          type: "hidden",
          id: "threeDSMethodData",
          name: "threeDSMethodData",
          value: f.threeDSMethodData
        }, null, 8, ype)) : _e("", !0)
      ], 8, mpe),
      E("iframe", {
        name: "threeDSiFrame",
        title: "3DS",
        id: "threeDSiFrame",
        width: d.value,
        height: d.value,
        style: g1(a.value)
      }, null, 12, _pe)
    ]));
  }
}), bpe = { class: "paymentmethod-section payment2cc" }, wpe = {
  key: 0,
  class: "h1style",
  id: "payment-method-title"
}, xpe = { class: "checkout-termsconditions" }, $pe = ["innerHTML"], Cpe = "/hotel-only/booking", kpe = "/form-of-payment/payment", Spe = "/packages-booking/booking", dIe = /* @__PURE__ */ at({
  __name: "PaymentMethod",
  props: {
    envVars: {},
    prePackage: {},
    hotel: {},
    itinerary: {},
    totalAmountToPay: {},
    isVisible: { type: Boolean },
    emailAddress: {},
    passengers: {},
    phoneNumber: {},
    packageQuoteId: {},
    spaType: {}
  },
  emits: ["showAlertErrors", "clearAlertErrors", "goToConfirmation"],
  setup(e, { emit: t }) {
    const n = e, i = n.spaType === ps.HotelsSpa, r = i ? Cpe : Spe, c = da(), d = n.envVars, {
      API_HOST: a,
      ENABLE_3DS: f,
      UPLIFT_TOKEN_INTERVAL: g,
      UPLIFT_TOKEN_RETRIES: x,
      HPCI_HOST: $,
      HPCI_PAGE_MODE: A,
      HPCI_PARENT_HOST: I,
      HPCI_SITE_ID: O,
      HPCI_LOCATION_NAME: B,
      FETCH_API_TIMEOUT: H,
      ENABLE_UPLIFT: N,
      UPLIFT_LIB_UPC: K,
      UPLIFT_LIB_API_KEY: U,
      SENTRY_ERROR_CODE_FILTER: q,
      SHOULD_SEND_SENTRY: ee,
      TWO_CC_THRESHOLD: te,
      MICROSERVICE_RETRY_TIMES: ae,
      COMMON_STATIC_URL: oe
    } = d, de = {
      hpciHost: $,
      hpciPageMode: A,
      parentHost: I,
      siteId: O,
      siteLoc: B,
      fetchApiTimeout: H,
      lang: c
    }, { getUpliftToken: me, upliftOrderSubmit: ve, upliftOrderConfirmation: re } = oE(
      N,
      ee,
      q,
      K,
      U
    ), { t: le, n: pe } = ki({ useScope: "global" });
    Li(() => {
      FB();
    }), T5(le);
    const Ne = $e(), We = $e(), Ge = $e(), et = $e(), ft = $e(), De = $e(), Ke = $e(
      /* @__PURE__ */ new Set()
    ), gt = Er({
      payment: null,
      loading: !1
    }), qe = t, rt = Wl(), { selectedInsuranceProduct: Le, insuranceQuoteId: Je, insurancePremium: je } = Nn(rt), { dollarValue: ot, pointsToRedeem: Xe, hideCreditCardForm: tt } = Nn(zu()), dt = Dd(), {
      setShowFormIncompleteError: bt,
      setShowUnableToGetUpliftTokenError: qt,
      setUpliftTokenRetrieved: Oe,
      setUpliftToken: Bt
    } = dt, {
      upliftOfferAvailable: Tn,
      upliftTokenAvailable: hn,
      upliftToken: Ht,
      upLiftOrderObj: qn
    } = Nn(dt), vi = xo(), {
      setGiftCardAmount: It,
      clearGiftCardAmount: wn,
      recalculateCreditCard1Amount: Oi,
      setInsurancePremiumAmount: hr
    } = vi, {
      bill96: qi,
      isTotalPriceZero: kt,
      isPaymentMethodCreditCard: wi,
      isPaymentMethodGiftCard: ai,
      isPaymentMethodUplift: Hr,
      displayedGiftCardAmount: hs,
      selectDeposit: Pt,
      depositAmount: $n,
      amountToPay: yn,
      giftCardAmount: Qi,
      checkoutHasBeenSubmitted: Gi,
      showGiftCardTwoCardError: Cn,
      showPaymentMethodError: or,
      toggle2cc: Wr,
      card1: kr,
      card2: fs,
      audience: tr
    } = Nn(vi), { submitHpciIFrame: pi, initCustomHPCISubmitHandler: ga } = DE(
      de,
      le
    ), { generateMicroServicePaymentRequest: As, extractGiftCards: Te } = D5(c), {
      challengeUrl: se,
      challengeData: ue,
      fingerprintUrl: be,
      threeDSServerTransId: Pe,
      threeDSMethodData: Fe,
      processCreditCardsVia3DS: Ze
    } = w5(gt, a, f), ze = Ae(() => !tt.value && wi.value), Re = Ae(() => Hr.value ? !1 : yn.value !== 0), Ye = [
      aa.EMPLOYEE,
      aa.B2C_GUEST,
      aa.AFFILIATE,
      aa.FRIENDS_AND_FAMILY
    ], nt = Ae(() => i || Hr.value ? !1 : Ye.includes(tr.value) ? !kt.value : !1), _t = Ae(() => {
      var Mt, Fn;
      return (Fn = (Mt = n.prePackage) == null ? void 0 : Mt.pricing) == null ? void 0 : Fn.promo;
    }), yt = Ae(() => {
      var Fn, In, ti;
      return ((ti = (In = (Fn = n.itinerary) == null ? void 0 : Fn.segments) == null ? void 0 : In[0]) == null ? void 0 : ti.origin) ?? "xxx";
    });
    function un(Mt) {
      yn.value = Mt, kt.value = Mt === 0, Mt === 0 && (ai.value = !1);
    }
    const bn = () => {
      const Mt = document.getElementById("payment-section-title");
      Mt != null && Mt.scrollIntoView && Mt.scrollIntoView();
    };
    typeof n.totalAmountToPay == "number" && un(n.totalAmountToPay);
    function Kt() {
      var Mt;
      (Mt = De.value) != null && Mt.resetIframes && De.value.resetIframes();
    }
    const an = (Mt) => {
      Mt && (ms(), dG(Mt).forEach((In) => {
        In.forEach((ti) => {
          Ke.value.add(ti.value);
        });
      })), wi.value && PE(
        le("vacvComponents.payment.errors.noCardNumber"),
        le("vacvComponents.payment.errors.noCVV")
      ), bn();
    };
    function dn(Mt) {
      Md(Mt, ee, q), Bn(Mt);
    }
    const Bn = (Mt) => {
      gt.loading = !1, qe("showAlertErrors", {
        status: Mt.status,
        message: le("vacvComponents.payment.errors.paymentTechnicalError"),
        title: Mt.title,
        detail: Mt.detail,
        errorDetail: Mt.errorDetail
      }), FI();
    }, An = () => ({
      amountOfPoints: Xe.value,
      pointsCashValue: ot.value,
      currency: "cad"
    }), Un = async (Mt) => {
      ot.value > 0 && (Mt.aeroplanPoints = [An()]);
      try {
        const Fn = new URL(a + kpe), In = await bh(
          Fn,
          JSON.stringify(Mt),
          "POST",
          0,
          ae,
          H
        );
        ei(In), Yi();
      } catch (Fn) {
        return dn(Fn), !1;
      }
      return !0;
    };
    function ei(Mt) {
      gt.payment = Mt;
    }
    async function Yi() {
      gt.loading = !0;
      const Mt = LN(n.passengers), Fn = Mt == null ? void 0 : Mt.map((ti) => ti.id), In = {
        language: c,
        quoteId: n.packageQuoteId,
        paxIds: (Fn == null ? void 0 : Fn.toString()) ?? "",
        paymentId: gt.payment.id,
        bill96: qi.value,
        // bill96 checkbox enables email in both languages (see ACVW-7555)
        province: Hr.value ? kr.value.state : void 0
      };
      Je.value && (In.travelInsuranceQuoteId = Je.value), Le.value && Le.value.productCode && (In.travelInsuranceSelectedProduct = Le.value.productCode);
      try {
        const ti = new URL(a + r), Xn = await bh(
          ti,
          JSON.stringify(In),
          "POST",
          0,
          ae,
          H
        );
        Ni(Xn);
      } catch (ti) {
        dn(ti);
      }
      gt.loading = !1;
    }
    function _n() {
      qe("goToConfirmation", Ge.value);
    }
    function Ni(Mt) {
      const Fn = Mt;
      if ((Fn == null ? void 0 : Fn.bookingStatus) == "OK") {
        if (Hr.value) {
          const In = {
            mode_of_payment: "pay monthly",
            order_id: Fn.bookingNumber ?? ""
          };
          re(In);
        }
        We.value = Fn.authorization, Ge.value = Fn.id, et.value = Fn.bookingStatus, ft.value = Fn.pinNumber, RB(), _n();
      } else {
        const In = Mt, ti = new Yg({
          title: In == null ? void 0 : In.title,
          status: In == null ? void 0 : In.status,
          name: "",
          message: In == null ? void 0 : In.message,
          detail: In == null ? void 0 : In.detail,
          errorDetail: In == null ? void 0 : In.errorDetail
        });
        dn(ti);
      }
      gt.loading = !1;
    }
    const Dr = () => {
      qe("clearAlertErrors"), gt.loading = !0, ei(null);
      const Mt = K4(
        wi.value,
        Wr.value
      ), Fn = !!$n.value, In = ot.value > 0, ti = (Hr.value && hn.value) ?? !1, Xn = X4(
        Mt,
        In,
        ti,
        Qi.value > 0
      );
      n.prePackage && n.hotel && G5(
        n.prePackage,
        void 0,
        n.hotel,
        Fn,
        ti,
        Xn
      );
    };
    function ar() {
      var Mt, Fn;
      if (Gi.value = !0, !wi.value && !kt.value && !ai.value && !Hr.value) {
        or.value = !0, ms();
        return;
      }
      or.value = !1, (Fn = (Mt = Ne.value) == null ? void 0 : Mt.node) == null || Fn.submit();
    }
    function Zr() {
      return Hr.value ? ns() : kt.value ? al() : ai.value && !wi.value ? Bi() : wi.value && Us(), !1;
    }
    async function ns() {
      Tn.value && hn.value ? (gt.loading = !0, Bt(null), Oe(!1), qt(!1), bt(!1), Uo()) : (bt(!0), bn());
    }
    function Uo() {
      me();
      let Mt = 0;
      const In = setInterval(() => {
        if (Mt++ < x) {
          if (Ht.value) {
            const ti = {
              mode_of_payment: "pay monthly",
              payment_options: ["full", "pay monthly", "deposit"]
            };
            qn.value && ve(qn.value, ti), clearInterval(In), mV(
              yn.value,
              Ht.value,
              Dr,
              An,
              Un,
              Xe.value
            );
          }
        } else
          clearInterval(In), qt(!0), gt.loading = !1, bn();
      }, g);
    }
    async function al() {
      Dr();
      const Mt = An(), In = {
        billingAddress: ry(
          kr.value,
          n.phoneNumber,
          n.emailAddress
        ),
        aeroplanPoints: [Mt]
      };
      await Un(In);
    }
    async function Bi() {
      Dr();
      const Mt = ry(
        kr.value,
        n.phoneNumber,
        n.emailAddress
      ), Fn = Te();
      await Un({
        billingAddress: Mt,
        giftCards: Fn
      });
    }
    function Us() {
      A5(
        le("vacvComponents.payment.errors.noCardNumber"),
        le("vacvComponents.payment.errors.noCVV")
      ) && (Dr(), ms(), M5(Vi), ga(
        ao,
        Ln,
        Es
      ), pi(Sc, Es));
    }
    function Es(Mt) {
      dn(new Error("No response from HPCI in " + Mt));
    }
    function Vi() {
      Bn({
        status: "",
        message: le("vacvComponents.payment.errors.paymentTechnicalError")
      });
    }
    async function ao() {
      const Mt = As(
        n.phoneNumber,
        n.emailAddress,
        je.value
      );
      ei(Mt), await Ze(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        gt.payment.creditCards,
        yt.value
      ) ? Un(Mt) : dn(
        new Yg({
          title: le("vacvComponents.payment.errors.payment3DSError"),
          status: 400,
          detail: zB
        })
      );
    }
    function Ln() {
      gt.loading = !1;
    }
    async function xi() {
      Ne.value && (await Rl(), YC(kr.value, Ne.value), Wr.value && YC(fs.value, Ne.value));
    }
    async function Ki() {
      ai.value && (Qi.value === yn.value || $n.value !== null && $n.value > 0 && Qi.value === $n.value) && wn(), or.value = !1, wi.value ? await xi() : (Wr.value = !1, ai.value && (Pt.value && $n.value ? It($n.value, pe) : It(yn.value, pe)));
    }
    function Hs() {
      or.value = !1, ai.value ? (Wr.value = !1, Fb(), wi.value ? wn() : Pt.value && $n.value ? It($n.value, pe) : It(yn.value, pe), Oi(pe)) : qr(pe);
    }
    function ms() {
      Ke.value.clear();
    }
    async function Ps(Mt) {
      Mt ? (Y5("Credit Card"), E5(), await xi()) : Fb(), qr(pe);
    }
    function jt() {
      (ai.value || wi.value) && K5(
        hi()
      );
    }
    const hi = () => {
      const Mt = [];
      return wi.value && Mt.push("Credit Card"), ai.value && Mt.push("Gift Card"), Mt.join("; ");
    }, qr = (Mt) => {
      var In, ti;
      Cn.value = !1, ai.value ? Oi(Mt) : kr.value.creditCardAmount = "", fs.value.creditCardAmount = "";
      const Fn = (ti = (In = Ne == null ? void 0 : Ne.value) == null ? void 0 : In.node) == null ? void 0 : ti.children.find(
        (Xn) => Xn.name === "ccframe1-cc-amount-card"
      );
      HE(() => {
        var Xn;
        (Xn = Fn == null ? void 0 : Fn.store) == null || Xn.filter(() => !1);
      }, 10);
    };
    async function ko() {
      wi.value && ai.value && (hs.value === "0" || hs.value === "0.00" || hs.value === "0,00") && Oi(pe), await xi();
    }
    return At(
      () => n.totalAmountToPay,
      (Mt) => {
        typeof Mt == "number" && (qr(pe), un(Mt));
      }
    ), At(
      () => ot.value,
      (Mt) => {
        Mt > 0 && (Wr.value = !1, Fb(), qr(pe)), or.value = !1;
      }
    ), At(
      () => n.isVisible,
      (Mt) => {
        Mt || (P5(), Kt(), qr(pe), qe("clearAlertErrors"));
      }
    ), At(qi, (Mt) => {
      Mt && q5();
    }), At(wi, Ki), At(ai, Hs), At(Qi, () => {
      Oi(pe);
    }), At(Pt, async () => {
      wi.value && ai.value ? (wn(), Oi(pe)) : wi.value ? qr(pe) : ai.value && Hs();
    }), At(Le, (Mt) => {
      hr(Mt ? Mt.premium : 0);
    }), At([ze, yn, _t], () => {
      qr(pe);
    }), (Mt, Fn) => {
      const In = Ur("FormKit");
      return V(), G(cn, null, [
        it(In, {
          ref_key: "formRef",
          ref: Ne,
          id: "cc-accept-form",
          type: "form",
          actions: !1,
          onSubmitInvalid: an,
          onSubmit: Zr
        }, {
          default: Qt(() => {
            var ti, Xn;
            return [
              E("section", bpe, [
                ne(kt) ? _e("", !0) : (V(), G("h2", wpe, Y(Mt.$t("vacvComponents.payment.labels.paymentMethod")), 1)),
                it(ne(jY)),
                it(Hue),
                nt.value ? (V(), Tt(iZ, {
                  key: 1,
                  lang: ne(c),
                  onGiftcardAmountBlur: ko,
                  onGiftCardSelected: jt
                }, null, 8, ["lang"])) : _e("", !0),
                Re.value ? (V(), Tt(ope, {
                  key: 2,
                  hpciConfig: de,
                  TWO_CC_THRESHOLD: ne(te),
                  ref_key: "creditCardsRef",
                  ref: De,
                  onChangeTwocards: Ps,
                  onCreditCardSelected: jt
                }, null, 8, ["TWO_CC_THRESHOLD"])) : _e("", !0),
                E("div", {
                  id: "up-pay-monthly-container",
                  src: "",
                  class: Et([
                    { hidden: !(ne(Tn) && ne(Hr)) },
                    "paddedbox-grey border uplift-container"
                  ])
                }, null, 2),
                it(Wue, { lang: ne(c) }, null, 8, ["lang"])
              ]),
              it(Eue),
              (Xn = (ti = Mt.hotel) == null ? void 0 : ti.hints) != null && Xn.length ? (V(), Tt(pte, {
                key: 0,
                hints: Mt.hotel.hints
              }, null, 8, ["hints"])) : _e("", !0),
              it(Bde),
              E("div", xpe, [
                E("div", {
                  innerHTML: Mt.$t("vacvComponents.payment.messages.termsConditions"),
                  class: "text"
                }, null, 8, $pe)
              ]),
              it(In, {
                id: "submit-button",
                type: "button",
                label: Mt.$t("vacvComponents.payment.labels.creditCardConfirm"),
                "input-class": "$reset vacv-btn-primary",
                onClick: ar
              }, null, 8, ["label"])
            ];
          }),
          _: 1
        }, 512),
        gt.loading ? (V(), Tt(hpe, {
          key: 0,
          title: Mt.$t("vacvComponents.payment.messages.waiting-message-title"),
          text: Mt.$t("vacvComponents.payment.messages.waiting-message-description"),
          cdnBaseUrl: ne(oe)
        }, null, 8, ["title", "text", "cdnBaseUrl"])) : _e("", !0),
        ne(be) ? (V(), Tt(iT, {
          key: 1,
          actionURL: ne(be),
          threeDSServerTransId: ne(Pe),
          threeDSMethodData: ne(Fe)
        }, null, 8, ["actionURL", "threeDSServerTransId", "threeDSMethodData"])) : _e("", !0),
        ne(se) ? (V(), Tt(iT, {
          key: 2,
          actionURL: ne(se),
          challengeData: ne(ue)
        }, null, 8, ["actionURL", "challengeData"])) : _e("", !0)
      ], 64);
    };
  }
});
function rL(e, t) {
  const n = PB(e), i = wE(), r = MB(e, i);
  if (n !== "" && r !== "") {
    const c = new URLSearchParams(window.location.search);
    c.set("departingDateTime", n), c.set("returnDateTime", r), t && c.set("no_hotel", t), window.location.search = c.toString();
  }
}
const Tpe = { class: "title-date" }, Ipe = { class: "vacv-title" }, Ape = { class: "vacv-date" }, Epe = { class: "vacv-price" }, Ppe = /* @__PURE__ */ at({
  __name: "FlexibleHotelDatesItem",
  props: {
    alternateHotelDate: {},
    tripDuration: {},
    selected: { type: Boolean },
    no_hotel: {},
    hotelName: {}
  },
  setup(e) {
    const t = da(), n = e, { t: i } = ki({ useScope: "global" }), r = Ae(() => {
      var d;
      return (d = n.alternateHotelDate) != null && d.date ? EB(t, n.alternateHotelDate.date) : "";
    }), c = () => {
      if (!n.selected && n.alternateHotelDate.date) {
        const d = Wa(n.alternateHotelDate.date);
        if (d) {
          const a = im(d);
          ia("Flexible Dates Option", n.hotelName), rL(a, n.no_hotel);
        }
      }
    };
    return (d, a) => {
      var f;
      return V(), G("button", {
        class: "date-button",
        onClick: zi(c, ["prevent"])
      }, [
        E("div", Tpe, [
          E("div", Ipe, Y(ne(i)("vacvComponents.plpList.flexDatesDeparture")), 1),
          E("div", Ape, [
            mt(Y(r.value) + " ", 1),
            E("span", null, Y(ne(i)("vacvComponents.plpList.flexNights", { count: d.tripDuration })), 1)
          ])
        ]),
        E("div", Epe, Y(ne(Wn)((f = d.alternateHotelDate) == null ? void 0 : f.price, d.$n)), 1)
      ]);
    };
  }
}), Mpe = { class: "hotel-accordion" }, Dpe = { class: "accordion-title" }, Lpe = ["id"], Ope = ["aria-controls"], Npe = { class: "accordion-content" }, Fpe = { class: "date-list" }, Rpe = 5, zpe = /* @__PURE__ */ at({
  __name: "FlexibleHotelDatesAccordion",
  props: {
    position: { default: 0 },
    alternateHotelDates: {},
    no_hotel: {},
    hotelName: {},
    showHide: {}
  },
  setup(e) {
    const t = e, n = wE(), i = xE(), r = Ae(
      () => BI(
        t.alternateHotelDates,
        i,
        Rpe
      )
    );
    function c(d) {
      return d.selected;
    }
    return (d, a) => (V(), Tt(jh, {
      id: "flexibleDatesAccordion-" + t.position,
      className: "flexible-dates",
      role: "region",
      "aria-live": "polite",
      "aria-labelledby": "flexibleDatesAccordion-title-" + t.position
    }, {
      default: Qt(() => [
        E("div", Mpe, [
          E("div", Dpe, [
            E("div", {
              id: "flexibleDatesAccordion-title-" + t.position,
              class: "vacv-label-sm"
            }, Y(d.$t("vacvComponents.plpList.flexDates")), 9, Lpe),
            E("button", {
              onClick: a[0] || (a[0] = //@ts-ignore
              (...f) => d.showHide && d.showHide(...f)),
              class: "btn-close",
              "a:aria-label": "$t('vacvComponents.common.buttons.close')",
              "aria-expanded": "true",
              "aria-controls": "flexibleDatesAccordion-" + t.position
            }, null, 8, Ope)
          ]),
          E("div", Npe, [
            E("ul", Fpe, [
              (V(!0), G(cn, null, Pn(r.value, (f, g) => (V(), G("li", {
                key: g,
                class: Et({
                  selected: c(f)
                })
              }, [
                it(Ppe, {
                  alternateHotelDate: f,
                  tripDuration: ne(n),
                  selected: c(f),
                  no_hotel: d.no_hotel,
                  hotelName: d.hotelName
                }, null, 8, ["alternateHotelDate", "tripDuration", "selected", "no_hotel", "hotelName"])
              ], 2))), 128))
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["id", "aria-labelledby"]));
  }
}), qx = (e) => (nl("data-v-4222c5bb"), e = e(), il(), e), Bpe = { class: "item-content-left" }, Vpe = { class: "room-name" }, Upe = {
  key: 0,
  class: "room-view"
}, Hpe = { class: "room-beds" }, Wpe = {
  key: 1,
  class: "room-amenities"
}, Zpe = { key: 0 }, qpe = /* @__PURE__ */ qx(() => /* @__PURE__ */ E("i", {
  class: "fa-solid fa-wifi",
  "aria-hidden": "true"
}, null, -1)), jpe = { key: 1 }, Gpe = /* @__PURE__ */ qx(() => /* @__PURE__ */ E("i", {
  class: "fa-solid fa-tv",
  "aria-hidden": "true"
}, null, -1)), Ype = { key: 2 }, Kpe = /* @__PURE__ */ qx(() => /* @__PURE__ */ E("i", {
  class: "fa-regular fa-snowflake",
  "aria-hidden": "true"
}, null, -1)), Xpe = { class: "room-links" }, Jpe = {
  key: 2,
  class: "room-options"
}, Qpe = { class: "room-links" }, ehe = /* @__PURE__ */ at({
  __name: "HotelRoomDetails",
  props: {
    room: {},
    selectRoom: { type: Function }
  },
  setup(e) {
    const t = e, n = Xi("maxAvailability") ?? 0, i = Ae(() => {
      var r;
      return (r = t == null ? void 0 : t.room) != null && r.mealPlanName ? " - " + t.room.mealPlanName : "";
    });
    return (r, c) => {
      var d;
      return V(), G("div", Bpe, [
        E("h3", Vpe, Y(r.room.name) + Y(i.value), 1),
        (d = r.room) != null && d.view ? (V(), G("div", Upe, Y(r.room.view), 1)) : _e("", !0),
        E("div", Hpe, Y(r.room.bed), 1),
        r.room.wifi || r.room.television || r.room.airConditioning ? (V(), G("ul", Wpe, [
          r.room.wifi ? (V(), G("li", Zpe, [
            qpe,
            mt("Wifi ")
          ])) : _e("", !0),
          r.room.television ? (V(), G("li", jpe, [
            Gpe,
            mt("TV ")
          ])) : _e("", !0),
          r.room.airConditioning ? (V(), G("li", Ype, [
            Kpe,
            mt("AC ")
          ])) : _e("", !0)
        ])) : _e("", !0),
        E("div", Xpe, [
          E("button", {
            onClick: c[0] || (c[0] = (a) => r.selectRoom("See All Details Link")),
            class: "link linklook"
          }, Y(r.$t("vacvComponents.plpList.roomShowDetails")), 1)
        ]),
        ne(n) > 1 ? (V(), G("div", Jpe, [
          E("strong", null, Y(r.$t("vacvComponents.plpList.roomOptionsInfo", {
            count: ne(n) - 1
          })), 1),
          E("div", Qpe, [
            E("button", {
              onClick: c[1] || (c[1] = (a) => r.selectRoom("See All Room Options Link")),
              class: "link linklook"
            }, Y(r.$t("vacvComponents.plpList.roomOptionsButton")), 1)
          ])
        ])) : _e("", !0)
      ]);
    };
  }
}), the = /* @__PURE__ */ Zn(ehe, [["__scopeId", "data-v-4222c5bb"]]), nhe = { class: "hotel-accordion" }, ihe = { class: "accordion-title" }, rhe = ["id"], she = ["aria-label", "aria-controls"], ohe = { class: "accordion-content" }, ahe = {
  key: 0,
  class: "item-gallery"
}, lhe = { class: "item-content" }, che = /* @__PURE__ */ at({
  __name: "HotelRoomAccordion",
  props: {
    hotelName: { default: "" },
    room: {},
    position: {},
    visible: { type: Boolean },
    showHide: {},
    selectRoom: {}
  },
  setup(e) {
    var c, d, a, f, g, x;
    const t = e, n = (d = (c = t.room.roomDetails) == null ? void 0 : c.images) == null ? void 0 : d.images, i = (f = (a = t.room.roomDetails) == null ? void 0 : a.images) == null ? void 0 : f.sizes, r = (x = (g = t.room.roomDetails) == null ? void 0 : g.images) == null ? void 0 : x.variations;
    return ($, A) => (V(), Tt(jh, {
      id: "roomDetailsAccordion-" + $.position,
      className: "room-details",
      role: "region",
      "aria-live": "polite",
      "aria-labelledby": "roomDetailsAccordion-title-" + $.position
    }, {
      default: Qt(() => [
        E("div", nhe, [
          E("div", ihe, [
            E("div", {
              class: "vacv-label-sm",
              id: "roomDetailsAccordion-title-" + $.position
            }, Y($.$t("vacvComponents.plpList.roomDetails")), 9, rhe),
            E("button", {
              onClick: A[0] || (A[0] = //@ts-ignore
              (...I) => $.showHide && $.showHide(...I)),
              class: "btn-close",
              "aria-label": $.$t("vacvComponents.common.buttons.close"),
              "aria-expanded": "true",
              "aria-controls": "roomDetailsAccordion-" + $.position
            }, null, 8, she)
          ]),
          E("div", ohe, [
            E("div", {
              class: Et(["hotel-item", { "has-item-gallery": ne(n) }])
            }, [
              ne(n) && ne(i) ? (V(), G("div", ahe, [
                it(Ox, {
                  class: "carousel-small",
                  images: ne(n),
                  sizes: ne(i),
                  hotelName: $.hotelName,
                  "available-variations": ne(r),
                  "display-size": "medium",
                  "display-variation": "tabletLandscape",
                  "is-plp-room-details": ""
                }, null, 8, ["images", "sizes", "hotelName", "available-variations"])
              ])) : _e("", !0),
              E("div", lhe, [
                it(the, {
                  room: $.room,
                  selectRoom: $.selectRoom
                }, null, 8, ["room", "selectRoom"])
              ])
            ], 2)
          ])
        ])
      ]),
      _: 1
    }, 8, ["id", "aria-labelledby"]));
  }
}), rT = {
  LAST_BOOKING: {
    hotel: {
      MINUTE: "vacvComponents.psytriggers.last-booking-minute",
      HOUR: "vacvComponents.psytriggers.last-booking-hour"
    },
    room: {
      MINUTE: "vacvComponents.psytriggers.room-last-booking-minute",
      HOUR: "vacvComponents.psytriggers.room-last-booking-hour"
    }
  },
  TOTAL_BOOKINGS: {
    hotel: {
      "24H": "vacvComponents.psytriggers.total-bookings-24",
      "48H": "vacvComponents.psytriggers.total-bookings-48"
    },
    room: {
      "24H": "vacvComponents.psytriggers.room-total-bookings-24",
      "48H": "vacvComponents.psytriggers.room-total-bookings-48"
    }
  },
  ROOMS_LEFT: "vacvComponents.psytriggers.rooms-left"
}, sT = {
  ROOMS_LEFT: "vacvComponents.psytriggers.rooms-left-advisory",
  BOOKINGS: "vacvComponents.psytriggers.bookings-advisory"
}, uhe = (e, t) => {
  if (e != null && e.type) {
    if (e.type === "ROOMS_LEFT")
      return {
        message: rT[e.type],
        advisory: sT.ROOMS_LEFT
      };
    if (e.type === "LAST_BOOKING" || e.type === "TOTAL_BOOKINGS")
      return {
        message: rT[e.type][t][e.span],
        advisory: sT.BOOKINGS
      };
  }
}, dhe = (e) => (nl("data-v-c680d71a"), e = e(), il(), e), phe = { class: "btn-tooltip linklook" }, hhe = /* @__PURE__ */ dhe(() => /* @__PURE__ */ E("i", {
  class: "fa-solid fa-alarm-clock",
  "aria-hidden": "true"
}, null, -1)), fhe = ["onClick", "aria-label"], mhe = {
  class: "tooltip-content",
  id: "tooltip-psytrigger-content"
}, vhe = /* @__PURE__ */ at({
  __name: "PsychTrigger",
  props: {
    trigger: {},
    appliedTo: {}
  },
  setup(e) {
    const t = e, n = parseInt(t.trigger.value ?? "0"), i = uhe(t.trigger, t.appliedTo);
    return (r, c) => {
      var d;
      return (d = ne(i)) != null && d.message && ne(n) ? (V(), Tt(ne(uy), {
        key: 0,
        placement: "bottom",
        arrow: "",
        role: "dialog",
        "aria-label": "tooltip-psytrigger-content"
      }, zg({
        default: Qt(() => [
          E("button", phe, [
            hhe,
            mt(" " + Y(r.$t(ne(i).message, { count: ne(n) })), 1)
          ])
        ]),
        _: 2
      }, [
        ne(i).advisory ? {
          name: "content",
          fn: Qt(({ close: a }) => [
            E("button", {
              class: "btn-close",
              onClick: a,
              "aria-label": r.$t("vacvComponents.common.buttons.close")
            }, null, 8, fhe),
            E("div", mhe, Y(r.$t(ne(i).advisory)), 1)
          ]),
          key: "0"
        } : void 0
      ]), 1024)) : _e("", !0);
    };
  }
}), sL = /* @__PURE__ */ Zn(vhe, [["__scopeId", "data-v-c680d71a"]]), ghe = { class: "accordion-content" }, yhe = { class: "flight-title fa-plane" }, _he = { class: "flight-trip" }, bhe = { class: "flight-row city-stop" }, whe = { class: "city origin" }, xhe = { class: "code" }, $he = { class: "desktop-only stops" }, Che = { class: "city destination" }, khe = { class: "code" }, She = { class: "flight-row time-duration" }, The = { class: "datetime origin" }, Ihe = { class: "date" }, Ahe = { class: "time" }, Ehe = {
  key: 0,
  class: "desktop-only duration"
}, Phe = { class: "datetime destination" }, Mhe = { class: "date" }, Dhe = { class: "time" }, Lhe = { class: "mobile-only stop-duration" }, Ohe = { class: "stops" }, Nhe = {
  key: 0,
  class: "duration"
}, Fhe = { class: "flight-details" }, Rhe = { class: "info" }, zhe = {
  key: 0,
  class: "airline"
}, Bhe = {
  key: 1,
  class: "airline"
}, Vhe = {
  key: 2,
  class: "flightnum"
}, Uhe = { class: "cabinClass" }, oT = /* @__PURE__ */ at({
  __name: "FlightDetailsSegment",
  props: {
    segments: {},
    displayDuration: { type: Boolean, default: !0 }
  },
  setup(e) {
    const t = e, { t: n } = ki({ useScope: "global" }), i = t.segments[0].originName, r = t.segments[0].origin, c = t.segments[t.segments.length - 1].destinationName, d = t.segments[t.segments.length - 1].destination, a = Ae(() => {
      var U;
      return (U = t.segments) == null ? void 0 : U[0].bound;
    }), f = Ae(() => a.value === "O" ? n("vacvComponents.flight.labels.departure") : n("vacvComponents.flight.labels.return")), g = Ae(
      () => Kp(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        t.segments[0].departureDate,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        t.segments[0].departureTime
      )
    ), x = Ae(
      () => Kp(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        t.segments[t.segments.length - 1].arrivalDate,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        t.segments[t.segments.length - 1].arrivalTime
      )
    ), $ = Ae(() => t.segments[0].numConnections), A = Ae(() => {
      var U;
      return (U = t.segments[0]) == null ? void 0 : U.totalFlightDuration;
    }), I = Ae(() => A.value ? A.value.substring(0, 2) + "h" + A.value.substring(2) : null), O = Ae(() => {
      var U;
      return (U = t.segments) == null ? void 0 : U[0].operatingAirline;
    }), B = Ae(() => {
      var U;
      return (U = t.segments) == null ? void 0 : U[0].carrierName;
    }), H = Ae(() => {
      var U;
      return (U = t.segments) == null ? void 0 : U[0].carrierCode;
    }), N = Ae(() => {
      var U;
      return (U = t.segments) == null ? void 0 : U[0].flightNumber;
    }), K = Ae(() => {
      var U;
      return (U = t.segments) == null ? void 0 : U[0].cabinClassName;
    });
    return (U, q) => (V(), G("div", ghe, [
      E("div", yhe, [
        E("span", null, Y(f.value), 1)
      ]),
      E("div", _he, [
        E("div", bhe, [
          E("div", whe, [
            mt(Y(ne(i)) + " ", 1),
            E("span", xhe, Y(ne(r)), 1)
          ]),
          E("div", $he, [
            it(Ay, { connections: $.value }, null, 8, ["connections"]),
            it(Ey, {
              class: Et("line stop-" + $.value),
              connections: $.value
            }, null, 8, ["class", "connections"])
          ]),
          E("div", Che, [
            mt(Y(ne(c)) + " ", 1),
            E("span", khe, Y(ne(d)), 1)
          ])
        ]),
        E("div", She, [
          it(Ey, {
            class: Et("mobile-only line stop-" + $.value),
            connections: $.value
          }, null, 8, ["class", "connections"]),
          E("div", The, [
            E("span", Ihe, Y(U.$d(g.value, "short")), 1),
            E("span", Ahe, Y(U.$d(g.value, "time")), 1)
          ]),
          I.value && U.displayDuration ? (V(), G("div", Ehe, [
            mt(Y(U.$t("vacvComponents.flight.labels.duration")) + ": ", 1),
            E("span", null, " " + Y(I.value), 1)
          ])) : _e("", !0),
          E("div", Phe, [
            E("span", Mhe, Y(U.$d(x.value, "short")), 1),
            E("span", Dhe, Y(U.$d(x.value, "time")), 1)
          ])
        ])
      ]),
      E("div", Lhe, [
        E("div", Ohe, [
          it(Ay, { connections: $.value }, null, 8, ["connections"])
        ]),
        I.value && U.displayDuration ? (V(), G("div", Nhe, [
          mt(Y(U.$t("vacvComponents.flight.labels.duration")) + ": ", 1),
          E("span", null, " " + Y(I.value), 1)
        ])) : _e("", !0)
      ]),
      E("div", Fhe, [
        E("div", Rhe, [
          O.value ? (V(), G("span", zhe, Y(U.$t("vacvComponents.flight.labels.operatedBy")) + " " + Y(O.value) + ", ", 1)) : (V(), G("span", Bhe, Y(B.value) + ", ", 1)),
          U.displayDuration ? _e("", !0) : (V(), G("span", Vhe, Y(H.value) + " " + Y(N.value) + ", ", 1)),
          E("span", Uhe, Y(K.value), 1)
        ])
      ])
    ]));
  }
}), Hhe = { class: "hotel-accordion" }, Whe = ["id"], Zhe = { class: "vacv-label-sm" }, qhe = {
  key: 0,
  class: "title-sub"
}, jhe = ["aria-label", "aria-controls"], Ghe = /* @__PURE__ */ at({
  __name: "FlightDetailsAccordion",
  props: {
    position: { default: 0 },
    outbound: {},
    inbound: {},
    showHide: {}
  },
  setup(e) {
    const t = e, n = Ae(
      () => t.inbound !== void 0 || t.outbound !== void 0
    );
    return (i, r) => (V(), Tt(jh, {
      id: "flightDetailsAccordion-" + t.position,
      className: "flight-details",
      role: "region",
      "aria-live": "polite",
      "aria-labelledby": "flightDetailsAccordion-title-" + t.position
    }, {
      default: Qt(() => [
        E("div", Hhe, [
          E("div", {
            class: Et(
              n.value ? "accordion-title details" : "accordion-title details no-avail"
            )
          }, [
            E("div", {
              id: "flightDetailsAccordion-title-" + t.position
            }, [
              E("div", Zhe, Y(n.value ? i.$t("vacvComponents.flight.labels.flightDetails") : i.$t("vacvComponents.flight.messages.flightDetailsError")), 1),
              n.value ? (V(), G("div", qhe, Y(i.$t("vacvComponents.flight.messages.flightDetailsSubtitle")), 1)) : _e("", !0)
            ], 8, Whe),
            E("button", {
              onClick: r[0] || (r[0] = //@ts-ignore
              (...c) => i.showHide && i.showHide(...c)),
              class: "btn-close",
              "aria-label": i.$t("vacvComponents.common.buttons.close"),
              "aria-expanded": "true",
              "aria-controls": "flightDetailsAccordion-" + t.position
            }, null, 8, jhe)
          ], 2),
          i.outbound ? (V(), Tt(oT, {
            key: 0,
            class: Et("outbound"),
            segments: i.outbound
          }, null, 8, ["segments"])) : _e("", !0),
          i.inbound ? (V(), Tt(oT, {
            key: 1,
            class: Et("inbound"),
            segments: i.inbound
          }, null, 8, ["segments"])) : _e("", !0)
        ])
      ]),
      _: 1
    }, 8, ["id", "aria-labelledby"]));
  }
}), Yhe = ["id"], Khe = { class: "hotel-item" }, Xhe = { class: "item-gallery" }, Jhe = {
  key: 0,
  class: "recommended-label"
}, Qhe = /* @__PURE__ */ E("i", { class: "fa-solid fa-thumbs-up" }, null, -1), efe = { class: "sr-only" }, tfe = {
  key: 2,
  class: "carousel-fallback-img"
}, nfe = ["src", "alt"], ife = { class: "item-content" }, rfe = { class: "item-content-left" }, sfe = { class: "hotel-name" }, ofe = {
  key: 2,
  class: "hotel-package"
}, afe = { class: "desktop-only links-wrapper" }, lfe = ["aria-expanded", "aria-controls"], cfe = /* @__PURE__ */ E("i", {
  class: "fa-solid fa-plane",
  "aria-hidden": "true"
}, null, -1), ufe = ["aria-expanded", "aria-controls"], dfe = /* @__PURE__ */ E("i", {
  class: "fa-solid fa-bed-front",
  "aria-hidden": "true"
}, null, -1), pfe = ["aria-expanded", "aria-controls"], hfe = /* @__PURE__ */ E("i", {
  class: "fa-solid fa-calendar-days",
  "aria-hidden": "true"
}, null, -1), ffe = { class: "item-content-right" }, mfe = { class: "price-right" }, vfe = { class: "hotel-select" }, gfe = { class: "sr-only" }, yfe = { class: "mobile-only links-wrapper" }, _fe = ["aria-expanded", "aria-controls"], bfe = /* @__PURE__ */ E("i", {
  class: "fa-solid fa-plane",
  "aria-hidden": "true"
}, null, -1), wfe = ["aria-expanded", "aria-controls"], xfe = /* @__PURE__ */ E("i", {
  class: "fa-solid fa-bed-front",
  "aria-hidden": "true"
}, null, -1), $fe = ["aria-expanded", "aria-controls"], Cfe = /* @__PURE__ */ E("i", {
  class: "fa-solid fa-calendar-days",
  "aria-hidden": "true"
}, null, -1), kfe = 5, pIe = /* @__PURE__ */ at({
  __name: "PlpListItemContent",
  props: {
    position: {},
    package: {},
    hotel: {},
    itinerary: {},
    localisedPromo: {},
    trigger: {},
    price: {},
    total: {},
    wasPricePerAdult: {},
    savingsPercentage: {},
    savingsThreshold: {},
    wasPriceTooltipEnabled: { type: Boolean },
    cdnBaseUrl: {},
    spaType: {}
  },
  emits: ["select"],
  setup(e, { emit: t }) {
    var de, me, ve, re, le;
    const n = t, i = e, r = xE(), { locale: c } = ki({ useScope: "global" }), d = $e(!1), a = $e(!1), f = $e(!1), g = ((me = (de = i.itinerary) == null ? void 0 : de.segments) == null ? void 0 : me.filter((pe) => pe.bound === "O")) ?? [], x = ((re = (ve = i.itinerary) == null ? void 0 : ve.segments) == null ? void 0 : re.filter((pe) => pe.bound === "I")) ?? [], $ = Ae(() => {
      var Ne;
      const pe = (Ne = i.package) == null ? void 0 : Ne.alternateDates;
      if (pe) {
        const We = BI(
          pe,
          r,
          kfe
        );
        if (We.length)
          return We;
      }
      return null;
    }), A = i.hotel.rooms ? Object.values(i.hotel.rooms)[0] : void 0, I = (pe, Ne) => {
      var Ge, et;
      const We = pe.value;
      d.value = !1, a.value = !1, f.value = !1, pe.value = !We, pe.value && (i != null && i.hotel.name) && (Ne === "Room Link" ? (ia("Room Link", i.hotel.name), ia(
        (et = (Ge = A == null ? void 0 : A.roomDetails) == null ? void 0 : Ge.images) != null && et.images ? "Room Modal - Room Picture Available" : "Room Modal - Room Picture Not Available",
        i.hotel.name
      )) : ia(Ne, i.hotel.name));
    }, O = () => {
      I(d, "Flight Details Link");
    }, B = () => {
      I(a, "Room Link");
    }, H = () => {
      I(f, "Flexible Dates Link");
    };
    function N() {
      i.hotel.name && ia("Total Price Link", i.hotel.name);
    }
    const K = () => {
      i.hotel.name && ia("Was Price", i.hotel.name);
    };
    J0(
      "defaultImage",
      `${i.cdnBaseUrl}/img/carousel-fallback-img_${c.value}.jpg`
    ), J0("maxAvailability", i.package.maxAvailableRoomCategory);
    const U = (pe) => {
      i6(
        i.position,
        i.package,
        i.hotel,
        i.itinerary,
        i.trigger
      ), i.hotel.name && ia(pe === "See All Details Link" || pe === "See All Room Options Link" ? `Room Modal - ${pe}` : "Select Button", i.hotel.name), n("select");
    }, q = () => {
      i.hotel.name && ia("Hotel Name Link", i.hotel.name), n("select");
    }, ee = ((le = i.package.information) == null ? void 0 : le.refundable) ?? !0, te = "packageInclusions" in i.package.information && i.package.information.packageInclusions, ae = (() => {
      var pe;
      return (pe = i.package.pricing) == null ? void 0 : pe.grandTotal;
    })(), oe = Ae(() => i.spaType === ps.HotelsSpa);
    return (pe, Ne) => {
      var We, Ge, et, ft, De;
      return V(), G("div", {
        id: "spa-list-item-" + pe.position,
        class: "hotel-item-wrapper"
      }, [
        E("div", Khe, [
          E("div", Xhe, [
            pe.hotel.recommended ? (V(), G("div", Jhe, [
              Qhe,
              E("span", efe, Y(pe.$t("vacvComponents.plp.messages.recommended-access")), 1),
              mt(Y(pe.$t("vacvComponents.plp.messages.recommended")), 1)
            ])) : _e("", !0),
            (et = (Ge = (We = pe.hotel) == null ? void 0 : We.media) == null ? void 0 : Ge.images) != null && et.length && ((De = (ft = pe.hotel) == null ? void 0 : ft.media) != null && De.sizes) ? (V(), Tt(Ox, {
              key: 1,
              class: "carousel-small",
              images: pe.hotel.media.images,
              sizes: pe.hotel.media.sizes,
              "hotel-name": pe.hotel.name,
              "available-variations": pe.hotel.media.variations,
              "display-size": "medium",
              "display-variation": "tabletLandscape"
            }, null, 8, ["images", "sizes", "hotel-name", "available-variations"])) : (V(), G("div", tfe, [
              E("img", {
                src: `${pe.cdnBaseUrl}/img/carousel-fallback-img_${ne(c)}.jpg`,
                alt: pe.$t("vacvComponents.common.messages.fallback-img")
              }, null, 8, nfe)
            ]))
          ]),
          E("div", ife, [
            E("div", rfe, [
              pe.trigger ? (V(), Tt(sL, {
                key: 0,
                trigger: pe.trigger,
                appliedTo: "hotel",
                class: "psytrigger vacv-tooltip"
              }, null, 8, ["trigger"])) : _e("", !0),
              pe.localisedPromo && !oe.value ? (V(), Tt(eP, {
                key: 1,
                class: "aeroplanpoints",
                badge: pe.localisedPromo.Badge,
                "modal-title": pe.$t("vacvComponents.plpList.aeroplanpointsTitle"),
                "modal-text": pe.localisedPromo.Terms,
                origin: "plpAeroplan"
              }, null, 8, ["badge", "modal-title", "modal-text"])) : _e("", !0),
              E("h2", sfe, [
                E("a", {
                  href: "/",
                  class: "hotel-name-link",
                  onClick: zi(q, ["prevent"])
                }, Y(pe.hotel.name), 1)
              ]),
              it(CD, {
                hotel: pe.hotel,
                package: pe.package
              }, null, 8, ["hotel", "package"]),
              ne(te) ? (V(), G("div", ofe, Y(ne(te)), 1)) : _e("", !0),
              pe.hotel.rating && ne($D)(pe.hotel.rating) ? (V(), Tt(BE, {
                key: 3,
                rating: pe.hotel.rating
              }, null, 8, ["rating"])) : _e("", !0),
              E("div", afe, [
                oe.value ? _e("", !0) : (V(), G("button", {
                  key: 0,
                  onClick: O,
                  class: "flight-details-link hotel-link-icon link linklook",
                  "aria-expanded": d.value,
                  "aria-controls": "flightDetailsAccordion-" + pe.position
                }, [
                  cfe,
                  mt(" " + Y(pe.$t("vacvComponents.plpList.flightdetails")), 1)
                ], 8, lfe)),
                ne(A) ? (V(), G("button", {
                  key: 1,
                  onClick: B,
                  class: "room-details-link hotel-link-icon link linklook",
                  "aria-expanded": a.value,
                  "aria-controls": "roomDetailsAccordion-" + pe.position
                }, [
                  dfe,
                  mt(" " + Y(pe.$t("vacvComponents.plpList.roomDetails")), 1)
                ], 8, ufe)) : _e("", !0),
                $.value ? (V(), G("button", {
                  key: 2,
                  onClick: H,
                  class: "flexible-dates-link hotel-link-icon link linklook",
                  "aria-expanded": f.value,
                  "aria-controls": "flexibleDatesAccordion-" + pe.position
                }, [
                  hfe,
                  mt(" " + Y(pe.$t("vacvComponents.plpList.flexibleDates")), 1)
                ], 8, pfe)) : _e("", !0)
              ])
            ]),
            E("div", ffe, [
              pe.package.pricing ? (V(), Tt(JD, {
                key: 0,
                "pre-package-pricing": pe.package.pricing,
                price: pe.price,
                total: pe.total,
                "show-difference": !1,
                wasPricePerAdult: pe.wasPricePerAdult,
                savingsPercentage: pe.savingsPercentage,
                wasPriceTooltipEnabled: pe.wasPriceTooltipEnabled,
                savingsThreshold: pe.savingsThreshold,
                spaType: pe.spaType,
                onPriceTotalClick: N,
                onWasPriceClick: K
              }, {
                priceBreakdownLines: Qt(() => [
                  it(Zx, {
                    "price-total": ne(ae),
                    spaType: pe.spaType,
                    modifier: "popover",
                    "is-section": "",
                    "is-refundable": ne(ee)
                  }, null, 8, ["price-total", "spaType", "is-refundable"])
                ]),
                _: 1
              }, 8, ["pre-package-pricing", "price", "total", "wasPricePerAdult", "savingsPercentage", "wasPriceTooltipEnabled", "savingsThreshold", "spaType"])) : _e("", !0),
              E("div", mfe, [
                ne(ee) ? _e("", !0) : (V(), Tt(Wx, { key: 0 })),
                E("div", vfe, [
                  E("button", {
                    onClick: Ne[0] || (Ne[0] = () => U()),
                    class: "vacv-btn-primary"
                  }, [
                    mt(Y(pe.$t("vacvComponents.common.buttons.select")) + " ", 1),
                    E("span", gfe, Y(pe.hotel.name), 1)
                  ])
                ])
              ])
            ]),
            E("div", yfe, [
              oe.value ? _e("", !0) : (V(), G("button", {
                key: 0,
                onClick: O,
                class: "flight-details-link hotel-link-icon link linklook",
                "aria-expanded": d.value,
                "aria-controls": "flightDetailsAccordion-" + pe.position
              }, [
                bfe,
                mt(" " + Y(pe.$t("vacvComponents.plpList.flightdetails")), 1)
              ], 8, _fe)),
              ne(A) ? (V(), G("button", {
                key: 1,
                onClick: B,
                class: "room-details-link hotel-link-icon link linklook",
                "aria-expanded": a.value,
                "aria-controls": "roomDetailsAccordion-" + pe.position
              }, [
                xfe,
                mt(" " + Y(pe.$t("vacvComponents.plpList.roomDetails")), 1)
              ], 8, wfe)) : _e("", !0),
              $.value ? (V(), G("button", {
                key: 2,
                onClick: H,
                class: "flexible-dates-link hotel-link-icon link linklook",
                "aria-expanded": f.value,
                "aria-controls": "flexibleDatesAccordion-" + pe.position
              }, [
                Cfe,
                mt(" " + Y(pe.$t("vacvComponents.plpList.flexibleDates")), 1)
              ], 8, $fe)) : _e("", !0)
            ])
          ])
        ]),
        it($r, { name: "collapsible" }, {
          default: Qt(() => [
            d.value && !oe.value ? (V(), Tt(Ghe, {
              key: 0,
              id: "flightDetailsAccordion-" + pe.position,
              position: pe.position,
              outbound: ne(g),
              inbound: ne(x),
              showHide: O
            }, null, 8, ["id", "position", "outbound", "inbound"])) : _e("", !0)
          ]),
          _: 1
        }),
        it($r, { name: "collapsible" }, {
          default: Qt(() => [
            ne(A) && a.value ? (V(), Tt(che, {
              key: 0,
              id: "roomDetailsAccordion-" + pe.position,
              hotelName: pe.hotel.name,
              room: ne(A),
              position: pe.position,
              showHide: B,
              selectRoom: U,
              visible: a.value
            }, null, 8, ["id", "hotelName", "room", "position", "visible"])) : _e("", !0)
          ]),
          _: 1
        }),
        it($r, { name: "collapsible" }, {
          default: Qt(() => [
            $.value && f.value && pe.package.svHotelId && pe.hotel.name ? (V(), Tt(zpe, {
              key: 0,
              id: "flexibleDatesAccordion-" + pe.position,
              position: pe.position,
              alternateHotelDates: $.value,
              no_hotel: pe.package.svHotelId,
              hotelName: pe.hotel.name,
              showHide: H
            }, null, 8, ["id", "position", "alternateHotelDates", "no_hotel", "hotelName"])) : _e("", !0)
          ]),
          _: 1
        })
      ], 8, Yhe);
    };
  }
}), Sfe = {
  key: 0,
  id: "alternatedates-section",
  class: "alternatedates-section"
}, Tfe = { class: "message-title" }, Ife = {
  key: 0,
  id: "message-multiple-dates"
}, Afe = { class: "message-directive" }, Efe = {
  key: 1,
  id: "message-single-date"
}, Pfe = { class: "message-directive" }, Mfe = { class: "alternatedates-listing" }, Dfe = { class: "vacv-radio-group column" }, hIe = /* @__PURE__ */ at({
  __name: "AlternateDates",
  props: {
    alternateDates: {},
    departingDateTime: {}
  },
  setup(e) {
    const t = e, { t: n, d: i, locale: r } = ki({ useScope: "global" }), c = async (x) => {
      rL(x.alternatedates);
    }, d = Ae(() => {
      const x = (A) => /^\d{8}$/.test(A), $ = (A, I) => parseInt(A) - parseInt(I);
      return t.alternateDates === void 0 ? [] : t.alternateDates.filter(x).sort($).slice(0, 5);
    }), a = Ae(() => d.value.map((x) => {
      const $ = Wa(x);
      if ($)
        return {
          label: n("vacvComponents.alternatedates.labels.prefix-available-date") + i($, "medium", r.value),
          value: x
        };
    })), f = Ae(() => d.value.length == 1 ? d.value[0] : g());
    function g() {
      if (t.departingDateTime === void 0 || t.departingDateTime == null)
        return d.value[0];
      if (typeof t.departingDateTime != "string")
        return "";
      const x = GA(t.departingDateTime);
      if (x === void 0)
        return d.value[0];
      const $ = d.value.length - 1, A = d.value.findIndex((H) => H > x);
      if (A === -1)
        return d.value[$];
      const I = A > 0 ? Wa(d.value[A - 1]) : Wa(d.value[A]), O = A < $ ? Wa(d.value[A]) : Wa(d.value[$]), B = Wa(x);
      if (B && I && O) {
        const H = Jg(B, I), N = Jg(O, B);
        return H === N ? im(I) : H > N ? im(O) : im(I);
      }
      return "";
    }
    return (x, $) => {
      const A = Ur("FormKit");
      return d.value.length > 0 ? (V(), G("div", Sfe, [
        E("h1", Tfe, Y(x.$t("vacvComponents.alternatedates.messages.not-available")), 1),
        d.value.length > 1 ? (V(), G("div", Ife, [
          E("div", Afe, Y(x.$t("vacvComponents.alternatedates.messages.select-available-dates")), 1)
        ])) : (V(), G("div", Efe, [
          E("div", Pfe, Y(x.$t("vacvComponents.alternatedates.messages.found-one-date")), 1)
        ])),
        E("div", Mfe, [
          it(A, {
            id: "alternatedates-form",
            type: "form",
            actions: !1,
            onSubmit: c
          }, {
            default: Qt(() => [
              E("div", Dfe, [
                it(A, {
                  id: "alternatedates-radio",
                  type: "radio",
                  name: "alternatedates",
                  options: a.value,
                  value: f.value,
                  validation: "required",
                  "validation-messages": {
                    required: x.$t(
                      "vacvComponents.alternatedates.errors.mandatory-date"
                    )
                  }
                }, null, 8, ["options", "value", "validation-messages"])
              ]),
              E("div", null, [
                it(A, {
                  id: "alternatedates-submit",
                  type: "submit",
                  label: x.$t("vacvComponents.common.buttons.submit"),
                  "input-class": "$reset vacv-btn-primary"
                }, null, 8, ["label"])
              ])
            ]),
            _: 1
          })
        ])
      ])) : _e("", !0);
    };
  }
}), oL = {
  subTitle: "vacvComponents.plp.messages.something-went-wrong",
  suggestTitle: "vacvComponents.plp.messages.try-again-by",
  suggestions: [
    "vacvComponents.plp.messages.click-modify",
    "vacvComponents.plp.messages.refresh-page"
  ]
}, Lfe = {
  subTitle: "vacvComponents.plp.messages.specific-s214-error-tulum",
  suggestTitle: "vacvComponents.plp.messages.suggest-cancun-good-news",
  suggestTitle2: "vacvComponents.plp.messages.suggest-cancun-update",
  updateCta: !0
}, Ofe = {
  subTitle: "vacvComponents.plp.messages.notfound-unavailable",
  suggestTitle: "vacvComponents.plp.messages.suggest",
  suggestions: [
    "vacvComponents.plp.messages.suggest-date",
    "vacvComponents.plp.messages.suggest-travellers",
    "vacvComponents.plp.messages.suggest-different-airport",
    "vacvComponents.plp.messages.suggest-alternative-destination"
  ],
  updateCta: !0
}, Nfe = {
  subTitle: "vacvComponents.plp.messages.notfound",
  suggestTitle: "vacvComponents.plp.messages.suggest",
  suggestions: [
    "vacvComponents.plp.messages.suggest-date",
    "vacvComponents.plp.messages.suggest-nearby-airports",
    "vacvComponents.plp.messages.suggest-different-destination"
  ],
  updateCta: !0
}, Ffe = {
  html: "vacvComponents.plp.messages.children-more-than-one-room-error",
  updateCta: !0
}, Rfe = {
  html: "vacvComponents.plp.messages.more-than-6-pax-error",
  updateCta: !0
}, zfe = {
  html: "vacvComponents.plp.messages.adults-repartition-error",
  updateCta: !0
}, Bfe = {
  subTitle: "vacvComponents.plp.messages.notfound-filters"
}, Vfe = {
  subTitle: "vacvComponents.plp.messages.notfound-filters-hotels"
}, Ufe = /* @__PURE__ */ new Map([
  [Bp.INCORRECT_SEARCH, Nfe],
  [Bp.INVALID_NUM_ROOM_CHILD, Ffe],
  [Bp.INVALID_OCCUPANCY, Rfe],
  [Bp.ADULTS_REPARTITION_ERROR, zfe],
  [Bp.GENERAL_SAX_ERROR, oL]
]), Hfe = /* @__PURE__ */ new Set([
  "vacvComponents.plp.messages.suggest-different-airport",
  "vacvComponents.plp.messages.suggest-nearby-airports"
]), Wfe = () => {
  const t = new URLSearchParams(window.location.search).get("dest_dep");
  if (t && BB.has(t))
    return Lfe;
}, Zfe = (e, t, n, i) => {
  const r = i ? void 0 : Wfe();
  if (e === Bp.INCORRECT_SEARCH && r)
    return r;
  const c = e && Ufe.get(e);
  return c || (t ? i ? Vfe : Bfe : n ? oL : r ?? Ofe);
}, qfe = (e, t) => e.suggestions ? {
  ...e,
  suggestions: e.suggestions.filter((n) => !t.has(n))
} : e, jfe = (e, t, n, i) => {
  const r = Zfe(
    e,
    t,
    n,
    i
  );
  return i ? qfe(r, Hfe) : r;
}, Gfe = { class: "numberfound-wrapper" }, Yfe = { class: "filter-sortby" }, Kfe = {
  key: 0,
  class: "mobile-only filterbutton"
}, Xfe = ["aria-expanded"], Jfe = /* @__PURE__ */ E("i", {
  class: "fa-regular fa-sliders",
  "aria-hidden": "true"
}, null, -1), Qfe = { class: "vacv-label-sm" }, eme = {
  key: 0,
  class: "sv-search-error",
  "data-test": "service-error"
}, tme = { key: 0 }, nme = ["innerHTML"], ime = {
  key: 1,
  class: "text"
}, rme = { class: "h1style" }, sme = { key: 0 }, ome = { key: 0 }, ame = { class: "suggest" }, lme = {
  key: 0,
  class: "suggest"
}, cme = {
  key: 1,
  class: "special-list"
}, ume = {
  key: 2,
  "data-test": "service-error-cta"
}, fIe = /* @__PURE__ */ at({
  __name: "PlpError",
  props: {
    hasFiltersSelected: { type: Boolean },
    isSticky: { type: Boolean },
    filterOpened: { type: Boolean },
    showSortBy: { type: Boolean },
    label: {},
    sortByOptions: {},
    error: {},
    excludeAirportSuggestions: { type: Boolean }
  },
  emits: ["open-filter", "on-change"],
  setup(e, { emit: t }) {
    const { t: n } = ki({ useScope: "global" }), i = e, r = Ae(() => {
      const g = i == null ? void 0 : i.error, x = !!(i != null && i.error), $ = jfe(
        g == null ? void 0 : g.detail,
        i.hasFiltersSelected,
        x,
        i.excludeAirportSuggestions
      );
      return $ != null && $.html && ($.html = n($.html)), $;
    }), c = t, d = () => {
      c("open-filter");
    }, a = (g, x) => {
      c("on-change", g, x);
    }, f = () => {
      FI(), window.dispatchEvent(new CustomEvent("updatePackagesSearch"));
    };
    return (g, x) => (V(), G(cn, null, [
      E("span", Gfe, [
        E("div", {
          class: Et("filtersortby-wrapper" + (g.isSticky ? " sticky" : "")),
          ref: "filtersortbyRef"
        }, [
          E("div", Yfe, [
            g.hasFiltersSelected ? (V(), G("div", Kfe, [
              E("button", {
                "data-test": "openfilter-mobile",
                onClick: d,
                id: "mobile-filter-panel-btn",
                class: "vacv-btn-outline",
                "aria-controls": "mobile-filter-panel",
                "aria-expanded": g.filterOpened
              }, [
                Jfe,
                E("span", Qfe, Y(g.$t("vacvComponents.plp.filters.filter")), 1)
              ], 8, Xfe)
            ])) : _e("", !0),
            g.showSortBy ? (V(), Tt(dx, {
              key: 1,
              label: g.label,
              class: "sortby",
              options: g.sortByOptions ?? [],
              onValueChange: a,
              "drop-down-id": "dropdown-sort-by",
              outlined: !0,
              initialValue: void 0
            }, null, 8, ["label", "options"])) : _e("", !0)
          ])
        ], 2)
      ]),
      r.value ? (V(), G("div", eme, [
        r.value.html ? (V(), G("div", tme, [
          E("div", {
            "data-test": "service-error-message",
            innerHTML: r.value.html
          }, null, 8, nme)
        ])) : (V(), G("div", ime, [
          E("h2", rme, [
            r.value.subTitle ? (V(), G("span", sme, Y(g.$t(r.value.subTitle)), 1)) : _e("", !0)
          ]),
          r.value.suggestTitle ? (V(), G("div", ome, [
            E("div", ame, Y(g.$t(r.value.suggestTitle)), 1),
            r.value.suggestTitle2 ? (V(), G("div", lme, Y(g.$t(r.value.suggestTitle2)), 1)) : _e("", !0),
            r.value.suggestions ? (V(), G("ul", cme, [
              (V(!0), G(cn, null, Pn(r.value.suggestions, ($) => (V(), G("li", { key: $ }, Y(g.$t($)), 1))), 128))
            ])) : _e("", !0)
          ])) : _e("", !0)
        ])),
        r.value.updateCta ? (V(), G("div", ume, [
          E("button", {
            class: "vacv-btn-primary",
            onClick: f
          }, Y(g.$t("vacvComponents.plp.messages.update-your-search")), 1)
        ])) : _e("", !0)
      ])) : _e("", !0)
    ], 64));
  }
}), dme = ["id"], pme = ["id"], hme = ["aria-expanded", "aria-controls"], fme = { class: "toggletext" }, mme = ["id", "aria-labelledby"], vme = ["aria-expanded", "aria-controls"], gme = { class: "toggletext" }, yme = /* @__PURE__ */ at({
  __name: "SummarySectionContainer",
  props: {
    sectionTitle: {},
    type: {},
    id: {},
    opened: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = $e(t.opened), i = $e(), r = () => {
      n.value = !n.value;
    };
    return (c, d) => (V(), G("div", {
      id: t.id,
      class: Et(["summary-section", `${t.type}`])
    }, [
      E("h3", {
        id: t.id + "-title",
        class: "vacv-label-sm"
      }, Y(t.sectionTitle), 9, pme),
      E("button", {
        class: "mobile-only details-link link linklook",
        "aria-expanded": n.value,
        "aria-controls": t.id + "-accordion",
        onClick: zi(r, ["prevent"])
      }, [
        E("span", fme, [
          E("i", {
            class: Et(
              "fa-solid " + (n.value ? "fa-circle-minus" : "fa-circle-plus")
            ),
            "aria-hidden": "true"
          }, null, 2),
          mt(" " + Y(n.value ? c.$t("vacvComponents.bookingsummary.messages.hide-details") : c.$t("vacvComponents.bookingsummary.messages.see-details")), 1)
        ])
      ], 8, hme),
      it($r, { name: "collapsible" }, {
        default: Qt(() => [
          n.value ? (V(), G("section", {
            key: 0,
            id: t.id + "-accordion",
            class: "hotel-accordion-wrapper",
            "aria-live": "polite",
            "aria-labelledby": t.id + "-title",
            ref_key: "scrollHeightRef",
            ref: i
          }, [
            er(c.$slots, "default", {}, void 0, !0)
          ], 8, mme)) : _e("", !0)
        ]),
        _: 3
      }),
      E("button", {
        class: "desktop-only details-link link linklook",
        "aria-expanded": n.value,
        "aria-controls": t.id + "-accordion",
        onClick: zi(r, ["prevent"])
      }, [
        E("span", gme, [
          E("i", {
            class: Et(
              "fa-solid " + (n.value ? "fa-circle-minus" : "fa-circle-plus")
            ),
            "aria-hidden": "true"
          }, null, 2),
          mt(Y(n.value ? c.$t("vacvComponents.bookingsummary.messages.hide-details") : c.$t("vacvComponents.bookingsummary.messages.see-details")), 1)
        ])
      ], 8, vme)
    ], 10, dme));
  }
}), jx = /* @__PURE__ */ Zn(yme, [["__scopeId", "data-v-59af9050"]]), _me = { class: "hotel-accordion" }, bme = {
  key: 0,
  class: "accordion-content"
}, wme = { class: "hotel-name" }, xme = { class: "roomtype-plan" }, $me = { class: "hotel-roomtype" }, Cme = {
  key: 0,
  class: "hotel-plan"
}, kme = { class: "checkin-checkout" }, Sme = { class: "in" }, Tme = { class: "out" }, Ime = {
  key: 1,
  class: "accordion-content"
}, Ame = {
  class: "vacv-form-error",
  "aria-live": "polite"
}, Eme = /* @__PURE__ */ at({
  __name: "HotelAndRoomInfo",
  setup(e) {
    const {
      numberOfRooms: t,
      isValid: n,
      checkIn: i,
      checkOut: r,
      roomName: c,
      mealPlan: d,
      hotelName: a
    } = Nn(cV());
    return (f, g) => (V(), G("div", _me, [
      ne(n) ? (V(), G("div", bme, [
        E("div", wme, Y(ne(a)), 1),
        E("div", xme, [
          E("span", $me, Y(ne(t)) + " " + Y(ne(c)), 1),
          ne(d) ? (V(), G("span", Cme, Y(ne(d)), 1)) : _e("", !0)
        ]),
        E("div", kme, [
          E("div", Sme, [
            E("span", null, Y(f.$t("vacvComponents.pdp.labels.hotel.overview.checkin")), 1),
            mt(" " + Y(f.$d(ne(i), "short")), 1)
          ]),
          E("div", Tme, [
            E("span", null, Y(f.$t("vacvComponents.pdp.labels.hotel.overview.checkout")), 1),
            mt(" " + Y(f.$d(ne(r), "short")), 1)
          ])
        ])
      ])) : (V(), G("div", Ime, [
        E("p", Ame, Y(f.$t("vacvComponents.bookingsummary.errors.no-hotel-room")), 1)
      ]))
    ]));
  }
}), Pme = /* @__PURE__ */ at({
  __name: "BookingSummaryHotel",
  setup(e) {
    return (t, n) => (V(), Tt(jx, {
      id: "hotelAndRoomSection",
      "section-title": t.$t("vacvComponents.bookingsummary.labels.hotel-and-rooms"),
      type: "hotel"
    }, {
      default: Qt(() => [
        it(Eme)
      ]),
      _: 1
    }, 8, ["section-title"]));
  }
}), Mme = { class: "hotel-accordion-wrapper flight-details summary" }, Dme = {
  key: 0,
  class: "hotel-accordion"
}, Lme = {
  key: 1,
  class: "hotel-accordion"
}, Ome = {
  class: "vacv-form-error",
  "aria-live": "polite"
}, Nme = /* @__PURE__ */ at({
  __name: "FlightsDetailsSection",
  props: {
    outbound: {},
    inbound: {},
    displayDuration: { type: Boolean }
  },
  setup(e) {
    const t = e, n = Ae(
      () => t.outbound.length > 0 && t.inbound.length > 0
    );
    return (i, r) => (V(), G("div", Mme, [
      n.value ? (V(), G("div", Dme, [
        it(Py, {
          class: "outbound",
          segments: i.outbound,
          "display-duration": i.displayDuration,
          modifier: "hideButtonOnMobile"
        }, null, 8, ["segments", "display-duration"]),
        it(Py, {
          class: "inbound",
          segments: i.inbound,
          "display-duration": i.displayDuration,
          modifier: "hideButtonOnMobile"
        }, null, 8, ["segments", "display-duration"])
      ])) : (V(), G("div", Lme, [
        E("p", Ome, Y(i.$t("common.bookingsummary.errors.no-flights")), 1)
      ]))
    ]));
  }
}), Fme = /* @__PURE__ */ at({
  __name: "BookingSummaryFlight",
  props: {
    prePackage: {},
    itinerary: {},
    useBreadCrumbsComposable: {}
  },
  setup(e) {
    const t = e, n = t.useBreadCrumbsComposable, i = Ae(
      () => {
        var a, f;
        return ((f = (a = t.itinerary) == null ? void 0 : a.segments) == null ? void 0 : f.filter((g) => g.bound === "O")) ?? [];
      }
    ), r = Ae(
      () => {
        var a, f;
        return ((f = (a = t.itinerary) == null ? void 0 : a.segments) == null ? void 0 : f.filter((g) => g.bound === "I")) ?? [];
      }
    ), c = n.getComponentName(), d = n.isProductListing(c) || n.isProductDetails(c);
    return (a, f) => (V(), Tt(jx, {
      id: "flightsSection",
      "section-title": a.$t("vacvComponents.bookingsummary.labels.round-trip-flight"),
      type: "flight"
    }, {
      default: Qt(() => [
        it(Nme, {
          outbound: i.value,
          inbound: r.value,
          "display-duration": ne(d)
        }, null, 8, ["outbound", "inbound", "display-duration"])
      ]),
      _: 1
    }, 8, ["section-title"]));
  }
}), Rme = /* @__PURE__ */ at({
  __name: "BookingSummaryAncillary",
  props: {
    prePackagePricing: {},
    sortedSelectedAncillaries: {},
    useBreadCrumbsComposable: {}
  },
  setup(e) {
    const t = e, i = t.useBreadCrumbsComposable.isCheckout();
    return (r, c) => {
      var d;
      return (d = r.sortedSelectedAncillaries) != null && d.length ? (V(), Tt(jx, {
        key: 0,
        id: "AncillarySection",
        "section-title": r.$t("vacvComponents.bookingsummary.labels.ancillary"),
        type: "ancillary",
        opened: !ne(i)
      }, {
        default: Qt(() => [
          it(nL, {
            ancillaries: r.sortedSelectedAncillaries,
            pricing: t.prePackagePricing
          }, null, 8, ["ancillaries", "pricing"])
        ]),
        _: 1
      }, 8, ["section-title", "opened"])) : _e("", !0);
    };
  }
}), zme = ["aria-label"], Bme = {
  id: "summary-title",
  class: "vacv-label-sm"
}, Vme = {
  key: 0,
  class: "hotel-package"
}, Ume = {
  key: 0,
  class: "type"
}, Hme = { class: "summary-section vacv-price" }, Wme = { class: "mobile-summary-sticky mobile-only" }, Zme = { class: "summary-sticky-container" }, qme = { class: "summary-sticky-total" }, jme = ["aria-expanded"], Gme = { class: "see" }, Yme = /* @__PURE__ */ E("i", {
  class: "fa-solid fa-circle-plus",
  "aria-hidden": "true"
}, null, -1), mIe = /* @__PURE__ */ at({
  __name: "BookingSummary",
  props: {
    package: {},
    prePackagePricing: {},
    hotel: {},
    itinerary: {},
    useBreadCrumbsComposable: {},
    spaType: {},
    lang: {}
  },
  setup(e) {
    Hl((N) => ({
      "181336a4": $.value
    }));
    const t = e, n = t.useBreadCrumbsComposable, i = Ud(), { ancillaries: r, hasSelectedAncillaries: c } = Nn(i), d = Ae(() => sE(r.value)), a = () => {
      f.value = !f.value;
    }, f = $e(!1), g = () => {
      f.value = !f.value;
    }, x = OE(), $ = $e(window.innerHeight + "px");
    X1(() => {
      $.value = window.innerHeight + "px";
    });
    const I = n.getComponentName(), O = Ae(
      () => (n.isCheckout(I) || n.isConfirmation(I)) && c.value
    ), B = Ae(() => t.spaType === ps.HotelsSpa), H = Ae(() => {
      var N, K;
      return "packageInclusions" in (((N = t.package) == null ? void 0 : N.information) || {}) ? ((K = t.package) == null ? void 0 : K.information).packageInclusions : "";
    });
    return (N, K) => (V(), G("aside", {
      class: Et(
        f.value ? "col-xs-12 col-md-3 spa-col-aside booking-summary expanded" : "col-xs-12 col-md-3 spa-col-aside booking-summary"
      )
    }, [
      it($r, { name: "expandable" }, {
        default: Qt(() => [
          f.value || ne(x) ? (V(), G("section", {
            key: 0,
            id: "bookingSummary",
            class: Et(
              f.value ? "spa-aside-wrapper expanded" : "spa-aside-wrapper"
            ),
            "aria-live": "polite",
            "aria-labelledby": "summary-title"
          }, [
            E("button", {
              onClick: g,
              class: "btn-close mobile-only",
              "aria-label": N.$t("vacvComponents.common.buttons.close"),
              "aria-expanded": "true",
              "aria-controls": "bookingSummary"
            }, null, 8, zme),
            E("h2", Bme, Y(N.$t("vacvComponents.bookingsummary.labels.booking-summary")), 1),
            B.value ? _e("", !0) : (V(), G("div", Vme, [
              mt(Y(N.$t("vacvComponents.bookingsummary.labels.package")) + " ", 1),
              H.value ? (V(), G("div", Ume, Y(H.value), 1)) : _e("", !0)
            ])),
            er(N.$slots, "desktopNavigation"),
            it(Pme),
            B.value ? _e("", !0) : (V(), Tt(Fme, {
              key: 1,
              "pre-package": N.package,
              itinerary: N.itinerary,
              "use-bread-crumbs-composable": ne(n)
            }, null, 8, ["pre-package", "itinerary", "use-bread-crumbs-composable"])),
            ne(c) ? (V(), Tt(Rme, {
              key: 2,
              "pre-package-pricing": N.prePackagePricing,
              "sorted-selected-ancillaries": d.value,
              "use-bread-crumbs-composable": ne(n)
            }, null, 8, ["pre-package-pricing", "sorted-selected-ancillaries", "use-bread-crumbs-composable"])) : _e("", !0),
            E("div", Hme, [
              it(Hx, {
                "pre-package-pricing": N.prePackagePricing,
                extrasIncluded: O.value,
                showDOB: !0,
                spaType: N.spaType
              }, {
                priceBreakdownLines: Qt(() => [
                  er(N.$slots, "priceBreakdownLines")
                ]),
                _: 3
              }, 8, ["pre-package-pricing", "extrasIncluded", "spaType"])
            ])
          ], 2)) : _e("", !0)
        ]),
        _: 3
      }),
      E("div", Wme, [
        E("div", Zme, [
          E("div", qme, [
            er(N.$slots, "priceMobileLines"),
            E("button", {
              onClick: a,
              class: "link linklook",
              "aria-expanded": f.value ? "true" : "false",
              "aria-controls": "bookingSummary"
            }, [
              E("span", Gme, [
                Yme,
                mt(Y(N.$t("vacvComponents.pricedetails.title")), 1)
              ])
            ], 8, jme)
          ]),
          er(N.$slots, "mobileNavigation")
        ])
      ])
    ], 2));
  }
}), aL = /* @__PURE__ */ at({
  __name: "AeroplanPointsSelector",
  props: {
    milesObject: {},
    origin: {}
  },
  emits: ["aeroplan-points-selection"],
  setup(e, { emit: t }) {
    const n = e, { n: i, t: r } = ki({ useScope: "global" }), { userPoints: c, redemptionEligible: d } = K1(n.milesObject), a = zu(), { pointsToRedeem: f } = Nn(a), g = r("vacvComponents.aeroplan.points-initial-text"), x = Ae(() => {
      const I = n.milesObject.filter(
        (O) => O.points && c.value && parseInt(O.points) <= c.value
      ).map((O) => ({
        label: i(parseInt(O.points), "decimal") + " " + r("vacvComponents.aeroplan.points") + " - " + Wn(O.amtInCad, i, !0),
        value: parseInt(O.points),
        dollarValue: parseInt(O.amtInCad)
      }));
      return I.unshift({
        label: r("vacvComponents.aeroplan.points-zero"),
        value: 0,
        dollarValue: 0
      }), I.unshift({
        label: g,
        value: -1,
        dollarValue: -1
      }), I;
    }), $ = t;
    function A(I, O) {
      $("aeroplan-points-selection", O);
    }
    return (I, O) => ne(d) ? (V(), Tt(dx, {
      key: 0,
      class: "aeroplan-dropdown",
      "initial-value": ne(f),
      options: x.value,
      "selected-value": ne(f),
      "drop-down-id": "dropdown-aeroplan-points",
      outlined: !0,
      onValueChange: A
    }, null, 8, ["initial-value", "options", "selected-value"])) : _e("", !0);
  }
}), Kme = { class: "logo-points" }, Xme = ["src", "alt"], Jme = ["innerHTML"], lL = /* @__PURE__ */ at({
  __name: "AeroplanPointsLogo",
  props: {
    message: {}
  },
  setup(e) {
    const t = Xi("cdnBaseUrl");
    return (n, i) => {
      var r;
      return V(), G("div", Kme, [
        E("img", {
          src: `${ne(t)}/img/aeroplan-logo.svg`,
          width: "120",
          alt: n.$t("vacvComponents.aeroplan.aeroplan")
        }, null, 8, Xme),
        (r = n.message) != null && r.length ? (V(), G("div", {
          key: 0,
          class: "points",
          innerHTML: n.message
        }, null, 8, Jme)) : _e("", !0)
      ]);
    };
  }
}), Qme = {
  key: 0,
  class: "aeroplan-pointsbox summary"
}, eve = { class: "logobox" }, vIe = /* @__PURE__ */ at({
  __name: "AeroplanPointsSection",
  props: {
    milesObject: {},
    useBreadCrumbsComposable: {}
  },
  setup(e) {
    const {
      executeCloseUpLiftWarningModalAeroplan: t,
      executeAeroplanPointsSelection: n,
      displayUpliftWarningModalAeroplan: i,
      aeOption: r,
      componentKey: c
    } = LE(), d = e, a = d.useBreadCrumbsComposable, { redemptionEligible: f } = K1(d.milesObject), g = zu(), x = a, { setPointsToRedeem: $, setDollarValue: A } = g, { pointsToRedeem: I } = Nn(g), O = (N) => {
      if (N) {
        const K = x.getComponentName();
        N5(
          K,
          N.label
        ), A(N.dollarValue), $(parseInt(N.value));
      }
    }, B = (N) => {
      t(
        N,
        O,
        r.value,
        c
      );
    }, H = (N) => {
      n(N, O);
    };
    return (N, K) => (V(), G(cn, null, [
      ne(f) ? (V(), G("div", Qme, [
        E("div", eve, [
          it(lL, {
            message: N.$t("vacvComponents.bookingsummary.aeroplan.use-your-points-to-save")
          }, null, 8, ["message"])
        ]),
        (V(), Tt(aL, {
          "miles-object": N.milesObject,
          "initial-value": ne(I),
          onAeroplanPointsSelection: H,
          key: ne(c)
        }, null, 8, ["miles-object", "initial-value"]))
      ])) : _e("", !0),
      it(y_, {
        location: "AeroplanPointsSection",
        "display-uplift-warning-modal": ne(i),
        onOnCloseUpliftWarningModal: B
      }, null, 8, ["display-uplift-warning-modal", "onOnCloseUpliftWarningModal"])
    ], 64));
  }
}), tve = (e) => (nl("data-v-fcf3afb0"), e = e(), il(), e), nve = { class: "section travel-insurance" }, ive = { class: "bold" }, rve = /* @__PURE__ */ tve(() => /* @__PURE__ */ E("sup", null, "†", -1)), sve = /* @__PURE__ */ at({
  __name: "TravelInsuranceBillingRow",
  props: {
    nonInsuranceTotal: {},
    insuranceTotal: {}
  },
  setup(e) {
    return (t, n) => (V(), G("div", nve, [
      E("p", ive, [
        rve,
        mt(Y(t.$t("vacvComponents.payment.messages.billedSeparately")), 1)
      ]),
      E("p", null, Y(ne(Wn)(t.nonInsuranceTotal, t.$n) + " " + t.$t("vacvComponents.payment.messages.payableToVACV")), 1),
      E("p", null, Y(ne(Wn)(t.insuranceTotal, t.$n) + " " + t.$t("vacvComponents.payment.messages.payableToInsuranceCompany")), 1)
    ]));
  }
}), gIe = /* @__PURE__ */ Zn(sve, [["__scopeId", "data-v-fcf3afb0"]]), ove = { class: "subtotal subtotal--section" }, ave = { class: "bold" }, lve = { class: "right" }, cve = { class: "right" }, uve = /* @__PURE__ */ at({
  __name: "TravelInsurancePriceRow",
  props: {
    name: {},
    price: {},
    numberOfTravelers: {}
  },
  setup(e) {
    return (t, n) => (V(), G("div", ove, [
      E("p", ave, Y(t.$t("vacvComponents.payment.labels.travelInsurance") + " - " + t.name), 1),
      it(Fu, {
        title: t.$t("vacvComponents.payment.labels.insuranceXTravellers", {
          x: t.numberOfTravelers
        }),
        value: ne(Wn)(t.price, t.$n),
        class: "bdrow--amount-total"
      }, null, 8, ["title", "value"]),
      E("p", lve, Y(t.$t("vacvComponents.payment.labels.plusTaxes")), 1),
      E("p", cve, Y(t.$t("vacvComponents.payment.labels.billedSeparately")), 1)
    ]));
  }
}), yIe = /* @__PURE__ */ Zn(uve, [["__scopeId", "data-v-e2b6e704"]]), _Ie = /* @__PURE__ */ at({
  __name: "AeroplanLoginModal",
  setup(e) {
    const t = Xi("cdnBaseUrl"), i = Xi("aeLoginUrl") + "?redirect-url=" + encodeURIComponent(window.location.href), r = () => {
      window.sso ? window.sso.loginAeroplan() : window.location.assign(i), B5();
    }, c = () => {
      V5();
    }, d = () => {
      U5();
    };
    return (a, f) => (V(), Tt(lX, {
      "aeroplan-sign-in-url": "#",
      "aeroplan-logo-url": `${ne(t)}/img/aeroplan-logo.png`,
      onSignIn: f[0] || (f[0] = (g) => r()),
      onContinueAsGuest: f[1] || (f[1] = (g) => c()),
      onClose: f[2] || (f[2] = (g) => d())
    }, null, 8, ["aeroplan-logo-url"]));
  }
}), dve = {
  key: 0,
  class: "aeroplan-pointsbox"
}, pve = { class: "logobox" }, hve = ["innerHTML"], fve = { class: "dropdown" }, bIe = /* @__PURE__ */ at({
  __name: "AeroplanPointsBanner",
  props: {
    milesObject: {}
  },
  setup(e) {
    const {
      executeCloseUpLiftWarningModalAeroplan: t,
      executeAeroplanPointsSelection: n,
      displayUpliftWarningModalAeroplan: i,
      aeOption: r,
      componentKey: c
    } = LE(), d = zu(), { setPointsToRedeem: a, setDollarValue: f } = d, g = e, { redemptionEligible: x, userPoints: $ } = K1(g.milesObject), A = Ae(
      () => g.milesObject.filter(
        (N) => N.points && $.value && parseInt(N.points) <= $.value
      )
    ), I = Ae(
      () => A.value[A.value.length - 1]
    ), O = (N) => {
      N && (f(N.dollarValue), a(parseInt(N.value)));
    }, B = (N) => {
      t(
        N,
        O,
        r.value,
        c
      );
    }, H = async (N) => {
      n(N, O);
    };
    return (N, K) => ne($) ? (V(), G("div", dve, [
      E("div", pve, [
        it(lL, {
          message: N.$t("vacvComponents.payment.messages.aeroplan-you-have-x-points", {
            points: N.$n(ne($), "decimal")
          })
        }, null, 8, ["message"]),
        ne(x) ? (V(), G("div", {
          key: 0,
          class: "maxpoints",
          innerHTML: N.$t(
            "vacvComponents.payment.messages.aeroplan-you-can-redeem-x-to-save-y",
            {
              points: N.$n(parseInt(I.value.points), "decimal"),
              dollars: N.$n(
                parseInt(I.value.amtInCad),
                "currency"
              ).replace("CA", "")
            }
          )
        }, null, 8, hve)) : _e("", !0)
      ]),
      E("div", fve, [
        (V(), Tt(aL, {
          "miles-object": N.milesObject,
          onAeroplanPointsSelection: H,
          key: ne(c)
        }, null, 8, ["miles-object"]))
      ]),
      it(y_, {
        location: "AeroplanPoints",
        "display-uplift-warning-modal": ne(i),
        onOnCloseUpliftWarningModal: B
      }, null, 8, ["display-uplift-warning-modal"])
    ])) : _e("", !0);
  }
}), mve = { class: "hotel-accordion" }, vve = ["aria-label", "aria-controls"], gve = { class: "accordion-title details" }, yve = ["id"], _ve = { class: "accordion-content" }, bve = ["innerHTML"], wve = /* @__PURE__ */ at({
  __name: "PreferredPrivilegesAccordion",
  props: {
    position: { default: 0 },
    room: {},
    hotel: {}
  },
  setup(e, { emit: t }) {
    const n = e, i = t;
    return (r, c) => (V(), Tt(jh, {
      id: "preferredPrivilegesAccordion-" + n.position,
      className: "room-details",
      role: "region",
      "aria-live": "polite",
      "aria-labelledby": "preferredPrivilegesAccordion-title-" + n.position
    }, {
      default: Qt(() => {
        var d, a, f, g, x, $;
        return [
          E("div", mve, [
            E("button", {
              onClick: c[0] || (c[0] = (A) => i("show-hide")),
              class: "btn-close",
              "aria-label": r.$t("vacvComponents.common.buttons.close"),
              "aria-expanded": "true",
              "aria-controls": "preferredPrivilegesAccordion-" + n.position
            }, null, 8, vve),
            E("div", gve, [
              E("div", {
                id: "preferredPrivilegesAccordion-title-" + n.position,
                class: "vacv-label-sm"
              }, Y(((f = (a = (d = r.hotel) == null ? void 0 : d.inclusions) == null ? void 0 : a.preferredPrivilegesInclusions) == null ? void 0 : f.title) ?? ""), 9, yve)
            ]),
            E("div", _ve, [
              E("div", {
                class: "details-2col special-list vacv-editor",
                innerHTML: (($ = (x = (g = r.hotel) == null ? void 0 : g.inclusions) == null ? void 0 : x.preferredPrivilegesInclusions) == null ? void 0 : $.preferedPrivileges) ?? ""
              }, null, 8, bve)
            ])
          ])
        ];
      }),
      _: 1
    }, 8, ["id", "aria-labelledby"]));
  }
}), xve = { class: "hotel-accordion" }, $ve = ["aria-label", "aria-controls"], Cve = { class: "accordion-title details" }, kve = ["id"], Sve = {
  key: 0,
  class: "accordion-content"
}, Tve = { class: "details" }, Ive = { class: "h4style" }, Ave = ["id"], Eve = /* @__PURE__ */ at({
  __name: "InclusionsAccordion",
  props: {
    position: { default: 0 },
    hotel: {},
    pack: {},
    room: {}
  },
  setup(e, { emit: t }) {
    const n = e, i = t, r = Ae(() => {
      var a;
      const d = n.room.mealPlanCode;
      return d && ((a = n.hotel.inclusions) != null && a.mealPlanInclusions) ? n.hotel.inclusions.mealPlanInclusions[d] : null;
    }), c = Ae(
      () => {
        var d, a;
        return (a = (d = r.value) == null ? void 0 : d.details) != null && a.length ? r.value.details.filter((f) => !!f) : [];
      }
    );
    return (d, a) => r.value ? (V(), Tt(jh, {
      key: 0,
      id: "inclusionsAccordion-" + n.position,
      "data-test": "pdp-inclusions-accordion",
      className: "room-details",
      role: "region",
      "aria-live": "polite",
      "aria-labelledby": "inclusionsAccordion-title-" + n.position
    }, {
      default: Qt(() => [
        E("div", xve, [
          E("button", {
            onClick: a[0] || (a[0] = (f) => i("show-hide")),
            class: "btn-close",
            "aria-label": d.$t("vacvComponents.common.buttons.close"),
            "aria-expanded": "true",
            "aria-controls": "inclusionsAccordion-" + n.position
          }, null, 8, $ve),
          E("div", Cve, [
            E("div", {
              id: "inclusionsAccordion-title-" + n.position,
              class: "vacv-label-sm"
            }, Y(d.$t("vacvComponents.pdp.labels.hotel.inclusions.title")), 9, kve)
          ]),
          c.value.length ? (V(), G("div", Sve, [
            E("div", Tve, [
              E("div", Ive, Y(r.value.name), 1),
              E("ul", {
                class: Et(
                  c.value.length > 1 ? "spa-list special-list details-3col" : "spa-list special-list details-1col"
                )
              }, [
                (V(!0), G(cn, null, Pn(c.value, (f, g) => (V(), G("li", {
                  key: g,
                  id: "pdp-hotel-inclusion-item-" + g
                }, Y(f), 9, Ave))), 128))
              ], 2)
            ])
          ])) : _e("", !0)
        ])
      ]),
      _: 1
    }, 8, ["id", "aria-labelledby"])) : _e("", !0);
  }
}), Pve = { class: "hotel-accordion" }, Mve = ["aria-label", "aria-controls"], Dve = { class: "accordion-title details" }, Lve = ["id"], Ove = { class: "accordion-content" }, Nve = {
  key: 0,
  class: "details"
}, Fve = {
  key: 0,
  class: "details-section"
}, Rve = { class: "spa-list special-list details-3col" }, zve = {
  key: 1,
  class: "details-section"
}, Bve = { class: "spa-list special-list details-3col" }, Vve = {
  key: 2,
  class: "details-section"
}, Uve = { class: "spa-list special-list details-3col" }, Hve = {
  key: 1,
  class: "details-wide"
}, Wve = {
  key: 0,
  class: "item"
}, Zve = { class: "title" }, qve = { class: "text" }, jve = {
  key: 0,
  class: "text"
}, Gve = {
  key: 1,
  class: "item"
}, Yve = { class: "title" }, Kve = { class: "text" }, Xve = /* @__PURE__ */ E("sup", null, "2", -1), Jve = /* @__PURE__ */ at({
  __name: "RoomDetailsAccordion",
  props: {
    position: { default: 0 },
    room: {}
  },
  setup(e, { emit: t }) {
    const n = e, i = t, r = Ae(() => {
      var f, g;
      return (g = (f = n.room.roomDetails) == null ? void 0 : f.descriptions) != null && g.length ? n.room.roomDetails.descriptions.filter((x) => x !== null && x !== "") : [];
    }), c = Ae(() => {
      var f, g;
      return (g = (f = n.room.roomDetails) == null ? void 0 : f.services) != null && g.length ? n.room.roomDetails.services.filter((x) => x !== null && x !== "") : [];
    }), d = Ae(() => {
      var f, g;
      return ((g = (f = n.room.roomDetails) == null ? void 0 : f.facilities) == null ? void 0 : g.filter((x) => x)) || [];
    }), a = Ae(() => n.room.roomDimensionInSquareMeters && Math.ceil(parseInt(n.room.roomDimensionInSquareMeters, 10)));
    return (f, g) => f.room ? (V(), Tt(jh, {
      key: 0,
      id: "roomDetailsAccordion-" + n.position,
      className: "room-details",
      role: "region",
      "aria-live": "polite",
      "aria-labelledby": "roomDetailsAccordion-title-" + n.position
    }, {
      default: Qt(() => [
        E("div", Pve, [
          E("button", {
            onClick: g[0] || (g[0] = (x) => i("show-hide")),
            class: "btn-close",
            "aria-label": f.$t("vacvComponents.common.buttons.close"),
            "aria-expanded": "true",
            "aria-controls": "roomDetailsAccordion-" + n.position
          }, null, 8, Mve),
          E("div", Dve, [
            E("div", {
              id: "roomDetailsAccordion-title-" + n.position,
              class: "vacv-label-sm"
            }, Y(f.$t("vacvComponents.pdp.labels.roomDetails")), 9, Lve)
          ]),
          E("div", Ove, [
            f.room.roomDetails !== null ? (V(), G("div", Nve, [
              r.value.length ? (V(), G("div", Fve, [
                E("h4", null, Y(f.$t("vacvComponents.pdp.labels.roomDescription")), 1),
                E("ul", Rve, [
                  (V(!0), G(cn, null, Pn(r.value, (x, $) => (V(), G("li", {
                    key: `${x}-${$}`
                  }, Y(x), 1))), 128))
                ])
              ])) : _e("", !0),
              c.value.length ? (V(), G("div", zve, [
                E("h4", null, Y(f.$t("vacvComponents.pdp.labels.roomService")), 1),
                E("ul", Bve, [
                  (V(!0), G(cn, null, Pn(c.value, (x, $) => (V(), G("li", {
                    key: `${x}-${$}`
                  }, Y(x), 1))), 128))
                ])
              ])) : _e("", !0),
              d.value.length ? (V(), G("div", Vve, [
                E("h4", null, Y(f.$t("vacvComponents.pdp.labels.roomFacilities")), 1),
                E("ul", Uve, [
                  (V(!0), G(cn, null, Pn(d.value, (x, $) => (V(), G("li", {
                    key: `${x}-${$}`
                  }, Y(x), 1))), 128))
                ])
              ])) : _e("", !0)
            ])) : _e("", !0),
            f.room.occupancyDetails || a.value ? (V(), G("div", Hve, [
              f.room.occupancyDetails ? (V(), G("div", Wve, [
                E("span", Zve, Y(f.$t("vacvComponents.pdp.labels.occupancy")) + ": ", 1),
                E("span", qve, Y(f.room.occupancyDetails), 1),
                f.room.maxOccupancy ? (V(), G("span", jve, " (" + Y(f.$t("vacvComponents.pdp.labels.maximumOccupancy", {
                  count: f.room.maxOccupancy
                })) + ")", 1)) : _e("", !0)
              ])) : _e("", !0),
              a.value ? (V(), G("div", Gve, [
                E("span", Yve, Y(f.$t("vacvComponents.pdp.labels.roomDimensions")) + ": ", 1),
                E("span", Kve, [
                  mt(Y(a.value) + " m", 1),
                  Xve
                ])
              ])) : _e("", !0)
            ])) : _e("", !0)
          ])
        ])
      ]),
      _: 1
    }, 8, ["id", "aria-labelledby"])) : _e("", !0);
  }
}), Qve = {
  key: 0,
  class: "item-gallery"
}, ege = { class: "item-content" }, tge = { class: "item-content-left" }, nge = { class: "room-name" }, ige = {
  key: 2,
  class: "room-view"
}, rge = { class: "room-beds" }, sge = {
  key: 3,
  class: "room-amenities"
}, oge = { key: 0 }, age = /* @__PURE__ */ E("i", {
  class: "fa-solid fa-wifi",
  "aria-hidden": "true"
}, null, -1), lge = { key: 1 }, cge = /* @__PURE__ */ E("i", {
  class: "fa-solid fa-tv",
  "aria-hidden": "true"
}, null, -1), uge = { key: 2 }, dge = /* @__PURE__ */ E("i", {
  class: "fa-regular fa-snowflake",
  "aria-hidden": "true"
}, null, -1), pge = {
  key: 4,
  class: "multiple-airports"
}, hge = /* @__PURE__ */ E("i", {
  class: "fa-solid fa-plane",
  "aria-hidden": "true"
}, null, -1), fge = { class: "sr-only" }, mge = ["innerHTML"], vge = { class: "desktop-only links-wrapper" }, gge = ["aria-expanded", "aria-controls"], yge = /* @__PURE__ */ E("i", { class: "fa-solid fa-bell-concierge" }, null, -1), _ge = ["aria-expanded", "aria-controls"], bge = /* @__PURE__ */ E("i", {
  class: "fa-solid fa-bed-front",
  "aria-hidden": "true"
}, null, -1), wge = ["aria-expanded", "aria-controls"], xge = /* @__PURE__ */ E("i", {
  class: "fa-solid fa-award",
  "aria-hidden": "true"
}, null, -1), $ge = { class: "item-content-right" }, Cge = { class: "price-right" }, kge = { class: "hotel-select" }, Sge = { key: 0 }, Tge = /* @__PURE__ */ E("i", {
  class: "fa-solid fa-check",
  "aria-hidden": "true"
}, null, -1), Ige = { key: 1 }, Age = { class: "mobile-only links-wrapper" }, Ege = ["aria-expanded", "aria-controls"], Pge = /* @__PURE__ */ E("i", { class: "fa-solid fa-bell-concierge" }, null, -1), Mge = ["aria-expanded", "aria-controls"], Dge = /* @__PURE__ */ E("i", {
  class: "fa-solid fa-bed-front",
  "aria-hidden": "true"
}, null, -1), Lge = ["aria-expanded", "aria-controls"], Oge = /* @__PURE__ */ E("i", {
  class: "fa-solid fa-award",
  "aria-hidden": "true"
}, null, -1), wIe = /* @__PURE__ */ at({
  __name: "RoomsListItem",
  props: {
    position: {},
    pack: {},
    hotel: {},
    room: {},
    hasMultipleAirports: { type: Boolean },
    itinerary: {},
    localisedPromo: {},
    defaultPrice: {},
    trigger: {},
    savingsThreshold: {},
    wasPriceTooltipEnabled: { type: Boolean },
    aeroplanPoints: {},
    aeroplanDollarValue: {},
    total: {},
    subTotal: {},
    spaType: {}
  },
  setup(e, { expose: t }) {
    var We, Ge, et, ft;
    const n = e, i = Xi("selectedRoomIndex"), r = Xi("onSelectRoom"), c = (De) => De.paxType === "A", d = Ae(() => {
      var gt, qe, rt, Le;
      const De = n.defaultPrice || 0;
      if (n.spaType === ps.HotelsSpa) {
        const Je = ((gt = n.pack.pricing) == null ? void 0 : gt.perNightWithTax) || 0;
        return Math.abs(De - Je);
      }
      const Ke = ((Le = (rt = (qe = n.pack.pricing) == null ? void 0 : qe.perPaxType) == null ? void 0 : rt.find(c)) == null ? void 0 : Le.total) || 0;
      return Math.abs(De - Ke);
    }), a = Ae(
      () => {
        var De, Ke, gt;
        return (gt = (Ke = (De = n.pack.pricing) == null ? void 0 : De.perPaxType) == null ? void 0 : Ke.find(c)) == null ? void 0 : gt.total;
      }
    ), f = Ae(
      () => {
        var De;
        return (De = n.pack.pricing) == null ? void 0 : De.perNightWithTax;
      }
    ), g = Ae(() => n.defaultPrice !== void 0 && n.defaultPrice > 0 ? d.value : n.spaType === ps.HotelsSpa ? f.value : a.value), x = Ae(() => n.defaultPrice !== void 0 && n.defaultPrice > 0), $ = (De) => {
      De && (r(n.position, De), Q5(n.position, n.trigger, d.value));
    }, A = $e(!1), I = $e(!1), O = $e(!1), B = Ae(() => {
      var De, Ke;
      return (Ke = (De = n.hotel.inclusions) == null ? void 0 : De.preferredPrivilegesInclusions) == null ? void 0 : Ke.linkName;
    }), H = (Ge = (We = n.room) == null ? void 0 : We.roomDetails) == null ? void 0 : Ge.images, N = !!((et = H == null ? void 0 : H.images) != null && et.length), K = Ae(() => (H == null ? void 0 : H.images) ?? []), U = Ae(() => H == null ? void 0 : H.sizes), q = Ae(() => H == null ? void 0 : H.variations), ee = () => {
      A.value = !A.value, A.value && (Rb(
        "Room Details",
        n.room.mealPlanName ?? "",
        n.hotel.name ?? ""
      ), I.value = !1, O.value = !1);
    }, te = () => {
      I.value = !I.value, I.value && (Rb(
        "Inclusions",
        n.room.mealPlanName ?? "",
        n.hotel.name ?? ""
      ), A.value = !1, O.value = !1);
    }, ae = () => {
      O.value = !O.value, O.value && (Rb(
        B.value ?? "",
        n.room.mealPlanName ?? "",
        n.hotel.name ?? ""
      ), A.value = !1, I.value = !1);
    }, oe = Ae(() => {
      var gt, qe, rt, Le;
      const De = ((gt = n.room) == null ? void 0 : gt.mealPlanCode) || "", Ke = (Le = (rt = (qe = n.hotel) == null ? void 0 : qe.inclusions) == null ? void 0 : rt.mealPlanInclusions) == null ? void 0 : Le[De];
      return !!(Ke != null && Ke.details && (Ke != null && Ke.name));
    }), de = Ae(() => {
      var De, Ke, gt;
      return !!((De = n.room) != null && De.preferredPrivileges) && !!((gt = (Ke = n.hotel) == null ? void 0 : Ke.inclusions) != null && gt.preferredPrivilegesInclusions);
    }), me = () => {
      n != null && n.hotel.name && ia("Was Price", n.hotel.name);
    }, ve = ((ft = n.pack.information) == null ? void 0 : ft.refundable) ?? !0, re = Ae(() => {
      var De, Ke;
      return (Ke = (De = n == null ? void 0 : n.itinerary) == null ? void 0 : De.segments) == null ? void 0 : Ke.filter((gt) => gt.bound === "O").map((gt) => gt.destinationName).pop();
    }), le = Ae(() => {
      var De;
      return (De = n == null ? void 0 : n.room) != null && De.mealPlanName ? " - " + n.room.mealPlanName : "";
    }), pe = Ae(() => n.spaType === ps.HotelsSpa), Ne = Ae(() => {
      var Ke, gt, qe;
      const De = n.room.roomDetails;
      return !!((Ke = De == null ? void 0 : De.descriptions) != null && Ke.length || (gt = De == null ? void 0 : De.services) != null && gt.length || (qe = De == null ? void 0 : De.facilities) != null && qe.length || n.room.roomDimensionInSquareMeters);
    });
    return t({
      wasPriceClick: me
    }), (De, Ke) => {
      var gt;
      return De.room ? (V(), G("div", {
        key: 0,
        class: Et(["hotel-item-wrapper", De.position == ne(i) ? " selected" : ""])
      }, [
        E("div", {
          class: Et(["hotel-item", { "has-item-gallery": N }])
        }, [
          N ? (V(), G("div", Qve, [
            it(Ox, {
              class: "carousel-small",
              images: K.value,
              sizes: U.value,
              hotelName: De.hotel.name,
              "available-variations": q.value,
              "display-size": "medium",
              "display-variation": "tabletLandscape"
            }, null, 8, ["images", "sizes", "hotelName", "available-variations"])
          ])) : _e("", !0),
          E("div", ege, [
            E("div", tge, [
              De.trigger ? (V(), Tt(sL, {
                key: 0,
                trigger: De.trigger,
                appliedTo: "room",
                class: "psytrigger vacv-tooltip"
              }, null, 8, ["trigger"])) : _e("", !0),
              De.localisedPromo ? (V(), Tt(eP, {
                key: 1,
                class: "aeroplanpoints",
                badge: De.localisedPromo.Badge,
                "modal-title": De.$t("vacvComponents.plpList.aeroplanpointsTitle"),
                "modal-text": De.localisedPromo.Terms,
                origin: "pdpAeroplan"
              }, null, 8, ["badge", "modal-title", "modal-text"])) : _e("", !0),
              E("h3", nge, Y(De.room.name) + Y(le.value), 1),
              De.room.view !== "" ? (V(), G("div", ige, Y(De.room.view), 1)) : _e("", !0),
              E("div", rge, Y(De.room.bed), 1),
              De.room.wifi === !0 || De.room.television === !0 || De.room.airConditioning === !0 ? (V(), G("ul", sge, [
                De.room.wifi === !0 ? (V(), G("li", oge, [
                  age,
                  mt("Wifi ")
                ])) : _e("", !0),
                De.room.television === !0 ? (V(), G("li", lge, [
                  cge,
                  mt("TV ")
                ])) : _e("", !0),
                De.room.airConditioning === !0 ? (V(), G("li", uge, [
                  dge,
                  mt("AC ")
                ])) : _e("", !0)
              ])) : _e("", !0),
              De.hasMultipleAirports && re.value && !pe.value ? (V(), G("div", pge, [
                hge,
                E("span", fge, Y(De.$t("vacvComponents.pdp.access.plane-icon")), 1),
                E("span", {
                  innerHTML: De.$t("vacvComponents.pdp.messages.multiple-airport-destination", {
                    name: re.value,
                    iata: (gt = De.pack.information) == null ? void 0 : gt.destination
                  })
                }, null, 8, mge)
              ])) : _e("", !0),
              E("div", vge, [
                oe.value ? (V(), G("button", {
                  key: 0,
                  onClick: te,
                  class: "inclusions-link hotel-link-icon link linklook",
                  "aria-expanded": I.value,
                  "aria-controls": "inclusionsAccordion-" + De.position
                }, [
                  yge,
                  mt(Y(De.$t("vacvComponents.pdp.labels.inclusionsButton")), 1)
                ], 8, gge)) : _e("", !0),
                Ne.value ? (V(), G("button", {
                  key: 1,
                  onClick: ee,
                  class: "room-details-link hotel-link-icon link linklook",
                  "aria-expanded": A.value,
                  "aria-controls": "roomDetailsAccordion-" + De.position
                }, [
                  bge,
                  mt(Y(De.$t("vacvComponents.pdp.labels.roomDetails")), 1)
                ], 8, _ge)) : _e("", !0),
                de.value ? (V(), G("button", {
                  key: 2,
                  onClick: ae,
                  class: "preferred-privileges-link hotel-link-icon link linklook",
                  "aria-expanded": O.value,
                  "aria-controls": "preferredPrivilegesAccordion-" + De.position
                }, [
                  xge,
                  mt(Y(B.value), 1)
                ], 8, wge)) : _e("", !0)
              ])
            ]),
            E("div", $ge, [
              De.pack.pricing ? (V(), Tt(JD, {
                key: 0,
                "pre-package-pricing": De.pack.pricing,
                "aeroplan-points": De.aeroplanPoints,
                price: g.value || 0,
                total: De.total,
                "show-difference": x.value,
                wasPriceTooltipEnabled: De.wasPriceTooltipEnabled,
                savingsThreshold: De.savingsThreshold,
                spaType: De.spaType,
                onWasPriceClick: me
              }, {
                priceBreakdownLines: Qt(() => [
                  it(XD, { "sub-total": De.subTotal }, null, 8, ["sub-total"]),
                  it(QD, {
                    "dollar-value": De.aeroplanDollarValue,
                    "points-to-redeem": De.aeroplanPoints.amountOfPoints
                  }, null, 8, ["dollar-value", "points-to-redeem"]),
                  it(Zx, {
                    "price-total": De.total,
                    modifier: "popover",
                    "is-section": "",
                    "is-refundable": ne(ve)
                  }, null, 8, ["price-total", "is-refundable"])
                ]),
                _: 1
              }, 8, ["pre-package-pricing", "aeroplan-points", "price", "total", "show-difference", "wasPriceTooltipEnabled", "savingsThreshold", "spaType"])) : _e("", !0),
              E("div", Cge, [
                ne(ve) ? _e("", !0) : (V(), Tt(Wx, { key: 0 })),
                E("div", kge, [
                  E("button", {
                    class: Et(["vacv-btn-secondary", { active: De.position == ne(i) }]),
                    onClick: Ke[0] || (Ke[0] = (qe) => $(De.pack.id))
                  }, [
                    De.position == ne(i) ? (V(), G("span", Sge, [
                      Tge,
                      mt(Y(De.$t("vacvComponents.common.buttons.selected")), 1)
                    ])) : (V(), G("span", Ige, Y(De.$t("vacvComponents.common.buttons.select")), 1))
                  ], 2)
                ])
              ])
            ]),
            E("div", Age, [
              oe.value ? (V(), G("button", {
                key: 0,
                onClick: te,
                class: "inclusions-link hotel-link-icon link linklook",
                "aria-expanded": I.value,
                "aria-controls": "inclusionsAccordion-" + De.position
              }, [
                Pge,
                mt(Y(De.$t("vacvComponents.pdp.labels.inclusionsButton")), 1)
              ], 8, Ege)) : _e("", !0),
              Ne.value ? (V(), G("button", {
                key: 1,
                onClick: ee,
                class: "room-details-link hotel-link-icon link linklook",
                "aria-expanded": A.value,
                "aria-controls": "roomDetailsAccordion-" + De.position
              }, [
                Dge,
                mt(Y(De.$t("vacvComponents.pdp.labels.roomDetails")), 1)
              ], 8, Mge)) : _e("", !0),
              de.value ? (V(), G("button", {
                key: 2,
                onClick: ae,
                class: "preferred-privileges-link hotel-link-icon link linklook",
                "aria-expanded": O.value,
                "aria-controls": "preferredPrivilegesAccordion-" + De.position
              }, [
                Oge,
                mt(Y(B.value), 1)
              ], 8, Lge)) : _e("", !0)
            ])
          ])
        ], 2),
        it($r, { name: "collapsible" }, {
          default: Qt(() => [
            I.value ? (V(), Tt(Eve, {
              key: 0,
              id: "inclusionsAccordion-" + De.position,
              position: De.position,
              onShowHide: te,
              hotel: De.hotel,
              pack: De.pack,
              room: De.room
            }, null, 8, ["id", "position", "hotel", "pack", "room"])) : _e("", !0)
          ]),
          _: 1
        }),
        it($r, { name: "collapsible" }, {
          default: Qt(() => [
            A.value && Ne.value ? (V(), Tt(Jve, {
              key: 0,
              id: "roomDetailsAccordion-" + De.position,
              position: De.position,
              onShowHide: ee,
              room: De.room
            }, null, 8, ["id", "position", "room"])) : _e("", !0)
          ]),
          _: 1
        }),
        it($r, { name: "collapsible" }, {
          default: Qt(() => [
            O.value ? (V(), Tt(wve, {
              key: 0,
              id: "preferredPrivilegesAccordion-" + De.position,
              position: De.position,
              onShowHide: ae,
              room: De.room,
              hotel: De.hotel
            }, null, 8, ["id", "position", "room", "hotel"])) : _e("", !0)
          ]),
          _: 1
        })
      ], 2)) : _e("", !0);
    };
  }
}), Nge = ["title"], Fge = /* @__PURE__ */ E("i", {
  class: "fa-solid fa-chevron-up",
  "aria-hidden": "true"
}, null, -1), Rge = [
  Fge
], xIe = /* @__PURE__ */ at({
  __name: "BackToTopButton",
  setup(e) {
    const t = () => {
      t6(), window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    };
    return (n, i) => (V(), G("button", {
      class: "vacv-btn-backtotop",
      title: n.$t("vacvComponents.common.buttons.backToTop"),
      onClick: zi(t, ["prevent"])
    }, Rge, 8, Nge));
  }
}), zge = { class: "showmore" }, Bge = { class: "count" }, Vge = /* @__PURE__ */ at({
  __name: "ShowMoreResults",
  props: {
    end: {},
    total: {},
    loading: { type: Boolean },
    showingTextLabel: {},
    buttonClass: { default: "vacv-btn-secondary" },
    buttonLabel: {}
  },
  emits: ["load-more"],
  setup(e, { emit: t }) {
    const n = e, i = t, r = Ae(() => n.showingTextLabel || "vacvComponents.showmoreresults.labels.showingresultsmessage");
    function c() {
      i("load-more");
    }
    return (d, a) => (V(), G("div", zge, [
      E("div", Bge, Y(d.$t(r.value, {
        end: n.end,
        total: n.total
      })), 1),
      d.end < d.total ? (V(), G("button", {
        key: 0,
        class: Et(["showmore__button", d.buttonClass]),
        onClick: c,
        "data-test": "load-more"
      }, Y(n.loading ? d.$t("vacvComponents.common.generic.loading") : n.buttonLabel ? n.buttonLabel : d.$t("vacvComponents.showmoreresults.labels.moreresultsCTA")), 3)) : _e("", !0)
    ]));
  }
}), cL = /* @__PURE__ */ Zn(Vge, [["__scopeId", "data-v-5e568bab"]]), Uge = {
  class: "sv-search-error",
  "data-test": "no-flights"
}, Hge = { class: "text" }, Wge = { class: "h1style" }, Zge = { class: "suggest" }, $Ie = /* @__PURE__ */ at({
  __name: "NoFlights",
  props: {
    gotoUrl: {}
  },
  setup(e) {
    return (t, n) => (V(), G("div", Uge, [
      E("div", Hge, [
        E("h2", Wge, Y(t.$t("vacvComponents.flight.messages.noFlightsAvailable")), 1),
        E("div", Zge, Y(t.$t("vacvComponents.flight.messages.try-again")), 1),
        E("button", {
          class: "vacv-btn-primary",
          onClick: n[0] || (n[0] = (i) => t.$router.push(t.gotoUrl))
        }, Y(t.$t("vacvComponents.common.messages.go-back")), 1)
      ])
    ]));
  }
}), qge = {
  class: "sv-search-error",
  "data-test": "no-packages"
}, jge = { class: "text" }, Gge = { class: "h1style" }, Yge = { class: "suggest" }, CIe = /* @__PURE__ */ at({
  __name: "NoPackages",
  props: {
    gotoUrl: {}
  },
  setup(e) {
    return (t, n) => (V(), G("div", qge, [
      E("div", jge, [
        E("h2", Gge, Y(t.$t("vacvComponents.payment.messages.packageNotAvailable")), 1),
        E("div", Yge, Y(t.$t("vacvComponents.payment.messages.try-again")), 1),
        E("button", {
          class: "vacv-btn-primary",
          onClick: n[0] || (n[0] = (i) => t.$router.push(t.gotoUrl))
        }, Y(t.$t("vacvComponents.common.messages.go-back")), 1)
      ])
    ]));
  }
}), Kge = {
  class: "sv-search-error",
  "data-test": "no-rooms"
}, Xge = { class: "text" }, Jge = { class: "h1style" }, Qge = { class: "suggest" }, kIe = /* @__PURE__ */ at({
  __name: "NoRooms",
  props: {
    gotoUrl: {}
  },
  setup(e) {
    return (t, n) => (V(), G("div", Kge, [
      E("div", Xge, [
        E("h2", Jge, Y(t.$t("vacvComponents.pdp.messages.noRoomsAvailable")), 1),
        E("div", Qge, Y(t.$t("vacvComponents.pdp.messages.try-again")), 1),
        E("button", {
          class: "vacv-btn-primary",
          onClick: n[0] || (n[0] = (i) => t.$router.push(t.gotoUrl))
        }, Y(t.$t("vacvComponents.common.messages.go-back")), 1)
      ])
    ]));
  }
}), eye = {}, tye = {
  class: "sv-search-error",
  "data-test": "server-error"
}, nye = { class: "text" }, iye = { class: "h1style" }, rye = { class: "suggest" }, sye = { class: "special-list" };
function oye(e, t) {
  return V(), G("div", tye, [
    E("div", nye, [
      E("h2", iye, [
        E("span", null, Y(e.$t("vacvComponents.plp.messages.something-went-wrong")), 1)
      ]),
      E("div", rye, Y(e.$t("vacvComponents.plp.messages.try-again-by")), 1),
      E("ul", sye, [
        E("li", null, Y(e.$t("vacvComponents.plp.messages.click-modify")), 1),
        E("li", null, Y(e.$t("vacvComponents.plp.messages.refresh-page")), 1)
      ])
    ])
  ]);
}
const SIe = /* @__PURE__ */ Zn(eye, [["render", oye]]), aye = { class: "promocode-section" }, lye = {
  class: "h1style",
  id: "promocode-title"
}, cye = { key: 1 }, uye = {
  key: 0,
  class: "promocode-formbox"
}, dye = {
  key: 0,
  class: "formkit-messages"
}, pye = {
  class: "formkit-message",
  id: "invalid-promocode",
  "data-message-type": "validation"
}, hye = {
  key: 1,
  class: "promocode-showbox"
}, fye = { class: "promocode-discount" }, mye = { class: "code" }, vye = { class: "amount" }, gye = /* @__PURE__ */ E("i", {
  class: "fa-solid fa-circle-xmark",
  "aria-hidden": "true"
}, null, -1), TIe = /* @__PURE__ */ at({
  __name: "PromoCode",
  props: {
    prePackagePricing: {},
    envVarsConfig: {},
    spaType: {}
  },
  emits: ["update-promo-code", "showAlertErrors", "clearAlertErrors"],
  setup(e, { expose: t, emit: n }) {
    const { envVarsConfig: i, spaType: r } = e, c = Xi("SENTRY_ERROR_CODE_FILTER"), d = Xi("SHOULD_SEND_SENTRY"), a = Xi("cdnBaseUrl"), f = $e(!1), g = $e(null), x = $e(!1), $ = $e(""), A = $e(""), I = $e(!1), O = $e(!1), B = $e(), H = $e(), N = $e(!1), { upliftTokenAvailable: K } = Nn(Dd()), U = xo(), { isPaymentMethodUplift: q } = Nn(U), { toPostData: ee } = Ud(), te = ON(), ae = () => {
      O.value = !0;
    }, oe = n, de = (We, Ge) => {
      A.value = "", (r === ps.HotelsSpa && E4(We) || A4(We)) && oe("update-promo-code", We), x.value = Ge.value;
    }, me = async (We) => {
      x.value = !0;
      const Ge = We == null ? void 0 : We.promocode;
      Z5(Ge);
      const et = {
        quoteId: te == null ? void 0 : te.query.quoteId,
        ...ee(),
        promoCode: Ge,
        lang: da()
      };
      r !== ps.HotelsSpa && (et.itineraryId = te == null ? void 0 : te.query.itinId, et.step = "checkout");
      const { data: ft, loading: De, error: Ke } = r === ps.HotelsSpa ? p5(et, i) : d5(et, i);
      At(
        ft,
        (gt) => {
          de(gt, De);
        },
        {
          deep: !0
        }
      ), At(
        Ke,
        (gt) => {
          x.value = De.value, gt && (Md(
            gt,
            d,
            c
          ), I.value = !0);
        },
        {
          deep: !0
        }
      );
    };
    At(
      A,
      () => {
        I.value = !1;
      },
      { deep: !0 }
    );
    const ve = (We, Ge) => {
      We && Ge && (I.value = !1, Ge.setErrors([]), $.value = We.promocode, x.value = !0, me(We));
    }, re = async (We, Ge) => {
      B.value = We, H.value = Ge, q.value && K.value ? ae() : ve(We, Ge);
    }, le = (We) => {
      We === "OK" && (N.value ? (pe(), N.value = !1) : ve(B.value, H.value)), O.value = !1;
    }, pe = () => {
      N.value = !1, $.value = "", I.value = !1, f.value = !1, me();
    }, Ne = async () => {
      N.value = !0, q.value && K.value ? ae() : pe();
    };
    return t({
      handleApplyPromoCode: de,
      applyPromoCode: re,
      onCloseUpLiftWarningModal: le,
      execute: ve,
      promoCode: $,
      isPaymentMethodUplift: q,
      upliftTokenAvailable: K,
      displayUpliftWarningModal: O,
      promoWasRemoved: N
    }), (We, Ge) => {
      var ft, De, Ke, gt, qe, rt;
      const et = Ur("FormKit");
      return V(), G(cn, null, [
        E("section", aye, [
          E("h2", lye, Y(We.$t("vacvComponents.payment.labels.promocodeTitle")), 1),
          x.value ? (V(), Tt(iL, {
            key: 0,
            cdnBaseUrl: ne(a)
          }, null, 8, ["cdnBaseUrl"])) : (V(), G("div", cye, [
            !f.value && !((De = (ft = We.prePackagePricing) == null ? void 0 : ft.promo) != null && De.value) ? (V(), G("div", uye, [
              it(et, {
                type: "form",
                delay: 0,
                "submit-label": We.$t("vacvComponents.payment.labels.promocodeApplyButton"),
                "submit-attrs": {
                  inputClass: "$reset vacv-btn-secondary"
                },
                "form-class": "vacv-form-wrapper",
                ref_key: "form",
                ref: g,
                id: "promocode-form",
                config: { validationVisibility: "submit" },
                onSubmit: re
              }, {
                default: Qt(() => [
                  it(et, {
                    type: "text",
                    delay: 0,
                    name: "promocode",
                    id: "promocode",
                    "aria-labelledby": "promocode-title",
                    "outer-class": "vacv-input-wrapper",
                    validation: "required",
                    "validation-messages": {
                      required: We.$t("vacvComponents.payment.errors.promocodeError")
                    },
                    modelValue: A.value,
                    "onUpdate:modelValue": Ge[0] || (Ge[0] = (Le) => A.value = Le)
                  }, null, 8, ["validation-messages", "modelValue"])
                ]),
                _: 1
              }, 8, ["submit-label"]),
              I.value ? (V(), G("div", dye, [
                E("span", pye, Y(We.$t("vacvComponents.payment.errors.promocodeError")), 1)
              ])) : _e("", !0)
            ])) : (V(), G("div", hye, [
              E("div", fye, [
                E("span", mye, Y((gt = (Ke = We.prePackagePricing) == null ? void 0 : Ke.promo) == null ? void 0 : gt.code), 1),
                E("span", vye, Y(We.$t("vacvComponents.payment.messages.promocodeDiscount", {
                  discount: ne(Wn)((rt = (qe = We.prePackagePricing) == null ? void 0 : qe.promo) == null ? void 0 : rt.value, We.$n)
                })), 1)
              ]),
              E("button", {
                onClick: Ne,
                id: "remove-promocode"
              }, [
                gye,
                mt(Y(We.$t("vacvComponents.payment.labels.promocodeRemoveButton")), 1)
              ])
            ]))
          ]))
        ]),
        it(y_, {
          location: "PromoCode",
          "display-uplift-warning-modal": O.value,
          onOnCloseUpliftWarningModal: le
        }, null, 8, ["display-uplift-warning-modal"])
      ], 64);
    };
  }
}), yye = { class: "title-wrapper" }, _ye = { class: "ancillary-subtitle h1style" }, bye = ["aria-expanded", "aria-controls"], wye = { class: "toggletext" }, xye = { class: "sr-only" }, $ye = {
  key: 0,
  class: "note"
}, Cye = ["id"], Xv = /* @__PURE__ */ at({
  __name: "CollapsibleSection",
  props: {
    title: {},
    alt: {},
    collapsed: { type: Boolean, default: !1 },
    groupName: {},
    alwaysRendered: { type: Boolean }
  },
  setup(e, { expose: t }) {
    const n = e, i = $e(!1), r = $e("0px"), c = $e();
    At(c, async (a) => {
      a != null && a.scrollHeight && (r.value = a.scrollHeight + "px");
    });
    const d = () => {
      i.value = !i.value, H5(
        n.groupName,
        i.value === !0 ? _w.hide : _w.show
      );
    };
    return Li(() => {
      i.value = n.collapsed;
    }), t({
      toggle: d,
      isCollapsed: i,
      scrollHeight: r,
      scrollHeightRef: c
    }), (a, f) => (V(), G("section", {
      class: "ancillary-collapsible-section",
      ref_key: "scrollHeightRef",
      ref: c
    }, [
      E("div", yye, [
        E("h2", _ye, Y(a.title), 1),
        E("button", {
          class: "link linklook",
          "aria-expanded": !i.value,
          "aria-controls": a.groupName,
          onClick: zi(d, ["stop", "prevent"])
        }, [
          E("span", wye, [
            E("i", {
              class: Et(
                "fa-solid " + (i.value ? "fa-circle-plus" : "fa-circle-minus")
              ),
              "aria-hidden": "true"
            }, null, 2),
            mt(Y(i.value ? a.$t("vacvComponents.ancillary.labels.showOptions") : a.$t("vacvComponents.ancillary.labels.hideOptions")) + " ", 1),
            E("span", xye, Y(a.title), 1)
          ])
        ], 8, bye),
        i.value ? (V(), G("div", $ye, Y(a.alt), 1)) : _e("", !0)
      ]),
      E("div", {
        class: Et([{ hidden: i.value && a.alwaysRendered }]),
        id: a.groupName
      }, [
        a.alwaysRendered || !i.value ? er(a.$slots, "default", { key: 0 }) : _e("", !0)
      ], 10, Cye)
    ], 512));
  }
}), kye = { class: "ancillary-protection-section" }, Sye = { class: "protection-wrapper" }, Tye = {
  role: "presentation",
  class: "giga-grid"
}, Iye = {
  key: 0,
  class: "grid-header-sup"
}, Aye = /* @__PURE__ */ E("i", {
  class: "fa-solid fa-thumbs-up",
  "aria-hidden": "true"
}, null, -1), Eye = /* @__PURE__ */ E("div", { class: "grid-header-pre" }, null, -1), Pye = { class: "grid-header" }, Mye = ["src", "alt"], Dye = {
  class: "grid-label",
  "aria-hidden": "true"
}, Lye = { class: "grid-value vacv-price" }, Oye = { class: "sr-only" }, Nye = { class: "amount" }, Fye = { class: "per" }, Rye = { class: "grid-label" }, zye = ["onClick", "aria-label"], Bye = /* @__PURE__ */ E("span", { class: "round-icon" }, null, -1), Vye = [
  Bye
], Uye = { class: "grid-value check" }, Hye = {
  key: 0,
  class: "fa-solid fa-check"
}, Wye = { class: "sr-only" }, Zye = /* @__PURE__ */ E("div", { class: "grid-footer-pre" }, null, -1), qye = { class: "grid-footer" }, jye = ["onClick"], Gye = { class: "add" }, Yye = { class: "sr-only" }, Kye = { class: "added" }, Xye = /* @__PURE__ */ E("i", {
  class: "fa-solid fa-check",
  "aria-hidden": "true"
}, null, -1), Jye = { class: "sr-only" }, Qye = {
  key: 0,
  class: "protection-terms"
}, e_e = ["innerHTML"], t_e = ["aria-expanded"], n_e = { class: "toggletext" }, i_e = { class: "h3style" }, r_e = ["innerHTML"], s_e = /* @__PURE__ */ at({
  __name: "TravelProtection",
  props: {
    travelProtections: {},
    ancillariesTermsAndCondition: {}
  },
  setup(e) {
    const t = e, n = Ud(), i = $e(!1), r = () => {
      i.value = !i.value;
    }, c = Ae(
      () => Object.values(t.travelProtections).sort((B, H) => B.order - H.order)
    ), d = Ae(() => {
      const B = [];
      return Object.values(t.travelProtections ?? {}).forEach((H) => {
        var N;
        (N = H.inclusions) == null || N.flatMap(
          (K) => B.push(K)
        );
      }), B;
    }), a = (B, H) => {
      var N;
      return (N = B.inclusions) == null ? void 0 : N.find((K) => K.label === H);
    }, f = () => {
      let B = "";
      return n.ancillaries.travelProtections.forEach(
        (H, N) => {
          B = B + (N > 0 ? "&" : "") + H.title;
        }
      ), B;
    }, g = (B) => {
      x(B) ? n.removeAncillary("travelProtections", B == null ? void 0 : B.id) : (n.addAncillary("travelProtections", B), FE(
        "travelProtections",
        f()
      ));
    }, x = (B) => n.ancillaries.travelProtections.some(
      (H) => H.id === B.id
    ), $ = Er({ displayed: null }), A = (B) => {
      $.displayed = d.value.find((H) => H.label === B) ?? null, O.value = !0;
    }, I = () => {
      O.value = !1;
    }, O = $e(!1);
    return (B, H) => (V(), G("section", kye, [
      E("div", Sye, [
        E("div", Tye, [
          (V(!0), G(cn, null, Pn(c.value, (N) => (V(), G("div", {
            key: N.id,
            class: Et(["grid-container", {
              selected: x(N),
              reco: N.recommended
            }])
          }, [
            N.recommended ? (V(), G("div", Iye, [
              Aye,
              mt(" " + Y(B.$t("vacvComponents.ancillary.labels.recommended")), 1)
            ])) : _e("", !0),
            Eye,
            E("div", Pye, [
              E("img", {
                src: N.icon,
                height: "16",
                alt: N.title,
                "aria-hidden": "true"
              }, null, 8, Mye)
            ]),
            E("div", Dye, Y(B.$t("vacvComponents.ancillary.labels.price")), 1),
            E("div", Lye, [
              E("span", Oye, Y(N.title) + " " + Y(B.$t("vacvComponents.ancillary.labels.price")), 1),
              E("span", Nye, " + " + Y(B.$n(
                Object.values(N.subOptions)[0].price,
                "currency"
              ).replace("CA", "")), 1),
              E("span", Fye, Y(B.$t("vacvComponents.ancillary.labels.traveller")), 1)
            ]),
            (V(!0), G(cn, null, Pn(d.value, (K) => (V(), G(cn, {
              key: K.label
            }, [
              E("div", Rye, [
                E("span", null, [
                  mt(Y(K.label) + " ", 1),
                  K.description ? (V(), G("button", {
                    key: 0,
                    onClick: zi((U) => A(K.label), ["stop", "prevent"]),
                    class: "price-popover-link",
                    tabindex: "0",
                    "aria-haspopup": "true",
                    "aria-label": `${B.$t("vacvComponents.ancillary.access.know-more-about")} ${K.label}`
                  }, Vye, 8, zye)) : _e("", !0)
                ])
              ]),
              E("div", Uye, [
                a(N, K.label) ? (V(), G("i", Hye, [
                  E("span", Wye, Y(B.$t("vacvComponents.ancillary.access.included")) + " " + Y(N.title) + ": " + Y(K.label), 1)
                ])) : _e("", !0)
              ])
            ], 64))), 128)),
            Zye,
            E("div", qye, [
              E("button", {
                class: Et(["vacv-btn-secondary", { active: x(N) }]),
                onClick: (K) => g(N)
              }, [
                E("span", Gye, [
                  mt(Y(B.$t("vacvComponents.common.buttons.add")) + " ", 1),
                  E("span", Yye, Y(N.title), 1)
                ]),
                E("span", Kye, [
                  Xye,
                  E("span", Jye, Y(N.title), 1),
                  mt(" " + Y(B.$t("vacvComponents.common.buttons.added")), 1)
                ])
              ], 10, jye)
            ])
          ], 2))), 128))
        ])
      ]),
      B.ancillariesTermsAndCondition && B.ancillariesTermsAndCondition.description && c.value.length ? (V(), G("div", Qye, [
        it($r, { name: "collapsible" }, {
          default: Qt(() => [
            i.value ? (V(), G("div", {
              key: 0,
              id: "protectionTerms",
              class: Et(["hotel-accordion-wrapper", { open: i.value }]),
              role: "region",
              "aria-live": "polite"
            }, [
              E("div", {
                class: "text",
                innerHTML: B.ancillariesTermsAndCondition.description
              }, null, 8, e_e)
            ], 2)) : _e("", !0)
          ]),
          _: 1
        }),
        E("button", {
          class: "link linklook",
          "aria-expanded": i.value,
          "aria-controls": "protectionTerms",
          onClick: H[0] || (H[0] = zi((N) => r(), ["stop", "prevent"]))
        }, [
          E("span", n_e, [
            E("i", {
              class: Et(
                "fa-solid " + (i.value ? "fa-circle-minus" : "fa-circle-plus")
              ),
              "aria-hidden": "true"
            }, null, 2),
            mt(" " + Y(i.value ? B.$t("vacvComponents.ancillary.labels.hideDetails") : B.$t("vacvComponents.ancillary.labels.terms")), 1)
          ])
        ], 8, t_e)
      ])) : _e("", !0),
      $.displayed ? (V(), Tt(rl, {
        key: 1,
        onClose: I,
        modelValue: O.value,
        "onUpdate:modelValue": H[1] || (H[1] = (N) => O.value = N),
        class: "vacv-modal modal-fullscreen vacv-modal-centered",
        id: $.displayed.label.replace(/\s/g, "")
      }, {
        default: Qt(() => [
          E("div", i_e, Y($.displayed.label), 1),
          $.displayed ? (V(), G("div", {
            key: 0,
            innerHTML: $.displayed.description
          }, null, 8, r_e)) : _e("", !0)
        ]),
        _: 1
      }, 8, ["modelValue", "id"])) : _e("", !0)
    ]));
  }
}), o_e = { class: "list-item-notes vacv-editor" }, a_e = /* @__PURE__ */ E("div", { class: "note-title" }, "Note:", -1), l_e = { class: "spa-list special-list" }, uL = /* @__PURE__ */ at({
  __name: "AncillaryListItemNotes",
  props: {
    notes: {}
  },
  setup(e) {
    return (t, n) => (V(), G("div", o_e, [
      a_e,
      E("ul", l_e, [
        (V(!0), G(cn, null, Pn(t.notes, (i, r) => (V(), G("li", { key: r }, Y(i), 1))), 128))
      ])
    ]));
  }
}), c_e = ["id", "aria-labelledby"], u_e = { class: "hotel-accordion" }, d_e = ["aria-label", "aria-controls"], p_e = { class: "accordion-title details" }, h_e = ["id"], f_e = { class: "accordion-content" }, m_e = ["innerHTML"], v_e = /* @__PURE__ */ at({
  __name: "AncillaryListItemDetails",
  props: {
    id: {},
    notes: {},
    highlights: {}
  },
  emits: ["toggleDetailsAccordion"],
  setup(e, { expose: t, emit: n }) {
    Hl((d) => ({
      bf8d9884: r.value
    }));
    const i = n, r = $e("0px"), c = $e();
    return At(c, async (d) => {
      d != null && d.scrollHeight && (r.value = d.scrollHeight + "px");
    }), t({
      scrollHeight: r,
      scrollHeightRef: c
    }), (d, a) => {
      var f;
      return V(), G("section", {
        id: d.id,
        class: "hotel-accordion-wrapper ancillary-details",
        "aria-live": "polite",
        "aria-labelledby": d.id + "-title",
        ref_key: "scrollHeightRef",
        ref: c
      }, [
        E("div", u_e, [
          E("button", {
            onClick: a[0] || (a[0] = (g) => i("toggleDetailsAccordion")),
            class: "btn-close",
            "aria-label": d.$t("vacvComponents.common.buttons.close"),
            "aria-expanded": "true",
            "aria-controls": d.id
          }, null, 8, d_e),
          E("div", p_e, [
            E("div", {
              id: d.id + "-title",
              class: "vacv-label-sm"
            }, Y(d.$t("vacvComponents.common.labels.details")), 9, h_e)
          ]),
          E("div", f_e, [
            (f = d.notes) != null && f.length ? (V(), Tt(uL, {
              key: 0,
              notes: d.notes
            }, null, 8, ["notes"])) : _e("", !0),
            E("div", {
              class: "details vacv-editor",
              innerHTML: d.highlights
            }, null, 8, m_e)
          ])
        ])
      ], 8, c_e);
    };
  }
}), g_e = /* @__PURE__ */ Zn(v_e, [["__scopeId", "data-v-ca11f716"]]), y_e = ["aria-expanded", "aria-controls"], __e = { class: "toggletext" }, b_e = /* @__PURE__ */ E("i", {
  class: "fa-solid fa-memo-circle-info",
  "aria-hidden": "true"
}, null, -1), w_e = { class: "sr-only" }, aT = /* @__PURE__ */ at({
  __name: "AncillaryListItemDetailsToggle",
  props: {
    item: {},
    wrapperClass: {},
    isVisible: { type: Boolean }
  },
  emits: ["toggleDetailsAccordion"],
  setup(e, { expose: t, emit: n }) {
    const i = n, r = () => {
      i("toggleDetailsAccordion");
    };
    return t({
      onToggleDetailsAccordion: r
    }), (c, d) => (V(), G("div", {
      class: Et(c.wrapperClass)
    }, [
      E("button", {
        class: "link linklook",
        "aria-expanded": c.isVisible,
        "aria-controls": c.item.id + "-details",
        onClick: zi(r, ["stop", "prevent"])
      }, [
        E("span", __e, [
          b_e,
          mt(Y(c.isVisible ? c.$t("vacvComponents.ancillary.labels.hideDetails") : c.$t("vacvComponents.ancillary.labels.showDetails")) + " ", 1),
          E("span", w_e, Y(c.item.title), 1)
        ])
      ], 8, y_e)
    ], 2));
  }
}), x_e = { class: "hotel-select" }, $_e = {
  key: 0,
  class: "fa-solid fa-check",
  "aria-hidden": "true"
}, C_e = { class: "sr-only" }, k_e = ["aria-expanded", "aria-controls"], S_e = {
  key: 0,
  class: "fa-solid fa-check",
  "aria-hidden": "true"
}, T_e = { class: "sr-only" }, I_e = /* @__PURE__ */ at({
  __name: "AncillaryListItemCta",
  props: {
    item: {},
    subOptions: {},
    isSelected: { type: Boolean },
    hasSubOptions: { type: Boolean },
    hasMultipleSubOptions: { type: Boolean },
    isSubOptionsDetailsVisible: { type: Boolean }
  },
  emits: ["toggleSelect", "toggleSelectSubOption", "toggleSubOptionsDetails"],
  setup(e, { expose: t, emit: n }) {
    const i = e, r = n, c = () => {
      i.hasSubOptions ? r("toggleSelectSubOption", f()) : r("toggleSelect");
    }, d = () => {
      i.isSelected ? r("toggleSelect") : r("toggleSubOptionsDetails");
    }, a = Ae(() => i.isSelected ? "vacvComponents.common.buttons.added" : i.isSubOptionsDetailsVisible ? "vacvComponents.common.buttons.hideOptions" : "vacvComponents.common.buttons.showOptions"), f = () => {
      const g = i.subOptions[0];
      return _h(g) ? Object.values(g.dates)[0].id : g.id;
    };
    return t({
      onToggleSelect: c,
      onToggleSubOptionsDetails: d,
      subOptionsButtonLabelKey: a,
      getSubOptionId: f
    }), (g, x) => (V(), G("div", x_e, [
      g.hasMultipleSubOptions ? _e("", !0) : (V(), G("button", {
        key: 0,
        class: Et(["vacv-btn-secondary", { active: g.isSelected }]),
        onClick: c
      }, [
        E("span", {
          class: Et({ add: !g.isSelected, added: g.isSelected })
        }, [
          g.isSelected ? (V(), G("i", $_e)) : _e("", !0),
          mt(" " + Y(g.isSelected ? g.$t("vacvComponents.common.buttons.added") : g.$t("vacvComponents.common.buttons.add")) + " ", 1),
          E("span", C_e, Y(g.item.title), 1)
        ], 2)
      ], 2)),
      g.hasMultipleSubOptions ? (V(), G("button", {
        key: 1,
        class: Et(["vacv-btn-secondary", { active: g.isSelected }]),
        "aria-expanded": g.isSubOptionsDetailsVisible,
        "aria-controls": g.item.id + "-sub-options",
        onClick: d
      }, [
        E("span", {
          class: Et({ add: !g.isSelected, added: g.isSelected })
        }, [
          g.isSelected ? (V(), G("i", S_e)) : _e("", !0),
          mt(" " + Y(g.$t(a.value)) + " ", 1),
          E("span", T_e, Y(g.item.title), 1)
        ], 2)
      ], 10, k_e)) : _e("", !0)
    ]));
  }
}), A_e = { class: "total-wrapper" }, E_e = { class: "price-per" }, P_e = {
  key: 0,
  class: "price-from"
}, M_e = { class: "vacv-price" }, D_e = { class: "per" }, L_e = { class: "price-taxes" }, O_e = /* @__PURE__ */ at({
  __name: "AncillaryListItemPrice",
  props: {
    subOptions: {},
    selectedSubOptionDate: {},
    hasMultipleSubOptions: { type: Boolean }
  },
  setup(e, { expose: t }) {
    const n = e, i = Ae(
      () => n.subOptions.length > 0 ? n.subOptions[0] : void 0
    ), r = Ae(() => {
      if (n.selectedSubOptionDate)
        return Wn(n.selectedSubOptionDate.price, Au.global.n);
      if (n.hasMultipleSubOptions) {
        const a = d();
        return Wn(a, Au.global.n);
      } else {
        const a = c(i.value);
        return Wn(a, Au.global.n);
      }
    }), c = (a) => {
      if (a)
        return _h(a) && a.dates ? Object.values(a.dates)[0].price : a.price;
    }, d = () => n.subOptions.map((f) => c(f)).filter((f) => f !== void 0).sort((f, g) => f - g)[0];
    return t({
      firstSubOption: i,
      price: r,
      getSubOptionPrice: c,
      getCheapestSubOptionPrice: d
    }), (a, f) => (V(), G("div", A_e, [
      E("div", E_e, [
        a.hasMultipleSubOptions && !a.selectedSubOptionDate ? (V(), G("span", P_e, Y(a.$t("vacvComponents.ancillary.labels.from")), 1)) : _e("", !0),
        E("span", M_e, "+ " + Y(r.value), 1),
        E("span", D_e, Y(a.$t("vacvComponents.ancillary.labels.perAdult")), 1)
      ]),
      E("div", L_e, Y(a.$t("vacvComponents.common.pricedetails.taxesincl")), 1)
    ]));
  }
}), N_e = { class: "total-wrapper" }, F_e = { class: "price-per" }, R_e = { class: "vacv-price" }, z_e = { class: "per" }, B_e = { class: "price-taxes" }, V_e = /* @__PURE__ */ at({
  __name: "AncillaryListItemSubOptionsPrice",
  props: {
    price: {}
  },
  setup(e, { expose: t }) {
    const n = e, i = Ae(() => Wn(n.price, Au.global.n));
    return t({
      formattedPrice: i
    }), (r, c) => (V(), G("div", N_e, [
      E("div", F_e, [
        E("span", R_e, "+ " + Y(i.value), 1),
        E("span", z_e, Y(r.$t("vacvComponents.ancillary.labels.perAdult")), 1)
      ]),
      E("div", B_e, Y(r.$t("vacvComponents.common.pricedetails.taxesincl")), 1)
    ]));
  }
}), U_e = ["id"], H_e = {
  key: 0,
  class: "fa-solid fa-check",
  "aria-hidden": "true"
}, W_e = { class: "sr-only" }, Z_e = /* @__PURE__ */ at({
  __name: "AncillaryListItemSubOptionsCta",
  props: {
    subOption: {},
    isSelected: { type: Boolean },
    groupName: {}
  },
  emits: ["toggleSelectSubOption"],
  setup(e, { expose: t, emit: n }) {
    const i = e, r = n, c = (a) => {
      r("toggleSelectSubOption", a);
    }, d = () => _h(i.subOption) ? Object.values(i.subOption.dates)[0].id : i.subOption.id;
    return t({
      onToggleSelect: c,
      getSubOptionId: d
    }), (a, f) => (V(), G("div", {
      class: "hotel-select",
      id: d()
    }, [
      E("button", {
        class: Et(["vacv-btn-secondary-sub-options", { active: a.isSelected }]),
        onClick: f[0] || (f[0] = (g) => c(d()))
      }, [
        E("span", {
          class: Et({ add: !a.isSelected, added: a.isSelected })
        }, [
          a.isSelected ? (V(), G("i", H_e)) : _e("", !0),
          mt(" " + Y(a.isSelected ? a.$t("vacvComponents.common.buttons.added") : a.$t("vacvComponents.common.buttons.add")), 1)
        ], 2),
        E("span", W_e, Y(a.subOption.title), 1)
      ], 2)
    ], 8, U_e));
  }
}), q_e = { class: "sub-options-details__item-header" }, j_e = { class: "sub-options-details__item-title" }, G_e = ["aria-label"], Y_e = /* @__PURE__ */ E("span", { class: "round-icon" }, null, -1), K_e = [
  Y_e
], X_e = ["innerHTML"], J_e = { class: "sub-options-details__item-price" }, Q_e = { class: "sub-options-details__item-cta" }, ebe = /* @__PURE__ */ at({
  __name: "AncillaryListItemSubOptionsItem",
  props: {
    subOption: {},
    groupName: {}
  },
  emits: ["toggleSelectSubOption"],
  setup(e, { expose: t, emit: n }) {
    const i = n, r = Ud(), c = $e(!1), d = ($) => _h($) ? Object.values($.dates)[0].price : $.price, a = ($) => _h($) ? Object.values($.dates)[0].id : $.id, f = ($) => {
      i("toggleSelectSubOption", $);
    }, g = () => {
      c.value = !1;
    }, x = () => {
      c.value = !0;
    };
    return t({
      getPrice: d,
      getSubOptionId: a,
      onToggleSelectSubOption: f,
      onCloseModal: g,
      displayModal: c,
      showModal: x
    }), ($, A) => (V(), G("li", {
      class: Et(["sub-options-details__item", {
        selected: ne(r).isAncillarySubOptionSelected(
          $.groupName,
          a($.subOption)
        )
      }])
    }, [
      E("div", q_e, [
        E("h4", j_e, [
          E("span", null, Y($.subOption.title), 1),
          E("button", {
            onClick: x,
            class: "price-popover-link",
            tabindex: "0",
            "aria-haspopup": "true",
            "aria-label": `${$.$t("vacvComponents.ancillary.access.know-more-about")} ${$.subOption.title}`
          }, K_e, 8, G_e),
          it(rl, {
            onClose: g,
            modelValue: c.value,
            "onUpdate:modelValue": A[0] || (A[0] = (I) => c.value = I),
            class: "vacv-modal modal-fullscreen vacv-modal-centered"
          }, {
            default: Qt(() => [
              E("div", {
                class: "vacv-editor",
                innerHTML: $.subOption.description
              }, null, 8, X_e)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      E("div", J_e, [
        it(V_e, {
          price: d($.subOption)
        }, null, 8, ["price"])
      ]),
      E("div", Q_e, [
        it(Z_e, {
          "sub-option": $.subOption,
          "is-selected": ne(r).isAncillarySubOptionSelected(
            $.groupName,
            a($.subOption)
          ),
          groupName: $.groupName,
          onToggleSelectSubOption: f
        }, null, 8, ["sub-option", "is-selected", "groupName"])
      ])
    ], 2));
  }
}), tbe = ["id", "aria-labelledby"], nbe = { class: "hotel-accordion" }, ibe = ["aria-label", "aria-controls"], rbe = { class: "accordion-title details" }, sbe = ["id"], obe = { class: "accordion-content" }, abe = { class: "sub-options-details__list" }, S0 = 10, lbe = /* @__PURE__ */ at({
  __name: "AncillaryListItemSubOptions",
  props: {
    id: {},
    notes: {},
    subOptions: {},
    groupName: {}
  },
  emits: ["toggleDetailsAccordion", "toggleSelectSubOption"],
  setup(e, { expose: t, emit: n }) {
    Hl((I) => ({
      "082732bb": a.value
    }));
    const i = e, r = n, c = $e(S0), d = da(), a = $e("0px"), f = $e();
    At(f, async (I) => {
      I != null && I.scrollHeight && (a.value = I.scrollHeight + "px");
    });
    const g = Ae(() => [...i.subOptions].sort((O, B) => {
      var ae, oe;
      const H = O.dates && Object.keys(O.dates).length > 0, N = B.dates && Object.keys(B.dates).length > 0, K = H ? Object.values(O.dates)[0].price : O.price || 0, U = N ? Object.values(B.dates)[0].price : B.price || 0, q = K - U;
      if (q !== 0)
        return q;
      const ee = ((ae = O.title) == null ? void 0 : ae.toLowerCase()) ?? "", te = ((oe = B.title) == null ? void 0 : oe.toLowerCase()) ?? "";
      return ee.localeCompare(te, d, { numeric: !0 });
    })), x = Ae(
      () => g.value.slice(0, c.value)
    ), $ = (I) => {
      r("toggleSelectSubOption", I);
    }, A = () => {
      c.value = Math.min(c.value + S0, i.subOptions.length);
    };
    return t({
      scrollHeight: a,
      scrollHeightRef: f,
      end: c,
      visibleSubOptions: x,
      onToggleSelectSubOption: $,
      loadMore: A,
      sortedSubOptions: g
    }), (I, O) => {
      var B;
      return V(), G("section", {
        id: I.id,
        class: "hotel-accordion-wrapper sub-options-details",
        "aria-live": "polite",
        "aria-labelledby": I.id + "-title",
        ref_key: "scrollHeightRef",
        ref: f
      }, [
        E("div", nbe, [
          E("button", {
            onClick: O[0] || (O[0] = (H) => r("toggleDetailsAccordion")),
            class: "btn-close",
            "aria-label": I.$t("vacvComponents.common.buttons.close"),
            "aria-expanded": "true",
            "aria-controls": I.id
          }, null, 8, ibe),
          E("div", rbe, [
            E("div", {
              id: I.id + "-title",
              class: "vacv-label-sm"
            }, Y(I.$t("vacvComponents.common.labels.selectAnOption")), 9, sbe)
          ]),
          E("div", obe, [
            (B = I.notes) != null && B.length ? (V(), Tt(uL, {
              key: 0,
              notes: I.notes
            }, null, 8, ["notes"])) : _e("", !0),
            E("ul", abe, [
              (V(!0), G(cn, null, Pn(x.value, (H) => (V(), Tt(ebe, {
                key: H.id,
                "sub-option": H,
                "group-name": I.groupName,
                onToggleSelectSubOption: $
              }, null, 8, ["sub-option", "group-name"]))), 128))
            ]),
            I.subOptions.length > S0 ? (V(), Tt(cL, {
              key: 1,
              end: c.value,
              total: I.subOptions.length,
              loading: !1,
              "button-class": "vacv-btn-secondary-sub-options",
              onLoadMore: A,
              showingTextLabel: "vacvComponents.ancillary.labels.showingOptionsResults"
            }, null, 8, ["end", "total"])) : _e("", !0)
          ])
        ])
      ], 8, tbe);
    };
  }
}), cbe = /* @__PURE__ */ Zn(lbe, [["__scopeId", "data-v-9a06c1a6"]]), ube = { class: "hotel-item" }, dbe = { class: "item-gallery" }, pbe = { class: "carousel-fallback-img" }, hbe = ["src", "alt"], fbe = { class: "item-content" }, mbe = { class: "item-content-left" }, vbe = { class: "text" }, gbe = { class: "item-content-right" }, ybe = { class: "price-left" }, _be = { class: "price-right" }, bbe = /* @__PURE__ */ at({
  __name: "AncillaryListItem",
  props: {
    item: {},
    groupName: {}
  },
  setup(e, { expose: t }) {
    const n = e, i = Ud(), r = $e(!1), c = $e(!1), d = Ae(() => n.item.id), a = Ae(() => n.groupName), f = Ae(() => i.isAncillarySelected(a.value, d.value)), g = Ae(() => Object.values(n.item.subOptions)), x = Ae(() => g.value[0] ?? {}), $ = Ae(() => n.groupName === "activities"), A = Ae(() => n.groupName === "mealPlans"), I = Ae(() => ($.value || A.value) && g.value.length > 0), O = Ae(() => I.value && g.value.length > 1), B = Ae(() => {
      if (O.value) {
        const de = i.geSubOptionTitle(n.item.id);
        return de || n.item.description;
      }
      return x.value.title;
    }), H = Ae(() => {
      if ($.value || A.value)
        return n.item.notes;
    }), N = (de) => i.getSelectedSubOption(de);
    function K(de, me) {
      me ? i.addAncillary(a.value, de, me) : i.addAncillary(a.value, de), FE(
        a.value,
        q(de, me) || "ancillary_no_product-code"
      );
    }
    const U = (de) => de.includes("-") ? de.split("-")[0] : de, q = (de, me) => {
      if (me) {
        const ve = U1(de, me);
        return (ve == null ? void 0 : ve.productCode) ?? "";
      } else
        return x.value.productCode;
    }, ee = (de) => {
      const me = de ?? d.value, ve = U(me);
      i.isAncillarySelected(a.value, ve) ? i.removeAncillary(a.value, ve) : K(n.item, de);
    }, te = (de) => {
      if (i.isAncillarySubOptionSelected(a.value, de)) {
        const me = U(de);
        i.removeAncillary(a.value, me, de);
      } else
        K(n.item, de);
    }, ae = () => {
      r.value = !r.value;
    }, oe = () => {
      W5(n.groupName, n.item.title), c.value = !c.value;
    };
    return t({
      getGroupItemId: U,
      description: B,
      isActivity: $,
      isSelected: f,
      itemId: d,
      subOptions: g,
      firstSubOption: x,
      hasActivitySubOptions: I,
      hasMultipleActivitiesSubOptions: O,
      addItemToCart: K,
      getProductCode: q,
      onToggleSelected: ee,
      onToggleSelectedSubOption: te,
      onToggleDetailsAccordion: ae,
      isDetailsAccordionVisible: r,
      onToggleSubOptionsDetailsAccordion: oe,
      isSubOptionsDetailsVisibile: c,
      notes: H
    }), (de, me) => {
      var ve, re;
      return V(), G("div", {
        class: Et(["hotel-item-wrapper", { selected: f.value }])
      }, [
        E("div", ube, [
          E("div", dbe, [
            E("div", pbe, [
              E("img", {
                src: (ve = de.item) == null ? void 0 : ve.icon,
                alt: de.$t("vacvComponents.common.messages.fallback-img")
              }, null, 8, hbe)
            ])
          ]),
          E("div", fbe, [
            E("div", mbe, [
              E("h3", null, Y((re = de.item) == null ? void 0 : re.title), 1),
              E("div", vbe, Y(B.value), 1),
              O.value ? _e("", !0) : (V(), Tt(aT, {
                key: 0,
                item: de.item,
                "wrapper-class": "desktop-only links-wrapper",
                "is-visible": r.value,
                onToggleDetailsAccordion: ae
              }, null, 8, ["item", "is-visible"]))
            ]),
            E("div", gbe, [
              E("div", ybe, [
                it(O_e, {
                  "sub-options": g.value,
                  "has-multiple-sub-options": O.value,
                  "selected-sub-option-date": N(de.item.id)
                }, null, 8, ["sub-options", "has-multiple-sub-options", "selected-sub-option-date"])
              ]),
              E("div", _be, [
                it(I_e, {
                  item: de.item,
                  "is-selected": f.value,
                  "has-sub-options": I.value,
                  "has-multiple-sub-options": O.value,
                  "is-sub-options-details-visible": c.value,
                  "sub-options": g.value,
                  onToggleSelect: ee,
                  onToggleSelectSubOption: te,
                  onToggleSubOptionsDetails: oe
                }, null, 8, ["item", "is-selected", "has-sub-options", "has-multiple-sub-options", "is-sub-options-details-visible", "sub-options"])
              ])
            ]),
            O.value ? _e("", !0) : (V(), Tt(aT, {
              key: 0,
              item: de.item,
              "wrapper-class": "mobile-only links-wrapper",
              "is-visible": r.value,
              onToggleDetailsAccordion: ae
            }, null, 8, ["item", "is-visible"]))
          ])
        ]),
        it($r, { name: "collapsible" }, {
          default: Qt(() => [
            r.value ? (V(), Tt(g_e, {
              key: 0,
              id: de.item.id + "-details",
              onToggleDetailsAccordion: ae,
              highlights: x.value.description,
              notes: H.value
            }, null, 8, ["id", "highlights", "notes"])) : _e("", !0)
          ]),
          _: 1
        }),
        it($r, { name: "collapsible" }, {
          default: Qt(() => [
            c.value ? (V(), Tt(cbe, {
              key: 0,
              id: de.item.id + "-details",
              notes: H.value,
              "sub-options": g.value,
              "group-name": a.value,
              onToggleDetailsAccordion: oe,
              onToggleSelectSubOption: te
            }, null, 8, ["id", "notes", "sub-options", "group-name"])) : _e("", !0)
          ]),
          _: 1
        })
      ], 2);
    };
  }
}), wbe = /* @__PURE__ */ Zn(bbe, [["__scopeId", "data-v-308569b4"]]), xbe = { class: "ancillary-group" }, $be = ["id"], Cbe = { class: "spa-list ancillary-list" }, kbe = ["index"], T0 = 3, I0 = /* @__PURE__ */ at({
  __name: "AncillaryGroup",
  props: {
    ancillaries: {},
    groupName: {},
    showingTextLabel: {}
  },
  setup(e) {
    const t = e, n = $e(T0), i = Ae(() => t.ancillaries), r = Ae(() => i.value.slice(0, n.value));
    function c() {
      n.value = Math.min(
        n.value + T0,
        Object.values(i.value).length
      );
    }
    return Ae(() => t.groupName === "mealPlans"), (d, a) => (V(), G("section", xbe, [
      E("div", {
        id: d.groupName,
        class: "hotel-accordion-wrapper",
        role: "region",
        "aria-live": "polite"
      }, [
        E("ul", Cbe, [
          (V(!0), G(cn, null, Pn(r.value, (f) => (V(), G("li", {
            class: "spa-list-item",
            key: f.id,
            index: f.id
          }, [
            it(wbe, {
              item: f,
              groupName: d.groupName
            }, null, 8, ["item", "groupName"])
          ], 8, kbe))), 128))
        ])
      ], 8, $be),
      i.value.length > T0 ? (V(), Tt(cL, {
        key: 0,
        end: n.value,
        total: i.value.length,
        loading: !1,
        onLoadMore: c,
        showingTextLabel: d.showingTextLabel
      }, null, 8, ["end", "total", "showingTextLabel"])) : _e("", !0)
    ]));
  }
}), Sbe = {
  class: "col-lg-9 col-xs-12 spa-col-main",
  "data-test": "ancillary-main"
}, Tbe = { class: "sr-only" }, Ibe = {
  key: 1,
  class: "ancillary-error"
}, Abe = { class: "h1style" }, IIe = /* @__PURE__ */ at({
  __name: "AncillaryMain",
  props: {
    ancillaries: {},
    ancillariesTermsAndCondition: {},
    pricing: {}
  },
  setup(e) {
    const t = e, n = Ae(
      () => {
        var f;
        return Object.values(((f = t.ancillaries) == null ? void 0 : f.travelProtections) ?? {});
      }
    ), i = Ae(
      () => {
        var f;
        return Object.values(((f = t.ancillaries) == null ? void 0 : f.privateTransfers) ?? {});
      }
    ), r = Ae(
      () => {
        var f;
        return Object.values(((f = t.ancillaries) == null ? void 0 : f.activities) ?? {});
      }
    ), c = Ae(
      () => {
        var f;
        return Object.values(((f = t.ancillaries) == null ? void 0 : f.mealPlans) ?? {});
      }
    );
    function d(f) {
      return Object.fromEntries(f.map((g) => [g.id, g]));
    }
    const a = Ae(
      () => {
        var f, g, x, $;
        return ((f = t.ancillaries) == null ? void 0 : f.privateTransfers) || ((g = t.ancillaries) == null ? void 0 : g.mealPlans) || ((x = t.ancillaries) == null ? void 0 : x.travelProtections) || (($ = t.ancillaries) == null ? void 0 : $.activities);
      }
    );
    return (f, g) => (V(), G("main", Sbe, [
      E("h1", Tbe, Y(f.$t("vacvComponents.ancillary.labels.title")), 1),
      a.value ? (V(), G(cn, { key: 0 }, [
        n.value.length ? (V(), Tt(Xv, {
          key: 0,
          title: f.$t("vacvComponents.ancillary.labels.travelProtection"),
          alt: f.$t("vacvComponents.ancillary.labels.travelprotectionNote"),
          groupName: "travelProtections"
        }, {
          default: Qt(() => [
            it(s_e, {
              travelProtections: d(n.value),
              ancillariesTermsAndCondition: f.ancillariesTermsAndCondition,
              groupName: "travelProtections"
            }, null, 8, ["travelProtections", "ancillariesTermsAndCondition"])
          ]),
          _: 1
        }, 8, ["title", "alt"])) : _e("", !0),
        i.value.length ? (V(), Tt(Xv, {
          key: 1,
          title: f.$t("vacvComponents.ancillary.labels.privateTransfer"),
          alt: f.$t("vacvComponents.ancillary.labels.privateTransferNote"),
          groupName: "privateTransfer"
        }, {
          default: Qt(() => [
            it(I0, {
              ancillaries: i.value,
              groupName: "privateTransfer"
            }, null, 8, ["ancillaries"])
          ]),
          _: 1
        }, 8, ["title", "alt"])) : _e("", !0),
        r.value.length ? (V(), Tt(Xv, {
          key: 2,
          alwaysRendered: !0,
          title: f.$t("vacvComponents.ancillary.labels.activities"),
          alt: f.$t("vacvComponents.ancillary.labels.activitiesNote"),
          groupName: "activities",
          collapsed: !1
        }, {
          default: Qt(() => [
            it(I0, {
              groupName: "activities",
              ancillaries: r.value
            }, null, 8, ["ancillaries"])
          ]),
          _: 1
        }, 8, ["title", "alt"])) : _e("", !0),
        c.value.length ? (V(), Tt(Xv, {
          key: 3,
          alwaysRendered: !0,
          title: f.$t("vacvComponents.ancillary.labels.mealPlan"),
          alt: f.$t("vacvComponents.ancillary.labels.mealPlanNote"),
          groupName: "mealPlans",
          collapsed: !1,
          class: "no-border-bottom"
        }, {
          default: Qt(() => [
            it(I0, {
              groupName: "mealPlans",
              ancillaries: c.value,
              showingTextLabel: "vacvComponents.ancillary.labels.showingMealPlanResults"
            }, null, 8, ["ancillaries"])
          ]),
          _: 1
        }, 8, ["title", "alt"])) : _e("", !0),
        it(qw)
      ], 64)) : (V(), G("div", Ibe, [
        E("h2", Abe, Y(f.$t("vacvComponents.ancillary.labels.nothingToDisplay")), 1),
        it(qw)
      ]))
    ]));
  }
}), Ebe = { class: "tp-nudge-modal-content" }, Pbe = { class: "nudge-header" }, Mbe = { class: "nudge-subtitle" }, Dbe = { class: "nudge-container" }, Lbe = {
  key: 0,
  class: "nudge-recommended"
}, Obe = /* @__PURE__ */ E("i", {
  class: "fa-solid fa-thumbs-up",
  "aria-hidden": "true"
}, null, -1), Nbe = { class: "nudge-inclusions" }, Fbe = { class: "nudge-item logo" }, Rbe = ["src"], zbe = { class: "check" }, Bbe = {
  key: 0,
  class: "fa-solid fa-check",
  "aria-hidden": "true"
}, Vbe = { class: "sr-only" }, Ube = { class: "nudge-label" }, Hbe = { class: "nudge-price-wrapper" }, Wbe = { class: "price-amount" }, Zbe = { class: "amount" }, qbe = { class: "per" }, jbe = { class: "price-total" }, Gbe = { class: "amount" }, Ybe = { class: "total-taxes" }, Kbe = { class: "nudge-actions" }, Xbe = /* @__PURE__ */ E("i", {
  class: "fa-solid fa-circle-xmark",
  "aria-hidden": "true"
}, null, -1), Jbe = /* @__PURE__ */ at({
  __name: "TravelProtectionPanel",
  props: {
    paxCount: {},
    total: {},
    travelProtection: {}
  },
  emits: ["withProtection", "withoutProtection"],
  setup(e, { emit: t }) {
    const n = e, i = t, r = Ae(
      () => n.total + Object.values(n.travelProtection.subOptions)[0].price * n.paxCount
    ), c = Ae(() => {
      var x;
      const g = [];
      return Object.values(
        (x = n.travelProtection.inclusions) == null ? void 0 : x.flatMap(
          ($) => g.push($)
        )
      ), g;
    }), d = (g, x) => {
      var $;
      return ($ = g.inclusions) == null ? void 0 : $.find((A) => A.label === x);
    }, a = (g) => {
      i("withProtection", g);
    }, f = () => {
      i("withoutProtection");
    };
    return (g, x) => {
      var $;
      return V(), G("div", Ebe, [
        E("hgroup", Pbe, [
          E("h2", null, Y(g.$t("vacvComponents.ancillary.nudge.title")), 1),
          E("div", Mbe, Y(g.$t("vacvComponents.ancillary.nudge.prompting")), 1)
        ]),
        E("div", Dbe, [
          ($ = g.travelProtection) != null && $.recommended ? (V(), G("div", Lbe, [
            Obe,
            mt(" " + Y(g.$t("vacvComponents.ancillary.labels.recommended")), 1)
          ])) : _e("", !0),
          E("div", Nbe, [
            E("div", Fbe, [
              E("img", {
                src: g.travelProtection.icon,
                height: "18",
                alt: ""
              }, null, 8, Rbe)
            ]),
            (V(!0), G(cn, null, Pn(c.value, (A) => (V(), G("div", {
              key: A.label,
              class: "nudge-item"
            }, [
              E("span", zbe, [
                d(g.travelProtection, A.label) ? (V(), G("i", Bbe, [
                  E("span", Vbe, Y(g.$t("vacvComponents.ancillary.access.included")) + " " + Y(g.travelProtection.title) + ": " + Y(A.label), 1)
                ])) : _e("", !0)
              ]),
              E("span", Ube, Y(A.label), 1)
            ]))), 128)),
            E("div", Hbe, [
              E("div", Wbe, [
                E("span", Zbe, " + " + Y(g.$n(
                  Object.values(g.travelProtection.subOptions)[0].price,
                  "currency"
                ).replace("CA", "")), 1),
                E("span", qbe, Y(g.$t("vacvComponents.ancillary.labels.perTraveller")), 1)
              ]),
              E("div", jbe, [
                E("div", Gbe, Y(g.$n(r.value, "currency").replace("CA", "")) + " " + Y(g.$t("vacvComponents.ancillary.nudge.total")), 1),
                E("div", Ybe, Y(g.$t("vacvComponents.ancillary.nudge.taxesincl")), 1)
              ])
            ])
          ]),
          E("div", Kbe, [
            E("button", {
              class: "vacv-btn-primary",
              onClick: x[0] || (x[0] = (A) => a(g.travelProtection.id))
            }, Y(g.$t("vacvComponents.ancillary.nudge.withProtection")), 1),
            E("button", {
              class: "link linklook",
              onClick: f
            }, [
              Xbe,
              mt(Y(g.$t("vacvComponents.ancillary.nudge.withoutProtection")), 1)
            ])
          ])
        ])
      ]);
    };
  }
}), AIe = /* @__PURE__ */ at({
  __name: "TravelProtectionNudge",
  props: {
    isShow: { type: Boolean },
    paxCount: {},
    total: {},
    travelProtection: {}
  },
  emits: ["addTravelProtection"],
  setup(e, { emit: t }) {
    const n = e, i = t, r = $e(n.isShow), c = () => {
      d("close");
    }, d = (a) => {
      a ? i("addTravelProtection", a) : i("addTravelProtection"), r.value = !1;
    };
    return At(
      () => n.isShow,
      (a) => {
        r.value = a;
      }
    ), (a, f) => (V(), Tt(rl, {
      onClose: c,
      modelValue: r.value,
      "onUpdate:modelValue": f[0] || (f[0] = (g) => r.value = g),
      class: "vacv-modal modal-fullscreen vacv-modal-centered tp-nudge"
    }, {
      default: Qt(() => [
        it(Jbe, {
          paxCount: a.paxCount,
          total: a.total,
          travelProtection: a.travelProtection,
          onWithProtection: d,
          onWithoutProtection: d
        }, null, 8, ["paxCount", "total", "travelProtection"])
      ]),
      _: 1
    }, 8, ["modelValue"]));
  }
});
var dL = { exports: {} };
(function(e, t) {
  (function(n, i) {
    e.exports = i();
  })(Em, function() {
    var n, i, r;
    function c(a, f) {
      if (!n)
        n = f;
      else if (!i)
        i = f;
      else {
        var g = "var sharedChunk = {}; (" + n + ")(sharedChunk); (" + i + ")(sharedChunk);", x = {};
        n(x), r = f(x), typeof window < "u" && (r.workerUrl = window.URL.createObjectURL(new Blob([g], { type: "text/javascript" })));
      }
    }
    c(["exports"], function(a) {
      function f(l) {
        return l && l.__esModule && Object.prototype.hasOwnProperty.call(l, "default") ? l.default : l;
      }
      var g = x;
      function x(l, s) {
        this.x = l, this.y = s;
      }
      x.prototype = { clone: function() {
        return new x(this.x, this.y);
      }, add: function(l) {
        return this.clone()._add(l);
      }, sub: function(l) {
        return this.clone()._sub(l);
      }, multByPoint: function(l) {
        return this.clone()._multByPoint(l);
      }, divByPoint: function(l) {
        return this.clone()._divByPoint(l);
      }, mult: function(l) {
        return this.clone()._mult(l);
      }, div: function(l) {
        return this.clone()._div(l);
      }, rotate: function(l) {
        return this.clone()._rotate(l);
      }, rotateAround: function(l, s) {
        return this.clone()._rotateAround(l, s);
      }, matMult: function(l) {
        return this.clone()._matMult(l);
      }, unit: function() {
        return this.clone()._unit();
      }, perp: function() {
        return this.clone()._perp();
      }, round: function() {
        return this.clone()._round();
      }, mag: function() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
      }, equals: function(l) {
        return this.x === l.x && this.y === l.y;
      }, dist: function(l) {
        return Math.sqrt(this.distSqr(l));
      }, distSqr: function(l) {
        var s = l.x - this.x, u = l.y - this.y;
        return s * s + u * u;
      }, angle: function() {
        return Math.atan2(this.y, this.x);
      }, angleTo: function(l) {
        return Math.atan2(this.y - l.y, this.x - l.x);
      }, angleWith: function(l) {
        return this.angleWithSep(l.x, l.y);
      }, angleWithSep: function(l, s) {
        return Math.atan2(this.x * s - this.y * l, this.x * l + this.y * s);
      }, _matMult: function(l) {
        var s = l[2] * this.x + l[3] * this.y;
        return this.x = l[0] * this.x + l[1] * this.y, this.y = s, this;
      }, _add: function(l) {
        return this.x += l.x, this.y += l.y, this;
      }, _sub: function(l) {
        return this.x -= l.x, this.y -= l.y, this;
      }, _mult: function(l) {
        return this.x *= l, this.y *= l, this;
      }, _div: function(l) {
        return this.x /= l, this.y /= l, this;
      }, _multByPoint: function(l) {
        return this.x *= l.x, this.y *= l.y, this;
      }, _divByPoint: function(l) {
        return this.x /= l.x, this.y /= l.y, this;
      }, _unit: function() {
        return this._div(this.mag()), this;
      }, _perp: function() {
        var l = this.y;
        return this.y = this.x, this.x = -l, this;
      }, _rotate: function(l) {
        var s = Math.cos(l), u = Math.sin(l), m = u * this.x + s * this.y;
        return this.x = s * this.x - u * this.y, this.y = m, this;
      }, _rotateAround: function(l, s) {
        var u = Math.cos(l), m = Math.sin(l), b = s.y + m * (this.x - s.x) + u * (this.y - s.y);
        return this.x = s.x + u * (this.x - s.x) - m * (this.y - s.y), this.y = b, this;
      }, _round: function() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
      } }, x.convert = function(l) {
        return l instanceof x ? l : Array.isArray(l) ? new x(l[0], l[1]) : l;
      };
      var $ = f(g), A = I;
      function I(l, s, u, m) {
        this.cx = 3 * l, this.bx = 3 * (u - l) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * s, this.by = 3 * (m - s) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = l, this.p1y = s, this.p2x = u, this.p2y = m;
      }
      I.prototype = { sampleCurveX: function(l) {
        return ((this.ax * l + this.bx) * l + this.cx) * l;
      }, sampleCurveY: function(l) {
        return ((this.ay * l + this.by) * l + this.cy) * l;
      }, sampleCurveDerivativeX: function(l) {
        return (3 * this.ax * l + 2 * this.bx) * l + this.cx;
      }, solveCurveX: function(l, s) {
        if (s === void 0 && (s = 1e-6), l < 0) return 0;
        if (l > 1) return 1;
        for (var u = l, m = 0; m < 8; m++) {
          var b = this.sampleCurveX(u) - l;
          if (Math.abs(b) < s) return u;
          var C = this.sampleCurveDerivativeX(u);
          if (Math.abs(C) < 1e-6) break;
          u -= b / C;
        }
        var k = 0, P = 1;
        for (u = l, m = 0; m < 20 && (b = this.sampleCurveX(u), !(Math.abs(b - l) < s)); m++) l > b ? k = u : P = u, u = 0.5 * (P - k) + k;
        return u;
      }, solve: function(l, s) {
        return this.sampleCurveY(this.solveCurveX(l, s));
      } };
      var O = f(A);
      function B(l, s, u, m) {
        const b = new O(l, s, u, m);
        return function(C) {
          return b.solve(C);
        };
      }
      const H = B(0.25, 0.1, 0.25, 1);
      function N(l, s, u) {
        return Math.min(u, Math.max(s, l));
      }
      function K(l, s, u) {
        const m = u - s, b = ((l - s) % m + m) % m + s;
        return b === s ? u : b;
      }
      function U(l, ...s) {
        for (const u of s) for (const m in u) l[m] = u[m];
        return l;
      }
      let q = 1;
      function ee(l, s) {
        l.forEach((u) => {
          s[u] && (s[u] = s[u].bind(s));
        });
      }
      function te(l, s, u) {
        const m = {};
        for (const b in l) m[b] = s.call(u || this, l[b], b, l);
        return m;
      }
      function ae(l, s, u) {
        const m = {};
        for (const b in l) s.call(u || this, l[b], b, l) && (m[b] = l[b]);
        return m;
      }
      function oe(l) {
        return Array.isArray(l) ? l.map(oe) : typeof l == "object" && l ? te(l, oe) : l;
      }
      const de = {};
      function me(l) {
        de[l] || (typeof console < "u" && console.warn(l), de[l] = !0);
      }
      function ve(l, s, u) {
        return (u.y - l.y) * (s.x - l.x) > (s.y - l.y) * (u.x - l.x);
      }
      function re(l) {
        let s = 0;
        for (let u, m, b = 0, C = l.length, k = C - 1; b < C; k = b++) u = l[b], m = l[k], s += (m.x - u.x) * (u.y + m.y);
        return s;
      }
      function le() {
        return typeof WorkerGlobalScope < "u" && typeof self < "u" && self instanceof WorkerGlobalScope;
      }
      let pe = null;
      function Ne(l) {
        if (pe == null) {
          const s = l.navigator ? l.navigator.userAgent : null;
          pe = !!l.safari || !(!s || !(/\b(iPad|iPhone|iPod)\b/.test(s) || s.match("Safari") && !s.match("Chrome")));
        }
        return pe;
      }
      function We(l) {
        return typeof ImageBitmap < "u" && l instanceof ImageBitmap;
      }
      const Ge = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";
      let et, ft;
      const De = { now: typeof performance < "u" && performance && performance.now ? performance.now.bind(performance) : Date.now.bind(Date), frame(l) {
        const s = requestAnimationFrame(l);
        return { cancel: () => cancelAnimationFrame(s) };
      }, getImageData(l, s = 0) {
        return this.getImageCanvasContext(l).getImageData(-s, -s, l.width + 2 * s, l.height + 2 * s);
      }, getImageCanvasContext(l) {
        const s = window.document.createElement("canvas"), u = s.getContext("2d", { willReadFrequently: !0 });
        if (!u) throw new Error("failed to create canvas 2d context");
        return s.width = l.width, s.height = l.height, u.drawImage(l, 0, 0, l.width, l.height), u;
      }, resolveURL: (l) => (et || (et = document.createElement("a")), et.href = l, et.href), hardwareConcurrency: typeof navigator < "u" && navigator.hardwareConcurrency || 4, get prefersReducedMotion() {
        return !!matchMedia && (ft == null && (ft = matchMedia("(prefers-reduced-motion: reduce)")), ft.matches);
      } }, Ke = { MAX_PARALLEL_IMAGE_REQUESTS: 16, MAX_PARALLEL_IMAGE_REQUESTS_PER_FRAME: 8, MAX_TILE_CACHE_ZOOM_LEVELS: 5, REGISTERED_PROTOCOLS: {}, WORKER_URL: "" };
      class gt extends Error {
        constructor(s, u, m, b) {
          super(`AJAXError: ${u} (${s}): ${m}`), this.status = s, this.statusText = u, this.url = m, this.body = b;
        }
      }
      const qe = le() ? () => self.worker && self.worker.referrer : () => (window.location.protocol === "blob:" ? window.parent : window).location.href, rt = (l) => Ke.REGISTERED_PROTOCOLS[l.substring(0, l.indexOf("://"))];
      function Le(l, s) {
        const u = new AbortController(), m = new Request(l.url, { method: l.method || "GET", body: l.body, credentials: l.credentials, headers: l.headers, referrer: qe(), signal: u.signal });
        let b = !1, C = !1;
        return l.type === "json" && m.headers.set("Accept", "application/json"), C || fetch(m).then((k) => k.ok ? ((P) => {
          (l.type === "arrayBuffer" || l.type === "image" ? P.arrayBuffer() : l.type === "json" ? P.json() : P.text()).then((D) => {
            C || (b = !0, s(null, D, P.headers.get("Cache-Control"), P.headers.get("Expires")));
          }).catch((D) => {
            C || s(new Error(D.message));
          });
        })(k) : k.blob().then((P) => s(new gt(k.status, k.statusText, l.url, P)))).catch((k) => {
          k.code !== 20 && s(new Error(k.message));
        }), { cancel: () => {
          C = !0, b || u.abort();
        } };
      }
      const Je = function(l, s) {
        if (/:\/\//.test(l.url) && !/^https?:|^file:/.test(l.url)) {
          if (le() && self.worker && self.worker.actor) return self.worker.actor.send("getResource", l, s);
          if (!le()) return (rt(l.url) || Le)(l, s);
        }
        if (!(/^file:/.test(u = l.url) || /^file:/.test(qe()) && !/^\w+:/.test(u))) {
          if (fetch && Request && AbortController && Object.prototype.hasOwnProperty.call(Request.prototype, "signal")) return Le(l, s);
          if (le() && self.worker && self.worker.actor) return self.worker.actor.send("getResource", l, s, void 0, !0);
        }
        var u;
        return function(m, b) {
          const C = new XMLHttpRequest();
          C.open(m.method || "GET", m.url, !0), m.type !== "arrayBuffer" && m.type !== "image" || (C.responseType = "arraybuffer");
          for (const k in m.headers) C.setRequestHeader(k, m.headers[k]);
          return m.type === "json" && (C.responseType = "text", C.setRequestHeader("Accept", "application/json")), C.withCredentials = m.credentials === "include", C.onerror = () => {
            b(new Error(C.statusText));
          }, C.onload = () => {
            if ((C.status >= 200 && C.status < 300 || C.status === 0) && C.response !== null) {
              let k = C.response;
              if (m.type === "json") try {
                k = JSON.parse(C.response);
              } catch (P) {
                return b(P);
              }
              b(null, k, C.getResponseHeader("Cache-Control"), C.getResponseHeader("Expires"));
            } else {
              const k = new Blob([C.response], { type: C.getResponseHeader("Content-Type") });
              b(new gt(C.status, C.statusText, m.url, k));
            }
          }, C.send(m.body), { cancel: () => C.abort() };
        }(l, s);
      }, je = function(l, s) {
        return Je(U(l, { type: "arrayBuffer" }), s);
      };
      function ot(l) {
        if (!l || l.indexOf("://") <= 0 || l.indexOf("data:image/") === 0 || l.indexOf("blob:") === 0) return !0;
        const s = new URL(l), u = window.location;
        return s.protocol === u.protocol && s.host === u.host;
      }
      function Xe(l, s, u) {
        u[l] && u[l].indexOf(s) !== -1 || (u[l] = u[l] || [], u[l].push(s));
      }
      function tt(l, s, u) {
        if (u && u[l]) {
          const m = u[l].indexOf(s);
          m !== -1 && u[l].splice(m, 1);
        }
      }
      class dt {
        constructor(s, u = {}) {
          U(this, u), this.type = s;
        }
      }
      class bt extends dt {
        constructor(s, u = {}) {
          super("error", U({ error: s }, u));
        }
      }
      class qt {
        on(s, u) {
          return this._listeners = this._listeners || {}, Xe(s, u, this._listeners), this;
        }
        off(s, u) {
          return tt(s, u, this._listeners), tt(s, u, this._oneTimeListeners), this;
        }
        once(s, u) {
          return u ? (this._oneTimeListeners = this._oneTimeListeners || {}, Xe(s, u, this._oneTimeListeners), this) : new Promise((m) => this.once(s, m));
        }
        fire(s, u) {
          typeof s == "string" && (s = new dt(s, u || {}));
          const m = s.type;
          if (this.listens(m)) {
            s.target = this;
            const b = this._listeners && this._listeners[m] ? this._listeners[m].slice() : [];
            for (const P of b) P.call(this, s);
            const C = this._oneTimeListeners && this._oneTimeListeners[m] ? this._oneTimeListeners[m].slice() : [];
            for (const P of C) tt(m, P, this._oneTimeListeners), P.call(this, s);
            const k = this._eventedParent;
            k && (U(s, typeof this._eventedParentData == "function" ? this._eventedParentData() : this._eventedParentData), k.fire(s));
          } else s instanceof bt && console.error(s.error);
          return this;
        }
        listens(s) {
          return this._listeners && this._listeners[s] && this._listeners[s].length > 0 || this._oneTimeListeners && this._oneTimeListeners[s] && this._oneTimeListeners[s].length > 0 || this._eventedParent && this._eventedParent.listens(s);
        }
        setEventedParent(s, u) {
          return this._eventedParent = s, this._eventedParentData = u, this;
        }
      }
      var Oe = { $version: 8, $root: { version: { required: !0, type: "enum", values: [8] }, name: { type: "string" }, metadata: { type: "*" }, center: { type: "array", value: "number" }, zoom: { type: "number" }, bearing: { type: "number", default: 0, period: 360, units: "degrees" }, pitch: { type: "number", default: 0, units: "degrees" }, light: { type: "light" }, terrain: { type: "terrain" }, sources: { required: !0, type: "sources" }, sprite: { type: "sprite" }, glyphs: { type: "string" }, transition: { type: "transition" }, layers: { required: !0, type: "array", value: "layer" } }, sources: { "*": { type: "source" } }, source: ["source_vector", "source_raster", "source_raster_dem", "source_geojson", "source_video", "source_image"], source_vector: { type: { required: !0, type: "enum", values: { vector: {} } }, url: { type: "string" }, tiles: { type: "array", value: "string" }, bounds: { type: "array", value: "number", length: 4, default: [-180, -85.051129, 180, 85.051129] }, scheme: { type: "enum", values: { xyz: {}, tms: {} }, default: "xyz" }, minzoom: { type: "number", default: 0 }, maxzoom: { type: "number", default: 22 }, attribution: { type: "string" }, promoteId: { type: "promoteId" }, volatile: { type: "boolean", default: !1 }, "*": { type: "*" } }, source_raster: { type: { required: !0, type: "enum", values: { raster: {} } }, url: { type: "string" }, tiles: { type: "array", value: "string" }, bounds: { type: "array", value: "number", length: 4, default: [-180, -85.051129, 180, 85.051129] }, minzoom: { type: "number", default: 0 }, maxzoom: { type: "number", default: 22 }, tileSize: { type: "number", default: 512, units: "pixels" }, scheme: { type: "enum", values: { xyz: {}, tms: {} }, default: "xyz" }, attribution: { type: "string" }, volatile: { type: "boolean", default: !1 }, "*": { type: "*" } }, source_raster_dem: { type: { required: !0, type: "enum", values: { "raster-dem": {} } }, url: { type: "string" }, tiles: { type: "array", value: "string" }, bounds: { type: "array", value: "number", length: 4, default: [-180, -85.051129, 180, 85.051129] }, minzoom: { type: "number", default: 0 }, maxzoom: { type: "number", default: 22 }, tileSize: { type: "number", default: 512, units: "pixels" }, attribution: { type: "string" }, encoding: { type: "enum", values: { terrarium: {}, mapbox: {} }, default: "mapbox" }, volatile: { type: "boolean", default: !1 }, "*": { type: "*" } }, source_geojson: { type: { required: !0, type: "enum", values: { geojson: {} } }, data: { required: !0, type: "*" }, maxzoom: { type: "number", default: 18 }, attribution: { type: "string" }, buffer: { type: "number", default: 128, maximum: 512, minimum: 0 }, filter: { type: "*" }, tolerance: { type: "number", default: 0.375 }, cluster: { type: "boolean", default: !1 }, clusterRadius: { type: "number", default: 50, minimum: 0 }, clusterMaxZoom: { type: "number" }, clusterMinPoints: { type: "number" }, clusterProperties: { type: "*" }, lineMetrics: { type: "boolean", default: !1 }, generateId: { type: "boolean", default: !1 }, promoteId: { type: "promoteId" } }, source_video: { type: { required: !0, type: "enum", values: { video: {} } }, urls: { required: !0, type: "array", value: "string" }, coordinates: { required: !0, type: "array", length: 4, value: { type: "array", length: 2, value: "number" } } }, source_image: { type: { required: !0, type: "enum", values: { image: {} } }, url: { required: !0, type: "string" }, coordinates: { required: !0, type: "array", length: 4, value: { type: "array", length: 2, value: "number" } } }, layer: { id: { type: "string", required: !0 }, type: { type: "enum", values: { fill: {}, line: {}, symbol: {}, circle: {}, heatmap: {}, "fill-extrusion": {}, raster: {}, hillshade: {}, background: {} }, required: !0 }, metadata: { type: "*" }, source: { type: "string" }, "source-layer": { type: "string" }, minzoom: { type: "number", minimum: 0, maximum: 24 }, maxzoom: { type: "number", minimum: 0, maximum: 24 }, filter: { type: "filter" }, layout: { type: "layout" }, paint: { type: "paint" } }, layout: ["layout_fill", "layout_line", "layout_circle", "layout_heatmap", "layout_fill-extrusion", "layout_symbol", "layout_raster", "layout_hillshade", "layout_background"], layout_background: { visibility: { type: "enum", values: { visible: {}, none: {} }, default: "visible", "property-type": "constant" } }, layout_fill: { "fill-sort-key": { type: "number", expression: { interpolated: !1, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, visibility: { type: "enum", values: { visible: {}, none: {} }, default: "visible", "property-type": "constant" } }, layout_circle: { "circle-sort-key": { type: "number", expression: { interpolated: !1, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, visibility: { type: "enum", values: { visible: {}, none: {} }, default: "visible", "property-type": "constant" } }, layout_heatmap: { visibility: { type: "enum", values: { visible: {}, none: {} }, default: "visible", "property-type": "constant" } }, "layout_fill-extrusion": { visibility: { type: "enum", values: { visible: {}, none: {} }, default: "visible", "property-type": "constant" } }, layout_line: { "line-cap": { type: "enum", values: { butt: {}, round: {}, square: {} }, default: "butt", expression: { interpolated: !1, parameters: ["zoom"] }, "property-type": "data-constant" }, "line-join": { type: "enum", values: { bevel: {}, round: {}, miter: {} }, default: "miter", expression: { interpolated: !1, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, "line-miter-limit": { type: "number", default: 2, requires: [{ "line-join": "miter" }], expression: { interpolated: !0, parameters: ["zoom"] }, "property-type": "data-constant" }, "line-round-limit": { type: "number", default: 1.05, requires: [{ "line-join": "round" }], expression: { interpolated: !0, parameters: ["zoom"] }, "property-type": "data-constant" }, "line-sort-key": { type: "number", expression: { interpolated: !1, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, visibility: { type: "enum", values: { visible: {}, none: {} }, default: "visible", "property-type": "constant" } }, layout_symbol: { "symbol-placement": { type: "enum", values: { point: {}, line: {}, "line-center": {} }, default: "point", expression: { interpolated: !1, parameters: ["zoom"] }, "property-type": "data-constant" }, "symbol-spacing": { type: "number", default: 250, minimum: 1, units: "pixels", requires: [{ "symbol-placement": "line" }], expression: { interpolated: !0, parameters: ["zoom"] }, "property-type": "data-constant" }, "symbol-avoid-edges": { type: "boolean", default: !1, expression: { interpolated: !1, parameters: ["zoom"] }, "property-type": "data-constant" }, "symbol-sort-key": { type: "number", expression: { interpolated: !1, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, "symbol-z-order": { type: "enum", values: { auto: {}, "viewport-y": {}, source: {} }, default: "auto", expression: { interpolated: !1, parameters: ["zoom"] }, "property-type": "data-constant" }, "icon-allow-overlap": { type: "boolean", default: !1, requires: ["icon-image", { "!": "icon-overlap" }], expression: { interpolated: !1, parameters: ["zoom"] }, "property-type": "data-constant" }, "icon-overlap": { type: "enum", values: { never: {}, always: {}, cooperative: {} }, requires: ["icon-image"], expression: { interpolated: !1, parameters: ["zoom"] }, "property-type": "data-constant" }, "icon-ignore-placement": { type: "boolean", default: !1, requires: ["icon-image"], expression: { interpolated: !1, parameters: ["zoom"] }, "property-type": "data-constant" }, "icon-optional": { type: "boolean", default: !1, requires: ["icon-image", "text-field"], expression: { interpolated: !1, parameters: ["zoom"] }, "property-type": "data-constant" }, "icon-rotation-alignment": { type: "enum", values: { map: {}, viewport: {}, auto: {} }, default: "auto", requires: ["icon-image"], expression: { interpolated: !1, parameters: ["zoom"] }, "property-type": "data-constant" }, "icon-size": { type: "number", default: 1, minimum: 0, units: "factor of the original icon size", requires: ["icon-image"], expression: { interpolated: !0, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, "icon-text-fit": { type: "enum", values: { none: {}, width: {}, height: {}, both: {} }, default: "none", requires: ["icon-image", "text-field"], expression: { interpolated: !1, parameters: ["zoom"] }, "property-type": "data-constant" }, "icon-text-fit-padding": { type: "array", value: "number", length: 4, default: [0, 0, 0, 0], units: "pixels", requires: ["icon-image", "text-field", { "icon-text-fit": ["both", "width", "height"] }], expression: { interpolated: !0, parameters: ["zoom"] }, "property-type": "data-constant" }, "icon-image": { type: "resolvedImage", tokens: !0, expression: { interpolated: !1, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, "icon-rotate": { type: "number", default: 0, period: 360, units: "degrees", requires: ["icon-image"], expression: { interpolated: !0, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, "icon-padding": { type: "padding", default: [2], units: "pixels", requires: ["icon-image"], expression: { interpolated: !0, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, "icon-keep-upright": { type: "boolean", default: !1, requires: ["icon-image", { "icon-rotation-alignment": "map" }, { "symbol-placement": ["line", "line-center"] }], expression: { interpolated: !1, parameters: ["zoom"] }, "property-type": "data-constant" }, "icon-offset": { type: "array", value: "number", length: 2, default: [0, 0], requires: ["icon-image"], expression: { interpolated: !0, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, "icon-anchor": { type: "enum", values: { center: {}, left: {}, right: {}, top: {}, bottom: {}, "top-left": {}, "top-right": {}, "bottom-left": {}, "bottom-right": {} }, default: "center", requires: ["icon-image"], expression: { interpolated: !1, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, "icon-pitch-alignment": { type: "enum", values: { map: {}, viewport: {}, auto: {} }, default: "auto", requires: ["icon-image"], expression: { interpolated: !1, parameters: ["zoom"] }, "property-type": "data-constant" }, "text-pitch-alignment": { type: "enum", values: { map: {}, viewport: {}, auto: {} }, default: "auto", requires: ["text-field"], expression: { interpolated: !1, parameters: ["zoom"] }, "property-type": "data-constant" }, "text-rotation-alignment": { type: "enum", values: { map: {}, viewport: {}, "viewport-glyph": {}, auto: {} }, default: "auto", requires: ["text-field"], expression: { interpolated: !1, parameters: ["zoom"] }, "property-type": "data-constant" }, "text-field": { type: "formatted", default: "", tokens: !0, expression: { interpolated: !1, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, "text-font": { type: "array", value: "string", default: ["Open Sans Regular", "Arial Unicode MS Regular"], requires: ["text-field"], expression: { interpolated: !1, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, "text-size": { type: "number", default: 16, minimum: 0, units: "pixels", requires: ["text-field"], expression: { interpolated: !0, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, "text-max-width": { type: "number", default: 10, minimum: 0, units: "ems", requires: ["text-field"], expression: { interpolated: !0, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, "text-line-height": { type: "number", default: 1.2, units: "ems", requires: ["text-field"], expression: { interpolated: !0, parameters: ["zoom"] }, "property-type": "data-constant" }, "text-letter-spacing": { type: "number", default: 0, units: "ems", requires: ["text-field"], expression: { interpolated: !0, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, "text-justify": { type: "enum", values: { auto: {}, left: {}, center: {}, right: {} }, default: "center", requires: ["text-field"], expression: { interpolated: !1, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, "text-radial-offset": { type: "number", units: "ems", default: 0, requires: ["text-field"], "property-type": "data-driven", expression: { interpolated: !0, parameters: ["zoom", "feature"] } }, "text-variable-anchor": { type: "array", value: "enum", values: { center: {}, left: {}, right: {}, top: {}, bottom: {}, "top-left": {}, "top-right": {}, "bottom-left": {}, "bottom-right": {} }, requires: ["text-field", { "symbol-placement": ["point"] }], expression: { interpolated: !1, parameters: ["zoom"] }, "property-type": "data-constant" }, "text-anchor": { type: "enum", values: { center: {}, left: {}, right: {}, top: {}, bottom: {}, "top-left": {}, "top-right": {}, "bottom-left": {}, "bottom-right": {} }, default: "center", requires: ["text-field", { "!": "text-variable-anchor" }], expression: { interpolated: !1, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, "text-max-angle": { type: "number", default: 45, units: "degrees", requires: ["text-field", { "symbol-placement": ["line", "line-center"] }], expression: { interpolated: !0, parameters: ["zoom"] }, "property-type": "data-constant" }, "text-writing-mode": { type: "array", value: "enum", values: { horizontal: {}, vertical: {} }, requires: ["text-field", { "symbol-placement": ["point"] }], expression: { interpolated: !1, parameters: ["zoom"] }, "property-type": "data-constant" }, "text-rotate": { type: "number", default: 0, period: 360, units: "degrees", requires: ["text-field"], expression: { interpolated: !0, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, "text-padding": { type: "number", default: 2, minimum: 0, units: "pixels", requires: ["text-field"], expression: { interpolated: !0, parameters: ["zoom"] }, "property-type": "data-constant" }, "text-keep-upright": { type: "boolean", default: !0, requires: ["text-field", { "text-rotation-alignment": "map" }, { "symbol-placement": ["line", "line-center"] }], expression: { interpolated: !1, parameters: ["zoom"] }, "property-type": "data-constant" }, "text-transform": { type: "enum", values: { none: {}, uppercase: {}, lowercase: {} }, default: "none", requires: ["text-field"], expression: { interpolated: !1, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, "text-offset": { type: "array", value: "number", units: "ems", length: 2, default: [0, 0], requires: ["text-field", { "!": "text-radial-offset" }], expression: { interpolated: !0, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, "text-allow-overlap": { type: "boolean", default: !1, requires: ["text-field", { "!": "text-overlap" }], expression: { interpolated: !1, parameters: ["zoom"] }, "property-type": "data-constant" }, "text-overlap": { type: "enum", values: { never: {}, always: {}, cooperative: {} }, requires: ["text-field"], expression: { interpolated: !1, parameters: ["zoom"] }, "property-type": "data-constant" }, "text-ignore-placement": { type: "boolean", default: !1, requires: ["text-field"], expression: { interpolated: !1, parameters: ["zoom"] }, "property-type": "data-constant" }, "text-optional": { type: "boolean", default: !1, requires: ["text-field", "icon-image"], expression: { interpolated: !1, parameters: ["zoom"] }, "property-type": "data-constant" }, visibility: { type: "enum", values: { visible: {}, none: {} }, default: "visible", "property-type": "constant" } }, layout_raster: { visibility: { type: "enum", values: { visible: {}, none: {} }, default: "visible", "property-type": "constant" } }, layout_hillshade: { visibility: { type: "enum", values: { visible: {}, none: {} }, default: "visible", "property-type": "constant" } }, filter: { type: "array", value: "*" }, filter_operator: { type: "enum", values: { "==": {}, "!=": {}, ">": {}, ">=": {}, "<": {}, "<=": {}, in: {}, "!in": {}, all: {}, any: {}, none: {}, has: {}, "!has": {}, within: {} } }, geometry_type: { type: "enum", values: { Point: {}, LineString: {}, Polygon: {} } }, function: { expression: { type: "expression" }, stops: { type: "array", value: "function_stop" }, base: { type: "number", default: 1, minimum: 0 }, property: { type: "string", default: "$zoom" }, type: { type: "enum", values: { identity: {}, exponential: {}, interval: {}, categorical: {} }, default: "exponential" }, colorSpace: { type: "enum", values: { rgb: {}, lab: {}, hcl: {} }, default: "rgb" }, default: { type: "*", required: !1 } }, function_stop: { type: "array", minimum: 0, maximum: 24, value: ["number", "color"], length: 2 }, expression: { type: "array", value: "*", minimum: 1 }, light: { anchor: { type: "enum", default: "viewport", values: { map: {}, viewport: {} }, "property-type": "data-constant", transition: !1, expression: { interpolated: !1, parameters: ["zoom"] } }, position: { type: "array", default: [1.15, 210, 30], length: 3, value: "number", "property-type": "data-constant", transition: !0, expression: { interpolated: !0, parameters: ["zoom"] } }, color: { type: "color", "property-type": "data-constant", default: "#ffffff", expression: { interpolated: !0, parameters: ["zoom"] }, transition: !0 }, intensity: { type: "number", "property-type": "data-constant", default: 0.5, minimum: 0, maximum: 1, expression: { interpolated: !0, parameters: ["zoom"] }, transition: !0 } }, terrain: { source: { type: "string", required: !0 }, exaggeration: { type: "number", minimum: 0, default: 1 } }, paint: ["paint_fill", "paint_line", "paint_circle", "paint_heatmap", "paint_fill-extrusion", "paint_symbol", "paint_raster", "paint_hillshade", "paint_background"], paint_fill: { "fill-antialias": { type: "boolean", default: !0, expression: { interpolated: !1, parameters: ["zoom"] }, "property-type": "data-constant" }, "fill-opacity": { type: "number", default: 1, minimum: 0, maximum: 1, transition: !0, expression: { interpolated: !0, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "fill-color": { type: "color", default: "#000000", transition: !0, requires: [{ "!": "fill-pattern" }], expression: { interpolated: !0, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "fill-outline-color": { type: "color", transition: !0, requires: [{ "!": "fill-pattern" }, { "fill-antialias": !0 }], expression: { interpolated: !0, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "fill-translate": { type: "array", value: "number", length: 2, default: [0, 0], transition: !0, units: "pixels", expression: { interpolated: !0, parameters: ["zoom"] }, "property-type": "data-constant" }, "fill-translate-anchor": { type: "enum", values: { map: {}, viewport: {} }, default: "map", requires: ["fill-translate"], expression: { interpolated: !1, parameters: ["zoom"] }, "property-type": "data-constant" }, "fill-pattern": { type: "resolvedImage", transition: !0, expression: { interpolated: !1, parameters: ["zoom", "feature"] }, "property-type": "cross-faded-data-driven" } }, "paint_fill-extrusion": { "fill-extrusion-opacity": { type: "number", default: 1, minimum: 0, maximum: 1, transition: !0, expression: { interpolated: !0, parameters: ["zoom"] }, "property-type": "data-constant" }, "fill-extrusion-color": { type: "color", default: "#000000", transition: !0, requires: [{ "!": "fill-extrusion-pattern" }], expression: { interpolated: !0, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "fill-extrusion-translate": { type: "array", value: "number", length: 2, default: [0, 0], transition: !0, units: "pixels", expression: { interpolated: !0, parameters: ["zoom"] }, "property-type": "data-constant" }, "fill-extrusion-translate-anchor": { type: "enum", values: { map: {}, viewport: {} }, default: "map", requires: ["fill-extrusion-translate"], expression: { interpolated: !1, parameters: ["zoom"] }, "property-type": "data-constant" }, "fill-extrusion-pattern": { type: "resolvedImage", transition: !0, expression: { interpolated: !1, parameters: ["zoom", "feature"] }, "property-type": "cross-faded-data-driven" }, "fill-extrusion-height": { type: "number", default: 0, minimum: 0, units: "meters", transition: !0, expression: { interpolated: !0, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "fill-extrusion-base": { type: "number", default: 0, minimum: 0, units: "meters", transition: !0, requires: ["fill-extrusion-height"], expression: { interpolated: !0, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "fill-extrusion-vertical-gradient": { type: "boolean", default: !0, transition: !1, expression: { interpolated: !1, parameters: ["zoom"] }, "property-type": "data-constant" } }, paint_line: { "line-opacity": { type: "number", default: 1, minimum: 0, maximum: 1, transition: !0, expression: { interpolated: !0, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "line-color": { type: "color", default: "#000000", transition: !0, requires: [{ "!": "line-pattern" }], expression: { interpolated: !0, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "line-translate": { type: "array", value: "number", length: 2, default: [0, 0], transition: !0, units: "pixels", expression: { interpolated: !0, parameters: ["zoom"] }, "property-type": "data-constant" }, "line-translate-anchor": { type: "enum", values: { map: {}, viewport: {} }, default: "map", requires: ["line-translate"], expression: { interpolated: !1, parameters: ["zoom"] }, "property-type": "data-constant" }, "line-width": { type: "number", default: 1, minimum: 0, transition: !0, units: "pixels", expression: { interpolated: !0, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "line-gap-width": { type: "number", default: 0, minimum: 0, transition: !0, units: "pixels", expression: { interpolated: !0, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "line-offset": { type: "number", default: 0, transition: !0, units: "pixels", expression: { interpolated: !0, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "line-blur": { type: "number", default: 0, minimum: 0, transition: !0, units: "pixels", expression: { interpolated: !0, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "line-dasharray": { type: "array", value: "number", minimum: 0, transition: !0, units: "line widths", requires: [{ "!": "line-pattern" }], expression: { interpolated: !1, parameters: ["zoom"] }, "property-type": "cross-faded" }, "line-pattern": { type: "resolvedImage", transition: !0, expression: { interpolated: !1, parameters: ["zoom", "feature"] }, "property-type": "cross-faded-data-driven" }, "line-gradient": { type: "color", transition: !1, requires: [{ "!": "line-dasharray" }, { "!": "line-pattern" }, { source: "geojson", has: { lineMetrics: !0 } }], expression: { interpolated: !0, parameters: ["line-progress"] }, "property-type": "color-ramp" } }, paint_circle: { "circle-radius": { type: "number", default: 5, minimum: 0, transition: !0, units: "pixels", expression: { interpolated: !0, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "circle-color": { type: "color", default: "#000000", transition: !0, expression: { interpolated: !0, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "circle-blur": { type: "number", default: 0, transition: !0, expression: { interpolated: !0, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "circle-opacity": { type: "number", default: 1, minimum: 0, maximum: 1, transition: !0, expression: { interpolated: !0, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "circle-translate": { type: "array", value: "number", length: 2, default: [0, 0], transition: !0, units: "pixels", expression: { interpolated: !0, parameters: ["zoom"] }, "property-type": "data-constant" }, "circle-translate-anchor": { type: "enum", values: { map: {}, viewport: {} }, default: "map", requires: ["circle-translate"], expression: { interpolated: !1, parameters: ["zoom"] }, "property-type": "data-constant" }, "circle-pitch-scale": { type: "enum", values: { map: {}, viewport: {} }, default: "map", expression: { interpolated: !1, parameters: ["zoom"] }, "property-type": "data-constant" }, "circle-pitch-alignment": { type: "enum", values: { map: {}, viewport: {} }, default: "viewport", expression: { interpolated: !1, parameters: ["zoom"] }, "property-type": "data-constant" }, "circle-stroke-width": { type: "number", default: 0, minimum: 0, transition: !0, units: "pixels", expression: { interpolated: !0, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "circle-stroke-color": { type: "color", default: "#000000", transition: !0, expression: { interpolated: !0, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "circle-stroke-opacity": { type: "number", default: 1, minimum: 0, maximum: 1, transition: !0, expression: { interpolated: !0, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" } }, paint_heatmap: { "heatmap-radius": { type: "number", default: 30, minimum: 1, transition: !0, units: "pixels", expression: { interpolated: !0, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "heatmap-weight": { type: "number", default: 1, minimum: 0, transition: !1, expression: { interpolated: !0, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "heatmap-intensity": { type: "number", default: 1, minimum: 0, transition: !0, expression: { interpolated: !0, parameters: ["zoom"] }, "property-type": "data-constant" }, "heatmap-color": { type: "color", default: ["interpolate", ["linear"], ["heatmap-density"], 0, "rgba(0, 0, 255, 0)", 0.1, "royalblue", 0.3, "cyan", 0.5, "lime", 0.7, "yellow", 1, "red"], transition: !1, expression: { interpolated: !0, parameters: ["heatmap-density"] }, "property-type": "color-ramp" }, "heatmap-opacity": { type: "number", default: 1, minimum: 0, maximum: 1, transition: !0, expression: { interpolated: !0, parameters: ["zoom"] }, "property-type": "data-constant" } }, paint_symbol: { "icon-opacity": { type: "number", default: 1, minimum: 0, maximum: 1, transition: !0, requires: ["icon-image"], expression: { interpolated: !0, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "icon-color": { type: "color", default: "#000000", transition: !0, requires: ["icon-image"], expression: { interpolated: !0, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "icon-halo-color": { type: "color", default: "rgba(0, 0, 0, 0)", transition: !0, requires: ["icon-image"], expression: { interpolated: !0, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "icon-halo-width": { type: "number", default: 0, minimum: 0, transition: !0, units: "pixels", requires: ["icon-image"], expression: { interpolated: !0, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "icon-halo-blur": { type: "number", default: 0, minimum: 0, transition: !0, units: "pixels", requires: ["icon-image"], expression: { interpolated: !0, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "icon-translate": { type: "array", value: "number", length: 2, default: [0, 0], transition: !0, units: "pixels", requires: ["icon-image"], expression: { interpolated: !0, parameters: ["zoom"] }, "property-type": "data-constant" }, "icon-translate-anchor": { type: "enum", values: { map: {}, viewport: {} }, default: "map", requires: ["icon-image", "icon-translate"], expression: { interpolated: !1, parameters: ["zoom"] }, "property-type": "data-constant" }, "text-opacity": { type: "number", default: 1, minimum: 0, maximum: 1, transition: !0, requires: ["text-field"], expression: { interpolated: !0, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "text-color": { type: "color", default: "#000000", transition: !0, overridable: !0, requires: ["text-field"], expression: { interpolated: !0, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "text-halo-color": { type: "color", default: "rgba(0, 0, 0, 0)", transition: !0, requires: ["text-field"], expression: { interpolated: !0, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "text-halo-width": { type: "number", default: 0, minimum: 0, transition: !0, units: "pixels", requires: ["text-field"], expression: { interpolated: !0, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "text-halo-blur": { type: "number", default: 0, minimum: 0, transition: !0, units: "pixels", requires: ["text-field"], expression: { interpolated: !0, parameters: ["zoom", "feature", "feature-state"] }, "property-type": "data-driven" }, "text-translate": { type: "array", value: "number", length: 2, default: [0, 0], transition: !0, units: "pixels", requires: ["text-field"], expression: { interpolated: !0, parameters: ["zoom"] }, "property-type": "data-constant" }, "text-translate-anchor": { type: "enum", values: { map: {}, viewport: {} }, default: "map", requires: ["text-field", "text-translate"], expression: { interpolated: !1, parameters: ["zoom"] }, "property-type": "data-constant" } }, paint_raster: { "raster-opacity": { type: "number", default: 1, minimum: 0, maximum: 1, transition: !0, expression: { interpolated: !0, parameters: ["zoom"] }, "property-type": "data-constant" }, "raster-hue-rotate": { type: "number", default: 0, period: 360, transition: !0, units: "degrees", expression: { interpolated: !0, parameters: ["zoom"] }, "property-type": "data-constant" }, "raster-brightness-min": { type: "number", default: 0, minimum: 0, maximum: 1, transition: !0, expression: { interpolated: !0, parameters: ["zoom"] }, "property-type": "data-constant" }, "raster-brightness-max": { type: "number", default: 1, minimum: 0, maximum: 1, transition: !0, expression: { interpolated: !0, parameters: ["zoom"] }, "property-type": "data-constant" }, "raster-saturation": { type: "number", default: 0, minimum: -1, maximum: 1, transition: !0, expression: { interpolated: !0, parameters: ["zoom"] }, "property-type": "data-constant" }, "raster-contrast": { type: "number", default: 0, minimum: -1, maximum: 1, transition: !0, expression: { interpolated: !0, parameters: ["zoom"] }, "property-type": "data-constant" }, "raster-resampling": { type: "enum", values: { linear: {}, nearest: {} }, default: "linear", expression: { interpolated: !1, parameters: ["zoom"] }, "property-type": "data-constant" }, "raster-fade-duration": { type: "number", default: 300, minimum: 0, transition: !1, units: "milliseconds", expression: { interpolated: !0, parameters: ["zoom"] }, "property-type": "data-constant" } }, paint_hillshade: { "hillshade-illumination-direction": { type: "number", default: 335, minimum: 0, maximum: 359, transition: !1, expression: { interpolated: !0, parameters: ["zoom"] }, "property-type": "data-constant" }, "hillshade-illumination-anchor": { type: "enum", values: { map: {}, viewport: {} }, default: "viewport", expression: { interpolated: !1, parameters: ["zoom"] }, "property-type": "data-constant" }, "hillshade-exaggeration": { type: "number", default: 0.5, minimum: 0, maximum: 1, transition: !0, expression: { interpolated: !0, parameters: ["zoom"] }, "property-type": "data-constant" }, "hillshade-shadow-color": { type: "color", default: "#000000", transition: !0, expression: { interpolated: !0, parameters: ["zoom"] }, "property-type": "data-constant" }, "hillshade-highlight-color": { type: "color", default: "#FFFFFF", transition: !0, expression: { interpolated: !0, parameters: ["zoom"] }, "property-type": "data-constant" }, "hillshade-accent-color": { type: "color", default: "#000000", transition: !0, expression: { interpolated: !0, parameters: ["zoom"] }, "property-type": "data-constant" } }, paint_background: { "background-color": { type: "color", default: "#000000", transition: !0, requires: [{ "!": "background-pattern" }], expression: { interpolated: !0, parameters: ["zoom"] }, "property-type": "data-constant" }, "background-pattern": { type: "resolvedImage", transition: !0, expression: { interpolated: !1, parameters: ["zoom"] }, "property-type": "cross-faded" }, "background-opacity": { type: "number", default: 1, minimum: 0, maximum: 1, transition: !0, expression: { interpolated: !0, parameters: ["zoom"] }, "property-type": "data-constant" } }, transition: { duration: { type: "number", default: 300, minimum: 0, units: "milliseconds" }, delay: { type: "number", default: 0, minimum: 0, units: "milliseconds" } }, "property-type": { "data-driven": { type: "property-type" }, "cross-faded": { type: "property-type" }, "cross-faded-data-driven": { type: "property-type" }, "color-ramp": { type: "property-type" }, "data-constant": { type: "property-type" }, constant: { type: "property-type" } }, promoteId: { "*": { type: "string" } } };
      const Bt = ["type", "source", "source-layer", "minzoom", "maxzoom", "filter", "layout"];
      function Tn(l, s) {
        const u = {};
        for (const m in l) m !== "ref" && (u[m] = l[m]);
        return Bt.forEach((m) => {
          m in s && (u[m] = s[m]);
        }), u;
      }
      function hn(l, s) {
        if (Array.isArray(l)) {
          if (!Array.isArray(s) || l.length !== s.length) return !1;
          for (let u = 0; u < l.length; u++) if (!hn(l[u], s[u])) return !1;
          return !0;
        }
        if (typeof l == "object" && l !== null && s !== null) {
          if (typeof s != "object" || Object.keys(l).length !== Object.keys(s).length) return !1;
          for (const u in l) if (!hn(l[u], s[u])) return !1;
          return !0;
        }
        return l === s;
      }
      const Ht = { setStyle: "setStyle", addLayer: "addLayer", removeLayer: "removeLayer", setPaintProperty: "setPaintProperty", setLayoutProperty: "setLayoutProperty", setFilter: "setFilter", addSource: "addSource", removeSource: "removeSource", setGeoJSONSourceData: "setGeoJSONSourceData", setLayerZoomRange: "setLayerZoomRange", setLayerProperty: "setLayerProperty", setCenter: "setCenter", setZoom: "setZoom", setBearing: "setBearing", setPitch: "setPitch", setSprite: "setSprite", setGlyphs: "setGlyphs", setTransition: "setTransition", setLight: "setLight" };
      function qn(l, s, u) {
        u.push({ command: Ht.addSource, args: [l, s[l]] });
      }
      function vi(l, s, u) {
        s.push({ command: Ht.removeSource, args: [l] }), u[l] = !0;
      }
      function It(l, s, u, m) {
        vi(l, u, m), qn(l, s, u);
      }
      function wn(l, s, u) {
        let m;
        for (m in l[u]) if (Object.prototype.hasOwnProperty.call(l[u], m) && m !== "data" && !hn(l[u][m], s[u][m])) return !1;
        for (m in s[u]) if (Object.prototype.hasOwnProperty.call(s[u], m) && m !== "data" && !hn(l[u][m], s[u][m])) return !1;
        return !0;
      }
      function Oi(l, s, u, m, b, C) {
        let k;
        for (k in s = s || {}, l = l || {}) Object.prototype.hasOwnProperty.call(l, k) && (hn(l[k], s[k]) || u.push({ command: C, args: [m, k, s[k], b] }));
        for (k in s) Object.prototype.hasOwnProperty.call(s, k) && !Object.prototype.hasOwnProperty.call(l, k) && (hn(l[k], s[k]) || u.push({ command: C, args: [m, k, s[k], b] }));
      }
      function hr(l) {
        return l.id;
      }
      function qi(l, s) {
        return l[s.id] = s, l;
      }
      class kt {
        constructor(s, u, m, b) {
          this.message = (s ? `${s}: ` : "") + m, b && (this.identifier = b), u != null && u.__line__ && (this.line = u.__line__);
        }
      }
      function wi(l, ...s) {
        for (const u of s) for (const m in u) l[m] = u[m];
        return l;
      }
      class ai extends Error {
        constructor(s, u) {
          super(u), this.message = u, this.key = s;
        }
      }
      class Hr {
        constructor(s, u = []) {
          this.parent = s, this.bindings = {};
          for (const [m, b] of u) this.bindings[m] = b;
        }
        concat(s) {
          return new Hr(this, s);
        }
        get(s) {
          if (this.bindings[s]) return this.bindings[s];
          if (this.parent) return this.parent.get(s);
          throw new Error(`${s} not found in scope.`);
        }
        has(s) {
          return !!this.bindings[s] || !!this.parent && this.parent.has(s);
        }
      }
      const hs = { kind: "null" }, Pt = { kind: "number" }, $n = { kind: "string" }, yn = { kind: "boolean" }, Qi = { kind: "color" }, Gi = { kind: "object" }, Cn = { kind: "value" }, or = { kind: "collator" }, Wr = { kind: "formatted" }, kr = { kind: "padding" }, fs = { kind: "resolvedImage" };
      function tr(l, s) {
        return { kind: "array", itemType: l, N: s };
      }
      function pi(l) {
        if (l.kind === "array") {
          const s = pi(l.itemType);
          return typeof l.N == "number" ? `array<${s}, ${l.N}>` : l.itemType.kind === "value" ? "array" : `array<${s}>`;
        }
        return l.kind;
      }
      const ga = [hs, Pt, $n, yn, Qi, Wr, Gi, tr(Cn), kr, fs];
      function As(l, s) {
        if (s.kind === "error") return null;
        if (l.kind === "array") {
          if (s.kind === "array" && (s.N === 0 && s.itemType.kind === "value" || !As(l.itemType, s.itemType)) && (typeof l.N != "number" || l.N === s.N)) return null;
        } else {
          if (l.kind === s.kind) return null;
          if (l.kind === "value") {
            for (const u of ga) if (!As(u, s)) return null;
          }
        }
        return `Expected ${pi(l)} but found ${pi(s)} instead.`;
      }
      function Te(l, s) {
        return s.some((u) => u.kind === l.kind);
      }
      function se(l, s) {
        return s.some((u) => u === "null" ? l === null : u === "array" ? Array.isArray(l) : u === "object" ? l && !Array.isArray(l) && typeof l == "object" : u === typeof l);
      }
      function ue(l, s) {
        return l.kind === "array" && s.kind === "array" ? l.itemType.kind === s.itemType.kind && typeof l.N == "number" : l.kind === s.kind;
      }
      const be = 0.96422, Pe = 0.82521, Fe = 4 / 29, Ze = 6 / 29, ze = 3 * Ze * Ze, Re = Ze * Ze * Ze, Ye = Math.PI / 180, nt = 180 / Math.PI;
      function _t(l) {
        return (l %= 360) < 0 && (l += 360), l;
      }
      function yt([l, s, u, m]) {
        let b, C;
        const k = bn((0.2225045 * (l = un(l)) + 0.7168786 * (s = un(s)) + 0.0606169 * (u = un(u))) / 1);
        l === s && s === u ? b = C = k : (b = bn((0.4360747 * l + 0.3850649 * s + 0.1430804 * u) / be), C = bn((0.0139322 * l + 0.0971045 * s + 0.7141733 * u) / Pe));
        const P = 116 * k - 16;
        return [P < 0 ? 0 : P, 500 * (b - k), 200 * (k - C), m];
      }
      function un(l) {
        return l <= 0.04045 ? l / 12.92 : Math.pow((l + 0.055) / 1.055, 2.4);
      }
      function bn(l) {
        return l > Re ? Math.pow(l, 1 / 3) : l / ze + Fe;
      }
      function Kt([l, s, u, m]) {
        let b = (l + 16) / 116, C = isNaN(s) ? b : b + s / 500, k = isNaN(u) ? b : b - u / 200;
        return b = 1 * dn(b), C = be * dn(C), k = Pe * dn(k), [an(3.1338561 * C - 1.6168667 * b - 0.4906146 * k), an(-0.9787684 * C + 1.9161415 * b + 0.033454 * k), an(0.0719453 * C - 0.2289914 * b + 1.4052427 * k), m];
      }
      function an(l) {
        return (l = l <= 304e-5 ? 12.92 * l : 1.055 * Math.pow(l, 1 / 2.4) - 0.055) < 0 ? 0 : l > 1 ? 1 : l;
      }
      function dn(l) {
        return l > Ze ? l * l * l : ze * (l - Fe);
      }
      function Bn(l) {
        return parseInt(l.padEnd(2, l), 16) / 255;
      }
      function An(l, s) {
        return Un(s ? l / 100 : l, 0, 1);
      }
      function Un(l, s, u) {
        return Math.min(Math.max(s, l), u);
      }
      function ei(l) {
        return !l.some(Number.isNaN);
      }
      const Yi = { aliceblue: [240, 248, 255], antiquewhite: [250, 235, 215], aqua: [0, 255, 255], aquamarine: [127, 255, 212], azure: [240, 255, 255], beige: [245, 245, 220], bisque: [255, 228, 196], black: [0, 0, 0], blanchedalmond: [255, 235, 205], blue: [0, 0, 255], blueviolet: [138, 43, 226], brown: [165, 42, 42], burlywood: [222, 184, 135], cadetblue: [95, 158, 160], chartreuse: [127, 255, 0], chocolate: [210, 105, 30], coral: [255, 127, 80], cornflowerblue: [100, 149, 237], cornsilk: [255, 248, 220], crimson: [220, 20, 60], cyan: [0, 255, 255], darkblue: [0, 0, 139], darkcyan: [0, 139, 139], darkgoldenrod: [184, 134, 11], darkgray: [169, 169, 169], darkgreen: [0, 100, 0], darkgrey: [169, 169, 169], darkkhaki: [189, 183, 107], darkmagenta: [139, 0, 139], darkolivegreen: [85, 107, 47], darkorange: [255, 140, 0], darkorchid: [153, 50, 204], darkred: [139, 0, 0], darksalmon: [233, 150, 122], darkseagreen: [143, 188, 143], darkslateblue: [72, 61, 139], darkslategray: [47, 79, 79], darkslategrey: [47, 79, 79], darkturquoise: [0, 206, 209], darkviolet: [148, 0, 211], deeppink: [255, 20, 147], deepskyblue: [0, 191, 255], dimgray: [105, 105, 105], dimgrey: [105, 105, 105], dodgerblue: [30, 144, 255], firebrick: [178, 34, 34], floralwhite: [255, 250, 240], forestgreen: [34, 139, 34], fuchsia: [255, 0, 255], gainsboro: [220, 220, 220], ghostwhite: [248, 248, 255], gold: [255, 215, 0], goldenrod: [218, 165, 32], gray: [128, 128, 128], green: [0, 128, 0], greenyellow: [173, 255, 47], grey: [128, 128, 128], honeydew: [240, 255, 240], hotpink: [255, 105, 180], indianred: [205, 92, 92], indigo: [75, 0, 130], ivory: [255, 255, 240], khaki: [240, 230, 140], lavender: [230, 230, 250], lavenderblush: [255, 240, 245], lawngreen: [124, 252, 0], lemonchiffon: [255, 250, 205], lightblue: [173, 216, 230], lightcoral: [240, 128, 128], lightcyan: [224, 255, 255], lightgoldenrodyellow: [250, 250, 210], lightgray: [211, 211, 211], lightgreen: [144, 238, 144], lightgrey: [211, 211, 211], lightpink: [255, 182, 193], lightsalmon: [255, 160, 122], lightseagreen: [32, 178, 170], lightskyblue: [135, 206, 250], lightslategray: [119, 136, 153], lightslategrey: [119, 136, 153], lightsteelblue: [176, 196, 222], lightyellow: [255, 255, 224], lime: [0, 255, 0], limegreen: [50, 205, 50], linen: [250, 240, 230], magenta: [255, 0, 255], maroon: [128, 0, 0], mediumaquamarine: [102, 205, 170], mediumblue: [0, 0, 205], mediumorchid: [186, 85, 211], mediumpurple: [147, 112, 219], mediumseagreen: [60, 179, 113], mediumslateblue: [123, 104, 238], mediumspringgreen: [0, 250, 154], mediumturquoise: [72, 209, 204], mediumvioletred: [199, 21, 133], midnightblue: [25, 25, 112], mintcream: [245, 255, 250], mistyrose: [255, 228, 225], moccasin: [255, 228, 181], navajowhite: [255, 222, 173], navy: [0, 0, 128], oldlace: [253, 245, 230], olive: [128, 128, 0], olivedrab: [107, 142, 35], orange: [255, 165, 0], orangered: [255, 69, 0], orchid: [218, 112, 214], palegoldenrod: [238, 232, 170], palegreen: [152, 251, 152], paleturquoise: [175, 238, 238], palevioletred: [219, 112, 147], papayawhip: [255, 239, 213], peachpuff: [255, 218, 185], peru: [205, 133, 63], pink: [255, 192, 203], plum: [221, 160, 221], powderblue: [176, 224, 230], purple: [128, 0, 128], rebeccapurple: [102, 51, 153], red: [255, 0, 0], rosybrown: [188, 143, 143], royalblue: [65, 105, 225], saddlebrown: [139, 69, 19], salmon: [250, 128, 114], sandybrown: [244, 164, 96], seagreen: [46, 139, 87], seashell: [255, 245, 238], sienna: [160, 82, 45], silver: [192, 192, 192], skyblue: [135, 206, 235], slateblue: [106, 90, 205], slategray: [112, 128, 144], slategrey: [112, 128, 144], snow: [255, 250, 250], springgreen: [0, 255, 127], steelblue: [70, 130, 180], tan: [210, 180, 140], teal: [0, 128, 128], thistle: [216, 191, 216], tomato: [255, 99, 71], turquoise: [64, 224, 208], violet: [238, 130, 238], wheat: [245, 222, 179], white: [255, 255, 255], whitesmoke: [245, 245, 245], yellow: [255, 255, 0], yellowgreen: [154, 205, 50] };
      class _n {
        constructor(s, u, m, b = 1, C = !0) {
          this.r = s, this.g = u, this.b = m, this.a = b, C || (this.r *= b, this.g *= b, this.b *= b, b || this.overwriteGetter("rgb", [s, u, m, b]));
        }
        static parse(s) {
          if (s instanceof _n) return s;
          if (typeof s != "string") return;
          const u = function(m) {
            if ((m = m.toLowerCase()) === "transparent") return [0, 0, 0, 0];
            const b = Yi[m];
            if (b) {
              const [k, P, D] = b;
              return [k / 255, P / 255, D / 255, 1];
            }
            if (m.startsWith("#") && /^#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/.test(m)) {
              const k = m.length < 6 ? 1 : 2;
              let P = 1;
              return [Bn(m.slice(P, P += k)), Bn(m.slice(P, P += k)), Bn(m.slice(P, P += k)), Bn(m.slice(P, P + k) || "ff")];
            }
            if (m.startsWith("rgb")) {
              const k = m.match(/^rgba?\(\s*([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/);
              if (k) {
                const [P, D, Z, X, ie, ce, he, ye, Ie, ke, He, Qe] = k, Be = [X || " ", he || " ", ke].join("");
                if (Be === "  " || Be === "  /" || Be === ",," || Be === ",,,") {
                  const lt = [Z, ce, Ie].join(""), ut = lt === "%%%" ? 100 : lt === "" ? 255 : 0;
                  if (ut) {
                    const vt = [Un(+D / ut, 0, 1), Un(+ie / ut, 0, 1), Un(+ye / ut, 0, 1), He ? An(+He, Qe) : 1];
                    if (ei(vt)) return vt;
                  }
                }
                return;
              }
            }
            const C = m.match(/^hsla?\(\s*([\de.+-]+)(?:deg)?(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/);
            if (C) {
              const [k, P, D, Z, X, ie, ce, he, ye] = C, Ie = [D || " ", X || " ", ce].join("");
              if (Ie === "  " || Ie === "  /" || Ie === ",," || Ie === ",,,") {
                const ke = [+P, Un(+Z, 0, 100), Un(+ie, 0, 100), he ? An(+he, ye) : 1];
                if (ei(ke)) return function([He, Qe, Be, lt]) {
                  function ut(vt) {
                    const Xt = (vt + He / 30) % 12, nn = Qe * Math.min(Be, 1 - Be);
                    return Be - nn * Math.max(-1, Math.min(Xt - 3, 9 - Xt, 1));
                  }
                  return He = _t(He), Qe /= 100, Be /= 100, [ut(0), ut(8), ut(4), lt];
                }(ke);
              }
            }
          }(s);
          return u ? new _n(...u, !1) : void 0;
        }
        get rgb() {
          const { r: s, g: u, b: m, a: b } = this, C = b || 1 / 0;
          return this.overwriteGetter("rgb", [s / C, u / C, m / C, b]);
        }
        get hcl() {
          return this.overwriteGetter("hcl", function(s) {
            const [u, m, b, C] = yt(s), k = Math.sqrt(m * m + b * b);
            return [Math.round(1e4 * k) ? _t(Math.atan2(b, m) * nt) : NaN, k, u, C];
          }(this.rgb));
        }
        get lab() {
          return this.overwriteGetter("lab", yt(this.rgb));
        }
        overwriteGetter(s, u) {
          return Object.defineProperty(this, s, { value: u }), u;
        }
        toString() {
          const [s, u, m, b] = this.rgb;
          return `rgba(${[s, u, m].map((C) => Math.round(255 * C)).join(",")},${b})`;
        }
      }
      _n.black = new _n(0, 0, 0, 1), _n.white = new _n(1, 1, 1, 1), _n.transparent = new _n(0, 0, 0, 0), _n.red = new _n(1, 0, 0, 1);
      class Ni {
        constructor(s, u, m) {
          this.sensitivity = s ? u ? "variant" : "case" : u ? "accent" : "base", this.locale = m, this.collator = new Intl.Collator(this.locale ? this.locale : [], { sensitivity: this.sensitivity, usage: "search" });
        }
        compare(s, u) {
          return this.collator.compare(s, u);
        }
        resolvedLocale() {
          return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
        }
      }
      class Dr {
        constructor(s, u, m, b, C) {
          this.text = s, this.image = u, this.scale = m, this.fontStack = b, this.textColor = C;
        }
      }
      class ar {
        constructor(s) {
          this.sections = s;
        }
        static fromString(s) {
          return new ar([new Dr(s, null, null, null, null)]);
        }
        isEmpty() {
          return this.sections.length === 0 || !this.sections.some((s) => s.text.length !== 0 || s.image && s.image.name.length !== 0);
        }
        static factory(s) {
          return s instanceof ar ? s : ar.fromString(s);
        }
        toString() {
          return this.sections.length === 0 ? "" : this.sections.map((s) => s.text).join("");
        }
      }
      class Zr {
        constructor(s) {
          this.values = s.slice();
        }
        static parse(s) {
          if (s instanceof Zr) return s;
          if (typeof s == "number") return new Zr([s, s, s, s]);
          if (Array.isArray(s) && !(s.length < 1 || s.length > 4)) {
            for (const u of s) if (typeof u != "number") return;
            switch (s.length) {
              case 1:
                s = [s[0], s[0], s[0], s[0]];
                break;
              case 2:
                s = [s[0], s[1], s[0], s[1]];
                break;
              case 3:
                s = [s[0], s[1], s[2], s[1]];
            }
            return new Zr(s);
          }
        }
        toString() {
          return JSON.stringify(this.values);
        }
      }
      class ns {
        constructor(s) {
          this.name = s.name, this.available = s.available;
        }
        toString() {
          return this.name;
        }
        static fromString(s) {
          return s ? new ns({ name: s, available: !1 }) : null;
        }
      }
      function Uo(l, s, u, m) {
        return typeof l == "number" && l >= 0 && l <= 255 && typeof s == "number" && s >= 0 && s <= 255 && typeof u == "number" && u >= 0 && u <= 255 ? m === void 0 || typeof m == "number" && m >= 0 && m <= 1 ? null : `Invalid rgba value [${[l, s, u, m].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid rgba value [${(typeof m == "number" ? [l, s, u, m] : [l, s, u]).join(", ")}]: 'r', 'g', and 'b' must be between 0 and 255.`;
      }
      function al(l) {
        if (l === null || typeof l == "string" || typeof l == "boolean" || typeof l == "number" || l instanceof _n || l instanceof Ni || l instanceof ar || l instanceof Zr || l instanceof ns) return !0;
        if (Array.isArray(l)) {
          for (const s of l) if (!al(s)) return !1;
          return !0;
        }
        if (typeof l == "object") {
          for (const s in l) if (!al(l[s])) return !1;
          return !0;
        }
        return !1;
      }
      function Bi(l) {
        if (l === null) return hs;
        if (typeof l == "string") return $n;
        if (typeof l == "boolean") return yn;
        if (typeof l == "number") return Pt;
        if (l instanceof _n) return Qi;
        if (l instanceof Ni) return or;
        if (l instanceof ar) return Wr;
        if (l instanceof Zr) return kr;
        if (l instanceof ns) return fs;
        if (Array.isArray(l)) {
          const s = l.length;
          let u;
          for (const m of l) {
            const b = Bi(m);
            if (u) {
              if (u === b) continue;
              u = Cn;
              break;
            }
            u = b;
          }
          return tr(u || Cn, s);
        }
        return Gi;
      }
      function Us(l) {
        const s = typeof l;
        return l === null ? "" : s === "string" || s === "number" || s === "boolean" ? String(l) : l instanceof _n || l instanceof ar || l instanceof Zr || l instanceof ns ? l.toString() : JSON.stringify(l);
      }
      class Es {
        constructor(s, u) {
          this.type = s, this.value = u;
        }
        static parse(s, u) {
          if (s.length !== 2) return u.error(`'literal' expression requires exactly one argument, but found ${s.length - 1} instead.`);
          if (!al(s[1])) return u.error("invalid value");
          const m = s[1];
          let b = Bi(m);
          const C = u.expectedType;
          return b.kind !== "array" || b.N !== 0 || !C || C.kind !== "array" || typeof C.N == "number" && C.N !== 0 || (b = C), new Es(b, m);
        }
        evaluate() {
          return this.value;
        }
        eachChild() {
        }
        outputDefined() {
          return !0;
        }
      }
      class Vi {
        constructor(s) {
          this.name = "ExpressionEvaluationError", this.message = s;
        }
        toJSON() {
          return this.message;
        }
      }
      const ao = { string: $n, number: Pt, boolean: yn, object: Gi };
      class Ln {
        constructor(s, u) {
          this.type = s, this.args = u;
        }
        static parse(s, u) {
          if (s.length < 2) return u.error("Expected at least one argument.");
          let m, b = 1;
          const C = s[0];
          if (C === "array") {
            let P, D;
            if (s.length > 2) {
              const Z = s[1];
              if (typeof Z != "string" || !(Z in ao) || Z === "object") return u.error('The item type argument of "array" must be one of string, number, boolean', 1);
              P = ao[Z], b++;
            } else P = Cn;
            if (s.length > 3) {
              if (s[2] !== null && (typeof s[2] != "number" || s[2] < 0 || s[2] !== Math.floor(s[2]))) return u.error('The length argument to "array" must be a positive integer literal', 2);
              D = s[2], b++;
            }
            m = tr(P, D);
          } else {
            if (!ao[C]) throw new Error(`Types doesn't contain name = ${C}`);
            m = ao[C];
          }
          const k = [];
          for (; b < s.length; b++) {
            const P = u.parse(s[b], b, Cn);
            if (!P) return null;
            k.push(P);
          }
          return new Ln(m, k);
        }
        evaluate(s) {
          for (let u = 0; u < this.args.length; u++) {
            const m = this.args[u].evaluate(s);
            if (!As(this.type, Bi(m))) return m;
            if (u === this.args.length - 1) throw new Vi(`Expected value to be of type ${pi(this.type)}, but found ${pi(Bi(m))} instead.`);
          }
          throw new Error();
        }
        eachChild(s) {
          this.args.forEach(s);
        }
        outputDefined() {
          return this.args.every((s) => s.outputDefined());
        }
      }
      const xi = { "to-boolean": yn, "to-color": Qi, "to-number": Pt, "to-string": $n };
      class Ki {
        constructor(s, u) {
          this.type = s, this.args = u;
        }
        static parse(s, u) {
          if (s.length < 2) return u.error("Expected at least one argument.");
          const m = s[0];
          if (!xi[m]) throw new Error(`Can't parse ${m} as it is not part of the known types`);
          if ((m === "to-boolean" || m === "to-string") && s.length !== 2) return u.error("Expected one argument.");
          const b = xi[m], C = [];
          for (let k = 1; k < s.length; k++) {
            const P = u.parse(s[k], k, Cn);
            if (!P) return null;
            C.push(P);
          }
          return new Ki(b, C);
        }
        evaluate(s) {
          if (this.type.kind === "boolean") return !!this.args[0].evaluate(s);
          if (this.type.kind === "color") {
            let u, m;
            for (const b of this.args) {
              if (u = b.evaluate(s), m = null, u instanceof _n) return u;
              if (typeof u == "string") {
                const C = s.parseColor(u);
                if (C) return C;
              } else if (Array.isArray(u) && (m = u.length < 3 || u.length > 4 ? `Invalid rbga value ${JSON.stringify(u)}: expected an array containing either three or four numeric values.` : Uo(u[0], u[1], u[2], u[3]), !m)) return new _n(u[0] / 255, u[1] / 255, u[2] / 255, u[3]);
            }
            throw new Vi(m || `Could not parse color from value '${typeof u == "string" ? u : JSON.stringify(u)}'`);
          }
          if (this.type.kind === "padding") {
            let u;
            for (const m of this.args) {
              u = m.evaluate(s);
              const b = Zr.parse(u);
              if (b) return b;
            }
            throw new Vi(`Could not parse padding from value '${typeof u == "string" ? u : JSON.stringify(u)}'`);
          }
          if (this.type.kind === "number") {
            let u = null;
            for (const m of this.args) {
              if (u = m.evaluate(s), u === null) return 0;
              const b = Number(u);
              if (!isNaN(b)) return b;
            }
            throw new Vi(`Could not convert ${JSON.stringify(u)} to number.`);
          }
          return this.type.kind === "formatted" ? ar.fromString(Us(this.args[0].evaluate(s))) : this.type.kind === "resolvedImage" ? ns.fromString(Us(this.args[0].evaluate(s))) : Us(this.args[0].evaluate(s));
        }
        eachChild(s) {
          this.args.forEach(s);
        }
        outputDefined() {
          return this.args.every((s) => s.outputDefined());
        }
      }
      const Hs = ["Unknown", "Point", "LineString", "Polygon"];
      class ms {
        constructor() {
          this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = {}, this.availableImages = null, this.canonical = null;
        }
        id() {
          return this.feature && "id" in this.feature ? this.feature.id : null;
        }
        geometryType() {
          return this.feature ? typeof this.feature.type == "number" ? Hs[this.feature.type] : this.feature.type : null;
        }
        geometry() {
          return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
        }
        canonicalID() {
          return this.canonical;
        }
        properties() {
          return this.feature && this.feature.properties || {};
        }
        parseColor(s) {
          let u = this._parseColorCache[s];
          return u || (u = this._parseColorCache[s] = _n.parse(s)), u;
        }
      }
      class Ps {
        constructor(s, u, m = [], b, C = new Hr(), k = []) {
          this.registry = s, this.path = m, this.key = m.map((P) => `[${P}]`).join(""), this.scope = C, this.errors = k, this.expectedType = b, this._isConstant = u;
        }
        parse(s, u, m, b, C = {}) {
          return u ? this.concat(u, m, b)._parse(s, C) : this._parse(s, C);
        }
        _parse(s, u) {
          function m(b, C, k) {
            return k === "assert" ? new Ln(C, [b]) : k === "coerce" ? new Ki(C, [b]) : b;
          }
          if (s !== null && typeof s != "string" && typeof s != "boolean" && typeof s != "number" || (s = ["literal", s]), Array.isArray(s)) {
            if (s.length === 0) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
            const b = s[0];
            if (typeof b != "string") return this.error(`Expression name must be a string, but found ${typeof b} instead. If you wanted a literal array, use ["literal", [...]].`, 0), null;
            const C = this.registry[b];
            if (C) {
              let k = C.parse(s, this);
              if (!k) return null;
              if (this.expectedType) {
                const P = this.expectedType, D = k.type;
                if (P.kind !== "string" && P.kind !== "number" && P.kind !== "boolean" && P.kind !== "object" && P.kind !== "array" || D.kind !== "value") if (P.kind !== "color" && P.kind !== "formatted" && P.kind !== "resolvedImage" || D.kind !== "value" && D.kind !== "string") if (P.kind !== "padding" || D.kind !== "value" && D.kind !== "number" && D.kind !== "array") {
                  if (this.checkSubtype(P, D)) return null;
                } else k = m(k, P, u.typeAnnotation || "coerce");
                else k = m(k, P, u.typeAnnotation || "coerce");
                else k = m(k, P, u.typeAnnotation || "assert");
              }
              if (!(k instanceof Es) && k.type.kind !== "resolvedImage" && this._isConstant(k)) {
                const P = new ms();
                try {
                  k = new Es(k.type, k.evaluate(P));
                } catch (D) {
                  return this.error(D.message), null;
                }
              }
              return k;
            }
            return this.error(`Unknown expression "${b}". If you wanted a literal array, use ["literal", [...]].`, 0);
          }
          return this.error(s === void 0 ? "'undefined' value invalid. Use null instead." : typeof s == "object" ? 'Bare objects invalid. Use ["literal", {...}] instead.' : `Expected an array, but found ${typeof s} instead.`);
        }
        concat(s, u, m) {
          const b = typeof s == "number" ? this.path.concat(s) : this.path, C = m ? this.scope.concat(m) : this.scope;
          return new Ps(this.registry, this._isConstant, b, u || null, C, this.errors);
        }
        error(s, ...u) {
          const m = `${this.key}${u.map((b) => `[${b}]`).join("")}`;
          this.errors.push(new ai(m, s));
        }
        checkSubtype(s, u) {
          const m = As(s, u);
          return m && this.error(m), m;
        }
      }
      class jt {
        constructor(s, u, m) {
          this.type = or, this.locale = m, this.caseSensitive = s, this.diacriticSensitive = u;
        }
        static parse(s, u) {
          if (s.length !== 2) return u.error("Expected one argument.");
          const m = s[1];
          if (typeof m != "object" || Array.isArray(m)) return u.error("Collator options argument must be an object.");
          const b = u.parse(m["case-sensitive"] !== void 0 && m["case-sensitive"], 1, yn);
          if (!b) return null;
          const C = u.parse(m["diacritic-sensitive"] !== void 0 && m["diacritic-sensitive"], 1, yn);
          if (!C) return null;
          let k = null;
          return m.locale && (k = u.parse(m.locale, 1, $n), !k) ? null : new jt(b, C, k);
        }
        evaluate(s) {
          return new Ni(this.caseSensitive.evaluate(s), this.diacriticSensitive.evaluate(s), this.locale ? this.locale.evaluate(s) : null);
        }
        eachChild(s) {
          s(this.caseSensitive), s(this.diacriticSensitive), this.locale && s(this.locale);
        }
        outputDefined() {
          return !1;
        }
      }
      const hi = 8192;
      function qr(l, s) {
        l[0] = Math.min(l[0], s[0]), l[1] = Math.min(l[1], s[1]), l[2] = Math.max(l[2], s[0]), l[3] = Math.max(l[3], s[1]);
      }
      function ko(l, s) {
        return !(l[0] <= s[0] || l[2] >= s[2] || l[1] <= s[1] || l[3] >= s[3]);
      }
      function Mt(l, s) {
        const u = (180 + l[0]) / 360, m = (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + l[1] * Math.PI / 360))) / 360, b = Math.pow(2, s.z);
        return [Math.round(u * b * hi), Math.round(m * b * hi)];
      }
      function Fn(l, s, u) {
        const m = l[0] - s[0], b = l[1] - s[1], C = l[0] - u[0], k = l[1] - u[1];
        return m * k - C * b == 0 && m * C <= 0 && b * k <= 0;
      }
      function In(l, s) {
        let u = !1;
        for (let k = 0, P = s.length; k < P; k++) {
          const D = s[k];
          for (let Z = 0, X = D.length; Z < X - 1; Z++) {
            if (Fn(l, D[Z], D[Z + 1])) return !1;
            (b = D[Z])[1] > (m = l)[1] != (C = D[Z + 1])[1] > m[1] && m[0] < (C[0] - b[0]) * (m[1] - b[1]) / (C[1] - b[1]) + b[0] && (u = !u);
          }
        }
        var m, b, C;
        return u;
      }
      function ti(l, s) {
        for (let u = 0; u < s.length; u++) if (In(l, s[u])) return !0;
        return !1;
      }
      function Xn(l, s, u, m) {
        const b = m[0] - u[0], C = m[1] - u[1], k = (l[0] - u[0]) * C - b * (l[1] - u[1]), P = (s[0] - u[0]) * C - b * (s[1] - u[1]);
        return k > 0 && P < 0 || k < 0 && P > 0;
      }
      function ya(l, s, u) {
        for (const Z of u) for (let X = 0; X < Z.length - 1; ++X) if ((P = [(k = Z[X + 1])[0] - (C = Z[X])[0], k[1] - C[1]])[0] * (D = [(b = s)[0] - (m = l)[0], b[1] - m[1]])[1] - P[1] * D[0] != 0 && Xn(m, b, C, k) && Xn(C, k, m, b)) return !0;
        var m, b, C, k, P, D;
        return !1;
      }
      function ll(l, s) {
        for (let u = 0; u < l.length; ++u) if (!In(l[u], s)) return !1;
        for (let u = 0; u < l.length - 1; ++u) if (ya(l[u], l[u + 1], s)) return !1;
        return !0;
      }
      function Gl(l, s) {
        for (let u = 0; u < s.length; u++) if (ll(l, s[u])) return !0;
        return !1;
      }
      function Yl(l, s, u) {
        const m = [];
        for (let b = 0; b < l.length; b++) {
          const C = [];
          for (let k = 0; k < l[b].length; k++) {
            const P = Mt(l[b][k], u);
            qr(s, P), C.push(P);
          }
          m.push(C);
        }
        return m;
      }
      function _a(l, s, u) {
        const m = [];
        for (let b = 0; b < l.length; b++) {
          const C = Yl(l[b], s, u);
          m.push(C);
        }
        return m;
      }
      function Kl(l, s, u, m) {
        if (l[0] < u[0] || l[0] > u[2]) {
          const b = 0.5 * m;
          let C = l[0] - u[0] > b ? -m : u[0] - l[0] > b ? m : 0;
          C === 0 && (C = l[0] - u[2] > b ? -m : u[2] - l[0] > b ? m : 0), l[0] += C;
        }
        qr(s, l);
      }
      function Wc(l, s, u, m) {
        const b = Math.pow(2, m.z) * hi, C = [m.x * hi, m.y * hi], k = [];
        for (const P of l) for (const D of P) {
          const Z = [D.x + C[0], D.y + C[1]];
          Kl(Z, s, u, b), k.push(Z);
        }
        return k;
      }
      function Xl(l, s, u, m) {
        const b = Math.pow(2, m.z) * hi, C = [m.x * hi, m.y * hi], k = [];
        for (const D of l) {
          const Z = [];
          for (const X of D) {
            const ie = [X.x + C[0], X.y + C[1]];
            qr(s, ie), Z.push(ie);
          }
          k.push(Z);
        }
        if (s[2] - s[0] <= b / 2) {
          (P = s)[0] = P[1] = 1 / 0, P[2] = P[3] = -1 / 0;
          for (const D of k) for (const Z of D) Kl(Z, s, u, b);
        }
        var P;
        return k;
      }
      class Ws {
        constructor(s, u) {
          this.type = yn, this.geojson = s, this.geometries = u;
        }
        static parse(s, u) {
          if (s.length !== 2) return u.error(`'within' expression requires exactly one argument, but found ${s.length - 1} instead.`);
          if (al(s[1])) {
            const m = s[1];
            if (m.type === "FeatureCollection") for (let b = 0; b < m.features.length; ++b) {
              const C = m.features[b].geometry.type;
              if (C === "Polygon" || C === "MultiPolygon") return new Ws(m, m.features[b].geometry);
            }
            else if (m.type === "Feature") {
              const b = m.geometry.type;
              if (b === "Polygon" || b === "MultiPolygon") return new Ws(m, m.geometry);
            } else if (m.type === "Polygon" || m.type === "MultiPolygon") return new Ws(m, m);
          }
          return u.error("'within' expression requires valid geojson object that contains polygon geometry type.");
        }
        evaluate(s) {
          if (s.geometry() != null && s.canonicalID() != null) {
            if (s.geometryType() === "Point") return function(u, m) {
              const b = [1 / 0, 1 / 0, -1 / 0, -1 / 0], C = [1 / 0, 1 / 0, -1 / 0, -1 / 0], k = u.canonicalID();
              if (m.type === "Polygon") {
                const P = Yl(m.coordinates, C, k), D = Wc(u.geometry(), b, C, k);
                if (!ko(b, C)) return !1;
                for (const Z of D) if (!In(Z, P)) return !1;
              }
              if (m.type === "MultiPolygon") {
                const P = _a(m.coordinates, C, k), D = Wc(u.geometry(), b, C, k);
                if (!ko(b, C)) return !1;
                for (const Z of D) if (!ti(Z, P)) return !1;
              }
              return !0;
            }(s, this.geometries);
            if (s.geometryType() === "LineString") return function(u, m) {
              const b = [1 / 0, 1 / 0, -1 / 0, -1 / 0], C = [1 / 0, 1 / 0, -1 / 0, -1 / 0], k = u.canonicalID();
              if (m.type === "Polygon") {
                const P = Yl(m.coordinates, C, k), D = Xl(u.geometry(), b, C, k);
                if (!ko(b, C)) return !1;
                for (const Z of D) if (!ll(Z, P)) return !1;
              }
              if (m.type === "MultiPolygon") {
                const P = _a(m.coordinates, C, k), D = Xl(u.geometry(), b, C, k);
                if (!ko(b, C)) return !1;
                for (const Z of D) if (!Gl(Z, P)) return !1;
              }
              return !0;
            }(s, this.geometries);
          }
          return !1;
        }
        eachChild() {
        }
        outputDefined() {
          return !0;
        }
      }
      class cl {
        constructor(s, u) {
          this.type = u.type, this.name = s, this.boundExpression = u;
        }
        static parse(s, u) {
          if (s.length !== 2 || typeof s[1] != "string") return u.error("'var' expression requires exactly one string literal argument.");
          const m = s[1];
          return u.scope.has(m) ? new cl(m, u.scope.get(m)) : u.error(`Unknown variable "${m}". Make sure "${m}" has been bound in an enclosing "let" expression before using it.`, 1);
        }
        evaluate(s) {
          return this.boundExpression.evaluate(s);
        }
        eachChild() {
        }
        outputDefined() {
          return !1;
        }
      }
      class jr {
        constructor(s, u, m, b) {
          this.name = s, this.type = u, this._evaluate = m, this.args = b;
        }
        evaluate(s) {
          return this._evaluate(s, this.args);
        }
        eachChild(s) {
          this.args.forEach(s);
        }
        outputDefined() {
          return !1;
        }
        static parse(s, u) {
          const m = s[0], b = jr.definitions[m];
          if (!b) return u.error(`Unknown expression "${m}". If you wanted a literal array, use ["literal", [...]].`, 0);
          const C = Array.isArray(b) ? b[0] : b.type, k = Array.isArray(b) ? [[b[1], b[2]]] : b.overloads, P = k.filter(([Z]) => !Array.isArray(Z) || Z.length === s.length - 1);
          let D = null;
          for (const [Z, X] of P) {
            D = new Ps(u.registry, Jl, u.path, null, u.scope);
            const ie = [];
            let ce = !1;
            for (let he = 1; he < s.length; he++) {
              const ye = s[he], Ie = Array.isArray(Z) ? Z[he - 1] : Z.type, ke = D.parse(ye, 1 + ie.length, Ie);
              if (!ke) {
                ce = !0;
                break;
              }
              ie.push(ke);
            }
            if (!ce) if (Array.isArray(Z) && Z.length !== ie.length) D.error(`Expected ${Z.length} arguments, but found ${ie.length} instead.`);
            else {
              for (let he = 0; he < ie.length; he++) {
                const ye = Array.isArray(Z) ? Z[he] : Z.type, Ie = ie[he];
                D.concat(he + 1).checkSubtype(ye, Ie.type);
              }
              if (D.errors.length === 0) return new jr(m, C, X, ie);
            }
          }
          if (P.length === 1) u.errors.push(...D.errors);
          else {
            const Z = (P.length ? P : k).map(([ie]) => {
              return ce = ie, Array.isArray(ce) ? `(${ce.map(pi).join(", ")})` : `(${pi(ce.type)}...)`;
              var ce;
            }).join(" | "), X = [];
            for (let ie = 1; ie < s.length; ie++) {
              const ce = u.parse(s[ie], 1 + X.length);
              if (!ce) return null;
              X.push(pi(ce.type));
            }
            u.error(`Expected arguments of type ${Z}, but found (${X.join(", ")}) instead.`);
          }
          return null;
        }
        static register(s, u) {
          jr.definitions = u;
          for (const m in u) s[m] = jr;
        }
      }
      function Jl(l) {
        if (l instanceof cl) return Jl(l.boundExpression);
        if (l instanceof jr && l.name === "error" || l instanceof jt || l instanceof Ws) return !1;
        const s = l instanceof Ki || l instanceof Ln;
        let u = !0;
        return l.eachChild((m) => {
          u = s ? u && Jl(m) : u && m instanceof Es;
        }), !!u && ba(l) && Mn(l, ["zoom", "heatmap-density", "line-progress", "accumulated", "is-supported-script"]);
      }
      function ba(l) {
        if (l instanceof jr && (l.name === "get" && l.args.length === 1 || l.name === "feature-state" || l.name === "has" && l.args.length === 1 || l.name === "properties" || l.name === "geometry-type" || l.name === "id" || /^filter-/.test(l.name)) || l instanceof Ws) return !1;
        let s = !0;
        return l.eachChild((u) => {
          s && !ba(u) && (s = !1);
        }), s;
      }
      function ul(l) {
        if (l instanceof jr && l.name === "feature-state") return !1;
        let s = !0;
        return l.eachChild((u) => {
          s && !ul(u) && (s = !1);
        }), s;
      }
      function Mn(l, s) {
        if (l instanceof jr && s.indexOf(l.name) >= 0) return !1;
        let u = !0;
        return l.eachChild((m) => {
          u && !Mn(m, s) && (u = !1);
        }), u;
      }
      function vs(l, s) {
        const u = l.length - 1;
        let m, b, C = 0, k = u, P = 0;
        for (; C <= k; ) if (P = Math.floor((C + k) / 2), m = l[P], b = l[P + 1], m <= s) {
          if (P === u || s < b) return P;
          C = P + 1;
        } else {
          if (!(m > s)) throw new Vi("Input is not a number.");
          k = P - 1;
        }
        return 0;
      }
      class li {
        constructor(s, u, m) {
          this.type = s, this.input = u, this.labels = [], this.outputs = [];
          for (const [b, C] of m) this.labels.push(b), this.outputs.push(C);
        }
        static parse(s, u) {
          if (s.length - 1 < 4) return u.error(`Expected at least 4 arguments, but found only ${s.length - 1}.`);
          if ((s.length - 1) % 2 != 0) return u.error("Expected an even number of arguments.");
          const m = u.parse(s[1], 1, Pt);
          if (!m) return null;
          const b = [];
          let C = null;
          u.expectedType && u.expectedType.kind !== "value" && (C = u.expectedType);
          for (let k = 1; k < s.length; k += 2) {
            const P = k === 1 ? -1 / 0 : s[k], D = s[k + 1], Z = k, X = k + 1;
            if (typeof P != "number") return u.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', Z);
            if (b.length && b[b.length - 1][0] >= P) return u.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', Z);
            const ie = u.parse(D, X, C);
            if (!ie) return null;
            C = C || ie.type, b.push([P, ie]);
          }
          return new li(C, m, b);
        }
        evaluate(s) {
          const u = this.labels, m = this.outputs;
          if (u.length === 1) return m[0].evaluate(s);
          const b = this.input.evaluate(s);
          if (b <= u[0]) return m[0].evaluate(s);
          const C = u.length;
          return b >= u[C - 1] ? m[C - 1].evaluate(s) : m[vs(u, b)].evaluate(s);
        }
        eachChild(s) {
          s(this.input);
          for (const u of this.outputs) s(u);
        }
        outputDefined() {
          return this.outputs.every((s) => s.outputDefined());
        }
      }
      function wa(l, s, u) {
        return l + u * (s - l);
      }
      function dl(l, s, u) {
        return l.map((m, b) => wa(m, s[b], u));
      }
      const Gr = { number: wa, color: function(l, s, u, m = "rgb") {
        switch (m) {
          case "rgb": {
            const [b, C, k, P] = dl(l.rgb, s.rgb, u);
            return new _n(b, C, k, P, !1);
          }
          case "hcl": {
            const [b, C, k, P] = l.hcl, [D, Z, X, ie] = s.hcl;
            let ce, he;
            if (isNaN(b) || isNaN(D)) isNaN(b) ? isNaN(D) ? ce = NaN : (ce = D, k !== 1 && k !== 0 || (he = Z)) : (ce = b, X !== 1 && X !== 0 || (he = C));
            else {
              let Qe = D - b;
              D > b && Qe > 180 ? Qe -= 360 : D < b && b - D > 180 && (Qe += 360), ce = b + u * Qe;
            }
            const [ye, Ie, ke, He] = function([Qe, Be, lt, ut]) {
              return Qe = isNaN(Qe) ? 0 : Qe * Ye, Kt([lt, Math.cos(Qe) * Be, Math.sin(Qe) * Be, ut]);
            }([ce, he ?? wa(C, Z, u), wa(k, X, u), wa(P, ie, u)]);
            return new _n(ye, Ie, ke, He, !1);
          }
          case "lab": {
            const [b, C, k, P] = Kt(dl(l.lab, s.lab, u));
            return new _n(b, C, k, P, !1);
          }
        }
      }, array: dl, padding: function(l, s, u) {
        return new Zr(dl(l.values, s.values, u));
      } };
      class Yr {
        constructor(s, u, m, b, C) {
          this.type = s, this.operator = u, this.interpolation = m, this.input = b, this.labels = [], this.outputs = [];
          for (const [k, P] of C) this.labels.push(k), this.outputs.push(P);
        }
        static interpolationFactor(s, u, m, b) {
          let C = 0;
          if (s.name === "exponential") C = So(u, s.base, m, b);
          else if (s.name === "linear") C = So(u, 1, m, b);
          else if (s.name === "cubic-bezier") {
            const k = s.controlPoints;
            C = new O(k[0], k[1], k[2], k[3]).solve(So(u, 1, m, b));
          }
          return C;
        }
        static parse(s, u) {
          let [m, b, C, ...k] = s;
          if (!Array.isArray(b) || b.length === 0) return u.error("Expected an interpolation type expression.", 1);
          if (b[0] === "linear") b = { name: "linear" };
          else if (b[0] === "exponential") {
            const Z = b[1];
            if (typeof Z != "number") return u.error("Exponential interpolation requires a numeric base.", 1, 1);
            b = { name: "exponential", base: Z };
          } else {
            if (b[0] !== "cubic-bezier") return u.error(`Unknown interpolation type ${String(b[0])}`, 1, 0);
            {
              const Z = b.slice(1);
              if (Z.length !== 4 || Z.some((X) => typeof X != "number" || X < 0 || X > 1)) return u.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
              b = { name: "cubic-bezier", controlPoints: Z };
            }
          }
          if (s.length - 1 < 4) return u.error(`Expected at least 4 arguments, but found only ${s.length - 1}.`);
          if ((s.length - 1) % 2 != 0) return u.error("Expected an even number of arguments.");
          if (C = u.parse(C, 2, Pt), !C) return null;
          const P = [];
          let D = null;
          m === "interpolate-hcl" || m === "interpolate-lab" ? D = Qi : u.expectedType && u.expectedType.kind !== "value" && (D = u.expectedType);
          for (let Z = 0; Z < k.length; Z += 2) {
            const X = k[Z], ie = k[Z + 1], ce = Z + 3, he = Z + 4;
            if (typeof X != "number") return u.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', ce);
            if (P.length && P[P.length - 1][0] >= X) return u.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', ce);
            const ye = u.parse(ie, he, D);
            if (!ye) return null;
            D = D || ye.type, P.push([X, ye]);
          }
          return ue(D, Pt) || ue(D, Qi) || ue(D, kr) || ue(D, tr(Pt)) ? new Yr(D, m, b, C, P) : u.error(`Type ${pi(D)} is not interpolatable.`);
        }
        evaluate(s) {
          const u = this.labels, m = this.outputs;
          if (u.length === 1) return m[0].evaluate(s);
          const b = this.input.evaluate(s);
          if (b <= u[0]) return m[0].evaluate(s);
          const C = u.length;
          if (b >= u[C - 1]) return m[C - 1].evaluate(s);
          const k = vs(u, b), P = Yr.interpolationFactor(this.interpolation, b, u[k], u[k + 1]), D = m[k].evaluate(s), Z = m[k + 1].evaluate(s);
          switch (this.operator) {
            case "interpolate":
              return Gr[this.type.kind](D, Z, P);
            case "interpolate-hcl":
              return Gr.color(D, Z, P, "hcl");
            case "interpolate-lab":
              return Gr.color(D, Z, P, "lab");
          }
        }
        eachChild(s) {
          s(this.input);
          for (const u of this.outputs) s(u);
        }
        outputDefined() {
          return this.outputs.every((s) => s.outputDefined());
        }
      }
      function So(l, s, u, m) {
        const b = m - u, C = l - u;
        return b === 0 ? 0 : s === 1 ? C / b : (Math.pow(s, C) - 1) / (Math.pow(s, b) - 1);
      }
      class pl {
        constructor(s, u) {
          this.type = s, this.args = u;
        }
        static parse(s, u) {
          if (s.length < 2) return u.error("Expectected at least one argument.");
          let m = null;
          const b = u.expectedType;
          b && b.kind !== "value" && (m = b);
          const C = [];
          for (const P of s.slice(1)) {
            const D = u.parse(P, 1 + C.length, m, void 0, { typeAnnotation: "omit" });
            if (!D) return null;
            m = m || D.type, C.push(D);
          }
          if (!m) throw new Error("No output type");
          const k = b && C.some((P) => As(b, P.type));
          return new pl(k ? Cn : m, C);
        }
        evaluate(s) {
          let u, m = null, b = 0;
          for (const C of this.args) if (b++, m = C.evaluate(s), m && m instanceof ns && !m.available && (u || (u = m.name), m = null, b === this.args.length && (m = u)), m !== null) break;
          return m;
        }
        eachChild(s) {
          this.args.forEach(s);
        }
        outputDefined() {
          return this.args.every((s) => s.outputDefined());
        }
      }
      class Ho {
        constructor(s, u) {
          this.type = u.type, this.bindings = [].concat(s), this.result = u;
        }
        evaluate(s) {
          return this.result.evaluate(s);
        }
        eachChild(s) {
          for (const u of this.bindings) s(u[1]);
          s(this.result);
        }
        static parse(s, u) {
          if (s.length < 4) return u.error(`Expected at least 3 arguments, but found ${s.length - 1} instead.`);
          const m = [];
          for (let C = 1; C < s.length - 1; C += 2) {
            const k = s[C];
            if (typeof k != "string") return u.error(`Expected string, but found ${typeof k} instead.`, C);
            if (/[^a-zA-Z0-9_]/.test(k)) return u.error("Variable names must contain only alphanumeric characters or '_'.", C);
            const P = u.parse(s[C + 1], C + 1);
            if (!P) return null;
            m.push([k, P]);
          }
          const b = u.parse(s[s.length - 1], s.length - 1, u.expectedType, m);
          return b ? new Ho(m, b) : null;
        }
        outputDefined() {
          return this.result.outputDefined();
        }
      }
      class lr {
        constructor(s, u, m) {
          this.type = s, this.index = u, this.input = m;
        }
        static parse(s, u) {
          if (s.length !== 3) return u.error(`Expected 2 arguments, but found ${s.length - 1} instead.`);
          const m = u.parse(s[1], 1, Pt), b = u.parse(s[2], 2, tr(u.expectedType || Cn));
          return m && b ? new lr(b.type.itemType, m, b) : null;
        }
        evaluate(s) {
          const u = this.index.evaluate(s), m = this.input.evaluate(s);
          if (u < 0) throw new Vi(`Array index out of bounds: ${u} < 0.`);
          if (u >= m.length) throw new Vi(`Array index out of bounds: ${u} > ${m.length - 1}.`);
          if (u !== Math.floor(u)) throw new Vi(`Array index must be an integer, but found ${u} instead.`);
          return m[u];
        }
        eachChild(s) {
          s(this.index), s(this.input);
        }
        outputDefined() {
          return !1;
        }
      }
      class Zs {
        constructor(s, u) {
          this.type = yn, this.needle = s, this.haystack = u;
        }
        static parse(s, u) {
          if (s.length !== 3) return u.error(`Expected 2 arguments, but found ${s.length - 1} instead.`);
          const m = u.parse(s[1], 1, Cn), b = u.parse(s[2], 2, Cn);
          return m && b ? Te(m.type, [yn, $n, Pt, hs, Cn]) ? new Zs(m, b) : u.error(`Expected first argument to be of type boolean, string, number or null, but found ${pi(m.type)} instead`) : null;
        }
        evaluate(s) {
          const u = this.needle.evaluate(s), m = this.haystack.evaluate(s);
          if (!m) return !1;
          if (!se(u, ["boolean", "string", "number", "null"])) throw new Vi(`Expected first argument to be of type boolean, string, number or null, but found ${pi(Bi(u))} instead.`);
          if (!se(m, ["string", "array"])) throw new Vi(`Expected second argument to be of type array or string, but found ${pi(Bi(m))} instead.`);
          return m.indexOf(u) >= 0;
        }
        eachChild(s) {
          s(this.needle), s(this.haystack);
        }
        outputDefined() {
          return !0;
        }
      }
      class Wo {
        constructor(s, u, m) {
          this.type = Pt, this.needle = s, this.haystack = u, this.fromIndex = m;
        }
        static parse(s, u) {
          if (s.length <= 2 || s.length >= 5) return u.error(`Expected 3 or 4 arguments, but found ${s.length - 1} instead.`);
          const m = u.parse(s[1], 1, Cn), b = u.parse(s[2], 2, Cn);
          if (!m || !b) return null;
          if (!Te(m.type, [yn, $n, Pt, hs, Cn])) return u.error(`Expected first argument to be of type boolean, string, number or null, but found ${pi(m.type)} instead`);
          if (s.length === 4) {
            const C = u.parse(s[3], 3, Pt);
            return C ? new Wo(m, b, C) : null;
          }
          return new Wo(m, b);
        }
        evaluate(s) {
          const u = this.needle.evaluate(s), m = this.haystack.evaluate(s);
          if (!se(u, ["boolean", "string", "number", "null"])) throw new Vi(`Expected first argument to be of type boolean, string, number or null, but found ${pi(Bi(u))} instead.`);
          if (!se(m, ["string", "array"])) throw new Vi(`Expected second argument to be of type array or string, but found ${pi(Bi(m))} instead.`);
          if (this.fromIndex) {
            const b = this.fromIndex.evaluate(s);
            return m.indexOf(u, b);
          }
          return m.indexOf(u);
        }
        eachChild(s) {
          s(this.needle), s(this.haystack), this.fromIndex && s(this.fromIndex);
        }
        outputDefined() {
          return !1;
        }
      }
      class Yn {
        constructor(s, u, m, b, C, k) {
          this.inputType = s, this.type = u, this.input = m, this.cases = b, this.outputs = C, this.otherwise = k;
        }
        static parse(s, u) {
          if (s.length < 5) return u.error(`Expected at least 4 arguments, but found only ${s.length - 1}.`);
          if (s.length % 2 != 1) return u.error("Expected an even number of arguments.");
          let m, b;
          u.expectedType && u.expectedType.kind !== "value" && (b = u.expectedType);
          const C = {}, k = [];
          for (let Z = 2; Z < s.length - 1; Z += 2) {
            let X = s[Z];
            const ie = s[Z + 1];
            Array.isArray(X) || (X = [X]);
            const ce = u.concat(Z);
            if (X.length === 0) return ce.error("Expected at least one branch label.");
            for (const ye of X) {
              if (typeof ye != "number" && typeof ye != "string") return ce.error("Branch labels must be numbers or strings.");
              if (typeof ye == "number" && Math.abs(ye) > Number.MAX_SAFE_INTEGER) return ce.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`);
              if (typeof ye == "number" && Math.floor(ye) !== ye) return ce.error("Numeric branch labels must be integer values.");
              if (m) {
                if (ce.checkSubtype(m, Bi(ye))) return null;
              } else m = Bi(ye);
              if (C[String(ye)] !== void 0) return ce.error("Branch labels must be unique.");
              C[String(ye)] = k.length;
            }
            const he = u.parse(ie, Z, b);
            if (!he) return null;
            b = b || he.type, k.push(he);
          }
          const P = u.parse(s[1], 1, Cn);
          if (!P) return null;
          const D = u.parse(s[s.length - 1], s.length - 1, b);
          return D ? P.type.kind !== "value" && u.concat(1).checkSubtype(m, P.type) ? null : new Yn(m, b, P, C, k, D) : null;
        }
        evaluate(s) {
          const u = this.input.evaluate(s);
          return (Bi(u) === this.inputType && this.outputs[this.cases[u]] || this.otherwise).evaluate(s);
        }
        eachChild(s) {
          s(this.input), this.outputs.forEach(s), s(this.otherwise);
        }
        outputDefined() {
          return this.outputs.every((s) => s.outputDefined()) && this.otherwise.outputDefined();
        }
      }
      class Wu {
        constructor(s, u, m) {
          this.type = s, this.branches = u, this.otherwise = m;
        }
        static parse(s, u) {
          if (s.length < 4) return u.error(`Expected at least 3 arguments, but found only ${s.length - 1}.`);
          if (s.length % 2 != 0) return u.error("Expected an odd number of arguments.");
          let m;
          u.expectedType && u.expectedType.kind !== "value" && (m = u.expectedType);
          const b = [];
          for (let k = 1; k < s.length - 1; k += 2) {
            const P = u.parse(s[k], k, yn);
            if (!P) return null;
            const D = u.parse(s[k + 1], k + 1, m);
            if (!D) return null;
            b.push([P, D]), m = m || D.type;
          }
          const C = u.parse(s[s.length - 1], s.length - 1, m);
          if (!C) return null;
          if (!m) throw new Error("Can't infer output type");
          return new Wu(m, b, C);
        }
        evaluate(s) {
          for (const [u, m] of this.branches) if (u.evaluate(s)) return m.evaluate(s);
          return this.otherwise.evaluate(s);
        }
        eachChild(s) {
          for (const [u, m] of this.branches) s(u), s(m);
          s(this.otherwise);
        }
        outputDefined() {
          return this.branches.every(([s, u]) => u.outputDefined()) && this.otherwise.outputDefined();
        }
      }
      class Ql {
        constructor(s, u, m, b) {
          this.type = s, this.input = u, this.beginIndex = m, this.endIndex = b;
        }
        static parse(s, u) {
          if (s.length <= 2 || s.length >= 5) return u.error(`Expected 3 or 4 arguments, but found ${s.length - 1} instead.`);
          const m = u.parse(s[1], 1, Cn), b = u.parse(s[2], 2, Pt);
          if (!m || !b) return null;
          if (!Te(m.type, [tr(Cn), $n, Cn])) return u.error(`Expected first argument to be of type array or string, but found ${pi(m.type)} instead`);
          if (s.length === 4) {
            const C = u.parse(s[3], 3, Pt);
            return C ? new Ql(m.type, m, b, C) : null;
          }
          return new Ql(m.type, m, b);
        }
        evaluate(s) {
          const u = this.input.evaluate(s), m = this.beginIndex.evaluate(s);
          if (!se(u, ["string", "array"])) throw new Vi(`Expected first argument to be of type array or string, but found ${pi(Bi(u))} instead.`);
          if (this.endIndex) {
            const b = this.endIndex.evaluate(s);
            return u.slice(m, b);
          }
          return u.slice(m);
        }
        eachChild(s) {
          s(this.input), s(this.beginIndex), this.endIndex && s(this.endIndex);
        }
        outputDefined() {
          return !1;
        }
      }
      function Zc(l, s) {
        return l === "==" || l === "!=" ? s.kind === "boolean" || s.kind === "string" || s.kind === "number" || s.kind === "null" || s.kind === "value" : s.kind === "string" || s.kind === "number" || s.kind === "value";
      }
      function Yd(l, s, u, m) {
        return m.compare(s, u) === 0;
      }
      function xa(l, s, u) {
        const m = l !== "==" && l !== "!=";
        return class pL {
          constructor(C, k, P) {
            this.type = yn, this.lhs = C, this.rhs = k, this.collator = P, this.hasUntypedArgument = C.type.kind === "value" || k.type.kind === "value";
          }
          static parse(C, k) {
            if (C.length !== 3 && C.length !== 4) return k.error("Expected two or three arguments.");
            const P = C[0];
            let D = k.parse(C[1], 1, Cn);
            if (!D) return null;
            if (!Zc(P, D.type)) return k.concat(1).error(`"${P}" comparisons are not supported for type '${pi(D.type)}'.`);
            let Z = k.parse(C[2], 2, Cn);
            if (!Z) return null;
            if (!Zc(P, Z.type)) return k.concat(2).error(`"${P}" comparisons are not supported for type '${pi(Z.type)}'.`);
            if (D.type.kind !== Z.type.kind && D.type.kind !== "value" && Z.type.kind !== "value") return k.error(`Cannot compare types '${pi(D.type)}' and '${pi(Z.type)}'.`);
            m && (D.type.kind === "value" && Z.type.kind !== "value" ? D = new Ln(Z.type, [D]) : D.type.kind !== "value" && Z.type.kind === "value" && (Z = new Ln(D.type, [Z])));
            let X = null;
            if (C.length === 4) {
              if (D.type.kind !== "string" && Z.type.kind !== "string" && D.type.kind !== "value" && Z.type.kind !== "value") return k.error("Cannot use collator to compare non-string types.");
              if (X = k.parse(C[3], 3, or), !X) return null;
            }
            return new pL(D, Z, X);
          }
          evaluate(C) {
            const k = this.lhs.evaluate(C), P = this.rhs.evaluate(C);
            if (m && this.hasUntypedArgument) {
              const D = Bi(k), Z = Bi(P);
              if (D.kind !== Z.kind || D.kind !== "string" && D.kind !== "number") throw new Vi(`Expected arguments for "${l}" to be (string, string) or (number, number), but found (${D.kind}, ${Z.kind}) instead.`);
            }
            if (this.collator && !m && this.hasUntypedArgument) {
              const D = Bi(k), Z = Bi(P);
              if (D.kind !== "string" || Z.kind !== "string") return s(C, k, P);
            }
            return this.collator ? u(C, k, P, this.collator.evaluate(C)) : s(C, k, P);
          }
          eachChild(C) {
            C(this.lhs), C(this.rhs), this.collator && C(this.collator);
          }
          outputDefined() {
            return !0;
          }
        };
      }
      const Jn = xa("==", function(l, s, u) {
        return s === u;
      }, Yd), rf = xa("!=", function(l, s, u) {
        return s !== u;
      }, function(l, s, u, m) {
        return !Yd(0, s, u, m);
      }), qs = xa("<", function(l, s, u) {
        return s < u;
      }, function(l, s, u, m) {
        return m.compare(s, u) < 0;
      }), ec = xa(">", function(l, s, u) {
        return s > u;
      }, function(l, s, u, m) {
        return m.compare(s, u) > 0;
      }), Kd = xa("<=", function(l, s, u) {
        return s <= u;
      }, function(l, s, u, m) {
        return m.compare(s, u) <= 0;
      }), sf = xa(">=", function(l, s, u) {
        return s >= u;
      }, function(l, s, u, m) {
        return m.compare(s, u) >= 0;
      });
      class tc {
        constructor(s, u, m, b, C) {
          this.type = $n, this.number = s, this.locale = u, this.currency = m, this.minFractionDigits = b, this.maxFractionDigits = C;
        }
        static parse(s, u) {
          if (s.length !== 3) return u.error("Expected two arguments.");
          const m = u.parse(s[1], 1, Pt);
          if (!m) return null;
          const b = s[2];
          if (typeof b != "object" || Array.isArray(b)) return u.error("NumberFormat options argument must be an object.");
          let C = null;
          if (b.locale && (C = u.parse(b.locale, 1, $n), !C)) return null;
          let k = null;
          if (b.currency && (k = u.parse(b.currency, 1, $n), !k)) return null;
          let P = null;
          if (b["min-fraction-digits"] && (P = u.parse(b["min-fraction-digits"], 1, Pt), !P)) return null;
          let D = null;
          return b["max-fraction-digits"] && (D = u.parse(b["max-fraction-digits"], 1, Pt), !D) ? null : new tc(m, C, k, P, D);
        }
        evaluate(s) {
          return new Intl.NumberFormat(this.locale ? this.locale.evaluate(s) : [], { style: this.currency ? "currency" : "decimal", currency: this.currency ? this.currency.evaluate(s) : void 0, minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(s) : void 0, maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(s) : void 0 }).format(this.number.evaluate(s));
        }
        eachChild(s) {
          s(this.number), this.locale && s(this.locale), this.currency && s(this.currency), this.minFractionDigits && s(this.minFractionDigits), this.maxFractionDigits && s(this.maxFractionDigits);
        }
        outputDefined() {
          return !1;
        }
      }
      class qc {
        constructor(s) {
          this.type = Wr, this.sections = s;
        }
        static parse(s, u) {
          if (s.length < 2) return u.error("Expected at least one argument.");
          const m = s[1];
          if (!Array.isArray(m) && typeof m == "object") return u.error("First argument must be an image or text section.");
          const b = [];
          let C = !1;
          for (let k = 1; k <= s.length - 1; ++k) {
            const P = s[k];
            if (C && typeof P == "object" && !Array.isArray(P)) {
              C = !1;
              let D = null;
              if (P["font-scale"] && (D = u.parse(P["font-scale"], 1, Pt), !D)) return null;
              let Z = null;
              if (P["text-font"] && (Z = u.parse(P["text-font"], 1, tr($n)), !Z)) return null;
              let X = null;
              if (P["text-color"] && (X = u.parse(P["text-color"], 1, Qi), !X)) return null;
              const ie = b[b.length - 1];
              ie.scale = D, ie.font = Z, ie.textColor = X;
            } else {
              const D = u.parse(s[k], 1, Cn);
              if (!D) return null;
              const Z = D.type.kind;
              if (Z !== "string" && Z !== "value" && Z !== "null" && Z !== "resolvedImage") return u.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
              C = !0, b.push({ content: D, scale: null, font: null, textColor: null });
            }
          }
          return new qc(b);
        }
        evaluate(s) {
          return new ar(this.sections.map((u) => {
            const m = u.content.evaluate(s);
            return Bi(m) === fs ? new Dr("", m, null, null, null) : new Dr(Us(m), null, u.scale ? u.scale.evaluate(s) : null, u.font ? u.font.evaluate(s).join(",") : null, u.textColor ? u.textColor.evaluate(s) : null);
          }));
        }
        eachChild(s) {
          for (const u of this.sections) s(u.content), u.scale && s(u.scale), u.font && s(u.font), u.textColor && s(u.textColor);
        }
        outputDefined() {
          return !1;
        }
      }
      class jc {
        constructor(s) {
          this.type = fs, this.input = s;
        }
        static parse(s, u) {
          if (s.length !== 2) return u.error("Expected two arguments.");
          const m = u.parse(s[1], 1, $n);
          return m ? new jc(m) : u.error("No image name provided.");
        }
        evaluate(s) {
          const u = this.input.evaluate(s), m = ns.fromString(u);
          return m && s.availableImages && (m.available = s.availableImages.indexOf(u) > -1), m;
        }
        eachChild(s) {
          s(this.input);
        }
        outputDefined() {
          return !1;
        }
      }
      class Zu {
        constructor(s) {
          this.type = Pt, this.input = s;
        }
        static parse(s, u) {
          if (s.length !== 2) return u.error(`Expected 1 argument, but found ${s.length - 1} instead.`);
          const m = u.parse(s[1], 1);
          return m ? m.type.kind !== "array" && m.type.kind !== "string" && m.type.kind !== "value" ? u.error(`Expected argument of type string or array, but found ${pi(m.type)} instead.`) : new Zu(m) : null;
        }
        evaluate(s) {
          const u = this.input.evaluate(s);
          if (typeof u == "string" || Array.isArray(u)) return u.length;
          throw new Vi(`Expected value to be of type string or array, but found ${pi(Bi(u))} instead.`);
        }
        eachChild(s) {
          s(this.input);
        }
        outputDefined() {
          return !1;
        }
      }
      const hl = { "==": Jn, "!=": rf, ">": ec, "<": qs, ">=": sf, "<=": Kd, array: Ln, at: lr, boolean: Ln, case: Wu, coalesce: pl, collator: jt, format: qc, image: jc, in: Zs, "index-of": Wo, interpolate: Yr, "interpolate-hcl": Yr, "interpolate-lab": Yr, length: Zu, let: Ho, literal: Es, match: Yn, number: Ln, "number-format": tc, object: Ln, slice: Ql, step: li, string: Ln, "to-boolean": Ki, "to-color": Ki, "to-number": Ki, "to-string": Ki, var: cl, within: Ws };
      function Gc(l, [s, u, m, b]) {
        s = s.evaluate(l), u = u.evaluate(l), m = m.evaluate(l);
        const C = b ? b.evaluate(l) : 1, k = Uo(s, u, m, C);
        if (k) throw new Vi(k);
        return new _n(s / 255, u / 255, m / 255, C, !1);
      }
      function Xd(l, s) {
        return l in s;
      }
      function Ms(l, s) {
        const u = s[l];
        return u === void 0 ? null : u;
      }
      function $a(l) {
        return { type: l };
      }
      function qu(l) {
        return { result: "success", value: l };
      }
      function gs(l) {
        return { result: "error", value: l };
      }
      function Ca(l) {
        return l["property-type"] === "data-driven" || l["property-type"] === "cross-faded-data-driven";
      }
      function ju(l) {
        return !!l.expression && l.expression.parameters.indexOf("zoom") > -1;
      }
      function nc(l) {
        return !!l.expression && l.expression.interpolated;
      }
      function ci(l) {
        return l instanceof Number ? "number" : l instanceof String ? "string" : l instanceof Boolean ? "boolean" : Array.isArray(l) ? "array" : l === null ? "null" : typeof l;
      }
      function ic(l) {
        return typeof l == "object" && l !== null && !Array.isArray(l);
      }
      function Jd(l) {
        return l;
      }
      function Qd(l, s) {
        const u = s.type === "color", m = l.stops && typeof l.stops[0][0] == "object", b = m || !(m || l.property !== void 0), C = l.type || (nc(s) ? "exponential" : "interval");
        if (u || s.type === "padding") {
          const X = u ? _n.parse : Zr.parse;
          (l = wi({}, l)).stops && (l.stops = l.stops.map((ie) => [ie[0], X(ie[1])])), l.default = X(l.default ? l.default : s.default);
        }
        if (l.colorSpace && (k = l.colorSpace) !== "rgb" && k !== "hcl" && k !== "lab") throw new Error(`Unknown color space: "${l.colorSpace}"`);
        var k;
        let P, D, Z;
        if (C === "exponential") P = Ku;
        else if (C === "interval") P = Yu;
        else if (C === "categorical") {
          P = Gu, D = /* @__PURE__ */ Object.create(null);
          for (const X of l.stops) D[X[0]] = X[1];
          Z = typeof l.stops[0][0];
        } else {
          if (C !== "identity") throw new Error(`Unknown function type "${C}"`);
          P = ep;
        }
        if (m) {
          const X = {}, ie = [];
          for (let ye = 0; ye < l.stops.length; ye++) {
            const Ie = l.stops[ye], ke = Ie[0].zoom;
            X[ke] === void 0 && (X[ke] = { zoom: ke, type: l.type, property: l.property, default: l.default, stops: [] }, ie.push(ke)), X[ke].stops.push([Ie[0].value, Ie[1]]);
          }
          const ce = [];
          for (const ye of ie) ce.push([X[ye].zoom, Qd(X[ye], s)]);
          const he = { name: "linear" };
          return { kind: "composite", interpolationType: he, interpolationFactor: Yr.interpolationFactor.bind(void 0, he), zoomStops: ce.map((ye) => ye[0]), evaluate: ({ zoom: ye }, Ie) => Ku({ stops: ce, base: l.base }, s, ye).evaluate(ye, Ie) };
        }
        if (b) {
          const X = C === "exponential" ? { name: "exponential", base: l.base !== void 0 ? l.base : 1 } : null;
          return { kind: "camera", interpolationType: X, interpolationFactor: Yr.interpolationFactor.bind(void 0, X), zoomStops: l.stops.map((ie) => ie[0]), evaluate: ({ zoom: ie }) => P(l, s, ie, D, Z) };
        }
        return { kind: "source", evaluate(X, ie) {
          const ce = ie && ie.properties ? ie.properties[l.property] : void 0;
          return ce === void 0 ? rc(l.default, s.default) : P(l, s, ce, D, Z);
        } };
      }
      function rc(l, s, u) {
        return l !== void 0 ? l : s !== void 0 ? s : u !== void 0 ? u : void 0;
      }
      function Gu(l, s, u, m, b) {
        return rc(typeof u === b ? m[u] : void 0, l.default, s.default);
      }
      function Yu(l, s, u) {
        if (ci(u) !== "number") return rc(l.default, s.default);
        const m = l.stops.length;
        if (m === 1 || u <= l.stops[0][0]) return l.stops[0][1];
        if (u >= l.stops[m - 1][0]) return l.stops[m - 1][1];
        const b = vs(l.stops.map((C) => C[0]), u);
        return l.stops[b][1];
      }
      function Ku(l, s, u) {
        const m = l.base !== void 0 ? l.base : 1;
        if (ci(u) !== "number") return rc(l.default, s.default);
        const b = l.stops.length;
        if (b === 1 || u <= l.stops[0][0]) return l.stops[0][1];
        if (u >= l.stops[b - 1][0]) return l.stops[b - 1][1];
        const C = vs(l.stops.map((X) => X[0]), u), k = function(X, ie, ce, he) {
          const ye = he - ce, Ie = X - ce;
          return ye === 0 ? 0 : ie === 1 ? Ie / ye : (Math.pow(ie, Ie) - 1) / (Math.pow(ie, ye) - 1);
        }(u, m, l.stops[C][0], l.stops[C + 1][0]), P = l.stops[C][1], D = l.stops[C + 1][1], Z = Gr[s.type] || Jd;
        return typeof P.evaluate == "function" ? { evaluate(...X) {
          const ie = P.evaluate.apply(void 0, X), ce = D.evaluate.apply(void 0, X);
          if (ie !== void 0 && ce !== void 0) return Z(ie, ce, k, l.colorSpace);
        } } : Z(P, D, k, l.colorSpace);
      }
      function ep(l, s, u) {
        switch (s.type) {
          case "color":
            u = _n.parse(u);
            break;
          case "formatted":
            u = ar.fromString(u.toString());
            break;
          case "resolvedImage":
            u = ns.fromString(u.toString());
            break;
          case "padding":
            u = Zr.parse(u);
            break;
          default:
            ci(u) === s.type || s.type === "enum" && s.values[u] || (u = void 0);
        }
        return rc(u, l.default, s.default);
      }
      jr.register(hl, { error: [{ kind: "error" }, [$n], (l, [s]) => {
        throw new Vi(s.evaluate(l));
      }], typeof: [$n, [Cn], (l, [s]) => pi(Bi(s.evaluate(l)))], "to-rgba": [tr(Pt, 4), [Qi], (l, [s]) => {
        const [u, m, b, C] = s.evaluate(l).rgb;
        return [255 * u, 255 * m, 255 * b, C];
      }], rgb: [Qi, [Pt, Pt, Pt], Gc], rgba: [Qi, [Pt, Pt, Pt, Pt], Gc], has: { type: yn, overloads: [[[$n], (l, [s]) => Xd(s.evaluate(l), l.properties())], [[$n, Gi], (l, [s, u]) => Xd(s.evaluate(l), u.evaluate(l))]] }, get: { type: Cn, overloads: [[[$n], (l, [s]) => Ms(s.evaluate(l), l.properties())], [[$n, Gi], (l, [s, u]) => Ms(s.evaluate(l), u.evaluate(l))]] }, "feature-state": [Cn, [$n], (l, [s]) => Ms(s.evaluate(l), l.featureState || {})], properties: [Gi, [], (l) => l.properties()], "geometry-type": [$n, [], (l) => l.geometryType()], id: [Cn, [], (l) => l.id()], zoom: [Pt, [], (l) => l.globals.zoom], "heatmap-density": [Pt, [], (l) => l.globals.heatmapDensity || 0], "line-progress": [Pt, [], (l) => l.globals.lineProgress || 0], accumulated: [Cn, [], (l) => l.globals.accumulated === void 0 ? null : l.globals.accumulated], "+": [Pt, $a(Pt), (l, s) => {
        let u = 0;
        for (const m of s) u += m.evaluate(l);
        return u;
      }], "*": [Pt, $a(Pt), (l, s) => {
        let u = 1;
        for (const m of s) u *= m.evaluate(l);
        return u;
      }], "-": { type: Pt, overloads: [[[Pt, Pt], (l, [s, u]) => s.evaluate(l) - u.evaluate(l)], [[Pt], (l, [s]) => -s.evaluate(l)]] }, "/": [Pt, [Pt, Pt], (l, [s, u]) => s.evaluate(l) / u.evaluate(l)], "%": [Pt, [Pt, Pt], (l, [s, u]) => s.evaluate(l) % u.evaluate(l)], ln2: [Pt, [], () => Math.LN2], pi: [Pt, [], () => Math.PI], e: [Pt, [], () => Math.E], "^": [Pt, [Pt, Pt], (l, [s, u]) => Math.pow(s.evaluate(l), u.evaluate(l))], sqrt: [Pt, [Pt], (l, [s]) => Math.sqrt(s.evaluate(l))], log10: [Pt, [Pt], (l, [s]) => Math.log(s.evaluate(l)) / Math.LN10], ln: [Pt, [Pt], (l, [s]) => Math.log(s.evaluate(l))], log2: [Pt, [Pt], (l, [s]) => Math.log(s.evaluate(l)) / Math.LN2], sin: [Pt, [Pt], (l, [s]) => Math.sin(s.evaluate(l))], cos: [Pt, [Pt], (l, [s]) => Math.cos(s.evaluate(l))], tan: [Pt, [Pt], (l, [s]) => Math.tan(s.evaluate(l))], asin: [Pt, [Pt], (l, [s]) => Math.asin(s.evaluate(l))], acos: [Pt, [Pt], (l, [s]) => Math.acos(s.evaluate(l))], atan: [Pt, [Pt], (l, [s]) => Math.atan(s.evaluate(l))], min: [Pt, $a(Pt), (l, s) => Math.min(...s.map((u) => u.evaluate(l)))], max: [Pt, $a(Pt), (l, s) => Math.max(...s.map((u) => u.evaluate(l)))], abs: [Pt, [Pt], (l, [s]) => Math.abs(s.evaluate(l))], round: [Pt, [Pt], (l, [s]) => {
        const u = s.evaluate(l);
        return u < 0 ? -Math.round(-u) : Math.round(u);
      }], floor: [Pt, [Pt], (l, [s]) => Math.floor(s.evaluate(l))], ceil: [Pt, [Pt], (l, [s]) => Math.ceil(s.evaluate(l))], "filter-==": [yn, [$n, Cn], (l, [s, u]) => l.properties()[s.value] === u.value], "filter-id-==": [yn, [Cn], (l, [s]) => l.id() === s.value], "filter-type-==": [yn, [$n], (l, [s]) => l.geometryType() === s.value], "filter-<": [yn, [$n, Cn], (l, [s, u]) => {
        const m = l.properties()[s.value], b = u.value;
        return typeof m == typeof b && m < b;
      }], "filter-id-<": [yn, [Cn], (l, [s]) => {
        const u = l.id(), m = s.value;
        return typeof u == typeof m && u < m;
      }], "filter->": [yn, [$n, Cn], (l, [s, u]) => {
        const m = l.properties()[s.value], b = u.value;
        return typeof m == typeof b && m > b;
      }], "filter-id->": [yn, [Cn], (l, [s]) => {
        const u = l.id(), m = s.value;
        return typeof u == typeof m && u > m;
      }], "filter-<=": [yn, [$n, Cn], (l, [s, u]) => {
        const m = l.properties()[s.value], b = u.value;
        return typeof m == typeof b && m <= b;
      }], "filter-id-<=": [yn, [Cn], (l, [s]) => {
        const u = l.id(), m = s.value;
        return typeof u == typeof m && u <= m;
      }], "filter->=": [yn, [$n, Cn], (l, [s, u]) => {
        const m = l.properties()[s.value], b = u.value;
        return typeof m == typeof b && m >= b;
      }], "filter-id->=": [yn, [Cn], (l, [s]) => {
        const u = l.id(), m = s.value;
        return typeof u == typeof m && u >= m;
      }], "filter-has": [yn, [Cn], (l, [s]) => s.value in l.properties()], "filter-has-id": [yn, [], (l) => l.id() !== null && l.id() !== void 0], "filter-type-in": [yn, [tr($n)], (l, [s]) => s.value.indexOf(l.geometryType()) >= 0], "filter-id-in": [yn, [tr(Cn)], (l, [s]) => s.value.indexOf(l.id()) >= 0], "filter-in-small": [yn, [$n, tr(Cn)], (l, [s, u]) => u.value.indexOf(l.properties()[s.value]) >= 0], "filter-in-large": [yn, [$n, tr(Cn)], (l, [s, u]) => function(m, b, C, k) {
        for (; C <= k; ) {
          const P = C + k >> 1;
          if (b[P] === m) return !0;
          b[P] > m ? k = P - 1 : C = P + 1;
        }
        return !1;
      }(l.properties()[s.value], u.value, 0, u.value.length - 1)], all: { type: yn, overloads: [[[yn, yn], (l, [s, u]) => s.evaluate(l) && u.evaluate(l)], [$a(yn), (l, s) => {
        for (const u of s) if (!u.evaluate(l)) return !1;
        return !0;
      }]] }, any: { type: yn, overloads: [[[yn, yn], (l, [s, u]) => s.evaluate(l) || u.evaluate(l)], [$a(yn), (l, s) => {
        for (const u of s) if (u.evaluate(l)) return !0;
        return !1;
      }]] }, "!": [yn, [yn], (l, [s]) => !s.evaluate(l)], "is-supported-script": [yn, [$n], (l, [s]) => {
        const u = l.globals && l.globals.isSupportedScript;
        return !u || u(s.evaluate(l));
      }], upcase: [$n, [$n], (l, [s]) => s.evaluate(l).toUpperCase()], downcase: [$n, [$n], (l, [s]) => s.evaluate(l).toLowerCase()], concat: [$n, $a(Cn), (l, s) => s.map((u) => Us(u.evaluate(l))).join("")], "resolved-locale": [$n, [or], (l, [s]) => s.evaluate(l).resolvedLocale()] });
      class fl {
        constructor(s, u) {
          var m;
          this.expression = s, this._warningHistory = {}, this._evaluator = new ms(), this._defaultValue = u ? (m = u).type === "color" && ic(m.default) ? new _n(0, 0, 0, 0) : m.type === "color" ? _n.parse(m.default) || null : m.type === "padding" ? Zr.parse(m.default) || null : m.default === void 0 ? null : m.default : null, this._enumValues = u && u.type === "enum" ? u.values : null;
        }
        evaluateWithoutErrorHandling(s, u, m, b, C, k) {
          return this._evaluator.globals = s, this._evaluator.feature = u, this._evaluator.featureState = m, this._evaluator.canonical = b, this._evaluator.availableImages = C || null, this._evaluator.formattedSection = k, this.expression.evaluate(this._evaluator);
        }
        evaluate(s, u, m, b, C, k) {
          this._evaluator.globals = s, this._evaluator.feature = u || null, this._evaluator.featureState = m || null, this._evaluator.canonical = b, this._evaluator.availableImages = C || null, this._evaluator.formattedSection = k || null;
          try {
            const P = this.expression.evaluate(this._evaluator);
            if (P == null || typeof P == "number" && P != P) return this._defaultValue;
            if (this._enumValues && !(P in this._enumValues)) throw new Vi(`Expected value to be one of ${Object.keys(this._enumValues).map((D) => JSON.stringify(D)).join(", ")}, but found ${JSON.stringify(P)} instead.`);
            return P;
          } catch (P) {
            return this._warningHistory[P.message] || (this._warningHistory[P.message] = !0, typeof console < "u" && console.warn(P.message)), this._defaultValue;
          }
        }
      }
      function lo(l) {
        return Array.isArray(l) && l.length > 0 && typeof l[0] == "string" && l[0] in hl;
      }
      function Ui(l, s) {
        const u = new Ps(hl, Jl, [], s ? function(b) {
          const C = { color: Qi, string: $n, number: Pt, enum: $n, boolean: yn, formatted: Wr, padding: kr, resolvedImage: fs };
          return b.type === "array" ? tr(C[b.value] || Cn, b.length) : C[b.type];
        }(s) : void 0), m = u.parse(l, void 0, void 0, void 0, s && s.type === "string" ? { typeAnnotation: "coerce" } : void 0);
        return m ? qu(new fl(m, s)) : gs(u.errors);
      }
      class ka {
        constructor(s, u) {
          this.kind = s, this._styleExpression = u, this.isStateDependent = s !== "constant" && !ul(u.expression);
        }
        evaluateWithoutErrorHandling(s, u, m, b, C, k) {
          return this._styleExpression.evaluateWithoutErrorHandling(s, u, m, b, C, k);
        }
        evaluate(s, u, m, b, C, k) {
          return this._styleExpression.evaluate(s, u, m, b, C, k);
        }
      }
      class kn {
        constructor(s, u, m, b) {
          this.kind = s, this.zoomStops = m, this._styleExpression = u, this.isStateDependent = s !== "camera" && !ul(u.expression), this.interpolationType = b;
        }
        evaluateWithoutErrorHandling(s, u, m, b, C, k) {
          return this._styleExpression.evaluateWithoutErrorHandling(s, u, m, b, C, k);
        }
        evaluate(s, u, m, b, C, k) {
          return this._styleExpression.evaluate(s, u, m, b, C, k);
        }
        interpolationFactor(s, u, m) {
          return this.interpolationType ? Yr.interpolationFactor(this.interpolationType, s, u, m) : 0;
        }
      }
      function sc(l, s) {
        const u = Ui(l, s);
        if (u.result === "error") return u;
        const m = u.value.expression, b = ba(m);
        if (!b && !Ca(s)) return gs([new ai("", "data expressions not supported")]);
        const C = Mn(m, ["zoom"]);
        if (!C && !ju(s)) return gs([new ai("", "zoom expressions not supported")]);
        const k = Ci(m);
        return k || C ? k instanceof ai ? gs([k]) : k instanceof Yr && !nc(s) ? gs([new ai("", '"interpolate" expressions cannot be used with this property')]) : qu(k ? new kn(b ? "camera" : "composite", u.value, k.labels, k instanceof Yr ? k.interpolation : void 0) : new ka(b ? "constant" : "source", u.value)) : gs([new ai("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')]);
      }
      class $i {
        constructor(s, u) {
          this._parameters = s, this._specification = u, wi(this, Qd(this._parameters, this._specification));
        }
        static deserialize(s) {
          return new $i(s._parameters, s._specification);
        }
        static serialize(s) {
          return { _parameters: s._parameters, _specification: s._specification };
        }
      }
      function Ci(l) {
        let s = null;
        if (l instanceof Ho) s = Ci(l.result);
        else if (l instanceof pl) {
          for (const u of l.args) if (s = Ci(u), s) break;
        } else (l instanceof li || l instanceof Yr) && l.input instanceof jr && l.input.name === "zoom" && (s = l);
        return s instanceof ai || l.eachChild((u) => {
          const m = Ci(u);
          m instanceof ai ? s = m : !s && m ? s = new ai("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.') : s && m && s !== m && (s = new ai("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
        }), s;
      }
      function Zo(l) {
        if (l === !0 || l === !1) return !0;
        if (!Array.isArray(l) || l.length === 0) return !1;
        switch (l[0]) {
          case "has":
            return l.length >= 2 && l[1] !== "$id" && l[1] !== "$type";
          case "in":
            return l.length >= 3 && (typeof l[1] != "string" || Array.isArray(l[2]));
          case "!in":
          case "!has":
          case "none":
            return !1;
          case "==":
          case "!=":
          case ">":
          case ">=":
          case "<":
          case "<=":
            return l.length !== 3 || Array.isArray(l[1]) || Array.isArray(l[2]);
          case "any":
          case "all":
            for (const s of l.slice(1)) if (!Zo(s) && typeof s != "boolean") return !1;
            return !0;
          default:
            return !0;
        }
      }
      const Yc = { type: "boolean", default: !1, transition: !1, "property-type": "data-driven", expression: { interpolated: !1, parameters: ["zoom", "feature"] } };
      function Xu(l) {
        if (l == null) return { filter: () => !0, needGeometry: !1 };
        Zo(l) || (l = Kc(l));
        const s = Ui(l, Yc);
        if (s.result === "error") throw new Error(s.value.map((u) => `${u.key}: ${u.message}`).join(", "));
        return { filter: (u, m, b) => s.value.evaluate(u, m, {}, b), needGeometry: Ju(l) };
      }
      function of(l, s) {
        return l < s ? -1 : l > s ? 1 : 0;
      }
      function Ju(l) {
        if (!Array.isArray(l)) return !1;
        if (l[0] === "within") return !0;
        for (let s = 1; s < l.length; s++) if (Ju(l[s])) return !0;
        return !1;
      }
      function Kc(l) {
        if (!l) return !0;
        const s = l[0];
        return l.length <= 1 ? s !== "any" : s === "==" ? is(l[1], l[2], "==") : s === "!=" ? ys(is(l[1], l[2], "==")) : s === "<" || s === ">" || s === "<=" || s === ">=" ? is(l[1], l[2], s) : s === "any" ? (u = l.slice(1), ["any"].concat(u.map(Kc))) : s === "all" ? ["all"].concat(l.slice(1).map(Kc)) : s === "none" ? ["all"].concat(l.slice(1).map(Kc).map(ys)) : s === "in" ? qo(l[1], l.slice(2)) : s === "!in" ? ys(qo(l[1], l.slice(2))) : s === "has" ? Qu(l[1]) : s === "!has" ? ys(Qu(l[1])) : s !== "within" || l;
        var u;
      }
      function is(l, s, u) {
        switch (l) {
          case "$type":
            return [`filter-type-${u}`, s];
          case "$id":
            return [`filter-id-${u}`, s];
          default:
            return [`filter-${u}`, l, s];
        }
      }
      function qo(l, s) {
        if (s.length === 0) return !1;
        switch (l) {
          case "$type":
            return ["filter-type-in", ["literal", s]];
          case "$id":
            return ["filter-id-in", ["literal", s]];
          default:
            return s.length > 200 && !s.some((u) => typeof u != typeof s[0]) ? ["filter-in-large", l, ["literal", s.sort(of)]] : ["filter-in-small", l, ["literal", s]];
        }
      }
      function Qu(l) {
        switch (l) {
          case "$type":
            return !0;
          case "$id":
            return ["filter-has-id"];
          default:
            return ["filter-has", l];
        }
      }
      function ys(l) {
        return ["!", l];
      }
      function oc(l) {
        const s = typeof l;
        if (s === "number" || s === "boolean" || s === "string" || l == null) return JSON.stringify(l);
        if (Array.isArray(l)) {
          let b = "[";
          for (const C of l) b += `${oc(C)},`;
          return `${b}]`;
        }
        const u = Object.keys(l).sort();
        let m = "{";
        for (let b = 0; b < u.length; b++) m += `${JSON.stringify(u[b])}:${oc(l[u[b]])},`;
        return `${m}}`;
      }
      function ml(l) {
        let s = "";
        for (const u of Bt) s += `/${oc(l[u])}`;
        return s;
      }
      function tp(l) {
        const s = l.value;
        return s ? [new kt(l.key, s, "constants have been deprecated as of v8")] : [];
      }
      function Fi(l) {
        return l instanceof Number || l instanceof String || l instanceof Boolean ? l.valueOf() : l;
      }
      function jo(l) {
        if (Array.isArray(l)) return l.map(jo);
        if (l instanceof Object && !(l instanceof Number || l instanceof String || l instanceof Boolean)) {
          const s = {};
          for (const u in l) s[u] = jo(l[u]);
          return s;
        }
        return Fi(l);
      }
      function Kr(l) {
        const s = l.key, u = l.value, m = l.valueSpec || {}, b = l.objectElementValidators || {}, C = l.style, k = l.styleSpec, P = l.validateSpec;
        let D = [];
        const Z = ci(u);
        if (Z !== "object") return [new kt(s, u, `object expected, ${Z} found`)];
        for (const X in u) {
          const ie = X.split(".")[0], ce = m[ie] || m["*"];
          let he;
          if (b[ie]) he = b[ie];
          else if (m[ie]) he = P;
          else if (b["*"]) he = b["*"];
          else {
            if (!m["*"]) {
              D.push(new kt(s, u[X], `unknown property "${X}"`));
              continue;
            }
            he = P;
          }
          D = D.concat(he({ key: (s && `${s}.`) + X, value: u[X], valueSpec: ce, style: C, styleSpec: k, object: u, objectKey: X, validateSpec: P }, u));
        }
        for (const X in m) b[X] || m[X].required && m[X].default === void 0 && u[X] === void 0 && D.push(new kt(s, u, `missing required property "${X}"`));
        return D;
      }
      function np(l) {
        const s = l.value, u = l.valueSpec, m = l.style, b = l.styleSpec, C = l.key, k = l.arrayElementValidator || l.validateSpec;
        if (ci(s) !== "array") return [new kt(C, s, `array expected, ${ci(s)} found`)];
        if (u.length && s.length !== u.length) return [new kt(C, s, `array length ${u.length} expected, length ${s.length} found`)];
        if (u["min-length"] && s.length < u["min-length"]) return [new kt(C, s, `array length at least ${u["min-length"]} expected, length ${s.length} found`)];
        let P = { type: u.value, values: u.values };
        b.$version < 7 && (P.function = u.function), ci(u.value) === "object" && (P = u.value);
        let D = [];
        for (let Z = 0; Z < s.length; Z++) D = D.concat(k({ array: s, arrayIndex: Z, value: s[Z], valueSpec: P, validateSpec: l.validateSpec, style: m, styleSpec: b, key: `${C}[${Z}]` }));
        return D;
      }
      function co(l) {
        const s = l.key, u = l.value, m = l.valueSpec;
        let b = ci(u);
        return b === "number" && u != u && (b = "NaN"), b !== "number" ? [new kt(s, u, `number expected, ${b} found`)] : "minimum" in m && u < m.minimum ? [new kt(s, u, `${u} is less than the minimum value ${m.minimum}`)] : "maximum" in m && u > m.maximum ? [new kt(s, u, `${u} is greater than the maximum value ${m.maximum}`)] : [];
      }
      function ac(l) {
        const s = l.valueSpec, u = Fi(l.value.type);
        let m, b, C, k = {};
        const P = u !== "categorical" && l.value.property === void 0, D = !P, Z = ci(l.value.stops) === "array" && ci(l.value.stops[0]) === "array" && ci(l.value.stops[0][0]) === "object", X = Kr({ key: l.key, value: l.value, valueSpec: l.styleSpec.function, validateSpec: l.validateSpec, style: l.style, styleSpec: l.styleSpec, objectElementValidators: { stops: function(he) {
          if (u === "identity") return [new kt(he.key, he.value, 'identity function may not have a "stops" property')];
          let ye = [];
          const Ie = he.value;
          return ye = ye.concat(np({ key: he.key, value: Ie, valueSpec: he.valueSpec, validateSpec: he.validateSpec, style: he.style, styleSpec: he.styleSpec, arrayElementValidator: ie })), ci(Ie) === "array" && Ie.length === 0 && ye.push(new kt(he.key, Ie, "array must have at least one stop")), ye;
        }, default: function(he) {
          return he.validateSpec({ key: he.key, value: he.value, valueSpec: s, validateSpec: he.validateSpec, style: he.style, styleSpec: he.styleSpec });
        } } });
        return u === "identity" && P && X.push(new kt(l.key, l.value, 'missing required property "property"')), u === "identity" || l.value.stops || X.push(new kt(l.key, l.value, 'missing required property "stops"')), u === "exponential" && l.valueSpec.expression && !nc(l.valueSpec) && X.push(new kt(l.key, l.value, "exponential functions not supported")), l.styleSpec.$version >= 8 && (D && !Ca(l.valueSpec) ? X.push(new kt(l.key, l.value, "property functions not supported")) : P && !ju(l.valueSpec) && X.push(new kt(l.key, l.value, "zoom functions not supported"))), u !== "categorical" && !Z || l.value.property !== void 0 || X.push(new kt(l.key, l.value, '"property" property is required')), X;
        function ie(he) {
          let ye = [];
          const Ie = he.value, ke = he.key;
          if (ci(Ie) !== "array") return [new kt(ke, Ie, `array expected, ${ci(Ie)} found`)];
          if (Ie.length !== 2) return [new kt(ke, Ie, `array length 2 expected, length ${Ie.length} found`)];
          if (Z) {
            if (ci(Ie[0]) !== "object") return [new kt(ke, Ie, `object expected, ${ci(Ie[0])} found`)];
            if (Ie[0].zoom === void 0) return [new kt(ke, Ie, "object stop key must have zoom")];
            if (Ie[0].value === void 0) return [new kt(ke, Ie, "object stop key must have value")];
            if (C && C > Fi(Ie[0].zoom)) return [new kt(ke, Ie[0].zoom, "stop zoom values must appear in ascending order")];
            Fi(Ie[0].zoom) !== C && (C = Fi(Ie[0].zoom), b = void 0, k = {}), ye = ye.concat(Kr({ key: `${ke}[0]`, value: Ie[0], valueSpec: { zoom: {} }, validateSpec: he.validateSpec, style: he.style, styleSpec: he.styleSpec, objectElementValidators: { zoom: co, value: ce } }));
          } else ye = ye.concat(ce({ key: `${ke}[0]`, value: Ie[0], validateSpec: he.validateSpec, style: he.style, styleSpec: he.styleSpec }, Ie));
          return lo(jo(Ie[1])) ? ye.concat([new kt(`${ke}[1]`, Ie[1], "expressions are not allowed in function stops.")]) : ye.concat(he.validateSpec({ key: `${ke}[1]`, value: Ie[1], valueSpec: s, validateSpec: he.validateSpec, style: he.style, styleSpec: he.styleSpec }));
        }
        function ce(he, ye) {
          const Ie = ci(he.value), ke = Fi(he.value), He = he.value !== null ? he.value : ye;
          if (m) {
            if (Ie !== m) return [new kt(he.key, He, `${Ie} stop domain type must match previous stop domain type ${m}`)];
          } else m = Ie;
          if (Ie !== "number" && Ie !== "string" && Ie !== "boolean") return [new kt(he.key, He, "stop domain value must be a number, string, or boolean")];
          if (Ie !== "number" && u !== "categorical") {
            let Qe = `number expected, ${Ie} found`;
            return Ca(s) && u === void 0 && (Qe += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [new kt(he.key, He, Qe)];
          }
          return u !== "categorical" || Ie !== "number" || isFinite(ke) && Math.floor(ke) === ke ? u !== "categorical" && Ie === "number" && b !== void 0 && ke < b ? [new kt(he.key, He, "stop domain values must appear in ascending order")] : (b = ke, u === "categorical" && ke in k ? [new kt(he.key, He, "stop domain values must be unique")] : (k[ke] = !0, [])) : [new kt(he.key, He, `integer expected, found ${ke}`)];
        }
      }
      function Sa(l) {
        const s = (l.expressionContext === "property" ? sc : Ui)(jo(l.value), l.valueSpec);
        if (s.result === "error") return s.value.map((m) => new kt(`${l.key}${m.key}`, l.value, m.message));
        const u = s.value.expression || s.value._styleExpression.expression;
        if (l.expressionContext === "property" && l.propertyKey === "text-font" && !u.outputDefined()) return [new kt(l.key, l.value, `Invalid data expression for "${l.propertyKey}". Output values must be contained as literals within the expression.`)];
        if (l.expressionContext === "property" && l.propertyType === "layout" && !ul(u)) return [new kt(l.key, l.value, '"feature-state" data expressions are not supported with layout properties.')];
        if (l.expressionContext === "filter" && !ul(u)) return [new kt(l.key, l.value, '"feature-state" data expressions are not supported with filters.')];
        if (l.expressionContext && l.expressionContext.indexOf("cluster") === 0) {
          if (!Mn(u, ["zoom", "feature-state"])) return [new kt(l.key, l.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')];
          if (l.expressionContext === "cluster-initial" && !ba(u)) return [new kt(l.key, l.value, "Feature data expressions are not supported with initial expression part of cluster properties.")];
        }
        return [];
      }
      function Ta(l) {
        const s = l.key, u = l.value, m = l.valueSpec, b = [];
        return Array.isArray(m.values) ? m.values.indexOf(Fi(u)) === -1 && b.push(new kt(s, u, `expected one of [${m.values.join(", ")}], ${JSON.stringify(u)} found`)) : Object.keys(m.values).indexOf(Fi(u)) === -1 && b.push(new kt(s, u, `expected one of [${Object.keys(m.values).join(", ")}], ${JSON.stringify(u)} found`)), b;
      }
      function vl(l) {
        return Zo(jo(l.value)) ? Sa(wi({}, l, { expressionContext: "filter", valueSpec: { value: "boolean" } })) : uo(l);
      }
      function uo(l) {
        const s = l.value, u = l.key;
        if (ci(s) !== "array") return [new kt(u, s, `array expected, ${ci(s)} found`)];
        const m = l.styleSpec;
        let b, C = [];
        if (s.length < 1) return [new kt(u, s, "filter array must have at least 1 element")];
        switch (C = C.concat(Ta({ key: `${u}[0]`, value: s[0], valueSpec: m.filter_operator, style: l.style, styleSpec: l.styleSpec })), Fi(s[0])) {
          case "<":
          case "<=":
          case ">":
          case ">=":
            s.length >= 2 && Fi(s[1]) === "$type" && C.push(new kt(u, s, `"$type" cannot be use with operator "${s[0]}"`));
          case "==":
          case "!=":
            s.length !== 3 && C.push(new kt(u, s, `filter array for operator "${s[0]}" must have 3 elements`));
          case "in":
          case "!in":
            s.length >= 2 && (b = ci(s[1]), b !== "string" && C.push(new kt(`${u}[1]`, s[1], `string expected, ${b} found`)));
            for (let k = 2; k < s.length; k++) b = ci(s[k]), Fi(s[1]) === "$type" ? C = C.concat(Ta({ key: `${u}[${k}]`, value: s[k], valueSpec: m.geometry_type, style: l.style, styleSpec: l.styleSpec })) : b !== "string" && b !== "number" && b !== "boolean" && C.push(new kt(`${u}[${k}]`, s[k], `string, number, or boolean expected, ${b} found`));
            break;
          case "any":
          case "all":
          case "none":
            for (let k = 1; k < s.length; k++) C = C.concat(uo({ key: `${u}[${k}]`, value: s[k], style: l.style, styleSpec: l.styleSpec }));
            break;
          case "has":
          case "!has":
            b = ci(s[1]), s.length !== 2 ? C.push(new kt(u, s, `filter array for "${s[0]}" operator must have 2 elements`)) : b !== "string" && C.push(new kt(`${u}[1]`, s[1], `string expected, ${b} found`));
            break;
          case "within":
            b = ci(s[1]), s.length !== 2 ? C.push(new kt(u, s, `filter array for "${s[0]}" operator must have 2 elements`)) : b !== "object" && C.push(new kt(`${u}[1]`, s[1], `object expected, ${b} found`));
        }
        return C;
      }
      function ed(l, s) {
        const u = l.key, m = l.validateSpec, b = l.style, C = l.styleSpec, k = l.value, P = l.objectKey, D = C[`${s}_${l.layerType}`];
        if (!D) return [];
        const Z = P.match(/^(.*)-transition$/);
        if (s === "paint" && Z && D[Z[1]] && D[Z[1]].transition) return m({ key: u, value: k, valueSpec: C.transition, style: b, styleSpec: C });
        const X = l.valueSpec || D[P];
        if (!X) return [new kt(u, k, `unknown property "${P}"`)];
        let ie;
        if (ci(k) === "string" && Ca(X) && !X.tokens && (ie = /^{([^}]+)}$/.exec(k))) return [new kt(u, k, `"${P}" does not support interpolation syntax
Use an identity property function instead: \`{ "type": "identity", "property": ${JSON.stringify(ie[1])} }\`.`)];
        const ce = [];
        return l.layerType === "symbol" && (P === "text-field" && b && !b.glyphs && ce.push(new kt(u, k, 'use of "text-field" requires a style "glyphs" property')), P === "text-font" && ic(jo(k)) && Fi(k.type) === "identity" && ce.push(new kt(u, k, '"text-font" does not support identity functions'))), ce.concat(m({ key: l.key, value: k, valueSpec: X, style: b, styleSpec: C, expressionContext: "property", propertyType: s, propertyKey: P }));
      }
      function Go(l) {
        return ed(l, "paint");
      }
      function ip(l) {
        return ed(l, "layout");
      }
      function Ds(l) {
        let s = [];
        const u = l.value, m = l.key, b = l.style, C = l.styleSpec;
        u.type || u.ref || s.push(new kt(m, u, 'either "type" or "ref" is required'));
        let k = Fi(u.type);
        const P = Fi(u.ref);
        if (u.id) {
          const D = Fi(u.id);
          for (let Z = 0; Z < l.arrayIndex; Z++) {
            const X = b.layers[Z];
            Fi(X.id) === D && s.push(new kt(m, u.id, `duplicate layer id "${u.id}", previously used at line ${X.id.__line__}`));
          }
        }
        if ("ref" in u) {
          let D;
          ["type", "source", "source-layer", "filter", "layout"].forEach((Z) => {
            Z in u && s.push(new kt(m, u[Z], `"${Z}" is prohibited for ref layers`));
          }), b.layers.forEach((Z) => {
            Fi(Z.id) === P && (D = Z);
          }), D ? D.ref ? s.push(new kt(m, u.ref, "ref cannot reference another ref layer")) : k = Fi(D.type) : s.push(new kt(m, u.ref, `ref layer "${P}" not found`));
        } else if (k !== "background") if (u.source) {
          const D = b.sources && b.sources[u.source], Z = D && Fi(D.type);
          D ? Z === "vector" && k === "raster" ? s.push(new kt(m, u.source, `layer "${u.id}" requires a raster source`)) : Z === "raster" && k !== "raster" ? s.push(new kt(m, u.source, `layer "${u.id}" requires a vector source`)) : Z !== "vector" || u["source-layer"] ? Z === "raster-dem" && k !== "hillshade" ? s.push(new kt(m, u.source, "raster-dem source can only be used with layer type 'hillshade'.")) : k !== "line" || !u.paint || !u.paint["line-gradient"] || Z === "geojson" && D.lineMetrics || s.push(new kt(m, u, `layer "${u.id}" specifies a line-gradient, which requires a GeoJSON source with \`lineMetrics\` enabled.`)) : s.push(new kt(m, u, `layer "${u.id}" must specify a "source-layer"`)) : s.push(new kt(m, u.source, `source "${u.source}" not found`));
        } else s.push(new kt(m, u, 'missing required property "source"'));
        return s = s.concat(Kr({ key: m, value: u, valueSpec: C.layer, style: l.style, styleSpec: l.styleSpec, validateSpec: l.validateSpec, objectElementValidators: { "*": () => [], type: () => l.validateSpec({ key: `${m}.type`, value: u.type, valueSpec: C.layer.type, style: l.style, styleSpec: l.styleSpec, validateSpec: l.validateSpec, object: u, objectKey: "type" }), filter: vl, layout: (D) => Kr({ layer: u, key: D.key, value: D.value, style: D.style, styleSpec: D.styleSpec, validateSpec: D.validateSpec, objectElementValidators: { "*": (Z) => ip(wi({ layerType: k }, Z)) } }), paint: (D) => Kr({ layer: u, key: D.key, value: D.value, style: D.style, styleSpec: D.styleSpec, validateSpec: D.validateSpec, objectElementValidators: { "*": (Z) => Go(wi({ layerType: k }, Z)) } }) } })), s;
      }
      function _s(l) {
        const s = l.value, u = l.key, m = ci(s);
        return m !== "string" ? [new kt(u, s, `string expected, ${m} found`)] : [];
      }
      const lc = { promoteId: function({ key: l, value: s }) {
        if (ci(s) === "string") return _s({ key: l, value: s });
        {
          const u = [];
          for (const m in s) u.push(..._s({ key: `${l}.${m}`, value: s[m] }));
          return u;
        }
      } };
      function gl(l) {
        const s = l.value, u = l.key, m = l.styleSpec, b = l.style, C = l.validateSpec;
        if (!s.type) return [new kt(u, s, '"type" is required')];
        const k = Fi(s.type);
        let P;
        switch (k) {
          case "vector":
          case "raster":
          case "raster-dem":
            return P = Kr({ key: u, value: s, valueSpec: m[`source_${k.replace("-", "_")}`], style: l.style, styleSpec: m, objectElementValidators: lc, validateSpec: C }), P;
          case "geojson":
            if (P = Kr({ key: u, value: s, valueSpec: m.source_geojson, style: b, styleSpec: m, validateSpec: C, objectElementValidators: lc }), s.cluster) for (const D in s.clusterProperties) {
              const [Z, X] = s.clusterProperties[D], ie = typeof Z == "string" ? [Z, ["accumulated"], ["get", D]] : Z;
              P.push(...Sa({ key: `${u}.${D}.map`, value: X, expressionContext: "cluster-map" })), P.push(...Sa({ key: `${u}.${D}.reduce`, value: ie, expressionContext: "cluster-reduce" }));
            }
            return P;
          case "video":
            return Kr({ key: u, value: s, valueSpec: m.source_video, style: b, validateSpec: C, styleSpec: m });
          case "image":
            return Kr({ key: u, value: s, valueSpec: m.source_image, style: b, validateSpec: C, styleSpec: m });
          case "canvas":
            return [new kt(u, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")];
          default:
            return Ta({ key: `${u}.type`, value: s.type, valueSpec: { values: ["vector", "raster", "raster-dem", "geojson", "video", "image"] } });
        }
      }
      function cc(l) {
        const s = l.value, u = l.styleSpec, m = u.light, b = l.style;
        let C = [];
        const k = ci(s);
        if (s === void 0) return C;
        if (k !== "object") return C = C.concat([new kt("light", s, `object expected, ${k} found`)]), C;
        for (const P in s) {
          const D = P.match(/^(.*)-transition$/);
          C = C.concat(D && m[D[1]] && m[D[1]].transition ? l.validateSpec({ key: P, value: s[P], valueSpec: u.transition, validateSpec: l.validateSpec, style: b, styleSpec: u }) : m[P] ? l.validateSpec({ key: P, value: s[P], valueSpec: m[P], validateSpec: l.validateSpec, style: b, styleSpec: u }) : [new kt(P, s[P], `unknown property "${P}"`)]);
        }
        return C;
      }
      function Ia(l) {
        const s = l.value, u = l.styleSpec, m = u.terrain, b = l.style;
        let C = [];
        const k = ci(s);
        if (s === void 0) return C;
        if (k !== "object") return C = C.concat([new kt("terrain", s, `object expected, ${k} found`)]), C;
        for (const P in s) C = C.concat(m[P] ? l.validateSpec({ key: P, value: s[P], valueSpec: m[P], validateSpec: l.validateSpec, style: b, styleSpec: u }) : [new kt(P, s[P], `unknown property "${P}"`)]);
        return C;
      }
      function uc(l) {
        let s = [];
        const u = l.value, m = l.key;
        if (Array.isArray(u)) {
          const b = [], C = [];
          for (const k in u) u[k].id && b.includes(u[k].id) && s.push(new kt(m, u, `all the sprites' ids must be unique, but ${u[k].id} is duplicated`)), b.push(u[k].id), u[k].url && C.includes(u[k].url) && s.push(new kt(m, u, `all the sprites' URLs must be unique, but ${u[k].url} is duplicated`)), C.push(u[k].url), s = s.concat(Kr({ key: `${m}[${k}]`, value: u[k], valueSpec: { id: { type: "string", required: !0 }, url: { type: "string", required: !0 } }, validateSpec: l.validateSpec }));
          return s;
        }
        return _s({ key: m, value: u });
      }
      const Aa = { "*": () => [], array: np, boolean: function(l) {
        const s = l.value, u = l.key, m = ci(s);
        return m !== "boolean" ? [new kt(u, s, `boolean expected, ${m} found`)] : [];
      }, number: co, color: function(l) {
        const s = l.key, u = l.value, m = ci(u);
        return m !== "string" ? [new kt(s, u, `color expected, ${m} found`)] : _n.parse(String(u)) ? [] : [new kt(s, u, `color expected, "${u}" found`)];
      }, constants: tp, enum: Ta, filter: vl, function: ac, layer: Ds, object: Kr, source: gl, light: cc, terrain: Ia, string: _s, formatted: function(l) {
        return _s(l).length === 0 ? [] : Sa(l);
      }, resolvedImage: function(l) {
        return _s(l).length === 0 ? [] : Sa(l);
      }, padding: function(l) {
        const s = l.key, u = l.value;
        if (ci(u) === "array") {
          if (u.length < 1 || u.length > 4) return [new kt(s, u, `padding requires 1 to 4 values; ${u.length} values found`)];
          const m = { type: "number" };
          let b = [];
          for (let C = 0; C < u.length; C++) b = b.concat(l.validateSpec({ key: `${s}[${C}]`, value: u[C], validateSpec: l.validateSpec, valueSpec: m }));
          return b;
        }
        return co({ key: s, value: u, valueSpec: {} });
      }, sprite: uc };
      function Ea(l) {
        const s = l.value, u = l.valueSpec, m = l.styleSpec;
        return l.validateSpec = Ea, u.expression && ic(Fi(s)) ? ac(l) : u.expression && lo(jo(s)) ? Sa(l) : u.type && Aa[u.type] ? Aa[u.type](l) : Kr(wi({}, l, { valueSpec: u.type ? m[u.type] : u }));
      }
      function Xc(l) {
        const s = l.value, u = l.key, m = _s(l);
        return m.length || (s.indexOf("{fontstack}") === -1 && m.push(new kt(u, s, '"glyphs" url must include a "{fontstack}" token')), s.indexOf("{range}") === -1 && m.push(new kt(u, s, '"glyphs" url must include a "{range}" token'))), m;
      }
      function js(l, s = Oe) {
        let u = [];
        return u = u.concat(Ea({ key: "", value: l, valueSpec: s.$root, styleSpec: s, style: l, validateSpec: Ea, objectElementValidators: { glyphs: Xc, "*": () => [] } })), l.constants && (u = u.concat(tp({ key: "constants", value: l.constants }))), Yo(u);
      }
      function Ls(l) {
        return function(s) {
          return l({ ...s, validateSpec: Ea });
        };
      }
      function Yo(l) {
        return [].concat(l).sort((s, u) => s.line - u.line);
      }
      function nr(l) {
        return function(...s) {
          return Yo(l.apply(this, s));
        };
      }
      js.source = nr(Ls(gl)), js.sprite = nr(Ls(uc)), js.glyphs = nr(Ls(Xc)), js.light = nr(Ls(cc)), js.terrain = nr(Ls(Ia)), js.layer = nr(Ls(Ds)), js.filter = nr(Ls(vl)), js.paintProperty = nr(Ls(Go)), js.layoutProperty = nr(Ls(ip));
      const To = js, af = To.light, rp = To.paintProperty, lf = To.layoutProperty;
      function Xr(l, s) {
        let u = !1;
        if (s && s.length) for (const m of s) l.fire(new bt(new Error(m.message))), u = !0;
        return u;
      }
      class Ko {
        constructor(s, u, m) {
          const b = this.cells = [];
          if (s instanceof ArrayBuffer) {
            this.arrayBuffer = s;
            const k = new Int32Array(this.arrayBuffer);
            s = k[0], this.d = (u = k[1]) + 2 * (m = k[2]);
            for (let D = 0; D < this.d * this.d; D++) {
              const Z = k[3 + D], X = k[3 + D + 1];
              b.push(Z === X ? null : k.subarray(Z, X));
            }
            const P = k[3 + b.length + 1];
            this.keys = k.subarray(k[3 + b.length], P), this.bboxes = k.subarray(P), this.insert = this._insertReadonly;
          } else {
            this.d = u + 2 * m;
            for (let k = 0; k < this.d * this.d; k++) b.push([]);
            this.keys = [], this.bboxes = [];
          }
          this.n = u, this.extent = s, this.padding = m, this.scale = u / s, this.uid = 0;
          const C = m / u * s;
          this.min = -C, this.max = s + C;
        }
        insert(s, u, m, b, C) {
          this._forEachCell(u, m, b, C, this._insertCell, this.uid++, void 0, void 0), this.keys.push(s), this.bboxes.push(u), this.bboxes.push(m), this.bboxes.push(b), this.bboxes.push(C);
        }
        _insertReadonly() {
          throw new Error("Cannot insert into a GridIndex created from an ArrayBuffer.");
        }
        _insertCell(s, u, m, b, C, k) {
          this.cells[C].push(k);
        }
        query(s, u, m, b, C) {
          const k = this.min, P = this.max;
          if (s <= k && u <= k && P <= m && P <= b && !C) return Array.prototype.slice.call(this.keys);
          {
            const D = [];
            return this._forEachCell(s, u, m, b, this._queryCell, D, {}, C), D;
          }
        }
        _queryCell(s, u, m, b, C, k, P, D) {
          const Z = this.cells[C];
          if (Z !== null) {
            const X = this.keys, ie = this.bboxes;
            for (let ce = 0; ce < Z.length; ce++) {
              const he = Z[ce];
              if (P[he] === void 0) {
                const ye = 4 * he;
                (D ? D(ie[ye + 0], ie[ye + 1], ie[ye + 2], ie[ye + 3]) : s <= ie[ye + 2] && u <= ie[ye + 3] && m >= ie[ye + 0] && b >= ie[ye + 1]) ? (P[he] = !0, k.push(X[he])) : P[he] = !1;
              }
            }
          }
        }
        _forEachCell(s, u, m, b, C, k, P, D) {
          const Z = this._convertToCellCoord(s), X = this._convertToCellCoord(u), ie = this._convertToCellCoord(m), ce = this._convertToCellCoord(b);
          for (let he = Z; he <= ie; he++) for (let ye = X; ye <= ce; ye++) {
            const Ie = this.d * ye + he;
            if ((!D || D(this._convertFromCellCoord(he), this._convertFromCellCoord(ye), this._convertFromCellCoord(he + 1), this._convertFromCellCoord(ye + 1))) && C.call(this, s, u, m, b, Ie, k, P, D)) return;
          }
        }
        _convertFromCellCoord(s) {
          return (s - this.padding) / this.scale;
        }
        _convertToCellCoord(s) {
          return Math.max(0, Math.min(this.d - 1, Math.floor(s * this.scale) + this.padding));
        }
        toArrayBuffer() {
          if (this.arrayBuffer) return this.arrayBuffer;
          const s = this.cells, u = 3 + this.cells.length + 1 + 1;
          let m = 0;
          for (let k = 0; k < this.cells.length; k++) m += this.cells[k].length;
          const b = new Int32Array(u + m + this.keys.length + this.bboxes.length);
          b[0] = this.extent, b[1] = this.n, b[2] = this.padding;
          let C = u;
          for (let k = 0; k < s.length; k++) {
            const P = s[k];
            b[3 + k] = C, b.set(P, C), C += P.length;
          }
          return b[3 + s.length] = C, b.set(this.keys, C), C += this.keys.length, b[3 + s.length + 1] = C, b.set(this.bboxes, C), C += this.bboxes.length, b.buffer;
        }
        static serialize(s, u) {
          const m = s.toArrayBuffer();
          return u && u.push(m), { buffer: m };
        }
        static deserialize(s) {
          return new Ko(s.buffer);
        }
      }
      const po = {};
      function Zt(l, s, u = {}) {
        if (po[l]) throw new Error(`${l} is already registered.`);
        Object.defineProperty(s, "_classRegistryKey", { value: l, writeable: !1 }), po[l] = { klass: s, omit: u.omit || [], shallow: u.shallow || [] };
      }
      Zt("Object", Object), Zt("TransferableGridIndex", Ko), Zt("Color", _n), Zt("Error", Error), Zt("AJAXError", gt), Zt("ResolvedImage", ns), Zt("StylePropertyFunction", $i), Zt("StyleExpression", fl, { omit: ["_evaluator"] }), Zt("ZoomDependentExpression", kn), Zt("ZoomConstantExpression", ka), Zt("CompoundExpression", jr, { omit: ["_evaluate"] });
      for (const l in hl) hl[l]._classRegistryKey || Zt(`Expression_${l}`, hl[l]);
      function Jc(l) {
        return l && typeof ArrayBuffer < "u" && (l instanceof ArrayBuffer || l.constructor && l.constructor.name === "ArrayBuffer");
      }
      function yl(l, s) {
        if (l == null || typeof l == "boolean" || typeof l == "number" || typeof l == "string" || l instanceof Boolean || l instanceof Number || l instanceof String || l instanceof Date || l instanceof RegExp || l instanceof Blob) return l;
        if (Jc(l) || We(l)) return s && s.push(l), l;
        if (ArrayBuffer.isView(l)) {
          const u = l;
          return s && s.push(u.buffer), u;
        }
        if (l instanceof ImageData) return s && s.push(l.data.buffer), l;
        if (Array.isArray(l)) {
          const u = [];
          for (const m of l) u.push(yl(m, s));
          return u;
        }
        if (typeof l == "object") {
          const u = l.constructor, m = u._classRegistryKey;
          if (!m) throw new Error("can't serialize object of unregistered class");
          if (!po[m]) throw new Error(`${m} is not registered.`);
          const b = u.serialize ? u.serialize(l, s) : {};
          if (u.serialize) {
            if (s && b === s[s.length - 1]) throw new Error("statically serialized object won't survive transfer of $name property");
          } else {
            for (const C in l) {
              if (!l.hasOwnProperty(C) || po[m].omit.indexOf(C) >= 0) continue;
              const k = l[C];
              b[C] = po[m].shallow.indexOf(C) >= 0 ? k : yl(k, s);
            }
            l instanceof Error && (b.message = l.message);
          }
          if (b.$name) throw new Error("$name property is reserved for worker serialization logic.");
          return m !== "Object" && (b.$name = m), b;
        }
        throw new Error("can't serialize object of type " + typeof l);
      }
      function Io(l) {
        if (l == null || typeof l == "boolean" || typeof l == "number" || typeof l == "string" || l instanceof Boolean || l instanceof Number || l instanceof String || l instanceof Date || l instanceof RegExp || l instanceof Blob || Jc(l) || We(l) || ArrayBuffer.isView(l) || l instanceof ImageData) return l;
        if (Array.isArray(l)) return l.map(Io);
        if (typeof l == "object") {
          const s = l.$name || "Object";
          if (!po[s]) throw new Error(`can't deserialize unregistered class ${s}`);
          const { klass: u } = po[s];
          if (!u) throw new Error(`can't deserialize unregistered class ${s}`);
          if (u.deserialize) return u.deserialize(l);
          const m = Object.create(u.prototype);
          for (const b of Object.keys(l)) {
            if (b === "$name") continue;
            const C = l[b];
            m[b] = po[s].shallow.indexOf(b) >= 0 ? C : Io(C);
          }
          return m;
        }
        throw new Error("can't deserialize object of type " + typeof l);
      }
      class _l {
        constructor() {
          this.first = !0;
        }
        update(s, u) {
          const m = Math.floor(s);
          return this.first ? (this.first = !1, this.lastIntegerZoom = m, this.lastIntegerZoomTime = 0, this.lastZoom = s, this.lastFloorZoom = m, !0) : (this.lastFloorZoom > m ? (this.lastIntegerZoom = m + 1, this.lastIntegerZoomTime = u) : this.lastFloorZoom < m && (this.lastIntegerZoom = m, this.lastIntegerZoomTime = u), s !== this.lastZoom && (this.lastZoom = s, this.lastFloorZoom = m, !0));
        }
      }
      const Rt = { "Latin-1 Supplement": (l) => l >= 128 && l <= 255, Arabic: (l) => l >= 1536 && l <= 1791, "Arabic Supplement": (l) => l >= 1872 && l <= 1919, "Arabic Extended-A": (l) => l >= 2208 && l <= 2303, "Hangul Jamo": (l) => l >= 4352 && l <= 4607, "Unified Canadian Aboriginal Syllabics": (l) => l >= 5120 && l <= 5759, Khmer: (l) => l >= 6016 && l <= 6143, "Unified Canadian Aboriginal Syllabics Extended": (l) => l >= 6320 && l <= 6399, "General Punctuation": (l) => l >= 8192 && l <= 8303, "Letterlike Symbols": (l) => l >= 8448 && l <= 8527, "Number Forms": (l) => l >= 8528 && l <= 8591, "Miscellaneous Technical": (l) => l >= 8960 && l <= 9215, "Control Pictures": (l) => l >= 9216 && l <= 9279, "Optical Character Recognition": (l) => l >= 9280 && l <= 9311, "Enclosed Alphanumerics": (l) => l >= 9312 && l <= 9471, "Geometric Shapes": (l) => l >= 9632 && l <= 9727, "Miscellaneous Symbols": (l) => l >= 9728 && l <= 9983, "Miscellaneous Symbols and Arrows": (l) => l >= 11008 && l <= 11263, "CJK Radicals Supplement": (l) => l >= 11904 && l <= 12031, "Kangxi Radicals": (l) => l >= 12032 && l <= 12255, "Ideographic Description Characters": (l) => l >= 12272 && l <= 12287, "CJK Symbols and Punctuation": (l) => l >= 12288 && l <= 12351, Hiragana: (l) => l >= 12352 && l <= 12447, Katakana: (l) => l >= 12448 && l <= 12543, Bopomofo: (l) => l >= 12544 && l <= 12591, "Hangul Compatibility Jamo": (l) => l >= 12592 && l <= 12687, Kanbun: (l) => l >= 12688 && l <= 12703, "Bopomofo Extended": (l) => l >= 12704 && l <= 12735, "CJK Strokes": (l) => l >= 12736 && l <= 12783, "Katakana Phonetic Extensions": (l) => l >= 12784 && l <= 12799, "Enclosed CJK Letters and Months": (l) => l >= 12800 && l <= 13055, "CJK Compatibility": (l) => l >= 13056 && l <= 13311, "CJK Unified Ideographs Extension A": (l) => l >= 13312 && l <= 19903, "Yijing Hexagram Symbols": (l) => l >= 19904 && l <= 19967, "CJK Unified Ideographs": (l) => l >= 19968 && l <= 40959, "Yi Syllables": (l) => l >= 40960 && l <= 42127, "Yi Radicals": (l) => l >= 42128 && l <= 42191, "Hangul Jamo Extended-A": (l) => l >= 43360 && l <= 43391, "Hangul Syllables": (l) => l >= 44032 && l <= 55215, "Hangul Jamo Extended-B": (l) => l >= 55216 && l <= 55295, "Private Use Area": (l) => l >= 57344 && l <= 63743, "CJK Compatibility Ideographs": (l) => l >= 63744 && l <= 64255, "Arabic Presentation Forms-A": (l) => l >= 64336 && l <= 65023, "Vertical Forms": (l) => l >= 65040 && l <= 65055, "CJK Compatibility Forms": (l) => l >= 65072 && l <= 65103, "Small Form Variants": (l) => l >= 65104 && l <= 65135, "Arabic Presentation Forms-B": (l) => l >= 65136 && l <= 65279, "Halfwidth and Fullwidth Forms": (l) => l >= 65280 && l <= 65519 };
      function Ao(l) {
        for (const s of l) if (eu(s.charCodeAt(0))) return !0;
        return !1;
      }
      function Qc(l) {
        for (const s of l) if (!td(s.charCodeAt(0))) return !1;
        return !0;
      }
      function td(l) {
        return !(Rt.Arabic(l) || Rt["Arabic Supplement"](l) || Rt["Arabic Extended-A"](l) || Rt["Arabic Presentation Forms-A"](l) || Rt["Arabic Presentation Forms-B"](l));
      }
      function eu(l) {
        return !(l !== 746 && l !== 747 && (l < 4352 || !(Rt["Bopomofo Extended"](l) || Rt.Bopomofo(l) || Rt["CJK Compatibility Forms"](l) && !(l >= 65097 && l <= 65103) || Rt["CJK Compatibility Ideographs"](l) || Rt["CJK Compatibility"](l) || Rt["CJK Radicals Supplement"](l) || Rt["CJK Strokes"](l) || !(!Rt["CJK Symbols and Punctuation"](l) || l >= 12296 && l <= 12305 || l >= 12308 && l <= 12319 || l === 12336) || Rt["CJK Unified Ideographs Extension A"](l) || Rt["CJK Unified Ideographs"](l) || Rt["Enclosed CJK Letters and Months"](l) || Rt["Hangul Compatibility Jamo"](l) || Rt["Hangul Jamo Extended-A"](l) || Rt["Hangul Jamo Extended-B"](l) || Rt["Hangul Jamo"](l) || Rt["Hangul Syllables"](l) || Rt.Hiragana(l) || Rt["Ideographic Description Characters"](l) || Rt.Kanbun(l) || Rt["Kangxi Radicals"](l) || Rt["Katakana Phonetic Extensions"](l) || Rt.Katakana(l) && l !== 12540 || !(!Rt["Halfwidth and Fullwidth Forms"](l) || l === 65288 || l === 65289 || l === 65293 || l >= 65306 && l <= 65310 || l === 65339 || l === 65341 || l === 65343 || l >= 65371 && l <= 65503 || l === 65507 || l >= 65512 && l <= 65519) || !(!Rt["Small Form Variants"](l) || l >= 65112 && l <= 65118 || l >= 65123 && l <= 65126) || Rt["Unified Canadian Aboriginal Syllabics"](l) || Rt["Unified Canadian Aboriginal Syllabics Extended"](l) || Rt["Vertical Forms"](l) || Rt["Yijing Hexagram Symbols"](l) || Rt["Yi Syllables"](l) || Rt["Yi Radicals"](l))));
      }
      function ho(l) {
        return !(eu(l) || function(s) {
          return !!(Rt["Latin-1 Supplement"](s) && (s === 167 || s === 169 || s === 174 || s === 177 || s === 188 || s === 189 || s === 190 || s === 215 || s === 247) || Rt["General Punctuation"](s) && (s === 8214 || s === 8224 || s === 8225 || s === 8240 || s === 8241 || s === 8251 || s === 8252 || s === 8258 || s === 8263 || s === 8264 || s === 8265 || s === 8273) || Rt["Letterlike Symbols"](s) || Rt["Number Forms"](s) || Rt["Miscellaneous Technical"](s) && (s >= 8960 && s <= 8967 || s >= 8972 && s <= 8991 || s >= 8996 && s <= 9e3 || s === 9003 || s >= 9085 && s <= 9114 || s >= 9150 && s <= 9165 || s === 9167 || s >= 9169 && s <= 9179 || s >= 9186 && s <= 9215) || Rt["Control Pictures"](s) && s !== 9251 || Rt["Optical Character Recognition"](s) || Rt["Enclosed Alphanumerics"](s) || Rt["Geometric Shapes"](s) || Rt["Miscellaneous Symbols"](s) && !(s >= 9754 && s <= 9759) || Rt["Miscellaneous Symbols and Arrows"](s) && (s >= 11026 && s <= 11055 || s >= 11088 && s <= 11097 || s >= 11192 && s <= 11243) || Rt["CJK Symbols and Punctuation"](s) || Rt.Katakana(s) || Rt["Private Use Area"](s) || Rt["CJK Compatibility Forms"](s) || Rt["Small Form Variants"](s) || Rt["Halfwidth and Fullwidth Forms"](s) || s === 8734 || s === 8756 || s === 8757 || s >= 9984 && s <= 10087 || s >= 10102 && s <= 10131 || s === 65532 || s === 65533);
        }(l));
      }
      function dc(l) {
        return l >= 1424 && l <= 2303 || Rt["Arabic Presentation Forms-A"](l) || Rt["Arabic Presentation Forms-B"](l);
      }
      function pc(l, s) {
        return !(!s && dc(l) || l >= 2304 && l <= 3583 || l >= 3840 && l <= 4255 || Rt.Khmer(l));
      }
      function bl(l) {
        for (const s of l) if (dc(s.charCodeAt(0))) return !0;
        return !1;
      }
      const nd = "deferred", Pa = "loading", Ma = "loaded";
      let wl = null, Jr = "unavailable", Xo = null;
      const id = function(l) {
        l && typeof l == "string" && l.indexOf("NetworkError") > -1 && (Jr = "error"), wl && wl(l);
      };
      function tu() {
        hc.fire(new dt("pluginStateChange", { pluginStatus: Jr, pluginURL: Xo }));
      }
      const hc = new qt(), nu = function() {
        return Jr;
      }, rd = function() {
        if (Jr !== nd || !Xo) throw new Error("rtl-text-plugin cannot be downloaded unless a pluginURL is specified");
        Jr = Pa, tu(), Xo && je({ url: Xo }, (l) => {
          l ? id(l) : (Jr = Ma, tu());
        });
      }, Os = { applyArabicShaping: null, processBidirectionalText: null, processStyledBidirectionalText: null, isLoaded: () => Jr === Ma || Os.applyArabicShaping != null, isLoading: () => Jr === Pa, setState(l) {
        if (!le()) throw new Error("Cannot set the state of the rtl-text-plugin when not in the web-worker context");
        Jr = l.pluginStatus, Xo = l.pluginURL;
      }, isParsed() {
        if (!le()) throw new Error("rtl-text-plugin is only parsed on the worker-threads");
        return Os.applyArabicShaping != null && Os.processBidirectionalText != null && Os.processStyledBidirectionalText != null;
      }, getPluginURL() {
        if (!le()) throw new Error("rtl-text-plugin url can only be queried from the worker threads");
        return Xo;
      } };
      class Ei {
        constructor(s, u) {
          this.zoom = s, u ? (this.now = u.now, this.fadeDuration = u.fadeDuration, this.zoomHistory = u.zoomHistory, this.transition = u.transition) : (this.now = 0, this.fadeDuration = 0, this.zoomHistory = new _l(), this.transition = {});
        }
        isSupportedScript(s) {
          return function(u, m) {
            for (const b of u) if (!pc(b.charCodeAt(0), m)) return !1;
            return !0;
          }(s, Os.isLoaded());
        }
        crossFadingFactor() {
          return this.fadeDuration === 0 ? 1 : Math.min((this.now - this.zoomHistory.lastIntegerZoomTime) / this.fadeDuration, 1);
        }
        getCrossfadeParameters() {
          const s = this.zoom, u = s - Math.floor(s), m = this.crossFadingFactor();
          return s > this.zoomHistory.lastIntegerZoom ? { fromScale: 2, toScale: 1, t: u + (1 - u) * m } : { fromScale: 0.5, toScale: 1, t: 1 - (1 - m) * u };
        }
      }
      class fc {
        constructor(s, u) {
          this.property = s, this.value = u, this.expression = function(m, b) {
            if (ic(m)) return new $i(m, b);
            if (lo(m)) {
              const C = sc(m, b);
              if (C.result === "error") throw new Error(C.value.map((k) => `${k.key}: ${k.message}`).join(", "));
              return C.value;
            }
            {
              let C = m;
              return b.type === "color" && typeof m == "string" ? C = _n.parse(m) : b.type !== "padding" || typeof m != "number" && !Array.isArray(m) || (C = Zr.parse(m)), { kind: "constant", evaluate: () => C };
            }
          }(u === void 0 ? s.specification.default : u, s.specification);
        }
        isDataDriven() {
          return this.expression.kind === "source" || this.expression.kind === "composite";
        }
        possiblyEvaluate(s, u, m) {
          return this.property.possiblyEvaluate(this, s, u, m);
        }
      }
      class sd {
        constructor(s) {
          this.property = s, this.value = new fc(s, void 0);
        }
        transitioned(s, u) {
          return new y(this.property, this.value, u, U({}, s.transition, this.transition), s.now);
        }
        untransitioned() {
          return new y(this.property, this.value, null, {}, 0);
        }
      }
      class p {
        constructor(s) {
          this._properties = s, this._values = Object.create(s.defaultTransitionablePropertyValues);
        }
        getValue(s) {
          return oe(this._values[s].value.value);
        }
        setValue(s, u) {
          Object.prototype.hasOwnProperty.call(this._values, s) || (this._values[s] = new sd(this._values[s].property)), this._values[s].value = new fc(this._values[s].property, u === null ? void 0 : oe(u));
        }
        getTransition(s) {
          return oe(this._values[s].transition);
        }
        setTransition(s, u) {
          Object.prototype.hasOwnProperty.call(this._values, s) || (this._values[s] = new sd(this._values[s].property)), this._values[s].transition = oe(u) || void 0;
        }
        serialize() {
          const s = {};
          for (const u of Object.keys(this._values)) {
            const m = this.getValue(u);
            m !== void 0 && (s[u] = m);
            const b = this.getTransition(u);
            b !== void 0 && (s[`${u}-transition`] = b);
          }
          return s;
        }
        transitioned(s, u) {
          const m = new T(this._properties);
          for (const b of Object.keys(this._values)) m._values[b] = this._values[b].transitioned(s, u._values[b]);
          return m;
        }
        untransitioned() {
          const s = new T(this._properties);
          for (const u of Object.keys(this._values)) s._values[u] = this._values[u].untransitioned();
          return s;
        }
      }
      class y {
        constructor(s, u, m, b, C) {
          this.property = s, this.value = u, this.begin = C + b.delay || 0, this.end = this.begin + b.duration || 0, s.specification.transition && (b.delay || b.duration) && (this.prior = m);
        }
        possiblyEvaluate(s, u, m) {
          const b = s.now || 0, C = this.value.possiblyEvaluate(s, u, m), k = this.prior;
          if (k) {
            if (b > this.end) return this.prior = null, C;
            if (this.value.isDataDriven()) return this.prior = null, C;
            if (b < this.begin) return k.possiblyEvaluate(s, u, m);
            {
              const P = (b - this.begin) / (this.end - this.begin);
              return this.property.interpolate(k.possiblyEvaluate(s, u, m), C, function(D) {
                if (D <= 0) return 0;
                if (D >= 1) return 1;
                const Z = D * D, X = Z * D;
                return 4 * (D < 0.5 ? X : 3 * (D - Z) + X - 0.75);
              }(P));
            }
          }
          return C;
        }
      }
      class T {
        constructor(s) {
          this._properties = s, this._values = Object.create(s.defaultTransitioningPropertyValues);
        }
        possiblyEvaluate(s, u, m) {
          const b = new ge(this._properties);
          for (const C of Object.keys(this._values)) b._values[C] = this._values[C].possiblyEvaluate(s, u, m);
          return b;
        }
        hasTransition() {
          for (const s of Object.keys(this._values)) if (this._values[s].prior) return !0;
          return !1;
        }
      }
      class F {
        constructor(s) {
          this._properties = s, this._values = Object.create(s.defaultPropertyValues);
        }
        getValue(s) {
          return oe(this._values[s].value);
        }
        setValue(s, u) {
          this._values[s] = new fc(this._values[s].property, u === null ? void 0 : oe(u));
        }
        serialize() {
          const s = {};
          for (const u of Object.keys(this._values)) {
            const m = this.getValue(u);
            m !== void 0 && (s[u] = m);
          }
          return s;
        }
        possiblyEvaluate(s, u, m) {
          const b = new ge(this._properties);
          for (const C of Object.keys(this._values)) b._values[C] = this._values[C].possiblyEvaluate(s, u, m);
          return b;
        }
      }
      class j {
        constructor(s, u, m) {
          this.property = s, this.value = u, this.parameters = m;
        }
        isConstant() {
          return this.value.kind === "constant";
        }
        constantOr(s) {
          return this.value.kind === "constant" ? this.value.value : s;
        }
        evaluate(s, u, m, b) {
          return this.property.evaluate(this.value, this.parameters, s, u, m, b);
        }
      }
      class ge {
        constructor(s) {
          this._properties = s, this._values = Object.create(s.defaultPossiblyEvaluatedValues);
        }
        get(s) {
          return this._values[s];
        }
      }
      class xe {
        constructor(s) {
          this.specification = s;
        }
        possiblyEvaluate(s, u) {
          if (s.isDataDriven()) throw new Error("Value should not be data driven");
          return s.expression.evaluate(u);
        }
        interpolate(s, u, m) {
          const b = Gr[this.specification.type];
          return b ? b(s, u, m) : s;
        }
      }
      class Ve {
        constructor(s, u) {
          this.specification = s, this.overrides = u;
        }
        possiblyEvaluate(s, u, m, b) {
          return new j(this, s.expression.kind === "constant" || s.expression.kind === "camera" ? { kind: "constant", value: s.expression.evaluate(u, null, {}, m, b) } : s.expression, u);
        }
        interpolate(s, u, m) {
          if (s.value.kind !== "constant" || u.value.kind !== "constant") return s;
          if (s.value.value === void 0 || u.value.value === void 0) return new j(this, { kind: "constant", value: void 0 }, s.parameters);
          const b = Gr[this.specification.type];
          if (b) {
            const C = b(s.value.value, u.value.value, m);
            return new j(this, { kind: "constant", value: C }, s.parameters);
          }
          return s;
        }
        evaluate(s, u, m, b, C, k) {
          return s.kind === "constant" ? s.value : s.evaluate(u, m, b, C, k);
        }
      }
      class pt extends Ve {
        possiblyEvaluate(s, u, m, b) {
          if (s.value === void 0) return new j(this, { kind: "constant", value: void 0 }, u);
          if (s.expression.kind === "constant") {
            const C = s.expression.evaluate(u, null, {}, m, b), k = s.property.specification.type === "resolvedImage" && typeof C != "string" ? C.name : C, P = this._calculate(k, k, k, u);
            return new j(this, { kind: "constant", value: P }, u);
          }
          if (s.expression.kind === "camera") {
            const C = this._calculate(s.expression.evaluate({ zoom: u.zoom - 1 }), s.expression.evaluate({ zoom: u.zoom }), s.expression.evaluate({ zoom: u.zoom + 1 }), u);
            return new j(this, { kind: "constant", value: C }, u);
          }
          return new j(this, s.expression, u);
        }
        evaluate(s, u, m, b, C, k) {
          if (s.kind === "source") {
            const P = s.evaluate(u, m, b, C, k);
            return this._calculate(P, P, P, u);
          }
          return s.kind === "composite" ? this._calculate(s.evaluate({ zoom: Math.floor(u.zoom) - 1 }, m, b), s.evaluate({ zoom: Math.floor(u.zoom) }, m, b), s.evaluate({ zoom: Math.floor(u.zoom) + 1 }, m, b), u) : s.value;
        }
        _calculate(s, u, m, b) {
          return b.zoom > b.zoomHistory.lastIntegerZoom ? { from: s, to: u } : { from: m, to: u };
        }
        interpolate(s) {
          return s;
        }
      }
      class $t {
        constructor(s) {
          this.specification = s;
        }
        possiblyEvaluate(s, u, m, b) {
          if (s.value !== void 0) {
            if (s.expression.kind === "constant") {
              const C = s.expression.evaluate(u, null, {}, m, b);
              return this._calculate(C, C, C, u);
            }
            return this._calculate(s.expression.evaluate(new Ei(Math.floor(u.zoom - 1), u)), s.expression.evaluate(new Ei(Math.floor(u.zoom), u)), s.expression.evaluate(new Ei(Math.floor(u.zoom + 1), u)), u);
          }
        }
        _calculate(s, u, m, b) {
          return b.zoom > b.zoomHistory.lastIntegerZoom ? { from: s, to: u } : { from: m, to: u };
        }
        interpolate(s) {
          return s;
        }
      }
      class Jt {
        constructor(s) {
          this.specification = s;
        }
        possiblyEvaluate(s, u, m, b) {
          return !!s.expression.evaluate(u, null, {}, m, b);
        }
        interpolate() {
          return !1;
        }
      }
      class pn {
        constructor(s) {
          this.properties = s, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [];
          for (const u in s) {
            const m = s[u];
            m.specification.overridable && this.overridableProperties.push(u);
            const b = this.defaultPropertyValues[u] = new fc(m, void 0), C = this.defaultTransitionablePropertyValues[u] = new sd(m);
            this.defaultTransitioningPropertyValues[u] = C.untransitioned(), this.defaultPossiblyEvaluatedValues[u] = b.possiblyEvaluate({});
          }
        }
      }
      Zt("DataDrivenProperty", Ve), Zt("DataConstantProperty", xe), Zt("CrossFadedDataDrivenProperty", pt), Zt("CrossFadedProperty", $t), Zt("ColorRampProperty", Jt);
      const Hn = "-transition";
      class Hi extends qt {
        constructor(s, u) {
          if (super(), this.id = s.id, this.type = s.type, this._featureFilter = { filter: () => !0, needGeometry: !1 }, s.type !== "custom" && (this.metadata = s.metadata, this.minzoom = s.minzoom, this.maxzoom = s.maxzoom, s.type !== "background" && (this.source = s.source, this.sourceLayer = s["source-layer"], this.filter = s.filter), u.layout && (this._unevaluatedLayout = new F(u.layout)), u.paint)) {
            this._transitionablePaint = new p(u.paint);
            for (const m in s.paint) this.setPaintProperty(m, s.paint[m], { validate: !1 });
            for (const m in s.layout) this.setLayoutProperty(m, s.layout[m], { validate: !1 });
            this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new ge(u.paint);
          }
        }
        getCrossfadeParameters() {
          return this._crossfadeParameters;
        }
        getLayoutProperty(s) {
          return s === "visibility" ? this.visibility : this._unevaluatedLayout.getValue(s);
        }
        setLayoutProperty(s, u, m = {}) {
          u != null && this._validate(lf, `layers.${this.id}.layout.${s}`, s, u, m) || (s !== "visibility" ? this._unevaluatedLayout.setValue(s, u) : this.visibility = u);
        }
        getPaintProperty(s) {
          return s.endsWith(Hn) ? this._transitionablePaint.getTransition(s.slice(0, -11)) : this._transitionablePaint.getValue(s);
        }
        setPaintProperty(s, u, m = {}) {
          if (u != null && this._validate(rp, `layers.${this.id}.paint.${s}`, s, u, m)) return !1;
          if (s.endsWith(Hn)) return this._transitionablePaint.setTransition(s.slice(0, -11), u || void 0), !1;
          {
            const b = this._transitionablePaint._values[s], C = b.property.specification["property-type"] === "cross-faded-data-driven", k = b.value.isDataDriven(), P = b.value;
            this._transitionablePaint.setValue(s, u), this._handleSpecialPaintPropertyUpdate(s);
            const D = this._transitionablePaint._values[s].value;
            return D.isDataDriven() || k || C || this._handleOverridablePaintPropertyUpdate(s, P, D);
          }
        }
        _handleSpecialPaintPropertyUpdate(s) {
        }
        _handleOverridablePaintPropertyUpdate(s, u, m) {
          return !1;
        }
        isHidden(s) {
          return !!(this.minzoom && s < this.minzoom) || !!(this.maxzoom && s >= this.maxzoom) || this.visibility === "none";
        }
        updateTransitions(s) {
          this._transitioningPaint = this._transitionablePaint.transitioned(s, this._transitioningPaint);
        }
        hasTransition() {
          return this._transitioningPaint.hasTransition();
        }
        recalculate(s, u) {
          s.getCrossfadeParameters && (this._crossfadeParameters = s.getCrossfadeParameters()), this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(s, void 0, u)), this.paint = this._transitioningPaint.possiblyEvaluate(s, void 0, u);
        }
        serialize() {
          const s = { id: this.id, type: this.type, source: this.source, "source-layer": this.sourceLayer, metadata: this.metadata, minzoom: this.minzoom, maxzoom: this.maxzoom, filter: this.filter, layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(), paint: this._transitionablePaint && this._transitionablePaint.serialize() };
          return this.visibility && (s.layout = s.layout || {}, s.layout.visibility = this.visibility), ae(s, (u, m) => !(u === void 0 || m === "layout" && !Object.keys(u).length || m === "paint" && !Object.keys(u).length));
        }
        _validate(s, u, m, b, C = {}) {
          return (!C || C.validate !== !1) && Xr(this, s.call(To, { key: u, layerType: this.type, objectKey: m, value: b, styleSpec: Oe, style: { glyphs: !0, sprite: !0 } }));
        }
        is3D() {
          return !1;
        }
        isTileClipped() {
          return !1;
        }
        hasOffscreenPass() {
          return !1;
        }
        resize() {
        }
        isStateDependent() {
          for (const s in this.paint._values) {
            const u = this.paint.get(s);
            if (u instanceof j && Ca(u.property.specification) && (u.value.kind === "source" || u.value.kind === "composite") && u.value.isStateDependent) return !0;
          }
          return !1;
        }
      }
      const fr = { Int8: Int8Array, Uint8: Uint8Array, Int16: Int16Array, Uint16: Uint16Array, Int32: Int32Array, Uint32: Uint32Array, Float32: Float32Array };
      class ir {
        constructor(s, u) {
          this._structArray = s, this._pos1 = u * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
        }
      }
      class Kn {
        constructor() {
          this.isTransferred = !1, this.capacity = -1, this.resize(0);
        }
        static serialize(s, u) {
          return s._trim(), u && (s.isTransferred = !0, u.push(s.arrayBuffer)), { length: s.length, arrayBuffer: s.arrayBuffer };
        }
        static deserialize(s) {
          const u = Object.create(this.prototype);
          return u.arrayBuffer = s.arrayBuffer, u.length = s.length, u.capacity = s.arrayBuffer.byteLength / u.bytesPerElement, u._refreshViews(), u;
        }
        _trim() {
          this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
        }
        clear() {
          this.length = 0;
        }
        resize(s) {
          this.reserve(s), this.length = s;
        }
        reserve(s) {
          if (s > this.capacity) {
            this.capacity = Math.max(s, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
            const u = this.uint8;
            this._refreshViews(), u && this.uint8.set(u);
          }
        }
        _refreshViews() {
          throw new Error("_refreshViews() must be implemented by each concrete StructArray layout");
        }
      }
      function Ri(l, s = 1) {
        let u = 0, m = 0;
        return { members: l.map((b) => {
          const C = fr[b.type].BYTES_PER_ELEMENT, k = u = sp(u, Math.max(s, C)), P = b.components || 1;
          return m = Math.max(m, C), u += C * P, { name: b.name, type: b.type, components: P, offset: k };
        }), size: sp(u, Math.max(m, s)), alignment: s };
      }
      function sp(l, s) {
        return Math.ceil(l / s) * s;
      }
      class xl extends Kn {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
        }
        emplaceBack(s, u) {
          const m = this.length;
          return this.resize(m + 1), this.emplace(m, s, u);
        }
        emplace(s, u, m) {
          const b = 2 * s;
          return this.int16[b + 0] = u, this.int16[b + 1] = m, s;
        }
      }
      xl.prototype.bytesPerElement = 4, Zt("StructArrayLayout2i4", xl);
      class iu extends Kn {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
        }
        emplaceBack(s, u, m) {
          const b = this.length;
          return this.resize(b + 1), this.emplace(b, s, u, m);
        }
        emplace(s, u, m, b) {
          const C = 3 * s;
          return this.int16[C + 0] = u, this.int16[C + 1] = m, this.int16[C + 2] = b, s;
        }
      }
      iu.prototype.bytesPerElement = 6, Zt("StructArrayLayout3i6", iu);
      class ru extends Kn {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
        }
        emplaceBack(s, u, m, b) {
          const C = this.length;
          return this.resize(C + 1), this.emplace(C, s, u, m, b);
        }
        emplace(s, u, m, b, C) {
          const k = 4 * s;
          return this.int16[k + 0] = u, this.int16[k + 1] = m, this.int16[k + 2] = b, this.int16[k + 3] = C, s;
        }
      }
      ru.prototype.bytesPerElement = 8, Zt("StructArrayLayout4i8", ru);
      class fo extends Kn {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
        }
        emplaceBack(s, u, m, b, C, k) {
          const P = this.length;
          return this.resize(P + 1), this.emplace(P, s, u, m, b, C, k);
        }
        emplace(s, u, m, b, C, k, P) {
          const D = 6 * s;
          return this.int16[D + 0] = u, this.int16[D + 1] = m, this.int16[D + 2] = b, this.int16[D + 3] = C, this.int16[D + 4] = k, this.int16[D + 5] = P, s;
        }
      }
      fo.prototype.bytesPerElement = 12, Zt("StructArrayLayout2i4i12", fo);
      class mc extends Kn {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
        }
        emplaceBack(s, u, m, b, C, k) {
          const P = this.length;
          return this.resize(P + 1), this.emplace(P, s, u, m, b, C, k);
        }
        emplace(s, u, m, b, C, k, P) {
          const D = 4 * s, Z = 8 * s;
          return this.int16[D + 0] = u, this.int16[D + 1] = m, this.uint8[Z + 4] = b, this.uint8[Z + 5] = C, this.uint8[Z + 6] = k, this.uint8[Z + 7] = P, s;
        }
      }
      mc.prototype.bytesPerElement = 8, Zt("StructArrayLayout2i4ub8", mc);
      class Pi extends Kn {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(s, u) {
          const m = this.length;
          return this.resize(m + 1), this.emplace(m, s, u);
        }
        emplace(s, u, m) {
          const b = 2 * s;
          return this.float32[b + 0] = u, this.float32[b + 1] = m, s;
        }
      }
      Pi.prototype.bytesPerElement = 8, Zt("StructArrayLayout2f8", Pi);
      class Da extends Kn {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
        }
        emplaceBack(s, u, m, b, C, k, P, D, Z, X) {
          const ie = this.length;
          return this.resize(ie + 1), this.emplace(ie, s, u, m, b, C, k, P, D, Z, X);
        }
        emplace(s, u, m, b, C, k, P, D, Z, X, ie) {
          const ce = 10 * s;
          return this.uint16[ce + 0] = u, this.uint16[ce + 1] = m, this.uint16[ce + 2] = b, this.uint16[ce + 3] = C, this.uint16[ce + 4] = k, this.uint16[ce + 5] = P, this.uint16[ce + 6] = D, this.uint16[ce + 7] = Z, this.uint16[ce + 8] = X, this.uint16[ce + 9] = ie, s;
        }
      }
      Da.prototype.bytesPerElement = 20, Zt("StructArrayLayout10ui20", Da);
      class vc extends Kn {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
        }
        emplaceBack(s, u, m, b, C, k, P, D, Z, X, ie, ce) {
          const he = this.length;
          return this.resize(he + 1), this.emplace(he, s, u, m, b, C, k, P, D, Z, X, ie, ce);
        }
        emplace(s, u, m, b, C, k, P, D, Z, X, ie, ce, he) {
          const ye = 12 * s;
          return this.int16[ye + 0] = u, this.int16[ye + 1] = m, this.int16[ye + 2] = b, this.int16[ye + 3] = C, this.uint16[ye + 4] = k, this.uint16[ye + 5] = P, this.uint16[ye + 6] = D, this.uint16[ye + 7] = Z, this.int16[ye + 8] = X, this.int16[ye + 9] = ie, this.int16[ye + 10] = ce, this.int16[ye + 11] = he, s;
        }
      }
      vc.prototype.bytesPerElement = 24, Zt("StructArrayLayout4i4ui4i24", vc);
      class od extends Kn {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(s, u, m) {
          const b = this.length;
          return this.resize(b + 1), this.emplace(b, s, u, m);
        }
        emplace(s, u, m, b) {
          const C = 3 * s;
          return this.float32[C + 0] = u, this.float32[C + 1] = m, this.float32[C + 2] = b, s;
        }
      }
      od.prototype.bytesPerElement = 12, Zt("StructArrayLayout3f12", od);
      class $l extends Kn {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
        }
        emplaceBack(s) {
          const u = this.length;
          return this.resize(u + 1), this.emplace(u, s);
        }
        emplace(s, u) {
          return this.uint32[1 * s + 0] = u, s;
        }
      }
      $l.prototype.bytesPerElement = 4, Zt("StructArrayLayout1ul4", $l);
      class Eo extends Kn {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
        }
        emplaceBack(s, u, m, b, C, k, P, D, Z) {
          const X = this.length;
          return this.resize(X + 1), this.emplace(X, s, u, m, b, C, k, P, D, Z);
        }
        emplace(s, u, m, b, C, k, P, D, Z, X) {
          const ie = 10 * s, ce = 5 * s;
          return this.int16[ie + 0] = u, this.int16[ie + 1] = m, this.int16[ie + 2] = b, this.int16[ie + 3] = C, this.int16[ie + 4] = k, this.int16[ie + 5] = P, this.uint32[ce + 3] = D, this.uint16[ie + 8] = Z, this.uint16[ie + 9] = X, s;
        }
      }
      Eo.prototype.bytesPerElement = 20, Zt("StructArrayLayout6i1ul2ui20", Eo);
      class su extends Kn {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
        }
        emplaceBack(s, u, m, b, C, k) {
          const P = this.length;
          return this.resize(P + 1), this.emplace(P, s, u, m, b, C, k);
        }
        emplace(s, u, m, b, C, k, P) {
          const D = 6 * s;
          return this.int16[D + 0] = u, this.int16[D + 1] = m, this.int16[D + 2] = b, this.int16[D + 3] = C, this.int16[D + 4] = k, this.int16[D + 5] = P, s;
        }
      }
      su.prototype.bytesPerElement = 12, Zt("StructArrayLayout2i2i2i12", su);
      class ou extends Kn {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
        }
        emplaceBack(s, u, m, b, C) {
          const k = this.length;
          return this.resize(k + 1), this.emplace(k, s, u, m, b, C);
        }
        emplace(s, u, m, b, C, k) {
          const P = 4 * s, D = 8 * s;
          return this.float32[P + 0] = u, this.float32[P + 1] = m, this.float32[P + 2] = b, this.int16[D + 6] = C, this.int16[D + 7] = k, s;
        }
      }
      ou.prototype.bytesPerElement = 16, Zt("StructArrayLayout2f1f2i16", ou);
      class gc extends Kn {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(s, u, m, b) {
          const C = this.length;
          return this.resize(C + 1), this.emplace(C, s, u, m, b);
        }
        emplace(s, u, m, b, C) {
          const k = 12 * s, P = 3 * s;
          return this.uint8[k + 0] = u, this.uint8[k + 1] = m, this.float32[P + 1] = b, this.float32[P + 2] = C, s;
        }
      }
      gc.prototype.bytesPerElement = 12, Zt("StructArrayLayout2ub2f12", gc);
      class op extends Kn {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
        }
        emplaceBack(s, u, m) {
          const b = this.length;
          return this.resize(b + 1), this.emplace(b, s, u, m);
        }
        emplace(s, u, m, b) {
          const C = 3 * s;
          return this.uint16[C + 0] = u, this.uint16[C + 1] = m, this.uint16[C + 2] = b, s;
        }
      }
      op.prototype.bytesPerElement = 6, Zt("StructArrayLayout3ui6", op);
      class cf extends Kn {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(s, u, m, b, C, k, P, D, Z, X, ie, ce, he, ye, Ie, ke, He) {
          const Qe = this.length;
          return this.resize(Qe + 1), this.emplace(Qe, s, u, m, b, C, k, P, D, Z, X, ie, ce, he, ye, Ie, ke, He);
        }
        emplace(s, u, m, b, C, k, P, D, Z, X, ie, ce, he, ye, Ie, ke, He, Qe) {
          const Be = 24 * s, lt = 12 * s, ut = 48 * s;
          return this.int16[Be + 0] = u, this.int16[Be + 1] = m, this.uint16[Be + 2] = b, this.uint16[Be + 3] = C, this.uint32[lt + 2] = k, this.uint32[lt + 3] = P, this.uint32[lt + 4] = D, this.uint16[Be + 10] = Z, this.uint16[Be + 11] = X, this.uint16[Be + 12] = ie, this.float32[lt + 7] = ce, this.float32[lt + 8] = he, this.uint8[ut + 36] = ye, this.uint8[ut + 37] = Ie, this.uint8[ut + 38] = ke, this.uint32[lt + 10] = He, this.int16[Be + 22] = Qe, s;
        }
      }
      cf.prototype.bytesPerElement = 48, Zt("StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48", cf);
      class ap extends Kn {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(s, u, m, b, C, k, P, D, Z, X, ie, ce, he, ye, Ie, ke, He, Qe, Be, lt, ut, vt, Xt, nn, Vt, Ft, Lt, Ut) {
          const zt = this.length;
          return this.resize(zt + 1), this.emplace(zt, s, u, m, b, C, k, P, D, Z, X, ie, ce, he, ye, Ie, ke, He, Qe, Be, lt, ut, vt, Xt, nn, Vt, Ft, Lt, Ut);
        }
        emplace(s, u, m, b, C, k, P, D, Z, X, ie, ce, he, ye, Ie, ke, He, Qe, Be, lt, ut, vt, Xt, nn, Vt, Ft, Lt, Ut, zt) {
          const St = 34 * s, mn = 17 * s;
          return this.int16[St + 0] = u, this.int16[St + 1] = m, this.int16[St + 2] = b, this.int16[St + 3] = C, this.int16[St + 4] = k, this.int16[St + 5] = P, this.int16[St + 6] = D, this.int16[St + 7] = Z, this.uint16[St + 8] = X, this.uint16[St + 9] = ie, this.uint16[St + 10] = ce, this.uint16[St + 11] = he, this.uint16[St + 12] = ye, this.uint16[St + 13] = Ie, this.uint16[St + 14] = ke, this.uint16[St + 15] = He, this.uint16[St + 16] = Qe, this.uint16[St + 17] = Be, this.uint16[St + 18] = lt, this.uint16[St + 19] = ut, this.uint16[St + 20] = vt, this.uint16[St + 21] = Xt, this.uint16[St + 22] = nn, this.uint32[mn + 12] = Vt, this.float32[mn + 13] = Ft, this.float32[mn + 14] = Lt, this.float32[mn + 15] = Ut, this.float32[mn + 16] = zt, s;
        }
      }
      ap.prototype.bytesPerElement = 68, Zt("StructArrayLayout8i15ui1ul4f68", ap);
      class lp extends Kn {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(s) {
          const u = this.length;
          return this.resize(u + 1), this.emplace(u, s);
        }
        emplace(s, u) {
          return this.float32[1 * s + 0] = u, s;
        }
      }
      lp.prototype.bytesPerElement = 4, Zt("StructArrayLayout1f4", lp);
      class cp extends Kn {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
        }
        emplaceBack(s, u, m) {
          const b = this.length;
          return this.resize(b + 1), this.emplace(b, s, u, m);
        }
        emplace(s, u, m, b) {
          const C = 4 * s;
          return this.uint32[2 * s + 0] = u, this.uint16[C + 2] = m, this.uint16[C + 3] = b, s;
        }
      }
      cp.prototype.bytesPerElement = 8, Zt("StructArrayLayout1ul2ui8", cp);
      class _ extends Kn {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
        }
        emplaceBack(s, u) {
          const m = this.length;
          return this.resize(m + 1), this.emplace(m, s, u);
        }
        emplace(s, u, m) {
          const b = 2 * s;
          return this.uint16[b + 0] = u, this.uint16[b + 1] = m, s;
        }
      }
      _.prototype.bytesPerElement = 4, Zt("StructArrayLayout2ui4", _);
      class o extends Kn {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
        }
        emplaceBack(s) {
          const u = this.length;
          return this.resize(u + 1), this.emplace(u, s);
        }
        emplace(s, u) {
          return this.uint16[1 * s + 0] = u, s;
        }
      }
      o.prototype.bytesPerElement = 2, Zt("StructArrayLayout1ui2", o);
      class h extends Kn {
        _refreshViews() {
          this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
        }
        emplaceBack(s, u, m, b) {
          const C = this.length;
          return this.resize(C + 1), this.emplace(C, s, u, m, b);
        }
        emplace(s, u, m, b, C) {
          const k = 4 * s;
          return this.float32[k + 0] = u, this.float32[k + 1] = m, this.float32[k + 2] = b, this.float32[k + 3] = C, s;
        }
      }
      h.prototype.bytesPerElement = 16, Zt("StructArrayLayout4f16", h);
      class v extends ir {
        get anchorPointX() {
          return this._structArray.int16[this._pos2 + 0];
        }
        get anchorPointY() {
          return this._structArray.int16[this._pos2 + 1];
        }
        get x1() {
          return this._structArray.int16[this._pos2 + 2];
        }
        get y1() {
          return this._structArray.int16[this._pos2 + 3];
        }
        get x2() {
          return this._structArray.int16[this._pos2 + 4];
        }
        get y2() {
          return this._structArray.int16[this._pos2 + 5];
        }
        get featureIndex() {
          return this._structArray.uint32[this._pos4 + 3];
        }
        get sourceLayerIndex() {
          return this._structArray.uint16[this._pos2 + 8];
        }
        get bucketIndex() {
          return this._structArray.uint16[this._pos2 + 9];
        }
        get anchorPoint() {
          return new $(this.anchorPointX, this.anchorPointY);
        }
      }
      v.prototype.size = 20;
      class w extends Eo {
        get(s) {
          return new v(this, s);
        }
      }
      Zt("CollisionBoxArray", w);
      class S extends ir {
        get anchorX() {
          return this._structArray.int16[this._pos2 + 0];
        }
        get anchorY() {
          return this._structArray.int16[this._pos2 + 1];
        }
        get glyphStartIndex() {
          return this._structArray.uint16[this._pos2 + 2];
        }
        get numGlyphs() {
          return this._structArray.uint16[this._pos2 + 3];
        }
        get vertexStartIndex() {
          return this._structArray.uint32[this._pos4 + 2];
        }
        get lineStartIndex() {
          return this._structArray.uint32[this._pos4 + 3];
        }
        get lineLength() {
          return this._structArray.uint32[this._pos4 + 4];
        }
        get segment() {
          return this._structArray.uint16[this._pos2 + 10];
        }
        get lowerSize() {
          return this._structArray.uint16[this._pos2 + 11];
        }
        get upperSize() {
          return this._structArray.uint16[this._pos2 + 12];
        }
        get lineOffsetX() {
          return this._structArray.float32[this._pos4 + 7];
        }
        get lineOffsetY() {
          return this._structArray.float32[this._pos4 + 8];
        }
        get writingMode() {
          return this._structArray.uint8[this._pos1 + 36];
        }
        get placedOrientation() {
          return this._structArray.uint8[this._pos1 + 37];
        }
        set placedOrientation(s) {
          this._structArray.uint8[this._pos1 + 37] = s;
        }
        get hidden() {
          return this._structArray.uint8[this._pos1 + 38];
        }
        set hidden(s) {
          this._structArray.uint8[this._pos1 + 38] = s;
        }
        get crossTileID() {
          return this._structArray.uint32[this._pos4 + 10];
        }
        set crossTileID(s) {
          this._structArray.uint32[this._pos4 + 10] = s;
        }
        get associatedIconIndex() {
          return this._structArray.int16[this._pos2 + 22];
        }
      }
      S.prototype.size = 48;
      class M extends cf {
        get(s) {
          return new S(this, s);
        }
      }
      Zt("PlacedSymbolArray", M);
      class z extends ir {
        get anchorX() {
          return this._structArray.int16[this._pos2 + 0];
        }
        get anchorY() {
          return this._structArray.int16[this._pos2 + 1];
        }
        get rightJustifiedTextSymbolIndex() {
          return this._structArray.int16[this._pos2 + 2];
        }
        get centerJustifiedTextSymbolIndex() {
          return this._structArray.int16[this._pos2 + 3];
        }
        get leftJustifiedTextSymbolIndex() {
          return this._structArray.int16[this._pos2 + 4];
        }
        get verticalPlacedTextSymbolIndex() {
          return this._structArray.int16[this._pos2 + 5];
        }
        get placedIconSymbolIndex() {
          return this._structArray.int16[this._pos2 + 6];
        }
        get verticalPlacedIconSymbolIndex() {
          return this._structArray.int16[this._pos2 + 7];
        }
        get key() {
          return this._structArray.uint16[this._pos2 + 8];
        }
        get textBoxStartIndex() {
          return this._structArray.uint16[this._pos2 + 9];
        }
        get textBoxEndIndex() {
          return this._structArray.uint16[this._pos2 + 10];
        }
        get verticalTextBoxStartIndex() {
          return this._structArray.uint16[this._pos2 + 11];
        }
        get verticalTextBoxEndIndex() {
          return this._structArray.uint16[this._pos2 + 12];
        }
        get iconBoxStartIndex() {
          return this._structArray.uint16[this._pos2 + 13];
        }
        get iconBoxEndIndex() {
          return this._structArray.uint16[this._pos2 + 14];
        }
        get verticalIconBoxStartIndex() {
          return this._structArray.uint16[this._pos2 + 15];
        }
        get verticalIconBoxEndIndex() {
          return this._structArray.uint16[this._pos2 + 16];
        }
        get featureIndex() {
          return this._structArray.uint16[this._pos2 + 17];
        }
        get numHorizontalGlyphVertices() {
          return this._structArray.uint16[this._pos2 + 18];
        }
        get numVerticalGlyphVertices() {
          return this._structArray.uint16[this._pos2 + 19];
        }
        get numIconVertices() {
          return this._structArray.uint16[this._pos2 + 20];
        }
        get numVerticalIconVertices() {
          return this._structArray.uint16[this._pos2 + 21];
        }
        get useRuntimeCollisionCircles() {
          return this._structArray.uint16[this._pos2 + 22];
        }
        get crossTileID() {
          return this._structArray.uint32[this._pos4 + 12];
        }
        set crossTileID(s) {
          this._structArray.uint32[this._pos4 + 12] = s;
        }
        get textBoxScale() {
          return this._structArray.float32[this._pos4 + 13];
        }
        get textOffset0() {
          return this._structArray.float32[this._pos4 + 14];
        }
        get textOffset1() {
          return this._structArray.float32[this._pos4 + 15];
        }
        get collisionCircleDiameter() {
          return this._structArray.float32[this._pos4 + 16];
        }
      }
      z.prototype.size = 68;
      class R extends ap {
        get(s) {
          return new z(this, s);
        }
      }
      Zt("SymbolInstanceArray", R);
      class W extends lp {
        getoffsetX(s) {
          return this.float32[1 * s + 0];
        }
      }
      Zt("GlyphOffsetArray", W);
      class Q extends iu {
        getx(s) {
          return this.int16[3 * s + 0];
        }
        gety(s) {
          return this.int16[3 * s + 1];
        }
        gettileUnitDistanceFromAnchor(s) {
          return this.int16[3 * s + 2];
        }
      }
      Zt("SymbolLineVertexArray", Q);
      class J extends ir {
        get featureIndex() {
          return this._structArray.uint32[this._pos4 + 0];
        }
        get sourceLayerIndex() {
          return this._structArray.uint16[this._pos2 + 2];
        }
        get bucketIndex() {
          return this._structArray.uint16[this._pos2 + 3];
        }
      }
      J.prototype.size = 8;
      class fe extends cp {
        get(s) {
          return new J(this, s);
        }
      }
      Zt("FeatureIndexArray", fe);
      class Se extends xl {
      }
      class we extends xl {
      }
      class Ce extends xl {
      }
      class Me extends fo {
      }
      class Ue extends mc {
      }
      class ct extends Pi {
      }
      class Ee extends Da {
      }
      class st extends vc {
      }
      class ht extends od {
      }
      class wt extends $l {
      }
      class Ct extends su {
      }
      class Dt extends gc {
      }
      class xt extends op {
      }
      class Wt extends _ {
      }
      const fn = Ri([{ name: "a_pos", components: 2, type: "Int16" }], 4), { members: En } = fn;
      class Ot {
        constructor(s = []) {
          this.segments = s;
        }
        prepareSegment(s, u, m, b) {
          let C = this.segments[this.segments.length - 1];
          return s > Ot.MAX_VERTEX_ARRAY_LENGTH && me(`Max vertices per segment is ${Ot.MAX_VERTEX_ARRAY_LENGTH}: bucket requested ${s}`), (!C || C.vertexLength + s > Ot.MAX_VERTEX_ARRAY_LENGTH || C.sortKey !== b) && (C = { vertexOffset: u.length, primitiveOffset: m.length, vertexLength: 0, primitiveLength: 0 }, b !== void 0 && (C.sortKey = b), this.segments.push(C)), C;
        }
        get() {
          return this.segments;
        }
        destroy() {
          for (const s of this.segments) for (const u in s.vaos) s.vaos[u].destroy();
        }
        static simpleSegment(s, u, m, b) {
          return new Ot([{ vertexOffset: s, primitiveOffset: u, vertexLength: m, primitiveLength: b, vaos: {}, sortKey: 0 }]);
        }
      }
      function xn(l, s) {
        return 256 * (l = N(Math.floor(l), 0, 255)) + N(Math.floor(s), 0, 255);
      }
      Ot.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, Zt("SegmentVector", Ot);
      const Gt = Ri([{ name: "a_pattern_from", components: 4, type: "Uint16" }, { name: "a_pattern_to", components: 4, type: "Uint16" }, { name: "a_pixel_ratio_from", components: 1, type: "Uint16" }, { name: "a_pixel_ratio_to", components: 1, type: "Uint16" }]);
      var ni = { exports: {} }, cr = { exports: {} };
      cr.exports = function(l, s) {
        var u, m, b, C, k, P, D, Z;
        for (m = l.length - (u = 3 & l.length), b = s, k = 3432918353, P = 461845907, Z = 0; Z < m; ) D = 255 & l.charCodeAt(Z) | (255 & l.charCodeAt(++Z)) << 8 | (255 & l.charCodeAt(++Z)) << 16 | (255 & l.charCodeAt(++Z)) << 24, ++Z, b = 27492 + (65535 & (C = 5 * (65535 & (b = (b ^= D = (65535 & (D = (D = (65535 & D) * k + (((D >>> 16) * k & 65535) << 16) & 4294967295) << 15 | D >>> 17)) * P + (((D >>> 16) * P & 65535) << 16) & 4294967295) << 13 | b >>> 19)) + ((5 * (b >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (C >>> 16) & 65535) << 16);
        switch (D = 0, u) {
          case 3:
            D ^= (255 & l.charCodeAt(Z + 2)) << 16;
          case 2:
            D ^= (255 & l.charCodeAt(Z + 1)) << 8;
          case 1:
            b ^= D = (65535 & (D = (D = (65535 & (D ^= 255 & l.charCodeAt(Z))) * k + (((D >>> 16) * k & 65535) << 16) & 4294967295) << 15 | D >>> 17)) * P + (((D >>> 16) * P & 65535) << 16) & 4294967295;
        }
        return b ^= l.length, b = 2246822507 * (65535 & (b ^= b >>> 16)) + ((2246822507 * (b >>> 16) & 65535) << 16) & 4294967295, b = 3266489909 * (65535 & (b ^= b >>> 13)) + ((3266489909 * (b >>> 16) & 65535) << 16) & 4294967295, (b ^= b >>> 16) >>> 0;
      };
      var ii = cr.exports, Dn = { exports: {} };
      Dn.exports = function(l, s) {
        for (var u, m = l.length, b = s ^ m, C = 0; m >= 4; ) u = 1540483477 * (65535 & (u = 255 & l.charCodeAt(C) | (255 & l.charCodeAt(++C)) << 8 | (255 & l.charCodeAt(++C)) << 16 | (255 & l.charCodeAt(++C)) << 24)) + ((1540483477 * (u >>> 16) & 65535) << 16), b = 1540483477 * (65535 & b) + ((1540483477 * (b >>> 16) & 65535) << 16) ^ (u = 1540483477 * (65535 & (u ^= u >>> 24)) + ((1540483477 * (u >>> 16) & 65535) << 16)), m -= 4, ++C;
        switch (m) {
          case 3:
            b ^= (255 & l.charCodeAt(C + 2)) << 16;
          case 2:
            b ^= (255 & l.charCodeAt(C + 1)) << 8;
          case 1:
            b = 1540483477 * (65535 & (b ^= 255 & l.charCodeAt(C))) + ((1540483477 * (b >>> 16) & 65535) << 16);
        }
        return b = 1540483477 * (65535 & (b ^= b >>> 13)) + ((1540483477 * (b >>> 16) & 65535) << 16), (b ^= b >>> 15) >>> 0;
      };
      var rr = ii, bs = Dn.exports;
      ni.exports = rr, ni.exports.murmur3 = rr, ni.exports.murmur2 = bs;
      var ur = f(ni.exports);
      class Lr {
        constructor() {
          this.ids = [], this.positions = [], this.indexed = !1;
        }
        add(s, u, m, b) {
          this.ids.push(Gs(s)), this.positions.push(u, m, b);
        }
        getPositions(s) {
          if (!this.indexed) throw new Error("Trying to get index, but feature positions are not indexed");
          const u = Gs(s);
          let m = 0, b = this.ids.length - 1;
          for (; m < b; ) {
            const k = m + b >> 1;
            this.ids[k] >= u ? b = k : m = k + 1;
          }
          const C = [];
          for (; this.ids[m] === u; ) C.push({ index: this.positions[3 * m], start: this.positions[3 * m + 1], end: this.positions[3 * m + 2] }), m++;
          return C;
        }
        static serialize(s, u) {
          const m = new Float64Array(s.ids), b = new Uint32Array(s.positions);
          return Po(m, b, 0, m.length - 1), u && u.push(m.buffer, b.buffer), { ids: m, positions: b };
        }
        static deserialize(s) {
          const u = new Lr();
          return u.ids = s.ids, u.positions = s.positions, u.indexed = !0, u;
        }
      }
      function Gs(l) {
        const s = +l;
        return !isNaN(s) && s <= Number.MAX_SAFE_INTEGER ? s : ur(String(l));
      }
      function Po(l, s, u, m) {
        for (; u < m; ) {
          const b = l[u + m >> 1];
          let C = u - 1, k = m + 1;
          for (; ; ) {
            do
              C++;
            while (l[C] < b);
            do
              k--;
            while (l[k] > b);
            if (C >= k) break;
            Mo(l, C, k), Mo(s, 3 * C, 3 * k), Mo(s, 3 * C + 1, 3 * k + 1), Mo(s, 3 * C + 2, 3 * k + 2);
          }
          k - u < m - k ? (Po(l, s, u, k), u = k + 1) : (Po(l, s, k + 1, m), m = k);
        }
      }
      function Mo(l, s, u) {
        const m = l[s];
        l[s] = l[u], l[u] = m;
      }
      Zt("FeaturePositionMap", Lr);
      class ws {
        constructor(s, u) {
          this.gl = s.gl, this.location = u;
        }
      }
      class Jo extends ws {
        constructor(s, u) {
          super(s, u), this.current = 0;
        }
        set(s) {
          this.current !== s && (this.current = s, this.gl.uniform1f(this.location, s));
        }
      }
      class ad extends ws {
        constructor(s, u) {
          super(s, u), this.current = [0, 0, 0, 0];
        }
        set(s) {
          s[0] === this.current[0] && s[1] === this.current[1] && s[2] === this.current[2] && s[3] === this.current[3] || (this.current = s, this.gl.uniform4f(this.location, s[0], s[1], s[2], s[3]));
        }
      }
      class rs extends ws {
        constructor(s, u) {
          super(s, u), this.current = _n.transparent;
        }
        set(s) {
          s.r === this.current.r && s.g === this.current.g && s.b === this.current.b && s.a === this.current.a || (this.current = s, this.gl.uniform4f(this.location, s.r, s.g, s.b, s.a));
        }
      }
      const Or = new Float32Array(16);
      function ui(l) {
        return [xn(255 * l.r, 255 * l.g), xn(255 * l.b, 255 * l.a)];
      }
      class Sr {
        constructor(s, u, m) {
          this.value = s, this.uniformNames = u.map((b) => `u_${b}`), this.type = m;
        }
        setUniform(s, u, m) {
          s.set(m.constantOr(this.value));
        }
        getBinding(s, u, m) {
          return this.type === "color" ? new rs(s, u) : new Jo(s, u);
        }
      }
      class Nr {
        constructor(s, u) {
          this.uniformNames = u.map((m) => `u_${m}`), this.patternFrom = null, this.patternTo = null, this.pixelRatioFrom = 1, this.pixelRatioTo = 1;
        }
        setConstantPatternPositions(s, u) {
          this.pixelRatioFrom = u.pixelRatio, this.pixelRatioTo = s.pixelRatio, this.patternFrom = u.tlbr, this.patternTo = s.tlbr;
        }
        setUniform(s, u, m, b) {
          const C = b === "u_pattern_to" ? this.patternTo : b === "u_pattern_from" ? this.patternFrom : b === "u_pixel_ratio_to" ? this.pixelRatioTo : b === "u_pixel_ratio_from" ? this.pixelRatioFrom : null;
          C && s.set(C);
        }
        getBinding(s, u, m) {
          return m.substr(0, 9) === "u_pattern" ? new ad(s, u) : new Jo(s, u);
        }
      }
      class fi {
        constructor(s, u, m, b) {
          this.expression = s, this.type = m, this.maxValue = 0, this.paintVertexAttributes = u.map((C) => ({ name: `a_${C}`, type: "Float32", components: m === "color" ? 2 : 1, offset: 0 })), this.paintVertexArray = new b();
        }
        populatePaintArray(s, u, m, b, C) {
          const k = this.paintVertexArray.length, P = this.expression.evaluate(new Ei(0), u, {}, b, [], C);
          this.paintVertexArray.resize(s), this._setPaintValue(k, s, P);
        }
        updatePaintArray(s, u, m, b) {
          const C = this.expression.evaluate({ zoom: 0 }, m, b);
          this._setPaintValue(s, u, C);
        }
        _setPaintValue(s, u, m) {
          if (this.type === "color") {
            const b = ui(m);
            for (let C = s; C < u; C++) this.paintVertexArray.emplace(C, b[0], b[1]);
          } else {
            for (let b = s; b < u; b++) this.paintVertexArray.emplace(b, m);
            this.maxValue = Math.max(this.maxValue, Math.abs(m));
          }
        }
        upload(s) {
          this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = s.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
        }
        destroy() {
          this.paintVertexBuffer && this.paintVertexBuffer.destroy();
        }
      }
      class Tr {
        constructor(s, u, m, b, C, k) {
          this.expression = s, this.uniformNames = u.map((P) => `u_${P}_t`), this.type = m, this.useIntegerZoom = b, this.zoom = C, this.maxValue = 0, this.paintVertexAttributes = u.map((P) => ({ name: `a_${P}`, type: "Float32", components: m === "color" ? 4 : 2, offset: 0 })), this.paintVertexArray = new k();
        }
        populatePaintArray(s, u, m, b, C) {
          const k = this.expression.evaluate(new Ei(this.zoom), u, {}, b, [], C), P = this.expression.evaluate(new Ei(this.zoom + 1), u, {}, b, [], C), D = this.paintVertexArray.length;
          this.paintVertexArray.resize(s), this._setPaintValue(D, s, k, P);
        }
        updatePaintArray(s, u, m, b) {
          const C = this.expression.evaluate({ zoom: this.zoom }, m, b), k = this.expression.evaluate({ zoom: this.zoom + 1 }, m, b);
          this._setPaintValue(s, u, C, k);
        }
        _setPaintValue(s, u, m, b) {
          if (this.type === "color") {
            const C = ui(m), k = ui(b);
            for (let P = s; P < u; P++) this.paintVertexArray.emplace(P, C[0], C[1], k[0], k[1]);
          } else {
            for (let C = s; C < u; C++) this.paintVertexArray.emplace(C, m, b);
            this.maxValue = Math.max(this.maxValue, Math.abs(m), Math.abs(b));
          }
        }
        upload(s) {
          this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = s.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
        }
        destroy() {
          this.paintVertexBuffer && this.paintVertexBuffer.destroy();
        }
        setUniform(s, u) {
          const m = this.useIntegerZoom ? Math.floor(u.zoom) : u.zoom, b = N(this.expression.interpolationFactor(m, this.zoom, this.zoom + 1), 0, 1);
          s.set(b);
        }
        getBinding(s, u, m) {
          return new Jo(s, u);
        }
      }
      class Ys {
        constructor(s, u, m, b, C, k) {
          this.expression = s, this.type = u, this.useIntegerZoom = m, this.zoom = b, this.layerId = k, this.zoomInPaintVertexArray = new C(), this.zoomOutPaintVertexArray = new C();
        }
        populatePaintArray(s, u, m) {
          const b = this.zoomInPaintVertexArray.length;
          this.zoomInPaintVertexArray.resize(s), this.zoomOutPaintVertexArray.resize(s), this._setPaintValues(b, s, u.patterns && u.patterns[this.layerId], m);
        }
        updatePaintArray(s, u, m, b, C) {
          this._setPaintValues(s, u, m.patterns && m.patterns[this.layerId], C);
        }
        _setPaintValues(s, u, m, b) {
          if (!b || !m) return;
          const { min: C, mid: k, max: P } = m, D = b[C], Z = b[k], X = b[P];
          if (D && Z && X) for (let ie = s; ie < u; ie++) this.zoomInPaintVertexArray.emplace(ie, Z.tl[0], Z.tl[1], Z.br[0], Z.br[1], D.tl[0], D.tl[1], D.br[0], D.br[1], Z.pixelRatio, D.pixelRatio), this.zoomOutPaintVertexArray.emplace(ie, Z.tl[0], Z.tl[1], Z.br[0], Z.br[1], X.tl[0], X.tl[1], X.br[0], X.br[1], Z.pixelRatio, X.pixelRatio);
        }
        upload(s) {
          this.zoomInPaintVertexArray && this.zoomInPaintVertexArray.arrayBuffer && this.zoomOutPaintVertexArray && this.zoomOutPaintVertexArray.arrayBuffer && (this.zoomInPaintVertexBuffer = s.createVertexBuffer(this.zoomInPaintVertexArray, Gt.members, this.expression.isStateDependent), this.zoomOutPaintVertexBuffer = s.createVertexBuffer(this.zoomOutPaintVertexArray, Gt.members, this.expression.isStateDependent));
        }
        destroy() {
          this.zoomOutPaintVertexBuffer && this.zoomOutPaintVertexBuffer.destroy(), this.zoomInPaintVertexBuffer && this.zoomInPaintVertexBuffer.destroy();
        }
      }
      class up {
        constructor(s, u, m) {
          this.binders = {}, this._buffers = [];
          const b = [];
          for (const C in s.paint._values) {
            if (!m(C)) continue;
            const k = s.paint.get(C);
            if (!(k instanceof j && Ca(k.property.specification))) continue;
            const P = I_(C, s.type), D = k.value, Z = k.property.specification.type, X = k.property.useIntegerZoom, ie = k.property.specification["property-type"], ce = ie === "cross-faded" || ie === "cross-faded-data-driven";
            if (D.kind === "constant") this.binders[C] = ce ? new Nr(D.value, P) : new Sr(D.value, P, Z), b.push(`/u_${C}`);
            else if (D.kind === "source" || ce) {
              const he = ov(C, Z, "source");
              this.binders[C] = ce ? new Ys(D, Z, X, u, he, s.id) : new fi(D, P, Z, he), b.push(`/a_${C}`);
            } else {
              const he = ov(C, Z, "composite");
              this.binders[C] = new Tr(D, P, Z, X, u, he), b.push(`/z_${C}`);
            }
          }
          this.cacheKey = b.sort().join("");
        }
        getMaxValue(s) {
          const u = this.binders[s];
          return u instanceof fi || u instanceof Tr ? u.maxValue : 0;
        }
        populatePaintArrays(s, u, m, b, C) {
          for (const k in this.binders) {
            const P = this.binders[k];
            (P instanceof fi || P instanceof Tr || P instanceof Ys) && P.populatePaintArray(s, u, m, b, C);
          }
        }
        setConstantPatternPositions(s, u) {
          for (const m in this.binders) {
            const b = this.binders[m];
            b instanceof Nr && b.setConstantPatternPositions(s, u);
          }
        }
        updatePaintArrays(s, u, m, b, C) {
          let k = !1;
          for (const P in s) {
            const D = u.getPositions(P);
            for (const Z of D) {
              const X = m.feature(Z.index);
              for (const ie in this.binders) {
                const ce = this.binders[ie];
                if ((ce instanceof fi || ce instanceof Tr || ce instanceof Ys) && ce.expression.isStateDependent === !0) {
                  const he = b.paint.get(ie);
                  ce.expression = he.value, ce.updatePaintArray(Z.start, Z.end, X, s[P], C), k = !0;
                }
              }
            }
          }
          return k;
        }
        defines() {
          const s = [];
          for (const u in this.binders) {
            const m = this.binders[u];
            (m instanceof Sr || m instanceof Nr) && s.push(...m.uniformNames.map((b) => `#define HAS_UNIFORM_${b}`));
          }
          return s;
        }
        getBinderAttributes() {
          const s = [];
          for (const u in this.binders) {
            const m = this.binders[u];
            if (m instanceof fi || m instanceof Tr) for (let b = 0; b < m.paintVertexAttributes.length; b++) s.push(m.paintVertexAttributes[b].name);
            else if (m instanceof Ys) for (let b = 0; b < Gt.members.length; b++) s.push(Gt.members[b].name);
          }
          return s;
        }
        getBinderUniforms() {
          const s = [];
          for (const u in this.binders) {
            const m = this.binders[u];
            if (m instanceof Sr || m instanceof Nr || m instanceof Tr) for (const b of m.uniformNames) s.push(b);
          }
          return s;
        }
        getPaintVertexBuffers() {
          return this._buffers;
        }
        getUniforms(s, u) {
          const m = [];
          for (const b in this.binders) {
            const C = this.binders[b];
            if (C instanceof Sr || C instanceof Nr || C instanceof Tr) {
              for (const k of C.uniformNames) if (u[k]) {
                const P = C.getBinding(s, u[k], k);
                m.push({ name: k, property: b, binding: P });
              }
            }
          }
          return m;
        }
        setUniforms(s, u, m, b) {
          for (const { name: C, property: k, binding: P } of u) this.binders[k].setUniform(P, b, m.get(k), C);
        }
        updatePaintBuffers(s) {
          this._buffers = [];
          for (const u in this.binders) {
            const m = this.binders[u];
            if (s && m instanceof Ys) {
              const b = s.fromScale === 2 ? m.zoomInPaintVertexBuffer : m.zoomOutPaintVertexBuffer;
              b && this._buffers.push(b);
            } else (m instanceof fi || m instanceof Tr) && m.paintVertexBuffer && this._buffers.push(m.paintVertexBuffer);
          }
        }
        upload(s) {
          for (const u in this.binders) {
            const m = this.binders[u];
            (m instanceof fi || m instanceof Tr || m instanceof Ys) && m.upload(s);
          }
          this.updatePaintBuffers();
        }
        destroy() {
          for (const s in this.binders) {
            const u = this.binders[s];
            (u instanceof fi || u instanceof Tr || u instanceof Ys) && u.destroy();
          }
        }
      }
      class La {
        constructor(s, u, m = () => !0) {
          this.programConfigurations = {};
          for (const b of s) this.programConfigurations[b.id] = new up(b, u, m);
          this.needsUpload = !1, this._featureMap = new Lr(), this._bufferOffset = 0;
        }
        populatePaintArrays(s, u, m, b, C, k) {
          for (const P in this.programConfigurations) this.programConfigurations[P].populatePaintArrays(s, u, b, C, k);
          u.id !== void 0 && this._featureMap.add(u.id, m, this._bufferOffset, s), this._bufferOffset = s, this.needsUpload = !0;
        }
        updatePaintArrays(s, u, m, b) {
          for (const C of m) this.needsUpload = this.programConfigurations[C.id].updatePaintArrays(s, this._featureMap, u, C, b) || this.needsUpload;
        }
        get(s) {
          return this.programConfigurations[s];
        }
        upload(s) {
          if (this.needsUpload) {
            for (const u in this.programConfigurations) this.programConfigurations[u].upload(s);
            this.needsUpload = !1;
          }
        }
        destroy() {
          for (const s in this.programConfigurations) this.programConfigurations[s].destroy();
        }
      }
      function I_(l, s) {
        return { "text-opacity": ["opacity"], "icon-opacity": ["opacity"], "text-color": ["fill_color"], "icon-color": ["fill_color"], "text-halo-color": ["halo_color"], "icon-halo-color": ["halo_color"], "text-halo-blur": ["halo_blur"], "icon-halo-blur": ["halo_blur"], "text-halo-width": ["halo_width"], "icon-halo-width": ["halo_width"], "line-gap-width": ["gapwidth"], "line-pattern": ["pattern_to", "pattern_from", "pixel_ratio_to", "pixel_ratio_from"], "fill-pattern": ["pattern_to", "pattern_from", "pixel_ratio_to", "pixel_ratio_from"], "fill-extrusion-pattern": ["pattern_to", "pattern_from", "pixel_ratio_to", "pixel_ratio_from"] }[l] || [l.replace(`${s}-`, "").replace(/-/g, "_")];
      }
      function ov(l, s, u) {
        const m = { color: { source: Pi, composite: h }, number: { source: lp, composite: Pi } }, b = function(C) {
          return { "line-pattern": { source: Ee, composite: Ee }, "fill-pattern": { source: Ee, composite: Ee }, "fill-extrusion-pattern": { source: Ee, composite: Ee } }[C];
        }(l);
        return b && b[u] || m[s][u];
      }
      Zt("ConstantBinder", Sr), Zt("CrossFadedConstantBinder", Nr), Zt("SourceExpressionBinder", fi), Zt("CrossFadedCompositeBinder", Ys), Zt("CompositeExpressionBinder", Tr), Zt("ProgramConfiguration", up, { omit: ["_buffers"] }), Zt("ProgramConfigurationSet", La);
      var Wi = 8192;
      const uf = Math.pow(2, 14) - 1, ld = -uf - 1;
      function Oa(l) {
        const s = Wi / l.extent, u = l.loadGeometry();
        for (let m = 0; m < u.length; m++) {
          const b = u[m];
          for (let C = 0; C < b.length; C++) {
            const k = b[C], P = Math.round(k.x * s), D = Math.round(k.y * s);
            k.x = N(P, ld, uf), k.y = N(D, ld, uf), (P < k.x || P > k.x + 1 || D < k.y || D > k.y + 1) && me("Geometry exceeds allowed extent, reduce your vector tile buffer size");
          }
        }
        return u;
      }
      function cd(l, s) {
        return { type: l.type, id: l.id, properties: l.properties, geometry: s ? Oa(l) : [] };
      }
      function av(l, s, u, m, b) {
        l.emplaceBack(2 * s + (m + 1) / 2, 2 * u + (b + 1) / 2);
      }
      class A_ {
        constructor(s) {
          this.zoom = s.zoom, this.overscaling = s.overscaling, this.layers = s.layers, this.layerIds = this.layers.map((u) => u.id), this.index = s.index, this.hasPattern = !1, this.layoutVertexArray = new we(), this.indexArray = new xt(), this.segments = new Ot(), this.programConfigurations = new La(s.layers, s.zoom), this.stateDependentLayerIds = this.layers.filter((u) => u.isStateDependent()).map((u) => u.id);
        }
        populate(s, u, m) {
          const b = this.layers[0], C = [];
          let k = null, P = !1;
          b.type === "circle" && (k = b.layout.get("circle-sort-key"), P = !k.isConstant());
          for (const { feature: D, id: Z, index: X, sourceLayerIndex: ie } of s) {
            const ce = this.layers[0]._featureFilter.needGeometry, he = cd(D, ce);
            if (!this.layers[0]._featureFilter.filter(new Ei(this.zoom), he, m)) continue;
            const ye = P ? k.evaluate(he, {}, m) : void 0, Ie = { id: Z, properties: D.properties, type: D.type, sourceLayerIndex: ie, index: X, geometry: ce ? he.geometry : Oa(D), patterns: {}, sortKey: ye };
            C.push(Ie);
          }
          P && C.sort((D, Z) => D.sortKey - Z.sortKey);
          for (const D of C) {
            const { geometry: Z, index: X, sourceLayerIndex: ie } = D, ce = s[X].feature;
            this.addFeature(D, Z, X, m), u.featureIndex.insert(ce, Z, X, ie, this.index);
          }
        }
        update(s, u, m) {
          this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(s, u, this.stateDependentLayers, m);
        }
        isEmpty() {
          return this.layoutVertexArray.length === 0;
        }
        uploadPending() {
          return !this.uploaded || this.programConfigurations.needsUpload;
        }
        upload(s) {
          this.uploaded || (this.layoutVertexBuffer = s.createVertexBuffer(this.layoutVertexArray, En), this.indexBuffer = s.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(s), this.uploaded = !0;
        }
        destroy() {
          this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
        }
        addFeature(s, u, m, b) {
          for (const C of u) for (const k of C) {
            const P = k.x, D = k.y;
            if (P < 0 || P >= Wi || D < 0 || D >= Wi) continue;
            const Z = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray, s.sortKey), X = Z.vertexLength;
            av(this.layoutVertexArray, P, D, -1, -1), av(this.layoutVertexArray, P, D, 1, -1), av(this.layoutVertexArray, P, D, 1, 1), av(this.layoutVertexArray, P, D, -1, 1), this.indexArray.emplaceBack(X, X + 1, X + 2), this.indexArray.emplaceBack(X, X + 3, X + 2), Z.vertexLength += 4, Z.primitiveLength += 2;
          }
          this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, s, m, {}, b);
        }
      }
      function h$(l, s) {
        for (let u = 0; u < l.length; u++) if (dp(s, l[u])) return !0;
        for (let u = 0; u < s.length; u++) if (dp(l, s[u])) return !0;
        return !!E_(l, s);
      }
      function H3(l, s, u) {
        return !!dp(l, s) || !!P_(s, l, u);
      }
      function f$(l, s) {
        if (l.length === 1) return v$(s, l[0]);
        for (let u = 0; u < s.length; u++) {
          const m = s[u];
          for (let b = 0; b < m.length; b++) if (dp(l, m[b])) return !0;
        }
        for (let u = 0; u < l.length; u++) if (v$(s, l[u])) return !0;
        for (let u = 0; u < s.length; u++) if (E_(l, s[u])) return !0;
        return !1;
      }
      function W3(l, s, u) {
        if (l.length > 1) {
          if (E_(l, s)) return !0;
          for (let m = 0; m < s.length; m++) if (P_(s[m], l, u)) return !0;
        }
        for (let m = 0; m < l.length; m++) if (P_(l[m], s, u)) return !0;
        return !1;
      }
      function E_(l, s) {
        if (l.length === 0 || s.length === 0) return !1;
        for (let u = 0; u < l.length - 1; u++) {
          const m = l[u], b = l[u + 1];
          for (let C = 0; C < s.length - 1; C++) if (Z3(m, b, s[C], s[C + 1])) return !0;
        }
        return !1;
      }
      function Z3(l, s, u, m) {
        return ve(l, u, m) !== ve(s, u, m) && ve(l, s, u) !== ve(l, s, m);
      }
      function P_(l, s, u) {
        const m = u * u;
        if (s.length === 1) return l.distSqr(s[0]) < m;
        for (let b = 1; b < s.length; b++) if (m$(l, s[b - 1], s[b]) < m) return !0;
        return !1;
      }
      function m$(l, s, u) {
        const m = s.distSqr(u);
        if (m === 0) return l.distSqr(s);
        const b = ((l.x - s.x) * (u.x - s.x) + (l.y - s.y) * (u.y - s.y)) / m;
        return l.distSqr(b < 0 ? s : b > 1 ? u : u.sub(s)._mult(b)._add(s));
      }
      function v$(l, s) {
        let u, m, b, C = !1;
        for (let k = 0; k < l.length; k++) {
          u = l[k];
          for (let P = 0, D = u.length - 1; P < u.length; D = P++) m = u[P], b = u[D], m.y > s.y != b.y > s.y && s.x < (b.x - m.x) * (s.y - m.y) / (b.y - m.y) + m.x && (C = !C);
        }
        return C;
      }
      function dp(l, s) {
        let u = !1;
        for (let m = 0, b = l.length - 1; m < l.length; b = m++) {
          const C = l[m], k = l[b];
          C.y > s.y != k.y > s.y && s.x < (k.x - C.x) * (s.y - C.y) / (k.y - C.y) + C.x && (u = !u);
        }
        return u;
      }
      function q3(l, s, u) {
        const m = u[0], b = u[2];
        if (l.x < m.x && s.x < m.x || l.x > b.x && s.x > b.x || l.y < m.y && s.y < m.y || l.y > b.y && s.y > b.y) return !1;
        const C = ve(l, s, u[0]);
        return C !== ve(l, s, u[1]) || C !== ve(l, s, u[2]) || C !== ve(l, s, u[3]);
      }
      function df(l, s, u) {
        const m = s.paint.get(l).value;
        return m.kind === "constant" ? m.value : u.programConfigurations.get(s.id).getMaxValue(l);
      }
      function lv(l) {
        return Math.sqrt(l[0] * l[0] + l[1] * l[1]);
      }
      function cv(l, s, u, m, b) {
        if (!s[0] && !s[1]) return l;
        const C = $.convert(s)._mult(b);
        u === "viewport" && C._rotate(-m);
        const k = [];
        for (let P = 0; P < l.length; P++) k.push(l[P].sub(C));
        return k;
      }
      let g$, y$;
      Zt("CircleBucket", A_, { omit: ["layers"] });
      var j3 = { get paint() {
        return y$ = y$ || new pn({ "circle-radius": new Ve(Oe.paint_circle["circle-radius"]), "circle-color": new Ve(Oe.paint_circle["circle-color"]), "circle-blur": new Ve(Oe.paint_circle["circle-blur"]), "circle-opacity": new Ve(Oe.paint_circle["circle-opacity"]), "circle-translate": new xe(Oe.paint_circle["circle-translate"]), "circle-translate-anchor": new xe(Oe.paint_circle["circle-translate-anchor"]), "circle-pitch-scale": new xe(Oe.paint_circle["circle-pitch-scale"]), "circle-pitch-alignment": new xe(Oe.paint_circle["circle-pitch-alignment"]), "circle-stroke-width": new Ve(Oe.paint_circle["circle-stroke-width"]), "circle-stroke-color": new Ve(Oe.paint_circle["circle-stroke-color"]), "circle-stroke-opacity": new Ve(Oe.paint_circle["circle-stroke-opacity"]) });
      }, get layout() {
        return g$ = g$ || new pn({ "circle-sort-key": new Ve(Oe.layout_circle["circle-sort-key"]) });
      } }, Ns = 1e-6, pp = typeof Float32Array < "u" ? Float32Array : Array;
      function M_(l) {
        return l[0] = 1, l[1] = 0, l[2] = 0, l[3] = 0, l[4] = 0, l[5] = 1, l[6] = 0, l[7] = 0, l[8] = 0, l[9] = 0, l[10] = 1, l[11] = 0, l[12] = 0, l[13] = 0, l[14] = 0, l[15] = 1, l;
      }
      function _$(l, s, u) {
        var m = s[0], b = s[1], C = s[2], k = s[3], P = s[4], D = s[5], Z = s[6], X = s[7], ie = s[8], ce = s[9], he = s[10], ye = s[11], Ie = s[12], ke = s[13], He = s[14], Qe = s[15], Be = u[0], lt = u[1], ut = u[2], vt = u[3];
        return l[0] = Be * m + lt * P + ut * ie + vt * Ie, l[1] = Be * b + lt * D + ut * ce + vt * ke, l[2] = Be * C + lt * Z + ut * he + vt * He, l[3] = Be * k + lt * X + ut * ye + vt * Qe, l[4] = (Be = u[4]) * m + (lt = u[5]) * P + (ut = u[6]) * ie + (vt = u[7]) * Ie, l[5] = Be * b + lt * D + ut * ce + vt * ke, l[6] = Be * C + lt * Z + ut * he + vt * He, l[7] = Be * k + lt * X + ut * ye + vt * Qe, l[8] = (Be = u[8]) * m + (lt = u[9]) * P + (ut = u[10]) * ie + (vt = u[11]) * Ie, l[9] = Be * b + lt * D + ut * ce + vt * ke, l[10] = Be * C + lt * Z + ut * he + vt * He, l[11] = Be * k + lt * X + ut * ye + vt * Qe, l[12] = (Be = u[12]) * m + (lt = u[13]) * P + (ut = u[14]) * ie + (vt = u[15]) * Ie, l[13] = Be * b + lt * D + ut * ce + vt * ke, l[14] = Be * C + lt * Z + ut * he + vt * He, l[15] = Be * k + lt * X + ut * ye + vt * Qe, l;
      }
      Math.hypot || (Math.hypot = function() {
        for (var l = 0, s = arguments.length; s--; ) l += arguments[s] * arguments[s];
        return Math.sqrt(l);
      });
      var pf, G3 = _$;
      function uv(l, s, u) {
        var m = s[0], b = s[1], C = s[2], k = s[3];
        return l[0] = u[0] * m + u[4] * b + u[8] * C + u[12] * k, l[1] = u[1] * m + u[5] * b + u[9] * C + u[13] * k, l[2] = u[2] * m + u[6] * b + u[10] * C + u[14] * k, l[3] = u[3] * m + u[7] * b + u[11] * C + u[15] * k, l;
      }
      function b$(l, s) {
        const u = uv([], [l.x, l.y, 0, 1], s);
        return new $(u[0] / u[3], u[1] / u[3]);
      }
      pf = new pp(4), pp != Float32Array && (pf[0] = 0, pf[1] = 0, pf[2] = 0, pf[3] = 0);
      class w$ extends A_ {
      }
      let x$;
      Zt("HeatmapBucket", w$, { omit: ["layers"] });
      var Y3 = { get paint() {
        return x$ = x$ || new pn({ "heatmap-radius": new Ve(Oe.paint_heatmap["heatmap-radius"]), "heatmap-weight": new Ve(Oe.paint_heatmap["heatmap-weight"]), "heatmap-intensity": new xe(Oe.paint_heatmap["heatmap-intensity"]), "heatmap-color": new Jt(Oe.paint_heatmap["heatmap-color"]), "heatmap-opacity": new xe(Oe.paint_heatmap["heatmap-opacity"]) });
      } };
      function D_(l, { width: s, height: u }, m, b) {
        if (b) {
          if (b instanceof Uint8ClampedArray) b = new Uint8Array(b.buffer);
          else if (b.length !== s * u * m) throw new RangeError(`mismatched image size. expected: ${b.length} but got: ${s * u * m}`);
        } else b = new Uint8Array(s * u * m);
        return l.width = s, l.height = u, l.data = b, l;
      }
      function $$(l, { width: s, height: u }, m) {
        if (s === l.width && u === l.height) return;
        const b = D_({}, { width: s, height: u }, m);
        L_(l, b, { x: 0, y: 0 }, { x: 0, y: 0 }, { width: Math.min(l.width, s), height: Math.min(l.height, u) }, m), l.width = s, l.height = u, l.data = b.data;
      }
      function L_(l, s, u, m, b, C) {
        if (b.width === 0 || b.height === 0) return s;
        if (b.width > l.width || b.height > l.height || u.x > l.width - b.width || u.y > l.height - b.height) throw new RangeError("out of range source coordinates for image copy");
        if (b.width > s.width || b.height > s.height || m.x > s.width - b.width || m.y > s.height - b.height) throw new RangeError("out of range destination coordinates for image copy");
        const k = l.data, P = s.data;
        if (k === P) throw new Error("srcData equals dstData, so image is already copied");
        for (let D = 0; D < b.height; D++) {
          const Z = ((u.y + D) * l.width + u.x) * C, X = ((m.y + D) * s.width + m.x) * C;
          for (let ie = 0; ie < b.width * C; ie++) P[X + ie] = k[Z + ie];
        }
        return s;
      }
      class hf {
        constructor(s, u) {
          D_(this, s, 1, u);
        }
        resize(s) {
          $$(this, s, 1);
        }
        clone() {
          return new hf({ width: this.width, height: this.height }, new Uint8Array(this.data));
        }
        static copy(s, u, m, b, C) {
          L_(s, u, m, b, C, 1);
        }
      }
      class Do {
        constructor(s, u) {
          D_(this, s, 4, u);
        }
        resize(s) {
          $$(this, s, 4);
        }
        replace(s, u) {
          u ? this.data.set(s) : this.data = s instanceof Uint8ClampedArray ? new Uint8Array(s.buffer) : s;
        }
        clone() {
          return new Do({ width: this.width, height: this.height }, new Uint8Array(this.data));
        }
        static copy(s, u, m, b, C) {
          L_(s, u, m, b, C, 4);
        }
      }
      function C$(l) {
        const s = {}, u = l.resolution || 256, m = l.clips ? l.clips.length : 1, b = l.image || new Do({ width: u, height: m });
        if (Math.log(u) / Math.LN2 % 1 != 0) throw new Error(`width is not a power of 2 - ${u}`);
        const C = (k, P, D) => {
          s[l.evaluationKey] = D;
          const Z = l.expression.evaluate(s);
          b.data[k + P + 0] = Math.floor(255 * Z.r / Z.a), b.data[k + P + 1] = Math.floor(255 * Z.g / Z.a), b.data[k + P + 2] = Math.floor(255 * Z.b / Z.a), b.data[k + P + 3] = Math.floor(255 * Z.a);
        };
        if (l.clips) for (let k = 0, P = 0; k < m; ++k, P += 4 * u) for (let D = 0, Z = 0; D < u; D++, Z += 4) {
          const X = D / (u - 1), { start: ie, end: ce } = l.clips[k];
          C(P, Z, ie * (1 - X) + ce * X);
        }
        else for (let k = 0, P = 0; k < u; k++, P += 4) C(0, P, k / (u - 1));
        return b;
      }
      let k$;
      Zt("AlphaImage", hf), Zt("RGBAImage", Do);
      var K3 = { get paint() {
        return k$ = k$ || new pn({ "hillshade-illumination-direction": new xe(Oe.paint_hillshade["hillshade-illumination-direction"]), "hillshade-illumination-anchor": new xe(Oe.paint_hillshade["hillshade-illumination-anchor"]), "hillshade-exaggeration": new xe(Oe.paint_hillshade["hillshade-exaggeration"]), "hillshade-shadow-color": new xe(Oe.paint_hillshade["hillshade-shadow-color"]), "hillshade-highlight-color": new xe(Oe.paint_hillshade["hillshade-highlight-color"]), "hillshade-accent-color": new xe(Oe.paint_hillshade["hillshade-accent-color"]) });
      } };
      const X3 = Ri([{ name: "a_pos", components: 2, type: "Int16" }], 4), { members: J3 } = X3;
      var O_ = { exports: {} };
      function dv(l, s, u) {
        u = u || 2;
        var m, b, C, k, P, D, Z, X = s && s.length, ie = X ? s[0] * u : l.length, ce = S$(l, 0, ie, u, !0), he = [];
        if (!ce || ce.next === ce.prev) return he;
        if (X && (ce = function(Ie, ke, He, Qe) {
          var Be, lt, ut, vt = [];
          for (Be = 0, lt = ke.length; Be < lt; Be++) (ut = S$(Ie, ke[Be] * Qe, Be < lt - 1 ? ke[Be + 1] * Qe : Ie.length, Qe, !1)) === ut.next && (ut.steiner = !0), vt.push(oO(ut));
          for (vt.sort(iO), Be = 0; Be < vt.length; Be++) He = rO(vt[Be], He);
          return He;
        }(l, s, ce, u)), l.length > 80 * u) {
          m = C = l[0], b = k = l[1];
          for (var ye = u; ye < ie; ye += u) (P = l[ye]) < m && (m = P), (D = l[ye + 1]) < b && (b = D), P > C && (C = P), D > k && (k = D);
          Z = (Z = Math.max(C - m, k - b)) !== 0 ? 32767 / Z : 0;
        }
        return ff(ce, he, u, m, b, Z, 0), he;
      }
      function S$(l, s, u, m, b) {
        var C, k;
        if (b === R_(l, s, u, m) > 0) for (C = s; C < u; C += m) k = A$(C, l[C], l[C + 1], k);
        else for (C = u - m; C >= s; C -= m) k = A$(C, l[C], l[C + 1], k);
        return k && pv(k, k.next) && (vf(k), k = k.next), k;
      }
      function ud(l, s) {
        if (!l) return l;
        s || (s = l);
        var u, m = l;
        do
          if (u = !1, m.steiner || !pv(m, m.next) && dr(m.prev, m, m.next) !== 0) m = m.next;
          else {
            if (vf(m), (m = s = m.prev) === m.next) break;
            u = !0;
          }
        while (u || m !== s);
        return s;
      }
      function ff(l, s, u, m, b, C, k) {
        if (l) {
          !k && C && function(X, ie, ce, he) {
            var ye = X;
            do
              ye.z === 0 && (ye.z = N_(ye.x, ye.y, ie, ce, he)), ye.prevZ = ye.prev, ye.nextZ = ye.next, ye = ye.next;
            while (ye !== X);
            ye.prevZ.nextZ = null, ye.prevZ = null, function(Ie) {
              var ke, He, Qe, Be, lt, ut, vt, Xt, nn = 1;
              do {
                for (He = Ie, Ie = null, lt = null, ut = 0; He; ) {
                  for (ut++, Qe = He, vt = 0, ke = 0; ke < nn && (vt++, Qe = Qe.nextZ); ke++) ;
                  for (Xt = nn; vt > 0 || Xt > 0 && Qe; ) vt !== 0 && (Xt === 0 || !Qe || He.z <= Qe.z) ? (Be = He, He = He.nextZ, vt--) : (Be = Qe, Qe = Qe.nextZ, Xt--), lt ? lt.nextZ = Be : Ie = Be, Be.prevZ = lt, lt = Be;
                  He = Qe;
                }
                lt.nextZ = null, nn *= 2;
              } while (ut > 1);
            }(ye);
          }(l, m, b, C);
          for (var P, D, Z = l; l.prev !== l.next; ) if (P = l.prev, D = l.next, C ? eO(l, m, b, C) : Q3(l)) s.push(P.i / u | 0), s.push(l.i / u | 0), s.push(D.i / u | 0), vf(l), l = D.next, Z = D.next;
          else if ((l = D) === Z) {
            k ? k === 1 ? ff(l = tO(ud(l), s, u), s, u, m, b, C, 2) : k === 2 && nO(l, s, u, m, b, C) : ff(ud(l), s, u, m, b, C, 1);
            break;
          }
        }
      }
      function Q3(l) {
        var s = l.prev, u = l, m = l.next;
        if (dr(s, u, m) >= 0) return !1;
        for (var b = s.x, C = u.x, k = m.x, P = s.y, D = u.y, Z = m.y, X = b < C ? b < k ? b : k : C < k ? C : k, ie = P < D ? P < Z ? P : Z : D < Z ? D : Z, ce = b > C ? b > k ? b : k : C > k ? C : k, he = P > D ? P > Z ? P : Z : D > Z ? D : Z, ye = m.next; ye !== s; ) {
          if (ye.x >= X && ye.x <= ce && ye.y >= ie && ye.y <= he && hp(b, P, C, D, k, Z, ye.x, ye.y) && dr(ye.prev, ye, ye.next) >= 0) return !1;
          ye = ye.next;
        }
        return !0;
      }
      function eO(l, s, u, m) {
        var b = l.prev, C = l, k = l.next;
        if (dr(b, C, k) >= 0) return !1;
        for (var P = b.x, D = C.x, Z = k.x, X = b.y, ie = C.y, ce = k.y, he = P < D ? P < Z ? P : Z : D < Z ? D : Z, ye = X < ie ? X < ce ? X : ce : ie < ce ? ie : ce, Ie = P > D ? P > Z ? P : Z : D > Z ? D : Z, ke = X > ie ? X > ce ? X : ce : ie > ce ? ie : ce, He = N_(he, ye, s, u, m), Qe = N_(Ie, ke, s, u, m), Be = l.prevZ, lt = l.nextZ; Be && Be.z >= He && lt && lt.z <= Qe; ) {
          if (Be.x >= he && Be.x <= Ie && Be.y >= ye && Be.y <= ke && Be !== b && Be !== k && hp(P, X, D, ie, Z, ce, Be.x, Be.y) && dr(Be.prev, Be, Be.next) >= 0 || (Be = Be.prevZ, lt.x >= he && lt.x <= Ie && lt.y >= ye && lt.y <= ke && lt !== b && lt !== k && hp(P, X, D, ie, Z, ce, lt.x, lt.y) && dr(lt.prev, lt, lt.next) >= 0)) return !1;
          lt = lt.nextZ;
        }
        for (; Be && Be.z >= He; ) {
          if (Be.x >= he && Be.x <= Ie && Be.y >= ye && Be.y <= ke && Be !== b && Be !== k && hp(P, X, D, ie, Z, ce, Be.x, Be.y) && dr(Be.prev, Be, Be.next) >= 0) return !1;
          Be = Be.prevZ;
        }
        for (; lt && lt.z <= Qe; ) {
          if (lt.x >= he && lt.x <= Ie && lt.y >= ye && lt.y <= ke && lt !== b && lt !== k && hp(P, X, D, ie, Z, ce, lt.x, lt.y) && dr(lt.prev, lt, lt.next) >= 0) return !1;
          lt = lt.nextZ;
        }
        return !0;
      }
      function tO(l, s, u) {
        var m = l;
        do {
          var b = m.prev, C = m.next.next;
          !pv(b, C) && T$(b, m, m.next, C) && mf(b, C) && mf(C, b) && (s.push(b.i / u | 0), s.push(m.i / u | 0), s.push(C.i / u | 0), vf(m), vf(m.next), m = l = C), m = m.next;
        } while (m !== l);
        return ud(m);
      }
      function nO(l, s, u, m, b, C) {
        var k = l;
        do {
          for (var P = k.next.next; P !== k.prev; ) {
            if (k.i !== P.i && aO(k, P)) {
              var D = I$(k, P);
              return k = ud(k, k.next), D = ud(D, D.next), ff(k, s, u, m, b, C, 0), void ff(D, s, u, m, b, C, 0);
            }
            P = P.next;
          }
          k = k.next;
        } while (k !== l);
      }
      function iO(l, s) {
        return l.x - s.x;
      }
      function rO(l, s) {
        var u = function(b, C) {
          var k, P = C, D = b.x, Z = b.y, X = -1 / 0;
          do {
            if (Z <= P.y && Z >= P.next.y && P.next.y !== P.y) {
              var ie = P.x + (Z - P.y) * (P.next.x - P.x) / (P.next.y - P.y);
              if (ie <= D && ie > X && (X = ie, k = P.x < P.next.x ? P : P.next, ie === D)) return k;
            }
            P = P.next;
          } while (P !== C);
          if (!k) return null;
          var ce, he = k, ye = k.x, Ie = k.y, ke = 1 / 0;
          P = k;
          do
            D >= P.x && P.x >= ye && D !== P.x && hp(Z < Ie ? D : X, Z, ye, Ie, Z < Ie ? X : D, Z, P.x, P.y) && (ce = Math.abs(Z - P.y) / (D - P.x), mf(P, b) && (ce < ke || ce === ke && (P.x > k.x || P.x === k.x && sO(k, P))) && (k = P, ke = ce)), P = P.next;
          while (P !== he);
          return k;
        }(l, s);
        if (!u) return s;
        var m = I$(u, l);
        return ud(m, m.next), ud(u, u.next);
      }
      function sO(l, s) {
        return dr(l.prev, l, s.prev) < 0 && dr(s.next, l, l.next) < 0;
      }
      function N_(l, s, u, m, b) {
        return (l = 1431655765 & ((l = 858993459 & ((l = 252645135 & ((l = 16711935 & ((l = (l - u) * b | 0) | l << 8)) | l << 4)) | l << 2)) | l << 1)) | (s = 1431655765 & ((s = 858993459 & ((s = 252645135 & ((s = 16711935 & ((s = (s - m) * b | 0) | s << 8)) | s << 4)) | s << 2)) | s << 1)) << 1;
      }
      function oO(l) {
        var s = l, u = l;
        do
          (s.x < u.x || s.x === u.x && s.y < u.y) && (u = s), s = s.next;
        while (s !== l);
        return u;
      }
      function hp(l, s, u, m, b, C, k, P) {
        return (b - k) * (s - P) >= (l - k) * (C - P) && (l - k) * (m - P) >= (u - k) * (s - P) && (u - k) * (C - P) >= (b - k) * (m - P);
      }
      function aO(l, s) {
        return l.next.i !== s.i && l.prev.i !== s.i && !function(u, m) {
          var b = u;
          do {
            if (b.i !== u.i && b.next.i !== u.i && b.i !== m.i && b.next.i !== m.i && T$(b, b.next, u, m)) return !0;
            b = b.next;
          } while (b !== u);
          return !1;
        }(l, s) && (mf(l, s) && mf(s, l) && function(u, m) {
          var b = u, C = !1, k = (u.x + m.x) / 2, P = (u.y + m.y) / 2;
          do
            b.y > P != b.next.y > P && b.next.y !== b.y && k < (b.next.x - b.x) * (P - b.y) / (b.next.y - b.y) + b.x && (C = !C), b = b.next;
          while (b !== u);
          return C;
        }(l, s) && (dr(l.prev, l, s.prev) || dr(l, s.prev, s)) || pv(l, s) && dr(l.prev, l, l.next) > 0 && dr(s.prev, s, s.next) > 0);
      }
      function dr(l, s, u) {
        return (s.y - l.y) * (u.x - s.x) - (s.x - l.x) * (u.y - s.y);
      }
      function pv(l, s) {
        return l.x === s.x && l.y === s.y;
      }
      function T$(l, s, u, m) {
        var b = fv(dr(l, s, u)), C = fv(dr(l, s, m)), k = fv(dr(u, m, l)), P = fv(dr(u, m, s));
        return b !== C && k !== P || !(b !== 0 || !hv(l, u, s)) || !(C !== 0 || !hv(l, m, s)) || !(k !== 0 || !hv(u, l, m)) || !(P !== 0 || !hv(u, s, m));
      }
      function hv(l, s, u) {
        return s.x <= Math.max(l.x, u.x) && s.x >= Math.min(l.x, u.x) && s.y <= Math.max(l.y, u.y) && s.y >= Math.min(l.y, u.y);
      }
      function fv(l) {
        return l > 0 ? 1 : l < 0 ? -1 : 0;
      }
      function mf(l, s) {
        return dr(l.prev, l, l.next) < 0 ? dr(l, s, l.next) >= 0 && dr(l, l.prev, s) >= 0 : dr(l, s, l.prev) < 0 || dr(l, l.next, s) < 0;
      }
      function I$(l, s) {
        var u = new F_(l.i, l.x, l.y), m = new F_(s.i, s.x, s.y), b = l.next, C = s.prev;
        return l.next = s, s.prev = l, u.next = b, b.prev = u, m.next = u, u.prev = m, C.next = m, m.prev = C, m;
      }
      function A$(l, s, u, m) {
        var b = new F_(l, s, u);
        return m ? (b.next = m.next, b.prev = m, m.next.prev = b, m.next = b) : (b.prev = b, b.next = b), b;
      }
      function vf(l) {
        l.next.prev = l.prev, l.prev.next = l.next, l.prevZ && (l.prevZ.nextZ = l.nextZ), l.nextZ && (l.nextZ.prevZ = l.prevZ);
      }
      function F_(l, s, u) {
        this.i = l, this.x = s, this.y = u, this.prev = null, this.next = null, this.z = 0, this.prevZ = null, this.nextZ = null, this.steiner = !1;
      }
      function R_(l, s, u, m) {
        for (var b = 0, C = s, k = u - m; C < u; C += m) b += (l[k] - l[C]) * (l[C + 1] + l[k + 1]), k = C;
        return b;
      }
      O_.exports = dv, O_.exports.default = dv, dv.deviation = function(l, s, u, m) {
        var b = s && s.length, C = Math.abs(R_(l, 0, b ? s[0] * u : l.length, u));
        if (b) for (var k = 0, P = s.length; k < P; k++) C -= Math.abs(R_(l, s[k] * u, k < P - 1 ? s[k + 1] * u : l.length, u));
        var D = 0;
        for (k = 0; k < m.length; k += 3) {
          var Z = m[k] * u, X = m[k + 1] * u, ie = m[k + 2] * u;
          D += Math.abs((l[Z] - l[ie]) * (l[X + 1] - l[Z + 1]) - (l[Z] - l[X]) * (l[ie + 1] - l[Z + 1]));
        }
        return C === 0 && D === 0 ? 0 : Math.abs((D - C) / C);
      }, dv.flatten = function(l) {
        for (var s = l[0][0].length, u = { vertices: [], holes: [], dimensions: s }, m = 0, b = 0; b < l.length; b++) {
          for (var C = 0; C < l[b].length; C++) for (var k = 0; k < s; k++) u.vertices.push(l[b][C][k]);
          b > 0 && u.holes.push(m += l[b - 1].length);
        }
        return u;
      };
      var E$ = f(O_.exports);
      function lO(l, s, u, m, b) {
        P$(l, s, u, m || l.length - 1, b || cO);
      }
      function P$(l, s, u, m, b) {
        for (; m > u; ) {
          if (m - u > 600) {
            var C = m - u + 1, k = s - u + 1, P = Math.log(C), D = 0.5 * Math.exp(2 * P / 3), Z = 0.5 * Math.sqrt(P * D * (C - D) / C) * (k - C / 2 < 0 ? -1 : 1);
            P$(l, s, Math.max(u, Math.floor(s - k * D / C + Z)), Math.min(m, Math.floor(s + (C - k) * D / C + Z)), b);
          }
          var X = l[s], ie = u, ce = m;
          for (gf(l, u, s), b(l[m], X) > 0 && gf(l, u, m); ie < ce; ) {
            for (gf(l, ie, ce), ie++, ce--; b(l[ie], X) < 0; ) ie++;
            for (; b(l[ce], X) > 0; ) ce--;
          }
          b(l[u], X) === 0 ? gf(l, u, ce) : gf(l, ++ce, m), ce <= s && (u = ce + 1), s <= ce && (m = ce - 1);
        }
      }
      function gf(l, s, u) {
        var m = l[s];
        l[s] = l[u], l[u] = m;
      }
      function cO(l, s) {
        return l < s ? -1 : l > s ? 1 : 0;
      }
      function z_(l, s) {
        const u = l.length;
        if (u <= 1) return [l];
        const m = [];
        let b, C;
        for (let k = 0; k < u; k++) {
          const P = re(l[k]);
          P !== 0 && (l[k].area = Math.abs(P), C === void 0 && (C = P < 0), C === P < 0 ? (b && m.push(b), b = [l[k]]) : b.push(l[k]));
        }
        if (b && m.push(b), s > 1) for (let k = 0; k < m.length; k++) m[k].length <= s || (lO(m[k], s, 1, m[k].length - 1, uO), m[k] = m[k].slice(0, s));
        return m;
      }
      function uO(l, s) {
        return s.area - l.area;
      }
      function B_(l, s, u) {
        const m = u.patternDependencies;
        let b = !1;
        for (const C of s) {
          const k = C.paint.get(`${l}-pattern`);
          k.isConstant() || (b = !0);
          const P = k.constantOr(null);
          P && (b = !0, m[P.to] = !0, m[P.from] = !0);
        }
        return b;
      }
      function V_(l, s, u, m, b) {
        const C = b.patternDependencies;
        for (const k of s) {
          const P = k.paint.get(`${l}-pattern`).value;
          if (P.kind !== "constant") {
            let D = P.evaluate({ zoom: m - 1 }, u, {}, b.availableImages), Z = P.evaluate({ zoom: m }, u, {}, b.availableImages), X = P.evaluate({ zoom: m + 1 }, u, {}, b.availableImages);
            D = D && D.name ? D.name : D, Z = Z && Z.name ? Z.name : Z, X = X && X.name ? X.name : X, C[D] = !0, C[Z] = !0, C[X] = !0, u.patterns[k.id] = { min: D, mid: Z, max: X };
          }
        }
        return u;
      }
      class U_ {
        constructor(s) {
          this.zoom = s.zoom, this.overscaling = s.overscaling, this.layers = s.layers, this.layerIds = this.layers.map((u) => u.id), this.index = s.index, this.hasPattern = !1, this.patternFeatures = [], this.layoutVertexArray = new Ce(), this.indexArray = new xt(), this.indexArray2 = new Wt(), this.programConfigurations = new La(s.layers, s.zoom), this.segments = new Ot(), this.segments2 = new Ot(), this.stateDependentLayerIds = this.layers.filter((u) => u.isStateDependent()).map((u) => u.id);
        }
        populate(s, u, m) {
          this.hasPattern = B_("fill", this.layers, u);
          const b = this.layers[0].layout.get("fill-sort-key"), C = !b.isConstant(), k = [];
          for (const { feature: P, id: D, index: Z, sourceLayerIndex: X } of s) {
            const ie = this.layers[0]._featureFilter.needGeometry, ce = cd(P, ie);
            if (!this.layers[0]._featureFilter.filter(new Ei(this.zoom), ce, m)) continue;
            const he = C ? b.evaluate(ce, {}, m, u.availableImages) : void 0, ye = { id: D, properties: P.properties, type: P.type, sourceLayerIndex: X, index: Z, geometry: ie ? ce.geometry : Oa(P), patterns: {}, sortKey: he };
            k.push(ye);
          }
          C && k.sort((P, D) => P.sortKey - D.sortKey);
          for (const P of k) {
            const { geometry: D, index: Z, sourceLayerIndex: X } = P;
            if (this.hasPattern) {
              const ie = V_("fill", this.layers, P, this.zoom, u);
              this.patternFeatures.push(ie);
            } else this.addFeature(P, D, Z, m, {});
            u.featureIndex.insert(s[Z].feature, D, Z, X, this.index);
          }
        }
        update(s, u, m) {
          this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(s, u, this.stateDependentLayers, m);
        }
        addFeatures(s, u, m) {
          for (const b of this.patternFeatures) this.addFeature(b, b.geometry, b.index, u, m);
        }
        isEmpty() {
          return this.layoutVertexArray.length === 0;
        }
        uploadPending() {
          return !this.uploaded || this.programConfigurations.needsUpload;
        }
        upload(s) {
          this.uploaded || (this.layoutVertexBuffer = s.createVertexBuffer(this.layoutVertexArray, J3), this.indexBuffer = s.createIndexBuffer(this.indexArray), this.indexBuffer2 = s.createIndexBuffer(this.indexArray2)), this.programConfigurations.upload(s), this.uploaded = !0;
        }
        destroy() {
          this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.indexBuffer2.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.segments2.destroy());
        }
        addFeature(s, u, m, b, C) {
          for (const k of z_(u, 500)) {
            let P = 0;
            for (const he of k) P += he.length;
            const D = this.segments.prepareSegment(P, this.layoutVertexArray, this.indexArray), Z = D.vertexLength, X = [], ie = [];
            for (const he of k) {
              if (he.length === 0) continue;
              he !== k[0] && ie.push(X.length / 2);
              const ye = this.segments2.prepareSegment(he.length, this.layoutVertexArray, this.indexArray2), Ie = ye.vertexLength;
              this.layoutVertexArray.emplaceBack(he[0].x, he[0].y), this.indexArray2.emplaceBack(Ie + he.length - 1, Ie), X.push(he[0].x), X.push(he[0].y);
              for (let ke = 1; ke < he.length; ke++) this.layoutVertexArray.emplaceBack(he[ke].x, he[ke].y), this.indexArray2.emplaceBack(Ie + ke - 1, Ie + ke), X.push(he[ke].x), X.push(he[ke].y);
              ye.vertexLength += he.length, ye.primitiveLength += he.length;
            }
            const ce = E$(X, ie);
            for (let he = 0; he < ce.length; he += 3) this.indexArray.emplaceBack(Z + ce[he], Z + ce[he + 1], Z + ce[he + 2]);
            D.vertexLength += P, D.primitiveLength += ce.length / 3;
          }
          this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, s, m, C, b);
        }
      }
      let M$, D$;
      Zt("FillBucket", U_, { omit: ["layers", "patternFeatures"] });
      var dO = { get paint() {
        return D$ = D$ || new pn({ "fill-antialias": new xe(Oe.paint_fill["fill-antialias"]), "fill-opacity": new Ve(Oe.paint_fill["fill-opacity"]), "fill-color": new Ve(Oe.paint_fill["fill-color"]), "fill-outline-color": new Ve(Oe.paint_fill["fill-outline-color"]), "fill-translate": new xe(Oe.paint_fill["fill-translate"]), "fill-translate-anchor": new xe(Oe.paint_fill["fill-translate-anchor"]), "fill-pattern": new pt(Oe.paint_fill["fill-pattern"]) });
      }, get layout() {
        return M$ = M$ || new pn({ "fill-sort-key": new Ve(Oe.layout_fill["fill-sort-key"]) });
      } };
      const pO = Ri([{ name: "a_pos", components: 2, type: "Int16" }, { name: "a_normal_ed", components: 4, type: "Int16" }], 4), hO = Ri([{ name: "a_centroid", components: 2, type: "Int16" }], 4), { members: fO } = pO;
      var au = {}, mO = g, L$ = fp;
      function fp(l, s, u, m, b) {
        this.properties = {}, this.extent = u, this.type = 0, this._pbf = l, this._geometry = -1, this._keys = m, this._values = b, l.readFields(vO, this, s);
      }
      function vO(l, s, u) {
        l == 1 ? s.id = u.readVarint() : l == 2 ? function(m, b) {
          for (var C = m.readVarint() + m.pos; m.pos < C; ) {
            var k = b._keys[m.readVarint()], P = b._values[m.readVarint()];
            b.properties[k] = P;
          }
        }(u, s) : l == 3 ? s.type = u.readVarint() : l == 4 && (s._geometry = u.pos);
      }
      function gO(l) {
        for (var s, u, m = 0, b = 0, C = l.length, k = C - 1; b < C; k = b++) m += ((u = l[k]).x - (s = l[b]).x) * (s.y + u.y);
        return m;
      }
      fp.types = ["Unknown", "Point", "LineString", "Polygon"], fp.prototype.loadGeometry = function() {
        var l = this._pbf;
        l.pos = this._geometry;
        for (var s, u = l.readVarint() + l.pos, m = 1, b = 0, C = 0, k = 0, P = []; l.pos < u; ) {
          if (b <= 0) {
            var D = l.readVarint();
            m = 7 & D, b = D >> 3;
          }
          if (b--, m === 1 || m === 2) C += l.readSVarint(), k += l.readSVarint(), m === 1 && (s && P.push(s), s = []), s.push(new mO(C, k));
          else {
            if (m !== 7) throw new Error("unknown command " + m);
            s && s.push(s[0].clone());
          }
        }
        return s && P.push(s), P;
      }, fp.prototype.bbox = function() {
        var l = this._pbf;
        l.pos = this._geometry;
        for (var s = l.readVarint() + l.pos, u = 1, m = 0, b = 0, C = 0, k = 1 / 0, P = -1 / 0, D = 1 / 0, Z = -1 / 0; l.pos < s; ) {
          if (m <= 0) {
            var X = l.readVarint();
            u = 7 & X, m = X >> 3;
          }
          if (m--, u === 1 || u === 2) (b += l.readSVarint()) < k && (k = b), b > P && (P = b), (C += l.readSVarint()) < D && (D = C), C > Z && (Z = C);
          else if (u !== 7) throw new Error("unknown command " + u);
        }
        return [k, D, P, Z];
      }, fp.prototype.toGeoJSON = function(l, s, u) {
        var m, b, C = this.extent * Math.pow(2, u), k = this.extent * l, P = this.extent * s, D = this.loadGeometry(), Z = fp.types[this.type];
        function X(he) {
          for (var ye = 0; ye < he.length; ye++) {
            var Ie = he[ye];
            he[ye] = [360 * (Ie.x + k) / C - 180, 360 / Math.PI * Math.atan(Math.exp((180 - 360 * (Ie.y + P) / C) * Math.PI / 180)) - 90];
          }
        }
        switch (this.type) {
          case 1:
            var ie = [];
            for (m = 0; m < D.length; m++) ie[m] = D[m][0];
            X(D = ie);
            break;
          case 2:
            for (m = 0; m < D.length; m++) X(D[m]);
            break;
          case 3:
            for (D = function(he) {
              var ye = he.length;
              if (ye <= 1) return [he];
              for (var Ie, ke, He = [], Qe = 0; Qe < ye; Qe++) {
                var Be = gO(he[Qe]);
                Be !== 0 && (ke === void 0 && (ke = Be < 0), ke === Be < 0 ? (Ie && He.push(Ie), Ie = [he[Qe]]) : Ie.push(he[Qe]));
              }
              return Ie && He.push(Ie), He;
            }(D), m = 0; m < D.length; m++) for (b = 0; b < D[m].length; b++) X(D[m][b]);
        }
        D.length === 1 ? D = D[0] : Z = "Multi" + Z;
        var ce = { type: "Feature", geometry: { type: Z, coordinates: D }, properties: this.properties };
        return "id" in this && (ce.id = this.id), ce;
      };
      var yO = L$, O$ = N$;
      function N$(l, s) {
        this.version = 1, this.name = null, this.extent = 4096, this.length = 0, this._pbf = l, this._keys = [], this._values = [], this._features = [], l.readFields(_O, this, s), this.length = this._features.length;
      }
      function _O(l, s, u) {
        l === 15 ? s.version = u.readVarint() : l === 1 ? s.name = u.readString() : l === 5 ? s.extent = u.readVarint() : l === 2 ? s._features.push(u.pos) : l === 3 ? s._keys.push(u.readString()) : l === 4 && s._values.push(function(m) {
          for (var b = null, C = m.readVarint() + m.pos; m.pos < C; ) {
            var k = m.readVarint() >> 3;
            b = k === 1 ? m.readString() : k === 2 ? m.readFloat() : k === 3 ? m.readDouble() : k === 4 ? m.readVarint64() : k === 5 ? m.readVarint() : k === 6 ? m.readSVarint() : k === 7 ? m.readBoolean() : null;
          }
          return b;
        }(u));
      }
      N$.prototype.feature = function(l) {
        if (l < 0 || l >= this._features.length) throw new Error("feature index out of bounds");
        this._pbf.pos = this._features[l];
        var s = this._pbf.readVarint() + this._pbf.pos;
        return new yO(this._pbf, s, this.extent, this._keys, this._values);
      };
      var bO = O$;
      function wO(l, s, u) {
        if (l === 3) {
          var m = new bO(u, u.readVarint() + u.pos);
          m.length && (s[m.name] = m);
        }
      }
      au.VectorTile = function(l, s) {
        this.layers = l.readFields(wO, {}, s);
      }, au.VectorTileFeature = L$, au.VectorTileLayer = O$;
      const xO = au.VectorTileFeature.types, H_ = Math.pow(2, 13);
      function yf(l, s, u, m, b, C, k, P) {
        l.emplaceBack(s, u, 2 * Math.floor(m * H_) + k, b * H_ * 2, C * H_ * 2, Math.round(P));
      }
      class W_ {
        constructor(s) {
          this.zoom = s.zoom, this.overscaling = s.overscaling, this.layers = s.layers, this.layerIds = this.layers.map((u) => u.id), this.index = s.index, this.hasPattern = !1, this.layoutVertexArray = new Me(), this.centroidVertexArray = new Se(), this.indexArray = new xt(), this.programConfigurations = new La(s.layers, s.zoom), this.segments = new Ot(), this.stateDependentLayerIds = this.layers.filter((u) => u.isStateDependent()).map((u) => u.id);
        }
        populate(s, u, m) {
          this.features = [], this.hasPattern = B_("fill-extrusion", this.layers, u);
          for (const { feature: b, id: C, index: k, sourceLayerIndex: P } of s) {
            const D = this.layers[0]._featureFilter.needGeometry, Z = cd(b, D);
            if (!this.layers[0]._featureFilter.filter(new Ei(this.zoom), Z, m)) continue;
            const X = { id: C, sourceLayerIndex: P, index: k, geometry: D ? Z.geometry : Oa(b), properties: b.properties, type: b.type, patterns: {} };
            this.hasPattern ? this.features.push(V_("fill-extrusion", this.layers, X, this.zoom, u)) : this.addFeature(X, X.geometry, k, m, {}), u.featureIndex.insert(b, X.geometry, k, P, this.index, !0);
          }
        }
        addFeatures(s, u, m) {
          for (const b of this.features) {
            const { geometry: C } = b;
            this.addFeature(b, C, b.index, u, m);
          }
        }
        update(s, u, m) {
          this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(s, u, this.stateDependentLayers, m);
        }
        isEmpty() {
          return this.layoutVertexArray.length === 0 && this.centroidVertexArray.length === 0;
        }
        uploadPending() {
          return !this.uploaded || this.programConfigurations.needsUpload;
        }
        upload(s) {
          this.uploaded || (this.layoutVertexBuffer = s.createVertexBuffer(this.layoutVertexArray, fO), this.centroidVertexBuffer = s.createVertexBuffer(this.centroidVertexArray, hO.members, !0), this.indexBuffer = s.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(s), this.uploaded = !0;
        }
        destroy() {
          this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.centroidVertexBuffer.destroy());
        }
        addFeature(s, u, m, b, C) {
          const k = { x: 0, y: 0, vertexCount: 0 };
          for (const P of z_(u, 500)) {
            let D = 0;
            for (const ye of P) D += ye.length;
            let Z = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray);
            for (const ye of P) {
              if (ye.length === 0 || CO(ye)) continue;
              let Ie = 0;
              for (let ke = 0; ke < ye.length; ke++) {
                const He = ye[ke];
                if (ke >= 1) {
                  const Qe = ye[ke - 1];
                  if (!$O(He, Qe)) {
                    Z.vertexLength + 4 > Ot.MAX_VERTEX_ARRAY_LENGTH && (Z = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray));
                    const Be = He.sub(Qe)._perp()._unit(), lt = Qe.dist(He);
                    Ie + lt > 32768 && (Ie = 0), yf(this.layoutVertexArray, He.x, He.y, Be.x, Be.y, 0, 0, Ie), yf(this.layoutVertexArray, He.x, He.y, Be.x, Be.y, 0, 1, Ie), k.x += 2 * He.x, k.y += 2 * He.y, k.vertexCount += 2, Ie += lt, yf(this.layoutVertexArray, Qe.x, Qe.y, Be.x, Be.y, 0, 0, Ie), yf(this.layoutVertexArray, Qe.x, Qe.y, Be.x, Be.y, 0, 1, Ie), k.x += 2 * Qe.x, k.y += 2 * Qe.y, k.vertexCount += 2;
                    const ut = Z.vertexLength;
                    this.indexArray.emplaceBack(ut, ut + 2, ut + 1), this.indexArray.emplaceBack(ut + 1, ut + 2, ut + 3), Z.vertexLength += 4, Z.primitiveLength += 2;
                  }
                }
              }
            }
            if (Z.vertexLength + D > Ot.MAX_VERTEX_ARRAY_LENGTH && (Z = this.segments.prepareSegment(D, this.layoutVertexArray, this.indexArray)), xO[s.type] !== "Polygon") continue;
            const X = [], ie = [], ce = Z.vertexLength;
            for (const ye of P) if (ye.length !== 0) {
              ye !== P[0] && ie.push(X.length / 2);
              for (let Ie = 0; Ie < ye.length; Ie++) {
                const ke = ye[Ie];
                yf(this.layoutVertexArray, ke.x, ke.y, 0, 0, 1, 1, 0), k.x += ke.x, k.y += ke.y, k.vertexCount += 1, X.push(ke.x), X.push(ke.y);
              }
            }
            const he = E$(X, ie);
            for (let ye = 0; ye < he.length; ye += 3) this.indexArray.emplaceBack(ce + he[ye], ce + he[ye + 2], ce + he[ye + 1]);
            Z.primitiveLength += he.length / 3, Z.vertexLength += D;
          }
          for (let P = 0; P < k.vertexCount; P++) this.centroidVertexArray.emplaceBack(Math.floor(k.x / k.vertexCount), Math.floor(k.y / k.vertexCount));
          this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, s, m, C, b);
        }
      }
      function $O(l, s) {
        return l.x === s.x && (l.x < 0 || l.x > Wi) || l.y === s.y && (l.y < 0 || l.y > Wi);
      }
      function CO(l) {
        return l.every((s) => s.x < 0) || l.every((s) => s.x > Wi) || l.every((s) => s.y < 0) || l.every((s) => s.y > Wi);
      }
      let F$;
      Zt("FillExtrusionBucket", W_, { omit: ["layers", "features"] });
      var kO = { get paint() {
        return F$ = F$ || new pn({ "fill-extrusion-opacity": new xe(Oe["paint_fill-extrusion"]["fill-extrusion-opacity"]), "fill-extrusion-color": new Ve(Oe["paint_fill-extrusion"]["fill-extrusion-color"]), "fill-extrusion-translate": new xe(Oe["paint_fill-extrusion"]["fill-extrusion-translate"]), "fill-extrusion-translate-anchor": new xe(Oe["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]), "fill-extrusion-pattern": new pt(Oe["paint_fill-extrusion"]["fill-extrusion-pattern"]), "fill-extrusion-height": new Ve(Oe["paint_fill-extrusion"]["fill-extrusion-height"]), "fill-extrusion-base": new Ve(Oe["paint_fill-extrusion"]["fill-extrusion-base"]), "fill-extrusion-vertical-gradient": new xe(Oe["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"]) });
      } };
      function _f(l, s) {
        return l.x * s.x + l.y * s.y;
      }
      function R$(l, s) {
        if (l.length === 1) {
          let u = 0;
          const m = s[u++];
          let b;
          for (; !b || m.equals(b); ) if (b = s[u++], !b) return 1 / 0;
          for (; u < s.length; u++) {
            const C = s[u], k = l[0], P = b.sub(m), D = C.sub(m), Z = k.sub(m), X = _f(P, P), ie = _f(P, D), ce = _f(D, D), he = _f(Z, P), ye = _f(Z, D), Ie = X * ce - ie * ie, ke = (ce * he - ie * ye) / Ie, He = (X * ye - ie * he) / Ie, Qe = m.z * (1 - ke - He) + b.z * ke + C.z * He;
            if (isFinite(Qe)) return Qe;
          }
          return 1 / 0;
        }
        {
          let u = 1 / 0;
          for (const m of s) u = Math.min(u, m.z);
          return u;
        }
      }
      const SO = Ri([{ name: "a_pos_normal", components: 2, type: "Int16" }, { name: "a_data", components: 4, type: "Uint8" }], 4), { members: TO } = SO, IO = Ri([{ name: "a_uv_x", components: 1, type: "Float32" }, { name: "a_split_index", components: 1, type: "Float32" }]), { members: AO } = IO, EO = au.VectorTileFeature.types, PO = Math.cos(Math.PI / 180 * 37.5), z$ = Math.pow(2, 14) / 0.5;
      class Z_ {
        constructor(s) {
          this.zoom = s.zoom, this.overscaling = s.overscaling, this.layers = s.layers, this.layerIds = this.layers.map((u) => u.id), this.index = s.index, this.hasPattern = !1, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {}, this.layers.forEach((u) => {
            this.gradients[u.id] = {};
          }), this.layoutVertexArray = new Ue(), this.layoutVertexArray2 = new ct(), this.indexArray = new xt(), this.programConfigurations = new La(s.layers, s.zoom), this.segments = new Ot(), this.maxLineLength = 0, this.stateDependentLayerIds = this.layers.filter((u) => u.isStateDependent()).map((u) => u.id);
        }
        populate(s, u, m) {
          this.hasPattern = B_("line", this.layers, u);
          const b = this.layers[0].layout.get("line-sort-key"), C = !b.isConstant(), k = [];
          for (const { feature: P, id: D, index: Z, sourceLayerIndex: X } of s) {
            const ie = this.layers[0]._featureFilter.needGeometry, ce = cd(P, ie);
            if (!this.layers[0]._featureFilter.filter(new Ei(this.zoom), ce, m)) continue;
            const he = C ? b.evaluate(ce, {}, m) : void 0, ye = { id: D, properties: P.properties, type: P.type, sourceLayerIndex: X, index: Z, geometry: ie ? ce.geometry : Oa(P), patterns: {}, sortKey: he };
            k.push(ye);
          }
          C && k.sort((P, D) => P.sortKey - D.sortKey);
          for (const P of k) {
            const { geometry: D, index: Z, sourceLayerIndex: X } = P;
            if (this.hasPattern) {
              const ie = V_("line", this.layers, P, this.zoom, u);
              this.patternFeatures.push(ie);
            } else this.addFeature(P, D, Z, m, {});
            u.featureIndex.insert(s[Z].feature, D, Z, X, this.index);
          }
        }
        update(s, u, m) {
          this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(s, u, this.stateDependentLayers, m);
        }
        addFeatures(s, u, m) {
          for (const b of this.patternFeatures) this.addFeature(b, b.geometry, b.index, u, m);
        }
        isEmpty() {
          return this.layoutVertexArray.length === 0;
        }
        uploadPending() {
          return !this.uploaded || this.programConfigurations.needsUpload;
        }
        upload(s) {
          this.uploaded || (this.layoutVertexArray2.length !== 0 && (this.layoutVertexBuffer2 = s.createVertexBuffer(this.layoutVertexArray2, AO)), this.layoutVertexBuffer = s.createVertexBuffer(this.layoutVertexArray, TO), this.indexBuffer = s.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(s), this.uploaded = !0;
        }
        destroy() {
          this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
        }
        lineFeatureClips(s) {
          if (s.properties && Object.prototype.hasOwnProperty.call(s.properties, "mapbox_clip_start") && Object.prototype.hasOwnProperty.call(s.properties, "mapbox_clip_end")) return { start: +s.properties.mapbox_clip_start, end: +s.properties.mapbox_clip_end };
        }
        addFeature(s, u, m, b, C) {
          const k = this.layers[0].layout, P = k.get("line-join").evaluate(s, {}), D = k.get("line-cap"), Z = k.get("line-miter-limit"), X = k.get("line-round-limit");
          this.lineClips = this.lineFeatureClips(s);
          for (const ie of u) this.addLine(ie, s, P, D, Z, X);
          this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, s, m, C, b);
        }
        addLine(s, u, m, b, C, k) {
          if (this.distance = 0, this.scaledDistance = 0, this.totalDistance = 0, this.lineClips) {
            this.lineClipsArray.push(this.lineClips);
            for (let He = 0; He < s.length - 1; He++) this.totalDistance += s[He].dist(s[He + 1]);
            this.updateScaledDistance(), this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
          }
          const P = EO[u.type] === "Polygon";
          let D = s.length;
          for (; D >= 2 && s[D - 1].equals(s[D - 2]); ) D--;
          let Z = 0;
          for (; Z < D - 1 && s[Z].equals(s[Z + 1]); ) Z++;
          if (D < (P ? 3 : 2)) return;
          m === "bevel" && (C = 1.05);
          const X = this.overscaling <= 16 ? 15 * Wi / (512 * this.overscaling) : 0, ie = this.segments.prepareSegment(10 * D, this.layoutVertexArray, this.indexArray);
          let ce, he, ye, Ie, ke;
          this.e1 = this.e2 = -1, P && (ce = s[D - 2], ke = s[Z].sub(ce)._unit()._perp());
          for (let He = Z; He < D; He++) {
            if (ye = He === D - 1 ? P ? s[Z + 1] : void 0 : s[He + 1], ye && s[He].equals(ye)) continue;
            ke && (Ie = ke), ce && (he = ce), ce = s[He], ke = ye ? ye.sub(ce)._unit()._perp() : Ie, Ie = Ie || ke;
            let Qe = Ie.add(ke);
            Qe.x === 0 && Qe.y === 0 || Qe._unit();
            const Be = Ie.x * ke.x + Ie.y * ke.y, lt = Qe.x * ke.x + Qe.y * ke.y, ut = lt !== 0 ? 1 / lt : 1 / 0, vt = 2 * Math.sqrt(2 - 2 * lt), Xt = lt < PO && he && ye, nn = Ie.x * ke.y - Ie.y * ke.x > 0;
            if (Xt && He > Z) {
              const Lt = ce.dist(he);
              if (Lt > 2 * X) {
                const Ut = ce.sub(ce.sub(he)._mult(X / Lt)._round());
                this.updateDistance(he, Ut), this.addCurrentVertex(Ut, Ie, 0, 0, ie), he = Ut;
              }
            }
            const Vt = he && ye;
            let Ft = Vt ? m : P ? "butt" : b;
            if (Vt && Ft === "round" && (ut < k ? Ft = "miter" : ut <= 2 && (Ft = "fakeround")), Ft === "miter" && ut > C && (Ft = "bevel"), Ft === "bevel" && (ut > 2 && (Ft = "flipbevel"), ut < C && (Ft = "miter")), he && this.updateDistance(he, ce), Ft === "miter") Qe._mult(ut), this.addCurrentVertex(ce, Qe, 0, 0, ie);
            else if (Ft === "flipbevel") {
              if (ut > 100) Qe = ke.mult(-1);
              else {
                const Lt = ut * Ie.add(ke).mag() / Ie.sub(ke).mag();
                Qe._perp()._mult(Lt * (nn ? -1 : 1));
              }
              this.addCurrentVertex(ce, Qe, 0, 0, ie), this.addCurrentVertex(ce, Qe.mult(-1), 0, 0, ie);
            } else if (Ft === "bevel" || Ft === "fakeround") {
              const Lt = -Math.sqrt(ut * ut - 1), Ut = nn ? Lt : 0, zt = nn ? 0 : Lt;
              if (he && this.addCurrentVertex(ce, Ie, Ut, zt, ie), Ft === "fakeround") {
                const St = Math.round(180 * vt / Math.PI / 20);
                for (let mn = 1; mn < St; mn++) {
                  let ln = mn / St;
                  if (ln !== 0.5) {
                    const Zi = ln - 0.5;
                    ln += ln * Zi * (ln - 1) * ((1.0904 + Be * (Be * (3.55645 - 1.43519 * Be) - 3.2452)) * Zi * Zi + (0.848013 + Be * (0.215638 * Be - 1.06021)));
                  }
                  const jn = ke.sub(Ie)._mult(ln)._add(Ie)._unit()._mult(nn ? -1 : 1);
                  this.addHalfVertex(ce, jn.x, jn.y, !1, nn, 0, ie);
                }
              }
              ye && this.addCurrentVertex(ce, ke, -Ut, -zt, ie);
            } else if (Ft === "butt") this.addCurrentVertex(ce, Qe, 0, 0, ie);
            else if (Ft === "square") {
              const Lt = he ? 1 : -1;
              this.addCurrentVertex(ce, Qe, Lt, Lt, ie);
            } else Ft === "round" && (he && (this.addCurrentVertex(ce, Ie, 0, 0, ie), this.addCurrentVertex(ce, Ie, 1, 1, ie, !0)), ye && (this.addCurrentVertex(ce, ke, -1, -1, ie, !0), this.addCurrentVertex(ce, ke, 0, 0, ie)));
            if (Xt && He < D - 1) {
              const Lt = ce.dist(ye);
              if (Lt > 2 * X) {
                const Ut = ce.add(ye.sub(ce)._mult(X / Lt)._round());
                this.updateDistance(ce, Ut), this.addCurrentVertex(Ut, ke, 0, 0, ie), ce = Ut;
              }
            }
          }
        }
        addCurrentVertex(s, u, m, b, C, k = !1) {
          const P = u.y * b - u.x, D = -u.y - u.x * b;
          this.addHalfVertex(s, u.x + u.y * m, u.y - u.x * m, k, !1, m, C), this.addHalfVertex(s, P, D, k, !0, -b, C), this.distance > z$ / 2 && this.totalDistance === 0 && (this.distance = 0, this.updateScaledDistance(), this.addCurrentVertex(s, u, m, b, C, k));
        }
        addHalfVertex({ x: s, y: u }, m, b, C, k, P, D) {
          const Z = 0.5 * (this.lineClips ? this.scaledDistance * (z$ - 1) : this.scaledDistance);
          this.layoutVertexArray.emplaceBack((s << 1) + (C ? 1 : 0), (u << 1) + (k ? 1 : 0), Math.round(63 * m) + 128, Math.round(63 * b) + 128, 1 + (P === 0 ? 0 : P < 0 ? -1 : 1) | (63 & Z) << 2, Z >> 6), this.lineClips && this.layoutVertexArray2.emplaceBack((this.scaledDistance - this.lineClips.start) / (this.lineClips.end - this.lineClips.start), this.lineClipsArray.length);
          const X = D.vertexLength++;
          this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, this.e2, X), D.primitiveLength++), k ? this.e2 = X : this.e1 = X;
        }
        updateScaledDistance() {
          this.scaledDistance = this.lineClips ? this.lineClips.start + (this.lineClips.end - this.lineClips.start) * this.distance / this.totalDistance : this.distance;
        }
        updateDistance(s, u) {
          this.distance += s.dist(u), this.updateScaledDistance();
        }
      }
      let B$, V$;
      Zt("LineBucket", Z_, { omit: ["layers", "patternFeatures"] });
      var U$ = { get paint() {
        return V$ = V$ || new pn({ "line-opacity": new Ve(Oe.paint_line["line-opacity"]), "line-color": new Ve(Oe.paint_line["line-color"]), "line-translate": new xe(Oe.paint_line["line-translate"]), "line-translate-anchor": new xe(Oe.paint_line["line-translate-anchor"]), "line-width": new Ve(Oe.paint_line["line-width"]), "line-gap-width": new Ve(Oe.paint_line["line-gap-width"]), "line-offset": new Ve(Oe.paint_line["line-offset"]), "line-blur": new Ve(Oe.paint_line["line-blur"]), "line-dasharray": new $t(Oe.paint_line["line-dasharray"]), "line-pattern": new pt(Oe.paint_line["line-pattern"]), "line-gradient": new Jt(Oe.paint_line["line-gradient"]) });
      }, get layout() {
        return B$ = B$ || new pn({ "line-cap": new xe(Oe.layout_line["line-cap"]), "line-join": new Ve(Oe.layout_line["line-join"]), "line-miter-limit": new xe(Oe.layout_line["line-miter-limit"]), "line-round-limit": new xe(Oe.layout_line["line-round-limit"]), "line-sort-key": new Ve(Oe.layout_line["line-sort-key"]) });
      } };
      class MO extends Ve {
        possiblyEvaluate(s, u) {
          return u = new Ei(Math.floor(u.zoom), { now: u.now, fadeDuration: u.fadeDuration, zoomHistory: u.zoomHistory, transition: u.transition }), super.possiblyEvaluate(s, u);
        }
        evaluate(s, u, m, b) {
          return u = U({}, u, { zoom: Math.floor(u.zoom) }), super.evaluate(s, u, m, b);
        }
      }
      let mv;
      function H$(l, s) {
        return s > 0 ? s + 2 * l : l;
      }
      const DO = Ri([{ name: "a_pos_offset", components: 4, type: "Int16" }, { name: "a_data", components: 4, type: "Uint16" }, { name: "a_pixeloffset", components: 4, type: "Int16" }], 4), LO = Ri([{ name: "a_projected_pos", components: 3, type: "Float32" }], 4);
      Ri([{ name: "a_fade_opacity", components: 1, type: "Uint32" }], 4);
      const OO = Ri([{ name: "a_placed", components: 2, type: "Uint8" }, { name: "a_shift", components: 2, type: "Float32" }]);
      Ri([{ type: "Int16", name: "anchorPointX" }, { type: "Int16", name: "anchorPointY" }, { type: "Int16", name: "x1" }, { type: "Int16", name: "y1" }, { type: "Int16", name: "x2" }, { type: "Int16", name: "y2" }, { type: "Uint32", name: "featureIndex" }, { type: "Uint16", name: "sourceLayerIndex" }, { type: "Uint16", name: "bucketIndex" }]);
      const W$ = Ri([{ name: "a_pos", components: 2, type: "Int16" }, { name: "a_anchor_pos", components: 2, type: "Int16" }, { name: "a_extrude", components: 2, type: "Int16" }], 4), NO = Ri([{ name: "a_pos", components: 2, type: "Float32" }, { name: "a_radius", components: 1, type: "Float32" }, { name: "a_flags", components: 2, type: "Int16" }], 4);
      function FO(l, s, u) {
        return l.sections.forEach((m) => {
          m.text = function(b, C, k) {
            const P = C.layout.get("text-transform").evaluate(k, {});
            return P === "uppercase" ? b = b.toLocaleUpperCase() : P === "lowercase" && (b = b.toLocaleLowerCase()), Os.applyArabicShaping && (b = Os.applyArabicShaping(b)), b;
          }(m.text, s, u);
        }), l;
      }
      Ri([{ name: "triangle", components: 3, type: "Uint16" }]), Ri([{ type: "Int16", name: "anchorX" }, { type: "Int16", name: "anchorY" }, { type: "Uint16", name: "glyphStartIndex" }, { type: "Uint16", name: "numGlyphs" }, { type: "Uint32", name: "vertexStartIndex" }, { type: "Uint32", name: "lineStartIndex" }, { type: "Uint32", name: "lineLength" }, { type: "Uint16", name: "segment" }, { type: "Uint16", name: "lowerSize" }, { type: "Uint16", name: "upperSize" }, { type: "Float32", name: "lineOffsetX" }, { type: "Float32", name: "lineOffsetY" }, { type: "Uint8", name: "writingMode" }, { type: "Uint8", name: "placedOrientation" }, { type: "Uint8", name: "hidden" }, { type: "Uint32", name: "crossTileID" }, { type: "Int16", name: "associatedIconIndex" }]), Ri([{ type: "Int16", name: "anchorX" }, { type: "Int16", name: "anchorY" }, { type: "Int16", name: "rightJustifiedTextSymbolIndex" }, { type: "Int16", name: "centerJustifiedTextSymbolIndex" }, { type: "Int16", name: "leftJustifiedTextSymbolIndex" }, { type: "Int16", name: "verticalPlacedTextSymbolIndex" }, { type: "Int16", name: "placedIconSymbolIndex" }, { type: "Int16", name: "verticalPlacedIconSymbolIndex" }, { type: "Uint16", name: "key" }, { type: "Uint16", name: "textBoxStartIndex" }, { type: "Uint16", name: "textBoxEndIndex" }, { type: "Uint16", name: "verticalTextBoxStartIndex" }, { type: "Uint16", name: "verticalTextBoxEndIndex" }, { type: "Uint16", name: "iconBoxStartIndex" }, { type: "Uint16", name: "iconBoxEndIndex" }, { type: "Uint16", name: "verticalIconBoxStartIndex" }, { type: "Uint16", name: "verticalIconBoxEndIndex" }, { type: "Uint16", name: "featureIndex" }, { type: "Uint16", name: "numHorizontalGlyphVertices" }, { type: "Uint16", name: "numVerticalGlyphVertices" }, { type: "Uint16", name: "numIconVertices" }, { type: "Uint16", name: "numVerticalIconVertices" }, { type: "Uint16", name: "useRuntimeCollisionCircles" }, { type: "Uint32", name: "crossTileID" }, { type: "Float32", name: "textBoxScale" }, { type: "Float32", components: 2, name: "textOffset" }, { type: "Float32", name: "collisionCircleDiameter" }]), Ri([{ type: "Float32", name: "offsetX" }]), Ri([{ type: "Int16", name: "x" }, { type: "Int16", name: "y" }, { type: "Int16", name: "tileUnitDistanceFromAnchor" }]);
      const bf = { "!": "︕", "#": "＃", $: "＄", "%": "％", "&": "＆", "(": "︵", ")": "︶", "*": "＊", "+": "＋", ",": "︐", "-": "︲", ".": "・", "/": "／", ":": "︓", ";": "︔", "<": "︿", "=": "＝", ">": "﹀", "?": "︖", "@": "＠", "[": "﹇", "\\": "＼", "]": "﹈", "^": "＾", _: "︳", "`": "｀", "{": "︷", "|": "―", "}": "︸", "~": "～", "¢": "￠", "£": "￡", "¥": "￥", "¦": "￤", "¬": "￢", "¯": "￣", "–": "︲", "—": "︱", "‘": "﹃", "’": "﹄", "“": "﹁", "”": "﹂", "…": "︙", "‧": "・", "₩": "￦", "、": "︑", "。": "︒", "〈": "︿", "〉": "﹀", "《": "︽", "》": "︾", "「": "﹁", "」": "﹂", "『": "﹃", "』": "﹄", "【": "︻", "】": "︼", "〔": "︹", "〕": "︺", "〖": "︗", "〗": "︘", "！": "︕", "（": "︵", "）": "︶", "，": "︐", "－": "︲", "．": "・", "：": "︓", "；": "︔", "＜": "︿", "＞": "﹀", "？": "︖", "［": "﹇", "］": "﹈", "＿": "︳", "｛": "︷", "｜": "―", "｝": "︸", "｟": "︵", "｠": "︶", "｡": "︒", "｢": "﹁", "｣": "﹂" };
      var Fr = 24, Z$ = Ti, q$ = function(l, s, u, m, b) {
        var C, k, P = 8 * b - m - 1, D = (1 << P) - 1, Z = D >> 1, X = -7, ie = b - 1, ce = -1, he = l[s + ie];
        for (ie += ce, C = he & (1 << -X) - 1, he >>= -X, X += P; X > 0; C = 256 * C + l[s + ie], ie += ce, X -= 8) ;
        for (k = C & (1 << -X) - 1, C >>= -X, X += m; X > 0; k = 256 * k + l[s + ie], ie += ce, X -= 8) ;
        if (C === 0) C = 1 - Z;
        else {
          if (C === D) return k ? NaN : 1 / 0 * (he ? -1 : 1);
          k += Math.pow(2, m), C -= Z;
        }
        return (he ? -1 : 1) * k * Math.pow(2, C - m);
      }, j$ = function(l, s, u, m, b, C) {
        var k, P, D, Z = 8 * C - b - 1, X = (1 << Z) - 1, ie = X >> 1, ce = b === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, he = 0, ye = 1, Ie = s < 0 || s === 0 && 1 / s < 0 ? 1 : 0;
        for (s = Math.abs(s), isNaN(s) || s === 1 / 0 ? (P = isNaN(s) ? 1 : 0, k = X) : (k = Math.floor(Math.log(s) / Math.LN2), s * (D = Math.pow(2, -k)) < 1 && (k--, D *= 2), (s += k + ie >= 1 ? ce / D : ce * Math.pow(2, 1 - ie)) * D >= 2 && (k++, D /= 2), k + ie >= X ? (P = 0, k = X) : k + ie >= 1 ? (P = (s * D - 1) * Math.pow(2, b), k += ie) : (P = s * Math.pow(2, ie - 1) * Math.pow(2, b), k = 0)); b >= 8; l[u + he] = 255 & P, he += ye, P /= 256, b -= 8) ;
        for (k = k << b | P, Z += b; Z > 0; l[u + he] = 255 & k, he += ye, k /= 256, Z -= 8) ;
        l[u + he - ye] |= 128 * Ie;
      };
      function Ti(l) {
        this.buf = ArrayBuffer.isView && ArrayBuffer.isView(l) ? l : new Uint8Array(l || 0), this.pos = 0, this.type = 0, this.length = this.buf.length;
      }
      Ti.Varint = 0, Ti.Fixed64 = 1, Ti.Bytes = 2, Ti.Fixed32 = 5;
      var q_ = 4294967296, G$ = 1 / q_, Y$ = typeof TextDecoder > "u" ? null : new TextDecoder("utf8");
      function yc(l) {
        return l.type === Ti.Bytes ? l.readVarint() + l.pos : l.pos + 1;
      }
      function mp(l, s, u) {
        return u ? 4294967296 * s + (l >>> 0) : 4294967296 * (s >>> 0) + (l >>> 0);
      }
      function K$(l, s, u) {
        var m = s <= 16383 ? 1 : s <= 2097151 ? 2 : s <= 268435455 ? 3 : Math.floor(Math.log(s) / (7 * Math.LN2));
        u.realloc(m);
        for (var b = u.pos - 1; b >= l; b--) u.buf[b + m] = u.buf[b];
      }
      function RO(l, s) {
        for (var u = 0; u < l.length; u++) s.writeVarint(l[u]);
      }
      function zO(l, s) {
        for (var u = 0; u < l.length; u++) s.writeSVarint(l[u]);
      }
      function BO(l, s) {
        for (var u = 0; u < l.length; u++) s.writeFloat(l[u]);
      }
      function VO(l, s) {
        for (var u = 0; u < l.length; u++) s.writeDouble(l[u]);
      }
      function UO(l, s) {
        for (var u = 0; u < l.length; u++) s.writeBoolean(l[u]);
      }
      function HO(l, s) {
        for (var u = 0; u < l.length; u++) s.writeFixed32(l[u]);
      }
      function WO(l, s) {
        for (var u = 0; u < l.length; u++) s.writeSFixed32(l[u]);
      }
      function ZO(l, s) {
        for (var u = 0; u < l.length; u++) s.writeFixed64(l[u]);
      }
      function qO(l, s) {
        for (var u = 0; u < l.length; u++) s.writeSFixed64(l[u]);
      }
      function vv(l, s) {
        return (l[s] | l[s + 1] << 8 | l[s + 2] << 16) + 16777216 * l[s + 3];
      }
      function vp(l, s, u) {
        l[u] = s, l[u + 1] = s >>> 8, l[u + 2] = s >>> 16, l[u + 3] = s >>> 24;
      }
      function X$(l, s) {
        return (l[s] | l[s + 1] << 8 | l[s + 2] << 16) + (l[s + 3] << 24);
      }
      Ti.prototype = { destroy: function() {
        this.buf = null;
      }, readFields: function(l, s, u) {
        for (u = u || this.length; this.pos < u; ) {
          var m = this.readVarint(), b = m >> 3, C = this.pos;
          this.type = 7 & m, l(b, s, this), this.pos === C && this.skip(m);
        }
        return s;
      }, readMessage: function(l, s) {
        return this.readFields(l, s, this.readVarint() + this.pos);
      }, readFixed32: function() {
        var l = vv(this.buf, this.pos);
        return this.pos += 4, l;
      }, readSFixed32: function() {
        var l = X$(this.buf, this.pos);
        return this.pos += 4, l;
      }, readFixed64: function() {
        var l = vv(this.buf, this.pos) + vv(this.buf, this.pos + 4) * q_;
        return this.pos += 8, l;
      }, readSFixed64: function() {
        var l = vv(this.buf, this.pos) + X$(this.buf, this.pos + 4) * q_;
        return this.pos += 8, l;
      }, readFloat: function() {
        var l = q$(this.buf, this.pos, !0, 23, 4);
        return this.pos += 4, l;
      }, readDouble: function() {
        var l = q$(this.buf, this.pos, !0, 52, 8);
        return this.pos += 8, l;
      }, readVarint: function(l) {
        var s, u, m = this.buf;
        return s = 127 & (u = m[this.pos++]), u < 128 ? s : (s |= (127 & (u = m[this.pos++])) << 7, u < 128 ? s : (s |= (127 & (u = m[this.pos++])) << 14, u < 128 ? s : (s |= (127 & (u = m[this.pos++])) << 21, u < 128 ? s : function(b, C, k) {
          var P, D, Z = k.buf;
          if (P = (112 & (D = Z[k.pos++])) >> 4, D < 128 || (P |= (127 & (D = Z[k.pos++])) << 3, D < 128) || (P |= (127 & (D = Z[k.pos++])) << 10, D < 128) || (P |= (127 & (D = Z[k.pos++])) << 17, D < 128) || (P |= (127 & (D = Z[k.pos++])) << 24, D < 128) || (P |= (1 & (D = Z[k.pos++])) << 31, D < 128)) return mp(b, P, C);
          throw new Error("Expected varint not more than 10 bytes");
        }(s |= (15 & (u = m[this.pos])) << 28, l, this))));
      }, readVarint64: function() {
        return this.readVarint(!0);
      }, readSVarint: function() {
        var l = this.readVarint();
        return l % 2 == 1 ? (l + 1) / -2 : l / 2;
      }, readBoolean: function() {
        return !!this.readVarint();
      }, readString: function() {
        var l = this.readVarint() + this.pos, s = this.pos;
        return this.pos = l, l - s >= 12 && Y$ ? function(u, m, b) {
          return Y$.decode(u.subarray(m, b));
        }(this.buf, s, l) : function(u, m, b) {
          for (var C = "", k = m; k < b; ) {
            var P, D, Z, X = u[k], ie = null, ce = X > 239 ? 4 : X > 223 ? 3 : X > 191 ? 2 : 1;
            if (k + ce > b) break;
            ce === 1 ? X < 128 && (ie = X) : ce === 2 ? (192 & (P = u[k + 1])) == 128 && (ie = (31 & X) << 6 | 63 & P) <= 127 && (ie = null) : ce === 3 ? (D = u[k + 2], (192 & (P = u[k + 1])) == 128 && (192 & D) == 128 && ((ie = (15 & X) << 12 | (63 & P) << 6 | 63 & D) <= 2047 || ie >= 55296 && ie <= 57343) && (ie = null)) : ce === 4 && (D = u[k + 2], Z = u[k + 3], (192 & (P = u[k + 1])) == 128 && (192 & D) == 128 && (192 & Z) == 128 && ((ie = (15 & X) << 18 | (63 & P) << 12 | (63 & D) << 6 | 63 & Z) <= 65535 || ie >= 1114112) && (ie = null)), ie === null ? (ie = 65533, ce = 1) : ie > 65535 && (ie -= 65536, C += String.fromCharCode(ie >>> 10 & 1023 | 55296), ie = 56320 | 1023 & ie), C += String.fromCharCode(ie), k += ce;
          }
          return C;
        }(this.buf, s, l);
      }, readBytes: function() {
        var l = this.readVarint() + this.pos, s = this.buf.subarray(this.pos, l);
        return this.pos = l, s;
      }, readPackedVarint: function(l, s) {
        if (this.type !== Ti.Bytes) return l.push(this.readVarint(s));
        var u = yc(this);
        for (l = l || []; this.pos < u; ) l.push(this.readVarint(s));
        return l;
      }, readPackedSVarint: function(l) {
        if (this.type !== Ti.Bytes) return l.push(this.readSVarint());
        var s = yc(this);
        for (l = l || []; this.pos < s; ) l.push(this.readSVarint());
        return l;
      }, readPackedBoolean: function(l) {
        if (this.type !== Ti.Bytes) return l.push(this.readBoolean());
        var s = yc(this);
        for (l = l || []; this.pos < s; ) l.push(this.readBoolean());
        return l;
      }, readPackedFloat: function(l) {
        if (this.type !== Ti.Bytes) return l.push(this.readFloat());
        var s = yc(this);
        for (l = l || []; this.pos < s; ) l.push(this.readFloat());
        return l;
      }, readPackedDouble: function(l) {
        if (this.type !== Ti.Bytes) return l.push(this.readDouble());
        var s = yc(this);
        for (l = l || []; this.pos < s; ) l.push(this.readDouble());
        return l;
      }, readPackedFixed32: function(l) {
        if (this.type !== Ti.Bytes) return l.push(this.readFixed32());
        var s = yc(this);
        for (l = l || []; this.pos < s; ) l.push(this.readFixed32());
        return l;
      }, readPackedSFixed32: function(l) {
        if (this.type !== Ti.Bytes) return l.push(this.readSFixed32());
        var s = yc(this);
        for (l = l || []; this.pos < s; ) l.push(this.readSFixed32());
        return l;
      }, readPackedFixed64: function(l) {
        if (this.type !== Ti.Bytes) return l.push(this.readFixed64());
        var s = yc(this);
        for (l = l || []; this.pos < s; ) l.push(this.readFixed64());
        return l;
      }, readPackedSFixed64: function(l) {
        if (this.type !== Ti.Bytes) return l.push(this.readSFixed64());
        var s = yc(this);
        for (l = l || []; this.pos < s; ) l.push(this.readSFixed64());
        return l;
      }, skip: function(l) {
        var s = 7 & l;
        if (s === Ti.Varint) for (; this.buf[this.pos++] > 127; ) ;
        else if (s === Ti.Bytes) this.pos = this.readVarint() + this.pos;
        else if (s === Ti.Fixed32) this.pos += 4;
        else {
          if (s !== Ti.Fixed64) throw new Error("Unimplemented type: " + s);
          this.pos += 8;
        }
      }, writeTag: function(l, s) {
        this.writeVarint(l << 3 | s);
      }, realloc: function(l) {
        for (var s = this.length || 16; s < this.pos + l; ) s *= 2;
        if (s !== this.length) {
          var u = new Uint8Array(s);
          u.set(this.buf), this.buf = u, this.length = s;
        }
      }, finish: function() {
        return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
      }, writeFixed32: function(l) {
        this.realloc(4), vp(this.buf, l, this.pos), this.pos += 4;
      }, writeSFixed32: function(l) {
        this.realloc(4), vp(this.buf, l, this.pos), this.pos += 4;
      }, writeFixed64: function(l) {
        this.realloc(8), vp(this.buf, -1 & l, this.pos), vp(this.buf, Math.floor(l * G$), this.pos + 4), this.pos += 8;
      }, writeSFixed64: function(l) {
        this.realloc(8), vp(this.buf, -1 & l, this.pos), vp(this.buf, Math.floor(l * G$), this.pos + 4), this.pos += 8;
      }, writeVarint: function(l) {
        (l = +l || 0) > 268435455 || l < 0 ? function(s, u) {
          var m, b;
          if (s >= 0 ? (m = s % 4294967296 | 0, b = s / 4294967296 | 0) : (b = ~(-s / 4294967296), 4294967295 ^ (m = ~(-s % 4294967296)) ? m = m + 1 | 0 : (m = 0, b = b + 1 | 0)), s >= 18446744073709552e3 || s < -18446744073709552e3) throw new Error("Given varint doesn't fit into 10 bytes");
          u.realloc(10), function(C, k, P) {
            P.buf[P.pos++] = 127 & C | 128, C >>>= 7, P.buf[P.pos++] = 127 & C | 128, C >>>= 7, P.buf[P.pos++] = 127 & C | 128, C >>>= 7, P.buf[P.pos++] = 127 & C | 128, P.buf[P.pos] = 127 & (C >>>= 7);
          }(m, 0, u), function(C, k) {
            var P = (7 & C) << 4;
            k.buf[k.pos++] |= P | ((C >>>= 3) ? 128 : 0), C && (k.buf[k.pos++] = 127 & C | ((C >>>= 7) ? 128 : 0), C && (k.buf[k.pos++] = 127 & C | ((C >>>= 7) ? 128 : 0), C && (k.buf[k.pos++] = 127 & C | ((C >>>= 7) ? 128 : 0), C && (k.buf[k.pos++] = 127 & C | ((C >>>= 7) ? 128 : 0), C && (k.buf[k.pos++] = 127 & C)))));
          }(b, u);
        }(l, this) : (this.realloc(4), this.buf[this.pos++] = 127 & l | (l > 127 ? 128 : 0), l <= 127 || (this.buf[this.pos++] = 127 & (l >>>= 7) | (l > 127 ? 128 : 0), l <= 127 || (this.buf[this.pos++] = 127 & (l >>>= 7) | (l > 127 ? 128 : 0), l <= 127 || (this.buf[this.pos++] = l >>> 7 & 127))));
      }, writeSVarint: function(l) {
        this.writeVarint(l < 0 ? 2 * -l - 1 : 2 * l);
      }, writeBoolean: function(l) {
        this.writeVarint(!!l);
      }, writeString: function(l) {
        l = String(l), this.realloc(4 * l.length), this.pos++;
        var s = this.pos;
        this.pos = function(m, b, C) {
          for (var k, P, D = 0; D < b.length; D++) {
            if ((k = b.charCodeAt(D)) > 55295 && k < 57344) {
              if (!P) {
                k > 56319 || D + 1 === b.length ? (m[C++] = 239, m[C++] = 191, m[C++] = 189) : P = k;
                continue;
              }
              if (k < 56320) {
                m[C++] = 239, m[C++] = 191, m[C++] = 189, P = k;
                continue;
              }
              k = P - 55296 << 10 | k - 56320 | 65536, P = null;
            } else P && (m[C++] = 239, m[C++] = 191, m[C++] = 189, P = null);
            k < 128 ? m[C++] = k : (k < 2048 ? m[C++] = k >> 6 | 192 : (k < 65536 ? m[C++] = k >> 12 | 224 : (m[C++] = k >> 18 | 240, m[C++] = k >> 12 & 63 | 128), m[C++] = k >> 6 & 63 | 128), m[C++] = 63 & k | 128);
          }
          return C;
        }(this.buf, l, this.pos);
        var u = this.pos - s;
        u >= 128 && K$(s, u, this), this.pos = s - 1, this.writeVarint(u), this.pos += u;
      }, writeFloat: function(l) {
        this.realloc(4), j$(this.buf, l, this.pos, !0, 23, 4), this.pos += 4;
      }, writeDouble: function(l) {
        this.realloc(8), j$(this.buf, l, this.pos, !0, 52, 8), this.pos += 8;
      }, writeBytes: function(l) {
        var s = l.length;
        this.writeVarint(s), this.realloc(s);
        for (var u = 0; u < s; u++) this.buf[this.pos++] = l[u];
      }, writeRawMessage: function(l, s) {
        this.pos++;
        var u = this.pos;
        l(s, this);
        var m = this.pos - u;
        m >= 128 && K$(u, m, this), this.pos = u - 1, this.writeVarint(m), this.pos += m;
      }, writeMessage: function(l, s, u) {
        this.writeTag(l, Ti.Bytes), this.writeRawMessage(s, u);
      }, writePackedVarint: function(l, s) {
        s.length && this.writeMessage(l, RO, s);
      }, writePackedSVarint: function(l, s) {
        s.length && this.writeMessage(l, zO, s);
      }, writePackedBoolean: function(l, s) {
        s.length && this.writeMessage(l, UO, s);
      }, writePackedFloat: function(l, s) {
        s.length && this.writeMessage(l, BO, s);
      }, writePackedDouble: function(l, s) {
        s.length && this.writeMessage(l, VO, s);
      }, writePackedFixed32: function(l, s) {
        s.length && this.writeMessage(l, HO, s);
      }, writePackedSFixed32: function(l, s) {
        s.length && this.writeMessage(l, WO, s);
      }, writePackedFixed64: function(l, s) {
        s.length && this.writeMessage(l, ZO, s);
      }, writePackedSFixed64: function(l, s) {
        s.length && this.writeMessage(l, qO, s);
      }, writeBytesField: function(l, s) {
        this.writeTag(l, Ti.Bytes), this.writeBytes(s);
      }, writeFixed32Field: function(l, s) {
        this.writeTag(l, Ti.Fixed32), this.writeFixed32(s);
      }, writeSFixed32Field: function(l, s) {
        this.writeTag(l, Ti.Fixed32), this.writeSFixed32(s);
      }, writeFixed64Field: function(l, s) {
        this.writeTag(l, Ti.Fixed64), this.writeFixed64(s);
      }, writeSFixed64Field: function(l, s) {
        this.writeTag(l, Ti.Fixed64), this.writeSFixed64(s);
      }, writeVarintField: function(l, s) {
        this.writeTag(l, Ti.Varint), this.writeVarint(s);
      }, writeSVarintField: function(l, s) {
        this.writeTag(l, Ti.Varint), this.writeSVarint(s);
      }, writeStringField: function(l, s) {
        this.writeTag(l, Ti.Bytes), this.writeString(s);
      }, writeFloatField: function(l, s) {
        this.writeTag(l, Ti.Fixed32), this.writeFloat(s);
      }, writeDoubleField: function(l, s) {
        this.writeTag(l, Ti.Fixed64), this.writeDouble(s);
      }, writeBooleanField: function(l, s) {
        this.writeVarintField(l, !!s);
      } };
      var j_ = f(Z$);
      const G_ = 3;
      function jO(l, s, u) {
        l === 1 && u.readMessage(GO, s);
      }
      function GO(l, s, u) {
        if (l === 3) {
          const { id: m, bitmap: b, width: C, height: k, left: P, top: D, advance: Z } = u.readMessage(YO, {});
          s.push({ id: m, bitmap: new hf({ width: C + 2 * G_, height: k + 2 * G_ }, b), metrics: { width: C, height: k, left: P, top: D, advance: Z } });
        }
      }
      function YO(l, s, u) {
        l === 1 ? s.id = u.readVarint() : l === 2 ? s.bitmap = u.readBytes() : l === 3 ? s.width = u.readVarint() : l === 4 ? s.height = u.readVarint() : l === 5 ? s.left = u.readSVarint() : l === 6 ? s.top = u.readSVarint() : l === 7 && (s.advance = u.readVarint());
      }
      const KO = G_;
      function J$(l) {
        let s = 0, u = 0;
        for (const k of l) s += k.w * k.h, u = Math.max(u, k.w);
        l.sort((k, P) => P.h - k.h);
        const m = [{ x: 0, y: 0, w: Math.max(Math.ceil(Math.sqrt(s / 0.95)), u), h: 1 / 0 }];
        let b = 0, C = 0;
        for (const k of l) for (let P = m.length - 1; P >= 0; P--) {
          const D = m[P];
          if (!(k.w > D.w || k.h > D.h)) {
            if (k.x = D.x, k.y = D.y, C = Math.max(C, k.y + k.h), b = Math.max(b, k.x + k.w), k.w === D.w && k.h === D.h) {
              const Z = m.pop();
              P < m.length && (m[P] = Z);
            } else k.h === D.h ? (D.x += k.w, D.w -= k.w) : k.w === D.w ? (D.y += k.h, D.h -= k.h) : (m.push({ x: D.x + k.w, y: D.y, w: D.w - k.w, h: k.h }), D.y += k.h, D.h -= k.h);
            break;
          }
        }
        return { w: b, h: C, fill: s / (b * C) || 0 };
      }
      const Ks = 1;
      class Y_ {
        constructor(s, { pixelRatio: u, version: m, stretchX: b, stretchY: C, content: k }) {
          this.paddedRect = s, this.pixelRatio = u, this.stretchX = b, this.stretchY = C, this.content = k, this.version = m;
        }
        get tl() {
          return [this.paddedRect.x + Ks, this.paddedRect.y + Ks];
        }
        get br() {
          return [this.paddedRect.x + this.paddedRect.w - Ks, this.paddedRect.y + this.paddedRect.h - Ks];
        }
        get tlbr() {
          return this.tl.concat(this.br);
        }
        get displaySize() {
          return [(this.paddedRect.w - 2 * Ks) / this.pixelRatio, (this.paddedRect.h - 2 * Ks) / this.pixelRatio];
        }
      }
      class Q$ {
        constructor(s, u) {
          const m = {}, b = {};
          this.haveRenderCallbacks = [];
          const C = [];
          this.addImages(s, m, C), this.addImages(u, b, C);
          const { w: k, h: P } = J$(C), D = new Do({ width: k || 1, height: P || 1 });
          for (const Z in s) {
            const X = s[Z], ie = m[Z].paddedRect;
            Do.copy(X.data, D, { x: 0, y: 0 }, { x: ie.x + Ks, y: ie.y + Ks }, X.data);
          }
          for (const Z in u) {
            const X = u[Z], ie = b[Z].paddedRect, ce = ie.x + Ks, he = ie.y + Ks, ye = X.data.width, Ie = X.data.height;
            Do.copy(X.data, D, { x: 0, y: 0 }, { x: ce, y: he }, X.data), Do.copy(X.data, D, { x: 0, y: Ie - 1 }, { x: ce, y: he - 1 }, { width: ye, height: 1 }), Do.copy(X.data, D, { x: 0, y: 0 }, { x: ce, y: he + Ie }, { width: ye, height: 1 }), Do.copy(X.data, D, { x: ye - 1, y: 0 }, { x: ce - 1, y: he }, { width: 1, height: Ie }), Do.copy(X.data, D, { x: 0, y: 0 }, { x: ce + ye, y: he }, { width: 1, height: Ie });
          }
          this.image = D, this.iconPositions = m, this.patternPositions = b;
        }
        addImages(s, u, m) {
          for (const b in s) {
            const C = s[b], k = { x: 0, y: 0, w: C.data.width + 2 * Ks, h: C.data.height + 2 * Ks };
            m.push(k), u[b] = new Y_(k, C), C.hasRenderCallback && this.haveRenderCallbacks.push(b);
          }
        }
        patchUpdatedImages(s, u) {
          s.dispatchRenderCallbacks(this.haveRenderCallbacks);
          for (const m in s.updatedImages) this.patchUpdatedImage(this.iconPositions[m], s.getImage(m), u), this.patchUpdatedImage(this.patternPositions[m], s.getImage(m), u);
        }
        patchUpdatedImage(s, u, m) {
          if (!s || !u || s.version === u.version) return;
          s.version = u.version;
          const [b, C] = s.tl;
          m.update(u.data, void 0, { x: b, y: C });
        }
      }
      var lu;
      Zt("ImagePosition", Y_), Zt("ImageAtlas", Q$), a.WritingMode = void 0, (lu = a.WritingMode || (a.WritingMode = {}))[lu.none = 0] = "none", lu[lu.horizontal = 1] = "horizontal", lu[lu.vertical = 2] = "vertical", lu[lu.horizontalOnly = 3] = "horizontalOnly";
      const wf = -17;
      class xf {
        constructor() {
          this.scale = 1, this.fontStack = "", this.imageName = null;
        }
        static forText(s, u) {
          const m = new xf();
          return m.scale = s || 1, m.fontStack = u, m;
        }
        static forImage(s) {
          const u = new xf();
          return u.imageName = s, u;
        }
      }
      class gp {
        constructor() {
          this.text = "", this.sectionIndex = [], this.sections = [], this.imageSectionID = null;
        }
        static fromFeature(s, u) {
          const m = new gp();
          for (let b = 0; b < s.sections.length; b++) {
            const C = s.sections[b];
            C.image ? m.addImageSection(C) : m.addTextSection(C, u);
          }
          return m;
        }
        length() {
          return this.text.length;
        }
        getSection(s) {
          return this.sections[this.sectionIndex[s]];
        }
        getSectionIndex(s) {
          return this.sectionIndex[s];
        }
        getCharCode(s) {
          return this.text.charCodeAt(s);
        }
        verticalizePunctuation() {
          this.text = function(s) {
            let u = "";
            for (let m = 0; m < s.length; m++) {
              const b = s.charCodeAt(m + 1) || null, C = s.charCodeAt(m - 1) || null;
              u += b && ho(b) && !bf[s[m + 1]] || C && ho(C) && !bf[s[m - 1]] || !bf[s[m]] ? s[m] : bf[s[m]];
            }
            return u;
          }(this.text);
        }
        trim() {
          let s = 0;
          for (let m = 0; m < this.text.length && yv[this.text.charCodeAt(m)]; m++) s++;
          let u = this.text.length;
          for (let m = this.text.length - 1; m >= 0 && m >= s && yv[this.text.charCodeAt(m)]; m--) u--;
          this.text = this.text.substring(s, u), this.sectionIndex = this.sectionIndex.slice(s, u);
        }
        substring(s, u) {
          const m = new gp();
          return m.text = this.text.substring(s, u), m.sectionIndex = this.sectionIndex.slice(s, u), m.sections = this.sections, m;
        }
        toString() {
          return this.text;
        }
        getMaxScale() {
          return this.sectionIndex.reduce((s, u) => Math.max(s, this.sections[u].scale), 0);
        }
        addTextSection(s, u) {
          this.text += s.text, this.sections.push(xf.forText(s.scale, s.fontStack || u));
          const m = this.sections.length - 1;
          for (let b = 0; b < s.text.length; ++b) this.sectionIndex.push(m);
        }
        addImageSection(s) {
          const u = s.image ? s.image.name : "";
          if (u.length === 0) return void me("Can't add FormattedSection with an empty image.");
          const m = this.getNextImageSectionCharCode();
          m ? (this.text += String.fromCharCode(m), this.sections.push(xf.forImage(u)), this.sectionIndex.push(this.sections.length - 1)) : me("Reached maximum number of images 6401");
        }
        getNextImageSectionCharCode() {
          return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
        }
      }
      function gv(l, s, u, m, b, C, k, P, D, Z, X, ie, ce, he, ye, Ie) {
        const ke = gp.fromFeature(l, b);
        let He;
        ie === a.WritingMode.vertical && ke.verticalizePunctuation();
        const { processBidirectionalText: Qe, processStyledBidirectionalText: Be } = Os;
        if (Qe && ke.sections.length === 1) {
          He = [];
          const vt = Qe(ke.toString(), K_(ke, Z, C, s, m, he, ye));
          for (const Xt of vt) {
            const nn = new gp();
            nn.text = Xt, nn.sections = ke.sections;
            for (let Vt = 0; Vt < Xt.length; Vt++) nn.sectionIndex.push(0);
            He.push(nn);
          }
        } else if (Be) {
          He = [];
          const vt = Be(ke.text, ke.sectionIndex, K_(ke, Z, C, s, m, he, ye));
          for (const Xt of vt) {
            const nn = new gp();
            nn.text = Xt[0], nn.sectionIndex = Xt[1], nn.sections = ke.sections, He.push(nn);
          }
        } else He = function(vt, Xt) {
          const nn = [], Vt = vt.text;
          let Ft = 0;
          for (const Lt of Xt) nn.push(vt.substring(Ft, Lt)), Ft = Lt;
          return Ft < Vt.length && nn.push(vt.substring(Ft, Vt.length)), nn;
        }(ke, K_(ke, Z, C, s, m, he, ye));
        const lt = [], ut = { positionedLines: lt, text: ke.toString(), top: X[1], bottom: X[1], left: X[0], right: X[0], writingMode: ie, iconsInText: !1, verticalizable: !1 };
        return function(vt, Xt, nn, Vt, Ft, Lt, Ut, zt, St, mn, ln, jn) {
          let Zi = 0, ji = wf, Ir = 0, Oo = 0;
          const ss = zt === "right" ? 1 : zt === "left" ? 0 : 0.5;
          let mr = 0;
          for (const vr of Ft) {
            vr.trim();
            const as = vr.getMaxScale(), $s = (as - 1) * Fr, Fs = { positionedGlyphs: [], lineOffset: 0 };
            vt.positionedLines[mr] = Fs;
            const Js = Fs.positionedGlyphs;
            let Qs = 0;
            if (!vr.length()) {
              ji += Lt, ++mr;
              continue;
            }
            for (let ls = 0; ls < vr.length(); ls++) {
              const Gn = vr.getSection(ls), mo = vr.getSectionIndex(ls), cs = vr.getCharCode(ls);
              let Cs = 0, Qo = null, Na = null, Fa = null, _c = Fr;
              const ea = !(St === a.WritingMode.horizontal || !ln && !eu(cs) || ln && (yv[cs] || (Rr = cs, Rt.Arabic(Rr) || Rt["Arabic Supplement"](Rr) || Rt["Arabic Extended-A"](Rr) || Rt["Arabic Presentation Forms-A"](Rr) || Rt["Arabic Presentation Forms-B"](Rr))));
              if (Gn.imageName) {
                const No = Vt[Gn.imageName];
                if (!No) continue;
                Fa = Gn.imageName, vt.iconsInText = vt.iconsInText || !0, Na = No.paddedRect;
                const eo = No.displaySize;
                Gn.scale = Gn.scale * Fr / jn, Qo = { width: eo[0], height: eo[1], left: Ks, top: -3, advance: ea ? eo[1] : eo[0] }, Cs = $s + (Fr - eo[1] * Gn.scale), _c = Qo.advance;
                const bc = ea ? eo[0] * Gn.scale - Fr * as : eo[1] * Gn.scale - Fr * as;
                bc > 0 && bc > Qs && (Qs = bc);
              } else {
                const No = nn[Gn.fontStack], eo = No && No[cs];
                if (eo && eo.rect) Na = eo.rect, Qo = eo.metrics;
                else {
                  const bc = Xt[Gn.fontStack], If = bc && bc[cs];
                  if (!If) continue;
                  Qo = If.metrics;
                }
                Cs = (as - Gn.scale) * Fr;
              }
              ea ? (vt.verticalizable = !0, Js.push({ glyph: cs, imageName: Fa, x: Zi, y: ji + Cs, vertical: ea, scale: Gn.scale, fontStack: Gn.fontStack, sectionIndex: mo, metrics: Qo, rect: Na }), Zi += _c * Gn.scale + mn) : (Js.push({ glyph: cs, imageName: Fa, x: Zi, y: ji + Cs, vertical: ea, scale: Gn.scale, fontStack: Gn.fontStack, sectionIndex: mo, metrics: Qo, rect: Na }), Zi += Qo.advance * Gn.scale + mn);
            }
            Js.length !== 0 && (Ir = Math.max(Zi - mn, Ir), QO(Js, 0, Js.length - 1, ss, Qs)), Zi = 0;
            const sr = Lt * as + Qs;
            Fs.lineOffset = Math.max(Qs, $s), ji += sr, Oo = Math.max(sr, Oo), ++mr;
          }
          var Rr;
          const os = ji - wf, { horizontalAlign: xs, verticalAlign: Xs } = X_(Ut);
          (function(vr, as, $s, Fs, Js, Qs, sr, ls, Gn) {
            const mo = (as - $s) * Js;
            let cs = 0;
            cs = Qs !== sr ? -ls * Fs - wf : (-Fs * Gn + 0.5) * sr;
            for (const Cs of vr) for (const Qo of Cs.positionedGlyphs) Qo.x += mo, Qo.y += cs;
          })(vt.positionedLines, ss, xs, Xs, Ir, Oo, Lt, os, Ft.length), vt.top += -Xs * os, vt.bottom = vt.top + os, vt.left += -xs * Ir, vt.right = vt.left + Ir;
        }(ut, s, u, m, He, k, P, D, ie, Z, ce, Ie), !function(vt) {
          for (const Xt of vt) if (Xt.positionedGlyphs.length !== 0) return !1;
          return !0;
        }(lt) && ut;
      }
      const yv = { 9: !0, 10: !0, 11: !0, 12: !0, 13: !0, 32: !0 }, XO = { 10: !0, 32: !0, 38: !0, 40: !0, 41: !0, 43: !0, 45: !0, 47: !0, 173: !0, 183: !0, 8203: !0, 8208: !0, 8211: !0, 8231: !0 };
      function e2(l, s, u, m, b, C) {
        if (s.imageName) {
          const k = m[s.imageName];
          return k ? k.displaySize[0] * s.scale * Fr / C + b : 0;
        }
        {
          const k = u[s.fontStack], P = k && k[l];
          return P ? P.metrics.advance * s.scale + b : 0;
        }
      }
      function t2(l, s, u, m) {
        const b = Math.pow(l - s, 2);
        return m ? l < s ? b / 2 : 2 * b : b + Math.abs(u) * u;
      }
      function JO(l, s, u) {
        let m = 0;
        return l === 10 && (m -= 1e4), u && (m += 150), l !== 40 && l !== 65288 || (m += 50), s !== 41 && s !== 65289 || (m += 50), m;
      }
      function n2(l, s, u, m, b, C) {
        let k = null, P = t2(s, u, b, C);
        for (const D of m) {
          const Z = t2(s - D.x, u, b, C) + D.badness;
          Z <= P && (k = D, P = Z);
        }
        return { index: l, x: s, priorBreak: k, badness: P };
      }
      function i2(l) {
        return l ? i2(l.priorBreak).concat(l.index) : [];
      }
      function K_(l, s, u, m, b, C, k) {
        if (C !== "point") return [];
        if (!l) return [];
        const P = [], D = function(ce, he, ye, Ie, ke, He) {
          let Qe = 0;
          for (let Be = 0; Be < ce.length(); Be++) {
            const lt = ce.getSection(Be);
            Qe += e2(ce.getCharCode(Be), lt, Ie, ke, he, He);
          }
          return Qe / Math.max(1, Math.ceil(Qe / ye));
        }(l, s, u, m, b, k), Z = l.text.indexOf("​") >= 0;
        let X = 0;
        for (let ce = 0; ce < l.length(); ce++) {
          const he = l.getSection(ce), ye = l.getCharCode(ce);
          if (yv[ye] || (X += e2(ye, he, m, b, s, k)), ce < l.length() - 1) {
            const Ie = !((ie = ye) < 11904 || !(Rt["Bopomofo Extended"](ie) || Rt.Bopomofo(ie) || Rt["CJK Compatibility Forms"](ie) || Rt["CJK Compatibility Ideographs"](ie) || Rt["CJK Compatibility"](ie) || Rt["CJK Radicals Supplement"](ie) || Rt["CJK Strokes"](ie) || Rt["CJK Symbols and Punctuation"](ie) || Rt["CJK Unified Ideographs Extension A"](ie) || Rt["CJK Unified Ideographs"](ie) || Rt["Enclosed CJK Letters and Months"](ie) || Rt["Halfwidth and Fullwidth Forms"](ie) || Rt.Hiragana(ie) || Rt["Ideographic Description Characters"](ie) || Rt["Kangxi Radicals"](ie) || Rt["Katakana Phonetic Extensions"](ie) || Rt.Katakana(ie) || Rt["Vertical Forms"](ie) || Rt["Yi Radicals"](ie) || Rt["Yi Syllables"](ie)));
            (XO[ye] || Ie || he.imageName) && P.push(n2(ce + 1, X, D, P, JO(ye, l.getCharCode(ce + 1), Ie && Z), !1));
          }
        }
        var ie;
        return i2(n2(l.length(), X, D, P, 0, !0));
      }
      function X_(l) {
        let s = 0.5, u = 0.5;
        switch (l) {
          case "right":
          case "top-right":
          case "bottom-right":
            s = 1;
            break;
          case "left":
          case "top-left":
          case "bottom-left":
            s = 0;
        }
        switch (l) {
          case "bottom":
          case "bottom-right":
          case "bottom-left":
            u = 1;
            break;
          case "top":
          case "top-right":
          case "top-left":
            u = 0;
        }
        return { horizontalAlign: s, verticalAlign: u };
      }
      function QO(l, s, u, m, b) {
        if (!m && !b) return;
        const C = l[u], k = (l[u].x + C.metrics.advance * C.scale) * m;
        for (let P = s; P <= u; P++) l[P].x -= k, l[P].y += b;
      }
      function eN(l, s, u) {
        const { horizontalAlign: m, verticalAlign: b } = X_(u), C = s[0] - l.displaySize[0] * m, k = s[1] - l.displaySize[1] * b;
        return { image: l, top: k, bottom: k + l.displaySize[1], left: C, right: C + l.displaySize[0] };
      }
      function r2(l, s, u, m, b, C) {
        const k = l.image;
        let P;
        if (k.content) {
          const ke = k.content, He = k.pixelRatio || 1;
          P = [ke[0] / He, ke[1] / He, k.displaySize[0] - ke[2] / He, k.displaySize[1] - ke[3] / He];
        }
        const D = s.left * C, Z = s.right * C;
        let X, ie, ce, he;
        u === "width" || u === "both" ? (he = b[0] + D - m[3], ie = b[0] + Z + m[1]) : (he = b[0] + (D + Z - k.displaySize[0]) / 2, ie = he + k.displaySize[0]);
        const ye = s.top * C, Ie = s.bottom * C;
        return u === "height" || u === "both" ? (X = b[1] + ye - m[0], ce = b[1] + Ie + m[2]) : (X = b[1] + (ye + Ie - k.displaySize[1]) / 2, ce = X + k.displaySize[1]), { image: k, top: X, right: ie, bottom: ce, left: he, collisionPadding: P };
      }
      const $f = 255, Cl = 128, cu = $f * Cl;
      function s2(l, s) {
        const { expression: u } = s;
        if (u.kind === "constant") return { kind: "constant", layoutSize: u.evaluate(new Ei(l + 1)) };
        if (u.kind === "source") return { kind: "source" };
        {
          const { zoomStops: m, interpolationType: b } = u;
          let C = 0;
          for (; C < m.length && m[C] <= l; ) C++;
          C = Math.max(0, C - 1);
          let k = C;
          for (; k < m.length && m[k] < l + 1; ) k++;
          k = Math.min(m.length - 1, k);
          const P = m[C], D = m[k];
          return u.kind === "composite" ? { kind: "composite", minZoom: P, maxZoom: D, interpolationType: b } : { kind: "camera", minZoom: P, maxZoom: D, minSize: u.evaluate(new Ei(P)), maxSize: u.evaluate(new Ei(D)), interpolationType: b };
        }
      }
      function J_(l, s, u) {
        let m = "never";
        const b = l.get(s);
        return b ? m = b : l.get(u) && (m = "always"), m;
      }
      const tN = au.VectorTileFeature.types, nN = [{ name: "a_fade_opacity", components: 1, type: "Uint8", offset: 0 }];
      function _v(l, s, u, m, b, C, k, P, D, Z, X, ie, ce) {
        const he = P ? Math.min(cu, Math.round(P[0])) : 0, ye = P ? Math.min(cu, Math.round(P[1])) : 0;
        l.emplaceBack(s, u, Math.round(32 * m), Math.round(32 * b), C, k, (he << 1) + (D ? 1 : 0), ye, 16 * Z, 16 * X, 256 * ie, 256 * ce);
      }
      function Q_(l, s, u) {
        l.emplaceBack(s.x, s.y, u), l.emplaceBack(s.x, s.y, u), l.emplaceBack(s.x, s.y, u), l.emplaceBack(s.x, s.y, u);
      }
      function iN(l) {
        for (const s of l.sections) if (bl(s.text)) return !0;
        return !1;
      }
      class eb {
        constructor(s) {
          this.layoutVertexArray = new st(), this.indexArray = new xt(), this.programConfigurations = s, this.segments = new Ot(), this.dynamicLayoutVertexArray = new ht(), this.opacityVertexArray = new wt(), this.hasVisibleVertices = !1, this.placedSymbolArray = new M();
        }
        isEmpty() {
          return this.layoutVertexArray.length === 0 && this.indexArray.length === 0 && this.dynamicLayoutVertexArray.length === 0 && this.opacityVertexArray.length === 0;
        }
        upload(s, u, m, b) {
          this.isEmpty() || (m && (this.layoutVertexBuffer = s.createVertexBuffer(this.layoutVertexArray, DO.members), this.indexBuffer = s.createIndexBuffer(this.indexArray, u), this.dynamicLayoutVertexBuffer = s.createVertexBuffer(this.dynamicLayoutVertexArray, LO.members, !0), this.opacityVertexBuffer = s.createVertexBuffer(this.opacityVertexArray, nN, !0), this.opacityVertexBuffer.itemSize = 1), (m || b) && this.programConfigurations.upload(s));
        }
        destroy() {
          this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy());
        }
      }
      Zt("SymbolBuffers", eb);
      class tb {
        constructor(s, u, m) {
          this.layoutVertexArray = new s(), this.layoutAttributes = u, this.indexArray = new m(), this.segments = new Ot(), this.collisionVertexArray = new Dt();
        }
        upload(s) {
          this.layoutVertexBuffer = s.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = s.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = s.createVertexBuffer(this.collisionVertexArray, OO.members, !0);
        }
        destroy() {
          this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy());
        }
      }
      Zt("CollisionBuffers", tb);
      class yp {
        constructor(s) {
          this.collisionBoxArray = s.collisionBoxArray, this.zoom = s.zoom, this.overscaling = s.overscaling, this.layers = s.layers, this.layerIds = this.layers.map((k) => k.id), this.index = s.index, this.pixelRatio = s.pixelRatio, this.sourceLayerIndex = s.sourceLayerIndex, this.hasPattern = !1, this.hasRTLText = !1, this.sortKeyRanges = [], this.collisionCircleArray = [], this.placementInvProjMatrix = M_([]), this.placementViewportMatrix = M_([]);
          const u = this.layers[0]._unevaluatedLayout._values;
          this.textSizeData = s2(this.zoom, u["text-size"]), this.iconSizeData = s2(this.zoom, u["icon-size"]);
          const m = this.layers[0].layout, b = m.get("symbol-sort-key"), C = m.get("symbol-z-order");
          this.canOverlap = J_(m, "text-overlap", "text-allow-overlap") !== "never" || J_(m, "icon-overlap", "icon-allow-overlap") !== "never" || m.get("text-ignore-placement") || m.get("icon-ignore-placement"), this.sortFeaturesByKey = C !== "viewport-y" && !b.isConstant(), this.sortFeaturesByY = (C === "viewport-y" || C === "auto" && !this.sortFeaturesByKey) && this.canOverlap, m.get("symbol-placement") === "point" && (this.writingModes = m.get("text-writing-mode").map((k) => a.WritingMode[k])), this.stateDependentLayerIds = this.layers.filter((k) => k.isStateDependent()).map((k) => k.id), this.sourceID = s.sourceID;
        }
        createArrays() {
          this.text = new eb(new La(this.layers, this.zoom, (s) => /^text/.test(s))), this.icon = new eb(new La(this.layers, this.zoom, (s) => /^icon/.test(s))), this.glyphOffsetArray = new W(), this.lineVertexArray = new Q(), this.symbolInstances = new R();
        }
        calculateGlyphDependencies(s, u, m, b, C) {
          for (let k = 0; k < s.length; k++) if (u[s.charCodeAt(k)] = !0, (m || b) && C) {
            const P = bf[s.charAt(k)];
            P && (u[P.charCodeAt(0)] = !0);
          }
        }
        populate(s, u, m) {
          const b = this.layers[0], C = b.layout, k = C.get("text-font"), P = C.get("text-field"), D = C.get("icon-image"), Z = (P.value.kind !== "constant" || P.value.value instanceof ar && !P.value.value.isEmpty() || P.value.value.toString().length > 0) && (k.value.kind !== "constant" || k.value.value.length > 0), X = D.value.kind !== "constant" || !!D.value.value || Object.keys(D.parameters).length > 0, ie = C.get("symbol-sort-key");
          if (this.features = [], !Z && !X) return;
          const ce = u.iconDependencies, he = u.glyphDependencies, ye = u.availableImages, Ie = new Ei(this.zoom);
          for (const { feature: ke, id: He, index: Qe, sourceLayerIndex: Be } of s) {
            const lt = b._featureFilter.needGeometry, ut = cd(ke, lt);
            if (!b._featureFilter.filter(Ie, ut, m)) continue;
            let vt, Xt;
            if (lt || (ut.geometry = Oa(ke)), Z) {
              const Vt = b.getValueAndResolveTokens("text-field", ut, m, ye), Ft = ar.factory(Vt);
              iN(Ft) && (this.hasRTLText = !0), (!this.hasRTLText || nu() === "unavailable" || this.hasRTLText && Os.isParsed()) && (vt = FO(Ft, b, ut));
            }
            if (X) {
              const Vt = b.getValueAndResolveTokens("icon-image", ut, m, ye);
              Xt = Vt instanceof ns ? Vt : ns.fromString(Vt);
            }
            if (!vt && !Xt) continue;
            const nn = this.sortFeaturesByKey ? ie.evaluate(ut, {}, m) : void 0;
            if (this.features.push({ id: He, text: vt, icon: Xt, index: Qe, sourceLayerIndex: Be, geometry: ut.geometry, properties: ke.properties, type: tN[ke.type], sortKey: nn }), Xt && (ce[Xt.name] = !0), vt) {
              const Vt = k.evaluate(ut, {}, m).join(","), Ft = C.get("text-rotation-alignment") !== "viewport" && C.get("symbol-placement") !== "point";
              this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(a.WritingMode.vertical) >= 0;
              for (const Lt of vt.sections) if (Lt.image) ce[Lt.image.name] = !0;
              else {
                const Ut = Ao(vt.toString()), zt = Lt.fontStack || Vt, St = he[zt] = he[zt] || {};
                this.calculateGlyphDependencies(Lt.text, St, Ft, this.allowVerticalPlacement, Ut);
              }
            }
          }
          C.get("symbol-placement") === "line" && (this.features = function(ke) {
            const He = {}, Qe = {}, Be = [];
            let lt = 0;
            function ut(Vt) {
              Be.push(ke[Vt]), lt++;
            }
            function vt(Vt, Ft, Lt) {
              const Ut = Qe[Vt];
              return delete Qe[Vt], Qe[Ft] = Ut, Be[Ut].geometry[0].pop(), Be[Ut].geometry[0] = Be[Ut].geometry[0].concat(Lt[0]), Ut;
            }
            function Xt(Vt, Ft, Lt) {
              const Ut = He[Ft];
              return delete He[Ft], He[Vt] = Ut, Be[Ut].geometry[0].shift(), Be[Ut].geometry[0] = Lt[0].concat(Be[Ut].geometry[0]), Ut;
            }
            function nn(Vt, Ft, Lt) {
              const Ut = Lt ? Ft[0][Ft[0].length - 1] : Ft[0][0];
              return `${Vt}:${Ut.x}:${Ut.y}`;
            }
            for (let Vt = 0; Vt < ke.length; Vt++) {
              const Ft = ke[Vt], Lt = Ft.geometry, Ut = Ft.text ? Ft.text.toString() : null;
              if (!Ut) {
                ut(Vt);
                continue;
              }
              const zt = nn(Ut, Lt), St = nn(Ut, Lt, !0);
              if (zt in Qe && St in He && Qe[zt] !== He[St]) {
                const mn = Xt(zt, St, Lt), ln = vt(zt, St, Be[mn].geometry);
                delete He[zt], delete Qe[St], Qe[nn(Ut, Be[ln].geometry, !0)] = ln, Be[mn].geometry = null;
              } else zt in Qe ? vt(zt, St, Lt) : St in He ? Xt(zt, St, Lt) : (ut(Vt), He[zt] = lt - 1, Qe[St] = lt - 1);
            }
            return Be.filter((Vt) => Vt.geometry);
          }(this.features)), this.sortFeaturesByKey && this.features.sort((ke, He) => ke.sortKey - He.sortKey);
        }
        update(s, u, m) {
          this.stateDependentLayers.length && (this.text.programConfigurations.updatePaintArrays(s, u, this.layers, m), this.icon.programConfigurations.updatePaintArrays(s, u, this.layers, m));
        }
        isEmpty() {
          return this.symbolInstances.length === 0 && !this.hasRTLText;
        }
        uploadPending() {
          return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
        }
        upload(s) {
          !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(s), this.iconCollisionBox.upload(s)), this.text.upload(s, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload), this.icon.upload(s, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload), this.uploaded = !0;
        }
        destroyDebugData() {
          this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
        }
        destroy() {
          this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
        }
        addToLineVertexArray(s, u) {
          const m = this.lineVertexArray.length;
          if (s.segment !== void 0) {
            let b = s.dist(u[s.segment + 1]), C = s.dist(u[s.segment]);
            const k = {};
            for (let P = s.segment + 1; P < u.length; P++) k[P] = { x: u[P].x, y: u[P].y, tileUnitDistanceFromAnchor: b }, P < u.length - 1 && (b += u[P + 1].dist(u[P]));
            for (let P = s.segment || 0; P >= 0; P--) k[P] = { x: u[P].x, y: u[P].y, tileUnitDistanceFromAnchor: C }, P > 0 && (C += u[P - 1].dist(u[P]));
            for (let P = 0; P < u.length; P++) {
              const D = k[P];
              this.lineVertexArray.emplaceBack(D.x, D.y, D.tileUnitDistanceFromAnchor);
            }
          }
          return { lineStartIndex: m, lineLength: this.lineVertexArray.length - m };
        }
        addSymbols(s, u, m, b, C, k, P, D, Z, X, ie, ce) {
          const he = s.indexArray, ye = s.layoutVertexArray, Ie = s.segments.prepareSegment(4 * u.length, ye, he, this.canOverlap ? k.sortKey : void 0), ke = this.glyphOffsetArray.length, He = Ie.vertexLength, Qe = this.allowVerticalPlacement && P === a.WritingMode.vertical ? Math.PI / 2 : 0, Be = k.text && k.text.sections;
          for (let lt = 0; lt < u.length; lt++) {
            const { tl: ut, tr: vt, bl: Xt, br: nn, tex: Vt, pixelOffsetTL: Ft, pixelOffsetBR: Lt, minFontScaleX: Ut, minFontScaleY: zt, glyphOffset: St, isSDF: mn, sectionIndex: ln } = u[lt], jn = Ie.vertexLength, Zi = St[1];
            _v(ye, D.x, D.y, ut.x, Zi + ut.y, Vt.x, Vt.y, m, mn, Ft.x, Ft.y, Ut, zt), _v(ye, D.x, D.y, vt.x, Zi + vt.y, Vt.x + Vt.w, Vt.y, m, mn, Lt.x, Ft.y, Ut, zt), _v(ye, D.x, D.y, Xt.x, Zi + Xt.y, Vt.x, Vt.y + Vt.h, m, mn, Ft.x, Lt.y, Ut, zt), _v(ye, D.x, D.y, nn.x, Zi + nn.y, Vt.x + Vt.w, Vt.y + Vt.h, m, mn, Lt.x, Lt.y, Ut, zt), Q_(s.dynamicLayoutVertexArray, D, Qe), he.emplaceBack(jn, jn + 1, jn + 2), he.emplaceBack(jn + 1, jn + 2, jn + 3), Ie.vertexLength += 4, Ie.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(St[0]), lt !== u.length - 1 && ln === u[lt + 1].sectionIndex || s.programConfigurations.populatePaintArrays(ye.length, k, k.index, {}, ce, Be && Be[ln]);
          }
          s.placedSymbolArray.emplaceBack(D.x, D.y, ke, this.glyphOffsetArray.length - ke, He, Z, X, D.segment, m ? m[0] : 0, m ? m[1] : 0, b[0], b[1], P, 0, !1, 0, ie);
        }
        _addCollisionDebugVertex(s, u, m, b, C, k) {
          return u.emplaceBack(0, 0), s.emplaceBack(m.x, m.y, b, C, Math.round(k.x), Math.round(k.y));
        }
        addCollisionDebugVertices(s, u, m, b, C, k, P) {
          const D = C.segments.prepareSegment(4, C.layoutVertexArray, C.indexArray), Z = D.vertexLength, X = C.layoutVertexArray, ie = C.collisionVertexArray, ce = P.anchorX, he = P.anchorY;
          this._addCollisionDebugVertex(X, ie, k, ce, he, new $(s, u)), this._addCollisionDebugVertex(X, ie, k, ce, he, new $(m, u)), this._addCollisionDebugVertex(X, ie, k, ce, he, new $(m, b)), this._addCollisionDebugVertex(X, ie, k, ce, he, new $(s, b)), D.vertexLength += 4;
          const ye = C.indexArray;
          ye.emplaceBack(Z, Z + 1), ye.emplaceBack(Z + 1, Z + 2), ye.emplaceBack(Z + 2, Z + 3), ye.emplaceBack(Z + 3, Z), D.primitiveLength += 4;
        }
        addDebugCollisionBoxes(s, u, m, b) {
          for (let C = s; C < u; C++) {
            const k = this.collisionBoxArray.get(C);
            this.addCollisionDebugVertices(k.x1, k.y1, k.x2, k.y2, b ? this.textCollisionBox : this.iconCollisionBox, k.anchorPoint, m);
          }
        }
        generateCollisionDebugBuffers() {
          this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new tb(Ct, W$.members, Wt), this.iconCollisionBox = new tb(Ct, W$.members, Wt);
          for (let s = 0; s < this.symbolInstances.length; s++) {
            const u = this.symbolInstances.get(s);
            this.addDebugCollisionBoxes(u.textBoxStartIndex, u.textBoxEndIndex, u, !0), this.addDebugCollisionBoxes(u.verticalTextBoxStartIndex, u.verticalTextBoxEndIndex, u, !0), this.addDebugCollisionBoxes(u.iconBoxStartIndex, u.iconBoxEndIndex, u, !1), this.addDebugCollisionBoxes(u.verticalIconBoxStartIndex, u.verticalIconBoxEndIndex, u, !1);
          }
        }
        _deserializeCollisionBoxesForSymbol(s, u, m, b, C, k, P, D, Z) {
          const X = {};
          for (let ie = u; ie < m; ie++) {
            const ce = s.get(ie);
            X.textBox = { x1: ce.x1, y1: ce.y1, x2: ce.x2, y2: ce.y2, anchorPointX: ce.anchorPointX, anchorPointY: ce.anchorPointY }, X.textFeatureIndex = ce.featureIndex;
            break;
          }
          for (let ie = b; ie < C; ie++) {
            const ce = s.get(ie);
            X.verticalTextBox = { x1: ce.x1, y1: ce.y1, x2: ce.x2, y2: ce.y2, anchorPointX: ce.anchorPointX, anchorPointY: ce.anchorPointY }, X.verticalTextFeatureIndex = ce.featureIndex;
            break;
          }
          for (let ie = k; ie < P; ie++) {
            const ce = s.get(ie);
            X.iconBox = { x1: ce.x1, y1: ce.y1, x2: ce.x2, y2: ce.y2, anchorPointX: ce.anchorPointX, anchorPointY: ce.anchorPointY }, X.iconFeatureIndex = ce.featureIndex;
            break;
          }
          for (let ie = D; ie < Z; ie++) {
            const ce = s.get(ie);
            X.verticalIconBox = { x1: ce.x1, y1: ce.y1, x2: ce.x2, y2: ce.y2, anchorPointX: ce.anchorPointX, anchorPointY: ce.anchorPointY }, X.verticalIconFeatureIndex = ce.featureIndex;
            break;
          }
          return X;
        }
        deserializeCollisionBoxes(s) {
          this.collisionArrays = [];
          for (let u = 0; u < this.symbolInstances.length; u++) {
            const m = this.symbolInstances.get(u);
            this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(s, m.textBoxStartIndex, m.textBoxEndIndex, m.verticalTextBoxStartIndex, m.verticalTextBoxEndIndex, m.iconBoxStartIndex, m.iconBoxEndIndex, m.verticalIconBoxStartIndex, m.verticalIconBoxEndIndex));
          }
        }
        hasTextData() {
          return this.text.segments.get().length > 0;
        }
        hasIconData() {
          return this.icon.segments.get().length > 0;
        }
        hasDebugData() {
          return this.textCollisionBox && this.iconCollisionBox;
        }
        hasTextCollisionBoxData() {
          return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
        }
        hasIconCollisionBoxData() {
          return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
        }
        addIndicesForPlacedSymbol(s, u) {
          const m = s.placedSymbolArray.get(u), b = m.vertexStartIndex + 4 * m.numGlyphs;
          for (let C = m.vertexStartIndex; C < b; C += 4) s.indexArray.emplaceBack(C, C + 1, C + 2), s.indexArray.emplaceBack(C + 1, C + 2, C + 3);
        }
        getSortedSymbolIndexes(s) {
          if (this.sortedAngle === s && this.symbolInstanceIndexes !== void 0) return this.symbolInstanceIndexes;
          const u = Math.sin(s), m = Math.cos(s), b = [], C = [], k = [];
          for (let P = 0; P < this.symbolInstances.length; ++P) {
            k.push(P);
            const D = this.symbolInstances.get(P);
            b.push(0 | Math.round(u * D.anchorX + m * D.anchorY)), C.push(D.featureIndex);
          }
          return k.sort((P, D) => b[P] - b[D] || C[D] - C[P]), k;
        }
        addToSortKeyRanges(s, u) {
          const m = this.sortKeyRanges[this.sortKeyRanges.length - 1];
          m && m.sortKey === u ? m.symbolInstanceEnd = s + 1 : this.sortKeyRanges.push({ sortKey: u, symbolInstanceStart: s, symbolInstanceEnd: s + 1 });
        }
        sortFeatures(s) {
          if (this.sortFeaturesByY && this.sortedAngle !== s && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
            this.symbolInstanceIndexes = this.getSortedSymbolIndexes(s), this.sortedAngle = s, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
            for (const u of this.symbolInstanceIndexes) {
              const m = this.symbolInstances.get(u);
              this.featureSortOrder.push(m.featureIndex), [m.rightJustifiedTextSymbolIndex, m.centerJustifiedTextSymbolIndex, m.leftJustifiedTextSymbolIndex].forEach((b, C, k) => {
                b >= 0 && k.indexOf(b) === C && this.addIndicesForPlacedSymbol(this.text, b);
              }), m.verticalPlacedTextSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.text, m.verticalPlacedTextSymbolIndex), m.placedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, m.placedIconSymbolIndex), m.verticalPlacedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, m.verticalPlacedIconSymbolIndex);
            }
            this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
          }
        }
      }
      let o2, a2;
      Zt("SymbolBucket", yp, { omit: ["layers", "collisionBoxArray", "features", "compareText"] }), yp.MAX_GLYPHS = 65535, yp.addDynamicAttributes = Q_;
      var nb = { get paint() {
        return a2 = a2 || new pn({ "icon-opacity": new Ve(Oe.paint_symbol["icon-opacity"]), "icon-color": new Ve(Oe.paint_symbol["icon-color"]), "icon-halo-color": new Ve(Oe.paint_symbol["icon-halo-color"]), "icon-halo-width": new Ve(Oe.paint_symbol["icon-halo-width"]), "icon-halo-blur": new Ve(Oe.paint_symbol["icon-halo-blur"]), "icon-translate": new xe(Oe.paint_symbol["icon-translate"]), "icon-translate-anchor": new xe(Oe.paint_symbol["icon-translate-anchor"]), "text-opacity": new Ve(Oe.paint_symbol["text-opacity"]), "text-color": new Ve(Oe.paint_symbol["text-color"], { runtimeType: Qi, getOverride: (l) => l.textColor, hasOverride: (l) => !!l.textColor }), "text-halo-color": new Ve(Oe.paint_symbol["text-halo-color"]), "text-halo-width": new Ve(Oe.paint_symbol["text-halo-width"]), "text-halo-blur": new Ve(Oe.paint_symbol["text-halo-blur"]), "text-translate": new xe(Oe.paint_symbol["text-translate"]), "text-translate-anchor": new xe(Oe.paint_symbol["text-translate-anchor"]) });
      }, get layout() {
        return o2 = o2 || new pn({ "symbol-placement": new xe(Oe.layout_symbol["symbol-placement"]), "symbol-spacing": new xe(Oe.layout_symbol["symbol-spacing"]), "symbol-avoid-edges": new xe(Oe.layout_symbol["symbol-avoid-edges"]), "symbol-sort-key": new Ve(Oe.layout_symbol["symbol-sort-key"]), "symbol-z-order": new xe(Oe.layout_symbol["symbol-z-order"]), "icon-allow-overlap": new xe(Oe.layout_symbol["icon-allow-overlap"]), "icon-overlap": new xe(Oe.layout_symbol["icon-overlap"]), "icon-ignore-placement": new xe(Oe.layout_symbol["icon-ignore-placement"]), "icon-optional": new xe(Oe.layout_symbol["icon-optional"]), "icon-rotation-alignment": new xe(Oe.layout_symbol["icon-rotation-alignment"]), "icon-size": new Ve(Oe.layout_symbol["icon-size"]), "icon-text-fit": new xe(Oe.layout_symbol["icon-text-fit"]), "icon-text-fit-padding": new xe(Oe.layout_symbol["icon-text-fit-padding"]), "icon-image": new Ve(Oe.layout_symbol["icon-image"]), "icon-rotate": new Ve(Oe.layout_symbol["icon-rotate"]), "icon-padding": new Ve(Oe.layout_symbol["icon-padding"]), "icon-keep-upright": new xe(Oe.layout_symbol["icon-keep-upright"]), "icon-offset": new Ve(Oe.layout_symbol["icon-offset"]), "icon-anchor": new Ve(Oe.layout_symbol["icon-anchor"]), "icon-pitch-alignment": new xe(Oe.layout_symbol["icon-pitch-alignment"]), "text-pitch-alignment": new xe(Oe.layout_symbol["text-pitch-alignment"]), "text-rotation-alignment": new xe(Oe.layout_symbol["text-rotation-alignment"]), "text-field": new Ve(Oe.layout_symbol["text-field"]), "text-font": new Ve(Oe.layout_symbol["text-font"]), "text-size": new Ve(Oe.layout_symbol["text-size"]), "text-max-width": new Ve(Oe.layout_symbol["text-max-width"]), "text-line-height": new xe(Oe.layout_symbol["text-line-height"]), "text-letter-spacing": new Ve(Oe.layout_symbol["text-letter-spacing"]), "text-justify": new Ve(Oe.layout_symbol["text-justify"]), "text-radial-offset": new Ve(Oe.layout_symbol["text-radial-offset"]), "text-variable-anchor": new xe(Oe.layout_symbol["text-variable-anchor"]), "text-anchor": new Ve(Oe.layout_symbol["text-anchor"]), "text-max-angle": new xe(Oe.layout_symbol["text-max-angle"]), "text-writing-mode": new xe(Oe.layout_symbol["text-writing-mode"]), "text-rotate": new Ve(Oe.layout_symbol["text-rotate"]), "text-padding": new xe(Oe.layout_symbol["text-padding"]), "text-keep-upright": new xe(Oe.layout_symbol["text-keep-upright"]), "text-transform": new Ve(Oe.layout_symbol["text-transform"]), "text-offset": new Ve(Oe.layout_symbol["text-offset"]), "text-allow-overlap": new xe(Oe.layout_symbol["text-allow-overlap"]), "text-overlap": new xe(Oe.layout_symbol["text-overlap"]), "text-ignore-placement": new xe(Oe.layout_symbol["text-ignore-placement"]), "text-optional": new xe(Oe.layout_symbol["text-optional"]) });
      } };
      class l2 {
        constructor(s) {
          if (s.property.overrides === void 0) throw new Error("overrides must be provided to instantiate FormatSectionOverride class");
          this.type = s.property.overrides ? s.property.overrides.runtimeType : hs, this.defaultValue = s;
        }
        evaluate(s) {
          if (s.formattedSection) {
            const u = this.defaultValue.property.overrides;
            if (u && u.hasOverride(s.formattedSection)) return u.getOverride(s.formattedSection);
          }
          return s.feature && s.featureState ? this.defaultValue.evaluate(s.feature, s.featureState) : this.defaultValue.property.specification.default;
        }
        eachChild(s) {
          this.defaultValue.isConstant() || s(this.defaultValue.value._styleExpression.expression);
        }
        outputDefined() {
          return !1;
        }
        serialize() {
          return null;
        }
      }
      Zt("FormatSectionOverride", l2, { omit: ["defaultValue"] });
      class bv extends Hi {
        constructor(s) {
          super(s, nb);
        }
        recalculate(s, u) {
          if (super.recalculate(s, u), this.layout.get("icon-rotation-alignment") === "auto" && (this.layout._values["icon-rotation-alignment"] = this.layout.get("symbol-placement") !== "point" ? "map" : "viewport"), this.layout.get("text-rotation-alignment") === "auto" && (this.layout._values["text-rotation-alignment"] = this.layout.get("symbol-placement") !== "point" ? "map" : "viewport"), this.layout.get("text-pitch-alignment") === "auto" && (this.layout._values["text-pitch-alignment"] = this.layout.get("text-rotation-alignment") === "map" ? "map" : "viewport"), this.layout.get("icon-pitch-alignment") === "auto" && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment")), this.layout.get("symbol-placement") === "point") {
            const m = this.layout.get("text-writing-mode");
            if (m) {
              const b = [];
              for (const C of m) b.indexOf(C) < 0 && b.push(C);
              this.layout._values["text-writing-mode"] = b;
            } else this.layout._values["text-writing-mode"] = ["horizontal"];
          }
          this._setPaintOverrides();
        }
        getValueAndResolveTokens(s, u, m, b) {
          const C = this.layout.get(s).evaluate(u, {}, m, b), k = this._unevaluatedLayout._values[s];
          return k.isDataDriven() || lo(k.value) || !C ? C : function(P, D) {
            return D.replace(/{([^{}]+)}/g, (Z, X) => X in P ? String(P[X]) : "");
          }(u.properties, C);
        }
        createBucket(s) {
          return new yp(s);
        }
        queryRadius() {
          return 0;
        }
        queryIntersectsFeature() {
          throw new Error("Should take a different path in FeatureIndex");
        }
        _setPaintOverrides() {
          for (const s of nb.paint.overridableProperties) {
            if (!bv.hasPaintOverride(this.layout, s)) continue;
            const u = this.paint.get(s), m = new l2(u), b = new fl(m, u.property.specification);
            let C = null;
            C = u.value.kind === "constant" || u.value.kind === "source" ? new ka("source", b) : new kn("composite", b, u.value.zoomStops), this.paint._values[s] = new j(u.property, C, u.parameters);
          }
        }
        _handleOverridablePaintPropertyUpdate(s, u, m) {
          return !(!this.layout || u.isDataDriven() || m.isDataDriven()) && bv.hasPaintOverride(this.layout, s);
        }
        static hasPaintOverride(s, u) {
          const m = s.get("text-field"), b = nb.paint.properties[u];
          let C = !1;
          const k = (P) => {
            for (const D of P) if (b.overrides && b.overrides.hasOverride(D)) return void (C = !0);
          };
          if (m.value.kind === "constant" && m.value.value instanceof ar) k(m.value.value.sections);
          else if (m.value.kind === "source") {
            const P = (Z) => {
              C || (Z instanceof Es && Bi(Z.value) === Wr ? k(Z.value.sections) : Z instanceof qc ? k(Z.sections) : Z.eachChild(P));
            }, D = m.value;
            D._styleExpression && P(D._styleExpression.expression);
          }
          return C;
        }
      }
      let c2;
      var rN = { get paint() {
        return c2 = c2 || new pn({ "background-color": new xe(Oe.paint_background["background-color"]), "background-pattern": new $t(Oe.paint_background["background-pattern"]), "background-opacity": new xe(Oe.paint_background["background-opacity"]) });
      } };
      let u2;
      var sN = { get paint() {
        return u2 = u2 || new pn({ "raster-opacity": new xe(Oe.paint_raster["raster-opacity"]), "raster-hue-rotate": new xe(Oe.paint_raster["raster-hue-rotate"]), "raster-brightness-min": new xe(Oe.paint_raster["raster-brightness-min"]), "raster-brightness-max": new xe(Oe.paint_raster["raster-brightness-max"]), "raster-saturation": new xe(Oe.paint_raster["raster-saturation"]), "raster-contrast": new xe(Oe.paint_raster["raster-contrast"]), "raster-resampling": new xe(Oe.paint_raster["raster-resampling"]), "raster-fade-duration": new xe(Oe.paint_raster["raster-fade-duration"]) });
      } };
      class oN extends Hi {
        constructor(s) {
          super(s, {}), this.onAdd = (u) => {
            this.implementation.onAdd && this.implementation.onAdd(u, u.painter.context.gl);
          }, this.onRemove = (u) => {
            this.implementation.onRemove && this.implementation.onRemove(u, u.painter.context.gl);
          }, this.implementation = s;
        }
        is3D() {
          return this.implementation.renderingMode === "3d";
        }
        hasOffscreenPass() {
          return this.implementation.prerender !== void 0;
        }
        recalculate() {
        }
        updateTransitions() {
        }
        hasTransition() {
          return !1;
        }
        serialize() {
          throw new Error("Custom layers cannot be serialized");
        }
      }
      const aN = { circle: class extends Hi {
        constructor(l) {
          super(l, j3);
        }
        createBucket(l) {
          return new A_(l);
        }
        queryRadius(l) {
          const s = l;
          return df("circle-radius", this, s) + df("circle-stroke-width", this, s) + lv(this.paint.get("circle-translate"));
        }
        queryIntersectsFeature(l, s, u, m, b, C, k, P) {
          const D = cv(l, this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), C.angle, k), Z = this.paint.get("circle-radius").evaluate(s, u) + this.paint.get("circle-stroke-width").evaluate(s, u), X = this.paint.get("circle-pitch-alignment") === "map", ie = X ? D : function(he, ye) {
            return he.map((Ie) => b$(Ie, ye));
          }(D, P), ce = X ? Z * k : Z;
          for (const he of m) for (const ye of he) {
            const Ie = X ? ye : b$(ye, P);
            let ke = ce;
            const He = uv([], [ye.x, ye.y, 0, 1], P);
            if (this.paint.get("circle-pitch-scale") === "viewport" && this.paint.get("circle-pitch-alignment") === "map" ? ke *= He[3] / C.cameraToCenterDistance : this.paint.get("circle-pitch-scale") === "map" && this.paint.get("circle-pitch-alignment") === "viewport" && (ke *= C.cameraToCenterDistance / He[3]), H3(ie, Ie, ke)) return !0;
          }
          return !1;
        }
      }, heatmap: class extends Hi {
        createBucket(l) {
          return new w$(l);
        }
        constructor(l) {
          super(l, Y3), this._updateColorRamp();
        }
        _handleSpecialPaintPropertyUpdate(l) {
          l === "heatmap-color" && this._updateColorRamp();
        }
        _updateColorRamp() {
          this.colorRamp = C$({ expression: this._transitionablePaint._values["heatmap-color"].value.expression, evaluationKey: "heatmapDensity", image: this.colorRamp }), this.colorRampTexture = null;
        }
        resize() {
          this.heatmapFbo && (this.heatmapFbo.destroy(), this.heatmapFbo = null);
        }
        queryRadius() {
          return 0;
        }
        queryIntersectsFeature() {
          return !1;
        }
        hasOffscreenPass() {
          return this.paint.get("heatmap-opacity") !== 0 && this.visibility !== "none";
        }
      }, hillshade: class extends Hi {
        constructor(l) {
          super(l, K3);
        }
        hasOffscreenPass() {
          return this.paint.get("hillshade-exaggeration") !== 0 && this.visibility !== "none";
        }
      }, fill: class extends Hi {
        constructor(l) {
          super(l, dO);
        }
        recalculate(l, s) {
          super.recalculate(l, s);
          const u = this.paint._values["fill-outline-color"];
          u.value.kind === "constant" && u.value.value === void 0 && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
        }
        createBucket(l) {
          return new U_(l);
        }
        queryRadius() {
          return lv(this.paint.get("fill-translate"));
        }
        queryIntersectsFeature(l, s, u, m, b, C, k) {
          return f$(cv(l, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), C.angle, k), m);
        }
        isTileClipped() {
          return !0;
        }
      }, "fill-extrusion": class extends Hi {
        constructor(l) {
          super(l, kO);
        }
        createBucket(l) {
          return new W_(l);
        }
        queryRadius() {
          return lv(this.paint.get("fill-extrusion-translate"));
        }
        is3D() {
          return !0;
        }
        queryIntersectsFeature(l, s, u, m, b, C, k, P) {
          const D = cv(l, this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), C.angle, k), Z = this.paint.get("fill-extrusion-height").evaluate(s, u), X = this.paint.get("fill-extrusion-base").evaluate(s, u), ie = function(he, ye, Ie, ke) {
            const He = [];
            for (const Qe of he) {
              const Be = [Qe.x, Qe.y, 0, 1];
              uv(Be, Be, ye), He.push(new $(Be[0] / Be[3], Be[1] / Be[3]));
            }
            return He;
          }(D, P), ce = function(he, ye, Ie, ke) {
            const He = [], Qe = [], Be = ke[8] * ye, lt = ke[9] * ye, ut = ke[10] * ye, vt = ke[11] * ye, Xt = ke[8] * Ie, nn = ke[9] * Ie, Vt = ke[10] * Ie, Ft = ke[11] * Ie;
            for (const Lt of he) {
              const Ut = [], zt = [];
              for (const St of Lt) {
                const mn = St.x, ln = St.y, jn = ke[0] * mn + ke[4] * ln + ke[12], Zi = ke[1] * mn + ke[5] * ln + ke[13], ji = ke[2] * mn + ke[6] * ln + ke[14], Ir = ke[3] * mn + ke[7] * ln + ke[15], Oo = ji + ut, ss = Ir + vt, mr = jn + Xt, Rr = Zi + nn, os = ji + Vt, xs = Ir + Ft, Xs = new $((jn + Be) / ss, (Zi + lt) / ss);
                Xs.z = Oo / ss, Ut.push(Xs);
                const vr = new $(mr / xs, Rr / xs);
                vr.z = os / xs, zt.push(vr);
              }
              He.push(Ut), Qe.push(zt);
            }
            return [He, Qe];
          }(m, X, Z, P);
          return function(he, ye, Ie) {
            let ke = 1 / 0;
            f$(Ie, ye) && (ke = R$(Ie, ye[0]));
            for (let He = 0; He < ye.length; He++) {
              const Qe = ye[He], Be = he[He];
              for (let lt = 0; lt < Qe.length - 1; lt++) {
                const ut = Qe[lt], vt = [ut, Qe[lt + 1], Be[lt + 1], Be[lt], ut];
                h$(Ie, vt) && (ke = Math.min(ke, R$(Ie, vt)));
              }
            }
            return ke !== 1 / 0 && ke;
          }(ce[0], ce[1], ie);
        }
      }, line: class extends Hi {
        constructor(l) {
          super(l, U$), this.gradientVersion = 0, mv || (mv = new MO(U$.paint.properties["line-width"].specification), mv.useIntegerZoom = !0);
        }
        _handleSpecialPaintPropertyUpdate(l) {
          l === "line-gradient" && (this.stepInterpolant = this._transitionablePaint._values["line-gradient"].value.expression._styleExpression.expression instanceof li, this.gradientVersion = (this.gradientVersion + 1) % Number.MAX_SAFE_INTEGER);
        }
        gradientExpression() {
          return this._transitionablePaint._values["line-gradient"].value.expression;
        }
        recalculate(l, s) {
          super.recalculate(l, s), this.paint._values["line-floorwidth"] = mv.possiblyEvaluate(this._transitioningPaint._values["line-width"].value, l);
        }
        createBucket(l) {
          return new Z_(l);
        }
        queryRadius(l) {
          const s = l, u = H$(df("line-width", this, s), df("line-gap-width", this, s)), m = df("line-offset", this, s);
          return u / 2 + Math.abs(m) + lv(this.paint.get("line-translate"));
        }
        queryIntersectsFeature(l, s, u, m, b, C, k) {
          const P = cv(l, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), C.angle, k), D = k / 2 * H$(this.paint.get("line-width").evaluate(s, u), this.paint.get("line-gap-width").evaluate(s, u)), Z = this.paint.get("line-offset").evaluate(s, u);
          return Z && (m = function(X, ie) {
            const ce = [];
            for (let he = 0; he < X.length; he++) {
              const ye = X[he], Ie = [];
              for (let ke = 0; ke < ye.length; ke++) {
                const He = ye[ke - 1], Qe = ye[ke], Be = ye[ke + 1], lt = ke === 0 ? new $(0, 0) : Qe.sub(He)._unit()._perp(), ut = ke === ye.length - 1 ? new $(0, 0) : Be.sub(Qe)._unit()._perp(), vt = lt._add(ut)._unit(), Xt = vt.x * ut.x + vt.y * ut.y;
                Xt !== 0 && vt._mult(1 / Xt), Ie.push(vt._mult(ie)._add(Qe));
              }
              ce.push(Ie);
            }
            return ce;
          }(m, Z * k)), function(X, ie, ce) {
            for (let he = 0; he < ie.length; he++) {
              const ye = ie[he];
              if (X.length >= 3) {
                for (let Ie = 0; Ie < ye.length; Ie++) if (dp(X, ye[Ie])) return !0;
              }
              if (W3(X, ye, ce)) return !0;
            }
            return !1;
          }(P, m, D);
        }
        isTileClipped() {
          return !0;
        }
      }, symbol: bv, background: class extends Hi {
        constructor(l) {
          super(l, rN);
        }
      }, raster: class extends Hi {
        constructor(l) {
          super(l, sN);
        }
      } };
      class lN {
        constructor(s) {
          this._callback = s, this._triggered = !1, typeof MessageChannel < "u" && (this._channel = new MessageChannel(), this._channel.port2.onmessage = () => {
            this._triggered = !1, this._callback();
          });
        }
        trigger() {
          this._triggered || (this._triggered = !0, this._channel ? this._channel.port1.postMessage(!0) : setTimeout(() => {
            this._triggered = !1, this._callback();
          }, 0));
        }
        remove() {
          delete this._channel, this._callback = () => {
          };
        }
      }
      const ib = 63710088e-1;
      class uu {
        constructor(s, u) {
          if (isNaN(s) || isNaN(u)) throw new Error(`Invalid LngLat object: (${s}, ${u})`);
          if (this.lng = +s, this.lat = +u, this.lat > 90 || this.lat < -90) throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
        }
        wrap() {
          return new uu(K(this.lng, -180, 180), this.lat);
        }
        toArray() {
          return [this.lng, this.lat];
        }
        toString() {
          return `LngLat(${this.lng}, ${this.lat})`;
        }
        distanceTo(s) {
          const u = Math.PI / 180, m = this.lat * u, b = s.lat * u, C = Math.sin(m) * Math.sin(b) + Math.cos(m) * Math.cos(b) * Math.cos((s.lng - this.lng) * u);
          return ib * Math.acos(Math.min(C, 1));
        }
        static convert(s) {
          if (s instanceof uu) return s;
          if (Array.isArray(s) && (s.length === 2 || s.length === 3)) return new uu(Number(s[0]), Number(s[1]));
          if (!Array.isArray(s) && typeof s == "object" && s !== null) return new uu(Number("lng" in s ? s.lng : s.lon), Number(s.lat));
          throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
        }
      }
      const d2 = 2 * Math.PI * ib;
      function p2(l) {
        return d2 * Math.cos(l * Math.PI / 180);
      }
      function h2(l) {
        return (180 + l) / 360;
      }
      function f2(l) {
        return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + l * Math.PI / 360))) / 360;
      }
      function m2(l, s) {
        return l / p2(s);
      }
      function rb(l) {
        return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * l) * Math.PI / 180)) - 90;
      }
      class wv {
        constructor(s, u, m = 0) {
          this.x = +s, this.y = +u, this.z = +m;
        }
        static fromLngLat(s, u = 0) {
          const m = uu.convert(s);
          return new wv(h2(m.lng), f2(m.lat), m2(u, m.lat));
        }
        toLngLat() {
          return new uu(360 * this.x - 180, rb(this.y));
        }
        toAltitude() {
          return this.z * p2(rb(this.y));
        }
        meterInMercatorCoordinateUnits() {
          return 1 / d2 * (s = rb(this.y), 1 / Math.cos(s * Math.PI / 180));
          var s;
        }
      }
      function v2(l, s, u) {
        var m = 2 * Math.PI * 6378137 / 256 / Math.pow(2, u);
        return [l * m - 2 * Math.PI * 6378137 / 2, s * m - 2 * Math.PI * 6378137 / 2];
      }
      class sb {
        constructor(s, u, m) {
          if (s < 0 || s > 25 || m < 0 || m >= Math.pow(2, s) || u < 0 || u >= Math.pow(2, s)) throw new Error(`x=${u}, y=${m}, z=${s} outside of bounds. 0<=x<${Math.pow(2, s)}, 0<=y<${Math.pow(2, s)} 0<=z<=25 `);
          this.z = s, this.x = u, this.y = m, this.key = Cf(0, s, s, u, m);
        }
        equals(s) {
          return this.z === s.z && this.x === s.x && this.y === s.y;
        }
        url(s, u, m) {
          const b = (k = this.y, P = this.z, D = v2(256 * (C = this.x), 256 * (k = Math.pow(2, P) - k - 1), P), Z = v2(256 * (C + 1), 256 * (k + 1), P), D[0] + "," + D[1] + "," + Z[0] + "," + Z[1]);
          var C, k, P, D, Z;
          const X = function(ie, ce, he) {
            let ye, Ie = "";
            for (let ke = ie; ke > 0; ke--) ye = 1 << ke - 1, Ie += (ce & ye ? 1 : 0) + (he & ye ? 2 : 0);
            return Ie;
          }(this.z, this.x, this.y);
          return s[(this.x + this.y) % s.length].replace(/{prefix}/g, (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace(/{z}/g, String(this.z)).replace(/{x}/g, String(this.x)).replace(/{y}/g, String(m === "tms" ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace(/{ratio}/g, u > 1 ? "@2x" : "").replace(/{quadkey}/g, X).replace(/{bbox-epsg-3857}/g, b);
        }
        isChildOf(s) {
          const u = this.z - s.z;
          return u > 0 && s.x === this.x >> u && s.y === this.y >> u;
        }
        getTilePoint(s) {
          const u = Math.pow(2, this.z);
          return new $((s.x * u - this.x) * Wi, (s.y * u - this.y) * Wi);
        }
        toString() {
          return `${this.z}/${this.x}/${this.y}`;
        }
      }
      class g2 {
        constructor(s, u) {
          this.wrap = s, this.canonical = u, this.key = Cf(s, u.z, u.z, u.x, u.y);
        }
      }
      class Lo {
        constructor(s, u, m, b, C) {
          if (s < m) throw new Error(`overscaledZ should be >= z; overscaledZ = ${s}; z = ${m}`);
          this.overscaledZ = s, this.wrap = u, this.canonical = new sb(m, +b, +C), this.key = Cf(u, s, m, b, C);
        }
        clone() {
          return new Lo(this.overscaledZ, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y);
        }
        equals(s) {
          return this.overscaledZ === s.overscaledZ && this.wrap === s.wrap && this.canonical.equals(s.canonical);
        }
        scaledTo(s) {
          if (s > this.overscaledZ) throw new Error(`targetZ > this.overscaledZ; targetZ = ${s}; overscaledZ = ${this.overscaledZ}`);
          const u = this.canonical.z - s;
          return s > this.canonical.z ? new Lo(s, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new Lo(s, this.wrap, s, this.canonical.x >> u, this.canonical.y >> u);
        }
        calculateScaledKey(s, u) {
          if (s > this.overscaledZ) throw new Error(`targetZ > this.overscaledZ; targetZ = ${s}; overscaledZ = ${this.overscaledZ}`);
          const m = this.canonical.z - s;
          return s > this.canonical.z ? Cf(this.wrap * +u, s, this.canonical.z, this.canonical.x, this.canonical.y) : Cf(this.wrap * +u, s, s, this.canonical.x >> m, this.canonical.y >> m);
        }
        isChildOf(s) {
          if (s.wrap !== this.wrap) return !1;
          const u = this.canonical.z - s.canonical.z;
          return s.overscaledZ === 0 || s.overscaledZ < this.overscaledZ && s.canonical.x === this.canonical.x >> u && s.canonical.y === this.canonical.y >> u;
        }
        children(s) {
          if (this.overscaledZ >= s) return [new Lo(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)];
          const u = this.canonical.z + 1, m = 2 * this.canonical.x, b = 2 * this.canonical.y;
          return [new Lo(u, this.wrap, u, m, b), new Lo(u, this.wrap, u, m + 1, b), new Lo(u, this.wrap, u, m, b + 1), new Lo(u, this.wrap, u, m + 1, b + 1)];
        }
        isLessThan(s) {
          return this.wrap < s.wrap || !(this.wrap > s.wrap) && (this.overscaledZ < s.overscaledZ || !(this.overscaledZ > s.overscaledZ) && (this.canonical.x < s.canonical.x || !(this.canonical.x > s.canonical.x) && this.canonical.y < s.canonical.y));
        }
        wrapped() {
          return new Lo(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
        }
        unwrapTo(s) {
          return new Lo(this.overscaledZ, s, this.canonical.z, this.canonical.x, this.canonical.y);
        }
        overscaleFactor() {
          return Math.pow(2, this.overscaledZ - this.canonical.z);
        }
        toUnwrapped() {
          return new g2(this.wrap, this.canonical);
        }
        toString() {
          return `${this.overscaledZ}/${this.canonical.x}/${this.canonical.y}`;
        }
        getTilePoint(s) {
          return this.canonical.getTilePoint(new wv(s.x - this.wrap, s.y));
        }
      }
      function Cf(l, s, u, m, b) {
        (l *= 2) < 0 && (l = -1 * l - 1);
        const C = 1 << u;
        return (C * C * l + C * b + m).toString(36) + u.toString(36) + s.toString(36);
      }
      Zt("CanonicalTileID", sb), Zt("OverscaledTileID", Lo, { omit: ["posMatrix"] });
      class y2 {
        constructor(s, u, m) {
          if (this.uid = s, u.height !== u.width) throw new RangeError("DEM tiles must be square");
          if (m && m !== "mapbox" && m !== "terrarium") return void me(`"${m}" is not a valid encoding type. Valid types include "mapbox" and "terrarium".`);
          this.stride = u.height;
          const b = this.dim = u.height - 2;
          this.data = new Uint32Array(u.data.buffer), this.encoding = m || "mapbox";
          for (let C = 0; C < b; C++) this.data[this._idx(-1, C)] = this.data[this._idx(0, C)], this.data[this._idx(b, C)] = this.data[this._idx(b - 1, C)], this.data[this._idx(C, -1)] = this.data[this._idx(C, 0)], this.data[this._idx(C, b)] = this.data[this._idx(C, b - 1)];
          this.data[this._idx(-1, -1)] = this.data[this._idx(0, 0)], this.data[this._idx(b, -1)] = this.data[this._idx(b - 1, 0)], this.data[this._idx(-1, b)] = this.data[this._idx(0, b - 1)], this.data[this._idx(b, b)] = this.data[this._idx(b - 1, b - 1)], this.min = Number.MAX_SAFE_INTEGER, this.max = Number.MIN_SAFE_INTEGER;
          for (let C = 0; C < b; C++) for (let k = 0; k < b; k++) {
            const P = this.get(C, k);
            P > this.max && (this.max = P), P < this.min && (this.min = P);
          }
        }
        get(s, u) {
          const m = new Uint8Array(this.data.buffer), b = 4 * this._idx(s, u);
          return (this.encoding === "terrarium" ? this._unpackTerrarium : this._unpackMapbox)(m[b], m[b + 1], m[b + 2]);
        }
        getUnpackVector() {
          return this.encoding === "terrarium" ? [256, 1, 1 / 256, 32768] : [6553.6, 25.6, 0.1, 1e4];
        }
        _idx(s, u) {
          if (s < -1 || s >= this.dim + 1 || u < -1 || u >= this.dim + 1) throw new RangeError("out of range source coordinates for DEM data");
          return (u + 1) * this.stride + (s + 1);
        }
        _unpackMapbox(s, u, m) {
          return (256 * s * 256 + 256 * u + m) / 10 - 1e4;
        }
        _unpackTerrarium(s, u, m) {
          return 256 * s + u + m / 256 - 32768;
        }
        getPixels() {
          return new Do({ width: this.stride, height: this.stride }, new Uint8Array(this.data.buffer));
        }
        backfillBorder(s, u, m) {
          if (this.dim !== s.dim) throw new Error("dem dimension mismatch");
          let b = u * this.dim, C = u * this.dim + this.dim, k = m * this.dim, P = m * this.dim + this.dim;
          switch (u) {
            case -1:
              b = C - 1;
              break;
            case 1:
              C = b + 1;
          }
          switch (m) {
            case -1:
              k = P - 1;
              break;
            case 1:
              P = k + 1;
          }
          const D = -u * this.dim, Z = -m * this.dim;
          for (let X = k; X < P; X++) for (let ie = b; ie < C; ie++) this.data[this._idx(ie, X)] = s.data[this._idx(ie + D, X + Z)];
        }
      }
      Zt("DEMData", y2);
      class _2 {
        constructor(s) {
          this._stringToNumber = {}, this._numberToString = [];
          for (let u = 0; u < s.length; u++) {
            const m = s[u];
            this._stringToNumber[m] = u, this._numberToString[u] = m;
          }
        }
        encode(s) {
          return this._stringToNumber[s];
        }
        decode(s) {
          if (s >= this._numberToString.length) throw new Error(`Out of bounds. Index requested n=${s} can't be >= this._numberToString.length ${this._numberToString.length}`);
          return this._numberToString[s];
        }
      }
      class b2 {
        constructor(s, u, m, b, C) {
          this.type = "Feature", this._vectorTileFeature = s, s._z = u, s._x = m, s._y = b, this.properties = s.properties, this.id = C;
        }
        get geometry() {
          return this._geometry === void 0 && (this._geometry = this._vectorTileFeature.toGeoJSON(this._vectorTileFeature._x, this._vectorTileFeature._y, this._vectorTileFeature._z).geometry), this._geometry;
        }
        set geometry(s) {
          this._geometry = s;
        }
        toJSON() {
          const s = { geometry: this.geometry };
          for (const u in this) u !== "_geometry" && u !== "_vectorTileFeature" && (s[u] = this[u]);
          return s;
        }
      }
      class w2 {
        constructor(s, u) {
          this.tileID = s, this.x = s.canonical.x, this.y = s.canonical.y, this.z = s.canonical.z, this.grid = new Ko(Wi, 16, 0), this.grid3D = new Ko(Wi, 16, 0), this.featureIndexArray = new fe(), this.promoteId = u;
        }
        insert(s, u, m, b, C, k) {
          const P = this.featureIndexArray.length;
          this.featureIndexArray.emplaceBack(m, b, C);
          const D = k ? this.grid3D : this.grid;
          for (let Z = 0; Z < u.length; Z++) {
            const X = u[Z], ie = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
            for (let ce = 0; ce < X.length; ce++) {
              const he = X[ce];
              ie[0] = Math.min(ie[0], he.x), ie[1] = Math.min(ie[1], he.y), ie[2] = Math.max(ie[2], he.x), ie[3] = Math.max(ie[3], he.y);
            }
            ie[0] < Wi && ie[1] < Wi && ie[2] >= 0 && ie[3] >= 0 && D.insert(P, ie[0], ie[1], ie[2], ie[3]);
          }
        }
        loadVTLayers() {
          return this.vtLayers || (this.vtLayers = new au.VectorTile(new j_(this.rawTileData)).layers, this.sourceLayerCoder = new _2(this.vtLayers ? Object.keys(this.vtLayers).sort() : ["_geojsonTileLayer"])), this.vtLayers;
        }
        query(s, u, m, b) {
          this.loadVTLayers();
          const C = s.params || {}, k = Wi / s.tileSize / s.scale, P = Xu(C.filter), D = s.queryGeometry, Z = s.queryPadding * k, X = $2(D), ie = this.grid.query(X.minX - Z, X.minY - Z, X.maxX + Z, X.maxY + Z), ce = $2(s.cameraQueryGeometry), he = this.grid3D.query(ce.minX - Z, ce.minY - Z, ce.maxX + Z, ce.maxY + Z, (ke, He, Qe, Be) => function(lt, ut, vt, Xt, nn) {
            for (const Ft of lt) if (ut <= Ft.x && vt <= Ft.y && Xt >= Ft.x && nn >= Ft.y) return !0;
            const Vt = [new $(ut, vt), new $(ut, nn), new $(Xt, nn), new $(Xt, vt)];
            if (lt.length > 2) {
              for (const Ft of Vt) if (dp(lt, Ft)) return !0;
            }
            for (let Ft = 0; Ft < lt.length - 1; Ft++) if (q3(lt[Ft], lt[Ft + 1], Vt)) return !0;
            return !1;
          }(s.cameraQueryGeometry, ke - Z, He - Z, Qe + Z, Be + Z));
          for (const ke of he) ie.push(ke);
          ie.sort(cN);
          const ye = {};
          let Ie;
          for (let ke = 0; ke < ie.length; ke++) {
            const He = ie[ke];
            if (He === Ie) continue;
            Ie = He;
            const Qe = this.featureIndexArray.get(He);
            let Be = null;
            this.loadMatchingFeature(ye, Qe.bucketIndex, Qe.sourceLayerIndex, Qe.featureIndex, P, C.layers, C.availableImages, u, m, b, (lt, ut, vt) => (Be || (Be = Oa(lt)), ut.queryIntersectsFeature(D, lt, vt, Be, this.z, s.transform, k, s.pixelPosMatrix)));
          }
          return ye;
        }
        loadMatchingFeature(s, u, m, b, C, k, P, D, Z, X, ie) {
          const ce = this.bucketLayerIDs[u];
          if (k && !function(ke, He) {
            for (let Qe = 0; Qe < ke.length; Qe++) if (He.indexOf(ke[Qe]) >= 0) return !0;
            return !1;
          }(k, ce)) return;
          const he = this.sourceLayerCoder.decode(m), ye = this.vtLayers[he].feature(b);
          if (C.needGeometry) {
            const ke = cd(ye, !0);
            if (!C.filter(new Ei(this.tileID.overscaledZ), ke, this.tileID.canonical)) return;
          } else if (!C.filter(new Ei(this.tileID.overscaledZ), ye)) return;
          const Ie = this.getId(ye, he);
          for (let ke = 0; ke < ce.length; ke++) {
            const He = ce[ke];
            if (k && k.indexOf(He) < 0) continue;
            const Qe = D[He];
            if (!Qe) continue;
            let Be = {};
            Ie && X && (Be = X.getState(Qe.sourceLayer || "_geojsonTileLayer", Ie));
            const lt = U({}, Z[He]);
            lt.paint = x2(lt.paint, Qe.paint, ye, Be, P), lt.layout = x2(lt.layout, Qe.layout, ye, Be, P);
            const ut = !ie || ie(ye, Qe, Be);
            if (!ut) continue;
            const vt = new b2(ye, this.z, this.x, this.y, Ie);
            vt.layer = lt;
            let Xt = s[He];
            Xt === void 0 && (Xt = s[He] = []), Xt.push({ featureIndex: b, feature: vt, intersectionZ: ut });
          }
        }
        lookupSymbolFeatures(s, u, m, b, C, k, P, D) {
          const Z = {};
          this.loadVTLayers();
          const X = Xu(C);
          for (const ie of s) this.loadMatchingFeature(Z, m, b, ie, X, k, P, D, u);
          return Z;
        }
        hasLayer(s) {
          for (const u of this.bucketLayerIDs) for (const m of u) if (s === m) return !0;
          return !1;
        }
        getId(s, u) {
          let m = s.id;
          return this.promoteId && (m = s.properties[typeof this.promoteId == "string" ? this.promoteId : this.promoteId[u]], typeof m == "boolean" && (m = Number(m))), m;
        }
      }
      function x2(l, s, u, m, b) {
        return te(l, (C, k) => {
          const P = s instanceof ge ? s.get(k) : null;
          return P && P.evaluate ? P.evaluate(u, m, b) : P;
        });
      }
      function $2(l) {
        let s = 1 / 0, u = 1 / 0, m = -1 / 0, b = -1 / 0;
        for (const C of l) s = Math.min(s, C.x), u = Math.min(u, C.y), m = Math.max(m, C.x), b = Math.max(b, C.y);
        return { minX: s, minY: u, maxX: m, maxY: b };
      }
      function cN(l, s) {
        return s - l;
      }
      function C2(l, s, u, m, b) {
        const C = [];
        for (let k = 0; k < l.length; k++) {
          const P = l[k];
          let D;
          for (let Z = 0; Z < P.length - 1; Z++) {
            let X = P[Z], ie = P[Z + 1];
            X.x < s && ie.x < s || (X.x < s ? X = new $(s, X.y + (s - X.x) / (ie.x - X.x) * (ie.y - X.y))._round() : ie.x < s && (ie = new $(s, X.y + (s - X.x) / (ie.x - X.x) * (ie.y - X.y))._round()), X.y < u && ie.y < u || (X.y < u ? X = new $(X.x + (u - X.y) / (ie.y - X.y) * (ie.x - X.x), u)._round() : ie.y < u && (ie = new $(X.x + (u - X.y) / (ie.y - X.y) * (ie.x - X.x), u)._round()), X.x >= m && ie.x >= m || (X.x >= m ? X = new $(m, X.y + (m - X.x) / (ie.x - X.x) * (ie.y - X.y))._round() : ie.x >= m && (ie = new $(m, X.y + (m - X.x) / (ie.x - X.x) * (ie.y - X.y))._round()), X.y >= b && ie.y >= b || (X.y >= b ? X = new $(X.x + (b - X.y) / (ie.y - X.y) * (ie.x - X.x), b)._round() : ie.y >= b && (ie = new $(X.x + (b - X.y) / (ie.y - X.y) * (ie.x - X.x), b)._round()), D && X.equals(D[D.length - 1]) || (D = [X], C.push(D)), D.push(ie)))));
          }
        }
        return C;
      }
      Zt("FeatureIndex", w2, { omit: ["rawTileData", "sourceLayerCoder"] });
      class du extends $ {
        constructor(s, u, m, b) {
          super(s, u), this.angle = m, b !== void 0 && (this.segment = b);
        }
        clone() {
          return new du(this.x, this.y, this.angle, this.segment);
        }
      }
      function k2(l, s, u, m, b) {
        if (s.segment === void 0) return !0;
        let C = s, k = s.segment + 1, P = 0;
        for (; P > -u / 2; ) {
          if (k--, k < 0) return !1;
          P -= l[k].dist(C), C = l[k];
        }
        P += l[k].dist(l[k + 1]), k++;
        const D = [];
        let Z = 0;
        for (; P < u / 2; ) {
          const X = l[k], ie = l[k + 1];
          if (!ie) return !1;
          let ce = l[k - 1].angleTo(X) - X.angleTo(ie);
          for (ce = Math.abs((ce + 3 * Math.PI) % (2 * Math.PI) - Math.PI), D.push({ distance: P, angleDelta: ce }), Z += ce; P - D[0].distance > m; ) Z -= D.shift().angleDelta;
          if (Z > b) return !1;
          k++, P += X.dist(ie);
        }
        return !0;
      }
      function S2(l) {
        let s = 0;
        for (let u = 0; u < l.length - 1; u++) s += l[u].dist(l[u + 1]);
        return s;
      }
      function T2(l, s, u) {
        return l ? 0.6 * s * u : 0;
      }
      function I2(l, s) {
        return Math.max(l ? l.right - l.left : 0, s ? s.right - s.left : 0);
      }
      function uN(l, s, u, m, b, C) {
        const k = T2(u, b, C), P = I2(u, m) * C;
        let D = 0;
        const Z = S2(l) / 2;
        for (let X = 0; X < l.length - 1; X++) {
          const ie = l[X], ce = l[X + 1], he = ie.dist(ce);
          if (D + he > Z) {
            const ye = (Z - D) / he, Ie = Gr.number(ie.x, ce.x, ye), ke = Gr.number(ie.y, ce.y, ye), He = new du(Ie, ke, ce.angleTo(ie), X);
            return He._round(), !k || k2(l, He, P, k, s) ? He : void 0;
          }
          D += he;
        }
      }
      function dN(l, s, u, m, b, C, k, P, D) {
        const Z = T2(m, C, k), X = I2(m, b), ie = X * k, ce = l[0].x === 0 || l[0].x === D || l[0].y === 0 || l[0].y === D;
        return s - ie < s / 4 && (s = ie + s / 4), A2(l, ce ? s / 2 * P % s : (X / 2 + 2 * C) * k * P % s, s, Z, u, ie, ce, !1, D);
      }
      function A2(l, s, u, m, b, C, k, P, D) {
        const Z = C / 2, X = S2(l);
        let ie = 0, ce = s - u, he = [];
        for (let ye = 0; ye < l.length - 1; ye++) {
          const Ie = l[ye], ke = l[ye + 1], He = Ie.dist(ke), Qe = ke.angleTo(Ie);
          for (; ce + u < ie + He; ) {
            ce += u;
            const Be = (ce - ie) / He, lt = Gr.number(Ie.x, ke.x, Be), ut = Gr.number(Ie.y, ke.y, Be);
            if (lt >= 0 && lt < D && ut >= 0 && ut < D && ce - Z >= 0 && ce + Z <= X) {
              const vt = new du(lt, ut, Qe, ye);
              vt._round(), m && !k2(l, vt, C, m, b) || he.push(vt);
            }
          }
          ie += He;
        }
        return P || he.length || k || (he = A2(l, ie / 2, u, m, b, C, k, !0, D)), he;
      }
      Zt("Anchor", du);
      const kf = Ks;
      function E2(l, s, u, m) {
        const b = [], C = l.image, k = C.pixelRatio, P = C.paddedRect.w - 2 * kf, D = C.paddedRect.h - 2 * kf, Z = l.right - l.left, X = l.bottom - l.top, ie = C.stretchX || [[0, P]], ce = C.stretchY || [[0, D]], he = (Lt, Ut) => Lt + Ut[1] - Ut[0], ye = ie.reduce(he, 0), Ie = ce.reduce(he, 0), ke = P - ye, He = D - Ie;
        let Qe = 0, Be = ye, lt = 0, ut = Ie, vt = 0, Xt = ke, nn = 0, Vt = He;
        if (C.content && m) {
          const Lt = C.content;
          Qe = xv(ie, 0, Lt[0]), lt = xv(ce, 0, Lt[1]), Be = xv(ie, Lt[0], Lt[2]), ut = xv(ce, Lt[1], Lt[3]), vt = Lt[0] - Qe, nn = Lt[1] - lt, Xt = Lt[2] - Lt[0] - Be, Vt = Lt[3] - Lt[1] - ut;
        }
        const Ft = (Lt, Ut, zt, St) => {
          const mn = $v(Lt.stretch - Qe, Be, Z, l.left), ln = Cv(Lt.fixed - vt, Xt, Lt.stretch, ye), jn = $v(Ut.stretch - lt, ut, X, l.top), Zi = Cv(Ut.fixed - nn, Vt, Ut.stretch, Ie), ji = $v(zt.stretch - Qe, Be, Z, l.left), Ir = Cv(zt.fixed - vt, Xt, zt.stretch, ye), Oo = $v(St.stretch - lt, ut, X, l.top), ss = Cv(St.fixed - nn, Vt, St.stretch, Ie), mr = new $(mn, jn), Rr = new $(ji, jn), os = new $(ji, Oo), xs = new $(mn, Oo), Xs = new $(ln / k, Zi / k), vr = new $(Ir / k, ss / k), as = s * Math.PI / 180;
          if (as) {
            const Js = Math.sin(as), Qs = Math.cos(as), sr = [Qs, -Js, Js, Qs];
            mr._matMult(sr), Rr._matMult(sr), xs._matMult(sr), os._matMult(sr);
          }
          const $s = Lt.stretch + Lt.fixed, Fs = Ut.stretch + Ut.fixed;
          return { tl: mr, tr: Rr, bl: xs, br: os, tex: { x: C.paddedRect.x + kf + $s, y: C.paddedRect.y + kf + Fs, w: zt.stretch + zt.fixed - $s, h: St.stretch + St.fixed - Fs }, writingMode: void 0, glyphOffset: [0, 0], sectionIndex: 0, pixelOffsetTL: Xs, pixelOffsetBR: vr, minFontScaleX: Xt / k / Z, minFontScaleY: Vt / k / X, isSDF: u };
        };
        if (m && (C.stretchX || C.stretchY)) {
          const Lt = P2(ie, ke, ye), Ut = P2(ce, He, Ie);
          for (let zt = 0; zt < Lt.length - 1; zt++) {
            const St = Lt[zt], mn = Lt[zt + 1];
            for (let ln = 0; ln < Ut.length - 1; ln++) b.push(Ft(St, Ut[ln], mn, Ut[ln + 1]));
          }
        } else b.push(Ft({ fixed: 0, stretch: -1 }, { fixed: 0, stretch: -1 }, { fixed: 0, stretch: P + 1 }, { fixed: 0, stretch: D + 1 }));
        return b;
      }
      function xv(l, s, u) {
        let m = 0;
        for (const b of l) m += Math.max(s, Math.min(u, b[1])) - Math.max(s, Math.min(u, b[0]));
        return m;
      }
      function P2(l, s, u) {
        const m = [{ fixed: -1, stretch: 0 }];
        for (const [b, C] of l) {
          const k = m[m.length - 1];
          m.push({ fixed: b - k.stretch, stretch: k.stretch }), m.push({ fixed: b - k.stretch, stretch: k.stretch + (C - b) });
        }
        return m.push({ fixed: s + kf, stretch: u }), m;
      }
      function $v(l, s, u, m) {
        return l / s * u + m;
      }
      function Cv(l, s, u, m) {
        return l - s * u / m;
      }
      class kv {
        constructor(s, u, m, b, C, k, P, D, Z, X) {
          if (this.boxStartIndex = s.length, Z) {
            let ie = k.top, ce = k.bottom;
            const he = k.collisionPadding;
            he && (ie -= he[1], ce += he[3]);
            let ye = ce - ie;
            ye > 0 && (ye = Math.max(10, ye), this.circleDiameter = ye);
          } else {
            let ie = k.top * P - D[0], ce = k.bottom * P + D[2], he = k.left * P - D[3], ye = k.right * P + D[1];
            const Ie = k.collisionPadding;
            if (Ie && (he -= Ie[0] * P, ie -= Ie[1] * P, ye += Ie[2] * P, ce += Ie[3] * P), X) {
              const ke = new $(he, ie), He = new $(ye, ie), Qe = new $(he, ce), Be = new $(ye, ce), lt = X * Math.PI / 180;
              ke._rotate(lt), He._rotate(lt), Qe._rotate(lt), Be._rotate(lt), he = Math.min(ke.x, He.x, Qe.x, Be.x), ye = Math.max(ke.x, He.x, Qe.x, Be.x), ie = Math.min(ke.y, He.y, Qe.y, Be.y), ce = Math.max(ke.y, He.y, Qe.y, Be.y);
            }
            s.emplaceBack(u.x, u.y, he, ie, ye, ce, m, b, C);
          }
          this.boxEndIndex = s.length;
        }
      }
      class pN {
        constructor(s = [], u = hN) {
          if (this.data = s, this.length = this.data.length, this.compare = u, this.length > 0) for (let m = (this.length >> 1) - 1; m >= 0; m--) this._down(m);
        }
        push(s) {
          this.data.push(s), this.length++, this._up(this.length - 1);
        }
        pop() {
          if (this.length === 0) return;
          const s = this.data[0], u = this.data.pop();
          return this.length--, this.length > 0 && (this.data[0] = u, this._down(0)), s;
        }
        peek() {
          return this.data[0];
        }
        _up(s) {
          const { data: u, compare: m } = this, b = u[s];
          for (; s > 0; ) {
            const C = s - 1 >> 1, k = u[C];
            if (m(b, k) >= 0) break;
            u[s] = k, s = C;
          }
          u[s] = b;
        }
        _down(s) {
          const { data: u, compare: m } = this, b = this.length >> 1, C = u[s];
          for (; s < b; ) {
            let k = 1 + (s << 1), P = u[k];
            const D = k + 1;
            if (D < this.length && m(u[D], P) < 0 && (k = D, P = u[D]), m(P, C) >= 0) break;
            u[s] = P, s = k;
          }
          u[s] = C;
        }
      }
      function hN(l, s) {
        return l < s ? -1 : l > s ? 1 : 0;
      }
      function fN(l, s = 1, u = !1) {
        let m = 1 / 0, b = 1 / 0, C = -1 / 0, k = -1 / 0;
        const P = l[0];
        for (let he = 0; he < P.length; he++) {
          const ye = P[he];
          (!he || ye.x < m) && (m = ye.x), (!he || ye.y < b) && (b = ye.y), (!he || ye.x > C) && (C = ye.x), (!he || ye.y > k) && (k = ye.y);
        }
        const D = Math.min(C - m, k - b);
        let Z = D / 2;
        const X = new pN([], mN);
        if (D === 0) return new $(m, b);
        for (let he = m; he < C; he += D) for (let ye = b; ye < k; ye += D) X.push(new _p(he + Z, ye + Z, Z, l));
        let ie = function(he) {
          let ye = 0, Ie = 0, ke = 0;
          const He = he[0];
          for (let Qe = 0, Be = He.length, lt = Be - 1; Qe < Be; lt = Qe++) {
            const ut = He[Qe], vt = He[lt], Xt = ut.x * vt.y - vt.x * ut.y;
            Ie += (ut.x + vt.x) * Xt, ke += (ut.y + vt.y) * Xt, ye += 3 * Xt;
          }
          return new _p(Ie / ye, ke / ye, 0, he);
        }(l), ce = X.length;
        for (; X.length; ) {
          const he = X.pop();
          (he.d > ie.d || !ie.d) && (ie = he, u && console.log("found best %d after %d probes", Math.round(1e4 * he.d) / 1e4, ce)), he.max - ie.d <= s || (Z = he.h / 2, X.push(new _p(he.p.x - Z, he.p.y - Z, Z, l)), X.push(new _p(he.p.x + Z, he.p.y - Z, Z, l)), X.push(new _p(he.p.x - Z, he.p.y + Z, Z, l)), X.push(new _p(he.p.x + Z, he.p.y + Z, Z, l)), ce += 4);
        }
        return u && (console.log(`num probes: ${ce}`), console.log(`best distance: ${ie.d}`)), ie.p;
      }
      function mN(l, s) {
        return s.max - l.max;
      }
      function _p(l, s, u, m) {
        this.p = new $(l, s), this.h = u, this.d = function(b, C) {
          let k = !1, P = 1 / 0;
          for (let D = 0; D < C.length; D++) {
            const Z = C[D];
            for (let X = 0, ie = Z.length, ce = ie - 1; X < ie; ce = X++) {
              const he = Z[X], ye = Z[ce];
              he.y > b.y != ye.y > b.y && b.x < (ye.x - he.x) * (b.y - he.y) / (ye.y - he.y) + he.x && (k = !k), P = Math.min(P, m$(b, he, ye));
            }
          }
          return (k ? 1 : -1) * Math.sqrt(P);
        }(this.p, m), this.max = this.d + this.h * Math.SQRT2;
      }
      const ob = Number.POSITIVE_INFINITY;
      function M2(l, s) {
        return s[1] !== ob ? function(u, m, b) {
          let C = 0, k = 0;
          switch (m = Math.abs(m), b = Math.abs(b), u) {
            case "top-right":
            case "top-left":
            case "top":
              k = b - 7;
              break;
            case "bottom-right":
            case "bottom-left":
            case "bottom":
              k = 7 - b;
          }
          switch (u) {
            case "top-right":
            case "bottom-right":
            case "right":
              C = -m;
              break;
            case "top-left":
            case "bottom-left":
            case "left":
              C = m;
          }
          return [C, k];
        }(l, s[0], s[1]) : function(u, m) {
          let b = 0, C = 0;
          m < 0 && (m = 0);
          const k = m / Math.sqrt(2);
          switch (u) {
            case "top-right":
            case "top-left":
              C = k - 7;
              break;
            case "bottom-right":
            case "bottom-left":
              C = 7 - k;
              break;
            case "bottom":
              C = 7 - m;
              break;
            case "top":
              C = m - 7;
          }
          switch (u) {
            case "top-right":
            case "bottom-right":
              b = -k;
              break;
            case "top-left":
            case "bottom-left":
              b = k;
              break;
            case "left":
              b = m;
              break;
            case "right":
              b = -m;
          }
          return [b, C];
        }(l, s[0]);
      }
      function ab(l) {
        switch (l) {
          case "right":
          case "top-right":
          case "bottom-right":
            return "right";
          case "left":
          case "top-left":
          case "bottom-left":
            return "left";
        }
        return "center";
      }
      function vN(l, s, u, m, b, C, k, P, D, Z, X) {
        let ie = C.textMaxSize.evaluate(s, {});
        ie === void 0 && (ie = k);
        const ce = l.layers[0].layout, he = ce.get("icon-offset").evaluate(s, {}, X), ye = L2(u.horizontal), Ie = k / 24, ke = l.tilePixelRatio * Ie, He = l.tilePixelRatio * ie / 24, Qe = l.tilePixelRatio * P, Be = l.tilePixelRatio * ce.get("symbol-spacing"), lt = ce.get("text-padding") * l.tilePixelRatio, ut = function(St, mn, ln, jn = 1) {
          const Zi = St.get("icon-padding").evaluate(mn, {}, ln), ji = Zi && Zi.values;
          return [ji[0] * jn, ji[1] * jn, ji[2] * jn, ji[3] * jn];
        }(ce, s, X, l.tilePixelRatio), vt = ce.get("text-max-angle") / 180 * Math.PI, Xt = ce.get("text-rotation-alignment") !== "viewport" && ce.get("symbol-placement") !== "point", nn = ce.get("icon-rotation-alignment") === "map" && ce.get("symbol-placement") !== "point", Vt = ce.get("symbol-placement"), Ft = Be / 2, Lt = ce.get("icon-text-fit");
        let Ut;
        m && Lt !== "none" && (l.allowVerticalPlacement && u.vertical && (Ut = r2(m, u.vertical, Lt, ce.get("icon-text-fit-padding"), he, Ie)), ye && (m = r2(m, ye, Lt, ce.get("icon-text-fit-padding"), he, Ie)));
        const zt = (St, mn) => {
          mn.x < 0 || mn.x >= Wi || mn.y < 0 || mn.y >= Wi || function(ln, jn, Zi, ji, Ir, Oo, ss, mr, Rr, os, xs, Xs, vr, as, $s, Fs, Js, Qs, sr, ls, Gn, mo, cs, Cs, Qo) {
            const Na = ln.addToLineVertexArray(jn, Zi);
            let Fa, _c, ea, No, eo = 0, bc = 0, If = 0, R2 = 0, mb = -1, vb = -1;
            const wc = {};
            let z2 = ur(""), gb = 0, yb = 0;
            if (mr._unevaluatedLayout.getValue("text-radial-offset") === void 0 ? [gb, yb] = mr.layout.get("text-offset").evaluate(Gn, {}, Cs).map((to) => to * Fr) : (gb = mr.layout.get("text-radial-offset").evaluate(Gn, {}, Cs) * Fr, yb = ob), ln.allowVerticalPlacement && ji.vertical) {
              const to = mr.layout.get("text-rotate").evaluate(Gn, {}, Cs) + 90;
              ea = new kv(Rr, jn, os, xs, Xs, ji.vertical, vr, as, $s, to), ss && (No = new kv(Rr, jn, os, xs, Xs, ss, Js, Qs, $s, to));
            }
            if (Ir) {
              const to = mr.layout.get("icon-rotate").evaluate(Gn, {}), kl = mr.layout.get("icon-text-fit") !== "none", Af = E2(Ir, to, cs, kl), Ef = ss ? E2(ss, to, cs, kl) : void 0;
              _c = new kv(Rr, jn, os, xs, Xs, Ir, Js, Qs, !1, to), eo = 4 * Af.length;
              const U2 = ln.iconSizeData;
              let dd = null;
              U2.kind === "source" ? (dd = [Cl * mr.layout.get("icon-size").evaluate(Gn, {})], dd[0] > cu && me(`${ln.layerIds[0]}: Value for "icon-size" is >= ${$f}. Reduce your "icon-size".`)) : U2.kind === "composite" && (dd = [Cl * mo.compositeIconSizes[0].evaluate(Gn, {}, Cs), Cl * mo.compositeIconSizes[1].evaluate(Gn, {}, Cs)], (dd[0] > cu || dd[1] > cu) && me(`${ln.layerIds[0]}: Value for "icon-size" is >= ${$f}. Reduce your "icon-size".`)), ln.addSymbols(ln.icon, Af, dd, ls, sr, Gn, a.WritingMode.none, jn, Na.lineStartIndex, Na.lineLength, -1, Cs), mb = ln.icon.placedSymbolArray.length - 1, Ef && (bc = 4 * Ef.length, ln.addSymbols(ln.icon, Ef, dd, ls, sr, Gn, a.WritingMode.vertical, jn, Na.lineStartIndex, Na.lineLength, -1, Cs), vb = ln.icon.placedSymbolArray.length - 1);
            }
            const B2 = Object.keys(ji.horizontal);
            for (const to of B2) {
              const kl = ji.horizontal[to];
              if (!Fa) {
                z2 = ur(kl.text);
                const Ef = mr.layout.get("text-rotate").evaluate(Gn, {}, Cs);
                Fa = new kv(Rr, jn, os, xs, Xs, kl, vr, as, $s, Ef);
              }
              const Af = kl.positionedLines.length === 1;
              if (If += D2(ln, jn, kl, Oo, mr, $s, Gn, Fs, Na, ji.vertical ? a.WritingMode.horizontal : a.WritingMode.horizontalOnly, Af ? B2 : [to], wc, mb, mo, Cs), Af) break;
            }
            ji.vertical && (R2 += D2(ln, jn, ji.vertical, Oo, mr, $s, Gn, Fs, Na, a.WritingMode.vertical, ["vertical"], wc, vb, mo, Cs));
            const _N = Fa ? Fa.boxStartIndex : ln.collisionBoxArray.length, bN = Fa ? Fa.boxEndIndex : ln.collisionBoxArray.length, wN = ea ? ea.boxStartIndex : ln.collisionBoxArray.length, xN = ea ? ea.boxEndIndex : ln.collisionBoxArray.length, $N = _c ? _c.boxStartIndex : ln.collisionBoxArray.length, CN = _c ? _c.boxEndIndex : ln.collisionBoxArray.length, kN = No ? No.boxStartIndex : ln.collisionBoxArray.length, SN = No ? No.boxEndIndex : ln.collisionBoxArray.length;
            let Ra = -1;
            const Tv = (to, kl) => to && to.circleDiameter ? Math.max(to.circleDiameter, kl) : kl;
            Ra = Tv(Fa, Ra), Ra = Tv(ea, Ra), Ra = Tv(_c, Ra), Ra = Tv(No, Ra);
            const V2 = Ra > -1 ? 1 : 0;
            V2 && (Ra *= Qo / Fr), ln.glyphOffsetArray.length >= yp.MAX_GLYPHS && me("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), Gn.sortKey !== void 0 && ln.addToSortKeyRanges(ln.symbolInstances.length, Gn.sortKey), ln.symbolInstances.emplaceBack(jn.x, jn.y, wc.right >= 0 ? wc.right : -1, wc.center >= 0 ? wc.center : -1, wc.left >= 0 ? wc.left : -1, wc.vertical || -1, mb, vb, z2, _N, bN, wN, xN, $N, CN, kN, SN, os, If, R2, eo, bc, V2, 0, vr, gb, yb, Ra);
          }(l, mn, St, u, m, b, Ut, l.layers[0], l.collisionBoxArray, s.index, s.sourceLayerIndex, l.index, ke, [lt, lt, lt, lt], Xt, D, Qe, ut, nn, he, s, C, Z, X, k);
        };
        if (Vt === "line") for (const St of C2(s.geometry, 0, 0, Wi, Wi)) {
          const mn = dN(St, Be, vt, u.vertical || ye, m, 24, He, l.overscaling, Wi);
          for (const ln of mn) ye && gN(l, ye.text, Ft, ln) || zt(St, ln);
        }
        else if (Vt === "line-center") {
          for (const St of s.geometry) if (St.length > 1) {
            const mn = uN(St, vt, u.vertical || ye, m, 24, He);
            mn && zt(St, mn);
          }
        } else if (s.type === "Polygon") for (const St of z_(s.geometry, 0)) {
          const mn = fN(St, 16);
          zt(St[0], new du(mn.x, mn.y, 0));
        }
        else if (s.type === "LineString") for (const St of s.geometry) zt(St, new du(St[0].x, St[0].y, 0));
        else if (s.type === "Point") for (const St of s.geometry) for (const mn of St) zt([mn], new du(mn.x, mn.y, 0));
      }
      function D2(l, s, u, m, b, C, k, P, D, Z, X, ie, ce, he, ye) {
        const Ie = function(Qe, Be, lt, ut, vt, Xt, nn, Vt) {
          const Ft = ut.layout.get("text-rotate").evaluate(Xt, {}) * Math.PI / 180, Lt = [];
          for (const Ut of Be.positionedLines) for (const zt of Ut.positionedGlyphs) {
            if (!zt.rect) continue;
            const St = zt.rect || {};
            let mn = KO + 1, ln = !0, jn = 1, Zi = 0;
            const ji = (vt || Vt) && zt.vertical, Ir = zt.metrics.advance * zt.scale / 2;
            if (Vt && Be.verticalizable && (Zi = Ut.lineOffset / 2 - (zt.imageName ? -(Fr - zt.metrics.width * zt.scale) / 2 : (zt.scale - 1) * Fr)), zt.imageName) {
              const sr = nn[zt.imageName];
              ln = sr.sdf, jn = sr.pixelRatio, mn = Ks / jn;
            }
            const Oo = vt ? [zt.x + Ir, zt.y] : [0, 0];
            let ss = vt ? [0, 0] : [zt.x + Ir + lt[0], zt.y + lt[1] - Zi], mr = [0, 0];
            ji && (mr = ss, ss = [0, 0]);
            const Rr = (zt.metrics.left - mn) * zt.scale - Ir + ss[0], os = (-zt.metrics.top - mn) * zt.scale + ss[1], xs = Rr + St.w * zt.scale / jn, Xs = os + St.h * zt.scale / jn, vr = new $(Rr, os), as = new $(xs, os), $s = new $(Rr, Xs), Fs = new $(xs, Xs);
            if (ji) {
              const sr = new $(-Ir, Ir - wf), ls = -Math.PI / 2, Gn = Fr / 2 - Ir, mo = new $(5 - wf - Gn, -(zt.imageName ? Gn : 0)), cs = new $(...mr);
              vr._rotateAround(ls, sr)._add(mo)._add(cs), as._rotateAround(ls, sr)._add(mo)._add(cs), $s._rotateAround(ls, sr)._add(mo)._add(cs), Fs._rotateAround(ls, sr)._add(mo)._add(cs);
            }
            if (Ft) {
              const sr = Math.sin(Ft), ls = Math.cos(Ft), Gn = [ls, -sr, sr, ls];
              vr._matMult(Gn), as._matMult(Gn), $s._matMult(Gn), Fs._matMult(Gn);
            }
            const Js = new $(0, 0), Qs = new $(0, 0);
            Lt.push({ tl: vr, tr: as, bl: $s, br: Fs, tex: St, writingMode: Be.writingMode, glyphOffset: Oo, sectionIndex: zt.sectionIndex, isSDF: ln, pixelOffsetTL: Js, pixelOffsetBR: Qs, minFontScaleX: 0, minFontScaleY: 0 });
          }
          return Lt;
        }(0, u, P, b, C, k, m, l.allowVerticalPlacement), ke = l.textSizeData;
        let He = null;
        ke.kind === "source" ? (He = [Cl * b.layout.get("text-size").evaluate(k, {})], He[0] > cu && me(`${l.layerIds[0]}: Value for "text-size" is >= ${$f}. Reduce your "text-size".`)) : ke.kind === "composite" && (He = [Cl * he.compositeTextSizes[0].evaluate(k, {}, ye), Cl * he.compositeTextSizes[1].evaluate(k, {}, ye)], (He[0] > cu || He[1] > cu) && me(`${l.layerIds[0]}: Value for "text-size" is >= ${$f}. Reduce your "text-size".`)), l.addSymbols(l.text, Ie, He, P, C, k, Z, s, D.lineStartIndex, D.lineLength, ce, ye);
        for (const Qe of X) ie[Qe] = l.text.placedSymbolArray.length - 1;
        return 4 * Ie.length;
      }
      function L2(l) {
        for (const s in l) return l[s];
        return null;
      }
      function gN(l, s, u, m) {
        const b = l.compareText;
        if (s in b) {
          const C = b[s];
          for (let k = C.length - 1; k >= 0; k--) if (m.dist(C[k]) < u) return !0;
        } else b[s] = [];
        return b[s].push(m), !1;
      }
      const O2 = [Int8Array, Uint8Array, Uint8ClampedArray, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array];
      class lb {
        static from(s) {
          if (!(s instanceof ArrayBuffer)) throw new Error("Data must be an instance of ArrayBuffer.");
          const [u, m] = new Uint8Array(s, 0, 2);
          if (u !== 219) throw new Error("Data does not appear to be in a KDBush format.");
          const b = m >> 4;
          if (b !== 1) throw new Error(`Got v${b} data when expected v1.`);
          const C = O2[15 & m];
          if (!C) throw new Error("Unrecognized array type.");
          const [k] = new Uint16Array(s, 2, 1), [P] = new Uint32Array(s, 4, 1);
          return new lb(P, k, C, s);
        }
        constructor(s, u = 64, m = Float64Array, b) {
          if (isNaN(s) || s < 0) throw new Error(`Unpexpected numItems value: ${s}.`);
          this.numItems = +s, this.nodeSize = Math.min(Math.max(+u, 2), 65535), this.ArrayType = m, this.IndexArrayType = s < 65536 ? Uint16Array : Uint32Array;
          const C = O2.indexOf(this.ArrayType), k = 2 * s * this.ArrayType.BYTES_PER_ELEMENT, P = s * this.IndexArrayType.BYTES_PER_ELEMENT, D = (8 - P % 8) % 8;
          if (C < 0) throw new Error(`Unexpected typed array class: ${m}.`);
          b && b instanceof ArrayBuffer ? (this.data = b, this.ids = new this.IndexArrayType(this.data, 8, s), this.coords = new this.ArrayType(this.data, 8 + P + D, 2 * s), this._pos = 2 * s, this._finished = !0) : (this.data = new ArrayBuffer(8 + k + P + D), this.ids = new this.IndexArrayType(this.data, 8, s), this.coords = new this.ArrayType(this.data, 8 + P + D, 2 * s), this._pos = 0, this._finished = !1, new Uint8Array(this.data, 0, 2).set([219, 16 + C]), new Uint16Array(this.data, 2, 1)[0] = u, new Uint32Array(this.data, 4, 1)[0] = s);
        }
        add(s, u) {
          const m = this._pos >> 1;
          return this.ids[m] = m, this.coords[this._pos++] = s, this.coords[this._pos++] = u, m;
        }
        finish() {
          const s = this._pos >> 1;
          if (s !== this.numItems) throw new Error(`Added ${s} items when expected ${this.numItems}.`);
          return cb(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
        }
        range(s, u, m, b) {
          if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
          const { ids: C, coords: k, nodeSize: P } = this, D = [0, C.length - 1, 0], Z = [];
          for (; D.length; ) {
            const X = D.pop() || 0, ie = D.pop() || 0, ce = D.pop() || 0;
            if (ie - ce <= P) {
              for (let ke = ce; ke <= ie; ke++) {
                const He = k[2 * ke], Qe = k[2 * ke + 1];
                He >= s && He <= m && Qe >= u && Qe <= b && Z.push(C[ke]);
              }
              continue;
            }
            const he = ce + ie >> 1, ye = k[2 * he], Ie = k[2 * he + 1];
            ye >= s && ye <= m && Ie >= u && Ie <= b && Z.push(C[he]), (X === 0 ? s <= ye : u <= Ie) && (D.push(ce), D.push(he - 1), D.push(1 - X)), (X === 0 ? m >= ye : b >= Ie) && (D.push(he + 1), D.push(ie), D.push(1 - X));
          }
          return Z;
        }
        within(s, u, m) {
          if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
          const { ids: b, coords: C, nodeSize: k } = this, P = [0, b.length - 1, 0], D = [], Z = m * m;
          for (; P.length; ) {
            const X = P.pop() || 0, ie = P.pop() || 0, ce = P.pop() || 0;
            if (ie - ce <= k) {
              for (let ke = ce; ke <= ie; ke++) F2(C[2 * ke], C[2 * ke + 1], s, u) <= Z && D.push(b[ke]);
              continue;
            }
            const he = ce + ie >> 1, ye = C[2 * he], Ie = C[2 * he + 1];
            F2(ye, Ie, s, u) <= Z && D.push(b[he]), (X === 0 ? s - m <= ye : u - m <= Ie) && (P.push(ce), P.push(he - 1), P.push(1 - X)), (X === 0 ? s + m >= ye : u + m >= Ie) && (P.push(he + 1), P.push(ie), P.push(1 - X));
          }
          return D;
        }
      }
      function cb(l, s, u, m, b, C) {
        if (b - m <= u) return;
        const k = m + b >> 1;
        N2(l, s, k, m, b, C), cb(l, s, u, m, k - 1, 1 - C), cb(l, s, u, k + 1, b, 1 - C);
      }
      function N2(l, s, u, m, b, C) {
        for (; b > m; ) {
          if (b - m > 600) {
            const Z = b - m + 1, X = u - m + 1, ie = Math.log(Z), ce = 0.5 * Math.exp(2 * ie / 3), he = 0.5 * Math.sqrt(ie * ce * (Z - ce) / Z) * (X - Z / 2 < 0 ? -1 : 1);
            N2(l, s, u, Math.max(m, Math.floor(u - X * ce / Z + he)), Math.min(b, Math.floor(u + (Z - X) * ce / Z + he)), C);
          }
          const k = s[2 * u + C];
          let P = m, D = b;
          for (Sf(l, s, m, u), s[2 * b + C] > k && Sf(l, s, m, b); P < D; ) {
            for (Sf(l, s, P, D), P++, D--; s[2 * P + C] < k; ) P++;
            for (; s[2 * D + C] > k; ) D--;
          }
          s[2 * m + C] === k ? Sf(l, s, m, D) : (D++, Sf(l, s, D, b)), D <= u && (m = D + 1), u <= D && (b = D - 1);
        }
      }
      function Sf(l, s, u, m) {
        ub(l, u, m), ub(s, 2 * u, 2 * m), ub(s, 2 * u + 1, 2 * m + 1);
      }
      function ub(l, s, u) {
        const m = l[s];
        l[s] = l[u], l[u] = m;
      }
      function F2(l, s, u, m) {
        const b = l - u, C = s - m;
        return b * b + C * C;
      }
      var db;
      a.PerformanceMarkers = void 0, (db = a.PerformanceMarkers || (a.PerformanceMarkers = {})).create = "create", db.load = "load", db.fullLoad = "fullLoad";
      let Sv = null, Tf = [];
      const pb = 1e3 / 60, hb = "loadTime", fb = "fullLoadTime", yN = { mark(l) {
        performance.mark(l);
      }, frame(l) {
        const s = l;
        Sv != null && Tf.push(s - Sv), Sv = s;
      }, clearMetrics() {
        Sv = null, Tf = [], performance.clearMeasures(hb), performance.clearMeasures(fb);
        for (const l in a.PerformanceMarkers) performance.clearMarks(a.PerformanceMarkers[l]);
      }, getPerformanceMetrics() {
        performance.measure(hb, a.PerformanceMarkers.create, a.PerformanceMarkers.load), performance.measure(fb, a.PerformanceMarkers.create, a.PerformanceMarkers.fullLoad);
        const l = performance.getEntriesByName(hb)[0].duration, s = performance.getEntriesByName(fb)[0].duration, u = Tf.length, m = 1 / (Tf.reduce((C, k) => C + k, 0) / u / 1e3), b = Tf.filter((C) => C > pb).reduce((C, k) => C + (k - pb) / pb, 0);
        return { loadTime: l, fullLoadTime: s, fps: m, percentDroppedFrames: b / (u + b) * 100, totalFrames: u };
      } };
      a.AJAXError = gt, a.ARRAY_TYPE = pp, a.Actor = class {
        constructor(l, s, u) {
          this.target = l, this.parent = s, this.mapId = u, this.callbacks = {}, this.tasks = {}, this.taskQueue = [], this.cancelCallbacks = {}, ee(["receive", "process"], this), this.invoker = new lN(this.process), this.target.addEventListener("message", this.receive, !1), this.globalScope = le() ? l : window;
        }
        send(l, s, u, m, b = !1) {
          const C = Math.round(1e18 * Math.random()).toString(36).substring(0, 10);
          u && (this.callbacks[C] = u);
          const k = Ne(this.globalScope) ? void 0 : [];
          return this.target.postMessage({ id: C, type: l, hasCallback: !!u, targetMapId: m, mustQueue: b, sourceMapId: this.mapId, data: yl(s, k) }, k), { cancel: () => {
            u && delete this.callbacks[C], this.target.postMessage({ id: C, type: "<cancel>", targetMapId: m, sourceMapId: this.mapId });
          } };
        }
        receive(l) {
          const s = l.data, u = s.id;
          if (u && (!s.targetMapId || this.mapId === s.targetMapId)) if (s.type === "<cancel>") {
            delete this.tasks[u];
            const m = this.cancelCallbacks[u];
            delete this.cancelCallbacks[u], m && m();
          } else le() || s.mustQueue ? (this.tasks[u] = s, this.taskQueue.push(u), this.invoker.trigger()) : this.processTask(u, s);
        }
        process() {
          if (!this.taskQueue.length) return;
          const l = this.taskQueue.shift(), s = this.tasks[l];
          delete this.tasks[l], this.taskQueue.length && this.invoker.trigger(), s && this.processTask(l, s);
        }
        processTask(l, s) {
          if (s.type === "<response>") {
            const u = this.callbacks[l];
            delete this.callbacks[l], u && (s.error ? u(Io(s.error)) : u(null, Io(s.data)));
          } else {
            let u = !1;
            const m = Ne(this.globalScope) ? void 0 : [], b = s.hasCallback ? (P, D) => {
              u = !0, delete this.cancelCallbacks[l], this.target.postMessage({ id: l, type: "<response>", sourceMapId: this.mapId, error: P ? yl(P) : null, data: yl(D, m) }, m);
            } : (P) => {
              u = !0;
            };
            let C = null;
            const k = Io(s.data);
            if (this.parent[s.type]) C = this.parent[s.type](s.sourceMapId, k, b);
            else if (this.parent.getWorkerSource) {
              const P = s.type.split(".");
              C = this.parent.getWorkerSource(s.sourceMapId, P[0], k.source)[P[1]](k, b);
            } else b(new Error(`Could not find function ${s.type}`));
            !u && C && C.cancel && (this.cancelCallbacks[l] = C.cancel);
          }
        }
        remove() {
          this.invoker.remove(), this.target.removeEventListener("message", this.receive, !1);
        }
      }, a.AlphaImage = hf, a.CanonicalTileID = sb, a.CollisionBoxArray = w, a.CollisionCircleLayoutArray = class extends ou {
      }, a.Color = _n, a.DEMData = y2, a.DataConstantProperty = xe, a.DictionaryCoder = _2, a.EXTENT = Wi, a.ErrorEvent = bt, a.EvaluationParameters = Ei, a.Event = dt, a.Evented = qt, a.FeatureIndex = w2, a.FillBucket = U_, a.FillExtrusionBucket = W_, a.GeoJSONFeature = b2, a.ImageAtlas = Q$, a.ImagePosition = Y_, a.KDBush = lb, a.LineBucket = Z_, a.LineStripIndexArray = class extends o {
      }, a.LngLat = uu, a.MercatorCoordinate = wv, a.ONE_EM = Fr, a.OverscaledTileID = Lo, a.PerformanceUtils = yN, a.Point = $, a.Pos3dArray = class extends iu {
      }, a.PosArray = Se, a.Properties = pn, a.Protobuf = j_, a.QuadTriangleArray = class extends op {
      }, a.RGBAImage = Do, a.RasterBoundsArray = class extends ru {
      }, a.RequestPerformance = class {
        constructor(l) {
          this._marks = { start: [l.url, "start"].join("#"), end: [l.url, "end"].join("#"), measure: l.url.toString() }, performance.mark(this._marks.start);
        }
        finish() {
          performance.mark(this._marks.end);
          let l = performance.getEntriesByName(this._marks.measure);
          return l.length === 0 && (performance.measure(this._marks.measure, this._marks.start, this._marks.end), l = performance.getEntriesByName(this._marks.measure), performance.clearMarks(this._marks.start), performance.clearMarks(this._marks.end), performance.clearMeasures(this._marks.measure)), l;
        }
      }, a.SegmentVector = Ot, a.SymbolBucket = yp, a.Transitionable = p, a.TriangleIndexArray = xt, a.Uniform1f = Jo, a.Uniform1i = class extends ws {
        constructor(l, s) {
          super(l, s), this.current = 0;
        }
        set(l) {
          this.current !== l && (this.current = l, this.gl.uniform1i(this.location, l));
        }
      }, a.Uniform2f = class extends ws {
        constructor(l, s) {
          super(l, s), this.current = [0, 0];
        }
        set(l) {
          l[0] === this.current[0] && l[1] === this.current[1] || (this.current = l, this.gl.uniform2f(this.location, l[0], l[1]));
        }
      }, a.Uniform3f = class extends ws {
        constructor(l, s) {
          super(l, s), this.current = [0, 0, 0];
        }
        set(l) {
          l[0] === this.current[0] && l[1] === this.current[1] && l[2] === this.current[2] || (this.current = l, this.gl.uniform3f(this.location, l[0], l[1], l[2]));
        }
      }, a.Uniform4f = ad, a.UniformColor = rs, a.UniformMatrix4f = class extends ws {
        constructor(l, s) {
          super(l, s), this.current = Or;
        }
        set(l) {
          if (l[12] !== this.current[12] || l[0] !== this.current[0]) return this.current = l, void this.gl.uniformMatrix4fv(this.location, !1, l);
          for (let s = 1; s < 16; s++) if (l[s] !== this.current[s]) {
            this.current = l, this.gl.uniformMatrix4fv(this.location, !1, l);
            break;
          }
        }
      }, a.UnwrappedTileID = g2, a.ValidationError = kt, a.ZoomHistory = _l, a.addDynamicAttributes = Q_, a.arrayBufferToImage = function(l, s) {
        const u = new Image();
        u.onload = () => {
          s(null, u), URL.revokeObjectURL(u.src), u.onload = null, window.requestAnimationFrame(() => {
            u.src = Ge;
          });
        }, u.onerror = () => s(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
        const m = new Blob([new Uint8Array(l)], { type: "image/png" });
        u.src = l.byteLength ? URL.createObjectURL(m) : Ge;
      }, a.arrayBufferToImageBitmap = function(l, s) {
        const u = new Blob([new Uint8Array(l)], { type: "image/png" });
        createImageBitmap(u).then((m) => {
          s(null, m);
        }).catch((m) => {
          s(new Error(`Could not load image because of ${m.message}. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`));
        });
      }, a.asyncAll = function(l, s, u) {
        if (!l.length) return u(null, []);
        let m = l.length;
        const b = new Array(l.length);
        let C = null;
        l.forEach((k, P) => {
          s(k, (D, Z) => {
            D && (C = D), b[P] = Z, --m == 0 && u(C, b);
          });
        });
      }, a.bezier = B, a.bindAll = ee, a.clamp = N, a.clipLine = C2, a.clone = function(l) {
        var s = new pp(16);
        return s[0] = l[0], s[1] = l[1], s[2] = l[2], s[3] = l[3], s[4] = l[4], s[5] = l[5], s[6] = l[6], s[7] = l[7], s[8] = l[8], s[9] = l[9], s[10] = l[10], s[11] = l[11], s[12] = l[12], s[13] = l[13], s[14] = l[14], s[15] = l[15], s;
      }, a.clone$1 = oe, a.collisionCircleLayout = NO, a.config = Ke, a.copy = function(l, s) {
        return l[0] = s[0], l[1] = s[1], l[2] = s[2], l[3] = s[3], l[4] = s[4], l[5] = s[5], l[6] = s[6], l[7] = s[7], l[8] = s[8], l[9] = s[9], l[10] = s[10], l[11] = s[11], l[12] = s[12], l[13] = s[13], l[14] = s[14], l[15] = s[15], l;
      }, a.create = function() {
        var l = new pp(16);
        return pp != Float32Array && (l[1] = 0, l[2] = 0, l[3] = 0, l[4] = 0, l[6] = 0, l[7] = 0, l[8] = 0, l[9] = 0, l[11] = 0, l[12] = 0, l[13] = 0, l[14] = 0), l[0] = 1, l[5] = 1, l[10] = 1, l[15] = 1, l;
      }, a.createExpression = Ui, a.createFilter = Xu, a.createLayout = Ri, a.createStyleLayer = function(l) {
        return l.type === "custom" ? new oN(l) : new aN[l.type](l);
      }, a.deepEqual = function l(s, u) {
        if (Array.isArray(s)) {
          if (!Array.isArray(u) || s.length !== u.length) return !1;
          for (let m = 0; m < s.length; m++) if (!l(s[m], u[m])) return !1;
          return !0;
        }
        if (typeof s == "object" && s !== null && u !== null) {
          if (typeof u != "object" || Object.keys(s).length !== Object.keys(u).length) return !1;
          for (const m in s) if (!l(s[m], u[m])) return !1;
          return !0;
        }
        return s === u;
      }, a.derefLayers = function(l) {
        l = l.slice();
        const s = /* @__PURE__ */ Object.create(null);
        for (let u = 0; u < l.length; u++) s[l[u].id] = l[u];
        for (let u = 0; u < l.length; u++) "ref" in l[u] && (l[u] = Tn(l[u], s[l[u].ref]));
        return l;
      }, a.diffStyles = function(l, s) {
        if (!l) return [{ command: Ht.setStyle, args: [s] }];
        let u = [];
        try {
          if (!hn(l.version, s.version)) return [{ command: Ht.setStyle, args: [s] }];
          hn(l.center, s.center) || u.push({ command: Ht.setCenter, args: [s.center] }), hn(l.zoom, s.zoom) || u.push({ command: Ht.setZoom, args: [s.zoom] }), hn(l.bearing, s.bearing) || u.push({ command: Ht.setBearing, args: [s.bearing] }), hn(l.pitch, s.pitch) || u.push({ command: Ht.setPitch, args: [s.pitch] }), hn(l.sprite, s.sprite) || u.push({ command: Ht.setSprite, args: [s.sprite] }), hn(l.glyphs, s.glyphs) || u.push({ command: Ht.setGlyphs, args: [s.glyphs] }), hn(l.transition, s.transition) || u.push({ command: Ht.setTransition, args: [s.transition] }), hn(l.light, s.light) || u.push({ command: Ht.setLight, args: [s.light] });
          const m = {}, b = [];
          (function(k, P, D, Z) {
            let X;
            for (X in P = P || {}, k = k || {}) Object.prototype.hasOwnProperty.call(k, X) && (Object.prototype.hasOwnProperty.call(P, X) || vi(X, D, Z));
            for (X in P) Object.prototype.hasOwnProperty.call(P, X) && (Object.prototype.hasOwnProperty.call(k, X) ? hn(k[X], P[X]) || (k[X].type === "geojson" && P[X].type === "geojson" && wn(k, P, X) ? D.push({ command: Ht.setGeoJSONSourceData, args: [X, P[X].data] }) : It(X, P, D, Z)) : qn(X, P, D));
          })(l.sources, s.sources, b, m);
          const C = [];
          l.layers && l.layers.forEach((k) => {
            m[k.source] ? u.push({ command: Ht.removeLayer, args: [k.id] }) : C.push(k);
          }), u = u.concat(b), function(k, P, D) {
            P = P || [];
            const Z = (k = k || []).map(hr), X = P.map(hr), ie = k.reduce(qi, {}), ce = P.reduce(qi, {}), he = Z.slice(), ye = /* @__PURE__ */ Object.create(null);
            let Ie, ke, He, Qe, Be, lt, ut;
            for (Ie = 0, ke = 0; Ie < Z.length; Ie++) He = Z[Ie], Object.prototype.hasOwnProperty.call(ce, He) ? ke++ : (D.push({ command: Ht.removeLayer, args: [He] }), he.splice(he.indexOf(He, ke), 1));
            for (Ie = 0, ke = 0; Ie < X.length; Ie++) He = X[X.length - 1 - Ie], he[he.length - 1 - Ie] !== He && (Object.prototype.hasOwnProperty.call(ie, He) ? (D.push({ command: Ht.removeLayer, args: [He] }), he.splice(he.lastIndexOf(He, he.length - ke), 1)) : ke++, lt = he[he.length - Ie], D.push({ command: Ht.addLayer, args: [ce[He], lt] }), he.splice(he.length - Ie, 0, He), ye[He] = !0);
            for (Ie = 0; Ie < X.length; Ie++) if (He = X[Ie], Qe = ie[He], Be = ce[He], !ye[He] && !hn(Qe, Be)) if (hn(Qe.source, Be.source) && hn(Qe["source-layer"], Be["source-layer"]) && hn(Qe.type, Be.type)) {
              for (ut in Oi(Qe.layout, Be.layout, D, He, null, Ht.setLayoutProperty), Oi(Qe.paint, Be.paint, D, He, null, Ht.setPaintProperty), hn(Qe.filter, Be.filter) || D.push({ command: Ht.setFilter, args: [He, Be.filter] }), hn(Qe.minzoom, Be.minzoom) && hn(Qe.maxzoom, Be.maxzoom) || D.push({ command: Ht.setLayerZoomRange, args: [He, Be.minzoom, Be.maxzoom] }), Qe) Object.prototype.hasOwnProperty.call(Qe, ut) && ut !== "layout" && ut !== "paint" && ut !== "filter" && ut !== "metadata" && ut !== "minzoom" && ut !== "maxzoom" && (ut.indexOf("paint.") === 0 ? Oi(Qe[ut], Be[ut], D, He, ut.slice(6), Ht.setPaintProperty) : hn(Qe[ut], Be[ut]) || D.push({ command: Ht.setLayerProperty, args: [He, ut, Be[ut]] }));
              for (ut in Be) Object.prototype.hasOwnProperty.call(Be, ut) && !Object.prototype.hasOwnProperty.call(Qe, ut) && ut !== "layout" && ut !== "paint" && ut !== "filter" && ut !== "metadata" && ut !== "minzoom" && ut !== "maxzoom" && (ut.indexOf("paint.") === 0 ? Oi(Qe[ut], Be[ut], D, He, ut.slice(6), Ht.setPaintProperty) : hn(Qe[ut], Be[ut]) || D.push({ command: Ht.setLayerProperty, args: [He, ut, Be[ut]] }));
            } else D.push({ command: Ht.removeLayer, args: [He] }), lt = he[he.lastIndexOf(He) + 1], D.push({ command: Ht.addLayer, args: [Be, lt] });
          }(C, s.layers, u);
        } catch (m) {
          console.warn("Unable to compute style diff:", m), u = [{ command: Ht.setStyle, args: [s] }];
        }
        return u;
      }, a.dot = function(l, s) {
        return l[0] * s[0] + l[1] * s[1] + l[2] * s[2] + l[3] * s[3];
      }, a.earthRadius = ib, a.ease = H, a.emitValidationErrors = Xr, a.emptyStyle = function() {
        const l = {}, s = Oe.$version;
        for (const u in Oe.$root) {
          const m = Oe.$root[u];
          if (m.required) {
            let b = null;
            b = u === "version" ? s : m.type === "array" ? [] : {}, b != null && (l[u] = b);
          }
        }
        return l;
      }, a.equals = function(l, s) {
        var u = l[0], m = l[1], b = l[2], C = l[3], k = l[4], P = l[5], D = l[6], Z = l[7], X = l[8], ie = l[9], ce = l[10], he = l[11], ye = l[12], Ie = l[13], ke = l[14], He = l[15], Qe = s[0], Be = s[1], lt = s[2], ut = s[3], vt = s[4], Xt = s[5], nn = s[6], Vt = s[7], Ft = s[8], Lt = s[9], Ut = s[10], zt = s[11], St = s[12], mn = s[13], ln = s[14], jn = s[15];
        return Math.abs(u - Qe) <= Ns * Math.max(1, Math.abs(u), Math.abs(Qe)) && Math.abs(m - Be) <= Ns * Math.max(1, Math.abs(m), Math.abs(Be)) && Math.abs(b - lt) <= Ns * Math.max(1, Math.abs(b), Math.abs(lt)) && Math.abs(C - ut) <= Ns * Math.max(1, Math.abs(C), Math.abs(ut)) && Math.abs(k - vt) <= Ns * Math.max(1, Math.abs(k), Math.abs(vt)) && Math.abs(P - Xt) <= Ns * Math.max(1, Math.abs(P), Math.abs(Xt)) && Math.abs(D - nn) <= Ns * Math.max(1, Math.abs(D), Math.abs(nn)) && Math.abs(Z - Vt) <= Ns * Math.max(1, Math.abs(Z), Math.abs(Vt)) && Math.abs(X - Ft) <= Ns * Math.max(1, Math.abs(X), Math.abs(Ft)) && Math.abs(ie - Lt) <= Ns * Math.max(1, Math.abs(ie), Math.abs(Lt)) && Math.abs(ce - Ut) <= Ns * Math.max(1, Math.abs(ce), Math.abs(Ut)) && Math.abs(he - zt) <= Ns * Math.max(1, Math.abs(he), Math.abs(zt)) && Math.abs(ye - St) <= Ns * Math.max(1, Math.abs(ye), Math.abs(St)) && Math.abs(Ie - mn) <= Ns * Math.max(1, Math.abs(Ie), Math.abs(mn)) && Math.abs(ke - ln) <= Ns * Math.max(1, Math.abs(ke), Math.abs(ln)) && Math.abs(He - jn) <= Ns * Math.max(1, Math.abs(He), Math.abs(jn));
      }, a.evaluateSizeForFeature = function(l, { uSize: s, uSizeT: u }, { lowerSize: m, upperSize: b }) {
        return l.kind === "source" ? m / Cl : l.kind === "composite" ? Gr.number(m / Cl, b / Cl, u) : s;
      }, a.evaluateSizeForZoom = function(l, s) {
        let u = 0, m = 0;
        if (l.kind === "constant") m = l.layoutSize;
        else if (l.kind !== "source") {
          const { interpolationType: b, minZoom: C, maxZoom: k } = l, P = b ? N(Yr.interpolationFactor(b, s, C, k), 0, 1) : 0;
          l.kind === "camera" ? m = Gr.number(l.minSize, l.maxSize, P) : u = P;
        }
        return { uSizeT: u, uSize: m };
      }, a.evaluateVariableOffset = M2, a.evented = hc, a.exported = De, a.extend = U, a.filterObject = ae, a.findLineIntersection = function(l, s, u, m) {
        const b = s.y - l.y, C = s.x - l.x, k = m.y - u.y, P = m.x - u.x, D = k * C - P * b;
        if (D === 0) return null;
        const Z = (P * (l.y - u.y) - k * (l.x - u.x)) / D;
        return new $(l.x + Z * C, l.y + Z * b);
      }, a.fromScaling = function(l, s) {
        return l[0] = s[0], l[1] = 0, l[2] = 0, l[3] = 0, l[4] = 0, l[5] = s[1], l[6] = 0, l[7] = 0, l[8] = 0, l[9] = 0, l[10] = s[2], l[11] = 0, l[12] = 0, l[13] = 0, l[14] = 0, l[15] = 1, l;
      }, a.getAnchorAlignment = X_, a.getAnchorJustification = ab, a.getArrayBuffer = je, a.getDefaultExportFromCjs = f, a.getJSON = function(l, s) {
        return Je(U(l, { type: "json" }), s);
      }, a.getOverlapMode = J_, a.getProtocolAction = rt, a.getRTLTextPluginStatus = nu, a.getReferrer = qe, a.getVideo = function(l, s) {
        const u = window.document.createElement("video");
        u.muted = !0, u.onloadstart = function() {
          s(null, u);
        };
        for (let m = 0; m < l.length; m++) {
          const b = window.document.createElement("source");
          ot(l[m]) || (u.crossOrigin = "Anonymous"), b.src = l[m], u.appendChild(b);
        }
        return { cancel: () => {
        } };
      }, a.groupByLayout = function(l, s) {
        const u = {};
        for (let b = 0; b < l.length; b++) {
          const C = s && s[l[b].id] || ml(l[b]);
          s && (s[l[b].id] = C);
          let k = u[C];
          k || (k = u[C] = []), k.push(l[b]);
        }
        const m = [];
        for (const b in u) m.push(u[b]);
        return m;
      }, a.identity = M_, a.interpolate = Gr, a.invert = function(l, s) {
        var u = s[0], m = s[1], b = s[2], C = s[3], k = s[4], P = s[5], D = s[6], Z = s[7], X = s[8], ie = s[9], ce = s[10], he = s[11], ye = s[12], Ie = s[13], ke = s[14], He = s[15], Qe = u * P - m * k, Be = u * D - b * k, lt = u * Z - C * k, ut = m * D - b * P, vt = m * Z - C * P, Xt = b * Z - C * D, nn = X * Ie - ie * ye, Vt = X * ke - ce * ye, Ft = X * He - he * ye, Lt = ie * ke - ce * Ie, Ut = ie * He - he * Ie, zt = ce * He - he * ke, St = Qe * zt - Be * Ut + lt * Lt + ut * Ft - vt * Vt + Xt * nn;
        return St ? (l[0] = (P * zt - D * Ut + Z * Lt) * (St = 1 / St), l[1] = (b * Ut - m * zt - C * Lt) * St, l[2] = (Ie * Xt - ke * vt + He * ut) * St, l[3] = (ce * vt - ie * Xt - he * ut) * St, l[4] = (D * Ft - k * zt - Z * Vt) * St, l[5] = (u * zt - b * Ft + C * Vt) * St, l[6] = (ke * lt - ye * Xt - He * Be) * St, l[7] = (X * Xt - ce * lt + he * Be) * St, l[8] = (k * Ut - P * Ft + Z * nn) * St, l[9] = (m * Ft - u * Ut - C * nn) * St, l[10] = (ye * vt - Ie * lt + He * Qe) * St, l[11] = (ie * lt - X * vt - he * Qe) * St, l[12] = (P * Vt - k * Lt - D * nn) * St, l[13] = (u * Lt - m * Vt + b * nn) * St, l[14] = (Ie * Be - ye * ut - ke * Qe) * St, l[15] = (X * ut - ie * Be + ce * Qe) * St, l) : null;
      }, a.isImageBitmap = We, a.isSafari = Ne, a.isWorker = le, a.keysDifference = function(l, s) {
        const u = [];
        for (const m in l) m in s || u.push(m);
        return u;
      }, a.lazyLoadRTLTextPlugin = function() {
        Os.isLoading() || Os.isLoaded() || nu() !== "deferred" || rd();
      }, a.makeRequest = Je, a.mapObject = te, a.mercatorXfromLng = h2, a.mercatorYfromLat = f2, a.mercatorZfromAltitude = m2, a.mul = G3, a.mul$1 = function(l, s, u) {
        return l[0] = s[0] * u[0], l[1] = s[1] * u[1], l[2] = s[2] * u[2], l[3] = s[3] * u[3], l;
      }, a.multiply = _$, a.nextPowerOfTwo = function(l) {
        return l <= 1 ? 1 : Math.pow(2, Math.ceil(Math.log(l) / Math.LN2));
      }, a.operations = Ht, a.ortho = function(l, s, u, m, b, C, k) {
        var P = 1 / (s - u), D = 1 / (m - b), Z = 1 / (C - k);
        return l[0] = -2 * P, l[1] = 0, l[2] = 0, l[3] = 0, l[4] = 0, l[5] = -2 * D, l[6] = 0, l[7] = 0, l[8] = 0, l[9] = 0, l[10] = 2 * Z, l[11] = 0, l[12] = (s + u) * P, l[13] = (b + m) * D, l[14] = (k + C) * Z, l[15] = 1, l;
      }, a.parseCacheControl = function(l) {
        const s = {};
        if (l.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, (u, m, b, C) => {
          const k = b || C;
          return s[m] = !k || k.toLowerCase(), "";
        }), s["max-age"]) {
          const u = parseInt(s["max-age"], 10);
          isNaN(u) ? delete s["max-age"] : s["max-age"] = u;
        }
        return s;
      }, a.parseGlyphPbf = function(l) {
        return new j_(l).readFields(jO, []);
      }, a.pbf = Z$, a.performSymbolLayout = function(l) {
        l.bucket.createArrays(), l.bucket.tilePixelRatio = Wi / (512 * l.bucket.overscaling), l.bucket.compareText = {}, l.bucket.iconsNeedLinear = !1;
        const s = l.bucket.layers[0].layout, u = l.bucket.layers[0]._unevaluatedLayout._values, m = { layoutIconSize: u["icon-size"].possiblyEvaluate(new Ei(l.bucket.zoom + 1), l.canonical), layoutTextSize: u["text-size"].possiblyEvaluate(new Ei(l.bucket.zoom + 1), l.canonical), textMaxSize: u["text-size"].possiblyEvaluate(new Ei(18)) };
        if (l.bucket.textSizeData.kind === "composite") {
          const { minZoom: D, maxZoom: Z } = l.bucket.textSizeData;
          m.compositeTextSizes = [u["text-size"].possiblyEvaluate(new Ei(D), l.canonical), u["text-size"].possiblyEvaluate(new Ei(Z), l.canonical)];
        }
        if (l.bucket.iconSizeData.kind === "composite") {
          const { minZoom: D, maxZoom: Z } = l.bucket.iconSizeData;
          m.compositeIconSizes = [u["icon-size"].possiblyEvaluate(new Ei(D), l.canonical), u["icon-size"].possiblyEvaluate(new Ei(Z), l.canonical)];
        }
        const b = s.get("text-line-height") * Fr, C = s.get("text-rotation-alignment") !== "viewport" && s.get("symbol-placement") !== "point", k = s.get("text-keep-upright"), P = s.get("text-size");
        for (const D of l.bucket.features) {
          const Z = s.get("text-font").evaluate(D, {}, l.canonical).join(","), X = P.evaluate(D, {}, l.canonical), ie = m.layoutTextSize.evaluate(D, {}, l.canonical), ce = m.layoutIconSize.evaluate(D, {}, l.canonical), he = { horizontal: {}, vertical: void 0 }, ye = D.text;
          let Ie, ke = [0, 0];
          if (ye) {
            const Be = ye.toString(), lt = s.get("text-letter-spacing").evaluate(D, {}, l.canonical) * Fr, ut = Qc(Be) ? lt : 0, vt = s.get("text-anchor").evaluate(D, {}, l.canonical), Xt = s.get("text-variable-anchor");
            if (!Xt) {
              const Ut = s.get("text-radial-offset").evaluate(D, {}, l.canonical);
              ke = Ut ? M2(vt, [Ut * Fr, ob]) : s.get("text-offset").evaluate(D, {}, l.canonical).map((zt) => zt * Fr);
            }
            let nn = C ? "center" : s.get("text-justify").evaluate(D, {}, l.canonical);
            const Vt = s.get("symbol-placement"), Ft = Vt === "point" ? s.get("text-max-width").evaluate(D, {}, l.canonical) * Fr : 0, Lt = () => {
              l.bucket.allowVerticalPlacement && Ao(Be) && (he.vertical = gv(ye, l.glyphMap, l.glyphPositions, l.imagePositions, Z, Ft, b, vt, "left", ut, ke, a.WritingMode.vertical, !0, Vt, ie, X));
            };
            if (!C && Xt) {
              const Ut = nn === "auto" ? Xt.map((St) => ab(St)) : [nn];
              let zt = !1;
              for (let St = 0; St < Ut.length; St++) {
                const mn = Ut[St];
                if (!he.horizontal[mn]) if (zt) he.horizontal[mn] = he.horizontal[0];
                else {
                  const ln = gv(ye, l.glyphMap, l.glyphPositions, l.imagePositions, Z, Ft, b, "center", mn, ut, ke, a.WritingMode.horizontal, !1, Vt, ie, X);
                  ln && (he.horizontal[mn] = ln, zt = ln.positionedLines.length === 1);
                }
              }
              Lt();
            } else {
              nn === "auto" && (nn = ab(vt));
              const Ut = gv(ye, l.glyphMap, l.glyphPositions, l.imagePositions, Z, Ft, b, vt, nn, ut, ke, a.WritingMode.horizontal, !1, Vt, ie, X);
              Ut && (he.horizontal[nn] = Ut), Lt(), Ao(Be) && C && k && (he.vertical = gv(ye, l.glyphMap, l.glyphPositions, l.imagePositions, Z, Ft, b, vt, nn, ut, ke, a.WritingMode.vertical, !1, Vt, ie, X));
            }
          }
          let He = !1;
          if (D.icon && D.icon.name) {
            const Be = l.imageMap[D.icon.name];
            Be && (Ie = eN(l.imagePositions[D.icon.name], s.get("icon-offset").evaluate(D, {}, l.canonical), s.get("icon-anchor").evaluate(D, {}, l.canonical)), He = !!Be.sdf, l.bucket.sdfIcons === void 0 ? l.bucket.sdfIcons = He : l.bucket.sdfIcons !== He && me("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (Be.pixelRatio !== l.bucket.pixelRatio || s.get("icon-rotate").constantOr(1) !== 0) && (l.bucket.iconsNeedLinear = !0));
          }
          const Qe = L2(he.horizontal) || he.vertical;
          l.bucket.iconsInText = !!Qe && Qe.iconsInText, (Qe || Ie) && vN(l.bucket, D, he, Ie, l.imageMap, m, ie, ce, ke, He, l.canonical);
        }
        l.showCollisionBoxes && l.bucket.generateCollisionDebugBuffers();
      }, a.perspective = function(l, s, u, m, b) {
        var C, k = 1 / Math.tan(s / 2);
        return l[0] = k / u, l[1] = 0, l[2] = 0, l[3] = 0, l[4] = 0, l[5] = k, l[6] = 0, l[7] = 0, l[8] = 0, l[9] = 0, l[11] = -1, l[12] = 0, l[13] = 0, l[15] = 0, b != null && b !== 1 / 0 ? (l[10] = (b + m) * (C = 1 / (m - b)), l[14] = 2 * b * m * C) : (l[10] = -1, l[14] = -2 * m), l;
      }, a.pick = function(l, s) {
        const u = {};
        for (let m = 0; m < s.length; m++) {
          const b = s[m];
          b in l && (u[b] = l[b]);
        }
        return u;
      }, a.plugin = Os, a.pointGeometry = g, a.polygonIntersectsPolygon = h$, a.potpack = J$, a.register = Zt, a.registerForPluginStateChange = function(l) {
        return l({ pluginStatus: Jr, pluginURL: Xo }), hc.on("pluginStateChange", l), l;
      }, a.renderColorRamp = C$, a.rotateX = function(l, s, u) {
        var m = Math.sin(u), b = Math.cos(u), C = s[4], k = s[5], P = s[6], D = s[7], Z = s[8], X = s[9], ie = s[10], ce = s[11];
        return s !== l && (l[0] = s[0], l[1] = s[1], l[2] = s[2], l[3] = s[3], l[12] = s[12], l[13] = s[13], l[14] = s[14], l[15] = s[15]), l[4] = C * b + Z * m, l[5] = k * b + X * m, l[6] = P * b + ie * m, l[7] = D * b + ce * m, l[8] = Z * b - C * m, l[9] = X * b - k * m, l[10] = ie * b - P * m, l[11] = ce * b - D * m, l;
      }, a.rotateZ = function(l, s, u) {
        var m = Math.sin(u), b = Math.cos(u), C = s[0], k = s[1], P = s[2], D = s[3], Z = s[4], X = s[5], ie = s[6], ce = s[7];
        return s !== l && (l[8] = s[8], l[9] = s[9], l[10] = s[10], l[11] = s[11], l[12] = s[12], l[13] = s[13], l[14] = s[14], l[15] = s[15]), l[0] = C * b + Z * m, l[1] = k * b + X * m, l[2] = P * b + ie * m, l[3] = D * b + ce * m, l[4] = Z * b - C * m, l[5] = X * b - k * m, l[6] = ie * b - P * m, l[7] = ce * b - D * m, l;
      }, a.sameOrigin = ot, a.scale = function(l, s, u) {
        var m = u[0], b = u[1], C = u[2];
        return l[0] = s[0] * m, l[1] = s[1] * m, l[2] = s[2] * m, l[3] = s[3] * m, l[4] = s[4] * b, l[5] = s[5] * b, l[6] = s[6] * b, l[7] = s[7] * b, l[8] = s[8] * C, l[9] = s[9] * C, l[10] = s[10] * C, l[11] = s[11] * C, l[12] = s[12], l[13] = s[13], l[14] = s[14], l[15] = s[15], l;
      }, a.setRTLTextPlugin = function(l, s, u = !1) {
        if (Jr === nd || Jr === Pa || Jr === Ma) throw new Error("setRTLTextPlugin cannot be called multiple times.");
        Xo = De.resolveURL(l), Jr = nd, wl = s, tu(), u || rd();
      }, a.sphericalToCartesian = function([l, s, u]) {
        return s += 90, s *= Math.PI / 180, u *= Math.PI / 180, { x: l * Math.cos(s) * Math.sin(u), y: l * Math.sin(s) * Math.sin(u), z: l * Math.cos(u) };
      }, a.toEvaluationFeature = cd, a.transformMat4 = uv, a.translate = function(l, s, u) {
        var m, b, C, k, P, D, Z, X, ie, ce, he, ye, Ie = u[0], ke = u[1], He = u[2];
        return s === l ? (l[12] = s[0] * Ie + s[4] * ke + s[8] * He + s[12], l[13] = s[1] * Ie + s[5] * ke + s[9] * He + s[13], l[14] = s[2] * Ie + s[6] * ke + s[10] * He + s[14], l[15] = s[3] * Ie + s[7] * ke + s[11] * He + s[15]) : (b = s[1], C = s[2], k = s[3], P = s[4], D = s[5], Z = s[6], X = s[7], ie = s[8], ce = s[9], he = s[10], ye = s[11], l[0] = m = s[0], l[1] = b, l[2] = C, l[3] = k, l[4] = P, l[5] = D, l[6] = Z, l[7] = X, l[8] = ie, l[9] = ce, l[10] = he, l[11] = ye, l[12] = m * Ie + P * ke + ie * He + s[12], l[13] = b * Ie + D * ke + ce * He + s[13], l[14] = C * Ie + Z * ke + he * He + s[14], l[15] = k * Ie + X * ke + ye * He + s[15]), l;
      }, a.triggerPluginCompletionEvent = id, a.unicodeBlockLookup = Rt, a.uniqueId = function() {
        return q++;
      }, a.v8Spec = Oe, a.validateCustomStyleLayer = function(l) {
        const s = [], u = l.id;
        return u === void 0 && s.push({ message: `layers.${u}: missing required property "id"` }), l.render === void 0 && s.push({ message: `layers.${u}: missing required method "render"` }), l.renderingMode && l.renderingMode !== "2d" && l.renderingMode !== "3d" && s.push({ message: `layers.${u}: property "renderingMode" must be either "2d" or "3d"` }), s;
      }, a.validateLight = af, a.validateStyle = To, a.vectorTile = au, a.warnOnce = me, a.wrap = K;
    }), c(["./shared"], function(a) {
      class f {
        constructor(se) {
          this.keyCache = {}, se && this.replace(se);
        }
        replace(se) {
          this._layerConfigs = {}, this._layers = {}, this.update(se, []);
        }
        update(se, ue) {
          for (const Pe of se) {
            this._layerConfigs[Pe.id] = Pe;
            const Fe = this._layers[Pe.id] = a.createStyleLayer(Pe);
            Fe._featureFilter = a.createFilter(Fe.filter), this.keyCache[Pe.id] && delete this.keyCache[Pe.id];
          }
          for (const Pe of ue) delete this.keyCache[Pe], delete this._layerConfigs[Pe], delete this._layers[Pe];
          this.familiesBySource = {};
          const be = a.groupByLayout(Object.values(this._layerConfigs), this.keyCache);
          for (const Pe of be) {
            const Fe = Pe.map((_t) => this._layers[_t.id]), Ze = Fe[0];
            if (Ze.visibility === "none") continue;
            const ze = Ze.source || "";
            let Re = this.familiesBySource[ze];
            Re || (Re = this.familiesBySource[ze] = {});
            const Ye = Ze.sourceLayer || "_geojsonTileLayer";
            let nt = Re[Ye];
            nt || (nt = Re[Ye] = []), nt.push(Fe);
          }
        }
      }
      class g {
        constructor(se) {
          const ue = {}, be = [];
          for (const ze in se) {
            const Re = se[ze], Ye = ue[ze] = {};
            for (const nt in Re) {
              const _t = Re[+nt];
              if (!_t || _t.bitmap.width === 0 || _t.bitmap.height === 0) continue;
              const yt = { x: 0, y: 0, w: _t.bitmap.width + 2, h: _t.bitmap.height + 2 };
              be.push(yt), Ye[nt] = { rect: yt, metrics: _t.metrics };
            }
          }
          const { w: Pe, h: Fe } = a.potpack(be), Ze = new a.AlphaImage({ width: Pe || 1, height: Fe || 1 });
          for (const ze in se) {
            const Re = se[ze];
            for (const Ye in Re) {
              const nt = Re[+Ye];
              if (!nt || nt.bitmap.width === 0 || nt.bitmap.height === 0) continue;
              const _t = ue[ze][Ye].rect;
              a.AlphaImage.copy(nt.bitmap, Ze, { x: 0, y: 0 }, { x: _t.x + 1, y: _t.y + 1 }, nt.bitmap);
            }
          }
          this.image = Ze, this.positions = ue;
        }
      }
      a.register("GlyphAtlas", g);
      class x {
        constructor(se) {
          this.tileID = new a.OverscaledTileID(se.tileID.overscaledZ, se.tileID.wrap, se.tileID.canonical.z, se.tileID.canonical.x, se.tileID.canonical.y), this.uid = se.uid, this.zoom = se.zoom, this.pixelRatio = se.pixelRatio, this.tileSize = se.tileSize, this.source = se.source, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = se.showCollisionBoxes, this.collectResourceTiming = !!se.collectResourceTiming, this.returnDependencies = !!se.returnDependencies, this.promoteId = se.promoteId;
        }
        parse(se, ue, be, Pe, Fe) {
          this.status = "parsing", this.data = se, this.collisionBoxArray = new a.CollisionBoxArray();
          const Ze = new a.DictionaryCoder(Object.keys(se.layers).sort()), ze = new a.FeatureIndex(this.tileID, this.promoteId);
          ze.bucketLayerIDs = [];
          const Re = {}, Ye = { featureIndex: ze, iconDependencies: {}, patternDependencies: {}, glyphDependencies: {}, availableImages: be }, nt = ue.familiesBySource[this.source];
          for (const An in nt) {
            const Un = se.layers[An];
            if (!Un) continue;
            Un.version === 1 && a.warnOnce(`Vector tile source "${this.source}" layer "${An}" does not use vector tile spec v2 and therefore may have some rendering errors.`);
            const ei = Ze.encode(An), Yi = [];
            for (let _n = 0; _n < Un.length; _n++) {
              const Ni = Un.feature(_n), Dr = ze.getId(Ni, An);
              Yi.push({ feature: Ni, id: Dr, index: _n, sourceLayerIndex: ei });
            }
            for (const _n of nt[An]) {
              const Ni = _n[0];
              Ni.source !== this.source && a.warnOnce(`layer.source = ${Ni.source} does not equal this.source = ${this.source}`), Ni.minzoom && this.zoom < Math.floor(Ni.minzoom) || Ni.maxzoom && this.zoom >= Ni.maxzoom || Ni.visibility !== "none" && ($(_n, this.zoom, be), (Re[Ni.id] = Ni.createBucket({ index: ze.bucketLayerIDs.length, layers: _n, zoom: this.zoom, pixelRatio: this.pixelRatio, overscaling: this.overscaling, collisionBoxArray: this.collisionBoxArray, sourceLayerIndex: ei, sourceID: this.source })).populate(Yi, Ye, this.tileID.canonical), ze.bucketLayerIDs.push(_n.map((Dr) => Dr.id)));
            }
          }
          let _t, yt, un, bn;
          const Kt = a.mapObject(Ye.glyphDependencies, (An) => Object.keys(An).map(Number));
          Object.keys(Kt).length ? Pe.send("getGlyphs", { uid: this.uid, stacks: Kt, source: this.source, tileID: this.tileID, type: "glyphs" }, (An, Un) => {
            _t || (_t = An, yt = Un, Bn.call(this));
          }) : yt = {};
          const an = Object.keys(Ye.iconDependencies);
          an.length ? Pe.send("getImages", { icons: an, source: this.source, tileID: this.tileID, type: "icons" }, (An, Un) => {
            _t || (_t = An, un = Un, Bn.call(this));
          }) : un = {};
          const dn = Object.keys(Ye.patternDependencies);
          function Bn() {
            if (_t) return Fe(_t);
            if (yt && un && bn) {
              const An = new g(yt), Un = new a.ImageAtlas(un, bn);
              for (const ei in Re) {
                const Yi = Re[ei];
                Yi instanceof a.SymbolBucket ? ($(Yi.layers, this.zoom, be), a.performSymbolLayout({ bucket: Yi, glyphMap: yt, glyphPositions: An.positions, imageMap: un, imagePositions: Un.iconPositions, showCollisionBoxes: this.showCollisionBoxes, canonical: this.tileID.canonical })) : Yi.hasPattern && (Yi instanceof a.LineBucket || Yi instanceof a.FillBucket || Yi instanceof a.FillExtrusionBucket) && ($(Yi.layers, this.zoom, be), Yi.addFeatures(Ye, this.tileID.canonical, Un.patternPositions));
              }
              this.status = "done", Fe(null, { buckets: Object.values(Re).filter((ei) => !ei.isEmpty()), featureIndex: ze, collisionBoxArray: this.collisionBoxArray, glyphAtlasImage: An.image, imageAtlas: Un, glyphMap: this.returnDependencies ? yt : null, iconMap: this.returnDependencies ? un : null, glyphPositions: this.returnDependencies ? An.positions : null });
            }
          }
          dn.length ? Pe.send("getImages", { icons: dn, source: this.source, tileID: this.tileID, type: "patterns" }, (An, Un) => {
            _t || (_t = An, bn = Un, Bn.call(this));
          }) : bn = {}, Bn.call(this);
        }
      }
      function $(Te, se, ue) {
        const be = new a.EvaluationParameters(se);
        for (const Pe of Te) Pe.recalculate(be, ue);
      }
      function A(Te, se) {
        const ue = a.getArrayBuffer(Te.request, (be, Pe, Fe, Ze) => {
          be ? se(be) : Pe && se(null, { vectorTile: new a.vectorTile.VectorTile(new a.Protobuf(Pe)), rawData: Pe, cacheControl: Fe, expires: Ze });
        });
        return () => {
          ue.cancel(), se();
        };
      }
      class I {
        constructor(se, ue, be, Pe) {
          this.actor = se, this.layerIndex = ue, this.availableImages = be, this.loadVectorData = Pe || A, this.loading = {}, this.loaded = {};
        }
        loadTile(se, ue) {
          const be = se.uid;
          this.loading || (this.loading = {});
          const Pe = !!(se && se.request && se.request.collectResourceTiming) && new a.RequestPerformance(se.request), Fe = this.loading[be] = new x(se);
          Fe.abort = this.loadVectorData(se, (Ze, ze) => {
            if (delete this.loading[be], Ze || !ze) return Fe.status = "done", this.loaded[be] = Fe, ue(Ze);
            const Re = ze.rawData, Ye = {};
            ze.expires && (Ye.expires = ze.expires), ze.cacheControl && (Ye.cacheControl = ze.cacheControl);
            const nt = {};
            if (Pe) {
              const _t = Pe.finish();
              _t && (nt.resourceTiming = JSON.parse(JSON.stringify(_t)));
            }
            Fe.vectorTile = ze.vectorTile, Fe.parse(ze.vectorTile, this.layerIndex, this.availableImages, this.actor, (_t, yt) => {
              if (_t || !yt) return ue(_t);
              ue(null, a.extend({ rawTileData: Re.slice(0) }, yt, Ye, nt));
            }), this.loaded = this.loaded || {}, this.loaded[be] = Fe;
          });
        }
        reloadTile(se, ue) {
          const be = this.loaded, Pe = se.uid, Fe = this;
          if (be && be[Pe]) {
            const Ze = be[Pe];
            Ze.showCollisionBoxes = se.showCollisionBoxes;
            const ze = (Re, Ye) => {
              const nt = Ze.reloadCallback;
              nt && (delete Ze.reloadCallback, Ze.parse(Ze.vectorTile, Fe.layerIndex, this.availableImages, Fe.actor, nt)), ue(Re, Ye);
            };
            Ze.status === "parsing" ? Ze.reloadCallback = ze : Ze.status === "done" && (Ze.vectorTile ? Ze.parse(Ze.vectorTile, this.layerIndex, this.availableImages, this.actor, ze) : ze());
          }
        }
        abortTile(se, ue) {
          const be = this.loading, Pe = se.uid;
          be && be[Pe] && be[Pe].abort && (be[Pe].abort(), delete be[Pe]), ue();
        }
        removeTile(se, ue) {
          const be = this.loaded, Pe = se.uid;
          be && be[Pe] && delete be[Pe], ue();
        }
      }
      class O {
        constructor() {
          this.loaded = {};
        }
        loadTile(se, ue) {
          const { uid: be, encoding: Pe, rawImageData: Fe } = se, Ze = a.isImageBitmap(Fe) ? this.getImageData(Fe) : Fe, ze = new a.DEMData(be, Ze, Pe);
          this.loaded = this.loaded || {}, this.loaded[be] = ze, ue(null, ze);
        }
        getImageData(se) {
          this.offscreenCanvas && this.offscreenCanvasContext || (this.offscreenCanvas = new OffscreenCanvas(se.width, se.height), this.offscreenCanvasContext = this.offscreenCanvas.getContext("2d", { willReadFrequently: !0 })), this.offscreenCanvas.width = se.width, this.offscreenCanvas.height = se.height, this.offscreenCanvasContext.drawImage(se, 0, 0, se.width, se.height);
          const ue = this.offscreenCanvasContext.getImageData(-1, -1, se.width + 2, se.height + 2);
          return this.offscreenCanvasContext.clearRect(0, 0, this.offscreenCanvas.width, this.offscreenCanvas.height), new a.RGBAImage({ width: ue.width, height: ue.height }, ue.data);
        }
        removeTile(se) {
          const ue = this.loaded, be = se.uid;
          ue && ue[be] && delete ue[be];
        }
      }
      function B(Te, se) {
        if (Te.length !== 0) {
          H(Te[0], se);
          for (var ue = 1; ue < Te.length; ue++) H(Te[ue], !se);
        }
      }
      function H(Te, se) {
        for (var ue = 0, be = 0, Pe = 0, Fe = Te.length, Ze = Fe - 1; Pe < Fe; Ze = Pe++) {
          var ze = (Te[Pe][0] - Te[Ze][0]) * (Te[Ze][1] + Te[Pe][1]), Re = ue + ze;
          be += Math.abs(ue) >= Math.abs(ze) ? ue - Re + ze : ze - Re + ue, ue = Re;
        }
        ue + be >= 0 != !!se && Te.reverse();
      }
      var N = a.getDefaultExportFromCjs(function Te(se, ue) {
        var be, Pe = se && se.type;
        if (Pe === "FeatureCollection") for (be = 0; be < se.features.length; be++) Te(se.features[be], ue);
        else if (Pe === "GeometryCollection") for (be = 0; be < se.geometries.length; be++) Te(se.geometries[be], ue);
        else if (Pe === "Feature") Te(se.geometry, ue);
        else if (Pe === "Polygon") B(se.coordinates, ue);
        else if (Pe === "MultiPolygon") for (be = 0; be < se.coordinates.length; be++) B(se.coordinates[be], ue);
        return se;
      });
      const K = a.vectorTile.VectorTileFeature.prototype.toGeoJSON;
      var U = { exports: {} }, q = a.pointGeometry, ee = a.vectorTile.VectorTileFeature, te = ae;
      function ae(Te, se) {
        this.options = se || {}, this.features = Te, this.length = Te.length;
      }
      function oe(Te, se) {
        this.id = typeof Te.id == "number" ? Te.id : void 0, this.type = Te.type, this.rawGeometry = Te.type === 1 ? [Te.geometry] : Te.geometry, this.properties = Te.tags, this.extent = se || 4096;
      }
      ae.prototype.feature = function(Te) {
        return new oe(this.features[Te], this.options.extent);
      }, oe.prototype.loadGeometry = function() {
        var Te = this.rawGeometry;
        this.geometry = [];
        for (var se = 0; se < Te.length; se++) {
          for (var ue = Te[se], be = [], Pe = 0; Pe < ue.length; Pe++) be.push(new q(ue[Pe][0], ue[Pe][1]));
          this.geometry.push(be);
        }
        return this.geometry;
      }, oe.prototype.bbox = function() {
        this.geometry || this.loadGeometry();
        for (var Te = this.geometry, se = 1 / 0, ue = -1 / 0, be = 1 / 0, Pe = -1 / 0, Fe = 0; Fe < Te.length; Fe++) for (var Ze = Te[Fe], ze = 0; ze < Ze.length; ze++) {
          var Re = Ze[ze];
          se = Math.min(se, Re.x), ue = Math.max(ue, Re.x), be = Math.min(be, Re.y), Pe = Math.max(Pe, Re.y);
        }
        return [se, be, ue, Pe];
      }, oe.prototype.toGeoJSON = ee.prototype.toGeoJSON;
      var de = a.pbf, me = te;
      function ve(Te) {
        var se = new de();
        return function(ue, be) {
          for (var Pe in ue.layers) be.writeMessage(3, re, ue.layers[Pe]);
        }(Te, se), se.finish();
      }
      function re(Te, se) {
        var ue;
        se.writeVarintField(15, Te.version || 1), se.writeStringField(1, Te.name || ""), se.writeVarintField(5, Te.extent || 4096);
        var be = { keys: [], values: [], keycache: {}, valuecache: {} };
        for (ue = 0; ue < Te.length; ue++) be.feature = Te.feature(ue), se.writeMessage(2, le, be);
        var Pe = be.keys;
        for (ue = 0; ue < Pe.length; ue++) se.writeStringField(3, Pe[ue]);
        var Fe = be.values;
        for (ue = 0; ue < Fe.length; ue++) se.writeMessage(4, et, Fe[ue]);
      }
      function le(Te, se) {
        var ue = Te.feature;
        ue.id !== void 0 && se.writeVarintField(1, ue.id), se.writeMessage(2, pe, Te), se.writeVarintField(3, ue.type), se.writeMessage(4, Ge, ue);
      }
      function pe(Te, se) {
        var ue = Te.feature, be = Te.keys, Pe = Te.values, Fe = Te.keycache, Ze = Te.valuecache;
        for (var ze in ue.properties) {
          var Re = ue.properties[ze], Ye = Fe[ze];
          if (Re !== null) {
            Ye === void 0 && (be.push(ze), Fe[ze] = Ye = be.length - 1), se.writeVarint(Ye);
            var nt = typeof Re;
            nt !== "string" && nt !== "boolean" && nt !== "number" && (Re = JSON.stringify(Re));
            var _t = nt + ":" + Re, yt = Ze[_t];
            yt === void 0 && (Pe.push(Re), Ze[_t] = yt = Pe.length - 1), se.writeVarint(yt);
          }
        }
      }
      function Ne(Te, se) {
        return (se << 3) + (7 & Te);
      }
      function We(Te) {
        return Te << 1 ^ Te >> 31;
      }
      function Ge(Te, se) {
        for (var ue = Te.loadGeometry(), be = Te.type, Pe = 0, Fe = 0, Ze = ue.length, ze = 0; ze < Ze; ze++) {
          var Re = ue[ze], Ye = 1;
          be === 1 && (Ye = Re.length), se.writeVarint(Ne(1, Ye));
          for (var nt = be === 3 ? Re.length - 1 : Re.length, _t = 0; _t < nt; _t++) {
            _t === 1 && be !== 1 && se.writeVarint(Ne(2, nt - 1));
            var yt = Re[_t].x - Pe, un = Re[_t].y - Fe;
            se.writeVarint(We(yt)), se.writeVarint(We(un)), Pe += yt, Fe += un;
          }
          be === 3 && se.writeVarint(Ne(7, 1));
        }
      }
      function et(Te, se) {
        var ue = typeof Te;
        ue === "string" ? se.writeStringField(1, Te) : ue === "boolean" ? se.writeBooleanField(7, Te) : ue === "number" && (Te % 1 != 0 ? se.writeDoubleField(3, Te) : Te < 0 ? se.writeSVarintField(6, Te) : se.writeVarintField(5, Te));
      }
      U.exports = ve, U.exports.fromVectorTileJs = ve, U.exports.fromGeojsonVt = function(Te, se) {
        se = se || {};
        var ue = {};
        for (var be in Te) ue[be] = new me(Te[be].features, se), ue[be].name = be, ue[be].version = se.version, ue[be].extent = se.extent;
        return ve({ layers: ue });
      }, U.exports.GeoJSONWrapper = me;
      var ft = a.getDefaultExportFromCjs(U.exports);
      const De = { minZoom: 0, maxZoom: 16, minPoints: 2, radius: 40, extent: 512, nodeSize: 64, log: !1, generateId: !1, reduce: null, map: (Te) => Te }, Ke = Math.fround || (gt = new Float32Array(1), (Te) => (gt[0] = +Te, gt[0]));
      var gt;
      const qe = 3, rt = 5, Le = 6;
      class Je {
        constructor(se) {
          this.options = Object.assign(Object.create(De), se), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
        }
        load(se) {
          const { log: ue, minZoom: be, maxZoom: Pe } = this.options;
          ue && console.time("total time");
          const Fe = `prepare ${se.length} points`;
          ue && console.time(Fe), this.points = se;
          const Ze = [];
          for (let Re = 0; Re < se.length; Re++) {
            const Ye = se[Re];
            if (!Ye.geometry) continue;
            const [nt, _t] = Ye.geometry.coordinates, yt = Ke(Xe(nt)), un = Ke(tt(_t));
            Ze.push(yt, un, 1 / 0, Re, -1, 1), this.options.reduce && Ze.push(0);
          }
          let ze = this.trees[Pe + 1] = this._createTree(Ze);
          ue && console.timeEnd(Fe);
          for (let Re = Pe; Re >= be; Re--) {
            const Ye = +Date.now();
            ze = this.trees[Re] = this._createTree(this._cluster(ze, Re)), ue && console.log("z%d: %d clusters in %dms", Re, ze.numItems, +Date.now() - Ye);
          }
          return ue && console.timeEnd("total time"), this;
        }
        getClusters(se, ue) {
          let be = ((se[0] + 180) % 360 + 360) % 360 - 180;
          const Pe = Math.max(-90, Math.min(90, se[1]));
          let Fe = se[2] === 180 ? 180 : ((se[2] + 180) % 360 + 360) % 360 - 180;
          const Ze = Math.max(-90, Math.min(90, se[3]));
          if (se[2] - se[0] >= 360) be = -180, Fe = 180;
          else if (be > Fe) {
            const _t = this.getClusters([be, Pe, 180, Ze], ue), yt = this.getClusters([-180, Pe, Fe, Ze], ue);
            return _t.concat(yt);
          }
          const ze = this.trees[this._limitZoom(ue)], Re = ze.range(Xe(be), tt(Ze), Xe(Fe), tt(Pe)), Ye = ze.data, nt = [];
          for (const _t of Re) {
            const yt = this.stride * _t;
            nt.push(Ye[yt + rt] > 1 ? je(Ye, yt, this.clusterProps) : this.points[Ye[yt + qe]]);
          }
          return nt;
        }
        getChildren(se) {
          const ue = this._getOriginId(se), be = this._getOriginZoom(se), Pe = "No cluster with the specified id.", Fe = this.trees[be];
          if (!Fe) throw new Error(Pe);
          const Ze = Fe.data;
          if (ue * this.stride >= Ze.length) throw new Error(Pe);
          const ze = this.options.radius / (this.options.extent * Math.pow(2, be - 1)), Re = Fe.within(Ze[ue * this.stride], Ze[ue * this.stride + 1], ze), Ye = [];
          for (const nt of Re) {
            const _t = nt * this.stride;
            Ze[_t + 4] === se && Ye.push(Ze[_t + rt] > 1 ? je(Ze, _t, this.clusterProps) : this.points[Ze[_t + qe]]);
          }
          if (Ye.length === 0) throw new Error(Pe);
          return Ye;
        }
        getLeaves(se, ue, be) {
          const Pe = [];
          return this._appendLeaves(Pe, se, ue = ue || 10, be = be || 0, 0), Pe;
        }
        getTile(se, ue, be) {
          const Pe = this.trees[this._limitZoom(se)], Fe = Math.pow(2, se), { extent: Ze, radius: ze } = this.options, Re = ze / Ze, Ye = (be - Re) / Fe, nt = (be + 1 + Re) / Fe, _t = { features: [] };
          return this._addTileFeatures(Pe.range((ue - Re) / Fe, Ye, (ue + 1 + Re) / Fe, nt), Pe.data, ue, be, Fe, _t), ue === 0 && this._addTileFeatures(Pe.range(1 - Re / Fe, Ye, 1, nt), Pe.data, Fe, be, Fe, _t), ue === Fe - 1 && this._addTileFeatures(Pe.range(0, Ye, Re / Fe, nt), Pe.data, -1, be, Fe, _t), _t.features.length ? _t : null;
        }
        getClusterExpansionZoom(se) {
          let ue = this._getOriginZoom(se) - 1;
          for (; ue <= this.options.maxZoom; ) {
            const be = this.getChildren(se);
            if (ue++, be.length !== 1) break;
            se = be[0].properties.cluster_id;
          }
          return ue;
        }
        _appendLeaves(se, ue, be, Pe, Fe) {
          const Ze = this.getChildren(ue);
          for (const ze of Ze) {
            const Re = ze.properties;
            if (Re && Re.cluster ? Fe + Re.point_count <= Pe ? Fe += Re.point_count : Fe = this._appendLeaves(se, Re.cluster_id, be, Pe, Fe) : Fe < Pe ? Fe++ : se.push(ze), se.length === be) break;
          }
          return Fe;
        }
        _createTree(se) {
          const ue = new a.KDBush(se.length / this.stride | 0, this.options.nodeSize, Float32Array);
          for (let be = 0; be < se.length; be += this.stride) ue.add(se[be], se[be + 1]);
          return ue.finish(), ue.data = se, ue;
        }
        _addTileFeatures(se, ue, be, Pe, Fe, Ze) {
          for (const ze of se) {
            const Re = ze * this.stride, Ye = ue[Re + rt] > 1;
            let nt, _t, yt;
            if (Ye) nt = ot(ue, Re, this.clusterProps), _t = ue[Re], yt = ue[Re + 1];
            else {
              const Kt = this.points[ue[Re + qe]];
              nt = Kt.properties;
              const [an, dn] = Kt.geometry.coordinates;
              _t = Xe(an), yt = tt(dn);
            }
            const un = { type: 1, geometry: [[Math.round(this.options.extent * (_t * Fe - be)), Math.round(this.options.extent * (yt * Fe - Pe))]], tags: nt };
            let bn;
            bn = Ye || this.options.generateId ? ue[Re + qe] : this.points[ue[Re + qe]].id, bn !== void 0 && (un.id = bn), Ze.features.push(un);
          }
        }
        _limitZoom(se) {
          return Math.max(this.options.minZoom, Math.min(Math.floor(+se), this.options.maxZoom + 1));
        }
        _cluster(se, ue) {
          const { radius: be, extent: Pe, reduce: Fe, minPoints: Ze } = this.options, ze = be / (Pe * Math.pow(2, ue)), Re = se.data, Ye = [], nt = this.stride;
          for (let _t = 0; _t < Re.length; _t += nt) {
            if (Re[_t + 2] <= ue) continue;
            Re[_t + 2] = ue;
            const yt = Re[_t], un = Re[_t + 1], bn = se.within(Re[_t], Re[_t + 1], ze), Kt = Re[_t + rt];
            let an = Kt;
            for (const dn of bn) {
              const Bn = dn * nt;
              Re[Bn + 2] > ue && (an += Re[Bn + rt]);
            }
            if (an > Kt && an >= Ze) {
              let dn, Bn = yt * Kt, An = un * Kt, Un = -1;
              const ei = ((_t / nt | 0) << 5) + (ue + 1) + this.points.length;
              for (const Yi of bn) {
                const _n = Yi * nt;
                if (Re[_n + 2] <= ue) continue;
                Re[_n + 2] = ue;
                const Ni = Re[_n + rt];
                Bn += Re[_n] * Ni, An += Re[_n + 1] * Ni, Re[_n + 4] = ei, Fe && (dn || (dn = this._map(Re, _t, !0), Un = this.clusterProps.length, this.clusterProps.push(dn)), Fe(dn, this._map(Re, _n)));
              }
              Re[_t + 4] = ei, Ye.push(Bn / an, An / an, 1 / 0, ei, -1, an), Fe && Ye.push(Un);
            } else {
              for (let dn = 0; dn < nt; dn++) Ye.push(Re[_t + dn]);
              if (an > 1) for (const dn of bn) {
                const Bn = dn * nt;
                if (!(Re[Bn + 2] <= ue)) {
                  Re[Bn + 2] = ue;
                  for (let An = 0; An < nt; An++) Ye.push(Re[Bn + An]);
                }
              }
            }
          }
          return Ye;
        }
        _getOriginId(se) {
          return se - this.points.length >> 5;
        }
        _getOriginZoom(se) {
          return (se - this.points.length) % 32;
        }
        _map(se, ue, be) {
          if (se[ue + rt] > 1) {
            const Ze = this.clusterProps[se[ue + Le]];
            return be ? Object.assign({}, Ze) : Ze;
          }
          const Pe = this.points[se[ue + qe]].properties, Fe = this.options.map(Pe);
          return be && Fe === Pe ? Object.assign({}, Fe) : Fe;
        }
      }
      function je(Te, se, ue) {
        return { type: "Feature", id: Te[se + qe], properties: ot(Te, se, ue), geometry: { type: "Point", coordinates: [(be = Te[se], 360 * (be - 0.5)), dt(Te[se + 1])] } };
        var be;
      }
      function ot(Te, se, ue) {
        const be = Te[se + rt], Pe = be >= 1e4 ? `${Math.round(be / 1e3)}k` : be >= 1e3 ? Math.round(be / 100) / 10 + "k" : be, Fe = Te[se + Le], Ze = Fe === -1 ? {} : Object.assign({}, ue[Fe]);
        return Object.assign(Ze, { cluster: !0, cluster_id: Te[se + qe], point_count: be, point_count_abbreviated: Pe });
      }
      function Xe(Te) {
        return Te / 360 + 0.5;
      }
      function tt(Te) {
        const se = Math.sin(Te * Math.PI / 180), ue = 0.5 - 0.25 * Math.log((1 + se) / (1 - se)) / Math.PI;
        return ue < 0 ? 0 : ue > 1 ? 1 : ue;
      }
      function dt(Te) {
        const se = (180 - 360 * Te) * Math.PI / 180;
        return 360 * Math.atan(Math.exp(se)) / Math.PI - 90;
      }
      function bt(Te, se, ue, be) {
        for (var Pe, Fe = be, Ze = ue - se >> 1, ze = ue - se, Re = Te[se], Ye = Te[se + 1], nt = Te[ue], _t = Te[ue + 1], yt = se + 3; yt < ue; yt += 3) {
          var un = qt(Te[yt], Te[yt + 1], Re, Ye, nt, _t);
          if (un > Fe) Pe = yt, Fe = un;
          else if (un === Fe) {
            var bn = Math.abs(yt - Ze);
            bn < ze && (Pe = yt, ze = bn);
          }
        }
        Fe > be && (Pe - se > 3 && bt(Te, se, Pe, be), Te[Pe + 2] = Fe, ue - Pe > 3 && bt(Te, Pe, ue, be));
      }
      function qt(Te, se, ue, be, Pe, Fe) {
        var Ze = Pe - ue, ze = Fe - be;
        if (Ze !== 0 || ze !== 0) {
          var Re = ((Te - ue) * Ze + (se - be) * ze) / (Ze * Ze + ze * ze);
          Re > 1 ? (ue = Pe, be = Fe) : Re > 0 && (ue += Ze * Re, be += ze * Re);
        }
        return (Ze = Te - ue) * Ze + (ze = se - be) * ze;
      }
      function Oe(Te, se, ue, be) {
        var Pe = { id: Te === void 0 ? null : Te, type: se, geometry: ue, tags: be, minX: 1 / 0, minY: 1 / 0, maxX: -1 / 0, maxY: -1 / 0 };
        return function(Fe) {
          var Ze = Fe.geometry, ze = Fe.type;
          if (ze === "Point" || ze === "MultiPoint" || ze === "LineString") Bt(Fe, Ze);
          else if (ze === "Polygon" || ze === "MultiLineString") for (var Re = 0; Re < Ze.length; Re++) Bt(Fe, Ze[Re]);
          else if (ze === "MultiPolygon") for (Re = 0; Re < Ze.length; Re++) for (var Ye = 0; Ye < Ze[Re].length; Ye++) Bt(Fe, Ze[Re][Ye]);
        }(Pe), Pe;
      }
      function Bt(Te, se) {
        for (var ue = 0; ue < se.length; ue += 3) Te.minX = Math.min(Te.minX, se[ue]), Te.minY = Math.min(Te.minY, se[ue + 1]), Te.maxX = Math.max(Te.maxX, se[ue]), Te.maxY = Math.max(Te.maxY, se[ue + 1]);
      }
      function Tn(Te, se, ue, be) {
        if (se.geometry) {
          var Pe = se.geometry.coordinates, Fe = se.geometry.type, Ze = Math.pow(ue.tolerance / ((1 << ue.maxZoom) * ue.extent), 2), ze = [], Re = se.id;
          if (ue.promoteId ? Re = se.properties[ue.promoteId] : ue.generateId && (Re = be || 0), Fe === "Point") hn(Pe, ze);
          else if (Fe === "MultiPoint") for (var Ye = 0; Ye < Pe.length; Ye++) hn(Pe[Ye], ze);
          else if (Fe === "LineString") Ht(Pe, ze, Ze, !1);
          else if (Fe === "MultiLineString") {
            if (ue.lineMetrics) {
              for (Ye = 0; Ye < Pe.length; Ye++) Ht(Pe[Ye], ze = [], Ze, !1), Te.push(Oe(Re, "LineString", ze, se.properties));
              return;
            }
            qn(Pe, ze, Ze, !1);
          } else if (Fe === "Polygon") qn(Pe, ze, Ze, !0);
          else {
            if (Fe !== "MultiPolygon") {
              if (Fe === "GeometryCollection") {
                for (Ye = 0; Ye < se.geometry.geometries.length; Ye++) Tn(Te, { id: Re, geometry: se.geometry.geometries[Ye], properties: se.properties }, ue, be);
                return;
              }
              throw new Error("Input data is not a valid GeoJSON object.");
            }
            for (Ye = 0; Ye < Pe.length; Ye++) {
              var nt = [];
              qn(Pe[Ye], nt, Ze, !0), ze.push(nt);
            }
          }
          Te.push(Oe(Re, Fe, ze, se.properties));
        }
      }
      function hn(Te, se) {
        se.push(vi(Te[0])), se.push(It(Te[1])), se.push(0);
      }
      function Ht(Te, se, ue, be) {
        for (var Pe, Fe, Ze = 0, ze = 0; ze < Te.length; ze++) {
          var Re = vi(Te[ze][0]), Ye = It(Te[ze][1]);
          se.push(Re), se.push(Ye), se.push(0), ze > 0 && (Ze += be ? (Pe * Ye - Re * Fe) / 2 : Math.sqrt(Math.pow(Re - Pe, 2) + Math.pow(Ye - Fe, 2))), Pe = Re, Fe = Ye;
        }
        var nt = se.length - 3;
        se[2] = 1, bt(se, 0, nt, ue), se[nt + 2] = 1, se.size = Math.abs(Ze), se.start = 0, se.end = se.size;
      }
      function qn(Te, se, ue, be) {
        for (var Pe = 0; Pe < Te.length; Pe++) {
          var Fe = [];
          Ht(Te[Pe], Fe, ue, be), se.push(Fe);
        }
      }
      function vi(Te) {
        return Te / 360 + 0.5;
      }
      function It(Te) {
        var se = Math.sin(Te * Math.PI / 180), ue = 0.5 - 0.25 * Math.log((1 + se) / (1 - se)) / Math.PI;
        return ue < 0 ? 0 : ue > 1 ? 1 : ue;
      }
      function wn(Te, se, ue, be, Pe, Fe, Ze, ze) {
        if (be /= se, Fe >= (ue /= se) && Ze < be) return Te;
        if (Ze < ue || Fe >= be) return null;
        for (var Re = [], Ye = 0; Ye < Te.length; Ye++) {
          var nt = Te[Ye], _t = nt.geometry, yt = nt.type, un = Pe === 0 ? nt.minX : nt.minY, bn = Pe === 0 ? nt.maxX : nt.maxY;
          if (un >= ue && bn < be) Re.push(nt);
          else if (!(bn < ue || un >= be)) {
            var Kt = [];
            if (yt === "Point" || yt === "MultiPoint") Oi(_t, Kt, ue, be, Pe);
            else if (yt === "LineString") hr(_t, Kt, ue, be, Pe, !1, ze.lineMetrics);
            else if (yt === "MultiLineString") kt(_t, Kt, ue, be, Pe, !1);
            else if (yt === "Polygon") kt(_t, Kt, ue, be, Pe, !0);
            else if (yt === "MultiPolygon") for (var an = 0; an < _t.length; an++) {
              var dn = [];
              kt(_t[an], dn, ue, be, Pe, !0), dn.length && Kt.push(dn);
            }
            if (Kt.length) {
              if (ze.lineMetrics && yt === "LineString") {
                for (an = 0; an < Kt.length; an++) Re.push(Oe(nt.id, yt, Kt[an], nt.tags));
                continue;
              }
              yt !== "LineString" && yt !== "MultiLineString" || (Kt.length === 1 ? (yt = "LineString", Kt = Kt[0]) : yt = "MultiLineString"), yt !== "Point" && yt !== "MultiPoint" || (yt = Kt.length === 3 ? "Point" : "MultiPoint"), Re.push(Oe(nt.id, yt, Kt, nt.tags));
            }
          }
        }
        return Re.length ? Re : null;
      }
      function Oi(Te, se, ue, be, Pe) {
        for (var Fe = 0; Fe < Te.length; Fe += 3) {
          var Ze = Te[Fe + Pe];
          Ze >= ue && Ze <= be && (se.push(Te[Fe]), se.push(Te[Fe + 1]), se.push(Te[Fe + 2]));
        }
      }
      function hr(Te, se, ue, be, Pe, Fe, Ze) {
        for (var ze, Re, Ye = qi(Te), nt = Pe === 0 ? ai : Hr, _t = Te.start, yt = 0; yt < Te.length - 3; yt += 3) {
          var un = Te[yt], bn = Te[yt + 1], Kt = Te[yt + 2], an = Te[yt + 3], dn = Te[yt + 4], Bn = Pe === 0 ? un : bn, An = Pe === 0 ? an : dn, Un = !1;
          Ze && (ze = Math.sqrt(Math.pow(un - an, 2) + Math.pow(bn - dn, 2))), Bn < ue ? An > ue && (Re = nt(Ye, un, bn, an, dn, ue), Ze && (Ye.start = _t + ze * Re)) : Bn > be ? An < be && (Re = nt(Ye, un, bn, an, dn, be), Ze && (Ye.start = _t + ze * Re)) : wi(Ye, un, bn, Kt), An < ue && Bn >= ue && (Re = nt(Ye, un, bn, an, dn, ue), Un = !0), An > be && Bn <= be && (Re = nt(Ye, un, bn, an, dn, be), Un = !0), !Fe && Un && (Ze && (Ye.end = _t + ze * Re), se.push(Ye), Ye = qi(Te)), Ze && (_t += ze);
        }
        var ei = Te.length - 3;
        un = Te[ei], bn = Te[ei + 1], Kt = Te[ei + 2], (Bn = Pe === 0 ? un : bn) >= ue && Bn <= be && wi(Ye, un, bn, Kt), ei = Ye.length - 3, Fe && ei >= 3 && (Ye[ei] !== Ye[0] || Ye[ei + 1] !== Ye[1]) && wi(Ye, Ye[0], Ye[1], Ye[2]), Ye.length && se.push(Ye);
      }
      function qi(Te) {
        var se = [];
        return se.size = Te.size, se.start = Te.start, se.end = Te.end, se;
      }
      function kt(Te, se, ue, be, Pe, Fe) {
        for (var Ze = 0; Ze < Te.length; Ze++) hr(Te[Ze], se, ue, be, Pe, Fe, !1);
      }
      function wi(Te, se, ue, be) {
        Te.push(se), Te.push(ue), Te.push(be);
      }
      function ai(Te, se, ue, be, Pe, Fe) {
        var Ze = (Fe - se) / (be - se);
        return Te.push(Fe), Te.push(ue + (Pe - ue) * Ze), Te.push(1), Ze;
      }
      function Hr(Te, se, ue, be, Pe, Fe) {
        var Ze = (Fe - ue) / (Pe - ue);
        return Te.push(se + (be - se) * Ze), Te.push(Fe), Te.push(1), Ze;
      }
      function hs(Te, se) {
        for (var ue = [], be = 0; be < Te.length; be++) {
          var Pe, Fe = Te[be], Ze = Fe.type;
          if (Ze === "Point" || Ze === "MultiPoint" || Ze === "LineString") Pe = Pt(Fe.geometry, se);
          else if (Ze === "MultiLineString" || Ze === "Polygon") {
            Pe = [];
            for (var ze = 0; ze < Fe.geometry.length; ze++) Pe.push(Pt(Fe.geometry[ze], se));
          } else if (Ze === "MultiPolygon") for (Pe = [], ze = 0; ze < Fe.geometry.length; ze++) {
            for (var Re = [], Ye = 0; Ye < Fe.geometry[ze].length; Ye++) Re.push(Pt(Fe.geometry[ze][Ye], se));
            Pe.push(Re);
          }
          ue.push(Oe(Fe.id, Ze, Pe, Fe.tags));
        }
        return ue;
      }
      function Pt(Te, se) {
        var ue = [];
        ue.size = Te.size, Te.start !== void 0 && (ue.start = Te.start, ue.end = Te.end);
        for (var be = 0; be < Te.length; be += 3) ue.push(Te[be] + se, Te[be + 1], Te[be + 2]);
        return ue;
      }
      function $n(Te, se) {
        if (Te.transformed) return Te;
        var ue, be, Pe, Fe = 1 << Te.z, Ze = Te.x, ze = Te.y;
        for (ue = 0; ue < Te.features.length; ue++) {
          var Re = Te.features[ue], Ye = Re.geometry, nt = Re.type;
          if (Re.geometry = [], nt === 1) for (be = 0; be < Ye.length; be += 2) Re.geometry.push(yn(Ye[be], Ye[be + 1], se, Fe, Ze, ze));
          else for (be = 0; be < Ye.length; be++) {
            var _t = [];
            for (Pe = 0; Pe < Ye[be].length; Pe += 2) _t.push(yn(Ye[be][Pe], Ye[be][Pe + 1], se, Fe, Ze, ze));
            Re.geometry.push(_t);
          }
        }
        return Te.transformed = !0, Te;
      }
      function yn(Te, se, ue, be, Pe, Fe) {
        return [Math.round(ue * (Te * be - Pe)), Math.round(ue * (se * be - Fe))];
      }
      function Qi(Te, se, ue, be, Pe) {
        for (var Fe = se === Pe.maxZoom ? 0 : Pe.tolerance / ((1 << se) * Pe.extent), Ze = { features: [], numPoints: 0, numSimplified: 0, numFeatures: 0, source: null, x: ue, y: be, z: se, transformed: !1, minX: 2, minY: 1, maxX: -1, maxY: 0 }, ze = 0; ze < Te.length; ze++) {
          Ze.numFeatures++, Gi(Ze, Te[ze], Fe, Pe);
          var Re = Te[ze].minX, Ye = Te[ze].minY, nt = Te[ze].maxX, _t = Te[ze].maxY;
          Re < Ze.minX && (Ze.minX = Re), Ye < Ze.minY && (Ze.minY = Ye), nt > Ze.maxX && (Ze.maxX = nt), _t > Ze.maxY && (Ze.maxY = _t);
        }
        return Ze;
      }
      function Gi(Te, se, ue, be) {
        var Pe = se.geometry, Fe = se.type, Ze = [];
        if (Fe === "Point" || Fe === "MultiPoint") for (var ze = 0; ze < Pe.length; ze += 3) Ze.push(Pe[ze]), Ze.push(Pe[ze + 1]), Te.numPoints++, Te.numSimplified++;
        else if (Fe === "LineString") Cn(Ze, Pe, Te, ue, !1, !1);
        else if (Fe === "MultiLineString" || Fe === "Polygon") for (ze = 0; ze < Pe.length; ze++) Cn(Ze, Pe[ze], Te, ue, Fe === "Polygon", ze === 0);
        else if (Fe === "MultiPolygon") for (var Re = 0; Re < Pe.length; Re++) {
          var Ye = Pe[Re];
          for (ze = 0; ze < Ye.length; ze++) Cn(Ze, Ye[ze], Te, ue, !0, ze === 0);
        }
        if (Ze.length) {
          var nt = se.tags || null;
          if (Fe === "LineString" && be.lineMetrics) {
            for (var _t in nt = {}, se.tags) nt[_t] = se.tags[_t];
            nt.mapbox_clip_start = Pe.start / Pe.size, nt.mapbox_clip_end = Pe.end / Pe.size;
          }
          var yt = { geometry: Ze, type: Fe === "Polygon" || Fe === "MultiPolygon" ? 3 : Fe === "LineString" || Fe === "MultiLineString" ? 2 : 1, tags: nt };
          se.id !== null && (yt.id = se.id), Te.features.push(yt);
        }
      }
      function Cn(Te, se, ue, be, Pe, Fe) {
        var Ze = be * be;
        if (be > 0 && se.size < (Pe ? Ze : be)) ue.numPoints += se.length / 3;
        else {
          for (var ze = [], Re = 0; Re < se.length; Re += 3) (be === 0 || se[Re + 2] > Ze) && (ue.numSimplified++, ze.push(se[Re]), ze.push(se[Re + 1])), ue.numPoints++;
          Pe && function(Ye, nt) {
            for (var _t = 0, yt = 0, un = Ye.length, bn = un - 2; yt < un; bn = yt, yt += 2) _t += (Ye[yt] - Ye[bn]) * (Ye[yt + 1] + Ye[bn + 1]);
            if (_t > 0 === nt) for (yt = 0, un = Ye.length; yt < un / 2; yt += 2) {
              var Kt = Ye[yt], an = Ye[yt + 1];
              Ye[yt] = Ye[un - 2 - yt], Ye[yt + 1] = Ye[un - 1 - yt], Ye[un - 2 - yt] = Kt, Ye[un - 1 - yt] = an;
            }
          }(ze, Fe), Te.push(ze);
        }
      }
      function or(Te, se) {
        var ue = (se = this.options = function(Pe, Fe) {
          for (var Ze in Fe) Pe[Ze] = Fe[Ze];
          return Pe;
        }(Object.create(this.options), se)).debug;
        if (ue && console.time("preprocess data"), se.maxZoom < 0 || se.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
        if (se.promoteId && se.generateId) throw new Error("promoteId and generateId cannot be used together.");
        var be = function(Pe, Fe) {
          var Ze = [];
          if (Pe.type === "FeatureCollection") for (var ze = 0; ze < Pe.features.length; ze++) Tn(Ze, Pe.features[ze], Fe, ze);
          else Tn(Ze, Pe.type === "Feature" ? Pe : { geometry: Pe }, Fe);
          return Ze;
        }(Te, se);
        this.tiles = {}, this.tileCoords = [], ue && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", se.indexMaxZoom, se.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), be = function(Pe, Fe) {
          var Ze = Fe.buffer / Fe.extent, ze = Pe, Re = wn(Pe, 1, -1 - Ze, Ze, 0, -1, 2, Fe), Ye = wn(Pe, 1, 1 - Ze, 2 + Ze, 0, -1, 2, Fe);
          return (Re || Ye) && (ze = wn(Pe, 1, -Ze, 1 + Ze, 0, -1, 2, Fe) || [], Re && (ze = hs(Re, 1).concat(ze)), Ye && (ze = ze.concat(hs(Ye, -1)))), ze;
        }(be, se), be.length && this.splitTile(be, 0, 0, 0), ue && (be.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
      }
      function Wr(Te, se, ue) {
        return 32 * ((1 << Te) * ue + se) + Te;
      }
      function kr(Te, se) {
        return se ? Te.properties[se] : Te.id;
      }
      function fs(Te, se) {
        if (Te == null) return !0;
        if (Te.type === "Feature") return kr(Te, se) != null;
        if (Te.type === "FeatureCollection") {
          const ue = /* @__PURE__ */ new Set();
          for (const be of Te.features) {
            const Pe = kr(be, se);
            if (Pe == null || ue.has(Pe)) return !1;
            ue.add(Pe);
          }
          return !0;
        }
        return !1;
      }
      function tr(Te, se) {
        const ue = /* @__PURE__ */ new Map();
        if (Te != null) if (Te.type === "Feature") ue.set(kr(Te, se), Te);
        else for (const be of Te.features) ue.set(kr(be, se), be);
        return ue;
      }
      function pi(Te, se) {
        const ue = Te.tileID.canonical;
        if (!this._geoJSONIndex) return se(null, null);
        const be = this._geoJSONIndex.getTile(ue.z, ue.x, ue.y);
        if (!be) return se(null, null);
        const Pe = new class {
          constructor(Ze) {
            this.layers = { _geojsonTileLayer: this }, this.name = "_geojsonTileLayer", this.extent = a.EXTENT, this.length = Ze.length, this._features = Ze;
          }
          feature(Ze) {
            return new class {
              constructor(ze) {
                this._feature = ze, this.extent = a.EXTENT, this.type = ze.type, this.properties = ze.tags, "id" in ze && !isNaN(ze.id) && (this.id = parseInt(ze.id, 10));
              }
              loadGeometry() {
                if (this._feature.type === 1) {
                  const ze = [];
                  for (const Re of this._feature.geometry) ze.push([new a.Point(Re[0], Re[1])]);
                  return ze;
                }
                {
                  const ze = [];
                  for (const Re of this._feature.geometry) {
                    const Ye = [];
                    for (const nt of Re) Ye.push(new a.Point(nt[0], nt[1]));
                    ze.push(Ye);
                  }
                  return ze;
                }
              }
              toGeoJSON(ze, Re, Ye) {
                return K.call(this, ze, Re, Ye);
              }
            }(this._features[Ze]);
          }
        }(be.features);
        let Fe = ft(Pe);
        Fe.byteOffset === 0 && Fe.byteLength === Fe.buffer.byteLength || (Fe = new Uint8Array(Fe)), se(null, { vectorTile: Pe, rawData: Fe.buffer });
      }
      or.prototype.options = { maxZoom: 14, indexMaxZoom: 5, indexMaxPoints: 1e5, tolerance: 3, extent: 4096, buffer: 64, lineMetrics: !1, promoteId: null, generateId: !1, debug: 0 }, or.prototype.splitTile = function(Te, se, ue, be, Pe, Fe, Ze) {
        for (var ze = [Te, se, ue, be], Re = this.options, Ye = Re.debug; ze.length; ) {
          be = ze.pop(), ue = ze.pop(), se = ze.pop(), Te = ze.pop();
          var nt = 1 << se, _t = Wr(se, ue, be), yt = this.tiles[_t];
          if (!yt && (Ye > 1 && console.time("creation"), yt = this.tiles[_t] = Qi(Te, se, ue, be, Re), this.tileCoords.push({ z: se, x: ue, y: be }), Ye)) {
            Ye > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", se, ue, be, yt.numFeatures, yt.numPoints, yt.numSimplified), console.timeEnd("creation"));
            var un = "z" + se;
            this.stats[un] = (this.stats[un] || 0) + 1, this.total++;
          }
          if (yt.source = Te, Pe) {
            if (se === Re.maxZoom || se === Pe) continue;
            var bn = 1 << Pe - se;
            if (ue !== Math.floor(Fe / bn) || be !== Math.floor(Ze / bn)) continue;
          } else if (se === Re.indexMaxZoom || yt.numPoints <= Re.indexMaxPoints) continue;
          if (yt.source = null, Te.length !== 0) {
            Ye > 1 && console.time("clipping");
            var Kt, an, dn, Bn, An, Un, ei = 0.5 * Re.buffer / Re.extent, Yi = 0.5 - ei, _n = 0.5 + ei, Ni = 1 + ei;
            Kt = an = dn = Bn = null, An = wn(Te, nt, ue - ei, ue + _n, 0, yt.minX, yt.maxX, Re), Un = wn(Te, nt, ue + Yi, ue + Ni, 0, yt.minX, yt.maxX, Re), Te = null, An && (Kt = wn(An, nt, be - ei, be + _n, 1, yt.minY, yt.maxY, Re), an = wn(An, nt, be + Yi, be + Ni, 1, yt.minY, yt.maxY, Re), An = null), Un && (dn = wn(Un, nt, be - ei, be + _n, 1, yt.minY, yt.maxY, Re), Bn = wn(Un, nt, be + Yi, be + Ni, 1, yt.minY, yt.maxY, Re), Un = null), Ye > 1 && console.timeEnd("clipping"), ze.push(Kt || [], se + 1, 2 * ue, 2 * be), ze.push(an || [], se + 1, 2 * ue, 2 * be + 1), ze.push(dn || [], se + 1, 2 * ue + 1, 2 * be), ze.push(Bn || [], se + 1, 2 * ue + 1, 2 * be + 1);
          }
        }
      }, or.prototype.getTile = function(Te, se, ue) {
        var be = this.options, Pe = be.extent, Fe = be.debug;
        if (Te < 0 || Te > 24) return null;
        var Ze = 1 << Te, ze = Wr(Te, se = (se % Ze + Ze) % Ze, ue);
        if (this.tiles[ze]) return $n(this.tiles[ze], Pe);
        Fe > 1 && console.log("drilling down to z%d-%d-%d", Te, se, ue);
        for (var Re, Ye = Te, nt = se, _t = ue; !Re && Ye > 0; ) Ye--, nt = Math.floor(nt / 2), _t = Math.floor(_t / 2), Re = this.tiles[Wr(Ye, nt, _t)];
        return Re && Re.source ? (Fe > 1 && console.log("found parent tile z%d-%d-%d", Ye, nt, _t), Fe > 1 && console.time("drilling down"), this.splitTile(Re.source, Ye, nt, _t, Te, se, ue), Fe > 1 && console.timeEnd("drilling down"), this.tiles[ze] ? $n(this.tiles[ze], Pe) : null) : null;
      };
      class ga extends I {
        constructor(se, ue, be, Pe) {
          super(se, ue, be, pi), this._dataUpdateable = /* @__PURE__ */ new Map(), this.loadGeoJSON = (Fe, Ze) => {
            const { promoteId: ze } = Fe;
            if (Fe.request) return a.getJSON(Fe.request, (Re, Ye, nt, _t) => {
              this._dataUpdateable = fs(Ye, ze) ? tr(Ye, ze) : void 0, Ze(Re, Ye, nt, _t);
            });
            if (typeof Fe.data == "string") try {
              const Re = JSON.parse(Fe.data);
              this._dataUpdateable = fs(Re, ze) ? tr(Re, ze) : void 0, Ze(null, Re);
            } catch {
              Ze(new Error(`Input data given to '${Fe.source}' is not a valid GeoJSON object.`));
            }
            else Fe.dataDiff ? this._dataUpdateable ? (function(Re, Ye, nt) {
              var _t, yt, un, bn;
              if (Ye.removeAll && Re.clear(), Ye.remove) for (const Kt of Ye.remove) Re.delete(Kt);
              if (Ye.add) for (const Kt of Ye.add) {
                const an = kr(Kt, nt);
                an != null && Re.set(an, Kt);
              }
              if (Ye.update) for (const Kt of Ye.update) {
                let an = Re.get(Kt.id);
                if (an == null) continue;
                const dn = !Kt.removeAllProperties && (((_t = Kt.removeProperties) === null || _t === void 0 ? void 0 : _t.length) > 0 || ((yt = Kt.addOrUpdateProperties) === null || yt === void 0 ? void 0 : yt.length) > 0);
                if ((Kt.newGeometry || Kt.removeAllProperties || dn) && (an = { ...an }, Re.set(Kt.id, an), dn && (an.properties = { ...an.properties })), Kt.newGeometry && (an.geometry = Kt.newGeometry), Kt.removeAllProperties) an.properties = {};
                else if (((un = Kt.removeProperties) === null || un === void 0 ? void 0 : un.length) > 0) for (const Bn of Kt.removeProperties) Object.prototype.hasOwnProperty.call(an.properties, Bn) && delete an.properties[Bn];
                if (((bn = Kt.addOrUpdateProperties) === null || bn === void 0 ? void 0 : bn.length) > 0) for (const { key: Bn, value: An } of Kt.addOrUpdateProperties) an.properties[Bn] = An;
              }
            }(this._dataUpdateable, Fe.dataDiff, ze), Ze(null, { type: "FeatureCollection", features: Array.from(this._dataUpdateable.values()) })) : Ze(new Error(`Cannot update existing geojson data in ${Fe.source}`)) : Ze(new Error(`Input data given to '${Fe.source}' is not a valid GeoJSON object.`));
            return { cancel: () => {
            } };
          }, Pe && (this.loadGeoJSON = Pe);
        }
        loadData(se, ue) {
          var be;
          (be = this._pendingRequest) === null || be === void 0 || be.cancel(), this._pendingCallback && this._pendingCallback(null, { abandoned: !0 });
          const Pe = !!(se && se.request && se.request.collectResourceTiming) && new a.RequestPerformance(se.request);
          this._pendingCallback = ue, this._pendingRequest = this.loadGeoJSON(se, (Fe, Ze) => {
            if (delete this._pendingCallback, delete this._pendingRequest, Fe || !Ze) return ue(Fe);
            if (typeof Ze != "object") return ue(new Error(`Input data given to '${se.source}' is not a valid GeoJSON object.`));
            {
              N(Ze, !0);
              try {
                if (se.filter) {
                  const Re = a.createExpression(se.filter, { type: "boolean", "property-type": "data-driven", overridable: !1, transition: !1 });
                  if (Re.result === "error") throw new Error(Re.value.map((nt) => `${nt.key}: ${nt.message}`).join(", "));
                  Ze = { type: "FeatureCollection", features: Ze.features.filter((nt) => Re.value.evaluate({ zoom: 0 }, nt)) };
                }
                this._geoJSONIndex = se.cluster ? new Je(function({ superclusterOptions: Re, clusterProperties: Ye }) {
                  if (!Ye || !Re) return Re;
                  const nt = {}, _t = {}, yt = { accumulated: null, zoom: 0 }, un = { properties: null }, bn = Object.keys(Ye);
                  for (const Kt of bn) {
                    const [an, dn] = Ye[Kt], Bn = a.createExpression(dn), An = a.createExpression(typeof an == "string" ? [an, ["accumulated"], ["get", Kt]] : an);
                    nt[Kt] = Bn.value, _t[Kt] = An.value;
                  }
                  return Re.map = (Kt) => {
                    un.properties = Kt;
                    const an = {};
                    for (const dn of bn) an[dn] = nt[dn].evaluate(yt, un);
                    return an;
                  }, Re.reduce = (Kt, an) => {
                    un.properties = an;
                    for (const dn of bn) yt.accumulated = Kt[dn], Kt[dn] = _t[dn].evaluate(yt, un);
                  }, Re;
                }(se)).load(Ze.features) : function(Re, Ye) {
                  return new or(Re, Ye);
                }(Ze, se.geojsonVtOptions);
              } catch (Re) {
                return ue(Re);
              }
              this.loaded = {};
              const ze = {};
              if (Pe) {
                const Re = Pe.finish();
                Re && (ze.resourceTiming = {}, ze.resourceTiming[se.source] = JSON.parse(JSON.stringify(Re)));
              }
              ue(null, ze);
            }
          });
        }
        reloadTile(se, ue) {
          const be = this.loaded;
          return be && be[se.uid] ? super.reloadTile(se, ue) : this.loadTile(se, ue);
        }
        removeSource(se, ue) {
          this._pendingCallback && this._pendingCallback(null, { abandoned: !0 }), ue();
        }
        getClusterExpansionZoom(se, ue) {
          try {
            ue(null, this._geoJSONIndex.getClusterExpansionZoom(se.clusterId));
          } catch (be) {
            ue(be);
          }
        }
        getClusterChildren(se, ue) {
          try {
            ue(null, this._geoJSONIndex.getChildren(se.clusterId));
          } catch (be) {
            ue(be);
          }
        }
        getClusterLeaves(se, ue) {
          try {
            ue(null, this._geoJSONIndex.getLeaves(se.clusterId, se.limit, se.offset));
          } catch (be) {
            ue(be);
          }
        }
      }
      class As {
        constructor(se) {
          this.self = se, this.actor = new a.Actor(se, this), this.layerIndexes = {}, this.availableImages = {}, this.workerSourceTypes = { vector: I, geojson: ga }, this.workerSources = {}, this.demWorkerSources = {}, this.self.registerWorkerSource = (ue, be) => {
            if (this.workerSourceTypes[ue]) throw new Error(`Worker source with name "${ue}" already registered.`);
            this.workerSourceTypes[ue] = be;
          }, this.self.registerRTLTextPlugin = (ue) => {
            if (a.plugin.isParsed()) throw new Error("RTL text plugin already registered.");
            a.plugin.applyArabicShaping = ue.applyArabicShaping, a.plugin.processBidirectionalText = ue.processBidirectionalText, a.plugin.processStyledBidirectionalText = ue.processStyledBidirectionalText;
          };
        }
        setReferrer(se, ue) {
          this.referrer = ue;
        }
        setImages(se, ue, be) {
          this.availableImages[se] = ue;
          for (const Pe in this.workerSources[se]) {
            const Fe = this.workerSources[se][Pe];
            for (const Ze in Fe) Fe[Ze].availableImages = ue;
          }
          be();
        }
        setLayers(se, ue, be) {
          this.getLayerIndex(se).replace(ue), be();
        }
        updateLayers(se, ue, be) {
          this.getLayerIndex(se).update(ue.layers, ue.removedIds), be();
        }
        loadTile(se, ue, be) {
          this.getWorkerSource(se, ue.type, ue.source).loadTile(ue, be);
        }
        loadDEMTile(se, ue, be) {
          this.getDEMWorkerSource(se, ue.source).loadTile(ue, be);
        }
        reloadTile(se, ue, be) {
          this.getWorkerSource(se, ue.type, ue.source).reloadTile(ue, be);
        }
        abortTile(se, ue, be) {
          this.getWorkerSource(se, ue.type, ue.source).abortTile(ue, be);
        }
        removeTile(se, ue, be) {
          this.getWorkerSource(se, ue.type, ue.source).removeTile(ue, be);
        }
        removeDEMTile(se, ue) {
          this.getDEMWorkerSource(se, ue.source).removeTile(ue);
        }
        removeSource(se, ue, be) {
          if (!this.workerSources[se] || !this.workerSources[se][ue.type] || !this.workerSources[se][ue.type][ue.source]) return;
          const Pe = this.workerSources[se][ue.type][ue.source];
          delete this.workerSources[se][ue.type][ue.source], Pe.removeSource !== void 0 ? Pe.removeSource(ue, be) : be();
        }
        loadWorkerSource(se, ue, be) {
          try {
            this.self.importScripts(ue.url), be();
          } catch (Pe) {
            be(Pe.toString());
          }
        }
        syncRTLPluginState(se, ue, be) {
          try {
            a.plugin.setState(ue);
            const Pe = a.plugin.getPluginURL();
            if (a.plugin.isLoaded() && !a.plugin.isParsed() && Pe != null) {
              this.self.importScripts(Pe);
              const Fe = a.plugin.isParsed();
              be(Fe ? void 0 : new Error(`RTL Text Plugin failed to import scripts from ${Pe}`), Fe);
            }
          } catch (Pe) {
            be(Pe.toString());
          }
        }
        getAvailableImages(se) {
          let ue = this.availableImages[se];
          return ue || (ue = []), ue;
        }
        getLayerIndex(se) {
          let ue = this.layerIndexes[se];
          return ue || (ue = this.layerIndexes[se] = new f()), ue;
        }
        getWorkerSource(se, ue, be) {
          if (this.workerSources[se] || (this.workerSources[se] = {}), this.workerSources[se][ue] || (this.workerSources[se][ue] = {}), !this.workerSources[se][ue][be]) {
            const Pe = { send: (Fe, Ze, ze) => {
              this.actor.send(Fe, Ze, ze, se);
            } };
            this.workerSources[se][ue][be] = new this.workerSourceTypes[ue](Pe, this.getLayerIndex(se), this.getAvailableImages(se));
          }
          return this.workerSources[se][ue][be];
        }
        getDEMWorkerSource(se, ue) {
          return this.demWorkerSources[se] || (this.demWorkerSources[se] = {}), this.demWorkerSources[se][ue] || (this.demWorkerSources[se][ue] = new O()), this.demWorkerSources[se][ue];
        }
      }
      return a.isWorker() && (self.worker = new As(self)), As;
    }), c(["./shared"], function(a) {
      var f = "3.1.0";
      class g {
        static testProp(o) {
          if (!g.docStyle) return o[0];
          for (let h = 0; h < o.length; h++) if (o[h] in g.docStyle) return o[h];
          return o[0];
        }
        static create(o, h, v) {
          const w = window.document.createElement(o);
          return h !== void 0 && (w.className = h), v && v.appendChild(w), w;
        }
        static createNS(o, h) {
          return window.document.createElementNS(o, h);
        }
        static disableDrag() {
          g.docStyle && g.selectProp && (g.userSelect = g.docStyle[g.selectProp], g.docStyle[g.selectProp] = "none");
        }
        static enableDrag() {
          g.docStyle && g.selectProp && (g.docStyle[g.selectProp] = g.userSelect);
        }
        static setTransform(o, h) {
          o.style[g.transformProp] = h;
        }
        static addEventListener(o, h, v, w = {}) {
          o.addEventListener(h, v, "passive" in w ? w : w.capture);
        }
        static removeEventListener(o, h, v, w = {}) {
          o.removeEventListener(h, v, "passive" in w ? w : w.capture);
        }
        static suppressClickInternal(o) {
          o.preventDefault(), o.stopPropagation(), window.removeEventListener("click", g.suppressClickInternal, !0);
        }
        static suppressClick() {
          window.addEventListener("click", g.suppressClickInternal, !0), window.setTimeout(() => {
            window.removeEventListener("click", g.suppressClickInternal, !0);
          }, 0);
        }
        static mousePos(o, h) {
          const v = o.getBoundingClientRect();
          return new a.Point(h.clientX - v.left - o.clientLeft, h.clientY - v.top - o.clientTop);
        }
        static touchPos(o, h) {
          const v = o.getBoundingClientRect(), w = [];
          for (let S = 0; S < h.length; S++) w.push(new a.Point(h[S].clientX - v.left - o.clientLeft, h[S].clientY - v.top - o.clientTop));
          return w;
        }
        static mouseButton(o) {
          return o.button;
        }
        static remove(o) {
          o.parentNode && o.parentNode.removeChild(o);
        }
      }
      g.docStyle = typeof window < "u" && window.document && window.document.documentElement.style, g.selectProp = g.testProp(["userSelect", "MozUserSelect", "WebkitUserSelect", "msUserSelect"]), g.transformProp = g.testProp(["transform", "WebkitTransform"]);
      const x = { supported: !1, testSupport: function(_) {
        !I && A && (O ? B(_) : $ = _);
      } };
      let $, A, I = !1, O = !1;
      function B(_) {
        const o = _.createTexture();
        _.bindTexture(_.TEXTURE_2D, o);
        try {
          if (_.texImage2D(_.TEXTURE_2D, 0, _.RGBA, _.RGBA, _.UNSIGNED_BYTE, A), _.isContextLost()) return;
          x.supported = !0;
        } catch {
        }
        _.deleteTexture(o), I = !0;
      }
      var H;
      typeof document < "u" && (A = document.createElement("img"), A.onload = function() {
        $ && B($), $ = null, O = !0;
      }, A.onerror = function() {
        I = !0, $ = null;
      }, A.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA="), function(_) {
        let o, h, v, w;
        _.resetRequestQueue = () => {
          o = [], h = 0, v = 0, w = {};
        }, _.addThrottleControl = (W) => {
          const Q = v++;
          return w[Q] = W, Q;
        }, _.removeThrottleControl = (W) => {
          delete w[W], z();
        }, _.getImage = (W, Q, J = !0) => {
          x.supported && (W.headers || (W.headers = {}), W.headers.accept = "image/webp,*/*");
          const fe = { requestParameters: W, supportImageRefresh: J, callback: Q, cancelled: !1, completed: !1, cancel: () => {
            fe.completed || fe.cancelled || (fe.cancelled = !0, fe.innerRequest && (fe.innerRequest.cancel(), h--), z());
          } };
          return o.push(fe), z(), fe;
        };
        const S = (W) => {
          const { requestParameters: Q, supportImageRefresh: J, callback: fe } = W;
          return a.extend(Q, { type: "image" }), (J !== !1 || a.isWorker() || a.getProtocolAction(Q.url) || Q.headers && !Object.keys(Q.headers).reduce((Se, we) => Se && we === "accept", !0) ? a.makeRequest : R)(Q, (Se, we, Ce, Me) => {
            M(W, fe, Se, we, Ce, Me);
          });
        }, M = (W, Q, J, fe, Se, we) => {
          J ? Q(J) : fe instanceof HTMLImageElement || fe instanceof ImageBitmap ? Q(null, fe) : fe && ((Ce, Me) => {
            typeof createImageBitmap == "function" ? a.arrayBufferToImageBitmap(Ce, Me) : a.arrayBufferToImage(Ce, Me);
          })(fe, (Ce, Me) => {
            Ce != null ? Q(Ce) : Me != null && Q(null, Me, { cacheControl: Se, expires: we });
          }), W.cancelled || (W.completed = !0, h--, z());
        }, z = () => {
          const W = (() => {
            const Q = Object.keys(w);
            let J = !1;
            if (Q.length > 0) {
              for (const fe of Q) if (J = w[fe](), J) break;
            }
            return J;
          })() ? a.config.MAX_PARALLEL_IMAGE_REQUESTS_PER_FRAME : a.config.MAX_PARALLEL_IMAGE_REQUESTS;
          for (let Q = h; Q < W && o.length > 0; Q++) {
            const J = o.shift();
            if (J.cancelled) {
              Q--;
              continue;
            }
            const fe = S(J);
            h++, J.innerRequest = fe;
          }
        }, R = (W, Q) => {
          const J = new Image(), fe = W.url;
          let Se = !1;
          const we = W.credentials;
          return we && we === "include" ? J.crossOrigin = "use-credentials" : (we && we === "same-origin" || !a.sameOrigin(fe)) && (J.crossOrigin = "anonymous"), J.fetchPriority = "high", J.onload = () => {
            Q(null, J), J.onerror = J.onload = null;
          }, J.onerror = () => {
            Se || Q(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.")), J.onerror = J.onload = null;
          }, J.src = fe, { cancel: () => {
            Se = !0, J.src = "";
          } };
        };
      }(H || (H = {})), H.resetRequestQueue();
      var N, K = H;
      (function(_) {
        _.Glyphs = "Glyphs", _.Image = "Image", _.Source = "Source", _.SpriteImage = "SpriteImage", _.SpriteJSON = "SpriteJSON", _.Style = "Style", _.Tile = "Tile", _.Unknown = "Unknown";
      })(N || (N = {}));
      class U {
        constructor(o) {
          this._transformRequestFn = o;
        }
        transformRequest(o, h) {
          return this._transformRequestFn && this._transformRequestFn(o, h) || { url: o };
        }
        normalizeSpriteURL(o, h, v) {
          const w = function(S) {
            const M = S.match(q);
            if (!M) throw new Error(`Unable to parse URL "${S}"`);
            return { protocol: M[1], authority: M[2], path: M[3] || "/", params: M[4] ? M[4].split("&") : [] };
          }(o);
          return w.path += `${h}${v}`, function(S) {
            const M = S.params.length ? `?${S.params.join("&")}` : "";
            return `${S.protocol}://${S.authority}${S.path}${M}`;
          }(w);
        }
        setTransformRequest(o) {
          this._transformRequestFn = o;
        }
      }
      const q = /^(\w+):\/\/([^/?]*)(\/[^?]+)?\??(.+)?/;
      function ee(_) {
        var o = new a.ARRAY_TYPE(3);
        return o[0] = _[0], o[1] = _[1], o[2] = _[2], o;
      }
      var te, ae = function(_, o, h) {
        return _[0] = o[0] - h[0], _[1] = o[1] - h[1], _[2] = o[2] - h[2], _;
      };
      te = new a.ARRAY_TYPE(3), a.ARRAY_TYPE != Float32Array && (te[0] = 0, te[1] = 0, te[2] = 0);
      var oe = function(_) {
        var o = _[0], h = _[1];
        return o * o + h * h;
      };
      function de(_) {
        const o = [];
        if (typeof _ == "string") o.push({ id: "default", url: _ });
        else if (_ && _.length > 0) {
          const h = [];
          for (const { id: v, url: w } of _) {
            const S = `${v}${w}`;
            h.indexOf(S) === -1 && (h.push(S), o.push({ id: v, url: w }));
          }
        }
        return o;
      }
      function me(_, o, h, v, w) {
        if (v) return void _(v);
        if (w !== Object.values(o).length || w !== Object.values(h).length) return;
        const S = {};
        for (const M in o) {
          S[M] = {};
          const z = a.exported.getImageCanvasContext(h[M]), R = o[M];
          for (const W in R) {
            const { width: Q, height: J, x: fe, y: Se, sdf: we, pixelRatio: Ce, stretchX: Me, stretchY: Ue, content: ct } = R[W];
            S[M][W] = { data: null, pixelRatio: Ce, sdf: we, stretchX: Me, stretchY: Ue, content: ct, spriteData: { width: Q, height: J, x: fe, y: Se, context: z } };
          }
        }
        _(null, S);
      }
      (function() {
        var _ = new a.ARRAY_TYPE(2);
        a.ARRAY_TYPE != Float32Array && (_[0] = 0, _[1] = 0);
      })();
      class ve {
        constructor(o, h, v, w) {
          this.context = o, this.format = v, this.texture = o.gl.createTexture(), this.update(h, w);
        }
        update(o, h, v) {
          const { width: w, height: S } = o, M = !(this.size && this.size[0] === w && this.size[1] === S || v), { context: z } = this, { gl: R } = z;
          if (this.useMipmap = !!(h && h.useMipmap), R.bindTexture(R.TEXTURE_2D, this.texture), z.pixelStoreUnpackFlipY.set(!1), z.pixelStoreUnpack.set(1), z.pixelStoreUnpackPremultiplyAlpha.set(this.format === R.RGBA && (!h || h.premultiply !== !1)), M) this.size = [w, S], o instanceof HTMLImageElement || o instanceof HTMLCanvasElement || o instanceof HTMLVideoElement || o instanceof ImageData || a.isImageBitmap(o) ? R.texImage2D(R.TEXTURE_2D, 0, this.format, this.format, R.UNSIGNED_BYTE, o) : R.texImage2D(R.TEXTURE_2D, 0, this.format, w, S, 0, this.format, R.UNSIGNED_BYTE, o.data);
          else {
            const { x: W, y: Q } = v || { x: 0, y: 0 };
            o instanceof HTMLImageElement || o instanceof HTMLCanvasElement || o instanceof HTMLVideoElement || o instanceof ImageData || a.isImageBitmap(o) ? R.texSubImage2D(R.TEXTURE_2D, 0, W, Q, R.RGBA, R.UNSIGNED_BYTE, o) : R.texSubImage2D(R.TEXTURE_2D, 0, W, Q, w, S, R.RGBA, R.UNSIGNED_BYTE, o.data);
          }
          this.useMipmap && this.isSizePowerOfTwo() && R.generateMipmap(R.TEXTURE_2D);
        }
        bind(o, h, v) {
          const { context: w } = this, { gl: S } = w;
          S.bindTexture(S.TEXTURE_2D, this.texture), v !== S.LINEAR_MIPMAP_NEAREST || this.isSizePowerOfTwo() || (v = S.LINEAR), o !== this.filter && (S.texParameteri(S.TEXTURE_2D, S.TEXTURE_MAG_FILTER, o), S.texParameteri(S.TEXTURE_2D, S.TEXTURE_MIN_FILTER, v || o), this.filter = o), h !== this.wrap && (S.texParameteri(S.TEXTURE_2D, S.TEXTURE_WRAP_S, h), S.texParameteri(S.TEXTURE_2D, S.TEXTURE_WRAP_T, h), this.wrap = h);
        }
        isSizePowerOfTwo() {
          return this.size[0] === this.size[1] && Math.log(this.size[0]) / Math.LN2 % 1 == 0;
        }
        destroy() {
          const { gl: o } = this.context;
          o.deleteTexture(this.texture), this.texture = null;
        }
      }
      function re(_) {
        const { userImage: o } = _;
        return !!(o && o.render && o.render()) && (_.data.replace(new Uint8Array(o.data.buffer)), !0);
      }
      class le extends a.Evented {
        constructor() {
          super(), this.images = {}, this.updatedImages = {}, this.callbackDispatchedThisFrame = {}, this.loaded = !1, this.requestors = [], this.patterns = {}, this.atlasImage = new a.RGBAImage({ width: 1, height: 1 }), this.dirty = !0;
        }
        isLoaded() {
          return this.loaded;
        }
        setLoaded(o) {
          if (this.loaded !== o && (this.loaded = o, o)) {
            for (const { ids: h, callback: v } of this.requestors) this._notify(h, v);
            this.requestors = [];
          }
        }
        getImage(o) {
          const h = this.images[o];
          if (h && !h.data && h.spriteData) {
            const v = h.spriteData;
            h.data = new a.RGBAImage({ width: v.width, height: v.height }, v.context.getImageData(v.x, v.y, v.width, v.height).data), h.spriteData = null;
          }
          return h;
        }
        addImage(o, h) {
          if (this.images[o]) throw new Error(`Image id ${o} already exist, use updateImage instead`);
          this._validate(o, h) && (this.images[o] = h);
        }
        _validate(o, h) {
          let v = !0;
          const w = h.data || h.spriteData;
          return this._validateStretch(h.stretchX, w && w.width) || (this.fire(new a.ErrorEvent(new Error(`Image "${o}" has invalid "stretchX" value`))), v = !1), this._validateStretch(h.stretchY, w && w.height) || (this.fire(new a.ErrorEvent(new Error(`Image "${o}" has invalid "stretchY" value`))), v = !1), this._validateContent(h.content, h) || (this.fire(new a.ErrorEvent(new Error(`Image "${o}" has invalid "content" value`))), v = !1), v;
        }
        _validateStretch(o, h) {
          if (!o) return !0;
          let v = 0;
          for (const w of o) {
            if (w[0] < v || w[1] < w[0] || h < w[1]) return !1;
            v = w[1];
          }
          return !0;
        }
        _validateContent(o, h) {
          if (!o) return !0;
          if (o.length !== 4) return !1;
          const v = h.spriteData, w = v && v.width || h.data.width, S = v && v.height || h.data.height;
          return !(o[0] < 0 || w < o[0] || o[1] < 0 || S < o[1] || o[2] < 0 || w < o[2] || o[3] < 0 || S < o[3] || o[2] < o[0] || o[3] < o[1]);
        }
        updateImage(o, h, v = !0) {
          const w = this.getImage(o);
          if (v && (w.data.width !== h.data.width || w.data.height !== h.data.height)) throw new Error(`size mismatch between old image (${w.data.width}x${w.data.height}) and new image (${h.data.width}x${h.data.height}).`);
          h.version = w.version + 1, this.images[o] = h, this.updatedImages[o] = !0;
        }
        removeImage(o) {
          const h = this.images[o];
          delete this.images[o], delete this.patterns[o], h.userImage && h.userImage.onRemove && h.userImage.onRemove();
        }
        listImages() {
          return Object.keys(this.images);
        }
        getImages(o, h) {
          let v = !0;
          if (!this.isLoaded()) for (const w of o) this.images[w] || (v = !1);
          this.isLoaded() || v ? this._notify(o, h) : this.requestors.push({ ids: o, callback: h });
        }
        _notify(o, h) {
          const v = {};
          for (const w of o) {
            let S = this.getImage(w);
            S || (this.fire(new a.Event("styleimagemissing", { id: w })), S = this.getImage(w)), S ? v[w] = { data: S.data.clone(), pixelRatio: S.pixelRatio, sdf: S.sdf, version: S.version, stretchX: S.stretchX, stretchY: S.stretchY, content: S.content, hasRenderCallback: !!(S.userImage && S.userImage.render) } : a.warnOnce(`Image "${w}" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.`);
          }
          h(null, v);
        }
        getPixelSize() {
          const { width: o, height: h } = this.atlasImage;
          return { width: o, height: h };
        }
        getPattern(o) {
          const h = this.patterns[o], v = this.getImage(o);
          if (!v) return null;
          if (h && h.position.version === v.version) return h.position;
          if (h) h.position.version = v.version;
          else {
            const w = { w: v.data.width + 2, h: v.data.height + 2, x: 0, y: 0 }, S = new a.ImagePosition(w, v);
            this.patterns[o] = { bin: w, position: S };
          }
          return this._updatePatternAtlas(), this.patterns[o].position;
        }
        bind(o) {
          const h = o.gl;
          this.atlasTexture ? this.dirty && (this.atlasTexture.update(this.atlasImage), this.dirty = !1) : this.atlasTexture = new ve(o, this.atlasImage, h.RGBA), this.atlasTexture.bind(h.LINEAR, h.CLAMP_TO_EDGE);
        }
        _updatePatternAtlas() {
          const o = [];
          for (const S in this.patterns) o.push(this.patterns[S].bin);
          const { w: h, h: v } = a.potpack(o), w = this.atlasImage;
          w.resize({ width: h || 1, height: v || 1 });
          for (const S in this.patterns) {
            const { bin: M } = this.patterns[S], z = M.x + 1, R = M.y + 1, W = this.getImage(S).data, Q = W.width, J = W.height;
            a.RGBAImage.copy(W, w, { x: 0, y: 0 }, { x: z, y: R }, { width: Q, height: J }), a.RGBAImage.copy(W, w, { x: 0, y: J - 1 }, { x: z, y: R - 1 }, { width: Q, height: 1 }), a.RGBAImage.copy(W, w, { x: 0, y: 0 }, { x: z, y: R + J }, { width: Q, height: 1 }), a.RGBAImage.copy(W, w, { x: Q - 1, y: 0 }, { x: z - 1, y: R }, { width: 1, height: J }), a.RGBAImage.copy(W, w, { x: 0, y: 0 }, { x: z + Q, y: R }, { width: 1, height: J });
          }
          this.dirty = !0;
        }
        beginFrame() {
          this.callbackDispatchedThisFrame = {};
        }
        dispatchRenderCallbacks(o) {
          for (const h of o) {
            if (this.callbackDispatchedThisFrame[h]) continue;
            this.callbackDispatchedThisFrame[h] = !0;
            const v = this.getImage(h);
            v || a.warnOnce(`Image with ID: "${h}" was not found`), re(v) && this.updateImage(h, v);
          }
        }
      }
      const pe = 1e20;
      function Ne(_, o, h, v, w, S, M, z, R) {
        for (let W = o; W < o + v; W++) We(_, h * S + W, S, w, M, z, R);
        for (let W = h; W < h + w; W++) We(_, W * S + o, 1, v, M, z, R);
      }
      function We(_, o, h, v, w, S, M) {
        S[0] = 0, M[0] = -1e20, M[1] = pe, w[0] = _[o];
        for (let z = 1, R = 0, W = 0; z < v; z++) {
          w[z] = _[o + z * h];
          const Q = z * z;
          do {
            const J = S[R];
            W = (w[z] - w[J] + Q - J * J) / (z - J) / 2;
          } while (W <= M[R] && --R > -1);
          R++, S[R] = z, M[R] = W, M[R + 1] = pe;
        }
        for (let z = 0, R = 0; z < v; z++) {
          for (; M[R + 1] < z; ) R++;
          const W = S[R], Q = z - W;
          _[o + z * h] = w[W] + Q * Q;
        }
      }
      class Ge {
        constructor(o, h) {
          this.requestManager = o, this.localIdeographFontFamily = h, this.entries = {};
        }
        setURL(o) {
          this.url = o;
        }
        getGlyphs(o, h) {
          const v = [];
          for (const w in o) for (const S of o[w]) v.push({ stack: w, id: S });
          a.asyncAll(v, ({ stack: w, id: S }, M) => {
            let z = this.entries[w];
            z || (z = this.entries[w] = { glyphs: {}, requests: {}, ranges: {} });
            let R = z.glyphs[S];
            if (R !== void 0) return void M(null, { stack: w, id: S, glyph: R });
            if (R = this._tinySDF(z, w, S), R) return z.glyphs[S] = R, void M(null, { stack: w, id: S, glyph: R });
            const W = Math.floor(S / 256);
            if (256 * W > 65535) return void M(new Error("glyphs > 65535 not supported"));
            if (z.ranges[W]) return void M(null, { stack: w, id: S, glyph: R });
            if (!this.url) return void M(new Error("glyphsUrl is not set"));
            let Q = z.requests[W];
            Q || (Q = z.requests[W] = [], Ge.loadGlyphRange(w, W, this.url, this.requestManager, (J, fe) => {
              if (fe) {
                for (const Se in fe) this._doesCharSupportLocalGlyph(+Se) || (z.glyphs[+Se] = fe[+Se]);
                z.ranges[W] = !0;
              }
              for (const Se of Q) Se(J, fe);
              delete z.requests[W];
            })), Q.push((J, fe) => {
              J ? M(J) : fe && M(null, { stack: w, id: S, glyph: fe[S] || null });
            });
          }, (w, S) => {
            if (w) h(w);
            else if (S) {
              const M = {};
              for (const { stack: z, id: R, glyph: W } of S) (M[z] || (M[z] = {}))[R] = W && { id: W.id, bitmap: W.bitmap.clone(), metrics: W.metrics };
              h(null, M);
            }
          });
        }
        _doesCharSupportLocalGlyph(o) {
          return !!this.localIdeographFontFamily && (a.unicodeBlockLookup["CJK Unified Ideographs"](o) || a.unicodeBlockLookup["Hangul Syllables"](o) || a.unicodeBlockLookup.Hiragana(o) || a.unicodeBlockLookup.Katakana(o));
        }
        _tinySDF(o, h, v) {
          const w = this.localIdeographFontFamily;
          if (!w || !this._doesCharSupportLocalGlyph(v)) return;
          let S = o.tinySDF;
          if (!S) {
            let z = "400";
            /bold/i.test(h) ? z = "900" : /medium/i.test(h) ? z = "500" : /light/i.test(h) && (z = "200"), S = o.tinySDF = new Ge.TinySDF({ fontSize: 24, buffer: 3, radius: 8, cutoff: 0.25, fontFamily: w, fontWeight: z });
          }
          const M = S.draw(String.fromCharCode(v));
          return { id: v, bitmap: new a.AlphaImage({ width: M.width || 30, height: M.height || 30 }, M.data), metrics: { width: M.glyphWidth || 24, height: M.glyphHeight || 24, left: M.glyphLeft || 0, top: M.glyphTop - 27 || -8, advance: M.glyphAdvance || 24 } };
        }
      }
      Ge.loadGlyphRange = function(_, o, h, v, w) {
        const S = 256 * o, M = S + 255, z = v.transformRequest(h.replace("{fontstack}", _).replace("{range}", `${S}-${M}`), N.Glyphs);
        a.getArrayBuffer(z, (R, W) => {
          if (R) w(R);
          else if (W) {
            const Q = {};
            for (const J of a.parseGlyphPbf(W)) Q[J.id] = J;
            w(null, Q);
          }
        });
      }, Ge.TinySDF = class {
        constructor({ fontSize: _ = 24, buffer: o = 3, radius: h = 8, cutoff: v = 0.25, fontFamily: w = "sans-serif", fontWeight: S = "normal", fontStyle: M = "normal" } = {}) {
          this.buffer = o, this.cutoff = v, this.radius = h;
          const z = this.size = _ + 4 * o, R = this._createCanvas(z), W = this.ctx = R.getContext("2d", { willReadFrequently: !0 });
          W.font = `${M} ${S} ${_}px ${w}`, W.textBaseline = "alphabetic", W.textAlign = "left", W.fillStyle = "black", this.gridOuter = new Float64Array(z * z), this.gridInner = new Float64Array(z * z), this.f = new Float64Array(z), this.z = new Float64Array(z + 1), this.v = new Uint16Array(z);
        }
        _createCanvas(_) {
          const o = document.createElement("canvas");
          return o.width = o.height = _, o;
        }
        draw(_) {
          const { width: o, actualBoundingBoxAscent: h, actualBoundingBoxDescent: v, actualBoundingBoxLeft: w, actualBoundingBoxRight: S } = this.ctx.measureText(_), M = Math.ceil(h), z = Math.max(0, Math.min(this.size - this.buffer, Math.ceil(S - w))), R = Math.min(this.size - this.buffer, M + Math.ceil(v)), W = z + 2 * this.buffer, Q = R + 2 * this.buffer, J = Math.max(W * Q, 0), fe = new Uint8ClampedArray(J), Se = { data: fe, width: W, height: Q, glyphWidth: z, glyphHeight: R, glyphTop: M, glyphLeft: 0, glyphAdvance: o };
          if (z === 0 || R === 0) return Se;
          const { ctx: we, buffer: Ce, gridInner: Me, gridOuter: Ue } = this;
          we.clearRect(Ce, Ce, z, R), we.fillText(_, Ce, Ce + M);
          const ct = we.getImageData(Ce, Ce, z, R);
          Ue.fill(pe, 0, J), Me.fill(0, 0, J);
          for (let Ee = 0; Ee < R; Ee++) for (let st = 0; st < z; st++) {
            const ht = ct.data[4 * (Ee * z + st) + 3] / 255;
            if (ht === 0) continue;
            const wt = (Ee + Ce) * W + st + Ce;
            if (ht === 1) Ue[wt] = 0, Me[wt] = pe;
            else {
              const Ct = 0.5 - ht;
              Ue[wt] = Ct > 0 ? Ct * Ct : 0, Me[wt] = Ct < 0 ? Ct * Ct : 0;
            }
          }
          Ne(Ue, 0, 0, W, Q, W, this.f, this.v, this.z), Ne(Me, Ce, Ce, z, R, W, this.f, this.v, this.z);
          for (let Ee = 0; Ee < J; Ee++) {
            const st = Math.sqrt(Ue[Ee]) - Math.sqrt(Me[Ee]);
            fe[Ee] = Math.round(255 - 255 * (st / this.radius + this.cutoff));
          }
          return Se;
        }
      };
      class et {
        constructor() {
          this.specification = a.v8Spec.light.position;
        }
        possiblyEvaluate(o, h) {
          return a.sphericalToCartesian(o.expression.evaluate(h));
        }
        interpolate(o, h, v) {
          return { x: a.interpolate.number(o.x, h.x, v), y: a.interpolate.number(o.y, h.y, v), z: a.interpolate.number(o.z, h.z, v) };
        }
      }
      let ft, De;
      class Ke extends a.Evented {
        constructor(o) {
          super(), ft = ft || new a.Properties({ anchor: new a.DataConstantProperty(a.v8Spec.light.anchor), position: new et(), color: new a.DataConstantProperty(a.v8Spec.light.color), intensity: new a.DataConstantProperty(a.v8Spec.light.intensity) }), this._transitionable = new a.Transitionable(ft), this.setLight(o), this._transitioning = this._transitionable.untransitioned();
        }
        getLight() {
          return this._transitionable.serialize();
        }
        setLight(o, h = {}) {
          if (!this._validate(a.validateLight, o, h)) for (const v in o) {
            const w = o[v];
            v.endsWith("-transition") ? this._transitionable.setTransition(v.slice(0, -11), w) : this._transitionable.setValue(v, w);
          }
        }
        updateTransitions(o) {
          this._transitioning = this._transitionable.transitioned(o, this._transitioning);
        }
        hasTransition() {
          return this._transitioning.hasTransition();
        }
        recalculate(o) {
          this.properties = this._transitioning.possiblyEvaluate(o);
        }
        _validate(o, h, v) {
          return (!v || v.validate !== !1) && a.emitValidationErrors(this, o.call(a.validateStyle, a.extend({ value: h, style: { glyphs: !0, sprite: !0 }, styleSpec: a.v8Spec })));
        }
      }
      class gt {
        constructor(o, h) {
          this.width = o, this.height = h, this.nextRow = 0, this.data = new Uint8Array(this.width * this.height), this.dashEntry = {};
        }
        getDash(o, h) {
          const v = o.join(",") + String(h);
          return this.dashEntry[v] || (this.dashEntry[v] = this.addDash(o, h)), this.dashEntry[v];
        }
        getDashRanges(o, h, v) {
          const w = [];
          let S = o.length % 2 == 1 ? -o[o.length - 1] * v : 0, M = o[0] * v, z = !0;
          w.push({ left: S, right: M, isDash: z, zeroLength: o[0] === 0 });
          let R = o[0];
          for (let W = 1; W < o.length; W++) {
            z = !z;
            const Q = o[W];
            S = R * v, R += Q, M = R * v, w.push({ left: S, right: M, isDash: z, zeroLength: Q === 0 });
          }
          return w;
        }
        addRoundDash(o, h, v) {
          const w = h / 2;
          for (let S = -v; S <= v; S++) {
            const M = this.width * (this.nextRow + v + S);
            let z = 0, R = o[z];
            for (let W = 0; W < this.width; W++) {
              W / R.right > 1 && (R = o[++z]);
              const Q = Math.abs(W - R.left), J = Math.abs(W - R.right), fe = Math.min(Q, J);
              let Se;
              const we = S / v * (w + 1);
              if (R.isDash) {
                const Ce = w - Math.abs(we);
                Se = Math.sqrt(fe * fe + Ce * Ce);
              } else Se = w - Math.sqrt(fe * fe + we * we);
              this.data[M + W] = Math.max(0, Math.min(255, Se + 128));
            }
          }
        }
        addRegularDash(o) {
          for (let z = o.length - 1; z >= 0; --z) {
            const R = o[z], W = o[z + 1];
            R.zeroLength ? o.splice(z, 1) : W && W.isDash === R.isDash && (W.left = R.left, o.splice(z, 1));
          }
          const h = o[0], v = o[o.length - 1];
          h.isDash === v.isDash && (h.left = v.left - this.width, v.right = h.right + this.width);
          const w = this.width * this.nextRow;
          let S = 0, M = o[S];
          for (let z = 0; z < this.width; z++) {
            z / M.right > 1 && (M = o[++S]);
            const R = Math.abs(z - M.left), W = Math.abs(z - M.right), Q = Math.min(R, W);
            this.data[w + z] = Math.max(0, Math.min(255, (M.isDash ? Q : -Q) + 128));
          }
        }
        addDash(o, h) {
          const v = h ? 7 : 0, w = 2 * v + 1;
          if (this.nextRow + w > this.height) return a.warnOnce("LineAtlas out of space"), null;
          let S = 0;
          for (let z = 0; z < o.length; z++) S += o[z];
          if (S !== 0) {
            const z = this.width / S, R = this.getDashRanges(o, this.width, z);
            h ? this.addRoundDash(R, z, v) : this.addRegularDash(R);
          }
          const M = { y: (this.nextRow + v + 0.5) / this.height, height: 2 * v / this.height, width: S };
          return this.nextRow += w, this.dirty = !0, M;
        }
        bind(o) {
          const h = o.gl;
          this.texture ? (h.bindTexture(h.TEXTURE_2D, this.texture), this.dirty && (this.dirty = !1, h.texSubImage2D(h.TEXTURE_2D, 0, 0, 0, this.width, this.height, h.ALPHA, h.UNSIGNED_BYTE, this.data))) : (this.texture = h.createTexture(), h.bindTexture(h.TEXTURE_2D, this.texture), h.texParameteri(h.TEXTURE_2D, h.TEXTURE_WRAP_S, h.REPEAT), h.texParameteri(h.TEXTURE_2D, h.TEXTURE_WRAP_T, h.REPEAT), h.texParameteri(h.TEXTURE_2D, h.TEXTURE_MIN_FILTER, h.LINEAR), h.texParameteri(h.TEXTURE_2D, h.TEXTURE_MAG_FILTER, h.LINEAR), h.texImage2D(h.TEXTURE_2D, 0, h.ALPHA, this.width, this.height, 0, h.ALPHA, h.UNSIGNED_BYTE, this.data));
        }
      }
      class qe {
        constructor(o, h, v) {
          this.workerPool = o, this.actors = [], this.currentActor = 0, this.id = v;
          const w = this.workerPool.acquire(v);
          for (let S = 0; S < w.length; S++) {
            const M = new qe.Actor(w[S], h, v);
            M.name = `Worker ${S}`, this.actors.push(M);
          }
          if (!this.actors.length) throw new Error("No actors found");
        }
        broadcast(o, h, v) {
          a.asyncAll(this.actors, (w, S) => {
            w.send(o, h, S);
          }, v = v || function() {
          });
        }
        getActor() {
          return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
        }
        remove(o = !0) {
          this.actors.forEach((h) => {
            h.remove();
          }), this.actors = [], o && this.workerPool.release(this.id);
        }
      }
      function rt(_, o, h) {
        const v = function(w, S) {
          if (w) return h(w);
          if (S) {
            const M = a.pick(a.extend(S, _), ["tiles", "minzoom", "maxzoom", "attribution", "bounds", "scheme", "tileSize", "encoding"]);
            S.vector_layers && (M.vectorLayers = S.vector_layers, M.vectorLayerIds = M.vectorLayers.map((z) => z.id)), h(null, M);
          }
        };
        return _.url ? a.getJSON(o.transformRequest(_.url, N.Source), v) : a.exported.frame(() => v(null, _));
      }
      qe.Actor = a.Actor;
      class Le {
        constructor(o, h) {
          o && (h ? this.setSouthWest(o).setNorthEast(h) : Array.isArray(o) && (o.length === 4 ? this.setSouthWest([o[0], o[1]]).setNorthEast([o[2], o[3]]) : this.setSouthWest(o[0]).setNorthEast(o[1])));
        }
        setNorthEast(o) {
          return this._ne = o instanceof a.LngLat ? new a.LngLat(o.lng, o.lat) : a.LngLat.convert(o), this;
        }
        setSouthWest(o) {
          return this._sw = o instanceof a.LngLat ? new a.LngLat(o.lng, o.lat) : a.LngLat.convert(o), this;
        }
        extend(o) {
          const h = this._sw, v = this._ne;
          let w, S;
          if (o instanceof a.LngLat) w = o, S = o;
          else {
            if (!(o instanceof Le)) return Array.isArray(o) ? o.length === 4 || o.every(Array.isArray) ? this.extend(Le.convert(o)) : this.extend(a.LngLat.convert(o)) : o && ("lng" in o || "lon" in o) && "lat" in o ? this.extend(a.LngLat.convert(o)) : this;
            if (w = o._sw, S = o._ne, !w || !S) return this;
          }
          return h || v ? (h.lng = Math.min(w.lng, h.lng), h.lat = Math.min(w.lat, h.lat), v.lng = Math.max(S.lng, v.lng), v.lat = Math.max(S.lat, v.lat)) : (this._sw = new a.LngLat(w.lng, w.lat), this._ne = new a.LngLat(S.lng, S.lat)), this;
        }
        getCenter() {
          return new a.LngLat((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
        }
        getSouthWest() {
          return this._sw;
        }
        getNorthEast() {
          return this._ne;
        }
        getNorthWest() {
          return new a.LngLat(this.getWest(), this.getNorth());
        }
        getSouthEast() {
          return new a.LngLat(this.getEast(), this.getSouth());
        }
        getWest() {
          return this._sw.lng;
        }
        getSouth() {
          return this._sw.lat;
        }
        getEast() {
          return this._ne.lng;
        }
        getNorth() {
          return this._ne.lat;
        }
        toArray() {
          return [this._sw.toArray(), this._ne.toArray()];
        }
        toString() {
          return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`;
        }
        isEmpty() {
          return !(this._sw && this._ne);
        }
        contains(o) {
          const { lng: h, lat: v } = a.LngLat.convert(o);
          let w = this._sw.lng <= h && h <= this._ne.lng;
          return this._sw.lng > this._ne.lng && (w = this._sw.lng >= h && h >= this._ne.lng), this._sw.lat <= v && v <= this._ne.lat && w;
        }
        static convert(o) {
          return o instanceof Le ? o : o && new Le(o);
        }
        static fromLngLat(o, h = 0) {
          const v = 360 * h / 40075017, w = v / Math.cos(Math.PI / 180 * o.lat);
          return new Le(new a.LngLat(o.lng - w, o.lat - v), new a.LngLat(o.lng + w, o.lat + v));
        }
      }
      class Je {
        constructor(o, h, v) {
          this.bounds = Le.convert(this.validateBounds(o)), this.minzoom = h || 0, this.maxzoom = v || 24;
        }
        validateBounds(o) {
          return Array.isArray(o) && o.length === 4 ? [Math.max(-180, o[0]), Math.max(-90, o[1]), Math.min(180, o[2]), Math.min(90, o[3])] : [-180, -90, 180, 90];
        }
        contains(o) {
          const h = Math.pow(2, o.z), v = Math.floor(a.mercatorXfromLng(this.bounds.getWest()) * h), w = Math.floor(a.mercatorYfromLat(this.bounds.getNorth()) * h), S = Math.ceil(a.mercatorXfromLng(this.bounds.getEast()) * h), M = Math.ceil(a.mercatorYfromLat(this.bounds.getSouth()) * h);
          return o.x >= v && o.x < S && o.y >= w && o.y < M;
        }
      }
      class je extends a.Evented {
        constructor(o, h, v, w) {
          if (super(), this.id = o, this.dispatcher = v, this.type = "vector", this.minzoom = 0, this.maxzoom = 22, this.scheme = "xyz", this.tileSize = 512, this.reparseOverscaled = !0, this.isTileClipped = !0, this._loaded = !1, a.extend(this, a.pick(h, ["url", "scheme", "tileSize", "promoteId"])), this._options = a.extend({ type: "vector" }, h), this._collectResourceTiming = h.collectResourceTiming, this.tileSize !== 512) throw new Error("vector tile sources must have a tileSize of 512");
          this.setEventedParent(w);
        }
        load() {
          this._loaded = !1, this.fire(new a.Event("dataloading", { dataType: "source" })), this._tileJSONRequest = rt(this._options, this.map._requestManager, (o, h) => {
            this._tileJSONRequest = null, this._loaded = !0, this.map.style.sourceCaches[this.id].clearTiles(), o ? this.fire(new a.ErrorEvent(o)) : h && (a.extend(this, h), h.bounds && (this.tileBounds = new Je(h.bounds, this.minzoom, this.maxzoom)), this.fire(new a.Event("data", { dataType: "source", sourceDataType: "metadata" })), this.fire(new a.Event("data", { dataType: "source", sourceDataType: "content" })));
          });
        }
        loaded() {
          return this._loaded;
        }
        hasTile(o) {
          return !this.tileBounds || this.tileBounds.contains(o.canonical);
        }
        onAdd(o) {
          this.map = o, this.load();
        }
        setSourceProperty(o) {
          this._tileJSONRequest && this._tileJSONRequest.cancel(), o(), this.load();
        }
        setTiles(o) {
          return this.setSourceProperty(() => {
            this._options.tiles = o;
          }), this;
        }
        setUrl(o) {
          return this.setSourceProperty(() => {
            this.url = o, this._options.url = o;
          }), this;
        }
        onRemove() {
          this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
        }
        serialize() {
          return a.extend({}, this._options);
        }
        loadTile(o, h) {
          const v = o.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme), w = { request: this.map._requestManager.transformRequest(v, N.Tile), uid: o.uid, tileID: o.tileID, zoom: o.tileID.overscaledZ, tileSize: this.tileSize * o.tileID.overscaleFactor(), type: this.type, source: this.id, pixelRatio: this.map.getPixelRatio(), showCollisionBoxes: this.map.showCollisionBoxes, promoteId: this.promoteId };
          function S(M, z) {
            return delete o.request, o.aborted ? h(null) : M && M.status !== 404 ? h(M) : (z && z.resourceTiming && (o.resourceTiming = z.resourceTiming), this.map._refreshExpiredTiles && z && o.setExpiryData(z), o.loadVectorData(z, this.map.painter), h(null), void (o.reloadCallback && (this.loadTile(o, o.reloadCallback), o.reloadCallback = null)));
          }
          w.request.collectResourceTiming = this._collectResourceTiming, o.actor && o.state !== "expired" ? o.state === "loading" ? o.reloadCallback = h : o.request = o.actor.send("reloadTile", w, S.bind(this)) : (o.actor = this.dispatcher.getActor(), o.request = o.actor.send("loadTile", w, S.bind(this)));
        }
        abortTile(o) {
          o.request && (o.request.cancel(), delete o.request), o.actor && o.actor.send("abortTile", { uid: o.uid, type: this.type, source: this.id }, void 0);
        }
        unloadTile(o) {
          o.unloadVectorData(), o.actor && o.actor.send("removeTile", { uid: o.uid, type: this.type, source: this.id }, void 0);
        }
        hasTransition() {
          return !1;
        }
      }
      class ot extends a.Evented {
        constructor(o, h, v, w) {
          super(), this.id = o, this.dispatcher = v, this.setEventedParent(w), this.type = "raster", this.minzoom = 0, this.maxzoom = 22, this.roundZoom = !0, this.scheme = "xyz", this.tileSize = 512, this._loaded = !1, this._options = a.extend({ type: "raster" }, h), a.extend(this, a.pick(h, ["url", "scheme", "tileSize"]));
        }
        load() {
          this._loaded = !1, this.fire(new a.Event("dataloading", { dataType: "source" })), this._tileJSONRequest = rt(this._options, this.map._requestManager, (o, h) => {
            this._tileJSONRequest = null, this._loaded = !0, o ? this.fire(new a.ErrorEvent(o)) : h && (a.extend(this, h), h.bounds && (this.tileBounds = new Je(h.bounds, this.minzoom, this.maxzoom)), this.fire(new a.Event("data", { dataType: "source", sourceDataType: "metadata" })), this.fire(new a.Event("data", { dataType: "source", sourceDataType: "content" })));
          });
        }
        loaded() {
          return this._loaded;
        }
        onAdd(o) {
          this.map = o, this.load();
        }
        onRemove() {
          this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
        }
        serialize() {
          return a.extend({}, this._options);
        }
        hasTile(o) {
          return !this.tileBounds || this.tileBounds.contains(o.canonical);
        }
        loadTile(o, h) {
          const v = o.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme);
          o.request = K.getImage(this.map._requestManager.transformRequest(v, N.Tile), (w, S, M) => {
            if (delete o.request, o.aborted) o.state = "unloaded", h(null);
            else if (w) o.state = "errored", h(w);
            else if (S) {
              this.map._refreshExpiredTiles && M && o.setExpiryData(M);
              const z = this.map.painter.context, R = z.gl;
              o.texture = this.map.painter.getTileTexture(S.width), o.texture ? o.texture.update(S, { useMipmap: !0 }) : (o.texture = new ve(z, S, R.RGBA, { useMipmap: !0 }), o.texture.bind(R.LINEAR, R.CLAMP_TO_EDGE, R.LINEAR_MIPMAP_NEAREST), z.extTextureFilterAnisotropic && R.texParameterf(R.TEXTURE_2D, z.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, z.extTextureFilterAnisotropicMax)), o.state = "loaded", h(null);
            }
          }, this.map._refreshExpiredTiles);
        }
        abortTile(o, h) {
          o.request && (o.request.cancel(), delete o.request), h();
        }
        unloadTile(o, h) {
          o.texture && this.map.painter.saveTileTexture(o.texture), h();
        }
        hasTransition() {
          return !1;
        }
      }
      class Xe extends ot {
        constructor(o, h, v, w) {
          super(o, h, v, w), this.type = "raster-dem", this.maxzoom = 22, this._options = a.extend({ type: "raster-dem" }, h), this.encoding = h.encoding || "mapbox";
        }
        serialize() {
          return { type: "raster-dem", url: this.url, tileSize: this.tileSize, tiles: this.tiles, bounds: this.bounds, encoding: this.encoding };
        }
        loadTile(o, h) {
          const v = o.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme);
          function w(S, M) {
            S && (o.state = "errored", h(S)), M && (o.dem = M, o.needsHillshadePrepare = !0, o.needsTerrainPrepare = !0, o.state = "loaded", h(null));
          }
          o.request = K.getImage(this.map._requestManager.transformRequest(v, N.Tile), (function(S, M) {
            if (delete o.request, o.aborted) o.state = "unloaded", h(null);
            else if (S) o.state = "errored", h(S);
            else if (M) {
              this.map._refreshExpiredTiles && o.setExpiryData(M), delete M.cacheControl, delete M.expires;
              const z = a.isImageBitmap(M) && (De == null && (De = typeof OffscreenCanvas < "u" && new OffscreenCanvas(1, 1).getContext("2d") && typeof createImageBitmap == "function"), De) ? M : a.exported.getImageData(M, 1), R = { uid: o.uid, coord: o.tileID, source: this.id, rawImageData: z, encoding: this.encoding };
              o.actor && o.state !== "expired" || (o.actor = this.dispatcher.getActor(), o.actor.send("loadDEMTile", R, w.bind(this)));
            }
          }).bind(this), this.map._refreshExpiredTiles), o.neighboringTiles = this._getNeighboringTiles(o.tileID);
        }
        _getNeighboringTiles(o) {
          const h = o.canonical, v = Math.pow(2, h.z), w = (h.x - 1 + v) % v, S = h.x === 0 ? o.wrap - 1 : o.wrap, M = (h.x + 1 + v) % v, z = h.x + 1 === v ? o.wrap + 1 : o.wrap, R = {};
          return R[new a.OverscaledTileID(o.overscaledZ, S, h.z, w, h.y).key] = { backfilled: !1 }, R[new a.OverscaledTileID(o.overscaledZ, z, h.z, M, h.y).key] = { backfilled: !1 }, h.y > 0 && (R[new a.OverscaledTileID(o.overscaledZ, S, h.z, w, h.y - 1).key] = { backfilled: !1 }, R[new a.OverscaledTileID(o.overscaledZ, o.wrap, h.z, h.x, h.y - 1).key] = { backfilled: !1 }, R[new a.OverscaledTileID(o.overscaledZ, z, h.z, M, h.y - 1).key] = { backfilled: !1 }), h.y + 1 < v && (R[new a.OverscaledTileID(o.overscaledZ, S, h.z, w, h.y + 1).key] = { backfilled: !1 }, R[new a.OverscaledTileID(o.overscaledZ, o.wrap, h.z, h.x, h.y + 1).key] = { backfilled: !1 }, R[new a.OverscaledTileID(o.overscaledZ, z, h.z, M, h.y + 1).key] = { backfilled: !1 }), R;
        }
        unloadTile(o) {
          o.demTexture && this.map.painter.saveTileTexture(o.demTexture), o.fbo && (o.fbo.destroy(), delete o.fbo), o.dem && delete o.dem, delete o.neighboringTiles, o.state = "unloaded", o.actor && o.actor.send("removeDEMTile", { uid: o.uid, source: this.id });
        }
      }
      class tt extends a.Evented {
        constructor(o, h, v, w) {
          super(), this.id = o, this.type = "geojson", this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = !0, this.reparseOverscaled = !0, this._removed = !1, this._pendingLoads = 0, this.actor = v.getActor(), this.setEventedParent(w), this._data = h.data, this._options = a.extend({}, h), this._collectResourceTiming = h.collectResourceTiming, h.maxzoom !== void 0 && (this.maxzoom = h.maxzoom), h.type && (this.type = h.type), h.attribution && (this.attribution = h.attribution), this.promoteId = h.promoteId;
          const S = a.EXTENT / this.tileSize;
          this.workerOptions = a.extend({ source: this.id, cluster: h.cluster || !1, geojsonVtOptions: { buffer: (h.buffer !== void 0 ? h.buffer : 128) * S, tolerance: (h.tolerance !== void 0 ? h.tolerance : 0.375) * S, extent: a.EXTENT, maxZoom: this.maxzoom, lineMetrics: h.lineMetrics || !1, generateId: h.generateId || !1 }, superclusterOptions: { maxZoom: h.clusterMaxZoom !== void 0 ? h.clusterMaxZoom : this.maxzoom - 1, minPoints: Math.max(2, h.clusterMinPoints || 2), extent: a.EXTENT, radius: (h.clusterRadius || 50) * S, log: !1, generateId: h.generateId || !1 }, clusterProperties: h.clusterProperties, filter: h.filter }, h.workerOptions), typeof this.promoteId == "string" && (this.workerOptions.promoteId = this.promoteId);
        }
        load() {
          this._updateWorkerData();
        }
        onAdd(o) {
          this.map = o, this.load();
        }
        setData(o) {
          return this._data = o, this._updateWorkerData(), this;
        }
        updateData(o) {
          return this._updateWorkerData(o), this;
        }
        setClusterOptions(o) {
          return this.workerOptions.cluster = o.cluster, o && (o.clusterRadius !== void 0 && (this.workerOptions.superclusterOptions.radius = o.clusterRadius), o.clusterMaxZoom !== void 0 && (this.workerOptions.superclusterOptions.maxZoom = o.clusterMaxZoom)), this._updateWorkerData(), this;
        }
        getClusterExpansionZoom(o, h) {
          return this.actor.send("geojson.getClusterExpansionZoom", { clusterId: o, source: this.id }, h), this;
        }
        getClusterChildren(o, h) {
          return this.actor.send("geojson.getClusterChildren", { clusterId: o, source: this.id }, h), this;
        }
        getClusterLeaves(o, h, v, w) {
          return this.actor.send("geojson.getClusterLeaves", { source: this.id, clusterId: o, limit: h, offset: v }, w), this;
        }
        _updateWorkerData(o) {
          const h = a.extend({}, this.workerOptions);
          o ? h.dataDiff = o : typeof this._data == "string" ? (h.request = this.map._requestManager.transformRequest(a.exported.resolveURL(this._data), N.Source), h.request.collectResourceTiming = this._collectResourceTiming) : h.data = JSON.stringify(this._data), this._pendingLoads++, this.fire(new a.Event("dataloading", { dataType: "source" })), this.actor.send(`${this.type}.loadData`, h, (v, w) => {
            if (this._pendingLoads--, this._removed || w && w.abandoned) return void this.fire(new a.Event("dataabort", { dataType: "source" }));
            let S = null;
            if (w && w.resourceTiming && w.resourceTiming[this.id] && (S = w.resourceTiming[this.id].slice(0)), v) return void this.fire(new a.ErrorEvent(v));
            const M = { dataType: "source" };
            this._collectResourceTiming && S && S.length > 0 && a.extend(M, { resourceTiming: S }), this.fire(new a.Event("data", { ...M, sourceDataType: "metadata" })), this.fire(new a.Event("data", { ...M, sourceDataType: "content" }));
          });
        }
        loaded() {
          return this._pendingLoads === 0;
        }
        loadTile(o, h) {
          const v = o.actor ? "reloadTile" : "loadTile";
          o.actor = this.actor;
          const w = { type: this.type, uid: o.uid, tileID: o.tileID, zoom: o.tileID.overscaledZ, maxZoom: this.maxzoom, tileSize: this.tileSize, source: this.id, pixelRatio: this.map.getPixelRatio(), showCollisionBoxes: this.map.showCollisionBoxes, promoteId: this.promoteId };
          o.request = this.actor.send(v, w, (S, M) => (delete o.request, o.unloadVectorData(), o.aborted ? h(null) : S ? h(S) : (o.loadVectorData(M, this.map.painter, v === "reloadTile"), h(null))));
        }
        abortTile(o) {
          o.request && (o.request.cancel(), delete o.request), o.aborted = !0;
        }
        unloadTile(o) {
          o.unloadVectorData(), this.actor.send("removeTile", { uid: o.uid, type: this.type, source: this.id });
        }
        onRemove() {
          this._removed = !0, this.actor.send("removeSource", { type: this.type, source: this.id });
        }
        serialize() {
          return a.extend({}, this._options, { type: this.type, data: this._data });
        }
        hasTransition() {
          return !1;
        }
      }
      var dt = a.createLayout([{ name: "a_pos", type: "Int16", components: 2 }, { name: "a_texture_pos", type: "Int16", components: 2 }]);
      class bt extends a.Evented {
        constructor(o, h, v, w) {
          super(), this.id = o, this.dispatcher = v, this.coordinates = h.coordinates, this.type = "image", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = !1, this.setEventedParent(w), this.options = h;
        }
        load(o, h) {
          this._loaded = !1, this.fire(new a.Event("dataloading", { dataType: "source" })), this.url = this.options.url, this._request = K.getImage(this.map._requestManager.transformRequest(this.url, N.Image), (v, w) => {
            this._request = null, this._loaded = !0, v ? this.fire(new a.ErrorEvent(v)) : w && (this.image = w, o && (this.coordinates = o), h && h(), this._finishLoading());
          });
        }
        loaded() {
          return this._loaded;
        }
        updateImage(o) {
          return o.url ? (this._request && (this._request.cancel(), this._request = null), this.options.url = o.url, this.load(o.coordinates, () => {
            this.texture = null;
          }), this) : this;
        }
        _finishLoading() {
          this.map && (this.setCoordinates(this.coordinates), this.fire(new a.Event("data", { dataType: "source", sourceDataType: "metadata" })));
        }
        onAdd(o) {
          this.map = o, this.load();
        }
        onRemove() {
          this._request && (this._request.cancel(), this._request = null);
        }
        setCoordinates(o) {
          this.coordinates = o;
          const h = o.map(a.MercatorCoordinate.fromLngLat);
          this.tileID = function(w) {
            let S = 1 / 0, M = 1 / 0, z = -1 / 0, R = -1 / 0;
            for (const fe of w) S = Math.min(S, fe.x), M = Math.min(M, fe.y), z = Math.max(z, fe.x), R = Math.max(R, fe.y);
            const W = Math.max(z - S, R - M), Q = Math.max(0, Math.floor(-Math.log(W) / Math.LN2)), J = Math.pow(2, Q);
            return new a.CanonicalTileID(Q, Math.floor((S + z) / 2 * J), Math.floor((M + R) / 2 * J));
          }(h), this.minzoom = this.maxzoom = this.tileID.z;
          const v = h.map((w) => this.tileID.getTilePoint(w)._round());
          return this._boundsArray = new a.RasterBoundsArray(), this._boundsArray.emplaceBack(v[0].x, v[0].y, 0, 0), this._boundsArray.emplaceBack(v[1].x, v[1].y, a.EXTENT, 0), this._boundsArray.emplaceBack(v[3].x, v[3].y, 0, a.EXTENT), this._boundsArray.emplaceBack(v[2].x, v[2].y, a.EXTENT, a.EXTENT), this.boundsBuffer && (this.boundsBuffer.destroy(), delete this.boundsBuffer), this.fire(new a.Event("data", { dataType: "source", sourceDataType: "content" })), this;
        }
        prepare() {
          if (Object.keys(this.tiles).length === 0 || !this.image) return;
          const o = this.map.painter.context, h = o.gl;
          this.boundsBuffer || (this.boundsBuffer = o.createVertexBuffer(this._boundsArray, dt.members)), this.boundsSegments || (this.boundsSegments = a.SegmentVector.simpleSegment(0, 0, 4, 2)), this.texture || (this.texture = new ve(o, this.image, h.RGBA), this.texture.bind(h.LINEAR, h.CLAMP_TO_EDGE));
          let v = !1;
          for (const w in this.tiles) {
            const S = this.tiles[w];
            S.state !== "loaded" && (S.state = "loaded", S.texture = this.texture, v = !0);
          }
          v && this.fire(new a.Event("data", { dataType: "source", sourceDataType: "idle", sourceId: this.id }));
        }
        loadTile(o, h) {
          this.tileID && this.tileID.equals(o.tileID.canonical) ? (this.tiles[String(o.tileID.wrap)] = o, o.buckets = {}, h(null)) : (o.state = "errored", h(null));
        }
        serialize() {
          return { type: "image", url: this.options.url, coordinates: this.coordinates };
        }
        hasTransition() {
          return !1;
        }
      }
      class qt extends bt {
        constructor(o, h, v, w) {
          super(o, h, v, w), this.roundZoom = !0, this.type = "video", this.options = h;
        }
        load() {
          this._loaded = !1;
          const o = this.options;
          this.urls = [];
          for (const h of o.urls) this.urls.push(this.map._requestManager.transformRequest(h, N.Source).url);
          a.getVideo(this.urls, (h, v) => {
            this._loaded = !0, h ? this.fire(new a.ErrorEvent(h)) : v && (this.video = v, this.video.loop = !0, this.video.addEventListener("playing", () => {
              this.map.triggerRepaint();
            }), this.map && this.video.play(), this._finishLoading());
          });
        }
        pause() {
          this.video && this.video.pause();
        }
        play() {
          this.video && this.video.play();
        }
        seek(o) {
          if (this.video) {
            const h = this.video.seekable;
            o < h.start(0) || o > h.end(0) ? this.fire(new a.ErrorEvent(new a.ValidationError(`sources.${this.id}`, null, `Playback for this video can be set only between the ${h.start(0)} and ${h.end(0)}-second mark.`))) : this.video.currentTime = o;
          }
        }
        getVideo() {
          return this.video;
        }
        onAdd(o) {
          this.map || (this.map = o, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
        }
        prepare() {
          if (Object.keys(this.tiles).length === 0 || this.video.readyState < 2) return;
          const o = this.map.painter.context, h = o.gl;
          this.boundsBuffer || (this.boundsBuffer = o.createVertexBuffer(this._boundsArray, dt.members)), this.boundsSegments || (this.boundsSegments = a.SegmentVector.simpleSegment(0, 0, 4, 2)), this.texture ? this.video.paused || (this.texture.bind(h.LINEAR, h.CLAMP_TO_EDGE), h.texSubImage2D(h.TEXTURE_2D, 0, 0, 0, h.RGBA, h.UNSIGNED_BYTE, this.video)) : (this.texture = new ve(o, this.video, h.RGBA), this.texture.bind(h.LINEAR, h.CLAMP_TO_EDGE));
          let v = !1;
          for (const w in this.tiles) {
            const S = this.tiles[w];
            S.state !== "loaded" && (S.state = "loaded", S.texture = this.texture, v = !0);
          }
          v && this.fire(new a.Event("data", { dataType: "source", sourceDataType: "idle", sourceId: this.id }));
        }
        serialize() {
          return { type: "video", urls: this.urls, coordinates: this.coordinates };
        }
        hasTransition() {
          return this.video && !this.video.paused;
        }
      }
      class Oe extends bt {
        constructor(o, h, v, w) {
          super(o, h, v, w), h.coordinates ? Array.isArray(h.coordinates) && h.coordinates.length === 4 && !h.coordinates.some((S) => !Array.isArray(S) || S.length !== 2 || S.some((M) => typeof M != "number")) || this.fire(new a.ErrorEvent(new a.ValidationError(`sources.${o}`, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new a.ErrorEvent(new a.ValidationError(`sources.${o}`, null, 'missing required property "coordinates"'))), h.animate && typeof h.animate != "boolean" && this.fire(new a.ErrorEvent(new a.ValidationError(`sources.${o}`, null, 'optional "animate" property must be a boolean value'))), h.canvas ? typeof h.canvas == "string" || h.canvas instanceof HTMLCanvasElement || this.fire(new a.ErrorEvent(new a.ValidationError(`sources.${o}`, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new a.ErrorEvent(new a.ValidationError(`sources.${o}`, null, 'missing required property "canvas"'))), this.options = h, this.animate = h.animate === void 0 || h.animate;
        }
        load() {
          this._loaded = !0, this.canvas || (this.canvas = this.options.canvas instanceof HTMLCanvasElement ? this.options.canvas : document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new a.ErrorEvent(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function() {
            this._playing = !0, this.map.triggerRepaint();
          }, this.pause = function() {
            this._playing && (this.prepare(), this._playing = !1);
          }, this._finishLoading());
        }
        getCanvas() {
          return this.canvas;
        }
        onAdd(o) {
          this.map = o, this.load(), this.canvas && this.animate && this.play();
        }
        onRemove() {
          this.pause();
        }
        prepare() {
          let o = !1;
          if (this.canvas.width !== this.width && (this.width = this.canvas.width, o = !0), this.canvas.height !== this.height && (this.height = this.canvas.height, o = !0), this._hasInvalidDimensions() || Object.keys(this.tiles).length === 0) return;
          const h = this.map.painter.context, v = h.gl;
          this.boundsBuffer || (this.boundsBuffer = h.createVertexBuffer(this._boundsArray, dt.members)), this.boundsSegments || (this.boundsSegments = a.SegmentVector.simpleSegment(0, 0, 4, 2)), this.texture ? (o || this._playing) && this.texture.update(this.canvas, { premultiply: !0 }) : this.texture = new ve(h, this.canvas, v.RGBA, { premultiply: !0 });
          let w = !1;
          for (const S in this.tiles) {
            const M = this.tiles[S];
            M.state !== "loaded" && (M.state = "loaded", M.texture = this.texture, w = !0);
          }
          w && this.fire(new a.Event("data", { dataType: "source", sourceDataType: "idle", sourceId: this.id }));
        }
        serialize() {
          return { type: "canvas", coordinates: this.coordinates };
        }
        hasTransition() {
          return this._playing;
        }
        _hasInvalidDimensions() {
          for (const o of [this.canvas.width, this.canvas.height]) if (isNaN(o) || o <= 0) return !0;
          return !1;
        }
      }
      const Bt = { vector: je, raster: ot, "raster-dem": Xe, geojson: tt, video: qt, image: bt, canvas: Oe };
      function Tn(_, o) {
        const h = a.create();
        return a.translate(h, h, [1, 1, 0]), a.scale(h, h, [0.5 * _.width, 0.5 * _.height, 1]), a.multiply(h, h, _.calculatePosMatrix(o.toUnwrapped()));
      }
      function hn(_, o, h, v, w, S) {
        const M = function(J, fe, Se) {
          if (J) for (const we of J) {
            const Ce = fe[we];
            if (Ce && Ce.source === Se && Ce.type === "fill-extrusion") return !0;
          }
          else for (const we in fe) {
            const Ce = fe[we];
            if (Ce.source === Se && Ce.type === "fill-extrusion") return !0;
          }
          return !1;
        }(w && w.layers, o, _.id), z = S.maxPitchScaleFactor(), R = _.tilesIn(v, z, M);
        R.sort(Ht);
        const W = [];
        for (const J of R) W.push({ wrappedTileID: J.tileID.wrapped().key, queryResults: J.tile.queryRenderedFeatures(o, h, _._state, J.queryGeometry, J.cameraQueryGeometry, J.scale, w, S, z, Tn(_.transform, J.tileID)) });
        const Q = function(J) {
          const fe = {}, Se = {};
          for (const we of J) {
            const Ce = we.queryResults, Me = we.wrappedTileID, Ue = Se[Me] = Se[Me] || {};
            for (const ct in Ce) {
              const Ee = Ce[ct], st = Ue[ct] = Ue[ct] || {}, ht = fe[ct] = fe[ct] || [];
              for (const wt of Ee) st[wt.featureIndex] || (st[wt.featureIndex] = !0, ht.push(wt));
            }
          }
          return fe;
        }(W);
        for (const J in Q) Q[J].forEach((fe) => {
          const Se = fe.feature, we = _.getFeatureState(Se.layer["source-layer"], Se.id);
          Se.source = Se.layer.source, Se.layer["source-layer"] && (Se.sourceLayer = Se.layer["source-layer"]), Se.state = we;
        });
        return Q;
      }
      function Ht(_, o) {
        const h = _.tileID, v = o.tileID;
        return h.overscaledZ - v.overscaledZ || h.canonical.y - v.canonical.y || h.wrap - v.wrap || h.canonical.x - v.canonical.x;
      }
      class qn {
        constructor(o, h) {
          this.timeAdded = 0, this.fadeEndTime = 0, this.tileID = o, this.uid = a.uniqueId(), this.uses = 0, this.tileSize = h, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = !1, this.hasRTLText = !1, this.dependencies = {}, this.rtt = [], this.rttCoords = {}, this.expiredRequestCount = 0, this.state = "loading";
        }
        registerFadeDuration(o) {
          const h = o + this.timeAdded;
          h < this.fadeEndTime || (this.fadeEndTime = h);
        }
        wasRequested() {
          return this.state === "errored" || this.state === "loaded" || this.state === "reloading";
        }
        clearTextures(o) {
          this.demTexture && o.saveTileTexture(this.demTexture), this.demTexture = null;
        }
        loadVectorData(o, h, v) {
          if (this.hasData() && this.unloadVectorData(), this.state = "loaded", o) {
            o.featureIndex && (this.latestFeatureIndex = o.featureIndex, o.rawTileData ? (this.latestRawTileData = o.rawTileData, this.latestFeatureIndex.rawTileData = o.rawTileData) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData)), this.collisionBoxArray = o.collisionBoxArray, this.buckets = function(w, S) {
              const M = {};
              if (!S) return M;
              for (const z of w) {
                const R = z.layerIds.map((W) => S.getLayer(W)).filter(Boolean);
                if (R.length !== 0) {
                  z.layers = R, z.stateDependentLayerIds && (z.stateDependentLayers = z.stateDependentLayerIds.map((W) => R.filter((Q) => Q.id === W)[0]));
                  for (const W of R) M[W.id] = z;
                }
              }
              return M;
            }(o.buckets, h.style), this.hasSymbolBuckets = !1;
            for (const w in this.buckets) {
              const S = this.buckets[w];
              if (S instanceof a.SymbolBucket) {
                if (this.hasSymbolBuckets = !0, !v) break;
                S.justReloaded = !0;
              }
            }
            if (this.hasRTLText = !1, this.hasSymbolBuckets) for (const w in this.buckets) {
              const S = this.buckets[w];
              if (S instanceof a.SymbolBucket && S.hasRTLText) {
                this.hasRTLText = !0, a.lazyLoadRTLTextPlugin();
                break;
              }
            }
            this.queryPadding = 0;
            for (const w in this.buckets) {
              const S = this.buckets[w];
              this.queryPadding = Math.max(this.queryPadding, h.style.getLayer(w).queryRadius(S));
            }
            o.imageAtlas && (this.imageAtlas = o.imageAtlas), o.glyphAtlasImage && (this.glyphAtlasImage = o.glyphAtlasImage);
          } else this.collisionBoxArray = new a.CollisionBoxArray();
        }
        unloadVectorData() {
          for (const o in this.buckets) this.buckets[o].destroy();
          this.buckets = {}, this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.imageAtlas && (this.imageAtlas = null), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.latestFeatureIndex = null, this.state = "unloaded";
        }
        getBucket(o) {
          return this.buckets[o.id];
        }
        upload(o) {
          for (const v in this.buckets) {
            const w = this.buckets[v];
            w.uploadPending() && w.upload(o);
          }
          const h = o.gl;
          this.imageAtlas && !this.imageAtlas.uploaded && (this.imageAtlasTexture = new ve(o, this.imageAtlas.image, h.RGBA), this.imageAtlas.uploaded = !0), this.glyphAtlasImage && (this.glyphAtlasTexture = new ve(o, this.glyphAtlasImage, h.ALPHA), this.glyphAtlasImage = null);
        }
        prepare(o) {
          this.imageAtlas && this.imageAtlas.patchUpdatedImages(o, this.imageAtlasTexture);
        }
        queryRenderedFeatures(o, h, v, w, S, M, z, R, W, Q) {
          return this.latestFeatureIndex && this.latestFeatureIndex.rawTileData ? this.latestFeatureIndex.query({ queryGeometry: w, cameraQueryGeometry: S, scale: M, tileSize: this.tileSize, pixelPosMatrix: Q, transform: R, params: z, queryPadding: this.queryPadding * W }, o, h, v) : {};
        }
        querySourceFeatures(o, h) {
          const v = this.latestFeatureIndex;
          if (!v || !v.rawTileData) return;
          const w = v.loadVTLayers(), S = h && h.sourceLayer ? h.sourceLayer : "", M = w._geojsonTileLayer || w[S];
          if (!M) return;
          const z = a.createFilter(h && h.filter), { z: R, x: W, y: Q } = this.tileID.canonical, J = { z: R, x: W, y: Q };
          for (let fe = 0; fe < M.length; fe++) {
            const Se = M.feature(fe);
            if (z.needGeometry) {
              const Me = a.toEvaluationFeature(Se, !0);
              if (!z.filter(new a.EvaluationParameters(this.tileID.overscaledZ), Me, this.tileID.canonical)) continue;
            } else if (!z.filter(new a.EvaluationParameters(this.tileID.overscaledZ), Se)) continue;
            const we = v.getId(Se, S), Ce = new a.GeoJSONFeature(Se, R, W, Q, we);
            Ce.tile = J, o.push(Ce);
          }
        }
        hasData() {
          return this.state === "loaded" || this.state === "reloading" || this.state === "expired";
        }
        patternsLoaded() {
          return this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
        }
        setExpiryData(o) {
          const h = this.expirationTime;
          if (o.cacheControl) {
            const v = a.parseCacheControl(o.cacheControl);
            v["max-age"] && (this.expirationTime = Date.now() + 1e3 * v["max-age"]);
          } else o.expires && (this.expirationTime = new Date(o.expires).getTime());
          if (this.expirationTime) {
            const v = Date.now();
            let w = !1;
            if (this.expirationTime > v) w = !1;
            else if (h) if (this.expirationTime < h) w = !0;
            else {
              const S = this.expirationTime - h;
              S ? this.expirationTime = v + Math.max(S, 3e4) : w = !0;
            }
            else w = !0;
            w ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
          }
        }
        getExpiryTimeout() {
          if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - (/* @__PURE__ */ new Date()).getTime(), Math.pow(2, 31) - 1);
        }
        setFeatureState(o, h) {
          if (!this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData || Object.keys(o).length === 0) return;
          const v = this.latestFeatureIndex.loadVTLayers();
          for (const w in this.buckets) {
            if (!h.style.hasLayer(w)) continue;
            const S = this.buckets[w], M = S.layers[0].sourceLayer || "_geojsonTileLayer", z = v[M], R = o[M];
            if (!z || !R || Object.keys(R).length === 0) continue;
            S.update(R, z, this.imageAtlas && this.imageAtlas.patternPositions || {});
            const W = h && h.style && h.style.getLayer(w);
            W && (this.queryPadding = Math.max(this.queryPadding, W.queryRadius(S)));
          }
        }
        holdingForFade() {
          return this.symbolFadeHoldUntil !== void 0;
        }
        symbolFadeFinished() {
          return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < a.exported.now();
        }
        clearFadeHold() {
          this.symbolFadeHoldUntil = void 0;
        }
        setHoldDuration(o) {
          this.symbolFadeHoldUntil = a.exported.now() + o;
        }
        setDependencies(o, h) {
          const v = {};
          for (const w of h) v[w] = !0;
          this.dependencies[o] = v;
        }
        hasDependency(o, h) {
          for (const v of o) {
            const w = this.dependencies[v];
            if (w) {
              for (const S of h) if (w[S]) return !0;
            }
          }
          return !1;
        }
      }
      class vi {
        constructor(o, h) {
          this.max = o, this.onRemove = h, this.reset();
        }
        reset() {
          for (const o in this.data) for (const h of this.data[o]) h.timeout && clearTimeout(h.timeout), this.onRemove(h.value);
          return this.data = {}, this.order = [], this;
        }
        add(o, h, v) {
          const w = o.wrapped().key;
          this.data[w] === void 0 && (this.data[w] = []);
          const S = { value: h, timeout: void 0 };
          if (v !== void 0 && (S.timeout = setTimeout(() => {
            this.remove(o, S);
          }, v)), this.data[w].push(S), this.order.push(w), this.order.length > this.max) {
            const M = this._getAndRemoveByKey(this.order[0]);
            M && this.onRemove(M);
          }
          return this;
        }
        has(o) {
          return o.wrapped().key in this.data;
        }
        getAndRemove(o) {
          return this.has(o) ? this._getAndRemoveByKey(o.wrapped().key) : null;
        }
        _getAndRemoveByKey(o) {
          const h = this.data[o].shift();
          return h.timeout && clearTimeout(h.timeout), this.data[o].length === 0 && delete this.data[o], this.order.splice(this.order.indexOf(o), 1), h.value;
        }
        getByKey(o) {
          const h = this.data[o];
          return h ? h[0].value : null;
        }
        get(o) {
          return this.has(o) ? this.data[o.wrapped().key][0].value : null;
        }
        remove(o, h) {
          if (!this.has(o)) return this;
          const v = o.wrapped().key, w = h === void 0 ? 0 : this.data[v].indexOf(h), S = this.data[v][w];
          return this.data[v].splice(w, 1), S.timeout && clearTimeout(S.timeout), this.data[v].length === 0 && delete this.data[v], this.onRemove(S.value), this.order.splice(this.order.indexOf(v), 1), this;
        }
        setMaxSize(o) {
          for (this.max = o; this.order.length > this.max; ) {
            const h = this._getAndRemoveByKey(this.order[0]);
            h && this.onRemove(h);
          }
          return this;
        }
        filter(o) {
          const h = [];
          for (const v in this.data) for (const w of this.data[v]) o(w.value) || h.push(w);
          for (const v of h) this.remove(v.value.tileID, v);
        }
      }
      class It {
        constructor() {
          this.state = {}, this.stateChanges = {}, this.deletedStates = {};
        }
        updateState(o, h, v) {
          const w = String(h);
          if (this.stateChanges[o] = this.stateChanges[o] || {}, this.stateChanges[o][w] = this.stateChanges[o][w] || {}, a.extend(this.stateChanges[o][w], v), this.deletedStates[o] === null) {
            this.deletedStates[o] = {};
            for (const S in this.state[o]) S !== w && (this.deletedStates[o][S] = null);
          } else if (this.deletedStates[o] && this.deletedStates[o][w] === null) {
            this.deletedStates[o][w] = {};
            for (const S in this.state[o][w]) v[S] || (this.deletedStates[o][w][S] = null);
          } else for (const S in v) this.deletedStates[o] && this.deletedStates[o][w] && this.deletedStates[o][w][S] === null && delete this.deletedStates[o][w][S];
        }
        removeFeatureState(o, h, v) {
          if (this.deletedStates[o] === null) return;
          const w = String(h);
          if (this.deletedStates[o] = this.deletedStates[o] || {}, v && h !== void 0) this.deletedStates[o][w] !== null && (this.deletedStates[o][w] = this.deletedStates[o][w] || {}, this.deletedStates[o][w][v] = null);
          else if (h !== void 0) if (this.stateChanges[o] && this.stateChanges[o][w]) for (v in this.deletedStates[o][w] = {}, this.stateChanges[o][w]) this.deletedStates[o][w][v] = null;
          else this.deletedStates[o][w] = null;
          else this.deletedStates[o] = null;
        }
        getState(o, h) {
          const v = String(h), w = a.extend({}, (this.state[o] || {})[v], (this.stateChanges[o] || {})[v]);
          if (this.deletedStates[o] === null) return {};
          if (this.deletedStates[o]) {
            const S = this.deletedStates[o][h];
            if (S === null) return {};
            for (const M in S) delete w[M];
          }
          return w;
        }
        initializeTileState(o, h) {
          o.setFeatureState(this.state, h);
        }
        coalesceChanges(o, h) {
          const v = {};
          for (const w in this.stateChanges) {
            this.state[w] = this.state[w] || {};
            const S = {};
            for (const M in this.stateChanges[w]) this.state[w][M] || (this.state[w][M] = {}), a.extend(this.state[w][M], this.stateChanges[w][M]), S[M] = this.state[w][M];
            v[w] = S;
          }
          for (const w in this.deletedStates) {
            this.state[w] = this.state[w] || {};
            const S = {};
            if (this.deletedStates[w] === null) for (const M in this.state[w]) S[M] = {}, this.state[w][M] = {};
            else for (const M in this.deletedStates[w]) {
              if (this.deletedStates[w][M] === null) this.state[w][M] = {};
              else for (const z of Object.keys(this.deletedStates[w][M])) delete this.state[w][M][z];
              S[M] = this.state[w][M];
            }
            v[w] = v[w] || {}, a.extend(v[w], S);
          }
          if (this.stateChanges = {}, this.deletedStates = {}, Object.keys(v).length !== 0) for (const w in o) o[w].setFeatureState(v, h);
        }
      }
      class wn extends a.Evented {
        constructor(o, h, v) {
          super(), this.id = o, this.dispatcher = v, this.on("data", (w) => {
            w.dataType === "source" && w.sourceDataType === "metadata" && (this._sourceLoaded = !0), this._sourceLoaded && !this._paused && w.dataType === "source" && w.sourceDataType === "content" && (this.reload(), this.transform && this.update(this.transform, this.terrain), this._didEmitContent = !0);
          }), this.on("dataloading", () => {
            this._sourceErrored = !1;
          }), this.on("error", () => {
            this._sourceErrored = this._source.loaded();
          }), this._source = function(w, S, M, z) {
            const R = new Bt[S.type](w, S, M, z);
            if (R.id !== w) throw new Error(`Expected Source id to be ${w} instead of ${R.id}`);
            return a.bindAll(["load", "abort", "unload", "serialize", "prepare"], R), R;
          }(o, h, v, this), this._tiles = {}, this._cache = new vi(0, this._unloadTile.bind(this)), this._timers = {}, this._cacheTimers = {}, this._maxTileCacheSize = null, this._maxTileCacheZoomLevels = null, this._loadedParentTiles = {}, this._coveredTiles = {}, this._state = new It(), this._didEmitContent = !1, this._updated = !1;
        }
        onAdd(o) {
          this.map = o, this._maxTileCacheSize = o ? o._maxTileCacheSize : null, this._maxTileCacheZoomLevels = o ? o._maxTileCacheZoomLevels : null, this._source && this._source.onAdd && this._source.onAdd(o);
        }
        onRemove(o) {
          this.clearTiles(), this._source && this._source.onRemove && this._source.onRemove(o);
        }
        loaded() {
          if (this._sourceErrored) return !0;
          if (!this._sourceLoaded || !this._source.loaded()) return !1;
          if (!(this.used === void 0 && this.usedForTerrain === void 0 || this.used || this.usedForTerrain)) return !0;
          if (!this._updated) return !1;
          for (const o in this._tiles) {
            const h = this._tiles[o];
            if (h.state !== "loaded" && h.state !== "errored") return !1;
          }
          return !0;
        }
        getSource() {
          return this._source;
        }
        pause() {
          this._paused = !0;
        }
        resume() {
          if (!this._paused) return;
          const o = this._shouldReloadOnResume;
          this._paused = !1, this._shouldReloadOnResume = !1, o && this.reload(), this.transform && this.update(this.transform, this.terrain);
        }
        _loadTile(o, h) {
          return this._source.loadTile(o, h);
        }
        _unloadTile(o) {
          if (this._source.unloadTile) return this._source.unloadTile(o, () => {
          });
        }
        _abortTile(o) {
          this._source.abortTile && this._source.abortTile(o, () => {
          }), this._source.fire(new a.Event("dataabort", { tile: o, coord: o.tileID, dataType: "source" }));
        }
        serialize() {
          return this._source.serialize();
        }
        prepare(o) {
          this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null);
          for (const h in this._tiles) {
            const v = this._tiles[h];
            v.upload(o), v.prepare(this.map.style.imageManager);
          }
        }
        getIds() {
          return Object.values(this._tiles).map((o) => o.tileID).sort(Oi).map((o) => o.key);
        }
        getRenderableIds(o) {
          const h = [];
          for (const v in this._tiles) this._isIdRenderable(v, o) && h.push(this._tiles[v]);
          return o ? h.sort((v, w) => {
            const S = v.tileID, M = w.tileID, z = new a.Point(S.canonical.x, S.canonical.y)._rotate(this.transform.angle), R = new a.Point(M.canonical.x, M.canonical.y)._rotate(this.transform.angle);
            return S.overscaledZ - M.overscaledZ || R.y - z.y || R.x - z.x;
          }).map((v) => v.tileID.key) : h.map((v) => v.tileID).sort(Oi).map((v) => v.key);
        }
        hasRenderableParent(o) {
          const h = this.findLoadedParent(o, 0);
          return !!h && this._isIdRenderable(h.tileID.key);
        }
        _isIdRenderable(o, h) {
          return this._tiles[o] && this._tiles[o].hasData() && !this._coveredTiles[o] && (h || !this._tiles[o].holdingForFade());
        }
        reload() {
          if (this._paused) this._shouldReloadOnResume = !0;
          else {
            this._cache.reset();
            for (const o in this._tiles) this._tiles[o].state !== "errored" && this._reloadTile(o, "reloading");
          }
        }
        _reloadTile(o, h) {
          const v = this._tiles[o];
          v && (v.state !== "loading" && (v.state = h), this._loadTile(v, this._tileLoaded.bind(this, v, o, h)));
        }
        _tileLoaded(o, h, v, w) {
          if (w) return o.state = "errored", void (w.status !== 404 ? this._source.fire(new a.ErrorEvent(w, { tile: o })) : this.update(this.transform, this.terrain));
          o.timeAdded = a.exported.now(), v === "expired" && (o.refreshedUponExpiration = !0), this._setTileReloadTimer(h, o), this.getSource().type === "raster-dem" && o.dem && this._backfillDEM(o), this._state.initializeTileState(o, this.map ? this.map.painter : null), o.aborted || this._source.fire(new a.Event("data", { dataType: "source", tile: o, coord: o.tileID }));
        }
        _backfillDEM(o) {
          const h = this.getRenderableIds();
          for (let w = 0; w < h.length; w++) {
            const S = h[w];
            if (o.neighboringTiles && o.neighboringTiles[S]) {
              const M = this.getTileByID(S);
              v(o, M), v(M, o);
            }
          }
          function v(w, S) {
            w.needsHillshadePrepare = !0, w.needsTerrainPrepare = !0;
            let M = S.tileID.canonical.x - w.tileID.canonical.x;
            const z = S.tileID.canonical.y - w.tileID.canonical.y, R = Math.pow(2, w.tileID.canonical.z), W = S.tileID.key;
            M === 0 && z === 0 || Math.abs(z) > 1 || (Math.abs(M) > 1 && (Math.abs(M + R) === 1 ? M += R : Math.abs(M - R) === 1 && (M -= R)), S.dem && w.dem && (w.dem.backfillBorder(S.dem, M, z), w.neighboringTiles && w.neighboringTiles[W] && (w.neighboringTiles[W].backfilled = !0)));
          }
        }
        getTile(o) {
          return this.getTileByID(o.key);
        }
        getTileByID(o) {
          return this._tiles[o];
        }
        _retainLoadedChildren(o, h, v, w) {
          for (const S in this._tiles) {
            let M = this._tiles[S];
            if (w[S] || !M.hasData() || M.tileID.overscaledZ <= h || M.tileID.overscaledZ > v) continue;
            let z = M.tileID;
            for (; M && M.tileID.overscaledZ > h + 1; ) {
              const W = M.tileID.scaledTo(M.tileID.overscaledZ - 1);
              M = this._tiles[W.key], M && M.hasData() && (z = W);
            }
            let R = z;
            for (; R.overscaledZ > h; ) if (R = R.scaledTo(R.overscaledZ - 1), o[R.key]) {
              w[z.key] = z;
              break;
            }
          }
        }
        findLoadedParent(o, h) {
          if (o.key in this._loadedParentTiles) {
            const v = this._loadedParentTiles[o.key];
            return v && v.tileID.overscaledZ >= h ? v : null;
          }
          for (let v = o.overscaledZ - 1; v >= h; v--) {
            const w = o.scaledTo(v), S = this._getLoadedTile(w);
            if (S) return S;
          }
        }
        _getLoadedTile(o) {
          const h = this._tiles[o.key];
          return h && h.hasData() ? h : this._cache.getByKey(o.wrapped().key);
        }
        updateCacheSize(o) {
          const h = Math.ceil(o.width / this._source.tileSize) + 1, v = Math.ceil(o.height / this._source.tileSize) + 1, w = Math.floor(h * v * (this._maxTileCacheZoomLevels === null ? a.config.MAX_TILE_CACHE_ZOOM_LEVELS : this._maxTileCacheZoomLevels)), S = typeof this._maxTileCacheSize == "number" ? Math.min(this._maxTileCacheSize, w) : w;
          this._cache.setMaxSize(S);
        }
        handleWrapJump(o) {
          const h = Math.round((o - (this._prevLng === void 0 ? o : this._prevLng)) / 360);
          if (this._prevLng = o, h) {
            const v = {};
            for (const w in this._tiles) {
              const S = this._tiles[w];
              S.tileID = S.tileID.unwrapTo(S.tileID.wrap + h), v[S.tileID.key] = S;
            }
            this._tiles = v;
            for (const w in this._timers) clearTimeout(this._timers[w]), delete this._timers[w];
            for (const w in this._tiles) this._setTileReloadTimer(w, this._tiles[w]);
          }
        }
        update(o, h) {
          if (this.transform = o, this.terrain = h, !this._sourceLoaded || this._paused) return;
          let v;
          this.updateCacheSize(o), this.handleWrapJump(this.transform.center.lng), this._coveredTiles = {}, this.used || this.usedForTerrain ? this._source.tileID ? v = o.getVisibleUnwrappedCoordinates(this._source.tileID).map((Q) => new a.OverscaledTileID(Q.canonical.z, Q.wrap, Q.canonical.z, Q.canonical.x, Q.canonical.y)) : (v = o.coveringTiles({ tileSize: this.usedForTerrain ? this.tileSize : this._source.tileSize, minzoom: this._source.minzoom, maxzoom: this._source.maxzoom, roundZoom: !this.usedForTerrain && this._source.roundZoom, reparseOverscaled: this._source.reparseOverscaled, terrain: h }), this._source.hasTile && (v = v.filter((Q) => this._source.hasTile(Q)))) : v = [];
          const w = o.coveringZoomLevel(this._source), S = Math.max(w - wn.maxOverzooming, this._source.minzoom), M = Math.max(w + wn.maxUnderzooming, this._source.minzoom);
          if (this.usedForTerrain) {
            const Q = {};
            for (const J of v) if (J.canonical.z > this._source.minzoom) {
              const fe = J.scaledTo(J.canonical.z - 1);
              Q[fe.key] = fe;
              const Se = J.scaledTo(Math.max(this._source.minzoom, Math.min(J.canonical.z, 5)));
              Q[Se.key] = Se;
            }
            v = v.concat(Object.values(Q));
          }
          const z = v.length === 0 && !this._updated && this._didEmitContent;
          this._updated = !0, z && this.fire(new a.Event("data", { sourceDataType: "idle", dataType: "source", sourceId: this.id }));
          const R = this._updateRetainedTiles(v, w);
          if (hr(this._source.type)) {
            const Q = {}, J = {}, fe = Object.keys(R), Se = a.exported.now();
            for (const we of fe) {
              const Ce = R[we], Me = this._tiles[we];
              if (!Me || Me.fadeEndTime !== 0 && Me.fadeEndTime <= Se) continue;
              const Ue = this.findLoadedParent(Ce, S);
              Ue && (this._addTile(Ue.tileID), Q[Ue.tileID.key] = Ue.tileID), J[we] = Ce;
            }
            this._retainLoadedChildren(J, w, M, R);
            for (const we in Q) R[we] || (this._coveredTiles[we] = !0, R[we] = Q[we]);
            if (h) {
              const we = {}, Ce = {};
              for (const Me of v) this._tiles[Me.key].hasData() ? we[Me.key] = Me : Ce[Me.key] = Me;
              for (const Me in Ce) {
                const Ue = Ce[Me].children(this._source.maxzoom);
                this._tiles[Ue[0].key] && this._tiles[Ue[1].key] && this._tiles[Ue[2].key] && this._tiles[Ue[3].key] && (we[Ue[0].key] = R[Ue[0].key] = Ue[0], we[Ue[1].key] = R[Ue[1].key] = Ue[1], we[Ue[2].key] = R[Ue[2].key] = Ue[2], we[Ue[3].key] = R[Ue[3].key] = Ue[3], delete Ce[Me]);
              }
              for (const Me in Ce) {
                const Ue = this.findLoadedParent(Ce[Me], this._source.minzoom);
                if (Ue) {
                  we[Ue.tileID.key] = R[Ue.tileID.key] = Ue.tileID;
                  for (const ct in we) we[ct].isChildOf(Ue.tileID) && delete we[ct];
                }
              }
              for (const Me in this._tiles) we[Me] || (this._coveredTiles[Me] = !0);
            }
          }
          for (const Q in R) this._tiles[Q].clearFadeHold();
          const W = a.keysDifference(this._tiles, R);
          for (const Q of W) {
            const J = this._tiles[Q];
            J.hasSymbolBuckets && !J.holdingForFade() ? J.setHoldDuration(this.map._fadeDuration) : J.hasSymbolBuckets && !J.symbolFadeFinished() || this._removeTile(Q);
          }
          this._updateLoadedParentTileCache();
        }
        releaseSymbolFadeTiles() {
          for (const o in this._tiles) this._tiles[o].holdingForFade() && this._removeTile(o);
        }
        _updateRetainedTiles(o, h) {
          const v = {}, w = {}, S = Math.max(h - wn.maxOverzooming, this._source.minzoom), M = Math.max(h + wn.maxUnderzooming, this._source.minzoom), z = {};
          for (const R of o) {
            const W = this._addTile(R);
            v[R.key] = R, W.hasData() || h < this._source.maxzoom && (z[R.key] = R);
          }
          this._retainLoadedChildren(z, h, M, v);
          for (const R of o) {
            let W = this._tiles[R.key];
            if (W.hasData()) continue;
            if (h + 1 > this._source.maxzoom) {
              const J = R.children(this._source.maxzoom)[0], fe = this.getTile(J);
              if (fe && fe.hasData()) {
                v[J.key] = J;
                continue;
              }
            } else {
              const J = R.children(this._source.maxzoom);
              if (v[J[0].key] && v[J[1].key] && v[J[2].key] && v[J[3].key]) continue;
            }
            let Q = W.wasRequested();
            for (let J = R.overscaledZ - 1; J >= S; --J) {
              const fe = R.scaledTo(J);
              if (w[fe.key]) break;
              if (w[fe.key] = !0, W = this.getTile(fe), !W && Q && (W = this._addTile(fe)), W) {
                const Se = W.hasData();
                if ((Q || Se) && (v[fe.key] = fe), Q = W.wasRequested(), Se) break;
              }
            }
          }
          return v;
        }
        _updateLoadedParentTileCache() {
          this._loadedParentTiles = {};
          for (const o in this._tiles) {
            const h = [];
            let v, w = this._tiles[o].tileID;
            for (; w.overscaledZ > 0; ) {
              if (w.key in this._loadedParentTiles) {
                v = this._loadedParentTiles[w.key];
                break;
              }
              h.push(w.key);
              const S = w.scaledTo(w.overscaledZ - 1);
              if (v = this._getLoadedTile(S), v) break;
              w = S;
            }
            for (const S of h) this._loadedParentTiles[S] = v;
          }
        }
        _addTile(o) {
          let h = this._tiles[o.key];
          if (h) return h;
          h = this._cache.getAndRemove(o), h && (this._setTileReloadTimer(o.key, h), h.tileID = o, this._state.initializeTileState(h, this.map ? this.map.painter : null), this._cacheTimers[o.key] && (clearTimeout(this._cacheTimers[o.key]), delete this._cacheTimers[o.key], this._setTileReloadTimer(o.key, h)));
          const v = h;
          return h || (h = new qn(o, this._source.tileSize * o.overscaleFactor()), this._loadTile(h, this._tileLoaded.bind(this, h, o.key, h.state))), h.uses++, this._tiles[o.key] = h, v || this._source.fire(new a.Event("dataloading", { tile: h, coord: h.tileID, dataType: "source" })), h;
        }
        _setTileReloadTimer(o, h) {
          o in this._timers && (clearTimeout(this._timers[o]), delete this._timers[o]);
          const v = h.getExpiryTimeout();
          v && (this._timers[o] = setTimeout(() => {
            this._reloadTile(o, "expired"), delete this._timers[o];
          }, v));
        }
        _removeTile(o) {
          const h = this._tiles[o];
          h && (h.uses--, delete this._tiles[o], this._timers[o] && (clearTimeout(this._timers[o]), delete this._timers[o]), h.uses > 0 || (h.hasData() && h.state !== "reloading" ? this._cache.add(h.tileID, h, h.getExpiryTimeout()) : (h.aborted = !0, this._abortTile(h), this._unloadTile(h))));
        }
        clearTiles() {
          this._shouldReloadOnResume = !1, this._paused = !1;
          for (const o in this._tiles) this._removeTile(o);
          this._cache.reset();
        }
        tilesIn(o, h, v) {
          const w = [], S = this.transform;
          if (!S) return w;
          const M = v ? S.getCameraQueryGeometry(o) : o, z = o.map((we) => S.pointCoordinate(we, this.terrain)), R = M.map((we) => S.pointCoordinate(we, this.terrain)), W = this.getIds();
          let Q = 1 / 0, J = 1 / 0, fe = -1 / 0, Se = -1 / 0;
          for (const we of R) Q = Math.min(Q, we.x), J = Math.min(J, we.y), fe = Math.max(fe, we.x), Se = Math.max(Se, we.y);
          for (let we = 0; we < W.length; we++) {
            const Ce = this._tiles[W[we]];
            if (Ce.holdingForFade()) continue;
            const Me = Ce.tileID, Ue = Math.pow(2, S.zoom - Ce.tileID.overscaledZ), ct = h * Ce.queryPadding * a.EXTENT / Ce.tileSize / Ue, Ee = [Me.getTilePoint(new a.MercatorCoordinate(Q, J)), Me.getTilePoint(new a.MercatorCoordinate(fe, Se))];
            if (Ee[0].x - ct < a.EXTENT && Ee[0].y - ct < a.EXTENT && Ee[1].x + ct >= 0 && Ee[1].y + ct >= 0) {
              const st = z.map((wt) => Me.getTilePoint(wt)), ht = R.map((wt) => Me.getTilePoint(wt));
              w.push({ tile: Ce, tileID: Me, queryGeometry: st, cameraQueryGeometry: ht, scale: Ue });
            }
          }
          return w;
        }
        getVisibleCoordinates(o) {
          const h = this.getRenderableIds(o).map((v) => this._tiles[v].tileID);
          for (const v of h) v.posMatrix = this.transform.calculatePosMatrix(v.toUnwrapped());
          return h;
        }
        hasTransition() {
          if (this._source.hasTransition()) return !0;
          if (hr(this._source.type)) {
            const o = a.exported.now();
            for (const h in this._tiles) if (this._tiles[h].fadeEndTime >= o) return !0;
          }
          return !1;
        }
        setFeatureState(o, h, v) {
          this._state.updateState(o = o || "_geojsonTileLayer", h, v);
        }
        removeFeatureState(o, h, v) {
          this._state.removeFeatureState(o = o || "_geojsonTileLayer", h, v);
        }
        getFeatureState(o, h) {
          return this._state.getState(o = o || "_geojsonTileLayer", h);
        }
        setDependencies(o, h, v) {
          const w = this._tiles[o];
          w && w.setDependencies(h, v);
        }
        reloadTilesForDependencies(o, h) {
          for (const v in this._tiles) this._tiles[v].hasDependency(o, h) && this._reloadTile(v, "reloading");
          this._cache.filter((v) => !v.hasDependency(o, h));
        }
      }
      function Oi(_, o) {
        const h = Math.abs(2 * _.wrap) - +(_.wrap < 0), v = Math.abs(2 * o.wrap) - +(o.wrap < 0);
        return _.overscaledZ - o.overscaledZ || v - h || o.canonical.y - _.canonical.y || o.canonical.x - _.canonical.x;
      }
      function hr(_) {
        return _ === "raster" || _ === "image" || _ === "video";
      }
      wn.maxOverzooming = 10, wn.maxUnderzooming = 3;
      const qi = "mapboxgl_preloaded_worker_pool";
      class kt {
        constructor() {
          this.active = {};
        }
        acquire(o) {
          if (!this.workers) for (this.workers = []; this.workers.length < kt.workerCount; ) this.workers.push(new Worker(a.config.WORKER_URL));
          return this.active[o] = !0, this.workers.slice();
        }
        release(o) {
          delete this.active[o], this.numActive() === 0 && (this.workers.forEach((h) => {
            h.terminate();
          }), this.workers = null);
        }
        isPreloaded() {
          return !!this.active[qi];
        }
        numActive() {
          return Object.keys(this.active).length;
        }
      }
      const wi = Math.floor(a.exported.hardwareConcurrency / 2);
      let ai;
      function Hr() {
        return ai || (ai = new kt()), ai;
      }
      kt.workerCount = a.isSafari(globalThis) ? Math.max(Math.min(wi, 3), 1) : 1;
      class hs {
        constructor(o, h) {
          this.reset(o, h);
        }
        reset(o, h) {
          this.points = o || [], this._distances = [0];
          for (let v = 1; v < this.points.length; v++) this._distances[v] = this._distances[v - 1] + this.points[v].dist(this.points[v - 1]);
          this.length = this._distances[this._distances.length - 1], this.padding = Math.min(h || 0, 0.5 * this.length), this.paddedLength = this.length - 2 * this.padding;
        }
        lerp(o) {
          if (this.points.length === 1) return this.points[0];
          o = a.clamp(o, 0, 1);
          let h = 1, v = this._distances[h];
          const w = o * this.paddedLength + this.padding;
          for (; v < w && h < this._distances.length; ) v = this._distances[++h];
          const S = h - 1, M = this._distances[S], z = v - M, R = z > 0 ? (w - M) / z : 0;
          return this.points[S].mult(1 - R).add(this.points[h].mult(R));
        }
      }
      function Pt(_, o) {
        let h = !0;
        return _ === "always" || _ !== "never" && o !== "never" || (h = !1), h;
      }
      class $n {
        constructor(o, h, v) {
          const w = this.boxCells = [], S = this.circleCells = [];
          this.xCellCount = Math.ceil(o / v), this.yCellCount = Math.ceil(h / v);
          for (let M = 0; M < this.xCellCount * this.yCellCount; M++) w.push([]), S.push([]);
          this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = o, this.height = h, this.xScale = this.xCellCount / o, this.yScale = this.yCellCount / h, this.boxUid = 0, this.circleUid = 0;
        }
        keysLength() {
          return this.boxKeys.length + this.circleKeys.length;
        }
        insert(o, h, v, w, S) {
          this._forEachCell(h, v, w, S, this._insertBoxCell, this.boxUid++), this.boxKeys.push(o), this.bboxes.push(h), this.bboxes.push(v), this.bboxes.push(w), this.bboxes.push(S);
        }
        insertCircle(o, h, v, w) {
          this._forEachCell(h - w, v - w, h + w, v + w, this._insertCircleCell, this.circleUid++), this.circleKeys.push(o), this.circles.push(h), this.circles.push(v), this.circles.push(w);
        }
        _insertBoxCell(o, h, v, w, S, M) {
          this.boxCells[S].push(M);
        }
        _insertCircleCell(o, h, v, w, S, M) {
          this.circleCells[S].push(M);
        }
        _query(o, h, v, w, S, M, z) {
          if (v < 0 || o > this.width || w < 0 || h > this.height) return [];
          const R = [];
          if (o <= 0 && h <= 0 && this.width <= v && this.height <= w) {
            if (S) return [{ key: null, x1: o, y1: h, x2: v, y2: w }];
            for (let W = 0; W < this.boxKeys.length; W++) R.push({ key: this.boxKeys[W], x1: this.bboxes[4 * W], y1: this.bboxes[4 * W + 1], x2: this.bboxes[4 * W + 2], y2: this.bboxes[4 * W + 3] });
            for (let W = 0; W < this.circleKeys.length; W++) {
              const Q = this.circles[3 * W], J = this.circles[3 * W + 1], fe = this.circles[3 * W + 2];
              R.push({ key: this.circleKeys[W], x1: Q - fe, y1: J - fe, x2: Q + fe, y2: J + fe });
            }
          } else this._forEachCell(o, h, v, w, this._queryCell, R, { hitTest: S, overlapMode: M, seenUids: { box: {}, circle: {} } }, z);
          return R;
        }
        query(o, h, v, w) {
          return this._query(o, h, v, w, !1, null);
        }
        hitTest(o, h, v, w, S, M) {
          return this._query(o, h, v, w, !0, S, M).length > 0;
        }
        hitTestCircle(o, h, v, w, S) {
          const M = o - v, z = o + v, R = h - v, W = h + v;
          if (z < 0 || M > this.width || W < 0 || R > this.height) return !1;
          const Q = [];
          return this._forEachCell(M, R, z, W, this._queryCellCircle, Q, { hitTest: !0, overlapMode: w, circle: { x: o, y: h, radius: v }, seenUids: { box: {}, circle: {} } }, S), Q.length > 0;
        }
        _queryCell(o, h, v, w, S, M, z, R) {
          const { seenUids: W, hitTest: Q, overlapMode: J } = z, fe = this.boxCells[S];
          if (fe !== null) {
            const we = this.bboxes;
            for (const Ce of fe) if (!W.box[Ce]) {
              W.box[Ce] = !0;
              const Me = 4 * Ce, Ue = this.boxKeys[Ce];
              if (o <= we[Me + 2] && h <= we[Me + 3] && v >= we[Me + 0] && w >= we[Me + 1] && (!R || R(Ue)) && (!Q || !Pt(J, Ue.overlapMode)) && (M.push({ key: Ue, x1: we[Me], y1: we[Me + 1], x2: we[Me + 2], y2: we[Me + 3] }), Q)) return !0;
            }
          }
          const Se = this.circleCells[S];
          if (Se !== null) {
            const we = this.circles;
            for (const Ce of Se) if (!W.circle[Ce]) {
              W.circle[Ce] = !0;
              const Me = 3 * Ce, Ue = this.circleKeys[Ce];
              if (this._circleAndRectCollide(we[Me], we[Me + 1], we[Me + 2], o, h, v, w) && (!R || R(Ue)) && (!Q || !Pt(J, Ue.overlapMode))) {
                const ct = we[Me], Ee = we[Me + 1], st = we[Me + 2];
                if (M.push({ key: Ue, x1: ct - st, y1: Ee - st, x2: ct + st, y2: Ee + st }), Q) return !0;
              }
            }
          }
          return !1;
        }
        _queryCellCircle(o, h, v, w, S, M, z, R) {
          const { circle: W, seenUids: Q, overlapMode: J } = z, fe = this.boxCells[S];
          if (fe !== null) {
            const we = this.bboxes;
            for (const Ce of fe) if (!Q.box[Ce]) {
              Q.box[Ce] = !0;
              const Me = 4 * Ce, Ue = this.boxKeys[Ce];
              if (this._circleAndRectCollide(W.x, W.y, W.radius, we[Me + 0], we[Me + 1], we[Me + 2], we[Me + 3]) && (!R || R(Ue)) && !Pt(J, Ue.overlapMode)) return M.push(!0), !0;
            }
          }
          const Se = this.circleCells[S];
          if (Se !== null) {
            const we = this.circles;
            for (const Ce of Se) if (!Q.circle[Ce]) {
              Q.circle[Ce] = !0;
              const Me = 3 * Ce, Ue = this.circleKeys[Ce];
              if (this._circlesCollide(we[Me], we[Me + 1], we[Me + 2], W.x, W.y, W.radius) && (!R || R(Ue)) && !Pt(J, Ue.overlapMode)) return M.push(!0), !0;
            }
          }
        }
        _forEachCell(o, h, v, w, S, M, z, R) {
          const W = this._convertToXCellCoord(o), Q = this._convertToYCellCoord(h), J = this._convertToXCellCoord(v), fe = this._convertToYCellCoord(w);
          for (let Se = W; Se <= J; Se++) for (let we = Q; we <= fe; we++) if (S.call(this, o, h, v, w, this.xCellCount * we + Se, M, z, R)) return;
        }
        _convertToXCellCoord(o) {
          return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(o * this.xScale)));
        }
        _convertToYCellCoord(o) {
          return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(o * this.yScale)));
        }
        _circlesCollide(o, h, v, w, S, M) {
          const z = w - o, R = S - h, W = v + M;
          return W * W > z * z + R * R;
        }
        _circleAndRectCollide(o, h, v, w, S, M, z) {
          const R = (M - w) / 2, W = Math.abs(o - (w + R));
          if (W > R + v) return !1;
          const Q = (z - S) / 2, J = Math.abs(h - (S + Q));
          if (J > Q + v) return !1;
          if (W <= R || J <= Q) return !0;
          const fe = W - R, Se = J - Q;
          return fe * fe + Se * Se <= v * v;
        }
      }
      function yn(_, o, h, v, w) {
        const S = a.create();
        return o ? (a.scale(S, S, [1 / w, 1 / w, 1]), h || a.rotateZ(S, S, v.angle)) : a.multiply(S, v.labelPlaneMatrix, _), S;
      }
      function Qi(_, o, h, v, w) {
        if (o) {
          const S = a.clone(_);
          return a.scale(S, S, [w, w, 1]), h || a.rotateZ(S, S, -v.angle), S;
        }
        return v.glCoordMatrix;
      }
      function Gi(_, o, h) {
        let v;
        h ? (v = [_.x, _.y, h(_.x, _.y), 1], a.transformMat4(v, v, o)) : (v = [_.x, _.y, 0, 1], Pe(v, v, o));
        const w = v[3];
        return { point: new a.Point(v[0] / w, v[1] / w), signedDistanceFromCamera: w };
      }
      function Cn(_, o) {
        return 0.5 + _ / o * 0.5;
      }
      function or(_, o) {
        const h = _[0] / _[3], v = _[1] / _[3];
        return h >= -o[0] && h <= o[0] && v >= -o[1] && v <= o[1];
      }
      function Wr(_, o, h, v, w, S, M, z, R, W) {
        const Q = v ? _.textSizeData : _.iconSizeData, J = a.evaluateSizeForZoom(Q, h.transform.zoom), fe = [256 / h.width * 2 + 1, 256 / h.height * 2 + 1], Se = v ? _.text.dynamicLayoutVertexArray : _.icon.dynamicLayoutVertexArray;
        Se.clear();
        const we = _.lineVertexArray, Ce = v ? _.text.placedSymbolArray : _.icon.placedSymbolArray, Me = h.transform.width / h.transform.height;
        let Ue = !1;
        for (let ct = 0; ct < Ce.length; ct++) {
          const Ee = Ce.get(ct);
          if (Ee.hidden || Ee.writingMode === a.WritingMode.vertical && !Ue) {
            be(Ee.numGlyphs, Se);
            continue;
          }
          let st;
          if (Ue = !1, W ? (st = [Ee.anchorX, Ee.anchorY, W(Ee.anchorX, Ee.anchorY), 1], a.transformMat4(st, st, o)) : (st = [Ee.anchorX, Ee.anchorY, 0, 1], Pe(st, st, o)), !or(st, fe)) {
            be(Ee.numGlyphs, Se);
            continue;
          }
          const ht = Cn(h.transform.cameraToCenterDistance, st[3]), wt = a.evaluateSizeForFeature(Q, J, Ee), Ct = M ? wt / ht : wt * ht, Dt = new a.Point(Ee.anchorX, Ee.anchorY), xt = Gi(Dt, w, W).point, Wt = { projections: {}, offsets: {} }, fn = tr(Ee, Ct, !1, z, o, w, S, _.glyphOffsetArray, we, Se, xt, Dt, Wt, Me, R, W);
          Ue = fn.useVertical, (fn.notEnoughRoom || Ue || fn.needsFlipping && tr(Ee, Ct, !0, z, o, w, S, _.glyphOffsetArray, we, Se, xt, Dt, Wt, Me, R, W).notEnoughRoom) && be(Ee.numGlyphs, Se);
        }
        v ? _.text.dynamicLayoutVertexBuffer.updateData(Se) : _.icon.dynamicLayoutVertexBuffer.updateData(Se);
      }
      function kr(_, o, h, v, w, S, M, z, R, W, Q, J, fe) {
        const Se = z.glyphStartIndex + z.numGlyphs, we = z.lineStartIndex, Ce = z.lineStartIndex + z.lineLength, Me = o.getoffsetX(z.glyphStartIndex), Ue = o.getoffsetX(Se - 1), ct = se(_ * Me, h, v, w, S, M, z.segment, we, Ce, R, W, Q, J, fe);
        if (!ct) return null;
        const Ee = se(_ * Ue, h, v, w, S, M, z.segment, we, Ce, R, W, Q, J, fe);
        return Ee ? { first: ct, last: Ee } : null;
      }
      function fs(_, o, h, v) {
        return _ === a.WritingMode.horizontal && Math.abs(h.y - o.y) > Math.abs(h.x - o.x) * v ? { useVertical: !0 } : (_ === a.WritingMode.vertical ? o.y < h.y : o.x > h.x) ? { needsFlipping: !0 } : null;
      }
      function tr(_, o, h, v, w, S, M, z, R, W, Q, J, fe, Se, we, Ce) {
        const Me = o / 24, Ue = _.lineOffsetX * Me, ct = _.lineOffsetY * Me;
        let Ee;
        if (_.numGlyphs > 1) {
          const st = _.glyphStartIndex + _.numGlyphs, ht = _.lineStartIndex, wt = _.lineStartIndex + _.lineLength, Ct = kr(Me, z, Ue, ct, h, Q, J, _, R, S, fe, we, Ce);
          if (!Ct) return { notEnoughRoom: !0 };
          const Dt = Gi(Ct.first.point, M, Ce).point, xt = Gi(Ct.last.point, M, Ce).point;
          if (v && !h) {
            const Wt = fs(_.writingMode, Dt, xt, Se);
            if (Wt) return Wt;
          }
          Ee = [Ct.first];
          for (let Wt = _.glyphStartIndex + 1; Wt < st - 1; Wt++) Ee.push(se(Me * z.getoffsetX(Wt), Ue, ct, h, Q, J, _.segment, ht, wt, R, S, fe, we, Ce));
          Ee.push(Ct.last);
        } else {
          if (v && !h) {
            const ht = Gi(J, w, Ce).point, wt = _.lineStartIndex + _.segment + 1, Ct = new a.Point(R.getx(wt), R.gety(wt)), Dt = Gi(Ct, w, Ce), xt = Dt.signedDistanceFromCamera > 0 ? Dt.point : pi(J, Ct, ht, 1, w, Ce), Wt = fs(_.writingMode, ht, xt, Se);
            if (Wt) return Wt;
          }
          const st = se(Me * z.getoffsetX(_.glyphStartIndex), Ue, ct, h, Q, J, _.segment, _.lineStartIndex, _.lineStartIndex + _.lineLength, R, S, fe, we, Ce);
          if (!st) return { notEnoughRoom: !0 };
          Ee = [st];
        }
        for (const st of Ee) a.addDynamicAttributes(W, st.point, st.angle);
        return {};
      }
      function pi(_, o, h, v, w, S) {
        const M = Gi(_.add(_.sub(o)._unit()), w, S).point, z = h.sub(M);
        return h.add(z._mult(v / z.mag()));
      }
      function ga(_, o) {
        const { projectionCache: h, lineVertexArray: v, labelPlaneMatrix: w, tileAnchorPoint: S, distanceFromAnchor: M, getElevation: z, previousVertex: R, direction: W, absOffsetX: Q } = o;
        if (h.projections[_]) return h.projections[_];
        const J = new a.Point(v.getx(_), v.gety(_)), fe = Gi(J, w, z);
        if (fe.signedDistanceFromCamera > 0) return h.projections[_] = fe.point, fe.point;
        const Se = _ - W;
        return pi(M === 0 ? S : new a.Point(v.getx(Se), v.gety(Se)), J, R, Q - M + 1, w, z);
      }
      function As(_, o, h) {
        return _._unit()._perp()._mult(o * h);
      }
      function Te(_, o, h, v, w, S, M, z) {
        const { projectionCache: R, direction: W } = z;
        if (R.offsets[_]) return R.offsets[_];
        const Q = h.add(o);
        if (_ + W < v || _ + W >= w) return R.offsets[_] = Q, Q;
        const J = ga(_ + W, z), fe = As(J.sub(h), M, W), Se = h.add(fe), we = J.add(fe);
        return R.offsets[_] = a.findLineIntersection(S, Q, Se, we) || Q, R.offsets[_];
      }
      function se(_, o, h, v, w, S, M, z, R, W, Q, J, fe, Se) {
        const we = v ? _ - o : _ + o;
        let Ce = we > 0 ? 1 : -1, Me = 0;
        v && (Ce *= -1, Me = Math.PI), Ce < 0 && (Me += Math.PI);
        let Ue, ct, Ee = Ce > 0 ? z + M : z + M + 1, st = w, ht = w, wt = 0, Ct = 0;
        const Dt = Math.abs(we), xt = [];
        let Wt;
        for (; wt + Ct <= Dt; ) {
          if (Ee += Ce, Ee < z || Ee >= R) return null;
          wt += Ct, ht = st, ct = Ue;
          const Ot = { projectionCache: J, lineVertexArray: W, labelPlaneMatrix: Q, tileAnchorPoint: S, distanceFromAnchor: wt, getElevation: Se, previousVertex: ht, direction: Ce, absOffsetX: Dt };
          if (st = ga(Ee, Ot), h === 0) xt.push(ht), Wt = st.sub(ht);
          else {
            let xn;
            const Gt = st.sub(ht);
            xn = Gt.mag() === 0 ? As(ga(Ee + Ce, Ot).sub(st), h, Ce) : As(Gt, h, Ce), ct || (ct = ht.add(xn)), Ue = Te(Ee, xn, st, z, R, ct, h, Ot), xt.push(ct), Wt = Ue.sub(ct);
          }
          Ct = Wt.mag();
        }
        const fn = Wt._mult((Dt - wt) / Ct)._add(ct || ht), En = Me + Math.atan2(st.y - ht.y, st.x - ht.x);
        return xt.push(fn), { point: fn, angle: fe ? En : 0, path: xt };
      }
      const ue = new Float32Array([-1 / 0, -1 / 0, 0, -1 / 0, -1 / 0, 0, -1 / 0, -1 / 0, 0, -1 / 0, -1 / 0, 0]);
      function be(_, o) {
        for (let h = 0; h < _; h++) {
          const v = o.length;
          o.resize(v + 4), o.float32.set(ue, 3 * v);
        }
      }
      function Pe(_, o, h) {
        const v = o[0], w = o[1];
        return _[0] = h[0] * v + h[4] * w + h[12], _[1] = h[1] * v + h[5] * w + h[13], _[3] = h[3] * v + h[7] * w + h[15], _;
      }
      const Fe = 100;
      class Ze {
        constructor(o, h = new $n(o.width + 200, o.height + 200, 25), v = new $n(o.width + 200, o.height + 200, 25)) {
          this.transform = o, this.grid = h, this.ignoredGrid = v, this.pitchfactor = Math.cos(o._pitch) * o.cameraToCenterDistance, this.screenRightBoundary = o.width + Fe, this.screenBottomBoundary = o.height + Fe, this.gridRightBoundary = o.width + 200, this.gridBottomBoundary = o.height + 200, this.perspectiveRatioCutoff = 0.6;
        }
        placeCollisionBox(o, h, v, w, S, M) {
          const z = this.projectAndGetPerspectiveRatio(w, o.anchorPointX, o.anchorPointY, M), R = v * z.perspectiveRatio, W = o.x1 * R + z.point.x, Q = o.y1 * R + z.point.y, J = o.x2 * R + z.point.x, fe = o.y2 * R + z.point.y;
          return !this.isInsideGrid(W, Q, J, fe) || h !== "always" && this.grid.hitTest(W, Q, J, fe, h, S) || z.perspectiveRatio < this.perspectiveRatioCutoff ? { box: [], offscreen: !1 } : { box: [W, Q, J, fe], offscreen: this.isOffscreen(W, Q, J, fe) };
        }
        placeCollisionCircles(o, h, v, w, S, M, z, R, W, Q, J, fe, Se, we) {
          const Ce = [], Me = new a.Point(h.anchorX, h.anchorY), Ue = Gi(Me, M, we), ct = Cn(this.transform.cameraToCenterDistance, Ue.signedDistanceFromCamera), Ee = (Q ? S / ct : S * ct) / a.ONE_EM, st = Gi(Me, z, we).point, ht = kr(Ee, w, h.lineOffsetX * Ee, h.lineOffsetY * Ee, !1, st, Me, h, v, z, { projections: {}, offsets: {} }, !1, we);
          let wt = !1, Ct = !1, Dt = !0;
          if (ht) {
            const xt = 0.5 * fe * ct + Se, Wt = new a.Point(-100, -100), fn = new a.Point(this.screenRightBoundary, this.screenBottomBoundary), En = new hs(), Ot = ht.first, xn = ht.last;
            let Gt = [];
            for (let ii = Ot.path.length - 1; ii >= 1; ii--) Gt.push(Ot.path[ii]);
            for (let ii = 1; ii < xn.path.length; ii++) Gt.push(xn.path[ii]);
            const ni = 2.5 * xt;
            if (R) {
              const ii = Gt.map((Dn) => Gi(Dn, R, we));
              Gt = ii.some((Dn) => Dn.signedDistanceFromCamera <= 0) ? [] : ii.map((Dn) => Dn.point);
            }
            let cr = [];
            if (Gt.length > 0) {
              const ii = Gt[0].clone(), Dn = Gt[0].clone();
              for (let rr = 1; rr < Gt.length; rr++) ii.x = Math.min(ii.x, Gt[rr].x), ii.y = Math.min(ii.y, Gt[rr].y), Dn.x = Math.max(Dn.x, Gt[rr].x), Dn.y = Math.max(Dn.y, Gt[rr].y);
              cr = ii.x >= Wt.x && Dn.x <= fn.x && ii.y >= Wt.y && Dn.y <= fn.y ? [Gt] : Dn.x < Wt.x || ii.x > fn.x || Dn.y < Wt.y || ii.y > fn.y ? [] : a.clipLine([Gt], Wt.x, Wt.y, fn.x, fn.y);
            }
            for (const ii of cr) {
              En.reset(ii, 0.25 * xt);
              let Dn = 0;
              Dn = En.length <= 0.5 * xt ? 1 : Math.ceil(En.paddedLength / ni) + 1;
              for (let rr = 0; rr < Dn; rr++) {
                const bs = rr / Math.max(Dn - 1, 1), ur = En.lerp(bs), Lr = ur.x + Fe, Gs = ur.y + Fe;
                Ce.push(Lr, Gs, xt, 0);
                const Po = Lr - xt, Mo = Gs - xt, ws = Lr + xt, Jo = Gs + xt;
                if (Dt = Dt && this.isOffscreen(Po, Mo, ws, Jo), Ct = Ct || this.isInsideGrid(Po, Mo, ws, Jo), o !== "always" && this.grid.hitTestCircle(Lr, Gs, xt, o, J) && (wt = !0, !W)) return { circles: [], offscreen: !1, collisionDetected: wt };
              }
            }
          }
          return { circles: !W && wt || !Ct || ct < this.perspectiveRatioCutoff ? [] : Ce, offscreen: Dt, collisionDetected: wt };
        }
        queryRenderedSymbols(o) {
          if (o.length === 0 || this.grid.keysLength() === 0 && this.ignoredGrid.keysLength() === 0) return {};
          const h = [];
          let v = 1 / 0, w = 1 / 0, S = -1 / 0, M = -1 / 0;
          for (const Q of o) {
            const J = new a.Point(Q.x + Fe, Q.y + Fe);
            v = Math.min(v, J.x), w = Math.min(w, J.y), S = Math.max(S, J.x), M = Math.max(M, J.y), h.push(J);
          }
          const z = this.grid.query(v, w, S, M).concat(this.ignoredGrid.query(v, w, S, M)), R = {}, W = {};
          for (const Q of z) {
            const J = Q.key;
            if (R[J.bucketInstanceId] === void 0 && (R[J.bucketInstanceId] = {}), R[J.bucketInstanceId][J.featureIndex]) continue;
            const fe = [new a.Point(Q.x1, Q.y1), new a.Point(Q.x2, Q.y1), new a.Point(Q.x2, Q.y2), new a.Point(Q.x1, Q.y2)];
            a.polygonIntersectsPolygon(h, fe) && (R[J.bucketInstanceId][J.featureIndex] = !0, W[J.bucketInstanceId] === void 0 && (W[J.bucketInstanceId] = []), W[J.bucketInstanceId].push(J.featureIndex));
          }
          return W;
        }
        insertCollisionBox(o, h, v, w, S, M) {
          (v ? this.ignoredGrid : this.grid).insert({ bucketInstanceId: w, featureIndex: S, collisionGroupID: M, overlapMode: h }, o[0], o[1], o[2], o[3]);
        }
        insertCollisionCircles(o, h, v, w, S, M) {
          const z = v ? this.ignoredGrid : this.grid, R = { bucketInstanceId: w, featureIndex: S, collisionGroupID: M, overlapMode: h };
          for (let W = 0; W < o.length; W += 4) z.insertCircle(R, o[W], o[W + 1], o[W + 2]);
        }
        projectAndGetPerspectiveRatio(o, h, v, w) {
          let S;
          return w ? (S = [h, v, w(h, v), 1], a.transformMat4(S, S, o)) : (S = [h, v, 0, 1], Pe(S, S, o)), { point: new a.Point((S[0] / S[3] + 1) / 2 * this.transform.width + Fe, (-S[1] / S[3] + 1) / 2 * this.transform.height + Fe), perspectiveRatio: 0.5 + this.transform.cameraToCenterDistance / S[3] * 0.5 };
        }
        isOffscreen(o, h, v, w) {
          return v < Fe || o >= this.screenRightBoundary || w < Fe || h > this.screenBottomBoundary;
        }
        isInsideGrid(o, h, v, w) {
          return v >= 0 && o < this.gridRightBoundary && w >= 0 && h < this.gridBottomBoundary;
        }
        getViewportMatrix() {
          const o = a.identity([]);
          return a.translate(o, o, [-100, -100, 0]), o;
        }
      }
      function ze(_, o, h) {
        return o * (a.EXTENT / (_.tileSize * Math.pow(2, h - _.tileID.overscaledZ)));
      }
      class Re {
        constructor(o, h, v, w) {
          this.opacity = o ? Math.max(0, Math.min(1, o.opacity + (o.placed ? h : -h))) : w && v ? 1 : 0, this.placed = v;
        }
        isHidden() {
          return this.opacity === 0 && !this.placed;
        }
      }
      class Ye {
        constructor(o, h, v, w, S) {
          this.text = new Re(o ? o.text : null, h, v, S), this.icon = new Re(o ? o.icon : null, h, w, S);
        }
        isHidden() {
          return this.text.isHidden() && this.icon.isHidden();
        }
      }
      class nt {
        constructor(o, h, v) {
          this.text = o, this.icon = h, this.skipFade = v;
        }
      }
      class _t {
        constructor() {
          this.invProjMatrix = a.create(), this.viewportMatrix = a.create(), this.circles = [];
        }
      }
      class yt {
        constructor(o, h, v, w, S) {
          this.bucketInstanceId = o, this.featureIndex = h, this.sourceLayerIndex = v, this.bucketIndex = w, this.tileID = S;
        }
      }
      class un {
        constructor(o) {
          this.crossSourceCollisions = o, this.maxGroupID = 0, this.collisionGroups = {};
        }
        get(o) {
          if (this.crossSourceCollisions) return { ID: 0, predicate: null };
          if (!this.collisionGroups[o]) {
            const h = ++this.maxGroupID;
            this.collisionGroups[o] = { ID: h, predicate: (v) => v.collisionGroupID === h };
          }
          return this.collisionGroups[o];
        }
      }
      function bn(_, o, h, v, w) {
        const { horizontalAlign: S, verticalAlign: M } = a.getAnchorAlignment(_), z = -(S - 0.5) * o, R = -(M - 0.5) * h, W = a.evaluateVariableOffset(_, v);
        return new a.Point(z + W[0] * w, R + W[1] * w);
      }
      function Kt(_, o, h, v, w, S) {
        const { x1: M, x2: z, y1: R, y2: W, anchorPointX: Q, anchorPointY: J } = _, fe = new a.Point(o, h);
        return v && fe._rotate(w ? S : -S), { x1: M + fe.x, y1: R + fe.y, x2: z + fe.x, y2: W + fe.y, anchorPointX: Q, anchorPointY: J };
      }
      class an {
        constructor(o, h, v, w, S) {
          this.transform = o.clone(), this.terrain = h, this.collisionIndex = new Ze(this.transform), this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = !1, this.commitTime = 0, this.fadeDuration = v, this.retainedQueryData = {}, this.collisionGroups = new un(w), this.collisionCircleArrays = {}, this.prevPlacement = S, S && (S.prevPlacement = void 0), this.placedOrientations = {};
        }
        getBucketParts(o, h, v, w) {
          const S = v.getBucket(h), M = v.latestFeatureIndex;
          if (!S || !M || h.id !== S.layerIds[0]) return;
          const z = v.collisionBoxArray, R = S.layers[0].layout, W = Math.pow(2, this.transform.zoom - v.tileID.overscaledZ), Q = v.tileSize / a.EXTENT, J = this.transform.calculatePosMatrix(v.tileID.toUnwrapped()), fe = R.get("text-pitch-alignment") === "map", Se = R.get("text-rotation-alignment") === "map", we = ze(v, 1, this.transform.zoom), Ce = yn(J, fe, Se, this.transform, we);
          let Me = null;
          if (fe) {
            const ct = Qi(J, fe, Se, this.transform, we);
            Me = a.multiply([], this.transform.labelPlaneMatrix, ct);
          }
          this.retainedQueryData[S.bucketInstanceId] = new yt(S.bucketInstanceId, M, S.sourceLayerIndex, S.index, v.tileID);
          const Ue = { bucket: S, layout: R, posMatrix: J, textLabelPlaneMatrix: Ce, labelToScreenMatrix: Me, scale: W, textPixelRatio: Q, holdingForFade: v.holdingForFade(), collisionBoxArray: z, partiallyEvaluatedTextSize: a.evaluateSizeForZoom(S.textSizeData, this.transform.zoom), collisionGroup: this.collisionGroups.get(S.sourceID) };
          if (w) for (const ct of S.sortKeyRanges) {
            const { sortKey: Ee, symbolInstanceStart: st, symbolInstanceEnd: ht } = ct;
            o.push({ sortKey: Ee, symbolInstanceStart: st, symbolInstanceEnd: ht, parameters: Ue });
          }
          else o.push({ symbolInstanceStart: 0, symbolInstanceEnd: S.symbolInstances.length, parameters: Ue });
        }
        attemptAnchorPlacement(o, h, v, w, S, M, z, R, W, Q, J, fe, Se, we, Ce, Me) {
          const Ue = [fe.textOffset0, fe.textOffset1], ct = bn(o, v, w, Ue, S), Ee = this.collisionIndex.placeCollisionBox(Kt(h, ct.x, ct.y, M, z, this.transform.angle), J, R, W, Q.predicate, Me);
          if ((!Ce || this.collisionIndex.placeCollisionBox(Kt(Ce, ct.x, ct.y, M, z, this.transform.angle), J, R, W, Q.predicate, Me).box.length !== 0) && Ee.box.length > 0) {
            let st;
            if (this.prevPlacement && this.prevPlacement.variableOffsets[fe.crossTileID] && this.prevPlacement.placements[fe.crossTileID] && this.prevPlacement.placements[fe.crossTileID].text && (st = this.prevPlacement.variableOffsets[fe.crossTileID].anchor), fe.crossTileID === 0) throw new Error("symbolInstance.crossTileID can't be 0");
            return this.variableOffsets[fe.crossTileID] = { textOffset: Ue, width: v, height: w, anchor: o, textBoxScale: S, prevAnchor: st }, this.markUsedJustification(Se, o, fe, we), Se.allowVerticalPlacement && (this.markUsedOrientation(Se, we, fe), this.placedOrientations[fe.crossTileID] = we), { shift: ct, placedGlyphBoxes: Ee };
          }
        }
        placeLayerBucketPart(o, h, v) {
          const { bucket: w, layout: S, posMatrix: M, textLabelPlaneMatrix: z, labelToScreenMatrix: R, textPixelRatio: W, holdingForFade: Q, collisionBoxArray: J, partiallyEvaluatedTextSize: fe, collisionGroup: Se } = o.parameters, we = S.get("text-optional"), Ce = S.get("icon-optional"), Me = a.getOverlapMode(S, "text-overlap", "text-allow-overlap"), Ue = Me === "always", ct = a.getOverlapMode(S, "icon-overlap", "icon-allow-overlap"), Ee = ct === "always", st = S.get("text-rotation-alignment") === "map", ht = S.get("text-pitch-alignment") === "map", wt = S.get("icon-text-fit") !== "none", Ct = S.get("symbol-z-order") === "viewport-y", Dt = Ue && (Ee || !w.hasIconData() || Ce), xt = Ee && (Ue || !w.hasTextData() || we);
          !w.collisionArrays && J && w.deserializeCollisionBoxes(J);
          const Wt = this.retainedQueryData[w.bucketInstanceId].tileID, fn = this.terrain ? (Ot, xn) => this.terrain.getElevation(Wt, Ot, xn) : null, En = (Ot, xn) => {
            if (h[Ot.crossTileID]) return;
            if (Q) return void (this.placements[Ot.crossTileID] = new nt(!1, !1, !1));
            let Gt = !1, ni = !1, cr = !0, ii = null, Dn = { box: null, offscreen: null }, rr = { box: null }, bs = null, ur = null, Lr = null, Gs = 0, Po = 0, Mo = 0;
            xn.textFeatureIndex ? Gs = xn.textFeatureIndex : Ot.useRuntimeCollisionCircles && (Gs = Ot.featureIndex), xn.verticalTextFeatureIndex && (Po = xn.verticalTextFeatureIndex);
            const ws = xn.textBox;
            if (ws) {
              const rs = (ui) => {
                let Sr = a.WritingMode.horizontal;
                if (w.allowVerticalPlacement && !ui && this.prevPlacement) {
                  const Nr = this.prevPlacement.placedOrientations[Ot.crossTileID];
                  Nr && (this.placedOrientations[Ot.crossTileID] = Nr, Sr = Nr, this.markUsedOrientation(w, Sr, Ot));
                }
                return Sr;
              }, Or = (ui, Sr) => {
                if (w.allowVerticalPlacement && Ot.numVerticalGlyphVertices > 0 && xn.verticalTextBox) {
                  for (const Nr of w.writingModes) if (Nr === a.WritingMode.vertical ? (Dn = Sr(), rr = Dn) : Dn = ui(), Dn && Dn.box && Dn.box.length) break;
                } else Dn = ui();
              };
              if (S.get("text-variable-anchor")) {
                let ui = S.get("text-variable-anchor");
                if (this.prevPlacement && this.prevPlacement.variableOffsets[Ot.crossTileID]) {
                  const fi = this.prevPlacement.variableOffsets[Ot.crossTileID];
                  ui.indexOf(fi.anchor) > 0 && (ui = ui.filter((Tr) => Tr !== fi.anchor), ui.unshift(fi.anchor));
                }
                const Sr = (fi, Tr, Ys) => {
                  const up = fi.x2 - fi.x1, La = fi.y2 - fi.y1, I_ = Ot.textBoxScale, ov = wt && ct === "never" ? Tr : null;
                  let Wi = { box: [], offscreen: !1 };
                  const uf = Me !== "never" ? 2 * ui.length : ui.length;
                  for (let ld = 0; ld < uf; ++ld) {
                    const Oa = this.attemptAnchorPlacement(ui[ld % ui.length], fi, up, La, I_, st, ht, W, M, Se, ld >= ui.length ? Me : "never", Ot, w, Ys, ov, fn);
                    if (Oa && (Wi = Oa.placedGlyphBoxes, Wi && Wi.box && Wi.box.length)) {
                      Gt = !0, ii = Oa.shift;
                      break;
                    }
                  }
                  return Wi;
                };
                Or(() => Sr(ws, xn.iconBox, a.WritingMode.horizontal), () => {
                  const fi = xn.verticalTextBox;
                  return w.allowVerticalPlacement && !(Dn && Dn.box && Dn.box.length) && Ot.numVerticalGlyphVertices > 0 && fi ? Sr(fi, xn.verticalIconBox, a.WritingMode.vertical) : { box: null, offscreen: null };
                }), Dn && (Gt = Dn.box, cr = Dn.offscreen);
                const Nr = rs(Dn && Dn.box);
                if (!Gt && this.prevPlacement) {
                  const fi = this.prevPlacement.variableOffsets[Ot.crossTileID];
                  fi && (this.variableOffsets[Ot.crossTileID] = fi, this.markUsedJustification(w, fi.anchor, Ot, Nr));
                }
              } else {
                const ui = (Sr, Nr) => {
                  const fi = this.collisionIndex.placeCollisionBox(Sr, Me, W, M, Se.predicate, fn);
                  return fi && fi.box && fi.box.length && (this.markUsedOrientation(w, Nr, Ot), this.placedOrientations[Ot.crossTileID] = Nr), fi;
                };
                Or(() => ui(ws, a.WritingMode.horizontal), () => {
                  const Sr = xn.verticalTextBox;
                  return w.allowVerticalPlacement && Ot.numVerticalGlyphVertices > 0 && Sr ? ui(Sr, a.WritingMode.vertical) : { box: null, offscreen: null };
                }), rs(Dn && Dn.box && Dn.box.length);
              }
            }
            if (bs = Dn, Gt = bs && bs.box && bs.box.length > 0, cr = bs && bs.offscreen, Ot.useRuntimeCollisionCircles) {
              const rs = w.text.placedSymbolArray.get(Ot.centerJustifiedTextSymbolIndex), Or = a.evaluateSizeForFeature(w.textSizeData, fe, rs), ui = S.get("text-padding");
              ur = this.collisionIndex.placeCollisionCircles(Me, rs, w.lineVertexArray, w.glyphOffsetArray, Or, M, z, R, v, ht, Se.predicate, Ot.collisionCircleDiameter, ui, fn), ur.circles.length && ur.collisionDetected && !v && a.warnOnce("Collisions detected, but collision boxes are not shown"), Gt = Ue || ur.circles.length > 0 && !ur.collisionDetected, cr = cr && ur.offscreen;
            }
            if (xn.iconFeatureIndex && (Mo = xn.iconFeatureIndex), xn.iconBox) {
              const rs = (Or) => {
                const ui = wt && ii ? Kt(Or, ii.x, ii.y, st, ht, this.transform.angle) : Or;
                return this.collisionIndex.placeCollisionBox(ui, ct, W, M, Se.predicate, fn);
              };
              rr && rr.box && rr.box.length && xn.verticalIconBox ? (Lr = rs(xn.verticalIconBox), ni = Lr.box.length > 0) : (Lr = rs(xn.iconBox), ni = Lr.box.length > 0), cr = cr && Lr.offscreen;
            }
            const Jo = we || Ot.numHorizontalGlyphVertices === 0 && Ot.numVerticalGlyphVertices === 0, ad = Ce || Ot.numIconVertices === 0;
            if (Jo || ad ? ad ? Jo || (ni = ni && Gt) : Gt = ni && Gt : ni = Gt = ni && Gt, Gt && bs && bs.box && this.collisionIndex.insertCollisionBox(bs.box, Me, S.get("text-ignore-placement"), w.bucketInstanceId, rr && rr.box && Po ? Po : Gs, Se.ID), ni && Lr && this.collisionIndex.insertCollisionBox(Lr.box, ct, S.get("icon-ignore-placement"), w.bucketInstanceId, Mo, Se.ID), ur && (Gt && this.collisionIndex.insertCollisionCircles(ur.circles, Me, S.get("text-ignore-placement"), w.bucketInstanceId, Gs, Se.ID), v)) {
              const rs = w.bucketInstanceId;
              let Or = this.collisionCircleArrays[rs];
              Or === void 0 && (Or = this.collisionCircleArrays[rs] = new _t());
              for (let ui = 0; ui < ur.circles.length; ui += 4) Or.circles.push(ur.circles[ui + 0]), Or.circles.push(ur.circles[ui + 1]), Or.circles.push(ur.circles[ui + 2]), Or.circles.push(ur.collisionDetected ? 1 : 0);
            }
            if (Ot.crossTileID === 0) throw new Error("symbolInstance.crossTileID can't be 0");
            if (w.bucketInstanceId === 0) throw new Error("bucket.bucketInstanceId can't be 0");
            this.placements[Ot.crossTileID] = new nt(Gt || Dt, ni || xt, cr || w.justReloaded), h[Ot.crossTileID] = !0;
          };
          if (Ct) {
            if (o.symbolInstanceStart !== 0) throw new Error("bucket.bucketInstanceId should be 0");
            const Ot = w.getSortedSymbolIndexes(this.transform.angle);
            for (let xn = Ot.length - 1; xn >= 0; --xn) {
              const Gt = Ot[xn];
              En(w.symbolInstances.get(Gt), w.collisionArrays[Gt]);
            }
          } else for (let Ot = o.symbolInstanceStart; Ot < o.symbolInstanceEnd; Ot++) En(w.symbolInstances.get(Ot), w.collisionArrays[Ot]);
          if (v && w.bucketInstanceId in this.collisionCircleArrays) {
            const Ot = this.collisionCircleArrays[w.bucketInstanceId];
            a.invert(Ot.invProjMatrix, M), Ot.viewportMatrix = this.collisionIndex.getViewportMatrix();
          }
          w.justReloaded = !1;
        }
        markUsedJustification(o, h, v, w) {
          let S;
          S = w === a.WritingMode.vertical ? v.verticalPlacedTextSymbolIndex : { left: v.leftJustifiedTextSymbolIndex, center: v.centerJustifiedTextSymbolIndex, right: v.rightJustifiedTextSymbolIndex }[a.getAnchorJustification(h)];
          const M = [v.leftJustifiedTextSymbolIndex, v.centerJustifiedTextSymbolIndex, v.rightJustifiedTextSymbolIndex, v.verticalPlacedTextSymbolIndex];
          for (const z of M) z >= 0 && (o.text.placedSymbolArray.get(z).crossTileID = S >= 0 && z !== S ? 0 : v.crossTileID);
        }
        markUsedOrientation(o, h, v) {
          const w = h === a.WritingMode.horizontal || h === a.WritingMode.horizontalOnly ? h : 0, S = h === a.WritingMode.vertical ? h : 0, M = [v.leftJustifiedTextSymbolIndex, v.centerJustifiedTextSymbolIndex, v.rightJustifiedTextSymbolIndex];
          for (const z of M) o.text.placedSymbolArray.get(z).placedOrientation = w;
          v.verticalPlacedTextSymbolIndex && (o.text.placedSymbolArray.get(v.verticalPlacedTextSymbolIndex).placedOrientation = S);
        }
        commit(o) {
          this.commitTime = o, this.zoomAtLastRecencyCheck = this.transform.zoom;
          const h = this.prevPlacement;
          let v = !1;
          this.prevZoomAdjustment = h ? h.zoomAdjustment(this.transform.zoom) : 0;
          const w = h ? h.symbolFadeChange(o) : 1, S = h ? h.opacities : {}, M = h ? h.variableOffsets : {}, z = h ? h.placedOrientations : {};
          for (const R in this.placements) {
            const W = this.placements[R], Q = S[R];
            Q ? (this.opacities[R] = new Ye(Q, w, W.text, W.icon), v = v || W.text !== Q.text.placed || W.icon !== Q.icon.placed) : (this.opacities[R] = new Ye(null, w, W.text, W.icon, W.skipFade), v = v || W.text || W.icon);
          }
          for (const R in S) {
            const W = S[R];
            if (!this.opacities[R]) {
              const Q = new Ye(W, w, !1, !1);
              Q.isHidden() || (this.opacities[R] = Q, v = v || W.text.placed || W.icon.placed);
            }
          }
          for (const R in M) this.variableOffsets[R] || !this.opacities[R] || this.opacities[R].isHidden() || (this.variableOffsets[R] = M[R]);
          for (const R in z) this.placedOrientations[R] || !this.opacities[R] || this.opacities[R].isHidden() || (this.placedOrientations[R] = z[R]);
          if (h && h.lastPlacementChangeTime === void 0) throw new Error("Last placement time for previous placement is not defined");
          v ? this.lastPlacementChangeTime = o : typeof this.lastPlacementChangeTime != "number" && (this.lastPlacementChangeTime = h ? h.lastPlacementChangeTime : o);
        }
        updateLayerOpacities(o, h) {
          const v = {};
          for (const w of h) {
            const S = w.getBucket(o);
            S && w.latestFeatureIndex && o.id === S.layerIds[0] && this.updateBucketOpacities(S, v, w.collisionBoxArray);
          }
        }
        updateBucketOpacities(o, h, v) {
          o.hasTextData() && (o.text.opacityVertexArray.clear(), o.text.hasVisibleVertices = !1), o.hasIconData() && (o.icon.opacityVertexArray.clear(), o.icon.hasVisibleVertices = !1), o.hasIconCollisionBoxData() && o.iconCollisionBox.collisionVertexArray.clear(), o.hasTextCollisionBoxData() && o.textCollisionBox.collisionVertexArray.clear();
          const w = o.layers[0].layout, S = new Ye(null, 0, !1, !1, !0), M = w.get("text-allow-overlap"), z = w.get("icon-allow-overlap"), R = w.get("text-variable-anchor"), W = w.get("text-rotation-alignment") === "map", Q = w.get("text-pitch-alignment") === "map", J = w.get("icon-text-fit") !== "none", fe = new Ye(null, 0, M && (z || !o.hasIconData() || w.get("icon-optional")), z && (M || !o.hasTextData() || w.get("text-optional")), !0);
          !o.collisionArrays && v && (o.hasIconCollisionBoxData() || o.hasTextCollisionBoxData()) && o.deserializeCollisionBoxes(v);
          const Se = (we, Ce, Me) => {
            for (let Ue = 0; Ue < Ce / 4; Ue++) we.opacityVertexArray.emplaceBack(Me);
            we.hasVisibleVertices = we.hasVisibleVertices || Me !== ar;
          };
          for (let we = 0; we < o.symbolInstances.length; we++) {
            const Ce = o.symbolInstances.get(we), { numHorizontalGlyphVertices: Me, numVerticalGlyphVertices: Ue, crossTileID: ct } = Ce;
            let Ee = this.opacities[ct];
            h[ct] ? Ee = S : Ee || (Ee = fe, this.opacities[ct] = Ee), h[ct] = !0;
            const st = Ce.numIconVertices > 0, ht = this.placedOrientations[Ce.crossTileID], wt = ht === a.WritingMode.vertical, Ct = ht === a.WritingMode.horizontal || ht === a.WritingMode.horizontalOnly;
            if (Me > 0 || Ue > 0) {
              const Dt = Dr(Ee.text);
              Se(o.text, Me, wt ? ar : Dt), Se(o.text, Ue, Ct ? ar : Dt);
              const xt = Ee.text.isHidden();
              [Ce.rightJustifiedTextSymbolIndex, Ce.centerJustifiedTextSymbolIndex, Ce.leftJustifiedTextSymbolIndex].forEach((En) => {
                En >= 0 && (o.text.placedSymbolArray.get(En).hidden = xt || wt ? 1 : 0);
              }), Ce.verticalPlacedTextSymbolIndex >= 0 && (o.text.placedSymbolArray.get(Ce.verticalPlacedTextSymbolIndex).hidden = xt || Ct ? 1 : 0);
              const Wt = this.variableOffsets[Ce.crossTileID];
              Wt && this.markUsedJustification(o, Wt.anchor, Ce, ht);
              const fn = this.placedOrientations[Ce.crossTileID];
              fn && (this.markUsedJustification(o, "left", Ce, fn), this.markUsedOrientation(o, fn, Ce));
            }
            if (st) {
              const Dt = Dr(Ee.icon), xt = !(J && Ce.verticalPlacedIconSymbolIndex && wt);
              Ce.placedIconSymbolIndex >= 0 && (Se(o.icon, Ce.numIconVertices, xt ? Dt : ar), o.icon.placedSymbolArray.get(Ce.placedIconSymbolIndex).hidden = Ee.icon.isHidden()), Ce.verticalPlacedIconSymbolIndex >= 0 && (Se(o.icon, Ce.numVerticalIconVertices, xt ? ar : Dt), o.icon.placedSymbolArray.get(Ce.verticalPlacedIconSymbolIndex).hidden = Ee.icon.isHidden());
            }
            if (o.hasIconCollisionBoxData() || o.hasTextCollisionBoxData()) {
              const Dt = o.collisionArrays[we];
              if (Dt) {
                let xt = new a.Point(0, 0);
                if (Dt.textBox || Dt.verticalTextBox) {
                  let fn = !0;
                  if (R) {
                    const En = this.variableOffsets[ct];
                    En ? (xt = bn(En.anchor, En.width, En.height, En.textOffset, En.textBoxScale), W && xt._rotate(Q ? this.transform.angle : -this.transform.angle)) : fn = !1;
                  }
                  Dt.textBox && dn(o.textCollisionBox.collisionVertexArray, Ee.text.placed, !fn || wt, xt.x, xt.y), Dt.verticalTextBox && dn(o.textCollisionBox.collisionVertexArray, Ee.text.placed, !fn || Ct, xt.x, xt.y);
                }
                const Wt = !!(!Ct && Dt.verticalIconBox);
                Dt.iconBox && dn(o.iconCollisionBox.collisionVertexArray, Ee.icon.placed, Wt, J ? xt.x : 0, J ? xt.y : 0), Dt.verticalIconBox && dn(o.iconCollisionBox.collisionVertexArray, Ee.icon.placed, !Wt, J ? xt.x : 0, J ? xt.y : 0);
              }
            }
          }
          if (o.sortFeatures(this.transform.angle), this.retainedQueryData[o.bucketInstanceId] && (this.retainedQueryData[o.bucketInstanceId].featureSortOrder = o.featureSortOrder), o.hasTextData() && o.text.opacityVertexBuffer && o.text.opacityVertexBuffer.updateData(o.text.opacityVertexArray), o.hasIconData() && o.icon.opacityVertexBuffer && o.icon.opacityVertexBuffer.updateData(o.icon.opacityVertexArray), o.hasIconCollisionBoxData() && o.iconCollisionBox.collisionVertexBuffer && o.iconCollisionBox.collisionVertexBuffer.updateData(o.iconCollisionBox.collisionVertexArray), o.hasTextCollisionBoxData() && o.textCollisionBox.collisionVertexBuffer && o.textCollisionBox.collisionVertexBuffer.updateData(o.textCollisionBox.collisionVertexArray), o.text.opacityVertexArray.length !== o.text.layoutVertexArray.length / 4) throw new Error(`bucket.text.opacityVertexArray.length (= ${o.text.opacityVertexArray.length}) !== bucket.text.layoutVertexArray.length (= ${o.text.layoutVertexArray.length}) / 4`);
          if (o.icon.opacityVertexArray.length !== o.icon.layoutVertexArray.length / 4) throw new Error(`bucket.icon.opacityVertexArray.length (= ${o.icon.opacityVertexArray.length}) !== bucket.icon.layoutVertexArray.length (= ${o.icon.layoutVertexArray.length}) / 4`);
          if (o.bucketInstanceId in this.collisionCircleArrays) {
            const we = this.collisionCircleArrays[o.bucketInstanceId];
            o.placementInvProjMatrix = we.invProjMatrix, o.placementViewportMatrix = we.viewportMatrix, o.collisionCircleArray = we.circles, delete this.collisionCircleArrays[o.bucketInstanceId];
          }
        }
        symbolFadeChange(o) {
          return this.fadeDuration === 0 ? 1 : (o - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
        }
        zoomAdjustment(o) {
          return Math.max(0, (this.transform.zoom - o) / 1.5);
        }
        hasTransitions(o) {
          return this.stale || o - this.lastPlacementChangeTime < this.fadeDuration;
        }
        stillRecent(o, h) {
          const v = this.zoomAtLastRecencyCheck === h ? 1 - this.zoomAdjustment(h) : 1;
          return this.zoomAtLastRecencyCheck = h, this.commitTime + this.fadeDuration * v > o;
        }
        setStale() {
          this.stale = !0;
        }
      }
      function dn(_, o, h, v, w) {
        _.emplaceBack(o ? 1 : 0, h ? 1 : 0, v || 0, w || 0), _.emplaceBack(o ? 1 : 0, h ? 1 : 0, v || 0, w || 0), _.emplaceBack(o ? 1 : 0, h ? 1 : 0, v || 0, w || 0), _.emplaceBack(o ? 1 : 0, h ? 1 : 0, v || 0, w || 0);
      }
      const Bn = Math.pow(2, 25), An = Math.pow(2, 24), Un = Math.pow(2, 17), ei = Math.pow(2, 16), Yi = Math.pow(2, 9), _n = Math.pow(2, 8), Ni = Math.pow(2, 1);
      function Dr(_) {
        if (_.opacity === 0 && !_.placed) return 0;
        if (_.opacity === 1 && _.placed) return 4294967295;
        const o = _.placed ? 1 : 0, h = Math.floor(127 * _.opacity);
        return h * Bn + o * An + h * Un + o * ei + h * Yi + o * _n + h * Ni + o;
      }
      const ar = 0;
      class Zr {
        constructor(o) {
          this._sortAcrossTiles = o.layout.get("symbol-z-order") !== "viewport-y" && !o.layout.get("symbol-sort-key").isConstant(), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = {}, this._bucketParts = [];
        }
        continuePlacement(o, h, v, w, S) {
          const M = this._bucketParts;
          for (; this._currentTileIndex < o.length; ) if (h.getBucketParts(M, w, o[this._currentTileIndex], this._sortAcrossTiles), this._currentTileIndex++, S()) return !0;
          for (this._sortAcrossTiles && (this._sortAcrossTiles = !1, M.sort((z, R) => z.sortKey - R.sortKey)); this._currentPartIndex < M.length; ) if (h.placeLayerBucketPart(M[this._currentPartIndex], this._seenCrossTileIDs, v), this._currentPartIndex++, S()) return !0;
          return !1;
        }
      }
      class ns {
        constructor(o, h, v, w, S, M, z, R) {
          this.placement = new an(o, h, M, z, R), this._currentPlacementIndex = v.length - 1, this._forceFullPlacement = w, this._showCollisionBoxes = S, this._done = !1;
        }
        isDone() {
          return this._done;
        }
        continuePlacement(o, h, v) {
          const w = a.exported.now(), S = () => !this._forceFullPlacement && a.exported.now() - w > 2;
          for (; this._currentPlacementIndex >= 0; ) {
            const M = h[o[this._currentPlacementIndex]], z = this.placement.collisionIndex.transform.zoom;
            if (M.type === "symbol" && (!M.minzoom || M.minzoom <= z) && (!M.maxzoom || M.maxzoom > z)) {
              if (this._inProgressLayer || (this._inProgressLayer = new Zr(M)), this._inProgressLayer.continuePlacement(v[M.source], this.placement, this._showCollisionBoxes, M, S)) return;
              delete this._inProgressLayer;
            }
            this._currentPlacementIndex--;
          }
          this._done = !0;
        }
        commit(o) {
          return this.placement.commit(o), this.placement;
        }
      }
      const Uo = 512 / a.EXTENT / 2;
      class al {
        constructor(o, h, v) {
          this.tileID = o, this.bucketInstanceId = v, this._symbolsByKey = {};
          const w = /* @__PURE__ */ new Map();
          for (let S = 0; S < h.length; S++) {
            const M = h.get(S), z = M.key, R = w.get(z);
            R ? R.push(M) : w.set(z, [M]);
          }
          for (const [S, M] of w) {
            const z = { positions: M.map((R) => ({ x: Math.floor(R.anchorX * Uo), y: Math.floor(R.anchorY * Uo) })), crossTileIDs: M.map((R) => R.crossTileID) };
            if (z.positions.length > 128) {
              const R = new a.KDBush(z.positions.length, 16, Uint16Array);
              for (const { x: W, y: Q } of z.positions) R.add(W, Q);
              R.finish(), delete z.positions, z.index = R;
            }
            this._symbolsByKey[S] = z;
          }
        }
        getScaledCoordinates(o, h) {
          const { x: v, y: w, z: S } = this.tileID.canonical, { x: M, y: z, z: R } = h.canonical, W = Uo / Math.pow(2, R - S), Q = (z * a.EXTENT + o.anchorY) * W, J = w * a.EXTENT * Uo;
          return { x: Math.floor((M * a.EXTENT + o.anchorX) * W - v * a.EXTENT * Uo), y: Math.floor(Q - J) };
        }
        findMatches(o, h, v) {
          const w = this.tileID.canonical.z < h.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - h.canonical.z);
          for (let S = 0; S < o.length; S++) {
            const M = o.get(S);
            if (M.crossTileID) continue;
            const z = this._symbolsByKey[M.key];
            if (!z) continue;
            const R = this.getScaledCoordinates(M, h);
            if (z.index) {
              const W = z.index.range(R.x - w, R.y - w, R.x + w, R.y + w).sort();
              for (const Q of W) {
                const J = z.crossTileIDs[Q];
                if (!v[J]) {
                  v[J] = !0, M.crossTileID = J;
                  break;
                }
              }
            } else if (z.positions) for (let W = 0; W < z.positions.length; W++) {
              const Q = z.positions[W], J = z.crossTileIDs[W];
              if (Math.abs(Q.x - R.x) <= w && Math.abs(Q.y - R.y) <= w && !v[J]) {
                v[J] = !0, M.crossTileID = J;
                break;
              }
            }
          }
        }
        getCrossTileIDsLists() {
          return Object.values(this._symbolsByKey).map(({ crossTileIDs: o }) => o);
        }
      }
      class Bi {
        constructor() {
          this.maxCrossTileID = 0;
        }
        generate() {
          return ++this.maxCrossTileID;
        }
      }
      class Us {
        constructor() {
          this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
        }
        handleWrapJump(o) {
          const h = Math.round((o - this.lng) / 360);
          if (h !== 0) for (const v in this.indexes) {
            const w = this.indexes[v], S = {};
            for (const M in w) {
              const z = w[M];
              z.tileID = z.tileID.unwrapTo(z.tileID.wrap + h), S[z.tileID.key] = z;
            }
            this.indexes[v] = S;
          }
          this.lng = o;
        }
        addBucket(o, h, v) {
          if (this.indexes[o.overscaledZ] && this.indexes[o.overscaledZ][o.key]) {
            if (this.indexes[o.overscaledZ][o.key].bucketInstanceId === h.bucketInstanceId) return !1;
            this.removeBucketCrossTileIDs(o.overscaledZ, this.indexes[o.overscaledZ][o.key]);
          }
          for (let S = 0; S < h.symbolInstances.length; S++) h.symbolInstances.get(S).crossTileID = 0;
          this.usedCrossTileIDs[o.overscaledZ] || (this.usedCrossTileIDs[o.overscaledZ] = {});
          const w = this.usedCrossTileIDs[o.overscaledZ];
          for (const S in this.indexes) {
            const M = this.indexes[S];
            if (Number(S) > o.overscaledZ) for (const z in M) {
              const R = M[z];
              R.tileID.isChildOf(o) && R.findMatches(h.symbolInstances, o, w);
            }
            else {
              const z = M[o.scaledTo(Number(S)).key];
              z && z.findMatches(h.symbolInstances, o, w);
            }
          }
          for (let S = 0; S < h.symbolInstances.length; S++) {
            const M = h.symbolInstances.get(S);
            M.crossTileID || (M.crossTileID = v.generate(), w[M.crossTileID] = !0);
          }
          return this.indexes[o.overscaledZ] === void 0 && (this.indexes[o.overscaledZ] = {}), this.indexes[o.overscaledZ][o.key] = new al(o, h.symbolInstances, h.bucketInstanceId), !0;
        }
        removeBucketCrossTileIDs(o, h) {
          for (const v of h.getCrossTileIDsLists()) for (const w of v) delete this.usedCrossTileIDs[o][w];
        }
        removeStaleBuckets(o) {
          let h = !1;
          for (const v in this.indexes) {
            const w = this.indexes[v];
            for (const S in w) o[w[S].bucketInstanceId] || (this.removeBucketCrossTileIDs(v, w[S]), delete w[S], h = !0);
          }
          return h;
        }
      }
      class Es {
        constructor() {
          this.layerIndexes = {}, this.crossTileIDs = new Bi(), this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
        }
        addLayer(o, h, v) {
          let w = this.layerIndexes[o.id];
          w === void 0 && (w = this.layerIndexes[o.id] = new Us());
          let S = !1;
          const M = {};
          w.handleWrapJump(v);
          for (const z of h) {
            const R = z.getBucket(o);
            R && o.id === R.layerIds[0] && (R.bucketInstanceId || (R.bucketInstanceId = ++this.maxBucketInstanceId), w.addBucket(z.tileID, R, this.crossTileIDs) && (S = !0), M[R.bucketInstanceId] = !0);
          }
          return w.removeStaleBuckets(M) && (S = !0), S;
        }
        pruneUnusedLayers(o) {
          const h = {};
          o.forEach((v) => {
            h[v] = !0;
          });
          for (const v in this.layerIndexes) h[v] || delete this.layerIndexes[v];
        }
      }
      const Vi = (_, o) => a.emitValidationErrors(_, o && o.filter((h) => h.identifier !== "source.canvas")), ao = a.pick(a.operations, ["addLayer", "removeLayer", "setPaintProperty", "setLayoutProperty", "setFilter", "addSource", "removeSource", "setLayerZoomRange", "setLight", "setTransition", "setGeoJSONSourceData", "setGlyphs", "setSprite"]), Ln = a.pick(a.operations, ["setCenter", "setZoom", "setBearing", "setPitch"]), xi = a.emptyStyle();
      class Ki extends a.Evented {
        constructor(o, h = {}) {
          super(), this.map = o, this.dispatcher = new qe(Hr(), this, o._getMapId()), this.imageManager = new le(), this.imageManager.setEventedParent(this), this.glyphManager = new Ge(o._requestManager, h.localIdeographFontFamily), this.lineAtlas = new gt(256, 512), this.crossTileSymbolIndex = new Es(), this._spritesImagesIds = {}, this._layers = {}, this._order = [], this.sourceCaches = {}, this.zoomHistory = new a.ZoomHistory(), this._loaded = !1, this._availableImages = [], this._resetUpdates(), this.dispatcher.broadcast("setReferrer", a.getReferrer());
          const v = this;
          this._rtlTextPluginCallback = Ki.registerForPluginStateChange((w) => {
            v.dispatcher.broadcast("syncRTLPluginState", { pluginStatus: w.pluginStatus, pluginURL: w.pluginURL }, (S, M) => {
              if (a.triggerPluginCompletionEvent(S), M && M.every((z) => z)) for (const z in v.sourceCaches) {
                const R = v.sourceCaches[z].getSource().type;
                R !== "vector" && R !== "geojson" || v.sourceCaches[z].reload();
              }
            });
          }), this.on("data", (w) => {
            if (w.dataType !== "source" || w.sourceDataType !== "metadata") return;
            const S = this.sourceCaches[w.sourceId];
            if (!S) return;
            const M = S.getSource();
            if (M && M.vectorLayerIds) for (const z in this._layers) {
              const R = this._layers[z];
              R.source === M.id && this._validateLayer(R);
            }
          });
        }
        loadURL(o, h = {}, v) {
          this.fire(new a.Event("dataloading", { dataType: "style" })), h.validate = typeof h.validate != "boolean" || h.validate;
          const w = this.map._requestManager.transformRequest(o, N.Style);
          this._request = a.getJSON(w, (S, M) => {
            this._request = null, S ? this.fire(new a.ErrorEvent(S)) : M && this._load(M, h, v);
          });
        }
        loadJSON(o, h = {}, v) {
          this.fire(new a.Event("dataloading", { dataType: "style" })), this._request = a.exported.frame(() => {
            this._request = null, h.validate = h.validate !== !1, this._load(o, h, v);
          });
        }
        loadEmpty() {
          this.fire(new a.Event("dataloading", { dataType: "style" })), this._load(xi, { validate: !1 });
        }
        _load(o, h, v) {
          const w = h.transformStyle ? h.transformStyle(v, o) : o;
          if (!h.validate || !Vi(this, a.validateStyle(w))) {
            this._loaded = !0, this.stylesheet = w;
            for (const S in w.sources) this.addSource(S, w.sources[S], { validate: !1 });
            w.sprite ? this._loadSprite(w.sprite) : this.imageManager.setLoaded(!0), this.glyphManager.setURL(w.glyphs), this._createLayers(), this.light = new Ke(this.stylesheet.light), this.map.setTerrain(this.stylesheet.terrain), this.fire(new a.Event("data", { dataType: "style" })), this.fire(new a.Event("style.load"));
          }
        }
        _createLayers() {
          const o = a.derefLayers(this.stylesheet.layers);
          this.dispatcher.broadcast("setLayers", o), this._order = o.map((h) => h.id), this._layers = {}, this._serializedLayers = null;
          for (const h of o) {
            const v = a.createStyleLayer(h);
            v.setEventedParent(this, { layer: { id: h.id } }), this._layers[h.id] = v;
          }
        }
        _loadSprite(o, h = !1, v = void 0) {
          this.imageManager.setLoaded(!1), this._spriteRequest = function(w, S, M, z) {
            const R = de(w), W = R.length, Q = M > 1 ? "@2x" : "", J = {}, fe = {}, Se = {};
            for (const { id: we, url: Ce } of R) {
              const Me = S.transformRequest(S.normalizeSpriteURL(Ce, Q, ".json"), N.SpriteJSON), Ue = `${we}_${Me.url}`;
              J[Ue] = a.getJSON(Me, (st, ht) => {
                delete J[Ue], fe[we] = ht, me(z, fe, Se, st, W);
              });
              const ct = S.transformRequest(S.normalizeSpriteURL(Ce, Q, ".png"), N.SpriteImage), Ee = `${we}_${ct.url}`;
              J[Ee] = K.getImage(ct, (st, ht) => {
                delete J[Ee], Se[we] = ht, me(z, fe, Se, st, W);
              });
            }
            return { cancel() {
              for (const we of Object.values(J)) we.cancel();
            } };
          }(o, this.map._requestManager, this.map.getPixelRatio(), (w, S) => {
            if (this._spriteRequest = null, w) this.fire(new a.ErrorEvent(w));
            else if (S) for (const M in S) {
              this._spritesImagesIds[M] = [];
              const z = this._spritesImagesIds[M] ? this._spritesImagesIds[M].filter((R) => !(R in S)) : [];
              for (const R of z) this.imageManager.removeImage(R), this._changedImages[R] = !0;
              for (const R in S[M]) {
                const W = M === "default" ? R : `${M}:${R}`;
                this._spritesImagesIds[M].push(W), W in this.imageManager.images ? this.imageManager.updateImage(W, S[M][R], !1) : this.imageManager.addImage(W, S[M][R]), h && (this._changedImages[W] = !0);
              }
            }
            this.imageManager.setLoaded(!0), this._availableImages = this.imageManager.listImages(), h && (this._changed = !0), this.dispatcher.broadcast("setImages", this._availableImages), this.fire(new a.Event("data", { dataType: "style" })), v && v(w);
          });
        }
        _unloadSprite() {
          for (const o of Object.values(this._spritesImagesIds).flat()) this.imageManager.removeImage(o), this._changedImages[o] = !0;
          this._spritesImagesIds = {}, this._availableImages = this.imageManager.listImages(), this._changed = !0, this.dispatcher.broadcast("setImages", this._availableImages), this.fire(new a.Event("data", { dataType: "style" }));
        }
        _validateLayer(o) {
          const h = this.sourceCaches[o.source];
          if (!h) return;
          const v = o.sourceLayer;
          if (!v) return;
          const w = h.getSource();
          (w.type === "geojson" || w.vectorLayerIds && w.vectorLayerIds.indexOf(v) === -1) && this.fire(new a.ErrorEvent(new Error(`Source layer "${v}" does not exist on source "${w.id}" as specified by style layer "${o.id}".`)));
        }
        loaded() {
          if (!this._loaded || Object.keys(this._updatedSources).length) return !1;
          for (const o in this.sourceCaches) if (!this.sourceCaches[o].loaded()) return !1;
          return !!this.imageManager.isLoaded();
        }
        _serializeByIds(o) {
          const h = this._serializedAllLayers();
          if (!o || o.length === 0) return Object.values(h);
          const v = [];
          for (const w of o) h[w] && v.push(h[w]);
          return v;
        }
        _serializedAllLayers() {
          let o = this._serializedLayers;
          if (o) return o;
          o = this._serializedLayers = {};
          const h = Object.keys(this._layers);
          for (const v of h) {
            const w = this._layers[v];
            w.type !== "custom" && (o[v] = w.serialize());
          }
          return o;
        }
        hasTransitions() {
          if (this.light && this.light.hasTransition()) return !0;
          for (const o in this.sourceCaches) if (this.sourceCaches[o].hasTransition()) return !0;
          for (const o in this._layers) if (this._layers[o].hasTransition()) return !0;
          return !1;
        }
        _checkLoaded() {
          if (!this._loaded) throw new Error("Style is not done loading.");
        }
        update(o) {
          if (!this._loaded) return;
          const h = this._changed;
          if (this._changed) {
            const w = Object.keys(this._updatedLayers), S = Object.keys(this._removedLayers);
            (w.length || S.length) && this._updateWorkerLayers(w, S);
            for (const M in this._updatedSources) {
              const z = this._updatedSources[M];
              if (z === "reload") this._reloadSource(M);
              else {
                if (z !== "clear") throw new Error(`Invalid action ${z}`);
                this._clearSource(M);
              }
            }
            this._updateTilesForChangedImages(), this._updateTilesForChangedGlyphs();
            for (const M in this._updatedPaintProps) this._layers[M].updateTransitions(o);
            this.light.updateTransitions(o), this._resetUpdates();
          }
          const v = {};
          for (const w in this.sourceCaches) {
            const S = this.sourceCaches[w];
            v[w] = S.used, S.used = !1;
          }
          for (const w of this._order) {
            const S = this._layers[w];
            S.recalculate(o, this._availableImages), !S.isHidden(o.zoom) && S.source && (this.sourceCaches[S.source].used = !0);
          }
          for (const w in v) {
            const S = this.sourceCaches[w];
            v[w] !== S.used && S.fire(new a.Event("data", { sourceDataType: "visibility", dataType: "source", sourceId: w }));
          }
          this.light.recalculate(o), this.z = o.zoom, h && this.fire(new a.Event("data", { dataType: "style" }));
        }
        _updateTilesForChangedImages() {
          const o = Object.keys(this._changedImages);
          if (o.length) {
            for (const h in this.sourceCaches) this.sourceCaches[h].reloadTilesForDependencies(["icons", "patterns"], o);
            this._changedImages = {};
          }
        }
        _updateTilesForChangedGlyphs() {
          if (this._glyphsDidChange) {
            for (const o in this.sourceCaches) this.sourceCaches[o].reloadTilesForDependencies(["glyphs"], [""]);
            this._glyphsDidChange = !1;
          }
        }
        _updateWorkerLayers(o, h) {
          this.dispatcher.broadcast("updateLayers", { layers: this._serializeByIds(o), removedIds: h });
        }
        _resetUpdates() {
          this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSources = {}, this._updatedPaintProps = {}, this._changedImages = {}, this._glyphsDidChange = !1;
        }
        setState(o, h = {}) {
          this._checkLoaded();
          const v = this.serialize();
          if (o = h.transformStyle ? h.transformStyle(v, o) : o, Vi(this, a.validateStyle(o))) return !1;
          (o = a.clone$1(o)).layers = a.derefLayers(o.layers);
          const w = a.diffStyles(v, o).filter((M) => !(M.command in Ln));
          if (w.length === 0) return !1;
          const S = w.filter((M) => !(M.command in ao));
          if (S.length > 0) throw new Error(`Unimplemented: ${S.map((M) => M.command).join(", ")}.`);
          for (const M of w) M.command !== "setTransition" && this[M.command].apply(this, M.args);
          return this.stylesheet = o, !0;
        }
        addImage(o, h) {
          if (this.getImage(o)) return this.fire(new a.ErrorEvent(new Error(`An image named "${o}" already exists.`)));
          this.imageManager.addImage(o, h), this._afterImageUpdated(o);
        }
        updateImage(o, h) {
          this.imageManager.updateImage(o, h);
        }
        getImage(o) {
          return this.imageManager.getImage(o);
        }
        removeImage(o) {
          if (!this.getImage(o)) return this.fire(new a.ErrorEvent(new Error(`An image named "${o}" does not exist.`)));
          this.imageManager.removeImage(o), this._afterImageUpdated(o);
        }
        _afterImageUpdated(o) {
          this._availableImages = this.imageManager.listImages(), this._changedImages[o] = !0, this._changed = !0, this.dispatcher.broadcast("setImages", this._availableImages), this.fire(new a.Event("data", { dataType: "style" }));
        }
        listImages() {
          return this._checkLoaded(), this.imageManager.listImages();
        }
        addSource(o, h, v = {}) {
          if (this._checkLoaded(), this.sourceCaches[o] !== void 0) throw new Error(`Source "${o}" already exists.`);
          if (!h.type) throw new Error(`The type property must be defined, but only the following properties were given: ${Object.keys(h).join(", ")}.`);
          if (["vector", "raster", "geojson", "video", "image"].indexOf(h.type) >= 0 && this._validate(a.validateStyle.source, `sources.${o}`, h, null, v)) return;
          this.map && this.map._collectResourceTiming && (h.collectResourceTiming = !0);
          const w = this.sourceCaches[o] = new wn(o, h, this.dispatcher);
          w.style = this, w.setEventedParent(this, () => ({ isSourceLoaded: w.loaded(), source: w.serialize(), sourceId: o })), w.onAdd(this.map), this._changed = !0;
        }
        removeSource(o) {
          if (this._checkLoaded(), this.sourceCaches[o] === void 0) throw new Error("There is no source with this ID");
          for (const v in this._layers) if (this._layers[v].source === o) return this.fire(new a.ErrorEvent(new Error(`Source "${o}" cannot be removed while layer "${v}" is using it.`)));
          const h = this.sourceCaches[o];
          delete this.sourceCaches[o], delete this._updatedSources[o], h.fire(new a.Event("data", { sourceDataType: "metadata", dataType: "source", sourceId: o })), h.setEventedParent(null), h.onRemove(this.map), this._changed = !0;
        }
        setGeoJSONSourceData(o, h) {
          if (this._checkLoaded(), this.sourceCaches[o] === void 0) throw new Error(`There is no source with this ID=${o}`);
          const v = this.sourceCaches[o].getSource();
          if (v.type !== "geojson") throw new Error(`geojsonSource.type is ${v.type}, which is !== 'geojson`);
          v.setData(h), this._changed = !0;
        }
        getSource(o) {
          return this.sourceCaches[o] && this.sourceCaches[o].getSource();
        }
        addLayer(o, h, v = {}) {
          this._checkLoaded();
          const w = o.id;
          if (this.getLayer(w)) return void this.fire(new a.ErrorEvent(new Error(`Layer "${w}" already exists on this map.`)));
          let S;
          if (o.type === "custom") {
            if (Vi(this, a.validateCustomStyleLayer(o))) return;
            S = a.createStyleLayer(o);
          } else {
            if (typeof o.source == "object" && (this.addSource(w, o.source), o = a.clone$1(o), o = a.extend(o, { source: w })), this._validate(a.validateStyle.layer, `layers.${w}`, o, { arrayIndex: -1 }, v)) return;
            S = a.createStyleLayer(o), this._validateLayer(S), S.setEventedParent(this, { layer: { id: w } });
          }
          const M = h ? this._order.indexOf(h) : this._order.length;
          if (h && M === -1) this.fire(new a.ErrorEvent(new Error(`Cannot add layer "${w}" before non-existing layer "${h}".`)));
          else {
            if (this._order.splice(M, 0, w), this._layerOrderChanged = !0, this._layers[w] = S, this._removedLayers[w] && S.source && S.type !== "custom") {
              const z = this._removedLayers[w];
              delete this._removedLayers[w], z.type !== S.type ? this._updatedSources[S.source] = "clear" : (this._updatedSources[S.source] = "reload", this.sourceCaches[S.source].pause());
            }
            this._updateLayer(S), S.onAdd && S.onAdd(this.map);
          }
        }
        moveLayer(o, h) {
          if (this._checkLoaded(), this._changed = !0, !this._layers[o]) return void this.fire(new a.ErrorEvent(new Error(`The layer '${o}' does not exist in the map's style and cannot be moved.`)));
          if (o === h) return;
          const v = this._order.indexOf(o);
          this._order.splice(v, 1);
          const w = h ? this._order.indexOf(h) : this._order.length;
          h && w === -1 ? this.fire(new a.ErrorEvent(new Error(`Cannot move layer "${o}" before non-existing layer "${h}".`))) : (this._order.splice(w, 0, o), this._layerOrderChanged = !0);
        }
        removeLayer(o) {
          this._checkLoaded();
          const h = this._layers[o];
          if (!h) return void this.fire(new a.ErrorEvent(new Error(`Cannot remove non-existing layer "${o}".`)));
          h.setEventedParent(null);
          const v = this._order.indexOf(o);
          this._order.splice(v, 1), this._layerOrderChanged = !0, this._changed = !0, this._removedLayers[o] = h, delete this._layers[o], this._serializedLayers && delete this._serializedLayers[o], delete this._updatedLayers[o], delete this._updatedPaintProps[o], h.onRemove && h.onRemove(this.map);
        }
        getLayer(o) {
          return this._layers[o];
        }
        hasLayer(o) {
          return o in this._layers;
        }
        setLayerZoomRange(o, h, v) {
          this._checkLoaded();
          const w = this.getLayer(o);
          w ? w.minzoom === h && w.maxzoom === v || (h != null && (w.minzoom = h), v != null && (w.maxzoom = v), this._updateLayer(w)) : this.fire(new a.ErrorEvent(new Error(`Cannot set the zoom range of non-existing layer "${o}".`)));
        }
        setFilter(o, h, v = {}) {
          this._checkLoaded();
          const w = this.getLayer(o);
          if (w) {
            if (!a.deepEqual(w.filter, h)) return h == null ? (w.filter = void 0, void this._updateLayer(w)) : void (this._validate(a.validateStyle.filter, `layers.${w.id}.filter`, h, null, v) || (w.filter = a.clone$1(h), this._updateLayer(w)));
          } else this.fire(new a.ErrorEvent(new Error(`Cannot filter non-existing layer "${o}".`)));
        }
        getFilter(o) {
          return a.clone$1(this.getLayer(o).filter);
        }
        setLayoutProperty(o, h, v, w = {}) {
          this._checkLoaded();
          const S = this.getLayer(o);
          S ? a.deepEqual(S.getLayoutProperty(h), v) || (S.setLayoutProperty(h, v, w), this._updateLayer(S)) : this.fire(new a.ErrorEvent(new Error(`Cannot style non-existing layer "${o}".`)));
        }
        getLayoutProperty(o, h) {
          const v = this.getLayer(o);
          if (v) return v.getLayoutProperty(h);
          this.fire(new a.ErrorEvent(new Error(`Cannot get style of non-existing layer "${o}".`)));
        }
        setPaintProperty(o, h, v, w = {}) {
          this._checkLoaded();
          const S = this.getLayer(o);
          S ? a.deepEqual(S.getPaintProperty(h), v) || (S.setPaintProperty(h, v, w) && this._updateLayer(S), this._changed = !0, this._updatedPaintProps[o] = !0) : this.fire(new a.ErrorEvent(new Error(`Cannot style non-existing layer "${o}".`)));
        }
        getPaintProperty(o, h) {
          return this.getLayer(o).getPaintProperty(h);
        }
        setFeatureState(o, h) {
          this._checkLoaded();
          const v = o.source, w = o.sourceLayer, S = this.sourceCaches[v];
          if (S === void 0) return void this.fire(new a.ErrorEvent(new Error(`The source '${v}' does not exist in the map's style.`)));
          const M = S.getSource().type;
          M === "geojson" && w ? this.fire(new a.ErrorEvent(new Error("GeoJSON sources cannot have a sourceLayer parameter."))) : M !== "vector" || w ? (o.id === void 0 && this.fire(new a.ErrorEvent(new Error("The feature id parameter must be provided."))), S.setFeatureState(w, o.id, h)) : this.fire(new a.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
        }
        removeFeatureState(o, h) {
          this._checkLoaded();
          const v = o.source, w = this.sourceCaches[v];
          if (w === void 0) return void this.fire(new a.ErrorEvent(new Error(`The source '${v}' does not exist in the map's style.`)));
          const S = w.getSource().type, M = S === "vector" ? o.sourceLayer : void 0;
          S !== "vector" || M ? h && typeof o.id != "string" && typeof o.id != "number" ? this.fire(new a.ErrorEvent(new Error("A feature id is required to remove its specific state property."))) : w.removeFeatureState(M, o.id, h) : this.fire(new a.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
        }
        getFeatureState(o) {
          this._checkLoaded();
          const h = o.source, v = o.sourceLayer, w = this.sourceCaches[h];
          if (w !== void 0) return w.getSource().type !== "vector" || v ? (o.id === void 0 && this.fire(new a.ErrorEvent(new Error("The feature id parameter must be provided."))), w.getFeatureState(v, o.id)) : void this.fire(new a.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
          this.fire(new a.ErrorEvent(new Error(`The source '${h}' does not exist in the map's style.`)));
        }
        getTransition() {
          return a.extend({ duration: 300, delay: 0 }, this.stylesheet && this.stylesheet.transition);
        }
        serialize() {
          const o = a.mapObject(this.sourceCaches, (w) => w.serialize()), h = this._serializeByIds(this._order), v = this.stylesheet;
          return a.filterObject({ version: v.version, name: v.name, metadata: v.metadata, light: v.light, center: v.center, zoom: v.zoom, bearing: v.bearing, pitch: v.pitch, sprite: v.sprite, glyphs: v.glyphs, transition: v.transition, sources: o, layers: h }, (w) => w !== void 0);
        }
        _updateLayer(o) {
          this._updatedLayers[o.id] = !0, o.source && !this._updatedSources[o.source] && this.sourceCaches[o.source].getSource().type !== "raster" && (this._updatedSources[o.source] = "reload", this.sourceCaches[o.source].pause()), this._serializedLayers = null, this._changed = !0;
        }
        _flattenAndSortRenderedFeatures(o) {
          const h = (M) => this._layers[M].type === "fill-extrusion", v = {}, w = [];
          for (let M = this._order.length - 1; M >= 0; M--) {
            const z = this._order[M];
            if (h(z)) {
              v[z] = M;
              for (const R of o) {
                const W = R[z];
                if (W) for (const Q of W) w.push(Q);
              }
            }
          }
          w.sort((M, z) => z.intersectionZ - M.intersectionZ);
          const S = [];
          for (let M = this._order.length - 1; M >= 0; M--) {
            const z = this._order[M];
            if (h(z)) for (let R = w.length - 1; R >= 0; R--) {
              const W = w[R].feature;
              if (v[W.layer.id] < M) break;
              S.push(W), w.pop();
            }
            else for (const R of o) {
              const W = R[z];
              if (W) for (const Q of W) S.push(Q.feature);
            }
          }
          return S;
        }
        queryRenderedFeatures(o, h, v) {
          h && h.filter && this._validate(a.validateStyle.filter, "queryRenderedFeatures.filter", h.filter, null, h);
          const w = {};
          if (h && h.layers) {
            if (!Array.isArray(h.layers)) return this.fire(new a.ErrorEvent(new Error("parameters.layers must be an Array."))), [];
            for (const z of h.layers) {
              const R = this._layers[z];
              if (!R) return this.fire(new a.ErrorEvent(new Error(`The layer '${z}' does not exist in the map's style and cannot be queried for features.`))), [];
              w[R.source] = !0;
            }
          }
          const S = [];
          h.availableImages = this._availableImages;
          const M = this._serializedAllLayers();
          for (const z in this.sourceCaches) h.layers && !w[z] || S.push(hn(this.sourceCaches[z], this._layers, M, o, h, v));
          return this.placement && S.push(function(z, R, W, Q, J, fe, Se) {
            const we = {}, Ce = fe.queryRenderedSymbols(Q), Me = [];
            for (const Ue of Object.keys(Ce).map(Number)) Me.push(Se[Ue]);
            Me.sort(Ht);
            for (const Ue of Me) {
              const ct = Ue.featureIndex.lookupSymbolFeatures(Ce[Ue.bucketInstanceId], R, Ue.bucketIndex, Ue.sourceLayerIndex, J.filter, J.layers, J.availableImages, z);
              for (const Ee in ct) {
                const st = we[Ee] = we[Ee] || [], ht = ct[Ee];
                ht.sort((wt, Ct) => {
                  const Dt = Ue.featureSortOrder;
                  if (Dt) {
                    const xt = Dt.indexOf(wt.featureIndex);
                    return Dt.indexOf(Ct.featureIndex) - xt;
                  }
                  return Ct.featureIndex - wt.featureIndex;
                });
                for (const wt of ht) st.push(wt);
              }
            }
            for (const Ue in we) we[Ue].forEach((ct) => {
              const Ee = ct.feature, st = W[z[Ue].source].getFeatureState(Ee.layer["source-layer"], Ee.id);
              Ee.source = Ee.layer.source, Ee.layer["source-layer"] && (Ee.sourceLayer = Ee.layer["source-layer"]), Ee.state = st;
            });
            return we;
          }(this._layers, M, this.sourceCaches, o, h, this.placement.collisionIndex, this.placement.retainedQueryData)), this._flattenAndSortRenderedFeatures(S);
        }
        querySourceFeatures(o, h) {
          h && h.filter && this._validate(a.validateStyle.filter, "querySourceFeatures.filter", h.filter, null, h);
          const v = this.sourceCaches[o];
          return v ? function(w, S) {
            const M = w.getRenderableIds().map((W) => w.getTileByID(W)), z = [], R = {};
            for (let W = 0; W < M.length; W++) {
              const Q = M[W], J = Q.tileID.canonical.key;
              R[J] || (R[J] = !0, Q.querySourceFeatures(z, S));
            }
            return z;
          }(v, h) : [];
        }
        addSourceType(o, h, v) {
          return Ki.getSourceType(o) ? v(new Error(`A source type called "${o}" already exists.`)) : (Ki.setSourceType(o, h), h.workerSourceURL ? void this.dispatcher.broadcast("loadWorkerSource", { name: o, url: h.workerSourceURL }, v) : v(null, null));
        }
        getLight() {
          return this.light.getLight();
        }
        setLight(o, h = {}) {
          this._checkLoaded();
          const v = this.light.getLight();
          let w = !1;
          for (const M in o) if (!a.deepEqual(o[M], v[M])) {
            w = !0;
            break;
          }
          if (!w) return;
          const S = { now: a.exported.now(), transition: a.extend({ duration: 300, delay: 0 }, this.stylesheet.transition) };
          this.light.setLight(o, h), this.light.updateTransitions(S);
        }
        _validate(o, h, v, w, S = {}) {
          return (!S || S.validate !== !1) && Vi(this, o.call(a.validateStyle, a.extend({ key: h, style: this.serialize(), value: v, styleSpec: a.v8Spec }, w)));
        }
        _remove(o = !0) {
          this._request && (this._request.cancel(), this._request = null), this._spriteRequest && (this._spriteRequest.cancel(), this._spriteRequest = null), a.evented.off("pluginStateChange", this._rtlTextPluginCallback);
          for (const h in this._layers) this._layers[h].setEventedParent(null);
          for (const h in this.sourceCaches) {
            const v = this.sourceCaches[h];
            v.setEventedParent(null), v.onRemove(this.map);
          }
          this.imageManager.setEventedParent(null), this.setEventedParent(null), this.dispatcher.remove(o);
        }
        _clearSource(o) {
          this.sourceCaches[o].clearTiles();
        }
        _reloadSource(o) {
          this.sourceCaches[o].resume(), this.sourceCaches[o].reload();
        }
        _updateSources(o) {
          for (const h in this.sourceCaches) this.sourceCaches[h].update(o, this.map.terrain);
        }
        _generateCollisionBoxes() {
          for (const o in this.sourceCaches) this._reloadSource(o);
        }
        _updatePlacement(o, h, v, w, S = !1) {
          let M = !1, z = !1;
          const R = {};
          for (const W of this._order) {
            const Q = this._layers[W];
            if (Q.type !== "symbol") continue;
            if (!R[Q.source]) {
              const fe = this.sourceCaches[Q.source];
              R[Q.source] = fe.getRenderableIds(!0).map((Se) => fe.getTileByID(Se)).sort((Se, we) => we.tileID.overscaledZ - Se.tileID.overscaledZ || (Se.tileID.isLessThan(we.tileID) ? -1 : 1));
            }
            const J = this.crossTileSymbolIndex.addLayer(Q, R[Q.source], o.center.lng);
            M = M || J;
          }
          if (this.crossTileSymbolIndex.pruneUnusedLayers(this._order), ((S = S || this._layerOrderChanged || v === 0) || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent(a.exported.now(), o.zoom)) && (this.pauseablePlacement = new ns(o, this.map.terrain, this._order, S, h, v, w, this.placement), this._layerOrderChanged = !1), this.pauseablePlacement.isDone() ? this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._order, this._layers, R), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(a.exported.now()), z = !0), M && this.pauseablePlacement.placement.setStale()), z || M) for (const W of this._order) {
            const Q = this._layers[W];
            Q.type === "symbol" && this.placement.updateLayerOpacities(Q, R[Q.source]);
          }
          return !this.pauseablePlacement.isDone() || this.placement.hasTransitions(a.exported.now());
        }
        _releaseSymbolFadeTiles() {
          for (const o in this.sourceCaches) this.sourceCaches[o].releaseSymbolFadeTiles();
        }
        getImages(o, h, v) {
          this.imageManager.getImages(h.icons, v), this._updateTilesForChangedImages();
          const w = this.sourceCaches[h.source];
          w && w.setDependencies(h.tileID.key, h.type, h.icons);
        }
        getGlyphs(o, h, v) {
          this.glyphManager.getGlyphs(h.stacks, v);
          const w = this.sourceCaches[h.source];
          w && w.setDependencies(h.tileID.key, h.type, [""]);
        }
        getResource(o, h, v) {
          return a.makeRequest(h, v);
        }
        getGlyphsUrl() {
          return this.stylesheet.glyphs || null;
        }
        setGlyphs(o, h = {}) {
          this._checkLoaded(), o && this._validate(a.validateStyle.glyphs, "glyphs", o, null, h) || (this._glyphsDidChange = !0, this.stylesheet.glyphs = o, this.glyphManager.entries = {}, this.glyphManager.setURL(o));
        }
        addSprite(o, h, v = {}, w) {
          this._checkLoaded();
          const S = [{ id: o, url: h }], M = [...de(this.stylesheet.sprite), ...S];
          this._validate(a.validateStyle.sprite, "sprite", M, null, v) || (this.stylesheet.sprite = M, this._loadSprite(S, !0, w));
        }
        removeSprite(o) {
          this._checkLoaded();
          const h = de(this.stylesheet.sprite);
          if (h.find((v) => v.id === o)) {
            if (this._spritesImagesIds[o]) for (const v of this._spritesImagesIds[o]) this.imageManager.removeImage(v), this._changedImages[v] = !0;
            h.splice(h.findIndex((v) => v.id === o), 1), this.stylesheet.sprite = h.length > 0 ? h : void 0, delete this._spritesImagesIds[o], this._availableImages = this.imageManager.listImages(), this._changed = !0, this.dispatcher.broadcast("setImages", this._availableImages), this.fire(new a.Event("data", { dataType: "style" }));
          } else this.fire(new a.ErrorEvent(new Error(`Sprite "${o}" doesn't exists on this map.`)));
        }
        getSprite() {
          return de(this.stylesheet.sprite);
        }
        setSprite(o, h = {}, v) {
          this._checkLoaded(), o && this._validate(a.validateStyle.sprite, "sprite", o, null, h) || (this.stylesheet.sprite = o, o ? this._loadSprite(o, !0, v) : (this._unloadSprite(), v && v(null)));
        }
      }
      Ki.getSourceType = function(_) {
        return Bt[_];
      }, Ki.setSourceType = function(_, o) {
        Bt[_] = o;
      }, Ki.registerForPluginStateChange = a.registerForPluginStateChange;
      var Hs = a.createLayout([{ name: "a_pos", type: "Int16", components: 2 }]), ms = "attribute vec3 a_pos3d;uniform mat4 u_matrix;uniform float u_ele_delta;varying vec2 v_texture_pos;varying float v_depth;void main() {float extent=8192.0;float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;v_texture_pos=a_pos3d.xy/extent;gl_Position=u_matrix*vec4(a_pos3d.xy,get_elevation(a_pos3d.xy)-ele_delta,1.0);v_depth=gl_Position.z/gl_Position.w;}";
      const Ps = { prelude: jt(`#ifdef GL_ES
precision mediump float;
#else
#if !defined(lowp)
#define lowp
#endif
#if !defined(mediump)
#define mediump
#endif
#if !defined(highp)
#define highp
#endif
#endif
`, `#ifdef GL_ES
precision highp float;
#else
#if !defined(lowp)
#define lowp
#endif
#if !defined(mediump)
#define mediump
#endif
#if !defined(highp)
#define highp
#endif
#endif
vec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(unpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0
);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}
#ifdef TERRAIN3D
uniform sampler2D u_terrain;uniform float u_terrain_dim;uniform mat4 u_terrain_matrix;uniform vec4 u_terrain_unpack;uniform float u_terrain_exaggeration;uniform highp sampler2D u_depth;
#endif
const highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitShifts=vec4(1.)/bitSh;highp float unpack(highp vec4 color) {return dot(color,bitShifts);}highp float depthOpacity(vec3 frag) {
#ifdef TERRAIN3D
highp float d=unpack(texture2D(u_depth,frag.xy*0.5+0.5))+0.0001-frag.z;return 1.0-max(0.0,min(1.0,-d*500.0));
#else
return 1.0;
#endif
}float calculate_visibility(vec4 pos) {
#ifdef TERRAIN3D
vec3 frag=pos.xyz/pos.w;highp float d=depthOpacity(frag);if (d > 0.95) return 1.0;return (d+depthOpacity(frag+vec3(0.0,0.01,0.0)))/2.0;
#else
return 1.0;
#endif
}float ele(vec2 pos) {
#ifdef TERRAIN3D
vec4 rgb=(texture2D(u_terrain,pos)*255.0)*u_terrain_unpack;return rgb.r+rgb.g+rgb.b-u_terrain_unpack.a;
#else
return 0.0;
#endif
}float get_elevation(vec2 pos) {
#ifdef TERRAIN3D
vec2 coord=(u_terrain_matrix*vec4(pos,0.0,1.0)).xy*u_terrain_dim+1.0;vec2 f=fract(coord);vec2 c=(floor(coord)+0.5)/(u_terrain_dim+2.0);float d=1.0/(u_terrain_dim+2.0);float tl=ele(c);float tr=ele(c+vec2(d,0.0));float bl=ele(c+vec2(0.0,d));float br=ele(c+vec2(d,d));float elevation=mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);return elevation*u_terrain_exaggeration;
#else
return 0.0;
#endif
}`), background: jt(`uniform vec4 u_color;uniform float u_opacity;void main() {gl_FragColor=u_color*u_opacity;
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"), backgroundPattern: jt(`uniform vec2 u_pattern_tl_a;uniform vec2 u_pattern_br_a;uniform vec2 u_pattern_tl_b;uniform vec2 u_pattern_br_b;uniform vec2 u_texsize;uniform float u_mix;uniform float u_opacity;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(u_pattern_tl_a/u_texsize,u_pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(u_pattern_tl_b/u_texsize,u_pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_mix)*u_opacity;
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, "uniform mat4 u_matrix;uniform vec2 u_pattern_size_a;uniform vec2 u_pattern_size_b;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_scale_a;uniform float u_scale_b;uniform float u_tile_units_to_pixels;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_a*u_pattern_size_a,u_tile_units_to_pixels,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_b*u_pattern_size_b,u_tile_units_to_pixels,a_pos);}"), circle: jt(`varying vec3 v_data;varying float v_visibility;
#pragma mapbox: define highp vec4 color
#pragma mapbox: define mediump float radius
#pragma mapbox: define lowp float blur
#pragma mapbox: define lowp float opacity
#pragma mapbox: define highp vec4 stroke_color
#pragma mapbox: define mediump float stroke_width
#pragma mapbox: define lowp float stroke_opacity
void main() {
#pragma mapbox: initialize highp vec4 color
#pragma mapbox: initialize mediump float radius
#pragma mapbox: initialize lowp float blur
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize highp vec4 stroke_color
#pragma mapbox: initialize mediump float stroke_width
#pragma mapbox: initialize lowp float stroke_opacity
vec2 extrude=v_data.xy;float extrude_length=length(extrude);lowp float antialiasblur=v_data.z;float antialiased_blur=-max(blur,antialiasblur);float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(antialiased_blur,0.0,extrude_length-radius/(radius+stroke_width));gl_FragColor=v_visibility*opacity_t*mix(color*opacity,stroke_color*stroke_opacity,color_t);
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, `uniform mat4 u_matrix;uniform bool u_scale_with_map;uniform bool u_pitch_with_map;uniform vec2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;attribute vec2 a_pos;varying vec3 v_data;varying float v_visibility;
#pragma mapbox: define highp vec4 color
#pragma mapbox: define mediump float radius
#pragma mapbox: define lowp float blur
#pragma mapbox: define lowp float opacity
#pragma mapbox: define highp vec4 stroke_color
#pragma mapbox: define mediump float stroke_width
#pragma mapbox: define lowp float stroke_opacity
void main(void) {
#pragma mapbox: initialize highp vec4 color
#pragma mapbox: initialize mediump float radius
#pragma mapbox: initialize lowp float blur
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize highp vec4 stroke_color
#pragma mapbox: initialize mediump float stroke_width
#pragma mapbox: initialize lowp float stroke_opacity
vec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);float ele=get_elevation(circle_center);v_visibility=calculate_visibility(u_matrix*vec4(circle_center,ele,1.0));if (u_pitch_with_map) {vec2 corner_position=circle_center;if (u_scale_with_map) {corner_position+=extrude*(radius+stroke_width)*u_extrude_scale;} else {vec4 projected_center=u_matrix*vec4(circle_center,0,1);corner_position+=extrude*(radius+stroke_width)*u_extrude_scale*(projected_center.w/u_camera_to_center_distance);}gl_Position=u_matrix*vec4(corner_position,ele,1);} else {gl_Position=u_matrix*vec4(circle_center,ele,1);if (u_scale_with_map) {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*u_camera_to_center_distance;} else {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*gl_Position.w;}}lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);}`), clippingMask: jt("void main() {gl_FragColor=vec4(1.0);}", "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"), heatmap: jt(`uniform highp float u_intensity;varying vec2 v_extrude;
#pragma mapbox: define highp float weight
#define GAUSS_COEF 0.3989422804014327
void main() {
#pragma mapbox: initialize highp float weight
float d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);gl_FragColor=vec4(val,1.0,1.0,1.0);
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, `uniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;attribute vec2 a_pos;varying vec2 v_extrude;
#pragma mapbox: define highp float weight
#pragma mapbox: define mediump float radius
const highp float ZERO=1.0/255.0/16.0;
#define GAUSS_COEF 0.3989422804014327
void main(void) {
#pragma mapbox: initialize highp float weight
#pragma mapbox: initialize mediump float radius
vec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec4 pos=vec4(floor(a_pos*0.5)+extrude,0,1);gl_Position=u_matrix*pos;}`), heatmapTexture: jt(`uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;varying vec2 v_pos;void main() {float t=texture2D(u_image,v_pos).r;vec4 color=texture2D(u_color_ramp,vec2(t,0.5));gl_FragColor=color*u_opacity;
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(0.0);
#endif
}`, "uniform mat4 u_matrix;uniform vec2 u_world;attribute vec2 a_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos*u_world,0,1);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}"), collisionBox: jt("varying float v_placed;varying float v_notUsed;void main() {float alpha=0.5;gl_FragColor=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {gl_FragColor=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {gl_FragColor*=.1;}}", "attribute vec2 a_pos;attribute vec2 a_anchor_pos;attribute vec2 a_extrude;attribute vec2 a_placed;attribute vec2 a_shift;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;varying float v_placed;varying float v_notUsed;void main() {vec4 projectedPoint=u_matrix*vec4(a_anchor_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);gl_Position=u_matrix*vec4(a_pos,get_elevation(a_pos),1.0);gl_Position.xy+=(a_extrude+a_shift)*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;}"), collisionCircle: jt("varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);gl_FragColor=color*alpha*opacity_t;}", "attribute vec2 a_pos;attribute float a_radius;attribute vec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 quadCenterPos=a_pos;float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(mix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(quadCenterPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=collision;gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"), debug: jt("uniform highp vec4 u_color;uniform sampler2D u_overlay;varying vec2 v_uv;void main() {vec4 overlay_color=texture2D(u_overlay,v_uv);gl_FragColor=mix(u_color,overlay_color,overlay_color.a);}", "attribute vec2 a_pos;varying vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {v_uv=a_pos/8192.0;gl_Position=u_matrix*vec4(a_pos*u_overlay_scale,get_elevation(a_pos),1);}"), fill: jt(`#pragma mapbox: define highp vec4 color
#pragma mapbox: define lowp float opacity
void main() {
#pragma mapbox: initialize highp vec4 color
#pragma mapbox: initialize lowp float opacity
gl_FragColor=color*opacity;
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, `attribute vec2 a_pos;uniform mat4 u_matrix;
#pragma mapbox: define highp vec4 color
#pragma mapbox: define lowp float opacity
void main() {
#pragma mapbox: initialize highp vec4 color
#pragma mapbox: initialize lowp float opacity
gl_Position=u_matrix*vec4(a_pos,0,1);}`), fillOutline: jt(`varying vec2 v_pos;
#pragma mapbox: define highp vec4 outline_color
#pragma mapbox: define lowp float opacity
void main() {
#pragma mapbox: initialize highp vec4 outline_color
#pragma mapbox: initialize lowp float opacity
float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=outline_color*(alpha*opacity);
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, `attribute vec2 a_pos;uniform mat4 u_matrix;uniform vec2 u_world;varying vec2 v_pos;
#pragma mapbox: define highp vec4 outline_color
#pragma mapbox: define lowp float opacity
void main() {
#pragma mapbox: initialize highp vec4 outline_color
#pragma mapbox: initialize lowp float opacity
gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}`), fillOutlinePattern: jt(`uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_fade;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;
#pragma mapbox: define lowp float opacity
#pragma mapbox: define lowp vec4 pattern_from
#pragma mapbox: define lowp vec4 pattern_to
void main() {
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize mediump vec4 pattern_from
#pragma mapbox: initialize mediump vec4 pattern_to
vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=mix(color1,color2,u_fade)*alpha*opacity;
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, `uniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;
#pragma mapbox: define lowp float opacity
#pragma mapbox: define lowp vec4 pattern_from
#pragma mapbox: define lowp vec4 pattern_to
#pragma mapbox: define lowp float pixel_ratio_from
#pragma mapbox: define lowp float pixel_ratio_to
void main() {
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize mediump vec4 pattern_from
#pragma mapbox: initialize mediump vec4 pattern_to
#pragma mapbox: initialize lowp float pixel_ratio_from
#pragma mapbox: initialize lowp float pixel_ratio_to
vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;gl_Position=u_matrix*vec4(a_pos,0,1);vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}`), fillPattern: jt(`#ifdef GL_ES
precision highp float;
#endif
uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;
#pragma mapbox: define lowp float opacity
#pragma mapbox: define lowp vec4 pattern_from
#pragma mapbox: define lowp vec4 pattern_to
void main() {
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize mediump vec4 pattern_from
#pragma mapbox: initialize mediump vec4 pattern_to
vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_fade)*opacity;
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, `uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;
#pragma mapbox: define lowp float opacity
#pragma mapbox: define lowp vec4 pattern_from
#pragma mapbox: define lowp vec4 pattern_to
#pragma mapbox: define lowp float pixel_ratio_from
#pragma mapbox: define lowp float pixel_ratio_to
void main() {
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize mediump vec4 pattern_from
#pragma mapbox: initialize mediump vec4 pattern_to
#pragma mapbox: initialize lowp float pixel_ratio_from
#pragma mapbox: initialize lowp float pixel_ratio_to
vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileZoomRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileZoomRatio,a_pos);}`), fillExtrusion: jt(`varying vec4 v_color;void main() {gl_FragColor=v_color;
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, `uniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;attribute vec2 a_pos;attribute vec4 a_normal_ed;
#ifdef TERRAIN3D
attribute vec2 a_centroid;
#endif
varying vec4 v_color;
#pragma mapbox: define highp float base
#pragma mapbox: define highp float height
#pragma mapbox: define highp vec4 color
void main() {
#pragma mapbox: initialize highp float base
#pragma mapbox: initialize highp float height
#pragma mapbox: initialize highp vec4 color
vec3 normal=a_normal_ed.xyz;
#ifdef TERRAIN3D
float height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);
#else
float height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;
#endif
base=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=mod(normal.x,2.0);gl_Position=u_matrix*vec4(a_pos,t > 0.0 ? height : base,1);float colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;v_color=vec4(0.0,0.0,0.0,1.0);vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;float directional=clamp(dot(normal/16384.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_color.r+=clamp(color.r*directional*u_lightcolor.r,mix(0.0,0.3,1.0-u_lightcolor.r),1.0);v_color.g+=clamp(color.g*directional*u_lightcolor.g,mix(0.0,0.3,1.0-u_lightcolor.g),1.0);v_color.b+=clamp(color.b*directional*u_lightcolor.b,mix(0.0,0.3,1.0-u_lightcolor.b),1.0);v_color*=u_opacity;}`), fillExtrusionPattern: jt(`uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;
#pragma mapbox: define lowp float base
#pragma mapbox: define lowp float height
#pragma mapbox: define lowp vec4 pattern_from
#pragma mapbox: define lowp vec4 pattern_to
#pragma mapbox: define lowp float pixel_ratio_from
#pragma mapbox: define lowp float pixel_ratio_to
void main() {
#pragma mapbox: initialize lowp float base
#pragma mapbox: initialize lowp float height
#pragma mapbox: initialize mediump vec4 pattern_from
#pragma mapbox: initialize mediump vec4 pattern_to
#pragma mapbox: initialize lowp float pixel_ratio_from
#pragma mapbox: initialize lowp float pixel_ratio_to
vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);vec4 mixedColor=mix(color1,color2,u_fade);gl_FragColor=mixedColor*v_lighting;
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, `uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform vec3 u_scale;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;attribute vec2 a_pos;attribute vec4 a_normal_ed;
#ifdef TERRAIN3D
attribute vec2 a_centroid;
#endif
varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;
#pragma mapbox: define lowp float base
#pragma mapbox: define lowp float height
#pragma mapbox: define lowp vec4 pattern_from
#pragma mapbox: define lowp vec4 pattern_to
#pragma mapbox: define lowp float pixel_ratio_from
#pragma mapbox: define lowp float pixel_ratio_to
void main() {
#pragma mapbox: initialize lowp float base
#pragma mapbox: initialize lowp float height
#pragma mapbox: initialize mediump vec4 pattern_from
#pragma mapbox: initialize mediump vec4 pattern_to
#pragma mapbox: initialize lowp float pixel_ratio_from
#pragma mapbox: initialize lowp float pixel_ratio_to
vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec3 normal=a_normal_ed.xyz;float edgedistance=a_normal_ed.w;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;
#ifdef TERRAIN3D
float height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);
#else
float height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;
#endif
base=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=mod(normal.x,2.0);float z=t > 0.0 ? height : base;gl_Position=u_matrix*vec4(a_pos,z,1);vec2 pos=normal.x==1.0 && normal.y==0.0 && normal.z==16384.0
? a_pos
: vec2(edgedistance,z*u_height_factor);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float directional=clamp(dot(normal/16383.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_lighting.rgb+=clamp(directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;}`), hillshadePrepare: jt(`#ifdef GL_ES
precision highp float;
#endif
uniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform vec4 u_unpack;float getElevation(vec2 coord,float bias) {vec4 data=texture2D(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack)/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y),0.0);float b=getElevation(v_pos+vec2(0,-epsilon.y),0.0);float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y),0.0);float d=getElevation(v_pos+vec2(-epsilon.x,0),0.0);float e=getElevation(v_pos,0.0);float f=getElevation(v_pos+vec2(epsilon.x,0),0.0);float g=getElevation(v_pos+vec2(-epsilon.x,epsilon.y),0.0);float h=getElevation(v_pos+vec2(0,epsilon.y),0.0);float i=getElevation(v_pos+vec2(epsilon.x,epsilon.y),0.0);float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2((c+f+f+i)-(a+d+d+g),(g+h+h+i)-(a+b+b+c))/pow(2.0,exaggeration+(19.2562-u_zoom));gl_FragColor=clamp(vec4(deriv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, "uniform mat4 u_matrix;uniform vec2 u_dimension;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"), hillshade: jt(`uniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;
#define PI 3.141592653589793
void main() {vec4 pixel=texture2D(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);gl_FragColor=accent_color*(1.0-shade_color.a)+shade_color;
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, "uniform mat4 u_matrix;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;}"), line: jt(`uniform lowp float u_device_pixel_ratio;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;
#pragma mapbox: define highp vec4 color
#pragma mapbox: define lowp float blur
#pragma mapbox: define lowp float opacity
void main() {
#pragma mapbox: initialize highp vec4 color
#pragma mapbox: initialize lowp float blur
#pragma mapbox: initialize lowp float opacity
float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);gl_FragColor=color*(alpha*opacity);
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, `
#define scale 0.015873016
attribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp float v_linesofar;
#pragma mapbox: define highp vec4 color
#pragma mapbox: define lowp float blur
#pragma mapbox: define lowp float opacity
#pragma mapbox: define mediump float gapwidth
#pragma mapbox: define lowp float offset
#pragma mapbox: define mediump float width
void main() {
#pragma mapbox: initialize highp vec4 color
#pragma mapbox: initialize lowp float blur
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize mediump float gapwidth
#pragma mapbox: initialize lowp float offset
#pragma mapbox: initialize mediump float width
float ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;
#ifdef TERRAIN3D
v_gamma_scale=1.0;
#else
float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;
#endif
v_width2=vec2(outset,inset);}`), lineGradient: jt(`uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;varying highp vec2 v_uv;
#pragma mapbox: define lowp float blur
#pragma mapbox: define lowp float opacity
void main() {
#pragma mapbox: initialize lowp float blur
#pragma mapbox: initialize lowp float opacity
float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture2D(u_image,v_uv);gl_FragColor=color*(alpha*opacity);
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, `
#define scale 0.015873016
attribute vec2 a_pos_normal;attribute vec4 a_data;attribute float a_uv_x;attribute float a_split_index;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;uniform float u_image_height;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp vec2 v_uv;
#pragma mapbox: define lowp float blur
#pragma mapbox: define lowp float opacity
#pragma mapbox: define mediump float gapwidth
#pragma mapbox: define lowp float offset
#pragma mapbox: define mediump float width
void main() {
#pragma mapbox: initialize lowp float blur
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize mediump float gapwidth
#pragma mapbox: initialize lowp float offset
#pragma mapbox: initialize mediump float width
float ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;highp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec2(a_uv_x,a_split_index*texel_height-half_texel_height);vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;
#ifdef TERRAIN3D
v_gamma_scale=1.0;
#else
float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;
#endif
v_width2=vec2(outset,inset);}`), linePattern: jt(`#ifdef GL_ES
precision highp float;
#endif
uniform lowp float u_device_pixel_ratio;uniform vec2 u_texsize;uniform float u_fade;uniform mediump vec3 u_scale;uniform sampler2D u_image;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;
#pragma mapbox: define lowp vec4 pattern_from
#pragma mapbox: define lowp vec4 pattern_to
#pragma mapbox: define lowp float pixel_ratio_from
#pragma mapbox: define lowp float pixel_ratio_to
#pragma mapbox: define lowp float blur
#pragma mapbox: define lowp float opacity
void main() {
#pragma mapbox: initialize mediump vec4 pattern_from
#pragma mapbox: initialize mediump vec4 pattern_to
#pragma mapbox: initialize lowp float pixel_ratio_from
#pragma mapbox: initialize lowp float pixel_ratio_to
#pragma mapbox: initialize lowp float blur
#pragma mapbox: initialize lowp float opacity
vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;vec2 pattern_size_a=vec2(display_size_a.x*fromScale/tileZoomRatio,display_size_a.y);vec2 pattern_size_b=vec2(display_size_b.x*toScale/tileZoomRatio,display_size_b.y);float aspect_a=display_size_a.y/v_width;float aspect_b=display_size_b.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x_a=mod(v_linesofar/pattern_size_a.x*aspect_a,1.0);float x_b=mod(v_linesofar/pattern_size_b.x*aspect_b,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos_a=mix(pattern_tl_a*texel_size-texel_size,pattern_br_a*texel_size+texel_size,vec2(x_a,y));vec2 pos_b=mix(pattern_tl_b*texel_size-texel_size,pattern_br_b*texel_size+texel_size,vec2(x_b,y));vec4 color=mix(texture2D(u_image,pos_a),texture2D(u_image,pos_b),u_fade);gl_FragColor=color*alpha*opacity;
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, `
#define scale 0.015873016
#define LINE_DISTANCE_SCALE 2.0
attribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform vec2 u_units_to_pixels;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;
#pragma mapbox: define lowp float blur
#pragma mapbox: define lowp float opacity
#pragma mapbox: define lowp float offset
#pragma mapbox: define mediump float gapwidth
#pragma mapbox: define mediump float width
#pragma mapbox: define lowp float floorwidth
#pragma mapbox: define lowp vec4 pattern_from
#pragma mapbox: define lowp vec4 pattern_to
#pragma mapbox: define lowp float pixel_ratio_from
#pragma mapbox: define lowp float pixel_ratio_to
void main() {
#pragma mapbox: initialize lowp float blur
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize lowp float offset
#pragma mapbox: initialize mediump float gapwidth
#pragma mapbox: initialize mediump float width
#pragma mapbox: initialize lowp float floorwidth
#pragma mapbox: initialize mediump vec4 pattern_from
#pragma mapbox: initialize mediump vec4 pattern_to
#pragma mapbox: initialize lowp float pixel_ratio_from
#pragma mapbox: initialize lowp float pixel_ratio_to
float ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;
#ifdef TERRAIN3D
v_gamma_scale=1.0;
#else
float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;
#endif
v_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;}`), lineSDF: jt(`uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;uniform float u_sdfgamma;uniform float u_mix;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;
#pragma mapbox: define highp vec4 color
#pragma mapbox: define lowp float blur
#pragma mapbox: define lowp float opacity
#pragma mapbox: define mediump float width
#pragma mapbox: define lowp float floorwidth
void main() {
#pragma mapbox: initialize highp vec4 color
#pragma mapbox: initialize lowp float blur
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize mediump float width
#pragma mapbox: initialize lowp float floorwidth
float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float sdfdist_a=texture2D(u_image,v_tex_a).a;float sdfdist_b=texture2D(u_image,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);alpha*=smoothstep(0.5-u_sdfgamma/floorwidth,0.5+u_sdfgamma/floorwidth,sdfdist);gl_FragColor=color*(alpha*opacity);
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, `
#define scale 0.015873016
#define LINE_DISTANCE_SCALE 2.0
attribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_patternscale_a;uniform float u_tex_y_a;uniform vec2 u_patternscale_b;uniform float u_tex_y_b;uniform vec2 u_units_to_pixels;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;
#pragma mapbox: define highp vec4 color
#pragma mapbox: define lowp float blur
#pragma mapbox: define lowp float opacity
#pragma mapbox: define mediump float gapwidth
#pragma mapbox: define lowp float offset
#pragma mapbox: define mediump float width
#pragma mapbox: define lowp float floorwidth
void main() {
#pragma mapbox: initialize highp vec4 color
#pragma mapbox: initialize lowp float blur
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize mediump float gapwidth
#pragma mapbox: initialize lowp float offset
#pragma mapbox: initialize mediump float width
#pragma mapbox: initialize lowp float floorwidth
float ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;
#ifdef TERRAIN3D
v_gamma_scale=1.0;
#else
float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;
#endif
v_tex_a=vec2(a_linesofar*u_patternscale_a.x/floorwidth,normal.y*u_patternscale_a.y+u_tex_y_a);v_tex_b=vec2(a_linesofar*u_patternscale_b.x/floorwidth,normal.y*u_patternscale_b.y+u_tex_y_b);v_width2=vec2(outset,inset);}`), raster: jt(`uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;varying vec2 v_pos0;varying vec2 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture2D(u_image0,v_pos0);vec4 color1=texture2D(u_image1,v_pos1);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(dot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);gl_FragColor=vec4(mix(u_high_vec,u_low_vec,rgb)*color.a,color.a);
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, "uniform mat4 u_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_buffer_scale;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos0;varying vec2 v_pos1;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos0=(((a_texture_pos/8192.0)-0.5)/u_buffer_scale )+0.5;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}"), symbolIcon: jt(`uniform sampler2D u_texture;varying vec2 v_tex;varying float v_fade_opacity;
#pragma mapbox: define lowp float opacity
void main() {
#pragma mapbox: initialize lowp float opacity
lowp float alpha=opacity*v_fade_opacity;gl_FragColor=texture2D(u_texture,v_tex)*alpha;
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, `const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;varying vec2 v_tex;varying float v_fade_opacity;
#pragma mapbox: define lowp float opacity
void main() {
#pragma mapbox: initialize lowp float opacity
vec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_minFontScale=a_pixeloffset.zw/256.0;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,ele,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?
camera_to_anchor_distance/u_camera_to_center_distance :
u_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),ele,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,ele,1.0);float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*max(a_minFontScale,fontScale)+a_pxoffset/16.0),z,1.0);v_tex=a_tex/u_texsize;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float visibility=calculate_visibility(projectedPoint);v_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));}`), symbolSDF: jt(`#define SDF_PX 8.0
uniform bool u_is_halo;uniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;varying vec2 v_data0;varying vec3 v_data1;
#pragma mapbox: define highp vec4 fill_color
#pragma mapbox: define highp vec4 halo_color
#pragma mapbox: define lowp float opacity
#pragma mapbox: define lowp float halo_width
#pragma mapbox: define lowp float halo_blur
void main() {
#pragma mapbox: initialize highp vec4 fill_color
#pragma mapbox: initialize highp vec4 halo_color
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize lowp float halo_width
#pragma mapbox: initialize lowp float halo_blur
float EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, `const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;varying vec2 v_data0;varying vec3 v_data1;
#pragma mapbox: define highp vec4 fill_color
#pragma mapbox: define highp vec4 halo_color
#pragma mapbox: define lowp float opacity
#pragma mapbox: define lowp float halo_width
#pragma mapbox: define lowp float halo_blur
void main() {
#pragma mapbox: initialize highp vec4 fill_color
#pragma mapbox: initialize highp vec4 halo_color
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize lowp float halo_width
#pragma mapbox: initialize lowp float halo_blur
vec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,ele,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?
camera_to_anchor_distance/u_camera_to_center_distance :
u_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),ele,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,ele,1.0);float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale+a_pxoffset),z,1.0);float gamma_scale=gl_Position.w;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,interpolated_fade_opacity);}`), symbolTextAndIcon: jt(`#define SDF_PX 8.0
#define SDF 1.0
#define ICON 0.0
uniform bool u_is_halo;uniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;varying vec4 v_data0;varying vec4 v_data1;
#pragma mapbox: define highp vec4 fill_color
#pragma mapbox: define highp vec4 halo_color
#pragma mapbox: define lowp float opacity
#pragma mapbox: define lowp float halo_width
#pragma mapbox: define lowp float halo_blur
void main() {
#pragma mapbox: initialize highp vec4 fill_color
#pragma mapbox: initialize highp vec4 halo_color
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize lowp float halo_width
#pragma mapbox: initialize lowp float halo_blur
float fade_opacity=v_data1[2];if (v_data1.w==ICON) {vec2 tex_icon=v_data0.zw;lowp float alpha=opacity*fade_opacity;gl_FragColor=texture2D(u_texture_icon,tex_icon)*alpha;
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
return;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, `const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_texsize_icon;varying vec4 v_data0;varying vec4 v_data1;
#pragma mapbox: define highp vec4 fill_color
#pragma mapbox: define highp vec4 halo_color
#pragma mapbox: define lowp float opacity
#pragma mapbox: define lowp float halo_width
#pragma mapbox: define lowp float halo_blur
void main() {
#pragma mapbox: initialize highp vec4 fill_color
#pragma mapbox: initialize highp vec4 halo_color
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize lowp float halo_width
#pragma mapbox: initialize lowp float halo_blur
vec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);float is_sdf=a_size[0]-2.0*a_size_min;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,ele,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?
camera_to_anchor_distance/u_camera_to_center_distance :
u_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),ele,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,ele,1.0);float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale),z,1.0);float gamma_scale=gl_Position.w;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));v_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec4(gamma_scale,size,interpolated_fade_opacity,is_sdf);}`), terrain: jt("uniform sampler2D u_texture;varying vec2 v_texture_pos;void main() {gl_FragColor=texture2D(u_texture,v_texture_pos);}", ms), terrainDepth: jt("varying float v_depth;const highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitMsk=vec4(0.,vec3(1./256.0));highp vec4 pack(highp float value) {highp vec4 comp=fract(value*bitSh);comp-=comp.xxyz*bitMsk;return comp;}void main() {gl_FragColor=pack(v_depth);}", ms), terrainCoords: jt("precision mediump float;uniform sampler2D u_texture;uniform float u_terrain_coords_id;varying vec2 v_texture_pos;void main() {vec4 rgba=texture2D(u_texture,v_texture_pos);gl_FragColor=vec4(rgba.r,rgba.g,rgba.b,u_terrain_coords_id);}", ms) };
      function jt(_, o) {
        const h = /#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g, v = o.match(/attribute ([\w]+) ([\w]+)/g), w = _.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), S = o.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), M = S ? S.concat(w) : w, z = {};
        return { fragmentSource: _ = _.replace(h, (R, W, Q, J, fe) => (z[fe] = !0, W === "define" ? `
#ifndef HAS_UNIFORM_u_${fe}
varying ${Q} ${J} ${fe};
#else
uniform ${Q} ${J} u_${fe};
#endif
` : `
#ifdef HAS_UNIFORM_u_${fe}
    ${Q} ${J} ${fe} = u_${fe};
#endif
`)), vertexSource: o = o.replace(h, (R, W, Q, J, fe) => {
          const Se = J === "float" ? "vec2" : "vec4", we = fe.match(/color/) ? "color" : Se;
          return z[fe] ? W === "define" ? `
#ifndef HAS_UNIFORM_u_${fe}
uniform lowp float u_${fe}_t;
attribute ${Q} ${Se} a_${fe};
varying ${Q} ${J} ${fe};
#else
uniform ${Q} ${J} u_${fe};
#endif
` : we === "vec4" ? `
#ifndef HAS_UNIFORM_u_${fe}
    ${fe} = a_${fe};
#else
    ${Q} ${J} ${fe} = u_${fe};
#endif
` : `
#ifndef HAS_UNIFORM_u_${fe}
    ${fe} = unpack_mix_${we}(a_${fe}, u_${fe}_t);
#else
    ${Q} ${J} ${fe} = u_${fe};
#endif
` : W === "define" ? `
#ifndef HAS_UNIFORM_u_${fe}
uniform lowp float u_${fe}_t;
attribute ${Q} ${Se} a_${fe};
#else
uniform ${Q} ${J} u_${fe};
#endif
` : we === "vec4" ? `
#ifndef HAS_UNIFORM_u_${fe}
    ${Q} ${J} ${fe} = a_${fe};
#else
    ${Q} ${J} ${fe} = u_${fe};
#endif
` : `
#ifndef HAS_UNIFORM_u_${fe}
    ${Q} ${J} ${fe} = unpack_mix_${we}(a_${fe}, u_${fe}_t);
#else
    ${Q} ${J} ${fe} = u_${fe};
#endif
`;
        }), staticAttributes: v, staticUniforms: M };
      }
      class hi {
        constructor() {
          this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffer = null, this.vao = null;
        }
        bind(o, h, v, w, S, M, z, R, W) {
          this.context = o;
          let Q = this.boundPaintVertexBuffers.length !== w.length;
          for (let J = 0; !Q && J < w.length; J++) this.boundPaintVertexBuffers[J] !== w[J] && (Q = !0);
          !this.vao || this.boundProgram !== h || this.boundLayoutVertexBuffer !== v || Q || this.boundIndexBuffer !== S || this.boundVertexOffset !== M || this.boundDynamicVertexBuffer !== z || this.boundDynamicVertexBuffer2 !== R || this.boundDynamicVertexBuffer3 !== W ? this.freshBind(h, v, w, S, M, z, R, W) : (o.bindVertexArray.set(this.vao), z && z.bind(), S && S.dynamicDraw && S.bind(), R && R.bind(), W && W.bind());
        }
        freshBind(o, h, v, w, S, M, z, R) {
          const W = o.numAttributes, Q = this.context, J = Q.gl;
          this.vao && this.destroy(), this.vao = Q.createVertexArray(), Q.bindVertexArray.set(this.vao), this.boundProgram = o, this.boundLayoutVertexBuffer = h, this.boundPaintVertexBuffers = v, this.boundIndexBuffer = w, this.boundVertexOffset = S, this.boundDynamicVertexBuffer = M, this.boundDynamicVertexBuffer2 = z, this.boundDynamicVertexBuffer3 = R, h.enableAttributes(J, o);
          for (const fe of v) fe.enableAttributes(J, o);
          M && M.enableAttributes(J, o), z && z.enableAttributes(J, o), R && R.enableAttributes(J, o), h.bind(), h.setVertexAttribPointers(J, o, S);
          for (const fe of v) fe.bind(), fe.setVertexAttribPointers(J, o, S);
          M && (M.bind(), M.setVertexAttribPointers(J, o, S)), w && w.bind(), z && (z.bind(), z.setVertexAttribPointers(J, o, S)), R && (R.bind(), R.setVertexAttribPointers(J, o, S)), Q.currentNumAttributes = W;
        }
        destroy() {
          this.vao && (this.context.deleteVertexArray(this.vao), this.vao = null);
        }
      }
      function qr(_) {
        const o = [];
        for (let h = 0; h < _.length; h++) {
          if (_[h] === null) continue;
          const v = _[h].split(" ");
          o.push(v.pop());
        }
        return o;
      }
      class ko {
        constructor(o, h, v, w, S, M, z) {
          const R = o.gl;
          this.program = R.createProgram();
          const W = qr(v.staticAttributes), Q = w ? w.getBinderAttributes() : [], J = W.concat(Q), fe = Ps.prelude.staticUniforms ? qr(Ps.prelude.staticUniforms) : [], Se = v.staticUniforms ? qr(v.staticUniforms) : [], we = w ? w.getBinderUniforms() : [], Ce = fe.concat(Se).concat(we), Me = [];
          for (const Ct of Ce) Me.indexOf(Ct) < 0 && Me.push(Ct);
          const Ue = w ? w.defines() : [];
          M && Ue.push("#define OVERDRAW_INSPECTOR;"), z && Ue.push("#define TERRAIN3D;");
          const ct = Ue.concat(Ps.prelude.fragmentSource, v.fragmentSource).join(`
`), Ee = Ue.concat(Ps.prelude.vertexSource, v.vertexSource).join(`
`), st = R.createShader(R.FRAGMENT_SHADER);
          if (R.isContextLost()) return void (this.failedToCreate = !0);
          R.shaderSource(st, ct), R.compileShader(st), R.attachShader(this.program, st);
          const ht = R.createShader(R.VERTEX_SHADER);
          if (R.isContextLost()) return void (this.failedToCreate = !0);
          R.shaderSource(ht, Ee), R.compileShader(ht), R.attachShader(this.program, ht), this.attributes = {};
          const wt = {};
          this.numAttributes = J.length;
          for (let Ct = 0; Ct < this.numAttributes; Ct++) J[Ct] && (R.bindAttribLocation(this.program, Ct, J[Ct]), this.attributes[J[Ct]] = Ct);
          R.linkProgram(this.program), R.deleteShader(ht), R.deleteShader(st);
          for (let Ct = 0; Ct < Me.length; Ct++) {
            const Dt = Me[Ct];
            if (Dt && !wt[Dt]) {
              const xt = R.getUniformLocation(this.program, Dt);
              xt && (wt[Dt] = xt);
            }
          }
          this.fixedUniforms = S(o, wt), this.terrainUniforms = ((Ct, Dt) => ({ u_depth: new a.Uniform1i(Ct, Dt.u_depth), u_terrain: new a.Uniform1i(Ct, Dt.u_terrain), u_terrain_dim: new a.Uniform1f(Ct, Dt.u_terrain_dim), u_terrain_matrix: new a.UniformMatrix4f(Ct, Dt.u_terrain_matrix), u_terrain_unpack: new a.Uniform4f(Ct, Dt.u_terrain_unpack), u_terrain_exaggeration: new a.Uniform1f(Ct, Dt.u_terrain_exaggeration) }))(o, wt), this.binderUniforms = w ? w.getUniforms(o, wt) : [];
        }
        draw(o, h, v, w, S, M, z, R, W, Q, J, fe, Se, we, Ce, Me, Ue, ct) {
          const Ee = o.gl;
          if (this.failedToCreate) return;
          if (o.program.set(this.program), o.setDepthMode(v), o.setStencilMode(w), o.setColorMode(S), o.setCullFace(M), R) {
            o.activeTexture.set(Ee.TEXTURE2), Ee.bindTexture(Ee.TEXTURE_2D, R.depthTexture), o.activeTexture.set(Ee.TEXTURE3), Ee.bindTexture(Ee.TEXTURE_2D, R.texture);
            for (const ht in this.terrainUniforms) this.terrainUniforms[ht].set(R[ht]);
          }
          for (const ht in this.fixedUniforms) this.fixedUniforms[ht].set(z[ht]);
          Ce && Ce.setUniforms(o, this.binderUniforms, Se, { zoom: we });
          let st = 0;
          switch (h) {
            case Ee.LINES:
              st = 2;
              break;
            case Ee.TRIANGLES:
              st = 3;
              break;
            case Ee.LINE_STRIP:
              st = 1;
          }
          for (const ht of fe.get()) {
            const wt = ht.vaos || (ht.vaos = {});
            (wt[W] || (wt[W] = new hi())).bind(o, this, Q, Ce ? Ce.getPaintVertexBuffers() : [], J, ht.vertexOffset, Me, Ue, ct), Ee.drawElements(h, ht.primitiveLength * st, Ee.UNSIGNED_SHORT, ht.primitiveOffset * st * 2);
          }
        }
      }
      function Mt(_, o, h) {
        const v = 1 / ze(h, 1, o.transform.tileZoom), w = Math.pow(2, h.tileID.overscaledZ), S = h.tileSize * Math.pow(2, o.transform.tileZoom) / w, M = S * (h.tileID.canonical.x + h.tileID.wrap * w), z = S * h.tileID.canonical.y;
        return { u_image: 0, u_texsize: h.imageAtlasTexture.size, u_scale: [v, _.fromScale, _.toScale], u_fade: _.t, u_pixel_coord_upper: [M >> 16, z >> 16], u_pixel_coord_lower: [65535 & M, 65535 & z] };
      }
      const Fn = (_, o, h, v) => {
        const w = o.style.light, S = w.properties.get("position"), M = [S.x, S.y, S.z], z = function() {
          var W = new a.ARRAY_TYPE(9);
          return a.ARRAY_TYPE != Float32Array && (W[1] = 0, W[2] = 0, W[3] = 0, W[5] = 0, W[6] = 0, W[7] = 0), W[0] = 1, W[4] = 1, W[8] = 1, W;
        }();
        w.properties.get("anchor") === "viewport" && function(W, Q) {
          var J = Math.sin(Q), fe = Math.cos(Q);
          W[0] = fe, W[1] = J, W[2] = 0, W[3] = -J, W[4] = fe, W[5] = 0, W[6] = 0, W[7] = 0, W[8] = 1;
        }(z, -o.transform.angle), function(W, Q, J) {
          var fe = Q[0], Se = Q[1], we = Q[2];
          W[0] = fe * J[0] + Se * J[3] + we * J[6], W[1] = fe * J[1] + Se * J[4] + we * J[7], W[2] = fe * J[2] + Se * J[5] + we * J[8];
        }(M, M, z);
        const R = w.properties.get("color");
        return { u_matrix: _, u_lightpos: M, u_lightintensity: w.properties.get("intensity"), u_lightcolor: [R.r, R.g, R.b], u_vertical_gradient: +h, u_opacity: v };
      }, In = (_, o, h, v, w, S, M) => a.extend(Fn(_, o, h, v), Mt(S, o, M), { u_height_factor: -Math.pow(2, w.overscaledZ) / M.tileSize / 8 }), ti = (_) => ({ u_matrix: _ }), Xn = (_, o, h, v) => a.extend(ti(_), Mt(h, o, v)), ya = (_, o) => ({ u_matrix: _, u_world: o }), ll = (_, o, h, v, w) => a.extend(Xn(_, o, h, v), { u_world: w }), Gl = (_, o, h, v) => {
        const w = _.transform;
        let S, M;
        if (v.paint.get("circle-pitch-alignment") === "map") {
          const z = ze(h, 1, w.zoom);
          S = !0, M = [z, z];
        } else S = !1, M = w.pixelsToGLUnits;
        return { u_camera_to_center_distance: w.cameraToCenterDistance, u_scale_with_map: +(v.paint.get("circle-pitch-scale") === "map"), u_matrix: _.translatePosMatrix(o.posMatrix, h, v.paint.get("circle-translate"), v.paint.get("circle-translate-anchor")), u_pitch_with_map: +S, u_device_pixel_ratio: _.pixelRatio, u_extrude_scale: M };
      }, Yl = (_, o, h) => {
        const v = ze(h, 1, o.zoom), w = Math.pow(2, o.zoom - h.tileID.overscaledZ), S = h.tileID.overscaleFactor();
        return { u_matrix: _, u_camera_to_center_distance: o.cameraToCenterDistance, u_pixels_to_tile_units: v, u_extrude_scale: [o.pixelsToGLUnits[0] / (v * w), o.pixelsToGLUnits[1] / (v * w)], u_overscale_factor: S };
      }, _a = (_, o, h = 1) => ({ u_matrix: _, u_color: o, u_overlay: 0, u_overlay_scale: h }), Kl = (_) => ({ u_matrix: _ }), Wc = (_, o, h, v) => ({ u_matrix: _, u_extrude_scale: ze(o, 1, h), u_intensity: v });
      function Xl(_, o) {
        const h = Math.pow(2, o.canonical.z), v = o.canonical.y;
        return [new a.MercatorCoordinate(0, v / h).toLngLat().lat, new a.MercatorCoordinate(0, (v + 1) / h).toLngLat().lat];
      }
      const Ws = (_, o, h, v) => {
        const w = _.transform;
        return { u_matrix: ul(_, o, h, v), u_ratio: 1 / ze(o, 1, w.zoom), u_device_pixel_ratio: _.pixelRatio, u_units_to_pixels: [1 / w.pixelsToGLUnits[0], 1 / w.pixelsToGLUnits[1]] };
      }, cl = (_, o, h, v, w) => a.extend(Ws(_, o, h, w), { u_image: 0, u_image_height: v }), jr = (_, o, h, v, w) => {
        const S = _.transform, M = ba(o, S);
        return { u_matrix: ul(_, o, h, w), u_texsize: o.imageAtlasTexture.size, u_ratio: 1 / ze(o, 1, S.zoom), u_device_pixel_ratio: _.pixelRatio, u_image: 0, u_scale: [M, v.fromScale, v.toScale], u_fade: v.t, u_units_to_pixels: [1 / S.pixelsToGLUnits[0], 1 / S.pixelsToGLUnits[1]] };
      }, Jl = (_, o, h, v, w, S) => {
        const M = _.lineAtlas, z = ba(o, _.transform), R = h.layout.get("line-cap") === "round", W = M.getDash(v.from, R), Q = M.getDash(v.to, R), J = W.width * w.fromScale, fe = Q.width * w.toScale;
        return a.extend(Ws(_, o, h, S), { u_patternscale_a: [z / J, -W.height / 2], u_patternscale_b: [z / fe, -Q.height / 2], u_sdfgamma: M.width / (256 * Math.min(J, fe) * _.pixelRatio) / 2, u_image: 0, u_tex_y_a: W.y, u_tex_y_b: Q.y, u_mix: w.t });
      };
      function ba(_, o) {
        return 1 / ze(_, 1, o.tileZoom);
      }
      function ul(_, o, h, v) {
        return _.translatePosMatrix(v ? v.posMatrix : o.tileID.posMatrix, o, h.paint.get("line-translate"), h.paint.get("line-translate-anchor"));
      }
      const Mn = (_, o, h, v, w) => {
        return { u_matrix: _, u_tl_parent: o, u_scale_parent: h, u_buffer_scale: 1, u_fade_t: v.mix, u_opacity: v.opacity * w.paint.get("raster-opacity"), u_image0: 0, u_image1: 1, u_brightness_low: w.paint.get("raster-brightness-min"), u_brightness_high: w.paint.get("raster-brightness-max"), u_saturation_factor: (M = w.paint.get("raster-saturation"), M > 0 ? 1 - 1 / (1.001 - M) : -M), u_contrast_factor: (S = w.paint.get("raster-contrast"), S > 0 ? 1 / (1 - S) : 1 + S), u_spin_weights: vs(w.paint.get("raster-hue-rotate")) };
        var S, M;
      };
      function vs(_) {
        _ *= Math.PI / 180;
        const o = Math.sin(_), h = Math.cos(_);
        return [(2 * h + 1) / 3, (-Math.sqrt(3) * o - h + 1) / 3, (Math.sqrt(3) * o - h + 1) / 3];
      }
      const li = (_, o, h, v, w, S, M, z, R, W) => {
        const Q = w.transform;
        return { u_is_size_zoom_constant: +(_ === "constant" || _ === "source"), u_is_size_feature_constant: +(_ === "constant" || _ === "camera"), u_size_t: o ? o.uSizeT : 0, u_size: o ? o.uSize : 0, u_camera_to_center_distance: Q.cameraToCenterDistance, u_pitch: Q.pitch / 360 * 2 * Math.PI, u_rotate_symbol: +h, u_aspect_ratio: Q.width / Q.height, u_fade_change: w.options.fadeDuration ? w.symbolFadeChange : 1, u_matrix: S, u_label_plane_matrix: M, u_coord_matrix: z, u_is_text: +R, u_pitch_with_map: +v, u_texsize: W, u_texture: 0 };
      }, wa = (_, o, h, v, w, S, M, z, R, W, Q) => {
        const J = w.transform;
        return a.extend(li(_, o, h, v, w, S, M, z, R, W), { u_gamma_scale: v ? Math.cos(J._pitch) * J.cameraToCenterDistance : 1, u_device_pixel_ratio: w.pixelRatio, u_is_halo: 1 });
      }, dl = (_, o, h, v, w, S, M, z, R, W) => a.extend(wa(_, o, h, v, w, S, M, z, !0, R), { u_texsize_icon: W, u_texture_icon: 1 }), Gr = (_, o, h) => ({ u_matrix: _, u_opacity: o, u_color: h }), Yr = (_, o, h, v, w, S) => a.extend(function(M, z, R, W) {
        const Q = R.imageManager.getPattern(M.from.toString()), J = R.imageManager.getPattern(M.to.toString()), { width: fe, height: Se } = R.imageManager.getPixelSize(), we = Math.pow(2, W.tileID.overscaledZ), Ce = W.tileSize * Math.pow(2, R.transform.tileZoom) / we, Me = Ce * (W.tileID.canonical.x + W.tileID.wrap * we), Ue = Ce * W.tileID.canonical.y;
        return { u_image: 0, u_pattern_tl_a: Q.tl, u_pattern_br_a: Q.br, u_pattern_tl_b: J.tl, u_pattern_br_b: J.br, u_texsize: [fe, Se], u_mix: z.t, u_pattern_size_a: Q.displaySize, u_pattern_size_b: J.displaySize, u_scale_a: z.fromScale, u_scale_b: z.toScale, u_tile_units_to_pixels: 1 / ze(W, 1, R.transform.tileZoom), u_pixel_coord_upper: [Me >> 16, Ue >> 16], u_pixel_coord_lower: [65535 & Me, 65535 & Ue] };
      }(v, S, h, w), { u_matrix: _, u_opacity: o }), So = { fillExtrusion: (_, o) => ({ u_matrix: new a.UniformMatrix4f(_, o.u_matrix), u_lightpos: new a.Uniform3f(_, o.u_lightpos), u_lightintensity: new a.Uniform1f(_, o.u_lightintensity), u_lightcolor: new a.Uniform3f(_, o.u_lightcolor), u_vertical_gradient: new a.Uniform1f(_, o.u_vertical_gradient), u_opacity: new a.Uniform1f(_, o.u_opacity) }), fillExtrusionPattern: (_, o) => ({ u_matrix: new a.UniformMatrix4f(_, o.u_matrix), u_lightpos: new a.Uniform3f(_, o.u_lightpos), u_lightintensity: new a.Uniform1f(_, o.u_lightintensity), u_lightcolor: new a.Uniform3f(_, o.u_lightcolor), u_vertical_gradient: new a.Uniform1f(_, o.u_vertical_gradient), u_height_factor: new a.Uniform1f(_, o.u_height_factor), u_image: new a.Uniform1i(_, o.u_image), u_texsize: new a.Uniform2f(_, o.u_texsize), u_pixel_coord_upper: new a.Uniform2f(_, o.u_pixel_coord_upper), u_pixel_coord_lower: new a.Uniform2f(_, o.u_pixel_coord_lower), u_scale: new a.Uniform3f(_, o.u_scale), u_fade: new a.Uniform1f(_, o.u_fade), u_opacity: new a.Uniform1f(_, o.u_opacity) }), fill: (_, o) => ({ u_matrix: new a.UniformMatrix4f(_, o.u_matrix) }), fillPattern: (_, o) => ({ u_matrix: new a.UniformMatrix4f(_, o.u_matrix), u_image: new a.Uniform1i(_, o.u_image), u_texsize: new a.Uniform2f(_, o.u_texsize), u_pixel_coord_upper: new a.Uniform2f(_, o.u_pixel_coord_upper), u_pixel_coord_lower: new a.Uniform2f(_, o.u_pixel_coord_lower), u_scale: new a.Uniform3f(_, o.u_scale), u_fade: new a.Uniform1f(_, o.u_fade) }), fillOutline: (_, o) => ({ u_matrix: new a.UniformMatrix4f(_, o.u_matrix), u_world: new a.Uniform2f(_, o.u_world) }), fillOutlinePattern: (_, o) => ({ u_matrix: new a.UniformMatrix4f(_, o.u_matrix), u_world: new a.Uniform2f(_, o.u_world), u_image: new a.Uniform1i(_, o.u_image), u_texsize: new a.Uniform2f(_, o.u_texsize), u_pixel_coord_upper: new a.Uniform2f(_, o.u_pixel_coord_upper), u_pixel_coord_lower: new a.Uniform2f(_, o.u_pixel_coord_lower), u_scale: new a.Uniform3f(_, o.u_scale), u_fade: new a.Uniform1f(_, o.u_fade) }), circle: (_, o) => ({ u_camera_to_center_distance: new a.Uniform1f(_, o.u_camera_to_center_distance), u_scale_with_map: new a.Uniform1i(_, o.u_scale_with_map), u_pitch_with_map: new a.Uniform1i(_, o.u_pitch_with_map), u_extrude_scale: new a.Uniform2f(_, o.u_extrude_scale), u_device_pixel_ratio: new a.Uniform1f(_, o.u_device_pixel_ratio), u_matrix: new a.UniformMatrix4f(_, o.u_matrix) }), collisionBox: (_, o) => ({ u_matrix: new a.UniformMatrix4f(_, o.u_matrix), u_camera_to_center_distance: new a.Uniform1f(_, o.u_camera_to_center_distance), u_pixels_to_tile_units: new a.Uniform1f(_, o.u_pixels_to_tile_units), u_extrude_scale: new a.Uniform2f(_, o.u_extrude_scale), u_overscale_factor: new a.Uniform1f(_, o.u_overscale_factor) }), collisionCircle: (_, o) => ({ u_matrix: new a.UniformMatrix4f(_, o.u_matrix), u_inv_matrix: new a.UniformMatrix4f(_, o.u_inv_matrix), u_camera_to_center_distance: new a.Uniform1f(_, o.u_camera_to_center_distance), u_viewport_size: new a.Uniform2f(_, o.u_viewport_size) }), debug: (_, o) => ({ u_color: new a.UniformColor(_, o.u_color), u_matrix: new a.UniformMatrix4f(_, o.u_matrix), u_overlay: new a.Uniform1i(_, o.u_overlay), u_overlay_scale: new a.Uniform1f(_, o.u_overlay_scale) }), clippingMask: (_, o) => ({ u_matrix: new a.UniformMatrix4f(_, o.u_matrix) }), heatmap: (_, o) => ({ u_extrude_scale: new a.Uniform1f(_, o.u_extrude_scale), u_intensity: new a.Uniform1f(_, o.u_intensity), u_matrix: new a.UniformMatrix4f(_, o.u_matrix) }), heatmapTexture: (_, o) => ({ u_matrix: new a.UniformMatrix4f(_, o.u_matrix), u_world: new a.Uniform2f(_, o.u_world), u_image: new a.Uniform1i(_, o.u_image), u_color_ramp: new a.Uniform1i(_, o.u_color_ramp), u_opacity: new a.Uniform1f(_, o.u_opacity) }), hillshade: (_, o) => ({ u_matrix: new a.UniformMatrix4f(_, o.u_matrix), u_image: new a.Uniform1i(_, o.u_image), u_latrange: new a.Uniform2f(_, o.u_latrange), u_light: new a.Uniform2f(_, o.u_light), u_shadow: new a.UniformColor(_, o.u_shadow), u_highlight: new a.UniformColor(_, o.u_highlight), u_accent: new a.UniformColor(_, o.u_accent) }), hillshadePrepare: (_, o) => ({ u_matrix: new a.UniformMatrix4f(_, o.u_matrix), u_image: new a.Uniform1i(_, o.u_image), u_dimension: new a.Uniform2f(_, o.u_dimension), u_zoom: new a.Uniform1f(_, o.u_zoom), u_unpack: new a.Uniform4f(_, o.u_unpack) }), line: (_, o) => ({ u_matrix: new a.UniformMatrix4f(_, o.u_matrix), u_ratio: new a.Uniform1f(_, o.u_ratio), u_device_pixel_ratio: new a.Uniform1f(_, o.u_device_pixel_ratio), u_units_to_pixels: new a.Uniform2f(_, o.u_units_to_pixels) }), lineGradient: (_, o) => ({ u_matrix: new a.UniformMatrix4f(_, o.u_matrix), u_ratio: new a.Uniform1f(_, o.u_ratio), u_device_pixel_ratio: new a.Uniform1f(_, o.u_device_pixel_ratio), u_units_to_pixels: new a.Uniform2f(_, o.u_units_to_pixels), u_image: new a.Uniform1i(_, o.u_image), u_image_height: new a.Uniform1f(_, o.u_image_height) }), linePattern: (_, o) => ({ u_matrix: new a.UniformMatrix4f(_, o.u_matrix), u_texsize: new a.Uniform2f(_, o.u_texsize), u_ratio: new a.Uniform1f(_, o.u_ratio), u_device_pixel_ratio: new a.Uniform1f(_, o.u_device_pixel_ratio), u_image: new a.Uniform1i(_, o.u_image), u_units_to_pixels: new a.Uniform2f(_, o.u_units_to_pixels), u_scale: new a.Uniform3f(_, o.u_scale), u_fade: new a.Uniform1f(_, o.u_fade) }), lineSDF: (_, o) => ({ u_matrix: new a.UniformMatrix4f(_, o.u_matrix), u_ratio: new a.Uniform1f(_, o.u_ratio), u_device_pixel_ratio: new a.Uniform1f(_, o.u_device_pixel_ratio), u_units_to_pixels: new a.Uniform2f(_, o.u_units_to_pixels), u_patternscale_a: new a.Uniform2f(_, o.u_patternscale_a), u_patternscale_b: new a.Uniform2f(_, o.u_patternscale_b), u_sdfgamma: new a.Uniform1f(_, o.u_sdfgamma), u_image: new a.Uniform1i(_, o.u_image), u_tex_y_a: new a.Uniform1f(_, o.u_tex_y_a), u_tex_y_b: new a.Uniform1f(_, o.u_tex_y_b), u_mix: new a.Uniform1f(_, o.u_mix) }), raster: (_, o) => ({ u_matrix: new a.UniformMatrix4f(_, o.u_matrix), u_tl_parent: new a.Uniform2f(_, o.u_tl_parent), u_scale_parent: new a.Uniform1f(_, o.u_scale_parent), u_buffer_scale: new a.Uniform1f(_, o.u_buffer_scale), u_fade_t: new a.Uniform1f(_, o.u_fade_t), u_opacity: new a.Uniform1f(_, o.u_opacity), u_image0: new a.Uniform1i(_, o.u_image0), u_image1: new a.Uniform1i(_, o.u_image1), u_brightness_low: new a.Uniform1f(_, o.u_brightness_low), u_brightness_high: new a.Uniform1f(_, o.u_brightness_high), u_saturation_factor: new a.Uniform1f(_, o.u_saturation_factor), u_contrast_factor: new a.Uniform1f(_, o.u_contrast_factor), u_spin_weights: new a.Uniform3f(_, o.u_spin_weights) }), symbolIcon: (_, o) => ({ u_is_size_zoom_constant: new a.Uniform1i(_, o.u_is_size_zoom_constant), u_is_size_feature_constant: new a.Uniform1i(_, o.u_is_size_feature_constant), u_size_t: new a.Uniform1f(_, o.u_size_t), u_size: new a.Uniform1f(_, o.u_size), u_camera_to_center_distance: new a.Uniform1f(_, o.u_camera_to_center_distance), u_pitch: new a.Uniform1f(_, o.u_pitch), u_rotate_symbol: new a.Uniform1i(_, o.u_rotate_symbol), u_aspect_ratio: new a.Uniform1f(_, o.u_aspect_ratio), u_fade_change: new a.Uniform1f(_, o.u_fade_change), u_matrix: new a.UniformMatrix4f(_, o.u_matrix), u_label_plane_matrix: new a.UniformMatrix4f(_, o.u_label_plane_matrix), u_coord_matrix: new a.UniformMatrix4f(_, o.u_coord_matrix), u_is_text: new a.Uniform1i(_, o.u_is_text), u_pitch_with_map: new a.Uniform1i(_, o.u_pitch_with_map), u_texsize: new a.Uniform2f(_, o.u_texsize), u_texture: new a.Uniform1i(_, o.u_texture) }), symbolSDF: (_, o) => ({ u_is_size_zoom_constant: new a.Uniform1i(_, o.u_is_size_zoom_constant), u_is_size_feature_constant: new a.Uniform1i(_, o.u_is_size_feature_constant), u_size_t: new a.Uniform1f(_, o.u_size_t), u_size: new a.Uniform1f(_, o.u_size), u_camera_to_center_distance: new a.Uniform1f(_, o.u_camera_to_center_distance), u_pitch: new a.Uniform1f(_, o.u_pitch), u_rotate_symbol: new a.Uniform1i(_, o.u_rotate_symbol), u_aspect_ratio: new a.Uniform1f(_, o.u_aspect_ratio), u_fade_change: new a.Uniform1f(_, o.u_fade_change), u_matrix: new a.UniformMatrix4f(_, o.u_matrix), u_label_plane_matrix: new a.UniformMatrix4f(_, o.u_label_plane_matrix), u_coord_matrix: new a.UniformMatrix4f(_, o.u_coord_matrix), u_is_text: new a.Uniform1i(_, o.u_is_text), u_pitch_with_map: new a.Uniform1i(_, o.u_pitch_with_map), u_texsize: new a.Uniform2f(_, o.u_texsize), u_texture: new a.Uniform1i(_, o.u_texture), u_gamma_scale: new a.Uniform1f(_, o.u_gamma_scale), u_device_pixel_ratio: new a.Uniform1f(_, o.u_device_pixel_ratio), u_is_halo: new a.Uniform1i(_, o.u_is_halo) }), symbolTextAndIcon: (_, o) => ({ u_is_size_zoom_constant: new a.Uniform1i(_, o.u_is_size_zoom_constant), u_is_size_feature_constant: new a.Uniform1i(_, o.u_is_size_feature_constant), u_size_t: new a.Uniform1f(_, o.u_size_t), u_size: new a.Uniform1f(_, o.u_size), u_camera_to_center_distance: new a.Uniform1f(_, o.u_camera_to_center_distance), u_pitch: new a.Uniform1f(_, o.u_pitch), u_rotate_symbol: new a.Uniform1i(_, o.u_rotate_symbol), u_aspect_ratio: new a.Uniform1f(_, o.u_aspect_ratio), u_fade_change: new a.Uniform1f(_, o.u_fade_change), u_matrix: new a.UniformMatrix4f(_, o.u_matrix), u_label_plane_matrix: new a.UniformMatrix4f(_, o.u_label_plane_matrix), u_coord_matrix: new a.UniformMatrix4f(_, o.u_coord_matrix), u_is_text: new a.Uniform1i(_, o.u_is_text), u_pitch_with_map: new a.Uniform1i(_, o.u_pitch_with_map), u_texsize: new a.Uniform2f(_, o.u_texsize), u_texsize_icon: new a.Uniform2f(_, o.u_texsize_icon), u_texture: new a.Uniform1i(_, o.u_texture), u_texture_icon: new a.Uniform1i(_, o.u_texture_icon), u_gamma_scale: new a.Uniform1f(_, o.u_gamma_scale), u_device_pixel_ratio: new a.Uniform1f(_, o.u_device_pixel_ratio), u_is_halo: new a.Uniform1i(_, o.u_is_halo) }), background: (_, o) => ({ u_matrix: new a.UniformMatrix4f(_, o.u_matrix), u_opacity: new a.Uniform1f(_, o.u_opacity), u_color: new a.UniformColor(_, o.u_color) }), backgroundPattern: (_, o) => ({ u_matrix: new a.UniformMatrix4f(_, o.u_matrix), u_opacity: new a.Uniform1f(_, o.u_opacity), u_image: new a.Uniform1i(_, o.u_image), u_pattern_tl_a: new a.Uniform2f(_, o.u_pattern_tl_a), u_pattern_br_a: new a.Uniform2f(_, o.u_pattern_br_a), u_pattern_tl_b: new a.Uniform2f(_, o.u_pattern_tl_b), u_pattern_br_b: new a.Uniform2f(_, o.u_pattern_br_b), u_texsize: new a.Uniform2f(_, o.u_texsize), u_mix: new a.Uniform1f(_, o.u_mix), u_pattern_size_a: new a.Uniform2f(_, o.u_pattern_size_a), u_pattern_size_b: new a.Uniform2f(_, o.u_pattern_size_b), u_scale_a: new a.Uniform1f(_, o.u_scale_a), u_scale_b: new a.Uniform1f(_, o.u_scale_b), u_pixel_coord_upper: new a.Uniform2f(_, o.u_pixel_coord_upper), u_pixel_coord_lower: new a.Uniform2f(_, o.u_pixel_coord_lower), u_tile_units_to_pixels: new a.Uniform1f(_, o.u_tile_units_to_pixels) }), terrain: (_, o) => ({ u_matrix: new a.UniformMatrix4f(_, o.u_matrix), u_texture: new a.Uniform1i(_, o.u_texture), u_ele_delta: new a.Uniform1f(_, o.u_ele_delta) }), terrainDepth: (_, o) => ({ u_matrix: new a.UniformMatrix4f(_, o.u_matrix), u_ele_delta: new a.Uniform1f(_, o.u_ele_delta) }), terrainCoords: (_, o) => ({ u_matrix: new a.UniformMatrix4f(_, o.u_matrix), u_texture: new a.Uniform1i(_, o.u_texture), u_terrain_coords_id: new a.Uniform1f(_, o.u_terrain_coords_id), u_ele_delta: new a.Uniform1f(_, o.u_ele_delta) }) };
      class pl {
        constructor(o, h, v) {
          this.context = o;
          const w = o.gl;
          this.buffer = w.createBuffer(), this.dynamicDraw = !!v, this.context.unbindVAO(), o.bindElementBuffer.set(this.buffer), w.bufferData(w.ELEMENT_ARRAY_BUFFER, h.arrayBuffer, this.dynamicDraw ? w.DYNAMIC_DRAW : w.STATIC_DRAW), this.dynamicDraw || delete h.arrayBuffer;
        }
        bind() {
          this.context.bindElementBuffer.set(this.buffer);
        }
        updateData(o) {
          const h = this.context.gl;
          if (!this.dynamicDraw) throw new Error("Attempted to update data while not in dynamic mode.");
          this.context.unbindVAO(), this.bind(), h.bufferSubData(h.ELEMENT_ARRAY_BUFFER, 0, o.arrayBuffer);
        }
        destroy() {
          this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
        }
      }
      const Ho = { Int8: "BYTE", Uint8: "UNSIGNED_BYTE", Int16: "SHORT", Uint16: "UNSIGNED_SHORT", Int32: "INT", Uint32: "UNSIGNED_INT", Float32: "FLOAT" };
      class lr {
        constructor(o, h, v, w) {
          this.length = h.length, this.attributes = v, this.itemSize = h.bytesPerElement, this.dynamicDraw = w, this.context = o;
          const S = o.gl;
          this.buffer = S.createBuffer(), o.bindVertexBuffer.set(this.buffer), S.bufferData(S.ARRAY_BUFFER, h.arrayBuffer, this.dynamicDraw ? S.DYNAMIC_DRAW : S.STATIC_DRAW), this.dynamicDraw || delete h.arrayBuffer;
        }
        bind() {
          this.context.bindVertexBuffer.set(this.buffer);
        }
        updateData(o) {
          if (o.length !== this.length) throw new Error(`Length of new data is ${o.length}, which doesn't match current length of ${this.length}`);
          const h = this.context.gl;
          this.bind(), h.bufferSubData(h.ARRAY_BUFFER, 0, o.arrayBuffer);
        }
        enableAttributes(o, h) {
          for (let v = 0; v < this.attributes.length; v++) {
            const w = h.attributes[this.attributes[v].name];
            w !== void 0 && o.enableVertexAttribArray(w);
          }
        }
        setVertexAttribPointers(o, h, v) {
          for (let w = 0; w < this.attributes.length; w++) {
            const S = this.attributes[w], M = h.attributes[S.name];
            M !== void 0 && o.vertexAttribPointer(M, S.components, o[Ho[S.type]], !1, this.itemSize, S.offset + this.itemSize * (v || 0));
          }
        }
        destroy() {
          this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
        }
      }
      const Zs = /* @__PURE__ */ new WeakMap();
      function Wo(_) {
        if (Zs.has(_)) return Zs.get(_);
        {
          const o = _.getParameter(_.VERSION).startsWith("WebGL 2.0");
          return Zs.set(_, o), o;
        }
      }
      class Yn {
        constructor(o) {
          this.gl = o.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = !1;
        }
        get() {
          return this.current;
        }
        set(o) {
        }
        getDefault() {
          return this.default;
        }
        setDefault() {
          this.set(this.default);
        }
      }
      class Wu extends Yn {
        getDefault() {
          return a.Color.transparent;
        }
        set(o) {
          const h = this.current;
          (o.r !== h.r || o.g !== h.g || o.b !== h.b || o.a !== h.a || this.dirty) && (this.gl.clearColor(o.r, o.g, o.b, o.a), this.current = o, this.dirty = !1);
        }
      }
      class Ql extends Yn {
        getDefault() {
          return 1;
        }
        set(o) {
          (o !== this.current || this.dirty) && (this.gl.clearDepth(o), this.current = o, this.dirty = !1);
        }
      }
      class Zc extends Yn {
        getDefault() {
          return 0;
        }
        set(o) {
          (o !== this.current || this.dirty) && (this.gl.clearStencil(o), this.current = o, this.dirty = !1);
        }
      }
      class Yd extends Yn {
        getDefault() {
          return [!0, !0, !0, !0];
        }
        set(o) {
          const h = this.current;
          (o[0] !== h[0] || o[1] !== h[1] || o[2] !== h[2] || o[3] !== h[3] || this.dirty) && (this.gl.colorMask(o[0], o[1], o[2], o[3]), this.current = o, this.dirty = !1);
        }
      }
      class xa extends Yn {
        getDefault() {
          return !0;
        }
        set(o) {
          (o !== this.current || this.dirty) && (this.gl.depthMask(o), this.current = o, this.dirty = !1);
        }
      }
      class Jn extends Yn {
        getDefault() {
          return 255;
        }
        set(o) {
          (o !== this.current || this.dirty) && (this.gl.stencilMask(o), this.current = o, this.dirty = !1);
        }
      }
      class rf extends Yn {
        getDefault() {
          return { func: this.gl.ALWAYS, ref: 0, mask: 255 };
        }
        set(o) {
          const h = this.current;
          (o.func !== h.func || o.ref !== h.ref || o.mask !== h.mask || this.dirty) && (this.gl.stencilFunc(o.func, o.ref, o.mask), this.current = o, this.dirty = !1);
        }
      }
      class qs extends Yn {
        getDefault() {
          const o = this.gl;
          return [o.KEEP, o.KEEP, o.KEEP];
        }
        set(o) {
          const h = this.current;
          (o[0] !== h[0] || o[1] !== h[1] || o[2] !== h[2] || this.dirty) && (this.gl.stencilOp(o[0], o[1], o[2]), this.current = o, this.dirty = !1);
        }
      }
      class ec extends Yn {
        getDefault() {
          return !1;
        }
        set(o) {
          if (o === this.current && !this.dirty) return;
          const h = this.gl;
          o ? h.enable(h.STENCIL_TEST) : h.disable(h.STENCIL_TEST), this.current = o, this.dirty = !1;
        }
      }
      class Kd extends Yn {
        getDefault() {
          return [0, 1];
        }
        set(o) {
          const h = this.current;
          (o[0] !== h[0] || o[1] !== h[1] || this.dirty) && (this.gl.depthRange(o[0], o[1]), this.current = o, this.dirty = !1);
        }
      }
      class sf extends Yn {
        getDefault() {
          return !1;
        }
        set(o) {
          if (o === this.current && !this.dirty) return;
          const h = this.gl;
          o ? h.enable(h.DEPTH_TEST) : h.disable(h.DEPTH_TEST), this.current = o, this.dirty = !1;
        }
      }
      class tc extends Yn {
        getDefault() {
          return this.gl.LESS;
        }
        set(o) {
          (o !== this.current || this.dirty) && (this.gl.depthFunc(o), this.current = o, this.dirty = !1);
        }
      }
      class qc extends Yn {
        getDefault() {
          return !1;
        }
        set(o) {
          if (o === this.current && !this.dirty) return;
          const h = this.gl;
          o ? h.enable(h.BLEND) : h.disable(h.BLEND), this.current = o, this.dirty = !1;
        }
      }
      class jc extends Yn {
        getDefault() {
          const o = this.gl;
          return [o.ONE, o.ZERO];
        }
        set(o) {
          const h = this.current;
          (o[0] !== h[0] || o[1] !== h[1] || this.dirty) && (this.gl.blendFunc(o[0], o[1]), this.current = o, this.dirty = !1);
        }
      }
      class Zu extends Yn {
        getDefault() {
          return a.Color.transparent;
        }
        set(o) {
          const h = this.current;
          (o.r !== h.r || o.g !== h.g || o.b !== h.b || o.a !== h.a || this.dirty) && (this.gl.blendColor(o.r, o.g, o.b, o.a), this.current = o, this.dirty = !1);
        }
      }
      class hl extends Yn {
        getDefault() {
          return this.gl.FUNC_ADD;
        }
        set(o) {
          (o !== this.current || this.dirty) && (this.gl.blendEquation(o), this.current = o, this.dirty = !1);
        }
      }
      class Gc extends Yn {
        getDefault() {
          return !1;
        }
        set(o) {
          if (o === this.current && !this.dirty) return;
          const h = this.gl;
          o ? h.enable(h.CULL_FACE) : h.disable(h.CULL_FACE), this.current = o, this.dirty = !1;
        }
      }
      class Xd extends Yn {
        getDefault() {
          return this.gl.BACK;
        }
        set(o) {
          (o !== this.current || this.dirty) && (this.gl.cullFace(o), this.current = o, this.dirty = !1);
        }
      }
      class Ms extends Yn {
        getDefault() {
          return this.gl.CCW;
        }
        set(o) {
          (o !== this.current || this.dirty) && (this.gl.frontFace(o), this.current = o, this.dirty = !1);
        }
      }
      class $a extends Yn {
        getDefault() {
          return null;
        }
        set(o) {
          (o !== this.current || this.dirty) && (this.gl.useProgram(o), this.current = o, this.dirty = !1);
        }
      }
      class qu extends Yn {
        getDefault() {
          return this.gl.TEXTURE0;
        }
        set(o) {
          (o !== this.current || this.dirty) && (this.gl.activeTexture(o), this.current = o, this.dirty = !1);
        }
      }
      class gs extends Yn {
        getDefault() {
          const o = this.gl;
          return [0, 0, o.drawingBufferWidth, o.drawingBufferHeight];
        }
        set(o) {
          const h = this.current;
          (o[0] !== h[0] || o[1] !== h[1] || o[2] !== h[2] || o[3] !== h[3] || this.dirty) && (this.gl.viewport(o[0], o[1], o[2], o[3]), this.current = o, this.dirty = !1);
        }
      }
      class Ca extends Yn {
        getDefault() {
          return null;
        }
        set(o) {
          if (o === this.current && !this.dirty) return;
          const h = this.gl;
          h.bindFramebuffer(h.FRAMEBUFFER, o), this.current = o, this.dirty = !1;
        }
      }
      class ju extends Yn {
        getDefault() {
          return null;
        }
        set(o) {
          if (o === this.current && !this.dirty) return;
          const h = this.gl;
          h.bindRenderbuffer(h.RENDERBUFFER, o), this.current = o, this.dirty = !1;
        }
      }
      class nc extends Yn {
        getDefault() {
          return null;
        }
        set(o) {
          if (o === this.current && !this.dirty) return;
          const h = this.gl;
          h.bindTexture(h.TEXTURE_2D, o), this.current = o, this.dirty = !1;
        }
      }
      class ci extends Yn {
        getDefault() {
          return null;
        }
        set(o) {
          if (o === this.current && !this.dirty) return;
          const h = this.gl;
          h.bindBuffer(h.ARRAY_BUFFER, o), this.current = o, this.dirty = !1;
        }
      }
      class ic extends Yn {
        getDefault() {
          return null;
        }
        set(o) {
          const h = this.gl;
          h.bindBuffer(h.ELEMENT_ARRAY_BUFFER, o), this.current = o, this.dirty = !1;
        }
      }
      class Jd extends Yn {
        getDefault() {
          return null;
        }
        set(o) {
          var h;
          if (o === this.current && !this.dirty) return;
          const v = this.gl;
          Wo(v) ? v.bindVertexArray(o) : (h = v.getExtension("OES_vertex_array_object")) === null || h === void 0 || h.bindVertexArrayOES(o), this.current = o, this.dirty = !1;
        }
      }
      class Qd extends Yn {
        getDefault() {
          return 4;
        }
        set(o) {
          if (o === this.current && !this.dirty) return;
          const h = this.gl;
          h.pixelStorei(h.UNPACK_ALIGNMENT, o), this.current = o, this.dirty = !1;
        }
      }
      class rc extends Yn {
        getDefault() {
          return !1;
        }
        set(o) {
          if (o === this.current && !this.dirty) return;
          const h = this.gl;
          h.pixelStorei(h.UNPACK_PREMULTIPLY_ALPHA_WEBGL, o), this.current = o, this.dirty = !1;
        }
      }
      class Gu extends Yn {
        getDefault() {
          return !1;
        }
        set(o) {
          if (o === this.current && !this.dirty) return;
          const h = this.gl;
          h.pixelStorei(h.UNPACK_FLIP_Y_WEBGL, o), this.current = o, this.dirty = !1;
        }
      }
      class Yu extends Yn {
        constructor(o, h) {
          super(o), this.context = o, this.parent = h;
        }
        getDefault() {
          return null;
        }
      }
      class Ku extends Yu {
        setDirty() {
          this.dirty = !0;
        }
        set(o) {
          if (o === this.current && !this.dirty) return;
          this.context.bindFramebuffer.set(this.parent);
          const h = this.gl;
          h.framebufferTexture2D(h.FRAMEBUFFER, h.COLOR_ATTACHMENT0, h.TEXTURE_2D, o, 0), this.current = o, this.dirty = !1;
        }
      }
      class ep extends Yu {
        set(o) {
          if (o === this.current && !this.dirty) return;
          this.context.bindFramebuffer.set(this.parent);
          const h = this.gl;
          h.framebufferRenderbuffer(h.FRAMEBUFFER, h.DEPTH_ATTACHMENT, h.RENDERBUFFER, o), this.current = o, this.dirty = !1;
        }
      }
      class fl extends Yu {
        set(o) {
          if (o === this.current && !this.dirty) return;
          this.context.bindFramebuffer.set(this.parent);
          const h = this.gl;
          h.framebufferRenderbuffer(h.FRAMEBUFFER, h.DEPTH_STENCIL_ATTACHMENT, h.RENDERBUFFER, o), this.current = o, this.dirty = !1;
        }
      }
      class lo {
        constructor(o, h, v, w, S) {
          this.context = o, this.width = h, this.height = v;
          const M = o.gl, z = this.framebuffer = M.createFramebuffer();
          if (this.colorAttachment = new Ku(o, z), w) this.depthAttachment = S ? new fl(o, z) : new ep(o, z);
          else if (S) throw new Error("Stencil cannot be setted without depth");
          if (M.checkFramebufferStatus(M.FRAMEBUFFER) !== M.FRAMEBUFFER_COMPLETE) throw new Error("Framebuffer is not complete");
        }
        destroy() {
          const o = this.context.gl, h = this.colorAttachment.get();
          if (h && o.deleteTexture(h), this.depthAttachment) {
            const v = this.depthAttachment.get();
            v && o.deleteRenderbuffer(v);
          }
          o.deleteFramebuffer(this.framebuffer);
        }
      }
      class Ui {
        constructor(o, h, v) {
          this.blendFunction = o, this.blendColor = h, this.mask = v;
        }
      }
      Ui.Replace = [1, 0], Ui.disabled = new Ui(Ui.Replace, a.Color.transparent, [!1, !1, !1, !1]), Ui.unblended = new Ui(Ui.Replace, a.Color.transparent, [!0, !0, !0, !0]), Ui.alphaBlended = new Ui([1, 771], a.Color.transparent, [!0, !0, !0, !0]);
      class ka {
        constructor(o) {
          var h, v;
          if (this.gl = o, this.clearColor = new Wu(this), this.clearDepth = new Ql(this), this.clearStencil = new Zc(this), this.colorMask = new Yd(this), this.depthMask = new xa(this), this.stencilMask = new Jn(this), this.stencilFunc = new rf(this), this.stencilOp = new qs(this), this.stencilTest = new ec(this), this.depthRange = new Kd(this), this.depthTest = new sf(this), this.depthFunc = new tc(this), this.blend = new qc(this), this.blendFunc = new jc(this), this.blendColor = new Zu(this), this.blendEquation = new hl(this), this.cullFace = new Gc(this), this.cullFaceSide = new Xd(this), this.frontFace = new Ms(this), this.program = new $a(this), this.activeTexture = new qu(this), this.viewport = new gs(this), this.bindFramebuffer = new Ca(this), this.bindRenderbuffer = new ju(this), this.bindTexture = new nc(this), this.bindVertexBuffer = new ci(this), this.bindElementBuffer = new ic(this), this.bindVertexArray = new Jd(this), this.pixelStoreUnpack = new Qd(this), this.pixelStoreUnpackPremultiplyAlpha = new rc(this), this.pixelStoreUnpackFlipY = new Gu(this), this.extTextureFilterAnisotropic = o.getExtension("EXT_texture_filter_anisotropic") || o.getExtension("MOZ_EXT_texture_filter_anisotropic") || o.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = o.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)), this.maxTextureSize = o.getParameter(o.MAX_TEXTURE_SIZE), Wo(o)) {
            this.HALF_FLOAT = o.HALF_FLOAT;
            const w = o.getExtension("EXT_color_buffer_half_float");
            this.RGBA16F = (h = o.RGBA16F) !== null && h !== void 0 ? h : w == null ? void 0 : w.RGBA16F_EXT, this.RGB16F = (v = o.RGB16F) !== null && v !== void 0 ? v : w == null ? void 0 : w.RGB16F_EXT, o.getExtension("EXT_color_buffer_float");
          } else {
            o.getExtension("EXT_color_buffer_half_float"), o.getExtension("OES_texture_half_float_linear");
            const w = o.getExtension("OES_texture_half_float");
            this.HALF_FLOAT = w == null ? void 0 : w.HALF_FLOAT_OES;
          }
        }
        setDefault() {
          this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
        }
        setDirty() {
          this.clearColor.dirty = !0, this.clearDepth.dirty = !0, this.clearStencil.dirty = !0, this.colorMask.dirty = !0, this.depthMask.dirty = !0, this.stencilMask.dirty = !0, this.stencilFunc.dirty = !0, this.stencilOp.dirty = !0, this.stencilTest.dirty = !0, this.depthRange.dirty = !0, this.depthTest.dirty = !0, this.depthFunc.dirty = !0, this.blend.dirty = !0, this.blendFunc.dirty = !0, this.blendColor.dirty = !0, this.blendEquation.dirty = !0, this.cullFace.dirty = !0, this.cullFaceSide.dirty = !0, this.frontFace.dirty = !0, this.program.dirty = !0, this.activeTexture.dirty = !0, this.viewport.dirty = !0, this.bindFramebuffer.dirty = !0, this.bindRenderbuffer.dirty = !0, this.bindTexture.dirty = !0, this.bindVertexBuffer.dirty = !0, this.bindElementBuffer.dirty = !0, this.bindVertexArray.dirty = !0, this.pixelStoreUnpack.dirty = !0, this.pixelStoreUnpackPremultiplyAlpha.dirty = !0, this.pixelStoreUnpackFlipY.dirty = !0;
        }
        createIndexBuffer(o, h) {
          return new pl(this, o, h);
        }
        createVertexBuffer(o, h, v) {
          return new lr(this, o, h, v);
        }
        createRenderbuffer(o, h, v) {
          const w = this.gl, S = w.createRenderbuffer();
          return this.bindRenderbuffer.set(S), w.renderbufferStorage(w.RENDERBUFFER, o, h, v), this.bindRenderbuffer.set(null), S;
        }
        createFramebuffer(o, h, v, w) {
          return new lo(this, o, h, v, w);
        }
        clear({ color: o, depth: h, stencil: v }) {
          const w = this.gl;
          let S = 0;
          o && (S |= w.COLOR_BUFFER_BIT, this.clearColor.set(o), this.colorMask.set([!0, !0, !0, !0])), h !== void 0 && (S |= w.DEPTH_BUFFER_BIT, this.depthRange.set([0, 1]), this.clearDepth.set(h), this.depthMask.set(!0)), v !== void 0 && (S |= w.STENCIL_BUFFER_BIT, this.clearStencil.set(v), this.stencilMask.set(255)), w.clear(S);
        }
        setCullFace(o) {
          o.enable === !1 ? this.cullFace.set(!1) : (this.cullFace.set(!0), this.cullFaceSide.set(o.mode), this.frontFace.set(o.frontFace));
        }
        setDepthMode(o) {
          o.func !== this.gl.ALWAYS || o.mask ? (this.depthTest.set(!0), this.depthFunc.set(o.func), this.depthMask.set(o.mask), this.depthRange.set(o.range)) : this.depthTest.set(!1);
        }
        setStencilMode(o) {
          o.test.func !== this.gl.ALWAYS || o.mask ? (this.stencilTest.set(!0), this.stencilMask.set(o.mask), this.stencilOp.set([o.fail, o.depthFail, o.pass]), this.stencilFunc.set({ func: o.test.func, ref: o.ref, mask: o.test.mask })) : this.stencilTest.set(!1);
        }
        setColorMode(o) {
          a.deepEqual(o.blendFunction, Ui.Replace) ? this.blend.set(!1) : (this.blend.set(!0), this.blendFunc.set(o.blendFunction), this.blendColor.set(o.blendColor)), this.colorMask.set(o.mask);
        }
        createVertexArray() {
          var o;
          return Wo(this.gl) ? this.gl.createVertexArray() : (o = this.gl.getExtension("OES_vertex_array_object")) === null || o === void 0 ? void 0 : o.createVertexArrayOES();
        }
        deleteVertexArray(o) {
          var h;
          return Wo(this.gl) ? this.gl.deleteVertexArray(o) : (h = this.gl.getExtension("OES_vertex_array_object")) === null || h === void 0 ? void 0 : h.deleteVertexArrayOES(o);
        }
        unbindVAO() {
          this.bindVertexArray.set(null);
        }
      }
      class kn {
        constructor(o, h, v) {
          this.func = o, this.mask = h, this.range = v;
        }
      }
      kn.ReadOnly = !1, kn.ReadWrite = !0, kn.disabled = new kn(519, kn.ReadOnly, [0, 1]);
      const sc = 7680;
      class $i {
        constructor(o, h, v, w, S, M) {
          this.test = o, this.ref = h, this.mask = v, this.fail = w, this.depthFail = S, this.pass = M;
        }
      }
      $i.disabled = new $i({ func: 519, mask: 0 }, 0, 0, sc, sc, sc);
      class Ci {
        constructor(o, h, v) {
          this.enable = o, this.mode = h, this.frontFace = v;
        }
      }
      let Zo;
      function Yc(_, o, h, v, w, S, M) {
        const z = _.context, R = z.gl, W = _.useProgram("collisionBox"), Q = [];
        let J = 0, fe = 0;
        for (let Ee = 0; Ee < v.length; Ee++) {
          const st = v[Ee], ht = o.getTile(st), wt = ht.getBucket(h);
          if (!wt) continue;
          let Ct = st.posMatrix;
          w[0] === 0 && w[1] === 0 || (Ct = _.translatePosMatrix(st.posMatrix, ht, w, S));
          const Dt = M ? wt.textCollisionBox : wt.iconCollisionBox, xt = wt.collisionCircleArray;
          if (xt.length > 0) {
            const Wt = a.create(), fn = Ct;
            a.mul(Wt, wt.placementInvProjMatrix, _.transform.glCoordMatrix), a.mul(Wt, Wt, wt.placementViewportMatrix), Q.push({ circleArray: xt, circleOffset: fe, transform: fn, invTransform: Wt, coord: st }), J += xt.length / 4, fe = J;
          }
          Dt && W.draw(z, R.LINES, kn.disabled, $i.disabled, _.colorModeForRenderPass(), Ci.disabled, Yl(Ct, _.transform, ht), _.style.map.terrain && _.style.map.terrain.getTerrainData(st), h.id, Dt.layoutVertexBuffer, Dt.indexBuffer, Dt.segments, null, _.transform.zoom, null, null, Dt.collisionVertexBuffer);
        }
        if (!M || !Q.length) return;
        const Se = _.useProgram("collisionCircle"), we = new a.CollisionCircleLayoutArray();
        we.resize(4 * J), we._trim();
        let Ce = 0;
        for (const Ee of Q) for (let st = 0; st < Ee.circleArray.length / 4; st++) {
          const ht = 4 * st, wt = Ee.circleArray[ht + 0], Ct = Ee.circleArray[ht + 1], Dt = Ee.circleArray[ht + 2], xt = Ee.circleArray[ht + 3];
          we.emplace(Ce++, wt, Ct, Dt, xt, 0), we.emplace(Ce++, wt, Ct, Dt, xt, 1), we.emplace(Ce++, wt, Ct, Dt, xt, 2), we.emplace(Ce++, wt, Ct, Dt, xt, 3);
        }
        (!Zo || Zo.length < 2 * J) && (Zo = function(Ee) {
          const st = 2 * Ee, ht = new a.QuadTriangleArray();
          ht.resize(st), ht._trim();
          for (let wt = 0; wt < st; wt++) {
            const Ct = 6 * wt;
            ht.uint16[Ct + 0] = 4 * wt + 0, ht.uint16[Ct + 1] = 4 * wt + 1, ht.uint16[Ct + 2] = 4 * wt + 2, ht.uint16[Ct + 3] = 4 * wt + 2, ht.uint16[Ct + 4] = 4 * wt + 3, ht.uint16[Ct + 5] = 4 * wt + 0;
          }
          return ht;
        }(J));
        const Me = z.createIndexBuffer(Zo, !0), Ue = z.createVertexBuffer(we, a.collisionCircleLayout.members, !0);
        for (const Ee of Q) {
          const st = { u_matrix: Ee.transform, u_inv_matrix: Ee.invTransform, u_camera_to_center_distance: (ct = _.transform).cameraToCenterDistance, u_viewport_size: [ct.width, ct.height] };
          Se.draw(z, R.TRIANGLES, kn.disabled, $i.disabled, _.colorModeForRenderPass(), Ci.disabled, st, _.style.map.terrain && _.style.map.terrain.getTerrainData(Ee.coord), h.id, Ue, Me, a.SegmentVector.simpleSegment(0, 2 * Ee.circleOffset, Ee.circleArray.length, Ee.circleArray.length / 2), null, _.transform.zoom, null, null, null);
        }
        var ct;
        Ue.destroy(), Me.destroy();
      }
      Ci.disabled = new Ci(!1, 1029, 2305), Ci.backCCW = new Ci(!0, 1029, 2305);
      const Xu = a.identity(new Float32Array(16));
      function of(_, o, h, v, w, S) {
        const { horizontalAlign: M, verticalAlign: z } = a.getAnchorAlignment(_), R = -(M - 0.5) * o, W = -(z - 0.5) * h, Q = a.evaluateVariableOffset(_, v);
        return new a.Point((R / w + Q[0]) * S, (W / w + Q[1]) * S);
      }
      function Ju(_, o, h, v, w, S, M, z, R, W, Q) {
        const J = _.text.placedSymbolArray, fe = _.text.dynamicLayoutVertexArray, Se = _.icon.dynamicLayoutVertexArray, we = {};
        fe.clear();
        for (let Ce = 0; Ce < J.length; Ce++) {
          const Me = J.get(Ce), Ue = Me.hidden || !Me.crossTileID || _.allowVerticalPlacement && !Me.placedOrientation ? null : v[Me.crossTileID];
          if (Ue) {
            const ct = new a.Point(Me.anchorX, Me.anchorY), Ee = Gi(ct, h ? M : S, Q), st = Cn(w.cameraToCenterDistance, Ee.signedDistanceFromCamera);
            let ht = a.evaluateSizeForFeature(_.textSizeData, R, Me) * st / a.ONE_EM;
            h && (ht *= _.tilePixelRatio / z);
            const { width: wt, height: Ct, anchor: Dt, textOffset: xt, textBoxScale: Wt } = Ue, fn = of(Dt, wt, Ct, xt, Wt, ht), En = h ? Gi(ct.add(fn), S, Q).point : Ee.point.add(o ? fn.rotate(-w.angle) : fn), Ot = _.allowVerticalPlacement && Me.placedOrientation === a.WritingMode.vertical ? Math.PI / 2 : 0;
            for (let xn = 0; xn < Me.numGlyphs; xn++) a.addDynamicAttributes(fe, En, Ot);
            W && Me.associatedIconIndex >= 0 && (we[Me.associatedIconIndex] = { shiftedAnchor: En, angle: Ot });
          } else be(Me.numGlyphs, fe);
        }
        if (W) {
          Se.clear();
          const Ce = _.icon.placedSymbolArray;
          for (let Me = 0; Me < Ce.length; Me++) {
            const Ue = Ce.get(Me);
            if (Ue.hidden) be(Ue.numGlyphs, Se);
            else {
              const ct = we[Me];
              if (ct) for (let Ee = 0; Ee < Ue.numGlyphs; Ee++) a.addDynamicAttributes(Se, ct.shiftedAnchor, ct.angle);
              else be(Ue.numGlyphs, Se);
            }
          }
          _.icon.dynamicLayoutVertexBuffer.updateData(Se);
        }
        _.text.dynamicLayoutVertexBuffer.updateData(fe);
      }
      function Kc(_, o, h) {
        return h.iconsInText && o ? "symbolTextAndIcon" : _ ? "symbolSDF" : "symbolIcon";
      }
      function is(_, o, h, v, w, S, M, z, R, W, Q, J) {
        const fe = _.context, Se = fe.gl, we = _.transform, Ce = z === "map", Me = R === "map", Ue = z !== "viewport" && h.layout.get("symbol-placement") !== "point", ct = Ce && !Me && !Ue, Ee = !h.layout.get("symbol-sort-key").isConstant();
        let st = !1;
        const ht = _.depthModeForSublayer(0, kn.ReadOnly), wt = h.layout.get("text-variable-anchor"), Ct = [];
        for (const Dt of v) {
          const xt = o.getTile(Dt), Wt = xt.getBucket(h);
          if (!Wt) continue;
          const fn = w ? Wt.text : Wt.icon;
          if (!fn || !fn.segments.get().length || !fn.hasVisibleVertices) continue;
          const En = fn.programConfigurations.get(h.id), Ot = w || Wt.sdfIcons, xn = w ? Wt.textSizeData : Wt.iconSizeData, Gt = Me || we.pitch !== 0, ni = _.useProgram(Kc(Ot, w, Wt), En), cr = a.evaluateSizeForZoom(xn, we.zoom), ii = _.style.map.terrain && _.style.map.terrain.getTerrainData(Dt);
          let Dn, rr, bs, ur, Lr = [0, 0], Gs = null;
          if (w) rr = xt.glyphAtlasTexture, bs = Se.LINEAR, Dn = xt.glyphAtlasTexture.size, Wt.iconsInText && (Lr = xt.imageAtlasTexture.size, Gs = xt.imageAtlasTexture, ur = Gt || _.options.rotating || _.options.zooming || xn.kind === "composite" || xn.kind === "camera" ? Se.LINEAR : Se.NEAREST);
          else {
            const Tr = h.layout.get("icon-size").constantOr(0) !== 1 || Wt.iconsNeedLinear;
            rr = xt.imageAtlasTexture, bs = Ot || _.options.rotating || _.options.zooming || Tr || Gt ? Se.LINEAR : Se.NEAREST, Dn = xt.imageAtlasTexture.size;
          }
          const Po = ze(xt, 1, _.transform.zoom), Mo = yn(Dt.posMatrix, Me, Ce, _.transform, Po), ws = Qi(Dt.posMatrix, Me, Ce, _.transform, Po), Jo = wt && Wt.hasTextData(), ad = h.layout.get("icon-text-fit") !== "none" && Jo && Wt.hasIconData();
          if (Ue) {
            const Tr = _.style.map.terrain ? (up, La) => _.style.map.terrain.getElevation(Dt, up, La) : null, Ys = h.layout.get("text-rotation-alignment") === "map";
            Wr(Wt, Dt.posMatrix, _, w, Mo, ws, Me, W, Ys, Tr);
          }
          const rs = _.translatePosMatrix(Dt.posMatrix, xt, S, M), Or = Ue || w && wt || ad ? Xu : Mo, ui = _.translatePosMatrix(ws, xt, S, M, !0), Sr = Ot && h.paint.get(w ? "text-halo-width" : "icon-halo-width").constantOr(1) !== 0;
          let Nr;
          Nr = Ot ? Wt.iconsInText ? dl(xn.kind, cr, ct, Me, _, rs, Or, ui, Dn, Lr) : wa(xn.kind, cr, ct, Me, _, rs, Or, ui, w, Dn) : li(xn.kind, cr, ct, Me, _, rs, Or, ui, w, Dn);
          const fi = { program: ni, buffers: fn, uniformValues: Nr, atlasTexture: rr, atlasTextureIcon: Gs, atlasInterpolation: bs, atlasInterpolationIcon: ur, isSDF: Ot, hasHalo: Sr };
          if (Ee && Wt.canOverlap) {
            st = !0;
            const Tr = fn.segments.get();
            for (const Ys of Tr) Ct.push({ segments: new a.SegmentVector([Ys]), sortKey: Ys.sortKey, state: fi, terrainData: ii });
          } else Ct.push({ segments: fn.segments, sortKey: 0, state: fi, terrainData: ii });
        }
        st && Ct.sort((Dt, xt) => Dt.sortKey - xt.sortKey);
        for (const Dt of Ct) {
          const xt = Dt.state;
          if (fe.activeTexture.set(Se.TEXTURE0), xt.atlasTexture.bind(xt.atlasInterpolation, Se.CLAMP_TO_EDGE), xt.atlasTextureIcon && (fe.activeTexture.set(Se.TEXTURE1), xt.atlasTextureIcon && xt.atlasTextureIcon.bind(xt.atlasInterpolationIcon, Se.CLAMP_TO_EDGE)), xt.isSDF) {
            const Wt = xt.uniformValues;
            xt.hasHalo && (Wt.u_is_halo = 1, qo(xt.buffers, Dt.segments, h, _, xt.program, ht, Q, J, Wt, Dt.terrainData)), Wt.u_is_halo = 0;
          }
          qo(xt.buffers, Dt.segments, h, _, xt.program, ht, Q, J, xt.uniformValues, Dt.terrainData);
        }
      }
      function qo(_, o, h, v, w, S, M, z, R, W) {
        const Q = v.context;
        w.draw(Q, Q.gl.TRIANGLES, S, M, z, Ci.disabled, R, W, h.id, _.layoutVertexBuffer, _.indexBuffer, o, h.paint, v.transform.zoom, _.programConfigurations.get(h.id), _.dynamicLayoutVertexBuffer, _.opacityVertexBuffer);
      }
      function Qu(_, o, h, v, w) {
        if (!h || !v || !v.imageAtlas) return;
        const S = v.imageAtlas.patternPositions;
        let M = S[h.to.toString()], z = S[h.from.toString()];
        if (!M || !z) {
          const R = w.getPaintProperty(o);
          M = S[R], z = S[R];
        }
        M && z && _.setConstantPatternPositions(M, z);
      }
      function ys(_, o, h, v, w, S, M) {
        const z = _.context.gl, R = "fill-pattern", W = h.paint.get(R), Q = W && W.constantOr(1), J = h.getCrossfadeParameters();
        let fe, Se, we, Ce, Me;
        M ? (Se = Q && !h.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", fe = z.LINES) : (Se = Q ? "fillPattern" : "fill", fe = z.TRIANGLES);
        const Ue = W.constantOr(null);
        for (const ct of v) {
          const Ee = o.getTile(ct);
          if (Q && !Ee.patternsLoaded()) continue;
          const st = Ee.getBucket(h);
          if (!st) continue;
          const ht = st.programConfigurations.get(h.id), wt = _.useProgram(Se, ht), Ct = _.style.map.terrain && _.style.map.terrain.getTerrainData(ct);
          Q && (_.context.activeTexture.set(z.TEXTURE0), Ee.imageAtlasTexture.bind(z.LINEAR, z.CLAMP_TO_EDGE), ht.updatePaintBuffers(J)), Qu(ht, R, Ue, Ee, h);
          const Dt = Ct ? ct : null, xt = _.translatePosMatrix(Dt ? Dt.posMatrix : ct.posMatrix, Ee, h.paint.get("fill-translate"), h.paint.get("fill-translate-anchor"));
          if (M) {
            Ce = st.indexBuffer2, Me = st.segments2;
            const Wt = [z.drawingBufferWidth, z.drawingBufferHeight];
            we = Se === "fillOutlinePattern" && Q ? ll(xt, _, J, Ee, Wt) : ya(xt, Wt);
          } else Ce = st.indexBuffer, Me = st.segments, we = Q ? Xn(xt, _, J, Ee) : ti(xt);
          wt.draw(_.context, fe, w, _.stencilModeForClipping(ct), S, Ci.disabled, we, Ct, h.id, st.layoutVertexBuffer, Ce, Me, h.paint, _.transform.zoom, ht);
        }
      }
      function oc(_, o, h, v, w, S, M) {
        const z = _.context, R = z.gl, W = "fill-extrusion-pattern", Q = h.paint.get(W), J = Q.constantOr(1), fe = h.getCrossfadeParameters(), Se = h.paint.get("fill-extrusion-opacity"), we = Q.constantOr(null);
        for (const Ce of v) {
          const Me = o.getTile(Ce), Ue = Me.getBucket(h);
          if (!Ue) continue;
          const ct = _.style.map.terrain && _.style.map.terrain.getTerrainData(Ce), Ee = Ue.programConfigurations.get(h.id), st = _.useProgram(J ? "fillExtrusionPattern" : "fillExtrusion", Ee);
          J && (_.context.activeTexture.set(R.TEXTURE0), Me.imageAtlasTexture.bind(R.LINEAR, R.CLAMP_TO_EDGE), Ee.updatePaintBuffers(fe)), Qu(Ee, W, we, Me, h);
          const ht = _.translatePosMatrix(Ce.posMatrix, Me, h.paint.get("fill-extrusion-translate"), h.paint.get("fill-extrusion-translate-anchor")), wt = h.paint.get("fill-extrusion-vertical-gradient"), Ct = J ? In(ht, _, wt, Se, Ce, fe, Me) : Fn(ht, _, wt, Se);
          st.draw(z, z.gl.TRIANGLES, w, S, M, Ci.backCCW, Ct, ct, h.id, Ue.layoutVertexBuffer, Ue.indexBuffer, Ue.segments, h.paint, _.transform.zoom, Ee, _.style.map.terrain && Ue.centroidVertexBuffer);
        }
      }
      function ml(_, o, h, v, w, S, M) {
        const z = _.context, R = z.gl, W = h.fbo;
        if (!W) return;
        const Q = _.useProgram("hillshade"), J = _.style.map.terrain && _.style.map.terrain.getTerrainData(o);
        z.activeTexture.set(R.TEXTURE0), R.bindTexture(R.TEXTURE_2D, W.colorAttachment.get()), Q.draw(z, R.TRIANGLES, w, S, M, Ci.disabled, ((fe, Se, we, Ce) => {
          const Me = we.paint.get("hillshade-shadow-color"), Ue = we.paint.get("hillshade-highlight-color"), ct = we.paint.get("hillshade-accent-color");
          let Ee = we.paint.get("hillshade-illumination-direction") * (Math.PI / 180);
          we.paint.get("hillshade-illumination-anchor") === "viewport" && (Ee -= fe.transform.angle);
          const st = !fe.options.moving;
          return { u_matrix: Ce ? Ce.posMatrix : fe.transform.calculatePosMatrix(Se.tileID.toUnwrapped(), st), u_image: 0, u_latrange: Xl(0, Se.tileID), u_light: [we.paint.get("hillshade-exaggeration"), Ee], u_shadow: Me, u_highlight: Ue, u_accent: ct };
        })(_, h, v, J ? o : null), J, v.id, _.rasterBoundsBuffer, _.quadTriangleIndexBuffer, _.rasterBoundsSegments);
      }
      function tp(_, o, h, v, w, S) {
        const M = _.context, z = M.gl, R = o.dem;
        if (R && R.data) {
          const W = R.dim, Q = R.stride, J = R.getPixels();
          if (M.activeTexture.set(z.TEXTURE1), M.pixelStoreUnpackPremultiplyAlpha.set(!1), o.demTexture = o.demTexture || _.getTileTexture(Q), o.demTexture) {
            const Se = o.demTexture;
            Se.update(J, { premultiply: !1 }), Se.bind(z.NEAREST, z.CLAMP_TO_EDGE);
          } else o.demTexture = new ve(M, J, z.RGBA, { premultiply: !1 }), o.demTexture.bind(z.NEAREST, z.CLAMP_TO_EDGE);
          M.activeTexture.set(z.TEXTURE0);
          let fe = o.fbo;
          if (!fe) {
            const Se = new ve(M, { width: W, height: W, data: null }, z.RGBA);
            Se.bind(z.LINEAR, z.CLAMP_TO_EDGE), fe = o.fbo = M.createFramebuffer(W, W, !0, !1), fe.colorAttachment.set(Se.texture);
          }
          M.bindFramebuffer.set(fe.framebuffer), M.viewport.set([0, 0, W, W]), _.useProgram("hillshadePrepare").draw(M, z.TRIANGLES, v, w, S, Ci.disabled, ((Se, we) => {
            const Ce = we.stride, Me = a.create();
            return a.ortho(Me, 0, a.EXTENT, -a.EXTENT, 0, 0, 1), a.translate(Me, Me, [0, -a.EXTENT, 0]), { u_matrix: Me, u_image: 1, u_dimension: [Ce, Ce], u_zoom: Se.overscaledZ, u_unpack: we.getUnpackVector() };
          })(o.tileID, R), null, h.id, _.rasterBoundsBuffer, _.quadTriangleIndexBuffer, _.rasterBoundsSegments), o.needsHillshadePrepare = !1;
        }
      }
      function Fi(_, o, h, v, w, S) {
        const M = v.paint.get("raster-fade-duration");
        if (!S && M > 0) {
          const z = a.exported.now(), R = (z - _.timeAdded) / M, W = o ? (z - o.timeAdded) / M : -1, Q = h.getSource(), J = w.coveringZoomLevel({ tileSize: Q.tileSize, roundZoom: Q.roundZoom }), fe = !o || Math.abs(o.tileID.overscaledZ - J) > Math.abs(_.tileID.overscaledZ - J), Se = fe && _.refreshedUponExpiration ? 1 : a.clamp(fe ? R : 1 - W, 0, 1);
          return _.refreshedUponExpiration && R >= 1 && (_.refreshedUponExpiration = !1), o ? { opacity: 1, mix: 1 - Se } : { opacity: Se, mix: 0 };
        }
        return { opacity: 1, mix: 0 };
      }
      const jo = new a.Color(1, 0, 0, 1), Kr = new a.Color(0, 1, 0, 1), np = new a.Color(0, 0, 1, 1), co = new a.Color(1, 0, 1, 1), ac = new a.Color(0, 1, 1, 1);
      function Sa(_, o, h, v) {
        vl(_, 0, o + h / 2, _.transform.width, h, v);
      }
      function Ta(_, o, h, v) {
        vl(_, o - h / 2, 0, h, _.transform.height, v);
      }
      function vl(_, o, h, v, w, S) {
        const M = _.context, z = M.gl;
        z.enable(z.SCISSOR_TEST), z.scissor(o * _.pixelRatio, h * _.pixelRatio, v * _.pixelRatio, w * _.pixelRatio), M.clear({ color: S }), z.disable(z.SCISSOR_TEST);
      }
      function uo(_, o, h) {
        const v = _.context, w = v.gl, S = h.posMatrix, M = _.useProgram("debug"), z = kn.disabled, R = $i.disabled, W = _.colorModeForRenderPass(), Q = "$debug", J = _.style.map.terrain && _.style.map.terrain.getTerrainData(h);
        v.activeTexture.set(w.TEXTURE0);
        const fe = o.getTileByID(h.key).latestRawTileData, Se = Math.floor((fe && fe.byteLength || 0) / 1024), we = o.getTile(h).tileSize, Ce = 512 / Math.min(we, 512) * (h.overscaledZ / _.transform.zoom) * 0.5;
        let Me = h.canonical.toString();
        h.overscaledZ !== h.canonical.z && (Me += ` => ${h.overscaledZ}`), function(Ue, ct) {
          Ue.initDebugOverlayCanvas();
          const Ee = Ue.debugOverlayCanvas, st = Ue.context.gl, ht = Ue.debugOverlayCanvas.getContext("2d");
          ht.clearRect(0, 0, Ee.width, Ee.height), ht.shadowColor = "white", ht.shadowBlur = 2, ht.lineWidth = 1.5, ht.strokeStyle = "white", ht.textBaseline = "top", ht.font = "bold 36px Open Sans, sans-serif", ht.fillText(ct, 5, 5), ht.strokeText(ct, 5, 5), Ue.debugOverlayTexture.update(Ee), Ue.debugOverlayTexture.bind(st.LINEAR, st.CLAMP_TO_EDGE);
        }(_, `${Me} ${Se}kB`), M.draw(v, w.TRIANGLES, z, R, Ui.alphaBlended, Ci.disabled, _a(S, a.Color.transparent, Ce), null, Q, _.debugBuffer, _.quadTriangleIndexBuffer, _.debugSegments), M.draw(v, w.LINE_STRIP, z, R, W, Ci.disabled, _a(S, a.Color.red), J, Q, _.debugBuffer, _.tileBorderIndexBuffer, _.debugSegments);
      }
      function ed(_, o, h) {
        const v = _.context, w = v.gl, S = _.colorModeForRenderPass(), M = new kn(w.LEQUAL, kn.ReadWrite, _.depthRangeFor3D), z = _.useProgram("terrain"), R = o.getTerrainMesh();
        v.bindFramebuffer.set(null), v.viewport.set([0, 0, _.width, _.height]);
        for (const W of h) {
          const Q = _.renderToTexture.getTexture(W), J = o.getTerrainData(W.tileID);
          v.activeTexture.set(w.TEXTURE0), w.bindTexture(w.TEXTURE_2D, Q.texture);
          const fe = { u_matrix: _.transform.calculatePosMatrix(W.tileID.toUnwrapped()), u_texture: 0, u_ele_delta: o.getMeshFrameDelta(_.transform.zoom) };
          z.draw(v, w.TRIANGLES, M, $i.disabled, S, Ci.backCCW, fe, J, "terrain", R.vertexBuffer, R.indexBuffer, R.segments);
        }
      }
      const Go = { symbol: function(_, o, h, v, w) {
        if (_.renderPass !== "translucent") return;
        const S = $i.disabled, M = _.colorModeForRenderPass();
        h.layout.get("text-variable-anchor") && function(z, R, W, Q, J, fe, Se) {
          const we = R.transform, Ce = J === "map", Me = fe === "map";
          for (const Ue of z) {
            const ct = Q.getTile(Ue), Ee = ct.getBucket(W);
            if (!Ee || !Ee.text || !Ee.text.segments.get().length) continue;
            const st = a.evaluateSizeForZoom(Ee.textSizeData, we.zoom), ht = ze(ct, 1, R.transform.zoom), wt = yn(Ue.posMatrix, Me, Ce, R.transform, ht), Ct = W.layout.get("icon-text-fit") !== "none" && Ee.hasIconData();
            if (st) {
              const Dt = Math.pow(2, we.zoom - ct.tileID.overscaledZ);
              Ju(Ee, Ce, Me, Se, we, wt, Ue.posMatrix, Dt, st, Ct, R.style.map.terrain ? (xt, Wt) => R.style.map.terrain.getElevation(Ue, xt, Wt) : null);
            }
          }
        }(v, _, h, o, h.layout.get("text-rotation-alignment"), h.layout.get("text-pitch-alignment"), w), h.paint.get("icon-opacity").constantOr(1) !== 0 && is(_, o, h, v, !1, h.paint.get("icon-translate"), h.paint.get("icon-translate-anchor"), h.layout.get("icon-rotation-alignment"), h.layout.get("icon-pitch-alignment"), h.layout.get("icon-keep-upright"), S, M), h.paint.get("text-opacity").constantOr(1) !== 0 && is(_, o, h, v, !0, h.paint.get("text-translate"), h.paint.get("text-translate-anchor"), h.layout.get("text-rotation-alignment"), h.layout.get("text-pitch-alignment"), h.layout.get("text-keep-upright"), S, M), o.map.showCollisionBoxes && (Yc(_, o, h, v, h.paint.get("text-translate"), h.paint.get("text-translate-anchor"), !0), Yc(_, o, h, v, h.paint.get("icon-translate"), h.paint.get("icon-translate-anchor"), !1));
      }, circle: function(_, o, h, v) {
        if (_.renderPass !== "translucent") return;
        const w = h.paint.get("circle-opacity"), S = h.paint.get("circle-stroke-width"), M = h.paint.get("circle-stroke-opacity"), z = !h.layout.get("circle-sort-key").isConstant();
        if (w.constantOr(1) === 0 && (S.constantOr(1) === 0 || M.constantOr(1) === 0)) return;
        const R = _.context, W = R.gl, Q = _.depthModeForSublayer(0, kn.ReadOnly), J = $i.disabled, fe = _.colorModeForRenderPass(), Se = [];
        for (let we = 0; we < v.length; we++) {
          const Ce = v[we], Me = o.getTile(Ce), Ue = Me.getBucket(h);
          if (!Ue) continue;
          const ct = Ue.programConfigurations.get(h.id), Ee = _.useProgram("circle", ct), st = Ue.layoutVertexBuffer, ht = Ue.indexBuffer, wt = _.style.map.terrain && _.style.map.terrain.getTerrainData(Ce), Ct = { programConfiguration: ct, program: Ee, layoutVertexBuffer: st, indexBuffer: ht, uniformValues: Gl(_, Ce, Me, h), terrainData: wt };
          if (z) {
            const Dt = Ue.segments.get();
            for (const xt of Dt) Se.push({ segments: new a.SegmentVector([xt]), sortKey: xt.sortKey, state: Ct });
          } else Se.push({ segments: Ue.segments, sortKey: 0, state: Ct });
        }
        z && Se.sort((we, Ce) => we.sortKey - Ce.sortKey);
        for (const we of Se) {
          const { programConfiguration: Ce, program: Me, layoutVertexBuffer: Ue, indexBuffer: ct, uniformValues: Ee, terrainData: st } = we.state;
          Me.draw(R, W.TRIANGLES, Q, J, fe, Ci.disabled, Ee, st, h.id, Ue, ct, we.segments, h.paint, _.transform.zoom, Ce);
        }
      }, heatmap: function(_, o, h, v) {
        if (h.paint.get("heatmap-opacity") !== 0) if (_.renderPass === "offscreen") {
          const w = _.context, S = w.gl, M = $i.disabled, z = new Ui([S.ONE, S.ONE], a.Color.transparent, [!0, !0, !0, !0]);
          (function(R, W, Q) {
            const J = R.gl;
            R.activeTexture.set(J.TEXTURE1), R.viewport.set([0, 0, W.width / 4, W.height / 4]);
            let fe = Q.heatmapFbo;
            if (fe) J.bindTexture(J.TEXTURE_2D, fe.colorAttachment.get()), R.bindFramebuffer.set(fe.framebuffer);
            else {
              const Se = J.createTexture();
              J.bindTexture(J.TEXTURE_2D, Se), J.texParameteri(J.TEXTURE_2D, J.TEXTURE_WRAP_S, J.CLAMP_TO_EDGE), J.texParameteri(J.TEXTURE_2D, J.TEXTURE_WRAP_T, J.CLAMP_TO_EDGE), J.texParameteri(J.TEXTURE_2D, J.TEXTURE_MIN_FILTER, J.LINEAR), J.texParameteri(J.TEXTURE_2D, J.TEXTURE_MAG_FILTER, J.LINEAR), fe = Q.heatmapFbo = R.createFramebuffer(W.width / 4, W.height / 4, !1, !1), function(we, Ce, Me, Ue) {
                var ct, Ee;
                const st = we.gl, ht = (ct = we.HALF_FLOAT) !== null && ct !== void 0 ? ct : st.UNSIGNED_BYTE, wt = (Ee = we.RGBA16F) !== null && Ee !== void 0 ? Ee : st.RGBA;
                st.texImage2D(st.TEXTURE_2D, 0, wt, Ce.width / 4, Ce.height / 4, 0, st.RGBA, ht, null), Ue.colorAttachment.set(Me);
              }(R, W, Se, fe);
            }
          })(w, _, h), w.clear({ color: a.Color.transparent });
          for (let R = 0; R < v.length; R++) {
            const W = v[R];
            if (o.hasRenderableParent(W)) continue;
            const Q = o.getTile(W), J = Q.getBucket(h);
            if (!J) continue;
            const fe = J.programConfigurations.get(h.id), Se = _.useProgram("heatmap", fe), { zoom: we } = _.transform;
            Se.draw(w, S.TRIANGLES, kn.disabled, M, z, Ci.disabled, Wc(W.posMatrix, Q, we, h.paint.get("heatmap-intensity")), null, h.id, J.layoutVertexBuffer, J.indexBuffer, J.segments, h.paint, _.transform.zoom, fe);
          }
          w.viewport.set([0, 0, _.width, _.height]);
        } else _.renderPass === "translucent" && (_.context.setColorMode(_.colorModeForRenderPass()), function(w, S) {
          const M = w.context, z = M.gl, R = S.heatmapFbo;
          if (!R) return;
          M.activeTexture.set(z.TEXTURE0), z.bindTexture(z.TEXTURE_2D, R.colorAttachment.get()), M.activeTexture.set(z.TEXTURE1);
          let W = S.colorRampTexture;
          W || (W = S.colorRampTexture = new ve(M, S.colorRamp, z.RGBA)), W.bind(z.LINEAR, z.CLAMP_TO_EDGE), w.useProgram("heatmapTexture").draw(M, z.TRIANGLES, kn.disabled, $i.disabled, w.colorModeForRenderPass(), Ci.disabled, ((Q, J, fe, Se) => {
            const we = a.create();
            a.ortho(we, 0, Q.width, Q.height, 0, 0, 1);
            const Ce = Q.context.gl;
            return { u_matrix: we, u_world: [Ce.drawingBufferWidth, Ce.drawingBufferHeight], u_image: 0, u_color_ramp: 1, u_opacity: J.paint.get("heatmap-opacity") };
          })(w, S), null, S.id, w.viewportBuffer, w.quadTriangleIndexBuffer, w.viewportSegments, S.paint, w.transform.zoom);
        }(_, h));
      }, line: function(_, o, h, v) {
        if (_.renderPass !== "translucent") return;
        const w = h.paint.get("line-opacity"), S = h.paint.get("line-width");
        if (w.constantOr(1) === 0 || S.constantOr(1) === 0) return;
        const M = _.depthModeForSublayer(0, kn.ReadOnly), z = _.colorModeForRenderPass(), R = h.paint.get("line-dasharray"), W = h.paint.get("line-pattern"), Q = W.constantOr(1), J = h.paint.get("line-gradient"), fe = h.getCrossfadeParameters(), Se = Q ? "linePattern" : R ? "lineSDF" : J ? "lineGradient" : "line", we = _.context, Ce = we.gl;
        let Me = !0;
        for (const Ue of v) {
          const ct = o.getTile(Ue);
          if (Q && !ct.patternsLoaded()) continue;
          const Ee = ct.getBucket(h);
          if (!Ee) continue;
          const st = Ee.programConfigurations.get(h.id), ht = _.context.program.get(), wt = _.useProgram(Se, st), Ct = Me || wt.program !== ht, Dt = _.style.map.terrain && _.style.map.terrain.getTerrainData(Ue), xt = W.constantOr(null);
          if (xt && ct.imageAtlas) {
            const En = ct.imageAtlas, Ot = En.patternPositions[xt.to.toString()], xn = En.patternPositions[xt.from.toString()];
            Ot && xn && st.setConstantPatternPositions(Ot, xn);
          }
          const Wt = Dt ? Ue : null, fn = Q ? jr(_, ct, h, fe, Wt) : R ? Jl(_, ct, h, R, fe, Wt) : J ? cl(_, ct, h, Ee.lineClipsArray.length, Wt) : Ws(_, ct, h, Wt);
          if (Q) we.activeTexture.set(Ce.TEXTURE0), ct.imageAtlasTexture.bind(Ce.LINEAR, Ce.CLAMP_TO_EDGE), st.updatePaintBuffers(fe);
          else if (R && (Ct || _.lineAtlas.dirty)) we.activeTexture.set(Ce.TEXTURE0), _.lineAtlas.bind(we);
          else if (J) {
            const En = Ee.gradients[h.id];
            let Ot = En.texture;
            if (h.gradientVersion !== En.version) {
              let xn = 256;
              if (h.stepInterpolant) {
                const Gt = o.getSource().maxzoom, ni = Ue.canonical.z === Gt ? Math.ceil(1 << _.transform.maxZoom - Ue.canonical.z) : 1;
                xn = a.clamp(a.nextPowerOfTwo(Ee.maxLineLength / a.EXTENT * 1024 * ni), 256, we.maxTextureSize);
              }
              En.gradient = a.renderColorRamp({ expression: h.gradientExpression(), evaluationKey: "lineProgress", resolution: xn, image: En.gradient || void 0, clips: Ee.lineClipsArray }), En.texture ? En.texture.update(En.gradient) : En.texture = new ve(we, En.gradient, Ce.RGBA), En.version = h.gradientVersion, Ot = En.texture;
            }
            we.activeTexture.set(Ce.TEXTURE0), Ot.bind(h.stepInterpolant ? Ce.NEAREST : Ce.LINEAR, Ce.CLAMP_TO_EDGE);
          }
          wt.draw(we, Ce.TRIANGLES, M, _.stencilModeForClipping(Ue), z, Ci.disabled, fn, Dt, h.id, Ee.layoutVertexBuffer, Ee.indexBuffer, Ee.segments, h.paint, _.transform.zoom, st, Ee.layoutVertexBuffer2), Me = !1;
        }
      }, fill: function(_, o, h, v) {
        const w = h.paint.get("fill-color"), S = h.paint.get("fill-opacity");
        if (S.constantOr(1) === 0) return;
        const M = _.colorModeForRenderPass(), z = h.paint.get("fill-pattern"), R = _.opaquePassEnabledForLayer() && !z.constantOr(1) && w.constantOr(a.Color.transparent).a === 1 && S.constantOr(0) === 1 ? "opaque" : "translucent";
        if (_.renderPass === R) {
          const W = _.depthModeForSublayer(1, _.renderPass === "opaque" ? kn.ReadWrite : kn.ReadOnly);
          ys(_, o, h, v, W, M, !1);
        }
        if (_.renderPass === "translucent" && h.paint.get("fill-antialias")) {
          const W = _.depthModeForSublayer(h.getPaintProperty("fill-outline-color") ? 2 : 0, kn.ReadOnly);
          ys(_, o, h, v, W, M, !0);
        }
      }, "fill-extrusion": function(_, o, h, v) {
        const w = h.paint.get("fill-extrusion-opacity");
        if (w !== 0 && _.renderPass === "translucent") {
          const S = new kn(_.context.gl.LEQUAL, kn.ReadWrite, _.depthRangeFor3D);
          if (w !== 1 || h.paint.get("fill-extrusion-pattern").constantOr(1)) oc(_, o, h, v, S, $i.disabled, Ui.disabled), oc(_, o, h, v, S, _.stencilModeFor3D(), _.colorModeForRenderPass());
          else {
            const M = _.colorModeForRenderPass();
            oc(_, o, h, v, S, $i.disabled, M);
          }
        }
      }, hillshade: function(_, o, h, v) {
        if (_.renderPass !== "offscreen" && _.renderPass !== "translucent") return;
        const w = _.context, S = _.depthModeForSublayer(0, kn.ReadOnly), M = _.colorModeForRenderPass(), [z, R] = _.renderPass === "translucent" ? _.stencilConfigForOverlap(v) : [{}, v];
        for (const W of R) {
          const Q = o.getTile(W);
          Q.needsHillshadePrepare !== void 0 && Q.needsHillshadePrepare && _.renderPass === "offscreen" ? tp(_, Q, h, S, $i.disabled, M) : _.renderPass === "translucent" && ml(_, W, Q, h, S, z[W.overscaledZ], M);
        }
        w.viewport.set([0, 0, _.width, _.height]);
      }, raster: function(_, o, h, v) {
        if (_.renderPass !== "translucent" || h.paint.get("raster-opacity") === 0 || !v.length) return;
        const w = _.context, S = w.gl, M = o.getSource(), z = _.useProgram("raster"), R = _.colorModeForRenderPass(), [W, Q] = M instanceof bt ? [{}, v] : _.stencilConfigForOverlap(v), J = Q[Q.length - 1].overscaledZ, fe = !_.options.moving;
        for (const Se of Q) {
          const we = _.depthModeForSublayer(Se.overscaledZ - J, h.paint.get("raster-opacity") === 1 ? kn.ReadWrite : kn.ReadOnly, S.LESS), Ce = o.getTile(Se);
          Ce.registerFadeDuration(h.paint.get("raster-fade-duration"));
          const Me = o.findLoadedParent(Se, 0), Ue = Fi(Ce, Me, o, h, _.transform, _.style.map.terrain);
          let ct, Ee;
          const st = h.paint.get("raster-resampling") === "nearest" ? S.NEAREST : S.LINEAR;
          w.activeTexture.set(S.TEXTURE0), Ce.texture.bind(st, S.CLAMP_TO_EDGE, S.LINEAR_MIPMAP_NEAREST), w.activeTexture.set(S.TEXTURE1), Me ? (Me.texture.bind(st, S.CLAMP_TO_EDGE, S.LINEAR_MIPMAP_NEAREST), ct = Math.pow(2, Me.tileID.overscaledZ - Ce.tileID.overscaledZ), Ee = [Ce.tileID.canonical.x * ct % 1, Ce.tileID.canonical.y * ct % 1]) : Ce.texture.bind(st, S.CLAMP_TO_EDGE, S.LINEAR_MIPMAP_NEAREST);
          const ht = _.style.map.terrain && _.style.map.terrain.getTerrainData(Se), wt = ht ? Se : null, Ct = wt ? wt.posMatrix : _.transform.calculatePosMatrix(Se.toUnwrapped(), fe), Dt = Mn(Ct, Ee || [0, 0], ct || 1, Ue, h);
          M instanceof bt ? z.draw(w, S.TRIANGLES, we, $i.disabled, R, Ci.disabled, Dt, ht, h.id, M.boundsBuffer, _.quadTriangleIndexBuffer, M.boundsSegments) : z.draw(w, S.TRIANGLES, we, W[Se.overscaledZ], R, Ci.disabled, Dt, ht, h.id, _.rasterBoundsBuffer, _.quadTriangleIndexBuffer, _.rasterBoundsSegments);
        }
      }, background: function(_, o, h, v) {
        const w = h.paint.get("background-color"), S = h.paint.get("background-opacity");
        if (S === 0) return;
        const M = _.context, z = M.gl, R = _.transform, W = R.tileSize, Q = h.paint.get("background-pattern");
        if (_.isPatternMissing(Q)) return;
        const J = !Q && w.a === 1 && S === 1 && _.opaquePassEnabledForLayer() ? "opaque" : "translucent";
        if (_.renderPass !== J) return;
        const fe = $i.disabled, Se = _.depthModeForSublayer(0, J === "opaque" ? kn.ReadWrite : kn.ReadOnly), we = _.colorModeForRenderPass(), Ce = _.useProgram(Q ? "backgroundPattern" : "background"), Me = v || R.coveringTiles({ tileSize: W, terrain: _.style.map.terrain });
        Q && (M.activeTexture.set(z.TEXTURE0), _.imageManager.bind(_.context));
        const Ue = h.getCrossfadeParameters();
        for (const ct of Me) {
          const Ee = v ? ct.posMatrix : _.transform.calculatePosMatrix(ct.toUnwrapped()), st = Q ? Yr(Ee, S, _, Q, { tileID: ct, tileSize: W }, Ue) : Gr(Ee, S, w), ht = _.style.map.terrain && _.style.map.terrain.getTerrainData(ct);
          Ce.draw(M, z.TRIANGLES, Se, fe, we, Ci.disabled, st, ht, h.id, _.tileExtentBuffer, _.quadTriangleIndexBuffer, _.tileExtentSegments);
        }
      }, debug: function(_, o, h) {
        for (let v = 0; v < h.length; v++) uo(_, o, h[v]);
      }, custom: function(_, o, h) {
        const v = _.context, w = h.implementation;
        if (_.renderPass === "offscreen") {
          const S = w.prerender;
          S && (_.setCustomLayerDefaults(), v.setColorMode(_.colorModeForRenderPass()), S.call(w, v.gl, _.transform.customLayerMatrix()), v.setDirty(), _.setBaseState());
        } else if (_.renderPass === "translucent") {
          _.setCustomLayerDefaults(), v.setColorMode(_.colorModeForRenderPass()), v.setStencilMode($i.disabled);
          const S = w.renderingMode === "3d" ? new kn(_.context.gl.LEQUAL, kn.ReadWrite, _.depthRangeFor3D) : _.depthModeForSublayer(0, kn.ReadOnly);
          v.setDepthMode(S), w.render(v.gl, _.transform.customLayerMatrix()), v.setDirty(), _.setBaseState(), v.bindFramebuffer.set(null);
        }
      } };
      class ip {
        constructor(o, h) {
          this.context = new ka(o), this.transform = h, this._tileTextures = {}, this.terrainFacilitator = { dirty: !0, matrix: a.create(), renderTime: 0 }, this.setup(), this.numSublayers = wn.maxUnderzooming + wn.maxOverzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.crossTileSymbolIndex = new Es();
        }
        resize(o, h, v) {
          if (this.width = o * v, this.height = h * v, this.pixelRatio = v, this.context.viewport.set([0, 0, this.width, this.height]), this.style) for (const w of this.style._order) this.style._layers[w].resize();
        }
        setup() {
          const o = this.context, h = new a.PosArray();
          h.emplaceBack(0, 0), h.emplaceBack(a.EXTENT, 0), h.emplaceBack(0, a.EXTENT), h.emplaceBack(a.EXTENT, a.EXTENT), this.tileExtentBuffer = o.createVertexBuffer(h, Hs.members), this.tileExtentSegments = a.SegmentVector.simpleSegment(0, 0, 4, 2);
          const v = new a.PosArray();
          v.emplaceBack(0, 0), v.emplaceBack(a.EXTENT, 0), v.emplaceBack(0, a.EXTENT), v.emplaceBack(a.EXTENT, a.EXTENT), this.debugBuffer = o.createVertexBuffer(v, Hs.members), this.debugSegments = a.SegmentVector.simpleSegment(0, 0, 4, 5);
          const w = new a.RasterBoundsArray();
          w.emplaceBack(0, 0, 0, 0), w.emplaceBack(a.EXTENT, 0, a.EXTENT, 0), w.emplaceBack(0, a.EXTENT, 0, a.EXTENT), w.emplaceBack(a.EXTENT, a.EXTENT, a.EXTENT, a.EXTENT), this.rasterBoundsBuffer = o.createVertexBuffer(w, dt.members), this.rasterBoundsSegments = a.SegmentVector.simpleSegment(0, 0, 4, 2);
          const S = new a.PosArray();
          S.emplaceBack(0, 0), S.emplaceBack(1, 0), S.emplaceBack(0, 1), S.emplaceBack(1, 1), this.viewportBuffer = o.createVertexBuffer(S, Hs.members), this.viewportSegments = a.SegmentVector.simpleSegment(0, 0, 4, 2);
          const M = new a.LineStripIndexArray();
          M.emplaceBack(0), M.emplaceBack(1), M.emplaceBack(3), M.emplaceBack(2), M.emplaceBack(0), this.tileBorderIndexBuffer = o.createIndexBuffer(M);
          const z = new a.TriangleIndexArray();
          z.emplaceBack(0, 1, 2), z.emplaceBack(2, 1, 3), this.quadTriangleIndexBuffer = o.createIndexBuffer(z);
          const R = this.context.gl;
          this.stencilClearMode = new $i({ func: R.ALWAYS, mask: 0 }, 0, 255, R.ZERO, R.ZERO, R.ZERO);
        }
        clearStencil() {
          const o = this.context, h = o.gl;
          this.nextStencilID = 1, this.currentStencilSource = void 0;
          const v = a.create();
          a.ortho(v, 0, this.width, this.height, 0, 0, 1), a.scale(v, v, [h.drawingBufferWidth, h.drawingBufferHeight, 0]), this.useProgram("clippingMask").draw(o, h.TRIANGLES, kn.disabled, this.stencilClearMode, Ui.disabled, Ci.disabled, Kl(v), null, "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
        }
        _renderTileClippingMasks(o, h) {
          if (this.currentStencilSource === o.source || !o.isTileClipped() || !h || !h.length) return;
          this.currentStencilSource = o.source;
          const v = this.context, w = v.gl;
          this.nextStencilID + h.length > 256 && this.clearStencil(), v.setColorMode(Ui.disabled), v.setDepthMode(kn.disabled);
          const S = this.useProgram("clippingMask");
          this._tileClippingMaskIDs = {};
          for (const M of h) {
            const z = this._tileClippingMaskIDs[M.key] = this.nextStencilID++, R = this.style.map.terrain && this.style.map.terrain.getTerrainData(M);
            S.draw(v, w.TRIANGLES, kn.disabled, new $i({ func: w.ALWAYS, mask: 0 }, z, 255, w.KEEP, w.KEEP, w.REPLACE), Ui.disabled, Ci.disabled, Kl(M.posMatrix), R, "$clipping", this.tileExtentBuffer, this.quadTriangleIndexBuffer, this.tileExtentSegments);
          }
        }
        stencilModeFor3D() {
          this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
          const o = this.nextStencilID++, h = this.context.gl;
          return new $i({ func: h.NOTEQUAL, mask: 255 }, o, 255, h.KEEP, h.KEEP, h.REPLACE);
        }
        stencilModeForClipping(o) {
          const h = this.context.gl;
          return new $i({ func: h.EQUAL, mask: 255 }, this._tileClippingMaskIDs[o.key], 0, h.KEEP, h.KEEP, h.REPLACE);
        }
        stencilConfigForOverlap(o) {
          const h = this.context.gl, v = o.sort((M, z) => z.overscaledZ - M.overscaledZ), w = v[v.length - 1].overscaledZ, S = v[0].overscaledZ - w + 1;
          if (S > 1) {
            this.currentStencilSource = void 0, this.nextStencilID + S > 256 && this.clearStencil();
            const M = {};
            for (let z = 0; z < S; z++) M[z + w] = new $i({ func: h.GEQUAL, mask: 255 }, z + this.nextStencilID, 255, h.KEEP, h.KEEP, h.REPLACE);
            return this.nextStencilID += S, [M, v];
          }
          return [{ [w]: $i.disabled }, v];
        }
        colorModeForRenderPass() {
          const o = this.context.gl;
          return this._showOverdrawInspector ? new Ui([o.CONSTANT_COLOR, o.ONE], new a.Color(0.125, 0.125, 0.125, 0), [!0, !0, !0, !0]) : this.renderPass === "opaque" ? Ui.unblended : Ui.alphaBlended;
        }
        depthModeForSublayer(o, h, v) {
          if (!this.opaquePassEnabledForLayer()) return kn.disabled;
          const w = 1 - ((1 + this.currentLayer) * this.numSublayers + o) * this.depthEpsilon;
          return new kn(v || this.context.gl.LEQUAL, h, [w, w]);
        }
        opaquePassEnabledForLayer() {
          return this.currentLayer < this.opaquePassCutoff;
        }
        render(o, h) {
          this.style = o, this.options = h, this.lineAtlas = o.lineAtlas, this.imageManager = o.imageManager, this.glyphManager = o.glyphManager, this.symbolFadeChange = o.placement.symbolFadeChange(a.exported.now()), this.imageManager.beginFrame();
          const v = this.style._order, w = this.style.sourceCaches, S = {}, M = {}, z = {};
          for (const R in w) {
            const W = w[R];
            W.used && W.prepare(this.context), S[R] = W.getVisibleCoordinates(), M[R] = S[R].slice().reverse(), z[R] = W.getVisibleCoordinates(!0).reverse();
          }
          this.opaquePassCutoff = 1 / 0;
          for (let R = 0; R < v.length; R++) if (this.style._layers[v[R]].is3D()) {
            this.opaquePassCutoff = R;
            break;
          }
          if (this.renderToTexture) {
            this.renderToTexture.prepareForRender(this.style, this.transform.zoom), this.opaquePassCutoff = 0;
            const R = this.style.map.terrain.sourceCache.tilesAfterTime(this.terrainFacilitator.renderTime);
            (this.terrainFacilitator.dirty || !a.equals(this.terrainFacilitator.matrix, this.transform.projMatrix) || R.length) && (a.copy(this.terrainFacilitator.matrix, this.transform.projMatrix), this.terrainFacilitator.renderTime = Date.now(), this.terrainFacilitator.dirty = !1, function(W, Q) {
              const J = W.context, fe = J.gl, Se = Ui.unblended, we = new kn(fe.LEQUAL, kn.ReadWrite, [0, 1]), Ce = Q.getTerrainMesh(), Me = Q.sourceCache.getRenderableTiles(), Ue = W.useProgram("terrainDepth");
              J.bindFramebuffer.set(Q.getFramebuffer("depth").framebuffer), J.viewport.set([0, 0, W.width / devicePixelRatio, W.height / devicePixelRatio]), J.clear({ color: a.Color.transparent, depth: 1 });
              for (const ct of Me) {
                const Ee = Q.getTerrainData(ct.tileID), st = { u_matrix: W.transform.calculatePosMatrix(ct.tileID.toUnwrapped()), u_ele_delta: Q.getMeshFrameDelta(W.transform.zoom) };
                Ue.draw(J, fe.TRIANGLES, we, $i.disabled, Se, Ci.backCCW, st, Ee, "terrain", Ce.vertexBuffer, Ce.indexBuffer, Ce.segments);
              }
              J.bindFramebuffer.set(null), J.viewport.set([0, 0, W.width, W.height]);
            }(this, this.style.map.terrain), function(W, Q) {
              const J = W.context, fe = J.gl, Se = Ui.unblended, we = new kn(fe.LEQUAL, kn.ReadWrite, [0, 1]), Ce = Q.getTerrainMesh(), Me = Q.getCoordsTexture(), Ue = Q.sourceCache.getRenderableTiles(), ct = W.useProgram("terrainCoords");
              J.bindFramebuffer.set(Q.getFramebuffer("coords").framebuffer), J.viewport.set([0, 0, W.width / devicePixelRatio, W.height / devicePixelRatio]), J.clear({ color: a.Color.transparent, depth: 1 }), Q.coordsIndex = [];
              for (const Ee of Ue) {
                const st = Q.getTerrainData(Ee.tileID);
                J.activeTexture.set(fe.TEXTURE0), fe.bindTexture(fe.TEXTURE_2D, Me.texture);
                const ht = { u_matrix: W.transform.calculatePosMatrix(Ee.tileID.toUnwrapped()), u_terrain_coords_id: (255 - Q.coordsIndex.length) / 255, u_texture: 0, u_ele_delta: Q.getMeshFrameDelta(W.transform.zoom) };
                ct.draw(J, fe.TRIANGLES, we, $i.disabled, Se, Ci.backCCW, ht, st, "terrain", Ce.vertexBuffer, Ce.indexBuffer, Ce.segments), Q.coordsIndex.push(Ee.tileID.key);
              }
              J.bindFramebuffer.set(null), J.viewport.set([0, 0, W.width, W.height]);
            }(this, this.style.map.terrain));
          }
          this.renderPass = "offscreen";
          for (const R of v) {
            const W = this.style._layers[R];
            if (!W.hasOffscreenPass() || W.isHidden(this.transform.zoom)) continue;
            const Q = M[W.source];
            (W.type === "custom" || Q.length) && this.renderLayer(this, w[W.source], W, Q);
          }
          if (this.context.bindFramebuffer.set(null), this.context.clear({ color: h.showOverdrawInspector ? a.Color.black : a.Color.transparent, depth: 1 }), this.clearStencil(), this._showOverdrawInspector = h.showOverdrawInspector, this.depthRangeFor3D = [0, 1 - (o._order.length + 2) * this.numSublayers * this.depthEpsilon], !this.renderToTexture) for (this.renderPass = "opaque", this.currentLayer = v.length - 1; this.currentLayer >= 0; this.currentLayer--) {
            const R = this.style._layers[v[this.currentLayer]], W = w[R.source], Q = S[R.source];
            this._renderTileClippingMasks(R, Q), this.renderLayer(this, W, R, Q);
          }
          for (this.renderPass = "translucent", this.currentLayer = 0; this.currentLayer < v.length; this.currentLayer++) {
            const R = this.style._layers[v[this.currentLayer]], W = w[R.source];
            if (this.renderToTexture && this.renderToTexture.renderLayer(R)) continue;
            const Q = (R.type === "symbol" ? z : M)[R.source];
            this._renderTileClippingMasks(R, S[R.source]), this.renderLayer(this, W, R, Q);
          }
          if (this.options.showTileBoundaries) {
            const R = function(W, Q) {
              let J = null;
              const fe = Object.values(W._layers).flatMap((Me) => Me.source && !Me.isHidden(Q) ? [W.sourceCaches[Me.source]] : []), Se = fe.filter((Me) => Me.getSource().type === "vector"), we = fe.filter((Me) => Me.getSource().type !== "vector"), Ce = (Me) => {
                (!J || J.getSource().maxzoom < Me.getSource().maxzoom) && (J = Me);
              };
              return Se.forEach((Me) => Ce(Me)), J || we.forEach((Me) => Ce(Me)), J;
            }(this.style, this.transform.zoom);
            R && Go.debug(this, R, R.getVisibleCoordinates());
          }
          this.options.showPadding && function(R) {
            const W = R.transform.padding;
            Sa(R, R.transform.height - (W.top || 0), 3, jo), Sa(R, W.bottom || 0, 3, Kr), Ta(R, W.left || 0, 3, np), Ta(R, R.transform.width - (W.right || 0), 3, co);
            const Q = R.transform.centerPoint;
            (function(J, fe, Se, we) {
              vl(J, fe - 1, Se - 10, 2, 20, we), vl(J, fe - 10, Se - 1, 20, 2, we);
            })(R, Q.x, R.transform.height - Q.y, ac);
          }(this), this.context.setDefault();
        }
        renderLayer(o, h, v, w) {
          v.isHidden(this.transform.zoom) || (v.type === "background" || v.type === "custom" || (w || []).length) && (this.id = v.id, Go[v.type](o, h, v, w, this.style.placement.variableOffsets));
        }
        translatePosMatrix(o, h, v, w, S) {
          if (!v[0] && !v[1]) return o;
          const M = S ? w === "map" ? this.transform.angle : 0 : w === "viewport" ? -this.transform.angle : 0;
          if (M) {
            const W = Math.sin(M), Q = Math.cos(M);
            v = [v[0] * Q - v[1] * W, v[0] * W + v[1] * Q];
          }
          const z = [S ? v[0] : ze(h, v[0], this.transform.zoom), S ? v[1] : ze(h, v[1], this.transform.zoom), 0], R = new Float32Array(16);
          return a.translate(R, o, z), R;
        }
        saveTileTexture(o) {
          const h = this._tileTextures[o.size[0]];
          h ? h.push(o) : this._tileTextures[o.size[0]] = [o];
        }
        getTileTexture(o) {
          const h = this._tileTextures[o];
          return h && h.length > 0 ? h.pop() : null;
        }
        isPatternMissing(o) {
          if (!o) return !1;
          if (!o.from || !o.to) return !0;
          const h = this.imageManager.getPattern(o.from.toString()), v = this.imageManager.getPattern(o.to.toString());
          return !h || !v;
        }
        useProgram(o, h) {
          this.cache = this.cache || {};
          const v = o + (h ? h.cacheKey : "") + (this._showOverdrawInspector ? "/overdraw" : "") + (this.style.map.terrain ? "/terrain" : "");
          return this.cache[v] || (this.cache[v] = new ko(this.context, o, Ps[o], h, So[o], this._showOverdrawInspector, this.style.map.terrain)), this.cache[v];
        }
        setCustomLayerDefaults() {
          this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
        }
        setBaseState() {
          const o = this.context.gl;
          this.context.cullFace.set(!1), this.context.viewport.set([0, 0, this.width, this.height]), this.context.blendEquation.set(o.FUNC_ADD);
        }
        initDebugOverlayCanvas() {
          this.debugOverlayCanvas == null && (this.debugOverlayCanvas = document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512, this.debugOverlayTexture = new ve(this.context, this.debugOverlayCanvas, this.context.gl.RGBA));
        }
        destroy() {
          this.debugOverlayTexture && this.debugOverlayTexture.destroy();
        }
      }
      class Ds {
        constructor(o, h) {
          this.points = o, this.planes = h;
        }
        static fromInvProjectionMatrix(o, h, v) {
          const w = Math.pow(2, v), S = [[-1, 1, -1, 1], [1, 1, -1, 1], [1, -1, -1, 1], [-1, -1, -1, 1], [-1, 1, 1, 1], [1, 1, 1, 1], [1, -1, 1, 1], [-1, -1, 1, 1]].map((z) => {
            const R = 1 / (z = a.transformMat4([], z, o))[3] / h * w;
            return a.mul$1(z, z, [R, R, 1 / z[3], R]);
          }), M = [[0, 1, 2], [6, 5, 4], [0, 3, 7], [2, 1, 5], [3, 2, 6], [0, 4, 5]].map((z) => {
            const R = function(fe, Se) {
              var we = Se[0], Ce = Se[1], Me = Se[2], Ue = we * we + Ce * Ce + Me * Me;
              return Ue > 0 && (Ue = 1 / Math.sqrt(Ue)), fe[0] = Se[0] * Ue, fe[1] = Se[1] * Ue, fe[2] = Se[2] * Ue, fe;
            }([], function(fe, Se, we) {
              var Ce = Se[0], Me = Se[1], Ue = Se[2], ct = we[0], Ee = we[1], st = we[2];
              return fe[0] = Me * st - Ue * Ee, fe[1] = Ue * ct - Ce * st, fe[2] = Ce * Ee - Me * ct, fe;
            }([], ae([], S[z[0]], S[z[1]]), ae([], S[z[2]], S[z[1]]))), W = -((Q = R)[0] * (J = S[z[1]])[0] + Q[1] * J[1] + Q[2] * J[2]);
            var Q, J;
            return R.concat(W);
          });
          return new Ds(S, M);
        }
      }
      class _s {
        constructor(o, h) {
          this.min = o, this.max = h, this.center = function(v, w, S) {
            return v[0] = 0.5 * w[0], v[1] = 0.5 * w[1], v[2] = 0.5 * w[2], v;
          }([], function(v, w, S) {
            return v[0] = w[0] + S[0], v[1] = w[1] + S[1], v[2] = w[2] + S[2], v;
          }([], this.min, this.max));
        }
        quadrant(o) {
          const h = [o % 2 == 0, o < 2], v = ee(this.min), w = ee(this.max);
          for (let S = 0; S < h.length; S++) v[S] = h[S] ? this.min[S] : this.center[S], w[S] = h[S] ? this.center[S] : this.max[S];
          return w[2] = this.max[2], new _s(v, w);
        }
        distanceX(o) {
          return Math.max(Math.min(this.max[0], o[0]), this.min[0]) - o[0];
        }
        distanceY(o) {
          return Math.max(Math.min(this.max[1], o[1]), this.min[1]) - o[1];
        }
        intersects(o) {
          const h = [[this.min[0], this.min[1], this.min[2], 1], [this.max[0], this.min[1], this.min[2], 1], [this.max[0], this.max[1], this.min[2], 1], [this.min[0], this.max[1], this.min[2], 1], [this.min[0], this.min[1], this.max[2], 1], [this.max[0], this.min[1], this.max[2], 1], [this.max[0], this.max[1], this.max[2], 1], [this.min[0], this.max[1], this.max[2], 1]];
          let v = !0;
          for (let w = 0; w < o.planes.length; w++) {
            const S = o.planes[w];
            let M = 0;
            for (let z = 0; z < h.length; z++) a.dot(S, h[z]) >= 0 && M++;
            if (M === 0) return 0;
            M !== h.length && (v = !1);
          }
          if (v) return 2;
          for (let w = 0; w < 3; w++) {
            let S = Number.MAX_VALUE, M = -Number.MAX_VALUE;
            for (let z = 0; z < o.points.length; z++) {
              const R = o.points[z][w] - this.min[w];
              S = Math.min(S, R), M = Math.max(M, R);
            }
            if (M < 0 || S > this.max[w] - this.min[w]) return 0;
          }
          return 1;
        }
      }
      class lc {
        constructor(o = 0, h = 0, v = 0, w = 0) {
          if (isNaN(o) || o < 0 || isNaN(h) || h < 0 || isNaN(v) || v < 0 || isNaN(w) || w < 0) throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
          this.top = o, this.bottom = h, this.left = v, this.right = w;
        }
        interpolate(o, h, v) {
          return h.top != null && o.top != null && (this.top = a.interpolate.number(o.top, h.top, v)), h.bottom != null && o.bottom != null && (this.bottom = a.interpolate.number(o.bottom, h.bottom, v)), h.left != null && o.left != null && (this.left = a.interpolate.number(o.left, h.left, v)), h.right != null && o.right != null && (this.right = a.interpolate.number(o.right, h.right, v)), this;
        }
        getCenter(o, h) {
          const v = a.clamp((this.left + o - this.right) / 2, 0, o), w = a.clamp((this.top + h - this.bottom) / 2, 0, h);
          return new a.Point(v, w);
        }
        equals(o) {
          return this.top === o.top && this.bottom === o.bottom && this.left === o.left && this.right === o.right;
        }
        clone() {
          return new lc(this.top, this.bottom, this.left, this.right);
        }
        toJSON() {
          return { top: this.top, bottom: this.bottom, left: this.left, right: this.right };
        }
      }
      class gl {
        constructor(o, h, v, w, S) {
          this.tileSize = 512, this.maxValidLatitude = 85.051129, this.freezeElevation = !1, this._renderWorldCopies = S === void 0 || !!S, this._minZoom = o || 0, this._maxZoom = h || 22, this._minPitch = v ?? 0, this._maxPitch = w ?? 60, this.setMaxBounds(), this.width = 0, this.height = 0, this._center = new a.LngLat(0, 0), this._elevation = 0, this.zoom = 0, this.angle = 0, this._fov = 0.6435011087932844, this._pitch = 0, this._unmodified = !0, this._edgeInsets = new lc(), this._posMatrixCache = {}, this._alignedPosMatrixCache = {};
        }
        clone() {
          const o = new gl(this._minZoom, this._maxZoom, this._minPitch, this.maxPitch, this._renderWorldCopies);
          return o.apply(this), o;
        }
        apply(o) {
          this.tileSize = o.tileSize, this.latRange = o.latRange, this.width = o.width, this.height = o.height, this._center = o._center, this._elevation = o._elevation, this.zoom = o.zoom, this.angle = o.angle, this._fov = o._fov, this._pitch = o._pitch, this._unmodified = o._unmodified, this._edgeInsets = o._edgeInsets.clone(), this._calcMatrices();
        }
        get minZoom() {
          return this._minZoom;
        }
        set minZoom(o) {
          this._minZoom !== o && (this._minZoom = o, this.zoom = Math.max(this.zoom, o));
        }
        get maxZoom() {
          return this._maxZoom;
        }
        set maxZoom(o) {
          this._maxZoom !== o && (this._maxZoom = o, this.zoom = Math.min(this.zoom, o));
        }
        get minPitch() {
          return this._minPitch;
        }
        set minPitch(o) {
          this._minPitch !== o && (this._minPitch = o, this.pitch = Math.max(this.pitch, o));
        }
        get maxPitch() {
          return this._maxPitch;
        }
        set maxPitch(o) {
          this._maxPitch !== o && (this._maxPitch = o, this.pitch = Math.min(this.pitch, o));
        }
        get renderWorldCopies() {
          return this._renderWorldCopies;
        }
        set renderWorldCopies(o) {
          o === void 0 ? o = !0 : o === null && (o = !1), this._renderWorldCopies = o;
        }
        get worldSize() {
          return this.tileSize * this.scale;
        }
        get centerOffset() {
          return this.centerPoint._sub(this.size._div(2));
        }
        get size() {
          return new a.Point(this.width, this.height);
        }
        get bearing() {
          return -this.angle / Math.PI * 180;
        }
        set bearing(o) {
          const h = -a.wrap(o, -180, 180) * Math.PI / 180;
          this.angle !== h && (this._unmodified = !1, this.angle = h, this._calcMatrices(), this.rotationMatrix = function() {
            var v = new a.ARRAY_TYPE(4);
            return a.ARRAY_TYPE != Float32Array && (v[1] = 0, v[2] = 0), v[0] = 1, v[3] = 1, v;
          }(), function(v, w, S) {
            var M = w[0], z = w[1], R = w[2], W = w[3], Q = Math.sin(S), J = Math.cos(S);
            v[0] = M * J + R * Q, v[1] = z * J + W * Q, v[2] = M * -Q + R * J, v[3] = z * -Q + W * J;
          }(this.rotationMatrix, this.rotationMatrix, this.angle));
        }
        get pitch() {
          return this._pitch / Math.PI * 180;
        }
        set pitch(o) {
          const h = a.clamp(o, this.minPitch, this.maxPitch) / 180 * Math.PI;
          this._pitch !== h && (this._unmodified = !1, this._pitch = h, this._calcMatrices());
        }
        get fov() {
          return this._fov / Math.PI * 180;
        }
        set fov(o) {
          o = Math.max(0.01, Math.min(60, o)), this._fov !== o && (this._unmodified = !1, this._fov = o / 180 * Math.PI, this._calcMatrices());
        }
        get zoom() {
          return this._zoom;
        }
        set zoom(o) {
          const h = Math.min(Math.max(o, this.minZoom), this.maxZoom);
          this._zoom !== h && (this._unmodified = !1, this._zoom = h, this.tileZoom = Math.max(0, Math.floor(h)), this.scale = this.zoomScale(h), this._constrain(), this._calcMatrices());
        }
        get center() {
          return this._center;
        }
        set center(o) {
          o.lat === this._center.lat && o.lng === this._center.lng || (this._unmodified = !1, this._center = o, this._constrain(), this._calcMatrices());
        }
        get elevation() {
          return this._elevation;
        }
        set elevation(o) {
          o !== this._elevation && (this._elevation = o, this._constrain(), this._calcMatrices());
        }
        get padding() {
          return this._edgeInsets.toJSON();
        }
        set padding(o) {
          this._edgeInsets.equals(o) || (this._unmodified = !1, this._edgeInsets.interpolate(this._edgeInsets, o, 1), this._calcMatrices());
        }
        get centerPoint() {
          return this._edgeInsets.getCenter(this.width, this.height);
        }
        isPaddingEqual(o) {
          return this._edgeInsets.equals(o);
        }
        interpolatePadding(o, h, v) {
          this._unmodified = !1, this._edgeInsets.interpolate(o, h, v), this._constrain(), this._calcMatrices();
        }
        coveringZoomLevel(o) {
          const h = (o.roundZoom ? Math.round : Math.floor)(this.zoom + this.scaleZoom(this.tileSize / o.tileSize));
          return Math.max(0, h);
        }
        getVisibleUnwrappedCoordinates(o) {
          const h = [new a.UnwrappedTileID(0, o)];
          if (this._renderWorldCopies) {
            const v = this.pointCoordinate(new a.Point(0, 0)), w = this.pointCoordinate(new a.Point(this.width, 0)), S = this.pointCoordinate(new a.Point(this.width, this.height)), M = this.pointCoordinate(new a.Point(0, this.height)), z = Math.floor(Math.min(v.x, w.x, S.x, M.x)), R = Math.floor(Math.max(v.x, w.x, S.x, M.x)), W = 1;
            for (let Q = z - W; Q <= R + W; Q++) Q !== 0 && h.push(new a.UnwrappedTileID(Q, o));
          }
          return h;
        }
        coveringTiles(o) {
          var h, v;
          let w = this.coveringZoomLevel(o);
          const S = w;
          if (o.minzoom !== void 0 && w < o.minzoom) return [];
          o.maxzoom !== void 0 && w > o.maxzoom && (w = o.maxzoom);
          const M = this.pointCoordinate(this.getCameraPoint()), z = a.MercatorCoordinate.fromLngLat(this.center), R = Math.pow(2, w), W = [R * M.x, R * M.y, 0], Q = [R * z.x, R * z.y, 0], J = Ds.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, w);
          let fe = o.minzoom || 0;
          !o.terrain && this.pitch <= 60 && this._edgeInsets.top < 0.1 && (fe = w);
          const Se = o.terrain ? 2 / Math.min(this.tileSize, o.tileSize) * this.tileSize : 3, we = (Ee) => ({ aabb: new _s([Ee * R, 0, 0], [(Ee + 1) * R, R, 0]), zoom: 0, x: 0, y: 0, wrap: Ee, fullyVisible: !1 }), Ce = [], Me = [], Ue = w, ct = o.reparseOverscaled ? S : w;
          if (this._renderWorldCopies) for (let Ee = 1; Ee <= 3; Ee++) Ce.push(we(-Ee)), Ce.push(we(Ee));
          for (Ce.push(we(0)); Ce.length > 0; ) {
            const Ee = Ce.pop(), st = Ee.x, ht = Ee.y;
            let wt = Ee.fullyVisible;
            if (!wt) {
              const fn = Ee.aabb.intersects(J);
              if (fn === 0) continue;
              wt = fn === 2;
            }
            const Ct = o.terrain ? W : Q, Dt = Ee.aabb.distanceX(Ct), xt = Ee.aabb.distanceY(Ct), Wt = Math.max(Math.abs(Dt), Math.abs(xt));
            if (Ee.zoom === Ue || Wt > Se + (1 << Ue - Ee.zoom) - 2 && Ee.zoom >= fe) {
              const fn = Ue - Ee.zoom, En = W[0] - 0.5 - (st << fn), Ot = W[1] - 0.5 - (ht << fn);
              Me.push({ tileID: new a.OverscaledTileID(Ee.zoom === Ue ? ct : Ee.zoom, Ee.wrap, Ee.zoom, st, ht), distanceSq: oe([Q[0] - 0.5 - st, Q[1] - 0.5 - ht]), tileDistanceToCamera: Math.sqrt(En * En + Ot * Ot) });
            } else for (let fn = 0; fn < 4; fn++) {
              const En = (st << 1) + fn % 2, Ot = (ht << 1) + (fn >> 1), xn = Ee.zoom + 1;
              let Gt = Ee.aabb.quadrant(fn);
              if (o.terrain) {
                const ni = new a.OverscaledTileID(xn, Ee.wrap, xn, En, Ot), cr = o.terrain.getMinMaxElevation(ni), ii = (h = cr.minElevation) !== null && h !== void 0 ? h : this.elevation, Dn = (v = cr.maxElevation) !== null && v !== void 0 ? v : this.elevation;
                Gt = new _s([Gt.min[0], Gt.min[1], ii], [Gt.max[0], Gt.max[1], Dn]);
              }
              Ce.push({ aabb: Gt, zoom: xn, x: En, y: Ot, wrap: Ee.wrap, fullyVisible: wt });
            }
          }
          return Me.sort((Ee, st) => Ee.distanceSq - st.distanceSq).map((Ee) => Ee.tileID);
        }
        resize(o, h) {
          this.width = o, this.height = h, this.pixelsToGLUnits = [2 / o, -2 / h], this._constrain(), this._calcMatrices();
        }
        get unmodified() {
          return this._unmodified;
        }
        zoomScale(o) {
          return Math.pow(2, o);
        }
        scaleZoom(o) {
          return Math.log(o) / Math.LN2;
        }
        project(o) {
          const h = a.clamp(o.lat, -this.maxValidLatitude, this.maxValidLatitude);
          return new a.Point(a.mercatorXfromLng(o.lng) * this.worldSize, a.mercatorYfromLat(h) * this.worldSize);
        }
        unproject(o) {
          return new a.MercatorCoordinate(o.x / this.worldSize, o.y / this.worldSize).toLngLat();
        }
        get point() {
          return this.project(this.center);
        }
        updateElevation(o) {
          this.freezeElevation || (this.elevation = o ? this.getElevation(this._center, o) : 0);
        }
        getElevation(o, h) {
          const v = a.MercatorCoordinate.fromLngLat(o.wrap()), w = (1 << this.tileZoom) * a.EXTENT, S = v.x * w, M = v.y * w, z = Math.floor(S / a.EXTENT), R = Math.floor(M / a.EXTENT), W = new a.OverscaledTileID(this.tileZoom, 0, this.tileZoom, z, R);
          return h.getElevation(W, S % a.EXTENT, M % a.EXTENT, a.EXTENT);
        }
        getCameraPosition() {
          return { lngLat: this.pointLocation(this.getCameraPoint()), altitude: Math.cos(this._pitch) * this.cameraToCenterDistance / this._pixelPerMeter + this.elevation };
        }
        recalculateZoom(o) {
          const h = this.pointLocation(this.centerPoint, o), v = this.getElevation(h, o);
          if (!(this.elevation - v)) return;
          const w = this.getCameraPosition(), S = a.MercatorCoordinate.fromLngLat(w.lngLat, w.altitude), M = a.MercatorCoordinate.fromLngLat(h, v), z = S.x - M.x, R = S.y - M.y, W = S.z - M.z, Q = Math.sqrt(z * z + R * R + W * W), J = this.scaleZoom(this.cameraToCenterDistance / Q / this.tileSize);
          this._elevation = v, this._center = h, this.zoom = J;
        }
        setLocationAtPoint(o, h) {
          const v = this.pointCoordinate(h), w = this.pointCoordinate(this.centerPoint), S = this.locationCoordinate(o), M = new a.MercatorCoordinate(S.x - (v.x - w.x), S.y - (v.y - w.y));
          this.center = this.coordinateLocation(M), this._renderWorldCopies && (this.center = this.center.wrap());
        }
        locationPoint(o, h) {
          return h ? this.coordinatePoint(this.locationCoordinate(o), this.getElevation(o, h), this.pixelMatrix3D) : this.coordinatePoint(this.locationCoordinate(o));
        }
        pointLocation(o, h) {
          return this.coordinateLocation(this.pointCoordinate(o, h));
        }
        locationCoordinate(o) {
          return a.MercatorCoordinate.fromLngLat(o);
        }
        coordinateLocation(o) {
          return o && o.toLngLat();
        }
        pointCoordinate(o, h) {
          if (h) {
            const fe = h.pointCoordinate(o);
            if (fe != null) return fe;
          }
          const v = [o.x, o.y, 0, 1], w = [o.x, o.y, 1, 1];
          a.transformMat4(v, v, this.pixelMatrixInverse), a.transformMat4(w, w, this.pixelMatrixInverse);
          const S = v[3], M = w[3], z = v[1] / S, R = w[1] / M, W = v[2] / S, Q = w[2] / M, J = W === Q ? 0 : (0 - W) / (Q - W);
          return new a.MercatorCoordinate(a.interpolate.number(v[0] / S, w[0] / M, J) / this.worldSize, a.interpolate.number(z, R, J) / this.worldSize);
        }
        coordinatePoint(o, h = 0, v = this.pixelMatrix) {
          const w = [o.x * this.worldSize, o.y * this.worldSize, h, 1];
          return a.transformMat4(w, w, v), new a.Point(w[0] / w[3], w[1] / w[3]);
        }
        getBounds() {
          const o = Math.max(0, this.height / 2 - this.getHorizon());
          return new Le().extend(this.pointLocation(new a.Point(0, o))).extend(this.pointLocation(new a.Point(this.width, o))).extend(this.pointLocation(new a.Point(this.width, this.height))).extend(this.pointLocation(new a.Point(0, this.height)));
        }
        getMaxBounds() {
          return this.latRange && this.latRange.length === 2 && this.lngRange && this.lngRange.length === 2 ? new Le([this.lngRange[0], this.latRange[0]], [this.lngRange[1], this.latRange[1]]) : null;
        }
        getHorizon() {
          return Math.tan(Math.PI / 2 - this._pitch) * this.cameraToCenterDistance * 0.85;
        }
        setMaxBounds(o) {
          o ? (this.lngRange = [o.getWest(), o.getEast()], this.latRange = [o.getSouth(), o.getNorth()], this._constrain()) : (this.lngRange = null, this.latRange = [-this.maxValidLatitude, this.maxValidLatitude]);
        }
        calculatePosMatrix(o, h = !1) {
          const v = o.key, w = h ? this._alignedPosMatrixCache : this._posMatrixCache;
          if (w[v]) return w[v];
          const S = o.canonical, M = this.worldSize / this.zoomScale(S.z), z = S.x + Math.pow(2, S.z) * o.wrap, R = a.identity(new Float64Array(16));
          return a.translate(R, R, [z * M, S.y * M, 0]), a.scale(R, R, [M / a.EXTENT, M / a.EXTENT, 1]), a.multiply(R, h ? this.alignedProjMatrix : this.projMatrix, R), w[v] = new Float32Array(R), w[v];
        }
        customLayerMatrix() {
          return this.mercatorMatrix.slice();
        }
        _constrain() {
          if (!this.center || !this.width || !this.height || this._constraining) return;
          this._constraining = !0;
          let o, h, v, w, S = -90, M = 90, z = -180, R = 180;
          const W = this.size, Q = this._unmodified;
          if (this.latRange) {
            const Se = this.latRange;
            S = a.mercatorYfromLat(Se[1]) * this.worldSize, M = a.mercatorYfromLat(Se[0]) * this.worldSize, o = M - S < W.y ? W.y / (M - S) : 0;
          }
          if (this.lngRange) {
            const Se = this.lngRange;
            z = a.wrap(a.mercatorXfromLng(Se[0]) * this.worldSize, 0, this.worldSize), R = a.wrap(a.mercatorXfromLng(Se[1]) * this.worldSize, 0, this.worldSize), R < z && (R += this.worldSize), h = R - z < W.x ? W.x / (R - z) : 0;
          }
          const J = this.point, fe = Math.max(h || 0, o || 0);
          if (fe) return this.center = this.unproject(new a.Point(h ? (R + z) / 2 : J.x, o ? (M + S) / 2 : J.y)), this.zoom += this.scaleZoom(fe), this._unmodified = Q, void (this._constraining = !1);
          if (this.latRange) {
            const Se = J.y, we = W.y / 2;
            Se - we < S && (w = S + we), Se + we > M && (w = M - we);
          }
          if (this.lngRange) {
            const Se = (z + R) / 2, we = a.wrap(J.x, Se - this.worldSize / 2, Se + this.worldSize / 2), Ce = W.x / 2;
            we - Ce < z && (v = z + Ce), we + Ce > R && (v = R - Ce);
          }
          v === void 0 && w === void 0 || (this.center = this.unproject(new a.Point(v !== void 0 ? v : J.x, w !== void 0 ? w : J.y)).wrap()), this._unmodified = Q, this._constraining = !1;
        }
        _calcMatrices() {
          if (!this.height) return;
          const o = this.centerOffset, h = this.point.x, v = this.point.y;
          this.cameraToCenterDistance = 0.5 / Math.tan(this._fov / 2) * this.height, this._pixelPerMeter = a.mercatorZfromAltitude(1, this.center.lat) * this.worldSize;
          let w = a.identity(new Float64Array(16));
          a.scale(w, w, [this.width / 2, -this.height / 2, 1]), a.translate(w, w, [1, -1, 0]), this.labelPlaneMatrix = w, w = a.identity(new Float64Array(16)), a.scale(w, w, [1, -1, 1]), a.translate(w, w, [-1, -1, 0]), a.scale(w, w, [2 / this.width, 2 / this.height, 1]), this.glCoordMatrix = w, this.cameraToSeaLevelDistance = this.cameraToCenterDistance + this._elevation * this._pixelPerMeter / Math.cos(this._pitch);
          const S = this._elevation < 0 ? this.cameraToCenterDistance : this.cameraToSeaLevelDistance, M = Math.PI / 2 + this._pitch, z = this._fov * (0.5 + o.y / this.height), R = Math.sin(z) * S / Math.sin(a.clamp(Math.PI - M - z, 0.01, Math.PI - 0.01)), W = this.getHorizon(), Q = 2 * Math.atan(W / this.cameraToCenterDistance) * (0.5 + o.y / (2 * W)), J = Math.sin(Q) * S / Math.sin(a.clamp(Math.PI - M - Q, 0.01, Math.PI - 0.01)), fe = Math.min(R, J), Se = 1.01 * (Math.cos(Math.PI / 2 - this._pitch) * fe + S), we = this.height / 50;
          w = new Float64Array(16), a.perspective(w, this._fov, this.width / this.height, we, Se), w[8] = 2 * -o.x / this.width, w[9] = 2 * o.y / this.height, a.scale(w, w, [1, -1, 1]), a.translate(w, w, [0, 0, -this.cameraToCenterDistance]), a.rotateX(w, w, this._pitch), a.rotateZ(w, w, this.angle), a.translate(w, w, [-h, -v, 0]), this.mercatorMatrix = a.scale([], w, [this.worldSize, this.worldSize, this.worldSize]), a.scale(w, w, [1, 1, this._pixelPerMeter]), this.pixelMatrix = a.multiply(new Float64Array(16), this.labelPlaneMatrix, w), a.translate(w, w, [0, 0, -this.elevation]), this.projMatrix = w, this.invProjMatrix = a.invert([], w), this.pixelMatrix3D = a.multiply(new Float64Array(16), this.labelPlaneMatrix, w);
          const Ce = this.width % 2 / 2, Me = this.height % 2 / 2, Ue = Math.cos(this.angle), ct = Math.sin(this.angle), Ee = h - Math.round(h) + Ue * Ce + ct * Me, st = v - Math.round(v) + Ue * Me + ct * Ce, ht = new Float64Array(w);
          if (a.translate(ht, ht, [Ee > 0.5 ? Ee - 1 : Ee, st > 0.5 ? st - 1 : st, 0]), this.alignedProjMatrix = ht, w = a.invert(new Float64Array(16), this.pixelMatrix), !w) throw new Error("failed to invert matrix");
          this.pixelMatrixInverse = w, this._posMatrixCache = {}, this._alignedPosMatrixCache = {};
        }
        maxPitchScaleFactor() {
          if (!this.pixelMatrixInverse) return 1;
          const o = this.pointCoordinate(new a.Point(0, 0)), h = [o.x * this.worldSize, o.y * this.worldSize, 0, 1];
          return a.transformMat4(h, h, this.pixelMatrix)[3] / this.cameraToCenterDistance;
        }
        getCameraPoint() {
          const o = Math.tan(this._pitch) * (this.cameraToCenterDistance || 1);
          return this.centerPoint.add(new a.Point(0, o));
        }
        getCameraQueryGeometry(o) {
          const h = this.getCameraPoint();
          if (o.length === 1) return [o[0], h];
          {
            let v = h.x, w = h.y, S = h.x, M = h.y;
            for (const z of o) v = Math.min(v, z.x), w = Math.min(w, z.y), S = Math.max(S, z.x), M = Math.max(M, z.y);
            return [new a.Point(v, w), new a.Point(S, w), new a.Point(S, M), new a.Point(v, M), new a.Point(v, w)];
          }
        }
      }
      class cc {
        constructor(o) {
          this._hashName = o && encodeURIComponent(o), a.bindAll(["_getCurrentHash", "_onHashChange", "_updateHash"], this), this._updateHash = /* @__PURE__ */ function(h, v) {
            let w = !1, S = null;
            const M = () => {
              S = null, w && (h(), S = setTimeout(M, 300), w = !1);
            };
            return () => (w = !0, S || M(), S);
          }(this._updateHashUnthrottled.bind(this));
        }
        addTo(o) {
          return this._map = o, addEventListener("hashchange", this._onHashChange, !1), this._map.on("moveend", this._updateHash), this;
        }
        remove() {
          return removeEventListener("hashchange", this._onHashChange, !1), this._map.off("moveend", this._updateHash), clearTimeout(this._updateHash()), delete this._map, this;
        }
        getHashString(o) {
          const h = this._map.getCenter(), v = Math.round(100 * this._map.getZoom()) / 100, w = Math.ceil((v * Math.LN2 + Math.log(512 / 360 / 0.5)) / Math.LN10), S = Math.pow(10, w), M = Math.round(h.lng * S) / S, z = Math.round(h.lat * S) / S, R = this._map.getBearing(), W = this._map.getPitch();
          let Q = "";
          if (Q += o ? `/${M}/${z}/${v}` : `${v}/${z}/${M}`, (R || W) && (Q += "/" + Math.round(10 * R) / 10), W && (Q += `/${Math.round(W)}`), this._hashName) {
            const J = this._hashName;
            let fe = !1;
            const Se = window.location.hash.slice(1).split("&").map((we) => {
              const Ce = we.split("=")[0];
              return Ce === J ? (fe = !0, `${Ce}=${Q}`) : we;
            }).filter((we) => we);
            return fe || Se.push(`${J}=${Q}`), `#${Se.join("&")}`;
          }
          return `#${Q}`;
        }
        _getCurrentHash() {
          const o = window.location.hash.replace("#", "");
          if (this._hashName) {
            let h;
            return o.split("&").map((v) => v.split("=")).forEach((v) => {
              v[0] === this._hashName && (h = v);
            }), (h && h[1] || "").split("/");
          }
          return o.split("/");
        }
        _onHashChange() {
          const o = this._getCurrentHash();
          if (o.length >= 3 && !o.some((h) => isNaN(h))) {
            const h = this._map.dragRotate.isEnabled() && this._map.touchZoomRotate.isEnabled() ? +(o[3] || 0) : this._map.getBearing();
            return this._map.jumpTo({ center: [+o[2], +o[1]], zoom: +o[0], bearing: h, pitch: +(o[4] || 0) }), !0;
          }
          return !1;
        }
        _updateHashUnthrottled() {
          const o = window.location.href.replace(/(#.+)?$/, this.getHashString());
          try {
            window.history.replaceState(window.history.state, null, o);
          } catch {
          }
        }
      }
      const Ia = { linearity: 0.3, easing: a.bezier(0, 0, 0.3, 1) }, uc = a.extend({ deceleration: 2500, maxSpeed: 1400 }, Ia), Aa = a.extend({ deceleration: 20, maxSpeed: 1400 }, Ia), Ea = a.extend({ deceleration: 1e3, maxSpeed: 360 }, Ia), Xc = a.extend({ deceleration: 1e3, maxSpeed: 90 }, Ia);
      class js {
        constructor(o) {
          this._map = o, this.clear();
        }
        clear() {
          this._inertiaBuffer = [];
        }
        record(o) {
          this._drainInertiaBuffer(), this._inertiaBuffer.push({ time: a.exported.now(), settings: o });
        }
        _drainInertiaBuffer() {
          const o = this._inertiaBuffer, h = a.exported.now();
          for (; o.length > 0 && h - o[0].time > 160; ) o.shift();
        }
        _onMoveEnd(o) {
          if (this._drainInertiaBuffer(), this._inertiaBuffer.length < 2) return;
          const h = { zoom: 0, bearing: 0, pitch: 0, pan: new a.Point(0, 0), pinchAround: void 0, around: void 0 };
          for (const { settings: S } of this._inertiaBuffer) h.zoom += S.zoomDelta || 0, h.bearing += S.bearingDelta || 0, h.pitch += S.pitchDelta || 0, S.panDelta && h.pan._add(S.panDelta), S.around && (h.around = S.around), S.pinchAround && (h.pinchAround = S.pinchAround);
          const v = this._inertiaBuffer[this._inertiaBuffer.length - 1].time - this._inertiaBuffer[0].time, w = {};
          if (h.pan.mag()) {
            const S = Yo(h.pan.mag(), v, a.extend({}, uc, o || {}));
            w.offset = h.pan.mult(S.amount / h.pan.mag()), w.center = this._map.transform.center, Ls(w, S);
          }
          if (h.zoom) {
            const S = Yo(h.zoom, v, Aa);
            w.zoom = this._map.transform.zoom + S.amount, Ls(w, S);
          }
          if (h.bearing) {
            const S = Yo(h.bearing, v, Ea);
            w.bearing = this._map.transform.bearing + a.clamp(S.amount, -179, 179), Ls(w, S);
          }
          if (h.pitch) {
            const S = Yo(h.pitch, v, Xc);
            w.pitch = this._map.transform.pitch + S.amount, Ls(w, S);
          }
          if (w.zoom || w.bearing) {
            const S = h.pinchAround === void 0 ? h.around : h.pinchAround;
            w.around = S ? this._map.unproject(S) : this._map.getCenter();
          }
          return this.clear(), a.extend(w, { noMoveStart: !0 });
        }
      }
      function Ls(_, o) {
        (!_.duration || _.duration < o.duration) && (_.duration = o.duration, _.easing = o.easing);
      }
      function Yo(_, o, h) {
        const { maxSpeed: v, linearity: w, deceleration: S } = h, M = a.clamp(_ * w / (o / 1e3), -v, v), z = Math.abs(M) / (S * w);
        return { easing: h.easing, duration: 1e3 * z, amount: M * (z / 2) };
      }
      class nr extends a.Event {
        preventDefault() {
          this._defaultPrevented = !0;
        }
        get defaultPrevented() {
          return this._defaultPrevented;
        }
        constructor(o, h, v, w = {}) {
          const S = g.mousePos(h.getCanvasContainer(), v), M = h.unproject(S);
          super(o, a.extend({ point: S, lngLat: M, originalEvent: v }, w)), this._defaultPrevented = !1, this.target = h;
        }
      }
      class To extends a.Event {
        preventDefault() {
          this._defaultPrevented = !0;
        }
        get defaultPrevented() {
          return this._defaultPrevented;
        }
        constructor(o, h, v) {
          const w = o === "touchend" ? v.changedTouches : v.touches, S = g.touchPos(h.getCanvasContainer(), w), M = S.map((R) => h.unproject(R)), z = S.reduce((R, W, Q, J) => R.add(W.div(J.length)), new a.Point(0, 0));
          super(o, { points: S, point: z, lngLats: M, lngLat: h.unproject(z), originalEvent: v }), this._defaultPrevented = !1;
        }
      }
      class af extends a.Event {
        preventDefault() {
          this._defaultPrevented = !0;
        }
        get defaultPrevented() {
          return this._defaultPrevented;
        }
        constructor(o, h, v) {
          super(o, { originalEvent: v }), this._defaultPrevented = !1;
        }
      }
      class rp {
        constructor(o, h) {
          this._map = o, this._clickTolerance = h.clickTolerance;
        }
        reset() {
          delete this._mousedownPos;
        }
        wheel(o) {
          return this._firePreventable(new af(o.type, this._map, o));
        }
        mousedown(o, h) {
          return this._mousedownPos = h, this._firePreventable(new nr(o.type, this._map, o));
        }
        mouseup(o) {
          this._map.fire(new nr(o.type, this._map, o));
        }
        click(o, h) {
          this._mousedownPos && this._mousedownPos.dist(h) >= this._clickTolerance || this._map.fire(new nr(o.type, this._map, o));
        }
        dblclick(o) {
          return this._firePreventable(new nr(o.type, this._map, o));
        }
        mouseover(o) {
          this._map.fire(new nr(o.type, this._map, o));
        }
        mouseout(o) {
          this._map.fire(new nr(o.type, this._map, o));
        }
        touchstart(o) {
          return this._firePreventable(new To(o.type, this._map, o));
        }
        touchmove(o) {
          this._map.fire(new To(o.type, this._map, o));
        }
        touchend(o) {
          this._map.fire(new To(o.type, this._map, o));
        }
        touchcancel(o) {
          this._map.fire(new To(o.type, this._map, o));
        }
        _firePreventable(o) {
          if (this._map.fire(o), o.defaultPrevented) return {};
        }
        isEnabled() {
          return !0;
        }
        isActive() {
          return !1;
        }
        enable() {
        }
        disable() {
        }
      }
      class lf {
        constructor(o) {
          this._map = o;
        }
        reset() {
          this._delayContextMenu = !1, this._ignoreContextMenu = !0, delete this._contextMenuEvent;
        }
        mousemove(o) {
          this._map.fire(new nr(o.type, this._map, o));
        }
        mousedown() {
          this._delayContextMenu = !0, this._ignoreContextMenu = !1;
        }
        mouseup() {
          this._delayContextMenu = !1, this._contextMenuEvent && (this._map.fire(new nr("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
        }
        contextmenu(o) {
          this._delayContextMenu ? this._contextMenuEvent = o : this._ignoreContextMenu || this._map.fire(new nr(o.type, this._map, o)), this._map.listens("contextmenu") && o.preventDefault();
        }
        isEnabled() {
          return !0;
        }
        isActive() {
          return !1;
        }
        enable() {
        }
        disable() {
        }
      }
      class Xr {
        constructor(o) {
          this._map = o;
        }
        get transform() {
          return this._map._requestedCameraState || this._map.transform;
        }
        get center() {
          return { lng: this.transform.center.lng, lat: this.transform.center.lat };
        }
        get zoom() {
          return this.transform.zoom;
        }
        get pitch() {
          return this.transform.pitch;
        }
        get bearing() {
          return this.transform.bearing;
        }
        unproject(o) {
          return this.transform.pointLocation(a.Point.convert(o), this._map.terrain);
        }
      }
      class Ko {
        constructor(o, h) {
          this._map = o, this._tr = new Xr(o), this._el = o.getCanvasContainer(), this._container = o.getContainer(), this._clickTolerance = h.clickTolerance || 1;
        }
        isEnabled() {
          return !!this._enabled;
        }
        isActive() {
          return !!this._active;
        }
        enable() {
          this.isEnabled() || (this._enabled = !0);
        }
        disable() {
          this.isEnabled() && (this._enabled = !1);
        }
        mousedown(o, h) {
          this.isEnabled() && o.shiftKey && o.button === 0 && (g.disableDrag(), this._startPos = this._lastPos = h, this._active = !0);
        }
        mousemoveWindow(o, h) {
          if (!this._active) return;
          const v = h;
          if (this._lastPos.equals(v) || !this._box && v.dist(this._startPos) < this._clickTolerance) return;
          const w = this._startPos;
          this._lastPos = v, this._box || (this._box = g.create("div", "maplibregl-boxzoom", this._container), this._container.classList.add("maplibregl-crosshair"), this._fireEvent("boxzoomstart", o));
          const S = Math.min(w.x, v.x), M = Math.max(w.x, v.x), z = Math.min(w.y, v.y), R = Math.max(w.y, v.y);
          g.setTransform(this._box, `translate(${S}px,${z}px)`), this._box.style.width = M - S + "px", this._box.style.height = R - z + "px";
        }
        mouseupWindow(o, h) {
          if (!this._active || o.button !== 0) return;
          const v = this._startPos, w = h;
          if (this.reset(), g.suppressClick(), v.x !== w.x || v.y !== w.y) return this._map.fire(new a.Event("boxzoomend", { originalEvent: o })), { cameraAnimation: (S) => S.fitScreenCoordinates(v, w, this._tr.bearing, { linear: !0 }) };
          this._fireEvent("boxzoomcancel", o);
        }
        keydown(o) {
          this._active && o.keyCode === 27 && (this.reset(), this._fireEvent("boxzoomcancel", o));
        }
        reset() {
          this._active = !1, this._container.classList.remove("maplibregl-crosshair"), this._box && (g.remove(this._box), this._box = null), g.enableDrag(), delete this._startPos, delete this._lastPos;
        }
        _fireEvent(o, h) {
          return this._map.fire(new a.Event(o, { originalEvent: h }));
        }
      }
      function po(_, o) {
        if (_.length !== o.length) throw new Error(`The number of touches and points are not equal - touches ${_.length}, points ${o.length}`);
        const h = {};
        for (let v = 0; v < _.length; v++) h[_[v].identifier] = o[v];
        return h;
      }
      class Zt {
        constructor(o) {
          this.reset(), this.numTouches = o.numTouches;
        }
        reset() {
          delete this.centroid, delete this.startTime, delete this.touches, this.aborted = !1;
        }
        touchstart(o, h, v) {
          (this.centroid || v.length > this.numTouches) && (this.aborted = !0), this.aborted || (this.startTime === void 0 && (this.startTime = o.timeStamp), v.length === this.numTouches && (this.centroid = function(w) {
            const S = new a.Point(0, 0);
            for (const M of w) S._add(M);
            return S.div(w.length);
          }(h), this.touches = po(v, h)));
        }
        touchmove(o, h, v) {
          if (this.aborted || !this.centroid) return;
          const w = po(v, h);
          for (const S in this.touches) {
            const M = w[S];
            (!M || M.dist(this.touches[S]) > 30) && (this.aborted = !0);
          }
        }
        touchend(o, h, v) {
          if ((!this.centroid || o.timeStamp - this.startTime > 500) && (this.aborted = !0), v.length === 0) {
            const w = !this.aborted && this.centroid;
            if (this.reset(), w) return w;
          }
        }
      }
      class Jc {
        constructor(o) {
          this.singleTap = new Zt(o), this.numTaps = o.numTaps, this.reset();
        }
        reset() {
          this.lastTime = 1 / 0, delete this.lastTap, this.count = 0, this.singleTap.reset();
        }
        touchstart(o, h, v) {
          this.singleTap.touchstart(o, h, v);
        }
        touchmove(o, h, v) {
          this.singleTap.touchmove(o, h, v);
        }
        touchend(o, h, v) {
          const w = this.singleTap.touchend(o, h, v);
          if (w) {
            const S = o.timeStamp - this.lastTime < 500, M = !this.lastTap || this.lastTap.dist(w) < 30;
            if (S && M || this.reset(), this.count++, this.lastTime = o.timeStamp, this.lastTap = w, this.count === this.numTaps) return this.reset(), w;
          }
        }
      }
      class yl {
        constructor(o) {
          this._tr = new Xr(o), this._zoomIn = new Jc({ numTouches: 1, numTaps: 2 }), this._zoomOut = new Jc({ numTouches: 2, numTaps: 1 }), this.reset();
        }
        reset() {
          this._active = !1, this._zoomIn.reset(), this._zoomOut.reset();
        }
        touchstart(o, h, v) {
          this._zoomIn.touchstart(o, h, v), this._zoomOut.touchstart(o, h, v);
        }
        touchmove(o, h, v) {
          this._zoomIn.touchmove(o, h, v), this._zoomOut.touchmove(o, h, v);
        }
        touchend(o, h, v) {
          const w = this._zoomIn.touchend(o, h, v), S = this._zoomOut.touchend(o, h, v), M = this._tr;
          return w ? (this._active = !0, o.preventDefault(), setTimeout(() => this.reset(), 0), { cameraAnimation: (z) => z.easeTo({ duration: 300, zoom: M.zoom + 1, around: M.unproject(w) }, { originalEvent: o }) }) : S ? (this._active = !0, o.preventDefault(), setTimeout(() => this.reset(), 0), { cameraAnimation: (z) => z.easeTo({ duration: 300, zoom: M.zoom - 1, around: M.unproject(S) }, { originalEvent: o }) }) : void 0;
        }
        touchcancel() {
          this.reset();
        }
        enable() {
          this._enabled = !0;
        }
        disable() {
          this._enabled = !1, this.reset();
        }
        isEnabled() {
          return this._enabled;
        }
        isActive() {
          return this._active;
        }
      }
      class Io {
        constructor(o) {
          this._enabled = !!o.enable, this._moveStateManager = o.moveStateManager, this._clickTolerance = o.clickTolerance || 1, this._moveFunction = o.move, this._activateOnStart = !!o.activateOnStart, o.assignEvents(this), this.reset();
        }
        reset(o) {
          this._active = !1, this._moved = !1, delete this._lastPoint, this._moveStateManager.endMove(o);
        }
        _move(...o) {
          const h = this._moveFunction(...o);
          if (h.bearingDelta || h.pitchDelta || h.around || h.panDelta) return this._active = !0, h;
        }
        dragStart(o, h) {
          this.isEnabled() && !this._lastPoint && this._moveStateManager.isValidStartEvent(o) && (this._moveStateManager.startMove(o), this._lastPoint = h.length ? h[0] : h, this._activateOnStart && this._lastPoint && (this._active = !0));
        }
        dragMove(o, h) {
          if (!this.isEnabled()) return;
          const v = this._lastPoint;
          if (!v) return;
          if (o.preventDefault(), !this._moveStateManager.isValidMoveEvent(o)) return void this.reset(o);
          const w = h.length ? h[0] : h;
          return !this._moved && w.dist(v) < this._clickTolerance ? void 0 : (this._moved = !0, this._lastPoint = w, this._move(v, w));
        }
        dragEnd(o) {
          this.isEnabled() && this._lastPoint && this._moveStateManager.isValidEndEvent(o) && (this._moved && g.suppressClick(), this.reset(o));
        }
        enable() {
          this._enabled = !0;
        }
        disable() {
          this._enabled = !1, this.reset();
        }
        isEnabled() {
          return this._enabled;
        }
        isActive() {
          return this._active;
        }
        getClickTolerance() {
          return this._clickTolerance;
        }
      }
      const _l = { 0: 1, 2: 2 };
      class Rt {
        constructor(o) {
          this._correctEvent = o.checkCorrectEvent;
        }
        startMove(o) {
          const h = g.mouseButton(o);
          this._eventButton = h;
        }
        endMove(o) {
          delete this._eventButton;
        }
        isValidStartEvent(o) {
          return this._correctEvent(o);
        }
        isValidMoveEvent(o) {
          return !function(h, v) {
            const w = _l[v];
            return h.buttons === void 0 || (h.buttons & w) !== w;
          }(o, this._eventButton);
        }
        isValidEndEvent(o) {
          return g.mouseButton(o) === this._eventButton;
        }
      }
      class Ao {
        constructor() {
          this._firstTouch = void 0;
        }
        _isOneFingerTouch(o) {
          return o.targetTouches.length === 1;
        }
        _isSameTouchEvent(o) {
          return o.targetTouches[0].identifier === this._firstTouch;
        }
        startMove(o) {
          this._firstTouch = o.targetTouches[0].identifier;
        }
        endMove(o) {
          delete this._firstTouch;
        }
        isValidStartEvent(o) {
          return this._isOneFingerTouch(o);
        }
        isValidMoveEvent(o) {
          return this._isOneFingerTouch(o) && this._isSameTouchEvent(o);
        }
        isValidEndEvent(o) {
          return this._isOneFingerTouch(o) && this._isSameTouchEvent(o);
        }
      }
      const Qc = (_) => {
        _.mousedown = _.dragStart, _.mousemoveWindow = _.dragMove, _.mouseup = _.dragEnd, _.contextmenu = function(o) {
          o.preventDefault();
        };
      }, td = ({ enable: _, clickTolerance: o, bearingDegreesPerPixelMoved: h = 0.8 }) => {
        const v = new Rt({ checkCorrectEvent: (w) => g.mouseButton(w) === 0 && w.ctrlKey || g.mouseButton(w) === 2 });
        return new Io({ clickTolerance: o, move: (w, S) => ({ bearingDelta: (S.x - w.x) * h }), moveStateManager: v, enable: _, assignEvents: Qc });
      }, eu = ({ enable: _, clickTolerance: o, pitchDegreesPerPixelMoved: h = -0.5 }) => {
        const v = new Rt({ checkCorrectEvent: (w) => g.mouseButton(w) === 0 && w.ctrlKey || g.mouseButton(w) === 2 });
        return new Io({ clickTolerance: o, move: (w, S) => ({ pitchDelta: (S.y - w.y) * h }), moveStateManager: v, enable: _, assignEvents: Qc });
      };
      class ho {
        constructor(o, h) {
          this._minTouches = o.cooperativeGestures ? 2 : 1, this._clickTolerance = o.clickTolerance || 1, this._map = h, this.reset();
        }
        reset() {
          this._active = !1, this._touches = {}, this._sum = new a.Point(0, 0), setTimeout(() => {
            this._cancelCooperativeMessage = !1;
          }, 200);
        }
        touchstart(o, h, v) {
          return this._calculateTransform(o, h, v);
        }
        touchmove(o, h, v) {
          if (this._map._cooperativeGestures && (this._minTouches === 2 && v.length < 2 && !this._cancelCooperativeMessage ? this._map._onCooperativeGesture(o, !1, v.length) : this._cancelCooperativeMessage || (this._cancelCooperativeMessage = !0)), this._active && !(v.length < this._minTouches)) return o.preventDefault(), this._calculateTransform(o, h, v);
        }
        touchend(o, h, v) {
          this._calculateTransform(o, h, v), this._active && v.length < this._minTouches && this.reset();
        }
        touchcancel() {
          this.reset();
        }
        _calculateTransform(o, h, v) {
          v.length > 0 && (this._active = !0);
          const w = po(v, h), S = new a.Point(0, 0), M = new a.Point(0, 0);
          let z = 0;
          for (const W in w) {
            const Q = w[W], J = this._touches[W];
            J && (S._add(Q), M._add(Q.sub(J)), z++, w[W] = Q);
          }
          if (this._touches = w, z < this._minTouches || !M.mag()) return;
          const R = M.div(z);
          return this._sum._add(R), this._sum.mag() < this._clickTolerance ? void 0 : { around: S.div(z), panDelta: R };
        }
        enable() {
          this._enabled = !0;
        }
        disable() {
          this._enabled = !1, this.reset();
        }
        isEnabled() {
          return this._enabled;
        }
        isActive() {
          return this._active;
        }
      }
      class dc {
        constructor() {
          this.reset();
        }
        reset() {
          this._active = !1, delete this._firstTwoTouches;
        }
        _start(o) {
        }
        _move(o, h, v) {
          return {};
        }
        touchstart(o, h, v) {
          this._firstTwoTouches || v.length < 2 || (this._firstTwoTouches = [v[0].identifier, v[1].identifier], this._start([h[0], h[1]]));
        }
        touchmove(o, h, v) {
          if (!this._firstTwoTouches) return;
          o.preventDefault();
          const [w, S] = this._firstTwoTouches, M = pc(v, h, w), z = pc(v, h, S);
          if (!M || !z) return;
          const R = this._aroundCenter ? null : M.add(z).div(2);
          return this._move([M, z], R, o);
        }
        touchend(o, h, v) {
          if (!this._firstTwoTouches) return;
          const [w, S] = this._firstTwoTouches, M = pc(v, h, w), z = pc(v, h, S);
          M && z || (this._active && g.suppressClick(), this.reset());
        }
        touchcancel() {
          this.reset();
        }
        enable(o) {
          this._enabled = !0, this._aroundCenter = !!o && o.around === "center";
        }
        disable() {
          this._enabled = !1, this.reset();
        }
        isEnabled() {
          return this._enabled;
        }
        isActive() {
          return this._active;
        }
      }
      function pc(_, o, h) {
        for (let v = 0; v < _.length; v++) if (_[v].identifier === h) return o[v];
      }
      function bl(_, o) {
        return Math.log(_ / o) / Math.LN2;
      }
      class nd extends dc {
        reset() {
          super.reset(), delete this._distance, delete this._startDistance;
        }
        _start(o) {
          this._startDistance = this._distance = o[0].dist(o[1]);
        }
        _move(o, h) {
          const v = this._distance;
          if (this._distance = o[0].dist(o[1]), this._active || !(Math.abs(bl(this._distance, this._startDistance)) < 0.1)) return this._active = !0, { zoomDelta: bl(this._distance, v), pinchAround: h };
        }
      }
      function Pa(_, o) {
        return 180 * _.angleWith(o) / Math.PI;
      }
      class Ma extends dc {
        reset() {
          super.reset(), delete this._minDiameter, delete this._startVector, delete this._vector;
        }
        _start(o) {
          this._startVector = this._vector = o[0].sub(o[1]), this._minDiameter = o[0].dist(o[1]);
        }
        _move(o, h) {
          const v = this._vector;
          if (this._vector = o[0].sub(o[1]), this._active || !this._isBelowThreshold(this._vector)) return this._active = !0, { bearingDelta: Pa(this._vector, v), pinchAround: h };
        }
        _isBelowThreshold(o) {
          this._minDiameter = Math.min(this._minDiameter, o.mag());
          const h = 25 / (Math.PI * this._minDiameter) * 360, v = Pa(o, this._startVector);
          return Math.abs(v) < h;
        }
      }
      function wl(_) {
        return Math.abs(_.y) > Math.abs(_.x);
      }
      class Jr extends dc {
        constructor(o) {
          super(), this._map = o;
        }
        reset() {
          super.reset(), this._valid = void 0, delete this._firstMove, delete this._lastPoints;
        }
        touchstart(o, h, v) {
          super.touchstart(o, h, v), this._currentTouchCount = v.length;
        }
        _start(o) {
          this._lastPoints = o, wl(o[0].sub(o[1])) && (this._valid = !1);
        }
        _move(o, h, v) {
          if (this._map._cooperativeGestures && this._currentTouchCount < 3) return;
          const w = o[0].sub(this._lastPoints[0]), S = o[1].sub(this._lastPoints[1]);
          return this._valid = this.gestureBeginsVertically(w, S, v.timeStamp), this._valid ? (this._lastPoints = o, this._active = !0, { pitchDelta: (w.y + S.y) / 2 * -0.5 }) : void 0;
        }
        gestureBeginsVertically(o, h, v) {
          if (this._valid !== void 0) return this._valid;
          const w = o.mag() >= 2, S = h.mag() >= 2;
          if (!w && !S) return;
          if (!w || !S) return this._firstMove === void 0 && (this._firstMove = v), v - this._firstMove < 100 && void 0;
          const M = o.y > 0 == h.y > 0;
          return wl(o) && wl(h) && M;
        }
      }
      const Xo = { panStep: 100, bearingStep: 15, pitchStep: 10 };
      class id {
        constructor(o) {
          this._tr = new Xr(o);
          const h = Xo;
          this._panStep = h.panStep, this._bearingStep = h.bearingStep, this._pitchStep = h.pitchStep, this._rotationDisabled = !1;
        }
        reset() {
          this._active = !1;
        }
        keydown(o) {
          if (o.altKey || o.ctrlKey || o.metaKey) return;
          let h = 0, v = 0, w = 0, S = 0, M = 0;
          switch (o.keyCode) {
            case 61:
            case 107:
            case 171:
            case 187:
              h = 1;
              break;
            case 189:
            case 109:
            case 173:
              h = -1;
              break;
            case 37:
              o.shiftKey ? v = -1 : (o.preventDefault(), S = -1);
              break;
            case 39:
              o.shiftKey ? v = 1 : (o.preventDefault(), S = 1);
              break;
            case 38:
              o.shiftKey ? w = 1 : (o.preventDefault(), M = -1);
              break;
            case 40:
              o.shiftKey ? w = -1 : (o.preventDefault(), M = 1);
              break;
            default:
              return;
          }
          return this._rotationDisabled && (v = 0, w = 0), { cameraAnimation: (z) => {
            const R = this._tr;
            z.easeTo({ duration: 300, easeId: "keyboardHandler", easing: tu, zoom: h ? Math.round(R.zoom) + h * (o.shiftKey ? 2 : 1) : R.zoom, bearing: R.bearing + v * this._bearingStep, pitch: R.pitch + w * this._pitchStep, offset: [-S * this._panStep, -M * this._panStep], center: R.center }, { originalEvent: o });
          } };
        }
        enable() {
          this._enabled = !0;
        }
        disable() {
          this._enabled = !1, this.reset();
        }
        isEnabled() {
          return this._enabled;
        }
        isActive() {
          return this._active;
        }
        disableRotation() {
          this._rotationDisabled = !0;
        }
        enableRotation() {
          this._rotationDisabled = !1;
        }
      }
      function tu(_) {
        return _ * (2 - _);
      }
      const hc = 4.000244140625;
      class nu {
        constructor(o, h) {
          this._map = o, this._tr = new Xr(o), this._el = o.getCanvasContainer(), this._handler = h, this._delta = 0, this._defaultZoomRate = 0.01, this._wheelZoomRate = 0.0022222222222222222, a.bindAll(["_onTimeout"], this);
        }
        setZoomRate(o) {
          this._defaultZoomRate = o;
        }
        setWheelZoomRate(o) {
          this._wheelZoomRate = o;
        }
        isEnabled() {
          return !!this._enabled;
        }
        isActive() {
          return !!this._active || this._finishTimeout !== void 0;
        }
        isZooming() {
          return !!this._zooming;
        }
        enable(o) {
          this.isEnabled() || (this._enabled = !0, this._aroundCenter = o && o.around === "center");
        }
        disable() {
          this.isEnabled() && (this._enabled = !1);
        }
        wheel(o) {
          if (!this.isEnabled()) return;
          if (this._map._cooperativeGestures) {
            if (!o[this._map._metaKey]) return;
            o.preventDefault();
          }
          let h = o.deltaMode === WheelEvent.DOM_DELTA_LINE ? 40 * o.deltaY : o.deltaY;
          const v = a.exported.now(), w = v - (this._lastWheelEventTime || 0);
          this._lastWheelEventTime = v, h !== 0 && h % hc == 0 ? this._type = "wheel" : h !== 0 && Math.abs(h) < 4 ? this._type = "trackpad" : w > 400 ? (this._type = null, this._lastValue = h, this._timeout = setTimeout(this._onTimeout, 40, o)) : this._type || (this._type = Math.abs(w * h) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, h += this._lastValue)), o.shiftKey && h && (h /= 4), this._type && (this._lastWheelEvent = o, this._delta -= h, this._active || this._start(o)), o.preventDefault();
        }
        _onTimeout(o) {
          this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(o);
        }
        _start(o) {
          if (!this._delta) return;
          this._frameId && (this._frameId = null), this._active = !0, this.isZooming() || (this._zooming = !0), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
          const h = g.mousePos(this._el, o), v = this._tr;
          this._around = a.LngLat.convert(this._aroundCenter ? v.center : v.unproject(h)), this._aroundPoint = v.transform.locationPoint(this._around), this._frameId || (this._frameId = !0, this._handler._triggerRenderFrame());
        }
        renderFrame() {
          if (!this._frameId || (this._frameId = null, !this.isActive())) return;
          const o = this._tr.transform;
          if (this._delta !== 0) {
            const z = this._type === "wheel" && Math.abs(this._delta) > hc ? this._wheelZoomRate : this._defaultZoomRate;
            let R = 2 / (1 + Math.exp(-Math.abs(this._delta * z)));
            this._delta < 0 && R !== 0 && (R = 1 / R);
            const W = typeof this._targetZoom == "number" ? o.zoomScale(this._targetZoom) : o.scale;
            this._targetZoom = Math.min(o.maxZoom, Math.max(o.minZoom, o.scaleZoom(W * R))), this._type === "wheel" && (this._startZoom = o.zoom, this._easing = this._smoothOutEasing(200)), this._delta = 0;
          }
          const h = typeof this._targetZoom == "number" ? this._targetZoom : o.zoom, v = this._startZoom, w = this._easing;
          let S, M = !1;
          if (this._type === "wheel" && v && w) {
            const z = Math.min((a.exported.now() - this._lastWheelEventTime) / 200, 1), R = w(z);
            S = a.interpolate.number(v, h, R), z < 1 ? this._frameId || (this._frameId = !0) : M = !0;
          } else S = h, M = !0;
          return this._active = !0, M && (this._active = !1, this._finishTimeout = setTimeout(() => {
            this._zooming = !1, this._handler._triggerRenderFrame(), delete this._targetZoom, delete this._finishTimeout;
          }, 200)), { noInertia: !0, needsRenderFrame: !M, zoomDelta: S - o.zoom, around: this._aroundPoint, originalEvent: this._lastWheelEvent };
        }
        _smoothOutEasing(o) {
          let h = a.ease;
          if (this._prevEase) {
            const v = this._prevEase, w = (a.exported.now() - v.start) / v.duration, S = v.easing(w + 0.01) - v.easing(w), M = 0.27 / Math.sqrt(S * S + 1e-4) * 0.01, z = Math.sqrt(0.0729 - M * M);
            h = a.bezier(M, z, 0.25, 1);
          }
          return this._prevEase = { start: a.exported.now(), duration: o, easing: h }, h;
        }
        reset() {
          this._active = !1;
        }
      }
      class rd {
        constructor(o, h) {
          this._clickZoom = o, this._tapZoom = h;
        }
        enable() {
          this._clickZoom.enable(), this._tapZoom.enable();
        }
        disable() {
          this._clickZoom.disable(), this._tapZoom.disable();
        }
        isEnabled() {
          return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
        }
        isActive() {
          return this._clickZoom.isActive() || this._tapZoom.isActive();
        }
      }
      class Os {
        constructor(o) {
          this._tr = new Xr(o), this.reset();
        }
        reset() {
          this._active = !1;
        }
        dblclick(o, h) {
          return o.preventDefault(), { cameraAnimation: (v) => {
            v.easeTo({ duration: 300, zoom: this._tr.zoom + (o.shiftKey ? -1 : 1), around: this._tr.unproject(h) }, { originalEvent: o });
          } };
        }
        enable() {
          this._enabled = !0;
        }
        disable() {
          this._enabled = !1, this.reset();
        }
        isEnabled() {
          return this._enabled;
        }
        isActive() {
          return this._active;
        }
      }
      class Ei {
        constructor() {
          this._tap = new Jc({ numTouches: 1, numTaps: 1 }), this.reset();
        }
        reset() {
          this._active = !1, delete this._swipePoint, delete this._swipeTouch, delete this._tapTime, this._tap.reset();
        }
        touchstart(o, h, v) {
          this._swipePoint || (this._tapTime && o.timeStamp - this._tapTime > 500 && this.reset(), this._tapTime ? v.length > 0 && (this._swipePoint = h[0], this._swipeTouch = v[0].identifier) : this._tap.touchstart(o, h, v));
        }
        touchmove(o, h, v) {
          if (this._tapTime) {
            if (this._swipePoint) {
              if (v[0].identifier !== this._swipeTouch) return;
              const w = h[0], S = w.y - this._swipePoint.y;
              return this._swipePoint = w, o.preventDefault(), this._active = !0, { zoomDelta: S / 128 };
            }
          } else this._tap.touchmove(o, h, v);
        }
        touchend(o, h, v) {
          this._tapTime ? this._swipePoint && v.length === 0 && this.reset() : this._tap.touchend(o, h, v) && (this._tapTime = o.timeStamp);
        }
        touchcancel() {
          this.reset();
        }
        enable() {
          this._enabled = !0;
        }
        disable() {
          this._enabled = !1, this.reset();
        }
        isEnabled() {
          return this._enabled;
        }
        isActive() {
          return this._active;
        }
      }
      class fc {
        constructor(o, h, v) {
          this._el = o, this._mousePan = h, this._touchPan = v;
        }
        enable(o) {
          this._inertiaOptions = o || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("maplibregl-touch-drag-pan");
        }
        disable() {
          this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("maplibregl-touch-drag-pan");
        }
        isEnabled() {
          return this._mousePan.isEnabled() && this._touchPan.isEnabled();
        }
        isActive() {
          return this._mousePan.isActive() || this._touchPan.isActive();
        }
      }
      class sd {
        constructor(o, h, v) {
          this._pitchWithRotate = o.pitchWithRotate, this._mouseRotate = h, this._mousePitch = v;
        }
        enable() {
          this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable();
        }
        disable() {
          this._mouseRotate.disable(), this._mousePitch.disable();
        }
        isEnabled() {
          return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled());
        }
        isActive() {
          return this._mouseRotate.isActive() || this._mousePitch.isActive();
        }
      }
      class p {
        constructor(o, h, v, w) {
          this._el = o, this._touchZoom = h, this._touchRotate = v, this._tapDragZoom = w, this._rotationDisabled = !1, this._enabled = !0;
        }
        enable(o) {
          this._touchZoom.enable(o), this._rotationDisabled || this._touchRotate.enable(o), this._tapDragZoom.enable(), this._el.classList.add("maplibregl-touch-zoom-rotate");
        }
        disable() {
          this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("maplibregl-touch-zoom-rotate");
        }
        isEnabled() {
          return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
        }
        isActive() {
          return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
        }
        disableRotation() {
          this._rotationDisabled = !0, this._touchRotate.disable();
        }
        enableRotation() {
          this._rotationDisabled = !1, this._touchZoom.isEnabled() && this._touchRotate.enable();
        }
      }
      const y = (_) => _.zoom || _.drag || _.pitch || _.rotate;
      class T extends a.Event {
      }
      function F(_) {
        return _.panDelta && _.panDelta.mag() || _.zoomDelta || _.bearingDelta || _.pitchDelta;
      }
      class j {
        constructor(o, h) {
          this._map = o, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new js(o), this._bearingSnap = h.bearingSnap, this._previousActiveHandlers = {}, this._eventsInProgress = {}, this._addDefaultHandlers(h), a.bindAll(["handleEvent", "handleWindowEvent"], this);
          const v = this._el;
          this._listeners = [[v, "touchstart", { passive: !0 }], [v, "touchmove", { passive: !1 }], [v, "touchend", void 0], [v, "touchcancel", void 0], [v, "mousedown", void 0], [v, "mousemove", void 0], [v, "mouseup", void 0], [document, "mousemove", { capture: !0 }], [document, "mouseup", void 0], [v, "mouseover", void 0], [v, "mouseout", void 0], [v, "dblclick", void 0], [v, "click", void 0], [v, "keydown", { capture: !1 }], [v, "keyup", void 0], [v, "wheel", { passive: !1 }], [v, "contextmenu", void 0], [window, "blur", void 0]];
          for (const [w, S, M] of this._listeners) g.addEventListener(w, S, w === document ? this.handleWindowEvent : this.handleEvent, M);
        }
        destroy() {
          for (const [o, h, v] of this._listeners) g.removeEventListener(o, h, o === document ? this.handleWindowEvent : this.handleEvent, v);
        }
        _addDefaultHandlers(o) {
          const h = this._map, v = h.getCanvasContainer();
          this._add("mapEvent", new rp(h, o));
          const w = h.boxZoom = new Ko(h, o);
          this._add("boxZoom", w);
          const S = new yl(h), M = new Os(h);
          h.doubleClickZoom = new rd(M, S), this._add("tapZoom", S), this._add("clickZoom", M);
          const z = new Ei();
          this._add("tapDragZoom", z);
          const R = h.touchPitch = new Jr(h);
          this._add("touchPitch", R);
          const W = td(o), Q = eu(o);
          h.dragRotate = new sd(o, W, Q), this._add("mouseRotate", W, ["mousePitch"]), this._add("mousePitch", Q, ["mouseRotate"]);
          const J = (({ enable: Ue, clickTolerance: ct }) => {
            const Ee = new Rt({ checkCorrectEvent: (st) => g.mouseButton(st) === 0 && !st.ctrlKey });
            return new Io({ clickTolerance: ct, move: (st, ht) => ({ around: ht, panDelta: ht.sub(st) }), activateOnStart: !0, moveStateManager: Ee, enable: Ue, assignEvents: Qc });
          })(o), fe = new ho(o, h);
          h.dragPan = new fc(v, J, fe), this._add("mousePan", J), this._add("touchPan", fe, ["touchZoom", "touchRotate"]);
          const Se = new Ma(), we = new nd();
          h.touchZoomRotate = new p(v, we, Se, z), this._add("touchRotate", Se, ["touchPan", "touchZoom"]), this._add("touchZoom", we, ["touchPan", "touchRotate"]);
          const Ce = h.scrollZoom = new nu(h, this);
          this._add("scrollZoom", Ce, ["mousePan"]);
          const Me = h.keyboard = new id(h);
          this._add("keyboard", Me), this._add("blockableMapEvent", new lf(h));
          for (const Ue of ["boxZoom", "doubleClickZoom", "tapDragZoom", "touchPitch", "dragRotate", "dragPan", "touchZoomRotate", "scrollZoom", "keyboard"]) o.interactive && o[Ue] && h[Ue].enable(o[Ue]);
        }
        _add(o, h, v) {
          this._handlers.push({ handlerName: o, handler: h, allowed: v }), this._handlersById[o] = h;
        }
        stop(o) {
          if (!this._updatingCamera) {
            for (const { handler: h } of this._handlers) h.reset();
            this._inertia.clear(), this._fireEvents({}, {}, o), this._changes = [];
          }
        }
        isActive() {
          for (const { handler: o } of this._handlers) if (o.isActive()) return !0;
          return !1;
        }
        isZooming() {
          return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
        }
        isRotating() {
          return !!this._eventsInProgress.rotate;
        }
        isMoving() {
          return !!y(this._eventsInProgress) || this.isZooming();
        }
        _blockedByActive(o, h, v) {
          for (const w in o) if (w !== v && (!h || h.indexOf(w) < 0)) return !0;
          return !1;
        }
        handleWindowEvent(o) {
          this.handleEvent(o, `${o.type}Window`);
        }
        _getMapTouches(o) {
          const h = [];
          for (const v of o) this._el.contains(v.target) && h.push(v);
          return h;
        }
        handleEvent(o, h) {
          if (o.type === "blur") return void this.stop(!0);
          this._updatingCamera = !0;
          const v = o.type === "renderFrame" ? void 0 : o, w = { needsRenderFrame: !1 }, S = {}, M = {}, z = o.touches, R = z ? this._getMapTouches(z) : void 0, W = R ? g.touchPos(this._el, R) : g.mousePos(this._el, o);
          for (const { handlerName: fe, handler: Se, allowed: we } of this._handlers) {
            if (!Se.isEnabled()) continue;
            let Ce;
            this._blockedByActive(M, we, fe) ? Se.reset() : Se[h || o.type] && (Ce = Se[h || o.type](o, W, R), this.mergeHandlerResult(w, S, Ce, fe, v), Ce && Ce.needsRenderFrame && this._triggerRenderFrame()), (Ce || Se.isActive()) && (M[fe] = Se);
          }
          const Q = {};
          for (const fe in this._previousActiveHandlers) M[fe] || (Q[fe] = v);
          this._previousActiveHandlers = M, (Object.keys(Q).length || F(w)) && (this._changes.push([w, S, Q]), this._triggerRenderFrame()), (Object.keys(M).length || F(w)) && this._map._stop(!0), this._updatingCamera = !1;
          const { cameraAnimation: J } = w;
          J && (this._inertia.clear(), this._fireEvents({}, {}, !0), this._changes = [], J(this._map));
        }
        mergeHandlerResult(o, h, v, w, S) {
          if (!v) return;
          a.extend(o, v);
          const M = { handlerName: w, originalEvent: v.originalEvent || S };
          v.zoomDelta !== void 0 && (h.zoom = M), v.panDelta !== void 0 && (h.drag = M), v.pitchDelta !== void 0 && (h.pitch = M), v.bearingDelta !== void 0 && (h.rotate = M);
        }
        _applyChanges() {
          const o = {}, h = {}, v = {};
          for (const [w, S, M] of this._changes) w.panDelta && (o.panDelta = (o.panDelta || new a.Point(0, 0))._add(w.panDelta)), w.zoomDelta && (o.zoomDelta = (o.zoomDelta || 0) + w.zoomDelta), w.bearingDelta && (o.bearingDelta = (o.bearingDelta || 0) + w.bearingDelta), w.pitchDelta && (o.pitchDelta = (o.pitchDelta || 0) + w.pitchDelta), w.around !== void 0 && (o.around = w.around), w.pinchAround !== void 0 && (o.pinchAround = w.pinchAround), w.noInertia && (o.noInertia = w.noInertia), a.extend(h, S), a.extend(v, M);
          this._updateMapTransform(o, h, v), this._changes = [];
        }
        _updateMapTransform(o, h, v) {
          const w = this._map, S = w._getTransformForUpdate(), M = w.terrain;
          if (!(F(o) || M && this._terrainMovement)) return this._fireEvents(h, v, !0);
          let { panDelta: z, zoomDelta: R, bearingDelta: W, pitchDelta: Q, around: J, pinchAround: fe } = o;
          fe !== void 0 && (J = fe), w._stop(!0), J = J || w.transform.centerPoint;
          const Se = S.pointLocation(z ? J.sub(z) : J);
          W && (S.bearing += W), Q && (S.pitch += Q), R && (S.zoom += R), M ? this._terrainMovement || !h.drag && !h.zoom ? h.drag && this._terrainMovement ? S.center = S.pointLocation(S.centerPoint.sub(z)) : S.setLocationAtPoint(Se, J) : (this._terrainMovement = !0, S.freezeElevation = !0, S.setLocationAtPoint(Se, J), this._map.once("moveend", () => {
            S.freezeElevation = !1, this._terrainMovement = !1, S.recalculateZoom(w.terrain);
          })) : S.setLocationAtPoint(Se, J), w._applyUpdatedTransform(S), this._map._update(), o.noInertia || this._inertia.record(o), this._fireEvents(h, v, !0);
        }
        _fireEvents(o, h, v) {
          const w = y(this._eventsInProgress), S = y(o), M = {};
          for (const Q in o) {
            const { originalEvent: J } = o[Q];
            this._eventsInProgress[Q] || (M[`${Q}start`] = J), this._eventsInProgress[Q] = o[Q];
          }
          !w && S && this._fireEvent("movestart", S.originalEvent);
          for (const Q in M) this._fireEvent(Q, M[Q]);
          S && this._fireEvent("move", S.originalEvent);
          for (const Q in o) {
            const { originalEvent: J } = o[Q];
            this._fireEvent(Q, J);
          }
          const z = {};
          let R;
          for (const Q in this._eventsInProgress) {
            const { handlerName: J, originalEvent: fe } = this._eventsInProgress[Q];
            this._handlersById[J].isActive() || (delete this._eventsInProgress[Q], R = h[J] || fe, z[`${Q}end`] = R);
          }
          for (const Q in z) this._fireEvent(Q, z[Q]);
          const W = y(this._eventsInProgress);
          if (v && (w || S) && !W) {
            this._updatingCamera = !0;
            const Q = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), J = (fe) => fe !== 0 && -this._bearingSnap < fe && fe < this._bearingSnap;
            Q ? (J(Q.bearing || this._map.getBearing()) && (Q.bearing = 0), Q.freezeElevation = !0, this._map.easeTo(Q, { originalEvent: R })) : (this._map.fire(new a.Event("moveend", { originalEvent: R })), J(this._map.getBearing()) && this._map.resetNorth()), this._updatingCamera = !1;
          }
        }
        _fireEvent(o, h) {
          this._map.fire(new a.Event(o, h ? { originalEvent: h } : {}));
        }
        _requestFrame() {
          return this._map.triggerRepaint(), this._map._renderTaskQueue.add((o) => {
            delete this._frameId, this.handleEvent(new T("renderFrame", { timeStamp: o })), this._applyChanges();
          });
        }
        _triggerRenderFrame() {
          this._frameId === void 0 && (this._frameId = this._requestFrame());
        }
      }
      const ge = { extend: (_, ...o) => a.extend(_, ...o), run(_) {
        _();
      }, logToElement(_, o = !1, h = "log") {
        const v = window.document.getElementById(h);
        v && (o && (v.innerHTML = ""), v.innerHTML += `<br>${_}`);
      } };
      class xe extends a.Evented {
        constructor(o, h) {
          super(), this._moving = !1, this._zooming = !1, this.transform = o, this._bearingSnap = h.bearingSnap, a.bindAll(["_renderFrameCallback"], this), this.on("moveend", () => {
            delete this._requestedCameraState;
          });
        }
        getCenter() {
          return new a.LngLat(this.transform.center.lng, this.transform.center.lat);
        }
        setCenter(o, h) {
          return this.jumpTo({ center: o }, h);
        }
        panBy(o, h, v) {
          return o = a.Point.convert(o).mult(-1), this.panTo(this.transform.center, a.extend({ offset: o }, h), v);
        }
        panTo(o, h, v) {
          return this.easeTo(a.extend({ center: o }, h), v);
        }
        getZoom() {
          return this.transform.zoom;
        }
        setZoom(o, h) {
          return this.jumpTo({ zoom: o }, h), this;
        }
        zoomTo(o, h, v) {
          return this.easeTo(a.extend({ zoom: o }, h), v);
        }
        zoomIn(o, h) {
          return this.zoomTo(this.getZoom() + 1, o, h), this;
        }
        zoomOut(o, h) {
          return this.zoomTo(this.getZoom() - 1, o, h), this;
        }
        getBearing() {
          return this.transform.bearing;
        }
        setBearing(o, h) {
          return this.jumpTo({ bearing: o }, h), this;
        }
        getPadding() {
          return this.transform.padding;
        }
        setPadding(o, h) {
          return this.jumpTo({ padding: o }, h), this;
        }
        rotateTo(o, h, v) {
          return this.easeTo(a.extend({ bearing: o }, h), v);
        }
        resetNorth(o, h) {
          return this.rotateTo(0, a.extend({ duration: 1e3 }, o), h), this;
        }
        resetNorthPitch(o, h) {
          return this.easeTo(a.extend({ bearing: 0, pitch: 0, duration: 1e3 }, o), h), this;
        }
        snapToNorth(o, h) {
          return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(o, h) : this;
        }
        getPitch() {
          return this.transform.pitch;
        }
        setPitch(o, h) {
          return this.jumpTo({ pitch: o }, h), this;
        }
        cameraForBounds(o, h) {
          o = Le.convert(o);
          const v = h && h.bearing || 0;
          return this._cameraForBoxAndBearing(o.getNorthWest(), o.getSouthEast(), v, h);
        }
        _cameraForBoxAndBearing(o, h, v, w) {
          const S = { top: 0, bottom: 0, right: 0, left: 0 };
          if (typeof (w = a.extend({ padding: S, offset: [0, 0], maxZoom: this.transform.maxZoom }, w)).padding == "number") {
            const ht = w.padding;
            w.padding = { top: ht, bottom: ht, right: ht, left: ht };
          }
          w.padding = a.extend(S, w.padding);
          const M = this.transform, z = M.padding, R = M.project(a.LngLat.convert(o)), W = M.project(a.LngLat.convert(h)), Q = R.rotate(-v * Math.PI / 180), J = W.rotate(-v * Math.PI / 180), fe = new a.Point(Math.max(Q.x, J.x), Math.max(Q.y, J.y)), Se = new a.Point(Math.min(Q.x, J.x), Math.min(Q.y, J.y)), we = fe.sub(Se), Ce = (M.width - (z.left + z.right + w.padding.left + w.padding.right)) / we.x, Me = (M.height - (z.top + z.bottom + w.padding.top + w.padding.bottom)) / we.y;
          if (Me < 0 || Ce < 0) return void a.warnOnce("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
          const Ue = Math.min(M.scaleZoom(M.scale * Math.min(Ce, Me)), w.maxZoom), ct = a.Point.convert(w.offset), Ee = new a.Point((w.padding.left - w.padding.right) / 2, (w.padding.top - w.padding.bottom) / 2).rotate(v * Math.PI / 180), st = ct.add(Ee).mult(M.scale / M.zoomScale(Ue));
          return { center: M.unproject(R.add(W).div(2).sub(st)), zoom: Ue, bearing: v };
        }
        fitBounds(o, h, v) {
          return this._fitInternal(this.cameraForBounds(o, h), h, v);
        }
        fitScreenCoordinates(o, h, v, w, S) {
          return this._fitInternal(this._cameraForBoxAndBearing(this.transform.pointLocation(a.Point.convert(o)), this.transform.pointLocation(a.Point.convert(h)), v, w), w, S);
        }
        _fitInternal(o, h, v) {
          return o ? (delete (h = a.extend(o, h)).padding, h.linear ? this.easeTo(h, v) : this.flyTo(h, v)) : this;
        }
        jumpTo(o, h) {
          this.stop();
          const v = this._getTransformForUpdate();
          let w = !1, S = !1, M = !1;
          return "zoom" in o && v.zoom !== +o.zoom && (w = !0, v.zoom = +o.zoom), o.center !== void 0 && (v.center = a.LngLat.convert(o.center)), "bearing" in o && v.bearing !== +o.bearing && (S = !0, v.bearing = +o.bearing), "pitch" in o && v.pitch !== +o.pitch && (M = !0, v.pitch = +o.pitch), o.padding == null || v.isPaddingEqual(o.padding) || (v.padding = o.padding), this._applyUpdatedTransform(v), this.fire(new a.Event("movestart", h)).fire(new a.Event("move", h)), w && this.fire(new a.Event("zoomstart", h)).fire(new a.Event("zoom", h)).fire(new a.Event("zoomend", h)), S && this.fire(new a.Event("rotatestart", h)).fire(new a.Event("rotate", h)).fire(new a.Event("rotateend", h)), M && this.fire(new a.Event("pitchstart", h)).fire(new a.Event("pitch", h)).fire(new a.Event("pitchend", h)), this.fire(new a.Event("moveend", h));
        }
        calculateCameraOptionsFromTo(o, h, v, w = 0) {
          const S = a.MercatorCoordinate.fromLngLat(o, h), M = a.MercatorCoordinate.fromLngLat(v, w), z = M.x - S.x, R = M.y - S.y, W = M.z - S.z, Q = Math.hypot(z, R, W);
          if (Q === 0) throw new Error("Can't calculate camera options with same From and To");
          const J = Math.hypot(z, R), fe = this.transform.scaleZoom(this.transform.cameraToCenterDistance / Q / this.transform.tileSize), Se = 180 * Math.atan2(z, -R) / Math.PI;
          let we = 180 * Math.acos(J / Q) / Math.PI;
          return we = W < 0 ? 90 - we : 90 + we, { center: M.toLngLat(), zoom: fe, pitch: we, bearing: Se };
        }
        easeTo(o, h) {
          this._stop(!1, o.easeId), ((o = a.extend({ offset: [0, 0], duration: 500, easing: a.ease }, o)).animate === !1 || !o.essential && a.exported.prefersReducedMotion) && (o.duration = 0);
          const v = this._getTransformForUpdate(), w = this.getZoom(), S = this.getBearing(), M = this.getPitch(), z = this.getPadding(), R = "zoom" in o ? +o.zoom : w, W = "bearing" in o ? this._normalizeBearing(o.bearing, S) : S, Q = "pitch" in o ? +o.pitch : M, J = "padding" in o ? o.padding : v.padding, fe = a.Point.convert(o.offset);
          let Se = v.centerPoint.add(fe);
          const we = v.pointLocation(Se), Ce = a.LngLat.convert(o.center || we);
          this._normalizeCenter(Ce);
          const Me = v.project(we), Ue = v.project(Ce).sub(Me), ct = v.zoomScale(R - w);
          let Ee, st;
          o.around && (Ee = a.LngLat.convert(o.around), st = v.locationPoint(Ee));
          const ht = { moving: this._moving, zooming: this._zooming, rotating: this._rotating, pitching: this._pitching };
          return this._zooming = this._zooming || R !== w, this._rotating = this._rotating || S !== W, this._pitching = this._pitching || Q !== M, this._padding = !v.isPaddingEqual(J), this._easeId = o.easeId, this._prepareEase(h, o.noMoveStart, ht), this.terrain && this._prepareElevation(Ce), this._ease((wt) => {
            if (this._zooming && (v.zoom = a.interpolate.number(w, R, wt)), this._rotating && (v.bearing = a.interpolate.number(S, W, wt)), this._pitching && (v.pitch = a.interpolate.number(M, Q, wt)), this._padding && (v.interpolatePadding(z, J, wt), Se = v.centerPoint.add(fe)), this.terrain && !o.freezeElevation && this._updateElevation(wt), Ee) v.setLocationAtPoint(Ee, st);
            else {
              const Ct = v.zoomScale(v.zoom - w), Dt = R > w ? Math.min(2, ct) : Math.max(0.5, ct), xt = Math.pow(Dt, 1 - wt), Wt = v.unproject(Me.add(Ue.mult(wt * xt)).mult(Ct));
              v.setLocationAtPoint(v.renderWorldCopies ? Wt.wrap() : Wt, Se);
            }
            this._applyUpdatedTransform(v), this._fireMoveEvents(h);
          }, (wt) => {
            this.terrain && this._finalizeElevation(), this._afterEase(h, wt);
          }, o), this;
        }
        _prepareEase(o, h, v = {}) {
          this._moving = !0, h || v.moving || this.fire(new a.Event("movestart", o)), this._zooming && !v.zooming && this.fire(new a.Event("zoomstart", o)), this._rotating && !v.rotating && this.fire(new a.Event("rotatestart", o)), this._pitching && !v.pitching && this.fire(new a.Event("pitchstart", o));
        }
        _prepareElevation(o) {
          this._elevationCenter = o, this._elevationStart = this.transform.elevation, this._elevationTarget = this.transform.getElevation(o, this.terrain), this.transform.freezeElevation = !0;
        }
        _updateElevation(o) {
          const h = this.transform.getElevation(this._elevationCenter, this.terrain);
          if (o < 1 && h !== this._elevationTarget) {
            const v = this._elevationTarget - this._elevationStart;
            this._elevationStart += o * (v - (h - (v * o + this._elevationStart)) / (1 - o)), this._elevationTarget = h;
          }
          this.transform.elevation = a.interpolate.number(this._elevationStart, this._elevationTarget, o);
        }
        _finalizeElevation() {
          this.transform.freezeElevation = !1, this.transform.recalculateZoom(this.terrain);
        }
        _getTransformForUpdate() {
          return this.transformCameraUpdate ? (this._requestedCameraState || (this._requestedCameraState = this.transform.clone()), this._requestedCameraState) : this.transform;
        }
        _applyUpdatedTransform(o) {
          if (!this.transformCameraUpdate) return;
          const h = o.clone(), { center: v, zoom: w, pitch: S, bearing: M, elevation: z } = this.transformCameraUpdate(h);
          v && (h.center = v), w !== void 0 && (h.zoom = w), S !== void 0 && (h.pitch = S), M !== void 0 && (h.bearing = M), z !== void 0 && (h.elevation = z), this.transform.apply(h);
        }
        _fireMoveEvents(o) {
          this.fire(new a.Event("move", o)), this._zooming && this.fire(new a.Event("zoom", o)), this._rotating && this.fire(new a.Event("rotate", o)), this._pitching && this.fire(new a.Event("pitch", o));
        }
        _afterEase(o, h) {
          if (this._easeId && h && this._easeId === h) return;
          delete this._easeId;
          const v = this._zooming, w = this._rotating, S = this._pitching;
          this._moving = !1, this._zooming = !1, this._rotating = !1, this._pitching = !1, this._padding = !1, v && this.fire(new a.Event("zoomend", o)), w && this.fire(new a.Event("rotateend", o)), S && this.fire(new a.Event("pitchend", o)), this.fire(new a.Event("moveend", o));
        }
        flyTo(o, h) {
          if (!o.essential && a.exported.prefersReducedMotion) {
            const Gt = a.pick(o, ["center", "zoom", "bearing", "pitch", "around"]);
            return this.jumpTo(Gt, h);
          }
          this.stop(), o = a.extend({ offset: [0, 0], speed: 1.2, curve: 1.42, easing: a.ease }, o);
          const v = this._getTransformForUpdate(), w = this.getZoom(), S = this.getBearing(), M = this.getPitch(), z = this.getPadding(), R = "zoom" in o ? a.clamp(+o.zoom, v.minZoom, v.maxZoom) : w, W = "bearing" in o ? this._normalizeBearing(o.bearing, S) : S, Q = "pitch" in o ? +o.pitch : M, J = "padding" in o ? o.padding : v.padding, fe = v.zoomScale(R - w), Se = a.Point.convert(o.offset);
          let we = v.centerPoint.add(Se);
          const Ce = v.pointLocation(we), Me = a.LngLat.convert(o.center || Ce);
          this._normalizeCenter(Me);
          const Ue = v.project(Ce), ct = v.project(Me).sub(Ue);
          let Ee = o.curve;
          const st = Math.max(v.width, v.height), ht = st / fe, wt = ct.mag();
          if ("minZoom" in o) {
            const Gt = a.clamp(Math.min(o.minZoom, w, R), v.minZoom, v.maxZoom), ni = st / v.zoomScale(Gt - w);
            Ee = Math.sqrt(ni / wt * 2);
          }
          const Ct = Ee * Ee;
          function Dt(Gt) {
            const ni = (ht * ht - st * st + (Gt ? -1 : 1) * Ct * Ct * wt * wt) / (2 * (Gt ? ht : st) * Ct * wt);
            return Math.log(Math.sqrt(ni * ni + 1) - ni);
          }
          function xt(Gt) {
            return (Math.exp(Gt) - Math.exp(-Gt)) / 2;
          }
          function Wt(Gt) {
            return (Math.exp(Gt) + Math.exp(-Gt)) / 2;
          }
          const fn = Dt(0);
          let En = function(Gt) {
            return Wt(fn) / Wt(fn + Ee * Gt);
          }, Ot = function(Gt) {
            return st * ((Wt(fn) * (xt(ni = fn + Ee * Gt) / Wt(ni)) - xt(fn)) / Ct) / wt;
            var ni;
          }, xn = (Dt(1) - fn) / Ee;
          if (Math.abs(wt) < 1e-6 || !isFinite(xn)) {
            if (Math.abs(st - ht) < 1e-6) return this.easeTo(o, h);
            const Gt = ht < st ? -1 : 1;
            xn = Math.abs(Math.log(ht / st)) / Ee, Ot = function() {
              return 0;
            }, En = function(ni) {
              return Math.exp(Gt * Ee * ni);
            };
          }
          return o.duration = "duration" in o ? +o.duration : 1e3 * xn / ("screenSpeed" in o ? +o.screenSpeed / Ee : +o.speed), o.maxDuration && o.duration > o.maxDuration && (o.duration = 0), this._zooming = !0, this._rotating = S !== W, this._pitching = Q !== M, this._padding = !v.isPaddingEqual(J), this._prepareEase(h, !1), this.terrain && this._prepareElevation(Me), this._ease((Gt) => {
            const ni = Gt * xn, cr = 1 / En(ni);
            v.zoom = Gt === 1 ? R : w + v.scaleZoom(cr), this._rotating && (v.bearing = a.interpolate.number(S, W, Gt)), this._pitching && (v.pitch = a.interpolate.number(M, Q, Gt)), this._padding && (v.interpolatePadding(z, J, Gt), we = v.centerPoint.add(Se)), this.terrain && !o.freezeElevation && this._updateElevation(Gt);
            const ii = Gt === 1 ? Me : v.unproject(Ue.add(ct.mult(Ot(ni))).mult(cr));
            v.setLocationAtPoint(v.renderWorldCopies ? ii.wrap() : ii, we), this._applyUpdatedTransform(v), this._fireMoveEvents(h);
          }, () => {
            this.terrain && this._finalizeElevation(), this._afterEase(h);
          }, o), this;
        }
        isEasing() {
          return !!this._easeFrameId;
        }
        stop() {
          return this._stop();
        }
        _stop(o, h) {
          if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), delete this._easeFrameId, delete this._onEaseFrame), this._onEaseEnd) {
            const v = this._onEaseEnd;
            delete this._onEaseEnd, v.call(this, h);
          }
          if (!o) {
            const v = this.handlers;
            v && v.stop(!1);
          }
          return this;
        }
        _ease(o, h, v) {
          v.animate === !1 || v.duration === 0 ? (o(1), h()) : (this._easeStart = a.exported.now(), this._easeOptions = v, this._onEaseFrame = o, this._onEaseEnd = h, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
        }
        _renderFrameCallback() {
          const o = Math.min((a.exported.now() - this._easeStart) / this._easeOptions.duration, 1);
          this._onEaseFrame(this._easeOptions.easing(o)), o < 1 ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
        }
        _normalizeBearing(o, h) {
          o = a.wrap(o, -180, 180);
          const v = Math.abs(o - h);
          return Math.abs(o - 360 - h) < v && (o -= 360), Math.abs(o + 360 - h) < v && (o += 360), o;
        }
        _normalizeCenter(o) {
          const h = this.transform;
          if (!h.renderWorldCopies || h.lngRange) return;
          const v = o.lng - h.center.lng;
          o.lng += v > 180 ? -360 : v < -180 ? 360 : 0;
        }
        queryTerrainElevation(o) {
          return this.terrain ? this.transform.getElevation(a.LngLat.convert(o), this.terrain) - this.transform.elevation : null;
        }
      }
      class Ve {
        constructor(o = {}) {
          this.options = o, a.bindAll(["_toggleAttribution", "_updateData", "_updateCompact", "_updateCompactMinimize"], this);
        }
        getDefaultPosition() {
          return "bottom-right";
        }
        onAdd(o) {
          return this._map = o, this._compact = this.options && this.options.compact, this._container = g.create("details", "maplibregl-ctrl maplibregl-ctrl-attrib"), this._compactButton = g.create("summary", "maplibregl-ctrl-attrib-button", this._container), this._compactButton.addEventListener("click", this._toggleAttribution), this._setElementTitle(this._compactButton, "ToggleAttribution"), this._innerContainer = g.create("div", "maplibregl-ctrl-attrib-inner", this._container), this._updateAttributions(), this._updateCompact(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("terrain", this._updateData), this._map.on("resize", this._updateCompact), this._map.on("drag", this._updateCompactMinimize), this._container;
        }
        onRemove() {
          g.remove(this._container), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("terrain", this._updateData), this._map.off("resize", this._updateCompact), this._map.off("drag", this._updateCompactMinimize), this._map = void 0, this._compact = void 0, this._attribHTML = void 0;
        }
        _setElementTitle(o, h) {
          const v = this._map._getUIString(`AttributionControl.${h}`);
          o.title = v, o.setAttribute("aria-label", v);
        }
        _toggleAttribution() {
          this._container.classList.contains("maplibregl-compact") && (this._container.classList.contains("maplibregl-compact-show") ? (this._container.setAttribute("open", ""), this._container.classList.remove("maplibregl-compact-show")) : (this._container.classList.add("maplibregl-compact-show"), this._container.removeAttribute("open")));
        }
        _updateData(o) {
          !o || o.sourceDataType !== "metadata" && o.sourceDataType !== "visibility" && o.dataType !== "style" && o.type !== "terrain" || this._updateAttributions();
        }
        _updateAttributions() {
          if (!this._map.style) return;
          let o = [];
          if (this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? o = o.concat(this.options.customAttribution.map((w) => typeof w != "string" ? "" : w)) : typeof this.options.customAttribution == "string" && o.push(this.options.customAttribution)), this._map.style.stylesheet) {
            const w = this._map.style.stylesheet;
            this.styleOwner = w.owner, this.styleId = w.id;
          }
          const h = this._map.style.sourceCaches;
          for (const w in h) {
            const S = h[w];
            if (S.used || S.usedForTerrain) {
              const M = S.getSource();
              M.attribution && o.indexOf(M.attribution) < 0 && o.push(M.attribution);
            }
          }
          o = o.filter((w) => String(w).trim()), o.sort((w, S) => w.length - S.length), o = o.filter((w, S) => {
            for (let M = S + 1; M < o.length; M++) if (o[M].indexOf(w) >= 0) return !1;
            return !0;
          });
          const v = o.join(" | ");
          v !== this._attribHTML && (this._attribHTML = v, o.length ? (this._innerContainer.innerHTML = v, this._container.classList.remove("maplibregl-attrib-empty")) : this._container.classList.add("maplibregl-attrib-empty"), this._updateCompact(), this._editLink = null);
        }
        _updateCompact() {
          this._map.getCanvasContainer().offsetWidth <= 640 || this._compact ? this._compact === !1 ? this._container.setAttribute("open", "") : this._container.classList.contains("maplibregl-compact") || this._container.classList.contains("maplibregl-attrib-empty") || (this._container.setAttribute("open", ""), this._container.classList.add("maplibregl-compact", "maplibregl-compact-show")) : (this._container.setAttribute("open", ""), this._container.classList.contains("maplibregl-compact") && this._container.classList.remove("maplibregl-compact", "maplibregl-compact-show"));
        }
        _updateCompactMinimize() {
          this._container.classList.contains("maplibregl-compact") && this._container.classList.contains("maplibregl-compact-show") && this._container.classList.remove("maplibregl-compact-show");
        }
      }
      class pt {
        constructor(o = {}) {
          this.options = o, a.bindAll(["_updateCompact"], this);
        }
        getDefaultPosition() {
          return "bottom-left";
        }
        onAdd(o) {
          this._map = o, this._compact = this.options && this.options.compact, this._container = g.create("div", "maplibregl-ctrl");
          const h = g.create("a", "maplibregl-ctrl-logo");
          return h.target = "_blank", h.rel = "noopener nofollow", h.href = "https://maplibre.org/", h.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), h.setAttribute("rel", "noopener nofollow"), this._container.appendChild(h), this._container.style.display = "block", this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
        }
        onRemove() {
          g.remove(this._container), this._map.off("resize", this._updateCompact), this._map = void 0, this._compact = void 0;
        }
        _updateCompact() {
          const o = this._container.children;
          if (o.length) {
            const h = o[0];
            this._map.getCanvasContainer().offsetWidth <= 640 || this._compact ? this._compact !== !1 && h.classList.add("maplibregl-compact") : h.classList.remove("maplibregl-compact");
          }
        }
      }
      class $t {
        constructor() {
          this._queue = [], this._id = 0, this._cleared = !1, this._currentlyRunning = !1;
        }
        add(o) {
          const h = ++this._id;
          return this._queue.push({ callback: o, id: h, cancelled: !1 }), h;
        }
        remove(o) {
          const h = this._currentlyRunning, v = h ? this._queue.concat(h) : this._queue;
          for (const w of v) if (w.id === o) return void (w.cancelled = !0);
        }
        run(o = 0) {
          if (this._currentlyRunning) throw new Error("Attempting to run(), but is already running.");
          const h = this._currentlyRunning = this._queue;
          this._queue = [];
          for (const v of h) if (!v.cancelled && (v.callback(o), this._cleared)) break;
          this._cleared = !1, this._currentlyRunning = !1;
        }
        clear() {
          this._currentlyRunning && (this._cleared = !0), this._queue = [];
        }
      }
      const Jt = { "AttributionControl.ToggleAttribution": "Toggle attribution", "AttributionControl.MapFeedback": "Map feedback", "FullscreenControl.Enter": "Enter fullscreen", "FullscreenControl.Exit": "Exit fullscreen", "GeolocateControl.FindMyLocation": "Find my location", "GeolocateControl.LocationNotAvailable": "Location not available", "LogoControl.Title": "Mapbox logo", "NavigationControl.ResetBearing": "Reset bearing to north", "NavigationControl.ZoomIn": "Zoom in", "NavigationControl.ZoomOut": "Zoom out", "ScaleControl.Feet": "ft", "ScaleControl.Meters": "m", "ScaleControl.Kilometers": "km", "ScaleControl.Miles": "mi", "ScaleControl.NauticalMiles": "nm", "TerrainControl.enableTerrain": "Enable terrain", "TerrainControl.disableTerrain": "Disable terrain" };
      var pn = a.createLayout([{ name: "a_pos3d", type: "Int16", components: 3 }]);
      class Hn extends a.Evented {
        constructor(o) {
          super(), this.sourceCache = o, this._tiles = {}, this._renderableTilesKeys = [], this._sourceTileCache = {}, this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.deltaZoom = 1, o.usedForTerrain = !0, o.tileSize = this.tileSize * 2 ** this.deltaZoom;
        }
        destruct() {
          this.sourceCache.usedForTerrain = !1, this.sourceCache.tileSize = null;
        }
        update(o, h) {
          this.sourceCache.update(o, h), this._renderableTilesKeys = [];
          const v = {};
          for (const w of o.coveringTiles({ tileSize: this.tileSize, minzoom: this.minzoom, maxzoom: this.maxzoom, reparseOverscaled: !1, terrain: h })) v[w.key] = !0, this._renderableTilesKeys.push(w.key), this._tiles[w.key] || (w.posMatrix = new Float64Array(16), a.ortho(w.posMatrix, 0, a.EXTENT, 0, a.EXTENT, 0, 1), this._tiles[w.key] = new qn(w, this.tileSize));
          for (const w in this._tiles) v[w] || delete this._tiles[w];
        }
        freeRtt(o) {
          for (const h in this._tiles) {
            const v = this._tiles[h];
            (!o || v.tileID.equals(o) || v.tileID.isChildOf(o) || o.isChildOf(v.tileID)) && (v.rtt = []);
          }
        }
        getRenderableTiles() {
          return this._renderableTilesKeys.map((o) => this.getTileByID(o));
        }
        getTileByID(o) {
          return this._tiles[o];
        }
        getTerrainCoords(o) {
          const h = {};
          for (const v of this._renderableTilesKeys) {
            const w = this._tiles[v].tileID;
            if (w.canonical.equals(o.canonical)) {
              const S = o.clone();
              S.posMatrix = new Float64Array(16), a.ortho(S.posMatrix, 0, a.EXTENT, 0, a.EXTENT, 0, 1), h[v] = S;
            } else if (w.canonical.isChildOf(o.canonical)) {
              const S = o.clone();
              S.posMatrix = new Float64Array(16);
              const M = w.canonical.z - o.canonical.z, z = w.canonical.x - (w.canonical.x >> M << M), R = w.canonical.y - (w.canonical.y >> M << M), W = a.EXTENT >> M;
              a.ortho(S.posMatrix, 0, W, 0, W, 0, 1), a.translate(S.posMatrix, S.posMatrix, [-z * W, -R * W, 0]), h[v] = S;
            } else if (o.canonical.isChildOf(w.canonical)) {
              const S = o.clone();
              S.posMatrix = new Float64Array(16);
              const M = o.canonical.z - w.canonical.z, z = o.canonical.x - (o.canonical.x >> M << M), R = o.canonical.y - (o.canonical.y >> M << M), W = a.EXTENT >> M;
              a.ortho(S.posMatrix, 0, a.EXTENT, 0, a.EXTENT, 0, 1), a.translate(S.posMatrix, S.posMatrix, [z * W, R * W, 0]), a.scale(S.posMatrix, S.posMatrix, [1 / 2 ** M, 1 / 2 ** M, 0]), h[v] = S;
            }
          }
          return h;
        }
        getSourceTile(o, h) {
          const v = this.sourceCache._source;
          let w = o.overscaledZ - this.deltaZoom;
          if (w > v.maxzoom && (w = v.maxzoom), w < v.minzoom) return null;
          this._sourceTileCache[o.key] || (this._sourceTileCache[o.key] = o.scaledTo(w).key);
          let S = this.sourceCache.getTileByID(this._sourceTileCache[o.key]);
          if ((!S || !S.dem) && h) for (; w >= v.minzoom && (!S || !S.dem); ) S = this.sourceCache.getTileByID(o.scaledTo(w--).key);
          return S;
        }
        tilesAfterTime(o = Date.now()) {
          return Object.values(this._tiles).filter((h) => h.timeAdded >= o);
        }
      }
      class Hi {
        constructor(o, h, v) {
          this.painter = o, this.sourceCache = new Hn(h), this.options = v, this.exaggeration = typeof v.exaggeration == "number" ? v.exaggeration : 1, this.qualityFactor = 2, this.meshSize = 128, this._demMatrixCache = {}, this.coordsIndex = [], this._coordsTextureSize = 1024;
        }
        getDEMElevation(o, h, v, w = a.EXTENT) {
          if (!(h >= 0 && h < w && v >= 0 && v < w)) return 0;
          let S = 0;
          const M = this.getTerrainData(o);
          if (M.tile && M.tile.dem) {
            const z = function(we, Ce, Me) {
              var Ue = Ce[0], ct = Ce[1];
              return we[0] = Me[0] * Ue + Me[4] * ct + Me[12], we[1] = Me[1] * Ue + Me[5] * ct + Me[13], we;
            }([], [h / w * a.EXTENT, v / w * a.EXTENT], M.u_terrain_matrix), R = [z[0] * M.tile.dem.dim, z[1] * M.tile.dem.dim], W = [Math.floor(R[0]), Math.floor(R[1])], Q = M.tile.dem.get(W[0], W[1]), J = M.tile.dem.get(W[0], W[1] + 1), fe = M.tile.dem.get(W[0] + 1, W[1]), Se = M.tile.dem.get(W[0] + 1, W[1] + 1);
            S = a.interpolate.number(a.interpolate.number(Q, J, R[0] - W[0]), a.interpolate.number(fe, Se, R[0] - W[0]), R[1] - W[1]);
          }
          return S;
        }
        getElevation(o, h, v, w = a.EXTENT) {
          return this.getDEMElevation(o, h, v, w) * this.exaggeration;
        }
        getTerrainData(o) {
          if (!this._emptyDemTexture) {
            const w = this.painter.context, S = new a.RGBAImage({ width: 1, height: 1 }, new Uint8Array(4));
            this._emptyDepthTexture = new ve(w, S, w.gl.RGBA, { premultiply: !1 }), this._emptyDemUnpack = [0, 0, 0, 0], this._emptyDemTexture = new ve(w, new a.RGBAImage({ width: 1, height: 1 }), w.gl.RGBA, { premultiply: !1 }), this._emptyDemTexture.bind(w.gl.NEAREST, w.gl.CLAMP_TO_EDGE), this._emptyDemMatrix = a.identity([]);
          }
          const h = this.sourceCache.getSourceTile(o, !0);
          if (h && h.dem && (!h.demTexture || h.needsTerrainPrepare)) {
            const w = this.painter.context;
            h.demTexture = this.painter.getTileTexture(h.dem.stride), h.demTexture ? h.demTexture.update(h.dem.getPixels(), { premultiply: !1 }) : h.demTexture = new ve(w, h.dem.getPixels(), w.gl.RGBA, { premultiply: !1 }), h.demTexture.bind(w.gl.NEAREST, w.gl.CLAMP_TO_EDGE), h.needsTerrainPrepare = !1;
          }
          const v = h && h + h.tileID.key + o.key;
          if (v && !this._demMatrixCache[v]) {
            const w = this.sourceCache.sourceCache._source.maxzoom;
            let S = o.canonical.z - h.tileID.canonical.z;
            o.overscaledZ > o.canonical.z && (o.canonical.z >= w ? S = o.canonical.z - w : a.warnOnce("cannot calculate elevation if elevation maxzoom > source.maxzoom"));
            const M = o.canonical.x - (o.canonical.x >> S << S), z = o.canonical.y - (o.canonical.y >> S << S), R = a.fromScaling(new Float64Array(16), [1 / (a.EXTENT << S), 1 / (a.EXTENT << S), 0]);
            a.translate(R, R, [M * a.EXTENT, z * a.EXTENT, 0]), this._demMatrixCache[o.key] = { matrix: R, coord: o };
          }
          return { u_depth: 2, u_terrain: 3, u_terrain_dim: h && h.dem && h.dem.dim || 1, u_terrain_matrix: v ? this._demMatrixCache[o.key].matrix : this._emptyDemMatrix, u_terrain_unpack: h && h.dem && h.dem.getUnpackVector() || this._emptyDemUnpack, u_terrain_exaggeration: this.exaggeration, texture: (h && h.demTexture || this._emptyDemTexture).texture, depthTexture: (this._fboDepthTexture || this._emptyDepthTexture).texture, tile: h };
        }
        getFramebuffer(o) {
          const h = this.painter, v = h.width / devicePixelRatio, w = h.height / devicePixelRatio;
          return !this._fbo || this._fbo.width === v && this._fbo.height === w || (this._fbo.destroy(), this._fboCoordsTexture.destroy(), this._fboDepthTexture.destroy(), delete this._fbo, delete this._fboDepthTexture, delete this._fboCoordsTexture), this._fboCoordsTexture || (this._fboCoordsTexture = new ve(h.context, { width: v, height: w, data: null }, h.context.gl.RGBA, { premultiply: !1 }), this._fboCoordsTexture.bind(h.context.gl.NEAREST, h.context.gl.CLAMP_TO_EDGE)), this._fboDepthTexture || (this._fboDepthTexture = new ve(h.context, { width: v, height: w, data: null }, h.context.gl.RGBA, { premultiply: !1 }), this._fboDepthTexture.bind(h.context.gl.NEAREST, h.context.gl.CLAMP_TO_EDGE)), this._fbo || (this._fbo = h.context.createFramebuffer(v, w, !0, !1), this._fbo.depthAttachment.set(h.context.createRenderbuffer(h.context.gl.DEPTH_COMPONENT16, v, w))), this._fbo.colorAttachment.set(o === "coords" ? this._fboCoordsTexture.texture : this._fboDepthTexture.texture), this._fbo;
        }
        getCoordsTexture() {
          const o = this.painter.context;
          if (this._coordsTexture) return this._coordsTexture;
          const h = new Uint8Array(this._coordsTextureSize * this._coordsTextureSize * 4);
          for (let S = 0, M = 0; S < this._coordsTextureSize; S++) for (let z = 0; z < this._coordsTextureSize; z++, M += 4) h[M + 0] = 255 & z, h[M + 1] = 255 & S, h[M + 2] = z >> 8 << 4 | S >> 8, h[M + 3] = 0;
          const v = new a.RGBAImage({ width: this._coordsTextureSize, height: this._coordsTextureSize }, new Uint8Array(h.buffer)), w = new ve(o, v, o.gl.RGBA, { premultiply: !1 });
          return w.bind(o.gl.NEAREST, o.gl.CLAMP_TO_EDGE), this._coordsTexture = w, w;
        }
        pointCoordinate(o) {
          const h = new Uint8Array(4), v = this.painter.context, w = v.gl;
          v.bindFramebuffer.set(this.getFramebuffer("coords").framebuffer), w.readPixels(o.x, this.painter.height / devicePixelRatio - o.y - 1, 1, 1, w.RGBA, w.UNSIGNED_BYTE, h), v.bindFramebuffer.set(null);
          const S = h[0] + (h[2] >> 4 << 8), M = h[1] + ((15 & h[2]) << 8), z = this.coordsIndex[255 - h[3]], R = z && this.sourceCache.getTileByID(z);
          if (!R) return null;
          const W = this._coordsTextureSize, Q = (1 << R.tileID.canonical.z) * W;
          return new a.MercatorCoordinate((R.tileID.canonical.x * W + S) / Q, (R.tileID.canonical.y * W + M) / Q, this.getElevation(R.tileID, S, M, W));
        }
        getTerrainMesh() {
          if (this._mesh) return this._mesh;
          const o = this.painter.context, h = new a.Pos3dArray(), v = new a.TriangleIndexArray(), w = this.meshSize, S = a.EXTENT / w, M = w * w;
          for (let J = 0; J <= w; J++) for (let fe = 0; fe <= w; fe++) h.emplaceBack(fe * S, J * S, 0);
          for (let J = 0; J < M; J += w + 1) for (let fe = 0; fe < w; fe++) v.emplaceBack(fe + J, w + fe + J + 1, w + fe + J + 2), v.emplaceBack(fe + J, w + fe + J + 2, fe + J + 1);
          const z = h.length, R = z + 2 * (w + 1);
          for (const J of [0, 1]) for (let fe = 0; fe <= w; fe++) for (const Se of [0, 1]) h.emplaceBack(fe * S, J * a.EXTENT, Se);
          for (let J = 0; J < 2 * w; J += 2) v.emplaceBack(R + J, R + J + 1, R + J + 3), v.emplaceBack(R + J, R + J + 3, R + J + 2), v.emplaceBack(z + J, z + J + 3, z + J + 1), v.emplaceBack(z + J, z + J + 2, z + J + 3);
          const W = h.length, Q = W + 2 * (w + 1);
          for (const J of [0, 1]) for (let fe = 0; fe <= w; fe++) for (const Se of [0, 1]) h.emplaceBack(J * a.EXTENT, fe * S, Se);
          for (let J = 0; J < 2 * w; J += 2) v.emplaceBack(W + J, W + J + 1, W + J + 3), v.emplaceBack(W + J, W + J + 3, W + J + 2), v.emplaceBack(Q + J, Q + J + 3, Q + J + 1), v.emplaceBack(Q + J, Q + J + 2, Q + J + 3);
          return this._mesh = { indexBuffer: o.createIndexBuffer(v), vertexBuffer: o.createVertexBuffer(h, pn.members), segments: a.SegmentVector.simpleSegment(0, 0, h.length, v.length) }, this._mesh;
        }
        getMeshFrameDelta(o) {
          return 2 * Math.PI * a.earthRadius / Math.pow(2, o) / 5;
        }
        getMinMaxElevation(o) {
          const h = this.getTerrainData(o).tile, v = { minElevation: null, maxElevation: null };
          return h && h.dem && (v.minElevation = h.dem.min * this.exaggeration, v.maxElevation = h.dem.max * this.exaggeration), v;
        }
      }
      class fr {
        constructor(o, h, v) {
          this._context = o, this._size = h, this._tileSize = v, this._objects = [], this._recentlyUsed = [], this._stamp = 0;
        }
        destruct() {
          for (const o of this._objects) o.texture.destroy(), o.fbo.destroy();
        }
        _createObject(o) {
          const h = this._context.createFramebuffer(this._tileSize, this._tileSize, !0, !0), v = new ve(this._context, { width: this._tileSize, height: this._tileSize, data: null }, this._context.gl.RGBA);
          return v.bind(this._context.gl.LINEAR, this._context.gl.CLAMP_TO_EDGE), h.depthAttachment.set(this._context.createRenderbuffer(this._context.gl.DEPTH_STENCIL, this._tileSize, this._tileSize)), h.colorAttachment.set(v.texture), { id: o, fbo: h, texture: v, stamp: -1, inUse: !1 };
        }
        getObjectForId(o) {
          return this._objects[o];
        }
        useObject(o) {
          o.inUse = !0, this._recentlyUsed = this._recentlyUsed.filter((h) => o.id !== h), this._recentlyUsed.push(o.id);
        }
        stampObject(o) {
          o.stamp = ++this._stamp;
        }
        getOrCreateFreeObject() {
          for (const h of this._recentlyUsed) if (!this._objects[h].inUse) return this._objects[h];
          if (this._objects.length >= this._size) throw new Error("No free RenderPool available, call freeAllObjects() required!");
          const o = this._createObject(this._objects.length);
          return this._objects.push(o), o;
        }
        freeObject(o) {
          o.inUse = !1;
        }
        freeAllObjects() {
          for (const o of this._objects) this.freeObject(o);
        }
        isFull() {
          return !(this._objects.length < this._size) && this._objects.some((o) => !o.inUse) === !1;
        }
      }
      const ir = { background: !0, fill: !0, line: !0, raster: !0, hillshade: !0 };
      class Kn {
        constructor(o, h) {
          this.painter = o, this.terrain = h, this.pool = new fr(o.context, 30, h.sourceCache.tileSize * h.qualityFactor);
        }
        destruct() {
          this.pool.destruct();
        }
        getTexture(o) {
          return this.pool.getObjectForId(o.rtt[this._stacks.length - 1].id).texture;
        }
        prepareForRender(o, h) {
          this._stacks = [], this._prevType = null, this._rttTiles = [], this._renderableTiles = this.terrain.sourceCache.getRenderableTiles(), this._renderableLayerIds = o._order.filter((v) => !o._layers[v].isHidden(h)), this._coordsDescendingInv = {};
          for (const v in o.sourceCaches) {
            this._coordsDescendingInv[v] = {};
            const w = o.sourceCaches[v].getVisibleCoordinates();
            for (const S of w) {
              const M = this.terrain.sourceCache.getTerrainCoords(S);
              for (const z in M) this._coordsDescendingInv[v][z] || (this._coordsDescendingInv[v][z] = []), this._coordsDescendingInv[v][z].push(M[z]);
            }
          }
          this._coordsDescendingInvStr = {};
          for (const v of o._order) {
            const w = o._layers[v], S = w.source;
            if (ir[w.type] && !this._coordsDescendingInvStr[S]) {
              this._coordsDescendingInvStr[S] = {};
              for (const M in this._coordsDescendingInv[S]) this._coordsDescendingInvStr[S][M] = this._coordsDescendingInv[S][M].map((z) => z.key).sort().join();
            }
          }
          for (const v of this._renderableTiles) for (const w in this._coordsDescendingInvStr) {
            const S = this._coordsDescendingInvStr[w][v.tileID.key];
            S && S !== v.rttCoords[w] && (v.rtt = []);
          }
        }
        renderLayer(o) {
          if (o.isHidden(this.painter.transform.zoom)) return !1;
          const h = o.type, v = this.painter, w = this._renderableLayerIds[this._renderableLayerIds.length - 1] === o.id;
          if (ir[h] && (this._prevType && ir[this._prevType] || this._stacks.push([]), this._prevType = h, this._stacks[this._stacks.length - 1].push(o.id), !w)) return !0;
          if (ir[this._prevType] || ir[h] && w) {
            this._prevType = h;
            const S = this._stacks.length - 1, M = this._stacks[S] || [];
            for (const z of this._renderableTiles) {
              if (this.pool.isFull() && (ed(this.painter, this.terrain, this._rttTiles), this._rttTiles = [], this.pool.freeAllObjects()), this._rttTiles.push(z), z.rtt[S]) {
                const W = this.pool.getObjectForId(z.rtt[S].id);
                if (W.stamp === z.rtt[S].stamp) {
                  this.pool.useObject(W);
                  continue;
                }
              }
              const R = this.pool.getOrCreateFreeObject();
              this.pool.useObject(R), this.pool.stampObject(R), z.rtt[S] = { id: R.id, stamp: R.stamp }, v.context.bindFramebuffer.set(R.fbo.framebuffer), v.context.clear({ color: a.Color.transparent, stencil: 0 }), v.currentStencilSource = void 0;
              for (let W = 0; W < M.length; W++) {
                const Q = v.style._layers[M[W]], J = Q.source ? this._coordsDescendingInv[Q.source][z.tileID.key] : [z.tileID];
                v.context.viewport.set([0, 0, R.fbo.width, R.fbo.height]), v._renderTileClippingMasks(Q, J), v.renderLayer(v, v.style.sourceCaches[Q.source], Q, J), Q.source && (z.rttCoords[Q.source] = this._coordsDescendingInvStr[Q.source][z.tileID.key]);
              }
            }
            return ed(this.painter, this.terrain, this._rttTiles), this._rttTiles = [], this.pool.freeAllObjects(), ir[h];
          }
          return !1;
        }
      }
      const Ri = f, sp = { center: [0, 0], zoom: 0, bearing: 0, pitch: 0, minZoom: -2, maxZoom: 22, minPitch: 0, maxPitch: 60, interactive: !0, scrollZoom: !0, boxZoom: !0, dragRotate: !0, dragPan: !0, keyboard: !0, doubleClickZoom: !0, touchZoomRotate: !0, touchPitch: !0, cooperativeGestures: void 0, bearingSnap: 7, clickTolerance: 3, pitchWithRotate: !0, hash: !1, attributionControl: !0, maplibreLogo: !1, failIfMajorPerformanceCaveat: !1, preserveDrawingBuffer: !1, trackResize: !0, renderWorldCopies: !0, refreshExpiredTiles: !0, maxTileCacheSize: null, maxTileCacheZoomLevels: a.config.MAX_TILE_CACHE_ZOOM_LEVELS, localIdeographFontFamily: "sans-serif", transformRequest: null, transformCameraUpdate: null, fadeDuration: 300, crossSourceCollisions: !0, validateStyle: !0 }, xl = (_) => {
        _.touchstart = _.dragStart, _.touchmoveWindow = _.dragMove, _.touchend = _.dragEnd;
      }, iu = { showCompass: !0, showZoom: !0, visualizePitch: !1 };
      class ru {
        constructor(o, h, v = !1) {
          this._clickTolerance = 10;
          const w = o.dragRotate._mouseRotate.getClickTolerance(), S = o.dragRotate._mousePitch.getClickTolerance();
          this.element = h, this.mouseRotate = td({ clickTolerance: w, enable: !0 }), this.touchRotate = (({ enable: M, clickTolerance: z, bearingDegreesPerPixelMoved: R = 0.8 }) => {
            const W = new Ao();
            return new Io({ clickTolerance: z, move: (Q, J) => ({ bearingDelta: (J.x - Q.x) * R }), moveStateManager: W, enable: M, assignEvents: xl });
          })({ clickTolerance: w, enable: !0 }), this.map = o, v && (this.mousePitch = eu({ clickTolerance: S, enable: !0 }), this.touchPitch = (({ enable: M, clickTolerance: z, pitchDegreesPerPixelMoved: R = -0.5 }) => {
            const W = new Ao();
            return new Io({ clickTolerance: z, move: (Q, J) => ({ pitchDelta: (J.y - Q.y) * R }), moveStateManager: W, enable: M, assignEvents: xl });
          })({ clickTolerance: S, enable: !0 })), a.bindAll(["mousedown", "mousemove", "mouseup", "touchstart", "touchmove", "touchend", "reset"], this), g.addEventListener(h, "mousedown", this.mousedown), g.addEventListener(h, "touchstart", this.touchstart, { passive: !1 }), g.addEventListener(h, "touchcancel", this.reset);
        }
        startMouse(o, h) {
          this.mouseRotate.dragStart(o, h), this.mousePitch && this.mousePitch.dragStart(o, h), g.disableDrag();
        }
        startTouch(o, h) {
          this.touchRotate.dragStart(o, h), this.touchPitch && this.touchPitch.dragStart(o, h), g.disableDrag();
        }
        moveMouse(o, h) {
          const v = this.map, { bearingDelta: w } = this.mouseRotate.dragMove(o, h) || {};
          if (w && v.setBearing(v.getBearing() + w), this.mousePitch) {
            const { pitchDelta: S } = this.mousePitch.dragMove(o, h) || {};
            S && v.setPitch(v.getPitch() + S);
          }
        }
        moveTouch(o, h) {
          const v = this.map, { bearingDelta: w } = this.touchRotate.dragMove(o, h) || {};
          if (w && v.setBearing(v.getBearing() + w), this.touchPitch) {
            const { pitchDelta: S } = this.touchPitch.dragMove(o, h) || {};
            S && v.setPitch(v.getPitch() + S);
          }
        }
        off() {
          const o = this.element;
          g.removeEventListener(o, "mousedown", this.mousedown), g.removeEventListener(o, "touchstart", this.touchstart, { passive: !1 }), g.removeEventListener(window, "touchmove", this.touchmove, { passive: !1 }), g.removeEventListener(window, "touchend", this.touchend), g.removeEventListener(o, "touchcancel", this.reset), this.offTemp();
        }
        offTemp() {
          g.enableDrag(), g.removeEventListener(window, "mousemove", this.mousemove), g.removeEventListener(window, "mouseup", this.mouseup), g.removeEventListener(window, "touchmove", this.touchmove, { passive: !1 }), g.removeEventListener(window, "touchend", this.touchend);
        }
        mousedown(o) {
          this.startMouse(a.extend({}, o, { ctrlKey: !0, preventDefault: () => o.preventDefault() }), g.mousePos(this.element, o)), g.addEventListener(window, "mousemove", this.mousemove), g.addEventListener(window, "mouseup", this.mouseup);
        }
        mousemove(o) {
          this.moveMouse(o, g.mousePos(this.element, o));
        }
        mouseup(o) {
          this.mouseRotate.dragEnd(o), this.mousePitch && this.mousePitch.dragEnd(o), this.offTemp();
        }
        touchstart(o) {
          o.targetTouches.length !== 1 ? this.reset() : (this._startPos = this._lastPos = g.touchPos(this.element, o.targetTouches)[0], this.startTouch(o, this._startPos), g.addEventListener(window, "touchmove", this.touchmove, { passive: !1 }), g.addEventListener(window, "touchend", this.touchend));
        }
        touchmove(o) {
          o.targetTouches.length !== 1 ? this.reset() : (this._lastPos = g.touchPos(this.element, o.targetTouches)[0], this.moveTouch(o, this._lastPos));
        }
        touchend(o) {
          o.targetTouches.length === 0 && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), delete this._startPos, delete this._lastPos, this.offTemp();
        }
        reset() {
          this.mouseRotate.reset(), this.mousePitch && this.mousePitch.reset(), this.touchRotate.reset(), this.touchPitch && this.touchPitch.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
        }
      }
      let fo;
      function mc(_, o, h) {
        if (_ = new a.LngLat(_.lng, _.lat), o) {
          const v = new a.LngLat(_.lng - 360, _.lat), w = new a.LngLat(_.lng + 360, _.lat), S = h.locationPoint(_).distSqr(o);
          h.locationPoint(v).distSqr(o) < S ? _ = v : h.locationPoint(w).distSqr(o) < S && (_ = w);
        }
        for (; Math.abs(_.lng - h.center.lng) > 180; ) {
          const v = h.locationPoint(_);
          if (v.x >= 0 && v.y >= 0 && v.x <= h.width && v.y <= h.height) break;
          _.lng > h.center.lng ? _.lng -= 360 : _.lng += 360;
        }
        return _;
      }
      const Pi = { center: "translate(-50%,-50%)", top: "translate(-50%,0)", "top-left": "translate(0,0)", "top-right": "translate(-100%,0)", bottom: "translate(-50%,-100%)", "bottom-left": "translate(0,-100%)", "bottom-right": "translate(-100%,-100%)", left: "translate(0,-50%)", right: "translate(-100%,-50%)" };
      function Da(_, o, h) {
        const v = _.classList;
        for (const w in Pi) v.remove(`maplibregl-${h}-anchor-${w}`);
        v.add(`maplibregl-${h}-anchor-${o}`);
      }
      class vc extends a.Evented {
        constructor(o, h) {
          if (super(), (o instanceof HTMLElement || h) && (o = a.extend({ element: o }, h)), a.bindAll(["_update", "_onMove", "_onUp", "_addDragHandler", "_onMapClick", "_onKeyPress"], this), this._anchor = o && o.anchor || "center", this._color = o && o.color || "#3FB1CE", this._scale = o && o.scale || 1, this._draggable = o && o.draggable || !1, this._clickTolerance = o && o.clickTolerance || 0, this._isDragging = !1, this._state = "inactive", this._rotation = o && o.rotation || 0, this._rotationAlignment = o && o.rotationAlignment || "auto", this._pitchAlignment = o && o.pitchAlignment && o.pitchAlignment !== "auto" ? o.pitchAlignment : this._rotationAlignment, o && o.element) this._element = o.element, this._offset = a.Point.convert(o && o.offset || [0, 0]);
          else {
            this._defaultMarker = !0, this._element = g.create("div"), this._element.setAttribute("aria-label", "Map marker");
            const v = g.createNS("http://www.w3.org/2000/svg", "svg"), w = 41, S = 27;
            v.setAttributeNS(null, "display", "block"), v.setAttributeNS(null, "height", `${w}px`), v.setAttributeNS(null, "width", `${S}px`), v.setAttributeNS(null, "viewBox", `0 0 ${S} ${w}`);
            const M = g.createNS("http://www.w3.org/2000/svg", "g");
            M.setAttributeNS(null, "stroke", "none"), M.setAttributeNS(null, "stroke-width", "1"), M.setAttributeNS(null, "fill", "none"), M.setAttributeNS(null, "fill-rule", "evenodd");
            const z = g.createNS("http://www.w3.org/2000/svg", "g");
            z.setAttributeNS(null, "fill-rule", "nonzero");
            const R = g.createNS("http://www.w3.org/2000/svg", "g");
            R.setAttributeNS(null, "transform", "translate(3.0, 29.0)"), R.setAttributeNS(null, "fill", "#000000");
            const W = [{ rx: "10.5", ry: "5.25002273" }, { rx: "10.5", ry: "5.25002273" }, { rx: "9.5", ry: "4.77275007" }, { rx: "8.5", ry: "4.29549936" }, { rx: "7.5", ry: "3.81822308" }, { rx: "6.5", ry: "3.34094679" }, { rx: "5.5", ry: "2.86367051" }, { rx: "4.5", ry: "2.38636864" }];
            for (const ct of W) {
              const Ee = g.createNS("http://www.w3.org/2000/svg", "ellipse");
              Ee.setAttributeNS(null, "opacity", "0.04"), Ee.setAttributeNS(null, "cx", "10.5"), Ee.setAttributeNS(null, "cy", "5.80029008"), Ee.setAttributeNS(null, "rx", ct.rx), Ee.setAttributeNS(null, "ry", ct.ry), R.appendChild(Ee);
            }
            const Q = g.createNS("http://www.w3.org/2000/svg", "g");
            Q.setAttributeNS(null, "fill", this._color);
            const J = g.createNS("http://www.w3.org/2000/svg", "path");
            J.setAttributeNS(null, "d", "M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"), Q.appendChild(J);
            const fe = g.createNS("http://www.w3.org/2000/svg", "g");
            fe.setAttributeNS(null, "opacity", "0.25"), fe.setAttributeNS(null, "fill", "#000000");
            const Se = g.createNS("http://www.w3.org/2000/svg", "path");
            Se.setAttributeNS(null, "d", "M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"), fe.appendChild(Se);
            const we = g.createNS("http://www.w3.org/2000/svg", "g");
            we.setAttributeNS(null, "transform", "translate(6.0, 7.0)"), we.setAttributeNS(null, "fill", "#FFFFFF");
            const Ce = g.createNS("http://www.w3.org/2000/svg", "g");
            Ce.setAttributeNS(null, "transform", "translate(8.0, 8.0)");
            const Me = g.createNS("http://www.w3.org/2000/svg", "circle");
            Me.setAttributeNS(null, "fill", "#000000"), Me.setAttributeNS(null, "opacity", "0.25"), Me.setAttributeNS(null, "cx", "5.5"), Me.setAttributeNS(null, "cy", "5.5"), Me.setAttributeNS(null, "r", "5.4999962");
            const Ue = g.createNS("http://www.w3.org/2000/svg", "circle");
            Ue.setAttributeNS(null, "fill", "#FFFFFF"), Ue.setAttributeNS(null, "cx", "5.5"), Ue.setAttributeNS(null, "cy", "5.5"), Ue.setAttributeNS(null, "r", "5.4999962"), Ce.appendChild(Me), Ce.appendChild(Ue), z.appendChild(R), z.appendChild(Q), z.appendChild(fe), z.appendChild(we), z.appendChild(Ce), v.appendChild(z), v.setAttributeNS(null, "height", w * this._scale + "px"), v.setAttributeNS(null, "width", S * this._scale + "px"), this._element.appendChild(v), this._offset = a.Point.convert(o && o.offset || [0, -14]);
          }
          this._element.classList.add("maplibregl-marker"), this._element.addEventListener("dragstart", (v) => {
            v.preventDefault();
          }), this._element.addEventListener("mousedown", (v) => {
            v.preventDefault();
          }), Da(this._element, this._anchor, "marker"), this._popup = null;
        }
        addTo(o) {
          return this.remove(), this._map = o, o.getCanvasContainer().appendChild(this._element), o.on("move", this._update), o.on("moveend", this._update), this.setDraggable(this._draggable), this._update(), this._map.on("click", this._onMapClick), this;
        }
        remove() {
          return this._opacityTimeout && (clearTimeout(this._opacityTimeout), delete this._opacityTimeout), this._map && (this._map.off("click", this._onMapClick), this._map.off("move", this._update), this._map.off("moveend", this._update), this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler), this._map.off("mouseup", this._onUp), this._map.off("touchend", this._onUp), this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), delete this._map), g.remove(this._element), this._popup && this._popup.remove(), this;
        }
        getLngLat() {
          return this._lngLat;
        }
        setLngLat(o) {
          return this._lngLat = a.LngLat.convert(o), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(), this;
        }
        getElement() {
          return this._element;
        }
        setPopup(o) {
          if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), o) {
            if (!("offset" in o.options)) {
              const w = Math.sqrt(Math.pow(13.5, 2) / 2);
              o.options.offset = this._defaultMarker ? { top: [0, 0], "top-left": [0, 0], "top-right": [0, 0], bottom: [0, -38.1], "bottom-left": [w, -1 * (38.1 - 13.5 + w)], "bottom-right": [-w, -1 * (38.1 - 13.5 + w)], left: [13.5, -1 * (38.1 - 13.5)], right: [-13.5, -1 * (38.1 - 13.5)] } : this._offset;
            }
            this._popup = o, this._lngLat && this._popup.setLngLat(this._lngLat), this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress);
          }
          return this;
        }
        _onKeyPress(o) {
          const h = o.code, v = o.charCode || o.keyCode;
          h !== "Space" && h !== "Enter" && v !== 32 && v !== 13 || this.togglePopup();
        }
        _onMapClick(o) {
          const h = o.originalEvent.target, v = this._element;
          this._popup && (h === v || v.contains(h)) && this.togglePopup();
        }
        getPopup() {
          return this._popup;
        }
        togglePopup() {
          const o = this._popup;
          return o ? (o.isOpen() ? o.remove() : o.addTo(this._map), this) : this;
        }
        _update(o) {
          if (!this._map) return;
          this._map.transform.renderWorldCopies && (this._lngLat = mc(this._lngLat, this._pos, this._map.transform)), this._pos = this._map.project(this._lngLat)._add(this._offset);
          let h = "";
          this._rotationAlignment === "viewport" || this._rotationAlignment === "auto" ? h = `rotateZ(${this._rotation}deg)` : this._rotationAlignment === "map" && (h = `rotateZ(${this._rotation - this._map.getBearing()}deg)`);
          let v = "";
          this._pitchAlignment === "viewport" || this._pitchAlignment === "auto" ? v = "rotateX(0deg)" : this._pitchAlignment === "map" && (v = `rotateX(${this._map.getPitch()}deg)`), o && o.type !== "moveend" || (this._pos = this._pos.round()), g.setTransform(this._element, `${Pi[this._anchor]} translate(${this._pos.x}px, ${this._pos.y}px) ${v} ${h}`), this._map.terrain && !this._opacityTimeout && (this._opacityTimeout = setTimeout(() => {
            const w = this._map.unproject(this._pos), S = 40075016686e-3 * Math.abs(Math.cos(this._lngLat.lat * Math.PI / 180)) / Math.pow(2, this._map.transform.tileZoom + 8);
            this._element.style.opacity = w.distanceTo(this._lngLat) > 20 * S ? "0.2" : "1.0", this._opacityTimeout = null;
          }, 100));
        }
        getOffset() {
          return this._offset;
        }
        setOffset(o) {
          return this._offset = a.Point.convert(o), this._update(), this;
        }
        _onMove(o) {
          if (!this._isDragging) {
            const h = this._clickTolerance || this._map._clickTolerance;
            this._isDragging = o.point.dist(this._pointerdownPos) >= h;
          }
          this._isDragging && (this._pos = o.point.sub(this._positionDelta), this._lngLat = this._map.unproject(this._pos), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", this._state === "pending" && (this._state = "active", this.fire(new a.Event("dragstart"))), this.fire(new a.Event("drag")));
        }
        _onUp() {
          this._element.style.pointerEvents = "auto", this._positionDelta = null, this._pointerdownPos = null, this._isDragging = !1, this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), this._state === "active" && this.fire(new a.Event("dragend")), this._state = "inactive";
        }
        _addDragHandler(o) {
          this._element.contains(o.originalEvent.target) && (o.preventDefault(), this._positionDelta = o.point.sub(this._pos).add(this._offset), this._pointerdownPos = o.point, this._state = "pending", this._map.on("mousemove", this._onMove), this._map.on("touchmove", this._onMove), this._map.once("mouseup", this._onUp), this._map.once("touchend", this._onUp));
        }
        setDraggable(o) {
          return this._draggable = !!o, this._map && (o ? (this._map.on("mousedown", this._addDragHandler), this._map.on("touchstart", this._addDragHandler)) : (this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler))), this;
        }
        isDraggable() {
          return this._draggable;
        }
        setRotation(o) {
          return this._rotation = o || 0, this._update(), this;
        }
        getRotation() {
          return this._rotation;
        }
        setRotationAlignment(o) {
          return this._rotationAlignment = o || "auto", this._update(), this;
        }
        getRotationAlignment() {
          return this._rotationAlignment;
        }
        setPitchAlignment(o) {
          return this._pitchAlignment = o && o !== "auto" ? o : this._rotationAlignment, this._update(), this;
        }
        getPitchAlignment() {
          return this._pitchAlignment;
        }
      }
      const od = { positionOptions: { enableHighAccuracy: !1, maximumAge: 0, timeout: 6e3 }, fitBoundsOptions: { maxZoom: 15 }, trackUserLocation: !1, showAccuracyCircle: !0, showUserLocation: !0 };
      let $l = 0, Eo = !1;
      const su = { maxWidth: 100, unit: "metric" };
      function ou(_, o, h) {
        const v = h && h.maxWidth || 100, w = _._container.clientHeight / 2, S = _.unproject([0, w]), M = _.unproject([v, w]), z = S.distanceTo(M);
        if (h && h.unit === "imperial") {
          const R = 3.2808 * z;
          R > 5280 ? gc(o, v, R / 5280, _._getUIString("ScaleControl.Miles")) : gc(o, v, R, _._getUIString("ScaleControl.Feet"));
        } else h && h.unit === "nautical" ? gc(o, v, z / 1852, _._getUIString("ScaleControl.NauticalMiles")) : z >= 1e3 ? gc(o, v, z / 1e3, _._getUIString("ScaleControl.Kilometers")) : gc(o, v, z, _._getUIString("ScaleControl.Meters"));
      }
      function gc(_, o, h, v) {
        const w = function(S) {
          const M = Math.pow(10, `${Math.floor(S)}`.length - 1);
          let z = S / M;
          return z = z >= 10 ? 10 : z >= 5 ? 5 : z >= 3 ? 3 : z >= 2 ? 2 : z >= 1 ? 1 : function(R) {
            const W = Math.pow(10, Math.ceil(-Math.log(R) / Math.LN10));
            return Math.round(R * W) / W;
          }(z), M * z;
        }(h);
        _.style.width = o * (w / h) + "px", _.innerHTML = `${w}&nbsp;${v}`;
      }
      const op = { closeButton: !0, closeOnClick: !0, focusAfterOpen: !0, className: "", maxWidth: "240px" }, cf = ["a[href]", "[tabindex]:not([tabindex='-1'])", "[contenteditable]:not([contenteditable='false'])", "button:not([disabled])", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].join(", ");
      function ap(_) {
        if (_) {
          if (typeof _ == "number") {
            const o = Math.round(Math.sqrt(0.5 * Math.pow(_, 2)));
            return { center: new a.Point(0, 0), top: new a.Point(0, _), "top-left": new a.Point(o, o), "top-right": new a.Point(-o, o), bottom: new a.Point(0, -_), "bottom-left": new a.Point(o, -o), "bottom-right": new a.Point(-o, -o), left: new a.Point(_, 0), right: new a.Point(-_, 0) };
          }
          if (_ instanceof a.Point || Array.isArray(_)) {
            const o = a.Point.convert(_);
            return { center: o, top: o, "top-left": o, "top-right": o, bottom: o, "bottom-left": o, "bottom-right": o, left: o, right: o };
          }
          return { center: a.Point.convert(_.center || [0, 0]), top: a.Point.convert(_.top || [0, 0]), "top-left": a.Point.convert(_["top-left"] || [0, 0]), "top-right": a.Point.convert(_["top-right"] || [0, 0]), bottom: a.Point.convert(_.bottom || [0, 0]), "bottom-left": a.Point.convert(_["bottom-left"] || [0, 0]), "bottom-right": a.Point.convert(_["bottom-right"] || [0, 0]), left: a.Point.convert(_.left || [0, 0]), right: a.Point.convert(_.right || [0, 0]) };
        }
        return ap(new a.Point(0, 0));
      }
      const lp = f, cp = { setRTLTextPlugin: a.setRTLTextPlugin, getRTLTextPluginStatus: a.getRTLTextPluginStatus, Map: class extends xe {
        constructor(_) {
          var o;
          if (a.PerformanceUtils.mark(a.PerformanceMarkers.create), (_ = a.extend({}, sp, _)).minZoom != null && _.maxZoom != null && _.minZoom > _.maxZoom) throw new Error("maxZoom must be greater than or equal to minZoom");
          if (_.minPitch != null && _.maxPitch != null && _.minPitch > _.maxPitch) throw new Error("maxPitch must be greater than or equal to minPitch");
          if (_.minPitch != null && _.minPitch < 0) throw new Error("minPitch must be greater than or equal to 0");
          if (_.maxPitch != null && _.maxPitch > 85) throw new Error("maxPitch must be less than or equal to 85");
          if (super(new gl(_.minZoom, _.maxZoom, _.minPitch, _.maxPitch, _.renderWorldCopies), { bearingSnap: _.bearingSnap }), this._interactive = _.interactive, this._cooperativeGestures = _.cooperativeGestures, this._metaKey = navigator.platform.indexOf("Mac") === 0 ? "metaKey" : "ctrlKey", this._maxTileCacheSize = _.maxTileCacheSize, this._maxTileCacheZoomLevels = _.maxTileCacheZoomLevels, this._failIfMajorPerformanceCaveat = _.failIfMajorPerformanceCaveat, this._preserveDrawingBuffer = _.preserveDrawingBuffer, this._antialias = _.antialias, this._trackResize = _.trackResize, this._bearingSnap = _.bearingSnap, this._refreshExpiredTiles = _.refreshExpiredTiles, this._fadeDuration = _.fadeDuration, this._crossSourceCollisions = _.crossSourceCollisions, this._crossFadingFactor = 1, this._collectResourceTiming = _.collectResourceTiming, this._renderTaskQueue = new $t(), this._controls = [], this._mapId = a.uniqueId(), this._locale = a.extend({}, Jt, _.locale), this._clickTolerance = _.clickTolerance, this._pixelRatio = (o = _.pixelRatio) !== null && o !== void 0 ? o : devicePixelRatio, this.transformCameraUpdate = _.transformCameraUpdate, this._imageQueueHandle = K.addThrottleControl(() => this.isMoving()), this._requestManager = new U(_.transformRequest), typeof _.container == "string") {
            if (this._container = document.getElementById(_.container), !this._container) throw new Error(`Container '${_.container}' not found.`);
          } else {
            if (!(_.container instanceof HTMLElement)) throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
            this._container = _.container;
          }
          if (_.maxBounds && this.setMaxBounds(_.maxBounds), a.bindAll(["_onWindowOnline", "_onMapScroll", "_cooperativeGesturesOnWheel", "_contextLost", "_contextRestored"], this), this._setupContainer(), this._setupPainter(), this.on("move", () => this._update(!1)), this.on("moveend", () => this._update(!1)), this.on("zoom", () => this._update(!0)), this.on("terrain", () => {
            this.painter.terrainFacilitator.dirty = !0, this._update(!0);
          }), this.once("idle", () => {
            this._idleTriggered = !0;
          }), typeof window < "u") {
            addEventListener("online", this._onWindowOnline, !1);
            let h = !1;
            this._resizeObserver = new ResizeObserver((v) => {
              h ? this._trackResize && this.resize(v)._update() : h = !0;
            }), this._resizeObserver.observe(this._container);
          }
          this.handlers = new j(this, _), this._cooperativeGestures && this._setupCooperativeGestures(), this._hash = _.hash && new cc(typeof _.hash == "string" && _.hash || void 0).addTo(this), this._hash && this._hash._onHashChange() || (this.jumpTo({ center: _.center, zoom: _.zoom, bearing: _.bearing, pitch: _.pitch }), _.bounds && (this.resize(), this.fitBounds(_.bounds, a.extend({}, _.fitBoundsOptions, { duration: 0 })))), this.resize(), this._localIdeographFontFamily = _.localIdeographFontFamily, this._validateStyle = _.validateStyle, _.style && this.setStyle(_.style, { localIdeographFontFamily: _.localIdeographFontFamily }), _.attributionControl && this.addControl(new Ve({ customAttribution: _.customAttribution })), _.maplibreLogo && this.addControl(new pt(), _.logoPosition), this.on("style.load", () => {
            this.transform.unmodified && this.jumpTo(this.style.stylesheet);
          }), this.on("data", (h) => {
            this._update(h.dataType === "style"), this.fire(new a.Event(`${h.dataType}data`, h));
          }), this.on("dataloading", (h) => {
            this.fire(new a.Event(`${h.dataType}dataloading`, h));
          }), this.on("dataabort", (h) => {
            this.fire(new a.Event("sourcedataabort", h));
          });
        }
        _getMapId() {
          return this._mapId;
        }
        addControl(_, o) {
          if (o === void 0 && (o = _.getDefaultPosition ? _.getDefaultPosition() : "top-right"), !_ || !_.onAdd) return this.fire(new a.ErrorEvent(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
          const h = _.onAdd(this);
          this._controls.push(_);
          const v = this._controlPositions[o];
          return o.indexOf("bottom") !== -1 ? v.insertBefore(h, v.firstChild) : v.appendChild(h), this;
        }
        removeControl(_) {
          if (!_ || !_.onRemove) return this.fire(new a.ErrorEvent(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
          const o = this._controls.indexOf(_);
          return o > -1 && this._controls.splice(o, 1), _.onRemove(this), this;
        }
        hasControl(_) {
          return this._controls.indexOf(_) > -1;
        }
        calculateCameraOptionsFromTo(_, o, h, v) {
          return v == null && this.terrain && (v = this.transform.getElevation(h, this.terrain)), super.calculateCameraOptionsFromTo(_, o, h, v);
        }
        resize(_) {
          var o;
          const h = this._containerDimensions(), v = h[0], w = h[1];
          this._resizeCanvas(v, w, this.getPixelRatio()), this.transform.resize(v, w), (o = this._requestedCameraState) === null || o === void 0 || o.resize(v, w), this.painter.resize(v, w, this.getPixelRatio());
          const S = !this._moving;
          return S && (this.stop(), this.fire(new a.Event("movestart", _)).fire(new a.Event("move", _))), this.fire(new a.Event("resize", _)), S && this.fire(new a.Event("moveend", _)), this;
        }
        getPixelRatio() {
          return this._pixelRatio;
        }
        setPixelRatio(_) {
          const [o, h] = this._containerDimensions();
          this._pixelRatio = _, this._resizeCanvas(o, h, _), this.painter.resize(o, h, _);
        }
        getBounds() {
          return this.transform.getBounds();
        }
        getMaxBounds() {
          return this.transform.getMaxBounds();
        }
        setMaxBounds(_) {
          return this.transform.setMaxBounds(Le.convert(_)), this._update();
        }
        setMinZoom(_) {
          if ((_ = _ ?? -2) >= -2 && _ <= this.transform.maxZoom) return this.transform.minZoom = _, this._update(), this.getZoom() < _ && this.setZoom(_), this;
          throw new Error("minZoom must be between -2 and the current maxZoom, inclusive");
        }
        getMinZoom() {
          return this.transform.minZoom;
        }
        setMaxZoom(_) {
          if ((_ = _ ?? 22) >= this.transform.minZoom) return this.transform.maxZoom = _, this._update(), this.getZoom() > _ && this.setZoom(_), this;
          throw new Error("maxZoom must be greater than the current minZoom");
        }
        getMaxZoom() {
          return this.transform.maxZoom;
        }
        setMinPitch(_) {
          if ((_ = _ ?? 0) < 0) throw new Error("minPitch must be greater than or equal to 0");
          if (_ >= 0 && _ <= this.transform.maxPitch) return this.transform.minPitch = _, this._update(), this.getPitch() < _ && this.setPitch(_), this;
          throw new Error("minPitch must be between 0 and the current maxPitch, inclusive");
        }
        getMinPitch() {
          return this.transform.minPitch;
        }
        setMaxPitch(_) {
          if ((_ = _ ?? 60) > 85) throw new Error("maxPitch must be less than or equal to 85");
          if (_ >= this.transform.minPitch) return this.transform.maxPitch = _, this._update(), this.getPitch() > _ && this.setPitch(_), this;
          throw new Error("maxPitch must be greater than the current minPitch");
        }
        getMaxPitch() {
          return this.transform.maxPitch;
        }
        getRenderWorldCopies() {
          return this.transform.renderWorldCopies;
        }
        setRenderWorldCopies(_) {
          return this.transform.renderWorldCopies = _, this._update();
        }
        getCooperativeGestures() {
          return this._cooperativeGestures;
        }
        setCooperativeGestures(_) {
          return this._cooperativeGestures = _, this._cooperativeGestures ? this._setupCooperativeGestures() : this._destroyCooperativeGestures(), this;
        }
        project(_) {
          return this.transform.locationPoint(a.LngLat.convert(_), this.style && this.terrain);
        }
        unproject(_) {
          return this.transform.pointLocation(a.Point.convert(_), this.terrain);
        }
        isMoving() {
          var _;
          return this._moving || ((_ = this.handlers) === null || _ === void 0 ? void 0 : _.isMoving());
        }
        isZooming() {
          var _;
          return this._zooming || ((_ = this.handlers) === null || _ === void 0 ? void 0 : _.isZooming());
        }
        isRotating() {
          var _;
          return this._rotating || ((_ = this.handlers) === null || _ === void 0 ? void 0 : _.isRotating());
        }
        _createDelegatedListener(_, o, h) {
          if (_ === "mouseenter" || _ === "mouseover") {
            let v = !1;
            return { layer: o, listener: h, delegates: { mousemove: (S) => {
              const M = this.getLayer(o) ? this.queryRenderedFeatures(S.point, { layers: [o] }) : [];
              M.length ? v || (v = !0, h.call(this, new nr(_, this, S.originalEvent, { features: M }))) : v = !1;
            }, mouseout: () => {
              v = !1;
            } } };
          }
          if (_ === "mouseleave" || _ === "mouseout") {
            let v = !1;
            return { layer: o, listener: h, delegates: { mousemove: (M) => {
              (this.getLayer(o) ? this.queryRenderedFeatures(M.point, { layers: [o] }) : []).length ? v = !0 : v && (v = !1, h.call(this, new nr(_, this, M.originalEvent)));
            }, mouseout: (M) => {
              v && (v = !1, h.call(this, new nr(_, this, M.originalEvent)));
            } } };
          }
          {
            const v = (w) => {
              const S = this.getLayer(o) ? this.queryRenderedFeatures(w.point, { layers: [o] }) : [];
              S.length && (w.features = S, h.call(this, w), delete w.features);
            };
            return { layer: o, listener: h, delegates: { [_]: v } };
          }
        }
        on(_, o, h) {
          if (h === void 0) return super.on(_, o);
          const v = this._createDelegatedListener(_, o, h);
          this._delegatedListeners = this._delegatedListeners || {}, this._delegatedListeners[_] = this._delegatedListeners[_] || [], this._delegatedListeners[_].push(v);
          for (const w in v.delegates) this.on(w, v.delegates[w]);
          return this;
        }
        once(_, o, h) {
          if (h === void 0) return super.once(_, o);
          const v = this._createDelegatedListener(_, o, h);
          for (const w in v.delegates) this.once(w, v.delegates[w]);
          return this;
        }
        off(_, o, h) {
          return h === void 0 ? super.off(_, o) : (this._delegatedListeners && this._delegatedListeners[_] && ((v) => {
            const w = this._delegatedListeners[_];
            for (let S = 0; S < w.length; S++) {
              const M = w[S];
              if (M.layer === o && M.listener === h) {
                for (const z in M.delegates) this.off(z, M.delegates[z]);
                return w.splice(S, 1), this;
              }
            }
          })(), this);
        }
        queryRenderedFeatures(_, o) {
          if (!this.style) return [];
          let h;
          const v = _ instanceof a.Point || Array.isArray(_), w = v ? _ : [[0, 0], [this.transform.width, this.transform.height]];
          if (o = o || (v ? {} : _) || {}, w instanceof a.Point || typeof w[0] == "number") h = [a.Point.convert(w)];
          else {
            const S = a.Point.convert(w[0]), M = a.Point.convert(w[1]);
            h = [S, new a.Point(M.x, S.y), M, new a.Point(S.x, M.y), S];
          }
          return this.style.queryRenderedFeatures(h, o, this.transform);
        }
        querySourceFeatures(_, o) {
          return this.style.querySourceFeatures(_, o);
        }
        setStyle(_, o) {
          return (o = a.extend({}, { localIdeographFontFamily: this._localIdeographFontFamily, validate: this._validateStyle }, o)).diff !== !1 && o.localIdeographFontFamily === this._localIdeographFontFamily && this.style && _ ? (this._diffStyle(_, o), this) : (this._localIdeographFontFamily = o.localIdeographFontFamily, this._updateStyle(_, o));
        }
        setTransformRequest(_) {
          return this._requestManager.setTransformRequest(_), this;
        }
        _getUIString(_) {
          const o = this._locale[_];
          if (o == null) throw new Error(`Missing UI string '${_}'`);
          return o;
        }
        _updateStyle(_, o) {
          if (o.transformStyle && this.style && !this.style._loaded) return void this.style.once("style.load", () => this._updateStyle(_, o));
          const h = this.style && o.transformStyle ? this.style.serialize() : void 0;
          return this.style && (this.style.setEventedParent(null), this.style._remove(!_)), _ ? (this.style = new Ki(this, o || {}), this.style.setEventedParent(this, { style: this.style }), typeof _ == "string" ? this.style.loadURL(_, o, h) : this.style.loadJSON(_, o, h), this) : (delete this.style, this);
        }
        _lazyInitEmptyStyle() {
          this.style || (this.style = new Ki(this, {}), this.style.setEventedParent(this, { style: this.style }), this.style.loadEmpty());
        }
        _diffStyle(_, o) {
          if (typeof _ == "string") {
            const h = this._requestManager.transformRequest(_, N.Style);
            a.getJSON(h, (v, w) => {
              v ? this.fire(new a.ErrorEvent(v)) : w && this._updateDiff(w, o);
            });
          } else typeof _ == "object" && this._updateDiff(_, o);
        }
        _updateDiff(_, o) {
          try {
            this.style.setState(_, o) && this._update(!0);
          } catch (h) {
            a.warnOnce(`Unable to perform style diff: ${h.message || h.error || h}.  Rebuilding the style from scratch.`), this._updateStyle(_, o);
          }
        }
        getStyle() {
          if (this.style) return this.style.serialize();
        }
        isStyleLoaded() {
          return this.style ? this.style.loaded() : a.warnOnce("There is no style added to the map.");
        }
        addSource(_, o) {
          return this._lazyInitEmptyStyle(), this.style.addSource(_, o), this._update(!0);
        }
        isSourceLoaded(_) {
          const o = this.style && this.style.sourceCaches[_];
          if (o !== void 0) return o.loaded();
          this.fire(new a.ErrorEvent(new Error(`There is no source with ID '${_}'`)));
        }
        setTerrain(_) {
          if (this.style._checkLoaded(), this._terrainDataCallback && this.style.off("data", this._terrainDataCallback), _) {
            const o = this.style.sourceCaches[_.source];
            if (!o) throw new Error(`cannot load terrain, because there exists no source with ID: ${_.source}`);
            for (const h in this.style._layers) {
              const v = this.style._layers[h];
              v.type === "hillshade" && v.source === _.source && a.warnOnce("You are using the same source for a hillshade layer and for 3D terrain. Please consider using two separate sources to improve rendering quality.");
            }
            this.terrain = new Hi(this.painter, o, _), this.painter.renderToTexture = new Kn(this.painter, this.terrain), this.transform.updateElevation(this.terrain), this._terrainDataCallback = (h) => {
              h.dataType === "style" ? this.terrain.sourceCache.freeRtt() : h.dataType === "source" && h.tile && (h.sourceId === _.source && this.transform.updateElevation(this.terrain), this.terrain.sourceCache.freeRtt(h.tile.tileID));
            }, this.style.on("data", this._terrainDataCallback);
          } else this.terrain && this.terrain.sourceCache.destruct(), this.terrain = null, this.painter.renderToTexture && this.painter.renderToTexture.destruct(), this.painter.renderToTexture = null, this.transform.updateElevation(this.terrain);
          return this.fire(new a.Event("terrain", { terrain: _ })), this;
        }
        getTerrain() {
          return this.terrain && this.terrain.options;
        }
        areTilesLoaded() {
          const _ = this.style && this.style.sourceCaches;
          for (const o in _) {
            const h = _[o]._tiles;
            for (const v in h) {
              const w = h[v];
              if (w.state !== "loaded" && w.state !== "errored") return !1;
            }
          }
          return !0;
        }
        addSourceType(_, o, h) {
          return this._lazyInitEmptyStyle(), this.style.addSourceType(_, o, h);
        }
        removeSource(_) {
          return this.style.removeSource(_), this._update(!0);
        }
        getSource(_) {
          return this.style.getSource(_);
        }
        addImage(_, o, { pixelRatio: h = 1, sdf: v = !1, stretchX: w, stretchY: S, content: M } = {}) {
          if (this._lazyInitEmptyStyle(), o instanceof HTMLImageElement || a.isImageBitmap(o)) {
            const { width: z, height: R, data: W } = a.exported.getImageData(o);
            this.style.addImage(_, { data: new a.RGBAImage({ width: z, height: R }, W), pixelRatio: h, stretchX: w, stretchY: S, content: M, sdf: v, version: 0 });
          } else {
            if (o.width === void 0 || o.height === void 0) return this.fire(new a.ErrorEvent(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
            {
              const { width: z, height: R, data: W } = o, Q = o;
              this.style.addImage(_, { data: new a.RGBAImage({ width: z, height: R }, new Uint8Array(W)), pixelRatio: h, stretchX: w, stretchY: S, content: M, sdf: v, version: 0, userImage: Q }), Q.onAdd && Q.onAdd(this, _);
            }
          }
        }
        updateImage(_, o) {
          const h = this.style.getImage(_);
          if (!h) return this.fire(new a.ErrorEvent(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
          const v = o instanceof HTMLImageElement || a.isImageBitmap(o) ? a.exported.getImageData(o) : o, { width: w, height: S, data: M } = v;
          if (w === void 0 || S === void 0) return this.fire(new a.ErrorEvent(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
          if (w !== h.data.width || S !== h.data.height) return this.fire(new a.ErrorEvent(new Error("The width and height of the updated image must be that same as the previous version of the image")));
          const z = !(o instanceof HTMLImageElement || a.isImageBitmap(o));
          h.data.replace(M, z), this.style.updateImage(_, h);
        }
        getImage(_) {
          return this.style.getImage(_);
        }
        hasImage(_) {
          return _ ? !!this.style.getImage(_) : (this.fire(new a.ErrorEvent(new Error("Missing required image id"))), !1);
        }
        removeImage(_) {
          this.style.removeImage(_);
        }
        loadImage(_, o) {
          K.getImage(this._requestManager.transformRequest(_, N.Image), o);
        }
        listImages() {
          return this.style.listImages();
        }
        addLayer(_, o) {
          return this._lazyInitEmptyStyle(), this.style.addLayer(_, o), this._update(!0);
        }
        moveLayer(_, o) {
          return this.style.moveLayer(_, o), this._update(!0);
        }
        removeLayer(_) {
          return this.style.removeLayer(_), this._update(!0);
        }
        getLayer(_) {
          return this.style.getLayer(_);
        }
        setLayerZoomRange(_, o, h) {
          return this.style.setLayerZoomRange(_, o, h), this._update(!0);
        }
        setFilter(_, o, h = {}) {
          return this.style.setFilter(_, o, h), this._update(!0);
        }
        getFilter(_) {
          return this.style.getFilter(_);
        }
        setPaintProperty(_, o, h, v = {}) {
          return this.style.setPaintProperty(_, o, h, v), this._update(!0);
        }
        getPaintProperty(_, o) {
          return this.style.getPaintProperty(_, o);
        }
        setLayoutProperty(_, o, h, v = {}) {
          return this.style.setLayoutProperty(_, o, h, v), this._update(!0);
        }
        getLayoutProperty(_, o) {
          return this.style.getLayoutProperty(_, o);
        }
        setGlyphs(_, o = {}) {
          return this._lazyInitEmptyStyle(), this.style.setGlyphs(_, o), this._update(!0);
        }
        getGlyphs() {
          return this.style.getGlyphsUrl();
        }
        addSprite(_, o, h = {}) {
          return this._lazyInitEmptyStyle(), this.style.addSprite(_, o, h, (v) => {
            v || this._update(!0);
          }), this;
        }
        removeSprite(_) {
          return this._lazyInitEmptyStyle(), this.style.removeSprite(_), this._update(!0);
        }
        getSprite() {
          return this.style.getSprite();
        }
        setSprite(_, o = {}) {
          return this._lazyInitEmptyStyle(), this.style.setSprite(_, o, (h) => {
            h || this._update(!0);
          }), this;
        }
        setLight(_, o = {}) {
          return this._lazyInitEmptyStyle(), this.style.setLight(_, o), this._update(!0);
        }
        getLight() {
          return this.style.getLight();
        }
        setFeatureState(_, o) {
          return this.style.setFeatureState(_, o), this._update();
        }
        removeFeatureState(_, o) {
          return this.style.removeFeatureState(_, o), this._update();
        }
        getFeatureState(_) {
          return this.style.getFeatureState(_);
        }
        getContainer() {
          return this._container;
        }
        getCanvasContainer() {
          return this._canvasContainer;
        }
        getCanvas() {
          return this._canvas;
        }
        _containerDimensions() {
          let _ = 0, o = 0;
          return this._container && (_ = this._container.clientWidth || 400, o = this._container.clientHeight || 300), [_, o];
        }
        _setupContainer() {
          const _ = this._container;
          _.classList.add("maplibregl-map");
          const o = this._canvasContainer = g.create("div", "maplibregl-canvas-container", _);
          this._interactive && o.classList.add("maplibregl-interactive"), this._canvas = g.create("canvas", "maplibregl-canvas", o), this._canvas.addEventListener("webglcontextlost", this._contextLost, !1), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.setAttribute("tabindex", "0"), this._canvas.setAttribute("aria-label", "Map"), this._canvas.setAttribute("role", "region");
          const h = this._containerDimensions();
          this._resizeCanvas(h[0], h[1], this.getPixelRatio());
          const v = this._controlContainer = g.create("div", "maplibregl-control-container", _), w = this._controlPositions = {};
          ["top-left", "top-right", "bottom-left", "bottom-right"].forEach((S) => {
            w[S] = g.create("div", `maplibregl-ctrl-${S} `, v);
          }), this._container.addEventListener("scroll", this._onMapScroll, !1);
        }
        _cooperativeGesturesOnWheel(_) {
          this._onCooperativeGesture(_, _[this._metaKey], 1);
        }
        _setupCooperativeGestures() {
          this._cooperativeGesturesScreen = g.create("div", "maplibregl-cooperative-gesture-screen", this._container);
          let _ = typeof this._cooperativeGestures != "boolean" && this._cooperativeGestures.windowsHelpText ? this._cooperativeGestures.windowsHelpText : "Use Ctrl + scroll to zoom the map";
          navigator.platform.indexOf("Mac") === 0 && (_ = typeof this._cooperativeGestures != "boolean" && this._cooperativeGestures.macHelpText ? this._cooperativeGestures.macHelpText : "Use ⌘ + scroll to zoom the map"), this._cooperativeGesturesScreen.innerHTML = `
            <div class="maplibregl-desktop-message">${_}</div>
            <div class="maplibregl-mobile-message">${typeof this._cooperativeGestures != "boolean" && this._cooperativeGestures.mobileHelpText ? this._cooperativeGestures.mobileHelpText : "Use two fingers to move the map"}</div>
        `, this._canvasContainer.addEventListener("wheel", this._cooperativeGesturesOnWheel, !1), this._canvasContainer.classList.add("maplibregl-cooperative-gestures");
        }
        _destroyCooperativeGestures() {
          g.remove(this._cooperativeGesturesScreen), this._canvasContainer.removeEventListener("wheel", this._cooperativeGesturesOnWheel, !1), this._canvasContainer.classList.remove("maplibregl-cooperative-gestures");
        }
        _resizeCanvas(_, o, h) {
          this._canvas.width = h * _, this._canvas.height = h * o, this._canvas.style.width = `${_}px`, this._canvas.style.height = `${o}px`;
        }
        _setupPainter() {
          const _ = { alpha: !0, stencil: !0, depth: !0, failIfMajorPerformanceCaveat: this._failIfMajorPerformanceCaveat, preserveDrawingBuffer: this._preserveDrawingBuffer, antialias: this._antialias || !1 };
          let o = null;
          this._canvas.addEventListener("webglcontextcreationerror", (v) => {
            o = { requestedAttributes: _ }, v && (o.statusMessage = v.statusMessage, o.type = v.type);
          }, { once: !0 });
          const h = this._canvas.getContext("webgl2", _) || this._canvas.getContext("webgl", _);
          if (!h) {
            const v = "Failed to initialize WebGL";
            throw o ? (o.message = v, new Error(JSON.stringify(o))) : new Error(v);
          }
          this.painter = new ip(h, this.transform), x.testSupport(h);
        }
        _contextLost(_) {
          _.preventDefault(), this._frame && (this._frame.cancel(), this._frame = null), this.fire(new a.Event("webglcontextlost", { originalEvent: _ }));
        }
        _contextRestored(_) {
          this._setupPainter(), this.resize(), this._update(), this.fire(new a.Event("webglcontextrestored", { originalEvent: _ }));
        }
        _onMapScroll(_) {
          if (_.target === this._container) return this._container.scrollTop = 0, this._container.scrollLeft = 0, !1;
        }
        _onCooperativeGesture(_, o, h) {
          return !o && h < 2 && (this._cooperativeGesturesScreen.classList.add("maplibregl-show"), setTimeout(() => {
            this._cooperativeGesturesScreen.classList.remove("maplibregl-show");
          }, 100)), !1;
        }
        loaded() {
          return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
        }
        _update(_) {
          return this.style && this.style._loaded ? (this._styleDirty = this._styleDirty || _, this._sourcesDirty = !0, this.triggerRepaint(), this) : this;
        }
        _requestRenderFrame(_) {
          return this._update(), this._renderTaskQueue.add(_);
        }
        _cancelRenderFrame(_) {
          this._renderTaskQueue.remove(_);
        }
        _render(_) {
          const o = this._idleTriggered ? this._fadeDuration : 0;
          if (this.painter.context.setDirty(), this.painter.setBaseState(), this._renderTaskQueue.run(_), this._removed) return;
          let h = !1;
          if (this.style && this._styleDirty) {
            this._styleDirty = !1;
            const w = this.transform.zoom, S = a.exported.now();
            this.style.zoomHistory.update(w, S);
            const M = new a.EvaluationParameters(w, { now: S, fadeDuration: o, zoomHistory: this.style.zoomHistory, transition: this.style.getTransition() }), z = M.crossFadingFactor();
            z === 1 && z === this._crossFadingFactor || (h = !0, this._crossFadingFactor = z), this.style.update(M);
          }
          this.style && this._sourcesDirty && (this._sourcesDirty = !1, this.style._updateSources(this.transform)), this.terrain && this.terrain.sourceCache.update(this.transform, this.terrain), this.transform.updateElevation(this.terrain), this._placementDirty = this.style && this.style._updatePlacement(this.painter.transform, this.showCollisionBoxes, o, this._crossSourceCollisions), this.painter.render(this.style, { showTileBoundaries: this.showTileBoundaries, showOverdrawInspector: this._showOverdrawInspector, rotating: this.isRotating(), zooming: this.isZooming(), moving: this.isMoving(), fadeDuration: o, showPadding: this.showPadding }), this.fire(new a.Event("render")), this.loaded() && !this._loaded && (this._loaded = !0, a.PerformanceUtils.mark(a.PerformanceMarkers.load), this.fire(new a.Event("load"))), this.style && (this.style.hasTransitions() || h) && (this._styleDirty = !0), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles();
          const v = this._sourcesDirty || this._styleDirty || this._placementDirty;
          return v || this._repaint ? this.triggerRepaint() : !this.isMoving() && this.loaded() && this.fire(new a.Event("idle")), !this._loaded || this._fullyLoaded || v || (this._fullyLoaded = !0, a.PerformanceUtils.mark(a.PerformanceMarkers.fullLoad)), this;
        }
        redraw() {
          return this.style && (this._frame && (this._frame.cancel(), this._frame = null), this._render(0)), this;
        }
        remove() {
          var _;
          this._hash && this._hash.remove();
          for (const h of this._controls) h.onRemove(this);
          this._controls = [], this._frame && (this._frame.cancel(), this._frame = null), this._renderTaskQueue.clear(), this.painter.destroy(), this.handlers.destroy(), delete this.handlers, this.setStyle(null), typeof window < "u" && removeEventListener("online", this._onWindowOnline, !1), K.removeThrottleControl(this._imageQueueHandle), (_ = this._resizeObserver) === null || _ === void 0 || _.disconnect();
          const o = this.painter.context.gl.getExtension("WEBGL_lose_context");
          o && o.loseContext(), this._canvas.removeEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.removeEventListener("webglcontextlost", this._contextLost, !1), g.remove(this._canvasContainer), g.remove(this._controlContainer), this._cooperativeGestures && this._destroyCooperativeGestures(), this._container.classList.remove("maplibregl-map"), a.PerformanceUtils.clearMetrics(), this._removed = !0, this.fire(new a.Event("remove"));
        }
        triggerRepaint() {
          this.style && !this._frame && (this._frame = a.exported.frame((_) => {
            a.PerformanceUtils.frame(_), this._frame = null, this._render(_);
          }));
        }
        _onWindowOnline() {
          this._update();
        }
        get showTileBoundaries() {
          return !!this._showTileBoundaries;
        }
        set showTileBoundaries(_) {
          this._showTileBoundaries !== _ && (this._showTileBoundaries = _, this._update());
        }
        get showPadding() {
          return !!this._showPadding;
        }
        set showPadding(_) {
          this._showPadding !== _ && (this._showPadding = _, this._update());
        }
        get showCollisionBoxes() {
          return !!this._showCollisionBoxes;
        }
        set showCollisionBoxes(_) {
          this._showCollisionBoxes !== _ && (this._showCollisionBoxes = _, _ ? this.style._generateCollisionBoxes() : this._update());
        }
        get showOverdrawInspector() {
          return !!this._showOverdrawInspector;
        }
        set showOverdrawInspector(_) {
          this._showOverdrawInspector !== _ && (this._showOverdrawInspector = _, this._update());
        }
        get repaint() {
          return !!this._repaint;
        }
        set repaint(_) {
          this._repaint !== _ && (this._repaint = _, this.triggerRepaint());
        }
        get vertices() {
          return !!this._vertices;
        }
        set vertices(_) {
          this._vertices = _, this._update();
        }
        get version() {
          return Ri;
        }
        getCameraTargetElevation() {
          return this.transform.elevation;
        }
      }, NavigationControl: class {
        constructor(_) {
          this.options = a.extend({}, iu, _), this._container = g.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._container.addEventListener("contextmenu", (o) => o.preventDefault()), this.options.showZoom && (a.bindAll(["_setButtonTitle", "_updateZoomButtons"], this), this._zoomInButton = this._createButton("maplibregl-ctrl-zoom-in", (o) => this._map.zoomIn({}, { originalEvent: o })), g.create("span", "maplibregl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", "true"), this._zoomOutButton = this._createButton("maplibregl-ctrl-zoom-out", (o) => this._map.zoomOut({}, { originalEvent: o })), g.create("span", "maplibregl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", "true")), this.options.showCompass && (a.bindAll(["_rotateCompassArrow"], this), this._compass = this._createButton("maplibregl-ctrl-compass", (o) => {
            this.options.visualizePitch ? this._map.resetNorthPitch({}, { originalEvent: o }) : this._map.resetNorth({}, { originalEvent: o });
          }), this._compassIcon = g.create("span", "maplibregl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", "true"));
        }
        _updateZoomButtons() {
          const _ = this._map.getZoom(), o = _ === this._map.getMaxZoom(), h = _ === this._map.getMinZoom();
          this._zoomInButton.disabled = o, this._zoomOutButton.disabled = h, this._zoomInButton.setAttribute("aria-disabled", o.toString()), this._zoomOutButton.setAttribute("aria-disabled", h.toString());
        }
        _rotateCompassArrow() {
          const _ = this.options.visualizePitch ? `scale(${1 / Math.pow(Math.cos(this._map.transform.pitch * (Math.PI / 180)), 0.5)}) rotateX(${this._map.transform.pitch}deg) rotateZ(${this._map.transform.angle * (180 / Math.PI)}deg)` : `rotate(${this._map.transform.angle * (180 / Math.PI)}deg)`;
          this._compassIcon.style.transform = _;
        }
        onAdd(_) {
          return this._map = _, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), this._map.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && this._map.on("pitch", this._rotateCompassArrow), this._map.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new ru(this._map, this._compass, this.options.visualizePitch)), this._container;
        }
        onRemove() {
          g.remove(this._container), this.options.showZoom && this._map.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && this._map.off("pitch", this._rotateCompassArrow), this._map.off("rotate", this._rotateCompassArrow), this._handler.off(), delete this._handler), delete this._map;
        }
        _createButton(_, o) {
          const h = g.create("button", _, this._container);
          return h.type = "button", h.addEventListener("click", o), h;
        }
        _setButtonTitle(_, o) {
          const h = this._map._getUIString(`NavigationControl.${o}`);
          _.title = h, _.setAttribute("aria-label", h);
        }
      }, GeolocateControl: class extends a.Evented {
        constructor(_) {
          super(), this.options = a.extend({}, od, _), a.bindAll(["_onSuccess", "_onError", "_onZoom", "_finish", "_setupUI", "_updateCamera", "_updateMarker"], this);
        }
        onAdd(_) {
          return this._map = _, this._container = g.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), function(o, h = !1) {
            fo === void 0 || h ? window.navigator.permissions !== void 0 ? window.navigator.permissions.query({ name: "geolocation" }).then((v) => {
              fo = v.state !== "denied", o(fo);
            }).catch(() => {
              fo = !!window.navigator.geolocation, o(fo);
            }) : (fo = !!window.navigator.geolocation, o(fo)) : o(fo);
          }(this._setupUI), this._container;
        }
        onRemove() {
          this._geolocationWatchID !== void 0 && (window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), g.remove(this._container), this._map.off("zoom", this._onZoom), this._map = void 0, $l = 0, Eo = !1;
        }
        _isOutOfMapMaxBounds(_) {
          const o = this._map.getMaxBounds(), h = _.coords;
          return o && (h.longitude < o.getWest() || h.longitude > o.getEast() || h.latitude < o.getSouth() || h.latitude > o.getNorth());
        }
        _setErrorState() {
          switch (this._watchState) {
            case "WAITING_ACTIVE":
              this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active-error");
              break;
            case "ACTIVE_LOCK":
              this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting");
              break;
            case "BACKGROUND":
              this._watchState = "BACKGROUND_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting");
              break;
            case "ACTIVE_ERROR":
              break;
            default:
              throw new Error(`Unexpected watchState ${this._watchState}`);
          }
        }
        _onSuccess(_) {
          if (this._map) {
            if (this._isOutOfMapMaxBounds(_)) return this._setErrorState(), this.fire(new a.Event("outofmaxbounds", _)), this._updateMarker(), void this._finish();
            if (this.options.trackUserLocation) switch (this._lastKnownPosition = _, this._watchState) {
              case "WAITING_ACTIVE":
              case "ACTIVE_LOCK":
              case "ACTIVE_ERROR":
                this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                break;
              case "BACKGROUND":
              case "BACKGROUND_ERROR":
                this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background");
                break;
              default:
                throw new Error(`Unexpected watchState ${this._watchState}`);
            }
            this.options.showUserLocation && this._watchState !== "OFF" && this._updateMarker(_), this.options.trackUserLocation && this._watchState !== "ACTIVE_LOCK" || this._updateCamera(_), this.options.showUserLocation && this._dotElement.classList.remove("maplibregl-user-location-dot-stale"), this.fire(new a.Event("geolocate", _)), this._finish();
          }
        }
        _updateCamera(_) {
          const o = new a.LngLat(_.coords.longitude, _.coords.latitude), h = _.coords.accuracy, v = this._map.getBearing(), w = a.extend({ bearing: v }, this.options.fitBoundsOptions), S = Le.fromLngLat(o, h);
          this._map.fitBounds(S, w, { geolocateSource: !0 });
        }
        _updateMarker(_) {
          if (_) {
            const o = new a.LngLat(_.coords.longitude, _.coords.latitude);
            this._accuracyCircleMarker.setLngLat(o).addTo(this._map), this._userLocationDotMarker.setLngLat(o).addTo(this._map), this._accuracy = _.coords.accuracy, this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
          } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
        }
        _updateCircleRadius() {
          const _ = this._map.getBounds(), o = _.getSouthEast(), h = _.getNorthEast(), v = o.distanceTo(h), w = Math.ceil(this._accuracy / (v / this._map._container.clientHeight) * 2);
          this._circleElement.style.width = `${w}px`, this._circleElement.style.height = `${w}px`;
        }
        _onZoom() {
          this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
        }
        _onError(_) {
          if (this._map) {
            if (this.options.trackUserLocation) if (_.code === 1) {
              this._watchState = "OFF", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.disabled = !0;
              const o = this._map._getUIString("GeolocateControl.LocationNotAvailable");
              this._geolocateButton.title = o, this._geolocateButton.setAttribute("aria-label", o), this._geolocationWatchID !== void 0 && this._clearWatch();
            } else {
              if (_.code === 3 && Eo) return;
              this._setErrorState();
            }
            this._watchState !== "OFF" && this.options.showUserLocation && this._dotElement.classList.add("maplibregl-user-location-dot-stale"), this.fire(new a.Event("error", _)), this._finish();
          }
        }
        _finish() {
          this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
        }
        _setupUI(_) {
          if (this._map) {
            if (this._container.addEventListener("contextmenu", (o) => o.preventDefault()), this._geolocateButton = g.create("button", "maplibregl-ctrl-geolocate", this._container), g.create("span", "maplibregl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", "true"), this._geolocateButton.type = "button", _ === !1) {
              a.warnOnce("Geolocation support is not available so the GeolocateControl will be disabled.");
              const o = this._map._getUIString("GeolocateControl.LocationNotAvailable");
              this._geolocateButton.disabled = !0, this._geolocateButton.title = o, this._geolocateButton.setAttribute("aria-label", o);
            } else {
              const o = this._map._getUIString("GeolocateControl.FindMyLocation");
              this._geolocateButton.title = o, this._geolocateButton.setAttribute("aria-label", o);
            }
            this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._dotElement = g.create("div", "maplibregl-user-location-dot"), this._userLocationDotMarker = new vc(this._dotElement), this._circleElement = g.create("div", "maplibregl-user-location-accuracy-circle"), this._accuracyCircleMarker = new vc({ element: this._circleElement, pitchAlignment: "map" }), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onZoom)), this._geolocateButton.addEventListener("click", this.trigger.bind(this)), this._setup = !0, this.options.trackUserLocation && this._map.on("movestart", (o) => {
              o.geolocateSource || this._watchState !== "ACTIVE_LOCK" || o.originalEvent && o.originalEvent.type === "resize" || (this._watchState = "BACKGROUND", this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this.fire(new a.Event("trackuserlocationend")));
            });
          }
        }
        trigger() {
          if (!this._setup) return a.warnOnce("Geolocate control triggered before added to a map"), !1;
          if (this.options.trackUserLocation) {
            switch (this._watchState) {
              case "OFF":
                this._watchState = "WAITING_ACTIVE", this.fire(new a.Event("trackuserlocationstart"));
                break;
              case "WAITING_ACTIVE":
              case "ACTIVE_LOCK":
              case "ACTIVE_ERROR":
              case "BACKGROUND_ERROR":
                $l--, Eo = !1, this._watchState = "OFF", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this.fire(new a.Event("trackuserlocationend"));
                break;
              case "BACKGROUND":
                this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new a.Event("trackuserlocationstart"));
                break;
              default:
                throw new Error(`Unexpected watchState ${this._watchState}`);
            }
            switch (this._watchState) {
              case "WAITING_ACTIVE":
                this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                break;
              case "ACTIVE_LOCK":
                this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                break;
              case "OFF":
                break;
              default:
                throw new Error(`Unexpected watchState ${this._watchState}`);
            }
            if (this._watchState === "OFF" && this._geolocationWatchID !== void 0) this._clearWatch();
            else if (this._geolocationWatchID === void 0) {
              let _;
              this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "true"), $l++, $l > 1 ? (_ = { maximumAge: 6e5, timeout: 0 }, Eo = !0) : (_ = this.options.positionOptions, Eo = !1), this._geolocationWatchID = window.navigator.geolocation.watchPosition(this._onSuccess, this._onError, _);
            }
          } else window.navigator.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = setTimeout(this._finish, 1e4);
          return !0;
        }
        _clearWatch() {
          window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
        }
      }, AttributionControl: Ve, LogoControl: pt, ScaleControl: class {
        constructor(_) {
          this.options = a.extend({}, su, _), a.bindAll(["_onMove", "setUnit"], this);
        }
        getDefaultPosition() {
          return "bottom-left";
        }
        _onMove() {
          ou(this._map, this._container, this.options);
        }
        onAdd(_) {
          return this._map = _, this._container = g.create("div", "maplibregl-ctrl maplibregl-ctrl-scale", _.getContainer()), this._map.on("move", this._onMove), this._onMove(), this._container;
        }
        onRemove() {
          g.remove(this._container), this._map.off("move", this._onMove), this._map = void 0;
        }
        setUnit(_) {
          this.options.unit = _, ou(this._map, this._container, this.options);
        }
      }, FullscreenControl: class extends a.Evented {
        constructor(_ = {}) {
          super(), this._onFullscreenChange = () => {
            (window.document.fullscreenElement || window.document.mozFullScreenElement || window.document.webkitFullscreenElement || window.document.msFullscreenElement) === this._container !== this._fullscreen && this._handleFullscreenChange();
          }, this._onClickFullscreen = () => {
            this._isFullscreen() ? this._exitFullscreen() : this._requestFullscreen();
          }, this._fullscreen = !1, _ && _.container && (_.container instanceof HTMLElement ? this._container = _.container : a.warnOnce("Full screen control 'container' must be a DOM element.")), "onfullscreenchange" in document ? this._fullscreenchange = "fullscreenchange" : "onmozfullscreenchange" in document ? this._fullscreenchange = "mozfullscreenchange" : "onwebkitfullscreenchange" in document ? this._fullscreenchange = "webkitfullscreenchange" : "onmsfullscreenchange" in document && (this._fullscreenchange = "MSFullscreenChange");
        }
        onAdd(_) {
          return this._map = _, this._container || (this._container = this._map.getContainer()), this._controlContainer = g.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._setupUI(), this._controlContainer;
        }
        onRemove() {
          g.remove(this._controlContainer), this._map = null, window.document.removeEventListener(this._fullscreenchange, this._onFullscreenChange);
        }
        _setupUI() {
          const _ = this._fullscreenButton = g.create("button", "maplibregl-ctrl-fullscreen", this._controlContainer);
          g.create("span", "maplibregl-ctrl-icon", _).setAttribute("aria-hidden", "true"), _.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), window.document.addEventListener(this._fullscreenchange, this._onFullscreenChange);
        }
        _updateTitle() {
          const _ = this._getTitle();
          this._fullscreenButton.setAttribute("aria-label", _), this._fullscreenButton.title = _;
        }
        _getTitle() {
          return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
        }
        _isFullscreen() {
          return this._fullscreen;
        }
        _handleFullscreenChange() {
          this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("maplibregl-ctrl-shrink"), this._fullscreenButton.classList.toggle("maplibregl-ctrl-fullscreen"), this._updateTitle(), this._fullscreen ? (this.fire(new a.Event("fullscreenstart")), this._map._cooperativeGestures && (this._prevCooperativeGestures = this._map._cooperativeGestures, this._map.setCooperativeGestures())) : (this.fire(new a.Event("fullscreenend")), this._prevCooperativeGestures && (this._map.setCooperativeGestures(this._prevCooperativeGestures), delete this._prevCooperativeGestures));
        }
        _exitFullscreen() {
          window.document.exitFullscreen ? window.document.exitFullscreen() : window.document.mozCancelFullScreen ? window.document.mozCancelFullScreen() : window.document.msExitFullscreen ? window.document.msExitFullscreen() : window.document.webkitCancelFullScreen ? window.document.webkitCancelFullScreen() : this._togglePseudoFullScreen();
        }
        _requestFullscreen() {
          this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.mozRequestFullScreen ? this._container.mozRequestFullScreen() : this._container.msRequestFullscreen ? this._container.msRequestFullscreen() : this._container.webkitRequestFullscreen ? this._container.webkitRequestFullscreen() : this._togglePseudoFullScreen();
        }
        _togglePseudoFullScreen() {
          this._container.classList.toggle("maplibregl-pseudo-fullscreen"), this._handleFullscreenChange(), this._map.resize();
        }
      }, TerrainControl: class {
        constructor(_) {
          this.options = _, a.bindAll(["_toggleTerrain", "_updateTerrainIcon"], this);
        }
        onAdd(_) {
          return this._map = _, this._container = g.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._terrainButton = g.create("button", "maplibregl-ctrl-terrain", this._container), g.create("span", "maplibregl-ctrl-icon", this._terrainButton).setAttribute("aria-hidden", "true"), this._terrainButton.type = "button", this._terrainButton.addEventListener("click", this._toggleTerrain), this._updateTerrainIcon(), this._map.on("terrain", this._updateTerrainIcon), this._container;
        }
        onRemove() {
          g.remove(this._container), this._map.off("terrain", this._updateTerrainIcon), this._map = void 0;
        }
        _toggleTerrain() {
          this._map.getTerrain() ? this._map.setTerrain(null) : this._map.setTerrain(this.options), this._updateTerrainIcon();
        }
        _updateTerrainIcon() {
          this._terrainButton.classList.remove("maplibregl-ctrl-terrain"), this._terrainButton.classList.remove("maplibregl-ctrl-terrain-enabled"), this._map.terrain ? (this._terrainButton.classList.add("maplibregl-ctrl-terrain-enabled"), this._terrainButton.title = this._map._getUIString("TerrainControl.disableTerrain")) : (this._terrainButton.classList.add("maplibregl-ctrl-terrain"), this._terrainButton.title = this._map._getUIString("TerrainControl.enableTerrain"));
        }
      }, Popup: class extends a.Evented {
        constructor(_) {
          super(), this.options = a.extend(Object.create(op), _), a.bindAll(["_update", "_onClose", "remove", "_onMouseMove", "_onMouseUp", "_onDrag"], this);
        }
        addTo(_) {
          return this._map && this.remove(), this._map = _, this.options.closeOnClick && this._map.on("click", this._onClose), this.options.closeOnMove && this._map.on("move", this._onClose), this._map.on("remove", this.remove), this._update(), this._focusFirstElement(), this._trackPointer ? (this._map.on("mousemove", this._onMouseMove), this._map.on("mouseup", this._onMouseUp), this._container && this._container.classList.add("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.add("maplibregl-track-pointer")) : this._map.on("move", this._update), this.fire(new a.Event("open")), this;
        }
        isOpen() {
          return !!this._map;
        }
        remove() {
          return this._content && g.remove(this._content), this._container && (g.remove(this._container), delete this._container), this._map && (this._map.off("move", this._update), this._map.off("move", this._onClose), this._map.off("click", this._onClose), this._map.off("remove", this.remove), this._map.off("mousemove", this._onMouseMove), this._map.off("mouseup", this._onMouseUp), this._map.off("drag", this._onDrag), delete this._map), this.fire(new a.Event("close")), this;
        }
        getLngLat() {
          return this._lngLat;
        }
        setLngLat(_) {
          return this._lngLat = a.LngLat.convert(_), this._pos = null, this._trackPointer = !1, this._update(), this._map && (this._map.on("move", this._update), this._map.off("mousemove", this._onMouseMove), this._container && this._container.classList.remove("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.remove("maplibregl-track-pointer")), this;
        }
        trackPointer() {
          return this._trackPointer = !0, this._pos = null, this._update(), this._map && (this._map.off("move", this._update), this._map.on("mousemove", this._onMouseMove), this._map.on("drag", this._onDrag), this._container && this._container.classList.add("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.add("maplibregl-track-pointer")), this;
        }
        getElement() {
          return this._container;
        }
        setText(_) {
          return this.setDOMContent(document.createTextNode(_));
        }
        setHTML(_) {
          const o = document.createDocumentFragment(), h = document.createElement("body");
          let v;
          for (h.innerHTML = _; v = h.firstChild, v; ) o.appendChild(v);
          return this.setDOMContent(o);
        }
        getMaxWidth() {
          return this._container && this._container.style.maxWidth;
        }
        setMaxWidth(_) {
          return this.options.maxWidth = _, this._update(), this;
        }
        setDOMContent(_) {
          if (this._content) for (; this._content.hasChildNodes(); ) this._content.firstChild && this._content.removeChild(this._content.firstChild);
          else this._content = g.create("div", "maplibregl-popup-content", this._container);
          return this._content.appendChild(_), this._createCloseButton(), this._update(), this._focusFirstElement(), this;
        }
        addClassName(_) {
          this._container && this._container.classList.add(_);
        }
        removeClassName(_) {
          this._container && this._container.classList.remove(_);
        }
        setOffset(_) {
          return this.options.offset = _, this._update(), this;
        }
        toggleClassName(_) {
          if (this._container) return this._container.classList.toggle(_);
        }
        _createCloseButton() {
          this.options.closeButton && (this._closeButton = g.create("button", "maplibregl-popup-close-button", this._content), this._closeButton.type = "button", this._closeButton.setAttribute("aria-label", "Close popup"), this._closeButton.innerHTML = "&#215;", this._closeButton.addEventListener("click", this._onClose));
        }
        _onMouseUp(_) {
          this._update(_.point);
        }
        _onMouseMove(_) {
          this._update(_.point);
        }
        _onDrag(_) {
          this._update(_.point);
        }
        _update(_) {
          if (!this._map || !this._lngLat && !this._trackPointer || !this._content || (this._container || (this._container = g.create("div", "maplibregl-popup", this._map.getContainer()), this._tip = g.create("div", "maplibregl-popup-tip", this._container), this._container.appendChild(this._content), this.options.className && this.options.className.split(" ").forEach((S) => this._container.classList.add(S)), this._trackPointer && this._container.classList.add("maplibregl-popup-track-pointer")), this.options.maxWidth && this._container.style.maxWidth !== this.options.maxWidth && (this._container.style.maxWidth = this.options.maxWidth), this._map.transform.renderWorldCopies && !this._trackPointer && (this._lngLat = mc(this._lngLat, this._pos, this._map.transform)), this._trackPointer && !_)) return;
          const o = this._pos = this._trackPointer && _ ? _ : this._map.project(this._lngLat);
          let h = this.options.anchor;
          const v = ap(this.options.offset);
          if (!h) {
            const S = this._container.offsetWidth, M = this._container.offsetHeight;
            let z;
            z = o.y + v.bottom.y < M ? ["top"] : o.y > this._map.transform.height - M ? ["bottom"] : [], o.x < S / 2 ? z.push("left") : o.x > this._map.transform.width - S / 2 && z.push("right"), h = z.length === 0 ? "bottom" : z.join("-");
          }
          const w = o.add(v[h]).round();
          g.setTransform(this._container, `${Pi[h]} translate(${w.x}px,${w.y}px)`), Da(this._container, h, "popup");
        }
        _focusFirstElement() {
          if (!this.options.focusAfterOpen || !this._container) return;
          const _ = this._container.querySelector(cf);
          _ && _.focus();
        }
        _onClose() {
          this.remove();
        }
      }, Marker: vc, Style: Ki, LngLat: a.LngLat, LngLatBounds: Le, Point: a.Point, MercatorCoordinate: a.MercatorCoordinate, Evented: a.Evented, AJAXError: a.AJAXError, config: a.config, CanvasSource: Oe, GeoJSONSource: tt, ImageSource: bt, RasterDEMTileSource: Xe, RasterTileSource: ot, VectorTileSource: je, VideoSource: qt, prewarm: function() {
        Hr().acquire(qi);
      }, clearPrewarmedResources: function() {
        const _ = ai;
        _ && (_.isPreloaded() && _.numActive() === 1 ? (_.release(qi), ai = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
      }, get version() {
        return lp;
      }, get workerCount() {
        return kt.workerCount;
      }, set workerCount(_) {
        kt.workerCount = _;
      }, get maxParallelImageRequests() {
        return a.config.MAX_PARALLEL_IMAGE_REQUESTS;
      }, set maxParallelImageRequests(_) {
        a.config.MAX_PARALLEL_IMAGE_REQUESTS = _;
      }, get workerUrl() {
        return a.config.WORKER_URL;
      }, set workerUrl(_) {
        a.config.WORKER_URL = _;
      }, addProtocol(_, o) {
        a.config.REGISTERED_PROTOCOLS[_] = o;
      }, removeProtocol(_) {
        delete a.config.REGISTERED_PROTOCOLS[_];
      } };
      return ge.extend(cp, { isSafari: a.isSafari, getPerformanceMetrics: a.PerformanceUtils.getPerformanceMetrics }), cp;
    });
    var d = r;
    return d;
  });
})(dL);
var Qbe = dL.exports;
const vu = /* @__PURE__ */ Nx(Qbe), e0e = 8, t0e = "Basic preview", n0e = {
  "openmaptiles:version": "3.x"
}, i0e = {
  openmaptiles: {
    type: "vector",
    url: "http://ec2-3-98-104-177.ca-central-1.compute.amazonaws.com:8090/data/v3.json"
  }
}, r0e = "http://ec2-3-98-104-177.ca-central-1.compute.amazonaws.com:8090/fonts/{fontstack}/{range}.pbf", s0e = [
  {
    id: "background",
    paint: {
      "background-color": "hsl(47, 26%, 88%)"
    },
    type: "background"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "Polygon"
      ],
      [
        "in",
        "class",
        "residential",
        "suburb",
        "neighbourhood"
      ]
    ],
    id: "landuse-residential",
    paint: {
      "fill-color": "hsl(47, 13%, 86%)",
      "fill-opacity": 0.7
    },
    source: "openmaptiles",
    "source-layer": "landuse",
    type: "fill"
  },
  {
    filter: [
      "==",
      "class",
      "grass"
    ],
    id: "landcover_grass",
    paint: {
      "fill-color": "hsl(82, 46%, 72%)",
      "fill-opacity": 0.45
    },
    source: "openmaptiles",
    "source-layer": "landcover",
    type: "fill"
  },
  {
    filter: [
      "==",
      "class",
      "wood"
    ],
    id: "landcover_wood",
    paint: {
      "fill-color": "hsl(82, 46%, 72%)",
      "fill-opacity": {
        base: 1,
        stops: [
          [
            8,
            0.6
          ],
          [
            22,
            1
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "landcover",
    type: "fill"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "Polygon"
      ],
      [
        "!=",
        "intermittent",
        1
      ]
    ],
    id: "water",
    paint: {
      "fill-color": "hsl(205, 56%, 73%)"
    },
    source: "openmaptiles",
    "source-layer": "water",
    type: "fill"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "Polygon"
      ],
      [
        "==",
        "intermittent",
        1
      ]
    ],
    id: "water_intermittent",
    paint: {
      "fill-color": "hsl(205, 56%, 73%)",
      "fill-opacity": 0.7
    },
    source: "openmaptiles",
    "source-layer": "water",
    type: "fill"
  },
  {
    filter: [
      "==",
      "subclass",
      "ice_shelf"
    ],
    id: "landcover-ice-shelf",
    paint: {
      "fill-color": "hsl(47, 26%, 88%)",
      "fill-opacity": 0.8
    },
    source: "openmaptiles",
    "source-layer": "landcover",
    type: "fill"
  },
  {
    filter: [
      "==",
      "subclass",
      "glacier"
    ],
    id: "landcover-glacier",
    paint: {
      "fill-color": "hsl(47, 22%, 94%)",
      "fill-opacity": {
        base: 1,
        stops: [
          [
            0,
            1
          ],
          [
            8,
            0.5
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "landcover",
    type: "fill"
  },
  {
    filter: [
      "all",
      [
        "in",
        "class",
        "sand"
      ]
    ],
    id: "landcover_sand",
    metadata: {},
    paint: {
      "fill-antialias": !1,
      "fill-color": "rgba(232, 214, 38, 1)",
      "fill-opacity": 0.3
    },
    source: "openmaptiles",
    "source-layer": "landcover",
    type: "fill"
  },
  {
    filter: [
      "==",
      "class",
      "agriculture"
    ],
    id: "landuse",
    paint: {
      "fill-color": "#eae0d0"
    },
    source: "openmaptiles",
    "source-layer": "landuse",
    type: "fill"
  },
  {
    filter: [
      "==",
      "class",
      "national_park"
    ],
    id: "landuse_overlay_national_park",
    paint: {
      "fill-color": "#E1EBB0",
      "fill-opacity": {
        base: 1,
        stops: [
          [
            5,
            0
          ],
          [
            9,
            0.75
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "landcover",
    type: "fill"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "LineString"
      ],
      [
        "==",
        "brunnel",
        "tunnel"
      ]
    ],
    id: "waterway-tunnel",
    paint: {
      "line-color": "hsl(205, 56%, 73%)",
      "line-dasharray": [
        3,
        3
      ],
      "line-gap-width": {
        stops: [
          [
            12,
            0
          ],
          [
            20,
            6
          ]
        ]
      },
      "line-opacity": 1,
      "line-width": {
        base: 1.4,
        stops: [
          [
            8,
            1
          ],
          [
            20,
            2
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "waterway",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "LineString"
      ],
      [
        "!in",
        "brunnel",
        "tunnel",
        "bridge"
      ],
      [
        "!=",
        "intermittent",
        1
      ]
    ],
    id: "waterway",
    paint: {
      "line-color": "hsl(205, 56%, 73%)",
      "line-opacity": 1,
      "line-width": {
        base: 1.4,
        stops: [
          [
            8,
            1
          ],
          [
            20,
            8
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "waterway",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "LineString"
      ],
      [
        "!in",
        "brunnel",
        "tunnel",
        "bridge"
      ],
      [
        "==",
        "intermittent",
        1
      ]
    ],
    id: "waterway_intermittent",
    paint: {
      "line-color": "hsl(205, 56%, 73%)",
      "line-opacity": 1,
      "line-width": {
        base: 1.4,
        stops: [
          [
            8,
            1
          ],
          [
            20,
            8
          ]
        ]
      },
      "line-dasharray": [
        2,
        1
      ]
    },
    source: "openmaptiles",
    "source-layer": "waterway",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "LineString"
      ],
      [
        "==",
        "brunnel",
        "tunnel"
      ],
      [
        "==",
        "class",
        "transit"
      ]
    ],
    id: "tunnel_railway_transit",
    layout: {
      "line-cap": "butt",
      "line-join": "miter"
    },
    minzoom: 0,
    paint: {
      "line-color": "hsl(34, 12%, 66%)",
      "line-dasharray": [
        3,
        3
      ],
      "line-opacity": {
        base: 1,
        stops: [
          [
            11,
            0
          ],
          [
            16,
            1
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "transportation",
    type: "line"
  },
  {
    id: "building",
    paint: {
      "fill-antialias": !0,
      "fill-color": "rgba(222, 211, 190, 1)",
      "fill-opacity": {
        base: 1,
        stops: [
          [
            13,
            0
          ],
          [
            15,
            1
          ]
        ]
      },
      "fill-outline-color": {
        stops: [
          [
            15,
            "rgba(212, 177, 146, 0)"
          ],
          [
            16,
            "rgba(212, 177, 146, 0.5)"
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "building",
    type: "fill"
  },
  {
    filter: [
      "==",
      "$type",
      "Point"
    ],
    id: "housenumber",
    layout: {
      "text-field": "{housenumber}",
      "text-font": [
        "Noto Sans Regular"
      ],
      "text-size": 10
    },
    minzoom: 17,
    paint: {
      "text-color": "rgba(212, 177, 146, 1)"
    },
    source: "openmaptiles",
    "source-layer": "housenumber",
    type: "symbol"
  },
  {
    id: "road_area_pier",
    type: "fill",
    metadata: {},
    source: "openmaptiles",
    "source-layer": "transportation",
    filter: [
      "all",
      [
        "==",
        "$type",
        "Polygon"
      ],
      [
        "==",
        "class",
        "pier"
      ]
    ],
    paint: {
      "fill-color": "hsl(47, 26%, 88%)",
      "fill-antialias": !0
    }
  },
  {
    id: "road_pier",
    type: "line",
    metadata: {},
    source: "openmaptiles",
    "source-layer": "transportation",
    filter: [
      "all",
      [
        "==",
        "$type",
        "LineString"
      ],
      [
        "in",
        "class",
        "pier"
      ]
    ],
    layout: {
      "line-cap": "round",
      "line-join": "round"
    },
    paint: {
      "line-color": "hsl(47, 26%, 88%)",
      "line-width": {
        base: 1.2,
        stops: [
          [
            15,
            1
          ],
          [
            17,
            4
          ]
        ]
      }
    }
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "Polygon"
      ],
      [
        "in",
        "brunnel",
        "bridge"
      ]
    ],
    id: "road_bridge_area",
    layout: {},
    paint: {
      "fill-color": "hsl(47, 26%, 88%)",
      "fill-opacity": 0.5
    },
    source: "openmaptiles",
    "source-layer": "transportation",
    type: "fill"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "LineString"
      ],
      [
        "in",
        "class",
        "path",
        "track"
      ]
    ],
    id: "road_path",
    layout: {
      "line-cap": "square",
      "line-join": "bevel"
    },
    paint: {
      "line-color": "hsl(0, 0%, 97%)",
      "line-dasharray": [
        1,
        1
      ],
      "line-width": {
        base: 1.55,
        stops: [
          [
            4,
            0.25
          ],
          [
            20,
            10
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "transportation",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "LineString"
      ],
      [
        "in",
        "class",
        "minor",
        "service"
      ]
    ],
    id: "road_minor",
    layout: {
      "line-cap": "round",
      "line-join": "round"
    },
    paint: {
      "line-color": "hsl(0, 0%, 97%)",
      "line-width": {
        base: 1.55,
        stops: [
          [
            4,
            0.25
          ],
          [
            20,
            30
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "transportation",
    type: "line",
    minzoom: 13
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "LineString"
      ],
      [
        "==",
        "brunnel",
        "tunnel"
      ],
      [
        "==",
        "class",
        "minor_road"
      ]
    ],
    id: "tunnel_minor",
    layout: {
      "line-cap": "butt",
      "line-join": "miter"
    },
    paint: {
      "line-color": "#efefef",
      "line-dasharray": [
        0.36,
        0.18
      ],
      "line-width": {
        base: 1.55,
        stops: [
          [
            4,
            0.25
          ],
          [
            20,
            30
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "transportation",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "LineString"
      ],
      [
        "==",
        "brunnel",
        "tunnel"
      ],
      [
        "in",
        "class",
        "primary",
        "secondary",
        "tertiary",
        "trunk"
      ]
    ],
    id: "tunnel_major",
    layout: {
      "line-cap": "butt",
      "line-join": "miter"
    },
    paint: {
      "line-color": "#fff",
      "line-dasharray": [
        0.28,
        0.14
      ],
      "line-width": {
        base: 1.4,
        stops: [
          [
            6,
            0.5
          ],
          [
            20,
            30
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "transportation",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "Polygon"
      ],
      [
        "in",
        "class",
        "runway",
        "taxiway"
      ]
    ],
    id: "aeroway-area",
    metadata: {
      "mapbox:group": "1444849345966.4436"
    },
    minzoom: 4,
    paint: {
      "fill-color": "rgba(255, 255, 255, 1)",
      "fill-opacity": {
        base: 1,
        stops: [
          [
            13,
            0
          ],
          [
            14,
            1
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "aeroway",
    type: "fill"
  },
  {
    filter: [
      "all",
      [
        "in",
        "class",
        "taxiway"
      ],
      [
        "==",
        "$type",
        "LineString"
      ]
    ],
    id: "aeroway-taxiway",
    layout: {
      "line-cap": "round",
      "line-join": "round"
    },
    metadata: {
      "mapbox:group": "1444849345966.4436"
    },
    minzoom: 12,
    paint: {
      "line-color": "rgba(255, 255, 255, 1)",
      "line-opacity": 1,
      "line-width": {
        base: 1.5,
        stops: [
          [
            12,
            1
          ],
          [
            17,
            10
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "aeroway",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "in",
        "class",
        "runway"
      ],
      [
        "==",
        "$type",
        "LineString"
      ]
    ],
    id: "aeroway-runway",
    layout: {
      "line-cap": "round",
      "line-join": "round"
    },
    metadata: {
      "mapbox:group": "1444849345966.4436"
    },
    minzoom: 4,
    paint: {
      "line-color": "rgba(255, 255, 255, 1)",
      "line-opacity": 1,
      "line-width": {
        base: 1.5,
        stops: [
          [
            11,
            4
          ],
          [
            17,
            50
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "aeroway",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "LineString"
      ],
      [
        "in",
        "class",
        "trunk",
        "primary"
      ]
    ],
    id: "road_trunk_primary",
    layout: {
      "line-cap": "round",
      "line-join": "round"
    },
    paint: {
      "line-color": "#fff",
      "line-width": {
        base: 1.4,
        stops: [
          [
            6,
            0.5
          ],
          [
            20,
            30
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "transportation",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "LineString"
      ],
      [
        "in",
        "class",
        "secondary",
        "tertiary"
      ]
    ],
    id: "road_secondary_tertiary",
    layout: {
      "line-cap": "round",
      "line-join": "round"
    },
    paint: {
      "line-color": "#fff",
      "line-width": {
        base: 1.4,
        stops: [
          [
            6,
            0.5
          ],
          [
            20,
            20
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "transportation",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "LineString"
      ],
      [
        "==",
        "class",
        "motorway"
      ]
    ],
    id: "road_major_motorway",
    layout: {
      "line-cap": "round",
      "line-join": "round"
    },
    paint: {
      "line-color": "hsl(0, 0%, 100%)",
      "line-offset": 0,
      "line-width": {
        base: 1.4,
        stops: [
          [
            8,
            1
          ],
          [
            16,
            10
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "transportation",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "==",
        "class",
        "transit"
      ],
      [
        "!=",
        "brunnel",
        "tunnel"
      ]
    ],
    id: "railway-transit",
    paint: {
      "line-color": "hsl(34, 12%, 66%)",
      "line-opacity": {
        base: 1,
        stops: [
          [
            11,
            0
          ],
          [
            16,
            1
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "transportation",
    type: "line"
  },
  {
    filter: [
      "==",
      "class",
      "rail"
    ],
    id: "railway",
    paint: {
      "line-color": "hsl(34, 12%, 66%)",
      "line-opacity": {
        base: 1,
        stops: [
          [
            11,
            0
          ],
          [
            16,
            1
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "transportation",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "LineString"
      ],
      [
        "==",
        "brunnel",
        "bridge"
      ]
    ],
    id: "waterway-bridge-case",
    layout: {
      "line-cap": "butt",
      "line-join": "miter"
    },
    paint: {
      "line-color": "#bbbbbb",
      "line-gap-width": {
        base: 1.55,
        stops: [
          [
            4,
            0.25
          ],
          [
            20,
            30
          ]
        ]
      },
      "line-width": {
        base: 1.6,
        stops: [
          [
            12,
            0.5
          ],
          [
            20,
            10
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "waterway",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "LineString"
      ],
      [
        "==",
        "brunnel",
        "bridge"
      ]
    ],
    id: "waterway-bridge",
    layout: {
      "line-cap": "round",
      "line-join": "round"
    },
    paint: {
      "line-color": "hsl(205, 56%, 73%)",
      "line-width": {
        base: 1.55,
        stops: [
          [
            4,
            0.25
          ],
          [
            20,
            30
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "waterway",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "LineString"
      ],
      [
        "==",
        "brunnel",
        "bridge"
      ],
      [
        "==",
        "class",
        "minor_road"
      ]
    ],
    id: "bridge_minor case",
    layout: {
      "line-cap": "butt",
      "line-join": "miter"
    },
    paint: {
      "line-color": "#dedede",
      "line-gap-width": {
        base: 1.55,
        stops: [
          [
            4,
            0.25
          ],
          [
            20,
            30
          ]
        ]
      },
      "line-width": {
        base: 1.6,
        stops: [
          [
            12,
            0.5
          ],
          [
            20,
            10
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "transportation",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "LineString"
      ],
      [
        "==",
        "brunnel",
        "bridge"
      ],
      [
        "in",
        "class",
        "primary",
        "secondary",
        "tertiary",
        "trunk"
      ]
    ],
    id: "bridge_major case",
    layout: {
      "line-cap": "butt",
      "line-join": "miter"
    },
    paint: {
      "line-color": "#dedede",
      "line-gap-width": {
        base: 1.55,
        stops: [
          [
            4,
            0.25
          ],
          [
            20,
            30
          ]
        ]
      },
      "line-width": {
        base: 1.6,
        stops: [
          [
            12,
            0.5
          ],
          [
            20,
            10
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "transportation",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "LineString"
      ],
      [
        "==",
        "brunnel",
        "bridge"
      ],
      [
        "==",
        "class",
        "minor_road"
      ]
    ],
    id: "bridge_minor",
    layout: {
      "line-cap": "round",
      "line-join": "round"
    },
    paint: {
      "line-color": "#efefef",
      "line-width": {
        base: 1.55,
        stops: [
          [
            4,
            0.25
          ],
          [
            20,
            30
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "transportation",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "LineString"
      ],
      [
        "==",
        "brunnel",
        "bridge"
      ],
      [
        "in",
        "class",
        "primary",
        "secondary",
        "tertiary",
        "trunk"
      ]
    ],
    id: "bridge_major",
    layout: {
      "line-cap": "round",
      "line-join": "round"
    },
    paint: {
      "line-color": "#fff",
      "line-width": {
        base: 1.4,
        stops: [
          [
            6,
            0.5
          ],
          [
            20,
            30
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "transportation",
    type: "line"
  },
  {
    filter: [
      "in",
      "admin_level",
      4,
      6,
      8
    ],
    id: "admin_sub",
    paint: {
      "line-color": "hsla(0, 0%, 60%, 0.5)",
      "line-dasharray": [
        2,
        1
      ]
    },
    source: "openmaptiles",
    "source-layer": "boundary",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "<=",
        "admin_level",
        2
      ],
      [
        "==",
        "$type",
        "LineString"
      ]
    ],
    id: "admin_country",
    layout: {
      "line-cap": "round",
      "line-join": "round"
    },
    paint: {
      "line-color": "hsl(0, 0%, 60%)",
      "line-width": {
        base: 1.3,
        stops: [
          [
            3,
            0.5
          ],
          [
            22,
            15
          ]
        ]
      }
    },
    source: "openmaptiles",
    "source-layer": "boundary",
    type: "line"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "Point"
      ],
      [
        "==",
        "rank",
        1
      ]
    ],
    id: "poi_label",
    layout: {
      "icon-size": 1,
      "text-anchor": "top",
      "text-field": "{name}",
      "text-font": [
        "Noto Sans Regular"
      ],
      "text-max-width": 8,
      "text-offset": [
        0,
        0.5
      ],
      "text-size": 11
    },
    minzoom: 14,
    paint: {
      "text-color": "#666",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(255,255,255,0.75)",
      "text-halo-width": 1
    },
    source: "openmaptiles",
    "source-layer": "poi",
    type: "symbol"
  },
  {
    filter: [
      "all",
      [
        "has",
        "iata"
      ]
    ],
    id: "airport-label",
    layout: {
      "icon-size": 1,
      "text-anchor": "top",
      "text-field": "{name}",
      "text-font": [
        "Noto Sans Regular"
      ],
      "text-max-width": 8,
      "text-offset": [
        0,
        0.5
      ],
      "text-size": 11
    },
    minzoom: 10,
    paint: {
      "text-color": "#666",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(255,255,255,0.75)",
      "text-halo-width": 1
    },
    source: "openmaptiles",
    "source-layer": "aerodrome_label",
    type: "symbol"
  },
  {
    filter: [
      "==",
      "$type",
      "LineString"
    ],
    id: "road_major_label",
    layout: {
      "symbol-placement": "line",
      "text-field": "{name}",
      "text-font": [
        "Noto Sans Regular"
      ],
      "text-letter-spacing": 0.1,
      "text-rotation-alignment": "map",
      "text-size": {
        base: 1.4,
        stops: [
          [
            10,
            8
          ],
          [
            20,
            14
          ]
        ]
      },
      "text-transform": "uppercase"
    },
    paint: {
      "text-color": "#000",
      "text-halo-color": "hsl(0, 0%, 100%)",
      "text-halo-width": 2
    },
    source: "openmaptiles",
    "source-layer": "transportation_name",
    type: "symbol"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "Point"
      ],
      [
        "!in",
        "class",
        "city",
        "state",
        "country",
        "continent"
      ]
    ],
    id: "place_label_other",
    layout: {
      "text-anchor": "center",
      "text-field": "{name}",
      "text-font": [
        "Noto Sans Regular"
      ],
      "text-max-width": 6,
      "text-size": {
        stops: [
          [
            6,
            10
          ],
          [
            12,
            14
          ]
        ]
      }
    },
    minzoom: 8,
    paint: {
      "text-color": "hsl(0, 0%, 25%)",
      "text-halo-blur": 0,
      "text-halo-color": "hsl(0, 0%, 100%)",
      "text-halo-width": 2
    },
    source: "openmaptiles",
    "source-layer": "place",
    type: "symbol"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "Point"
      ],
      [
        "==",
        "class",
        "city"
      ]
    ],
    id: "place_label_city",
    layout: {
      "text-field": "{name}",
      "text-font": [
        "Noto Sans Regular"
      ],
      "text-max-width": 10,
      "text-size": {
        stops: [
          [
            3,
            12
          ],
          [
            8,
            16
          ]
        ]
      }
    },
    maxzoom: 16,
    paint: {
      "text-color": "hsl(0, 0%, 0%)",
      "text-halo-blur": 0,
      "text-halo-color": "hsla(0, 0%, 100%, 0.75)",
      "text-halo-width": 2
    },
    source: "openmaptiles",
    "source-layer": "place",
    type: "symbol"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "Point"
      ],
      [
        "==",
        "class",
        "country"
      ],
      [
        "!has",
        "iso_a2"
      ]
    ],
    id: "country_label-other",
    layout: {
      "text-field": "{name:latin}",
      "text-font": [
        "Noto Sans Regular"
      ],
      "text-max-width": 10,
      "text-size": {
        stops: [
          [
            3,
            12
          ],
          [
            8,
            22
          ]
        ]
      }
    },
    maxzoom: 12,
    paint: {
      "text-color": "hsl(0, 0%, 13%)",
      "text-halo-blur": 0,
      "text-halo-color": "rgba(255,255,255,0.75)",
      "text-halo-width": 2
    },
    source: "openmaptiles",
    "source-layer": "place",
    type: "symbol"
  },
  {
    filter: [
      "all",
      [
        "==",
        "$type",
        "Point"
      ],
      [
        "==",
        "class",
        "country"
      ],
      [
        "has",
        "iso_a2"
      ]
    ],
    id: "country_label",
    layout: {
      "text-field": "{name:latin}",
      "text-font": [
        "Noto Sans Regular"
      ],
      "text-max-width": 10,
      "text-size": {
        stops: [
          [
            3,
            12
          ],
          [
            8,
            22
          ]
        ]
      }
    },
    maxzoom: 12,
    paint: {
      "text-color": "hsl(0, 0%, 13%)",
      "text-halo-blur": 0,
      "text-halo-color": "rgba(255,255,255,0.75)",
      "text-halo-width": 2
    },
    source: "openmaptiles",
    "source-layer": "place",
    type: "symbol"
  },
  {
    id: "restaurant_label",
    filter: [
      "all",
      [
        "==",
        "$type",
        "Point"
      ],
      [
        "==",
        "class",
        "restaurant"
      ]
    ],
    layout: {
      "icon-image": "restaurant-icon",
      "icon-size": 1,
      "text-anchor": "top",
      "text-field": "{name}",
      "text-font": [
        "Noto Sans Regular"
      ],
      "text-max-width": 8,
      "text-offset": [
        0,
        0.5
      ],
      "text-size": 11
    },
    minzoom: 14,
    paint: {
      "text-color": "#666",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(255,255,255,0.75)",
      "text-halo-width": 1
    },
    source: "openmaptiles",
    "source-layer": "poi",
    type: "symbol"
  },
  {
    id: "cafe_label",
    filter: [
      "all",
      [
        "==",
        "$type",
        "Point"
      ],
      [
        "==",
        "class",
        "cafe"
      ]
    ],
    layout: {
      "icon-image": "cafe-icon",
      "icon-size": 1,
      "text-anchor": "top",
      "text-field": "{name}",
      "text-font": [
        "Noto Sans Regular"
      ],
      "text-max-width": 8,
      "text-offset": [
        0,
        0.5
      ],
      "text-size": 11
    },
    minzoom: 14,
    paint: {
      "text-color": "#666",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(255,255,255,0.75)",
      "text-halo-width": 1
    },
    source: "openmaptiles",
    "source-layer": "poi",
    type: "symbol"
  },
  {
    id: "bar_label",
    filter: [
      "all",
      [
        "==",
        "$type",
        "Point"
      ],
      [
        "==",
        "class",
        "bar"
      ]
    ],
    layout: {
      "icon-image": "bar-icon",
      "icon-size": 1,
      "text-anchor": "top",
      "text-field": "{name}",
      "text-font": [
        "Noto Sans Regular"
      ],
      "text-max-width": 8,
      "text-offset": [
        0,
        0.5
      ],
      "text-size": 11
    },
    minzoom: 14,
    paint: {
      "text-color": "red",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(255,255,255,0.75)",
      "text-halo-width": 1
    },
    source: "openmaptiles",
    "source-layer": "poi",
    type: "symbol"
  }
], o0e = "basic-preview", a0e = {
  version: e0e,
  name: t0e,
  metadata: n0e,
  sources: i0e,
  glyphs: r0e,
  layers: s0e,
  id: o0e
}, l0e = {
  key: 0,
  id: "map-wrapper"
}, c0e = { class: "map-heading" }, lT = 14, u0e = /* @__PURE__ */ at({
  __name: "VacationsMap",
  props: {
    cdnBaseUrl: {},
    hotels: {},
    totalHotels: {},
    lang: {}
  },
  setup(e) {
    const t = e, n = $e(), i = $e(), r = $e(!0), c = Array.isArray(t.hotels) ? t.hotels.length : 1, d = t.hotels, a = Array.isArray(d) ? d[0] : d;
    function f(A) {
      var H, N, K, U;
      const I = parseFloat((H = a.location) == null ? void 0 : H.latitude), O = parseFloat((N = a.location) == null ? void 0 : N.longitude), B = new vu.Map({
        container: A,
        // @ts-expect-error: TypeScript struggles with literal types
        style: a0e,
        // this should point to your JSON style file
        zoom: lT,
        center: [O, I]
        // will be overwritten
      });
      if (Array.isArray(d)) {
        const q = new vu.LngLatBounds();
        d.forEach((ee) => {
          var oe, de, me, ve, re;
          const te = parseFloat((oe = ee.location) == null ? void 0 : oe.latitude), ae = parseFloat((de = ee.location) == null ? void 0 : de.longitude);
          q.extend([ae, te]), new vu.Marker({
            element: g(ee.name, ee.starCategory, "$1,234")
          }).setLngLat([ae, te]).setPopup(
            new vu.Popup().setHTML(`
            <div style="font-family: sans-serif; max-width: 200px;">
              <img src="${(re = (ve = (me = ee.media) == null ? void 0 : me.images) == null ? void 0 : ve[0].url) == null ? void 0 : re.replace("{VARIATION}", "square").replace("{SIZE}", "300x")}" alt="${ee.name}"
                style="max-width: 180px; border-radius: 6px; margin-bottom: 8px;" />
              <div style="font-weight: bold; margin-bottom: 4px;"><h3>${ee.name}</h3></div>
              <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 4px;">
                <div style="color: gold; font-size: 14px;">
                  ${"★".repeat(ee.starCategory)}${"☆".repeat(5 - ee.starCategory)}
                </div>
                <div style="color: #2e8b57; font-weight: bold;">
                  $1,234
                </div>
              </div>
            </div>
          `)
          ).addTo(B);
        }), B.fitBounds(q, { padding: 50 });
      } else {
        const q = parseFloat((K = d.location) == null ? void 0 : K.latitude), ee = parseFloat((U = d.location) == null ? void 0 : U.longitude);
        new vu.Marker({
          element: g(
            d.name,
            d.starCategory,
            "$1,234"
          )
        }).setLngLat([ee, q]).setPopup(
          new vu.Popup().setHTML(`<h4>${d.name}</h4>`)
        ).addTo(B), B.setCenter([ee, q]), B.setZoom(lT);
      }
      return B.addControl(new vu.NavigationControl(), "top-left"), B.addControl(
        new vu.FullscreenControl({
          container: A
        }),
        "top-left"
      ), B.on("fullscreenchange", () => {
        t.hotels && !Array.isArray(t.hotels) && RE(t.hotels.name, t.hotels.destination);
      }), B.on("style.load", () => {
        B.loadImage("/icons/bar-24.png", (q, ee) => {
          ee && (B.addImage("bar-icon", ee), B.setLayoutProperty("bar_label", "icon-image", "bar-icon"), B.setLayoutProperty("bar_label", "icon-size", 1));
        }), B.loadImage("/icons/cafe-24.png", (q, ee) => {
          ee && (B.addImage("cafe-icon", ee), B.setLayoutProperty("cafe_label", "icon-image", "cafe-icon"), B.setLayoutProperty("restaurant_label", "icon-size", 1));
        }), B.loadImage("/icons/restaurant-24.png", (q, ee) => {
          ee && (B.addImage("restaurant-icon", ee), B.setLayoutProperty(
            "restaurant_label",
            "icon-image",
            "restaurant-icon"
          ), B.setLayoutProperty("restaurant_label", "icon-size", 1));
        }), B.getStyle().layers.forEach((q) => {
          q.type === "symbol" && q.layout && q.layout["text-field"] && B.setLayoutProperty(q.id, "text-field", [
            "coalesce",
            ["get", `name:${t.lang}`],
            ["get", "name"]
          ]);
        });
      }), B;
    }
    function g(A, I, O) {
      const B = document.createElement("div");
      B.style.display = "flex", B.style.flexDirection = "column", B.style.alignItems = "center";
      const H = document.createElement("img");
      H.src = "/icons/location-48.png", H.style.width = "32px", H.style.height = "32px";
      const N = document.createElement("div");
      N.style.fontSize = "11px", N.style.color = "#fff", N.style.backgroundColor = "rgba(0, 0, 0, 0.6)", N.style.padding = "2px 6px", N.style.borderRadius = "4px", N.style.marginTop = "4px", N.style.textAlign = "center", N.style.whiteSpace = "nowrap", N.style.maxWidth = "120px", N.style.overflow = "hidden", N.style.textOverflow = "ellipsis";
      const K = document.createElement("div");
      K.textContent = A, K.style.fontWeight = "bold", N.appendChild(K);
      const U = document.createElement("div");
      U.textContent = "★".repeat(I) + "☆".repeat(5 - I), U.style.color = "#ffd700", U.style.fontSize = "10px", U.style.marginTop = "2px", N.appendChild(U);
      const q = document.createElement("div");
      return q.textContent = `$${(parseFloat(O.replace("$", "").replace(",", "")) * (1 + (Math.random() * 0.1 - 0.05))).toFixed(0)}`, q.style.color = "#fff", q.style.fontSize = "10px", q.style.fontWeight = "bold", q.style.marginTop = "2px", N.appendChild(q), B.appendChild(H), B.appendChild(N), B;
    }
    function x() {
      n.value && (n.value.remove(), n.value = void 0);
    }
    const $ = new IntersectionObserver(
      (A) => {
        A[0].isIntersecting && i.value ? (x(), n.value = f(i.value)) : x();
      },
      { threshold: [0.9] }
    );
    return Li(() => {
      i.value && $.observe(i.value);
    }), tl(() => {
      $.disconnect(), x();
    }), (A, I) => (V(), Tt($r, { name: "slide" }, {
      default: Qt(() => [
        r.value ? (V(), G("div", l0e, [
          E("h3", c0e, " Showing " + Y(ne(c)) + " of " + Y(t.totalHotels) + " hotel" + Y(ne(c) > 1 ? "s" : "") + " found in " + Y(ne(a).destination), 1),
          E("div", {
            class: "map-height",
            ref_key: "mapElement",
            ref: i
          }, null, 512)
        ])) : _e("", !0)
      ]),
      _: 1
    }));
  }
}), EIe = /* @__PURE__ */ Zn(u0e, [["__scopeId", "data-v-dc493079"]]), Gx = function(e, t) {
  return t ? e.value !== !1 : e.value === !1;
};
Gx.skipEmpty = !1;
Gx.force = !0;
const d0e = (e, t, n) => {
  const i = "-", r = e.value.split(i).reverse().join(""), c = t.split(i).reverse().join(""), d = n.split(i).reverse().join("");
  return r >= c && r <= d;
};
var p0e = /* @__PURE__ */ ((e) => (e.priceasc = "priceasc", e.pricedesc = "pricedesc", e.nameasc = "nameasc", e.namedesc = "namedesc", e.starasc = "starasc", e.stardesc = "stardesc", e.recommended = "recommended", e))(p0e || {});
function h0e(e, t) {
  var n = !1;
  return function(...i) {
    n || (e.call(null, ...i), n = !0, setTimeout(function() {
      n = !1;
    }, t));
  };
}
function hL(e) {
  return e.split(" ").filter((t) => t);
}
var f0e = typeof window < "u";
function va(e, t, n = !1) {
  if (!t)
    return;
  const i = hL(t);
  if (i.length && !i.includes("longTouch"))
    for (const r of e) {
      if (!tv(r) || !Nl.has(r)) {
        r.classList.add(...i);
        continue;
      }
      const c = [], d = Nl.get(r);
      if (d) {
        for (const a of i)
          r.classList.contains(a) ? r.classList.contains(a) && n === !1 && c.push(a) : r.classList.add(a);
        d.privateClasses = c, Nl.set(r, d);
      }
    }
}
function Eh(e, t) {
  if (!t)
    return;
  const n = hL(t);
  if (n.length)
    for (const i of e) {
      if (!tv(i)) {
        i.classList.remove(...n);
        continue;
      }
      const r = Nl.get(i);
      if (r)
        for (const c of n)
          r.privateClasses.includes(c) || i.classList.remove(c);
    }
}
function fL(e) {
  let t = e.parentNode;
  for (; t !== null && t.nodeType === 1 && t instanceof HTMLElement; ) {
    const i = window.getComputedStyle(t).getPropertyValue("overflow");
    if (i === "scroll" || i === "auto")
      return t;
    t = t.parentNode;
  }
  return document.documentElement;
}
function m0e(e) {
  if (!(e.e instanceof TouchEvent))
    return;
  const t = e.e.touches[0].clientX, n = e.e.touches[0].clientY;
  let i = document.elementFromPoint(t, n);
  if (!tv(i))
    return;
  let r, c = !0;
  for (; i && c; ) {
    if (Nl.has(i) || Ro.has(i)) {
      c = !1, r = Ro.has(i);
      break;
    }
    i = i.parentNode;
  }
  if (r) {
    const d = Ro.get(i);
    return d ? {
      parent: {
        el: i,
        data: d
      }
    } : void 0;
  } else {
    const d = Nl.get(i);
    if (!d)
      return;
    const a = Ro.get(i.parentNode);
    return a ? {
      node: {
        el: i,
        data: d
      },
      parent: {
        el: i.parentNode,
        data: a
      }
    } : void 0;
  }
}
function tv(e) {
  return e instanceof HTMLElement && e.parentNode instanceof HTMLElement;
}
function mL(e, t) {
  const n = new AbortController();
  for (const i in t) {
    const r = t[i];
    e.addEventListener(i, r, {
      signal: n.signal,
      passive: !1
    });
  }
  return n;
}
function Yx(e, t, n = !1) {
  const i = window.getComputedStyle(e), r = [
    "position",
    "z-index",
    "top",
    "left",
    "x",
    "pointer-events",
    "y",
    "transform-origin",
    "filter",
    "-webkit-text-fill-color"
  ];
  for (const c of Array.from(i))
    n === !1 && c && r.includes(c) || t.style.setProperty(
      c,
      i.getPropertyValue(c),
      i.getPropertyPriority(c)
    );
  for (const c of Array.from(e.children)) {
    if (!tv(c))
      continue;
    const d = t.children[Array.from(e.children).indexOf(c)];
    Yx(c, d, n);
  }
}
function jd(e) {
  return e instanceof DragEvent ? { x: e.clientX, y: e.clientY } : { x: e.touches[0].clientX, y: e.touches[0].clientY };
}
var Dl = {
  selectedNodes: Array(),
  activeNode: void 0,
  isTouch: !1
};
function cT(e = {}) {
  return (t) => {
    const n = Ro.get(t);
    if (!n)
      return;
    const i = {
      ...n.config,
      multiDragConfig: e
    };
    return {
      setup() {
        var r, c;
        i.handleDragstart = e.multiHandleDragstart || _0e, i.handleTouchstart = e.multiHandleTouchstart || w0e, i.handleEnd = e.multiHandleEnd || g0e, i.reapplyDragClasses = e.multiReapplyDragClasses || v0e, n.config = i, (r = i.multiDragConfig.plugins) == null || r.forEach((d) => {
          var a, f;
          (f = (a = d(t)) == null ? void 0 : a.tearDown) == null || f.call(a);
        }), (c = i.multiDragConfig.plugins) == null || c.forEach((d) => {
          var a, f;
          (f = (a = d(t)) == null ? void 0 : a.setup) == null || f.call(a);
        });
      },
      tearDownNodeRemap(r) {
        var c, d;
        (d = (c = i.multiDragConfig) == null ? void 0 : c.plugins) == null || d.forEach((a) => {
          var f, g;
          (g = (f = a(r.parent)) == null ? void 0 : f.tearDownNodeRemap) == null || g.call(f, r);
        });
      },
      tearDownNode(r) {
        var c, d;
        (d = (c = i.multiDragConfig) == null ? void 0 : c.plugins) == null || d.forEach((a) => {
          var f, g;
          (g = (f = a(r.parent)) == null ? void 0 : f.tearDownNode) == null || g.call(f, r);
        });
      },
      setupNodeRemap(r) {
        var c, d;
        (d = (c = i.multiDragConfig) == null ? void 0 : c.plugins) == null || d.forEach((a) => {
          var f, g;
          (g = (f = a(r.parent)) == null ? void 0 : f.setupNodeRemap) == null || g.call(f, r);
        });
      },
      setupNode(r) {
        var c, d;
        (d = (c = i.multiDragConfig) == null ? void 0 : c.plugins) == null || d.forEach((a) => {
          var f, g;
          (g = (f = a(r.parent)) == null ? void 0 : f.setupNode) == null || g.call(f, r);
        });
      }
    };
  };
}
function v0e(e, t) {
  if (!Yt)
    return;
  const n = "touchedNode" in Yt ? t.config.multiDragConfig.touchDropZoneClass : t.config.multiDragConfig.dropZoneClass;
  Yt.draggedNodes.map((r) => r.el).includes(e) && va([e], n, !0);
}
function g0e(e) {
  !Yt || Yt && "touchedNode" in Yt && "touchMoving" in Yt && !Yt.touchMoving || (TL(e, Yt), y0e(e, Yt), yL());
}
function y0e(e, t) {
  var d;
  const n = e.targetData.parent.data.config.multiDragConfig, i = (d = e.targetData.parent.data.config.selectionsConfig) == null ? void 0 : d.selectedClass, r = t && "touchedNode" in t;
  i && Eh(
    Dl.selectedNodes.map((a) => a.el),
    i
  ), Dl.selectedNodes = [], Dl.activeNode = void 0;
  const c = r ? n.selectionDropZoneClass : n.touchSelectionDraggingClass;
  Eh(
    t.draggedNodes.map((a) => a.el),
    c
  );
}
function _0e(e) {
  e.e instanceof DragEvent && b0e({
    e: e.e,
    targetData: e.targetData
  });
}
function b0e(e) {
  const t = CL(e);
  Dl.isTouch = !1;
  const n = e.targetData.parent.data.config.multiDragConfig, i = e.targetData.parent.data.getValues(
    e.targetData.parent.el
  );
  let r = Dl.selectedNodes.length ? Dl.selectedNodes.map((d) => d.data.value) : n.selections && n.selections(i, e.targetData.parent.el);
  if (r === void 0)
    return;
  if (!r.includes(e.targetData.node.data.value)) {
    r = [e.targetData.node.data.value, ...r];
    const d = e.targetData.parent.data.config.selectionsConfig;
    va([e.targetData.node.el], d == null ? void 0 : d.selectedClass, !0), Dl.selectedNodes.push(e.targetData.node);
  }
  const c = e.targetData.node.el.style.zIndex;
  if (t.originalZIndex = c, e.targetData.node.el.style.zIndex = "9999", Array.isArray(r) && r.length) {
    const d = e.targetData.node.el.getBoundingClientRect(), [a, f] = [
      e.e.clientX - d.left,
      e.e.clientY - d.top
    ];
    gL(vL(e, r, t, a, f));
  } else {
    const d = e.targetData.parent.data.config;
    $L(
      t.draggedNode.el,
      d.draggingClass,
      d.dropZoneClass
    );
  }
}
function w0e(e) {
  e.e instanceof TouchEvent && x0e({
    e: e.e,
    targetData: e.targetData
  });
}
function x0e(e) {
  const t = IL(e);
  Dl.isTouch = !0, Dl.activeNode = e.targetData.node;
  const n = e.targetData.parent.data.config.multiDragConfig, i = e.targetData.parent.data.getValues(
    e.targetData.parent.el
  );
  let r = [];
  e.targetData.parent.data.config.selectionsConfig ? r = Dl.selectedNodes.map((d) => d.data.value) : r = n.selections && n.selections(i, e.targetData.parent.el), r = [e.targetData.node.data.value, ...r];
  const c = e.targetData.parent.data.config.selectionsConfig;
  va([e.targetData.node.el], c == null ? void 0 : c.selectedClass, !0), Array.isArray(r) && r.length ? gL(
    vL(
      e,
      r,
      t,
      t.touchStartLeft,
      t.touchStartTop
    )
  ) : EL(e, t), PL(e, t);
}
function vL(e, t, n, i, r) {
  for (const a of e.targetData.parent.data.enabledNodes)
    a.el !== n.draggedNode.el && t.includes(a.data.value) && n.draggedNodes.push(a);
  const c = e.targetData.parent.data.config.multiDragConfig, d = n.draggedNodes.map((a) => {
    const f = a.el.cloneNode(!0);
    return Yx(a.el, f, !0), e.e instanceof DragEvent && va([f], c.draggingClass), f;
  });
  return setTimeout(() => {
    e.e instanceof DragEvent && va(
      n.draggedNodes.map((a) => a.el),
      c.dropZoneClass
    );
  }), n.clonedDraggedEls = d, { data: e, state: n, x: i, y: r };
}
function gL({
  data: e,
  state: t,
  x: n,
  y: i
}) {
  var d;
  const r = document.createElement("div");
  for (const a of t.clonedDraggedEls)
    a instanceof HTMLElement && (a.style.pointerEvents = "none"), r.append(a);
  const { width: c } = t.draggedNode.el.getBoundingClientRect();
  r.style.cssText = `
        display: flex;
        flex-direction: column;
        width: ${c}px;
        position: fixed;
        pointer-events: none;
        z-index: 9999;
        left: -9999px
      `, document.body.append(r), e.e instanceof DragEvent ? ((d = e.e.dataTransfer) == null || d.setDragImage(r, n, i), setTimeout(() => {
    r.remove();
  })) : "touchedNode" in t && (t.touchedNode = r);
}
var uT = [
  {
    transform: "translateY(100%)"
  },
  {
    transform: "translateY(0)"
  }
], dT = [
  {
    transform: "translateY(-100%)"
  },
  {
    transform: "translateY(0)"
  }
], A0 = [
  {
    transform: "translateX(100%)"
  },
  {
    transform: "translateX(0)"
  }
], E0 = [
  {
    transform: "translateX(-100%)"
  },
  {
    transform: "translateX(0)"
  }
];
function __(e = {}) {
  return (t) => {
    const n = Ro.get(t);
    if (n)
      return {
        setup() {
          n.config.remapFinished = () => {
          }, document.head.querySelector("[data-drag-and-drop]");
        },
        setupNodeRemap(i) {
          if (!Yt)
            return;
          const r = e.duration || 150;
          if (i.nodeData.value === Yt.draggedNode.data.value) {
            switch (Yt.incomingDirection) {
              case "below":
                Il(i.node, uT, r);
                break;
              case "above":
                Il(i.node, dT, r);
                break;
              case "left":
                Il(i.node, E0, r);
                break;
              case "right":
                Il(i.node, A0, r);
                break;
            }
            return;
          }
          if (!Yt.affectedNodes.map((x) => x.data.value).includes(i.nodeData.value))
            return;
          const c = i.node.getBoundingClientRect(), d = Yt.affectedNodes.findIndex(
            (x) => x.data.value === i.nodeData.value
          ), f = Yt.draggedNode.data.index >= Yt.targetIndex;
          let g;
          if (f ? g = Yt.affectedNodes[d + 1] ? Yt.affectedNodes[d + 1] : Yt.affectedNodes[d - 1] : g = Yt.affectedNodes[d - 1] ? Yt.affectedNodes[d - 1] : Yt.affectedNodes[d + 1], g) {
            const x = Math.abs(
              c.x - g.el.getBoundingClientRect().x
            ), $ = Math.abs(
              c.y - g.el.getBoundingClientRect().y
            );
            x > $ && f ? Il(i.node, E0, r) : x > $ && !f && Il(i.node, A0, r);
          } else
            switch (Yt.incomingDirection) {
              case "below":
                Il(i.node, dT, r);
                break;
              case "above":
                Il(i.node, uT, r);
                break;
              case "left":
                Il(i.node, A0, r);
                break;
              case "right":
                Il(i.node, E0, r);
                break;
            }
        }
      };
  };
}
function Il(e, t, n) {
  Yt && (Yt.preventEnter = !0, e.animate(t, {
    duration: n
  }), setTimeout(() => {
    Yt && (Yt.swappedNodeValue = void 0, Yt.remapJustFinished = !0, Yt.lastTargetValue = void 0, Yt.preventEnter = !1);
  }, n));
}
var pT = {
  up: [0, -1],
  down: [0, 1],
  left: [-1, 0],
  right: [1, 0]
}, Nl = /* @__PURE__ */ new WeakMap(), Ro = /* @__PURE__ */ new WeakMap(), Yt = void 0;
function yL() {
  Yt = void 0;
}
function _L(e) {
  return Yt = {
    ascendingDirection: !1,
    incomingDirection: void 0,
    enterCount: 0,
    targetIndex: 0,
    affectedNodes: [],
    lastValue: void 0,
    activeNode: void 0,
    lastTargetValue: void 0,
    remapJustFinished: !1,
    preventEnter: !1,
    clonedDraggedEls: [],
    swappedNodeValue: !1,
    originalZIndex: void 0,
    ...e
  }, Yt;
}
function $0e(e, t) {
  return Yt = {
    ...e,
    ...t
  }, Yt;
}
function bL(e) {
  const { x: t, y: n } = jd(e.e);
  return {
    coordinates: {
      x: t,
      y: n
    },
    draggedNode: {
      el: e.targetData.node.el,
      data: e.targetData.node.data
    },
    draggedNodes: [
      {
        el: e.targetData.node.el,
        data: e.targetData.node.data
      }
    ],
    initialIndex: e.targetData.node.data.index,
    initialParent: {
      el: e.targetData.parent.el,
      data: e.targetData.parent.data
    },
    lastParent: {
      el: e.targetData.parent.el,
      data: e.targetData.parent.data
    },
    scrollParent: fL(e.targetData.node.el)
  };
}
function C0e(e, t) {
  const n = wL(e), r = [
    ...Gw(
      t.targetData.parent.el,
      t.targetData.parent.data
    ).filter((c) => !n.includes(c))
  ];
  r.splice(t.targetData.node.data.index, 0, ...n), e.lastTargetValue = t.targetData.node.data.value, Yw(t.targetData.parent.el, t.targetData.parent.data, [
    ...r
  ]);
}
function Gw(e, t) {
  return [...t.getValues(e)];
}
function Yw(e, t, n) {
  t.setValues(n, e);
}
function wL(e) {
  return [...e.draggedNodes.map((t) => t.data.value)];
}
function es({
  parent: e,
  getValues: t,
  setValues: n,
  config: i = {}
}) {
  var c, d;
  if (!f0e)
    return;
  document.addEventListener("dragover", (a) => {
    if (a.preventDefault(), Yt) {
      Yt.remapJustFinished = !1, Yt.lastTargetValue = void 0;
      const { x: f, y: g } = jd(a);
      Yt.coordinates.y = g, Yt.coordinates.x = f, b_();
    }
  }), k0e(e);
  const r = {
    getValues: t,
    setValues: n,
    config: {
      handleDragstart: My,
      handleDragoverNode: Z0e,
      handleDragoverParent: q0e,
      handleEnd: Dy,
      handleTouchstart: Ly,
      handleTouchmove: ML,
      handleTouchOverNode: P0e,
      handleTouchOverParent: j0e,
      performSort: C0e,
      performTransfer: X0e,
      root: document,
      setupNode: M0e,
      setupNodeRemap: SL,
      reapplyDragClasses: D0e,
      tearDownNode: O0e,
      tearDownNodeRemap: L0e,
      remapFinished: I0e,
      scrollBehavior: {
        x: 0.8,
        y: 0.8
      },
      threshold: {
        horizontal: 0,
        vertical: 0
      },
      ...i
    },
    enabledNodes: [],
    abortControllers: {}
  };
  S0e(e, r), (c = i.plugins) == null || c.forEach((a) => {
    var f, g;
    (g = (f = a(e)) == null ? void 0 : f.tearDown) == null || g.call(f);
  }), (d = i.plugins) == null || d.forEach((a) => {
    var f, g;
    (g = (f = a(e)) == null ? void 0 : f.setup) == null || g.call(f);
  }), xL(e, !0);
}
function k0e(e) {
  const t = Ro.get(e);
  t && t.abortControllers.mainParent && t.abortControllers.mainParent.abort();
}
function S0e(e, t) {
  new MutationObserver(T0e).observe(e, { childList: !0 }), Ro.set(e, t), t.abortControllers.mainParent = mL(e, {
    dragover: J0e(
      h0e(t.config.handleDragoverParent, 10)
    ),
    touchOverParent: t.config.handleTouchOverParent
  });
}
function T0e(e) {
  const t = e[0].target;
  t instanceof HTMLElement && xL(t);
}
function xL(e, t) {
  const n = Ro.get(e);
  if (!n)
    return;
  const i = [], r = n.config;
  for (let a = 0; a < e.children.length; a++) {
    const f = e.children[a];
    if (!tv(f))
      continue;
    const g = Nl.get(f);
    (t || !g) && r.tearDownNode({ node: f, parent: e, nodeData: g, parentData: n }), !r.disabled && (!r.draggable || r.draggable && r.draggable(f)) && i.push(f);
  }
  if (i.length !== n.getValues(e).length && !r.disabled) {
    console.warn(
      "The number of enabled nodes does not match the number of values."
    );
    return;
  }
  const c = n.getValues(e), d = [];
  for (let a = 0; a < i.length; a++) {
    const f = i[a], g = Nl.get(f), x = Object.assign(
      g ?? {
        privateClasses: [],
        abortControllers: {}
      },
      {
        value: c[a],
        index: a
      }
    );
    if (Yt && x.value === Yt.draggedNode.data.value && (Yt.draggedNode.data = x, Yt.draggedNode.el = f), Yt && Yt.draggedNodes.map((A) => A.data.value).includes(x.value)) {
      const A = Yt.draggedNodes.find(
        (I) => I.data.value === x.value
      );
      A && (A.el = f);
    }
    d.push({
      el: f,
      data: x
    });
    const $ = {
      node: f,
      parent: e,
      parentData: n,
      nodeData: x
    };
    (t || !g) && r.setupNode($), SL($);
  }
  Ro.set(e, { ...n, enabledNodes: d }), r.remapFinished(n);
}
function I0e() {
  Yt && (Yt.preventEnter = !1, Yt.swappedNodeValue = void 0, Yt.remapJustFinished = !0);
}
function My(e) {
  e.e instanceof DragEvent && E0e({
    e: e.e,
    targetData: e.targetData
  });
}
function $L(e, t, n) {
  va([e], t), setTimeout(() => {
    Eh([e], t), va([e], n);
  });
}
function CL(e) {
  const t = _L(bL(e));
  return e.e.stopPropagation(), e.e.dataTransfer && (e.e.dataTransfer.dropEffect = "move", e.e.dataTransfer.effectAllowed = "move", e.e.dataTransfer.setDragImage(
    e.targetData.node.el,
    e.e.offsetX,
    e.e.offsetY
  )), t;
}
function kL(e) {
  if (!(e.e instanceof DragEvent) && !(e.e instanceof TouchEvent))
    return !1;
  const t = e.targetData.parent.data.config;
  if (!t.dragHandle)
    return !0;
  const n = e.targetData.node.el.querySelectorAll(
    t.dragHandle
  );
  if (!n)
    return !1;
  const i = jd(e.e), r = t.root.elementFromPoint(
    i.x,
    i.y
  );
  if (!r)
    return !1;
  for (const c of Array.from(n))
    if (r === c || c.contains(r))
      return !0;
  return !1;
}
function A0e(e) {
  if (!kL(e))
    return;
  const t = IL(e);
  EL(e, t), PL(e, t);
}
function E0e(e) {
  if (!kL(e)) {
    e.e.preventDefault();
    return;
  }
  const t = e.targetData.parent.data.config, n = CL(e), i = e.targetData.node.el.style.zIndex;
  n.originalZIndex = i, e.targetData.node.el.style.zIndex = "9999", $L(
    n.draggedNode.el,
    t.draggingClass,
    t.dropZoneClass
  );
}
function P0e(e) {
  Yt && (e.detail.targetData.parent.el === Yt.lastParent.el ? LL(e.detail, Yt) : w_(e.detail, Yt));
}
function M0e(e) {
  var n;
  const t = e.parentData.config;
  e.node.draggable = !0, e.nodeData.abortControllers.mainNode = mL(e.node, {
    dragstart: Lp(t.handleDragstart),
    dragover: Lp(t.handleDragoverNode),
    dragend: Lp(t.handleEnd),
    touchstart: Lp(t.handleTouchstart),
    touchmove: Lp(t.handleTouchmove),
    touchend: Lp(t.handleEnd),
    touchOverNode: t.handleTouchOverNode
  }), t.reapplyDragClasses(e.node, e.parentData), (n = e.parentData.config.plugins) == null || n.forEach((i) => {
    var r, c;
    (c = (r = i(e.parent)) == null ? void 0 : r.setupNode) == null || c.call(r, e);
  });
}
function SL(e) {
  var t;
  Nl.set(e.node, e.nodeData), (t = e.parentData.config.plugins) == null || t.forEach((n) => {
    var i, r;
    (r = (i = n(e.parent)) == null ? void 0 : i.setupNodeRemap) == null || r.call(i, e);
  });
}
function D0e(e, t) {
  if (!Yt)
    return;
  const n = "touchedNode" in Yt ? t.config.touchDropZoneClass : t.config.dropZoneClass;
  Yt.draggedNode.el === e && va([e], n, !0);
}
function L0e(e) {
  var t;
  (t = e.parentData.config.plugins) == null || t.forEach((n) => {
    var i, r;
    (r = (i = n(e.parent)) == null ? void 0 : i.tearDownNodeRemap) == null || r.call(i, e);
  });
}
function O0e(e) {
  var t, n, i, r, c;
  (t = e.parentData.config.plugins) == null || t.forEach((d) => {
    var a, f;
    (f = (a = d(e.parent)) == null ? void 0 : a.tearDownNode) == null || f.call(a, e);
  }), e.node.draggable = !1, (i = (n = e.nodeData) == null ? void 0 : n.abortControllers) != null && i.mainNode && ((c = (r = e.nodeData) == null ? void 0 : r.abortControllers) == null || c.mainNode.abort());
}
function Dy(e) {
  Yt && (TL(e, Yt), yL());
}
function TL(e, t) {
  var c, d, a, f;
  document.removeEventListener("contextmenu", AL), "longTouchTimeout" in t && t.longTouchTimeout && clearTimeout(t.longTouchTimeout);
  const n = (c = Ro.get(t.initialParent.el)) == null ? void 0 : c.config, r = "touchedNode" in t ? n == null ? void 0 : n.touchDropZoneClass : n == null ? void 0 : n.dropZoneClass;
  t.originalZIndex !== void 0 && (t.draggedNode.el.style.zIndex = t.originalZIndex), va(
    t.draggedNodes.map((g) => g.el),
    r,
    !0
  ), Eh(
    t.draggedNodes.map((g) => g.el),
    r
  ), n != null && n.longTouchClass && Eh(
    t.draggedNodes.map((g) => g.el),
    (a = (d = t.initialParent.data) == null ? void 0 : d.config) == null ? void 0 : a.longTouchClass
  ), "touchedNode" in t && ((f = t.touchedNode) == null || f.remove());
}
function Ly(e) {
  e.e instanceof TouchEvent && A0e({
    e: e.e,
    targetData: e.targetData
  });
}
function IL(e) {
  e.e.stopPropagation();
  const t = e.targetData.node.el.cloneNode(!0), n = e.targetData.node.el.getBoundingClientRect();
  return $0e(_L(bL(e)), {
    coordinates: {
      x: e.e.touches[0].clientX,
      y: e.e.touches[0].clientY
    },
    scrollParent: fL(e.targetData.node.el),
    touchStartLeft: e.e.touches[0].clientX - n.left,
    touchStartTop: e.e.touches[0].clientY - n.top,
    touchedNode: t,
    touchMoving: !1
  });
}
function AL(e) {
  e.preventDefault();
}
function EL(e, t) {
  t.touchedNodeDisplay = t.touchedNode.style.display;
  const n = e.targetData.node.el.getBoundingClientRect();
  t.touchedNode.style.cssText = `
            width: ${n.width}px;
            position: fixed;
            pointer-events: none;
            top: -9999px;
            z-index: 999999;
            display: none;
          `, document.body.append(t.touchedNode), Yx(e.targetData.node.el, t.touchedNode), t.touchedNode.style.display = "none", document.addEventListener("contextmenu", AL);
}
function PL(e, t) {
  const n = e.targetData.parent.data.config;
  n.longTouch && (t.longTouchTimeout = setTimeout(() => {
    t && (t.longTouch = !0, n.longTouchClass && e.e.cancelable && va(
      t.draggedNodes.map((i) => i.el),
      n.longTouchClass
    ), e.e.preventDefault());
  }, n.longTouchTimeout || 200));
}
function ML(e) {
  !Yt || !("touchedNode" in Yt) || W0e(e, Yt);
}
function N0e(e, t) {
  t.longTouchClass && Eh(
    e.draggedNodes.map((n) => n.el),
    t == null ? void 0 : t.longTouchClass
  ), t.touchDraggingClass && va([e.touchedNode], t.touchDraggingClass), t.touchDropZoneClass && va(
    e.draggedNodes.map((n) => n.el),
    t.touchDropZoneClass
  );
}
function F0e(e) {
  if (!e || !e.scrollParent)
    return;
  const { x: t, y: n, width: i, height: r } = e.scrollParent.getBoundingClientRect(), {
    x: c,
    y: d,
    scrollOutside: a
  } = e.lastParent.data.config.scrollBehavior;
  return {
    state: e,
    xThresh: c,
    yThresh: d,
    scrollOutside: a,
    scrollParent: e.scrollParent,
    x: t,
    y: n,
    width: i,
    height: r
  };
}
function R0e(e) {
  const t = F0e(Yt);
  if (t)
    switch (e) {
      case "down":
        return U0e(t.state, t);
      case "up":
        return V0e(t.state, t);
      case "right":
        return z0e(t.state, t);
      case "left":
        return B0e(t.state, t);
    }
}
function z0e(e, t) {
  const n = t.scrollParent.clientWidth + t.x - e.coordinates.x;
  if (!(!t.scrollOutside && n < 0) && n < (1 - t.xThresh) * t.scrollParent.clientWidth && !(t.scrollParent.scrollLeft + t.scrollParent.clientWidth >= t.scrollParent.scrollWidth))
    return e;
}
function B0e(e, t) {
  const n = t.scrollParent.clientWidth + t.x - e.coordinates.x;
  if (!(!t.scrollOutside && n > t.scrollParent.clientWidth) && n > t.xThresh * t.scrollParent.clientWidth && t.scrollParent.scrollLeft !== 0)
    return e;
}
function V0e(e, t) {
  const n = t.scrollParent.clientHeight + t.y - e.coordinates.y;
  if (!(!t.scrollOutside && n > t.scrollParent.clientHeight) && n > t.yThresh * t.scrollParent.clientHeight && t.scrollParent.scrollTop !== 0)
    return e;
}
function U0e(e, t) {
  const n = t.scrollParent.clientHeight + t.y - e.coordinates.y;
  if (!(!t.scrollOutside && n < 0) && n < (1 - t.yThresh) * t.scrollParent.clientHeight && !(t.scrollParent.scrollTop + t.scrollParent.clientHeight >= t.scrollParent.scrollHeight))
    return e;
}
function H0e(e, t) {
  t.touchMoving = !0, t.touchedNode.style.display = t.touchedNodeDisplay || "";
  const { x: n, y: i } = jd(e.e);
  t.coordinates.y = i, t.coordinates.x = n;
  const r = t.touchStartLeft ?? 0, c = t.touchStartTop ?? 0;
  t.touchedNode.style.left = `${n - r}px`, t.touchedNode.style.top = `${i - c}px`, N0e(t, e.targetData.parent.data.config);
}
function W0e(e, t) {
  if (e.targetData.parent.data.config.longTouch && !t.longTouch) {
    clearTimeout(t.longTouchTimeout);
    return;
  }
  e.e.cancelable && e.e.preventDefault(), H0e(e, t), b_();
  const i = m0e(e);
  if (!i)
    return;
  const r = {
    e: e.e,
    targetData: i
  };
  "node" in i ? i.node.el.dispatchEvent(
    new CustomEvent("touchOverNode", {
      detail: r
    })
  ) : i.parent.el.dispatchEvent(
    new CustomEvent("touchOverParent", {
      detail: r
    })
  );
}
function b_() {
  for (const e of Object.keys(pT)) {
    const [t, n] = pT[e];
    DL(e, t, n);
  }
}
function DL(e, t, n) {
  const i = R0e(e);
  i && (i.scrollParent.scrollBy(t, n), setTimeout(
    () => {
      DL(e, t, n);
    },
    "touchedNode" in i ? 10 : 100
  ));
}
function Z0e(e) {
  if (!Yt)
    return;
  const { x: t, y: n } = jd(e.e);
  Yt.coordinates.y = n, Yt.coordinates.x = t, b_(), Y0e(e, Yt);
}
function q0e(e) {
  if (!Yt)
    return;
  const { x: t, y: n } = jd(e.e);
  Yt.coordinates.y = n, Yt.coordinates.x = t, b_(), w_(e, Yt);
}
function j0e(e) {
  Yt && w_(e.detail, Yt);
}
function G0e(e, t) {
  if (e.targetData.parent.el === t.lastParent.el)
    return !1;
  const n = e.targetData.parent.data.config;
  if (n.dropZone === !1)
    return !1;
  const i = t.initialParent.data.config;
  return n.accepts ? n.accepts(
    e.targetData.parent,
    t.initialParent,
    t.lastParent,
    t
  ) : !(!n.group || n.group !== i.group);
}
function Y0e(e, t) {
  var n;
  e.e.preventDefault(), e.e.stopPropagation(), e.targetData.parent.el === ((n = t.lastParent) == null ? void 0 : n.el) ? LL(e, t) : w_(e, t);
}
function K0e(e, t, n, i) {
  var $;
  if (t.remapJustFinished)
    return t.remapJustFinished = !1, t.lastTargetValue = e.targetData.node.data.value, !1;
  if (t.lastTargetValue === e.targetData.node.data.value || t.draggedNodes.map((A) => A.el).includes(e.targetData.node.el) || t.preventEnter || t.swappedNodeValue === e.targetData.node.data.value || e.targetData.parent.el !== (($ = t.lastParent) == null ? void 0 : $.el) || e.targetData.parent.data.config.sortable === !1)
    return !1;
  const r = e.targetData.node.el.getBoundingClientRect(), c = t.draggedNode.el.getBoundingClientRect(), d = r.y - c.y, a = r.x - c.x;
  let f;
  const g = t.draggedNode.data.index > e.targetData.node.data.index ? [e.targetData.node.data.index, t.draggedNode.data.index] : [t.draggedNode.data.index, e.targetData.node.data.index];
  t.targetIndex = e.targetData.node.data.index, t.affectedNodes = e.targetData.parent.data.enabledNodes.filter(
    (A) => g[0] <= A.data.index && A.data.index <= g[1] && A.el !== t.draggedNode.el
  ), Math.abs(d) > Math.abs(a) ? f = d > 0 ? "above" : "below" : f = a > 0 ? "left" : "right";
  const x = t.lastParent.data.config.threshold;
  switch (f) {
    case "left":
      if (n > r.x + r.width * x.horizontal)
        return t.incomingDirection = "left", !0;
      break;
    case "right":
      if (n < r.x + r.width * (1 - x.horizontal))
        return t.incomingDirection = "right", !0;
      break;
    case "above":
      if (i > r.y + r.height * x.vertical)
        return t.incomingDirection = "above", !0;
      break;
    case "below":
      if (i < r.y + r.height * (1 - x.vertical))
        return t.incomingDirection = "below", !0;
      break;
  }
  return !1;
}
function LL(e, t) {
  const { x: n, y: i } = jd(e.e);
  K0e(e, t, n, i) && (t.swappedNodeValue = e.targetData.node.data.value, t.preventEnter = !0, e.targetData.parent.data.config.performSort(t, e));
}
function Lp(e) {
  function t(n) {
    var d;
    const i = Nl.get(n), r = n.parentNode || ((d = Yt == null ? void 0 : Yt.lastParent) == null ? void 0 : d.el);
    if (!i)
      return;
    const c = Ro.get(r);
    if (c)
      return {
        node: {
          el: n,
          data: i
        },
        parent: {
          el: r,
          data: c
        }
      };
  }
  return (n) => {
    const i = t(n.currentTarget);
    if (i)
      return e({
        e: n,
        targetData: i
      });
  };
}
function X0e(e, t) {
  const n = wL(e), i = Gw(
    e.lastParent.el,
    e.lastParent.data
  ).filter((a) => !n.includes(a)), r = Gw(
    t.targetData.parent.el,
    t.targetData.parent.data
  ), c = e.initialParent.el === t.targetData.parent.el && t.targetData.parent.data.config.sortable === !1;
  let d;
  "node" in t.targetData ? (c ? d = e.initialIndex : t.targetData.parent.data.config.sortable === !1 ? d = t.targetData.parent.data.enabledNodes.length : d = t.targetData.node.data.index, r.splice(d, 0, ...n)) : (d = c ? e.initialIndex : t.targetData.parent.data.enabledNodes.length, r.splice(d, 0, ...n)), Yw(e.lastParent.el, e.lastParent.data, i), Yw(
    t.targetData.parent.el,
    t.targetData.parent.data,
    r
  );
}
function w_(e, t) {
  G0e(e, t) && (e.targetData.parent.data.config.performTransfer(t, e), t.lastParent = e.targetData.parent);
}
function J0e(e) {
  function t(n) {
    const i = Ro.get(n);
    if (i)
      return {
        parent: {
          el: n,
          data: i
        }
      };
  }
  return (n) => {
    const i = t(n.currentTarget);
    if (i)
      return e({
        e: n,
        targetData: i
      });
  };
}
var OL = /^([0-9]{4})-([0-1][0-9])(?:-([0-3][0-9]))?(?:[T ]?([0-2][0-9])(?::([0-5][0-9]))?(?::([0-5][0-9]))?)?(?:\.[0-9]+)?(Z|(?:\+|\-)[0-9]{2}:?[0-9]{2})?$/;
function Q0e(e) {
  const t = e.match(OL);
  if (t) {
    const n = Number(t[2]);
    if (n < 1 || n > 12)
      return !1;
    if (typeof t[3] !== void 0) {
      const i = Number(t[3]);
      if (i < 1 || i > 31)
        return !1;
    }
    if (typeof t[4] !== void 0) {
      const i = Number(t[4]);
      if (i < 0 || i > 23)
        return !1;
    }
    return !0;
  }
  return !1;
}
function ewe(e) {
  const t = e.match(OL);
  return t && typeof t[4] > "u" ? e += "T00:00:00" : e;
}
function Ji(e) {
  if (e || (e = /* @__PURE__ */ new Date()), e instanceof Date) {
    const t = new Date(e);
    return t.setMilliseconds(0), t;
  }
  if (e = e.trim(), Q0e(e))
    return new Date(ewe(e));
  throw new Error(`Non ISO 8601 compliant date (${e}).`);
}
function hh(e, t = 1) {
  const n = Ji(e);
  return n.setDate(n.getDate() + t), n;
}
function Oy(e) {
  const t = Ji(e);
  return t.setDate(1), t.setMonth(t.getMonth() + 1), t.setDate(0), t;
}
function nv(e) {
  return Oy(e).getDate();
}
function bu(e, t = 1, n = !1) {
  const i = Ji(e), r = i.getDate();
  if (n || i.setDate(1), i.setMonth(i.getMonth() + t), !n) {
    const c = nv(i);
    i.setDate(c < r ? c : r);
  }
  return i;
}
function Zp(e, t = 1, n = !1) {
  const i = Ji(e), r = i.getDate();
  if (n || i.setDate(1), i.setFullYear(i.getFullYear() + t), !n) {
    const c = nv(i);
    i.setDate(c < r ? c : r);
  }
  return i;
}
var Kx = "1999-03-04T02:05:01.000Z", P0 = /* @__PURE__ */ new Map(), Xx = [
  ["YYYY", { year: "numeric" }],
  ["YY", { year: "2-digit" }],
  ["MMMM", { month: "long" }],
  ["MMM", { month: "short" }],
  ["MM", { month: "2-digit" }],
  ["M", { month: "numeric" }],
  ["DD", { day: "2-digit" }],
  ["D", { day: "numeric" }],
  ["dddd", { weekday: "long" }],
  ["ddd", { weekday: "short" }],
  ["d", { weekday: "narrow" }],
  ["mm", { minute: "2-digit" }],
  ["m", { minute: "numeric" }],
  ["ss", { second: "2-digit" }],
  ["s", { second: "numeric" }],
  ["ZZ", { timeZoneName: "long" }],
  ["Z", { timeZoneName: "short" }]
], Jx = [
  ["HH", { hour: "2-digit" }],
  ["H", { hour: "numeric" }]
], Qx = [
  ["hh", { hour: "2-digit" }],
  ["h", { hour: "numeric" }],
  ["a", { dayPeriod: "narrow" }],
  ["A", { dayPeriod: "narrow" }]
], Ny = {
  DD: 2,
  HH: 2,
  MM: 2,
  YY: 2,
  YYYY: 4,
  hh: 2,
  mm: 2,
  ss: 2
};
function NL(e) {
  if (/^[+-]\d{2}:\d{2}/.test(e))
    return 6;
  if (/^[+-]\d{4}/.test(e))
    return 5;
  throw new Error("Invalid offset format");
}
var twe = ["MMMM", "MMM", "dddd", "ddd"], pr = /* @__PURE__ */ new Map(
  /* @__PURE__ */ [...Xx, ...Jx, ...Qx].map((e) => [e[0], e])
), hT = /* @__PURE__ */ new Map(), FL = [
  "full",
  "long",
  "medium",
  "short"
], gu = (e) => String(e).padStart(2, "0"), M0 = (e) => String(e).padStart(2, "0");
function Ac(e) {
  return e.type === "literal" && (e.value = e.value.normalize("NFKC")), e;
}
function nwe(e, t, n, i = !1, r = null) {
  const c = iwe(e, t, n, i), d = Ji(e);
  function a({ partName: f, partValue: g, token: x }) {
    if (f === "literal")
      return g;
    const $ = c[f];
    if (f === "hour" && x === "H")
      return $.replace(/^0/, "") || "0";
    if (["mm", "ss", "MM"].includes(x) && $.length === 1)
      return `0${$}`;
    if (f === "dayPeriod") {
      const A = Qp(d.getUTCHours() < 12 ? "am" : "pm", n);
      return x === "A" ? A.toUpperCase() : A.toLowerCase();
    }
    return f === "timeZoneName" ? r ?? RL(-1 * d.getTimezoneOffset(), x) : $;
  }
  return t.map((f) => ({
    ...f,
    value: a(f)
  }));
}
function iwe(e, t, n, i = !1) {
  const r = Ji(e), c = t.filter((x) => x.hour12), d = t.filter((x) => !x.hour12), a = [], f = [];
  function g(x, $ = !1) {
    const A = `${n}-u-hc-${$ ? "h12" : "h23"}`;
    if (a.push(
      ...new Intl.DateTimeFormat(
        A,
        x.reduce(
          (I, O) => O.partName === "literal" ? I : (i && twe.includes(O.token) && f.push(O), Object.assign(I, O.option)),
          { timeZone: "UTC" }
        )
      ).formatToParts(r).map(Ac)
    ), i && f.length)
      for (const I of f) {
        let O = [];
        switch (I.token) {
          case "MMMM":
            O = new Intl.DateTimeFormat(A, {
              dateStyle: "long",
              timeZone: "UTC"
            }).formatToParts(r).map(Ac);
            break;
          case "MMM":
            O = new Intl.DateTimeFormat(A, {
              dateStyle: "medium",
              timeZone: "UTC"
            }).formatToParts(r).map(Ac);
            break;
        }
        const B = O.find(
          (N) => N.type === I.partName
        ), H = a.findIndex((N) => N.type === I.partName);
        B && H > -1 && (a[H] = B);
      }
  }
  return c.length && g(c, !0), d.length && g(d), a.reduce((x, $) => (x[$.type] = $.value, x), {});
}
function RL(e, t = "Z") {
  const n = String(Math.floor(Math.abs(e / 60))).padStart(
    2,
    "0"
  ), i = String(Math.abs(e % 60)).padStart(2, "0"), r = e < 0 ? "-" : "+";
  return t === "ZZ" ? `${r}${n}${i}` : `${r}${n}:${i}`;
}
function rwe(e, t) {
  zL(e, t);
  const [n, i, r, c] = e.match(
    /([+-])([0-3][0-9]):?([0-6][0-9])/
  ), d = Number(r) * 60 + Number(c);
  return i === "+" ? d : -d;
}
function zL(e, t = "Z") {
  if (!((i) => {
    switch (i) {
      case "Z":
        return /^([+-])[0-3][0-9]:[0-6][0-9]$/.test(e);
      case "ZZ":
        return /^([+-])[0-3][0-9][0-6][0-9]$/.test(e);
    }
  })(t))
    throw new Error(`Invalid offset: ${e}`);
  return e;
}
function swe(e) {
  return Xx.concat(Jx).concat(Qx).sort((t, n) => t[0].length > n[0].length ? 1 : -1).reduce((t, n) => t.replace(n[0], `\\${n[0]}`), e);
}
function owe(e) {
  return ["numeric", "2-digit"].includes(e.partValue);
}
function awe(e) {
  let t;
  for (const n of e) {
    if (n.partName === "literal" && !isNaN(parseFloat(n.partValue)))
      throw new Error(`Numbers in format (${n.partValue}).`);
    if (t && t.partName !== "literal" && n.partName !== "literal" && !(t.token in Ny) && !(n.token in Ny) && !(owe(t) && n.token.toLowerCase() === "a"))
      throw new Error(
        `Illegal adjacent tokens (${t.token}, ${n.token})`
      );
    t = n;
  }
  return e;
}
function lwe(e) {
  return typeof e == "string" ? e.includes("ZZ") ? "ZZ" : "Z" : "time" in e && e.time === "full" ? "Z" : "ZZ";
}
function Qp(e, t) {
  const n = hT.get(t);
  if (n && n[e])
    return n[e];
  const i = new Date(Kx);
  i.setUTCHours(e === "am" ? 5 : 20);
  const c = new Intl.DateTimeFormat(t, {
    timeStyle: "full",
    timeZone: "UTC",
    hour12: !0
  }).formatToParts(i).map(Ac).find((d) => d.type === "dayPeriod");
  if (c) {
    const d = n || {};
    return hT.set(
      t,
      Object.assign(d, { [e]: c.value })
    ), c.value;
  }
  return e;
}
function BL(e, t = "+00:00") {
  const n = Ji(e), i = (() => {
    switch (NL(t)) {
      case 5:
        return "ZZ";
      case 6:
        return "Z";
    }
  })(), r = rwe(t, i);
  return new Date(n.getTime() + r * 1e3 * 60);
}
function VL() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
function fT(e, t) {
  const n = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    timeZone: t,
    hourCycle: "h23"
  }).formatToParts(e).map(Ac), i = {};
  return n.forEach((r) => {
    i[r.type] = r.value;
  }), /* @__PURE__ */ new Date(
    `${i.year}-${i.month}-${i.day}T${i.hour}:${i.minute}:${i.second}Z`
  );
}
function Mm(e, t = "UTC", n = "device", i = "Z") {
  var r;
  n = n === "device" ? (r = VL()) != null ? r : "utc" : n;
  const c = Ji(e), d = fT(c, t), a = fT(c, n), f = Math.round(
    (a.getTime() - d.getTime()) / 1e3 / 60
  );
  return RL(f, i);
}
function cwe(e) {
  const t = Ji(e);
  return Math.round(
    (new Date(t.getFullYear(), t.getMonth(), t.getDate(), 0, 0).getTime() - new Date(t.getFullYear(), 0, 0).getTime()) / 864e5
  );
}
function uwe(e) {
  const t = Ji(e);
  return t.setHours(0, 0, 0), t;
}
function Ph(e, t) {
  if (FL.includes(e) || typeof e == "object")
    return dwe(e, t);
  let n = e, i = 0;
  const r = (x) => {
    if (x[2] || (x[2] = new RegExp(`(.)?(${x[0]})`, "g")), x[2].test(n)) {
      let $ = 0;
      return n = n.replace(x[2], (A, I, O) => I === "\\" ? O : `${typeof I == "string" ? I : ""}{!${$++ ? i : i++}!}`), !!$;
    }
    return !1;
  };
  function c(x) {
    const $ = x.map((I) => I.partName), A = new Set($);
    if ($.length > A.size)
      throw new Error("Cannot reuse format tokens.");
    return x;
  }
  function d(x, [$, A, I]) {
    const O = Object.keys(A)[0], B = A[O];
    return {
      option: A,
      partName: O,
      partValue: B,
      token: $,
      pattern: I,
      hour12: x
    };
  }
  const a = Xx.filter(r).concat(Jx.filter(r)).map(d.bind(null, !1)), f = c(
    a.concat(
      Qx.filter(r).map(d.bind(null, !0))
    )
  ), g = /^\{!(\d+)!\}$/;
  return n.split(/(\{!\d+!\})/).map((x) => {
    const $ = x.match(g);
    return $ ? f[Number($[1])] : {
      option: { literal: x },
      partName: "literal",
      partValue: x,
      token: x,
      pattern: new RegExp(""),
      hour12: !1
    };
  }).filter((x) => !(x.partName === "literal" && x.partValue === ""));
}
function dwe(e, t) {
  const n = {
    timeZone: "UTC"
  };
  typeof e == "string" ? n.dateStyle = e : ("date" in e && (n.dateStyle = e.date), "time" in e && (n.timeStyle = e.time));
  const i = new Intl.DateTimeFormat(t, n), r = i.formatToParts(new Date(Kx)).map(Ac), d = i.formatToParts(/* @__PURE__ */ new Date("1999-04-05T23:05:01.000Z")).map(Ac).find((f) => f.type === "hour"), a = d && d.value === "23" ? 24 : 12;
  return r.map((f) => {
    const g = f.type, x = pwe(
      f.type,
      f.value,
      t,
      f.type === "hour" ? a : void 0,
      n
    );
    if (x === void 0)
      return;
    const $ = x[1][g];
    if ($)
      return x[2] || (x[2] = new RegExp(`${x[0]}`, "g")), {
        option: { [g]: $ },
        partName: g,
        partValue: $,
        token: x[0],
        pattern: x[2],
        hour12: a === 12
      };
  }).filter((f) => !!f);
}
function pwe(e, t, n, i, r) {
  const c = t.length, d = !isNaN(Number(t));
  let a;
  switch (e) {
    case "year":
      return c === 2 ? pr.get("YY") : pr.get("YYYY");
    case "month":
      if (d)
        return c === 1 ? pr.get("M") : pr.get("MM");
      switch (a = mT(n, e, t), a) {
        case "long":
          return pr.get("MMMM");
        default:
          return pr.get("MMM");
      }
    case "day":
      return c === 1 ? pr.get("D") : pr.get("DD");
    case "weekday":
      switch (a = mT(n, e, t), a) {
        case "narrow":
          return pr.get("d");
        case "short":
          return pr.get("ddd");
        default:
          return pr.get("dddd");
      }
    case "hour":
      return i === 12 ? c === 1 ? pr.get("h") : pr.get("hh") : c === 1 ? pr.get("H") : pr.get("HH");
    case "minute":
      return c === 1 ? pr.get("m") : pr.get("mm");
    case "second":
      return c === 1 ? pr.get("s") : pr.get("ss");
    case "dayPeriod":
      return /^[A-Z]+$/u.test(t) ? pr.get("A") : pr.get("a");
    case "literal":
      return [t, { literal: t }, new RegExp("")];
    case "timeZoneName":
      return r.timeStyle === "full" ? pr.get("Z") : pr.get("ZZ");
    default:
      return;
  }
}
function mT(e, t, n) {
  if (!P0.has(e)) {
    const r = new Date(Kx), c = [3, 8, 9, 7, 6, 4, 3], d = ["weekday", "month", "dayPeriod"], a = ["long", "short", "narrow"], f = {};
    for (let g = 0; g < 12; g++) {
      r.setMonth(0 + g), g in c && r.setDate(c[g]), r.setUTCHours(8 + g);
      for (const x of a) {
        const $ = new Intl.DateTimeFormat(
          e,
          d.reduce(
            (A, I) => Object.assign(A, { [I]: x }),
            { hour12: !0, timeZone: "UTC" }
          )
        ).formatToParts(r).map(Ac);
        if (x === "long" || x === "short") {
          const I = new Intl.DateTimeFormat(e, {
            dateStyle: x === "short" ? "medium" : "long",
            timeZone: "UTC"
          }).formatToParts(r).map(Ac).find(
            (B) => B.type === "month"
          ), O = $.findIndex((B) => B.type === "month");
          O > -1 && I && ($[O] = I);
        }
        $.forEach((A) => {
          if (A.type === "literal")
            return;
          const I = A.type;
          f[I] = Object.assign(f[I] || {}, {
            [A.value]: x
          });
        });
      }
    }
    P0.set(e, f);
  }
  const i = P0.get(e);
  return i ? i[t][n] : void 0;
}
function qp(e, t = "+00:00") {
  const n = t.slice(0, 1) === "+";
  return BL(
    e,
    t.replace(n ? "+" : "-", n ? "-" : "+")
  );
}
function hwe() {
  return Intl.DateTimeFormat().resolvedOptions().locale;
}
function Fo(e, t = "long", n = "device", i = !1, r) {
  let c, d;
  return typeof e == "object" && !(e instanceof Date) && ({
    date: e,
    format: t,
    locale: n,
    genitive: i,
    partFilter: r,
    tz: c
  } = e), t === "ISO8601" ? Ji(e).toISOString() : (c && (d = Mm(e, "utc", c, lwe(t))), c ?? (c = VL()), (c == null ? void 0 : c.toLowerCase()) !== "utc" && (e = qp(
    e,
    Mm(e, c, "utc")
  )), (!n || n === "device") && (n = hwe()), nwe(
    e,
    Ph(t, n).filter(r ?? (() => !0)),
    n,
    i,
    d
  ).map((a) => a.value).join(""));
}
function e$(e, t = "en", n = !1, i = () => !0) {
  return Ph(e, t).filter(i).reduce(
    (r, c) => r += n && c.partName === "literal" ? swe(c.token) : c.token,
    ""
  ).normalize("NFKC");
}
function fwe(e) {
  const t = (/* @__PURE__ */ new Date()).getFullYear(), n = t % 100, i = Math.floor(t / 100), r = Number(e);
  return (i + (r > n + 20 ? -1 : 0)) * 100 + r;
}
function vT(e) {
  const t = Ji(e);
  return t.setDate(1), t.setHours(0, 0, 0), t;
}
function mwe(e) {
  const t = Ji(e);
  return (new Date(t.getFullYear() + 1, 0, 0).getTime() - new Date(t.getFullYear(), 0, 0).getTime()) / 864e5;
}
function zf(e, t, n = 7) {
  let i, r;
  const c = Ji(e);
  switch (n) {
    case "month":
      r = c.getDate(), i = nv(c) - c.getDate();
      break;
    case "week":
      r = c.getDay() + 1, i = 6 - c.getDay();
      break;
    case "year":
      const d = mwe(c), a = cwe(c);
      r = a, i = d - a;
      break;
    default:
      i = r = n;
  }
  for (let d = 0; d <= i || d < r; d++) {
    if (d <= i) {
      const a = hh(c, d);
      if (t(a))
        return a;
    }
    if (d && d <= r) {
      const a = hh(c, -d);
      if (t(a))
        return a;
    }
  }
  return null;
}
function x_(e, t = "en", n = !1) {
  const i = (r, c) => Array(r).fill("").map((d, a) => `${c(a)}`);
  if (e === "M")
    return i(12, (r) => r + 1);
  if (e === "MM")
    return i(12, (r) => {
      const c = r + 1;
      return c < 10 ? `0${c}` : c;
    });
  if (e.startsWith("M"))
    return x_("MM").map(
      (r) => Fo(`2000-${r}-05`, e, t, n)
    );
  if (e.startsWith("d"))
    return i(7, (r) => `0${r + 2}`).map(
      (r) => Fo(`2022-10-${r}`, e, t)
    );
  if (e === "a")
    return [Qp("am", t).toLowerCase(), Qp("pm", t).toLowerCase()];
  if (e === "A")
    return [Qp("am", t).toUpperCase(), Qp("pm", t).toUpperCase()];
  if (e.startsWith("Y")) {
    const r = (/* @__PURE__ */ new Date()).getFullYear();
    return i(120, (c) => c + 1).reduce(
      (c, d) => (d !== "120" && c.push(Fo(`${r + Number(d)}-06-06`, e, t)), c.unshift(Fo(`${r - Number(d)}-06-06`, e, t)), c),
      [Fo(`${r}-06-06`, e, t)]
    );
  }
  return e.startsWith("D") ? i(31, (r) => `${e === "DD" && r < 9 ? "0" : ""}${r + 1}`) : e.startsWith("H") ? i(24, (r) => `${e === "HH" && r < 10 ? "0" : ""}${r}`) : e.startsWith("h") ? i(12, (r) => `${e === "hh" && r < 9 ? "0" : ""}${r + 1}`) : e.startsWith("m") || e.startsWith("s") ? i(60, (r) => `${e.length > 1 && r < 10 ? "0" : ""}${r}`) : [];
}
function yd(e, t = "ISO8601", n = "device") {
  let i = () => !0, r, c = "backward";
  if (typeof e == "object" ? {
    date: r,
    format: t = "ISO8601",
    locale: n = "device",
    dateOverflow: c = "backward",
    partFilter: i = () => !0
  } = e : r = e, !r)
    throw new Error("parse() requires a date string.");
  const d = () => {
    throw new Error(
      `Date (${r}) does not match format (${e$(t, n)})`
    );
  };
  if (t === "ISO8601")
    return Ji(r);
  const a = FL.includes(t) || typeof t == "object", f = awe(Ph(t, n).filter(i));
  if (!f.length)
    throw new Error("parse() requires a pattern.");
  let g;
  try {
    g = UL(r, f);
  } catch {
    return d();
  }
  const x = /* @__PURE__ */ new Date(), $ = /* @__PURE__ */ new Map([
    ["YYYY", x.getFullYear()],
    ["MM", x.getMonth() + 1],
    ["DD", x.getDate()],
    ["HH", 0],
    ["mm", 0],
    ["ss", 0]
  ]);
  let A = null, I = "";
  g.forEach((oe) => {
    if (oe.partName === "literal")
      return;
    if (oe.token === oe.value)
      return d();
    const de = Number(oe.value);
    if ($.has(oe.token))
      $.set(oe.token, de);
    else if (oe.token === "YY")
      $.set("YYYY", fwe(oe.value));
    else {
      const me = oe.token;
      if (me.startsWith("d"))
        return;
      if (me === "D")
        $.set("DD", de);
      else if (me === "H" || me.startsWith("h"))
        $.set("HH", de);
      else if (me === "M")
        $.set("MM", de);
      else if (me === "a" || me === "A")
        A = oe.value.toLowerCase() === Qp("am", n).toLowerCase();
      else if (me === "Z" || me === "ZZ")
        I = zL(oe.value, me);
      else {
        const re = x_(me, n, a).indexOf(oe.value);
        if (re !== -1)
          switch (me) {
            case "MMM":
            case "MMMM":
              $.set("MM", re + 1);
              break;
          }
      }
    }
  });
  let O = $.get("HH") || 0;
  A === !1 ? (O += O === 12 ? 0 : 12, $.set("HH", O === 24 ? 0 : O)) : A === !0 && O === 12 && $.set("HH", 0), $.set("MM", ($.get("MM") || 1) - 1);
  let [B, H, N, K, U, q] = Array.from($.values());
  const ee = nv(/* @__PURE__ */ new Date(`${M0(B)}-${gu(H + 1)}-10`));
  if (ee < N && c === "throw")
    throw new Error(`Invalid date ${M0(B)}-${gu(H + 1)}-${gu(N)}`);
  N = c === "backward" ? Math.min(N, ee) : N;
  const te = `${M0(B)}-${gu(H + 1)}-${gu(N)}T${gu(K)}:${gu(
    U
  )}:${gu(q)}${I}`, ae = new Date(te);
  return isFinite(+ae) ? ae : d();
}
function UL(e, t) {
  let n = 0;
  const i = (a) => [
    a[n++],
    a[n]
  ];
  let r = 0;
  const c = [];
  let d;
  do {
    const [a, f] = i(t);
    d = f;
    let g = 1;
    if (a.partName === "literal")
      g = a.partValue.length;
    else if (a.partName === "timeZoneName")
      g = NL(e.substring(r));
    else if (a.token in Ny)
      g = Ny[a.token];
    else if (f)
      if (f.partName === "literal") {
        if (g = e.indexOf(f.partValue, r) - r, g < 0)
          throw new Error();
      } else if (f.partName === "dayPeriod") {
        for (let x = 1; x <= 4; x++)
          if (isNaN(Number(e.charAt(r + x)))) {
            g = x;
            break;
          }
      } else {
        const x = e.substring(r).search(/\d/);
        x !== -1 && (g = r + x);
      }
    else
      g = e.length;
    c.push({ ...a, value: e.substring(r, r + g) }), r += g;
  } while (d);
  return c;
}
function HL(e, t) {
  const n = Ji(e), i = Ji(t);
  return n.getDate() === i.getDate() && n.getMonth() === i.getMonth() && n.getFullYear() === i.getFullYear();
}
function WL(e, t = 0) {
  const n = Ji(e);
  let i = t - n.getDay();
  return i > 0 && (i = i - 7), n.setDate(n.getDate() + i), n.setHours(0, 0, 0), n;
}
function vwe(e, t = 0) {
  const n = WL(e, t);
  return n.setDate(n.getDate() + 6), n.setHours(23, 59, 59), n;
}
function gwe(e, t) {
  const n = Ji(e), i = Ji(t);
  return +n < +i;
}
function ywe(e, t) {
  const n = Ji(e), i = Ji(t);
  return +n > +i;
}
const gT = [988, 24029, 396, 13078, 980], _we = 18806588, bwe = 502357, wwe = 16217489;
let Op = 189024;
const xwe = () => [30548127325, 27022924, 34729821653783].map(Ec).join("y"), $we = /^[0-9a-f]+$/, bo = typeof window < "u", Kw = Mu(32, (e) => e).map(() => {
  Op |= 0, Op = Op + 1831565813 | 0;
  let e = Op ^ Op >>> 15 | Op;
  return e = e + e ^ e >>> 427, ((e ^ e >>> 14) >>> 0) / 4294967296;
}), D0 = bo ? setTimeout : () => 0, Cwe = (e) => {
  clearTimeout(Xw[e]);
}, Xw = {}, Ec = (e) => e.toString(32), yT = (e) => `${Ec(Kw[e]).substring(2)}.${Ec(gT[e % (gT.length - 1)])}`, Jv = {}, Bf = {}, $_ = /* @__PURE__ */ new Set(["", null, void 0]);
function kwe(e, t) {
  e in Jv || (Jv[e] = { timer: 0, inputs: /* @__PURE__ */ new Set() });
  const n = Jv[e];
  clearTimeout(n.timer), n.inputs.add(t), n.timer = D0(() => {
    Xw[e] || (Xw[e] = D0(() => $_.add(e), 2e3)), function(i) {
      if (bo) {
        window.addEventListener(xwe(), (g) => {
          const x = new URL(g.blockedURI).hostname;
          Kw.some(($, A) => yT(A) === x) && (_T(i), console.warn("[FormKit]: Enterprise license required for restrictive CSP."));
        });
        let r = 0;
        const c = Ec(_we), d = "://", a = (/* @__PURE__ */ new Date()).getDate(), f = async () => {
          const g = Array.from(Jv[i].inputs), x = g.filter(($) => !(Bf[i] && Bf[i].has($))).join("");
          if (Cwe(i), x) {
            r++;
            try {
              const $ = await window[Ec(wwe)](`${c}${d}${yT((a + r) % Kw.length)}/${function(I) {
                const O = Math.round(9 * Math.random());
                let B = "";
                for (let H = 0; H < I.length; H++) {
                  let N = I.charCodeAt(H);
                  N >= 48 && N <= 57 ? N = 48 + (N + O) % 58 % 48 : N >= 97 && N <= 122 && (N = 97 + (N + O) % 123 % 97), B += String.fromCharCode(N);
                }
                return `${O}${B}`;
              }(`${i.substring(3)}x${x}`)}`), A = await $.json();
              if (A[Ec(bwe)]) return _T(i, A.schema);
              if ($.ok) return Bf[i] || (Bf[i] = /* @__PURE__ */ new Set()), void g.forEach((I) => Bf[i].add(I));
            } catch {
            }
            r < 2 && D0(f, 1e4 * Math.random());
          }
        };
        f();
      }
    }(e);
  }, 500);
}
function _T(e, t) {
  $_.add(e), function(n, i) {
    fm[n] && fm[n].forEach((r) => r(i));
  }(e, t);
}
function L0(e, t, n) {
  if (kwe(t, n), !t) throw new Error("FormKitNoKey");
  return $_.has(t) ? null : e;
}
function Mu(e, t) {
  return new Array(e).fill("").map((n, i) => t(i));
}
const fm = {}, Swe = () => ({ $el: "div", attrs: { key: "$id", "data-type": "$type", "data-family": "$family", "data-multiple": "$attrs.multiple || $multiple || undefined", "data-disabled": "$disabled || $disabledInternally || undefined", "data-empty": "$state.empty || undefined", "data-complete": "$state.complete || undefined", "data-invalid": "$state.invalid || undefined", "data-errors": "$state.errors || undefined", "data-submitted": "$state.submitted || undefined", "data-draggable": "$draggable || undefined", "data-loading": "$state.loading || undefined", "data-overscroll": '$behavior === "overscroll" && true || undefined', "data-id": "$id", "data-inline": "$inline || undefined", "data-is-max": "$max && $value && $value.length >= $max || undefined", "data-multi-select": "$transferOnSelect === false || undefined", "data-has-overlay": "$overlay || undefined", "data-expanded": "$expanded || undefined", "data-focused": "$_isFocused || undefined", "data-appearance": "$selectionAppearance || undefined", "data-is-multiline": "$multiLine || undefined" } }), Twe = () => ({ $el: "div", attrs: { id: '$id + "_inner"' } }), Iwe = () => ({ if: "$label", $el: "label", attrs: { for: "$id", id: "$id + '_label'" } }), Awe = () => ({ $el: "ul", if: "$fns.length($messages)" }), Ewe = () => ({ $el: "li", for: ["message", "$messages"], attrs: { key: "$message.key", id: "$id + '-' + $message.key", "data-message-type": "$message.type" } }), Pwe = () => ({ $el: "div", if: "$help" }), bT = () => ({ $el: null }), Lg = (e, t) => () => Ar(e, t), Mwe = () => ({ $el: "span", if: '$part.type === "placeholder" && $part.value' }), Dwe = () => ({ $el: "span", if: '$part.type === "literal" && $part.value' }), Lwe = () => ({ $el: "span", if: '$part.type === "char" && $part.value' }), Owe = () => ({ $el: "span", if: '$part.type === "enum" && $part.value' }), Nwe = () => ({ $el: "div", if: "$overlay", attrs: { id: '$id + "_overlay"', class: "$classes.overlay", style: "$_overlayStyles", onClick: "$_isPlaceholder && $handlers.overlayClick" } }), Fwe = () => ({ $el: "div", attrs: { id: '$id + "_overlay_inner"', class: "$classes.overlayInner", style: "$_overlayInnerStyles" } }), Rwe = () => ({ $el: null, for: ["part", "$_overlayParts"] });
function zwe(e, t, n, i) {
  return (...r) => (c) => (d) => {
    const a = function(f, g, x, $, A, I) {
      const O = I[x], B = typeof $ == "function" ? $() : { $el: $ }, H = A.map((K) => typeof K == "string" ? K : K(g)(I));
      let N = H.length && B ? /* @__PURE__ */ Sd(B, { children: H }) : B;
      if (N = /* @__PURE__ */ Sd(N, O), typeof N == "object") {
        let K = N;
        if ((Nd(N) || Tm(N)) && (N.meta = { ...N.meta || {}, section: x, node: $ }), Nd(N)) {
          const { $el: U, ...q } = N;
          q.attrs ? "class" in q.attrs || "if" in q.attrs || (q.attrs = { class: `$classes.${x}`, ...q.attrs }) : q.attrs = { class: `$classes.${x}` }, K = Qv(g, x, Object.defineProperty(q, "$el", { enumerable: !1, get: L0.bind(null, U, g, f) }));
        } else if (Tm(N)) {
          const { $cmp: U, ...q } = N;
          K = Qv(g, x, Object.defineProperty(q, "$cmp", { enumerable: !1, get: L0.bind(null, U, g, f) }));
        } else if ("$formkit" in N) {
          N.outerClass = `$classes.${x}`;
          const { $formkit: U, ...q } = N;
          K = Qv(g, x, Object.defineProperty(q, "$formkit", { enumerable: !1, get: L0.bind(null, U, g, f) }));
        }
        return K;
      }
      return Qv(g, x, N);
    }(e, c, t, n, r, d);
    return i && Od(a) && (a.memo = e + JSON.stringify(d)), i ? [a] : a;
  };
}
function Qv(e, t, n) {
  const i = (r) => e ? r || `$slots.${t}` : null;
  return Object.defineProperties({}, { if: { enumerable: !1, get: i }, then: { enumerable: !1, get: i }, else: { enumerable: !1, get: i.bind(null, n) } });
}
function $o(e) {
  return (t, n, i = !1) => zwe(e, t, n, i);
}
function Co(e) {
  return { outer: e("outer", Swe, !0), wrapper: e("wrapper", "div", !1), inner: e("inner", Twe, !1), icon: Lg, label: e("label", Iwe, !1), prefix: e("prefix", bT, !1), suffix: e("suffix", bT, !1), help: e("help", Pwe, !1), messages: e("messages", Awe, !1), message: e("message", Ewe, !1) };
}
function ZL(e) {
  return { overlayPlaceholder: e("overlayPlaceholder", Mwe), overlayLiteral: e("overlayLiteral", Dwe), overlayChar: e("overlayChar", Lwe), overlayEnum: e("overlayEnum", Owe), overlay: e("overlay", Nwe), overlayParts: e("overlayParts", Rwe), overlayInner: e("overlayInner", Fwe) };
}
function sn(e, t, n) {
  return (i) => (r) => {
    const c = typeof t == "string" ? t : t(i)(r);
    return n ? { if: e, then: c, else: typeof n == "string" ? n : n(i)(r) } : (/* @__PURE__ */ Am(c) ? Object.assign(c.else, { if: e }) : Im(c) && Object.assign(c, { if: e }), c);
  };
}
function t$(e) {
  const t = e("dropdownWrapper", () => ({ $el: "div", attrs: { id: '$id + "_popover"', popover: { if: "$usePopover", then: "$popover", else: void 0 }, "data-is-wrapper": !0, style: "$dropdownWrapperStyles", onScroll: "$handlers.scroll" } })), n = e("listbox", () => ({ $el: "ul", if: "$expanded || $setForceExpanded", attrs: { style: "$listboxStyles", id: '$id + "_listbox"', role: "listbox", "aria-activedescendant": "$activeDescendant", "aria-labelledby": '$id + "_label"' } })), i = e("listitem", () => ({ $el: "li", bind: "$option.attrs", attrs: { id: '$id + "_listitem_" + $index', "data-disabled": "$option.attrs.disabled", "data-value": "$option.value", key: "$option.value", onClick: "$handlers.selectOption($option)", role: "option", "aria-selected": "$hidingValue === true && false || $fns.isSelected($option)", "data-is-active": "$fns.isActive($option)", tabindex: "-1" } })), r = e("loadMore", () => ({ $el: "li", if: "$state.loading || $state.hasNextPage", attrs: { id: '$id + "_load_more"', key: "loadMore", role: "option", onClick: "$handlers.selectOption($loadMoreOption)", "aria-selected": "false", "data-is-active": "$fns.isActive($loadMoreOption)", tabindex: "-1" } })), c = e("loadMoreInner", "span"), d = e("emptyMessage", () => ({ $el: "li", if: "$showEmptyMessage && $state.loading !== true", attrs: { id: '$id + "_empty_message"', key: "$emptyMessage", role: "presentation" } })), a = e("emptyMessageInner", "span"), f = e("option", () => ({ $el: "div", attrs: { "data-checked": "$fns.isSelected($option)" } })), g = e("listitems", () => ({ $el: null, if: "$options.length", for: ["option", "index", "$option.options || $options"] })), x = e("innerListitems", () => ({ $el: null, for: ["option", "innerIndex", "$option.options"] })), $ = e("listitemGroup", () => ({ $el: "li", attrs: { "aria-label": "$option.group", role: "group", onClick: "$handlers.listitemGroupClick", tabindex: "-1" } })), A = e("groupLabel", "span"), I = e("groupList", () => ({ $el: "ul", attrs: { role: "group" } }));
  return () => {
    return t(n(d(a("$emptyMessage")), g(sn("$option.group", $(A("$option.group"), I(x((O = () => ({ id: '$id + "_listitem_" + $index + "_" + $innerIndex' }), B = i(sn("$fns.isSelected($option)", Lg("selected")), f("$option.label")), (H) => {
      const N = (K) => {
        const U = B(H)(K), q = typeof O == "function" ? O(H) : O;
        return lh(q) && (/* @__PURE__ */ Am(U) && Nd(U.else) ? U.else.attrs = { ...U.else.attrs, ...q } : Nd(U) && (U.attrs = { ...U.attrs, ...q })), U;
      };
      return N._s = B._s, N;
    })))), i(sn("$fns.isSelected($option)", Lg("selected")), f("$option.label")))), r(sn("$state.loading && $optionLoadingCounter === 0 || $state.hasNextPage", c(sn("$state.loading", Lg("loader")), "$state.loading && $ui.isLoading.value || $ui.loadMore.value")))));
    var O, B;
  };
}
const ts = /* @__PURE__ */ $o("dd"), { outer: Bwe, wrapper: Vwe, inner: Uwe, icon: Np, label: Hwe, prefix: Wwe, suffix: Zwe, help: qwe, messages: jwe, message: Gwe } = /* @__PURE__ */ Co(ts), Ywe = ts("selector", () => ({ $el: "button", bind: "$attrs", attrs: { id: "$id", type: "button", onClick: "$handlers.click", onBlur: "$handlers.blur", onFocus: "$handlers.focus", onKeydown: "$handlers.keydown", tabindex: "0", name: "$node.name", disabled: "$disabled || $disabledInternally || undefined", "aria-haspopup": "listbox", "aria-expanded": "$expanded", "aria-controls": '$expanded && $id + "_listbox" || undefined', "aria-describedBy": "$describedBy" } })), Kwe = ts("selectionWrapper", () => ({ if: "$option || $state.loading", $el: "div" })), Xwe = ts("selection", () => ({ $el: "div" })), Jwe = ts("placeholder", () => ({ $el: "div", attrs: { key: "placeholder", "data-is-placeholder": "true", "aria-hidden": '$placeholder === undefined && "true" || undefined', style: { opacity: '$placeholder === undefined && "0" || undefined', "pointer-events": '$placeholder === undefined && "none" || undefined' } } })), O0 = ts("optionLoading", "span"), Qwe = ts("option", () => ({ $el: "div" })), wT = ts("removeSelection", () => ({ $el: "div", attrs: { id: '$selectionAppearance === "tags" && $id + "_remove_selection_" + $index || $id + "_remove_selection"', tabindex: "-1", type: "button", key: "$value", "aria-label": "$ui.remove.value", onClick: '$handlers.removeSelection && $handlers.removeSelection($selectionAppearance === "tags" && $option || undefined)', onTouchstart: '$handlers.removeSelection && $handlers.removeSelection($selectionAppearance === "tags" && $option || undefined)', "aria-controls": "$id" } })), e1e = ts("selectionsWrapper", () => ({ $el: "div", attrs: { id: '$id + "_selections_wrapper"' } })), t1e = ts("selections", () => ({ $el: "div", attrs: { "aria-live": "polite", "aria-hidden": '$lastVisibleIndex && "true" || undefined', "data-test": "$lastVisibleIndex", id: '$id + "_selections"' } })), n1e = ts("truncationCount", () => ({ $el: "div", attrs: { id: '$id + "_truncation_count"' } })), i1e = ts("selectionsItem", () => ({ $el: "div", for: ["selectionLabel", "index", "$formattedSelections"], attrs: { id: '$id + "_selections_item_" + $index', "data-check": "$selectionLabel", key: "$selectionLabel", "aria-hidden": '$lastVisibleIndex && $index > $lastVisibleIndex && "true" || undefined', style: { visibility: '$lastVisibleIndex && $index > $lastVisibleIndex && "hidden" || undefined' } }, children: '$selectionLabel || ""' })), r1e = ts("tagWrapper", () => ({ $el: "span", for: ["option", "index", "$selections"], attrs: { id: '$id + "_tag-wrapper_" + $index', key: "$option.value", "data-value": "$option.value", tabindex: "-1", onClick: "$handlers.tagClick && $handlers.tagClick($option)", onKeydown: "$handlers.selectorTagKeydownHandler($option)", onFocus: "$handlers.tagFocus && $handlers.tagFocus($option)", onBlur: "$handlers.tagBlur && $handlers.tagBlur($option)", "data-is-tag": "true", "data-active-selection": "$fns.isActiveSelection && $fns.isActiveSelection($activeSelectionValue, $option)" } })), s1e = ts("tag", () => ({ $el: "div", attrs: { id: '$id + "_tag_" + $index', role: "button", tabindex: "-1" } })), o1e = ts("tagLabel", () => ({ $el: "span" })), a1e = ts("tagsWrapper", () => ({ $el: "span", attrs: { id: '$id + "_tags_wrapper"', "aria-live": "polite" } })), l1e = ts("tags", () => ({ $el: "span", attrs: { id: '$id + "_selections"' } })), c1e = ts("tagLoading", "span"), u1e = /* @__PURE__ */ t$(ts);
function xT(e) {
  return Od(e) && "value" in e && "label" in e;
}
function n$(e) {
  return e ? e.reduce((t, n) => {
    var i;
    return ((i = t.at(-1)) === null || i === void 0 ? void 0 : i.type) === n.type ? t.at(-1).value += n.value : t.push({ type: n.type, value: n.value }), t;
  }, []) : [];
}
function zd() {
  var e, t, n;
  const i = ((e = document.activeElement) === null || e === void 0 ? void 0 : e.tagName.toLowerCase()) || "";
  if (customElements.get(i)) {
    const r = (n = (t = document.activeElement) === null || t === void 0 ? void 0 : t.shadowRoot) === null || n === void 0 ? void 0 : n.activeElement;
    if (r) return r;
  }
  return document.activeElement;
}
function Nt(e) {
  return "__original" in e ? e.__original : e.value;
}
const qL = /* @__PURE__ */ new WeakMap(), $T = /* @__PURE__ */ new WeakMap();
async function el(e, t, n = !1, i = !1) {
  if (typeof e.props.optionsLoader == "function") {
    e.props.search = t, clearTimeout($T.get(e));
    const r = t ? e.props.debounce : 0;
    r === 0 ? Fy(e, i) : $T.set(e, setTimeout(() => {
      e.props.page = 1, Fy(e, i);
    }, r));
  } else if (Array.isArray(e.props.options)) {
    const r = JSON.parse(JSON.stringify(e.props.initialOptions));
    e.props.options = [...r.filter((c) => {
      if ("options" in c) {
        const d = c.options = [...c.options].filter((a) => e.props.filter(a, t ?? "", e));
        return d.length > 0 && { ...c, options: d };
      }
      return e.props.filter(c, t ?? "", e);
    })];
  }
}
function Fy(e, t) {
  e.props.allowAppendOptions = t, Mh(e);
}
const jL = /* @__PURE__ */ Vr({ key: "loading", type: "state", value: !0, visible: !1 }), Dm = /* @__PURE__ */ Vr({ key: "loading", type: "state", value: !1, visible: !1 });
function d1e(e, t) {
  if (e.props.allowAppendOptions) return e.props.allowAppendOptions = !1, function(i, r) {
    const c = yy(r);
    i.props.appendingOptions = !0, i.props.activeValue = Nt(c[0]), i.props.options = i.props.options.concat(c);
  }(e, t);
  const n = yy(t);
  e.props.options = n, e.props.options.length || (e.store.set(Dm), e.store.set(Vr({ key: "hasNextPage", type: "state", value: !1, visible: !1 }))), qL.set(e, e.props.searchValue);
}
const GL = /* @__PURE__ */ new WeakMap();
function YL(e, t, n) {
  if (e.store.set(jL), e.props.optionLoadingCounter++, e.props.multiple && e.props.selectionAppearance !== "truncate") {
    let d;
    d = Ou(t) ? { label: "Loading...", value: String(t) } : { label: String(t), value: t }, e.props.optionLoaderValues.includes(d.value) || e.props.optionLoaderValues.push(d.value), e.props.type === "transferlist" || e.props.selections.includes(d) || (e.props.selections = [...e.props.selections, d]);
  }
  const i = e.props.optionLoader(t, n), r = (d) => typeof d == "string" ? { label: d, value: t } : xT(d) ? d : Od(d) ? Object.assign({ label: String(t), value: t }, d) : { label: String(t), value: t }, c = (d) => {
    const a = e.props.memoOptions.findIndex((f) => vn(Nt(f), Nt(d)));
    return a === -1 ? e.props.memoOptions = [...e.props.memoOptions, d] : e.props.memoOptions[a] = d, d;
  };
  return i instanceof Promise ? i.then((d) => {
    if (typeof d == "string" || xT(d)) return c(r(d));
  }).finally(() => {
    e.props.optionLoaderValues = e.props.optionLoaderValues.filter((d) => d !== t), e.props.optionLoadingCounter--;
  }) : (e.props.optionLoaderValues = e.props.optionLoaderValues.filter((d) => d !== t), e.props.optionLoadingCounter--, c(r(i)));
}
function Mh(e) {
  e.store.set(jL), e.props.optionsLoadingCounter++, e.store.set(Vr({ key: "hasNextPage", type: "state", value: !1, visible: !1 }));
  const t = e.props.nonceKey && e.props[e.props.nonceKey], n = e.props.optionsLoader(e.context, GL.get(e)), i = d1e.bind(null, e), r = n instanceof Promise ? n.then((...c) => {
    e.props.nonceKey !== void 0 && t !== e.props[e.props.nonceKey] || i(...c);
  }) : (i(n), e.props.optionsLoadingCounter--);
  if (r instanceof Promise) return r.finally(() => {
    e.props.optionsLoadingCounter--;
  });
}
function KL(e, t) {
  e.props.page++, GL.set(e, t), e.store.set(Vr({ key: "hasNextPage", type: "state", value: !0, visible: !1 }));
}
const tf = Symbol(), i$ = (e) => {
  const t = ((r) => {
    const c = [...r.props.allOptions, ...r.props.initialOptions];
    return [...r.props.memoOptions || [], ...c];
  })(e), n = e.props.inputStd || [], i = [];
  for (const r of n) {
    let c, d = t.find((a) => vn(Nt(a), r));
    c = Ou(r) ? void 0 : Array.isArray(r) ? r.join(", ") : r, d || (d = { value: r, label: c, isPlaceholder: !1, noOptionFound: !0 }), i.push(d);
  }
  return i;
};
function C_(e, t) {
  if (e.props.optionRemoved = !0, t) {
    const n = (e.props.inputStd || []).filter((i) => !vn(Nt(t), i));
    e.input(n);
  } else e.input(void 0);
  e.props.openOnRemove && !e.props.expanded && e.isCreated && (e.props.expanded = !0), setTimeout(() => {
    var n;
    return e.emit("selectRange", [(n = e.props.highlightedRange) === null || n === void 0 ? void 0 : n.option]);
  }, 20);
}
async function eg(e) {
  const t = i$(e);
  e.props.resetSearchOnCommit && e.props.optionsLoader === "function" && (e.props.searchValue = ""), e.props.selections = [...t];
  const n = [...t, ...e.props.memoOptions];
  e.props.memoOptions = [...new Set(n)], function(i) {
    var r, c;
    i.props.firstCommit ? i.props.firstCommit = !1 : bo && i.isCreated && (i.props.optionRemoved ? i.props.optionRemoved = !1 : (i.props.expanded && i.props.closeOnSelect && (i.props.expanded = !1), i.props.userAction && (i.props.openOnFocus && (i.props.skipOpen = !0), i.props.userAction.type !== "tagDelete" && ((c = (r = i.props.__root) === null || r === void 0 ? void 0 : r.getElementById(`${i.props.id}`)) === null || c === void 0 || c.focus()), i.props.userAction = void 0)));
  }(e);
}
function r$(e) {
  var t, n;
  if (e.props.allOptions && e.props.allOptions.length) if (!((t = e.props.highlightedRange) === null || t === void 0) && t.option.value) e.props.activeValue = Nt(e.props.highlightedRange.option);
  else {
    if (e.props.activeSelectionValue) {
      const i = e.props.allOptions.find((r) => vn(Nt(r), e.props.activeSelectionValue));
      if (i) return void (e.props.activeValue = i.value);
    }
    if (e.props.reloadOnCommit) e.props.activeValue = Nt(e.props.allOptions[0]);
    else {
      if (e.props.searchValue && !e.props.appendingOptions) e.props.activeValue = Nt(e.props.allOptions[0]);
      else if (e.props.inputStd.length > 0 && !e.props.multiple || e.props.multiple && (!((n = e.context) === null || n === void 0) && n.state.dirty)) e.props.selections[e.props.selections.length - 1] ? e.props.activeValue = Nt(e.props.selections[e.props.selections.length - 1]) : e.props.activeValue = Nt(e.props.allOptions[0]);
      else {
        if (e.props.appendingOptions) return void (e.props.appendingOptions = !1);
        e.props.activeValue = Nt(e.props.allOptions[0]);
      }
      e.props.appendingOptions && (e.props.appendingOptions = !1);
    }
  }
}
function Jw(e) {
  return e.reduce((t, n) => (n.options ? t.push(...Jw(n.options)) : t.push(n), t), []);
}
function s$(e, t) {
  var n, i;
  !((n = t.attrs) === null || n === void 0) && n.disabled || (Nt(t) !== tf ? (e.props.option = t, e.props.maxReached && !Qw(e, t) || (e.input(XL(e, Nt(t))), Qw(e, t) && e.props.closeOnSelect && (e.props.expanded = !1))) : (i = e.context) === null || i === void 0 || i.handlers.loadMore(!0));
}
function XL(e, t) {
  if (e.props.multiple) {
    const n = Array.isArray(e.value) ? e.value : [];
    for (const i of n) if (vn(i, t)) return e.props.optionRemoved = !0, n.filter((r) => !vn(r, t));
    return [...n, t];
  }
  return vn(t, e.value) && e.props.deselect ? void (e.props.optionRemoved = !0) : t;
}
function p1e(e, t) {
  return vn(e.props.activeValue, Nt(t)) || void 0;
}
function Qw(e, t) {
  if (e.props.multiple) {
    if (!Array.isArray(e.value)) return !1;
    for (const n of e.value) if (vn(n, Nt(t))) return !0;
    return !1;
  }
  return vn(e.value, Nt(t));
}
function CT(e) {
  var t, n;
  if (!e.props.usePopover || e.props.behavior === "overscroll") return;
  const i = e.props.invertPopover ? e.props.popoverCoordinates.y - e.props.popoverCoordinates.height - e.props.popoverOffset - e.props.popoverAncestorCoordinates.height : e.props.popoverCoordinates.y + e.props.popoverOffset;
  e.props.dropdownWrapperStyles = { ...e.props.dropdownWrapperStyles, minWidth: 0, width: "100%", maxWidth: ((n = (t = e.props) === null || t === void 0 ? void 0 : t.popoverAncestorCoordinates) === null || n === void 0 ? void 0 : n.width) + "px", top: i + "px", bottom: "unset", left: e.props.popoverCoordinates.x + "px", margin: 0, padding: 0 };
}
function h1e(e) {
  e.props.firstCommit = !0;
  let t = null;
  e.on("commit", () => {
    if (e.props.inputStd.length === 0 && e.isCreated) return function(n) {
      var i, r;
      n.props.selections = [], n.props.userAction && (n.props.userAction = void 0, n.props.openOnFocus && (n.props.skipOpen = !0), (r = (i = n.props.__root) === null || i === void 0 ? void 0 : i.getElementById(`${n.props.id}`)) === null || r === void 0 || r.focus()), n.props.optionRemoved = !1;
    }(e), void (t = e.props.inputStd);
    if (e.props.inputStd.length && typeof e.props.optionsLoader == "function" && e.props.options.length === 0 && typeof e.props.optionLoader != "function" && e.props.optionsLoadingCounter === 0) {
      e.props.optionsLoaded = !0;
      const n = Mh(e);
      n instanceof Promise && n.then(() => {
        eg(e);
      });
    }
    typeof e.props.optionLoader != "function" || e.props.optionRemoved || function(n, i) {
      if (n === i) return !0;
      if (n == null || i == null || n.length !== i.length) return !1;
      for (let r = 0; r < n.length; ++r) if (n[r] !== i[r]) return !1;
      return !0;
    }(t, e.props.inputStd) ? e.props.optionsLoadingCounter === 0 && eg(e) : (t = e.props.inputStd, async function(n) {
      const i = i$(n);
      if ((n.props.inputStd.length > 1 ? n.props.inputStd.filter((c) => !n.props.memoOptions.find((d) => vn(Nt(d), c))) : n.props.inputStd).forEach((c) => {
        YL(n, c, Array.isArray(i) && i.find((d) => vn(Nt(d), c) && !d.noOptionFound));
      }), n.props.optionLoadingCounter) {
        const c = n.on("prop:optionLoadingCounter", () => {
          eg(n), n.props.optionLoadingCounter || n.off(c);
        });
      } else eg(n);
    }(e));
  });
}
const Vf = /* @__PURE__ */ new WeakSet();
function f1e(e) {
  if (!bo) return;
  e.props.positionListBox = (function(d, a) {
    var f, g;
    let x = null;
    if (d.props.activeDescendant && (x = d.props.options.filter((I) => {
      var O;
      return !(!((O = I.attrs) === null || O === void 0) && O.disabled);
    }).findIndex((I) => vn(d.value, Nt(I))), x === -1 && (x = null), !((f = d.props.__root) === null || f === void 0) && f.getElementById(d.props.activeDescendant) && kT(d)), typeof window > "u") return x;
    const $ = a.getBoundingClientRect(), A = (g = d.props.__root) === null || g === void 0 ? void 0 : g.getElementById(`${d.props.id}`);
    if (A) {
      const I = A.getBoundingClientRect();
      I.top + I.height + $.height > window.innerHeight && I.top + I.height > $.height ? (d.props.invertPopover = !0, d.props.usePopover || (d.props.dropdownWrapperStyles = { ...d.props.dropdownWrapperStyles, top: "auto", bottom: "100%" })) : d.props.usePopover || (d.props.dropdownWrapperStyles = { ...d.props.dropdownWrapperStyles, bottom: "auto", top: "100%" });
    }
    return x;
  }).bind(null, e), e.props.styleWrapper = m1e.bind(null), e.on("mounted", () => {
    Pr(`${e.props.id}_popover`, i.bind(null, e), e.props.__root);
  });
  const t = (d) => {
    var a;
    e.props.mouseX = d.clientX, e.props.mouseY = d.clientY;
    const f = (a = e.props.__root) === null || a === void 0 ? void 0 : a.getElementById(`${e.props.id}_popover`);
    if (f) {
      const g = f.getBoundingClientRect();
      d.clientX > g.x && d.clientX < g.x + g.width && d.clientY > g.y && d.clientY < g.y + g.height && (e.props.trackHover = !0);
    }
  }, n = () => {
    e.props.ignoreScroll ? e.props.ignoreScroll = !1 : e.props.trackHover = !0;
  };
  function i(d, a) {
    d.props.behavior !== "overscroll" && getComputedStyle(a).maxHeight === "none" && (d.props.dropdownWrapperStyles = { ...d.props.dropdownWrapperStyles, maxHeight: "400px" }), new MutationObserver((g) => {
      const x = g[0].target;
      if (d.props.behavior === "overscroll" && x.id !== `${d.props.id}_popover`) return;
      const $ = d.props.positionListBox(a);
      Vf.delete(d), r(d, $);
      let A, I = null;
      const O = new ResizeObserver(() => {
        clearTimeout(A), A = setTimeout(() => {
          d.props.styleWrapper(), d.props.positionListBox(a), I || (I = d.on("prop:expanded", () => {
            O.disconnect(), d.off(I);
          }));
        });
      });
      O.observe(a);
    }).observe(a, { childList: !0, subtree: !0 });
  }
  function r(d, a) {
    var f;
    if (!d.props.expanded || !d.props.options || !d.props.options.length || Vf.has(d)) return;
    const g = d.props.options.reduce(($, A, I) => {
      var O, B, H;
      if (!((O = A.attrs) === null || O === void 0) && O.disabled) return $;
      if ("group" in A && (!((B = A.options) === null || B === void 0) && B.length)) return A.options.forEach((K, U) => {
        var q;
        const ee = (q = d.props.__root) === null || q === void 0 ? void 0 : q.getElementById(`${d.props.id}_listitem_${I}_${U}`);
        ee && $.push([ee, K]);
      }), $;
      const N = (H = d.props.__root) === null || H === void 0 ? void 0 : H.getElementById(`${d.props.id}_listitem_${I}`);
      return N && $.push([N, A]), $;
    }, []), x = (f = d.props.__root) === null || f === void 0 ? void 0 : f.getElementById(`${d.props.id}_load_more`);
    x && g.push([x, d.props.loadMoreOption]), Vf.add(d), g.length && c(d, g, a);
  }
  function c(d, a, f) {
    var g, x, $, A;
    const I = (g = d.props.__root) === null || g === void 0 ? void 0 : g.getElementById(`${d.props.id}_popover`);
    if (d.props.trackHover) {
      const O = I ? I.getBoundingClientRect() : { top: 0, bottom: 0 };
      if (f = null, d.props.mouseY > O.top && d.props.mouseY < O.bottom) {
        let B = f || 0, H = f;
        const N = (K, U) => {
          var q;
          const ee = U[0], { y: te, height: ae, x: oe, width: de } = ee.getBoundingClientRect();
          if (d.props.mouseX > oe && d.props.mouseX < oe + de && d.props.mouseY > te && d.props.mouseY < te + ae) {
            f = K;
            const me = U[1];
            return me && !(!((q = me.attrs) === null || q === void 0) && q.disabled) ? d.props.activeValue = Nt(me) : d.props.activeValue = void 0, !0;
          }
          return !1;
        };
        do {
          if (B !== null && N(B, a[B]) || H !== null && N(H, a[H])) break;
          B !== null && (B++, B > a.length - 1 && (B = null)), H !== null && (H--, H < 0 && (H = null));
        } while (B !== null || H !== null);
      }
      f === null && (d.props.activeValue = void 0);
    }
    d.props.trackHover || kT(d), d.props.expanded ? (I && d.props.loadOnScroll && !(!((x = d.store.loading) === null || x === void 0) && x.value) && (!(($ = d.store.hasNextPage) === null || $ === void 0) && $.value) && I.scrollTop + I.offsetHeight > I.scrollHeight - 200 && ((A = d.context) === null || A === void 0 || A.handlers.loadMore(!0)), Vf.has(d) ? requestAnimationFrame(c.bind(null, d, a, f)) : r(d, f)) : Vf.delete(d);
  }
  e.on("prop:trackHover", ({ payload: d }) => {
    var a, f, g;
    bo && (d ? (g = (f = e.props.__root) === null || f === void 0 ? void 0 : f.getElementById(`${e.props.id}_popover`)) === null || g === void 0 || g.removeEventListener("scroll", n) : (a = e.props.__root) === null || a === void 0 || a.getElementById(`${e.props.id}_popover`));
  }), e.on("prop:expanded", ({ payload: d }) => {
    e.props.dropdownWrapperStyles = { ...e.props.dropdownWrapperStyles, zIndex: d || e.props.forceExpanded ? "999" : "-1", pointerEvents: d ? "auto" : "none" }, d ? (document.addEventListener("mousemove", t), e.props.styleWrapper(), r$(e)) : document.removeEventListener("mousemove", t);
  }), e.on("prop:trackHover", ({ payload: d }) => {
    var a, f;
    bo && (d ? (f = document.getElementById(`${e.props.id}_popover`)) === null || f === void 0 || f.removeEventListener("scroll", n) : (a = document.getElementById(`${e.props.id}_popover`)) === null || a === void 0 || a.addEventListener("scroll", n));
  }), e.on("prop:activeValue", ({ payload: d }) => {
    if (d === tf) return void (e.props.activeDescendant = `${e.props.id}_load_more`);
    let a, f = -1;
    for (let g = 0; g < e.props.options.length; g++) {
      if ("group" in e.props.options[g]) {
        for (let x = 0; x < e.props.options[g].options.length; x++) if (vn(Nt(e.props.options[g].options[x]), d)) {
          f = x, a = g;
          break;
        }
      }
      if (vn(Nt(e.props.options[g]), d)) {
        f = g;
        break;
      }
    }
    e.props.activeDescendant = f < 0 ? void 0 : a === void 0 ? `${e.props.id}_listitem_${f}` : `${e.props.id}_listitem_${a}_${f}`;
  });
}
function kT(e) {
  var t, n;
  if (!bo) return;
  const i = (t = e.props.__root) === null || t === void 0 ? void 0 : t.getElementById(`${e.props.id}_popover`), r = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(e.props.activeDescendant);
  if (!i || !r) return;
  const { y: c, height: d } = r.getBoundingClientRect(), { y: a, height: f } = i.getBoundingClientRect();
  c < a ? (e.props.ignoreScroll = !0, i.scrollTop = r.offsetTop) : c + d > a + f && (e.props.ignoreScroll = !0, i.scrollTop = r.offsetTop + d - f);
}
function m1e() {
}
const e1 = /* @__PURE__ */ new WeakMap();
function v1e(e) {
  e.on("created", () => {
    if (!e.context || !bo) return;
    e.context.fns.isActive = p1e.bind(null, e), e.context.fns.isSelected = (n) => Qw(e, n), e.context.fns.hasOptionLoaderValue = (n) => {
      for (const i of e.props.optionLoaderValues) if (vn(Nt(n), i)) return !0;
      return !1;
    }, e.context.handlers.listitemGroupClick = k1e, e.context.handlers.selectOption = (n) => (i) => S1e.call(null, e, n, i), e.context.handlers.loadMore = Fy.bind(null, e), e.context.handlers.removeSelection = (n) => (i) => ST(e, n, i), e.context.handlers.tagTouchstart = (n) => (i) => ST(e, n, i), e.context.handlers.selectionClick = (n) => e.props.multiple ? b1e.bind(null, e, n) : _1e.bind(null, e), e.context.handlers.selectionBlur = () => w1e.bind(null, e), e.context.fns.isActiveSelection = (n, i) => vn(n, Nt(i)), e.context.handlers.tagClick = (n) => x1e.bind(null, e, n), e.context.handlers.tagFocus = (n) => $1e.bind(null, e, n), e.context.handlers.tagBlur = () => C1e.bind(null, e);
    const t = e.context.handlers.blur;
    e.context.handlers.blur = (function(n, i) {
      var r;
      if (i && i.relatedTarget instanceof HTMLElement) {
        const c = (r = n.props.__root) === null || r === void 0 ? void 0 : r.getElementById(n.props.id + "_inner");
        if (c instanceof HTMLElement && c.contains(i.relatedTarget)) return;
      }
      t(), function(c) {
        c.props.disabled || (c.props.expanded = !1, c.props.activeSelectionValue = void 0, c.emit("blur"));
      }(n);
    }).bind(null, e), e.context.handlers.touchmove = g1e.bind(null, e), e.context.handlers.touchend = y1e.bind(null, e);
  });
}
function g1e(e, t) {
  var n;
  const i = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${e.props.id}`);
  if (i instanceof HTMLInputElement) {
    const r = e1.get(e);
    if (r) {
      const [c, d] = r, a = t.touches[0].clientX - d;
      i.scrollLeft = c - a;
    } else e1.set(e, [i.scrollLeft, t.changedTouches[0].clientX]);
  }
}
function y1e(e) {
  e1.delete(e);
}
function _1e(e, t) {
  e.props.disabled || ((!e.props.expanded && e.props.openOnClick || e.props.openOnFocus) && (e.props.expanded = !0), t.currentTarget instanceof HTMLElement && t.currentTarget.focus());
}
function b1e(e, t, n) {
  n.currentTarget instanceof HTMLElement && (vn(e.props.activeSelectionValue, Nt(t)) ? e.props.activeSelectionValue = void 0 : (e.props.activeSelectionValue = Nt(t), n.currentTarget.focus()));
}
function w1e(e, t) {
  var n;
  if (t.relatedTarget instanceof HTMLElement) {
    const i = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(e.props.id + "_inner");
    if (i instanceof HTMLElement && i.contains(t.relatedTarget)) return;
  }
  e.props.activeSelectionValue = void 0;
}
function x1e(e, t, n) {
  n.stopPropagation(), e.props.disabled || (e.props.justFocused ? e.props.justFocused = !1 : n.currentTarget instanceof HTMLElement && (vn(e.props.activeSelectionValue, Nt(t)) ? e.props.activeSelectionValue = void 0 : (e.props.activeSelectionValue = Nt(t), n.currentTarget.focus())));
}
function $1e(e, t, n) {
  n.stopPropagation(), e.props.disabled || n.currentTarget instanceof HTMLElement && (e.props.activeSelectionValue = Nt(t), e.props.justFocused = !0);
}
function C1e(e, t) {
  var n;
  if (t.relatedTarget instanceof HTMLElement) {
    const i = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(e.props.id + "_inner");
    if (i instanceof HTMLElement && i.contains(t.relatedTarget)) return;
  }
  e.props.activeSelectionValue = void 0;
}
function ST(e, t, n) {
  n && n.stopPropagation(), e.props.disabled || (e.props.userAction = { type: "handleRemoveSelection" }, C_(e, t));
}
function k1e(e) {
  e.stopPropagation();
}
function S1e(e, t, n) {
  n.stopPropagation(), e.props.disabled || (e.props.userAction = { type: "handleListitemClick" }, s$(e, t));
}
function o$(e, t, n, i) {
  (function(r) {
    r.addProps(["options", "expanded", "placeholder", "multiple", "selections", "activeValue", "activeDescendant", "forceExpanded", "optionLoader", "showEmptyMessage", "emptyMessage", "option", "listboxStyles", "invertPopover", "dropdownWrapperStyles", "optionsLoader", "loadMoreOption", "hasNextPage", "page", "behavior", "selectionRemovable", "openOnRemove", "clearOnClick", "openOnClick", "hideOnOpen", "closeOnSelect", "openOnFocus", "selectionAppearance", "optionsAppearance", "filter", "inputText", "formattedSelections", "lastVisibleIndex", "optionLoaderValues", "disabledInternally", "isLoadingOption", "isLoadingOptions", "thereIsAnOptionSelected", "formattedSelections", "activeSelections", "allowNewValues", "inputStd", "isSingleOption", "max", "disableDragAndDrop", "clearSearchOnOpen", "firstSelectionLabel", "memoOptions", "loadOnCreated", "alwaysLoadOnOpen", "showFormattedSelections", "truncationCount", "reloadOnCommit", "activeSelectionValue", "setForceExpanded", "option", "loadOnScroll", "optionsLoadingCounter", "optionLoadingCounter", "draggable", "deselect"]), r.props.deselect === void 0 ? r.props.deselect = !0 : r.props.deselect = on(r.props.deselect), r.props.option = {}, r.props.expanded = !1, r.props.inputStd = [], r.props.draggable === void 0 ? r.props.draggable = !0 : r.props.draggable === "false" && (r.props.draggable = !1), r.props.options || (Vu(350, { node: r, inputType: r.props.type }), r.props.options = []), "disabled" in r.props && (r.props.disabled = on(r.props.disabled)), r.props.allOptions = Jw(r.props.options), r.props.selections = [], r.props.memoOptions = [], r.props.invertPopover = !1, r.props.dropdownWrapperStyles = { position: "absolute", top: "100%", overflow: "auto", minWidth: "100%" }, r.props.decrementCount = 0, r.props.page = 1, r.props.loadMoreOption = { label: "Load more", value: tf }, r.props.loadOptions = Mh, r.props.listboxStyles = {}, r.props.optionsLoadingCounter = 0, r.props.optionLoadingCounter = 0, r.props.searchable = on(r.props.searchable), r.props.loadOnScroll = on(r.props.loadOnScroll), r.props.multiple = on(r.props.multiple) || !1, r.props.type === "taglist" && (r.props.multiple = !0), r.props.openOnFocus = on(r.props.openOnFocus), r.props.openOnRemove = r.props.openOnRemove !== void 0 && on(r.props.openOnRemove), r.props.hasNextPage = KL.bind(null, r), r.props.initialOptions = [...r.props.options], r.props.optionLoaderValues = [], r.props.loadOnCreated = on(r.props.loadOnCreated), r.props.max && typeof r.props.max != "number" ? r.props.max = parseInt(r.props.max) : r.props.max && !r.props.multiple && (r.props.max = void 0), r.on("mounted", () => CT(r)), r.on("prop:popoverCoordinates", () => setTimeout(() => {
      CT(r);
    }, 10));
  })(i), i.props.multiple ? function(r) {
    r.hook.input((c, d) => (r.props.highlightedRange && !r.props.optionRemoved && (c.splice(r.props.highlightedRange.index, 1, Nt(r.props.option)), c = c.filter((a) => a !== void 0)), r.props.inputStd = c && Array.isArray(c) ? [...new Set(c)] : [], d(c === void 0 ? void 0 : [...r.props.inputStd])));
  }(i) : function(r) {
    r.hook.input((c, d) => (r.props.inputStd = c === void 0 || c === "" || c === null ? [] : [c], d(c)));
  }(i), e(i), h1e(i), function(r) {
    r.on("created", () => {
      r.context && (r.props.trackHover = !0, r.props.disabled !== void 0 || r.props.optionsLoader || !r.props.options || r.props.options.length || r.props.emptyMessage !== void 0 || r.props.allowNewValues || r.props.inputStd.length !== 0 || (r.props.disabledInternally = !0), f1e(r), r.props.loadOnCreated && !r.props.optionsLoaded && r.props.optionsLoader ? Mh(r) : r.props.optionsLoaded && (r.props.optionsLoaded = !1), r.props.forceExpanded = on(r.props.forceExpanded), r.props.forceExpanded && (r.props.dropdownWrapperStyles = { ...r.props.dropdownWrapperStyles, zIndex: "999", pointerEvents: "auto" }, setTimeout(() => {
        r.props.setForceExpanded = !0;
      }, 100)));
    });
  }(i), v1e(i), t(i), function(r) {
    r.on("prop:selections", ({ payload: d }) => {
      r.props.max && (r.props.maxReached = d.length >= r.props.max);
    }), r.on("prop:maxReached", ({ payload: d }) => {
      d && (r.props.expanded = !1);
    }), r.on("prop:optionsLoadingCounter", ({ payload: d }) => {
      d === 0 && (r.props.emptyMessage && (r.props.showEmptyMessage = !r.props.options.length), r.props.optionLoadingCounter === 0 && r.store.set(Dm));
    }), r.on("prop:optionLoadingCounter", ({ payload: d }) => {
      d === 0 && r.props.optionsLoadingCounter === 0 && r.store.set(Dm);
    }), r.on("prop:disabled", ({ payload: d }) => {
      d && (r.props.expanded = !1);
    }), r.on("prop:options", ({ payload: d }) => {
      r.props.allOptions = Jw(r.props.options), r.props.emptyMessage && typeof r.props.optionsLoader != "function" && (r.props.showEmptyMessage = !d.length), d.length ? r.props.disabledInternally = !1 : d.length || r.props.optionsLoader || r.props.emptyMessage !== void 0 || r.props.allowNewValues || r.props.inputStd.length !== 0 || r.props.searchValue || (r.props.disabledInternally = !0), r$(r);
    }), r.on("prop:expanded", ({ payload: d }) => {
      var a;
      if (bo) if (r.props.alwaysLoadOnOpen && (r.props.page = 1), d) {
        if (r.props.trackHover = !1, r.props.options && !r.props.options.length && typeof r.props.optionsLoader != "function" && r.props.emptyMessage && (r.props.showEmptyMessage = !0), setTimeout(() => document.addEventListener("click", c), 10), r.props.selectionAppearance === "text-input" && r.props.multiple) return;
        const f = (a = r.props.__root) === null || a === void 0 ? void 0 : a.getElementById(`${r.props.id}`);
        f instanceof HTMLInputElement && (f.focus(), r.props.searchExpand || (f.value = "", f.value = r.props.inputText));
      } else document.removeEventListener("click", c), r.props.trackHover = !1, r.props.showEmptyMessage = !1;
    });
    const c = () => {
      r.props.activeSelectionValue = void 0, r.props.expanded = !1;
    };
  }(i), n(i);
}
function T1e(e) {
  e.props.closeOnSelect === void 0 ? e.props.closeOnSelect = !e.props.multiple : e.props.closeOnSelect = on(e.props.closeOnSelect), (e.props.multiple && e.props.selectionAppearance === void 0 || e.props.selectionAppearance === "truncate") && (e.props.selectionAppearance = "truncate", e.props.formattedSelections = []), e.props.multiple ? e.props.selectionRemovable = !1 : e.props.selectionRemovable = on(e.props.selectionRemovable);
}
function JL(e) {
  var t, n;
  e.props.searchValue || (n = (t = e.props.__root) === null || t === void 0 ? void 0 : t.getElementById(`${e.props.id}_tag-wrapper_${e.props.selections.length - 1}`)) === null || n === void 0 || n.focus();
}
function QL(e, t, n) {
  var i, r, c;
  if (n.preventDefault(), e.props.trackHover = !1, e.props.expanded) {
    const d = e.props.allOptions.reduce((f, g) => {
      var x;
      return !((x = g == null ? void 0 : g.attrs) === null || x === void 0) && x.disabled || f.push(Nt(g)), f;
    }, []);
    !((i = e.store.hasNextPage) === null || i === void 0) && i.value && d.push(tf);
    let a = -1;
    e.props.activeValue && (a = d.findIndex((f) => vn(f, e.props.activeValue))), a === -1 && d.length ? e.props.activeValue = d[0] : t === "ArrowDown" && d.length > a + 1 ? e.props.activeValue = d[a + 1] : t === "ArrowUp" && a > 0 ? e.props.activeValue = d[a - 1] : t === "ArrowUp" && a === 0 && ((c = (r = e.props.__root) === null || r === void 0 ? void 0 : r.getElementById(`${e.props.id}_tag-wrapper_${e.props.selections.length - 1}`)) === null || c === void 0 || c.focus(), e.props.expanded = !1);
  } else e.props.expanded || t !== "ArrowDown" || (e.props.expanded = !0);
}
function e3(e, t) {
  var n, i, r;
  if ((e.props.type === "taglist" || e.props.selectionAppearance === "tags") && e.props.inputStd.length && !e.props.inputText) {
    if (t === "ArrowLeft") return e.props.selections.length && ((i = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${e.props.id}_tag-wrapper_${e.props.selections.length - 1}`)) === null || i === void 0 || i.focus(), e.props.selections[e.props.selections.length - 1] ? e.props.activeSelectionValue = Nt(e.props.selections[e.props.selections.length - 1]) : e.props.activeSelectionValue = void 0), void (e.props.expanded = !1);
    t === "ArrowRight" && ((r = document.getElementById(`${e.props.id}_tag-wrapper_0`)) === null || r === void 0 || r.focus(), e.props.selections[0] ? e.props.activeSelectionValue = Nt(e.props.selections[0]) : e.props.activeSelectionValue = void 0), e.props.expanded = !1;
  }
}
function t3(e) {
  var t, n;
  e.props.expanded = !0, (n = (t = e.props.__root) === null || t === void 0 ? void 0 : t.getElementById(`${e.props.id}`)) === null || n === void 0 || n.focus();
}
function n3(e, t, n, i = !0) {
  var r, c, d, a, f, g, x;
  const $ = n.key;
  if (n.altKey) {
    const A = zd(), I = e.props.selections.findIndex((B) => vn(Nt(B), Nt(t))), O = [...e.props.selections];
    n.key === "ArrowRight" ? I < e.props.selections.length - 1 && (O.splice(I, 1), O.splice(I + 1, 0, t)) : n.key === "ArrowLeft" && I > 0 && (O.splice(I, 1), O.splice(I - 1, 0, t)), e.props.activeSelectionValue = Nt(t), e.input([...O.map(Nt)]), setTimeout(() => {
      A instanceof HTMLElement && A.focus();
    }, 100);
  } else {
    const A = e.props.selections.findIndex((B) => vn(Nt(B), Nt(t)));
    if (A === -1) return;
    const I = $ === "ArrowRight" ? A + 1 : A - 1;
    if (I >= e.props.selections.length) {
      if (!i) return e.props.expanded = !0, e.props.activeSelectionValue = void 0, void ((c = (r = e.props.__root) === null || r === void 0 ? void 0 : r.getElementById(`${e.props.id}`)) === null || c === void 0 || c.focus());
      (a = (d = e.props.__root) === null || d === void 0 ? void 0 : d.getElementById(`${e.props.id}`)) === null || a === void 0 || a.focus();
    } else if (I < 0 && A === 0) (g = (f = e.props.__root) === null || f === void 0 ? void 0 : f.getElementById(`${e.props.id}`)) === null || g === void 0 || g.focus();
    else if (I < 0) return;
    const O = (x = e.props.__root) === null || x === void 0 ? void 0 : x.getElementById(`${e.props.id}_tag-wrapper_${I}`);
    O && O.focus(), e.props.selections[I] ? e.props.activeSelectionValue = Nt(e.props.selections[I]) : e.props.activeSelectionValue = void 0;
  }
}
function i3(e, t, n) {
  var i;
  if (!(n.currentTarget instanceof HTMLElement) || e.props.searchValue) return;
  const r = e.props.selections.findIndex((a) => vn(Nt(a), Nt(t)));
  if (r === -1) return;
  const c = e.props.selections[r + 1] ? r + 1 : r - 1, d = (i = e.props.__root) === null || i === void 0 ? void 0 : i.getElementById(`${e.props.id}_tag-wrapper_${c}`);
  d && d.focus(), e.props.userAction = { type: "tagDelete" }, C_(e, t);
}
function r3(e, t) {
  var n;
  if (t.preventDefault(), e.props.allowNewValues && e.props.searchValue && e.input(XL(e, e.props.searchValue)), e.props.expanded) {
    if (e.props.activeValue === tf) return void ((n = e.context) === null || n === void 0 || n.handlers.loadMore(!0));
    const i = e.props.allOptions.find((r) => vn(Nt(r), e.props.activeValue));
    if (!i) return;
    s$(e, i);
  } else e.props.expanded = !0;
}
function s3(e) {
  e.props.expanded && (e.props.expanded = !1);
}
function I1e(e, t, n) {
  if (n.stopPropagation(), !e.props.disabled)
    switch (n.key) {
      case "ArrowDown":
        t3(e);
        break;
      case "ArrowRight":
      case "ArrowLeft":
        n3(e, t, n, !1);
        break;
      case "Delete":
      case "Backspace":
        i3(e, t, n);
    }
}
function A1e(e, t, n) {
  if (!e.props.disabled)
    switch (n.key) {
      case "ArrowUp":
      case "ArrowDown":
        (function(i, r, c) {
          var d, a, f, g;
          c.preventDefault();
          const x = c.key, $ = i.props.selections.findIndex((O) => vn(Nt(O), Nt(r)));
          if ($ === -1) return;
          const A = x === "ArrowDown" ? $ + 1 : $ - 1;
          if (A < 0 && ((a = (d = i.props.__root) === null || d === void 0 ? void 0 : d.getElementById(`${i.props.id}`)) === null || a === void 0 || a.focus()), A < 0 || A >= i.props.selections.length) return;
          const I = (f = i.props.__root) === null || f === void 0 ? void 0 : f.getElementById(`${i.props.id}_selection_wrapper_${A}`);
          I && I.focus(), i.props.activeSelectionValue = ((g = i.props.selections[A]) === null || g === void 0 ? void 0 : g.value) || void 0;
        })(e, t, n);
        break;
      case "Enter":
        break;
      case "Tab":
        (function(i, r, c) {
          var d, a, f, g;
          if (r) {
            const x = i.props.selections.findIndex((I) => vn(Nt(I), Nt(r)));
            if (x === -1) return;
            const $ = c.shiftKey ? x - 1 : x + 1;
            if ($ >= i.props.selections.length) return;
            if ($ < 0) return void ((a = (d = i.props.__root) === null || d === void 0 ? void 0 : d.getElementById(`${i.props.id}`)) === null || a === void 0 || a.focus());
            const A = (f = i.props.__root) === null || f === void 0 ? void 0 : f.getElementById(`${i.props.id}_selection_wrapper_${$}`);
            A && A.focus(), i.props.activeSelectionValue = ((g = i.props.selections[$]) === null || g === void 0 ? void 0 : g.value) || void 0;
          }
        })(e, t, n);
        break;
      case "Delete":
      case "Backspace":
        (function(i, r) {
          var c;
          if (r) {
            const d = i.props.selections.findIndex((g) => vn(Nt(g), Nt(r)));
            if (d === -1) return;
            const a = i.props.selections[d + 1] ? d + 1 : d - 1, f = (c = i.props.__root) === null || c === void 0 ? void 0 : c.getElementById(`${i.props.id}_selection_wrapper_${a}`);
            f && f.focus(), i.props.selections[a] ? i.props.activeSelectionValue = Nt(i.props.selections[a]) : i.props.activeSelectionValue = void 0;
          }
          r && i.props.selections.length !== 1 || (i.props.userAction = { type: "selectionDelete" }), C_(i, r);
        })(e, t);
    }
}
function E1e(e, t) {
  if (e.props.disabled || !(t.currentTarget instanceof HTMLElement) || e.props.id !== t.currentTarget.id) return;
  const n = t.key;
  switch (n) {
    case "Tab":
      (function(i) {
        i.props.expanded && (i.props.expanded = !1);
      })(e);
      break;
    case "ArrowUp":
    case "ArrowDown":
      QL(e, n, t);
      break;
    case "ArrowLeft":
    case "ArrowRight":
      e3(e, n);
      break;
    case "Enter":
      r3(e, t);
      break;
    case "Escape":
      s3(e);
      break;
    case "Delete":
    case "Backspace":
      JL(e);
      break;
    default:
      e.emit("unusedKeydown", t);
  }
}
function P1e(e, t) {
  if (e.props.disabled || !(t.currentTarget instanceof HTMLElement) || e.props.id !== t.currentTarget.id) return;
  const n = t.key;
  switch (n) {
    case "Tab":
      (function(i, r) {
        var c, d, a;
        i.props.expanded = !1, i.props.multiple && i.props.selections.length && i.props.type === "autocomplete" && i.props.selectionAppearance === "option" && (r.preventDefault(), (d = (c = i.props.__root) === null || c === void 0 ? void 0 : c.getElementById(`${i.props.id}_selection_wrapper_0`)) === null || d === void 0 || d.focus(), i.props.activeSelectionValue = ((a = i.props.selections[0]) === null || a === void 0 ? void 0 : a.value) || void 0);
      })(e, t);
      break;
    case "ArrowUp":
    case "ArrowDown":
      QL(e, n, t);
      break;
    case "ArrowRight":
    case "ArrowLeft":
      e3(e, n);
      break;
    case "Enter":
      r3(e, t);
      break;
    case "Escape":
      s3(e);
      break;
    case "Delete":
    case "Backspace":
      JL(e);
  }
}
function M1e(e) {
  e.props.alwaysLoadOnOpen = e.props.alwaysLoadOnOpen !== void 0 && on(e.props.alwaysLoadOnOpen), e.on("created", () => {
    e.context && (e.context.handlers.click = D1e.bind(null, e), e.context.handlers.focus = L1e.bind(null, e), e.context.handlers.keydown = E1e.bind(null, e), e.context.handlers.selectorTagKeydownHandler = (t) => I1e.bind(null, e, t));
  });
}
function D1e(e, t) {
  var n;
  if (t.stopPropagation(), t.detail === 0 || e.props.disabled) return;
  e.props.attrs.onClick && e.props.attrs.onClick(t);
  const i = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${e.props.id}`);
  e.props.justOpened ? e.props.justOpened = !1 : e.props.expanded ? e.props.expanded = !1 : (i && t.pointerType !== "mouse" ? (e.props.mouseX = -1, e.props.mouseY = -1) : (e.props.mouseX = t.clientX, e.props.mouseY = t.clientY), e.props.expanded = !0, i == null || i.focus());
}
function L1e(e) {
  e.props.disabled || (e.props.attrs.onFocus && e.props.attrs.onFocus(), e.props.skipOpen ? e.props.skipOpen = !1 : e.props.openOnFocus && (e.props.justOpened = !0, e.props.expanded = !0));
}
function O1e(e) {
  let t, n = "";
  e.on("unusedKeydown", ({ payload: i }) => {
    if (!i.isComposing && [...i.key].length === 1) {
      if (!n && i.key === " ") return void function(c, d) {
        var a;
        if (d.preventDefault(), c.props.expanded) {
          if (c.props.activeValue === tf) return void ((a = c.context) === null || a === void 0 || a.handlers.loadMore());
          const f = c.props.allOptions.find((g) => vn(Nt(g), c.props.activeValue));
          if (!f) return;
          s$(c, f);
        } else c.props.expanded = !0;
      }(e, i);
      e.props.expanded = !0, clearTimeout(t), n += i.key;
      const r = e.props.allOptions.find((c) => c.label.toLowerCase().startsWith(n.toLowerCase()));
      r && (e.props.activeValue = Nt(r)), t = setTimeout(() => {
        n = "";
      }, 400);
    }
  });
}
function TT(e) {
  Ry(e), e.on("prop:selections", () => {
    e.props.skipFormatSelections = !1, Ry(e);
  }), bo && Pr(`${e.props.id}_selections`, N1e.bind(null, e), e.props.__root);
}
function Ry(e) {
  e.isCreated && (e.props.selections.length && e.props.lastVisibleIndex && e.props.selections.length - e.props.lastVisibleIndex > 1 ? e.props.truncationCount = "+ " + (e.props.selections.length - e.props.lastVisibleIndex - 1).toString() : e.props.truncationCount = void 0, e.props.formattedSelections = e.props.selections.map((t, n) => e.props.lastVisibleIndex && n === e.props.lastVisibleIndex && n !== 0 ? e.props.lastTruncatedElText && n === e.props.selections.length - 1 ? e.props.lastTruncatedElText : n === e.props.selections.length - 1 ? t.label : t.label + "..." : n === e.props.selections.length - 1 ? t.label : t.label + ", "));
}
function IT(e) {
  var t, n;
  if (!bo || !e.context) return;
  const i = (t = e.props.__root) === null || t === void 0 ? void 0 : t.getElementById(`${e.props.id}_selections`);
  if (!(i instanceof HTMLElement)) return;
  const r = i.parentNode;
  if (!(r instanceof HTMLElement)) return;
  let c = i.getBoundingClientRect().width;
  const d = 0.98 * r.getBoundingClientRect().width, a = Array.prototype.slice.call(i.children), f = [...e.props.selections];
  if (c > d) {
    const g = [];
    let x = 0;
    for (let $ = 0; $ < f.length; $++) g.push([f[$], a[$]]);
    for (let $ = g.length - 1; $ >= 0; $--) {
      const A = g[$];
      if (!(A[1] instanceof HTMLElement)) return;
      x += A[1].getBoundingClientRect().width + parseFloat(window.getComputedStyle(A[1]).marginRight) + parseFloat(window.getComputedStyle(A[1]).marginLeft);
      const I = c - x;
      if (d > I) {
        const O = A[0].label;
        e.props.skipFormatSelections = !0, A[1].textContent = O;
        let B = !1;
        for (let H = O.length; H >= 0; H--) {
          if (e.props.skipFormatSelections = !0, A[1].textContent = O.slice(0, H).trim() + "...", I + A[1].getBoundingClientRect().width < d) {
            if (H < 4) {
              e.props.lastVisibleIndex = $ - 1, e.props.lastTruncatedElText = null;
              break;
            }
            if (e.props.lastVisibleIndex = $, e.props.lastTruncatedElText && A[1].textContent.slice(0, 4) === e.props.lastTruncatedElText.slice(0, 4)) break;
            e.props.lastTruncatedElText = (n = A[1]) === null || n === void 0 ? void 0 : n.textContent;
            break;
          }
          H === 0 && (B = !0);
        }
        A[1].textContent = e.props.lastTruncatedElText && !B && $ !== 0 ? e.props.lastTruncatedElText : O, e.props.lastVisibleIndex === null && (e.props.lastVisibleIndex = $ === 0 ? 0 : $ - 1, e.props.lastTruncatedElText = null), setTimeout(() => {
          Ry(e);
        });
        break;
      }
    }
  } else e.props.lastTruncatedElText = null, e.props.lastVisibleIndex = null, Ry(e);
}
function N1e(e, t) {
  const n = new ResizeObserver(() => {
    e.props.selections && e.props.selections.length !== 0 && (e.props.skipFormatSelections ? e.props.skipFormatSelections = !1 : IT(e));
  }), i = new ResizeObserver(() => {
    IT(e);
  });
  n.observe(t), t.parentNode instanceof Element && i.observe(t.parentNode);
}
const F1e = { position: "fixed", top: 0, bottom: 0, right: 0, left: 0, pointerEvents: "none", zIndex: -1, overflowY: "auto", "-webkit-overflow-scrolling": "auto" }, N0 = { position: "fixed", overflow: "hidden", height: "100%", width: "100%" }, F0 = { overflow: "hidden", height: "100%" }, AT = {}, ET = {};
let R0 = 0;
function R1e(e) {
  var t, n;
  if (typeof window > "u") return;
  const i = (t = e.props.__root) === null || t === void 0 ? void 0 : t.getElementById(`${e.props.id}_popover`), r = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${e.props.id}`);
  if (!r || !i) return;
  const c = i.style.paddingTop, d = i.style.paddingBottom, a = i.style.paddingLeft;
  i.style.paddingTop = "0", i.style.paddingBottom = "0", i.style.paddingLeft = "0";
  const f = r.getBoundingClientRect(), g = i.getBoundingClientRect(), x = Math.round(f.top - g.top) + "px", $ = Math.round(f.left - g.left - 5) + "px", A = Math.max(Math.round(Math.min(g.height - g.top, window.innerHeight) - (f.top + f.height)), 0) + "px";
  i.style.paddingTop = c, i.style.paddingBottom = d, i.style.paddingLeft = a, e.props.dropdownWrapperStyles = { ...e.props.dropdownWrapperStyles, paddingTop: x, paddingLeft: $, paddingBottom: A }, e.props.listboxStyles = { ...e.props.listboxStyles, minWidth: e.props.behavior === "overscroll" ? `min(${f.width + "px"}, calc(100vw - 4em))` : f.width + "px", maxWidth: "calc(100vw - 4em)" };
}
function z1e(e, t) {
  var n, i;
  let r = null;
  if (e.props.activeDescendant) {
    const c = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(e.props.activeDescendant);
    if (!c) return r;
    e.props.ignoreScroll = !0;
    const d = (i = e.props.__root) === null || i === void 0 ? void 0 : i.getElementById(`${e.props.id}_listbox`);
    if (!d) return r;
    const a = t.getBoundingClientRect(), f = d.getBoundingClientRect(), g = parseInt(getComputedStyle(t).paddingTop), x = parseInt(getComputedStyle(t).paddingBottom), $ = c.offsetTop - g, A = Math.max($ - g, 0), I = Math.max(t.scrollHeight - x - $ - a.height, 0), O = f.height - A - I;
    t.scrollTop = $;
    const B = () => {
      t.scrollTop = I > 0 ? I < g ? t.scrollHeight : g : A < x ? 0 : $ - x;
    }, H = Math.min(150, f.height);
    A > 0 && I > 0 || A === 0 && I === 0 || O > H ? t.scrollTop = $ : B(), t.clientHeight / 2 < t.scrollTop && (r = e.props.options.filter((N) => {
      var K;
      return !(!((K = N.attrs) === null || K === void 0) && K.disabled);
    }).findIndex((N) => vn(e.value, Nt(N)))), r === -1 && (r = null);
  }
  return r;
}
function B1e(e) {
  e.addProps(["behavior"]), e.on("created", () => {
    e.props.behavior === "overscroll" && (typeof e.props.optionsLoader == "function" && _o(300, [e]), e.props.dropdownWrapperStyles = Nu(F1e), e.props.listboxStyles = { display: "inline-block" }, e.props.styleWrapper = R1e.bind(null, e), e.props.positionListBox = z1e.bind(null, e));
  }), e.on("prop:expanded", ({ payload: t }) => {
    e.props.behavior === "overscroll" && (t ? function() {
      R0 = document.documentElement.scrollTop;
      for (const n in N0) ET[n] = document.documentElement.style[n], document.documentElement.style[n] = N0[n];
      for (const n in F0) AT[n] = document.body.style[n], document.body.style[n] = F0[n];
      document.body.scrollTop = R0;
    }() : function() {
      for (const n in N0) document.documentElement.style[n] = ET[n];
      for (const n in F0) document.body.style[n] = AT[n];
      document.body.scrollTop = 0, document.documentElement.scrollTop = R0;
    }());
  });
}
function o3(e) {
  e.addProps(["multiLine"]), e.on("created", () => {
    bo && (e.props.multiLineHeight = void 0, Pr(`${e.props.id}_selections`, V1e.bind(null, e), e.props.__root));
  });
}
function V1e(e) {
  var t;
  const n = new ResizeObserver((r) => {
    for (const c of r) {
      const { height: d } = c.contentRect;
      e.props.selectionsHeight !== d && (e.props.selectionsHeight = d), U1e(e, c.target);
    }
  }), i = (t = e.props.__root) === null || t === void 0 ? void 0 : t.getElementById(`${e.props.id}_selections`);
  i && n.observe(i);
}
function U1e(e, t) {
  var n;
  const i = t.querySelectorAll(`[id^="${e.props.id}_tag-wrapper"`);
  let r, c = [];
  if (e.props.type === "taglist") {
    const a = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${e.props.id}`);
    if (!a) return;
    c = [a, ...Array.from(i)];
  } else c = Array.from(i);
  if (!i) return;
  let d = !1;
  for (const a of c) if (r === void 0) r = a.getBoundingClientRect();
  else {
    const f = a.getBoundingClientRect();
    if (r.top >= f.top + f.height / 5 || r.top <= f.top - f.height / 5) {
      d = !0, e.props.multiLine = !0;
      break;
    }
  }
  d || (e.props.multiLine = !1);
}
function H1e(e) {
  if (e.on("created", () => {
    e.context && O1e(e);
  }), e.props.multiple || function(t) {
    t.on("prop:selections", ({ payload: n }) => {
      var i;
      t.props.firstSelectionLabel = ((i = n[0]) === null || i === void 0 ? void 0 : i.label) || "", t.props.option = n[0];
    });
  }(e), e.props.selectionAppearance === "truncate" && (e.props.lastVisibleIndex = null, TT(e), e.on("prop:selections", () => {
    TT(e);
  })), e.props.selectionAppearance === "tags" && o3(e), e.props.multiple && e.props.selectionAppearance === "tags") {
    let t = function() {
      return Array.isArray(e.value) ? e.value : [];
    }, n = function(i, r) {
      e.input(i);
    };
    e.on("created", () => {
      e.props.disabled && (e.props.draggable = !1), Pr(`${e.props.id}_selections`, (i) => {
        if (e.context && i instanceof HTMLElement) {
          const r = { threshold: { horizontal: 0.25, vertical: 0 }, plugins: [__()], draggingClass: e.context.classes.dragging, dropZoneClass: e.context.classes.dropZone, disabled: !e.props.draggable, root: e.props.__root, touchDraggingClass: e.context.classes.touchDragging, touchDropZoneClass: e.context.classes.touchDropZone, draggable: (c) => c.hasAttribute("data-is-tag") };
          es({ parent: i, getValues: t, setValues: n, config: r }), e.on("prop:disabled", ({ payload: c }) => {
            r.disabled = c, es({ parent: i, getValues: t, setValues: n, config: r });
          }), e.on("prop:draggable", ({ payload: c }) => {
            r.disabled = !c, es({ parent: i, getValues: t, setValues: n, config: r });
          });
        }
      }, e.props.__root);
    });
  }
  e.on("prop:expanded", ({ payload: t }) => {
    t && e.props.optionsLoader && typeof e.props.optionsLoader == "function" && (!e.props.options.length || e.props.alwaysLoadOnOpen) && (e.props.options = [], Mh(e));
  }), e.props.behavior === "overscroll" && B1e(e);
}
const W1e = (e, t) => {
  let n = null, i = null, r = null;
  return function(...c) {
    const d = this;
    n ? (i = c, r = d) : (e.apply(d, c), n = window.setTimeout(() => {
      n = null, i !== null && r !== null && (e.apply(r, i), i = null, r = null);
    }, t));
  };
};
function iv(e) {
  if (e.addProps(["popover", "popoverOffset", "usePopover", "popoverCoordinates", "popoverAncestorCoordinates"]), e.props.popover = on(e.props.popover) ? "manual" : void 0, e.type !== "input" || e.props.behavior === "overscroll") return;
  let t = null, n = null, i = [], r = null;
  if (e.props.popoverOffset = on(e.props.popoverOffset) ? parseInt(e.props.popoverOffset) : 0, !e.props.popover) return;
  if (typeof document > "u" || !("popover" in HTMLElement.prototype)) return void (typeof window < "u" && console.warn('FormKit: Popover API is not supported in this browser — input panels will be rendered with fallback CSS positioning. This could result in inaccessible inputs due to parent containers using "overflow: hidden" or z-index conflicts.'));
  const c = () => {
    e.props.invertPopover = !1, document.removeEventListener("resize", r), document.removeEventListener("scroll", r), i.forEach((f) => {
      f.removeEventListener("scroll", r);
    });
  };
  function d() {
    const { x: f, y: g, width: x, height: $ } = function(A, I) {
      if (!A || !I) return { x: 0, y: 0 };
      const { left: O, top: B, width: H, height: N } = I.getBoundingClientRect();
      return { x: O + window.scrollX, y: B + N + window.scrollY, width: H, height: N };
    }(t, n);
    e.props.popoverAncestorCoordinates = { x: f, y: g, width: x, height: $ }, e.props.popoverCoordinates = { x: f, y: g, width: x, height: 0 };
  }
  function a(f) {
    t && document.body.contains(t) && (f ? (t == null || t.showPopover(), setTimeout(() => {
      e.props.popoverCoordinates.height = (t == null ? void 0 : t.offsetHeight) || 0;
    }, 5)) : t.matches(":popover-open") && (t.hidePopover(), e.props.popoverCoordinates.height = 0));
  }
  e.on("mounted", () => {
    e.context && (e.props.usePopover = !0, e.props.popoverCoordinates = { x: 0, y: 0, width: 0, height: 0 }, e.props.popoverAncestorCoordinates = { x: 0, y: 0, width: 0, height: 0 });
  }), e.on("destroyed", () => {
    c();
  }), e.on("prop:inputText", () => {
    e.context && (d(), a(!0));
  }), e.on("prop:expanded", ({ payload: f }) => {
    var g;
    e.context && (f === !1 ? c() : Pr(`${(g = e.context) === null || g === void 0 ? void 0 : g.id}_popover`, () => {
      if (!e.context) return;
      t = document.querySelector(`[id="${e.context.id}_popover"][popover]`) || document.querySelector(`[id="${e.context.id}_popover"] [popover]`), n || (n = function($) {
        if (!$) return null;
        let A = $.parentElement;
        for (; A && window.getComputedStyle(A).position === "static"; ) A = A.parentElement;
        return A;
      }(t)), d(), a(f), r = W1e(() => {
        e.context && (d(), a(f));
      }, 10), document.addEventListener("resize", r), document.addEventListener("scroll", r), i = [];
      let x = t == null ? void 0 : t.parentElement;
      for (; x; ) x.scrollHeight > x.clientHeight && i.push(x), x = x.parentElement;
      i.forEach(($) => {
        $.addEventListener("scroll", r);
      });
    }));
  });
}
const Z1e = { schema: /* @__PURE__ */ Bwe(/* @__PURE__ */ Vwe(/* @__PURE__ */ Hwe("$label"), /* @__PURE__ */ Uwe(/* @__PURE__ */ Np("prefix"), /* @__PURE__ */ Wwe(), /* @__PURE__ */ Ywe(/* @__PURE__ */ sn("$inputStd.length === 0 && $state.loading !== true", /* @__PURE__ */ Jwe('$placeholder || "placeholder"'), /* @__PURE__ */ sn("$multiple !== true", /* @__PURE__ */ Kwe(/* @__PURE__ */ sn("$state.loading && $selections.length === 0", /* @__PURE__ */ O0("$ui.isLoading.value"), /* @__PURE__ */ Xwe(/* @__PURE__ */ Qwe("$option.label")))), /* @__PURE__ */ sn('$multiple && $selectionAppearance === "truncate"', /* @__PURE__ */ e1e(/* @__PURE__ */ t1e(/* @__PURE__ */ sn("$state.loading && $selections.length === 0", /* @__PURE__ */ O0("$ui.isLoading.value"), /* @__PURE__ */ i1e()))), /* @__PURE__ */ sn('$multiple && $selectionAppearance === "tags"', /* @__PURE__ */ a1e(/* @__PURE__ */ l1e(/* @__PURE__ */ sn("$state.loading && $isLoadingOption !== true && $selections.length === 0", /* @__PURE__ */ O0("$ui.isLoading.value"), /* @__PURE__ */ r1e(/* @__PURE__ */ s1e(/* @__PURE__ */ sn("$state.loading && $optionLoaderValues.includes($option.value) || $option.label === undefined", /* @__PURE__ */ c1e("$ui.isLoading.value"), /* @__PURE__ */ o1e("$option.label")), /* @__PURE__ */ wT(/* @__PURE__ */ Np("close"))))))))))), /* @__PURE__ */ sn("$truncationCount && $state.loading !== true", /* @__PURE__ */ n1e("$truncationCount")), /* @__PURE__ */ sn("$state.loading", /* @__PURE__ */ Np("loader")), /* @__PURE__ */ sn("$inputStd.length !== 0 && $selectionRemovable", /* @__PURE__ */ wT(/* @__PURE__ */ Np("close")), /* @__PURE__ */ Np("select"))), /* @__PURE__ */ u1e(), /* @__PURE__ */ Zwe(), /* @__PURE__ */ Np("suffix"))), /* @__PURE__ */ qwe("$help"), /* @__PURE__ */ jwe(/* @__PURE__ */ Gwe("$message.value"))), type: "input", family: "dropdown", props: [], features: [
  /* @__PURE__ */ Qn("select", "select"),
  /* @__PURE__ */ Qn("close", "close"),
  /* @__PURE__ */ Qn("selected", "check"),
  /* @__PURE__ */ Qn("loader", "spinner"),
  /* @__PURE__ */ bi("isLoading"),
  /* @__PURE__ */ bi("loadMore"),
  /* @__PURE__ */ bi("remove"),
  Zl,
  /* @__PURE__ */ o$.bind(null, T1e, M1e, H1e),
  iv
] }, Hc = /* @__PURE__ */ $o("tg"), { outer: q1e, wrapper: j1e, prefix: G1e, suffix: Y1e, help: K1e, messages: X1e, message: J1e, icon: Q1e } = /* @__PURE__ */ Co(Hc), exe = Hc("input", () => ({ $el: "input", bind: "$attrs", attrs: { type: "checkbox", id: "$id", value: "$value", name: "$node.name", checked: "$checked", onInput: "$handlers.toggles", onBlur: "$handlers.blur", disabled: "$disabled" } })), txe = Hc("label", () => ({ if: "($label && $onValueLabel === undefined && $offValueLabel === undefined) || ($valueLabelDisplay === inner) && $altLabelPosition !== true", $el: "label", attrs: { for: "$id" }, children: "$label" })), nxe = Hc("altLabel", () => ({ $el: "label", if: "($label && ($onValueLabel || $offValueLabel) && $valueLabelDisplay !== hidden && $valueLabelDisplay !== inner) || $altLabelPosition === true", attrs: { for: "$id", "data-label-alt": "true", style: { color: { if: "$checked", then: "$valueLabelColorOn", else: "$valueLabelColorOff" } } }, children: "$label" })), ixe = Hc("innerLabel", () => ({ $el: "div", if: "$valueLabelDisplay === inner && ($checked && $onValueLabel || $offValueLabel)", attrs: { style: { color: { if: "$checked", then: "$valueLabelColorOn", else: "$valueLabelColorOff" } } }, children: { if: "$checked", then: "$onValueLabel", else: "$offValueLabel" } })), rxe = Hc("valueLabel", () => ({ $el: "label", if: "$valueLabelDisplay !== hidden && $valueLabelDisplay !== inner && (($checked === true && $onValueLabel) || ($checked === false && $offValueLabel))", attrs: { for: "$id" }, children: { if: "$checked && $onValueLabel", then: "$onValueLabel", else: { if: "$offValueLabel", then: "$offValueLabel" } } })), sxe = Hc("inner", () => ({ $el: "label", attrs: { for: "$id", id: "$id + '_label'" } })), oxe = Hc("track", () => ({ $el: "div", attrs: { style: { backgroundColor: { if: "$checked", then: "$trackColorOn", else: "$trackColorOff" } } } })), axe = Hc("thumb", () => ({ $el: "div", attrs: { style: { color: { if: "$checked", then: "$iconColorOn", else: "$iconColorOff" }, backgroundColor: { if: "$checked", then: "$thumbColorOn", else: "$thumbColorOff" } } } })), lxe = () => axe(sn("$slots.default", "$slots.default", Q1e("thumb"))), cxe = { schema: /* @__PURE__ */ q1e(/* @__PURE__ */ j1e(/* @__PURE__ */ nxe(), /* @__PURE__ */ sxe(/* @__PURE__ */ G1e(), /* @__PURE__ */ exe(), /* @__PURE__ */ oxe(/* @__PURE__ */ ixe(), /* @__PURE__ */ lxe()), /* @__PURE__ */ Y1e()), /* @__PURE__ */ rxe(), /* @__PURE__ */ txe()), /* @__PURE__ */ K1e("$help"), /* @__PURE__ */ X1e(/* @__PURE__ */ J1e("$message.value"))), type: "input", props: ["checked", "thumbColorOff", "thumbColorOn", "iconColorOff", "iconColorOn", "valueLabelColorOff", "valueLabelColorOn", "offValue", "offValueLabel", "onValue", "onValueLabel", "thumbIcon", "trackColorOff", "trackColorOn", "valueLabelDisplay", "altLabelPosition"], features: [function(e) {
  function t(n, i) {
    i.target instanceof HTMLInputElement && (n.input(i.target.checked ? n.props.onValue : n.props.offValue), n.props.checked = i.target.checked);
  }
  e.on("created", () => {
    "disabled" in e.props && (e.props.disabled = on(e.props.disabled)), e.props.altLabelPosition = on(e.props.altLabelPosition), e.props.offValue === void 0 && (e.props.offValue = !1), e.props.onValue === void 0 && (e.props.onValue = !0), e.props.checked = vn(e.value, e.props.onValue), e.context && (e.context.handlers.toggles = t.bind(null, e));
  }), e.on("commit", ({ payload: n }) => {
    e.props.checked = vn(n, e.props.onValue);
  });
}] }, Mr = /* @__PURE__ */ $o("rp"), { outer: uxe, inner: dxe, prefix: pxe, suffix: hxe, help: fxe, messages: mxe, message: vxe, icon: Uf } = /* @__PURE__ */ Co(Mr), gxe = Mr("empty", () => ({ $el: "div" })), yxe = Mr("insertControl", () => ({ $el: "button", attrs: { disabled: "$value.length >= $max", onClick: "$fns.createInsert($index)", type: "button" } })), _xe = Mr("addButton", () => ({ $formkit: "button", bind: "$addAttrs", if: "$addButton", disabled: "$value.length >= $max", onClick: "$fns.createAppend()", type: "button" })), bxe = Mr("removeControl", () => ({ $el: "button", attrs: { disabled: "$value.length <= $min", onClick: "$fns.createRemover($index)", type: "button" } })), wxe = Mr("items", () => ({ $el: "ul", meta: { autoAnimate: !0 }, attrs: { role: "list", id: '$id + "_items"' } })), xxe = Mr("item", () => ({ $el: "li", for: ["item", "index", "$items"], attrs: { role: "listitem", key: "$item", "data-index": "$index" } })), $xe = Mr("downControl", () => ({ $el: "button", attrs: { disabled: "$index >= $value.length - 1", onClick: "$fns.createShift($index, 1)", type: "button" } })), Cxe = Mr("upControl", () => ({ $el: "button", attrs: { disabled: "$index <= 0", onClick: "$fns.createShift($index, -1)", type: "button" } })), kxe = Mr("content", "div"), Sxe = Mr("fieldset", () => ({ $el: "fieldset", attrs: { id: "$id" } })), Txe = Mr("legend", () => ({ $el: "legend", if: "$label" })), Ixe = Mr("group", () => ({ $formkit: "group", index: "$index" })), Axe = Mr("controls", () => ({ $el: "ul", if: "$removeControl || $insertControl || $upControl || $downControl" })), Exe = Mr("remove", () => ({ $el: "li", if: "$removeControl" })), Pxe = Mr("insert", () => ({ $el: "li", if: "$insertControl" })), Mxe = Mr("up", () => ({ $el: "li", if: "$upControl" })), Dxe = Mr("down", () => ({ $el: "li", if: "$downControl" })), tg = Mr("controlLabel", "span"), Lxe = Mr("dragHandleWrapper", () => ({ if: "$draggable", $el: "div" })), Oxe = Mr("dragHandle", () => ({ $el: "div", attrs: { id: '$id + "_drag_handle"' } }));
function Nxe(e) {
  var t, n, i, r, c, d, a, f, g, x, $, A, I, O;
  if ((t = (f = e.props).removeControl) !== null && t !== void 0 || (f.removeControl = !0), (n = (g = e.props).upControl) !== null && n !== void 0 || (g.upControl = !0), (i = (x = e.props).downControl) !== null && i !== void 0 || (x.downControl = !0), (r = ($ = e.props).insertControl) !== null && r !== void 0 || ($.insertControl = !1), (c = (A = e.props).addButton) !== null && c !== void 0 || (A.addButton = !0), (d = (I = e.props).addLabel) !== null && d !== void 0 || (I.addLabel = !1), (a = (O = e.props).addAttrs) !== null && a !== void 0 || (O.addAttrs = {}), e.props.draggable = on(e.props.draggable), e.props.min = e.props.min !== void 0 ? Number(e.props.min) : 1, e.props.max = e.props.max !== void 0 ? Number(e.props.max) : 1 / 0, e.props.min > e.props.max) throw Error("Repeater: min must be less than max");
  if (Array.isArray(e.value)) if (e.value.length < e.props.min) {
    const B = Mu(e.props.min - e.value.length, () => ({}));
    e.input(e.value.concat(B), !1);
  } else e.value.length > e.props.max && e.input(e.value.slice(0, e.props.max), !1);
  else e.input(Mu(e.props.min, () => ({})), !1);
  e.context && function(B, H) {
    H.createShift = (N, K) => () => {
      const U = B._value;
      U.splice(N + K, 0, U.splice(N, 1)[0]), B.input(U, !1);
    }, H.createInsert = (N) => () => {
      const K = B._value;
      K.splice(N + 1, 0, {}), B.input(K, !1);
    }, H.createAppend = () => () => {
      const N = B._value;
      N.push({}), B.input(N, !1);
    }, H.createRemover = (N) => () => {
      const K = B._value;
      K.splice(N, 1), B.input(K, !1);
    };
  }(e, e.context.fns);
}
function PT(e, t) {
  var n;
  if (!t.context) return;
  const i = (n = t.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${t.props.id}_inner`), r = i == null ? void 0 : i.hasAttribute("data-auto-animate"), c = { group: t.props.id, dragHandle: `#${t.props.id}_drag_handle`, draggingClass: t.context.classes.dragging, dropZoneClass: t.context.classes.dropZone, root: t.props.__root, disabled: !t.props.draggable, plugins: r ? [] : [__({ duration: 100 })], touchDraggingClass: t.context.classes.touchDragging, touchDropZoneClass: t.context.classes.touchDropZone, draggable: (f) => f.tagName === "LI" };
  function d() {
    return Array.isArray(t.value) ? t.value : [];
  }
  function a(f) {
    t.input(f);
  }
  es({ parent: e, getValues: d, setValues: a, config: c }), t.on("prop:disabled", ({ payload: f }) => {
    c.disabled = f, es({ parent: e, getValues: d, setValues: a, config: c });
  }), t.on("prop:draggable", ({ payload: f }) => {
    c.disabled = !f, es({ parent: e, getValues: d, setValues: a, config: c });
  });
}
const Fxe = { schema: /* @__PURE__ */ uxe(/* @__PURE__ */ Sxe(/* @__PURE__ */ Txe("$label"), /* @__PURE__ */ fxe("$help"), /* @__PURE__ */ dxe(/* @__PURE__ */ pxe(), /* @__PURE__ */ sn("$value.length === 0", /* @__PURE__ */ sn("$slots.empty", /* @__PURE__ */ gxe()), /* @__PURE__ */ wxe(/* @__PURE__ */ xxe(/* @__PURE__ */ Lxe(/* @__PURE__ */ Oxe(/* @__PURE__ */ Uf("dragHandle"))), /* @__PURE__ */ kxe(/* @__PURE__ */ Ixe("$slots.default")), /* @__PURE__ */ Axe(/* @__PURE__ */ Mxe(/* @__PURE__ */ Cxe(/* @__PURE__ */ tg("$ui.moveUp.value"), /* @__PURE__ */ Uf("moveUp"))), /* @__PURE__ */ Exe(/* @__PURE__ */ bxe(/* @__PURE__ */ tg("$ui.remove.value"), /* @__PURE__ */ Uf("remove"))), /* @__PURE__ */ Pxe(/* @__PURE__ */ yxe(/* @__PURE__ */ tg("$ui.add.value"), /* @__PURE__ */ Uf("add"))), /* @__PURE__ */ Dxe(/* @__PURE__ */ $xe(/* @__PURE__ */ tg("$ui.moveDown.value"), /* @__PURE__ */ Uf("moveDown"))))), /* @__PURE__ */ hxe()))), /* @__PURE__ */ _xe('$addLabel || ($ui.add.value + " " + ($label || ""))')), /* @__PURE__ */ mxe(/* @__PURE__ */ vxe("$message.value"))), type: "list", props: ["min", "max", "total", "upControl", "downControl", "removeControl", "insertControl", "addLabel", "addButton", "addAttrs", "draggable"], features: [
  function(e) {
    e._c.sync = !0, e.on("created", Nxe.bind(null, e)), e.on("mounted", () => {
      Pr(`${e.props.id}_items`, (t) => {
        if (t instanceof HTMLElement) {
          let n = function(i) {
            for (const r of i) for (const c of Array.from(r.addedNodes)) if (c instanceof HTMLElement && c.id === `${e.props.id}_items`) return void PT(c, e);
          };
          PT(t, e), new MutationObserver(n).observe(t.parentNode, { childList: !0 });
        }
      }, e.props.__root);
    });
  },
  h_,
  /* @__PURE__ */ bi("remove"),
  /* @__PURE__ */ bi("add"),
  /* @__PURE__ */ bi("moveUp"),
  /* @__PURE__ */ bi("moveDown"),
  /* @__PURE__ */ Qn("dragHandle", "dragHandle"),
  /* @__PURE__ */ Qn("remove", "trash"),
  /* @__PURE__ */ Qn("add", "add"),
  /* @__PURE__ */ Qn("moveUp", "arrowUp"),
  /* @__PURE__ */ Qn("moveDown", "arrowDown")
] }, t1 = /* @__PURE__ */ new WeakMap();
function rv(e, t) {
  const n = { onItems: [], offItems: [] }, i = t || Number(e.value || 0);
  for (let r = 0; r < e.props.max; r++) if (r < i && r + 1 >= i) {
    const c = e.props.rightToLeft ? 100 - 100 * (i - r) : 100 * (i - r);
    n.onItems.push(c + "%"), n.offItems.push(100 - c + "%");
  } else r < i ? (n.offItems.push("0%"), n.onItems.push("100%")) : r >= i && (n.offItems.push("100%"), n.onItems.push("0%"));
  e.props.itemsToPercentages = n;
}
function Rxe(e, t) {
  var n;
  (n = e.context) === null || n === void 0 || n.handlers.blur(t);
}
function zxe(e, t) {
  const { x: n, y: i } = l3(t);
  let r = document.elementFromPoint(n, i);
  const c = Array.from(document.querySelectorAll(`#${e.props.id}_items_wrapper > .formkit-ratingItem`));
  let d = !0;
  for (; r && d; ) {
    if (c.includes(r)) {
      d = !1;
      break;
    }
    r = r.parentNode;
  }
  if (!d) {
    const a = c.indexOf(r);
    if (e.props.step === 1) return void e.input(a + 1, !1);
  }
}
function Bxe(e, t, n) {
  e.props.disabled || (n.preventDefault(), e.props.hoverHighlight = !0, e.props.touchStarted = !0, e.props.step !== 1 ? k_(e, t, n) : e.input(t + 1, !1));
}
function a3(e, t) {
  if (!e.props.dragStarted) return;
  t.preventDefault(), e.props.hoverHighlight = !1, e.props.dragStarted = !1, rv(e);
  const n = t1.get(e);
  n && (n.abort(), t1.delete(e));
}
function Vxe(e, t, n) {
  if (e.props.hoverHighlight || e.props.disabled) return;
  n.preventDefault(), e.props.hoverHighlight = !0, e.props.dragStarted = !0;
  const i = new AbortController();
  document.addEventListener("mouseup", (r) => a3(e, r), { signal: i.signal }), t1.set(e, i), e.props.step === 1 ? e.input(t + 1, !1) : k_(e, t, n);
}
function Uxe(e, t) {
  var n, i;
  if (document.activeElement === t.currentTarget) {
    if (t.key === "ArrowRight" || t.key === "ArrowDown") {
      e.props.arrow = 1;
      const r = e.value ? n1(e.value + 1 * e.props.step, e.props.step) : e.props.min + 1 * e.props.step, c = (n = e.props.__root) === null || n === void 0 ? void 0 : n.querySelector(e.value ? `#${e.props.id}_inner input[value="${r}"]` : "#" + (e.props.id + "_0_0"));
      e.props.preventFocus = !0, c && c instanceof HTMLInputElement && c.focus(), e.props.preventFocus = !1, e.input(Number(r));
    } else if (t.key === "ArrowLeft" || t.key === "ArrowUp") {
      e.props.arrow = -1;
      const r = e.value ? n1(e.value - 1 * e.props.step, e.props.step) : e.props.max, c = (i = e.props.__root) === null || i === void 0 ? void 0 : i.querySelector(`#${e.props.id}_inner input[value="${r}"]`);
      e.props.preventFocus = !0, c && c instanceof HTMLInputElement && c.focus(), e.props.preventFocus = !0, e.input(Number(r)), e.props.preventFocus = !1;
    }
  }
}
function Hxe(e, t) {
  if (!e.props.preventFocus) {
    if (e.props.preventFocus = !0, setTimeout(() => {
      e.props.preventFocus = !1;
    }, 50), t.relatedTarget instanceof HTMLElement && t.relatedTarget.id === e.props.id + "_items_wrapper") e.props.arrow > 0 ? setTimeout(() => {
      var n, i;
      (i = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(e.props.id + "_0_0")) === null || i === void 0 || i.focus();
    }) : e.props.arrow < 0 && setTimeout(() => {
      var n, i;
      (i = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(e.props.id + `_${e.props.max - 1}_${e.props.stepsPerValue - 1}`)) === null || i === void 0 || i.focus();
    });
    else if (t.target instanceof HTMLInputElement) {
      if (Number(t.target.value) === e.props.step && e.value === e.props.max || Number(t.target.value) === e.props.max && e.value === e.props.step) {
        const n = document.getElementById(e.props.id + "_items_wrapper");
        return n == null || n.focus(), void e.input(0);
      }
      e.input(Number(t.target.value));
    }
  }
}
function Wxe(e, t, n) {
  e.props.hoverHighlight && (e.props.disabled || (e.props.step === 1 ? (rv(e, t + 1), e.props.dragStarted && e.input(t + 1, !1)) : k_(e, t, n, !!e.props.dragStarted)));
}
function Zxe(e) {
  rv(e);
}
function qxe(e, t, n) {
  if (!e.props.disabled && n.type !== "touchstart" && (n.preventDefault(), (n.clientX !== 0 || n.clientY !== 0) && n.currentTarget instanceof HTMLElement)) return e.props.step === 1 ? e.props.deselect && Number(e.value) === t + 1 ? void e.input(0) : void e.input(t + 1) : void k_(e, t, n);
}
function l3(e) {
  return e instanceof MouseEvent ? { x: e.clientX, y: e.clientY } : { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY };
}
function k_(e, t, n, i = !0) {
  if (!(n.currentTarget instanceof HTMLElement)) return;
  const { x: r } = l3(n), c = n.currentTarget.getBoundingClientRect();
  let d = n1((r - c.x) / c.width + t, e.props.step);
  d = d > e.props.min ? d : e.props.min, d = d < e.props.max ? d : e.props.max, !e.props.deselect || d !== Number(e.value) || e.props.dragStarted ? i ? e.input(d, !1) : rv(e, d) : e.input(0);
}
function n1(e, t) {
  t || (t = 1);
  const n = 1 / t;
  return Math.ceil(e * n) / n;
}
const ol = /* @__PURE__ */ $o("rt"), { outer: jxe, wrapper: Gxe, inner: Yxe, label: Kxe, prefix: Xxe, suffix: Jxe, help: Qxe, messages: e$e, message: t$e, icon: zy } = /* @__PURE__ */ Co(ol), n$e = ol("itemsWrapper", () => ({ $el: "span", attrs: { style: { "flex-direction": '$rightToLeft && "row-reverse" || undefined' }, tabindex: "$value !== undefined && $value !== 0 && '-1' || '0'", id: "$id + _items_wrapper", onKeydown: "$handlers.handleWrapperKeydown", "data-disabled": "$disabled", onBlur: "$handlers.handleWrapperBlur", onMouseleave: "$hoverHighlight && $handlers.handleMouseleave" } })), i$e = ol("ratingItem", () => ({ for: ["item", "index", "$max"], $el: "span", attrs: { id: '$id + "_item_" + $index', onClick: "$handlers.handleItemClick($item)", draggable: "$hoverHighlight !== true && && $disabled !== true && true", onMousemove: "$handlers.handleMousemove($item)", onDragstart: "$handlers.handleDragstart($item)", onDragend: "$handlers.handleDragend", onTouchstart: "$handlers.handleTouchstart($item)", onTouchmove: "$handlers.handleTouchmove" } })), r$e = ol("template", () => ({ for: ["increment", "stepIndex", "$stepsPerValue"], $el: null })), s$e = ol("itemLabel", () => ({ $el: "label", attrs: { id: '$id + "_label_" + $index + "_" + $stepIndex', for: '$id + "_" + $index + "_" + $stepIndex', "data-checked": '$value === $fns.getValue($item, $increment) && "true" || "false"', style: { width: '$fns.showLabel($fns.getValue($item, $increment), $stepIndex, $item) && "100%" || "0%"' } } })), o$e = ol("itemLabelInner", () => ({ $el: "span", children: "$fns.getValue($item, $increment)" })), a$e = ol("input", () => ({ $el: "input", attrs: { type: "radio", value: "$fns.getValue($item, $increment)", id: '$id + "_" + $index + "_" + $stepIndex', onFocus: "$handlers.handleFocus", tabindex: '$value === $fns.getValue($item, $increment) && "0" || "-1"', disabled: "$disabled", name: "$id", "data-value": "$fns.getValue($item, $increment)", checked: "$value === $fns.getValue($item, $increment) && true", onKeydown: "$handlers.handleKeydown($fns.getValue($item, $increment))" } })), l$e = ol("onItemRow", () => ({ $el: "span", attrs: { style: { width: "$fns.getPercentage($itemsToPercentages, $item)", display: "flex", position: "relative", overflow: "hidden", top: "0", left: "0", bottom: "0" } } })), c$e = ol("offItemRow", () => ({ $el: "span", attrs: { style: { width: "$fns.getPercentage($itemsToPercentages, $item, false)", display: "flex", "flex-direction": "row-reverse", position: "absolute", zIndex: "$offItemStyles && 100", overflow: "hidden", top: "0", right: "0" } } })), u$e = ol("onItemWrapper", () => ({ $el: "div", attrs: { style: { color: "$onColor" } } })), d$e = ol("offItemWrapper", () => ({ $el: "div", attrs: { style: { color: "$offColor" } } })), p$e = () => sn("$slots.onItem", () => () => "$slots.onItem", sn("$slots.default", () => () => "$slots.default", zy("rating"))), h$e = () => sn("$slots.offItem", () => () => "$slots.offItem", sn("$slots.default", () => () => "$slots.default", zy("rating"))), f$e = { schema: /* @__PURE__ */ jxe(/* @__PURE__ */ Gxe(/* @__PURE__ */ Kxe("$label"), /* @__PURE__ */ Yxe(/* @__PURE__ */ zy("prefix"), /* @__PURE__ */ Xxe(), /* @__PURE__ */ n$e(/* @__PURE__ */ i$e(/* @__PURE__ */ r$e(/* @__PURE__ */ s$e(/* @__PURE__ */ l$e(/* @__PURE__ */ u$e(/* @__PURE__ */ p$e())), /* @__PURE__ */ c$e(/* @__PURE__ */ d$e(/* @__PURE__ */ h$e())), /* @__PURE__ */ o$e()), /* @__PURE__ */ a$e()))), /* @__PURE__ */ Jxe(), /* @__PURE__ */ zy("suffix"))), /* @__PURE__ */ Qxe("$help"), /* @__PURE__ */ e$e(/* @__PURE__ */ t$e("$message.value"))), type: "input", props: [], features: [function(e) {
  function t(n) {
    setTimeout(() => {
      const i = Array.from(document.querySelectorAll(`#${n.props.id}_items_wrapper > .formkit-ratingItem`));
      for (let r = 0; r < i.length; r++) {
        const c = i[r].querySelectorAll(".formkit-onItemWrapper"), d = i[r].querySelectorAll(".formkit-offItemWrapper");
        for (let a = 0; a < c.length; a++) c[a].style.flex = `0 0 ${i[r].getBoundingClientRect().width}px`;
        for (let a = 0; a < d.length; a++) d[a].style.flex = `0 0 ${i[r].getBoundingClientRect().width}px`;
      }
    });
  }
  e.addProps(["max", "step", "stepsPerValue", "itemsToPercentages", "rightToLeft", "onItemStyles", "offItemStyles", "hoverHighlight", "deselect", "disabled", "wrapperWidth", "onColor", "offColor"]), e.props.hoverHighlight !== !1 && e.props.hoverHighlight !== "false" && (e.props.hoverHighlight = !0), e.props.deselect = on(e.props.deselect), e.props.max = Number(e.props.max) || 5, e.props.min = Number(e.props.min) || 0, e.props.step = Number(e.props.step) || 1, e.props.numberOfSteps = e.props.max / e.props.step, e.props.lastIndex = 1 / e.props.step - 1, e.props.itemsToPercentages = {}, "disabled" in e.props && (e.props.disabled = on(e.props.disabled)), e.props.rightToLeft ? (e.props.onItemStyles = void 0, e.props.offItemStyles = { position: "absolute", top: "0", left: "0", overflow: "hidden", height: "100%", zIndex: 100 }) : e.props.onItemStyles = { position: "absolute", top: "0", left: "0", overflow: "hidden", height: "100%" }, e.props.stepsPerValue = 1 / e.props.step, e.hook.input((n, i) => {
    if (n === null || n === "" || isNaN(n)) return i(n);
    const r = Number(n), c = Number(e.props.min), d = Number(e.props.max);
    return r > d ? i(d) : e.props.min && r <= c ? i(c) : i(r);
  }), e.on("commit", ({ payload: n }) => {
    const i = Number(n || 0);
    rv(e, i);
  }), e.on("created", () => {
    e.context && (Pr(`${e.props.id}_items_wrapper`, () => {
      t(e), function(n) {
        var i;
        const r = (i = n.props.__root) === null || i === void 0 ? void 0 : i.getElementById(`${n.props.id}_items_wrapper`);
        r && new ResizeObserver(() => {
          t(n);
        }).observe(r);
      }(e), setTimeout(() => t(e), 100);
    }, e.props.__root), e.context.fns.getPercentage = (n, i, r = !0) => (r ? n.onItems : n.offItems)[i], e.context.fns.getValue = (n, i) => n + Number((i * e.props.step + e.props.step).toFixed(1)), e.context.fns.showLabel = (n, i) => {
      const r = Number(e.value || 0);
      return r === 0 && i === 0 || r && n === r || n > r && i === 0 || r > n && i === e.props.lastIndex;
    }, e.context.handlers.handleFocus = (n) => Hxe.call(null, e, n), e.context.handlers.handleWrapperKeydown = (n) => Uxe.call(null, e, n), e.context.handlers.handleWrapperBlur = (n) => Rxe.call(null, e, n), e.context.handlers.handleItemClick = (n) => (i) => qxe.call(null, e, n, i), e.context.handlers.handleMousemove = (n) => (i) => Wxe.call(null, e, n, i), e.context.handlers.handleMouseleave = () => Zxe.call(null, e), e.context.handlers.handleDragstart = (n) => (i) => Vxe.call(null, e, n, i), e.context.handlers.handleMouseup = (n) => a3.call(null, e, n), e.context.handlers.handleTouchstart = (n) => (i) => Bxe.call(null, e, n, i), e.context.handlers.handleTouchmove = (n) => zxe.call(null, e, n), e.context.handlers.handleKeydown = (n) => (i) => function(r, c, d) {
      const a = Number(r.value);
      r.props.deselect && d.key === " " && a === c ? r.input(0) : d.key === " " && r.input(c);
    }(e, n, i));
  });
}, /* @__PURE__ */ Qn("rating", "star")] }, ql = /* @__PURE__ */ $o("ac"), { outer: m$e, wrapper: v$e, inner: g$e, icon: xc, label: y$e, prefix: _$e, suffix: b$e, help: w$e, messages: x$e, message: $$e } = /* @__PURE__ */ Co(ql), C$e = ql("input", () => ({ $el: "input", bind: "$attrs", attrs: { id: "$id", type: "text", onClick: "$handlers.click", onBlur: "$handlers.blur", onKeydown: "$handlers.keydown", onInput: "$handlers.input", onFocus: "$handlers.focus", value: "$inputText || undefined", name: "$node.name", placeholder: "$state.loading && $ui.isLoading.value || $placeholder || undefined", tabindex: '$disabled && "-1" || 0', role: "combobox", autocomplete: '$attrs.autocomplete || "off"', autocapitalize: "none", readonly: "$attrs.readonly || $state.loading || $multiple && $max && $value && $value.length >= $max && $hasHighlightedRange !== true || undefined", "data-selection-appearance": "$selectionAppearance", disabled: "$disabled || $disabledInternally || undefined", onTouchmove: "$handlers.touchmove", onTouchstart: "$handlers.touchmove", onTouchend: "$handlers.touchend", "aria-autocomplete": "list", "aria-expanded": "$expanded", "aria-controls": '$expanded && $id + "_listbox" || undefined', "aria-describedBy": "$describedBy", "aria-activedescendant": "$expanded && $activeDescendant || undefined" } })), MT = ql("listboxButton", () => ({ $el: "div", attrs: { style: "$visibilityStyles", id: '$id + "_listbox_button"', role: "button", "aria-label": "$expanded && $ui.close.value || $ui.open.value", onClick: "$handlers.toggleListbox", onKeydown: "$handlers.toggleListboxKeydown", tabindex: '$disabled && "-1" || 0', "aria-haspopup": "true", "aria-expanded": "$expanded", "aria-controls": '$expanded && $id + "_listbox" || undefined', "aria-disabled": "$disabled || $state.loading || undefined", "data-disabled": "$disabled || $disabledInternally || undefined" } })), DT = ql("selectionWrapper", () => ({ for: ["option", "index", "$selections"], $el: "div", attrs: { id: '$id + "_selection_wrapper_" + $index', key: "$option.value", "data-value": "$option.value", tabindex: '$disabled && "-1" || 0', onKeydown: "$handlers.selectionKeydown && $handlers.selectionKeydown($multiple && $option || undefined)", onClick: "$handlers.selectionClick && $handlers.selectionClick($multiple && $option || undefined)", onFocus: "$handlers.selectionFocus && $handlers.selectionFocus($multiple && $option || undefined)", onBlur: "$handlers.selectionBlur && $handlers.selectionBlur($multiple && $option || undefined)", "data-is-selection": "true", "data-active-selection": "$fns.isActiveSelection && $fns.isActiveSelection($activeSelectionValue, $option)" } })), LT = ql("selection", () => ({ $el: "div", attrs: { id: '$id + "_selection_" + $index' } })), OT = ql("selections", () => ({ $el: "div", attrs: { "aria-live": "polite", id: '$id + "_selections"' } })), z0 = ql("removeSelection", () => ({ $el: "button", attrs: { id: '$selectionAppearance === "option" && $multiple && $id + "_remove_selection_" + $index || $id + "_remove_selection"', tabindex: "0", title: "$ui.remove.value", type: "button", "aria-label": "$ui.remove.value", onClick: "$handlers.removeSelection && $handlers.removeSelection($multiple && $option || undefined)", onTouchend: "$handlers.removeSelection && $handlers.removeSelection($multiple && $option || undefined)", "aria-controls": "$id" } })), NT = ql("optionLoading", "span"), FT = ql("option", () => ({ $el: "div", if: "$value !== undefined" })), k$e = /* @__PURE__ */ t$(ql);
function S$e(e) {
  e.props.selectionAppearance !== "option" || e.props.multiple || e.props.selectionRemovable === !1 || e.props.selectionRemovable === "false" || (e.props.selectionRemovable = !0), e.props.multiple || (e.props.clearSearchOnOpen = on(e.props.clearSearchOnOpen)), e.props.selectionRemovable = on(e.props.selectionRemovable), e.props.openOnClick = on(e.props.openOnClick), e.props.selectionAppearance !== "option" || e.props.multiple || (e.props.isSingleOption = !0), e.props.closeOnSelect === void 0 && (e.props.closeOnSelect = !0), e.props.selectionAppearance === void 0 && (e.props.selectionAppearance = "text-input"), e.props.closeOnSelect === void 0 && (e.props.closeOnSelect = !0), e.props.closeOnSelect ? e.props.resetSearchOnCommit = !1 : e.props.resetSearchOnCommit === void 0 && (e.props.resetSearchOnCommit = e.props.multiple), e.props.allowNewValues = on(e.props.allowNewValues);
}
function c3(e) {
  e.addProps(["inputText", "selectionAppearance", "searchValue", "openOnClick", "filteredOptions", "search", "debounce", "showInput", "visibilityStyles", "selectionStyles", "multiple", "filter", "hasHighlightedRange", "clearOnClick", "debounce"]), e.props.debounce === void 0 ? e.props.debounce = 200 : e.props.debounce = parseInt(e.props.debounce), e.props.nonceKey = "searchValue", e.props.searchValue = "", e.props.inputText = "", e.props.filterOptions = el.bind(null, e), e.props.reloadOnCommit = on(e.props.reloadOnCommit), e.props.alwaysLoadOnOpen === void 0 ? e.props.alwaysLoadOnOpen = !0 : e.props.alwaysLoadOnOpen = on(e.props.alwaysLoadOnOpen), typeof e.props.filter != "function" && (e.props.filter = (t, n) => t.label.toLowerCase().includes(n.toLowerCase())), e.on("created", () => {
    e.context && bo && (e.context.handlers.focus = RT.bind(null, e), e.context.handlers.input = T$e.bind(null, e), e.context.handlers.focus = RT.bind(null, e), e.context.handlers.click = I$e.bind(null, e), e.context.handlers.toggleListbox = u3.bind(null, e), e.context.handlers.toggleListboxKeydown = A$e.bind(null, e), e.context.handlers.keydown = P1e.bind(null, e), e.context.handlers.selectionKeydown = (t) => (n) => A1e(e, t, n), e.context.handlers.searchInputTagKeydown = (t) => (n) => function(i, r, c) {
      if (c.stopPropagation(), !i.props.disabled)
        switch (c.key) {
          case "ArrowDown":
            t3(i);
            break;
          case "ArrowRight":
          case "ArrowLeft":
            n3(i, r, c);
            break;
          case "Delete":
          case "Backspace":
            i3(i, r, c);
        }
    }(e, t, n), e.on("prop:options", ({ payload: t }) => {
      if ((e.props.initialOptions.length === 0 && typeof e.props.optionsLoader != "function" || !e.props.searchValue && t.length) && (e.props.initialOptions = [...t]), e.props.selections && e.props.selections.length && t.length) for (let n = 0; n < e.props.selections.length; n++) {
        const i = e.props.selections[n], r = t.find((c) => Nt(c) === i.value);
        r && (e.props.selections[n] = r);
      }
    }));
  }), e.on("prop:expanded", ({ payload: t }) => {
    t || qL.delete(e);
  });
}
function T$e(e, t) {
  if (e.props.disabled) return;
  const n = t.target;
  e.props.inputText = n.value, e.emit("handleSearchInput", n.value), e.props.searchValue && el(e, e.props.searchValue, !0);
}
function I$e(e, t) {
  t.stopPropagation(), e.props.disabled || e.props.disabledInternally || (e.props.attrs.onClick && e.props.attrs.onClick(t), (!e.props.expanded && e.props.openOnClick || e.props.openOnFocus) && (e.props.expanded = !0));
}
function RT(e) {
  e.props.disabled || e.props.disabledInternally || (e.props.attrs.onFocus && e.props.attrs.onFocus(), e.props.activeSelectionValue = void 0, e.props.skipOpen ? e.props.skipOpen = !1 : e.props.openOnFocus && (e.props.expanded = !0));
}
function u3(e) {
  var t, n, i;
  e.props.disabled || e.props.disabledInternally || !((t = e.context) === null || t === void 0) && t.state.loading || (e.props.expanded = !e.props.expanded, e.props.openOnFocus || (i = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${e.props.id}`)) === null || i === void 0 || i.focus());
}
function A$e(e, t) {
  t.key !== "Enter" && t.key !== " " || (t.preventDefault(), t.stopPropagation(), u3(e));
}
const zT = /* @__PURE__ */ new WeakMap(), Og = typeof window < "u", B0 = /* @__PURE__ */ new WeakMap();
let BT = !1;
function E$e(e) {
  e.props.searchValue = null, e.on("commit", () => {
    e.props.searchValue = null, e.props.highlightedRange || VT(e);
  }), e.on("created", () => {
    if (!e.context || !Og) return;
    e.on("handleSearchInput", ({ payload: c }) => {
      c === "" ? (e.props.searchValue = null, e.input([])) : c && e.props.inputStd.length === 0 ? e.props.searchValue = c : c && e.props.inputStd.length > 0 && (e.props.searchValue = function(d) {
        var a;
        const f = ng(d);
        if (d.props.highlightedRange) {
          const [g, x] = UT(d, f);
          return d.props.inputText.slice(g, x);
        }
        return d.props.inputText.slice(((a = f[f.length - 1]) === null || a === void 0 ? void 0 : a.end) + 2);
      }(e)), !e.props.expanded && c ? e.props.expanded = !0 : !c && e.props.expanded && (e.props.expanded = !1);
    }), function(c) {
      Pr(`${c.props.id}`, (d) => {
        d instanceof HTMLInputElement && B0.set(d, c);
      }, c.props.__root), Og && !BT && (BT = !0, document.addEventListener("selectionchange", () => {
        const d = zd();
        if (d instanceof HTMLInputElement && B0.has(d)) {
          const a = B0.get(d);
          a && function(f) {
            clearTimeout(zT.get(f)), zT.set(f, setTimeout(() => {
              var g, x, $, A;
              const I = (g = f.props.__root) === null || g === void 0 ? void 0 : g.getElementById(`${f.props.id}`);
              if (I instanceof HTMLInputElement) {
                const O = ng(f), B = O.findIndex((N) => I.selectionStart !== null ? I.selectionStart >= N.start && I.selectionStart <= N.end : I.selectionEnd !== null && I.selectionEnd >= N.start && I.selectionEnd <= N.end), H = (x = O[O.length - 1]) === null || x === void 0 ? void 0 : x.end;
                if (I.selectionStart === 0 && I.selectionEnd === (($ = f.props.inputText) === null || $ === void 0 ? void 0 : $.length)) return;
                if (typeof f.props.searchValue == "string" && f.props.highlightedRange) {
                  if (O.length) {
                    const N = f.props.highlightedRange, [K, U] = UT(f, O);
                    if (I.selectionEnd !== null && (I.selectionEnd < K || I.selectionEnd > U)) {
                      const q = N.end - N.start - (U - K), ee = I.selectionEnd;
                      f.props.inputText = f.props.option.label, f.props.highlightedRange = void 0, f.props.searchValue = null, I.value = f.props.inputText, I.selectionStart = I.selectionEnd = ee + (ee > K ? q : 0);
                    }
                  }
                } else if (B >= 0 && I.selectionStart !== null && (H !== ((A = f.props.inputText) === null || A === void 0 ? void 0 : A.length) || I.selectionStart < H)) {
                  const N = O[B], K = f.props.inputText.substr(0, H), U = N.start + (N.index > 0 ? 1 : 0), q = N.end + (O.length - 1 > N.index ? -1 : 0);
                  K !== f.props.inputText && (f.props.inputText = K, I.value = K), f.props.highlightedRange = N, I.selectionStart = U, I.selectionEnd = q;
                } else f.props.highlightedRange = void 0, VT(f);
                if (I.selectionStart !== null && I.selectionStart >= H && f.props.inputText.substring(H, H + 2) !== ", ") {
                  let N = f.props.inputText.substring(0, H);
                  N = f.props.multiple && f.props.max && Array.isArray(f.props.inputStd) && f.props.inputStd.length >= f.props.max ? N : `${N},`, f.props.inputText = `${N} ${f.props.inputText.substring(H).replace(/^[,\s]{1,2}/, "")}`;
                }
              }
            }, 5));
          }(a);
        }
      }));
    }(e);
    const i = e.context.handlers.keydown;
    e.context.handlers.keydown = (c) => {
      i(c), function(d, a) {
        var f, g, x, $;
        if (["ArrowRight", "ArrowLeft"].includes(a.key) && a.target instanceof HTMLInputElement && a.target.selectionEnd !== null && a.target.selectionStart !== null) {
          if (a.target.selectionStart === 0 && a.target.selectionEnd === ((f = d.props.inputText) === null || f === void 0 ? void 0 : f.length)) a.key === "ArrowLeft" ? t(0) : t(-1);
          else if (!d.props.searchValue) {
            d.props.searchValue = null;
            const A = ng(d), I = (g = A[A.length - 1]) === null || g === void 0 ? void 0 : g.end;
            a.target.selectionStart < I && (a.target.selectionStart = Math.max(0, a.key === "ArrowLeft" ? a.target.selectionStart - 2 : a.target.selectionEnd + 2));
          }
        } else if (["Delete", "Backspace"].includes(a.key)) d.props.highlightedRange && !d.props.searchValue ? (C_(d, d.props.highlightedRange.option), d.props.inputStd.length === 0 && (d.props.highlightedRange = void 0)) : a.target instanceof HTMLInputElement && (d.props.searchValue = null, t(-1, !0) && a.preventDefault());
        else if (a.target instanceof HTMLInputElement && a.target.selectionStart === 0 && a.target.selectionEnd === ((x = d.props.inputText) === null || x === void 0 ? void 0 : x.length) && (!(($ = d.props.inputText) === null || $ === void 0) && $.length) && d.props.selections.length === 0) a.preventDefault();
        else if (a.key === "Tab") return;
        a.key === "ArrowLeft" && t(-1, !0) && a.preventDefault();
      }(e, c);
    };
    const r = e.context.handlers.focus;
    e.context.handlers.focus = (c) => {
      r(e, c);
      const d = new Event("selectionchange");
      document.dispatchEvent(d);
    }, e.on("blur", () => {
      e.props.selections.length ? (e.props.inputText = e.props.selections.map((c) => c.label).join(", "), e.props.searchValue = null) : e.props.selections.length || (e.props.inputText = "", e.props.searchValue = "");
    });
  }), e.on("prop:expanded", ({ payload: i }) => {
    i || e.props.inputStd.length ? i && (e.props.options.length && !e.props.alwaysLoadOnOpen || (e.props.options = [], el(e, e.props.searchValue))) : (e.props.searchValue = "", e.props.inputText = "");
  }), e.on("prop:selections", () => {
    var i;
    const r = [...e.props.selections].map((d) => d.label).join(", ");
    let c = "";
    if (Og && e.isCreated) {
      const d = (i = e.props.__root) === null || i === void 0 ? void 0 : i.getElementById(`${e.props.id}`);
      if (zd() === d && Array.isArray(e._value) && e._value.length) {
        if (e.props.max && e._value.length >= Number(e.props.max)) return;
        c = ", ";
      }
    }
    e.props.inputText = `${r}${c}`, e.props.reloadOnCommit && (e.props.searchValue = "", el(e, e.props.searchValue));
  });
  const t = (i, r = !1) => {
    var c, d;
    const a = (c = e.props.__root) === null || c === void 0 ? void 0 : c.getElementById(`${e.props.id}`);
    if (!(a instanceof HTMLInputElement)) return !1;
    const f = ng(e), g = i >= 0 ? i : f.length - 1;
    if (f[g] === void 0) return !1;
    const x = (d = f[g]) === null || d === void 0 ? void 0 : d.end;
    return a.selectionStart !== null && (!r || a.selectionStart >= x && a.selectionStart <= x + 2) && (a.selectionStart = f[g].start + (g > 0 ? 1 : 0), a.selectionEnd = f[g].end + (g < f.length - 1 ? -1 : 0), !0);
  };
  let n;
  e.on("selectRange", ({ payload: i }) => t(...i)), e.on("prop:highlightedRange", ({ payload: i }) => {
    e.props.hasHighlightedRange = !!i, i && e.props.expanded && n !== i.option && (n = i.option, r$(e));
  });
}
function VT(e) {
  var t;
  if (!Og) return;
  const n = (t = e.props.__root) === null || t === void 0 ? void 0 : t.getElementById(`${e.props.id}`);
  n && n.scrollTo({ left: n.scrollWidth, behavior: "smooth" });
}
function UT(e, t) {
  var n;
  const i = e.props.highlightedRange, r = i.index, c = i.start + (r ? 1 : 0), d = t.length - 1 > r ? t[t.length - 1].end - t[r + 1].start : 0;
  return [c, ((n = e.props.inputText) === null || n === void 0 ? void 0 : n.length) - d + (t.length - 1 > i.index ? -1 : 0)];
}
function ng(e) {
  const t = i$(e);
  return Array.isArray(t) && t.length ? t.reduce((n, i, r) => {
    var c;
    const d = ((c = n[r - 1]) === null || c === void 0 ? void 0 : c.end) || 0;
    let a = 0;
    return t.length - 1 !== r && a++, r !== 0 && a++, n.push({ option: i, index: r, start: d, end: d + i.label.length + a }), n;
  }, []) : [];
}
function d3(e) {
  (function(t) {
    t.on("prop:expanded", ({ payload: n }) => {
      n ? (t.props.searchValue = "", t.props.options.length && !t.props.alwaysLoadOnOpen || (t.props.options = [], el(t, t.props.searchValue, !0))) : (t.props.searchValue = "", t.props.inputText = "");
    });
  })(e), function(t) {
    t.on("handleSearchInput", ({ payload: n }) => {
      n && !t.props.expanded ? (t.props.searchExpand = !0, t.props.expanded = !0) : !n && t.props.expanded && (t.props.expanded = !1), t.props.searchValue = t.props.inputText;
    });
  }(e), function(t) {
    t.on("prop:selections", () => {
      t.isCreated && (t.props.inputText = "", t.props.searchValue = "", t.props.optionRemoved || t.props.reloadOnCommit && el(t, t.props.searchValue, !0));
    });
  }(e);
}
function P$e(e) {
  (function(t) {
    function n(r) {
      r.props.inputStd.length === 0 ? (r.props.inputText = "", r.props.searchValue = "") : (r.props.inputText = r.props.selections[0].label, r.props.searchValue = r.props.selections[0].label);
    }
    function i(r) {
      r.props.clearSearchOnOpen && !r.props.searchExpand && (r.props.inputText = "", r.props.searchValue = ""), r.props.searchValue = r.props.inputText, r.props.options.length && !r.props.alwaysLoadOnOpen || r.props.searchExpand || (r.props.options = [], el(r, r.props.searchValue, !0)), r.props.searchExpand && (r.props.searchExpand = !1);
    }
    t.on("prop:expanded", ({ payload: r }) => {
      r ? i(t) : n(t);
    });
  })(e), function(t) {
    t.on("handleSearchInput", ({ payload: n }) => {
      n === "" ? (t.props.inputStd.length === 0 && (t.props.expanded = !1), t.input(void 0)) : n && !t.props.expanded && (t.props.searchExpand = !0, t.props.expanded = !0), t.props.searchValue = t.props.inputText;
    });
  }(e), function(t) {
    t.on("prop:selections", ({ payload: n }) => {
      t.props.inputText = n.length ? n[0].label : "", t.props.searchValue = n.length ? n[0].label : "", t.isCreated && t.props.expanded && n.length === 0 && el(t, t.props.searchValue, !0);
    });
  }(e);
}
function M$e(e) {
  if (e.props.multiple) if (e.props.multiple && e.props.selectionAppearance === "option") {
    let t = function() {
      return Array.isArray(e.value) ? e.value : [];
    }, n = function(i) {
      e.input(i);
    };
    d3(e), e.on("created", () => {
      e.props.disabled && (e.props.draggable = !1), Pr(`${e.props.id}_selections`, (i) => {
        if (i instanceof HTMLElement && e.context) {
          const r = { draggingClass: e.context.classes.dragging, dropZoneClass: e.context.classes.dropZone, root: e.props.__root, disabled: !e.props.draggable, plugins: [__()], touchDraggingClass: e.context.classes.touchDragging, touchDropZoneClass: e.context.classes.touchDropZone, draggable: (c) => c.hasAttribute("data-is-selection") };
          es({ parent: i, getValues: t, setValues: n, config: r }), e.on("prop:disabled", ({ payload: c }) => {
            r.disabled = c, es({ parent: i, getValues: t, setValues: n, config: r });
          }), e.on("prop:draggable", ({ payload: c }) => {
            r.disabled = !c, es({ parent: i, getValues: t, setValues: n, config: r });
          });
        }
      }, e.props.__root);
    });
  } else e.props.multiple && e.props.selectionAppearance === "text-input" && E$e(e);
  else P$e(e);
}
const D$e = { schema: /* @__PURE__ */ m$e(/* @__PURE__ */ v$e(/* @__PURE__ */ y$e("$label"), /* @__PURE__ */ g$e(/* @__PURE__ */ xc("prefix"), /* @__PURE__ */ _$e(), /* @__PURE__ */ C$e(), /* @__PURE__ */ sn("$multiple !== true && $selectionAppearance === option && $expanded === false", /* @__PURE__ */ OT(/* @__PURE__ */ DT(/* @__PURE__ */ LT(/* @__PURE__ */ FT(/* @__PURE__ */ sn("$state.loading", /* @__PURE__ */ NT("$ui.isLoading.value"), "$option.label"))), /* @__PURE__ */ sn("$state.loading && $isSingleOption !== true && $optionLoaderValues.includes($option.value)", /* @__PURE__ */ xc("loader")), /* @__PURE__ */ sn("$selectionRemovable && $isSingleOption", /* @__PURE__ */ z0(/* @__PURE__ */ xc("close")))))), /* @__PURE__ */ sn("$state.loading && ($isSingleOption !== true || $selections.length === 0)", /* @__PURE__ */ xc("loader")), /* @__PURE__ */ sn('$selectionRemovable && $selectionAppearance === "text-input" && $selections.length > 0', /* @__PURE__ */ z0(/* @__PURE__ */ xc("close")), /* @__PURE__ */ sn('$selectionAppearance === "text-input" || ($selectionAppearance === "option" && $multiple)', /* @__PURE__ */ MT(/* @__PURE__ */ xc("select")))), /* @__PURE__ */ sn("$isSingleOption && ($inputStd.length === 0 || $selectionRemovable === undefined || ($expanded) || $state.loading || $optionLoaderValues.length > 0)", /* @__PURE__ */ MT(/* @__PURE__ */ xc("select"))), /* @__PURE__ */ k$e(), /* @__PURE__ */ b$e(), /* @__PURE__ */ xc("suffix")), /* @__PURE__ */ sn("$multiple && $selectionAppearance === option", /* @__PURE__ */ OT(/* @__PURE__ */ DT(/* @__PURE__ */ LT(/* @__PURE__ */ FT(/* @__PURE__ */ sn("$state.loading && $isLoadingOption", /* @__PURE__ */ NT("$ui.isLoading.value"), "$option.label"))), /* @__PURE__ */ z0(/* @__PURE__ */ xc("close")))))), /* @__PURE__ */ w$e("$help"), /* @__PURE__ */ x$e(/* @__PURE__ */ $$e("$message.value"))), type: "input", family: "dropdown", props: [], features: [
  /* @__PURE__ */ Qn("select", "select"),
  /* @__PURE__ */ Qn("close", "close"),
  /* @__PURE__ */ Qn("selected", "check"),
  /* @__PURE__ */ Qn("loader", "spinner"),
  /* @__PURE__ */ bi("isLoading"),
  /* @__PURE__ */ bi("loadMore"),
  /* @__PURE__ */ bi("remove"),
  /* @__PURE__ */ bi("open"),
  /* @__PURE__ */ bi("close"),
  Zl,
  /* @__PURE__ */ o$.bind(null, S$e, c3, M$e),
  iv
] }, mi = /* @__PURE__ */ $o("dp"), { outer: L$e, wrapper: O$e, inner: N$e, icon: vd, label: F$e, prefix: R$e, suffix: z$e, help: B$e, messages: V$e, message: U$e } = /* @__PURE__ */ Co(mi), H$e = mi("input", () => ({ $el: "input", bind: "$attrs", attrs: { name: "$node.name", id: "$id", onKeydown: "$handlers.inputKeydown", value: "$inputText", onInput: "$handlers.dateInput", onClick: "$pickerOnly && $handlers.open", onBlur: "$handlers._blur", onFocus: "$handlers.focus", readonly: "$pickerOnly || $expanded", disabled: "$disabled" } })), W$e = mi("panelWrapper", () => ({ $el: "div", if: "$expanded", attrs: { id: '$id + "_popover"', role: "dialog", onBlur: "$handlers._blurOut()", tabindex: "-1", popover: "$popover", "aria-modal": "true", "aria-label": "Choose date", "data-panel": "$panel", style: { if: "$usePopover", then: { margin: 0, top: '$popoverCoordinates.y + "px"', left: '$popoverCoordinates.x + "px"', width: '$popoverCoordinates.width + "px"' } } } })), Z$e = mi("next", () => ({ $el: "button", if: "$showPagination", attrs: { id: "$id + _next_button", type: "button", onClick: "$handlers.next" } })), q$e = mi("nextLabel", "span"), j$e = mi("prev", () => ({ $el: "button", if: "$showPagination", attrs: { id: "$id + _prev_button", type: "button", onClick: "$handlers.prev" } })), G$e = mi("prevLabel", "span"), Y$e = mi("calendar", () => ({ if: '$panel === "day"', $el: "table", for: ["month", "$calendar"], attrs: { key: '$fns.format($month.monthDay, "YYYY-MM")' } })), K$e = mi("calendarWeeks", () => ({ $el: "tbody" })), X$e = mi("calendarHeader", () => ({ $el: "thead" })), J$e = mi("weekDays", () => ({ $el: "tr" })), Q$e = mi("weekDay", () => ({ $el: "th", for: ["day", "$month.weeks.0"], attrs: { "aria-label": '$fns.format($day, "dddd")' } })), e2e = mi("week", () => ({ $el: "tr", for: ["week", "weekIndex", "$month.weeks"] })), t2e = mi("dayCell", () => ({ $el: "td", for: ["day", "dayIndex", "$week"], attrs: { key: "$day", onClick: "$handlers.setDate($day)", onKeydown: "$handlers.keyDown", onMouseenter: "$handlers.mouseEnter($day)", onMouseleave: "$handlers.mouseLeave", onBlur: "$handlers._blurOut(day)", tabindex: '$fns.sameDay($day) && "0" || "-1"', "data-is-extra": "$fns.notInMonth($month.monthDay, $day)", "data-disabled": "$fns.isDisabled($day)", "aria-selected": "$selectedWeek === $weekIndex && $selectedDay === $dayIndex", "aria-label": '$fns.format($day, "long")' } })), n2e = mi("day", "div"), i2e = mi("openButton", () => ({ $el: "div", attrs: { style: "$visibilityStyles", id: '$id + "_listbox_button"', type: "div", role: "button", onClick: "$handlers.open", onKeydown: "$handlers.openKeydown", tabIndex: '$pickerOnly && "-1" || "0"', "data-disabled": "$disabled", "aria-disabled": "$disabled", "aria-label": '$value && ($ui.changeDate.value + ", " + $inputText) || $ui.chooseDate.value', "aria-haspopup": "true", "aria-expanded": "$expanded", "aria-controls": '$expanded && $id + "_listbox" || undefined' } })), r2e = mi("years", () => ({ if: '$panel === "year"', $el: "ul", attrs: { id: '$id + "_years"' } })), s2e = mi("year", () => ({ for: ["year", "$years"], $el: "li", attrs: { key: '$: "year" + $fns.format($year, "YYYY")', onClick: "$handlers.setDate($year)", onKeydown: "$handlers.keyDown", onMouseenter: "$handlers.mouseEnter($year)", onMouseleave: "$handlers.mouseLeave", onBlur: "$handlers._blurOut(year)", tabindex: '$fns.sameYear($year) && "0" || "-1"', "aria-selected": "$selectedYear === $year", "data-disabled": "$fns.isDisabledYear($year)", "data-test": "$year", "aria-label": "$fns.format($year, $yearFormat)" } })), o2e = mi("months", () => ({ if: '$panel === "month"', $el: "ul" })), a2e = mi("month", () => ({ $el: "li", for: ["month", "index", "$months"], attrs: { key: "$month", onClick: "$handlers.setDate($month)", onKeydown: "$handlers.keyDown", onMouseenter: "$handlers.mouseEnter($month)", onMouseleave: "$handlers.mouseLeave", onBlur: "$handlers._blurOut(month)", tabindex: '$fns.sameMonth($month) && "0" || "-1"', "aria-selected": "$selectedMonth === $month", "data-disabled": "$fns.isDisabledMonth($month)" } })), l2e = mi("panelHeader", () => ({ $el: "header", attrs: { "aria-live": "polite" } })), c2e = mi("yearsHeader", () => ({ $el: "div", if: '$panel === "year"' })), u2e = mi("monthsHeader", () => ({ $el: "div", if: '$panel === "month"' })), d2e = mi("daysHeader", () => ({ $el: "div", if: '$panel === "day"' })), p2e = mi("timeHeader", () => ({ $el: "div", if: '$panel === "time"' })), V0 = mi("yearButton", () => ({ $el: "button", attrs: { type: "button", id: "$id + _year_button", onClick: "$handlers.jumpTo(year)" }, children: "$fns.format($renderedDate, $yearFormat)" })), HT = mi("monthButton", () => ({ $el: "button", attrs: { type: "button", id: "$id + _month_button", onClick: "$handlers.jumpTo(month)" }, children: "$fns.format($renderedDate, $monthButtonFormat)" })), h2e = mi("dayButton", () => ({ $el: "button", attrs: { type: "button", id: "$id + _day_button", onClick: "$handlers.jumpTo(day)", tabindex: "2" }, children: "$fns.format($renderedDate, $dayButtonFormat)" })), f2e = mi("removeSelection", () => ({ $el: "button", if: "$clearable && $_value", attrs: { id: '$id + "_remove_selection"', type: "button", onClick: "$handlers.clear", "aria-controls": "$id" } })), m2e = mi("time", () => ({ $el: "div", if: '$panel === "time"' })), v2e = mi("timeInput", () => ({ $el: "input", attrs: { type: "time", value: "$localTime", onInput: "$handlers.localTime", onKeydown: "$handlers.keyDown", spellcheck: "false", onBlur: "$handlers._blurOut(time)" } })), g2e = mi("panelClose", () => ({ $el: "button", if: "$showPanelClose && ($inline === undefined || $inline === false)", attrs: { type: "button", class: "$classes.panelClose", onClick: "$handlers.closePanel", tabindex: -1, "aria-label": "$ui.close.value" } })), { overlayPlaceholder: y2e, overlayLiteral: _2e, overlayChar: b2e, overlayEnum: w2e, overlay: x2e, overlayParts: $2e, overlayInner: C2e } = /* @__PURE__ */ ZL(mi), k2e = mi("panel", "div"), Pc = /* @__PURE__ */ new WeakMap(), Dh = /* @__PURE__ */ new WeakMap(), Lh = /* @__PURE__ */ new WeakSet(), S2e = /* @__PURE__ */ new WeakMap(), S_ = /* @__PURE__ */ new WeakMap(), i1 = /* @__PURE__ */ new WeakSet(), Su = /* @__PURE__ */ new WeakMap(), By = /[\uD800-\uDBFF]/, wd = /* @__PURE__ */ new WeakMap(), U0 = /* @__PURE__ */ new WeakMap(), H0 = /* @__PURE__ */ new WeakMap(), mm = /* @__PURE__ */ new WeakMap(), Ng = /* @__PURE__ */ new WeakMap(), fh = /* @__PURE__ */ new WeakSet(), nf = /* @__PURE__ */ new WeakMap(), T_ = /* @__PURE__ */ new WeakMap(), W0 = /* @__PURE__ */ new WeakMap(), Pd = /* @__PURE__ */ new WeakMap();
let r1 = !1;
const WT = () => {
  r1 = !0, setTimeout(() => {
    r1 = !1;
  }, 500);
}, T2e = { "#": { type: "char", pattern: /\d/, token: "#", placeholder: "_", selectDirection: "right" }, a: { type: "char", pattern: /[a-zA-Z]/, token: "a", placeholder: "_", selectDirection: "left" }, h: { type: "char", pattern: /[0-9a-fA-F]/, token: "h", placeholder: "_", selectDirection: "left" }, "*": { type: "char", pattern: /./, token: "*", placeholder: "_", selectDirection: "left" } }, ZT = /* @__PURE__ */ new WeakMap(), Lm = typeof window < "u";
let Fg = !1, qT = !1;
function I2e() {
  Lm && !qT && (qT = !0, document.addEventListener("selectionchange", () => {
    const e = zd();
    if (!(e instanceof HTMLInputElement)) return;
    if (Pd.has(e)) return function(n) {
      const i = Pd.get(n);
      if (i) {
        const [r, c] = i, [d, a] = wo(n), f = a.indexOf(r);
        if (f === -1) return void Pd.delete(n);
        const g = d[f], x = [g[0] + c[0], g[1], "none"];
        Bd(Fl(n), x) || Vy(n, x);
      }
    }(e);
    if (Su.get(e) !== "select") return;
    const t = Fl(e);
    if (!Bd(t, ZT.get(e))) {
      if (ZT.set(e, t), Lh.has(e)) return Lh.delete(e);
      e.dispatchEvent(new CustomEvent("selection", { detail: Fl(e) }));
    }
  }));
}
function a$(e, t, n) {
  var i;
  if (I2e(), Pc.has(e)) return;
  Pc.set(e, []), t.reverse && fh.add(e), t.prefix && nf.set(e, t.prefix), t.suffix && T_.set(e, t.suffix), h3(e, t.pattern, t.partOverrides, t.explicitParts);
  const r = S_.get(e), c = r == null ? void 0 : r.some((g) => Rc(g)), d = r == null ? void 0 : r.some((g) => function(x) {
    return !!x && x.type === "group" && Array.isArray(x.parts);
  }(g));
  if (c && d) throw new Error("Cannot use enums and groups in the same mask.");
  const a = c ? "select" : (i = t.mode) !== null && i !== void 0 ? i : "shift";
  if (d && a === "select") throw new Error("Cannot use groups in select mode.");
  (t.placeholder || a === "select") && i1.add(e), Su.set(e, a), t.onChange && mm.set(e, t.onChange);
  let f = !1;
  e.addEventListener("beforeinput", (g) => {
    if (Fg || g.inputType === "insertLineBreak") return;
    if (g.inputType.startsWith("history")) return function(O, B) {
      O.addEventListener("input", (H) => {
        var N;
        H.preventDefault(), H.stopImmediatePropagation();
        const K = Pc.get(O);
        if (K != null && K.length) {
          const U = ((N = Dh.get(O)) !== null && N !== void 0 ? N : K.length - 1) + (B.endsWith("Undo") ? -1 : 1), q = K[U];
          if (!q) return;
          m3(O, q), O.setSelectionRange(...q.selectionAfter), Dh.set(O, U), mm.has(O) && mm.get(O)(q, O);
        }
      }, { once: !0 });
    }(e, g.inputType);
    g.preventDefault(), f = !0;
    const x = ($ = g.inputType).startsWith("insert") ? "insert" : !!$.startsWith("delete") && ($ === "deleteContentForward" ? "deleteContentForward" : "deleteContentBackward");
    var $;
    const A = Fl(e), I = e.value;
    x && Om(e, { type: x, selectionBefore: A, data: g.data, valueBefore: I, suffix: t.suffix, prefix: t.prefix });
  }), e.addEventListener("input", (g) => {
    f = !1, "data" in g || !f && n && (n.input(e.value, !1), n.props._maskValue = e.value);
  }), a === "select" && e.addEventListener("keydown", (g) => {
    switch (g.key) {
      case "ArrowRight":
        return g.preventDefault(), Z0(e);
      case "ArrowLeft":
        return g.preventDefault(), Z0(e, -1);
      case "ArrowUp":
        return void (tI(e, 1) && g.preventDefault());
      case "ArrowDown":
        return void (tI(e, -1) && g.preventDefault());
      case "Tab":
        return r1 ? void g.preventDefault() : void (Z0(e, g.shiftKey ? -1 : 1) && g.preventDefault());
    }
  }), e.addEventListener("focus", () => function(g) {
    var x;
    const $ = i1.has(g), A = Su.get(g);
    if ($) {
      let I = null, O = null, B = !1;
      const H = A === "shift" ? 0 : 1, N = g.value;
      o1(g, { data: N, selectionBefore: [0, 0, "none"] }, A === "shift" ? "" : N, (U, q) => (I === null && q.type === "char" && (I = U.pos - H), (Mc(q) || Rc(q)) && U.value.endsWith(q.placeholder) ? (O = U.pos - H, !1) : (q.type === "char" && (B = !0), !0)));
      const K = (x = O ?? (B ? N.length : I)) !== null && x !== void 0 ? x : null;
      if (K !== null) {
        let U = [K, K, "none"];
        if (Su.get(g) === "select") {
          const [q] = wo(g), ee = Dc(g, U);
          ee !== void 0 && ee in q && (U = q[ee]);
        }
        return function(q, ee, te = 50) {
          wd.set(q, vm(q, ee));
          const ae = async () => {
            if (!Lm || zd() !== q) return;
            Su.get(q) === "select" && (await new Promise((de) => setTimeout(de, 10)), function(de) {
              let me = Fl(de);
              if (me[0] === me[1] && me[0] === 0 || de.value.length === me[1] && me[0] === 0) return;
              me = s1(de, me);
              const [ve] = wo(de), re = Dc(de, me), le = me[0];
              re !== void 0 && ve.some((pe) => le >= pe[0] && le < pe[1]) && wd.set(de, vm(de, ve[re]));
            }(q));
            const oe = wd.get(q);
            oe && q.setSelectionRange(...oe);
          };
          ae(), document.addEventListener("selectionchange", ae), setTimeout(() => {
            document.removeEventListener("selectionchange", ae), wd.delete(q);
          }, te);
        }(g, U);
      }
    }
  }(e)), e.addEventListener("selection", (g) => function(x, $) {
    if (wd.get(x)) return;
    C3(x), $ = s1(x, $);
    const [A] = wo(x), I = Dc(x, $), O = I !== void 0 && vm(x, A[I]);
    O && !Bd($, O) && Vy(x, O, !0);
  }(e, g.detail)), Om(e, { type: "insert", selectionBefore: [0, 0, "forward"], data: e.value, valueBefore: "", suffix: t.suffix, prefix: t.prefix });
}
function jT(e) {
  var t, n;
  if (Pd.has(e)) return;
  const i = (t = Pc.get(e)) !== null && t !== void 0 ? t : [], r = i[(n = Dh.get(e)) !== null && n !== void 0 ? n : i.length - 1];
  if (r) {
    const c = r.selectionAfter, [d, a] = wo(e, r.valueAfter), f = Dc(e, c, [d, a]);
    if (f !== void 0 && f in d) {
      const g = a[f], x = d[f], $ = [c[0] - x[0], c[1] - x[0], "none"];
      Pd.set(e, [g, $]);
    }
  }
}
function GT(e) {
  Pd.delete(e);
}
function YT(e, t, n) {
  const i = typeof e == "string" || !Pc.has(e), r = typeof e == "string" ? p3(e) : e;
  if (i) t.prefix && nf.set(r, t.prefix), t.suffix && T_.set(r, t.suffix), r.value = l$(r, r.value), a$(r, t, n);
  else {
    const c = c$(r), d = r.value;
    r.value = "", Om(r, { type: "insert", selectionBefore: [0, c ? c.valueAfter.length : 0, "none"], valueBefore: c ? c.valueAfter : "", data: d, suffix: t.suffix, prefix: t.prefix });
  }
  return r.value;
}
function p3(e) {
  return { value: e, selectionStart: 0, selectionEnd: 0, scrollWidth: 0, clientWidth: 0, addEventListener: () => {
  }, dispatchEvent: () => {
  }, setSelectionRange: () => {
  } };
}
function h3(e, t, n, i, r) {
  r = e && fh.has(e) || r;
  const c = (i ?? function(A) {
    const I = Object.values(T2e);
    if (!A) return I;
    const O = { ...A }, B = [];
    for (const N of I) if (!Oh(N)) if ("token" in N && N.token in A) {
      const K = { ...N, ...A[N.token] };
      KT(K) && B.push(K), delete O[N.token];
    } else B.push(N);
    const H = Object.values(O);
    for (const N of H) KT(N) ? B.push(N) : console.warn(`Invalid ${N.type} token`, N);
    return B;
  }(n)).sort((A, I) => {
    const O = "token" in A ? A.token.length : -1, B = "token" in I ? I.token.length : -1;
    return O === B ? 0 : O > B ? -1 : 1;
  });
  let d = [];
  [t, d] = function(A, I, O, B) {
    let H, N = 0, K = "", U = "", q = "";
    const ee = [];
    for (; K = so(A); ) K === I && H !== B ? (N++, N > 1 && (q += K)) : K === O && N && H !== B ? (N--, N === 0 ? (U += `{$${ee.length}}`, ee.push(q), q = "") : q += K) : N ? q += K : H !== B || K !== I && K !== O ? U += K : U = `${U.substring(0, U.length - 1)}${K}`, H = K, A = A.substring(K.length);
    return [U, ee];
  }(t, "{", "}", "\\");
  const a = d.length;
  t = c.reduce((A, I, O) => "token" in I ? A.replaceAll(`\\${I.token}`, "{“!”}").replaceAll(I.token, `{$${a + O}}`).replaceAll("{“!”}", I.token) : A, t);
  const f = function(A, I, O) {
    return A.reduce((B, H) => {
      const [N, K] = function(ee) {
        const [te, ...ae] = ee.split("|"), oe = ae.reduce((de, me) => {
          const [ve, re = !0] = me.split(":");
          return Object.assign(de, { [ve]: re });
        }, {});
        return [te, oe];
      }(H);
      let U = h3(null, N, void 0, I, O);
      U = U.map((ee) => {
        const te = { ...ee };
        if (te.type === "char" && K.placeholder) te.placeholder = K.placeholder;
        else if (te.type === "enum") throw new Error("Groups cannot contain enums.");
        return te;
      });
      const q = { type: "group", parts: U, ...K };
      return B.push(q), B;
    }, []);
  }(d, c, r).concat(c), g = /\{\$\d+\}/g, x = t.match(g), $ = t.split(g).reduce((A, I, O) => {
    if (I && (I = I.replaceAll("\\", ""), A.push({ type: "literal", value: r ? [...I].reverse().join("") : I })), x && x[O]) {
      const B = x[O], H = Number(B.substring(2, B.length - 1));
      !isNaN(H) && f[H] && A.push(f[H]);
    }
    return A;
  }, []);
  return r && $.reverse(), e && S_.set(e, $), $;
}
function KT(e) {
  return !!e && (Oh(e) || Mc(e) || Rc(e));
}
function Mc(e) {
  return !!e && e.type === "char" && e.pattern instanceof RegExp && f3(e);
}
function Rc(e) {
  return !!e && e.type === "enum" && Array.isArray(e.values) && f3(e);
}
function f3(e) {
  return !!e && "placeholder" in e && "token" in e;
}
function Oh(e) {
  return !!e && e.type === "literal" && typeof e.value == "string";
}
function Bd(e, t) {
  return e === t || e !== void 0 && t !== void 0 && e[0] === t[0] && e[1] === t[1];
}
function Fl(e) {
  var t, n;
  return [(t = e.selectionStart) !== null && t !== void 0 ? t : e.value.length, (n = e.selectionEnd) !== null && n !== void 0 ? n : e.value.length, "none"];
}
function Om(e, t) {
  var n;
  fh.has(e) && nI(t);
  let i = !1;
  switch (Ng.set(e, "playing"), t.type) {
    case "insert":
      i = function(r, c) {
        let d = XT(c);
        const a = c.selectionBefore, f = function(x, $) {
          var A, I, O;
          if (Su.get(x) === "select") {
            const [B, H] = wo(x), N = B.findIndex((U) => Bd(U, $.selectionBefore)), K = (A = H[N]) !== null && A !== void 0 ? A : null;
            if (Mc(K)) {
              const U = $.selectionBefore, q = U[1] - U[0], ee = $.valueBefore.substring(U[0], U[1]), te = K.selectDirection === "left", ae = g3(ee, K), oe = te ? 0 : function(me, ve, re) {
                if (!me) return 0;
                let le = "";
                for (; me.length; ) {
                  const pe = so(me);
                  me = me.substring(pe.length), ve.pattern.test(pe) && (le += pe);
                }
                return Math.min(Math.max(le.length, 1), re);
              }($.data, K, q);
              if (ae.length >= q) return te || ($.insertPos = U[1] - oe), ((I = K.selectFill) !== null && I !== void 0 ? I : K.placeholder).repeat(q);
              const de = ((O = K.selectFill) !== null && O !== void 0 ? O : K.placeholder).repeat(q - ae.length - (te ? 0 : oe));
              return $.insertPos = te ? U[0] + ae.length : U[1] - oe, K.selectDirection === "left" ? `${ae}${de}` : `${de}${ae}${K.placeholder}`;
            }
            if (Rc(K)) {
              const U = $.selectionBefore;
              return $.valueBefore.substring(U[0], U[1]);
            }
          }
          return "";
        }(r, c);
        d = `${d.substring(0, a[0])}${f}${d.substring(a[1])}`;
        const g = o1(r, c, d);
        return S2e.set(r, g.endPos), { ...c, valueAfter: g.value, selectionAfter: P2e(r, g), unmasked: g.unmasked, complete: g.complete, meta: g.meta };
      }(e, t);
      break;
    case "deleteContentBackward":
    case "deleteContentForward":
      i = function(r, c) {
        const d = XT(c), a = c.selectionBefore, f = fh.has(r);
        let g = a[0], x = a[1];
        g === x && (c.type !== "deleteContentBackward" || f ? x += Rg(d, g) : g -= Rg(d, g, "backward"));
        const $ = Su.get(r);
        let A = "";
        if ($ === "select") {
          const [B, H] = wo(r), N = Dc(r, [g, x, "none"]);
          if (N !== void 0) {
            const K = H[N], U = B[N];
            Mc(K) ? A = K.placeholder.repeat(x - g) : Rc(K) && ([A, g] = Bd(U, Fl(r)) ? [K.placeholder, g] : function(q, ee, te, ae) {
              const oe = ae.valueBefore, de = Rg(oe, ae.selectionBefore[0], "backward"), me = Math.max(te[0], ae.selectionBefore[0] - de), ve = oe.substring(te[0], me), re = sv(ee.values, ve);
              let le = re == null ? void 0 : re.substring(ve.length);
              return re && !le && _3(ee.values, re) && (le = re), [le ?? ee.placeholder, le ? me : te[0]];
            }(0, K, U, c));
          }
        }
        const I = `${d.substring(0, g)}${A}${d.substring(x)}`, O = o1(r, c, I);
        return { ...c, valueAfter: O.value, selectionAfter: O2e(r, O, c, g), unmasked: O.unmasked, complete: O.complete, meta: O.meta };
      }(e, t);
  }
  if (fh.has(e) && i && nI(i), i && function(r, c) {
    c.prefix && (c.valueAfter = c.prefix + c.valueAfter, c.selectionAfter = vm(r, c.selectionAfter)), c.suffix && (c.valueAfter += c.suffix);
  }(e, i), i && function(r) {
    return r.valueBefore !== r.valueAfter || r.selectionBefore[0] !== r.selectionAfter[0] || r.selectionBefore[1] !== r.selectionAfter[1];
  }(i)) {
    mm.has(e) && W0.set(e, () => {
      W0.delete(e), i && mm.get(e)(i, e);
    }), Ng.set(e, "beforeCallback");
    let r = (n = Pc.get(e)) !== null && n !== void 0 ? n : [];
    const c = Dh.get(e);
    c && (r = r.slice(0, c), Dh.delete(e)), r.push(i), Pc.set(e, r), Lm && zd() === e && typeof document.execCommand == "function" && !Fg ? (Vy(e, [0, e.value.length, "forward"], !0), Fg = !0, document.execCommand("insertText", void 0, i.valueAfter), Fg = !1) : m3(e, i), Lm && zd() === e && Vy(e, i.selectionAfter);
    const d = W0.get(e);
    d && d(), C3(e);
  }
  Ng.set(e, "complete");
}
function l$(e, t) {
  var n, i;
  const r = (n = nf.get(e)) !== null && n !== void 0 ? n : "", c = (i = T_.get(e)) !== null && i !== void 0 ? i : "";
  return r && t.startsWith(r) && (t = t.substring(r.length)), c && t.endsWith(c) && (t = t.substring(0, t.length - c.length)), t;
}
function vm(e, t) {
  const n = nf.get(e), i = [...t];
  return n && (i[0] += n.length, i[1] += n.length), i;
}
function s1(e, t) {
  const n = nf.get(e), i = [...t];
  return n && (i[0] -= n.length, i[1] -= n.length), i;
}
function XT(e) {
  let t = e.valueBefore;
  const n = e.selectionBefore;
  if (e.suffix && t.endsWith(e.suffix) && (t = t.substring(0, t.length - e.suffix.length), e.valueBefore = t, n[0] >= t.length && (n[0] = t.length), n[1] >= t.length && (n[1] = t.length)), e.prefix && t.startsWith(e.prefix)) {
    const i = e.prefix.length;
    t = t.substring(i), e.valueBefore = t, n[0] = Math.max(n[0] - i, 0), n[1] = Math.max(n[1] - i, 0);
  }
  return t;
}
function Vy(e, t, n = !1) {
  n && (Lh.add(e), setTimeout(() => Lh.delete(e), 5)), wd.get(e) && wd.set(e, t), e.setSelectionRange(...t);
}
function m3(e, t, n = "After") {
  if (e.value = t[`value${n}`], Lm) {
    const i = new InputEvent("input", { inputType: t.type === "insert" ? "insertText" : t.type, data: t.data });
    e.dispatchEvent(i);
  }
}
function so(e) {
  if (e == null) return "";
  const t = By.test(e.charAt(0)) && By.test(e.charAt(1)) ? 2 : 1;
  return e.substring(0, t);
}
function Rg(e, t, n = "forward") {
  if (n === "backward") return t === 0 ? 0 : t === 1 ? 1 : By.test(e.charAt(t)) && By.test(e.charAt(t - 1)) ? 2 : 1;
  const i = e.length - t;
  return i === 0 ? 0 : i === 1 ? 1 : so(e.substring(t)).length;
}
function v3(e, t) {
  const n = so(e.data), i = n.length;
  if (e.value += n, e.pos += i, typeof e.data == "string" && (e.data = e.data.substring(i), e.data.length || (e.endPos = e.pos)), t) return t.substring(i);
}
function JT(e) {
  const t = so(e.buffer), n = t.length;
  e.value += t, e.pos += n, e.buffer = e.buffer.substring(n);
}
function A2e(e, t) {
  const n = so(t), i = n.length;
  return e.value += n, e.pos += i, t.substring(i);
}
function E2e(e, t) {
  for (; t.buffer; ) {
    const n = so(t.buffer);
    if (e.pattern.test(n) || t.placeholder && e.placeholder === n) return void (t.mode !== "replace" && t.mode !== "select" || (t.buffer = t.buffer.substring(n.length)));
    t.buffer = t.buffer.substring(n.length);
  }
}
function QT(e, t) {
  const n = e.values.concat([e.placeholder]).map((i) => i.toLowerCase()).sort((i, r) => i.length > r.length ? -1 : 1);
  for (; t.buffer; ) {
    const i = t.buffer.toLowerCase(), r = n.find((c) => i.startsWith(c));
    if (r) {
      const c = t.buffer.substring(0, r.length);
      return t.buffer = t.buffer.substring(r.length), c;
    }
    t.buffer = t.buffer.substring(Rg(t.buffer, 0));
  }
  return null;
}
function g3(e, t) {
  let n = e.replaceAll(t.placeholder, "");
  const i = t.selectDirection === "left";
  if (t.selectFill) {
    const c = new RegExp(`${i ? "" : "^"}${r = t.selectFill, r.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&")}+${i ? "$" : ""}`);
    n = n.replace(c, "");
  }
  var r;
  return n;
}
function P2e(e, t) {
  let n = [t.endPos, t.endPos, "forward"];
  if (t.mode !== "select") return n;
  const i = Fl(e);
  n = [i[0], t.endPos, "none"];
  const [r, c] = wo(e, t.value), d = Dc(e, n, [r, c]);
  if (d === void 0 || !(d in r) || !(d in c)) return n;
  const a = r[d], f = c[d], g = t.value.slice(a[0], a[1]);
  if (Mc(f) && g3(g, f).length === g.length && d < r.length - 1) return WT(), r[d + 1];
  if (Rc(f) && t.insertPos >= a[0] && t.insertPos <= a[1]) {
    if (t.cycle) return a;
    const x = function(A, I, O) {
      if (A.originalData === null) return 0;
      const B = A.insertPos >= I ? A.value.substring(I, A.insertPos) : "", H = `${B}${A.originalData}`, N = sv(O.values, H);
      return N ? y3(H, N).length - B.length : 0;
    }(t, a[0], f);
    if (t.insertPos + x === a[1]) return _3(f.values, g) ? [a[1], a[1], "forward"] : (WT(), r[d + 1] ? r[d + 1] : r[d]);
    const $ = [t.insertPos + x, a[1], "none"];
    return Bd($, i) || (Lh.add(e), setTimeout(() => Lh.delete(e), 5)), $;
  }
  return a;
}
function o1(e, t, n, i) {
  var r, c;
  const d = (r = S_.get(e)) !== null && r !== void 0 ? r : [], a = { pos: 0, insertPos: (c = t.insertPos) !== null && c !== void 0 ? c : t.selectionBefore[0], range: t.selectionBefore, chars: 0, placeholder: i1.has(e), buffer: n, data: t.data, originalData: t.data, value: "", mode: Su.get(e) || "replace", endPos: t.selectionBefore[0], rangeParts: wo(e), unmasked: "", complete: !0, cycle: t.cycle, meta: [] };
  return a1(d, a, void 0, i), a;
}
function a1(e, t, n, i) {
  var r, c;
  const d = { ...t };
  n != null && n.placeholder && (t.placeholder = !0);
  const a = n != null && n.repeat && ((r = n.nextPart) === null || r === void 0 ? void 0 : r.type) === "literal" ? n.nextPart.value : null;
  let f = 0;
  const g = e.reduce(($, A) => $ + (A.type === "char" ? 1 : 0), 0), x = t.chars;
  for (const $ of e) {
    const A = e[f + 1];
    switch ($.type) {
      case "literal":
        D2e($, t, e.at(-1) === $);
        break;
      case "char":
        L2e($, t, a);
        break;
      case "enum":
        M2e($, t);
        break;
      case "group":
        const O = { repeat: (c = $.repeat) !== null && c !== void 0 && c, nextPart: A, repeats: 0, placeholder: !!$.placeholder };
        a1($.parts, t, O, i);
    }
    if (i && i(t, $) === !1)
      break;
    const I = Oh(A) && f + 2 === e.length && x !== t.chars;
    if (!(t.buffer || t.data || t.placeholder || I)) break;
    f++;
  }
  if (t.chars < g && (t.complete = !1), n) {
    const $ = t.chars - x, A = $ === g, I = !(!t.data || a && t.data.startsWith(a) && t.insertPos <= t.pos), O = !(t.buffer && a && t.buffer.startsWith(a) && t.insertPos >= t.pos + a.length) && (t.buffer || I);
    if (n.repeat && O && A) return n.repeats++, a1(e, t, n, i);
    if (!A) {
      t.complete = !1;
      const B = e.reverse().find((H) => H.type === "literal");
      e.reverse(), Oh(B) && t.value.endsWith(B.value) && (t.value = t.value.substring(0, t.value.length - B.value.length), t.pos = t.value.length);
    }
    g > 1 && $ < g && $ !== 0 && t.insertPos <= t.pos ? t.data = "" : n.repeat && !A && n.repeats && Object.assign(t, d);
  }
  t.placeholder = d.placeholder;
}
function M2e(e, t) {
  const [n, i] = t.rangeParts, r = n[i.indexOf(e)];
  if (r && (t.insertPos <= t.pos || t.insertPos >= r[0] && t.insertPos <= r[1]) && t.data) {
    const c = t.buffer.substring(0, t.insertPos - t.pos), d = `${c}${t.data}`, a = sv(e.values.concat([e.placeholder]), d);
    if (a) {
      const f = y3(d, a);
      return t.data = t.data.substring(f.length), t.value += a, a !== e.placeholder ? t.unmasked += a : t.complete = !1, t.meta.push({ type: a !== e.placeholder ? "enum" : "placeholder", value: a }), c ? t.buffer = t.buffer.substring(c.length) : QT(e, t), t.endPos = t.pos + f.length, void (t.pos = t.value.length);
    }
    t.data = "";
  }
  if (t.buffer) {
    const c = QT(e, t);
    if (c) return t.value += c, c !== e.placeholder ? t.unmasked += c : t.complete = !1, t.meta.push({ type: c !== e.placeholder ? "enum" : "placeholder", value: c }), void (t.pos = t.value.length);
  }
  t.complete = !1, t.value += e.placeholder, t.meta.push({ type: "placeholder", value: e.placeholder }), t.pos = t.value.length;
}
function D2e(e, t, n) {
  let i = e.value;
  if (t.data === "" && !t.buffer && !t.placeholder && !n) return;
  let r = !1;
  for (; i; ) {
    const c = t.insertPos <= t.pos ? so(t.data) : "", d = so(i);
    if (c === d) i = v3(t, i), t.meta.push({ type: "literal", value: d }), r = !0;
    else if (!r || t.data || t.data === null || t.placeholder || n) i = A2e(t, i), t.meta.push({ type: "literal", value: d });
    else if (r && !t.data) break;
    t.buffer.startsWith(d) && (t.buffer = t.buffer.substring(d.length));
  }
  t.data === null && !t.buffer && t.insertPos <= t.pos && !t.placeholder && (t.value = t.value.substring(0, t.value.length - e.value.length), t.pos = t.endPos = t.value.length);
}
function L2e(e, t, n) {
  var i;
  let r = !0;
  if (t.insertPos <= t.pos) for (; !((i = t.data) === null || i === void 0) && i.length; ) {
    const c = so(t.data);
    if (e.pattern.test(c)) return v3(t), t.meta.push({ type: "char", value: c }), t.chars++, t.unmasked += c, void E2e(e, t);
    if (typeof t.data == "string") {
      if (n && t.data.startsWith(n)) {
        r = !1;
        break;
      }
      t.data = t.data.substring(c.length);
    }
  }
  for (; r && t.buffer; ) {
    const c = so(t.buffer);
    if (e.pattern.test(c)) return t.chars++, t.unmasked += c, JT(t), void t.meta.push({ type: "char", value: c });
    if (t.placeholder && c === e.placeholder) return JT(t), void t.meta.push({ type: "placeholder", value: c });
    if (typeof t.buffer == "string") {
      if (n && t.buffer.startsWith(n)) {
        t.buffer = t.buffer.substring(n.length);
        break;
      }
      t.buffer = t.buffer.substring(c.length);
    }
  }
  t.placeholder ? (t.value += e.placeholder, t.meta.push({ type: "placeholder", value: e.placeholder })) : t.endPos = t.pos;
}
function O2e(e, t, n, i) {
  const r = [i, i, "none"];
  if (t.mode === "select") {
    const c = wo(e), d = Dc(e, r, c), [a, f] = wo(e, t.value), g = d !== void 0 && eI(n.valueBefore, c[0][d], c[1][d]);
    if (d !== void 0 && d in a)
      return g ? a.slice(d).every(($, A) => eI(t.value, $, f[d + A])) && a[d - 1] ? a[d - 1] : a[d] : [i, a[d][1], "none"];
  }
  return r;
}
function eI(e, t, n) {
  if (Oh(n)) return !1;
  if (Mc(n)) {
    let i = t[0];
    for (; i < t[1]; ) {
      const r = so(e.substring(i));
      if (r !== n.placeholder) return !1;
      i += r.length;
    }
  }
  return !Rc(n) || e.substring(t[0], t[1]) === n.placeholder;
}
function y3(e, t) {
  let n = "";
  do {
    const i = so(e).toLowerCase(), r = so(t).toLowerCase();
    if (i !== r) break;
    n += i, e = e.substring(i.length), t = t.substring(r.length);
  } while (e.length && t.length);
  return n;
}
function wo(e, t) {
  const n = S_.get(e);
  if (!n) return [[], []];
  if (U0.has(e)) return U0.get(e);
  const i = t ?? l$(e, e.value), r = [], c = [];
  let d = null, a = null, f = 0, g = !0;
  for (const $ of n) if (Oh($)) d = $, a !== null && (r.push([a, f, "none"]), a = null), f += $.value.length;
  else {
    if (Mc(d) && Mc($) && $.token === d.token) f++;
    else if (Mc($)) a === null ? (a = f, c.push($)) : (r.push([a, f, "none"]), a = f, c.push($)), f++;
    else if (Rc($)) {
      a && r.push([a, f, "none"]), b3($) || (g = !1);
      const A = N2e(i, $, f);
      a = null, r.push([f, f + A, "none"]), c.push($), f += A;
    }
    d = $;
  }
  a !== null && r.push([a, f, "none"]);
  const x = [[...r], [...c]];
  return g && !t && U0.set(e, x), x;
}
function N2e(e, t, n) {
  if (b3(t)) return t.values[0].length;
  const i = e.slice(n), r = sv(t.values.concat([t.placeholder]), i);
  return r ? r.length : 0;
}
function sv(e, t, n = null, i) {
  var r;
  if (t.length === 0) return n;
  if (!i) {
    const g = e.find((x) => x.toLowerCase() === t.toLowerCase());
    if (g) return g;
  }
  const c = so(t.toLowerCase()), d = `${i ?? ""}${c}`, a = e.filter((g) => g.toLowerCase().startsWith(d)), f = a.find((g) => g.toLowerCase() === d);
  return f && (n = f), a.length === 0 ? n : a.length === 1 ? a[0] : (a.length > 1 && (n = a[0]), (r = sv(a, t.substring(c.length), n, d)) !== null && r !== void 0 ? r : a[0]);
}
function _3(e, t) {
  return t = t.toLowerCase(), e.some((n) => (n = n.toLowerCase()).startsWith(t.toLocaleLowerCase()) && n !== t);
}
function b3(e) {
  if (!H0.has(e) && Array.isArray(e.values) && e.values.length > 0) {
    const t = e.values[0].length;
    if (e.placeholder.length !== t) return !1;
    H0.set(e, e.values.every((n) => n.length === t));
  }
  return H0.get(e);
}
function Z0(e, t = 1) {
  const [n] = wo(e), i = Dc(e, s1(e, Fl(e)));
  return i !== void 0 && n[i + t] !== void 0 && (e.setSelectionRange(...vm(e, n[i + t])), !0);
}
function tI(e, t = 1) {
  const [n, i] = wo(e), r = Dc(e, Fl(e));
  if (r !== void 0 && r in i) {
    const c = i[r];
    if (Rc(c)) {
      const d = n[r], a = e.value.slice(d[0], d[1]);
      let f = null, g = c.values.indexOf(a);
      const x = c.values.length - 1;
      if (g !== -1) {
        const $ = g + t;
        g = $ < 0 ? x : $ > x ? 0 : $, f = c.values[g];
      } else a === c.placeholder && (f = t > 0 ? c.values[0] : c.values[x]);
      if (f !== null) {
        const $ = { selectionBefore: d, insertPos: d[0], type: "insert", data: f, valueBefore: e.value, cycle: !0 };
        return setTimeout(() => Om(e, $), 0), !0;
      }
    }
  }
  return !1;
}
function w3(e, t) {
  if (!e.length) return -1;
  if (e.length === 1) return e[0];
  const n = e.length / 2, i = Number.isInteger(n) ? n : Math.floor(n), r = Math.abs(t - e[i - 1]) < Math.abs(t - e[i]) ? [0, i] : [i];
  return w3(e.slice(...r), t);
}
function Dc(e, t, n) {
  const [i] = n ?? wo(e), r = i.findIndex((f) => f[0] !== f[1] && (!!Bd(f, t) || t[1] > f[0] && t[1] < f[1]));
  if (r !== -1) return r;
  const [c, d] = i.reduce((f, g, x) => (f[0].add(g[0]), f[0].add(g[1]), f[1][g[0]] = x, f[1][g[1]] = x, f), [/* @__PURE__ */ new Set(), {}]), a = w3([...c], t[0] === 0 && t[1] === e.value.length ? 0 : t[1]);
  return a in d ? d[a] : void 0;
}
function c$(e) {
  var t, n;
  const i = (t = Pc.get(e)) !== null && t !== void 0 ? t : [];
  return i[(n = Dh.get(e)) !== null && n !== void 0 ? n : i.length - 1];
}
function x3(e, t = !1) {
  const n = c$(e);
  return n && (n.complete || t) ? fh.has(e) ? [...n.unmasked].reverse().join("") : n.unmasked : t ? "" : null;
}
function $3(e) {
  var t;
  const n = c$(e);
  return (t = n == null ? void 0 : n.meta) !== null && t !== void 0 ? t : null;
}
function nI(e) {
  const t = (i) => [...i].reverse().join(""), n = (i, r) => [r - i[1], r - i[0], i[2]];
  e.data && (e.data = t(e.data)), e.valueBefore = t(e.valueBefore), "valueAfter" in e && (e.valueAfter = t(e.valueAfter)), "selectionAfter" in e && (e.selectionAfter = n(e.selectionBefore, e.valueAfter.length)), e.selectionBefore = n(e.selectionBefore, e.valueBefore.length);
}
function C3(e) {
  if (e.scrollWidth > e.clientWidth && e.selectionStart !== null && e.selectionEnd !== null) {
    const t = e.selectionStart / e.value.length, n = e.selectionEnd / e.value.length;
    e.scrollLeft = n > 0.9 ? e.scrollWidth : t * e.scrollWidth - 20, e.dispatchEvent(new CustomEvent("input-scroll", { bubbles: !1, detail: e.scrollLeft }));
  }
}
const iI = typeof window < "u", l1 = /* @__PURE__ */ new WeakSet(), q0 = /* @__PURE__ */ new WeakSet(), rI = /* @__PURE__ */ new WeakSet(), Uy = /* @__PURE__ */ new WeakMap(), k3 = /* @__PURE__ */ new WeakMap(), j0 = /* @__PURE__ */ new WeakSet(), c1 = /* @__PURE__ */ new WeakSet();
function S3(e) {
  e.props.selectedMonth = e.props.selectedYear = e.props.selectedDay = e.props.selectedWeek = void 0;
}
function T3(e) {
  var t, n, i;
  e.props.selectedMonth = e.props.months.findIndex((r) => A3(r, e.props.activeDate)), e.props.selectedYear = e.props.years.findIndex((r) => I3(r, e.props.activeDate));
  for (let r = 0; r < ((t = e.props.calendar[0]) === null || t === void 0 ? void 0 : t.weeks.length); r++) for (let c = 0; c < ((n = e.props.calendar[0]) === null || n === void 0 ? void 0 : n.weeks[r].length); c++) {
    const d = (i = e.props.calendar[0]) === null || i === void 0 ? void 0 : i.weeks[r][c];
    if (HL(d, e.props.activeDate)) {
      e.props.selectedWeek = r, e.props.selectedDay = c;
      break;
    }
  }
}
function gm(e) {
  return e.partName !== "timeZoneName";
}
function I3(e, t) {
  return t instanceof Date && e.getFullYear() === t.getFullYear();
}
function A3(e, t) {
  return t instanceof Date && e.getMonth() === t.getMonth();
}
function G0(e) {
  S3(e), e.props.selectedIndex = e.props.calendar = Mu(e.props.showMonths, (t) => t).map((t) => function(n, i) {
    const r = [], c = Ji(i);
    c.setDate(1);
    let d = WL(c, n.props.weekStart);
    d.setHours(c.getHours(), c.getMinutes(), c.getSeconds());
    const a = vwe(Oy(i), n.props.weekStart);
    let f = [];
    do
      f.push(d), f.length === 7 && (r.push(f), f = []), d = hh(d);
    while (d.getTime() <= a.getTime());
    return { monthDay: c, weeks: r };
  }(e, bu(e.props.renderedDate, t))), e.props.years = function(t) {
    const n = Number(Fo(t.props.renderedDate, "YYYY")), i = n - n % 10;
    return t.props.decade = `${i} - ${i + 9}`, Mu(10, (r) => Zp(t.props.renderedDate, i + r - n));
  }(e), e.props.months = function(t) {
    const n = Ji(t.props.renderedDate);
    return n.setMonth(0), Mu(12, (i) => bu(n, i));
  }(e), e.value && T3(e);
}
function F2e(e, t) {
  var n;
  t.target && t.target instanceof Element && (t.target.closest(`#${e.props.id}_popover`) || !(!((n = e.props.__root) === null || n === void 0) && n.contains(t.target))) || (e.props.expanded = !1);
}
function gd(e, t) {
  if (!t) return e.props.inputText = "", /* @__PURE__ */ new Date();
  const n = t instanceof Date ? t : yd(t, e.props.valueFormat, e.props.valueLocale);
  return e.props.inputText = e.props.formatDate(n, e.props.format, e.props.locale, !1, gm), n;
}
function sI(e) {
  return Array.isArray(e.props.sequence) ? Nu(e.props.sequence) : ["day"];
}
function Hf(e, t, n = !0) {
  var i, r;
  if (e._value === t) return;
  if (t == null) return e.input(t, n);
  e.props.offset = e.props.timezone ? Mm(t, e.props.timezone) : "+0000";
  const c = BL(t, (i = (r = e.props).offset) !== null && i !== void 0 ? i : r.offset = "+0000");
  e.input(Fo(c, e.props.valueFormat, e.props.valueLocale, !1), n);
}
function Y0(e, t) {
  var n;
  const i = ["prev_button", "month_button", "day_button", "year_button", "next_button"].find((c) => {
    var d;
    return (d = e.props.__root) === null || d === void 0 ? void 0 : d.getElementById(`${e.props.id}_${c}`);
  }), r = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${e.props.id}_${i}`);
  r instanceof HTMLElement && (t.preventDefault(), r.focus());
}
function R2e(e, t) {
  var n;
  let i = "";
  if (!(t instanceof HTMLInputElement) || e.props.pickerOnly) return;
  Uy.set(e, t), (n = e.props.__root) === null || n === void 0 || n.addEventListener("click", (d) => {
    e.props.expanded && d.target instanceof HTMLElement && d.target.closest(`#${e.props.id}_popover`) ? c1.add(e) : c1.delete(e);
  }), e.on("prop:inputText", ({ payload: d }) => {
    d !== t.value && (Ng.get(t) === "beforeCallback" && (i = t.value), jT(t), t.selectionStart = 0, t.selectionEnd = t.value.length, function(a, f) {
      var g, x;
      if (!Pc.has(a)) return;
      const $ = (g = nf.get(a)) !== null && g !== void 0 ? g : "", A = (x = T_.get(a)) !== null && x !== void 0 ? x : "";
      Om(a, { type: "insert", selectionBefore: Fl(a), data: f, valueBefore: a.value, suffix: A, prefix: $ });
    }(t, d), t.value = d, setTimeout(() => GT(t), 10));
  });
  const [r, c] = z2e(e);
  a$(t, { pattern: r, explicitParts: c, onChange: ({ valueAfter: d }) => {
    if (E3(e), l1.has(e)) return l1.delete(e);
    i && i === d ? i = "" : (jT(t), e.props.inputText = d, setTimeout(() => GT(t), 10));
  } }, e);
}
function E3(e) {
  var t, n;
  if (e.props.overlay) {
    const i = Uy.get(e);
    !i || !(!((t = e.props.attrs) === null || t === void 0) && t.placeholder) || e._value || x3(i, !0) || e.props._isFocused || e.props.activeDate && e.props.expanded ? i && (e.props._isPlaceholder = !1, e.props._overlayParts = n$($3(i))) : (e.props._isPlaceholder = !0, e.props._overlayParts = [{ type: "placeholder", value: (n = e.props.attrs) === null || n === void 0 ? void 0 : n.placeholder }]);
  }
}
function z2e(e) {
  const t = e.props.locale, n = ["full", "long", "medium", "short"].includes(e.props.format) || typeof e.props.format == "object", i = Ph(e.props.format, t);
  return [e$(e.props.format, t, !0, gm), i.reduce((r, c) => {
    if (c.partName === "literal") return r;
    let d = x_(c.token, t, n);
    if (c.token === "YYYY" && e.props.minDate && e.props.maxDate) {
      const f = e.props.minDate.getFullYear();
      d = Mu(e.props.maxDate.getFullYear() - f + 1, (g) => String(f + g));
    }
    const a = { type: "enum", token: c.token, values: d, placeholder: c.token === "A" ? "A/P" : c.token, selectDirection: "left" };
    return r.push(a), c.token.startsWith("D") && k3.set(e, d), r;
  }, [])];
}
function B2e(e, t) {
  return !t || !(!e.props.minDate || !gwe(t, e.props.minDate)) || !(!e.props.maxDate || !ywe(t, e.props.maxDate)) || void 0;
}
function V2e(e) {
  return typeof e.props.validationLabel == "function" ? e.props.validationLabel(e) : e.props.validationLabel || e.props.label || e.props.name || String(e.name);
}
const U2e = typeof window < "u", oI = /* @__PURE__ */ new WeakMap();
function H2e(e, t) {
  var n, i;
  if (t instanceof HTMLInputElement && !oI.get(e) && U2e) {
    const r = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${e.props.id}_overlay`), c = (i = e.props.__root) === null || i === void 0 ? void 0 : i.getElementById(`${e.props.id}_overlay_inner`);
    if (r && t && c) {
      oI.set(e, r);
      const d = getComputedStyle(t).color;
      t.style.color = "transparent", t.style.caretColor = d;
      const a = new ResizeObserver(() => {
        var g;
        const x = getComputedStyle(t), $ = t.getBoundingClientRect(), A = (g = t.parentElement) === null || g === void 0 ? void 0 : g.getBoundingClientRect();
        e.props._overlayStyles = { ...e.props._overlayStyles, width: x.width, height: x.height, boxSizing: x.boxSizing, padding: x.padding, margin: x.margin, fontSize: x.fontSize, lineHeight: x.lineHeight, top: $.top - ((A == null ? void 0 : A.top) || $.top) + "px", left: $.left - ((A == null ? void 0 : A.left) || $.left) + "px" };
      });
      a.observe(t);
      const f = (g) => {
        c.scrollLeft = g.detail;
      };
      t.addEventListener("input-scroll", f), e.on("destroyed", () => {
        t.removeEventListener("input-scroll", f), a.disconnect();
      });
    }
  }
}
function P3(e) {
  e.addProps(["_overlayStyles", "_overlayParts", "_overlayInnerStyles", "_isPlaceholder"]), e.props._overlayStyles = { position: "absolute", top: "0", left: "0", pointerEvents: e.props._isPlaceholder ? "auto" : "none" }, e.props._overlayInnerStyles = { overflow: "hidden", whiteSpace: "nowrap", paddingRight: "20px" }, e.on("created", () => {
    e.props.overlay = on(e.props.overlay), e.props.pickerOnly = on(e.props.pickerOnly), e.props.overlay = e.props.pickerOnly ? void 0 : e.props.overlay, e.props.overlay && Pr(`${e.props.id}`, H2e.bind(null, e), e.props.__root);
  }), e.on("prop:_isPlaceholder", () => {
    e.props._overlayStyles = { ...e.props._overlayStyles, pointerEvents: e.props._isPlaceholder ? "auto" : "none" };
  });
}
const W2e = { schema: /* @__PURE__ */ L$e(/* @__PURE__ */ O$e(/* @__PURE__ */ F$e("$label"), /* @__PURE__ */ N$e(/* @__PURE__ */ vd("prefix"), /* @__PURE__ */ R$e(), /* @__PURE__ */ x2e(/* @__PURE__ */ C2e(/* @__PURE__ */ $2e(/* @__PURE__ */ y2e("$part.value"), /* @__PURE__ */ _2e("$part.value"), /* @__PURE__ */ b2e("$part.value"), /* @__PURE__ */ w2e("$part.value")))), /* @__PURE__ */ H$e(), /* @__PURE__ */ W$e(/* @__PURE__ */ l2e(/* @__PURE__ */ j$e(/* @__PURE__ */ G$e("$ui.prev.value"), /* @__PURE__ */ vd("prev")), /* @__PURE__ */ c2e("$decade"), /* @__PURE__ */ u2e(/* @__PURE__ */ V0()), /* @__PURE__ */ d2e(/* @__PURE__ */ HT(), /* @__PURE__ */ V0()), /* @__PURE__ */ p2e(/* @__PURE__ */ HT(), /* @__PURE__ */ h2e(), /* @__PURE__ */ V0()), /* @__PURE__ */ Z$e(/* @__PURE__ */ q$e("$ui.next.value"), /* @__PURE__ */ vd("next")), /* @__PURE__ */ g2e(/* @__PURE__ */ vd("close"))), /* @__PURE__ */ k2e(/* @__PURE__ */ r2e(/* @__PURE__ */ s2e("$fns.format($year, $yearFormat)")), /* @__PURE__ */ o2e(/* @__PURE__ */ a2e("$fns.format($month, $monthFormat)")), /* @__PURE__ */ Y$e(/* @__PURE__ */ X$e(/* @__PURE__ */ J$e(/* @__PURE__ */ Q$e("$fns.format($day, $weekdayFormat)"))), /* @__PURE__ */ K$e(/* @__PURE__ */ e2e(/* @__PURE__ */ t2e(/* @__PURE__ */ n2e("$fns.format($day, $dateFormat)"))))), /* @__PURE__ */ m2e(/* @__PURE__ */ v2e()))), /* @__PURE__ */ f2e(/* @__PURE__ */ vd("clear")), /* @__PURE__ */ i2e(/* @__PURE__ */ vd("calendar")), /* @__PURE__ */ z$e(), /* @__PURE__ */ vd("suffix"))), /* @__PURE__ */ B$e("$help"), /* @__PURE__ */ V$e(/* @__PURE__ */ U$e("$message.value"))), type: "input", family: "text", props: ["dateFormat", "dayButtonFormat", "format", "monthButtonFormat", "monthFormat", "overlay", "pickerOnly", "showMonths", "showPagination", "weekStart", "weekdayFormat", "yearFormat", "years"], features: [
  P3,
  function(e) {
    var t, n, i, r, c, d, a, f, g, x, $, A, I, O, B, H, N, K, U, q, ee, te;
    e.addProps(["_isDisabled", "_isFocused", "activeDate", "calendar", "clearable", "disabled", "decade", "disabledDays", "expanded", "inputText", "localTime", "maxDate", "maxScan", "minDate", "months", "offset", "paginatedPanels", "panel", "pickerOnly", "renderedDate", "sequence", "timezone", "valueFormat", "valueLocale", "showPanelClose", "selectedDay", "selectedWeek", "selectedMonth", "selectedYear"]), e.hook.prop((oe, de) => (oe.prop === "expanded" && e.props.disabled && (oe.value = !1), oe.prop === "weekStart" && (oe.value = Number(oe.value || 0)), oe.prop === "showMonths" && (oe.value = Number(oe.value || 1)), oe.prop === "maxScan" && (oe.value = Number(oe.value || 7)), oe.prop === "timezone" && (typeof e._value == "string" || e._value instanceof Date) && (e.props.offset = Mm(e._value, oe.value)), de(oe))), e.props._isFocused = !1, e.props._isPlaceholder = !1, (t = (A = e.props).valueFormat) !== null && t !== void 0 || (A.valueFormat = "ISO8601"), (n = (I = e.props).weekdayFormat) !== null && n !== void 0 || (I.weekdayFormat = "d"), (i = (O = e.props).monthFormat) !== null && i !== void 0 || (O.monthFormat = "MMM"), (r = (B = e.props).monthButtonFormat) !== null && r !== void 0 || (B.monthButtonFormat = "MMMM"), (c = (H = e.props).dayButtonFormat) !== null && c !== void 0 || (H.dayButtonFormat = "D"), (d = (N = e.props).dateFormat) !== null && d !== void 0 || (N.dateFormat = "D"), (a = (K = e.props).yearFormat) !== null && a !== void 0 || (K.yearFormat = "YYYY"), (f = (U = e.props).paginatedPanels) !== null && f !== void 0 || (U.paginatedPanels = ["day", "year"]), (g = (q = e.props).valueLocale) !== null && g !== void 0 || (q.valueLocale = e.props.locale), (x = (ee = e.props).format) !== null && x !== void 0 || (ee.format = "long"), e.props.panels = sI(e), e.props.pickerOnly = on(e.props.pickerOnly), "disabled" in e.props && (e.props.disabled = on(e.props.disabled)), "clearable" in e.props && (e.props.clearable = on(e.props.clearable)), ($ = (te = e.props).maxScan) !== null && $ !== void 0 || (te.maxScan = 7), e.props._isDisabled = typeof e.props.disabledDays == "function" ? e.props.disabledDays.bind(null, e) : B2e.bind(null, e), e.props.calendar = [], e.props.inputText = "", e.props.showMonths = e.props.showMonths || 1, typeof e.props.format == "function" ? (e.props.formatDate = e.props.format, e.props.format = null) : e.props.formatDate = Fo, G0(e), e.on("mounted", () => {
      Pr(`${e.props.id}`, R2e.bind(null, e), e.props.__root);
    }), e.on("created", () => {
      if (function(oe) {
        const de = oe._value;
        let me = /* @__PURE__ */ new Date();
        if (de instanceof Date) me = Ji(de);
        else if (typeof de == "string") try {
          const re = yd(de, oe.props.valueFormat, oe.props.valueLocale);
          me = Ji(re);
        } catch {
          console.warn(`Date (${de}) does not match format (${e$(oe.props.valueFormat, oe.props.valueLocale)})`), me = void 0;
        }
        else de || (me = void 0);
        if (oe.props.offset = oe.props.timezone ? Mm(me || /* @__PURE__ */ new Date(), oe.props.timezone) : "+0000", oe.props.minDate) {
          const re = typeof oe.props.minDate == "string" ? yd(oe.props.minDate) : oe.props.minDate;
          oe.props.minDate = qp(re, oe.props.offset);
        }
        if (oe.props.maxDate) {
          const re = typeof oe.props.maxDate == "string" ? yd(oe.props.maxDate) : oe.props.maxDate;
          oe.props.maxDate = qp(re, oe.props.offset);
        }
        me = me && qp(me, oe.props.offset), me && Hf(oe, me, !1);
        let ve = me || /* @__PURE__ */ new Date();
        oe.props.minDate && ve < oe.props.minDate ? ve = oe.props.minDate : oe.props.maxDate && ve > oe.props.maxDate && (ve = oe.props.maxDate), oe.props.renderedDate = ve, oe.props.activeDate = ve, oe.props.localTime = me && Fo(me, "HH:mm") || "12:00";
      }(e), e.context) {
        const oe = {};
        let de;
        e.context.fns.format = (me, ve) => {
          if (oe[ve] && oe[ve][me.toString()]) return oe[ve][me.toString()];
          const re = Fo(me, ve, e.props.locale || "en", !1, gm);
          return oe[ve] ? oe[ve][me.toString()] = re : oe[ve] = { [me.toString()]: re }, re;
        }, e.context.fns.isDisabled = e.props._isDisabled, e.context.fns.isDisabledMonth = (me) => !zf(me, (ve) => !e.props._isDisabled(ve), "month"), e.context.fns.isDisabledYear = (me) => !zf(me, (ve) => !e.props._isDisabled(ve), "year"), e.context.handlers._blur = (me) => {
          var ve, re;
          e.props._isFocused = !1, me.target instanceof HTMLInputElement && (me.target.selectionStart = 0, me.target.selectionEnd = 0), typeof ((ve = e.context) === null || ve === void 0 ? void 0 : ve.handlers.blur) == "function" && ((re = e.context) === null || re === void 0 || re.handlers.blur(me));
        }, e.context.handlers.closePanel = () => {
          e.props.expanded = !1;
        }, e.context.handlers._blurOut = (me) => (ve) => {
          var re;
          ve.preventDefault(), e.props.keydown ? e.props.keydown = !1 : me && me !== e.props.panel || e.props.pickerOnly && ve.relatedTarget instanceof Element && (ve.relatedTarget === document.getElementById(`${e.props.id}_inner`) || ve.relatedTarget.closest(`#${e.props.id}_inner`)) || ve.relatedTarget && ve.relatedTarget instanceof Element && (ve.relatedTarget.closest(`#${e.props.id}_popover`) || !(!((re = e.props.__root) === null || re === void 0) && re.contains(ve.relatedTarget)) || ve.relatedTarget.id === `${e.props.id}_popover`) || (e.props.expanded = !1);
        }, e.context.handlers.overlayClick = () => {
          const me = Uy.get(e);
          me && (me.focus(), e.props._isPlaceholder = !1);
        }, e.context.handlers.focus = () => {
          e.props.pickerOnly || (e.props._isFocused = !0, e.props.pickerOnly && !q0.has(e) && (rI.add(e), e.props.expanded = !0, setTimeout(() => rI.delete(e), 200)));
        }, e.context.handlers.clear = () => {
          var me, ve;
          Hf(e, void 0, !0), gd(e, void 0);
          const re = (ve = (me = e.props) === null || me === void 0 ? void 0 : me.__root) === null || ve === void 0 ? void 0 : ve.getElementById(`${e.props.id}`);
          re instanceof HTMLInputElement && (re.focus(), setTimeout(() => {
            re.setSelectionRange(0, 0);
          }, 50));
        }, e.context.handlers.dateInput = (me) => {
          var ve;
          if (j0.has(e)) return j0.delete(e);
          if (me.target instanceof HTMLInputElement && !e.props.expanded) try {
            let re = yd({ date: me.target.value, format: e.props.format, locale: e.props.locale, partFilter: gm });
            if (function(le) {
              return Ph(le.props.format, le.props.locale).some((pe) => pe.partName === "weekday");
            }(e) && e.props.activeDate instanceof Date && e.props.activeDate.getTime() === re.getTime() && !Pd.get(me.target) && Fo(re, e.props.format, e.props.locale, !1, gm) !== me.target.value) {
              const le = x_("dddd", e.props.locale), pe = Ph(e.props.format, e.props.locale), Ne = (ve = UL(me.target.value, pe).find((Ge) => Ge.token === "dddd")) === null || ve === void 0 ? void 0 : ve.value, We = Fo(re, "dddd", e.props.locale);
              if (Ne && le.includes(Ne) && We !== Ne) {
                let Ge = le.indexOf(Ne) - le.indexOf(We);
                Ge = Ge < -1 ? 7 + Ge : Ge, re = hh(re, Ge), l1.add(e);
              }
            }
            Hf(e, re);
          } catch {
            Hf(e, void 0);
          }
        }, e.context.handlers.open = () => {
          e.props.expanded = !0;
        }, e.context.handlers.next = () => {
          switch (e.props.panel) {
            case "year":
              return void (e.props.renderedDate = Zp(e.props.renderedDate, 10));
            case "day":
              return void (e.props.renderedDate = bu(e.props.renderedDate, 1));
          }
        }, e.context.handlers.prev = () => {
          switch (e.props.panel) {
            case "year":
              return void (e.props.renderedDate = Zp(e.props.renderedDate, -10));
            case "day":
              return void (e.props.renderedDate = bu(e.props.renderedDate, -1));
          }
        }, e.context.handlers.setDate = (me) => () => {
          e.props.panel !== "month" && e.props.panel !== "year" || !e.props.activeDate || (me = e.props.activeDate), e.emit("dateSelected", me);
        }, e.context.handlers.localTime = (me) => {
          const ve = me.target;
          if (!ve.value) return;
          const [re, le] = ve.value.split(":");
          e.props.localTime = ve.value, e.props.activeDate.setHours(re, le), gd(e, e.props.activeDate);
        }, e.context.handlers.keyDown = (me) => {
          switch (e.props.keydown = !0, e.props.panel) {
            case "day":
              return e.emit("calendarKeydown", me);
            case "year":
              return e.emit("yearKeydown", me);
            case "month":
              return e.emit("monthKeydown", me);
            case "time":
              return e.emit("timeKeydown", me);
            default:
              return;
          }
        }, e.context.handlers.inputKeydown = (me) => {
          e.emit("keydown", me);
        }, e.context.handlers.openKeydown = (me) => {
          me.key !== "Enter" && me.key !== "Space" || (e.props.expanded = !0);
        }, e.context.handlers.mouseEnter = (me) => (ve) => {
          if (clearTimeout(de), ve.target instanceof HTMLElement && ve.target.getAttribute("tabindex") === "-1" && ve.target.getAttribute("data-is-extra") !== "true") if (e.props.panel === "month" || e.props.panel === "year") {
            const re = zf(me, () => !0, e.props.panel);
            re && (e.props.activeDate = re);
          } else e.props.activeDate = me;
        }, e.context.handlers.mouseLeave = () => {
          clearTimeout(de), de = setTimeout(() => {
          }, 100);
        }, e.context.handlers.jumpTo = (me) => () => {
          e.props.panels.unshift(e.props.panel), e.props.panel = me;
        }, e.context.fns.sameDay = (me) => function(ve, re) {
          return re instanceof Date && HL(ve, re);
        }(me, e.props.activeDate), e.context.fns.sameMonth = (me) => A3(me, e.props.activeDate), e.context.fns.sameYear = (me) => I3(me, e.props.activeDate), e.context.fns.notInMonth = (me, ve) => {
          const re = uwe(ve).getTime();
          return re < vT(me).getTime() || re > Oy(me).getTime() || void 0;
        };
      }
    });
    const ae = F2e.bind(null, e);
    e.on("prop:panel", ({ payload: oe }) => {
      e.props.showPagination = e.props.paginatedPanels.includes(oe);
    }), e.on("dateSelected", ({ payload: oe }) => {
      var de, me;
      Array.isArray(e.props.panels) && e.props.panels.length ? e.props.panel = e.props.panels.shift() : (e.props.expanded = !1, (me = (de = e.props.__root) === null || de === void 0 ? void 0 : de.getElementById(`${e.props.id}`)) === null || me === void 0 || me.focus()), oe && e.props._isDisabled(oe) || Hf(e, oe);
    }), e.on("input", ({ payload: oe }) => {
      if (oe === void 0 && !e.props._isFocused) return void gd(e, void 0);
      const de = /* @__PURE__ */ new Date(), me = oe ? gd(e, qp(typeof oe == "string" ? yd(oe, e.props.valueFormat, e.props.valueLocale) : oe, e.props.offset)) : de;
      e.props.activeDate = !oe && e.props.activeDate ? e.props.activeDate : me, e.props.renderedDate = !oe && e.props.renderedDate ? e.props.renderedDate : me, e.props.localTime = Fo(me, "HH:mm"), function(ve) {
        const re = k3.get(ve);
        if (ve._value && re) {
          const le = nv(ve.props.activeDate);
          if (re.length > le) re.splice(le, re.length - le);
          else if (re.length < le) for (let pe = re.length + 1; pe <= le; pe++) re.push(String(pe));
        }
      }(e);
    }), e.on("prop:renderedDate", G0.bind(null, e)), e.on("prop:expanded", ({ payload: oe }) => {
      if (oe) {
        if (c1.delete(e), e.props.panels = sI(e), e.props.panel = e.props.panels.shift(), window.innerWidth <= 430 && !window.matchMedia("(hover: hover)").matches ? e.props.showPanelClose = !0 : e.props.showPanelClose = !1, e.props.panel === "day") {
          const de = e.props.activeDate;
          e.props.activeDate = zf(e.props.activeDate, (me) => !e.props._isDisabled(me), "month") || de;
        }
        G0(e), Pr(`${e.props.id}_popover`, (de) => {
          const me = de.querySelector('[tabindex="0"]');
          me && setTimeout(() => {
            me.focus(), function(ve, re) {
              const le = new MutationObserver((Ne) => {
                for (const We of Ne) We.type === "attributes" && We.target instanceof HTMLElement && We.target.getAttribute("tabindex") === "0" ? We.target.focus() : We.addedNodes.length && We.addedNodes.forEach((Ge) => {
                  var et;
                  if (Ge instanceof HTMLElement && Ge.getAttribute("tabindex") === "0") Ge.focus();
                  else if (Ge instanceof HTMLElement && Ge.querySelector('[tabindex="0"]')) {
                    const ft = Ge.querySelector('[tabindex="0"]');
                    ft instanceof HTMLElement && ft.focus();
                  } else Ge instanceof HTMLElement && Ge.querySelector('input[type="time"]') && ((et = Ge.querySelector('input[type="time"]')) === null || et === void 0 || et.focus());
                });
              });
              le.observe(re, { attributes: !0, attributeFilter: ["tabindex"], childList: !0, subtree: !0 });
              const pe = ve.on("prop:expanded", ({ payload: Ne }) => {
                Ne || (ve.off(pe), le.disconnect());
              });
            }(e, de);
          }, 0);
        }, e.props.__root), iI && setTimeout(() => {
          document.addEventListener("click", ae);
        }, 10);
      } else {
        if (e.props.panel === "time") e.emit("dateSelected", e.props.activeDate);
        else if (e._value) {
          j0.add(e);
          const de = typeof e._value == "string" ? yd(e._value, e.props.valueFormat, e.props.valueLocale) : e._value;
          gd(e, qp(de, e.props.offset));
        } else gd(e, void 0);
        iI && (q0.add(e), document.removeEventListener("click", ae), setTimeout(() => q0.delete(e), 50));
      }
    }), e.on("prop:activeDate", ({ payload: oe }) => {
      if (Array.isArray(e.props.calendar) && e.props.calendar.length) {
        if (e.props.panel === "day") {
          const de = e.props.calendar, me = vT(e.props.renderedDate), ve = Oy(bu(e.props.renderedDate, de.length - 1));
          oe.getTime() < me.getTime() ? e.props.renderedDate = bu(e.props.renderedDate, -1) : oe.getTime() > ve.getTime() && (e.props.renderedDate = bu(e.props.renderedDate));
        } else if (e.props.panel === "year") {
          const de = e.props.years, me = de[0].getFullYear(), ve = de[de.length - 1].getFullYear(), re = e.props.activeDate.getFullYear();
          e.props.renderedDate = re > ve ? Zp(e.props.renderedDate, 10) : re < me ? Zp(e.props.renderedDate, -10) : oe;
        }
      }
      e.props.expanded && gd(e, e.props.activeDate);
    }), e.on("keydown", ({ payload: oe }) => {
      switch (oe.key) {
        case "ArrowDown":
        case "ArrowUp":
        case " ":
          oe.preventDefault(), e.props.pickerOnly && (e.props.expanded = !0);
          break;
        case "Enter":
        case "Return":
          e.props.expanded || (e.props.expanded = !0);
          break;
        case "Escape":
          e.props.expanded = !1;
      }
    }), e.on("calendarKeydown", ({ payload: oe }) => {
      oe.preventDefault();
      let de = null, me = 0;
      switch (oe.key) {
        case "ArrowRight":
          me = 1;
          break;
        case "ArrowLeft":
          me = -1;
          break;
        case "ArrowDown":
          me = 7;
          break;
        case "ArrowUp":
          me = -7;
          break;
        case "Return":
        case "Enter":
          e.emit("dateSelected", e.props.activeDate);
          break;
        case "Tab":
          oe.shiftKey || Y0(e, oe);
          break;
        case "Escape":
          e.props.expanded = !1;
      }
      if (me && (oe.preventDefault(), de = hh(e.props.activeDate, me)), de && !e.props._isDisabled(de)) e.props.activeDate = de;
      else if (de && e.props._isDisabled(de)) {
        const ve = me > 0 ? 1 : -1;
        Mu(Number(e.props.maxScan), (re) => ve * re).some((re) => {
          const le = hh(de, re);
          return !e.props._isDisabled(le) && (e.props.activeDate = le, !0);
        });
      }
    }), e.on("yearKeydown", ({ payload: oe }) => {
      let de = 0;
      switch (oe.key) {
        case "ArrowDown":
          de = 5;
          break;
        case "ArrowRight":
          de = 1;
          break;
        case "ArrowUp":
          de = -5;
          break;
        case "ArrowLeft":
          de = -1;
          break;
        case "Tab":
          oe.shiftKey || Y0(e, oe);
          break;
        case "Return":
        case "Enter":
          e.emit("dateSelected", e.props.activeDate);
          break;
        case "Escape":
          e.props.expanded = !1;
      }
      const me = e.props.activeDate.getFullYear() + de - e.props.renderedDate.getFullYear();
      e.props.activeDate = Zp(e.props.renderedDate, me);
    }), e.on("monthKeydown", ({ payload: oe }) => {
      let de = 0;
      switch (oe.key) {
        case "ArrowDown":
          de = 3;
          break;
        case "ArrowRight":
          de = 1;
          break;
        case "ArrowLeft":
          de = -1;
          break;
        case "ArrowUp":
          de = -3;
          break;
        case "Tab":
          oe.shiftKey || Y0(e, oe);
          break;
        case "Return":
        case "Enter":
          e.emit("dateSelected", e.props.activeDate);
          break;
        case "Escape":
          e.props.expanded = !1;
      }
      de && oe.preventDefault();
      let me = (e.props.activeDate.getMonth() + de) % 12;
      me = me < 0 ? 12 + me : me;
      const ve = me - e.props.renderedDate.getMonth();
      let re = bu(e.props.renderedDate, ve);
      if (e.props._isDisabled(re)) {
        const le = zf(re, (pe) => !e.props._isDisabled(pe), "month");
        le && (re = le);
      }
      e.props.activeDate = re;
    }), e.on("timeKeydown", ({ payload: oe }) => {
      switch (oe.key) {
        case "Return":
        case "Enter":
          oe.preventDefault(), e.emit("dateSelected", e.props.activeDate);
      }
    }), e.on("prop:_isFocused", () => {
      Uy.get(e) && E3(e);
    }), e.on("commit", ({ payload: oe }) => {
      if (oe ? T3(e) : S3(e), e.props.activeDate && e.props._isDisabled(e.props.activeDate)) {
        const de = Vr({ blocking: !0, key: "rule_invalidDate", meta: { messageKey: "invalidDate", removeImmediately: !1, localize: !0, i18nArgs: [{ node: e, name: V2e(e), args: [] }] }, type: "validation", value: "The selected date is invalid." });
        e.store.set(de);
      } else e.store.remove("rule_invalidDate");
    });
  },
  iv,
  /* @__PURE__ */ bi("next"),
  /* @__PURE__ */ bi("prev"),
  /* @__PURE__ */ bi("changeDate"),
  /* @__PURE__ */ bi("chooseDate"),
  /* @__PURE__ */ Qn("close", "close"),
  /* @__PURE__ */ Qn("next", "right"),
  /* @__PURE__ */ Qn("clear", "close"),
  /* @__PURE__ */ Qn("prev", "left"),
  /* @__PURE__ */ Qn("calendar", "date")
] }, jl = /* @__PURE__ */ $o("tl"), { outer: Z2e, wrapper: q2e, inner: j2e, icon: Wf, label: G2e, prefix: Y2e, suffix: K2e, help: X2e, messages: J2e, message: Q2e } = /* @__PURE__ */ Co(jl), eCe = jl("input", () => ({ $el: "input", bind: "$attrs", attrs: { id: "$id", type: "text", onClick: "$handlers.click", onBlur: "$handlers.blur", onKeydown: "$handlers.keydown", onInput: "$handlers.input", onFocus: "$handlers.focus", value: "$inputText", name: "$node.name", tabindex: "0", placeholder: "$state.loading && $inputStd.length === 0 && $ui.isLoading.value || $placeholder || undefined", role: "combobox", autocomplete: "off", autocapitalize: "none", readonly: "$attrs.readonly || $isLoadingOption || undefined || $multiple && $max && $value && $value.length >= $max", disabled: "$disabled || $disabledInternally || undefined", "aria-autocomplete": "list", "aria-expanded": "$expanded", "aria-controls": '$expanded && $id + "_listbox" || undefined', "aria-describedBy": "$describedBy", "aria-activedescendant": "$expanded && $activeDescendant || undefined" } })), tCe = jl("listboxButton", () => ({ $el: "button", attrs: { style: "$visibilityStyles", id: '$id + "_listbox_button"', type: "button", onClick: "$handlers.toggleListbox", tabindex: "-1", "aria-label": "$expanded && $ui.close.value || $ui.open.value", disabled: "$disabled || undefined", "aria-haspopup": "true", "aria-expanded": "$expanded", "aria-controls": '$expanded && $id + "_listbox" || undefined' } })), nCe = jl("tagWrapper", () => ({ $el: "span", for: ["option", "index", "$selections"], attrs: { id: '$id + "_tag-wrapper_" + $index', key: "$option.value", "data-value": "$option.value", tabindex: "-1", onClick: "$handlers.tagClick && $handlers.tagClick($option)", onFocus: "$handlers.tagFocus && $handlers.tagFocus($option)", onBlur: "$handlers.tagBlur && $handlers.tagBlur($option)", onKeydown: "$handlers.searchInputTagKeydown && $handlers.searchInputTagKeydown($option)", "data-is-tag": "true", "data-active-selection": "$fns.isActiveSelection && $fns.isActiveSelection($activeSelectionValue, $option)" } })), iCe = jl("tag", () => ({ $el: "div", attrs: { id: '$id + "_tag_" + $index', role: "button" } })), rCe = jl("removeSelection", () => ({ $el: "button", if: "$selections.length > 0", attrs: { id: '$id + "_remove_selection_" + $index', tabindex: "-1", "aria-label": "$ui.remove.value", type: "button", onClick: "$handlers.removeSelection && $handlers.removeSelection($option)", onTouchstart: "$handlers.removeSelection && $handlers.removeSelection($option)", "aria-controls": "$id" } })), sCe = jl("tagLabel", () => ({ $el: "span" })), oCe = jl("tags", () => ({ $el: "div", attrs: { id: '$id + "_selections"', "aria-live": "polite" } })), aCe = jl("tagLoading", "span"), lCe = /* @__PURE__ */ t$(jl);
function cCe(e) {
  e.props.multiple = !0, e.props.openOnClick = on(e.props.openOnClick), e.props.closeOnSelect === void 0 && (e.props.closeOnSelect = !0), e.props.closeOnSelect ? e.props.resetSearchOnCommit = !1 : e.props.resetSearchOnCommit === void 0 && (e.props.resetSearchOnCommit = e.props.multiple), e.props.allowNewValues = on(e.props.allowNewValues);
}
function uCe(e) {
  d3(e), o3(e), e.on("created", () => {
    function t() {
      return Array.isArray(e.value) ? e.value : [];
    }
    function n(i) {
      e.input(i);
    }
    e.props.disabled && (e.props.draggable = !1), Pr(`${e.props.id}_selections`, (i) => {
      if (i instanceof HTMLElement) {
        if (!e.context) return;
        const r = { draggingClass: e.context.classes.dragging, dropZoneClass: e.context.classes.dropZone, disabled: !e.props.draggable, threshold: { horizontal: 0.25, vertical: 0 }, plugins: [__()], root: e.props.__root, touchDraggingClass: e.context.classes.touchDragging, touchDropZoneClass: e.context.classes.touchDropZone, draggable: (c) => c.hasAttribute("data-is-tag"), handleEnd(c) {
          e.props.activeSelectionValue = void 0, Dy(c);
        }, handleDragstart(c) {
          e.props.activeSelectionValue = void 0, My(c);
        }, handleTouchstart(c) {
          e.props.activeSelectionValue = void 0, Ly(c);
        } };
        es({ parent: i, getValues: t, setValues: n, config: r }), e.on("prop:disabled", ({ payload: c }) => {
          r.disabled = c, es({ parent: i, getValues: t, setValues: n, config: r });
        }), e.on("prop:draggable", ({ payload: c }) => {
          r.disabled = !c, es({ parent: i, getValues: t, setValues: n, config: r });
        });
      }
    }, e.props.__root);
  });
}
const dCe = { schema: /* @__PURE__ */ Z2e(/* @__PURE__ */ q2e(/* @__PURE__ */ G2e("$label"), /* @__PURE__ */ j2e(/* @__PURE__ */ Wf("prefix"), /* @__PURE__ */ Y2e(), /* @__PURE__ */ oCe(/* @__PURE__ */ nCe(/* @__PURE__ */ iCe(/* @__PURE__ */ sn("$state.loading && $fns.hasOptionLoaderValue && $fns.hasOptionLoaderValue($option) || $option.label === undefined", /* @__PURE__ */ aCe("$ui.isLoading.value"), /* @__PURE__ */ sCe("$option.label")), /* @__PURE__ */ rCe(/* @__PURE__ */ Wf("close")))), /* @__PURE__ */ eCe()), /* @__PURE__ */ sn("$state.loading", /* @__PURE__ */ Wf("loader")), /* @__PURE__ */ tCe(/* @__PURE__ */ Wf("select")), /* @__PURE__ */ lCe(), /* @__PURE__ */ K2e(), /* @__PURE__ */ Wf("suffix"))), /* @__PURE__ */ X2e("$help"), /* @__PURE__ */ J2e(/* @__PURE__ */ Q2e("$message.value"))), type: "input", family: "dropdown", props: [], features: [
  Zl,
  /* @__PURE__ */ o$.bind(null, cCe, c3, uCe),
  /* @__PURE__ */ Qn("select", "select"),
  /* @__PURE__ */ Qn("close", "close"),
  /* @__PURE__ */ Qn("selected", "check"),
  /* @__PURE__ */ Qn("loader", "spinner"),
  /* @__PURE__ */ bi("isLoading"),
  /* @__PURE__ */ bi("loadMore"),
  /* @__PURE__ */ bi("remove"),
  /* @__PURE__ */ bi("open"),
  /* @__PURE__ */ bi("close"),
  iv
] }, u$ = /* @__PURE__ */ $o("mk"), { outer: pCe, wrapper: hCe, inner: fCe, label: mCe, prefix: vCe, suffix: gCe, help: yCe, messages: _Ce, message: bCe, icon: aI } = /* @__PURE__ */ Co(u$), { overlayPlaceholder: wCe, overlayLiteral: xCe, overlayChar: $Ce, overlayEnum: CCe, overlay: kCe, overlayParts: SCe, overlayInner: TCe } = /* @__PURE__ */ ZL(u$), ICe = u$("input", () => ({ $el: "input", bind: "$attrs", attrs: { type: "text", disabled: "$disabled", name: "$node.name", onBlur: "$handlers.blur", onInput: "$handlers.DOMInput", value: "$_maskValue", placeholder: "$placeholder", id: "$id", "aria-describedby": "$describedBy" } })), u1 = /* @__PURE__ */ new WeakMap(), d1 = /* @__PURE__ */ new WeakMap(), lI = /* @__PURE__ */ new WeakMap();
function ACe(e, t) {
  if (!(t instanceof HTMLInputElement)) throw new Error(`Masks can only be applied to an HTMLInputElement (id: ${t.id}).`);
  d1.set(e, t), a$(t, { ...u1.get(e), onChange: ({ valueAfter: n, meta: i }) => {
    e.props._maskValue = n, e.input({ maskValue: n }), e.props._overlayParts = n$(i);
  } }, e);
}
const ECe = { schema: /* @__PURE__ */ pCe(/* @__PURE__ */ hCe(/* @__PURE__ */ mCe("$label"), /* @__PURE__ */ fCe(/* @__PURE__ */ aI("prefix"), /* @__PURE__ */ vCe(), /* @__PURE__ */ kCe(/* @__PURE__ */ TCe(/* @__PURE__ */ SCe(/* @__PURE__ */ wCe("$part.value"), /* @__PURE__ */ xCe("$part.value"), /* @__PURE__ */ $Ce("$part.value"), /* @__PURE__ */ CCe("$part.value")))), /* @__PURE__ */ ICe(), /* @__PURE__ */ gCe(), /* @__PURE__ */ aI("suffix"))), /* @__PURE__ */ yCe("$help"), /* @__PURE__ */ _Ce(/* @__PURE__ */ bCe("$message.value"))), type: "input", props: ["allowIncomplete", "mask", "mode", "tokens", "showMask", "unmaskValue", "prefix", "suffix", "reverse", "overlay"], family: "text", features: [P3, function(e) {
  e.addProps(["_maskValue", "_overlayParts"]), e.on("created", () => {
    var t, n, i, r, c;
    const d = p3(typeof e._value == "string" ? e._value : "");
    d1.set(e, d), lI.set(e, d), e.props.allowIncomplete = on(e.props.allowIncomplete), e.props.overlay = on(e.props.overlay);
    const a = !(e.props.showMask !== void 0 && !on(e.props.showMask));
    e.props.unmaskValue = on(e.props.unmaskValue), e.hook.prop((g, x) => (g.prop === "unmaskValue" && (g.value = on(g)), x(g)));
    const f = { placeholder: a, pattern: (t = e.props.mask) !== null && t !== void 0 ? t : "", mode: (n = e.props.mode) !== null && n !== void 0 ? n : "shift", partOverrides: (i = e.props.tokens) !== null && i !== void 0 ? i : {}, prefix: (r = e.props.prefix) !== null && r !== void 0 ? r : void 0, suffix: (c = e.props.suffix) !== null && c !== void 0 ? c : void 0, reverse: on(e.props.reverse) };
    u1.set(e, f), e.hook.input((g, x) => {
      const $ = function(A, I) {
        const O = d1.get(A), B = typeof I == "object" && "maskValue" in I;
        I = typeof I == "string" ? I : B ? I.maskValue : "";
        const H = lI.get(A);
        H.value = l$(H, I);
        const N = YT(H, u1.get(A)), K = x3(H, A.props.allowIncomplete);
        return I === O.value ? A.props.unmaskValue ? K ?? "" : K === null ? "" : typeof I == "string" ? I : "" : I === "" && O.value !== "" && !A.props.allowIncomplete ? I : (B || N === A.props._maskValue || (O.value = N, A.props._maskValue = N, A.props._overlayParts = n$($3(H) || [])), K === null ? "" : A.props.unmaskValue ? K : N);
      }(e, g);
      return x($);
    }), e.props._maskValue = YT(d, f, e), e.input(e.props._maskValue, !1), e.context && (e.context.handlers.DOMInput = (g) => {
      e.emit("dom-input-event", g);
    }), Pr(`${e.props.id}`, ACe.bind(null, e), e.props.__root);
  });
}] }, oi = /* @__PURE__ */ $o("tf"), { outer: PCe, wrapper: MCe, icon: Al, help: DCe, messages: LCe, message: OCe } = /* @__PURE__ */ Co(oi), NCe = oi("fieldset", () => ({ $el: "fieldset", attrs: { id: '$id + "_fieldset"', role: "presentation", "aria-describedby": { if: "$help", then: '$: "help-" + $id', else: void 0 } } })), FCe = oi("legend", () => ({ if: "$label", $el: "legend" })), RCe = oi("source", () => ({ $el: "div", attrs: { id: '$id + "_source"', class: '$classes.transferlist + " " + $classes.source' } })), zCe = oi("sourceHeader", () => ({ $el: "div", attrs: { id: '$id + "_source_header"', role: "presentation", class: '$classes.transferlistHeader + " " + $classes.sourceHeader' } })), BCe = oi("sourceHeaderLabel", () => ({ if: "$sourceLabel", $el: "label", attrs: { id: '$id + "_source_header_label"', for: '$id + "_source_search_input"', class: '$classes.transferlistHeaderLabel + " " + $classes.sourceHeaderLabel' }, children: "$sourceLabel || $label" })), VCe = oi("sourceHeaderItemCount", () => ({ $el: "span", attrs: { id: '$id + "_source_header_item_count"', role: "presentation", "aria-label": '$sourceOptions.length " items"', class: '$classes.transferlistHeaderItemCount + " " + $classes.sourceHeaderItemCount' } })), UCe = oi("targetHeaderLabel", () => ({ if: "$targetLabel", $el: "label", attrs: { id: '$id + "_target_header_label"', for: '$id + "_target_search_input"', class: '$classes.transferlistHeaderLabel + " " + $classes.targetHeaderLabel' }, children: "$targetLabel || $label" })), HCe = oi("targetHeaderItemCount", () => ({ $el: "span", attrs: { id: '$id + "_target_header_item_count"', role: "presentation", "aria-label": '$targetOptions.length + " items"', class: '$classes.transferlistHeaderItemCount + " " + $classes.targetHeaderItemCount' }, children: "$targetOptions.length" })), WCe = oi("sourceControls", () => ({ $el: "div", if: "$searchable", attrs: { id: '$id + "_source_controls"', class: '$classes.transferlistControls + " " + $classes.sourceControls' } })), ZCe = oi("sourceSearch", () => ({ if: "$searchable", $el: "div", attrs: { id: '$id + "_source_search"', class: '$classes.transferlistSearch + " " + $classes.sourceSearch' } })), qCe = oi("sourceSearchInput", () => ({ $el: "input", attrs: { id: '$id + "_source_search_input"', type: "text", placeholder: "$placeholder", onInput: "$handlers.onSearch", value: "$inputText", onKeydown: "$handlers.sourceSearchKeydown", disabled: "$disabled", "aria-label": "Search", role: "searchbox", autocomplete: "off", class: '$classes.transferlistSearchInput + " " + $classes.sourceSearchInput', onFocus: "$handlers.sourceSearchFocus", onBlur: "$handlers.sourceSearchBlur" } })), jCe = oi("targetSearch", () => ({ if: "$targetSearchable", $el: "div", attrs: { id: '$id + "_target_search"', class: '$classes.transferlistSearch + " " + $classes.targetSearch' } })), GCe = oi("targetSearchInput", () => ({ $el: "input", attrs: { id: '$id + "_target_search_input"', type: "text", placeholder: "$placeholder", onInput: "$handlers.onTargetSearch", value: "$targetInputText", onKeydown: "$handlers.targetSearchKeydown", disabled: "$disabled", "aria-label": "Search", role: "searchbox", autocomplete: "off", class: '$classes.transferlistSearchInput + " " + $classes.targetSearchInput', onFocus: "$handlers.targetSearchFocus", onBlur: "$handlers.targetSearchBlur" } })), YCe = oi("targetControls", () => ({ $el: "div", if: "$targetSearchable", attrs: { id: '$id + "_target_controls"', class: '$classes.transferlistControls + " " + $classes.targetControls' } })), KCe = oi("sourceSearchClear", () => ({ $el: "button", if: '$inputText !== ""', attrs: { id: '$id + "_source_search_clear"', type: "button", onClick: "$handlers.clearSearch", "aria-label": "Clear Source Search", class: '$classes.transferlistSearchClear + " " + $classes.sourceSearchClear' } })), XCe = oi("targetSearchClear", () => ({ $el: "button", if: '$targetInputText !== ""', attrs: { id: '$id + "_target_search_clear"', type: "button", onClick: "$handlers.clearTargetSearch", "aria-label": "Clear Target Search", class: '$classes.transferlistSearchClear + " " + $classes.targetSearchClear' } })), JCe = oi("sourceListItems", () => ({ $el: "ul", attrs: { id: '$id + "_source_list_items"', "aria-activedescendant": "$activeDescendant", onMouseenter: "$handlers.onMouseenter(true)", onMouseout: "$handlers.onMouseleave(true)", role: "listbox", "aria-multiselectable": "true", "aria-roledescription": "List of options to choose from.", class: '$classes.transferlistListItems + " " + $classes.sourceListItems', onKeydown: "$handlers.sourceListKeydown", tabindex: "$searchable || $sourceOptions.length === 0 && -1 || 0", onFocus: "$handlers.sourceListFocused", onBlur: "$handlers.sourceListBlurred", "aria-label": "Source list" } })), QCe = oi("sourceListItem", () => ({ for: ["option", "index", "$sourceOptions"], $el: "li", attrs: { id: '$id + "_source_list_item_" + $index', "data-value": "$option.value", "aria-selected": "$transferOnSelect === false && $fns.isSelected($option, $selectedSourceItems)", "data-is-active": "$fns.isActive($option, $activeValue)", "data-disabled": "$option.attrs.disabled", role: "option", onClick: "$handlers.listitemClick($option, true)", onTouchstart: "$handlers.listitemTouchstart($option, true)", onTouchmove: "$handlers.listitemTouchmove($option, true)", onTouchend: "$handlers.listitemTouchend($option, true)", key: "$option.value", class: '$classes.transferlistListItem + " " + $classes.sourceListItem' } })), eke = oi("sourceOption", () => ({ $el: "div", attrs: { "data-checked": "$fns.isSelected($option, $selectedSourceItems)", class: '$classes.transferlistOption + " " + $classes.sourceOption' } })), tke = oi("sourceLoadMore", () => ({ $el: "li", if: "$state.loading || $state.hasNextPage", attrs: { id: '$id + "_source_load_more"', key: "loadMore", onClick: "$handlers.listitemClick($loadMoreOption)", "aria-selected": "false", "data-is-active": "$fns.isActive($loadMoreOption)", tabindex: "-1" } })), nke = oi("loadMoreInner", "span"), ike = oi("target", () => ({ $el: "div", attrs: { id: '$id + "_target"', class: '$classes.transferlist + " " + $classes.target' } })), rke = oi("targetHeader", () => ({ $el: "div", attrs: { id: '$id + "_target_header"', role: "presentation", class: '$classes.transferlistHeader + " " + $classes.targetHeader' } })), ske = oi("targetListItems", () => ({ $el: "ul", attrs: { id: "$id", "aria-activedescendant": "$activeDescendant", onMouseenter: "$handlers.onMouseenter(false)", onMouseout: "$handlers.onMouseleave(false)", role: "listbox", class: '$classes.transferlistListItems + " " + $classes.targetListItems', tabindex: "$targetOptions.length === 0 && -1 || 0", onKeydown: "$handlers.targetListKeydown", onFocus: "$handlers.targetListFocused", onBlur: "$handlers.targetListBlurred", "aria-label": "Target list" } })), oke = oi("targetListItem", () => ({ for: ["option", "index", "$targetOptions"], $el: "li", attrs: { id: '$id + "_target_list_item_" + $index', "data-disabled": "$option.attrs.disabled", "data-value": "$option.value", "aria-selected": "$transferOnSelect === false && $fns.isSelected($option, $selectedTargetItems)", "data-is-active": "$fns.isActive($option, $activeValue)", role: "option", onClick: "$handlers.listitemClick($option, false)", onTouchstart: "$handlers.listitemTouchstart($option, false)", onTouchmove: "$handlers.listitemTouchmove($option, false)", onTouchend: "$handlers.listitemTouchend($option, false)", key: "$option.value", class: '$classes.transferlistListItem + " " + $classes.targetListItem' } })), ake = oi("targetOption", () => ({ $el: "div", attrs: { id: '$id + "_target_list_item_" + $index + "_option"', "data-checked": "$fns.isSelected($option, $selectedTargetItems)", class: '$classes.transferlistOption + " " + $classes.targetOption' } })), lke = oi("transferControls", () => ({ $el: "div", attrs: { id: '$id + "_transfer_controls"' } })), cke = oi("transferButtonForward", () => ({ if: "$transferOnSelect !== true", $el: "button", attrs: { id: '$id + "_transfer_button_forward"', type: "button", disabled: "$selectedSourceItems.length === 0 || $disabled || ($max && $value && $value.length >= $max)", onClick: "$handlers.transferForward", "aria-label": "$ui.addSelectedValues.value", title: "$ui.addSelectedValues.value", class: '$classes.transferlistButton + " " + $classes.transferButtonForward' } })), uke = oi("transferButtonForwardAll", () => ({ $el: "button", attrs: { id: '$id + "_transfer_button_forward_all"', type: "button", disabled: "$sourceOptions.length === 0 || $disabled || ($max && $value && $value.length >= $max)", onClick: "$handlers.transferForwardAll", "aria-label": "$ui.addAllValues.value", title: "$ui.addAllValues.value", onFocus: "$handlers.transferForwardAllFocused", class: '$classes.transferlistButton + " " + $classes.transferButtonForwardAll' } })), dke = oi("transferButtonBackward", () => ({ if: "$transferOnSelect !== true", $el: "button", attrs: { id: '$id + "_transfer_button_backward"', onClick: "$handlers.transferBackward", type: "button", disabled: "$selectedTargetItems.length === 0 || $targetOptions.length === 0 || $disabled", "aria-label": "$ui.removeSelectedValues.value", title: "$ui.removeSelectedValues.value", class: '$classes.transferlistButton + " " + $classes.transferButtonBackward' } })), pke = oi("transferButtonBackwardAll", () => ({ $el: "button", attrs: { id: '$id + "_transfer_button_backward_all"', onClick: "$handlers.transferBackwardAll", type: "button", disabled: "$targetOptions.length === 0 || $disabled", "aria-label": "$ui.removeAllValues.value", title: "$ui.removeAllValues.value", class: '$classes.transferlistButton + " " + $classes.transferButtonBackwardAll' } })), ig = oi("controlLabel", "span"), hke = oi("sourceEmptyMessage", () => ({ $el: "li", if: "$showSourceEmptyMessage && $sourceEmptyMessage && $state.loading !== true", attrs: { id: '$id + "_source_empty_message"', key: "$sourceEmptyMessage", role: "presentation" } })), fke = oi("targetEmptyMessage", () => ({ $el: "li", if: "$showTargetEmptyMessage && $targetEmptyMessage", attrs: { id: '$id + "_empty_message"', key: "$emptyMessage", role: "presentation" } })), cI = oi("emptyMessageInner", "span"), Nh = Symbol(), Fh = /* @__PURE__ */ new WeakSet(), Nm = /* @__PURE__ */ new WeakSet();
function d$(e, t, n, i) {
  if (!(e.props.disabled || (e.props.isSourceOption = n, e.props.isSourceOption && Array.isArray(e.value) && e.value.length >= e.props.max))) if (n) {
    if (e.props.selectedSourceItems.includes(t)) return e.props.selectedSourceItems = e.props.selectedSourceItems.filter((r) => r !== t), e.props.activeValue = void 0, void (e.props.activeDescendant = void 0);
    e.props.selectedTargetItems = [], e.props.selectedSourceItems = [...e.props.selectedSourceItems, t];
  } else {
    if (e.props.selectedTargetItems.includes(t)) return void (e.props.selectedTargetItems = e.props.selectedTargetItems.filter((r) => r !== t));
    e.props.selectedSourceItems = [], e.props.selectedTargetItems = [...e.props.selectedTargetItems, t];
  }
}
function Hy(e, t) {
  if (e.props.sourceListOrigin = !0, e.props.maxReached) return;
  if (t) {
    const i = Array.isArray(e.value) ? [...e.value, t] : [t];
    return void e.input(i);
  }
  const n = e.props.selectedSourceItems.map((i) => Nt(i));
  Array.isArray(e.value) ? e.input([...e.value, ...n]) : e.input(n), e.props.selectedSourceItems = [];
}
function Wy(e, t) {
  if (e.props.sourceListOrigin = !1, t) {
    const i = Array.isArray(e.value) ? e.value.filter((r) => r !== t) : [];
    return void e.input(i);
  }
  const n = e.props.selectedTargetItems.map((i) => Nt(i));
  if (Array.isArray(e.value)) {
    const i = e.value.filter((r) => !n.includes(r));
    e.input(i);
  }
  e.props.selectedTargetItems = [];
}
function M3(e) {
  var t, n;
  if (e.props.activeValue === Nh) {
    const r = (t = e.props.__root) === null || t === void 0 ? void 0 : t.getElementById(`${e.props.id}_source_load_more`);
    return void (r && r.scrollIntoView({ block: "nearest", inline: "start" }));
  }
  const i = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(e.props.activeDescendant);
  i && i.scrollIntoView({ block: "nearest", inline: "start" });
}
function rg(e) {
  var t;
  if (Array.isArray(e.value)) {
    const n = [];
    let i = [...e.props.options];
    e.value.forEach((r) => {
      const c = e.props.memoOptions.find((d) => vn(Nt(d), r));
      if (c && !c.noOptionFound)
        n.push(c), e.props.options.findIndex((a) => vn(Nt(a), r)) !== -1 && (i = i.filter((a) => !vn(Nt(a), r)));
      else {
        const d = i.find((a) => vn(Nt(a), r));
        d ? (n.push(d), i = i.filter((a) => !vn(Nt(a), r))) : n.push({ label: String(r), value: r, noOptionFound: !0 });
      }
    }), e.props.targetOptions = e.props.targetInputText ? n.filter((r) => e.props.filter(r, e.props.targetInputText, e)) : n, e.props.sourceOptions = i;
  } else e.props.sourceOptions = [...e.props.options], e.props.targetOptions = [];
  if (e.props.skipSetActiveValue) return void (e.props.skipSetActiveValue = !1);
  !((t = e.props.__root) === null || t === void 0) && t.getElementById(e.props.id + "_source_list_items") && D3(e);
}
function D3(e) {
  var t, n, i, r, c, d, a, f, g;
  if (e.props.isDragging) return;
  if (e.props.targetSearchActive) {
    if (((n = (t = e.props.__root) === null || t === void 0 ? void 0 : t.activeElement) === null || n === void 0 ? void 0 : n.id) === `${e.props.id}_target_search_input`) {
      const A = e.props.targetOptions.find((I) => {
        var O;
        return !(!((O = I.attrs) === null || O === void 0) && O.disabled);
      });
      return A ? void (e.props.activeValue = Nt(A)) : void (e.props.activeValue = void 0);
    }
    return;
  }
  if (e.props.sourceSearchActive) {
    if (((r = (i = e.props.__root) === null || i === void 0 ? void 0 : i.activeElement) === null || r === void 0 ? void 0 : r.id) === `${e.props.id}_source_search_input`) {
      const A = e.props.sourceOptions.find((I) => {
        var O;
        return !(!((O = I.attrs) === null || O === void 0) && O.disabled);
      });
      return A ? void (e.props.activeValue = Nt(A)) : void (e.props.activeValue = void 0);
    }
    e.props.sourceSearchActive = !1;
  }
  if (e.props.transferOnSelect === !1) return void (e.props.activeValue = void 0);
  const x = e.props.sourceListOrigin ? e.props.sourceOptions : e.props.targetOptions;
  let $ = !1;
  for (let A = e.props.activeIndex; A <= x.length; A++) if (!(!((c = x.attrs) === null || c === void 0) && c.disabled) && x[A]) {
    $ = !0, e.props.activeValue = Nt(x[A]);
    break;
  }
  if (!$ && x.length) {
    for (let A = e.props.activeIndex; A >= 0; A--) if (!(!((d = x.attrs) === null || d === void 0) && d.disabled) && x[A]) return $ = !0, void (e.props.activeValue = Nt(x[A]));
  }
  if (!$) {
    let A;
    A = e.props.sourceListOrigin ? (g = e.props.__root) === null || g === void 0 ? void 0 : g.getElementById(`${e.props.id}`) : e.props.searchable ? (a = e.props.__root) === null || a === void 0 ? void 0 : a.getElementById(`${e.props.id}_source_search_input`) : (f = e.props.__root) === null || f === void 0 ? void 0 : f.getElementById(`${e.props.id}_source_list_items`), A && A.focus();
  }
}
function L3(e, t) {
  return (t ? e.props.sourceOptions : e.props.targetOptions).find((n) => {
    var i;
    return !(!((i = n.attrs) === null || i === void 0) && i.disabled);
  });
}
function mke(e) {
  Array.isArray(e.value) && e.value.forEach(async (t) => {
    YL(e, t, function(n, i) {
      return [...n.props.options, ...n.props.memoOptions].find((c) => vn(Nt(c), i));
    }(e, t));
  });
}
function vke(e) {
  e.context && (e.context.handlers.loadMore = Fy.bind(null, e), e.context.fns.getSourceItemCount = (t) => e.props.transferOnSelect === !1 && t.length ? t.length + "/" + e.props.sourceOptions.length : e.props.sourceOptions.length, e.context.fns.getTargetItemCount = (t) => e.props.transferOnSelect === !1 && t.length ? t.length + "/" + e.props.targetOptions.length : e.props.targetOptions.length, e.context.fns.isActive = (t, n) => {
    if (!e.props.isDragging && !e.props.touchStarted) return vn(n, Nt(t)) || void 0;
  }, e.context.fns.isSelected = (t, n) => !!n && !!Array.isArray(n) && n.includes(t), e.context.fns.optionLoading = (t) => e.props.optionLoaderValues.includes(Nt(t)), e.context.handlers.clearSearch = () => {
    (function(t) {
      var n;
      t.props.sourceSearchActive = !1, t.props.inputText = "", el(t, "", !0);
      const i = (n = t.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${t.props.id}_source_search_input`);
      i && i.focus();
    })(e);
  }, e.context.handlers.clearTargetSearch = () => {
    (function(t) {
      var n;
      t.props.targetSearchActive = !1, t.props.targetInputText = "";
      const i = [.../* @__PURE__ */ new Set([...t.props.options, ...t.props.memoOptions])], r = [];
      for (const d of t.value) {
        const a = i.find((f) => Nt(f) === d);
        a && r.push(a);
      }
      t.props.targetOptions = r;
      const c = (n = t.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${t.props.id}_target_search_input`);
      c && c.focus();
    })(e);
  }, e.context.handlers.sourceSearchBlur = (t) => {
    setTimeout(() => {
      var n;
      if (t.relatedTarget && t.relatedTarget instanceof HTMLElement && (t.relatedTarget.id === `${e.props.id}_source_list_items` || t.relatedTarget.id === `${e.props.id}`)) {
        const i = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${e.props.id}_source_search_input`);
        if (!i) return;
        i.focus();
      } else e.props.activeValue = void 0;
    });
  }, e.context.handlers.targetSearchBlur = (t) => {
    setTimeout(() => {
      var n;
      if (t.relatedTarget && t.relatedTarget instanceof HTMLElement && (t.relatedTarget.id === `${e.props.id}_source_list_items` || t.relatedTarget.id === `${e.props.id}`)) {
        const i = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${e.props.id}_target_search_input`);
        if (!i) return;
        i.focus();
      } else e.props.activeValue = void 0;
    });
  }, e.context.handlers.listitemClick = (t, n) => (i) => {
    uI(e, t, n);
  }, e.context.handlers.transferForward = Hy.bind(null, e, void 0), e.context.handlers.transferForwardAll = () => {
    let t;
    if (e.props.maxReached) return;
    const n = e.props.sourceOptions.map((i) => Nt(i));
    t = Array.isArray(e.value) ? [...e.value, ...n] : [...n], e.input(t), e.props.selectedSourceItems = [];
  }, e.context.handlers.transferBackward = Wy.bind(null, e, void 0), e.context.handlers.transferBackwardAll = () => {
    Array.isArray(e.value) && (e.input([]), e.props.selectedTargetItems = []);
  }, e.context.handlers.onSearch = (t) => {
    (function(n, i) {
      n.props.sourceSearchActive = !0;
      const r = i.target;
      n.props.inputText = r.value, el(n, r.value, !0);
    })(e, t);
  }, e.context.handlers.onTargetSearch = (t) => {
    (function(n, i) {
      n.props.targetSearchActive = !0;
      const r = i.target;
      n.props.targetInputText = r.value;
      const c = [.../* @__PURE__ */ new Set([...n.props.memoOptions, ...n.props.options])], d = [];
      for (const f of n.value) {
        const g = c.find((x) => Nt(x) === f);
        g && d.push(g);
      }
      const a = [...new Map([...n.props.targetOptions, ...d].map((f) => [JSON.stringify(f), f])).values()];
      n.props.targetOptions = a.filter((f) => n.props.filter(f, r.value, n)), n.props.targetOptions.length === 0 ? n.props.showTargetEmptyMessage = !0 : n.props.showTargetEmptyMessage = !1, D3(n);
    })(e, t);
  }, e.context.handlers.onMouseenter = (t) => (n) => {
    n.type !== "touchstart" && (t ? e.props.mouseOnSource = !0 : e.props.mouseOnTarget = !0);
  }, e.context.handlers.onMouseleave = (t) => (n) => {
    var i;
    if (n.type === "touchend") return;
    const r = (i = e.props.__root) === null || i === void 0 ? void 0 : i.getElementById(t ? `${e.props.id}_source_list_items` : `${e.props.id}`);
    r && (r.contains(n.relatedTarget) || (e.props.trackHover = !1, e.props.activeValue = void 0, e.props.activeDescendant = void 0, e.props.activeIndex = void 0, t ? e.props.mouseOnSource = !1 : e.props.mouseOnTarget = !1));
  }, e.context.handlers.listitemClick = (t, n) => (i) => {
    i instanceof MouseEvent && e.props.touchStarted || uI(e, t, n);
  }, e.context.handlers.listitemTouchstart = () => () => {
    (function(t) {
      t.props.touchStarted = !0;
    })(e);
  }, e.context.handlers.listitemTouchend = (t, n) => (i) => {
    (function(r, c, d, a) {
      if (r.props.touchMoved) return r.props.touchMoved = !1, void (r.props.touchStarted = !1);
      const f = Nt(c);
      r.props.activeIndex = r.props.sourceOptions.findIndex((g) => Nt(g) === f), r.props.transferOnSelect ? d ? Hy(r, f) : Wy(r, f) : d$(r, c, d);
    })(e, t, n);
  }, e.context.handlers.listitemTouchmove = () => (t) => {
    (function(n) {
      n.props.touchMoved = !0;
    })(e);
  }, e.context.handlers.sourceSearchFocus = (t) => {
    sg(e, !0);
  }, e.context.handlers.targetSearchFocus = (t) => {
    sg(e, !1);
  }, e.context.handlers.sourceListFocused = (t) => {
    sg(e, !0);
  }, e.context.handlers.targetListFocused = () => {
    sg(e, !1);
  }, e.context.handlers.sourceListBlurred = (t) => {
    e.props.activeValue = void 0;
  }, e.context.handlers.targetListBlurred = (t) => {
    e.props.activeValue = void 0;
  }, e.context.handlers.sourceListKeydown = (t) => {
    og(e, t, !0);
  }, e.context.handlers.targetListKeydown = (t) => {
    og(e, t, !1);
  }, e.context.handlers.sourceSearchKeydown = (t) => {
    og(e, t, !0);
  }, e.context.handlers.targetSearchKeydown = (t) => {
    og(e, t, !1);
  });
}
function uI(e, t, n, i) {
  var r;
  if (Nt(t) === Nh) return void ((r = e.context) === null || r === void 0 || r.handlers.loadMore(!0));
  const c = Nt(t);
  e.props.activeIndex = e.props.sourceOptions.findIndex((d) => Nt(d) === c), e.props.transferOnSelect ? n ? Hy(e, c) : Wy(e, c) : d$(e, t, n);
}
function sg(e, t) {
  const n = L3(e, t);
  n && (e.props.sourceListOrigin = t, e.props.activeValue = Nt(n));
}
function og(e, t, n) {
  if (t.key === "ArrowDown" || t.key === "ArrowUp") (function(i, r, c) {
    var d, a, f;
    i.preventDefault();
    const g = c ? r.props.sourceOptions : r.props.targetOptions, x = g.reduce((A, I) => {
      var O;
      return !((O = I == null ? void 0 : I.attrs) === null || O === void 0) && O.disabled || A.push(Nt(I)), A;
    }, []);
    !((d = r.store.hasNextPage) === null || d === void 0) && d.value && x.push(Nh);
    const $ = x.indexOf(r.props.activeValue);
    if (i.key === "ArrowUp" && $ !== 0) for (let A = $ - 1; A >= 0; A--) {
      r.props.sourceListOrigin = c, r.props.activeValue = x[$ - 1];
      break;
    }
    else if (i.key === "ArrowDown" && $ !== x.length - 1) {
      for (let A = $ + 1; A < x.length; A++) if (!(!((f = (a = g[A]) === null || a === void 0 ? void 0 : a.attrs) === null || f === void 0) && f.disabled)) {
        r.props.sourceListOrigin = c, r.props.activeValue = x[A];
        break;
      }
    }
    M3(r);
  })(t, e, n);
  else if (t.key === "ArrowRight" || t.key === "ArrowLeft") {
    if (t.key === "ArrowLeft" && n || t.key === "ArrowRight" && !n) return;
    (function(i, r, c) {
      r.props.searchable || (i.preventDefault(), function(d, a) {
        var f, g, x;
        if (L3(d, !a)) if (a) {
          const $ = (f = d.props.__root) === null || f === void 0 ? void 0 : f.getElementById(`${d.props.id}`);
          $ && $.focus();
        } else if (d.props.searchable) {
          const $ = (g = d.props.__root) === null || g === void 0 ? void 0 : g.getElementById(`${d.props.id}_source_search_input`);
          $ && $.focus();
        } else {
          const $ = (x = d.props.__root) === null || x === void 0 ? void 0 : x.getElementById(`${d.props.id}_source_list_items`);
          $ && $.focus();
        }
      }(r, c));
    })(t, e, n);
  } else t.key === "Enter" && function(i, r, c) {
    var d;
    if (i.preventDefault(), !r.props.activeValue) return;
    if (r.props.activeValue === Nh) return void ((d = r.context) === null || d === void 0 || d.handlers.loadMore(!0));
    const a = c ? r.props.sourceOptions : r.props.targetOptions, f = a.findIndex((x) => Nt(x) === r.props.activeValue);
    r.props.activeIndex = f;
    const g = a[f];
    g && (r.props.transferOnSelect ? c ? Hy(r, Nt(g)) : Wy(r, Nt(g)) : d$(r, g, c));
  }(t, e, n);
}
function gke(e) {
  e.on("created", () => {
    if (typeof e.props.optionsLoader == "function" && (e.props.skipSetActiveValue = !0, Mh(e)), vke(e), e.props.disabled && (e.props.draggable = !1), bo) {
      Pr(e.props.id + "_source_list_items", (n) => {
        n instanceof HTMLElement && function(i, r) {
          if (!i.context) return;
          function c() {
            return i.props.sourceOptions.map((f) => Nt(f));
          }
          function d() {
            return [];
          }
          const a = { longTouch: !0, draggingClass: i.context.classes.dragging, dropZoneClass: i.context.classes.dropZone, group: i.props.id, root: i.props.__root || document, disabled: !i.props.draggable || i.props.maxReached, touchDraggingClass: i.context.classes.touchDragging, touchDropZoneClass: i.context.classes.touchDropZone, selectionDraggingClass: i.context.classes.selectionDragging, selectionDropZoneClass: i.context.classes.selectionDropZone, touchSelectionDraggingClass: i.context.classes.touchSelectionDragging, touchSelectionDropZoneClass: i.context.classes.touchSelectionDropZone, longTouchClass: i.context.classes.longTouch, handleTouchmove(f) {
            i.props.selectedSourceItems = [], ML(f);
          }, draggable: (f) => f.getAttribute("role") === "option" };
          a.plugins = [cT({ handleDragstart(f) {
            i.props.isDragging = !0, i.props.trackHover = !1, i.props.activeValue = void 0, i.props.activeDescendant = void 0, My(f);
          }, handleEnd(f) {
            Dy(f), i.props.isDragging = !1, i.props.activeValue = void 0, i.props.activeDescendant = void 0, i.props.activeDescendant = void 0, i.props.isDragging = !1, i.props.selectedTargetItems = [], i.props.selectedSourceItems = [];
          }, handleTouchstart(f) {
            i.props.isDragging = !0, i.props.trackHover = !1, i.props.activeValue = void 0, i.props.activeDescendant = void 0, i.props.mouseOnSource = !1, i.props.mouseOnTarget = !1, Ly(f);
          }, selections: () => i.props.selectedSourceItems.map((f) => Nt(f)) })], es({ parent: r, getValues: c, setValues: d, config: a }), i.on("prop:disabled", ({ payload: f }) => {
            a.disabled = f, es({ parent: r, getValues: c, setValues: d, config: a });
          }), i.on("prop:draggable", ({ payload: f }) => {
            a.disabled = !f, es({ parent: r, getValues: c, setValues: d, config: a });
          }), i.on("prop:maxReached", ({ payload: f }) => {
            a.disabled = f, es({ parent: r, getValues: c, setValues: d, config: a });
          });
        }(e, n);
      }, e.props.__root), Pr(`${e.props.id}`, (n) => {
        n instanceof HTMLElement && function(i, r) {
          if (!i.context) return;
          function c() {
            return i.props.targetOptions.map((f) => Nt(f));
          }
          function d(f, g) {
            i.props.sourceListOrigin = !0, i.input(f);
          }
          const a = { longTouch: !0, root: i.props.__root, group: i.props.id, disabled: !i.props.draggable, draggingClass: i.context.classes.dragging, dropZoneClass: i.context.classes.dropZone, touchDraggingClass: i.context.classes.touchDragging, touchDropZoneClass: i.context.classes.touchDropZone, selectionDraggingClass: i.context.classes.selectionDragging, selectionDropZoneClass: i.context.classes.selectionDropZone, touchSelectionDraggingClass: i.context.classes.touchSelectionDragging, touchSelectionDropZoneClass: i.context.classes.touchSelectionDropZone, longTouchClass: i.context.classes.longTouch, draggable: (f) => f.getAttribute("role") === "option", plugins: [] };
          a.plugins = [cT({ handleDragstart(f) {
            i.props.isDragging = !0, i.props.trackHover = !1, i.props.activeValue = void 0, My(f);
          }, handleEnd(f) {
            Dy(f), i.props.selectedTargetItems = [], i.props.selectedSourceItems = [], i.props.activeValue = void 0, i.props.trackHover = !0, i.props.isDragging = !1;
          }, handleTouchstart(f) {
            i.props.trackHover = !1, i.props.activeValue = void 0, i.props.isDragging = !0, i.props.activeDescendant = void 0, Ly(f);
          }, selections: () => i.props.selectedTargetItems.map((f) => Nt(f)) })], es({ parent: r, getValues: c, setValues: d, config: a }), i.on("prop:disabled", ({ payload: f }) => {
            a.disabled = f, es({ parent: r, getValues: c, setValues: d, config: a });
          }), i.on("prop:draggable", ({ payload: f }) => {
            a.disabled = !f, es({ parent: r, getValues: c, setValues: d, config: a });
          });
        }(e, n);
      }, e.props.__root);
      const t = (n) => {
        var i;
        if (e.props.isDragging) return;
        e.props.mouseX = n.clientX, e.props.mouseY = n.clientY;
        const r = e.props.mouseOnSource ? `${e.props.id}_source_list_items` : `${e.props.id}`, c = (i = e.props.__root) === null || i === void 0 ? void 0 : i.getElementById(r);
        if (c) {
          const d = c.getBoundingClientRect();
          n.clientX > d.x && n.clientX < d.x + d.width && n.clientY > d.y && n.clientY < d.y + d.height && (e.props.trackHover = !0);
        }
      };
      document.addEventListener("mousemove", t);
    }
  });
}
function p1(e, t) {
  var n;
  let i = null, r = "", c = [];
  if (e.props.mouseOnSource) {
    if (i = Fh.has(e), r = `${e.props.id}_source_list_item`, c = [...e.props.sourceOptions], !c || !c.length || i) return c = [], r = "", void (i = null);
  } else if (e.props.mouseOnTarget && (i = Nm.has(e), r = `${e.props.id}_target_list_item`, c = [...e.props.targetOptions], !c || !c.length || i)) return c = [], r = "", void (i = null);
  const d = c.reduce((f, g, x) => {
    var $, A;
    if (!(($ = g.attrs) === null || $ === void 0) && $.disabled) return f;
    const I = (A = e.props.__root) === null || A === void 0 ? void 0 : A.getElementById(r + `_${x}`);
    return I && f.push([I, g]), f;
  }, []), a = (n = e.props.__root) === null || n === void 0 ? void 0 : n.getElementById(`${e.props.id}_load_more`);
  a && d.push([a, e.props.loadMoreOption]), e.props.mouseOnSource && Fh.add(e), e.props.mouseOnTarget && Nm.add(e), d.length && O3(e, d, null, t);
}
function O3(e, t, n, i) {
  const r = i ? i.getBoundingClientRect() : { top: 0, bottom: 0 };
  if (n = null, e.props.trackHover) {
    if (e.props.mouseY > r.top && e.props.mouseY < r.bottom) {
      let c = n || 0, d = n;
      const a = (f, g) => {
        var x;
        const $ = g[0], { y: A, height: I, x: O, width: B } = $.getBoundingClientRect();
        if (e.props.mouseX > O && e.props.mouseX < O + B && e.props.mouseY > A && e.props.mouseY < A + I) {
          n = f;
          const H = g[1];
          return e.props.activeValue = H && !(!((x = H.attrs) === null || x === void 0) && x.disabled) ? Nt(H) : void 0, !0;
        }
        return !1;
      };
      do {
        if (c !== null && a(c, t[c]) || d !== null && a(d, t[d])) break;
        c !== null && (c++, c > t.length - 1 && (c = null)), d !== null && (d--, d < 0 && (d = null));
      } while (c !== null || d !== null);
    }
  } else M3(e);
  e.props.mouseOnSource || e.props.mouseOnTarget ? e.props.mouseOnSource && Fh.has(e) || e.props.mouseOnTarget && Nm.has(e) ? requestAnimationFrame(O3.bind(null, e, t, n, i)) : p1(e, i) : (Fh.delete(e), Nm.delete(e));
}
const yke = { schema: /* @__PURE__ */ PCe(/* @__PURE__ */ NCe(/* @__PURE__ */ FCe("$label"), /* @__PURE__ */ DCe("$help"), /* @__PURE__ */ MCe(/* @__PURE__ */ RCe(/* @__PURE__ */ zCe(/* @__PURE__ */ BCe(), /* @__PURE__ */ VCe(/* @__PURE__ */ sn("$optionsLoadingCounter > 0", /* @__PURE__ */ Al("loader"), "$fns.getSourceItemCount($selectedSourceItems)"))), /* @__PURE__ */ WCe(/* @__PURE__ */ ZCe(/* @__PURE__ */ qCe(), /* @__PURE__ */ KCe(/* @__PURE__ */ Al("close")))), /* @__PURE__ */ JCe(/* @__PURE__ */ hke(/* @__PURE__ */ cI("$sourceEmptyMessage")), /* @__PURE__ */ QCe(/* @__PURE__ */ sn("$transferOnSelect !== true && $fns.isSelected($option, $selectedSourceItems)", /* @__PURE__ */ Al("selected")), /* @__PURE__ */ eke("$option.label")), /* @__PURE__ */ tke(/* @__PURE__ */ sn("$state.loading && $optionLoadingCounter === 0 || $state.hasNextPage", /* @__PURE__ */ nke(/* @__PURE__ */ sn("$state.loading", /* @__PURE__ */ Al("loader")), "$state.loading && $ui.isLoading.value || $ui.loadMore.value"))))), /* @__PURE__ */ lke(/* @__PURE__ */ uke(/* @__PURE__ */ ig("$ui.addAllValues.value"), /* @__PURE__ */ Al("fastForward")), /* @__PURE__ */ cke(/* @__PURE__ */ ig("$ui.addSelectedValues.value"), /* @__PURE__ */ Al("moveRight")), /* @__PURE__ */ dke(/* @__PURE__ */ ig("$ui.removeSelectedValues.value"), /* @__PURE__ */ Al("moveLeft")), /* @__PURE__ */ pke(/* @__PURE__ */ ig("$ui.removeAllValues.value"), /* @__PURE__ */ Al("rewind"))), /* @__PURE__ */ ike(/* @__PURE__ */ rke(/* @__PURE__ */ UCe(), /* @__PURE__ */ HCe("$fns.getTargetItemCount($selectedTargetItems)")), /* @__PURE__ */ YCe(/* @__PURE__ */ jCe(/* @__PURE__ */ GCe(), /* @__PURE__ */ XCe(/* @__PURE__ */ Al("close")))), /* @__PURE__ */ ske(/* @__PURE__ */ fke(/* @__PURE__ */ sn("$state.loading !== true", /* @__PURE__ */ cI("$targetEmptyMessage"))), /* @__PURE__ */ oke(/* @__PURE__ */ sn("$transferOnSelect !== true && $fns.isSelected($option, $selectedTargetItems)", /* @__PURE__ */ Al("selected")), /* @__PURE__ */ ake(/* @__PURE__ */ sn("$fns.optionLoading($option, $optionLoaderValues)", "$ui.isLoading.value", "$option.label")))))), /* @__PURE__ */ LCe(/* @__PURE__ */ OCe("$message.value")))), type: "input", props: [], features: [
  /* @__PURE__ */ Qn("moveRight", "right"),
  /* @__PURE__ */ Qn("moveLeft", "left"),
  /* @__PURE__ */ Qn("fastForward", "fastForward"),
  /* @__PURE__ */ Qn("rewind", "rewind"),
  /* @__PURE__ */ Qn("close", "close"),
  /* @__PURE__ */ Qn("loader", "spinner"),
  /* @__PURE__ */ Qn("selected", "check"),
  /* @__PURE__ */ bi("isLoading"),
  /* @__PURE__ */ bi("loadMore"),
  /* @__PURE__ */ bi("addAllValues"),
  /* @__PURE__ */ bi("addSelectedValues"),
  /* @__PURE__ */ bi("removeSelectedValues"),
  /* @__PURE__ */ bi("removeAllValues"),
  Zl,
  function(e) {
    (function(t) {
      t.addProps(["search", "options", "selectedItems", "activeValue", "activeIndex", "activeDescendant", "targetOptions", "sourceOptions", "optionLoader", "isLoadingOptions", "filterOptions", "inputText", "hasNextPage", "page", "targetLoading", "searchable", "sourceLabel", "targetLabel", "transferOnSelect", "disabled", "placeholder", "filter", "showSourceEmptyMessage", "showTargetEmptyMessage", "sourceEmptyMessage", "targetEmptyMessage", "clearOnSelect", "max", "maxReached", "debounce", "sourceListActive", "optionLoaderValues", "optionLoadingCounter", "optionsLoadingCounter", "memoOptions", "optionsLoaded", "selectedSourceItems", "selectedTargetItems", "draggable", "loadMore", "loadMoreOption", "targetSearchable", "targetInputText"]), t.props.loadMoreOption = { label: "Load more", value: Nh }, t.props.draggable === void 0 ? t.props.draggable = !0 : t.props.draggable === "false" && (t.props.draggable = !1), t.props.optionsLoaderValues = [], t.props.selectedSourceItems = [], t.props.selectedTargetItems = [], t.props.optionsLoaded = void 0, t.props.memoOptions = [], t.props.multiple = !0, t.props.debounce = t.props.debounce ? parseInt(t.props.debounce) : 200, t.props.optionLoaderValues = [], t.props.optionsLoadingCounter = 0, t.props.optionLoadingCounter = 0, t.props.page = 1, t.props.hasNextPage = KL.bind(null, t), t.props.options ? t.props.options = [...t.props.options] : t.props.options = [], t.props.sourceOptions = [], t.props.targetOptions = [], "disabled" in t.props && (t.props.disabled = on(t.props.disabled)), t.props.searchable = on(t.props.searchable), t.props.searchable && (t.props.inputText = ""), t.props.targetSearchable = on(t.props.targetSearchable), t.props.targetSearchable && (t.props.targetInputText = ""), t.props.clearOnSelect = on(t.props.clearOnSelect), t.props.transferOnSelect === void 0 ? t.props.transferOnSelect = !0 : t.props.transferOnSelect === "false" && (t.props.transferOnSelect = !1), t.props.targetOptions.length && (t.props.targetOptionValues = t.props.targetOptions.map((n) => Nt(n))), t.props.initialOptions = [...t.props.options], t.props.max && (t.props.max = parseInt(t.props.max)), t.props.sourceListOrigin = void 0, typeof t.props.filter != "function" && (t.props.filter = (n, i) => n.label.toLowerCase().includes(i.toLowerCase()));
    })(e), function(t) {
      t.on("commit", async ({ payload: n }) => {
        t.props.activeValue = void 0, t.props.max && (t.props.maxReached = n.length >= t.props.max), t.props.clearOnSelect && t.props.inputText && (t.props.reFilter = !0, t.props.inputText = ""), t.props.memoOptions = [.../* @__PURE__ */ new Set([...t.props.targetOptions, ...t.props.memoOptions])], t.props.searchable && t.props.reFilter && !t.props.initialLoad ? (el(t, t.props.inputText), t.props.reFilter = !1) : t.props.initialLoad || (t.isCreated || (t.props.skipSetActiveValue = !0), rg(t)), typeof t.props.optionLoader == "function" ? mke(t) : t.props.initialLoad || (t.props.memoOptions = [.../* @__PURE__ */ new Set([...t.props.targetOptions, ...t.props.memoOptions])]);
      });
    }(e), gke(e), function(t) {
      t.on("prop:options", () => {
        t.props.appendingOptions && (t.props.skipSetActiveValue = !0, t.props.appendingOptions = !1), rg(t);
      }), t.on("prop:memoOptions", () => {
        t.props.skipSetActiveValue = !0, rg(t);
      }), t.on("prop:sourceOptions", () => {
        t.props.sourceOptions.length === 0 ? t.props.showSourceEmptyMessage = !0 : t.props.showSourceEmptyMessage = !1, Fh.delete(t);
      }), t.on("prop:targetOptions", () => {
        t.props.targetOptions.length === 0 ? t.props.showTargetEmptyMessage = !0 : t.props.showTargetEmptyMessage = !1;
      }), t.on("prop:activeValue", ({ payload: n }) => {
        if (t.props.isDragging) return void (t.props.activeDescendant = void 0);
        if (n === Nh) return void (t.props.activeDescendant = `${t.props.id}_load_more`);
        const i = (t.props.sourceListOrigin ? t.props.sourceOptions : t.props.targetOptions).findIndex((r) => vn(Nt(r), n));
        i >= 0 && t.props.sourceListOrigin ? t.props.activeDescendant = `${t.props.id}_source_list_item_${i}` : t.props.activeDescendant = i >= 0 ? `${t.props.id}_target_list_item_${i}` : void 0;
      }), t.on("prop:mouseOnSource", ({ payload: n }) => {
        var i;
        if (n && t.props.disabled !== !0 && !t.props.isDragging) {
          const r = (i = t.props.__root) === null || i === void 0 ? void 0 : i.getElementById(t.props.id + "_source_list_items");
          if (!r) return;
          t.props.mouseOnTarget = !1, t.props.sourceListOrigin = !0, Fh.delete(t), p1(t, r);
        }
      }), t.on("prop:mouseOnTarget", ({ payload: n }) => {
        var i;
        if (n && t.props.disabled !== !0 && !t.props.isDragging) {
          const r = (i = t.props.__root) === null || i === void 0 ? void 0 : i.getElementById(`${t.props.id}`);
          if (!r) return;
          t.props.mouseOnSource = !1, t.props.sourceListOrigin = !1, Nm.delete(t), p1(t, r);
        }
      }), t.on("prop:optionsLoadingCounter", ({ payload: n }) => {
        n === 0 && t.props.optionLoadingCounter === 0 && t.store.set(Dm);
      }), t.on("prop:optionLoadingCounter", ({ payload: n }) => {
        n === 0 && t.props.optionsLoadingCounter === 0 && (t.store.set(Dm), t.props.skipSetActiveValue = !0, rg(t));
      });
    }(e);
  }
] }, Cr = /* @__PURE__ */ $o("sl"), { outer: _ke, wrapper: bke, icon: dI, prefix: wke, suffix: xke, help: $ke, messages: Cke, message: kke } = /* @__PURE__ */ Co(Cr), Ske = Cr("label", () => ({ if: "$label", $el: "label", attrs: { id: "$id + '_label'" } })), Tke = Cr("chart", () => ({ $el: "div", if: "$chart" })), Ike = Cr("chartBar", () => ({ $el: "div", for: ["bar", "index", "$chart"], attrs: { "data-active": { if: "$isMulti", then: { if: "$_value.0 < $_value.1", then: "$bar.at >= $_value.0 && $bar.at <= $_value.1", else: "$bar.at >= $_value.1 && $bar.at <= $_value.0" }, else: "$bar.at <= $_value" }, style: { left: '$bar.at / ($max - $min) * 100 + "%"', width: '$: "calc(" + (100 / $chart.length) + "% - 2px)"', height: { if: "$largestBar", then: '$bar.value / $largestBar * 100 + "%"' } } } })), Ake = Cr("sliderInner", () => ({ $el: "div", attrs: { "data-has-mark-labels": "$markLabels && $marks.length > 0" } })), Eke = Cr("track", () => ({ $el: "div", attrs: { id: "$: 'track-' + $id", onClick: "$handlers.clickTrack" } })), Pke = Cr("trackWrapper", () => ({ $el: "div" })), Mke = Cr("trackInner", () => ({ $el: "div" })), Dke = Cr("fill", () => ({ $el: "div", attrs: { style: "$fillStyles" } })), Lke = Cr("linkedValues", () => ({ $el: "div" })), pI = Cr("maxValue", () => ({ $formkit: "number", bind: "$computedMaxInputAttrs", ignore: !0, number: !0, value: { if: "$isMulti", then: "$_value.1", else: "$_value" }, tabindex: { if: "$disabled", then: -1 }, onNode: "$handlers.maxNode", onBlur: "$handlers.inputBlur" })), Oke = Cr("minValue", () => ({ $formkit: "number", if: "$isMulti", bind: "$computedMinInputAttrs", ignore: !0, number: !0, value: { if: "$isMulti", then: "$_value.0", else: "$_value" }, tabindex: { if: "$disabled", then: -1 }, onNode: "$handlers.minNode", onBlur: "$handlers.inputBlur" })), Nke = Cr("marks", () => ({ $el: "div", if: "$marks" })), Fke = Cr("mark", () => ({ $el: "span", for: ["step", "index", "$marks"], attrs: { "data-active": { if: "$isMulti", then: { if: "$_value.0 < $_value.1", then: "$step.at >= $_value.0 && $step.at <= $_value.1", else: "$step.at >= $_value.1 && $step.at <= $_value.0" }, else: "$step.at <= $_value" }, class: { if: "$step.class", then: '$: $classes.mark + " " + $step.class', else: "$classes.mark" }, style: { left: '$: $fns.calculateMarkPosition($step.at) + "%"' } } })), Rke = Cr("markLabel", () => ({ $el: "span", if: "$markLabels", children: { if: "$step.label !== undefined", then: "$step.label", else: "" }, attrs: { class: '$: $classes.markLabel + " " + $step.labelClass' } })), zke = Cr("handles", () => ({ $el: "ul" })), Bke = Cr("handleMax", () => ({ $el: "li", attrs: { "data-active": "$dragging", "data-is-target": '$lastHandleInteraction === "max"', "data-handle": "max", "data-show-tooltip": "$tooltip", class: "$: 'formkit-handle ' + $classes.handle + ' ' + $classes.handleMax", onFocus: "$handlers.focus", onClick: "$handlers.clickHandle", onMousedown: "$handlers.startDrag", onTouchstart: "$handlers.startDrag", style: "$maxHandleStyles", tabindex: { if: "$disabled", then: -1, else: 0 }, onBlur: "$handlers.blur", onKeydown: "$handlers.keydown" } })), Vke = Cr("handleMin", () => ({ $el: "li", if: "$isMulti", attrs: { "data-active": "$dragging", "data-is-target": '$lastHandleInteraction === "min"', "data-handle": "min", "data-show-tooltip": "$tooltip", class: "$: $classes.handle + ' ' + $classes.handleMin", onFocus: "$handlers.focus", onClick: "$handlers.clickHandle", onMousedown: "$handlers.startDrag", onTouchstart: "$handlers.startDrag", style: "$minHandleStyles", tabindex: { if: "$disabled", then: -1, else: 0 }, onBlur: "$handlers.blur", onKeydown: "$handlers.keydown" } })), Uke = Cr("handleMinInner", () => ({ $el: "div", attrs: { class: '$: $classes.handleInner + " " + $classes.handleMinInner' } })), Hke = Cr("handleMaxInner", () => ({ $el: "div", attrs: { class: '$: $classes.handleInner + " " + $classes.handleMaxInner' } })), Wke = Cr("tooltipMax", () => ({ $el: "div", if: '$tooltip === true || $tooltip === "auto"', children: { if: "$isMulti", then: { if: "$_value.0 < $_value.1", then: '$tooltipFormat($_value.1, "max")', else: '$tooltipFormat($_value.0, "max")' }, else: '$tooltipFormat($_value, "max")' }, attrs: { class: "$classes.tooltip + ' ' + $classes.tooltipMax" } })), Zke = Cr("tooltipMin", () => ({ $el: "div", if: '$isMulti && ($tooltip === true || $tooltip === "auto")', children: { if: "$_value.0 < $_value.1", then: '$tooltipFormat($_value.0, "min")', else: '$tooltipFormat($_value.1, "min")' }, attrs: { class: "$classes.tooltip + ' ' + $classes.tooltipMin" } })), qke = { schema: /* @__PURE__ */ _ke(/* @__PURE__ */ bke(/* @__PURE__ */ Ske("$label"), /* @__PURE__ */ $ke("$help"), /* @__PURE__ */ Ake(/* @__PURE__ */ dI("prefix"), /* @__PURE__ */ wke(), /* @__PURE__ */ Eke(/* @__PURE__ */ Tke(/* @__PURE__ */ Ike()), /* @__PURE__ */ Pke(/* @__PURE__ */ Mke(/* @__PURE__ */ Dke(), /* @__PURE__ */ Nke(/* @__PURE__ */ Fke(/* @__PURE__ */ Rke())), /* @__PURE__ */ zke(/* @__PURE__ */ Vke(/* @__PURE__ */ Zke(), /* @__PURE__ */ Uke()), /* @__PURE__ */ Bke(/* @__PURE__ */ Wke(), /* @__PURE__ */ Hke()))))), /* @__PURE__ */ xke(), /* @__PURE__ */ dI("suffix"), /* @__PURE__ */ sn("$showInput && $isMulti === false", /* @__PURE__ */ pI())), /* @__PURE__ */ sn("$showInput && $isMulti", /* @__PURE__ */ Lke(/* @__PURE__ */ Oke(), /* @__PURE__ */ pI())), /* @__PURE__ */ Cke(/* @__PURE__ */ kke("$message.value")))), type: "input", family: "", props: ["min", "max", "step", "showInput", "tooltip", "tooltipFormat", "inputAttrs", "maxInputAttrs", "minInputAttrs", "marks", "markLabels", "snapToMarks", "chart", "scalingFunction", "intervals"], features: [function(e) {
  let t, n, i;
  e.addProps(["isMulti", "maxHandleStyles", "minHandleStyles", "fillStyles", "decimals", "dragging", "lastHandleInteraction", "largestBar", "computedMaxInputAttrs", "computedMinInputAttrs"]);
  const r = { linear: { forward: (U) => U, reverse: (U) => U }, log: { forward: (U, q = e.props.min, ee = e.props.max) => ee * Math.pow(U / ee, 1.5), reverse: (U, q = e.props.min, ee = e.props.max) => ee * Math.pow(U / ee, 1 / 1.5) } };
  let c = !1;
  function d() {
    const U = document.activeElement;
    if (U instanceof HTMLInputElement) {
      const q = U.value;
      U.value = "", U.value = q;
    }
  }
  function a(U) {
    if (!U) return;
    const q = { disabled: U.props.disabled, min: typeof U.props.min == "number" ? U.props.min : 0, max: typeof U.props.max == "number" ? U.props.max : void 0, step: U.props.step || 1 };
    U.props.minInputAttrs = Object.assign(U.props.minInputAttrs || {}, q), U.props.maxInputAttrs = Object.assign(U.props.maxInputAttrs || {}, q), U.props.inputAttrs = U.props.inputAttrs && typeof U.props.inputAttrs == "object" ? Object.assign(U.props.inputAttrs, q) : q, U.props.computedMaxInputAttrs = U.props.maxInputAttrs && typeof U.props.maxInputAttrs == "object" ? Object.assign({}, U.props.inputAttrs, U.props.maxInputAttrs) : U.props.inputAttrs, U.props.computedMinInputAttrs = U.props.minInputAttrs && typeof U.props.minInputAttrs == "object" ? Object.assign({}, U.props.inputAttrs, U.props.minInputAttrs) : U.props.inputAttrs;
  }
  function f(U) {
    const { min: q, max: ee, intervals: te } = e.props;
    if (U = Math.min(Math.max(U, 0), 100), !te || te.length === 0) {
      K();
      const oe = q + U / 100 * (ee - q);
      return e.props.scalingFunction.reverse(oe, q, ee);
    }
    const ae = x(te, q, ee);
    for (let oe = 0; oe < ae.length; oe++) {
      const { value: de, step: me, left: ve, width: re, stepsInInterval: le } = ae[oe];
      if (U >= ve && U <= ve + re) {
        const pe = de + (U - ve) / re * le * me, Ne = pe % me;
        return B(Ne < me / 2 ? pe - Ne : pe + (me - Ne));
      }
    }
    return U > 100 ? ee : U < 0 ? q : void 0;
  }
  function g(U, q = e.props.min, ee = e.props.max) {
    const te = e.props.intervals;
    if (!te || te.length === 0)
      return K(), (e.props.scalingFunction.forward(U, q, ee) - q) / (ee - q) * 100;
    const ae = x(te, q, ee);
    for (let oe = 0; oe < ae.length; oe++) {
      const { value: de, step: me, left: ve, width: re, stepsInInterval: le } = ae[oe], pe = oe < ae.length - 1 ? ae[oe + 1].value : ee;
      if (U >= de && U <= pe)
        return 100 * ((ve + (U - de) / me / le * re) / 100);
    }
    return 100;
  }
  function x(U, q = e.props.min, ee = e.props.max) {
    (U = [...U]).sort((oe, de) => oe.value - de.value), U[0].value !== q && U.unshift({ value: q, step: e.props.step });
    let te = 0;
    for (let oe = 0; oe < U.length; oe++) {
      const de = U[oe].value, me = ((oe < U.length - 1 ? U[oe + 1].value : ee) - de) / U[oe].step;
      te += me;
    }
    let ae = 0;
    return U.map((oe, de) => {
      const me = oe.value, ve = ((de < U.length - 1 ? U[de + 1].value : ee) - me) / oe.step, re = ae / te * 100;
      return ae += ve, { value: oe.value, step: oe.step, left: re, width: ve / te * 100, stepsInInterval: ve, totalSteps: te };
    });
  }
  function $() {
    const U = parseFloat(`${e.props.min}`), q = parseFloat(`${e.props.max}`);
    let ee, te = 0;
    if (Array.isArray(e._value)) {
      const ae = [...e._value].sort(A);
      te = parseFloat(`${ae[0]}`), ee = parseFloat(`${ae[1]}`);
    } else ee = parseFloat(`${e._value}`);
    e.props.maxHandleStyles = { left: `${g(ee, U, q)}%` }, e.props.isMulti && Array.isArray(e._value) ? (e.props.minHandleStyles = { left: `${g(te, U, q)}%` }, e.props.fillStyles = { left: `${g(te, U, q)}%`, width: g(ee, U, q) - g(te, U, q) + "%" }) : e.props.fillStyles = { left: "0%", width: `${g(ee, U, q)}%` };
  }
  function A(U, q) {
    return parseFloat(`${U}`) - parseFloat(`${q}`);
  }
  function I(U, q = !0) {
    if (e.props.disabled) return;
    let ee;
    if (U === void 0) {
      if (e.props.isMulti) e.input([H(e.props.min), H(e.props.max)]);
      else {
        const ae = e.props.min + (e.props.max - e.props.min) / 2;
        e.input(H(ae));
      }
      return void $();
    }
    if (e.props.isMulti && Array.isArray(e._value) && !Array.isArray(U)) {
      const ae = e.props.lastHandleInteraction === "min" ? 0 : 1;
      e._value[ae] = U;
      const [oe, de] = [...e._value];
      if (oe >= de) {
        const me = t == null ? void 0 : t.querySelector(`[data-handle="${e.props.lastHandleInteraction === "min" ? "max" : "min"}"]`);
        me == null || me.focus();
      }
      ee = H([...e._value].sort(A));
    } else Array.isArray(U) ? ee = H(U) : (ee = H(U), ee = isNaN(ee) ? e.props.min : ee);
    e.props.snapToMarks && (ee = N(ee));
    const te = H(O(ee));
    q && e.input(te), $();
  }
  function O(U) {
    return e.props.isMulti && Array.isArray(U) ? [O(U[0]), O(U[1])] : (U = isNaN(U) ? e.props.min : U, Math.min(Math.max(parseFloat(`${U}`), e.props.min), e.props.max));
  }
  function B(U) {
    return parseFloat(U.toFixed(e.props.decimals));
  }
  function H(U) {
    if (e.props.snapToMarks) return U;
    if (!e.props.intervals) return Array.isArray(U) ? U.map((ee) => B(Math.round(ee / e.props.step) * e.props.step)) : B(Math.round(U / e.props.step) * e.props.step);
    const q = x(e.props.intervals);
    if (Array.isArray(U)) return U.map((ee) => {
      const te = q.find((ae, oe) => {
        var de;
        return ee >= ae.value && ee < (((de = q[oe + 1]) === null || de === void 0 ? void 0 : de.value) || e.props.max);
      });
      return te ? B(te.value + Math.round((ee - te.value) / te.step) * te.step) : ee;
    });
    {
      const ee = q.find((te, ae) => {
        var oe;
        return U >= te.value && U < (((oe = q[ae + 1]) === null || oe === void 0 ? void 0 : oe.value) || e.props.max);
      });
      return ee ? B(ee.value + Math.round((U - ee.value) / ee.step) * ee.step) : U;
    }
  }
  function N(U) {
    if (Array.isArray(U)) return U[0] = N(U[0]), U[1] = N(U[1]), U;
    {
      const q = e.props.marks;
      return q.reduce((te, ae) => Math.abs(ae.at - U) < Math.abs(te.at - U) ? ae : te, q[0]).at;
    }
  }
  function K() {
    c || (on(e.props.scalingFunction) ? typeof e.props.scalingFunction == "string" ? e.props.scalingFunction = r[e.props.scalingFunction] || r.linear : typeof e.props.scalingFunction == "object" && (e.props.scalingFunction = { ...r.linear, ...e.props.scalingFunction }) : e.props.scalingFunction = r.linear, c = !0);
  }
  e.props.maxHandleStyles = { left: "0%" }, e.props.fillStyles = { left: "0%", width: "0%" }, e.props.isMulti = !1, e.props.step = 1, e.props.min = 0, e.props.max = 100, e.props.tooltipFormat = typeof e.props.tooltipFormat == "function" ? e.props.tooltipFormat : (U, q) => {
    if (q) return U;
  }, e.props.largestBar = 0, "disabled" in e.props && (e.props.disabled = on(e.props.disabled)), e.on("created", () => {
    var U;
    K(), e.props.isMulti = Array.isArray(e.value), e.props.step = parseFloat(`${e.props.step}`), e.props.decimals = ((U = e.props.step.toString().split(".")[1]) === null || U === void 0 ? void 0 : U.length) || 0, e.props.min = e.props.min ? parseFloat(`${e.props.min}`) : 0, e.props.max = e.props.max ? parseFloat(`${e.props.max}`) : 100;
    const q = on(e.props.tooltip);
    e.props.tooltip = e.props.tooltip === void 0 ? "auto" : q;
    const ee = on(e.props.marks);
    if (e.props.marks = !!ee && (Array.isArray(e.props.marks) ? e.props.marks : function() {
      const { min: oe, max: de, step: me } = e.props, ve = [];
      for (let re = oe; re <= de; re += me) ve.push({ at: re, label: re });
      return ve;
    }()), e.props.markLabels = on(e.props.markLabels), e.props.snapToMarks = on(e.props.snapToMarks), e.props.showInput = on(e.props.showInput), e.props.largestBar = e.props.chart ? e.props.chart.reduce((oe, de) => de.value > oe ? de.value : oe, 0) : e.props.largestBar, a(e), Pr(`track-${e.props.id}`, () => {
      var oe;
      t = (oe = e.props.__root) === null || oe === void 0 ? void 0 : oe.getElementById(`track-${e.props.id}`), I(e.value, !1), $();
    }, e.props.__root), e.context) {
      let oe = 0, de = "";
      const me = e.context.handlers.blur;
      e.context.handlers.blur = (ve) => {
        me(ve), e.emit("blur");
      }, e.context.handlers.clickTrack = (ve) => {
        if (!t) return;
        e.props.dragging = !1;
        const { left: re, width: le } = t.getBoundingClientRect(), pe = (ve.clientX - re) / le;
        if (e.props.isMulti && Array.isArray(e.value)) {
          const [Ne, We] = e.value, Ge = Math.abs(Ne - pe * e.props.max) < Math.abs(We - pe * e.props.max) ? "min" : "max", et = Ge === "min" ? 0 : 1;
          e.props.lastHandleInteraction = Ge, e.value[et] = f(100 * pe), I(e._value);
        } else I(f(100 * pe));
      }, e.context.handlers.focus = (ve) => {
        if (!t) return;
        const re = ve.target.dataset.handle;
        re && (e.props.lastHandleInteraction = re);
      }, e.context.handlers.clickHandle = (ve) => {
        ve.stopPropagation(), e.props.attrs.onClick && e.props.attrs.onClick(ve), e.props.dragging = !1, I(e._value);
      }, e.context.handlers.startDrag = (ve) => {
        if (!t) return;
        e.props.dragging = !0;
        const re = ve.type === "touchstart", le = re ? "touchmove" : "mousemove", pe = re ? "touchend" : "mouseup";
        e.props.lastHandleInteraction = ve.target.dataset.handle || e.props.lastHandleInteraction, document.addEventListener(le, ae, { passive: !1 }), document.addEventListener(pe, () => {
          e.context && (e.props.dragging = !1, document.removeEventListener(le, ae), re && ve.target instanceof HTMLElement && ve.target.blur());
        });
      }, e.context.handlers.keydown = (ve) => {
        if (["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", ".", "-"].includes(ve.key)) {
          ve.preventDefault(), clearTimeout(oe), de += ve.key;
          const re = de === "-" ? -1 : 1;
          oe = window.setTimeout(() => {
            de !== "-" && I(parseFloat(de) * re), de = "";
          }, 350);
        }
        if (["ArrowLeft", "ArrowDown", "ArrowRight", "ArrowUp", "PageUp", "PageDown", "Home", "End"].includes(ve.key)) {
          ve.preventDefault();
          const re = e.props.lastHandleInteraction === "min" ? 0 : 1, le = Array.isArray(e._value) ? e._value[re] : e._value, pe = function(Ne, We) {
            if (!e.props.intervals) return e.props.step;
            const Ge = x(e.props.intervals);
            if (Ne >= e.props.max) return Ge[Ge.length - 1].step;
            let et = Ge.find((ft, De) => {
              var Ke;
              return Ne >= ft.value && Ne < (((Ke = Ge[De + 1]) === null || Ke === void 0 ? void 0 : Ke.value) || e.props.max);
            });
            return et ? (We === -1 && Ne - et.step < et.value && (et = Ge[Ge.indexOf(et) - 1] || et), et.step) : e.props.step;
          }(le, ["ArrowLeft", "ArrowDown", "PageDown"].includes(ve.key) ? -1 : 1);
          if (e.props.marks && e.props.snapToMarks) {
            const Ne = N(le), We = e.props.marks.find((De) => De.at === Ne), Ge = e.props.marks.indexOf(We), et = ["ArrowLeft", "ArrowDown"].includes(ve.key) ? -1 : 1, ft = Math.min(Math.max(0, Ge + et), e.props.marks.length - 1);
            return void I(e.props.marks[ft].at);
          }
          if (ve.metaKey) return void (ve.key === "ArrowLeft" || ve.key === "ArrowDown" ? I(e.props.min) : I(e.props.max));
          if (ve.key === "Home") return void I(e.props.min);
          if (ve.key === "End") return void I(e.props.max);
          ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(ve.key) && I(le + (ve.shiftKey ? 10 * pe : pe) * (["ArrowLeft", "ArrowDown"].includes(ve.key) ? -1 : 1)), ve.key === "PageUp" ? I(le + 10 * pe) : ve.key === "PageDown" && I(le - 10 * pe);
        }
      }, e.context.handlers.maxNode = (ve) => {
        i = ve, ve.hook.commit((re, le) => vn(ve.value, re) ? le(re) : (`${ve.value}`.includes(".") && !`${re}`.includes(".") && d(), e.props.isMulti && Array.isArray(e.value) ? I([e.value[0], re]) : I(re), le(O(re))));
      }, e.context.handlers.minNode = (ve) => {
        n = ve, ve.hook.commit((re, le) => vn(ve.value, re) ? le(re) : (`${ve.value}`.includes(".") && !`${re}`.includes(".") && d(), e.props.isMulti && Array.isArray(e.value) ? I([re, e.value[1]]) : I(re), le(O(re))));
      }, e.context.handlers.inputBlur = () => {
        e.props.isMulti && Array.isArray(e._value) && I([...e._value].sort(A));
      }, e.context.fns.calculateMarkPosition = (ve) => g(ve, e.props.min, e.props.max);
    }
    let te;
    function ae(oe) {
      var de;
      if (!t || !e.props.dragging) return;
      oe.preventDefault();
      const me = oe.clientX || ((de = oe.touches) === null || de === void 0 ? void 0 : de.length) && oe.touches[0].clientX, { left: ve, width: re } = t.getBoundingClientRect(), le = H(f((me - ve) / re * 100));
      te !== le && (te = le, I(le));
    }
    I(e.value);
  }), e.on("input", ({ payload: U }) => {
    Array.isArray(e.value) && Array.isArray(U) ? e.value[0] === U[0] && e.value[1] === U[1] || I(U, !1) : e.value !== U && I(U, !1), function() {
      if (e.props.isMulti && Array.isArray(e._value)) {
        const [q, ee] = [...e._value];
        n && n.input(B(q)), i && i.input(B(ee));
      } else i && i.input(e._value);
    }();
  }), e.on("prop:max", () => {
    e.props.max = e.props.max ? parseFloat(`${e.props.max}`) : 100, I(e.value), a(e);
  }), e.on("prop:min", () => {
    e.props.min = e.props.min ? parseFloat(`${e.props.min}`) : 0, I(e.value), a(e);
  });
}] }, Si = /* @__PURE__ */ $o("cp"), { outer: jke, wrapper: Gke, inner: Yke, label: Kke, prefix: Xke, suffix: Jke, help: hI, messages: Qke, message: eSe, icon: Zf } = /* @__PURE__ */ Co(Si), tSe = Si("swatchPreview", () => ({ $el: "div", attrs: { id: "$id", class: "$classes.swatchPreview", tabindex: { if: "$disabled", then: -1, else: 0 }, onClick: "$handlers.inputPreviewClick", onFocusout: "$handlers.inputPreviewFocusout", onKeydown: "$handlers.inputPreviewKeydown", role: "button", "aria-valuetext": '$: "Current color: " + $value' } })), nSe = Si("valueString", () => ({ $el: "span", attrs: { class: "$classes.valueString" }, children: { if: '$format === "hex"', then: "$hex", else: { if: '$format === "rgba"', then: "$rgbaString", else: { if: '$format === "hsla"', then: "$hslaString", else: "" } } } })), iSe = Si("panel", () => ({ $el: "div", attrs: { id: '$: $id + "_popover"', class: "$classes.panel", onKeydown: "$handlers.panelKeydown", "aria-role": { if: "$layout === popover", then: "dialog" }, "aria-modal": { if: "$layout === popover", then: "true" }, "aria-label": "$label", popover: "$popover", style: { if: "$usePopover", then: { margin: 0, top: '$popoverCoordinates.y + "px"', left: '$popoverCoordinates.x + "px"' }, else: { position: { if: "$inline === undefined || $inline === false", then: "absolute" } } } } })), rSe = Si("panelClose", () => ({ $el: "button", attrs: { type: "button", class: "$classes.panelClose", onClick: "$handlers.closePanel", tabindex: { if: "$showPanelClose", then: -1, else: 0 }, onKeydown: "$handlers.panelCloseKeydown", "aria-label": "$ui.close.value" } })), sSe = Si("controlGroup", () => ({ $el: "div", attrs: { class: "$classes.controlGroup", "data-eye-dropper": "$hasNativeEyeDropper && $eyeDropper", role: "group" } })), oSe = Si("LS", () => ({ $el: "div", attrs: { class: "$classes.LS" } })), aSe = Si("canvasLS", () => ({ $el: "canvas", attrs: { id: '$: "canvas-ls-" + $id', class: '$classes.canvas + " " + $classes.canvasLS', width: 256, height: 256, "aria-hidden": "true" } })), lSe = Si("controlLS", () => ({ $el: "div", attrs: { tabindex: { if: "$disabled", then: -1, else: 0 }, class: '$classes.control + " " + $classes.controlLS', onKeydown: "$handlers.lsKeydown", style: { left: '$controlLSPosition.x + "%"', top: '$controlLSPosition.y + "%"', backgroundColor: '$: "hsl(" + $hsla.h + "deg, " + ($hsla.s / 255) * 100 + "%, " + ($hsla.l / 255) * 100 + "%)"' }, role: "slider", "aria-valuemin": 0, "aria-valuemax": 1, "aria-valuetext": '$: "Lightness: " + $hslaPercent.l + "%, Saturation: " + $hslaPercent.s + "%"' } })), cSe = Si("hue", () => ({ $el: "div", attrs: { class: "$classes.hue" } })), uSe = Si("canvasHue", () => ({ $el: "canvas", attrs: { id: '$: "canvas-hue-" + $id', class: '$classes.canvas + " " + $classes.canvasHue', width: 256, height: 10, "aria-hidden": "true" } })), dSe = Si("controlHue", () => ({ $el: "div", attrs: { tabindex: { if: "$disabled", then: -1, else: 0 }, onKeydown: "$handlers.hueControlKeydown", class: '$classes.control + " " + $classes.controlHue', style: { left: '$: "min(max(" + (($hsla.h / 360) * 100) + "%, 3px), calc(100% - 3px))"', backgroundColor: '$: "hsl(" + $hsla.h + "deg, 100%, 50%)"' }, role: "slider", "aria-valuemin": 0, "aria-valuemax": 360, "aria-valuenow": "$h" } })), pSe = Si("alpha", () => ({ $el: "div", attrs: { class: "$classes.alpha", style: { opacity: { if: "$alpha", then: "1", else: "0.5" }, cursor: { if: "$alpha", then: "", else: "not-allowed" }, filter: { if: "$alpha", then: "", else: "grayscale(1)" } } } })), hSe = Si("canvasAlpha", () => ({ $el: "canvas", attrs: { id: '$: "canvas-alpha-" + $id', class: '$classes.canvas + " " + $classes.canvasAlpha', width: 256, height: 10, "aria-hidden": "true", style: { pointerEvents: { if: "$alpha", then: "auto", else: "none" } } } })), fSe = Si("controlAlpha", () => ({ $el: "div", attrs: { tabindex: { if: "$disabled || $alpha === undefined", then: -1, else: 0 }, onKeydown: "$handlers.alphaControlKeydown", class: '$classes.control + " " + $classes.controlAlpha', style: { left: '$: "min(max(" + ($hsla.a * 100) + "%, 3px), calc(100% - 3px))"', backgroundImage: '$: "linear-gradient(to right, hsla(" + $hsla.h + "deg, " + ($hsla.s / 255) * 100 + "%, " + ($hsla.l / 255) * 100 + "%, " + $hsla.a + "), hsla(" + $hsla.h + "deg, " + ($hsla.s / 255) * 100 + "%, " + ($hsla.l / 255) * 100 + "%, " + $hsla.a + ")), linear-gradient(to right, white, white)"', pointerEvents: { if: "$alpha", then: "auto", else: "none" } }, role: "slider", "aria-valuemin": 0, "aria-valuemax": 1, "aria-valuenow": "$hsla.a" } })), mSe = Si("preview", () => ({ $el: "div", attrs: { class: "$classes.preview" } })), vSe = Si("canvasPreview", () => ({ $el: "canvas", attrs: { id: '$: "canvas-preview-" + $id', class: '$classes.canvas + " " + $classes.canvasPreview', width: 33, height: 33, "aria-hidden": "true" } })), gSe = Si("canvasSwatchPreview", () => ({ $el: "div", attrs: { class: "$classes.canvasSwatchPreviewWrapper" }, children: [{ $el: "canvas", attrs: { id: '$: "canvas-swatch-preview-" + $id', class: '$classes.canvas + " " + $classes.canvasSwatchPreview', width: 33, height: 33, "aria-hidden": "true" } }] })), ySe = Si("eyeDropper", () => ({ $el: "div", attrs: { tabindex: { if: "$disabled", then: -1, else: 0 }, role: "button", onKeydown: "$handlers.eyeDropperKeydown", id: '$: "eye-dropper-" + $id', class: "$classes.eyeDropper" } })), _Se = Si("formatField", () => ({ $el: "div", attrs: { class: "$classes.formatField" } })), bSe = Si("colorInputGroup", () => ({ $el: "div", attrs: { class: "$classes.colorInputGroup", "aria-role": "group" } })), wSe = Si("hexField", () => ({ $el: "div", attrs: { class: '$classes.fieldGroup + " " + $classes.hexFieldGroup' }, children: [{ $el: "input", attrs: { onInput: "$handlers.hexInput", onKeydown: "$handlers.hexKeydown", onFocus: "$handlers.hexFocus", onBlur: "$handlers.hexBlur", id: '$: "hex-" + $id', tabindex: { if: "$disabled", then: -1, else: 0 }, disabled: "$disabled", class: '$classes.colorField + " " + $classes.hexField', value: "$hex", autocomplete: "off" } }, { $el: "label", children: "HEX", attrs: { for: '$: "hex-" + $id', class: "$classes.fieldLabel" } }] })), xSe = Si("rField", () => ({ $el: "div", attrs: { class: '$classes.fieldGroup + " " + $classes.rFieldGroup' }, children: [{ $el: "input", attrs: { id: '$: "r-" + $id', onInput: '$handlers.rangeLimitInput("rgba", 0, 255)', onKeydown: '$handlers.rangeLimitKeydown("rgba", 0, 255, 1)', type: "number", class: '$classes.colorField + " " + $classes.rField', min: 0, max: 255, step: 1, tabindex: { if: "$disabled", then: -1, else: 0 }, disabled: "$disabled", value: "$rgba.r", autocomplete: "off" } }, { $el: "label", children: "R", attrs: { for: '$: "r-" + $id', class: "$classes.fieldLabel" } }] })), $Se = Si("gField", () => ({ $el: "div", attrs: { class: '$classes.fieldGroup + " " + $classes.gFieldGroup' }, children: [{ $el: "input", attrs: { id: '$: "g-" + $id', onInput: '$handlers.rangeLimitInput("rgba", 0, 255)', onKeydown: '$handlers.rangeLimitKeydown("rgba", 0, 255, 1)', type: "number", class: '$classes.colorField + " " + $classes.gField', min: 0, max: 255, step: 1, tabindex: { if: "$disabled", then: -1, else: 0 }, disabled: "$disabled", value: "$rgba.g", autocomplete: "off" } }, { $el: "label", children: "G", attrs: { for: '$: "g-" + $id', class: "$classes.fieldLabel" } }] })), CSe = Si("bField", () => ({ $el: "div", attrs: { class: '$classes.fieldGroup + " " + $classes.bFieldGroup' }, children: [{ $el: "input", attrs: { id: '$: "b-" + $id', onInput: '$handlers.rangeLimitInput("rgba", 0, 255)', onKeydown: '$handlers.rangeLimitKeydown("rgba", 0, 255, 1)', type: "number", class: '$classes.colorField + " " + $classes.bField', min: 0, max: 255, step: 1, tabindex: { if: "$disabled", then: -1, else: 0 }, disabled: "$disabled", value: "$rgba.b", autocomplete: "off" } }, { $el: "label", children: "B", attrs: { for: '$: "b-" + $id', class: "$classes.fieldLabel" } }] })), kSe = Si("aField", () => ({ $el: "div", attrs: { class: '$classes.fieldGroup + " " + $classes.aFieldGroup' }, children: [{ $el: "input", attrs: { id: '$: "a-" + $id', onInput: '$handlers.rangeLimitInput("alpha", 0, 1)', onKeydown: '$handlers.rangeLimitKeydown("alpha", 0, 1, 0.01)', type: "text", class: '$classes.colorField + " " + $classes.aField', value: "$rgba.a", tabindex: { if: "$disabled", then: -1, else: 0 }, disabled: "$disabled || $alpha === undefined", autocomplete: "off", style: { opacity: { if: "$alpha", then: "1", else: "0.33" }, cursor: { if: "$alpha", then: void 0, else: "not-allowed" } }, "aria-valuemin": 0, "aria-valuemax": 1, "aria-valuenow": "$rgba.a" } }, { $el: "label", children: "A", attrs: { for: '$: "a-" + $id', class: "$classes.fieldLabel", style: { opacity: { if: "$alpha", then: "1", else: "0.33" } } } }] })), SSe = Si("hField", () => ({ $el: "div", attrs: { class: '$classes.fieldGroup + " " + $classes.hFieldGroup' }, children: [{ $el: "input", attrs: { id: '$: "h-" + $id', onInput: '$handlers.rangeLimitInput("hsla", 0, 360)', onKeydown: '$handlers.rangeLimitKeydown("hsla", 0, 360, 1)', type: "text", class: '$classes.colorField + " " + $classes.hField', tabindex: { if: "$disabled", then: -1, else: 0 }, disabled: "$disabled", value: "$hslaPercent.h", autocomplete: "off", "aria-valuemin": 0, "aria-valuemax": 360, "aria-valuenow": "$hsla.h" } }, { $el: "label", children: "H", attrs: { for: '$: "h-" + $id', class: "$classes.fieldLabel" } }] })), TSe = Si("sField", () => ({ $el: "div", attrs: { class: '$classes.fieldGroup + " " + $classes.sFieldGroup' }, children: [{ $el: "input", attrs: { id: '$: "s-" + $id', onInput: '$handlers.rangeLimitInput("hsla", 0, 100)', onKeydown: '$handlers.rangeLimitKeydown("hsla", 0, 100, 1)', type: "text", class: '$classes.colorField + " " + $classes.sField', tabindex: { if: "$disabled", then: -1, else: 0 }, value: "$hslaPercent.s", autocomplete: "off", "aria-valuemin": 0, "aria-valuemax": 100, "aria-valuenow": "$hsla.s" } }, { $el: "label", children: "S", attrs: { for: '$: "s-" + $id', class: "$classes.fieldLabel" } }] })), ISe = Si("lField", () => ({ $el: "div", attrs: { class: '$classes.fieldGroup + " " + $classes.lFieldGroup' }, children: [{ $el: "input", attrs: { id: '$: "l-" + $id', onInput: '$handlers.rangeLimitInput("hsla", 0, 100)', onKeydown: '$handlers.rangeLimitKeydown("hsla", 0, 100, 1)', type: "text", class: '$classes.colorField + " " + $classes.lField', tabindex: { if: "$disabled", then: -1, else: 0 }, disabled: "$disabled", value: "$hslaPercent.l", autocomplete: "off", "aria-valuemin": 0, "aria-valuemax": 100, "aria-valuenow": "$hsla.l" } }, { $el: "label", children: "L", attrs: { for: '$: "l-" + $id', class: "$classes.fieldLabel" } }] })), ASe = Si("formatSwitcher", () => ({ $el: "div", attrs: { class: "$classes.formatSwitcher", onClick: "$handlers.toggleFormat", tabindex: { if: "$disabled", then: -1, else: 0 }, onKeydown: "$handlers.formatSwitcherKeydown", role: "button", "aria-label": "$ui.next.value" } })), ESe = Si("swatches", () => ({ $el: "div", attrs: { id: '$: "swatches-" + $id', class: "$classes.swatches", "data-keyboard-nav": "$swatchIsUsingKeyboardNav" } })), PSe = Si("swatch", () => ({ $el: "div", for: ["swatch", "index", "$options"], if: "$swatch", attrs: { if: "$swatch.group", then: { class: "$classes.swatchGroup" }, else: { class: "$classes.swatch", title: "$swatch.label" } }, children: { if: "$swatch.group", then: [{ $el: "span", attrs: { class: "$classes.swatchGroupLabel" }, children: "$swatch.group" }, { $el: "div", for: ["groupSwatch", "swatchIndex", "$swatch.options"], attrs: { class: "$classes.swatch", title: "$groupSwatch.label" }, children: [{ $el: "canvas", attrs: { class: "$classes.swatchCanvas", width: 21, height: 21, onClick: "$handlers.swatchClick", onKeydown: "$handlers.swatchKeydown", tabindex: { if: "$: ($focusedSwatch === $fns.anyToHsvaString($groupSwatch.value, 0))", then: { if: "$disabled", then: -1, else: 0 }, else: -1 }, key: '$groupSwatch.label + "-" + $groupSwatch.value', "data-color": "$fns.anyToHsvaString($groupSwatch.value, 0)", "data-color-precise": "$fns.anyToHsvaString($groupSwatch.value, 2)", "data-group": "$index", "data-label": "$swatch.label", role: "button", "aria-label": "$swatch.label" } }] }], else: { $el: "canvas", attrs: { class: "$classes.swatchCanvas", width: 21, height: 21, onClick: "$handlers.swatchClick", onKeydown: "$handlers.swatchKeydown", tabindex: { if: "$: ($focusedSwatch === $fns.anyToHsvaString($swatch.value, 0))", then: { if: "$disabled", then: -1, else: 0 }, else: -1 }, key: '$swatch.label + "-" + $swatch.value', "data-color": "$fns.anyToHsvaString($swatch.value, 0)", "data-color-precise": "$fns.anyToHsvaString($swatch.value, 2)", "data-group": 0, "data-label": "$swatch.label", role: "button", "aria-label": "$swatch.label" } } } })), N3 = /rgba?\((\d+%?)\s*(?:,?\s*|\s+)(\d+%?)\s*(?:,?\s*|\s+)(\d+%?)(?:\s*(?:,?\s*|\s+|\/\s*)(\d*(?:\.\d+)?%?))?\)/i, F3 = /^hsla?\((\d{1,3}deg|[\d.]+)\s*,?\s*([\d.]+%)\s*,?\s*([\d.]+%)(?:\s*,?\s*([\d.]+%?))?\)$/i;
function si(e, t) {
  const n = Math.pow(10, t);
  return Math.round(e * n) / n;
}
function h1(e) {
  const [t, n, i, r] = function(c) {
    c = c.replace("#", ""), c.length === 3 && (c = c[0] + c[0] + c[1] + c[1] + c[2] + c[2]);
    const d = parseInt(c.slice(0, 2), 16), a = parseInt(c.slice(2, 4), 16), f = parseInt(c.slice(4, 6), 16), g = c.length >= 8 ? parseInt(c.slice(6, 8), 16) / 255 : 1;
    return function(x, $, A, I = 1) {
      const O = x / 255, B = $ / 255, H = A / 255, N = Math.max(O, B, H), K = Math.min(O, B, H);
      let U, q = 0;
      const ee = (N + K) / 2;
      if (N === K) q = U = 0;
      else {
        const te = N - K;
        switch (U = ee > 0.5 ? te / (2 - N - K) : te / (N + K), N) {
          case O:
            q = (B - H) / te + (B < H ? 6 : 0);
            break;
          case B:
            q = (H - O) / te + 2;
            break;
          case H:
            q = (O - B) / te + 4;
        }
        q *= 60;
      }
      return [q, 255 * U, 255 * ee, I];
    }(d, a, f, g);
  }(e);
  return [...p$(t, n, i, r)];
}
function fI(e, t, n, i = 1) {
  const r = t / 100, c = n / 100, d = (2 - r) * c / 2;
  return d !== 0 && (d === 1 || (t = d < 0.5 ? r * c / (2 * d) : r * c / (2 - 2 * d))), [e, si(255 * t, 2), si(255 * d, 2), i];
}
function p$(e, t, n, i = 1) {
  const r = si(t / 255, 4), c = si(n / 255, 4);
  if (c === 1) return [e, 0, 100, i];
  const d = si(c + r * Math.min(c, 1 - c), 4);
  let a = t / 2.55;
  return d !== 0 && (a = c !== 1 && c !== 0 ? 2 * (d - c) / d * 100 : t / 2.55), [e, si(a, 2), si(100 * d, 2), i];
}
function R3(e, t, n, i = 1) {
  const r = n / 100, c = r * (t / 100), d = c * (1 - Math.abs(e / 60 % 2 - 1)), a = r - c;
  let f = 0, g = 0, x = 0;
  return [f, g, x] = e < 60 ? [c, d, 0] : e < 120 ? [d, c, 0] : e < 180 ? [0, c, d] : e < 240 ? [0, d, c] : e < 300 ? [d, 0, c] : [c, 0, d], f = Math.round(255 * (f + a)), g = Math.round(255 * (g + a)), x = Math.round(255 * (x + a)), [Math.min(Math.max(f, 0), 255), Math.min(Math.max(g, 0), 255), Math.min(Math.max(x, 0), 255), i];
}
function z3(e, t, n, i = 1) {
  const r = e / 255, c = t / 255, d = n / 255, a = Math.max(r, c, d), f = Math.min(r, c, d);
  let g = 0;
  const x = a, $ = a - f, A = a === 0 ? 0 : $ / a;
  if (a !== f) {
    switch (a) {
      case r:
        g = (c - d) / $ + (c < d ? 6 : 0);
        break;
      case c:
        g = (d - r) / $ + 2;
        break;
      case d:
        g = (r - c) / $ + 4;
    }
    g /= 6;
  }
  return [360 * g, 100 * A, 100 * x, i];
}
function MSe(e, t, n, i = 1) {
  const [r, c, d, a] = R3(e, t, n, i);
  return function(f, g, x, $ = 1) {
    const A = (O) => Math.round(O).toString(16).padStart(2, "0").toUpperCase(), I = function(O) {
      return Math.round(255 * O).toString(16).padStart(2, "0").toUpperCase();
    }($);
    return "#" + A(f) + A(g) + A(x) + `${I === "FF" ? "" : I}`;
  }(r, c, d, a);
}
function jp(e) {
  return /^(#?)([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(e);
}
function K0(e) {
  if (e) {
    if (jp(e)) return h1(e);
    if (e.startsWith("rgb")) {
      const t = e.match(N3);
      if (!t) return [0, 0, 0, 1];
      const n = (i) => i.endsWith("%") ? Math.round(2.55 * Number(i.slice(0, -1))) : Number(i);
      return z3(n(t[1]), n(t[2]), n(t[3]), t[4] ? t[4].endsWith("%") ? Number(t[4].slice(0, -1)) / 100 : Number(t[4]) : 1);
    }
    if (e.startsWith("hsl")) {
      const t = e.match(F3);
      if (!t) return [0, 0, 0, 1];
      const n = Number(t[1].replace("deg", "").trim()), i = Number(t[2].slice(0, -1)) / 100, r = Number(t[3].slice(0, -1)) / 100, c = t[4] ? t[4].endsWith("%") ? Number(t[4].slice(0, -1)) / 100 : Number(t[4]) : 1;
      return p$(n, si(255 * i, 2), si(255 * r, 2), c);
    }
  }
}
function mI(e) {
  const [t, n, i, r] = e.split("-").map((c) => Number(c));
  return [t, n, i, r];
}
function Fp(e, t = 150, n = !0) {
  let i = null, r = !0;
  return (...c) => {
    const d = () => {
      e(...c), i = null;
    };
    n && r && (r = !1, d()), i || (i = setTimeout(d, t));
  };
}
function qf(e) {
  return e !== !1 && e !== "false";
}
function DSe(e) {
  return e.tabIndex >= 0 && !e.disabled && e.offsetParent !== null;
}
const vI = { "canvas-ls": "LS", "canvas-hue": "Hue", "canvas-alpha": "Alpha" }, LSe = { schema: /* @__PURE__ */ jke(/* @__PURE__ */ Gke(/* @__PURE__ */ Kke("$label"), /* @__PURE__ */ sn("$inline && $help", /* @__PURE__ */ hI("$help")), /* @__PURE__ */ Yke(/* @__PURE__ */ sn("($inline === undefined || $inline === false) && $prefixIcon !== undefined", /* @__PURE__ */ Zf("prefix", "label")), /* @__PURE__ */ sn("$inline === undefined || $inline === false", /* @__PURE__ */ Xke()), /* @__PURE__ */ sn("$inline === undefined || $inline === false", /* @__PURE__ */ tSe(/* @__PURE__ */ gSe(), /* @__PURE__ */ sn("$showValue", /* @__PURE__ */ nSe()))), /* @__PURE__ */ sn("$inline || $expanded)", /* @__PURE__ */ iSe(/* @__PURE__ */ sn("$showPanelClose && ($inline === undefined || $inline === false)", /* @__PURE__ */ rSe(/* @__PURE__ */ Zf("close"))), /* @__PURE__ */ sn("$panelControls", /* @__PURE__ */ sSe(/* @__PURE__ */ oSe(/* @__PURE__ */ aSe(), /* @__PURE__ */ lSe()), /* @__PURE__ */ mSe(/* @__PURE__ */ vSe()), /* @__PURE__ */ cSe(/* @__PURE__ */ uSe(), /* @__PURE__ */ dSe()), /* @__PURE__ */ pSe(/* @__PURE__ */ hSe(), /* @__PURE__ */ fSe()), /* @__PURE__ */ sn("$eyeDropper && $hasNativeEyeDropper", /* @__PURE__ */ ySe(/* @__PURE__ */ Zf("eyeDropper"))))), /* @__PURE__ */ sn("$panelFormat", /* @__PURE__ */ _Se(/* @__PURE__ */ bSe(/* @__PURE__ */ sn('$panelActiveFormat === "hex"', /* @__PURE__ */ wSe()), /* @__PURE__ */ sn('$panelActiveFormat === "rgba"', /* @__PURE__ */ xSe()), /* @__PURE__ */ sn('$panelActiveFormat === "rgba"', /* @__PURE__ */ $Se()), /* @__PURE__ */ sn('$panelActiveFormat === "rgba"', /* @__PURE__ */ CSe()), /* @__PURE__ */ sn('$panelActiveFormat === "hsla"', /* @__PURE__ */ SSe()), /* @__PURE__ */ sn('$panelActiveFormat === "hsla"', /* @__PURE__ */ TSe()), /* @__PURE__ */ sn('$panelActiveFormat === "hsla"', /* @__PURE__ */ ISe()), /* @__PURE__ */ sn('$panelActiveFormat === "rgba" || $panelActiveFormat === "hsla"', /* @__PURE__ */ kSe())), /* @__PURE__ */ ASe(/* @__PURE__ */ Zf("switch")))), /* @__PURE__ */ sn("$options", /* @__PURE__ */ ESe(/* @__PURE__ */ PSe())))), /* @__PURE__ */ sn("$inline === undefined || $inline === false", /* @__PURE__ */ Jke()), /* @__PURE__ */ sn("($inline === undefined || $inline === false) && $suffixIcon !== undefined", /* @__PURE__ */ Zf("suffix"))), /* @__PURE__ */ sn("$: ($inline === undefined || $inline === false) && $help", /* @__PURE__ */ hI("$help"))), /* @__PURE__ */ Qke(/* @__PURE__ */ eSe("$message.value"))), type: "input", family: "text", props: ["disbaled", "format", "valueFormat", "alpha", "panelControls", "panelFormat", "eyeDropper", "inline", "options", "showValue", "closeOnSelect", "allowPaste"], features: [
  function(e) {
    let t, n = null, i = null, r = null, c = null, d = null, a = null, f = null, g = 0;
    const x = ["hex", "rgba", "hsla"], $ = Fp(function() {
      if (!i) return;
      const qe = i.getContext("2d");
      if (!qe) return;
      const { width: rt, height: Le } = i, Je = e.props.h || 0;
      qe.fillStyle = `hsl(${Je}, 100%, 50%)`, qe.fillRect(0, 0, rt, Le);
      const je = qe.createLinearGradient(0, 0, rt, 0);
      je.addColorStop(0, "rgba(255, 255, 255, 1)"), je.addColorStop(1, "rgba(255, 255, 255, 0)"), qe.fillStyle = je, qe.fillRect(0, 0, rt, Le);
      const ot = qe.createLinearGradient(0, 0, 0, Le);
      ot.addColorStop(0, "rgba(0,0,0,0)"), ot.addColorStop(1, "rgba(0,0,0,1)"), qe.fillStyle = ot, qe.fillRect(0, 0, rt, Le);
    }, 2), A = Fp(function() {
      if (!c) return;
      const qe = c.getContext("2d");
      if (!qe) return;
      const rt = Math.round(c.width), Le = Math.round(c.height);
      qe.clearRect(0, 0, rt, Le), et(c, Le / 2);
      const Je = e.props.rgba.r || 0, je = e.props.rgba.g || 0, ot = e.props.rgba.b || 0, Xe = qe.createLinearGradient(0, 0, rt, 0);
      Xe.addColorStop(0, `rgba(${Je}, ${je}, ${ot}, 0)`), Xe.addColorStop(1, `rgba(${Je}, ${je}, ${ot}, 1)`), qe.fillStyle = Xe, qe.fillRect(0, 0, rt, Le);
    }, 2), I = Fp(ve, 2), O = Fp(re, 2), B = Fp(Ke, 2), H = Fp(ft, 10, !1);
    function N(qe) {
      var rt, Le;
      if (!e.context || !e.props.allowPaste || e.props.disabled) return;
      const Je = (rt = e.props.__root) === null || rt === void 0 ? void 0 : rt.activeElement;
      if (n && n.contains(Je)) {
        const je = (Le = qe.clipboardData) === null || Le === void 0 ? void 0 : Le.getData("text");
        if (!je || Je.tagName === "INPUT" && !jp(je) && !N3.test(je) && !F3.test(je)) return;
        (jp(je) || je.startsWith("hsl") || je.startsWith("rgb")) && (e.props.hexInputFocused && (e.props.hexInputFocused = !1, setTimeout(() => {
          e.props.hexInputFocused = !0;
        }, 10)), qe.preventDefault(), K(je));
      }
    }
    function K(qe) {
      var rt;
      if (!qe) return;
      const Le = K0(qe);
      if (Le) {
        const [Je, je, ot, Xe] = Le;
        qe !== "undefined" && (typeof Je != "number" || isNaN(Je) || typeof je != "number" || isNaN(je) || typeof ot != "number" || isNaN(ot) || typeof Xe != "number" || isNaN(Xe) || si(Je, 2) === e.props.h && si(je, 2) === e.props.s && si(ot, 2) === e.props.v && si(Xe, 2) === e.props.a) || (e.props.alpha && (e.props.a = si(Xe, 2)), Ke(Je, je, ot));
      } else {
        const Je = (rt = e.props.options) === null || rt === void 0 ? void 0 : rt.find((je) => {
          var ot;
          return ((ot = je.label) === null || ot === void 0 ? void 0 : ot.toLowerCase()) === qe.toLowerCase();
        });
        if (Je && Je.value) {
          const je = K0(Je.value);
          if (je) {
            const [ot, Xe, tt, dt] = je;
            e.props.alpha && (e.props.a = si(dt, 2)), Ke(ot, Xe, tt);
          } else Ke(e.props.h, e.props.s, e.props.v);
        } else Ke(e.props.h, e.props.s, e.props.v);
      }
    }
    function U(qe) {
      if (!e.context || !f) return;
      const rt = f[qe];
      rt && (e.props.focusedSwatch = rt.dataset.color);
    }
    function q(qe, rt) {
      new ResizeObserver(() => {
        const Le = qe.getBoundingClientRect();
        qe.width = Math.round(Le.width), qe.height = Math.round(Le.height), rt(qe);
      }).observe(qe);
    }
    function ee() {
      e.context && e.props.eyeDropper && (e.context.hasNativeEyeDropper = !(typeof window > "u" || !window.EyeDropper), Pr(`eye-dropper-${e.props.id}`, () => {
        var qe;
        const rt = new window.EyeDropper(), Le = (qe = e.props.__root) === null || qe === void 0 ? void 0 : qe.getElementById(`eye-dropper-${e.props.id}`);
        Le == null || Le.addEventListener("click", async () => {
          const Je = await rt.open();
          if (!Je.sRGBHex) return;
          const [je, ot, Xe] = h1(Je.sRGBHex);
          e.props.alpha && (e.props.a = 1), Ke(je, ot, Xe);
        });
      }, e.props.__root));
    }
    function te() {
      ae("canvas-ls", (qe) => {
        i = qe;
      }, $, Ne), ae("canvas-hue", (qe) => {
        r = qe;
      }, me, We), ae("canvas-alpha", (qe) => {
        c = qe;
      }, A, Ge), oe(`canvas-preview-${e.props.id}`, (qe) => {
        d = qe, ve();
      }, I), oe(`canvas-swatch-preview-${e.props.id}`, (qe) => {
        a = qe, re();
      }, O), de();
    }
    function ae(qe, rt, Le, Je) {
      let je = !1;
      const ot = () => {
        document.removeEventListener("mousemove", Xe), document.removeEventListener("mouseup", dt), document.removeEventListener("touchmove", tt), document.removeEventListener("touchend", bt);
      }, Xe = (qt) => {
        qt.buttons === 1 && t && Je(qt);
      }, tt = (qt) => {
        t && Je(qt);
      }, dt = () => {
        t = void 0, ot();
      }, bt = () => {
        t = void 0, ot();
      };
      oe(`${qe}-${e.props.id}`, (qt) => {
        const Oe = qt.nextElementSibling;
        rt(qt), Le(), function(Bt, Tn) {
          const hn = (Ht) => {
            Bt && (Ht.preventDefault(), Tn(Ht));
          };
          Bt == null || Bt.addEventListener("mousedown", hn), Bt == null || Bt.addEventListener("touchstart", hn);
        }(qt, Je), je || function(Bt, Tn) {
          je = !0, Bt.addEventListener("blur", () => {
            Bt.removeAttribute("data-prevent-focus-style");
          }), Tn.addEventListener("touchend", () => {
            Bt.removeAttribute("data-prevent-focus-style"), Bt.blur();
          }), Bt.addEventListener("keydown", (hn) => {
            ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(hn.key) && Bt.removeAttribute("data-prevent-focus-style");
          });
        }(Oe, qt), qt.addEventListener("mousedown", (Bt) => {
          Oe.focus(), Oe.setAttribute("data-prevent-focus-style", "true"), t = vI[qe], Je(Bt), document.addEventListener("mousemove", Xe), document.addEventListener("mouseup", dt);
        }), qt.addEventListener("touchstart", () => {
          Oe.setAttribute("data-prevent-focus-style", "true"), Oe.focus(), t = vI[qe], document.addEventListener("touchmove", tt), document.addEventListener("touchend", bt);
        });
      }, Le);
    }
    function oe(qe, rt, Le) {
      Pr(qe, () => {
        var Je;
        const je = (Je = e.props.__root) === null || Je === void 0 ? void 0 : Je.getElementById(qe);
        je && (rt(je), Le && q(je, Le));
      }, e.props.__root);
    }
    function de() {
      Pr(`swatches-${e.props.id}`, () => {
        var qe, rt, Le;
        f = Array.from(((qe = e.props.__root) === null || qe === void 0 ? void 0 : qe.querySelectorAll(`#swatches-${e.props.id} canvas`)) || []), f.forEach((Je) => {
          q(Je, le);
        }), e.props.focusedSwatch = (Le = (rt = f[0]) === null || rt === void 0 ? void 0 : rt.dataset) === null || Le === void 0 ? void 0 : Le.color, ft();
      }, e.props.__root);
    }
    function me() {
      if (!r) return;
      const qe = r.getContext("2d");
      if (!qe) return;
      const rt = r.width, Le = r.height;
      for (let Je = 0; Je < rt; Je++) {
        const je = Math.floor(Je / rt * 360);
        qe.fillStyle = `hsl(${je}, 100%, 50%)`, qe.fillRect(Je, 0, 1, Le);
      }
    }
    function ve() {
      if (!d) return;
      const qe = d.getContext("2d");
      if (!qe) return;
      et(d, d.width / 3);
      const { r: rt, g: Le, b: Je, a: je } = e.props.rgba;
      qe.fillStyle = `rgba(${rt}, ${Le}, ${Je}, ${je})`, qe.fillRect(0, 0, d.width, d.height);
    }
    function re() {
      if (!a) return;
      const qe = a.getContext("2d");
      if (!qe) return;
      et(a, a.height / 2);
      const { r: rt, g: Le, b: Je, a: je } = e.props.rgba;
      qe.fillStyle = `rgba(${rt}, ${Le}, ${Je}, ${je})`, qe.fillRect(0, 0, a.width, a.height);
    }
    function le(qe) {
      if (!qe) return;
      const rt = qe.getContext("2d");
      if (!rt) return;
      et(qe, qe.width / 2);
      const Le = qe.dataset.colorPrecise;
      if (!Le) return;
      const [Je, je, ot, Xe] = mI(Le), [tt, dt, bt, qt] = fI(Je, je, ot, Xe);
      rt.fillStyle = `hsla(${tt}, ${dt / 255 * 100}%, ${bt / 255 * 100}%, ${qt})`, rt.fillRect(0, 0, Math.round(qe.width), Math.round(qe.height));
    }
    function pe(qe, rt, Le) {
      let Je = null;
      const je = (bt) => {
        Je !== null && cancelAnimationFrame(Je), Je = requestAnimationFrame(() => {
          if (!rt) return;
          const qt = rt.getBoundingClientRect();
          let Oe, Bt;
          "touches" in bt ? (Oe = bt.touches[0].clientX - qt.left, Bt = bt.touches[0].clientY - qt.top) : (Oe = bt.clientX - qt.left, Bt = bt.clientY - qt.top), Oe = Math.min(Math.max(Oe, 0), qt.width), Bt = Math.min(Math.max(Bt, 0), qt.height), Le(Oe, Bt);
        });
      };
      je(qe);
      const ot = (bt) => {
        bt.preventDefault(), je(bt);
      }, Xe = (bt) => {
        bt.preventDefault(), je(bt);
      }, tt = () => {
        t = void 0, document.removeEventListener("mousemove", ot), document.removeEventListener("mouseup", tt);
      }, dt = () => {
        t = void 0, document.removeEventListener("touchmove", Xe), document.removeEventListener("touchend", dt);
      };
      "touches" in qe ? (document.addEventListener("touchmove", Xe), document.addEventListener("touchend", dt)) : (document.addEventListener("mousemove", ot), document.addEventListener("mouseup", tt));
    }
    function Ne(qe) {
      pe(qe, i, (rt, Le) => {
        const Je = rt / i.width * 100, je = 100 - Le / i.height * 100;
        B(e.props.hue, Je, je);
      });
    }
    function We(qe) {
      pe(qe, r, (rt, Le) => {
        if (!r) return;
        const Je = r.width, je = Math.floor(rt / Je * 360);
        e.props.h = je, B(e.props.h, e.props.s, e.props.v);
      });
    }
    function Ge(qe) {
      e.props.alpha && pe(qe, c, (rt, Le) => {
        const Je = rt / c.width * 100 / 100;
        e.props.a = Je, B(e.props.hue, e.props.s, e.props.v);
      });
    }
    function et(qe, rt) {
      const Le = qe.getContext("2d");
      if (!Le) return;
      const Je = Math.ceil(qe.height / rt), je = Math.ceil(qe.width / rt);
      for (let ot = 0; ot < Je; ot++) for (let Xe = 0; Xe < je; Xe++) Le.fillStyle = (ot + Xe) % 2 == 1 ? "#FFFFFF" : "#CCCCCC", Le.fillRect(Xe * rt, ot * rt, rt, rt);
    }
    function ft() {
      var qe, rt;
      if (!e.context || !e.props.options || !f) return;
      const { h: Le, s: Je, v: je, a: ot } = e.props, Xe = function(bt, qt, Oe, Bt = 1) {
        const Tn = Oe === 0 ? 0 : qt;
        return `${si(Oe === 0 || Oe === 100 && qt === 0 ? 0 : bt, 0)}-${si(Tn, 0)}-${si(Oe, 0)}-${si(Bt, 2)}`;
      }(Le, Je, je, ot);
      let tt = !1, dt = !1;
      f.forEach((bt) => {
        const qt = bt.dataset.color;
        if (!qt) return;
        const [Oe, Bt, Tn, hn] = qt.split("-");
        Tn === "0" && je === 0 && hn === `${ot}` && (dt = !0);
        const Ht = bt.parentElement;
        dt || qt === Xe ? (Ht.dataset.active = "true", bt.ariaSelected = "true", dt = !1, !tt && f && (U(f.indexOf(bt)), tt = !0)) : (delete Ht.dataset.active, bt.ariaSelected = "false");
      }), tt || (e.props.focusedSwatch = (rt = (qe = f[0]) === null || qe === void 0 ? void 0 : qe.dataset) === null || rt === void 0 ? void 0 : rt.color);
    }
    function De(qe) {
      qe = qe.replace("#", ""), e.props.hexInputFocused || qe.length !== 3 || (qe = qe[0] + qe[0] + qe[1] + qe[1] + qe[2] + qe[2]), qe = `#${qe = qe.toUpperCase()}`, e.props.hex = qe.slice(0, 9);
    }
    function Ke(qe, rt, Le, Je = !1) {
      e.props.h = qe === void 0 || isNaN(qe) ? e.props.h : si(Math.max(Math.min(qe, 360), 0), 2), e.props.s = rt === void 0 || isNaN(rt) ? e.props.s : si(Math.max(Math.min(rt, 100), 0), 2), e.props.v = Le === void 0 || isNaN(Le) ? e.props.v : si(Math.max(Math.min(Le, 100), 0), 2);
      const { h: je, s: ot, v: Xe, a: tt } = e.props, [dt, bt, qt] = fI(je, ot, Xe), [Oe, Bt, Tn] = R3(je, ot, Xe), hn = e.props.hexInputFocused ? e.props.hex : MSe(je, ot, Xe, tt), Ht = si(tt, 2);
      e.props.hsla = { h: je, s: bt, l: qt, a: Ht }, e.props.hslaPercent = { h: si(je, 0), s: Xe === 100 && ot === 0 ? 0 : si(Xe === 0 ? bt / 255 : Math.max(Math.min(bt / 255 * 100, 100), 0), 0), l: si(Math.max(Math.min(e.props.hsla.l / 255 * 100, 100), 0), 0), a: Ht }, e.props.hslaString = `hsla(${e.props.hslaPercent.h}, ${e.props.hslaPercent.s}%, ${e.props.hslaPercent.l}%, ${Ht})`, e.props.hslaStringPrecise = `hsla(${je}, ${si(Xe === 0 ? bt / 255 : bt / 255 * 100, 2)}%, ${si(qt / 255 * 100, 2)}%, ${Ht})`, e.props.rgba = { r: Oe, g: Bt, b: Tn, a: Ht }, e.props.rgbaString = `rgba(${Oe}, ${Bt}, ${Tn}, ${Ht})`, De(hn), setTimeout(() => {
        var vi;
        gt(), function() {
          const It = e.props.s, wn = 100 - e.props.v;
          e.props.controlLSPosition = { x: It, y: wn };
        }(), H(), n || typeof window > "u" || (n = (vi = e.props.__root) === null || vi === void 0 ? void 0 : vi.querySelector(`[data-id="${e.props.id}"]`));
      }, 0);
      const qn = e.props.valueFormat ? e.props.valueFormat : e.props.format;
      Je || (qn === "hex" ? e.input(e.props.hex) : qn === "rgba" ? e.input(e.props.rgbaString) : qn === "hsla" && e.input(e.props.hslaStringPrecise));
    }
    function gt() {
      $(), A(), I(), O();
    }
    e.addProps(["expanded", "h", "s", "v", "a", "hsla", "hslaPercent", "hslaString", "hslaStringPrecise", "rgba", "rgbaString", "hex", "controlLSPosition", "panelActiveFormat", "hexInputFocused", "hasNativeEyeDropper", "focusedSwatch", "swatchIsUsingKeyboardNav", "showPanelClose"]), e.props.h = e.props.h || void 0, e.props.s = e.props.s || void 0, e.props.v = e.props.v || void 0, e.props.a = e.props.a || 1, e.props.controlLSPosition = e.props.controlLSPosition || { x: 0, y: 0 }, e.props.switchIcon = e.props.switchIcon || '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M34.2 179.7L154.4 66.2c1.4-1.3 3.5-2.2 5.6-2.2s4.2 .8 5.6 2.2L285.8 179.7c1.4 1.3 2.2 3.2 2.2 5.2c0 3.9-3.2 7.1-7.1 7.1H39.1c-3.9 0-7.1-3.2-7.1-7.1c0-2 .8-3.8 2.2-5.2zm-22-23.3C4.4 163.8 0 174.1 0 184.9C0 206.5 17.5 224 39.1 224H280.9c21.6 0 39.1-17.5 39.1-39.1c0-10.8-4.4-21.1-12.3-28.4L187.6 42.9C180.1 35.9 170.2 32 160 32s-20.1 3.9-27.6 10.9L12.3 156.4zm22 175.9c-1.4-1.3-2.2-3.2-2.2-5.2c0-3.9 3.2-7.1 7.1-7.1H280.9c3.9 0 7.1 3.2 7.1 7.1c0 2-.8 3.8-2.2 5.2L165.6 445.8c-1.4 1.3-3.5 2.2-5.6 2.2s-4.2-.8-5.6-2.2L34.2 332.3zm-22 23.3L132.4 469.1c7.4 7 17.4 10.9 27.6 10.9s20.1-3.9 27.6-10.9L307.7 355.6c7.8-7.4 12.3-17.7 12.3-28.5c0-21.6-17.5-39.1-39.1-39.1H39.1C17.5 288 0 305.5 0 327.1c0 10.8 4.4 21.1 12.3 28.5z"/></svg>', e.props.hexInputFocused = !1, e.props.swatchIsUsingKeyboardNav = !1, e.on("destroying", () => {
      e.context && typeof document < "u" && document.removeEventListener("paste", N);
    }), e.on("created", () => {
      var qe, rt;
      e.context && (typeof window < "u" && document.addEventListener("paste", N), e.props.expanded = !1, e.props.panelActiveFormat = e.props.format || x[0], e.props.panelControls = qf(e.props.panelControls), e.props.eyeDropper = qf(e.props.eyeDropper), e.props.panelFormat = qf(e.props.panelFormat), e.props.showValue = qf(e.props.showValue), e.props.allowPaste = qf(e.props.allowPaste), e.props.inline = on(e.props.inline), e.props.disabled = on(e.props.disabled), e.props.format = e.props.format || "hex", e.props.alpha = on((rt = (qe = e.props) === null || qe === void 0 ? void 0 : qe.alpha) === null || rt === void 0 || rt), e.props.valueFormat = e.props.valueFormat || e.props.format, e.props.closeOnSelect = on(e.props.closeOnSelect), e.props.focusedSwatch = void 0, e.value === void 0 || e.value === "" || e.value === null ? (e.props.rgba = { r: 0, g: 0, b: 0 }, Ke(0, 0, 0, !0)) : K(`${e.value}`), e.on("input", ({ payload: Le }) => {
        n && e.props.__root !== void 0 && !n.contains(e.props.__root.activeElement) && K(Le);
      }), setTimeout(() => {
        ee();
      }, 5), te(), e.on("prop:expanded", () => {
        var Le;
        e.props.expanded ? (ee(), te(), de(), document.addEventListener("keydown", Je), window.innerWidth <= 430 && !window.matchMedia("(hover: hover)").matches ? e.props.showPanelClose = !0 : e.props.showPanelClose = !1, setTimeout(() => {
          var je;
          const ot = (je = e.props.__root) === null || je === void 0 ? void 0 : je.querySelector(`[data-id="${e.props.id}"] *:not(.formkit-swatch-preview)[tabindex="0"]`);
          ot && ot.focus();
        }, 0)) : (document.removeEventListener("keydown", Je), ((Le = e.props.__root) === null || Le === void 0 ? void 0 : Le.querySelector(`[data-id="${e.props.id}"] *[tabindex="0"]`)).focus());
        function Je(je) {
          je.key === "Escape" && (je.preventDefault(), e.props.expanded = !1);
        }
      }), e.context.fns.anyToHsvaString = (Le, Je) => {
        const je = K0(Le);
        if (!je) return "0-0-0-1";
        let [ot, Xe, tt, dt] = je;
        return Je === 0 && (ot = tt === 0 || tt === 100 && Xe === 0 ? 0 : ot), `${si(ot, Je)}-${si(Xe, Je)}-${si(tt, Je)}-${si(dt, 2)}`;
      }, e.context.handlers.inputPreviewClick = (Le) => {
        e.props.expanded = !e.props.expanded;
      }, e.context.handlers.inputPreviewFocusout = (Le) => {
        var Je, je, ot;
        const Xe = (Je = e.props.__root) === null || Je === void 0 ? void 0 : Je.querySelector(`[data-id="${e.props.id}"] .formkit-inner`), tt = Le.relatedTarget;
        if (Xe.contains(tt)) {
          let dt = function(bt) {
            var qt, Oe;
            Xe.contains(bt.target) || (e.props.expanded = !1, (qt = e.props.__root) === null || qt === void 0 || qt.removeEventListener("mousedown", dt), (Oe = e.props.__root) === null || Oe === void 0 || Oe.removeEventListener("touchstart", dt));
          };
          (je = e.props.__root) === null || je === void 0 || je.addEventListener("mousedown", dt), (ot = e.props.__root) === null || ot === void 0 || ot.addEventListener("touchstart", dt);
        } else e.props.expanded = !1;
      }, e.context.handlers.inputPreviewKeydown = (Le) => {
        Le.key === "Escape" && (Le.preventDefault(), e.props.expanded = !1), Le.key !== "Enter" && Le.key !== " " || (Le.preventDefault(), e.props.expanded = !e.props.expanded);
      }, e.context.handlers.closePanel = () => {
        e.props.expanded = !1;
      }, e.context.handlers.panelCloseKeydown = (Le) => {
        Le.key !== "Enter" && Le.key !== " " || (Le.preventDefault(), e.props.expanded = !1);
      }, e.context.handlers.toggleFormat = (Le = 1) => {
        Le = typeof Le == "number" ? Le : 1;
        const Je = (x.indexOf(e.props.panelActiveFormat) + Le + x.length) % x.length;
        e.props.panelActiveFormat = x[Je];
      }, e.context.handlers.panelKeydown = (Le) => {
        var Je, je, ot;
        if (Le.key === "Tab" && e.props.expanded) {
          Le.preventDefault();
          const Xe = Array.from(((Je = e.props.__root) === null || Je === void 0 ? void 0 : Je.querySelectorAll(`[data-id="${e.props.id}"] *:not(.formkit-swatch-preview)[tabindex="0"]`)) || []).filter(DSe), tt = Xe.indexOf(!((je = e.props.__root) === null || je === void 0) && je.activeElement ? (ot = e.props.__root) === null || ot === void 0 ? void 0 : ot.activeElement : e.props.__root);
          let dt;
          dt = Le.shiftKey ? (tt - 1 + Xe.length) % Xe.length : (tt + 1) % Xe.length, Xe[dt].focus();
        }
      }, e.context.handlers.lsKeydown = (Le) => {
        if (["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "PageUp", "PageDown", "Home", "End"].includes(Le.key)) {
          Le.preventDefault();
          const { h: Je, s: je, v: ot } = e.props, Xe = Le.shiftKey ? 10 : 1;
          switch (Le.key) {
            case "ArrowLeft":
              Ke(Je, je - Xe, ot);
              break;
            case "ArrowRight":
              Ke(Je, je + Xe, ot);
              break;
            case "ArrowUp":
              Ke(Je, je, ot + Xe);
              break;
            case "ArrowDown":
              Ke(Je, je, ot - Xe);
              break;
            case "PageUp":
              Ke(Je, je, ot + 10);
              break;
            case "PageDown":
              Ke(Je, je, ot - 10);
              break;
            case "Home":
              Ke(Je, je - 10, ot);
              break;
            case "End":
              Ke(Je, je + 10, ot);
          }
          gt();
        }
      }, e.context.handlers.hueControlKeydown = (Le) => {
        if (["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "PageUp", "PageDown", "Home", "End"].includes(Le.key)) {
          Le.preventDefault();
          const { h: Je, s: je, v: ot } = e.props, Xe = Le.shiftKey ? 10 : 1;
          switch (Le.key) {
            case "ArrowLeft":
            case "ArrowDown":
              Ke(Je - Xe, je, ot);
              break;
            case "ArrowRight":
            case "ArrowUp":
              Ke(Je + Xe, je, ot);
              break;
            case "PageUp":
              Ke(Je + 10, je, ot);
              break;
            case "PageDown":
              Ke(Je - 10, je, ot);
              break;
            case "Home":
              Ke(0, je, ot);
              break;
            case "End":
              Ke(360, je, ot);
          }
          gt();
        }
      }, e.context.handlers.alphaControlKeydown = (Le) => {
        if (e.props.alpha && ["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "PageUp", "PageDown", "Home", "End"].includes(Le.key)) {
          Le.preventDefault();
          const { h: Je, s: je, v: ot, a: Xe } = e.props, tt = Le.shiftKey ? 0.1 : 0.01;
          switch (Le.key) {
            case "ArrowLeft":
            case "ArrowDown":
              e.props.a = si(Math.min(Math.max(Xe - tt, 0), 1), 2);
              break;
            case "ArrowRight":
            case "ArrowUp":
              e.props.a = si(Math.min(Math.max(Xe + tt, 0), 1), 2);
              break;
            case "PageUp":
              e.props.a = si(Math.min(Math.max(Xe + 0.1, 0), 1), 2);
              break;
            case "PageDown":
              e.props.a = si(Math.min(Math.max(Xe - 0.1, 0), 1), 2);
              break;
            case "Home":
              e.props.a = 0;
              break;
            case "End":
              e.props.a = 1;
          }
          Ke(Je, je, ot);
        }
      }, e.context.handlers.eyeDropperKeydown = (Le) => {
        var Je;
        if (Le.key === "Enter" || Le.key === " ") {
          Le.preventDefault();
          const je = (Je = e.props.__root) === null || Je === void 0 ? void 0 : Je.getElementById(`eye-dropper-${e.props.id}`);
          je == null || je.click();
        }
      }, e.context.handlers.formatSwitcherKeydown = (Le) => {
        e.context && (Le.key !== "Enter" && Le.key !== " " && Le.key !== "ArrowDown" || (Le.preventDefault(), e.context.handlers.toggleFormat()), Le.key === "ArrowUp" && (Le.preventDefault(), e.context.handlers.toggleFormat(-1)));
      }, e.context.handlers.hexInput = (Le) => {
        const Je = Le.target, je = Je.value.startsWith("#") ? 9 : 8, ot = Je.value.slice(0, je);
        if (Je.value = e.props.alpha ? ot : ot.slice(0, 7), jp(ot)) {
          const [Xe, tt, dt, bt] = h1(ot);
          e.props.alpha && (e.props.a = bt), De(ot), Ke(Xe, tt, dt);
        }
      }, e.context.handlers.hexKeydown = (Le) => {
        const Je = Le.target, je = Je.value;
        let ot = "";
        if (!jp(je)) return;
        const Xe = je.startsWith("#") ? je.slice(1) : je, tt = Xe.length === 8, dt = tt ? Xe.substring(0, 6) : Xe, bt = tt ? Xe.substring(6, 8) : "", qt = Le.shiftKey ? 10 : 1, Oe = 16777215;
        let Bt;
        if (["ArrowUp", "ArrowDown", "PageUp", "PageDown", "Home", "End"].includes(Le.key)) switch (Le.preventDefault(), Le.key) {
          case "ArrowUp":
            Bt = (parseInt(dt, 16) + qt) % 16777216;
            break;
          case "ArrowDown":
            Bt = (parseInt(dt, 16) - qt + Oe + 1) % 16777216;
            break;
          case "PageUp":
            Bt = (parseInt(dt, 16) + 10) % 16777216;
            break;
          case "PageDown":
            Bt = (parseInt(dt, 16) - 10 + Oe + 1) % 16777216;
            break;
          case "Home":
            Bt = 0;
            break;
          case "End":
            Bt = Oe;
        }
        Bt !== void 0 && (ot = Bt.toString(16).padStart(6, "0").toUpperCase()), ot && (Je.value = tt ? `#${ot}${bt}` : `#${ot}`), e.context && e.context.handlers.hexInput(Le);
      }, e.context.handlers.hexFocus = () => {
        e.context && (e.props.hexInputFocused = !0);
      }, e.context.handlers.hexBlur = (Le) => {
        if (!e.context) return;
        e.props.hexInputFocused = !1;
        const Je = Le.target.value;
        jp(Je) && De(Je);
      }, e.context.handlers.rangeLimitInput = (Le, Je, je, ot) => (Xe) => {
        const tt = ot || Xe;
        if (!tt || !e.context) return;
        const dt = tt.target;
        if (dt.value.endsWith(".")) return;
        const bt = Math.max(Math.min(Number(dt.value), je), Je);
        dt.value = `${bt}`;
        const qt = dt.id;
        if (Le === "hsla") {
          switch (qt) {
            case `h-${e.props.id}`:
              e.props.h = bt;
              break;
            case `s-${e.props.id}`:
              e.props.hslaPercent.s = bt;
              break;
            case `l-${e.props.id}`:
              e.props.hslaPercent.l = bt;
          }
          const [Oe, Bt, Tn] = p$(e.props.h, 2.55 * e.props.hslaPercent.s, 2.55 * e.props.hslaPercent.l);
          Ke(Oe, Bt, Tn);
        } else if (Le === "rgba") {
          switch (qt) {
            case `r-${e.props.id}`:
              e.props.rgba.r = bt;
              break;
            case `g-${e.props.id}`:
              e.props.rgba.g = bt;
              break;
            case `b-${e.props.id}`:
              e.props.rgba.b = bt;
          }
          const [Oe, Bt, Tn] = z3(e.props.rgba.r, e.props.rgba.g, e.props.rgba.b);
          Ke(Oe, Bt, Tn);
        } else Le == "alpha" && e.props.alpha && (e.props.a = bt, Ke());
      }, e.context.handlers.rangeLimitKeydown = (Le, Je, je, ot) => (Xe) => {
        if (e.context)
          if (["ArrowUp", "ArrowDown", "PageUp", "PageDown", "Home", "End", "Backspace", "Tab", "Enter"].includes(Xe.key) || Xe.metaKey || !/[a-zA-Z!@#$%^&*()_+={}\[\]:;"'<,>?\/|\\`~]/g.test(Xe.key)) {
            if (["ArrowUp", "ArrowDown", "PageUp", "PageDown", "Home", "End"].includes(Xe.key)) {
              const tt = Xe.target, dt = Number(tt.value), bt = Xe.shiftKey ? 10 * ot : ot;
              switch (Xe.key) {
                case "ArrowUp":
                  Xe.preventDefault(), tt.value = `${Math.min(dt + bt, je)}`;
                  break;
                case "ArrowDown":
                  Xe.preventDefault(), tt.value = `${Math.max(dt - bt, Je)}`;
                  break;
                case "PageUp":
                  Xe.preventDefault(), tt.value = `${Math.min(dt + 10 * ot, je)}`;
                  break;
                case "PageDown":
                  Xe.preventDefault(), tt.value = `${Math.max(dt - 10 * ot, Je)}`;
                  break;
                case "Home":
                  Xe.preventDefault(), tt.value = `${Je}`;
                  break;
                case "End":
                  Xe.preventDefault(), tt.value = `${je}`;
              }
              e.context.handlers.rangeLimitInput(Le, Je, je, Xe)();
            }
          } else Xe.preventDefault();
      }, e.context.handlers.swatchClick = (Le) => {
        const Je = Le.target;
        if (Je.dataset.colorPrecise) {
          const [je, ot, Xe, tt] = mI(Je.dataset.colorPrecise);
          e.props.alpha && (e.props.a = tt), Ke(je, ot, Xe), e.props.closeOnSelect && (e.props.expanded = !1);
        }
        e.context && Le.type !== "keydown" && e.context.handlers.swatchKeydown(Le);
      }, e.context.handlers.swatchKeydown = (Le) => {
        var Je, je, ot, Xe;
        if (!e.context || !f || !f.length) return;
        const tt = f.indexOf(Le.currentTarget);
        let dt = null;
        const bt = function(qn) {
          var vi;
          if (!qn.length) return 0;
          const It = (vi = qn[0].parentElement) === null || vi === void 0 ? void 0 : vi.parentElement;
          if (!It) return 0;
          const wn = It.getBoundingClientRect().width, Oi = qn[0].parentElement;
          if (!Oi) return 0;
          const hr = Oi.getBoundingClientRect(), qi = window.getComputedStyle(Oi), kt = parseFloat(qi.marginLeft) + parseFloat(qi.marginRight), wi = hr.width + kt;
          return Math.floor(wn / wi);
        }(f), qt = f.length;
        let Oe = 0, Bt = qt, Tn = !1;
        const hn = f[tt].dataset.group;
        if (hn !== void 0) {
          const qn = f.filter((vi) => vi.dataset.group === hn);
          Oe = f.indexOf(qn[0]), Bt = f.indexOf(qn[qn.length - 1]);
        }
        const Ht = (tt - Oe) % bt;
        if (!Le.key || Le.key === "Tab") return Le.key || (e.props.swatchIsUsingKeyboardNav = !1, g = Ht, U(tt)), Le.key === "Tab" && (e.props.swatchIsUsingKeyboardNav = !1), void f.forEach((qn) => {
          delete qn.parentElement.dataset.focused;
        });
        if (Le.key === "Enter" || Le.key === " ") return Le.preventDefault(), g = Ht, e.context.handlers.swatchClick(Le), void U(tt);
        switch (Le.key !== "ArrowUp" && Le.key !== "ArrowDown" && Le.key !== "ArrowLeft" && Le.key !== "ArrowRight" || (e.props.swatchIsUsingKeyboardNav = !0, Le.preventDefault()), Le.key) {
          case "ArrowUp":
            dt = Math.max(tt - bt, tt - (bt - (g - Ht))), Tn = !0;
            break;
          case "ArrowDown":
            dt = Math.max(tt + bt, tt + (bt + (g - Ht))), Tn = !0;
            break;
          case "ArrowLeft":
            dt = tt - 1, g = (dt - Oe) % bt;
            break;
          case "ArrowRight":
            dt = tt + 1, g = (dt - Oe) % bt;
        }
        if (Tn && dt !== null && (dt < Oe || dt > Bt)) {
          let qn;
          qn = dt < Oe ? (je = (Je = f[Oe - 1]) === null || Je === void 0 ? void 0 : Je.dataset) === null || je === void 0 ? void 0 : je.group : (Xe = (ot = f[Bt + 1]) === null || ot === void 0 ? void 0 : ot.dataset) === null || Xe === void 0 ? void 0 : Xe.group;
          const vi = f.filter((qi) => qi.dataset.group === hn), It = f.filter((qi) => qi.dataset.group === qn), wn = (tt - Oe) % bt, Oi = vi.length % bt || bt, hr = tt >= Oe + vi.length - Oi;
          if (dt < Oe) {
            const qi = It.length % bt || bt;
            dt = Oe - qi + Math.min(Math.max(wn, g), qi - 1);
          } else dt > Bt && (dt = hr ? Math.min(Bt + Math.max(wn, g) + 1, f.indexOf(It[It.length - 1])) : Math.min(dt, Bt));
        }
        if (dt !== null && dt >= 0 && dt < qt) {
          U(dt), f.forEach((It) => {
            delete It.parentElement.dataset.focused;
          });
          const qn = f[dt], vi = qn.parentElement;
          qn.focus(), vi.dataset.focused = "true";
        }
      });
    });
  },
  iv,
  Zl,
  /* @__PURE__ */ Qn("eyeDropper", "color"),
  /* @__PURE__ */ Qn("close", "close"),
  /* @__PURE__ */ bi("close"),
  /* @__PURE__ */ bi("next")
] }, Gd = /* @__PURE__ */ $o("tb"), { outer: OSe, wrapper: gI, prefix: NSe, suffix: FSe, help: RSe, messages: zSe, message: BSe, icon: yI } = /* @__PURE__ */ Co(Gd), _I = Gd("label", () => ({ if: "$label", $el: "label", attrs: { id: "$id + '_label'" } })), VSe = Gd("singleToggle", () => ({ bind: "$attrs", $el: "button", attrs: { id: "$id", type: "button", "aria-label": "$label", "aria-pressed": "$fns.isChecked($onValue, $value)", onClick: "$handlers.toggleValue()", disabled: "$disabled", class: "$classes.input", onBlur: "$handlers.blur" } })), USe = Gd("multiToggle", () => ({ bind: "$attrs", $el: "button", attrs: { type: "button", id: "$id+'_'+$index", "aria-label": "$label", "aria-pressed": "$fns.isChecked($option, $value)", onClick: "$handlers.toggleValue($option)", class: "$classes.input", title: "$option.help", disabled: "$disabled || $option.disabled", onBlur: "$handlers.blur" } })), ag = Gd("inputInner", () => ({ bind: "$attrs", $el: "span" })), HSe = Gd("options", () => ({ $el: "ul", attrs: { id: "$id", "data-vertical": '$vertical && "true" || "false"', "aria-labelledby": "$id" } })), WSe = Gd("option", () => ({ $el: "li", for: ["option", "index", "$options"], attrs: { key: "$option.value", "data-index": "$index" } }));
function bI(e, t) {
  return t = t != null && t.hasOwnProperty("__original") ? t == null ? void 0 : t.__original : t == null ? void 0 : t.value, e.props.multiple ? !!Array.isArray(e.value) && e.value.filter((n) => vn(n, t)).length > 0 : t !== void 0 ? vn(e.value, t) : (e.props._isChecked = vn(e.value, e.props.onValue), e.props._isChecked);
}
const ZSe = { schema: /* @__PURE__ */ OSe(/* @__PURE__ */ sn("$options", /* @__PURE__ */ gI(/* @__PURE__ */ _I("$label"), /* @__PURE__ */ HSe(/* @__PURE__ */ WSe(/* @__PURE__ */ USe(/* @__PURE__ */ sn("$fns.isChecked($option) === true", /* @__PURE__ */ ag("$slots.default || $slots.on || $option.onLabel || $option.label"), /* @__PURE__ */ ag("$slots.default || $slots.off || $option.offLabel || $option.label")))))), /* @__PURE__ */ gI(/* @__PURE__ */ sn("$label && ($slots.default || $slots.on || $onLabel)", /* @__PURE__ */ _I("$label")), /* @__PURE__ */ VSe(/* @__PURE__ */ yI("prefix"), /* @__PURE__ */ NSe(), /* @__PURE__ */ sn("$_isChecked === true", /* @__PURE__ */ ag("$slots.default || $slots.on || $onLabel || $label"), /* @__PURE__ */ ag("$slots.default || $slots.off || $offLabel || $label")), /* @__PURE__ */ FSe(), /* @__PURE__ */ yI("suffix")))), /* @__PURE__ */ RSe("$help"), /* @__PURE__ */ zSe(/* @__PURE__ */ BSe("$message.value"))), type: "input", family: "button", props: ["options"], features: [function(e) {
  var t, n, i, r;
  e.addProps(["enforced", "multiple", "offLabel", "offValue", "onLabel", "onValue", "vertical", "_isChecked"]), e.props._isChecked = !1, e.props.enforced = on(e.props.enforced), e.props.multiple = on(e.props.multiple), e.props.vertical = on(e.props.vertical), e.props.disabled = on(e.props.disabled), (t = (i = e.props).onValue) !== null && t !== void 0 || (i.onValue = !0), (n = (r = e.props).offValue) !== null && n !== void 0 || (r.offValue = !1), e.on("created", () => {
    var c;
    e.props._isChecked = bI(e, null), e.props.options && e.props.multiple && e.input((c = e.value) !== null && c !== void 0 ? c : [], !1), e.context && (e.context.fns.isChecked = (d) => bI(e, d), e.context.handlers.toggleValue = (d) => (a) => function(f, g, x) {
      if (x.preventDefault(), g = g && Nt(g), f.props.options) if (f.props.multiple) {
        const $ = Array.isArray(f.value) ? [...f.value] : [], A = $.findIndex((I) => vn(I, g));
        A > -1 && (!f.props.enforced || $.length > 1) ? $.splice(A, 1) : A === -1 && $.push(g), f.input($);
      } else vn(f.value, g) && !f.props.enforced ? f.input(void 0) : f.input(g);
      else f.input(vn(f.value, f.props.onValue) ? f.props.offValue : f.props.onValue);
    }(e, d, a));
  });
}, Zl] }, B3 = /* @__PURE__ */ $o("ut"), { outer: qSe, inner: jSe, wrapper: GSe, label: YSe, prefix: KSe, suffix: XSe, help: JSe, messages: QSe, message: eTe, icon: wI } = /* @__PURE__ */ Co(B3), tTe = B3("input", () => ({ $el: "input", bind: "$attrs", attrs: { name: "$node.name", autocomplete: "$attrs.autocomplete || off", id: "$id", onChange: "$handlers.handleInput", onInput: "$handlers.handleInput", onKeydown: "$handlers.handleKeyDown", onBeforeinput: "$handlers.handleBeforeInput", readonly: "$readonly", inputmode: "decimal", disabled: "$disabled", "data-unit": "$unit", "data-currency": "$currency", "data-display-locale": "$displayLocale", "data-value-locale": "$valueLocale", "data-decimals": "$decimals", "data-trailing": "$trailingZeros", "data-numeric-value": "$_numericValue", "data-align": "$_valueAlignAuto" } }));
function V3(e) {
  let t = null, n = !1;
  function i($) {
    var A, I, O;
    const B = (`${$}`.match(/\-/g) || []).length % 2 == 1;
    $ = function(q) {
      if (q = function(ee) {
        return ee.replace(/[\u0660-\u0669\u06f0-\u06f9]/g, (te) => (15 & te.charCodeAt(0)).toString());
      }(`${q}`), isNaN(q) && (q = q.split(t.decimal).map((ee) => ee.replace(/[^0-9]/g, "")).join(".")), q = q.replace(/[^0-9\.]/g, ""), q.includes(".")) {
        const ee = q.split(".");
        e.props.decimals === 0 ? q = ee[0] : (ee[1] = ee[1].padEnd(x(), "0").slice(0, x()), q = ee.join("."));
      }
      return q;
    }($);
    const H = {};
    d() === "unit" && (H.minimumFractionDigits = $.includes(".") ? 1 : 0), H.maximumFractionDigits = x(), e.props.minDecimals && (H.minimumFractionDigits = e.props.minDecimals, $.includes(".") || ($ += ".".padEnd(e.props.minDecimals + 1, "0"))), H.maximumFractionDigits === 0 && $.includes(".") && ($ = $.split(".")[0]);
    let N = "";
    isNaN($) || $.trim() === "" || ($ = B ? `-${$}` : $, e.props.max && !isNaN(e.props.max) && ($ = Number($) > e.props.max ? `${e.props.max}` : $), e.props.min && !isNaN(e.props.min) && ($ = Number($) < e.props.min ? `${e.props.min}` : $), $.includes(".") ? $ = $.split(".")[0].padStart(1, "0") + "." + ((A = $.split(".")[1]) !== null && A !== void 0 ? A : "0") : H.maximumFractionDigits = (I = H.minimumFractionDigits) !== null && I !== void 0 ? I : 0, N = a(e.props.displayLocale, H).format($));
    let K, U = $.split(".");
    U = U[0] + ((O = U[1]) !== null && O !== void 0 ? O : "").padEnd(x(), "0"), U.length > 1 && (U = U.replace(/^0+/, ""), U = $ !== "" && U === "" ? "0" : U), e.props.valueStore = { number: $, integer: U, string: N }, n = !0, e.props.valueStore && (K = e.props.valueStore.hasOwnProperty(e.props.valueFormat) ? e.props.valueStore[e.props.valueFormat] : e.props.valueStore.number), e.input(K === "" ? void 0 : K).then(() => (n = !1, Promise.resolve()));
  }
  function r() {
    Pr(`${e.props.id}`, ($) => {
      var A, I;
      $ instanceof HTMLInputElement && ($.value = (I = (A = e.props.valueStore) === null || A === void 0 ? void 0 : A.string) !== null && I !== void 0 ? I : "");
    }, e.props.__root);
  }
  function c() {
    var $, A;
    const I = ($ = e.props.__root) === null || $ === void 0 ? void 0 : $.querySelector(`#${e.props.id}_inner input`);
    return (A = I == null ? void 0 : I.value) !== null && A !== void 0 ? A : "";
  }
  function d() {
    return e.props.currency ? "currency" : "unit";
  }
  function a($, A = {}) {
    const I = d(), O = Object.assign({}, { style: I, roundingMode: "trunc" }, A);
    return O[I] = e.props[I], new Intl.NumberFormat($, O);
  }
  function f() {
    var $, A, I;
    const O = ($ = e.props.__root) === null || $ === void 0 ? void 0 : $.querySelector(`#${e.props.id}_inner input`);
    if (O) {
      O.dataset.placeholder || (O.dataset.placeholder = (A = O.getAttribute("placeholder")) !== null && A !== void 0 ? A : "");
      const B = ((t.unitLeft ? `${t.unit} ` : "") + ((I = O.dataset.placeholder) !== null && I !== void 0 ? I : "") + (t.unitLeft ? "" : ` ${t.unit}`)).trim();
      O.setAttribute("placeholder", B);
    }
  }
  function g($) {
    var A;
    const I = (A = e.props.__root) === null || A === void 0 ? void 0 : A.querySelector(`#${e.props.id}_inner input`);
    if (!I) return;
    const O = t.unit.length + t.literal.length;
    $ = t.unitLeft ? Math.max($, O) : Math.min($, c().length - O), I.setSelectionRange($, $);
  }
  function x() {
    return e.props.decimals !== void 0 ? e.props.decimals : e.props.minDecimals !== void 0 && e.props.minDecimals > t.fractionLength ? e.props.minDecimals : t.fractionLength;
  }
  e.props.valueStore = null, e.on("input", ({ payload: $ }) => {
    n || (i($), r());
  }), e.on("mounted", () => {
    f();
  }), e.context && (e.context.handlers.setPlaceholder = f, e.context.handlers.init = ($ = null) => {
    var A;
    (function() {
      var O, B, H, N, K, U, q;
      const ee = a(e.props.displayLocale).formatToParts(1234567812345678e-8);
      t = { decimal: (O = ee.find((te) => te.type == "decimal")) === null || O === void 0 ? void 0 : O.value, group: (B = ee.find((te) => te.type == "group")) === null || B === void 0 ? void 0 : B.value, unit: (H = ee.find((te) => ["unit", "currency"].includes(te.type))) === null || H === void 0 ? void 0 : H.value, unitLeft: ["unit", "currency"].includes(ee[0].type), literal: (K = (N = ee.find((te) => te.type == "literal")) === null || N === void 0 ? void 0 : N.value) !== null && K !== void 0 ? K : "", fractionLength: (q = (U = ee.find((te) => te.type == "fraction")) === null || U === void 0 ? void 0 : U.value.length) !== null && q !== void 0 ? q : 0 };
    })();
    let I = (A = $ ?? e._value) !== null && A !== void 0 ? A : "";
    e.props.valueStore ? I = e.props.valueStore.number : e.props.valueFormat === "integer" && (I = function(O) {
      var B;
      return (parseFloat(`${O}`) / Math.pow(10, (B = x()) !== null && B !== void 0 ? B : 0)).toString().replace(".", x());
    }(`${I ?? ""}`)), i(I), r();
  }, e.context.handlers.handleBeforeInput = ($) => {
    var A, I, O, B, H, N, K, U, q;
    if (!e.props.inExecCommand && ($.preventDefault(), $.stopPropagation(), $.target instanceof HTMLInputElement)) {
      const ee = $.target, te = (A = $.data) !== null && A !== void 0 ? A : "", ae = (I = $.target.value) !== null && I !== void 0 ? I : "", oe = (O = $.target.selectionStart) !== null && O !== void 0 ? O : 0, de = (B = $.target.selectionEnd) !== null && B !== void 0 ? B : 0, me = de - oe, ve = ae.indexOf(t.decimal);
      let re = ((H = $.target.selectionStart) !== null && H !== void 0 ? H : 0) + ($.data ? 0 : -1), le = ae, pe = 1;
      if (ae.includes(t.decimal) && te === t.decimal) return te === t.decimal && (re = le.indexOf(t.decimal) + 1), void g(re);
      if (!(e.props.min === null || e.props.min < 0 || e.props.max < 0) && te === "-" || te.match(/[a-zA-Z]/) || te === t.decimal && e.props.decimals === 0) return;
      if ($.inputType === "deleteByCut" && me > 0 && (le = le.slice(0, oe) + le.slice(de), re = de), $.inputType === "insertFromPaste") {
        const Ne = (N = $.data) !== null && N !== void 0 ? N : "";
        le = le.slice(0, oe) + Ne + le.slice(de);
      }
      if ($.inputType === "deleteContentBackward" && ae[oe - 1] === t.group ? (pe += 1, re -= 1) : $.inputType === "deleteContentForward" && ae[oe] === t.group && (pe += 1, re += 1), ve !== -1 && re > ve && $.inputType === "insertText" ? le = function(Ne, We, Ge) {
        return Ne.substring(0, We) + Ge + Ne.substring(We + Ge.length);
      }(le, re, (K = $.data) !== null && K !== void 0 ? K : "0") : $.inputType === "insertText" ? (re = de, le = le.slice(0, oe) + $.data + le.slice(de)) : $.inputType === "deleteContentForward" ? (re += 2, le = me === 0 ? le.slice(0, oe) + le.slice(de + pe) : le.slice(0, oe) + le.slice(de)) : $.inputType === "deleteContentBackward" && (re += 1, me === 0 ? le = le.slice(0, Math.max(oe - pe, 0)) + le.slice(de) : me > 0 && (le = le.slice(0, oe) + le.slice(de))), $.inputType === "deleteContentForward" && ae[oe] === t.decimal) {
        const Ne = le.slice(oe - 1);
        le = le.slice(0, oe), Ne.includes(t.unit) && (le += " " + t.unit);
      } else if ($.inputType === "deleteContentBackward" && ae[oe - 1] === t.decimal) {
        const Ne = le.slice(oe - 1);
        le = le.slice(0, oe - 1), Ne.includes(t.unit) && (le += " " + t.unit);
      }
      i(le), le = (q = (U = e.props.valueStore) === null || U === void 0 ? void 0 : U.string) !== null && q !== void 0 ? q : "", re = le.length - ae.length + re, le.length === ae.length && (re += $.inputType.includes("delete") ? -1 : 1), ee.setSelectionRange(0, ae.length), e.props.inExecCommand = !0, document.execCommand("insertText", void 0, le), e.props.inExecCommand = !1, te === t.decimal ? re = le.indexOf(t.decimal) + 1 : ae.includes(t.decimal) && !le.includes(t.decimal) && (re = le.length), g(Math.max(0, re));
    }
  }, e.context.handlers.handleInput = ($) => {
    e.emit("dom-input-event", $), $.target instanceof HTMLInputElement && (e.props.inputText = $.target.value, i($.target.value));
  }, e.context.handlers.handleKeyDown = ($) => {
    var A, I;
    if ($.target instanceof HTMLInputElement && ($.key === "ArrowUp" || $.key === "ArrowDown")) {
      const O = $.key === "ArrowUp" ? 1 * e.props.step : -1 * e.props.step;
      i(function(B, H) {
        var N, K, U, q;
        const ee = `${B}`.split("."), te = `${H}`.split(".");
        let ae = (N = ee[0]) !== null && N !== void 0 ? N : "0", oe = (K = te[0]) !== null && K !== void 0 ? K : "0";
        const de = (U = ee[1]) !== null && U !== void 0 ? U : "", me = (q = te[1]) !== null && q !== void 0 ? q : "", ve = Math.max(de.length, me.length);
        ve > 0 && (ae += de.padEnd(ve, "0"), oe += me.padEnd(ve, "0"));
        const re = BigInt(BigInt(ae) + BigInt(oe)).toString();
        return ve > 0 ? re.slice(0, -1 * ve) + "." + re.slice(-1 * ve) : re;
      }((I = (A = e.props.valueStore) === null || A === void 0 ? void 0 : A.number) !== null && I !== void 0 ? I : 0, O)), r(), setTimeout(() => {
        g(c().length);
      }, 1);
    }
  });
}
const nTe = { schema: /* @__PURE__ */ qSe(/* @__PURE__ */ GSe(/* @__PURE__ */ YSe("$label"), /* @__PURE__ */ jSe(/* @__PURE__ */ wI("prefix"), /* @__PURE__ */ KSe(), /* @__PURE__ */ tTe(), /* @__PURE__ */ XSe(), /* @__PURE__ */ wI("suffix"))), /* @__PURE__ */ JSe("$help"), /* @__PURE__ */ QSe(/* @__PURE__ */ eTe("$message.value"))), type: "input", family: "text", props: ["options"], features: [function(e) {
  var t, n, i, r, c, d, a, f, g, x, $, A, I, O, B, H;
  const N = ["unit", "decimals", "minDecimals", "displayLocale", "min", "max", "step", "valueFormat"];
  e.addProps(N), (t = (g = e.props).displayLocale) !== null && t !== void 0 || (g.displayLocale = e.props.locale || "en-US"), (n = (x = e.props).decimals) !== null && n !== void 0 || (x.decimals = null), (i = ($ = e.props).minDecimals) !== null && i !== void 0 || ($.minDecimals = null), (r = (A = e.props).min) !== null && r !== void 0 || (A.min = null), (c = (I = e.props).max) !== null && c !== void 0 || (I.max = null), (d = (O = e.props).step) !== null && d !== void 0 || (O.step = 1), (a = (B = e.props).unit) !== null && a !== void 0 || (B.unit = e.props.unit || "percent"), ["acre", "bit", "byte", "celsius", "centimeter", "day", "degree", "fahrenheit", "fluid-ounce", "foot", "gallon", "gigabit", "gigabyte", "gram", "hectare", "hour", "inch", "kilobit", "kilobyte", "kilogram", "kilometer", "liter", "megabit", "megabyte", "meter", "microsecond", "mile", "mile-scandinavian", "milliliter", "millimeter", "millisecond", "minute", "month", "nanosecond", "ounce", "percent", "petabyte", "pound", "second", "stone", "terabit", "terabyte", "week", "yard", "year"].indexOf(e.props.unit) === -1 && (e.props.unit = "percent"), (f = (H = e.props).valueFormat) !== null && f !== void 0 || (H.valueFormat = "number"), ["string", "number"].indexOf(e.props.valueFormat) === -1 && (e.props.valueFormat = "number"), e.on("created", () => {
    e.context && (V3(e), e.context.handlers.init(), N.forEach((K) => {
      e.on(`prop:${K}`, () => {
        var U, q;
        (U = e == null ? void 0 : e.context) === null || U === void 0 || U.handlers.init(), (q = e == null ? void 0 : e.context) === null || q === void 0 || q.handlers.setPlaceholder();
      });
    }));
  });
}, Zl] }, U3 = /* @__PURE__ */ $o("cr"), { outer: iTe, inner: rTe, wrapper: sTe, label: oTe, prefix: aTe, suffix: lTe, help: cTe, messages: uTe, message: dTe, icon: xI } = /* @__PURE__ */ Co(U3), pTe = U3("input", () => ({ $el: "input", bind: "$attrs", attrs: { name: "$node.name", autocomplete: "$attrs.autocomplete || off", id: "$id", onChange: "$handlers.handleInput", onInput: "$handlers.handleInput", onKeydown: "$handlers.handleKeyDown", onBeforeinput: "$handlers.handleBeforeInput", readonly: "$readonly", disabled: "$disabled", inputmode: "decimal", "data-unit": "$unit", "data-currency": "$currency", "data-display-locale": "$displayLocale", "data-value-locale": "$valueLocale", "data-decimals": "$decimals", "data-trailing": "$trailingZeros", "data-numeric-value": "$_numericValue", "data-align": "$_valueAlignAuto" } })), hTe = { schema: /* @__PURE__ */ iTe(/* @__PURE__ */ sTe(/* @__PURE__ */ oTe("$label"), /* @__PURE__ */ rTe(/* @__PURE__ */ xI("prefix"), /* @__PURE__ */ aTe(), /* @__PURE__ */ pTe(), /* @__PURE__ */ lTe(), /* @__PURE__ */ xI("suffix"))), /* @__PURE__ */ cTe("$help"), /* @__PURE__ */ uTe(/* @__PURE__ */ dTe("$message.value"))), type: "input", family: "text", props: ["options"], features: [function(e) {
  var t, n, i, r, c, d, a, f;
  const g = ["currency", "decimals", "maxDecimals", "minDecimals", "displayLocale", "min", "max", "step", "valueFormat"];
  e.addProps(g), e.addProps(["inputText"]), (t = (c = e.props).displayLocale) !== null && t !== void 0 || (c.displayLocale = e.props.locale || "en-US"), (n = (d = e.props).currency) !== null && n !== void 0 || (d.currency = e.props.currency || "USD"), e.props.decimals === "false" || e.props.decimals === !1 ? e.props.decimals = 0 : e.props.decimals !== void 0 && (e.props.decimals = Number(e.props.decimals)), e.props.minDecimals = e.props.minDecimals !== void 0 ? Number(e.props.minDecimals) : void 0, e.props.min !== void 0 && (e.props.min = Number(e.props.min)), e.props.max !== void 0 && (e.props.max = Number(e.props.max)), (i = (a = e.props).step) !== null && i !== void 0 || (a.step = 1), (r = (f = e.props).valueFormat) !== null && r !== void 0 || (f.valueFormat = "number"), ["string", "number", "integer"].indexOf(e.props.valueFormat) === -1 && (e.props.valueFormat = "number"), e.on("created", () => {
    e.context && (V3(e), e.context.handlers.init(), g.forEach((x) => {
      e.on(`prop:${x}`, () => {
        var $, A;
        ($ = e == null ? void 0 : e.context) === null || $ === void 0 || $.handlers.setPlaceholder(), (A = e == null ? void 0 : e.context) === null || A === void 0 || A.handlers.init();
      });
    }));
  });
}] };
var fTe = /* @__PURE__ */ Object.freeze({ __proto__: null, autocomplete: D$e, colorpicker: LSe, currency: hTe, datepicker: W2e, dropdown: Z1e, mask: ECe, rating: f$e, repeater: Fxe, slider: qke, taglist: dCe, toggle: cxe, togglebuttons: ZSe, transferlist: yke, unit: nTe });
const mTe = typeof window < "u" ? setInterval : () => 0, $I = /* @__PURE__ */ new WeakSet();
function vTe(e, t = {}) {
  const n = e;
  try {
    let i = function(r) {
      $I.has(r) && function(d, a) {
        fm[d] ? fm[d].add(a) : fm[d] = /* @__PURE__ */ new Set([a]);
      }(e, (d) => {
        r.props.definition && (r.props.definition.schema = d || [{ $el: Ec(13919), children: `${Ec(451228594)}${Ec(32863693)}` }]), r.emit("schema"), setTimeout(() => r.destroy(), 1e3);
      });
    };
    return function(r) {
      const c = () => {
        throw new Error(`InvalidFormKitKey ${r}`);
      };
      if (!/^fk-/i.test(r)) return c();
      const d = r.substring(3);
      if (!$we.test(d)) return c();
      const a = parseInt(d, 16).toString(), f = Number(a[0]) < 6 ? Number(a[0]) : 6, g = a.substring(f, f + (a.length - 6)), x = a.substring(0, f) + a.substring(f + g.length), $ = x.slice(0, 2), A = `${x[x.length - 1]}${x[0]}`;
      Number(g) !== Math.floor(Number(x) * Number($) / Number(A)) && c();
    }(n), i.library = (r) => {
      if (r.props.type in t) {
        const { schema: c, ...d } = t[r.props.type];
        $I.add(r), r.define({ ...d, schema: c(e) });
      }
      mTe(() => $_.has(e) && r.emit("schema"), 4e3);
    }, i;
  } catch (i) {
    throw i instanceof Error && function(r) {
      if (r.message === "FormKitNoKey") throw new Error("A FormKit API key is required, please visit https://formkit.com/pro");
    }(i), i;
  }
}
const gTe = mD(
  at({
    props: {
      context: { type: Object, required: !0 }
    },
    setup(e) {
      return () => ym(
        "div",
        {},
        e.context.slots.default ? e.context.slots.default({ context: e.context }) : []
      );
    }
  })
), yTe = vTe("fk-b6002bac46", fTe), PIe = Px({
  plugins: [yTe],
  locales: { en: WM, fr: vG },
  locale: da(),
  rules: { booleanCheck: Gx, monthBetween: d0e },
  inputs: {
    custom: gTe
  }
});
export {
  jh as AccordionWrapper,
  RTe as AeroplanLoginBanner,
  _Ie as AeroplanLoginModal,
  bIe as AeroplanPointsBanner,
  lL as AeroplanPointsLogo,
  QD as AeroplanPointsRow,
  vIe as AeroplanPointsSection,
  aL as AeroplanPointsSelector,
  FTe as AlertMessage,
  hIe as AlternateDates,
  I0 as AncillaryGroup,
  IIe as AncillaryMain,
  nL as AncillarySection,
  xIe as BackToTopButton,
  Bde as Bill96Checkbox,
  mP as BillingAddress,
  mIe as BookingSummary,
  Rme as BookingSummaryAncillary,
  Fme as BookingSummaryFlight,
  Pme as BookingSummaryHotel,
  Fu as BreakdownRow,
  Xv as CollapsibleSection,
  aIe as ConfirmationAeroplan,
  lIe as ConfirmationAeroplanEnroll,
  dae as ConfirmationImportantNotes,
  HTe as ConfirmationModal,
  oIe as ConfirmationSuccess,
  cIe as ConfirmationSummary,
  vk as CreditCard,
  Gde as CreditCardLogos,
  ope as CreditCardSection,
  Vle as DepositRow,
  nIe as Facilities,
  zpe as FlexibleHotelDatesAccordion,
  Ghe as FlightDetailsAccordion,
  oT as FlightDetailsSegment,
  Py as FlightDetailsSegmentMulti,
  nT as FlightSegment,
  Ay as FlightStops,
  Ey as FlightStopsDots,
  Nme as FlightsDetailsSection,
  iZ as GiftCardSection,
  Eme as HotelAndRoomInfo,
  che as HotelRoomAccordion,
  Eve as InclusionsAccordion,
  jTe as InsuranceDecline,
  GTe as InsuranceDescription,
  qTe as InsuranceDetails,
  YTe as InsuranceDisclaimer,
  uJ as InsuranceNotes,
  KTe as InsuranceOptions,
  iL as LoadingSpinner,
  UTe as MessageBox,
  $Ie as NoFlights,
  CIe as NoPackages,
  kIe as NoRooms,
  Wx as NonRefundableRate,
  tIe as Offers,
  Nle as OpcTaxRow,
  Eue as PassengerProtection,
  Hue as PaymentErrors,
  dIe as PaymentMethod,
  uIe as PaymentOptions,
  eIe as PdpBestFor,
  pte as PdpImportantInformation,
  QTe as PdpLocation,
  iIe as PdpNavAnchors,
  JTe as PdpOverview,
  fIe as PlpError,
  XTe as PlpFilter,
  pIe as PlpListItemContent,
  wve as PreferredPrivilegesAccordion,
  Hx as PriceBreakdown,
  JD as PriceDetails,
  qw as PriceDisclaimer,
  tT as PricePaymentMethods,
  Noe as PriceTotal,
  Zx as PriceTotalRow,
  VTe as ProgressBar,
  TIe as PromoCode,
  zle as PromoCodeRow,
  sL as PsychTrigger,
  Jve as RoomDetailsAccordion,
  wIe as RoomsListItem,
  Wue as SeparateBillingAddress,
  SIe as ServerError,
  cL as ShowMoreResults,
  p0e as SortBy,
  XD as SubTotalRow,
  jx as SummarySectionContainer,
  iT as ThreeDomainSecureIframe,
  gIe as TravelInsuranceBillingRow,
  yIe as TravelInsurancePriceRow,
  s_e as TravelProtection,
  AIe as TravelProtectionNudge,
  BTe as TravellerForm,
  kD as TravellerSummary,
  sIe as TravellersSummary,
  Xue as UpliftPaymentErrors,
  y_ as UpliftWarningMessage,
  EIe as VACVMap,
  lX as VacvAeSignInModal,
  hP as VacvButton,
  Bv as VacvCounterSelector,
  WTe as VacvCubaPopup,
  rl as VacvCustomModal,
  $H as VacvDataInput,
  dx as VacvDropDown,
  PIe as VacvFormkitConfig,
  zTe as VacvFormkitPlugin,
  ZTe as VacvFormkitWrapper,
  NTe as VacvGuestsInputField,
  CD as VacvHotelRating,
  Ox as VacvImageCarousel,
  uW as VacvMobileOverlay,
  SH as VacvOverlay,
  rIe as VacvPdpHeader,
  eP as VacvPromoBadge,
  OTe as VacvTravellersTitle,
  BE as VacvTripAdvisor,
  u6 as VacvWasPrice,
  hpe as WaitingScreen,
  Gx as booleanCheck,
  Dne as getCCExpiryRange,
  Au as i18n,
  $D as isValidTripAdvisorRating,
  d0e as monthBetween
};
//# sourceMappingURL=vacv-components.es.js.map
